import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An account number for a corepro account */
  AccountNumber: any;
  Amount: any;
  BankCardPin: any;
  BigDecimal: any;
  CardNumberMasked: any;
  /** A ISO8601 format date string */
  Date: any;
  /** A ISO8601 format date time string */
  DateTime: any;
  /** A field representing a standard email address. https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
  Email: any;
  /**  A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/.  */
  EmailAddress: any;
  /** Represents untyped JSON */
  JSON: any;
  /** Standard format for monetary value - string representation of BigInt */
  Micros: any;
  /** An E.164 compliant phone number */
  PhoneNumber: any;
  PositiveFloat: any;
  ReferralCode: any;
  /** A routing number for a bank */
  RoutingNumber: any;
  /** A key scalar which maps to a string in the Unified String Repo */
  StringKey: any;
  /** A valid security symbol */
  TickerSymbol: any;
  Time: any;
  /** A legal URL */
  URL: any;
  /** Formatted full-name of a US state. */
  USStateName: any;
  /** A universally unique identifier compliant UUID Scalar */
  UUID: any;
  /** The Upload scalar type represents a file upload. */
  Upload: any;
  /**  Allows for a cleaner 'null' return type to support legacy GQL queries from the gateway  */
  Void: any;
};

/** Describes the employer switch based on the switch type. */
export type AbstractSwitch = AcornsPdfSwitch | OnlineSwitch | SubmittableSwitch;

/** Bundle of acceptance date, signature, and document type */
export type AcceptDocumentInput = {
  /** The date the document was signed by the user */
  acceptedDate: Scalars['Date'];
  /** Type of document the given signature is accepting */
  documentType: AcceptanceDocumentType;
  /** The version of the document the user is accepting */
  documentVersion: Scalars['String'];
  /** Name to apply to the accepted document */
  signature: Scalars['String'];
};

/** What happens when a user accepts a document */
export type AcceptDocumentResponse = AcceptedDocument | DocumentNotFound | UserNotFound;

/** Acceptance documents */
export type AcceptanceDocument = {
  __typename?: 'AcceptanceDocument';
  id: Scalars['ID'];
  /** Indicates whether the app should force the user to scroll to the bottom before accepting */
  mustScrollToBottom: Maybe<Scalars['Boolean']>;
  /** The name of the document */
  name: Scalars['String'];
  /** A string indicating a specific app feature that the acceptance of the document is required for using */
  requiredFor: Maybe<Scalars['String']>;
  /** The name of the summary */
  summaryName: Maybe<Scalars['String']>;
  /** The URL to the summary text */
  summaryUrl: Maybe<Scalars['URL']>;
  /** The type of document (arbitrary right now) */
  type: Scalars['String'];
  /** The URL to the document text */
  url: Scalars['URL'];
  /** The version of the document */
  version: Scalars['String'];
};

export enum AcceptanceDocumentType {
  /**
   * Required agreement when user is signed up through a referral program or code
   * @deprecated Referral disclosure is no longer required for referred users
   */
  referralDisclosure = 'referralDisclosure'
}

/** A document that a user has accepted */
export type AcceptedDocument = {
  __typename?: 'AcceptedDocument';
  acceptedDate: Scalars['Date'];
  documentType: AcceptanceDocumentType;
  documentUrl: Scalars['String'];
  documentVersion: Scalars['String'];
  signature: Scalars['String'];
};

/** Individual accounts opened by a user at Acorns */
export type Account = TimestampsInterface & {
  __typename?: 'Account';
  /** Type of account */
  accountType: AccountType;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Internal ID for account creator */
  creatorId: Scalars['ID'];
  /** Internal ID for account */
  id: Scalars['ID'];
  /** Status of account */
  status: AccountStatus;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export type AccountAchievement = {
  __typename?: 'AccountAchievement';
  achievement: AchievementItem;
  completed: Scalars['Boolean'];
  dateCompleted: Scalars['DateTime'];
};

/** The account provided is already closed */
export type AccountAlreadyClosedException = {
  __typename?: 'AccountAlreadyClosedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Investment account is already closed */
export type AccountClosedException = {
  __typename?: 'AccountClosedException';
  /** message */
  errorMessage: Maybe<Scalars['String']>;
};

/** The account has been frozen due to too many incorrect attempts */
export type AccountFrozen = {
  __typename?: 'AccountFrozen';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type AccountMoneyAssignmentInput = {
  amount?: InputMaybe<Scalars['Int']>;
  targetAccountId: Scalars['String'];
};

/** When investment account id doesn't match with user */
export type AccountNotFoundException = {
  __typename?: 'AccountNotFoundException';
  /** message */
  errorMessage: Maybe<Scalars['String']>;
};

export type AccountPoints = {
  __typename?: 'AccountPoints';
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String'];
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey'];
  earned: Scalars['Int'];
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int'];
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary: Maybe<Scalars['String']>;
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey: Maybe<Scalars['StringKey']>;
};

export type AccountPointsRule = {
  __typename?: 'AccountPointsRule';
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String'];
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey'];
  milestoneID: Scalars['ID'];
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int'];
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary: Maybe<Scalars['String']>;
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey: Maybe<Scalars['StringKey']>;
};

export type AccountRequirement = {
  __typename?: 'AccountRequirement';
  actionable: Scalars['Boolean'];
  description: Maybe<Scalars['String']>;
  status: AccountRequirementStatus;
  type: AccountRequirementType;
};

export enum AccountRequirementStatus {
  COMPLETED = 'COMPLETED',
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING'
}

export enum AccountRequirementType {
  FUNDING_SOURCE = 'FUNDING_SOURCE',
  LIQUIDATED = 'LIQUIDATED',
  NO_PENDING_INVESTMENTS = 'NO_PENDING_INVESTMENTS',
  NO_TRANSFERRING_DIVIDENDS = 'NO_TRANSFERRING_DIVIDENDS',
  NO_TRANSFERRING_INVESTMENTS = 'NO_TRANSFERRING_INVESTMENTS',
  RECURRING_DEPOSITS_DISABLED = 'RECURRING_DEPOSITS_DISABLED',
  SELF_DIRECTED_PORTFOLIO_CLOSED = 'SELF_DIRECTED_PORTFOLIO_CLOSED',
  VERIFIED_FUNDING_SOURCE = 'VERIFIED_FUNDING_SOURCE'
}

export type AccountRequirements = {
  __typename?: 'AccountRequirements';
  close: Array<AccountRequirement>;
};

/** reflects the user's account setup progress */
export type AccountSetupMilestones = {
  __typename?: 'AccountSetupMilestones';
  /** optional copy to provide more info */
  descriptionKey: Maybe<Scalars['StringKey']>;
  /** account setup completion progress */
  groupProgress: DiscreteMilestoneProgress;
  /** list of milestones to show in account set up widget */
  milestones: Array<Milestone>;
};

export enum AccountStatus {
  /** Account has been closed */
  closed = 'closed',
  /** Account closure is in progress */
  inactive = 'inactive',
  /** Open account ready for use */
  open = 'open',
  /** Account is in process of being opened or verified */
  pending = 'pending'
}

export type AccountStrengthResult = {
  __typename?: 'AccountStrengthResult';
  achievements: Maybe<Array<Maybe<AccountAchievement>>>;
  percentage: Scalars['Float'];
};

export enum AccountType {
  /** Core basic investment account */
  basic = 'basic',
  /** Spend LSB checking account */
  checking = 'checking',
  /** Later ROTH IRA account */
  rothIra = 'rothIra',
  /** Later SEP IRA account */
  sepIra = 'sepIra',
  /** Later traditional IRA account */
  traditionalIra = 'traditionalIra',
  /** Uniform Gift to Minors Act */
  ugma = 'ugma',
  /** Uniform Transfers to Minors Act */
  utma = 'utma'
}

/** Account values over the reporting period */
export type AccountValue = {
  __typename?: 'AccountValue';
  /** The dollar amount of the account's balance */
  amount: Maybe<Scalars['Float']>;
  /** The time of the associated account value */
  timestamp: Maybe<Scalars['DateTime']>;
};

export enum AchievementItem {
  accountValueGte10 = 'accountValueGte10',
  accountValueGte100 = 'accountValueGte100',
  automaticInvestmentOn = 'automaticInvestmentOn',
  automaticRoundupsOn = 'automaticRoundupsOn',
  fundingSourceLinked = 'fundingSourceLinked',
  multipleRoundupAccountsLinked = 'multipleRoundupAccountsLinked',
  registrationComplete = 'registrationComplete',
  roundupAccountLinked = 'roundupAccountLinked'
}

export type AcornsEarlyUserDetails = {
  __typename?: 'AcornsEarlyUserDetails';
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  credentialsExist: Scalars['Boolean'];
  dateOfBirth: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  zipCode: Maybe<Scalars['String']>;
};

export enum AcornsPartnerStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  EXPIRING_SOON = 'EXPIRING_SOON',
  INACTIVE = 'INACTIVE',
  IN_PROGRESS = 'IN_PROGRESS'
}

/** Acorns PDF Switches are performed by emailing and printing a PDF. */
export type AcornsPdfSwitch = SwitchInterface & {
  __typename?: 'AcornsPdfSwitch';
  source: SwitchSource;
  type: SwitchType;
};

/** Returned when there is negative values in allocations. */
export type AcornsValidationError = {
  __typename?: 'AcornsValidationError';
  message: Scalars['String'];
};

export type ActionCard = {
  __typename?: 'ActionCard';
  /** The body text for the card */
  body: Maybe<Scalars['String']>;
  /** call-to-action */
  ctaDetails: Maybe<ActionCardButton>;
  /** A smaller card title */
  eyebrow: Maybe<Scalars['String']>;
  /** Headline for the card */
  headline: Maybe<Scalars['String']>;
  /** An image used in the hero of a card */
  heroImageUrl: Maybe<Scalars['URL']>;
  /** A type of icon to render on the card */
  icon: Maybe<Scalars['String']>;
  /** An image to render on the card */
  image: Maybe<Scalars['JSON']>;
  /** An image to render on the card */
  imageUrl: Maybe<Scalars['URL']>;
  /** Owner name for found money offers */
  ownerName: Maybe<Scalars['String']>;
  /** A specific card style */
  style: ActionCardStyle;
  /** The title for the card */
  title: Maybe<Scalars['String']>;
  /** A specific type of card */
  type: Scalars['String'];
  /** Unique digest for the card */
  userCardDigest: Maybe<Scalars['ID']>;
  /** A widget to be rendered with the card */
  widget: Maybe<Scalars['JSON']>;
};

export type ActionCardButton = {
  __typename?: 'ActionCardButton';
  id: Maybe<Scalars['String']>;
  image: Maybe<Scalars['URL']>;
  title: Scalars['String'];
  type: Scalars['String'];
  video: Maybe<Scalars['URL']>;
  videoUrl: Maybe<Scalars['URL']>;
};

export enum ActionCardStyle {
  /** alert */
  alert = 'alert',
  /** announcingLater */
  announcingLater = 'announcingLater',
  /** basic */
  basic = 'basic',
  /** basicVideo */
  basicVideo = 'basicVideo',
  /** foundMoney */
  foundMoney = 'foundMoney',
  /** grow */
  grow = 'grow',
  /** snackable */
  snackable = 'snackable',
  /** widget */
  widget = 'widget'
}

export type ActionCardsInput = {
  feedContext?: InputMaybe<ActionFeedContext>;
};

export enum ActionFeedContext {
  /** feed context */
  a3Core = 'a3Core',
  /** feed context */
  a3Later = 'a3Later',
  /** feed context */
  a3Present = 'a3Present',
  /** feed context */
  a3Spend = 'a3Spend',
  /** feed context */
  a4BankingHub = 'a4BankingHub',
  /** feed context */
  a4CheckingEngagementWizard = 'a4CheckingEngagementWizard',
  /** feed context */
  a4CheckingHub = 'a4CheckingHub',
  /** feed context */
  a4Early = 'a4Early',
  /** feed context */
  a4EarlyDetails = 'a4EarlyDetails',
  /** feed context */
  a4Home = 'a4Home',
  /** feed context */
  a4HomeBottomNav = 'a4HomeBottomNav',
  /** feed context */
  a4Invest = 'a4Invest',
  /** feed context */
  a4InvestHub = 'a4InvestHub',
  /** feed context */
  a4Kids = 'a4Kids',
  /** feed context */
  a4Later = 'a4Later',
  /** feed context */
  a4LearnHub = 'a4LearnHub',
  /** feed context */
  a4Savings = 'a4Savings',
  /** feed context */
  a4Spend = 'a4Spend',
  /** feed context */
  later = 'later',
  /** feed context */
  present = 'present'
}

export type ActionFeedCta = {
  __typename?: 'ActionFeedCta';
  hideCardIfUnknown: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  image: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Maybe<ActionFeedCtaType>;
  video: Maybe<Scalars['String']>;
  videoUrl: Maybe<Scalars['String']>;
};

export enum ActionFeedCtaType {
  /** triggers an email download */
  email = 'email',
  /** grow article link */
  grow_article = 'grow_article',
  /** link */
  link = 'link',
  /** insights sequence offer */
  offer = 'offer',
  /** insights sequence spell */
  spell = 'spell',
  /** customer feedback survey */
  survey = 'survey',
  /** link to view a video */
  video = 'video',
  /** insights sequence wizard */
  wizard = 'wizard'
}

/** input for an action feed event */
export type ActionFeedEvent = {
  /** investment account id */
  accountId?: InputMaybe<Scalars['ID']>;
  /** event action type */
  action: ActionFeedEventAction;
  /** body of event */
  body?: InputMaybe<Scalars['String']>;
  /** cta id */
  ctaId?: InputMaybe<Scalars['ID']>;
  /** card, widget, or tip type */
  eventKey: Scalars['ID'];
  /** CARD | TIP */
  eventType: ActionFeedEventType;
  /** card digest id */
  userCardDigest?: InputMaybe<Scalars['String']>;
};

export enum ActionFeedEventAction {
  /** Completed */
  completed = 'completed',
  /** Dismissed */
  dismissed = 'dismissed',
  /** Card Impression */
  impression = 'impression',
  /** CTA Tapped */
  tapped = 'tapped'
}

/** Response to recording a feed event */
export type ActionFeedEventResponse = {
  __typename?: 'ActionFeedEventResponse';
  success: Scalars['Boolean'];
};

export enum ActionFeedEventType {
  /** Card Event - impression, tapped, dismissed */
  CARD = 'CARD',
  /** Tip Event - completed, dismissed */
  TIP = 'TIP'
}

/** Extendable Frontend Component Type */
export type ActionScreenComponent = ActionWidget;

export enum ActionScreenContext {
  /** screen context */
  a4BankingHub = 'a4BankingHub',
  /** screen context */
  a4CheckingHub = 'a4CheckingHub',
  /** screen context */
  a4EarlyDetails = 'a4EarlyDetails',
  /** screen context */
  a4HomeBottomNav = 'a4HomeBottomNav',
  /** screen context */
  a4Invest = 'a4Invest',
  /** screen context */
  a4InvestHub = 'a4InvestHub',
  /** screen context */
  a4Kids = 'a4Kids',
  /** screen context */
  a4Later = 'a4Later',
  /** screen context */
  a4LearnHub = 'a4LearnHub',
  /** screen context */
  a4Savings = 'a4Savings',
  /** screen context */
  a4Spend = 'a4Spend'
}

export enum ActionType {
  CHOOSE = 'CHOOSE',
  CONTINUE = 'CONTINUE',
  DIRECT = 'DIRECT',
  LINK = 'LINK',
  MANUAL = 'MANUAL',
  MORE_INFO = 'MORE_INFO',
  SKIP = 'SKIP',
  SWITCH = 'SWITCH',
  /** Represents when a user switches funnels mid-way through a funnel */
  UPDATE = 'UPDATE'
}

/** Action Screen widget type */
export type ActionWidget = {
  __typename?: 'ActionWidget';
  /**
   * unique identifying hash of the card
   * @deprecated not in use by clients
   */
  digest: Maybe<Scalars['String']>;
  /** The identifying string for the widget */
  identifier: Scalars['String'];
  /** The unique name of the widget */
  type: Scalars['String'];
};

export type ActivateBankCardInput = {
  cardNumberMasked: Scalars['CardNumberMasked'];
};

export type ActivateBankCardPayload = {
  __typename?: 'ActivateBankCardPayload';
  bankCard: Maybe<BankCard>;
};

export type ActivateOauthAppClientResult = OauthAppClient | OauthAppClientNotFoundException;

export type ActivateOauthAppResult = OauthApp | OauthAppNotFoundException;

export type ActiveReferralCampaignOutput = {
  __typename?: 'ActiveReferralCampaignOutput';
  campaigns: Array<Maybe<ReferralCampaignV2>>;
};

export type Activity = {
  __typename?: 'Activity';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  meta: Scalars['JSON'];
  pending: Maybe<Scalars['Boolean']>;
  type: ActivityType;
};

export enum ActivitySummaryProduct {
  /** Early investment product */
  EARLY = 'EARLY',
  /** Core investment product */
  INVEST = 'INVEST',
  /** Later investment product */
  LATER = 'LATER'
}

export type ActivitySummaryResponse = {
  __typename?: 'ActivitySummaryResponse';
  activitySummaryItems: Maybe<Array<SummaryItem>>;
  numberOfDays: Maybe<Scalars['Int']>;
  /** @deprecated Use `totalV2` for standardized money format */
  total: Maybe<CurrencyAmount>;
  totalV2: Maybe<MicrosMoney>;
};

export enum ActivityType {
  achFee = 'achFee',
  bonusRoundup = 'bonusRoundup',
  credit = 'credit',
  directFee = 'directFee',
  dividend = 'dividend',
  employeeContribution = 'employeeContribution',
  fee = 'fee',
  foundMoney = 'foundMoney',
  giftCard = 'giftCard',
  oneTimeInvestment = 'oneTimeInvestment',
  partnerReward = 'partnerReward',
  rebalance = 'rebalance',
  recurringInvestment = 'recurringInvestment',
  referralReward = 'referralReward',
  roundUp = 'roundUp',
  seeding = 'seeding',
  withdrawal = 'withdrawal'
}

/** Input for adding cohorts */
export type AddCohortEligibilityInput = {
  /** List of cohort slugs to add */
  add: Array<Scalars['String']>;
};

/** Added Cohorts Result */
export type AddCohortEligibilityResult = UserCohorts;

export type AddPolicyInput = {
  name: Scalars['String'];
};

export type AddPolicyResult = AddPolicySuccess | PoliciesRecordDoesNotExistException | PolicyNotAddedException;

export type AddPolicySuccess = {
  __typename?: 'AddPolicySuccess';
  policies: Maybe<Array<Maybe<Policy>>>;
};

export type AddSearchTermToLearnSearchHistoryInput = {
  term: Scalars['String'];
};

export type AddSearchTermToLearnSearchHistoryResult = LearnSearchTermSavedResult;

/** Input to add a security to a portfolio */
export type AddSecurityToPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID'];
  /** The market exchange symbol of the ETF to add to the portfolio */
  symbol: Scalars['String'];
};

/** Result from adding a security to a portfolio */
export type AddSecurityToPortfolioResult = InvestmentAccountNotFoundException | InvestmentAccountNotSupportedException | Portfolio | PortfolioNotFoundException | PortfolioNotSupportedException | SecurityNotSupportedException;

/** Input for creating a Self Directed Portfolio */
export type AddSelfDirectedPortfolioInput = {
  /** ID of the existing investment account for this portfolio to be associated with */
  investmentAccountId: Scalars['ID'];
};

/** Result from opening a Self Directed Portfolio */
export type AddSelfDirectedPortfolioResult = CustomerAgreementRequiredException | InvalidInvestmentAccountException | InvalidSubscriptionTierException | InvestmentAccount | PortfolioNotFoundException;

/** Miscellaneous attributes and information about a user's address */
export type Address = TimestampsInterface & {
  __typename?: 'Address';
  /** Type of address */
  addressType: AddressType;
  /** City */
  city: Scalars['String'];
  /** Country */
  country: Scalars['String'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Internal ID for address */
  id: Scalars['ID'];
  /** State */
  state: Scalars['String'];
  /** First street address */
  street1: Scalars['String'];
  /** Second street address */
  street2: Maybe<Scalars['String']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** Internal ID for user */
  userId: Scalars['ID'];
  /** Address has been verified */
  verified: Scalars['Boolean'];
  /** Zip code */
  zipCode: Scalars['String'];
};

export type AddressDeliverabilityAdditionalInfo = {
  __typename?: 'AddressDeliverabilityAdditionalInfo';
  isBusiness: Maybe<Scalars['Boolean']>;
  isPoBox: Maybe<Scalars['Boolean']>;
  isPrivateMailbox: Maybe<Scalars['Boolean']>;
  isVacant: Maybe<Scalars['Boolean']>;
};

/**
 * The Address is verified as deliverable but requires corrections to one or more input fields.
 * Note: Clients can determine what fields are different by diffing their input with the corrected field.
 */
export type AddressDeliverabilityCorrectedAddress = {
  __typename?: 'AddressDeliverabilityCorrectedAddress';
  additionalInfo: Maybe<AddressDeliverabilityAdditionalInfo>;
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street1: Maybe<Scalars['String']>;
  street2: Maybe<Scalars['String']>;
  zipCode: Maybe<Scalars['String']>;
};

/** Changeable attributes for addresses */
export type AddressDeliverabilityInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  /** 5 digit zip code */
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AddressDeliverabilityResult = AddressDeliverabilityCorrectedAddress | AddressDeliverabilityUnavailableError | AddressDeliverabilityVerificationError | AddressDeliverabilityVerified;

/** The Verification was unavailable. Clients should determine how to handle this case according to product requirements */
export type AddressDeliverabilityUnavailableError = {
  __typename?: 'AddressDeliverabilityUnavailableError';
  requestId: Maybe<Scalars['String']>;
};

/** The Verification rejected the address as undeliverable. */
export type AddressDeliverabilityVerificationError = {
  __typename?: 'AddressDeliverabilityVerificationError';
  failureReason: Maybe<AddressDeliverabilityVerificationErrorFailureReason>;
  requestId: Maybe<Scalars['String']>;
};

export enum AddressDeliverabilityVerificationErrorFailureReason {
  /** The input address matched to a physical address that does not receive delivery from the USPS */
  addressNotDeliverable = 'addressNotDeliverable',
  /** The input address is missing or was not found */
  addressNotFound = 'addressNotFound',
  /** The input matched multiple addresses, needs more info */
  ambiguousAddress = 'ambiguousAddress',
  /** The input address has an invalid house number */
  invalidAddressPrimaryNumber = 'invalidAddressPrimaryNumber',
  /** The input address contains an invalid ste, apt, or box number */
  invalidAddressSecondaryNumber = 'invalidAddressSecondaryNumber',
  /** The input city is missing or invalid */
  invalidCity = 'invalidCity',
  /** The input address' PO, RR, or HC box number invalid */
  invalidPoBoxNumber = 'invalidPoBoxNumber',
  /** The input state code is missing or invalid */
  invalidState = 'invalidState',
  /** The input postal code is missing or invalid */
  invalidZipCode = 'invalidZipCode',
  /** The input address is missing a house number */
  missingAddressPrimaryNumber = 'missingAddressPrimaryNumber',
  /** The input address is missing ste, apt, or box number */
  missingAddressSecondaryNumber = 'missingAddressSecondaryNumber',
  /** The input address matched to CMRA but PMB designator not present (PMB 123 or # 123) */
  missingPmbNumber = 'missingPmbNumber',
  /** The input address is missing PO, RR, or HC box number */
  missingPoBoxNumber = 'missingPoBoxNumber',
  /** An unknown or unmapped error occurred */
  unknown = 'unknown'
}

/** The Address is verified as deliverable with no corrections issued on any input fields. */
export type AddressDeliverabilityVerified = {
  __typename?: 'AddressDeliverabilityVerified';
  additionalInfo: Maybe<AddressDeliverabilityAdditionalInfo>;
  requestId: Maybe<Scalars['String']>;
};

/** Address Document Requested Alert. */
export type AddressDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'AddressDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** Changeable attributes for addresses */
export type AddressInput = {
  /** City */
  city?: InputMaybe<Scalars['String']>;
  /** Country */
  country?: InputMaybe<Scalars['String']>;
  /** State */
  state?: InputMaybe<Scalars['String']>;
  /** Street 1 */
  street1?: InputMaybe<Scalars['String']>;
  /** Street 2 */
  street2?: InputMaybe<Scalars['String']>;
  /** Zip code */
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum AddressType {
  /** A billing address */
  billing = 'billing',
  /** A mailing address */
  mailing = 'mailing',
  /** A residential address */
  residential = 'residential'
}

export type AddressVerification = {
  verificationStatus: VerificationStatus;
};

/** An existing Acorns user that has referred friends to Acorns */
export type Advocate = {
  __typename?: 'Advocate';
  /** User's current eligible campaign */
  campaign: Maybe<ReferralCampaignV2>;
  /** The content that supports and drives the user experience */
  experienceContent: Maybe<ExperienceContent>;
  /**
   * A list of people that have used the advocate's share link
   * @deprecated Field no longer supported
   */
  friends: Maybe<Array<Friend>>;
  /** The referral code associated with the advocate */
  referralCodes: Maybe<Array<Scalars['String']>>;
  /**
   * An object with referral metrics for the advocate
   * @deprecated Field no longer supported
   */
  referralHistory: Maybe<ReferralHistory>;
  /** UUID of the existing Acorns user */
  userId: Maybe<Scalars['ID']>;
};

/** List of referral codes and friends that were referred by an existing Acorns user */
export type AdvocateFriendsStatuses = {
  __typename?: 'AdvocateFriendsStatuses';
  /** A list of people that have used the advocate's share link */
  friends: Maybe<Array<Friend>>;
  /** The referral codes associated with the advocate */
  referralCodes: Maybe<Array<Scalars['String']>>;
  /** User ID of the advocate */
  userId: Scalars['ID'];
};

export type AdvocateV2 = {
  __typename?: 'AdvocateV2';
  userId: Maybe<Scalars['ID']>;
};

export type Alert = {
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/** Response from beneficiary alert hub alerts query */
export type AlertHubBeneficiaryAlert = MissingSsnBeneficiaryAlertItem | UnverifiedBeneficiarySsnAlertItem;

export type AlertMessage = Message & {
  __typename?: 'AlertMessage';
  body: MessageTextAsset;
  cardColor: Maybe<CardColor>;
  createdAt: Scalars['DateTime'];
  deepLink: Maybe<Scalars['URL']>;
  delay: Maybe<Scalars['Int']>;
  externalId: Scalars['ID'];
  icon: Maybe<MessageVisualAsset>;
  id: Scalars['ID'];
  isDismissed: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  messageCategory: MessageCategory;
  messageType: MessageType;
  platforms: Array<Platform>;
  priority: Maybe<Scalars['Int']>;
  readAt: Maybe<Scalars['DateTime']>;
  title: MessageTextAsset;
  trackingId: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
};

export type AllAccountHistorySummary = PastSummary & {
  __typename?: 'AllAccountHistorySummary';
  dividends: CurrencyAmount;
  earnRewards: CurrencyAmount;
  moneyIn: CurrencyAmount;
  moneyOut: CurrencyAmount;
  referralRewards: CurrencyAmount;
};

/** Optional filter to retrieve all accounts for a customer. */
export type AllAccountsFilterInput = {
  /** Retrieve accounts internal to Acorns. */
  internalType?: InputMaybe<Scalars['Boolean']>;
};

export type AllBankAccountsInput = {
  /** Deprecated. Use types instead. types takes precedence over type if both are non-null */
  type?: InputMaybe<BankAccountType>;
  types?: InputMaybe<Array<BankAccountType>>;
};

export type AllBankCardsFilter = {
  showNonActive?: InputMaybe<Scalars['Boolean']>;
};

export type AllBankDocumentsInput = {
  accountType?: InputMaybe<BankAccountType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type AllChatHistoryMessages = {
  __typename?: 'AllChatHistoryMessages';
  edges: Array<ChatHistoryMessageEdge>;
  pageInfo: PageInfo;
};

/** The result of the allCheckPayments query */
export type AllCheckPaymentsResult = AuthorizationError | CheckPaymentConnection;

export type AllPastCoreItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>;
};

export type AllPastEarlyItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>;
};

export type AllPastItemsFilter = {
  /** Requested Account */
  pastItemsAccountFilter?: InputMaybe<PastItemsAccountFilter>;
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>;
};

export type AllPastLaterItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>;
};

export type AllPastSpendItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>;
};

export type AllSupportArticlesFilterInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
};

export type AllTransferableToInput = {
  /** ID of TransferableAccounts that money can be taken from */
  from: Scalars['ID'];
};

/** Returned when the allocation amounts add up to over 100 */
export type AllocationAmountsSumExceedingMaxError = {
  __typename?: 'AllocationAmountsSumExceedingMaxError';
  message: Scalars['String'];
};

export type AnswerChallengeResult = AnswerChallengeSuccess | AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException;

export type AnswerChallengeSuccess = {
  __typename?: 'AnswerChallengeSuccess';
  authenticatorId: Scalars['ID'];
  deliveryType: ChallengeDeliveryType;
  userId: Scalars['ID'];
};

export type AnswerLearnQuizQuestionInput = {
  questionId: Scalars['ID'];
  quizId: Scalars['ID'];
  /** A list of one or more answers (if multiple choice question) */
  selectedAnswers: Array<LearnAnswerInput>;
};

export type AnswerLearnQuizQuestionResult = LearnQuizAnswerResult | RecordDoesNotExistError | UnauthorizedModifyLockedContentError;

export type ApplyPromoCodeResult = InvalidPromoCodeError | PromoCodeCustomer;

export type ApplyPromotionInput = {
  promotionId: Scalars['ID'];
  subscriptionId: Scalars['ID'];
};

export type ApplyPromotionResult = PromotionConsumedError | PromotionExpiredError | PromotionNotFoundError | SubscriberIneligibleError | TierSubscription;

export type ApplyPromotionalWaiverInput = {
  monthsToWaive: Scalars['Int'];
  promotion: WaiverPromotion_V2;
};

export type ApplyPromotionalWaiverResult = InvalidDateException | InvalidUserIdException | PromotionalWaiver_V2 | WaiverCreationException;

export type ApplyProvisionalWaiverResult = InvalidDateException | InvalidUserIdException | ProvisionalWaiver_V2 | WaiverCreationException;

export type ArchiveInvalidSmartDepositRecordsResult = {
  __typename?: 'ArchiveInvalidSmartDepositRecordsResult';
  userId: Scalars['String'];
};

/** Options to assign a subaccount to a given role */
export type AssignLinkedSubaccountInput = {
  /** Role to give the linked subaccount */
  role: LinkedSubaccountRoleEnum;
};

/** Response returned if the link session is asynchronous. */
export type AsyncLinkSessionResult = {
  __typename?: 'AsyncLinkSessionResult';
  /** The asynchronous process was kicked off successfully? */
  success: Scalars['Boolean'];
};

export type AuthAlert = {
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export type AuthChallenge = {
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type AuthChallengeAnswerAttemptsExhaustedException = {
  __typename?: 'AuthChallengeAnswerAttemptsExhaustedException';
  message: Maybe<Scalars['String']>;
};

export type AuthChallengeAnswerIncorrectException = {
  __typename?: 'AuthChallengeAnswerIncorrectException';
  message: Maybe<Scalars['String']>;
};

export type AuthChallengeExpiredException = {
  __typename?: 'AuthChallengeExpiredException';
  message: Maybe<Scalars['String']>;
};

export type AuthProfile = {
  __typename?: 'AuthProfile';
  /** the Authenticator that will be used for challenges by default. */
  defaultAuthenticator: Maybe<Authenticator>;
  email: Maybe<Scalars['EmailAddress']>;
  emailVerifiedAt: Maybe<Scalars['DateTime']>;
  loginAccess: Maybe<LoginAccess>;
  phoneNumber: Maybe<Scalars['String']>;
  phoneNumberVerifiedAt: Maybe<Scalars['DateTime']>;
  privateRelayUnverified: Maybe<Scalars['Boolean']>;
  requireLoginChallenge: Maybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type AuthProfileAlreadyExistsException = {
  __typename?: 'AuthProfileAlreadyExistsException';
  message: Maybe<Scalars['String']>;
};

export type AuthProfileNotFoundException = {
  __typename?: 'AuthProfileNotFoundException';
  userId: Scalars['ID'];
};

export type AuthSession = {
  __typename?: 'AuthSession';
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  identityToken: Maybe<Scalars['ID']>;
  /** @deprecated No longer used */
  redirectUrl: Maybe<Scalars['URL']>;
  refreshToken: Maybe<Scalars['ID']>;
  token: Scalars['ID'];
};

export type AuthTokenNotFoundException = {
  __typename?: 'AuthTokenNotFoundException';
  userId: Scalars['ID'];
};

export enum AuthType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  PUSH = 'PUSH'
}

export type AuthenticateForFeeNegotiationChallengeInput = {
  linkedAccountId: Scalars['ID'];
  tfaInput: Scalars['String'];
};

export type AuthenticateForFeeNegotiationChallengeMethodInput = {
  linkedAccountId: Scalars['ID'];
  restart: Scalars['Boolean'];
  tfaOption: Scalars['String'];
  tfaType: TfaType;
};

export type AuthenticateForFeeNegotiationInput = {
  bankName: BankName;
  linkedAccountId: Scalars['ID'];
  password: Scalars['String'];
  reconnect: Scalars['Boolean'];
  userName: Scalars['String'];
};

export type AuthenticateForFeeNegotiationResult = AuthenticateForFeeNegotiationStatus | LinkedAccountNotFound | NegotiationServiceConnectionFailure;

export type AuthenticateForFeeNegotiationStatus = {
  __typename?: 'AuthenticateForFeeNegotiationStatus';
  credentialStatus: CredentialStatus;
  operationError: Maybe<AutomationError>;
  operationStage: OperationStage;
  tfaMethod: Maybe<Scalars['String']>;
  tfaOptions: Maybe<TfaOptions>;
  tfaStatus: TfaStatus;
  tfaType: TfaType;
};

export type AuthenticateInput = {
  email: Scalars['EmailAddress'];
  password: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  udid: Scalars['String'];
};

export type AuthenticateNegotiationStatusResult = AuthenticateForFeeNegotiationStatus | LinkedAccountNotFound;

export type AuthenticateResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthSession | AuthenticatorTypeAlreadyRegisteredException | AuthenticatorUnavailableException | ChallengeRateExceededException | DeviceBlockedException | EmailAuthChallenge | InvalidCredentialsException | LoginRateLimitedException | PhoneNumberOptedOutException | SmsAuthChallenge | UserLockedException | UserSuspendedException;

export type AuthenticationAlreadyUpgradedException = {
  __typename?: 'AuthenticationAlreadyUpgradedException';
  userId: Scalars['ID'];
};

export type Authenticator = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>;
  lastUsedAt: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: AuthType;
  updatedAt: Scalars['DateTime'];
};

export type AuthenticatorAlreadyDefaultException = {
  __typename?: 'AuthenticatorAlreadyDefaultException';
  message: Maybe<Scalars['String']>;
};

export type AuthenticatorInfo = {
  __typename?: 'AuthenticatorInfo';
  id: Scalars['ID'];
  type: AuthType;
};

export type AuthenticatorNotFoundException = {
  __typename?: 'AuthenticatorNotFoundException';
  message: Maybe<Scalars['String']>;
};

export type AuthenticatorTypeAlreadyRegisteredException = {
  __typename?: 'AuthenticatorTypeAlreadyRegisteredException';
  message: Maybe<Scalars['String']>;
};

export type AuthenticatorUnavailableException = {
  __typename?: 'AuthenticatorUnavailableException';
  message: Maybe<Scalars['String']>;
};

export type AuthorizationError = {
  __typename?: 'AuthorizationError';
  requestId: Scalars['ID'];
};

export type AutomationError = {
  __typename?: 'AutomationError';
  error: Maybe<Scalars['String']>;
  errorCode: Maybe<AutomationErrorCode>;
};

export enum AutomationErrorCode {
  CTT_EX = 'CTT_EX',
  LOG_BLK = 'LOG_BLK',
  LOG_EX = 'LOG_EX',
  LOG_INV = 'LOG_INV',
  STT_EX = 'STT_EX',
  STT_RES = 'STT_RES',
  TFA_INV = 'TFA_INV',
  TFA_SEL_INV = 'TFA_SEL_INV',
  WF_TFA = 'WF_TFA'
}

export type BackendJobBatch = {
  __typename?: 'BackendJobBatch';
  createdAt: Scalars['DateTime'];
  failedJobs: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pendingJobs: Maybe<Scalars['Int']>;
  pendingPercentage: Maybe<Scalars['Float']>;
  processedJobs: Maybe<Scalars['Int']>;
  status: BackendJobBatchStatus;
  successPercentage: Maybe<Scalars['Float']>;
  totalJobs: Maybe<Scalars['Int']>;
  type: BackendJobBatchType;
};

export type BackendJobBatchAutomatedOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>;
  timeframe: BackendJobBatchTimeframe;
};

export type BackendJobBatchMoneyMovementFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>;
  timeframe: BackendJobBatchTimeframe;
};

export type BackendJobBatchOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>;
  timeframe: BackendJobBatchTimeframe;
};

export type BackendJobBatchProfitStarsFilterInput = {
  timeframe: BackendJobBatchTimeframe;
};

export enum BackendJobBatchStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  RESTARTED = 'RESTARTED',
  STARTED = 'STARTED'
}

export type BackendJobBatchSummary = {
  __typename?: 'BackendJobBatchSummary';
  createdAt: Scalars['DateTime'];
  customerCount: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  totalHoldingsAmount: Maybe<Scalars['Float']>;
  totalInvestmentAmount: Maybe<Scalars['Float']>;
  totalInvestmentCount: Maybe<Scalars['Int']>;
};

export type BackendJobBatchSummaryFilterInput = {
  jobBatchType: BackendJobBatchType;
  timeframe: BackendJobBatchTimeframe;
};

export enum BackendJobBatchTimeframe {
  LAST_SEVEN = 'LAST_SEVEN',
  LAST_THIRTY = 'LAST_THIRTY',
  MONTH = 'MONTH',
  TODAY = 'TODAY',
  YEAR = 'YEAR',
  YESTERDAY = 'YESTERDAY'
}

export enum BackendJobBatchType {
  AUTOMATED_BUY_ORDER_CONFIRM = 'AUTOMATED_BUY_ORDER_CONFIRM',
  AUTOMATED_BUY_ORDER_LOCK = 'AUTOMATED_BUY_ORDER_LOCK',
  AUTOMATED_SELL_FEE_ORDER_CONFIRM = 'AUTOMATED_SELL_FEE_ORDER_CONFIRM',
  AUTOMATED_SELL_FEE_ORDER_LOCK = 'AUTOMATED_SELL_FEE_ORDER_LOCK',
  BUY_ORDER_CONFIRM = 'BUY_ORDER_CONFIRM',
  BUY_ORDER_LOCK = 'BUY_ORDER_LOCK',
  CHARGEBACK_ORDER_LOCK = 'CHARGEBACK_ORDER_LOCK',
  PROFIT_STARS_DEPOSITS = 'PROFIT_STARS_DEPOSITS',
  REBALANCE_BUY_ORDER_CONFIRM = 'REBALANCE_BUY_ORDER_CONFIRM',
  REBALANCE_BUY_ORDER_LOCK = 'REBALANCE_BUY_ORDER_LOCK',
  REBALANCE_SELL_ORDER_CONFIRM = 'REBALANCE_SELL_ORDER_CONFIRM',
  REBALANCE_SELL_ORDER_LOCK = 'REBALANCE_SELL_ORDER_LOCK',
  SELL_FEE_ORDER_CONFIRM = 'SELL_FEE_ORDER_CONFIRM',
  SELL_FEE_ORDER_LOCK = 'SELL_FEE_ORDER_LOCK',
  TRANSFER_APPROVAL = 'TRANSFER_APPROVAL'
}

/** Request either has missing or incorrect data */
export type BadRequestError = {
  __typename?: 'BadRequestError';
  message: Scalars['String'];
};

export enum BadgeCategory {
  NEW_CUSTOMER = 'NEW_CUSTOMER',
  TRAVEL = 'TRAVEL'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  accountHolderReferenceId: Scalars['ID'];
  /** The name of the account */
  accountName: Scalars['String'];
  /**
   * Balance available for immediate withdrawal.
   * Settling a transaction for a DDA account will typically credit the
   * availableBalance immediately. However, savings or FBO accounts may have
   * a "deposit hold time" or a "new customer hold time", meaning there could be
   * a length of time between when the transaction is settled and the corresponding
   * funds are made available for withdrawal.
   */
  availableBalance: CurrencyAmount;
  availableBalanceAndIncomingBalance: CurrencyAmount;
  balance: CurrencyAmount;
  /** The bank that this account is associated with */
  bankType: BankType;
  closedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /**
   * The interest rates that are currently being offered
   * @deprecated Use bankInterestRates Query to get apy
   */
  currentAPY: Maybe<Scalars['String']>;
  /** @deprecated Use balance */
  currentBalance: CurrencyAmount;
  /** Information related to the goals of the bank account */
  goals: BankAccountGoals;
  id: Scalars['ID'];
  isEligible: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  /**
   * True if an account closure has been initiated but
   * was unsuccessful in automatically closing.
   */
  isPendingClosure: Maybe<Scalars['Boolean']>;
  lockReason: Maybe<BankAccountLockReason>;
  number: Scalars['String'];
  /**
   * Balance of pending deposit transactions. When a pending deposit transaction
   * settles, it will debit this balance. Deposit transactions which settle
   * immediately will never affect this balance.
   */
  pendingBalance: CurrencyAmount;
  referenceId: Scalars['ID'];
  /**
   * The current status of the account and requirements
   * needed to be met to close the account
   */
  requirements: BankAccountRequirements;
  routingNumber: Scalars['String'];
  status: BankAccountStatus;
  /**
   * Total balance of account, including funds that have holds placed on them. Represents all settled
   * transactions on the account to date. Balance of pending deposit transactions. When a pending deposit transaction settles, it will
   * debit this balance. Deposit transactions which settle immediately will never affect this
   * balance.
   */
  totalBalance: CurrencyAmount;
  type: BankAccountType;
  updatedAt: Scalars['DateTime'];
};

export enum BankAccountClosureReason {
  /** Going to a competitor */
  GOING_TO_A_COMPETITOR = 'GOING_TO_A_COMPETITOR',
  /** Had a bad experience */
  HAD_A_BAD_EXPERIENCE = 'HAD_A_BAD_EXPERIENCE',
  /** Missing features I expect with a checking account */
  MISSING_FEATURES_EXPECTED_WITH_CHECKING_ACCOUNT = 'MISSING_FEATURES_EXPECTED_WITH_CHECKING_ACCOUNT',
  /** Not seeing the value */
  NOT_SEEING_THE_VALUE = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NO_LONGER_USE = 'NO_LONGER_USE',
  /** Other */
  OTHER = 'OTHER'
}

export type BankAccountDisclosure = {
  __typename?: 'BankAccountDisclosure';
  id: Scalars['ID'];
  mustScrollToBottom: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredFor: Maybe<Scalars['String']>;
  summaryName: Maybe<Scalars['String']>;
  summaryUrl: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url: Scalars['String'];
  version: Scalars['String'];
};

export type BankAccountDisclosureFilter = {
  bankType: BankType;
  paymentProcessor: BankCardPaymentProcessor;
};

export type BankAccountGoal = {
  __typename?: 'BankAccountGoal';
  amount: CurrencyAmount;
  name: Scalars['String'];
  type: BankAccountGoalType;
};

export type BankAccountGoalInput = {
  amount: PositiveCurrencyAmountInput;
  type: BankAccountGoalType;
};

export enum BankAccountGoalType {
  EMERGENCY_SAVINGS = 'EMERGENCY_SAVINGS'
}

export type BankAccountGoals = {
  __typename?: 'BankAccountGoals';
  currentGoal: Maybe<BankAccountGoal>;
};

export enum BankAccountLockReason {
  Administrative = 'Administrative',
  CreditsOnly = 'CreditsOnly',
  Fraud = 'Fraud',
  Frozen = 'Frozen',
  Temporary = 'Temporary',
  Unknown = 'Unknown'
}

export type BankAccountNotFoundError = {
  __typename?: 'BankAccountNotFoundError';
  message: Scalars['String'];
};

/**
 * Defines a list of requirements that must be met before a bank account
 * can be closed
 */
export type BankAccountRequirement = {
  __typename?: 'BankAccountRequirement';
  actionable: Scalars['Boolean'];
  description: Maybe<Scalars['String']>;
  status: BankAccountRequirementStatus;
  type: BankAccountRequirementType;
};

export enum BankAccountRequirementStatus {
  ACTIONS_REQUIRED = 'ACTIONS_REQUIRED',
  COMPLETED = 'COMPLETED',
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING'
}

export enum BankAccountRequirementType {
  FUNDING_SOURCE = 'FUNDING_SOURCE',
  NO_PENDING_TRANSFERS = 'NO_PENDING_TRANSFERS',
  UNLOCKED_CHECKING_ACCOUNT = 'UNLOCKED_CHECKING_ACCOUNT',
  VERIFIED_FUNDING_SOURCE = 'VERIFIED_FUNDING_SOURCE'
}

export type BankAccountRequirements = {
  __typename?: 'BankAccountRequirements';
  close: Array<BankAccountRequirement>;
};

export type BankAccountState = {
  __typename?: 'BankAccountState';
  accountType: BankAccountType;
  status: BankAccountStateStatus;
};

export type BankAccountStateResult = {
  __typename?: 'BankAccountStateResult';
  accounts: Array<BankAccountState>;
};

export enum BankAccountStateStatus {
  CLOSED = 'CLOSED',
  HARD_FAILURE = 'HARD_FAILURE',
  LOCKED = 'LOCKED',
  NOT_OPENED = 'NOT_OPENED',
  OPEN = 'OPEN',
  OPENING = 'OPENING',
  REOPENING = 'REOPENING'
}

export enum BankAccountStatus {
  closed = 'closed',
  locked = 'locked',
  open = 'open'
}

export enum BankAccountType {
  save = 'save',
  spend = 'spend'
}

export type BankAccountTypeConfig = {
  accountType: BankAccountType;
  bankType?: InputMaybe<BankType>;
};

export type BankCard = {
  __typename?: 'BankCard';
  activatedAt: Maybe<Scalars['DateTime']>;
  bankType: BankType;
  cardNumberMasked: Maybe<Scalars['CardNumberMasked']>;
  createdAt: Scalars['DateTime'];
  digitalWalletTokens: Array<DigitalWalletToken>;
  expireMonth: Scalars['Int'];
  expireYear: Scalars['Int'];
  id: Scalars['ID'];
  isDigitalOnly: Maybe<Scalars['Boolean']>;
  isDigitallyProvisioned: Scalars['Boolean'];
  lockReason: Maybe<BankCardLockReason>;
  lockTypeCode: BankCardLockTypeCode;
  paymentProcessor: BankCardPaymentProcessor;
  referenceId: Scalars['ID'];
  status: BankCardStatus;
  tier: BankCardTier;
  type: BankCardType;
  userActivatedAt: Maybe<Scalars['DateTime']>;
};

export enum BankCardLockReason {
  admin = 'admin',
  damage = 'damage',
  fraud = 'fraud',
  lost = 'lost',
  pinRetriesExceeded = 'pinRetriesExceeded',
  stolen = 'stolen',
  temporary = 'temporary',
  unknown = 'unknown'
}

export enum BankCardLockTypeCode {
  customer = 'customer',
  system = 'system',
  unlocked = 'unlocked'
}

export type BankCardOrder = {
  __typename?: 'BankCardOrder';
  addressVerification: Maybe<BankCardOrderAddressVerification>;
  bankCardTier: Maybe<BankCardTier>;
  bankType: Maybe<BankType>;
  cardOrderStatus: BankCardOrderStatus;
  createdAt: Maybe<Scalars['String']>;
  failureReason: Maybe<BankCardOrderFailureReason>;
  fundingInitiated: Maybe<Scalars['Boolean']>;
  fundingSourceVerification: Maybe<BankCardOrderFundingSourceVerification>;
  identityVerification: Maybe<BankCardOrderIdentityVerification>;
  /**
   * Verification results for this customer contained reasons that we consider high risk,
   * irrespective of the decision returned by our KYC vendor.
   * The purpose of this field is to surface that risk to related backend services.
   * Front end clients should confirm with banking team before using.
   */
  isKycHighRisk: Maybe<Scalars['Boolean']>;
  kycStatus: Maybe<KycStatus>;
  prefundVerification: Maybe<BankCardOrderPrefundVerification>;
  requestVersion: Maybe<RequestVersions>;
};

export type BankCardOrderAddressVerification = AddressVerification & {
  __typename?: 'BankCardOrderAddressVerification';
  actionRequired: Maybe<BankCardOrderAddressVerificationActions>;
  status: BankCardOrderVerificationStatus;
  verificationStatus: VerificationStatus;
};

export enum BankCardOrderAddressVerificationActions {
  uploadDocuments = 'uploadDocuments'
}

export enum BankCardOrderFailureReason {
  ADDRESS_FAILURE = 'ADDRESS_FAILURE',
  EXPIRED = 'EXPIRED',
  FUNDING_SOURCE_FAILURE = 'FUNDING_SOURCE_FAILURE',
  IDENTITY_FAILURE = 'IDENTITY_FAILURE',
  PREFUND_FAILURE = 'PREFUND_FAILURE'
}

export type BankCardOrderFundingSourceVerification = {
  __typename?: 'BankCardOrderFundingSourceVerification';
  actionRequired: Maybe<BankCardOrderFundingSourceVerificationActions>;
  pendingReason: Maybe<BankCardOrderFundingSourceVerificationPendingReason>;
  status: BankCardOrderVerificationStatus;
};

export enum BankCardOrderFundingSourceVerificationActions {
  handleFrozenFundingSource = 'handleFrozenFundingSource',
  linkFundingSource = 'linkFundingSource',
  submitRDVs = 'submitRDVs',
  uploadDocuments = 'uploadDocuments'
}

export enum BankCardOrderFundingSourceVerificationPendingReason {
  documentsUnderReview = 'documentsUnderReview',
  rdvsInitiated = 'rdvsInitiated',
  rdvsPending = 'rdvsPending'
}

export type BankCardOrderIdentityVerification = IdentityVerification & {
  __typename?: 'BankCardOrderIdentityVerification';
  actionRequired: Maybe<BankCardOrderIdentityVerificationActions>;
  /**
   * If the user can re-attempt identity verification
   * They may have reached the max configured allowed attempts, or need manual approval due to suspected fraud or risk
   */
  canRetry: Maybe<Scalars['Boolean']>;
  documentUploadUrl: Maybe<Scalars['String']>;
  status: BankCardOrderVerificationStatus;
  verificationStatus: VerificationStatus;
};

export enum BankCardOrderIdentityVerificationActions {
  uploadDocuments = 'uploadDocuments'
}

export type BankCardOrderPrefundVerification = {
  __typename?: 'BankCardOrderPrefundVerification';
  actionRequired: Maybe<BankCardOrderPrefundVerificationActions>;
  status: BankCardOrderVerificationStatus;
};

export enum BankCardOrderPrefundVerificationActions {
  createBankTransfer = 'createBankTransfer'
}

export enum BankCardOrderStatus {
  accepted = 'accepted',
  actionRequired = 'actionRequired',
  failure = 'failure',
  notOrdered = 'notOrdered',
  pending = 'pending',
  success = 'success'
}

export enum BankCardOrderVerificationStatus {
  actionRequired = 'actionRequired',
  actionRequiredDueToFailure = 'actionRequiredDueToFailure',
  failure = 'failure',
  pending = 'pending',
  success = 'success'
}

export type BankCardPanDisplayPayload = {
  __typename?: 'BankCardPanDisplayPayload';
  bankCard: BankCard;
  token: Scalars['String'];
};

export type BankCardPanDisplayResult = BankCardPanDisplayPayload;

export enum BankCardPaymentProcessor {
  DPS = 'DPS',
  SHAZAM = 'SHAZAM'
}

export enum BankCardPermanentLockReason {
  fraud = 'fraud',
  lost = 'lost',
  stolen = 'stolen'
}

export type BankCardPrefundTransfer = {
  /** Amount (either $0 or between $25, $500) to transfer after bank account is created. */
  amount: PositiveCurrencyAmountInput;
};

export type BankCardProvisioningDetailsInput = {
  nonce: Scalars['String'];
};

export type BankCardProvisioningDetailsPayload = {
  __typename?: 'BankCardProvisioningDetailsPayload';
  cardNumberMasked: Maybe<Scalars['CardNumberMasked']>;
  token: Scalars['String'];
};

export type BankCardProvisioningDetailsResult = BankCardProvisioningDetailsPayload;

export type BankCardReissue = {
  __typename?: 'BankCardReissue';
  bankCardRequest: Maybe<BankCardRequest>;
  bankType: BankType;
  reissueBankCardEligibility: ReissueBankCardEligibility;
};

export type BankCardRequest = {
  __typename?: 'BankCardRequest';
  /** tag for new bank card */
  id: Scalars['ID'];
  /** True when new bank card has been activated */
  isActivated: Scalars['Boolean'];
  isReissue: Scalars['Boolean'];
  /** Issued date for new bank card */
  issuedDate: Maybe<Scalars['Date']>;
  /** The mailing address used to ship the reissued card */
  mailingAddress: Maybe<BankCardRequestMailingAddress>;
  previousBankCardId: Maybe<Scalars['ID']>;
  /** The tier level of the card. */
  previousBankCardTier: Maybe<BankCardTier>;
  /** Reason for requesting a new bank card */
  reason: BankCardRequestReason;
  /** Additional information pertaining to the request */
  reasonComment: Maybe<Scalars['String']>;
  /** Date associated with reason (Date lost, date stolen, etc) */
  reasonDate: Maybe<Scalars['Date']>;
  requestedDate: Scalars['Date'];
  status: BankCardRequestStatus;
  userId: Scalars['ID'];
};

export type BankCardRequestMailingAddress = {
  __typename?: 'BankCardRequestMailingAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type BankCardRequestMailingAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export enum BankCardRequestReason {
  DAMAGED = 'DAMAGED',
  DELIVERY_ISSUE = 'DELIVERY_ISSUE',
  LOST = 'LOST',
  NEW_ACCOUNT = 'NEW_ACCOUNT',
  OTHER = 'OTHER',
  STOLEN = 'STOLEN'
}

export enum BankCardRequestStatus {
  APPROVED = 'APPROVED',
  ISSUED = 'ISSUED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export enum BankCardStatus {
  archived = 'archived',
  denied = 'denied',
  digitalActivePhysicalInitiated = 'digitalActivePhysicalInitiated',
  digitalActivePhysicalPending = 'digitalActivePhysicalPending',
  expired = 'expired',
  hotlisted = 'hotlisted',
  initiated = 'initiated',
  pending = 'pending',
  pendingVerification = 'pendingVerification',
  reissued = 'reissued',
  verified = 'verified'
}

export enum BankCardTemporaryLockReason {
  damage = 'damage',
  fraud = 'fraud',
  temporary = 'temporary',
  unknown = 'unknown'
}

export enum BankCardTier {
  mightyOak = 'mightyOak',
  oak = 'oak',
  premiumOak = 'premiumOak',
  vipReissue = 'vipReissue'
}

export enum BankCardType {
  credit = 'credit',
  debit = 'debit'
}

export type BankConnection = {
  __typename?: 'BankConnection';
  accountStatus: Maybe<BankConnectionStatus>;
  bank: Scalars['String'];
  eligible: Maybe<Scalars['Boolean']>;
  lastSubmissionDate: Maybe<Scalars['DateTime']>;
  linkedAccountId: Scalars['ID'];
  logoUrl: Maybe<Scalars['URL']>;
  negotiationType: Maybe<NegotiationType>;
  nextSubmissionDate: Maybe<Scalars['DateTime']>;
  totalNegotiableFees: Maybe<MonetaryAmount>;
};

export enum BankConnectionStatus {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE_COOLDOWN = 'INELIGIBLE_COOLDOWN',
  INELIGIBLE_NOTSUPPORTED = 'INELIGIBLE_NOTSUPPORTED',
  INELIGIBLE_THRESHOLD = 'INELIGIBLE_THRESHOLD',
  LOWERTIER = 'LOWERTIER',
  PENDING = 'PENDING'
}

export type BankDocument = {
  __typename?: 'BankDocument';
  name: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

/** Bank Document Requested Alert. */
export type BankDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'BankDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export type BankFee = {
  __typename?: 'BankFee';
  accountName: Maybe<Scalars['String']>;
  amount: MonetaryAmount;
  category: Maybe<TransactionCategory>;
  /** @deprecated replaced by last4 */
  digit: Maybe<Scalars['String']>;
  last4: Maybe<Scalars['String']>;
  linkedAccountId: Maybe<Scalars['ID']>;
  linkedSubAccountId: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  status: Maybe<FeeStatus>;
  submissionKey: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  transactionDate: Maybe<Scalars['DateTime']>;
  type: Maybe<BankFeeType>;
};

export type BankFeeConnection = {
  __typename?: 'BankFeeConnection';
  bank: BankName;
  eligible: Scalars['Boolean'];
  feeSynopsis: Maybe<Scalars['String']>;
  institutionName: Scalars['String'];
  latestSubmission: Maybe<Submission>;
  linkedAccountId: Scalars['ID'];
  logoUrl: Scalars['URL'];
  mailInEligibility: Scalars['Boolean'];
  status: ConnectionStatus;
  submissions: Maybe<Array<Submission>>;
  totalNegotiableFees: MonetaryAmount;
};

export type BankFeeFilter = {
  connectionStatus?: InputMaybe<Array<BankConnectionStatus>>;
  status?: InputMaybe<Array<FeeStatus>>;
  submissionKey?: InputMaybe<Scalars['String']>;
};

export enum BankFeeNegotiationExternalStatus {
  ACTIONREQUIRED_CONNECTION_ERROR = 'ACTIONREQUIRED_CONNECTION_ERROR',
  ACTIONREQUIRED_REPORT_REFUND = 'ACTIONREQUIRED_REPORT_REFUND',
  ACTIONREQUIRED_SCHEDULE_CALL = 'ACTIONREQUIRED_SCHEDULE_CALL',
  CALL_SCHEDULED = 'CALL_SCHEDULED',
  RESOLVED_NO_REFUND = 'RESOLVED_NO_REFUND',
  RESOLVED_REFUND = 'RESOLVED_REFUND',
  SUBMITTED = 'SUBMITTED',
  SUBMITTED_SENT = 'SUBMITTED_SENT'
}

export enum BankFeeNegotiationInternalStatus {
  AUTOFETCH_COMPLETED = 'AUTOFETCH_COMPLETED',
  AUTO_CONNECTION_ERROR = 'AUTO_CONNECTION_ERROR',
  AUTO_ERROR = 'AUTO_ERROR',
  AUTO_IN_PROGRESS = 'AUTO_IN_PROGRESS',
  CALL_SCHEDULED = 'CALL_SCHEDULED',
  MAIL_IN_ERROR = 'MAIL_IN_ERROR',
  MAIL_IN_ESCALATED = 'MAIL_IN_ESCALATED',
  MAIL_IN_PENDING = 'MAIL_IN_PENDING',
  MAIL_IN_SCHEDULE_CALL = 'MAIL_IN_SCHEDULE_CALL',
  MAIL_IN_SENT = 'MAIL_IN_SENT',
  PENDING = 'PENDING',
  RESOLVED_NO_REFUND = 'RESOLVED_NO_REFUND',
  RESOLVED_REFUND = 'RESOLVED_REFUND'
}

export enum BankFeeNegotiationStatus {
  AUTO_CONNECTION_ERROR = 'AUTO_CONNECTION_ERROR',
  AUTO_ERROR = 'AUTO_ERROR',
  AUTO_IN_PROGRESS = 'AUTO_IN_PROGRESS',
  CALL_SCHEDULED = 'CALL_SCHEDULED',
  MAIL_IN_ERROR = 'MAIL_IN_ERROR',
  MAIL_IN_ESCALATED = 'MAIL_IN_ESCALATED',
  MAIL_IN_PENDING = 'MAIL_IN_PENDING',
  MAIL_IN_SCHEDULE_CALL = 'MAIL_IN_SCHEDULE_CALL',
  MAIL_IN_SENT = 'MAIL_IN_SENT',
  RESOLVED_NO_REFUND = 'RESOLVED_NO_REFUND',
  RESOLVED_REFUND = 'RESOLVED_REFUND',
  SUBMITTED = 'SUBMITTED'
}

export type BankFeeSummary = {
  __typename?: 'BankFeeSummary';
  coffeeCount: Scalars['Int'];
  eligible: Scalars['Boolean'];
  feesFound: FeeStatusSummary;
  linkedAccounts: Array<BankFeeConnection>;
  totalNegotiableFees: MonetaryAmount;
  totalNegotiatedFees: MonetaryAmount;
  totalReimbursedFees: MonetaryAmount;
};

export enum BankFeeType {
  ACCOUNT_MAINTENANCE_FEE = 'ACCOUNT_MAINTENANCE_FEE',
  ATM_FEE = 'ATM_FEE',
  BALANCE_INQUIRY_FEE = 'BALANCE_INQUIRY_FEE',
  CARD_SETUP_FEE = 'CARD_SETUP_FEE',
  CASH_ADVANCE = 'CASH_ADVANCE',
  CHECK_FEE = 'CHECK_FEE',
  CLOSED_ACCOUNT_PROCESSING_FEE = 'CLOSED_ACCOUNT_PROCESSING_FEE',
  CREDIT_CARD_INTEREST_CHARGE = 'CREDIT_CARD_INTEREST_CHARGE',
  DORMANT_FEE = 'DORMANT_FEE',
  EARLY_CLOSURE_FEE = 'EARLY_CLOSURE_FEE',
  EXCESS_FEE = 'EXCESS_FEE',
  EXTERNAL_TRANSFER_FEE = 'EXTERNAL_TRANSFER_FEE',
  FOREIGN_TRANSACTION_FEE = 'FOREIGN_TRANSACTION_FEE',
  LATE_FEE = 'LATE_FEE',
  MINIMUM_BALANCE_FEE = 'MINIMUM_BALANCE_FEE',
  MONTHLY_SERVICE_FEE = 'MONTHLY_SERVICE_FEE',
  NSF_FEE = 'NSF_FEE',
  OVERDRAFT_FEE = 'OVERDRAFT_FEE',
  PAPER_STATEMENT_FEE = 'PAPER_STATEMENT_FEE',
  STOP_PAYMENT_FEE = 'STOP_PAYMENT_FEE',
  WIRE_TRANSFER_FEE = 'WIRE_TRANSFER_FEE'
}

export type BankInterestRate = {
  __typename?: 'BankInterestRate';
  /** Pre-formatted to two places (i.e. "5.00"). Not present if the product has no associated interest rate. */
  currentApy: Maybe<Scalars['String']>;
  liveDate: Maybe<Scalars['String']>;
  productName: BankingProduct;
};

export type BankInterestRates = {
  __typename?: 'BankInterestRates';
  bankInterestRates: Maybe<Array<BankInterestRate>>;
};

export type BankInterestRatesResult = BankInterestRates | BankServiceFailure;

export type BankMetadata = {
  __typename?: 'BankMetadata';
  /** Deprecated */
  totals: Maybe<BankMetadataTotals>;
};

export type BankMetadataTotals = {
  __typename?: 'BankMetadataTotals';
  oak: Scalars['Int'];
  royalOak: Scalars['Int'];
};

export enum BankName {
  CHASE = 'CHASE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  TEST_BANK = 'TEST_BANK',
  WELLS_FARGO = 'WELLS_FARGO'
}

export type BankServiceFailure = {
  __typename?: 'BankServiceFailure';
  reason: Maybe<Scalars['String']>;
  retryable: Maybe<Scalars['Boolean']>;
};

export type BankStatement = {
  __typename?: 'BankStatement';
  createdAt: Scalars['DateTime'];
  month: Scalars['String'];
  type: BankStatementType;
  url: Scalars['String'];
  year: Scalars['String'];
};

export enum BankStatementType {
  monthly = 'monthly',
  tax = 'tax'
}

export type BankTransaction = {
  __typename?: 'BankTransaction';
  /** The amount of funds the transaction represents. */
  amount: CurrencyAmount;
  /** The exact date and time the funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /**
   * The card that created the transaction. Will be null if this transaction is
   * not tied to a card
   */
  bankCard: Maybe<BankCard>;
  /** The exact date and time the transaction was created */
  createdAt: Scalars['DateTime'];
  /**
   * Represents a client-specified description of the transaction.
   * If transaction was received from a NACHA file (typeCode is UNKWTH, UNKDEP, UNKRSV),
   * this property contains the description verbatim from the NACHA file. By law, this
   * description must be displayed to the end user. If transaction was received
   * from an ISO-8583 interface (i.e. debit card transaction), this property contains
   * description verbatim from DataElement 43 (Card Acceptor Name/Location) of
   * ISO-8583 interface plus details of any fees or surchages that may have been
   * incurred. By law, this description must be displayed to the end user
   * Otherwise, the transaction was received from a call to CorePro API or it was
   * line item in the Bulk Transfer File. This property contains the description
   * verbatim passed by the client code
   */
  description: Scalars['String'];
  id: Scalars['ID'];
  nachaCode: Scalars['String'];
  nachaInfo: Maybe<BankTransactionNachaInfo>;
  /** The exact date and time the transaction was settled. */
  settledAt: Maybe<Scalars['DateTime']>;
  /** The status of the transaction */
  status: BankTransactionStatus;
  /**
   * Shorter version of description. Depending on type, may contain full description.
   * Ex. Purchase transactions contain merchant name without address.
   */
  summary: Scalars['String'];
  /** The program-wide unique identifier generated for each transfer */
  tag: Maybe<Scalars['String']>;
  type: BankTransactionType;
  typeCode: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  /** The exact date and time the transaction was voided. */
  voidedAt: Maybe<Scalars['DateTime']>;
};

export type BankTransactionConnection = {
  __typename?: 'BankTransactionConnection';
  edges: Array<Maybe<BankTransactionEdge>>;
  pageInfo: PageInfo;
};

export type BankTransactionEdge = {
  __typename?: 'BankTransactionEdge';
  cursor: Scalars['ID'];
  node: Maybe<BankTransaction>;
};

export type BankTransactionNachaInfo = {
  __typename?: 'BankTransactionNachaInfo';
  companyDiscretionaryData: Maybe<Scalars['String']>;
  companyEntryDescription: Maybe<Scalars['String']>;
  companyIdentification: Maybe<Scalars['String']>;
  companyName: Maybe<Scalars['String']>;
  isEarlyDeposit: Maybe<Scalars['Boolean']>;
  nachaSettledDate: Maybe<Scalars['DateTime']>;
  standardEntryClassCode: Maybe<Scalars['String']>;
};

export enum BankTransactionStatus {
  /** Transaction has been created but not yet put into a NACHA file */
  initiated = 'initiated',
  /** Transaction has been created and put into a NACHA file */
  pending = 'pending',
  /** Transaction has been posted to the account */
  settled = 'settled',
  /** Transaction has been voided */
  voided = 'voided'
}

export enum BankTransactionType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

export enum BankType {
  LSB = 'LSB',
  NBKC = 'NBKC'
}

export enum BankingEligibilityFeature {
  VIEW_PAN_DETAILS = 'VIEW_PAN_DETAILS'
}

export enum BankingEligibilityReason {
  AVAILABLE = 'AVAILABLE',
  MFA_SMS_CHALLENGE_REQUIRED = 'MFA_SMS_CHALLENGE_REQUIRED',
  MFA_SMS_SETUP_REQUIRED = 'MFA_SMS_SETUP_REQUIRED',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type BankingFeatureEligibility = {
  __typename?: 'BankingFeatureEligibility';
  eligible: Scalars['Boolean'];
  reason: Maybe<BankingEligibilityReason>;
};

export type BankingKyc = {
  __typename?: 'BankingKyc';
  addressVerification: Maybe<AddressVerification>;
  identityVerification: Maybe<IdentityVerification>;
  kycStatus: Maybe<KycStatus>;
  /**
   * Details of Banking KYC results surfaced for clients that have been cleared to reuse Banking KYC user info for specific scenarios, with specific criteria.
   * Usage of this field is only appliable for approved clients.
   * Please confirm with the banking team before using.
   */
  verificationDetails: Maybe<VerificationDetails>;
};

export type BankingKycAddressVerification = AddressVerification & {
  __typename?: 'BankingKycAddressVerification';
  verificationStatus: VerificationStatus;
};

export type BankingKycIdentityVerification = IdentityVerification & {
  __typename?: 'BankingKycIdentityVerification';
  /**
   * If the user can re-attempt identity verification
   * They may have reached the max configured allowed attempts, or need manual review due to suspected fraud or risk
   */
  canRetry: Maybe<Scalars['Boolean']>;
  verificationStatus: VerificationStatus;
};

export enum BankingProduct {
  emergencySavings = 'emergencySavings',
  mightyOakChecking = 'mightyOakChecking',
  mightyOakEmergencyFund = 'mightyOakEmergencyFund',
  oakChecking = 'oakChecking',
  oakEmergencyFund = 'oakEmergencyFund'
}

export type BannersErrors = {
  __typename?: 'BannersErrors';
  error: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export type BannersResponse = BannersErrors | HelpcenterBannerContent | SiteWideBannerContent;

/** Acorns base Portfolio interface */
export type BasePortfolio = {
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation;
  cashOwed: MonetaryAmount;
  currentAllocationPercentage: Scalars['Float'];
  currentBalance: MonetaryAmount;
  currentBalanceWithPending: MonetaryAmount;
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>;
  /** Description of the portfolio */
  description: Scalars['String'];
  /** ID of the Portfolio */
  id: Scalars['ID'];
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String'];
  pendingBalance: MonetaryAmount;
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities: Maybe<Array<PortfolioSecurity>>;
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<Array<PortfolioSecurityAllocation>>;
  yearToDateReturn: Maybe<MarketReturn>;
};

/** Returned result for a batchAddTierSubscriptions mutation */
export type BatchAddTierSubscriptions = {
  __typename?: 'BatchAddTierSubscriptions';
  addedIds: Array<Scalars['ID']>;
  unaddedIds: Array<Scalars['ID']>;
};

export type BatchAddTierSubscriptionsInput = {
  allowInactiveTier?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
  migrationId?: InputMaybe<Scalars['ID']>;
  tierId: Scalars['ID'];
  tierPriceId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};

export type BatchAddTierSubscriptionsResult = BatchAddTierSubscriptions | InvalidTier | InvalidTierPrice;

/** A person who doesn't have an Acorns account, but may someday inherit one or funds from one. */
export type Beneficiary = TimestampsInterface & {
  __typename?: 'Beneficiary';
  /** List of addresses associated with beneficiary */
  addresses: Maybe<Array<Maybe<Address>>>;
  /** Age of beneficiary */
  age: Scalars['Int'];
  /** URL for the Beneficiary's avatar image */
  avatarUrl: Maybe<Scalars['String']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Internal ID for user who this beneficiary belongs to */
  custodianId: Scalars['ID'];
  /** Beneficiary's nickname for their custodian */
  custodianNickname: Maybe<Scalars['String']>;
  /**
   * Beneficiary's date of birth:
   * @deprecated Use beneficiary.age or beneficiary.eligible for contribution tooltip instead
   */
  dateOfBirth: Scalars['String'];
  /** Timestamp when the Beneficiary was deactivated */
  deactivatedAt: Maybe<Scalars['DateTime']>;
  /** Beneficiary's birthday is within the next month */
  eligibleForContributionTooltip: Scalars['Boolean'];
  /** Beneficiary's email ID */
  email: Maybe<Scalars['Email']>;
  /** First name of beneficiary */
  firstName: Scalars['String'];
  /** Internal ID for beneficiary */
  id: Scalars['ID'];
  /** Beneficiary's investment account */
  investmentAccount: Maybe<InvestmentAccount>;
  /** Last name of beneficiary */
  lastName: Scalars['String'];
  /** List of phone numbers associated with the beneficiary */
  phoneNumbers: Maybe<Array<Maybe<Phone>>>;
  /** True if the beneficiary has an ssn false if not */
  ssnPresent: Scalars['Boolean'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Cannot open early account because the beneficiary account already exsists */
export type BeneficiaryAccountExistsException = {
  __typename?: 'BeneficiaryAccountExistsException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** A person with the supplied date of birth is too old to open a UTMA/UGMA account */
export type BeneficiaryExceedsAgeLimitException = {
  __typename?: 'BeneficiaryExceedsAgeLimitException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Changeable attributes for beneficiaries */
export type BeneficiaryInfoInput = {
  /** Beneficiaries nickname for their custodian. */
  custodianNickname?: InputMaybe<Scalars['String']>;
  /** Beneficiary Email */
  email?: InputMaybe<Scalars['Email']>;
  /** Mailing Address */
  mailingAddress?: InputMaybe<AddressInput>;
  /** Beneficiary Phone number */
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** Changeable attributes for beneficiaries */
export type BeneficiaryInput = {
  /** Date of Birth */
  dateOfBirth: Scalars['String'];
  /** Beneficiary First Name */
  firstName: Scalars['String'];
  /** Beneficiary Last Name */
  lastName: Scalars['String'];
};

/** Beneficiary does not exist */
export type BeneficiaryNotFoundException = {
  __typename?: 'BeneficiaryNotFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export enum BeneficiaryType {
  entity = 'entity',
  individual = 'individual'
}

export type BenefitPartnerInput = {
  product: BenefitsProduct;
};

export type BenefitPartnerResponse = ProductNotSupportedException | TaxFilingPartner;

export enum BenefitProductStatus {
  COMING_SOON = 'COMING_SOON',
  DISABLED = 'DISABLED',
  DISABLING_SOON = 'DISABLING_SOON',
  ENABLED = 'ENABLED',
  TEMPORARILY_UNAVAILABLE = 'TEMPORARILY_UNAVAILABLE',
  UNDER_MAINTENANCE = 'UNDER_MAINTENANCE'
}

export type BenefitProductTile = {
  __typename?: 'BenefitProductTile';
  product: BenefitsTrackerProducts;
  status: BenefitProductStatus;
};

export enum BenefitPromotedThrough {
  MAIN_FEED_CARD = 'MAIN_FEED_CARD',
  TOUR_TIP = 'TOUR_TIP',
  WTDN = 'WTDN'
}

export type BenefitStatus = {
  __typename?: 'BenefitStatus';
  benefitProductKey: Scalars['String'];
  claimStatus: ClaimStatus;
  claimedOn: Maybe<Scalars['String']>;
  details: Maybe<Array<Maybe<ClaimStatusDetails>>>;
  expiresOn: Maybe<Scalars['String']>;
  /** @deprecated Use claim_status instead */
  status: Scalars['String'];
  updatedBy: Maybe<Scalars['String']>;
  updatedOn: Maybe<Scalars['String']>;
};

export enum BenefitStatusDetail {
  INELIGIBLE_AGE = 'INELIGIBLE_AGE',
  INELIGIBLE_LOCATION = 'INELIGIBLE_LOCATION'
}

export type BenefitTileGroup = {
  __typename?: 'BenefitTileGroup';
  group: Scalars['String'];
  groupName: Scalars['String'];
  products: Maybe<Array<Maybe<BenefitProductTile>>>;
};

export type BenefitsMessage = {
  __typename?: 'BenefitsMessage';
  message: Scalars['String'];
};

export enum BenefitsPartner {
  APRIL = 'APRIL',
  AVIBRA = 'AVIBRA',
  COLUMN_TAX = 'COLUMN_TAX',
  GO_HENRY = 'GO_HENRY',
  TRUST_AND_WILL = 'TRUST_AND_WILL'
}

export enum BenefitsProduct {
  BENEFITS_GOHENRY_STANDARD = 'BENEFITS_GOHENRY_STANDARD',
  BENEFITS_INSURANCE_BASIC = 'BENEFITS_INSURANCE_BASIC',
  BENEFITS_INSURANCE_STANDARD = 'BENEFITS_INSURANCE_STANDARD',
  BENEFITS_TAXFILING_STANDARD = 'BENEFITS_TAXFILING_STANDARD',
  BENEFITS_WILL_STANDARD = 'BENEFITS_WILL_STANDARD'
}

export type BenefitsStatusResponse = {
  __typename?: 'BenefitsStatusResponse';
  benefitsStatus: Array<BenefitStatus>;
  userId: Scalars['String'];
};

export enum BenefitsTrackerProducts {
  BENEFITS_FEE_NEGOTIATION = 'BENEFITS_FEE_NEGOTIATION',
  BENEFITS_GOHENRY_STANDARD = 'BENEFITS_GOHENRY_STANDARD',
  BENEFITS_INSURANCE_STANDARD = 'BENEFITS_INSURANCE_STANDARD',
  BENEFITS_TAXFILING_STANDARD = 'BENEFITS_TAXFILING_STANDARD',
  BENEFITS_WILL_STANDARD = 'BENEFITS_WILL_STANDARD'
}

export type BigCurrencyAmount = {
  __typename?: 'BigCurrencyAmount';
  currency: Currency;
  value: Scalars['BigDecimal'];
};

/** Attributes related to the billing cycle */
export type BillingCycle = TimestampsInterface & {
  __typename?: 'BillingCycle';
  active: Scalars['Boolean'];
  adhoc: Scalars['Boolean'];
  amount: Maybe<Scalars['Float']>;
  amountCollected: Maybe<Scalars['Float']>;
  amountOwed: Maybe<Scalars['Float']>;
  callbackUrl: Maybe<Scalars['String']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  credits: Array<Maybe<Credit>>;
  endDate: Scalars['String'];
  executionAudits: Array<Maybe<ExecutionAudit>>;
  extension: Scalars['String'];
  fees: Array<Maybe<Fee>>;
  id: Scalars['ID'];
  invoiceDate: Scalars['String'];
  liquidations: Array<Maybe<Liquidation>>;
  nonce: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  state: BillingCycleState;
  tierSubscription: Maybe<TierSubscription>;
  tierSubscriptionId: Maybe<Scalars['String']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};


/** Attributes related to the billing cycle */
export type BillingCycleCreditsArgs = {
  discount_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** Attributes related to the billing cycle */
export type BillingCycleFeesArgs = {
  execution_methods?: InputMaybe<Array<InputMaybe<FeeExecutionMethod>>>;
};

export enum BillingCycleState {
  /** Assessed billing cycle */
  ASSESSED = 'ASSESSED',
  /** Billing cycle execution started */
  EXECUTED = 'EXECUTED',
  /** Billing cycle execution failed */
  EXECUTION_FAILED = 'EXECUTION_FAILED',
  /** Failed billing cycle */
  FAILED = 'FAILED',
  /** Paid billing cycle */
  PAID = 'PAID',
  /** Partially collected billing cycle */
  PARTIAL = 'PARTIAL',
  /** Initiate refund billing cycle */
  PENDING_REFUND = 'PENDING_REFUND',
  /** Refunded billing cycle */
  REFUNDED = 'REFUNDED',
  /** Refund failed billing cycle */
  REFUND_FAILED = 'REFUND_FAILED',
  /** Billing cycle pending retry */
  RETRY_PENDING = 'RETRY_PENDING',
  /** Unpaid billing cycle */
  UNPAID = 'UNPAID'
}

export enum BillingFrequency {
  MONTHLY = 'MONTHLY',
  NEVER = 'NEVER',
  YEARLY = 'YEARLY'
}

/** Internal representation of a billing cycle */
export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  amount: Maybe<Scalars['Float']>;
  amountCollected: Maybe<Scalars['Float']>;
  amountOwed: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  executionMethod: Maybe<Scalars['String']>;
  failureReason: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceDate: Scalars['DateTime'];
  invoiceItems: Array<Maybe<InvoiceItem>>;
  startDate: Scalars['DateTime'];
  state: BillingCycleState;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
  vendorIntegrated: Scalars['Boolean'];
};

/** the billing profile for a user */
export type BillingProfile = {
  __typename?: 'BillingProfile';
  mightyOakCardWaiver: Maybe<MightyOakCardWaiver>;
  provisionalWaiver: Maybe<ProvisionalWaiver>;
  userId: Scalars['ID'];
  userVerifiedAt: Maybe<Scalars['String']>;
  waivers: Maybe<Array<Waiver>>;
};

/** Billing Profile not found */
export type BillingProfileNotFoundException = {
  __typename?: 'BillingProfileNotFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type BillingVendorError = {
  __typename?: 'BillingVendorError';
  message: Scalars['String'];
};

export type BlockDeviceInput = {
  deviceId: Scalars['ID'];
};

export type BlockDeviceResult = Device | DeviceNotFoundException;

export type BlockedEmailDomainException = {
  __typename?: 'BlockedEmailDomainException';
  message: Maybe<Scalars['String']>;
};

export enum BrazeEvent {
  AdvocateReferralLinkClick = 'AdvocateReferralLinkClick',
  FriendInvestCore = 'FriendInvestCore',
  FriendRegistrationStart = 'FriendRegistrationStart',
  FriendUserVerified = 'FriendUserVerified'
}

/** Grouping of Products */
export type Bundle = {
  __typename?: 'Bundle';
  /** Image asset path in CDN */
  iconPath: Scalars['String'];
  /** Name of bundle */
  name: Scalars['String'];
  /** Associated products to display for grouping */
  products: Array<PresentableProduct>;
};

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum CampaignBackgroundType {
  SQUIRRELS_WITH_ACORNS = 'SQUIRRELS_WITH_ACORNS',
  SQUIRRELS_WITH_ACORNS_CLOUD = 'SQUIRRELS_WITH_ACORNS_CLOUD',
  SQUIRRELS_WITH_ACORNS_TRANSPARENT = 'SQUIRRELS_WITH_ACORNS_TRANSPARENT',
  SQUIRRELS_WITH_ACORNS_UBER = 'SQUIRRELS_WITH_ACORNS_UBER'
}

export enum CampaignFilterType {
  ADVERTISED = 'ADVERTISED',
  PARTICIPATED = 'PARTICIPATED'
}

export type CampaignHistoryConnection = {
  __typename?: 'CampaignHistoryConnection';
  edges: Maybe<Array<CampaignHistoryEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type CampaignHistoryEdge = {
  __typename?: 'CampaignHistoryEdge';
  cursor: Scalars['String'];
  eligibilityMet: Maybe<Scalars['Boolean']>;
  hurdleMet: Maybe<Scalars['Boolean']>;
  node: ReferralCampaignV2;
  /** Number of referrals that have completed all requirements and are eligible for rewards */
  numCompletedReferrals: Maybe<Scalars['Int']>;
  /** Number of referrals that have started but haven't completed the qualifying action yet */
  numNonQualifiedReferrals: Maybe<Scalars['Int']>;
  /** Total number of referrals that are still in progress (qualified + non-qualified) */
  numPendingReferrals: Maybe<Scalars['Int']>;
  /** Number of referrals that have completed the qualifying action (e.g., investment, subscription, roundup) */
  numQualifiedReferrals: Maybe<Scalars['Int']>;
};

export type CampaignHistoryFilter = {
  /** filters specific Campaign */
  campaignId?: InputMaybe<Scalars['ID']>;
  /** Whether campaigns where created after the date. */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** Whether or not hurdle has been met */
  hurdleMet?: InputMaybe<Scalars['Boolean']>;
  /** Whether campaigns where published after the date. Defaults to 6 month back */
  publishedAfter?: InputMaybe<Scalars['DateTime']>;
  /** Published Campaign status (eg. COMPLETE, LIVE, PENDING, SCHEDULED) */
  publishedStatus?: InputMaybe<PublishedCampaignStatus>;
  /** Campaign reward filter type */
  rewardType?: InputMaybe<CampaignRewardFilterType>;
  /** Campaign filter type */
  type: CampaignFilterType;
};

export enum CampaignIconType {
  SQUIRREL_AVATAR_1 = 'SQUIRREL_AVATAR_1',
  SQUIRREL_AVATAR_2 = 'SQUIRREL_AVATAR_2',
  SQUIRREL_AVATAR_3 = 'SQUIRREL_AVATAR_3',
  SQUIRREL_AVATAR_UBER = 'SQUIRREL_AVATAR_UBER'
}

export enum CampaignQualificationActionType {
  INITIAL_INVESTMENT = 'INITIAL_INVESTMENT'
}

export enum CampaignRewardFilterType {
  BURST = 'BURST',
  EVERGREEN = 'EVERGREEN'
}

export enum CampaignStatus {
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED'
}

export type CampaignV2 = {
  __typename?: 'CampaignV2';
  campaignId: Maybe<Scalars['ID']>;
};

/** The result of the cancelCheckPayment mutation */
export type CancelCheckPaymentResult = AuthorizationError | CheckPayment | ResourceNotFoundError | UnableToCancelCheckError;

export type CancelIntentResult = Intent | ValidationError;

/** Input to cancel existing account closure request */
export type CancelInvestmentAccountClosureRequestInput = {
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID'];
};

/** Cancel investment account request mutation response */
export type CancelInvestmentAccountClosureRequestResult = AccountClosedException | AccountNotFoundException | ClosureRequestDoesNotExistException | InvestmentAccount;

/** Input to cancel a pending investment */
export type CancelInvestmentInput = {
  /** DEPRECATED: The ID of the investment account */
  investmentAccountId?: InputMaybe<Scalars['ID']>;
  /** The ID of the pending investment associated with the investment account id */
  investmentId: Scalars['ID'];
};

/** ID of canceled investment */
export type CancelInvestmentPayload = {
  __typename?: 'CancelInvestmentPayload';
  id: Scalars['ID'];
};

/** Cancel investment mutation response */
export type CancelInvestmentResult = CancelInvestmentPayload | InvestmentNotFoundException | InvestmentUncancellableException;

export type CancelMoneyAssignmentInput = {
  transactionId: Scalars['ID'];
};

export type CancelMoneyAssignmentResult = MoneyAssignmentAlreadyTransferredError | MoneyAssignmentNotFoundError | MoneyRulesCancelMoneyAssignmentSuccess;

export type CancelRecurringTransferResult = RecurringTransfer | VersionMismatchException;

export type CancelTransferPayload = {
  __typename?: 'CancelTransferPayload';
  transactionId: Scalars['ID'];
};

export enum CardColor {
  GREEN = 'GREEN',
  LEGACY = 'LEGACY',
  RED = 'RED',
  WHITE = 'WHITE'
}

/** Card delivery status */
export type CardDeliveryStatus = {
  __typename?: 'CardDeliveryStatus';
  /** When the card tracking record was created */
  createdAt: Scalars['String'];
  /** Current Tracking Status Description */
  description: Maybe<Scalars['String']>;
  /** USPS Tracking Number */
  picNumber: Maybe<Scalars['String']>;
  /** Reference ID */
  referenceId: Scalars['String'];
  /** Status enum */
  status: PackageStatus;
  /** When the card tracking record was updated */
  updatedAt: Scalars['String'];
};

export enum CarouselType {
  BANNER = 'BANNER',
  STANDARD = 'STANDARD'
}

export type ChallengeAnswerInput = {
  challengeAnswer: Scalars['String'];
  challengeId: Scalars['ID'];
};

export enum ChallengeDeliveryType {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS'
}

export type ChallengePointsEarned = {
  __typename?: 'ChallengePointsEarned';
  challengeID: Scalars['ID'];
  /** legal copy about how points are earned */
  details: Scalars['String'];
  /** how many points earned out of how many possible */
  earningProgress: DiscreteMilestoneProgress;
  /** summarized information about how points are earned */
  summary: Maybe<Scalars['String']>;
};

export enum ChallengePushState {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type ChallengeRateExceededException = {
  __typename?: 'ChallengeRateExceededException';
  errorCode: Scalars['String'];
};

export enum ChallengeTriggers {
  AUTHENTICATE = 'AUTHENTICATE',
  INIT_EMAIL = 'INIT_EMAIL',
  INIT_EMAIL_FOR_AUTHENTICATE = 'INIT_EMAIL_FOR_AUTHENTICATE',
  INIT_PUSH_FOR_VERIFICATION = 'INIT_PUSH_FOR_VERIFICATION',
  INIT_SMS = 'INIT_SMS',
  REINIT_CHALLENGE = 'REINIT_CHALLENGE',
  STEP_UP_AUTHENTICATION = 'STEP_UP_AUTHENTICATION',
  SUSPENDED_CHALLENGE = 'SUSPENDED_CHALLENGE',
  SUSPENDED_INIT_EMAIL_FOR_AUTHENTICATE = 'SUSPENDED_INIT_EMAIL_FOR_AUTHENTICATE'
}

/** Input to change the amount of an outside contribution */
export type ChangeOutsideContributionAmountInput = {
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String'];
  /** Stripe payment intent id */
  paymentIntentId: Scalars['ID'];
};

/** Change outside contribution amount response */
export type ChangeOutsideContributionAmountResult = ContributionAmountAboveThresholdError | ContributionAmountBelowThresholdError | OutsideContributionCheckoutCart;

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  securityAnswer?: InputMaybe<SecurityAnswer>;
};

export type ChangePasswordResult = ChangePasswordSuccess | IncorrectOldPasswordException | IncorrectSecurityAnswerException | InvalidPasswordException;

export type ChangePasswordSuccess = {
  __typename?: 'ChangePasswordSuccess';
  userId: Scalars['ID'];
};

export type ChatActionData = {
  __typename?: 'ChatActionData';
  /** Data that was passed back to api */
  apiScope: Maybe<Scalars['String']>;
  /** Data that was passed back to models */
  modelScope: Maybe<Scalars['String']>;
};

export type ChatActionDataInput = {
  /** Data passed to api */
  apiScope?: InputMaybe<Scalars['String']>;
  /** Data passed to models */
  modelScope?: InputMaybe<Scalars['String']>;
};

/** Specifies whether a message was written by a user or is bot generated */
export enum ChatAuthor {
  BOT = 'BOT',
  USER = 'USER'
}

export type ChatChoice = {
  __typename?: 'ChatChoice';
  /** Description associated with choices */
  description: Maybe<Scalars['String']>;
  /** ID generated for the choices */
  id: Scalars['ID'];
  /** Metadata associated with choices, typically hidden from user */
  metadata: Maybe<ChatChoiceActionMetadata>;
  /** Title to be displayed for the choices */
  title: Scalars['String'];
};

export type ChatChoiceActionData = {
  __typename?: 'ChatChoiceActionData';
  /** Additional data to be passed back to subsequent api calls once a choice is selected. */
  apiScope: Maybe<Scalars['String']>;
  /** Additional data to be passed back to subsequent model calls once a choice is selected. */
  modelScope: Maybe<Scalars['String']>;
};

export type ChatChoiceActionMetadata = {
  __typename?: 'ChatChoiceActionMetadata';
  /** Data associated with the action, gets back to the models */
  actionData: Maybe<ChatChoiceActionData>;
  /** Type of action performed by the choice */
  actionType: Scalars['String'];
};

export type ChatChoiceWidget = {
  __typename?: 'ChatChoiceWidget';
  choices: Array<ChatChoice>;
  title: Maybe<Scalars['String']>;
};

export enum ChatContext {
  BENEFITS_HUB = 'BENEFITS_HUB',
  LEARN_HUB = 'LEARN_HUB',
  REFERRALS_LANDER = 'REFERRALS_LANDER',
  SUPPORT = 'SUPPORT'
}

export type ChatDeeplink = {
  __typename?: 'ChatDeeplink';
  title: Scalars['String'];
  url: Scalars['String'];
};

export enum ChatFeatures {
  BASIC = 'BASIC',
  CHOICE_SELECTION = 'CHOICE_SELECTION',
  SUPPORT = 'SUPPORT'
}

export type ChatHistoryCitation = {
  __typename?: 'ChatHistoryCitation';
  id: Scalars['ID'];
  title: Maybe<Scalars['String']>;
  type: CitationType;
};

export type ChatHistoryCitationV2 = LearnHubCitation | SupportCitation;

export type ChatHistoryMessage = {
  __typename?: 'ChatHistoryMessage';
  /** Specifies whether a message was written by a user or is bot generated */
  author: ChatAuthor;
  /** Contains the contents of the message */
  body: Scalars['String'];
  canRate: Scalars['Boolean'];
  /** Chat widget associated with a particular BOT response */
  chatWidgets: Array<ChatWidget>;
  /**
   * The citations for a chat response. Only chats authored by a BOT will contain these
   * @deprecated Use CitationWidget in chatWidgets instead.
   */
  citations: Array<ChatHistoryCitation>;
  createdAt: Scalars['DateTime'];
  /** Custom feedback text provided by the user */
  customFeedback: Maybe<Scalars['String']>;
  /**
   * Deeplinks associated with a particular BOT response
   * @deprecated Use DeeplinkWidget in chatWidgets instead
   */
  deeplinks: Array<ChatDeeplink>;
  /** Reason for the feedback provided */
  feedbackReason: Maybe<MessageFeedbackReason>;
  id: Scalars['ID'];
  /** Metadata associated with the message */
  metadata: Maybe<ChatMessageMetadata>;
  /** ID of the message that prompted the current message. Only present for 'BOT' authored messages */
  originatingMessageId: Maybe<Scalars['ID']>;
  ragSessionId: Maybe<Scalars['ID']>;
  rating: Maybe<Scalars['Int']>;
  /** Specifies which session a message is from */
  sessionId: Scalars['ID'];
};

export type ChatHistoryMessageBody = {
  __typename?: 'ChatHistoryMessageBody';
  /** Id of the chat history message, subsequent body messages and footer will have the same ID */
  id: Scalars['ID'];
  /** When the partial message was sent */
  sentAt: Scalars['DateTime'];
  /** Text chunk of the full message */
  text: Scalars['String'];
};

export type ChatHistoryMessageCustomFeedbackOutOfBounds = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageCustomFeedbackOutOfBounds';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatHistoryMessageEdge = {
  __typename?: 'ChatHistoryMessageEdge';
  /** This value is passed back as the 'cursor' parameter to continue pagination. An empty string indicates there are no more pages to fetch. */
  cursor: Scalars['ID'];
  /** The ChatSessionRecord in the edge */
  node: ChatHistoryMessage;
};

export type ChatHistoryMessageError = {
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatHistoryMessageFooter = {
  __typename?: 'ChatHistoryMessageFooter';
  /** Used to display thumbs up/down */
  canRate: Scalars['Boolean'];
  chatWidgets: Array<ChatWidget>;
  /**
   * Citations for the chat history message
   * @deprecated Use CitationWidget in chatWidgets instead.
   */
  citations: Array<ChatHistoryCitation>;
  /** @deprecated Use DeeplinkWidget in chatWidgets instead */
  deeplinks: Array<ChatDeeplink>;
  /** Id of the chat history message, subsequent body messages and footer will have the same ID */
  id: Scalars['ID'];
  /** When the footer message was sent */
  sentAt: Scalars['DateTime'];
};

export type ChatHistoryMessageHeader = {
  __typename?: 'ChatHistoryMessageHeader';
  /** Specifies whether a message was written by a user or is bot generated */
  author: ChatAuthor;
  createdAt: Scalars['DateTime'];
  /** Id of the chat history message, subsequent body messages and footer will have the same ID */
  id: Scalars['ID'];
  /** ID of the message that prompted the current message. Only present for 'BOT' authored messages */
  originatingMessageId: Maybe<Scalars['ID']>;
  /** Specifies which session a message is from */
  sessionId: Scalars['ID'];
};

export type ChatHistoryMessageNotFound = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageNotFound';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatHistoryMessageNotRatable = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageNotRatable';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatHistoryMessageRatingFailed = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageRatingFailed';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatHistoryMessageRatingOutOfBounds = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageRatingOutOfBounds';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatMessageMetadata = {
  __typename?: 'ChatMessageMetadata';
  /** Data associated with the action */
  actionData: Maybe<ChatActionData>;
  /** Type of action associated with the message */
  actionType: Scalars['String'];
};

export type ChatMessageMetadataInput = {
  /** Data associated with the action */
  actionData?: InputMaybe<ChatActionDataInput>;
  /** Type of action associated with the message */
  actionType: Scalars['String'];
};

export type ChatMessageSizeOutOfBounds = ChatHistoryMessageError & {
  __typename?: 'ChatMessageSizeOutOfBounds';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatMessageStreamResponse = ChatHistoryMessage | ChatHistoryMessageBody | ChatHistoryMessageFooter | ChatHistoryMessageHeader;

export type ChatRedirect = {
  __typename?: 'ChatRedirect';
  conversationCategory: Scalars['String'];
  conversationContext: Scalars['String'];
  ctaExpiresAt: Scalars['DateTime'];
  title: Scalars['String'];
};

export type ChatSession = {
  __typename?: 'ChatSession';
  createdAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  originatingContext: Maybe<ChatContext>;
  supportedChatFeatures: Array<ChatFeatures>;
  type: Maybe<SessionType>;
  /** Specifies the id of the user who had the chat session */
  userId: Scalars['ID'];
};

export type ChatSessionNotFound = {
  __typename?: 'ChatSessionNotFound';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ChatUnavailableError = {
  __typename?: 'ChatUnavailableError';
  message: Scalars['String'];
};

export type ChatWidget = ChatChoiceWidget | CitationWidget | CustomerSupportChatWidget | DeeplinkWidget;

/** Represents the check to be uploaded. */
export type CheckImage = {
  /** Image based-64 encoded. */
  image: Scalars['String'];
  type: ImageType;
};

export type CheckPayment = {
  __typename?: 'CheckPayment';
  amount: CurrencyAmount;
  canceledAt: Maybe<Scalars['DateTime']>;
  checkNumber: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  estimatedArrivalAt: Scalars['DateTime'];
  failedAt: Maybe<Scalars['DateTime']>;
  failureReason: Maybe<CheckPaymentFailureReason>;
  fromAccountId: Scalars['String'];
  id: Scalars['ID'];
  memo: Maybe<Scalars['String']>;
  recipientAddress: CheckPaymentAddress;
  recipientName: Scalars['String'];
  status: CheckPaymentStatus;
  trackingNumber: Maybe<Scalars['String']>;
};

export type CheckPaymentAddress = {
  __typename?: 'CheckPaymentAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type CheckPaymentAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type CheckPaymentConnection = {
  __typename?: 'CheckPaymentConnection';
  edges: Array<CheckPaymentEdge>;
  pageInfo: PageInfo;
};

export type CheckPaymentEdge = {
  __typename?: 'CheckPaymentEdge';
  cursor: Scalars['ID'];
  node: CheckPayment;
};

export enum CheckPaymentFailureReason {
  insufficientFunds = 'insufficientFunds'
}

export type CheckPaymentRecipient = {
  __typename?: 'CheckPaymentRecipient';
  businessName: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
};

export type CheckPaymentRecipientAddressType = {
  __typename?: 'CheckPaymentRecipientAddressType';
  recipient: CheckPaymentRecipient;
  recipientAddress: CheckPaymentAddress;
};

export type CheckPaymentRecipientInput = {
  businessName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export enum CheckPaymentStatus {
  canceled = 'canceled',
  failed = 'failed',
  pending = 'pending',
  shipped = 'shipped'
}

export type CheckingHistorySummary = PastSummary & {
  __typename?: 'CheckingHistorySummary';
  interestEarned: Maybe<CurrencyAmount>;
  moneyIn: CurrencyAmount;
  moneyOut: CurrencyAmount;
};

export enum CheckoutCartStatus {
  /** Terminal state, canceled payment intent */
  CANCELED = 'CANCELED',
  /** State a payment intent is in after actions are handled */
  PROCESSING = 'PROCESSING',
  /** Payment intent needs further action by frontend */
  REQUIRES_ACTION = 'REQUIRES_ACTION',
  /** Payment intent needs capturing */
  REQUIRES_CAPTURE = 'REQUIRES_CAPTURE',
  /** Payment intent needs confirming */
  REQUIRES_CONFIRMATION = 'REQUIRES_CONFIRMATION',
  /** Initial state, before a payment method is attached */
  REQUIRES_PAYMENT_METHOD = 'REQUIRES_PAYMENT_METHOD',
  /** Terminal state, succeeded payment intent */
  SUCCEEDED = 'SUCCEEDED'
}

export enum CitationType {
  LEARN_HUB_CONTENT = 'LEARN_HUB_CONTENT',
  OTHER = 'OTHER',
  SUPPORT_FAQ = 'SUPPORT_FAQ'
}

export type CitationWidget = {
  __typename?: 'CitationWidget';
  citations: Array<ChatHistoryCitationV2>;
};

export enum ClaimStatus {
  CLAIMED = 'CLAIMED',
  EXPIRED = 'EXPIRED',
  EXPIRING_SOON = 'EXPIRING_SOON',
  INELIGIBLE = 'INELIGIBLE',
  IN_PROGRESS = 'IN_PROGRESS',
  UNCLAIMED = 'UNCLAIMED',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED'
}

export type ClaimStatusDetails = {
  __typename?: 'ClaimStatusDetails';
  message: Maybe<Scalars['String']>;
  statusCode: Maybe<BenefitStatusDetail>;
};

export type ClearSupportSiteCache = {
  __typename?: 'ClearSupportSiteCache';
  eventIds: Maybe<Array<Maybe<Scalars['String']>>>;
  message: Maybe<Scalars['String']>;
};

/** Represents the client info passed into startCheckDeposit */
export type ClientInfo = {
  /** App version */
  appVersion: Scalars['String'];
  /** Make of the device, e.g. Samsung, Apple, LG, etc */
  manufacturer: Scalars['String'];
  /** Device model, e.g. iPhone 7, AsusPad 2 etc. */
  model: Scalars['String'];
  /** Operating System, e.g. iOS, Android, Windows, Mac OS */
  os: Scalars['String'];
  /** Operating System version, e.g. 8.0.10211, KITKAT, LOLLIPOP etc. */
  osVersion: Scalars['String'];
  /** iphone, android, or web */
  platform: Scalars['String'];
};

export type CloseAccountReason = {
  __typename?: 'CloseAccountReason';
  key: Scalars['String'];
  label: Scalars['String'];
};

export type CloseBankAccountInput = {
  accountId: Scalars['ID'];
  bankAccountClosureReason?: InputMaybe<BankAccountClosureReason>;
  feedback?: InputMaybe<Scalars['String']>;
};

export type CloseBankAccountResult = BankAccount | BankAccountNotFoundError;

/** Investment account closure request */
export type CloseInvestmentAccountInput = {
  /** List of closure reason keys */
  accountClosureReasons?: InputMaybe<Array<Scalars['String']>>;
  /** Any closure reason comments the user may have */
  comments?: InputMaybe<Scalars['String']>;
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID'];
};

/** Investment Account Closure Response */
export type CloseInvestmentAccountResult = AccountNotFoundException | InvestmentAccount | InvestmentAccountAlreadyClosed | InvestmentAccountClosureInProgress | LaterAccountRequiresTaxWithholdings | LaterAccountRequiresWithdrawalReason | LaterAccountTaxWithholdingsPercentageExceeded | NonBasicAccountOpenException;

/** Close User Account Response */
export type CloseUserAccountResult = OpenAccountsException | UserNotFoundException | User_V2;

/** No account closure request exists for the given investment account */
export type ClosureRequestDoesNotExistException = {
  __typename?: 'ClosureRequestDoesNotExistException';
  /** message */
  errorMessage: Maybe<Scalars['String']>;
};

/** An account closure request already exists for this account */
export type ClosureRequestExistsException = {
  __typename?: 'ClosureRequestExistsException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type CohortEligibility = {
  __typename?: 'CohortEligibility';
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean'];
  /** key referencing the cohort eligibility scope */
  type: CohortEligibilityScope;
};

export enum CohortEligibilityScope {
  /** Earn Incentive New User Cohort */
  EARN_INCENTIVE = 'EARN_INCENTIVE',
  /** Mobile Remote Deposit Checks Feature Cohort */
  MRDC = 'MRDC',
  /** Passions Cohort */
  PASSIONS_EXPERIENCE = 'PASSIONS_EXPERIENCE',
  /** Personalized Found Money on Present Cohort */
  PERSONALIZED_FOUND_MONEY_ON_PRESENT = 'PERSONALIZED_FOUND_MONEY_ON_PRESENT',
  /** Send Check Cohort */
  SEND_CHECK = 'SEND_CHECK'
}

export type CohortEligibility_V2 = {
  __typename?: 'CohortEligibility_v2';
  /** key referencing the cohort name */
  cohort: Scalars['String'];
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean'];
};

export type CohortEligibility_V2FilterInput = {
  /** key referencing the cohort name */
  cohorts?: InputMaybe<Array<Scalars['String']>>;
};

export enum CollectionMethod {
  automatic = 'automatic',
  manual = 'manual'
}

/** Performance values aggregated across all investment accounts within a user's Acorns account */
export type CombinedPerformance = {
  __typename?: 'CombinedPerformance';
  /** Combined investment account values based on previous market day's closing prices */
  accountValues: Maybe<Array<Maybe<AccountValue>>>;
  /** Value of bond holdings across all investment accounts */
  bondValue: Maybe<MonetaryAmount>;
  /** Value of crypto holdings across all investment accounts */
  cryptoValue: Maybe<MonetaryAmount>;
  /** Value of all investment accounts based on most current available prices */
  currentBalance: Maybe<MonetaryAmount>;
  /** The dollar change in combined account value from market movement over the reporting period */
  marketChange: Maybe<MonetaryAmount>;
  /** The percentage change in combined account value from market movement over the reporting period */
  marketChangePercent: Maybe<Scalars['Float']>;
  /** The percentage change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangePercentWithoutFees: Maybe<Scalars['Float']>;
  /** The dollar change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangeWithoutFees: Maybe<MonetaryAmount>;
  /** The total dollar amount of contributions minus withdrawals */
  netInvestments: Maybe<MonetaryAmount>;
  /** Value of stock holdings across all investment accounts */
  stockValue: Maybe<MonetaryAmount>;
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested: Maybe<MonetaryAmount>;
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending: Maybe<MonetaryAmount>;
};

export type CompleteCheckDepositInput = {
  amount: CurrencyAmountInput;
  /** The session to complete. */
  sessionToken: Scalars['String'];
};

/** Response from completing a deposit. */
export type CompleteCheckDepositPayload = {
  __typename?: 'CompleteCheckDepositPayload';
  /** The session that was completed. */
  sessionToken: Scalars['String'];
};

export type CompleteFunnelOnboardingResult = RegistrationFunnel | UnmetRequirementsException;

export type CompletedQuiz = {
  __typename?: 'CompletedQuiz';
  communityAvgPercents: Scalars['Int'];
  correctQuestions: Scalars['Int'];
  totalQuestions: Scalars['Int'];
  userScorePercents: Scalars['Int'];
};

export type ConfigureSettingsInput = {
  employerHidden?: InputMaybe<Scalars['Boolean']>;
  employerName: Scalars['String'];
  splitPercent: Scalars['String'];
  splitType: DistributionType;
};

export type ConfigureSplitDepositDirectDepositIntentPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentPayload';
  intent: SplitDepositDirectDepositIntentSetting;
};

export type ConfigureSplitDepositDirectDepositIntentSettingInput = {
  allocations: Array<SplitDepositAllocationInput>;
  estimatedPaycheckAmount: CurrencyAmountInput;
  id?: InputMaybe<Scalars['ID']>;
  isActive: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isUsingRecommendedAllocations: Scalars['Boolean'];
};

export type ConfigureSplitDepositDirectDepositSettingInput = {
  allocations: Array<SplitDepositAllocationInput>;
  directDepositIntentSettingId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isUsingRecommendedAllocations: Scalars['Boolean'];
};

export type ConfigureSplitDepositDirectDepositSettingPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingPayload';
  setting: SplitDepositDirectDepositSetting;
};

export type ConnectAchAccountInput = {
  account: Scalars['AccountNumber'];
  routing: Scalars['RoutingNumber'];
};

export type ConnectAchAccountResult = ConnectAchAccountSucceeded | InstitutionNotSupportedError;

export type ConnectAchAccountSucceeded = {
  __typename?: 'ConnectACHAccountSucceeded';
  message: Scalars['String'];
};

export enum ConnectionStatus {
  AUTHORIZED = 'AUTHORIZED',
  TFA_REQUIRED = 'TFA_REQUIRED',
  UNAUTHORIZED = 'UNAUTHORIZED'
}

export type ConnectionSummary = {
  __typename?: 'ConnectionSummary';
  connections: Maybe<Array<BankConnection>>;
  totalEligibleFeeCount: Maybe<Scalars['Int']>;
  totalEligibleFees: Maybe<MonetaryAmount>;
  /** @deprecated replaced by totalEligibleFees */
  totalEligibleFeesForUser: Maybe<MonetaryAmount>;
  userEligibility: Maybe<Scalars['Boolean']>;
};

export type ConsumeUserTokenResult = InvalidUserTokenException | UserToken;

export type ContactCategory = {
  __typename?: 'ContactCategory';
  id: Scalars['ID'];
  label: Scalars['String'];
  subcategories: Maybe<Array<ContactSubcategory>>;
  value: Scalars['String'];
};

export type ContactFaq = {
  __typename?: 'ContactFaq';
  answer: Scalars['String'];
  href: Scalars['String'];
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type ContactFormAlert = {
  __typename?: 'ContactFormAlert';
  message: Maybe<Scalars['String']>;
};

export type ContactInfoInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ContactSubcategory = {
  __typename?: 'ContactSubcategory';
  chatEnabled: Scalars['Boolean'];
  emailEnabled: Scalars['Boolean'];
  faqs: Array<ContactFaq>;
  id: Scalars['ID'];
  label: Scalars['String'];
  message: Maybe<SubcategoryMessage>;
  phoneEnabled: Scalars['Boolean'];
  value: Scalars['String'];
};

export type ContentPreviewConnection = LearnConnection & {
  __typename?: 'ContentPreviewConnection';
  edges: Array<ContentPreviewEdge>;
  pageInfo: LearnPageInfo;
};

export type ContentPreviewEdge = LearnEdge & {
  __typename?: 'ContentPreviewEdge';
  cursor: Scalars['ID'];
  node: LearnContentPreview;
};

export type ContextEntryInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ContributionAbility = {
  __typename?: 'ContributionAbility';
  /** flag indicating if the user can contribute to this tax year */
  canContribute: Maybe<Scalars['Boolean']>;
  /** maximum legally allowed amount for contributions */
  planLimit: Maybe<Scalars['Int']>;
  /** available contribution amount */
  remaining: Maybe<Scalars['Float']>;
  /** tax year of aggregated contributions */
  taxYear: Scalars['Int'];
  /** total current contributions in tax year */
  yearToDate: Maybe<Scalars['Float']>;
};

export type ContributionAbilityByYear = {
  __typename?: 'ContributionAbilityByYear';
  contributionAbilities: Maybe<Array<ContributionAbility>>;
};

/** Contribution cannot be created because an additional action needs to be taken first */
export type ContributionActionRequiredError = {
  __typename?: 'ContributionActionRequiredError';
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID'];
  /** The url that the frontend needs to redirect the user to for 3DS. Only available for REDIRECT_TO_URL action */
  redirectUrl: Maybe<Scalars['String']>;
  /** The action that needs to be taken in order to create transaction */
  requiredAction: ContributionRequiredAction;
};

/** Contribution amount must be below the maximum threshold */
export type ContributionAmountAboveThresholdError = {
  __typename?: 'ContributionAmountAboveThresholdError';
  maximumThresholdAmount: Scalars['String'];
};

/** Contribution amount must be above the minimum threshold */
export type ContributionAmountBelowThresholdError = {
  __typename?: 'ContributionAmountBelowThresholdError';
  minimumThresholdAmount: Scalars['String'];
};

/** Contribution cannot be created because the card was declined */
export type ContributionCardDeclinedError = {
  __typename?: 'ContributionCardDeclinedError';
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID'];
};

export type ContributionHistoryItem = {
  __typename?: 'ContributionHistoryItem';
  year: Scalars['Int'];
};

/** Invalid owner email. */
export type ContributionInvalidOwnerEmailError = {
  __typename?: 'ContributionInvalidOwnerEmailError';
  /** The invalid email provided. */
  providedEmail: Scalars['String'];
};

export enum ContributionRequiredAction {
  /** Stripe is expecting the app to redirect the user (not part of our flow and should not happen) */
  REDIRECT_TO_URL = 'REDIRECT_TO_URL',
  /** The frontend is responsible for sending this payment intent to Stripe for 3DS verification */
  USE_STRIPE_SDK = 'USE_STRIPE_SDK'
}

export enum ContributionState {
  /** Terminal state, failed contribution */
  FAILED = 'FAILED',
  /** Initial state, pending contribution */
  PENDING = 'PENDING',
  /** Terminal state, successful contribution */
  SUCCESS = 'SUCCESS'
}

/** Pulls from funding source */
export type CoreAchSubscriptionFeeItem = PastItem & {
  __typename?: 'CoreACHSubscriptionFeeItem';
  /** The amount paid for the subscription. Note that this is intentionally positive because it does not represent removing balance from the account. */
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A Core account already exists for this user */
export type CoreAccountAlreadyExistsException = {
  __typename?: 'CoreAccountAlreadyExistsException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Deprecated - This exception is no longer returned */
export type CoreAccountClosedException = {
  __typename?: 'CoreAccountClosedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Legacy type we need to account for Credit (Found Money Credits + Employee Contribution) */
export type CoreAdjustmentItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreAdjustmentItem';
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreCashForwardItem = PastItem & {
  __typename?: 'CoreCashForwardItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Format: 2017-02 */
  relatedMonth: Scalars['String'];
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** You owe us money */
export type CoreCollectionItem = PastItem & {
  __typename?: 'CoreCollectionItem';
  /** The amount owed. */
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Sell shares to pay down cash owed by the customer. */
export type CoreDebtCollectionItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreDebtCollectionItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreDividendsItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreDividendsItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  etfCategory: Scalars['String'];
  etfTicker: Scalars['String'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreEmployeeCreditItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreEmployeeCreditItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  employerName: Scalars['String'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type CoreFeeInvestmentItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreFeeInvestmentItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreFoundMoneyRewardItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreFoundMoneyRewardItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  merchantName: Maybe<Scalars['String']>;
  partnerLogoUrl: Maybe<Scalars['URL']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreGiftCardCreditRedemptionItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreGiftCardCreditRedemptionItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Holding transfer transfered in from Age of Transfer beneficiary investment account */
export type CoreHoldingsTransferInItem = PastItem & {
  __typename?: 'CoreHoldingsTransferInItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** An investment in to the Core account */
export type CoreInvestmentItem = PastCoreCombinedItem & PastCoreTradedItem & PastItem & PastUserTransferItem & {
  __typename?: 'CoreInvestmentItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  isCombinedInvestment: Scalars['Boolean'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreLocalFoundMoneyItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreLocalFoundMoneyItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  merchantName: Maybe<Scalars['String']>;
  partnerLogoUrl: Maybe<Scalars['URL']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CorePartnerRewardItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CorePartnerRewardItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  merchantName: Maybe<Scalars['String']>;
  partnerLogoUrl: Maybe<Scalars['URL']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreRebalanceItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreRebalanceItem';
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreReferralRewardItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreReferralRewardItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Cash refunded to the customer */
export type CoreRefundedItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreRefundedItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Cash that is reinvested into the investment account */
export type CoreReinvestmentItem = PastCoreTradedItem & PastItem & {
  __typename?: 'CoreReinvestmentItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Instant and regular round ups */
export type CoreRoundUpsItem = PastCoreCombinedItem & PastCoreTradedItem & PastItem & PastUserTransferItem & {
  __typename?: 'CoreRoundUpsItem';
  /** The investment amount after being multiplied. */
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** The investment amount prior to being multiplied */
  initialAmount: CurrencyAmount;
  isCombinedInvestment: Scalars['Boolean'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  merchantName: Maybe<Scalars['String']>;
  multiplier: Scalars['Int'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** The amount of the transaction that caused this round up. TransactionAmount will be null if this is a combined round up investment. */
  transactionAmount: Maybe<CurrencyAmount>;
  type: RoundUpType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type CoreWithdrawalItem = PastCoreTradedItem & PastItem & PastUserTransferItem & {
  __typename?: 'CoreWithdrawalItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type Course = {
  __typename?: 'Course';
  authors: Array<LearnAuthor>;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  id: Scalars['ID'];
  learnProductKey: Maybe<LearnProductKey>;
  lessons: Array<Lesson>;
  metadata: LearnMetadata;
  summary: Maybe<Scalars['String']>;
  tags: Array<LearnTag>;
  theme: CourseTheme;
  /** @deprecated Tier will be removed */
  tier: LearnTier;
  title: Scalars['String'];
  topics: Array<LearnTopic>;
};

export type CourseLocked = {
  __typename?: 'CourseLocked';
  authors: Array<LearnAuthor>;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  id: Scalars['ID'];
  lessons: Array<Lesson>;
  numLessons: Scalars['Int'];
  primaryTopicName: Scalars['String'];
  productRequired: Scalars['String'];
  summary: Maybe<Scalars['String']>;
  theme: CourseTheme;
  title: Scalars['String'];
  topics: Array<LearnTopic>;
};

export type CoursePreview = {
  __typename?: 'CoursePreview';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  courseTheme: CourseTheme;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  isCompleted: Scalars['Boolean'];
  numberOfLessons: Scalars['Int'];
  primaryTopicName: Scalars['String'];
  productRequired: Maybe<Scalars['String']>;
  progress: Maybe<LearnProgress>;
  relatedQuizProgress: Maybe<LearnProgress>;
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String'];
  title: Scalars['String'];
};

export type CoursePreviewLocked = {
  __typename?: 'CoursePreviewLocked';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  courseTheme: CourseTheme;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  lockedReason: Maybe<Scalars['String']>;
  numberOfLessons: Scalars['Int'];
  primaryTopicName: Scalars['String'];
  productRequired: Scalars['String'];
  title: Scalars['String'];
};

export type CourseTheme = LearnThemeLiteral;

export type CreateAuthProfileInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type CreateAuthProfileResult = AuthProfile | AuthProfileAlreadyExistsException;

export type CreateBankAccountInput = {
  accountName?: InputMaybe<Scalars['String']>;
  isDocumentsAccepted: Scalars['Boolean'];
  tag?: InputMaybe<Scalars['String']>;
  type: BankAccountType;
};

export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload';
  bankAccount: Maybe<BankAccount>;
};

/** Response to a beneficiary creation attempt */
export type CreateBeneficiaryResult = Beneficiary | BeneficiaryExceedsAgeLimitException | InternalErrorException | InvalidDateOfBirthException | InvalidFirstNameException | InvalidLastNameException;

export type CreateCustomSupportTicketInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  category?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  subject: Scalars['String'];
  ticketFormId?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type CreateDelegateResult = DelegateDefinition;

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoFailure = {
  __typename?: 'CreateDirectDepositLinkInfoFailure';
  failureMessage: Scalars['String'];
};

/** Mutation attributes for retrieving a Pinwheel link token */
export type CreateDirectDepositLinkInfoInput = {
  /** Account ID */
  accountId: Scalars['ID'];
  /** Required Job */
  requiredJobs: Array<PinwheelLinkTokenRequiredJobs>;
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>;
  /** Vendor */
  vendor?: InputMaybe<DirectDepositVendor>;
};

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoPayload = {
  __typename?: 'CreateDirectDepositLinkInfoPayload';
  results: CreatePinwheelLinkToken;
  vendor: Scalars['String'];
};

/** Describes the create direct deposit info return type. */
export type CreateDirectDepositLinkInfoSwitch = CreateDirectDepositLinkInfoFailure | CreateDirectDepositLinkInfoPayload;

export type CreateDocumentUpload = {
  __typename?: 'CreateDocumentUpload';
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  requestedDocumentId: Scalars['ID'];
  uploadUrl: Scalars['URL'];
};

export type CreateDocumentUploadInput = {
  contentType: Scalars['String'];
  documentType: DocumentType;
};

export type CreateImplicitTokenForUserInput = {
  oauthAppClientId?: InputMaybe<Scalars['String']>;
  oauthAppId: Scalars['String'];
};

export type CreateImplicitTokenForUserResult = ImplicitToken | InvalidOauthAppClientIdException | OauthAppNotFoundException;

/** Input of CreateIntent. */
export type CreateIntentInput = {
  /** The amount to transfer. */
  amount: CurrencyAmountInput;
  /** The ID of the `CustomerAccount` to transfer money from. */
  fromId: Scalars['ID'];
  /** Idempotent identifier for this transaction intent, provided by caller. */
  nonce: Scalars['UUID'];
  /** The ID of the `CustomerAccount` to transfer money to. */
  toId: Scalars['ID'];
  /** Additional input to be passed for this transfer. */
  transferContext?: InputMaybe<Array<ContextEntryInput>>;
};

export type CreateIntentResult = Intent | ValidationError;

/** Input for creating investing strategy recommendations */
export type CreateInvestingStrategyRecommendationInput = {
  /** Type of account to get recommendation for */
  accountType: SuitabilityAccountType;
  /** Factors affecting outcome of recommendation */
  factors: Array<InvestingStrategyFactors>;
};

export type CreateInvestingStrategyRecommendationResult = BadRequestError | RecommendedInvestingStrategy;

export type CreateInvestmentAccountResponse = {
  __typename?: 'CreateInvestmentAccountResponse';
  id: Scalars['ID'];
  iraType: InvestmentAccountTypes;
  userUuid: Scalars['ID'];
};

export type CreateJobAlertResult = JobAlert;

export type CreateOauthAppInput = {
  accessTokenAudience: Array<InputMaybe<Scalars['String']>>;
  accessTokenExpiry?: InputMaybe<Scalars['Int']>;
  active: Scalars['Boolean'];
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<Scalars['String']>;
  externalApp: Scalars['Boolean'];
  imageUri?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pageType: Scalars['String'];
  redirectUri?: InputMaybe<Scalars['String']>;
  refreshTokenExpiry?: InputMaybe<Scalars['Int']>;
  scopeIdentifiers: Array<Scalars['String']>;
  type: OauthAppType;
};

export type CreateOauthAppResult = OauthApp;

export type CreateOfferInput = {
  availableTo: OfferAvailability;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  offerType: OfferType;
  price: OfferPriceInput;
};

export type CreateOfferResult = Offer;

/** Input to create a new outside contribution checkout cart */
export type CreateOutsideContributionCheckoutCartInput = {
  /** Outside contribution code */
  code: Scalars['String'];
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String'];
};

/** Create Outside Contribution checkout cart response */
export type CreateOutsideContributionCheckoutCartResult = ContributionAmountAboveThresholdError | ContributionAmountBelowThresholdError | OutsideContributionCheckoutCart;

/** Input to create a new outside contribution */
export type CreateOutsideContributionInput = {
  /** The last 4 digits of the debit card number */
  cardNumberLast4: Scalars['String'];
  /** The provider of the debit card ie visa, mastercard etc */
  cardProvider: Scalars['String'];
  /** The outside contributor email address */
  contributorEmail: Scalars['String'];
  /** The first name of the outside contributor */
  contributorFirstName: Scalars['String'];
  /** The last name of the outside contributor */
  contributorLastName: Scalars['String'];
  /** The note from the outside contributor */
  note?: InputMaybe<Scalars['String']>;
  /** The name from the note of the contributor */
  noteAuthor?: InputMaybe<Scalars['String']>;
  /** Stripe payment_intent_id */
  paymentIntentId: Scalars['ID'];
  /** Stripe payment_method_id */
  paymentMethodId: Scalars['ID'];
};

/** Create Outside Contribution mutation response */
export type CreateOutsideContributionResult = ContributionActionRequiredError | ContributionCardDeclinedError | ContributionInvalidOwnerEmailError | OutsideContribution;

export type CreatePinwheelLinkToken = {
  __typename?: 'CreatePinwheelLinkToken';
  /** Pinwheel Token expiration date/time */
  expires: Scalars['DateTime'];
  /** UUID of the link token */
  id: Scalars['String'];
  /** Pinwheel token Environment */
  mode: Scalars['String'];
  /** Short lived token that is used to initialize Pinwheel Link */
  token: Scalars['String'];
};

/** Attributes for a linked account created through Plaid Link */
export type CreatePlaidLinkedAccountInput = {
  /** Should the related round up account be disabled */
  disableRoundUps?: InputMaybe<Scalars['Boolean']>;
  /** Plaid's Financial Institution ID */
  externalInstitutionId?: InputMaybe<Scalars['String']>;
  /** Plaid link session id */
  linkSessionId: Scalars['String'];
};

export type CreatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine;
  channel: Scalars['String'];
  condensedTitle: Scalars['String'];
  description: Scalars['String'];
  internalMemo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  publishEnd?: InputMaybe<Scalars['DateTime']>;
  publishStart: Scalars['DateTime'];
  qualificationAction: PromoCodeQualificationAction;
  qualificationAmount: Scalars['Int'];
  rewards: Array<Scalars['ID']>;
  status: PromoCodeStatus;
  termsUrl?: InputMaybe<Scalars['URL']>;
  title: Scalars['String'];
};

export type CreatePromoCodeResult = DuplicatePromoCodeError | PromoCode | PromoCodeFieldLengthError;

export type CreatePromoCodeRewardInput = {
  amount: Scalars['Float'];
  type: PromoCodeRewardType;
};

export type CreatePromoCodeRewardResult = DuplicatePromoCodeRewardError | PromoCodeReward;

/** Input for creating a prospect user */
export type CreateProspectUserInput = {
  /** Email address of the prospect user */
  email: Scalars['String'];
  /** Prospect Type */
  type: ProspectType;
};

/** Create Prospect User Response */
export type CreateProspectUserResult = GrowProspect | InternalErrorException | LaterWaitlistProspect | OutsideContributionProspect | User_V2;

export type CreateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<CampaignBackgroundType>;
  condensedTitle?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  eligibilityEnd?: InputMaybe<Scalars['DateTime']>;
  hidden: Scalars['Boolean'];
  icon?: InputMaybe<CampaignIconType>;
  internalMemo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  publishEnd?: InputMaybe<Scalars['DateTime']>;
  publishStart: Scalars['DateTime'];
  qualificationAction: CampaignQualificationActionType;
  qualificationAmount: Scalars['Int'];
  rewards: Array<Scalars['ID']>;
  status: CampaignStatus;
  title: Scalars['String'];
};

export type CreateReferralCampaignResult = ReferralCampaignV2;

export type CreateReferralCampaignRewardInput = {
  amount: Scalars['Float'];
  hurdle: Scalars['Int'];
  repeated: Scalars['Boolean'];
  targets: Array<ReferralCampaignRewardTarget>;
  type: ReferralCampaignRewardType;
};

export type CreateReferralCampaignRewardResult = ReferralCampaignReward;

export type CreateReferralPayoutInput = {
  advocateId: Scalars['ID'];
  campaignId: Scalars['ID'];
  friendId?: InputMaybe<Scalars['ID']>;
  rewardId: Scalars['ID'];
};

export type CreateReferralPayoutResult = ReferralPayout | ReferralPayoutExistsError;

export type CreateReferralRelationshipResult = InvalidReferralRelationship | ReferralRelationship;

export type CreateRefundError = {
  __typename?: 'CreateRefundError';
  message: Scalars['String'];
};

export type CreateRefundResult = BillingInvoice | CreateRefundError | VendorIntegrationError | VendorRefundInvoiceError;

export type CreateSavingsAccountInput = {
  bankType?: InputMaybe<BankType>;
  currentGoal?: InputMaybe<BankAccountGoalInput>;
  isReopen?: InputMaybe<Scalars['Boolean']>;
  type: SavingsAccountType;
};

export type CreateSavingsAccountPayload = {
  __typename?: 'CreateSavingsAccountPayload';
  bankAccountId: Scalars['ID'];
};

export type CreateSavingsAccountResult = CreateSavingsAccountPayload | CreateSavingsAccountVerificationError;

export type CreateSavingsAccountVerificationError = {
  __typename?: 'CreateSavingsAccountVerificationError';
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>;
};

export type CreateScopeException = {
  __typename?: 'CreateScopeException';
  message: Scalars['String'];
};

export type CreateScopeInput = {
  description?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type CreateScopeResult = CreateScopeException | Scope;

export type CreateSubscriptionMigrationInput = {
  description: Scalars['String'];
  effectiveAt: Scalars['DateTime'];
  fromTierId: Scalars['ID'];
  toTierId: Scalars['ID'];
};

export type CreateSubscriptionMigrationResult = SubscriptionMigration;

export type CreateSupportTicketInput = {
  category?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message: Scalars['String'];
  phone: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type CreateSuspendedUserSupportTicketInput = {
  dob?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  message: Array<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  uuid?: InputMaybe<Scalars['ID']>;
};

/** Input for creating an upload url for direct to s3 upload */
export type CreateUploadUrlInput = {
  /** the document type of the upload document */
  documentType: DocumentType;
  /** the file_name upload document */
  fileName: Scalars['String'];
  /** the user_id of the user uploading a document */
  userId: Scalars['String'];
};

/** CreateUploadUrlResult */
export type CreateUploadUrlResult = UploadUrl;

export type CreateUserInput = {
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']>>;
  authorizationAccessToken?: InputMaybe<Scalars['String']>;
  authorizationExpiresAt?: InputMaybe<Scalars['DateTime']>;
  authorizationProvider?: InputMaybe<Scalars['String']>;
  authorizationRefreshToken?: InputMaybe<Scalars['String']>;
  authorizationUid?: InputMaybe<Scalars['String']>;
  captchaToken?: InputMaybe<Scalars['String']>;
  clientCredentialsToken?: InputMaybe<Scalars['String']>;
  codeGroup?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  invitationCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  sourceAttributes?: InputMaybe<Scalars['JSON']>;
  sourceId?: InputMaybe<Scalars['String']>;
  udid: Scalars['String'];
  usResident?: InputMaybe<Scalars['Boolean']>;
  withBasicAccount?: InputMaybe<Scalars['Boolean']>;
};

/** Input for creating a new user and user profile */
export type CreateUserProfileInput = {
  /** required acceptance document version UUIDs for login */
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']>>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  usResident: Scalars['Boolean'];
};

/** CreateUserProfileResult */
export type CreateUserProfileResult = MissingAgreementsException | User | UserExistsException | UserNotUsResidentException;

export type CreateVendorInvoiceInput = {
  chargeCustomerNotes?: InputMaybe<Scalars['String']>;
  collectionMethod?: InputMaybe<CollectionMethod>;
  creditCustomerNotes?: InputMaybe<Scalars['String']>;
  currency: Currency;
  netTerms?: InputMaybe<Scalars['Int']>;
  netTermsType?: InputMaybe<NetTermsType>;
  poNumber?: InputMaybe<Scalars['String']>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
  vatReverseChargeNotes?: InputMaybe<Scalars['String']>;
};

export type CreateVendorInvoiceResult = BillingVendorError | InvoiceCollection;

export type CreateVendorLineItemInput = {
  accountingCode?: InputMaybe<Scalars['String']>;
  avalaraServiceType?: InputMaybe<Scalars['Int']>;
  avalaraTransactionType?: InputMaybe<Scalars['Int']>;
  creditReasonCode?: InputMaybe<CreditReasonCode>;
  currency: Currency;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  itemCode?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Origin>;
  productCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  revenueScheduleType?: InputMaybe<RevenueScheduleType>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  taxCode?: InputMaybe<Scalars['String']>;
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  taxInclusive?: InputMaybe<Scalars['Boolean']>;
  type: Type;
  unitAmount: Scalars['Float'];
};

export type CreateVendorLineItemResult = BillingVendorError | InvoiceLineItem;

export enum CredentialStatus {
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  VALID = 'VALID'
}

export type Credentials = {
  __typename?: 'Credentials';
  email: Scalars['EmailAddress'];
  userId: Scalars['ID'];
};

/** Possible credentials types */
export enum CredentialsType {
  /** Acorns Early OIDC credentials */
  ACORNS_EARLY = 'ACORNS_EARLY',
  /** Apple OIDC credentials */
  APPLE = 'APPLE',
  /** Google OIDC credentials */
  GOOGLE = 'GOOGLE',
  /** Native email and password credentials */
  USER = 'USER'
}

/** Credit information */
export type Credit = TimestampsInterface & {
  __typename?: 'Credit';
  amount: Scalars['Float'];
  assessedAt: Maybe<Scalars['String']>;
  billingCycle: BillingCycle;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  discountId: Scalars['ID'];
  id: Scalars['ID'];
  state: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export enum CreditReasonCode {
  general = 'general',
  promotional = 'promotional',
  service = 'service'
}

export type Cta = {
  __typename?: 'Cta';
  id: Scalars['ID'];
  image: Maybe<Image>;
  title: Maybe<Scalars['String']>;
  type: CtaType;
};

export enum CtaType {
  action = 'action',
  disclaimer = 'disclaimer',
  grow_article = 'grow_article',
  link = 'link',
  protect_link = 'protect_link',
  video = 'video'
}

/** System of money that is used in a particular country */
export enum Currency {
  USD = 'USD'
}

/** Standard format for all currency amounts */
export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  /** Currency code of owning country. */
  currency: Currency;
  /** Quantity of currency */
  value: Scalars['Float'];
};

/** Input the amount to be transferred. */
export type CurrencyAmountInput = {
  /** Currency code of the country. */
  currency: Currency;
  /** Quantity of currency */
  value: Scalars['Float'];
};

export type CurrencyMilestoneProgress = {
  __typename?: 'CurrencyMilestoneProgress';
  /** the type of currency */
  currency: Currency;
  /** the current value */
  currentAmount: Scalars['Float'];
  /** the value needed for completion */
  targetAmount: Scalars['Float'];
};

/** A bank statement showing ownership of the current funding source has not been provided */
export type CurrentBankStatementNotProvided = {
  __typename?: 'CurrentBankStatementNotProvided';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type CustomFieldInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption';
  default: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  label: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  raw_name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Account details of a customer account. This owns the customerAccount type and can be defined by id. */
export type CustomerAccount = {
  __typename?: 'CustomerAccount';
  /** The available balance of the account. */
  balance: Maybe<CurrencyAmount>;
  /** Beneficiary as populated by user service. */
  beneficiary: Maybe<Beneficiary>;
  /** Datetime the account was created. */
  createdAt: Scalars['DateTime'];
  /** Get customer accounts by transfer action. */
  customerAccountsByTransferAction: Array<Maybe<CustomerAccount>>;
  /** Account has either a customer action required or will have customer communication to show. */
  customerNotice: Scalars['Boolean'];
  /** ID. */
  id: Scalars['ID'];
  /** The FinancialInstitution associated with this account. Populated if the account was connected through Plaid or DBI, null for all other accounts. */
  institution: Maybe<FinancialInstitution>;
  /**
   * Indicator if the account has deposit capability at this time.
   * @deprecated Deprecated
   */
  isDepositAllowed: Scalars['Boolean'];
  /**
   * Indicator if the account has withdrawal capability at this time.
   * @deprecated Deprecated
   */
  isWithdrawalAllowed: Scalars['Boolean'];
  /** The last 2-4 alphanumeric characters of an account's official account number. */
  mask: Maybe<Scalars['String']>;
  /** Account name. */
  name: Scalars['String'];
  /** User ID. */
  ownerId: Scalars['ID'];
  /** ID used to reference the account in the owning domain. */
  referenceId: Scalars['ID'];
  /** Account status. */
  status: CustomerAccountStatus;
  /** Type of the account. */
  type: Scalars['String'];
  /** Datetime the account was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** Account details of a customer account. This owns the customerAccount type and can be defined by id. */
export type CustomerAccountCustomerAccountsByTransferActionArgs = {
  transferAction: TransferAction;
};

/** Customer Account Closure Record */
export type CustomerAccountClosure = {
  __typename?: 'CustomerAccountClosure';
  closedAt: Maybe<Scalars['DateTime']>;
  closureState: CustomerAccountClosureState;
  requestedAt: Scalars['DateTime'];
  requestedBy: Scalars['String'];
  /** User UUID */
  userId: Scalars['ID'];
  workflowId: Scalars['String'];
};

export enum CustomerAccountClosureState {
  FULFILLED = 'FULFILLED',
  INITIATED = 'INITIATED'
}

export enum CustomerAccountStatus {
  /** Account is closed. */
  CLOSED = 'CLOSED',
  /** Account is open but locked for transfer. */
  LOCKED = 'LOCKED',
  /** Account is open. */
  OPEN = 'OPEN',
  /** Account has started the closure process. */
  PENDING_CLOSURE = 'PENDING_CLOSURE',
  /** Account has started the opening process. */
  PENDING_OPEN = 'PENDING_OPEN',
  /** Account has started the re-opening process. */
  PENDING_REOPEN = 'PENDING_REOPEN'
}

/** Required acceptance documents for portfolio missing */
export type CustomerAgreementRequiredException = {
  __typename?: 'CustomerAgreementRequiredException';
  /** message */
  message: Maybe<Scalars['String']>;
  /** message */
  requiredAcceptanceDocumentTypes: Array<Scalars['String']>;
};

export type CustomerEarnOnboardingMilestone = {
  __typename?: 'CustomerEarnOnboardingMilestone';
  badgeText: Scalars['String'];
  completedAt: Maybe<Scalars['DateTime']>;
  completionDescription: Scalars['String'];
  completionTitle: Scalars['String'];
  description: Scalars['String'];
  header: Scalars['String'];
  key: Scalars['String'];
  logoUrl: Scalars['URL'];
  primaryCta: EarnOnboardingMilestoneCta;
  reward: MonetaryAmount;
  secondaryCta: Maybe<EarnOnboardingMilestoneCta>;
  steps: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type CustomerEarnOnboardingProgram = CustomerEarnOnboardingProgramControl | CustomerEarnOnboardingProgramFeature;

export type CustomerEarnOnboardingProgramControl = {
  __typename?: 'CustomerEarnOnboardingProgramControl';
  experimentName: Scalars['String'];
  variantName: Scalars['String'];
};

export type CustomerEarnOnboardingProgramFeature = {
  __typename?: 'CustomerEarnOnboardingProgramFeature';
  activePeriodDays: Scalars['Int'];
  closeAt: Scalars['DateTime'];
  closurePeriodDays: Scalars['Int'];
  completionDescription: Scalars['String'];
  completionLogoUrl: Scalars['URL'];
  completionTitle: Scalars['String'];
  description: Scalars['String'];
  endAt: Scalars['DateTime'];
  experiment: Maybe<Scalars['String']>;
  header: Scalars['String'];
  milestones: Array<CustomerEarnOnboardingMilestone>;
  primaryCta: Scalars['String'];
  startAt: Scalars['DateTime'];
  status: CustomerEarnOnboardingStatus;
  subTitle: Scalars['String'];
  termsLabel: Scalars['String'];
  title: Scalars['String'];
  variant: Maybe<Scalars['String']>;
};

export enum CustomerEarnOnboardingStatus {
  BEFORE_OPEN = 'BEFORE_OPEN',
  CLOSED = 'CLOSED',
  CLOSING = 'CLOSING',
  OPEN = 'OPEN'
}

export type CustomerMoneyRulesResult = CustomerMoneyRulesResultSuccess | MoneyRulesRulesetNotFoundException;

export type CustomerMoneyRulesResultSuccess = {
  __typename?: 'CustomerMoneyRulesResultSuccess';
  resultingRuleset: MoneyRulesRuleset;
};

export type CustomerSupportChatWidget = {
  __typename?: 'CustomerSupportChatWidget';
  chatRedirect: Maybe<ChatRedirect>;
  emailRedirect: Maybe<EmailRedirect>;
  phoneRedirect: Maybe<PhoneRedirect>;
  sessionId: Scalars['ID'];
};

export enum DayOfWeek {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED'
}

/** Response to a beneficiary ssn update */
export type DeactivateBeneficiaryResult = Beneficiary | BeneficiaryNotFoundException | InternalErrorException;

export type DeactivateOauthAppClientResult = OauthAppClient | OauthAppClientNotFoundException;

export type DeactivateOauthAppResult = OauthApp | OauthAppNotFoundException;

export type DeactivateTierSubscriptionInput = {
  feedback?: InputMaybe<Scalars['String']>;
  subscriptionDeactivationReason: TierSubscriptionDeactivationReason;
  userId?: InputMaybe<Scalars['ID']>;
};

export type DeactivateTierSubscriptionResult = TierSubscription | TierSubscriptionAlreadyDeactivated;

export enum DealType {
  PARTNER_LINK = 'PARTNER_LINK',
  SIMPLY_SPEND = 'SIMPLY_SPEND',
  TAP_AND_GET = 'TAP_AND_GET',
  UNIQUE_PRICE_POINT = 'UNIQUE_PRICE_POINT',
  VERIFIED_REFERRAL = 'VERIFIED_REFERRAL'
}

export type DeeplinkWidget = {
  __typename?: 'DeeplinkWidget';
  deeplinks: Array<ChatDeeplink>;
};

export type DelegateDefinition = {
  __typename?: 'DelegateDefinition';
  departmentId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  qualifiedHostName: Scalars['String'];
};

export type DelegateDefinitionInput = {
  departmentId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  qualifiedHostName?: InputMaybe<Scalars['String']>;
};

export type DelegateFilterInput = {
  departmentId?: InputMaybe<Scalars['ID']>;
  ownerId?: InputMaybe<Scalars['ID']>;
};

export type DeleteDelegateResult = DeleteDelegateResultTemporaryImpl;

export type DeleteDelegateResultTemporaryImpl = {
  __typename?: 'DeleteDelegateResultTemporaryImpl';
  someField: Scalars['String'];
};

export type DeleteExpiredBankCardOrderCardTierNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderCardTierNotFoundError';
  failureMessage: Scalars['String'];
};

export type DeleteExpiredBankCardOrderNotExpiredError = {
  __typename?: 'DeleteExpiredBankCardOrderNotExpiredError';
  expiresAt: Scalars['DateTime'];
};

export type DeleteExpiredBankCardOrderNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderNotFoundError';
  userId: Scalars['ID'];
};

export type DeleteExpiredBankCardOrderResult = BankCardOrder | DeleteExpiredBankCardOrderCardTierNotFoundError | DeleteExpiredBankCardOrderNotExpiredError | DeleteExpiredBankCardOrderNotFoundError;

export type DeleteOauthAppResult = DeleteOauthAppSuccess | OauthAppNotFoundException;

export type DeleteOauthAppSuccess = {
  __typename?: 'DeleteOauthAppSuccess';
  oauthAppId: Scalars['ID'];
};

export type DeleteScopeSuccess = {
  __typename?: 'DeleteScopeSuccess';
  message: Scalars['String'];
};

/** Response for deleting a trusted contact for a user */
export type DeleteTrustedContactResult = InternalErrorException | TrustedContact | TrustedContactNotFoundException;

export enum DepositField {
  accountHolderName = 'accountHolderName',
  accountNumber = 'accountNumber',
  auxOnUs = 'auxOnUs',
  backEndorsement = 'backEndorsement',
  backImage = 'backImage',
  checkDate = 'checkDate',
  checkNumber = 'checkNumber',
  codeline = 'codeline',
  courtesyAmount = 'courtesyAmount',
  customerSuppliedAmount = 'customerSuppliedAmount',
  encodedAmount = 'encodedAmount',
  epc = 'epc',
  fractionCode = 'fractionCode',
  frontImage = 'frontImage',
  frontSignature = 'frontSignature',
  institutionName = 'institutionName',
  instrumentType = 'instrumentType',
  legalAmount = 'legalAmount',
  onUs = 'onUs',
  payeeName = 'payeeName',
  routing = 'routing'
}

/** Represents a risk that could prevent the deposit from completing */
export type DepositRiskFactor = {
  __typename?: 'DepositRiskFactor';
  /** Description of risk */
  description: Scalars['String'];
  fields: Array<DepositField>;
  /**
   * Risk Statuses:
   *     fixable: fixable = true
   *     confirmable: confirmable = true
   *     hard_reject: fixable = false, confirmable = false, severity level reject
   */
  status: RiskStatus;
};

export type DeregisterAuthenticatorInput = {
  id: Scalars['ID'];
};

export type DeregisterAuthenticatorResult = AuthenticatorNotFoundException | EmailAuthenticator | PhoneAuthenticator;

export type DesignLibraryIcon = {
  __typename?: 'DesignLibraryIcon';
  /** icon type corresponding to a Design Library icon */
  icon: IconType;
};

export type Destination = {
  __typename?: 'Destination';
  /** deep link to milestone action destination */
  deepLink: Scalars['URL'];
  /** key that maps to client-defined destination label */
  labelKey: Scalars['StringKey'];
};

export type Device = {
  __typename?: 'Device';
  appVersion: Maybe<Scalars['String']>;
  blockTrigger: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deviceAdid: Maybe<Scalars['String']>;
  firstLoginAt: Maybe<Scalars['DateTime']>;
  hasActiveSession: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isBlocked: Scalars['Boolean'];
  lastLoginAt: Maybe<Scalars['DateTime']>;
  platform: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userAgent: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type DeviceBlockedException = {
  __typename?: 'DeviceBlockedException';
  message: Maybe<Scalars['String']>;
};

export type DeviceNotFoundException = {
  __typename?: 'DeviceNotFoundException';
  message: Maybe<Scalars['String']>;
};

export enum DeviceType {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export type DigitalWalletDevice = {
  __typename?: 'DigitalWalletDevice';
  deviceId: Scalars['String'];
  deviceName: Scalars['String'];
  deviceNumber: Scalars['String'];
  deviceType: DigitalWalletDeviceType;
};

export enum DigitalWalletDeviceType {
  Card = 'Card',
  FashionAccessory = 'FashionAccessory',
  HomeAppliance = 'HomeAppliance',
  KeyFob = 'KeyFob',
  MediaOrGamingDevice = 'MediaOrGamingDevice',
  MobileDevice = 'MobileDevice',
  MobileDeviceAccessory = 'MobileDeviceAccessory',
  MobilePhone = 'MobilePhone',
  PCOrLaptop = 'PCOrLaptop',
  Tablet = 'Tablet',
  UnknownOther = 'UnknownOther',
  Vehicle = 'Vehicle',
  Watch = 'Watch'
}

export type DigitalWalletToken = {
  __typename?: 'DigitalWalletToken';
  device: DigitalWalletDevice;
  isDeviceProvisioned: Scalars['Boolean'];
  tokenStatus: Scalars['String'];
};

export enum DirectDepositDistribution {
  /** Amount of Paycheck */
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  /** Entire Paycheck */
  FULL_AMOUNT = 'FULL_AMOUNT',
  /** Percentage of Paycheck */
  PERCENTAGE_AMOUNT = 'PERCENTAGE_AMOUNT'
}

/** Describes a user direct deposit info */
export type DirectDepositInfo = {
  __typename?: 'DirectDepositInfo';
  /** Direct Deposit Status */
  status: DirectDepositStatus;
};

/** Direct Deposit Info */
export type DirectDepositInfoPayload = {
  __typename?: 'DirectDepositInfoPayload';
  /** Direct Deposit Info */
  info: Maybe<DirectDepositInfo>;
};

/** Describes a user state for all its direct deposit switches. */
export type DirectDepositState = {
  __typename?: 'DirectDepositState';
  /** Creation Date */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Switch Method */
  switchMethod: SwitchMethod;
  /** Switch State */
  switchState: SwitchState;
  /** Last Updated Date */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Direct Deposit User State */
export type DirectDepositStatePayload = {
  __typename?: 'DirectDepositStatePayload';
  /** Direct Deposit State */
  state: Maybe<DirectDepositState>;
};

export enum DirectDepositStatus {
  /** Downloaded pdf to personal device or got a success status back from Pinwheel */
  Attempted = 'Attempted',
  /** SplitDepositSettings Query returns a paycheck has landed */
  Completed = 'Completed',
  /** Has not set up DD */
  NoInteraction = 'NoInteraction',
  /** Has viewed the pdf or entered the pinwheel flow */
  Viewed = 'Viewed'
}

export enum DirectDepositVendor {
  Pinwheel = 'Pinwheel'
}

export type DiscreteMilestoneProgress = {
  __typename?: 'DiscreteMilestoneProgress';
  /** the current value */
  currentInt: Scalars['Int'];
  /** the value needed for completion */
  targetInt: Scalars['Int'];
};

export type DismissMessageInput = {
  messageId: Scalars['ID'];
};

export type DismissMessagesInput = {
  messageIds: Array<Scalars['ID']>;
};

export type DismissMessagesResult = DismissMessagesSuccess | UpdateMessagesFailure;

export type DismissMessagesSuccess = {
  __typename?: 'DismissMessagesSuccess';
  dismissedCount: Scalars['Int'];
};

export type DistributionAmounts = {
  __typename?: 'DistributionAmounts';
  investment: Scalars['String'];
  retirement: Scalars['String'];
  savings: Scalars['String'];
};

export enum DistributionType {
  BALANCED = 'BALANCED',
  LONG_TERM = 'LONG_TERM',
  LONG_WEIGHTED = 'LONG_WEIGHTED',
  MEDIUM_TERM = 'MEDIUM_TERM',
  MEDIUM_WEIGHTED = 'MEDIUM_WEIGHTED'
}

/** Discrete categorization information for diversification scores */
export type DiversificationBucket = {
  __typename?: 'DiversificationBucket';
  bucketName: DiversificationBucketType;
  minDiversificationScoreThreshold: Scalars['Float'];
};

export enum DiversificationBucketType {
  /** Excellent Diversification Bucket */
  EXCELLENT = 'EXCELLENT',
  /** Fair Diversification Bucket */
  FAIR = 'FAIR',
  /** Poor Diversification Bucket */
  POOR = 'POOR'
}

/** Diversification information for a given portfolio */
export type DiversificationInfo = {
  __typename?: 'DiversificationInfo';
  diversificationBuckets: Array<DiversificationBucket>;
  securityDiversificationInfo: Array<SecurityDiversificationInfo>;
};

/** Input to fetch portfolio diversification information for a provided customer's account */
export type DiversificationInfoByInvestmentAccountIdInput = {
  /** Investment account id of the desired customer's investment account, currently limited to managed account id */
  investmentAccountId: Scalars['ID'];
  /** List of ticker symbols the caller wishes to know the diversification factors for */
  symbols: Array<Scalars['TickerSymbol']>;
};

export type Document = {
  __typename?: 'Document';
  uploadedAt: Scalars['DateTime'];
  url: Scalars['URL'];
};

export type DocumentInput = {
  uploadedAt: Scalars['DateTime'];
  url: Scalars['URL'];
};

/** No document for the given document_type and version */
export type DocumentNotFound = {
  __typename?: 'DocumentNotFound';
  /** The type of document to sign */
  documentType: AcceptanceDocumentType;
  /** The version of the document to sign */
  documentVersion: Scalars['String'];
};

export enum DocumentQueryType {
  address = 'address',
  all = 'all',
  beneficiarySsn = 'beneficiarySsn',
  bulkSuspendCsv = 'bulkSuspendCsv',
  currentBankStatement = 'currentBankStatement',
  earlyQuarantinePromotion = 'earlyQuarantinePromotion',
  futureBankStatement = 'futureBankStatement',
  id = 'id',
  militaryId = 'militaryId',
  miscellaneous = 'miscellaneous',
  paypalFundingSource = 'paypalFundingSource',
  spendAddress = 'spendAddress',
  spendFundingSource = 'spendFundingSource',
  spendId = 'spendId',
  ssn = 'ssn',
  traditionalFundingSource = 'traditionalFundingSource',
  w9 = 'w9'
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  acceptedAt: Maybe<Scalars['DateTime']>;
  canceledAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  documentType: DocumentType;
  documents: Maybe<Array<Document>>;
  externalId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  parentRequest: Maybe<DocumentRequest>;
  parentRequestId: Maybe<Scalars['ID']>;
  rejectedAt: Maybe<Scalars['DateTime']>;
  rejectedNote: Maybe<Scalars['String']>;
  rejectedReason: Maybe<RejectedReason>;
  /** Idempotency key for ensuring that duplicate requests are not made or to store additional data */
  requestKey: Maybe<Scalars['String']>;
  requestedFileCount: Maybe<Scalars['Int']>;
  requesterId: Maybe<Scalars['ID']>;
  reviewerId: Maybe<Scalars['String']>;
  status: DocumentStatus;
  userId: Scalars['ID'];
};

export type DocumentRequestEdge = {
  __typename?: 'DocumentRequestEdge';
  node: Maybe<DocumentRequest>;
};

export type DocumentRequestInput = {
  documentRequestId: Scalars['ID'];
};

export type DocumentRequestsConnection = {
  __typename?: 'DocumentRequestsConnection';
  edges: Maybe<Array<DocumentRequestEdge>>;
  pageInfo: DocumentRequestsPageInfo;
};

export type DocumentRequestsInput = {
  pageInput?: InputMaybe<DocumentRequestsPageInput>;
  status?: InputMaybe<DocumentStatus>;
  type: DocumentQueryType;
  /** Deprecated: use `status` field */
  uploaded?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentRequestsPageInfo = {
  __typename?: 'DocumentRequestsPageInfo';
  cursor: Maybe<Scalars['String']>;
  hasNext: Scalars['Boolean'];
};

export type DocumentRequestsPageInput = {
  ascending?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum DocumentStatus {
  accepted = 'accepted',
  canceled = 'canceled',
  rejected = 'rejected',
  requested = 'requested',
  uploaded = 'uploaded'
}

export enum DocumentType {
  address = 'address',
  beneficiarySsn = 'beneficiarySsn',
  bulkSuspendCsv = 'bulkSuspendCsv',
  currentBankStatement = 'currentBankStatement',
  earlyQuarantinePromotion = 'earlyQuarantinePromotion',
  futureBankStatement = 'futureBankStatement',
  id = 'id',
  militaryId = 'militaryId',
  miscellaneous = 'miscellaneous',
  paypalFundingSource = 'paypalFundingSource',
  spendAddress = 'spendAddress',
  spendFundingSource = 'spendFundingSource',
  spendId = 'spendId',
  ssn = 'ssn',
  traditionalFundingSource = 'traditionalFundingSource',
  w9 = 'w9'
}

export type DocumentUploadSession = {
  __typename?: 'DocumentUploadSession';
  /** Token used as identifier for document upload session */
  token: Scalars['String'];
};

/** Uploads from backend */
export type DocumentUploads = {
  __typename?: 'DocumentUploads';
  uploadDocuments: Array<LegacyUploadDocument>;
};

export type DocumentVerification = {
  __typename?: 'DocumentVerification';
  /** Result of verifying uploaded documents */
  decision: DocumentVerificationDecision;
  /** Error descriptors based on reason codes triggered */
  outstandingIssues: Maybe<Array<Scalars['String']>>;
  /** Flag indicating if the customer’s identity was marked as verified during document review */
  verificationCriteriaMet: Scalars['Boolean'];
};

export enum DocumentVerificationDecision {
  /** Documents were verified and accepted */
  ACCEPTED = 'ACCEPTED',
  /** Documents were declined due to various reason codes */
  REJECTED = 'REJECTED',
  /** The information submitted was incomplete or missing */
  RESUBMISSION_REQUIRED = 'RESUBMISSION_REQUIRED',
  /** Manual review is necessary */
  REVIEW_REQUIRED = 'REVIEW_REQUIRED'
}

export type DuplicateActionError = {
  __typename?: 'DuplicateActionError';
  requestId: Scalars['ID'];
};

export type DuplicateBillingInfoError = {
  __typename?: 'DuplicateBillingInfoError';
  message: Scalars['String'];
};

export type DuplicatePromoCodeError = {
  __typename?: 'DuplicatePromoCodeError';
  name: Scalars['String'];
};

export type DuplicatePromoCodeRewardError = {
  __typename?: 'DuplicatePromoCodeRewardError';
  amount: Scalars['Float'];
  type: PromoCodeRewardType;
};

/** DEPRECATED - Use Security type instead */
export type Etf = {
  __typename?: 'ETF';
  /** Indicates the amount of every dollar that will go towards buying a share of the ETF */
  amount: Maybe<Scalars['Int']>;
  /** ETF high price over trailing 12 month period */
  annualHigh: Maybe<Scalars['Float']>;
  /** ETF low price over trailing 12 month period */
  annualLow: Maybe<Scalars['Float']>;
  /** Indicates the current per/share price */
  currentPrice: Maybe<Scalars['Float']>;
  /** The Acorns-designated display name of the ETF */
  displayName: Scalars['String'];
  /** Indicates the individual stocks that make up the ETF */
  holdings: Maybe<Array<Holding>>;
  /** Indicates the investment category for the ETF */
  investmentCategories: InvestmentCategory;
  /** Indicates the last market day's close per/share price */
  lastClosePrice: Maybe<Scalars['Float']>;
  /** The Acorns-designated name of the ETF */
  name: Scalars['String'];
  /** Indicates the total worth of the ETF as a whole */
  netAssets: Maybe<Scalars['String']>;
  /** Indicates the day's open per/share price */
  openPrice: Maybe<Scalars['Float']>;
  /**
   * Indicates the number of shares the user owns
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  ownedShares: Maybe<Scalars['Float']>;
  /** Indicates the percent of every dollar that will go towards buying a share of the ETF */
  percent: Maybe<Scalars['Float']>;
  /** Get price values of the ETF over a time range */
  performance: EtfPerformance;
  /** Indicates the position of the ETF */
  position: Maybe<Scalars['Int']>;
  /** Indicates the per/share price range over the current week */
  priceRangeOverWeek: Maybe<Scalars['String']>;
  /** Indicates whether or not the ETF can be removed from a managed Portfolio by direction of an account holder. */
  removable: Maybe<Scalars['Boolean']>;
  /** The market exchange symbol of the ETF */
  symbol: Scalars['String'];
  /** Indicates the total number of shares in the market */
  volume: Maybe<Scalars['Int']>;
  /** Indicates the year-to-date return of the ETF */
  ytdReturn: Maybe<Scalars['Float']>;
  /** Indicates the year-to-date return percentage of the ETF */
  ytdReturnPercentage: Maybe<Scalars['Float']>;
};


/** DEPRECATED - Use Security type instead */
export type EtfPerformanceArgs = {
  points?: InputMaybe<Scalars['Int']>;
  timescale: EtfTimescale;
  timespan: Scalars['Int'];
};

/** Amount and Percentage of ETF Gain */
export type EtfGain = {
  __typename?: 'ETFGain';
  amount: Scalars['Float'];
  percentage: Scalars['Float'];
};

/** Gain and Prices of ETF */
export type EtfPerformance = {
  __typename?: 'ETFPerformance';
  gain: Maybe<EtfGain>;
  prices: Maybe<Array<EtfPrice>>;
};

/** Price of ETF */
export type EtfPrice = {
  __typename?: 'ETFPrice';
  amount: Scalars['Float'];
  timestamp: Scalars['DateTime'];
};

export enum EtfTimescale {
  day = 'day',
  month = 'month',
  week = 'week',
  year = 'year'
}

/** State Laws Regarding UGMA/UTMA account types and termination ages */
export type EarlyAccountStateRegulation = {
  __typename?: 'EarlyAccountStateRegulation';
  /** Whether UGMA/UTMA account is offered in the given state */
  accountType: EarlyInvestmentAccountType;
  /** Default age of termination for the given state */
  defaultAge: Scalars['Int'];
  /** Maximum age of termination for the given state */
  maxAge: Maybe<Scalars['Int']>;
  /** Minimum age of termination for the given state */
  minAge: Maybe<Scalars['Int']>;
  /** Full State/Territory name */
  state: Scalars['String'];
  /** State/Territory abbreviation */
  stateCode: Scalars['String'];
};

/** Result for Early Account state regulations */
export type EarlyAccountStateRegulationResult = EarlyAccountStateRegulation | InternalErrorException | InvalidStateException | UserNotFoundException;

/** DEPRECATED - Use InvestmentAccountTransferability instead */
export type EarlyAccountTransferInfo = {
  __typename?: 'EarlyAccountTransferInfo';
  /** The beneficiary investment account's state of residence */
  stateCode: Scalars['String'];
  /** The beneficiary investment account's age of transfer */
  terminationAge: Scalars['Int'];
  /** The beneficiary investment account's date of transfer */
  terminationDate: Scalars['Date'];
};

/** Sell shares to pay down cash owed by the customer. */
export type EarlyDebtCollectionItem = PastCoreTradedItem & PastItem & {
  __typename?: 'EarlyDebtCollectionItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type EarlyDividendsItem = PastCoreTradedItem & PastEarlyItem & PastItem & {
  __typename?: 'EarlyDividendsItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  etfCategory: Scalars['String'];
  etfTicker: Scalars['String'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Sell shares for the fee. */
export type EarlyFeeInvestmentItem = PastCoreTradedItem & PastEarlyItem & PastItem & {
  __typename?: 'EarlyFeeInvestmentItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A gift investment line item for the Early account */
export type EarlyGiftItem = PastAnnotatedItem & PastCoreTradedItem & PastEarlyItem & PastItem & {
  __typename?: 'EarlyGiftItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** Annotation on the item */
  note: Maybe<Scalars['String']>;
  /** Author of the note */
  noteAuthor: Maybe<Scalars['String']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type EarlyHistorySummary = PastSummary & {
  __typename?: 'EarlyHistorySummary';
  dividends: CurrencyAmount;
  earlyInvestMatches: CurrencyAmount;
  giftsReceived: CurrencyAmount;
  moneyIn: CurrencyAmount;
  moneyOut: CurrencyAmount;
};

export enum EarlyInvestmentAccountType {
  /** Uniform Gift to Minors Act Custodial Investment Account */
  UGMA = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  UTMA = 'UTMA'
}

/** A generic money movement line item for the Early account */
export type EarlyInvestmentItem = PastCoreTradedItem & PastEarlyItem & PastItem & PastUserTransferItem & {
  __typename?: 'EarlyInvestmentItem';
  amount: Maybe<CurrencyAmount>;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A matching investment made into a customers account by the firm. */
export type EarlyMatchItem = PastCoreTradedItem & PastEarlyItem & PastItem & {
  __typename?: 'EarlyMatchItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A removal of matching investments made into a customers account by the firm. */
export type EarlyMatchRemovalItem = PastCoreTradedItem & PastEarlyItem & PastItem & {
  __typename?: 'EarlyMatchRemovalItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Cash that is reinvested into the investment account */
export type EarlyRefundedItem = PastCoreTradedItem & PastEarlyItem & PastItem & {
  __typename?: 'EarlyRefundedItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Cash that is reinvested into the investment account */
export type EarlyReinvestmentItem = PastCoreTradedItem & PastEarlyItem & PastItem & {
  __typename?: 'EarlyReinvestmentItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type EarlyWithdrawalItem = PastCoreTradedItem & PastEarlyItem & PastItem & PastUserTransferItem & {
  __typename?: 'EarlyWithdrawalItem';
  amount: CurrencyAmount;
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type EarnCtaRecord = {
  __typename?: 'EarnCTARecord';
  ctaDates: Maybe<Array<Maybe<Scalars['Date']>>>;
  devicePlatform: Maybe<Scalars['String']>;
  partnerName: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type EarnMissingCreditRequest = {
  __typename?: 'EarnMissingCreditRequest';
  createdAt: Scalars['DateTime'];
  extensionMerchantName: Maybe<Scalars['String']>;
  merchantId: Scalars['ID'];
  method: EarnPurchaseMethod;
  orderNumber: Scalars['String'];
  proofOfPurchaseUrl: Scalars['URL'];
  purchaseDate: Scalars['Date'];
  subTotal: Scalars['Float'];
  total: Scalars['Float'];
  userId: Scalars['ID'];
};

export type EarnMissingCreditRequestPurchaseDateError = {
  __typename?: 'EarnMissingCreditRequestPurchaseDateError';
  maxDays: Scalars['Int'];
  minDays: Scalars['Int'];
};

export type EarnOffer = {
  __typename?: 'EarnOffer';
  /** The list of applicable categories for affiliates */
  affiliateCategoryList: Maybe<Array<Scalars['String']>>;
  /** Whether affiliateCategoryList is inclusionary or exclusionary */
  affiliateCategoryType: Maybe<Scalars['String']>;
  /** For use with colorBackgroundLogoImageUrl */
  backgroundColorHex: Scalars['String'];
  /** Non-logo background image */
  backgroundImageUrl: Scalars['URL'];
  /** Offer's Badge Category */
  badgeCategory: Maybe<BadgeCategory>;
  /** Long description of what is needed to qualify for offer */
  campaignDescription: Scalars['String'];
  /** ID associated with the Campaign */
  campaignId: Scalars['ID'];
  campaignOfferId: Scalars['ID'];
  /** Transparent logo used with backgroundColorHex overlaid on background */
  colorBackgroundLogoImageUrl: Scalars['URL'];
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL'];
  ctaDetails: EarnOfferCtaDetails;
  /** Offer's Deal Type */
  dealType: Maybe<DealType>;
  /** Desktop Background/featured image url */
  desktopBackgroundImageUrl: Maybe<Scalars['URL']>;
  /** Offer Details Information */
  details: Array<Scalars['String']>;
  /** List of device platforms the campaign offer is eligible for */
  devicePlatforms: Array<Scalars['String']>;
  /** The main campaign text used image overlay text */
  displayBody: Maybe<Scalars['String']>;
  /** The ending date of a campaign */
  displayEndDate: Maybe<Scalars['String']>;
  /** The main campaign name used on tiles and on details */
  displayName: Scalars['String'];
  /** The starting date of a campaign */
  displayStartDate: Maybe<Scalars['String']>;
  /** Summary of qualification, e.g. "For new customers only" */
  displaySubtitle: Maybe<Scalars['String']>;
  /** Display Title for the amount invested, e.g. "Earn 2%" or "Earn $10" */
  displayTitle: Scalars['String'];
  /** Offer Exclusion Information */
  exclusions: Array<Scalars['String']>;
  /** Denotes the favorite order rank by most recently added */
  favoriteRank: Scalars['Int'];
  /** Used for the banner on the categories page */
  featuredCategoryOffer: Scalars['Boolean'];
  /** Used for the banner on the categories page */
  featuredCategoryOfferRank: Scalars['Int'];
  /** The amount for the reward */
  incentiveAmount: Maybe<Scalars['Float']>;
  /** The reward amount rate */
  incentiveRate: Maybe<EarnOfferIncentiveRate>;
  /** Amount invested, e.g. "2%" or "$10" */
  incentiveSummary: Scalars['String'];
  /** The reward amount structure */
  incentiveType: Maybe<EarnOfferIncentiveType>;
  /** Denotes a favorite offer for the current user */
  isFavorite: Scalars['Boolean'];
  /** Offer's Keyphrase Categories Names */
  keyphraseCategoryNames: Maybe<Array<Scalars['String']>>;
  /** External merchantId associated with owner */
  merchantId: Maybe<Scalars['String']>;
  /** Description of the brand */
  ownerDescription: Scalars['String'];
  /** ID associated with the Owner */
  ownerId: Scalars['ID'];
  /** The name of the Owner */
  ownerName: Scalars['String'];
  /** Used for the banner on web */
  promoted: Scalars['Boolean'];
  /** Used for the banner on web */
  promotionRank: Scalars['Int'];
  /** Identifying slug on the owner level */
  slug: Scalars['String'];
  termsAndConditionsUrl: Scalars['String'];
  /** The ending time for a campaign */
  visibilityEndTime: Maybe<Scalars['String']>;
  /** The starting time for a campaign */
  visibilityStartTime: Maybe<Scalars['String']>;
  /** Manages how we launch offers on mobile */
  webviewEnabled: Scalars['Boolean'];
};

export type EarnOfferCtaDetails = {
  __typename?: 'EarnOfferCtaDetails';
  android: Maybe<Scalars['String']>;
  buttonUrl: Maybe<Scalars['String']>;
  chromeExt: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  internallyRouted: Scalars['Boolean'];
  ios: Maybe<Scalars['String']>;
  notificationTitle: Scalars['String'];
  notificationUrl: Scalars['URL'];
  repeatTitle: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  userMetadata: Maybe<Scalars['String']>;
  web: Maybe<Scalars['String']>;
};

export enum EarnOfferIncentiveRate {
  DYNAMIC = 'DYNAMIC',
  FLAT = 'FLAT'
}

export enum EarnOfferIncentiveTemplate {
  V1 = 'V1'
}

export enum EarnOfferIncentiveType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE'
}

export type EarnOfferQueryPage = {
  __typename?: 'EarnOfferQueryPage';
  earnOffers: Array<EarnOffer>;
  pageInfo: EarnPageInfo;
};

export type EarnOnboardingMilestoneCta = {
  __typename?: 'EarnOnboardingMilestoneCta';
  destination: EarnOnboardingMilestoneCtaType;
  title: Scalars['String'];
};

export enum EarnOnboardingMilestoneCtaType {
  DOWNLOAD_EXTENSION = 'DOWNLOAD_EXTENSION',
  LINK_CARD = 'LINK_CARD',
  SIMPLY_SPEND_OFFERS = 'SIMPLY_SPEND_OFFERS',
  TAP_AND_GET_OFFERS = 'TAP_AND_GET_OFFERS'
}

export type EarnPageInfo = {
  __typename?: 'EarnPageInfo';
  /** This value is passed back as the 'cursor' parameter to continue pagination. An empty string indicates there are no more pages to fetch. */
  endCursor: Scalars['String'];
};

export enum EarnPurchaseMethod {
  ANDROID = 'ANDROID',
  CHROME_EXTENSION = 'CHROME_EXTENSION',
  EARN_REWARD_EMAIL = 'EARN_REWARD_EMAIL',
  IN_STORE = 'IN_STORE',
  IPHONE = 'IPHONE',
  SAFARI_EXTENSION = 'SAFARI_EXTENSION',
  WEB_APP = 'WEB_APP'
}

export type EarnReward = {
  __typename?: 'EarnReward';
  amount: MonetaryAmount;
  colorBackgroundLogoImageUrl: Scalars['URL'];
  displayName: Scalars['String'];
  expectedFulfilledAt: Maybe<Scalars['Date']>;
  fulfilledAt: Maybe<Scalars['Date']>;
  fulfillmentType: EarnRewardFulfillmentType;
  id: Scalars['ID'];
  incentiveAmount: Maybe<Scalars['Float']>;
  investmentId: Maybe<Scalars['ID']>;
  linked: Maybe<Array<EarnReward>>;
  /** The purchase or event date associated with the reward */
  originationDate: Scalars['Date'];
  status: Maybe<EarnRewardStatus>;
  type: EarnRewardType;
};

export enum EarnRewardFulfillmentType {
  STANDARD = 'STANDARD',
  TRAVEL = 'TRAVEL'
}

export enum EarnRewardInvestType {
  EARN_REWARD = 'EARN_REWARD',
  EARN_REWARD_MATCH = 'EARN_REWARD_MATCH',
  EARN_ROUND_UP_MATCH = 'EARN_ROUND_UP_MATCH',
  EMPLOYEE_CONTRIBUTION = 'EMPLOYEE_CONTRIBUTION',
  REFERRAL = 'REFERRAL'
}

export enum EarnRewardStatus {
  FULFILLED = 'FULFILLED',
  PENDING = 'PENDING'
}

export enum EarnRewardType {
  EMPLOYEE_BENEFIT = 'EMPLOYEE_BENEFIT',
  REFERRAL = 'REFERRAL',
  REWARD = 'REWARD',
  REWARD_MATCH = 'REWARD_MATCH',
  ROUNDUP_MATCH = 'ROUNDUP_MATCH'
}

export type Ecbsv = {
  __typename?: 'Ecbsv';
  /** Flag indicating whether eCBSV can be used or not for verification */
  consent: Scalars['Boolean'];
  /** UTC timestamp when customer provided eCBSV response */
  providedAt: Maybe<Scalars['DateTime']>;
};

export type EducationTip = {
  __typename?: 'EducationTip';
  /** key that maps to client-defined education tip details */
  detailsKey: Scalars['StringKey'];
  /** key that maps to client-defined education tip summary */
  summaryKey: Scalars['StringKey'];
};

export type Eligibility = {
  __typename?: 'Eligibility';
  eligible: Scalars['Boolean'];
};

export enum EligibilityScope {
  fundSpendInActivation = 'fundSpendInActivation',
  mrdc = 'mrdc',
  roundUps = 'roundUps',
  sendCheck = 'sendCheck',
  spend = 'spend',
  spendRecurringTransfers = 'spendRecurringTransfers'
}

export type EmailAddressValidation = {
  __typename?: 'EmailAddressValidation';
  /** Wether or not credentials are associated with the address or not. */
  credentialsExist: Scalars['Boolean'];
  /** Soft check indicating wether or not a DNS MX record exists for the address domain (does not validate that an email can actually be delivered to the email server). */
  deliverable: Scalars['Boolean'];
  /** The email that is being validated */
  email: Scalars['EmailAddress'];
  /** Indicates if the email credential is enabled for use. */
  nativeCredentialsEnabled: Maybe<Scalars['Boolean']>;
  /** Indicates if the email is associated with an OIDC provider. */
  oidcAssociated: Maybe<Scalars['Boolean']>;
  /** List of OIDC providers the email is associated with. */
  oidcProviders: Maybe<Array<Maybe<OidcProvider>>>;
  /** Indicates wether the address may have common spelling mistakes. */
  possibleTypo: Scalars['Boolean'];
  /** Suggestion for corrected address if there was a typo detected. */
  suggestion: Maybe<Scalars['EmailAddress']>;
};

export type EmailAuthChallenge = AuthChallenge & {
  __typename?: 'EmailAuthChallenge';
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  maskedEmail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EmailAuthenticator = Authenticator & {
  __typename?: 'EmailAuthenticator';
  createdAt: Scalars['DateTime'];
  deviceId: Scalars['ID'];
  email: Scalars['EmailAddress'];
  id: Scalars['ID'];
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>;
  lastUsedAt: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: AuthType;
  updatedAt: Scalars['DateTime'];
};

export type EmailRedirect = {
  __typename?: 'EmailRedirect';
  title: Scalars['String'];
};

export type EmailTakenException = {
  __typename?: 'EmailTakenException';
  message: Maybe<Scalars['String']>;
};

export type EmergencyFundHistorySummary = PastSummary & {
  __typename?: 'EmergencyFundHistorySummary';
  interestEarned: Maybe<CurrencyAmount>;
  moneyIn: CurrencyAmount;
  moneyOut: CurrencyAmount;
};

export enum Employees {
  /** User has full or part time employees under their company */
  fullOrPart = 'fullOrPart',
  /** User has no employees under their company */
  none = 'none'
}

/** Employer */
export type Employer = {
  __typename?: 'Employer';
  /**
   * Clickswitch Target ID
   * @deprecated Use SwitchInterface.vendorTargetId instead
   */
  clickSwitchTargetId: Maybe<Scalars['ID']>;
  /** DUNS Name */
  dunsName: Maybe<Scalars['String']>;
  /** Duns Number */
  dunsNumber: Maybe<Scalars['ID']>;
  /** Employer Name */
  employerName: Scalars['String'];
  /** Employer ID */
  id: Scalars['ID'];
  /** Employer Logo URL */
  logoUrl: Maybe<Scalars['String']>;
  /** Switch Type specific information. */
  switch: AbstractSwitch;
  /** Switch Type */
  switchType: SwitchType;
  /**
   * Employer URL
   * @deprecated Use OnlineSwitch.url instead
   */
  url: Maybe<Scalars['String']>;
};

export type EmploymentInput = {
  employer?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  suitability?: InputMaybe<Array<InputMaybe<SuitabilityInput>>>;
};

export enum EmploymentStatus {
  /** User is a full time employee or contractor */
  fullTime = 'fullTime',
  /** User is a part time employee or contractor */
  partTime = 'partTime',
  /** User is retired and does not work */
  retired = 'retired',
  /** User owns their own business or is self employed */
  selfEmployed = 'selfEmployed',
  /** User is enrolled full time in school */
  student = 'student',
  /** User currently is not employed */
  unemployed = 'unemployed'
}

/** Configuration for investment account quarterly recaps. */
export type EnableQuarterlyRecapsInput = {
  /** Wether or not to enable quarterly recaps. */
  enabled: Scalars['Boolean'];
  /** The unique identifier of the investment account for which to configure quarterly recaps. */
  investmentAccountId: Scalars['ID'];
};

/** Result of configuring investment account recaps. */
export type EnableQuarterlyRecapsResult = InvalidSubscriptionTierException | InvestmentAccount | InvestmentAccountNotFoundException | InvestmentAccountNotSupportedException;

export type EstimatedCheckPaymentDates = {
  __typename?: 'EstimatedCheckPaymentDates';
  estimatedArrivalAt: Scalars['DateTime'];
  estimatedShippingAt: Scalars['DateTime'];
  estimatedTransferAtText: Scalars['String'];
};

/** Input to get estimated dates for a transfer */
export type EstimatedTransferDatesInput = {
  /** Amount of the transfer which will be created. */
  amount?: InputMaybe<CurrencyAmountInput>;
  /** Type of account to move money from */
  fromAccountType: TransferableAccountTypeEnum;
  /** Type of account to move money into */
  toAccountType: TransferableAccountTypeEnum;
  /** UTC datetime when the transfer was/will be created. If omitted, the current datetime will be used */
  transferCreatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Estimated dates for a transfer */
export type EstimatedTransferDatesPayload = {
  __typename?: 'EstimatedTransferDatesPayload';
  /** Estimated UTC datetime when the transfer will be completed by */
  estimatedTransferCompletedAt: Scalars['DateTime'];
};

/** Evaluates check deposit session to determine if it is submittable. */
export type EvaluateCheckDepositInput = {
  amount: CurrencyAmountInput;
  /** The session to evaluate. */
  sessionToken: Scalars['String'];
};

/** Evaluates if a check can be submitted. */
export type EvaluateCheckDepositPayload = {
  __typename?: 'EvaluateCheckDepositPayload';
  /** Recognized amount from check image. */
  ocrAmount: CurrencyAmount;
  riskFactors: Array<DepositRiskFactor>;
};

export type ExchangeAcornsEarlyTokenResult = AcornsEarlyUserDetails | InvalidAcornsEarlyTokenException;

export type ExecuteMoneyInError = {
  __typename?: 'ExecuteMoneyInError';
  message: Scalars['String'];
};

export type ExecuteMoneyInInput = {
  moneyInEvent: MoneyInEventInput;
};

export type ExecuteMoneyInResult = ExecuteMoneyInError | ExecuteMoneyInSuccess;

export type ExecuteMoneyInSuccess = {
  __typename?: 'ExecuteMoneyInSuccess';
  workflowId: Scalars['ID'];
};

/** Mirrors the MoneyManagerRebalanceResult type */
export type ExecuteMoneyManagerRebalancesInput = {
  allocations: Array<MoneyManagerRebalanceAllocationInput>;
  ruleset: MoneyManagerRebalanceRulesetInput;
  sourceAccountId: Scalars['ID'];
  sourceAccountType: MoneyManagerRebalanceSourceAccountType;
  sourceAmount: MoneyRulesCurrencyAmountInput;
};

export type ExecuteMoneyManagerRebalancesResult = ExecuteMoneyManagerRebalancesSuccess | RebalanceAlreadyExecutedError | RebalanceSourceInsufficientBalanceError;

export type ExecuteMoneyManagerRebalancesSuccess = {
  __typename?: 'ExecuteMoneyManagerRebalancesSuccess';
  assignment: MoneyManagerRebalanceAssignment;
};

/** Execution Audit */
export type ExecutionAudit = TimestampsInterface & {
  __typename?: 'ExecutionAudit';
  billingCycleId: Scalars['ID'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  decisionName: Scalars['String'];
  id: Scalars['ID'];
  result: Maybe<Scalars['String']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export type ExistingEmailVerifiedException = {
  __typename?: 'ExistingEmailVerifiedException';
  message: Maybe<Scalars['String']>;
};

/** A reopen request for this investment account already exists and is pending review */
export type ExistingRequestPendingReview = {
  __typename?: 'ExistingRequestPendingReview';
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest;
};

/** A reopen request for this investment account already exists and is pending user action */
export type ExistingRequestPendingUserAction = {
  __typename?: 'ExistingRequestPendingUserAction';
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest;
};

/** The content that supports and drives the user experience */
export type ExperienceContent = {
  __typename?: 'ExperienceContent';
  /** Campaign ID for the referrer's active campaign */
  campaignId: Maybe<Scalars['ID']>;
  pillAmount: Maybe<Scalars['String']>;
  /** JSON Content for rendering the referrer experience */
  rawContent: Maybe<Scalars['String']>;
  /** Referrer's link to refer new friends */
  shareableLink: Maybe<Scalars['String']>;
};

export type ExpirePromotionalWaiverInput = {
  promotion: WaiverPromotion_V2;
};

export type ExpirePromotionalWaiverResult = InvalidUserIdException | PromotionalWaiver_V2 | WaiverDeletionException;

/** Individual accounts opened by a user at Acorns */
export type ExternalMetadata = {
  __typename?: 'ExternalMetadata';
  /** Flag indicating if user is active customer in external source */
  isSubscriptionActive: Scalars['Boolean'];
  /** External subscription type */
  membership: Maybe<ExternalSubscriptionType>;
};

export enum ExternalSource {
  direct_bank = 'direct_bank',
  manual = 'manual',
  paypal = 'paypal',
  plaid = 'plaid',
  spend = 'spend'
}

export enum ExternalSubscriptionType {
  /** Legacy highest tier */
  LEGACY_PREMIUM = 'LEGACY_PREMIUM',
  /** Highest tier */
  PREMIUM = 'PREMIUM'
}

export enum ExternalUserSource {
  USER_EXTERNAL_SOURCE_GO_HENRY = 'USER_EXTERNAL_SOURCE_GO_HENRY',
  USER_EXTERNAL_SOURCE_INVALID = 'USER_EXTERNAL_SOURCE_INVALID'
}

export type ExtoleCampaignHistoryConnection = {
  __typename?: 'ExtoleCampaignHistoryConnection';
  edges: Maybe<Array<ExtoleCampaignHistoryEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type ExtoleCampaignHistoryEdge = {
  __typename?: 'ExtoleCampaignHistoryEdge';
  cursor: Scalars['String'];
  hurdleMet: Maybe<Scalars['Boolean']>;
  node: ExtoleReferralCampaign;
};

export type ExtoleReferralCampaign = {
  __typename?: 'ExtoleReferralCampaign';
  advocateRewardAmount: Scalars['Float'];
  eligibilityEnd: Scalars['DateTime'];
  friendRewardAmount: Scalars['Float'];
  hurdle: Scalars['Int'];
  id: Scalars['ID'];
  publishEnd: Scalars['DateTime'];
  publishStart: Scalars['DateTime'];
  status: PublishedCampaignStatus;
  title: Scalars['String'];
};

export type ExtoleReferralHistory = {
  __typename?: 'ExtoleReferralHistory';
  extoleFriendHistory: Maybe<FriendHistoryConnection>;
  userId: Maybe<Scalars['ID']>;
};


export type ExtoleReferralHistoryExtoleFriendHistoryArgs = {
  extoleCampaignId?: InputMaybe<Scalars['ID']>;
  filter: ReferralPaginatedFilter;
};

export type FailVendorInvoiceResult = BillingVendorError | Invoice;

export type FavoritePartnerOfferGroup = {
  __typename?: 'FavoritePartnerOfferGroup';
  /** list of offers in the favorite group */
  offers: Array<PartnerOfferGroupItem>;
};

/** Used to customize favorite offer group contents */
export type FavoritePartnerOfferInput = {
  ids: Array<Scalars['String']>;
};

export type FeaturedLearnContentPreview = LearnArticlePreview | LearnMediaPreview;

export type FeaturedMilestones = {
  __typename?: 'FeaturedMilestones';
  /** list of featured milestones to show on widget */
  milestones: Array<Milestone>;
};

export type FeaturedMilestonesV2 = AccountSetupMilestones | FeaturedMilestones;

/** Fee information */
export type Fee = TimestampsInterface & {
  __typename?: 'Fee';
  accountId: Maybe<Scalars['ID']>;
  amount: Scalars['Float'];
  amountCollected: Scalars['Float'];
  assessedAt: Maybe<Scalars['String']>;
  balance: Maybe<Scalars['Float']>;
  billingCycle: BillingCycle;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  discount: Maybe<Scalars['Float']>;
  discountedAmount: Maybe<Scalars['Float']>;
  feeCategoryId: Scalars['String'];
  feeExecutions: Array<Maybe<FeeExecution>>;
  feeType: FeeType;
  id: Scalars['ID'];
  state: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  userId: Maybe<Scalars['ID']>;
};

/** Fee execution information */
export type FeeExecution = TimestampsInterface & {
  __typename?: 'FeeExecution';
  accountType: Maybe<Scalars['String']>;
  amountCollected: Scalars['Float'];
  amountRequested: Scalars['Float'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  executionMethod: Scalars['String'];
  externalId: Maybe<Scalars['ID']>;
  fundingAccountId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  reason: Maybe<Scalars['String']>;
  sourceId: Maybe<Scalars['ID']>;
  state: Maybe<Scalars['String']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export enum FeeExecutionMethod {
  /** Executed fee by direct ACH */
  DIRECT = 'DIRECT',
  /** Executed fee by selling shares */
  LIQUIDATE_SECURITIES = 'LIQUIDATE_SECURITIES',
  /** Pre-emptively failed execution due to a known failure reason */
  PREEMPTIVE_FAILURE = 'PREEMPTIVE_FAILURE',
  /** Skipped fee execution */
  SKIP = 'SKIP',
  /** Executed by direct ACH from Spend funding source */
  SPEND_DIRECT = 'SPEND_DIRECT',
  /** Waived fee execution */
  WAIVE = 'WAIVE'
}

export type FeeNegotiation = {
  __typename?: 'FeeNegotiation';
  connection: Maybe<BankConnection>;
  created: Maybe<Scalars['DateTime']>;
  displayStatus: Maybe<Scalars['String']>;
  feeSynopsis: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalStatus: Maybe<BankFeeNegotiationInternalStatus>;
  negotiatedAmount: Maybe<MonetaryAmount>;
  refundAmount: Maybe<MonetaryAmount>;
  status: Maybe<BankFeeNegotiationExternalStatus>;
  updated: Maybe<Scalars['DateTime']>;
};

export type FeeNegotiationSummary = {
  __typename?: 'FeeNegotiationSummary';
  negotiations: Maybe<Array<FeeNegotiation>>;
  totalRefundedFees: Maybe<MonetaryAmount>;
};

export enum FeeStatus {
  NEGOTIABLE = 'NEGOTIABLE',
  NEGOTIATED = 'NEGOTIATED',
  PROCESSING = 'PROCESSING',
  UNNEGOTIABLE = 'UNNEGOTIABLE'
}

export enum FeeStatusFilter {
  NEGOTIABLE = 'NEGOTIABLE',
  NEGOTIATED = 'NEGOTIATED',
  PROCESSING = 'PROCESSING',
  UNNEGOTIABLE = 'UNNEGOTIABLE'
}

export type FeeStatusSummary = {
  __typename?: 'FeeStatusSummary';
  negotiable: Scalars['Int'];
  negotiated: Scalars['Int'];
  processing: Scalars['Int'];
  total: Scalars['Int'];
  unnegotiable: Scalars['Int'];
};

export enum FeeType {
  /** ADVISORY fee */
  ADVISORY = 'ADVISORY',
  /** SUBSCRIPTION fee */
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export enum FeedContext {
  /** a4 banking hub */
  a4_banking_hub = 'a4_banking_hub',
  /** a4 checking engagement wizard */
  a4_checking_engagement_wizard = 'a4_checking_engagement_wizard',
  /** a4 checking hub */
  a4_checking_hub = 'a4_checking_hub',
  /** a4 early */
  a4_early = 'a4_early',
  /** a4 early details */
  a4_early_details = 'a4_early_details',
  /** a4 home/present */
  a4_home = 'a4_home',
  /** a4 home bottom nav */
  a4_home_bottom_nav = 'a4_home_bottom_nav',
  /** a4 invest */
  a4_invest = 'a4_invest',
  /** invest hub */
  a4_invest_hub = 'a4_invest_hub',
  /** a4 kids */
  a4_kids = 'a4_kids',
  /** a4 later */
  a4_later = 'a4_later',
  /** a4 learn hub */
  a4_learn_hub = 'a4_learn_hub',
  /** a4 savings */
  a4_savings = 'a4_savings',
  /** a4 spend */
  a4_spend = 'a4_spend'
}

export type File = {
  __typename?: 'File';
  documentRequestId: Scalars['ID'];
  encoding: Scalars['String'];
  filename: Scalars['String'];
  mimetype: Scalars['String'];
  url: Scalars['URL'];
};

/** The file does not exist */
export type FileDoesNotExistError = {
  __typename?: 'FileDoesNotExistError';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The upload uuid */
  uploadUuid: Maybe<Scalars['ID']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** The file does not exist in s3 */
export type FileDoesNotExistInS3 = {
  __typename?: 'FileDoesNotExistInS3';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type FileOrException = File | FileSizeError | UploadFailedError;

export type FileSizeError = {
  __typename?: 'FileSizeError';
  message: Scalars['String'];
};

/** The file uploaded exceeds the max allowed byte size */
export type FileTooLarge = {
  __typename?: 'FileTooLarge';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export enum FilingType {
  /** User files taxes with their spouse */
  joint = 'joint',
  /** User files taxes living with spouse part of the year */
  separatePartYear = 'separatePartYear',
  /** User files taxes living apart from spouse all year */
  separateWholeYear = 'separateWholeYear'
}

export type FinancialAdvisorQuestionResponse = {
  __typename?: 'FinancialAdvisorQuestionResponse';
  interactionId: Scalars['String'];
  message: Scalars['String'];
};

export type FinancialAdvisorQuestionsResponse = {
  __typename?: 'FinancialAdvisorQuestionsResponse';
  message: Scalars['String'];
};

export enum FinancialEducation {
  /** User has little to no experience with financial education */
  BEGINNER = 'BEGINNER',
  /** User has a lot of experience with financial education */
  EXPERT = 'EXPERT',
  /** User has some experience with financial education */
  MODERATE = 'MODERATE'
}

export type FinancialGoalsInput = {
  age: Scalars['Int'];
  annualIncome: Scalars['Int'];
  contributionFrequency: Scalars['String'];
  employmentStatus: Scalars['String'];
  spendPercent: Scalars['Float'];
  state: Scalars['String'];
  strategy: Scalars['String'];
};

export type FinancialGoalsResult = {
  __typename?: 'FinancialGoalsResult';
  age: Array<Scalars['Int']>;
  balance: Array<Scalars['Float']>;
  cumulativeContributions: Array<Scalars['Float']>;
  totalContributions: Array<Scalars['Float']>;
};

/** Miscellaneous attributes about a Financial Institution */
export type FinancialInstitution = TimestampsInterface & {
  __typename?: 'FinancialInstitution';
  /** Is this Financial Institution blacklisted within Acorns */
  blacklisted: Scalars['Boolean'];
  /** Inorganic ordering for Financial Institutions */
  boost: Scalars['Int'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Is this Financial Institution removed from Plaid's list */
  deleted: Scalars['Boolean'];
  /** Is this Financial Institution a Direct Bank type */
  directBank: Scalars['Boolean'];
  /** Plaid Financial Institution ID */
  externalId: Scalars['String'];
  /** Does this Financial Institution have multi-factor authentication? */
  hasMfa: Scalars['Boolean'];
  /** Internal Acorns UUID representing Financial Institution */
  id: Scalars['ID'];
  /** The link provider type of the financial institution */
  linkProviderType: Maybe<LinkProviderType>;
  /** Location of logo for a Financial Institution */
  logoUrl: Scalars['String'];
  /** Name of Financial Institution */
  name: Scalars['String'];
  /** URL for signing in with Direct Bank Integration */
  oauthUrl: Maybe<Scalars['String']>;
  /** Plaid products this Financial Institution supports */
  products: Array<Scalars['String']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** URL of the Financial Institution */
  url: Maybe<Scalars['String']>;
};

/** An individual edge within the paginated list of FinancialInstitutionType */
export type FinancialInstitutionTypeEdge = {
  __typename?: 'FinancialInstitutionTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID'];
  /** The FinancialInstitutionType record in the edge */
  node: FinancialInstitution;
};

/** Relay style pagination information for FinancialInstitutionType */
export type FinancialInstitutionTypePagination = {
  __typename?: 'FinancialInstitutionTypePagination';
  edges: Array<FinancialInstitutionTypeEdge>;
  pageInfo: PageInfo;
};

export type FinishSetup = {
  __typename?: 'FinishSetup';
  eyebrow: Scalars['String'];
  tips: Array<SetUpTip>;
};

export type FooterContent = {
  __typename?: 'FooterContent';
  acornsLogoAsset: Scalars['String'];
  disclosures: Scalars['String'];
  linkColumn1Header: Scalars['String'];
  linkColumn2Header: Scalars['String'];
  linkColumn3Header: Scalars['String'];
  mainCTAText: Scalars['String'];
  mainCTAUrl: Scalars['String'];
  mainHeadline: Scalars['String'];
};

export enum FormType {
  form1099 = 'form1099',
  form1099BDIV = 'form1099BDIV',
  form1099MISC = 'form1099MISC',
  form1099R = 'form1099R',
  form1099R1 = 'form1099R1',
  form1099R2 = 'form1099R2',
  form1099R4 = 'form1099R4',
  form1099R7 = 'form1099R7',
  form1099R8 = 'form1099R8',
  form1099RE = 'form1099RE',
  form1099RJ = 'form1099RJ',
  form1099RQ = 'form1099RQ',
  form1099RT = 'form1099RT',
  form5498 = 'form5498',
  other = 'other'
}

export type FormattedMonetaryAmount = {
  __typename?: 'FormattedMonetaryAmount';
  currency: Currency;
  value: Scalars['String'];
};

export type FoundMoneyCampaignOfferV2 = {
  __typename?: 'FoundMoneyCampaignOfferV2';
  id: Scalars['ID'];
  incentiveSummary: Scalars['String'];
};

export type FoundMoneyCampaignV2 = {
  __typename?: 'FoundMoneyCampaignV2';
  backgroundColorHex: Scalars['String'];
  backgroundImageUrl: Scalars['URL'];
  cohortSlug: Scalars['String'];
  colorBackgroundLogoImageUrl: Maybe<Scalars['URL']>;
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  imageUrl: Scalars['URL'];
  offers: Array<FoundMoneyCampaignOfferV2>;
  ownerId: Scalars['ID'];
};

export type FoundMoneyReward = {
  __typename?: 'FoundMoneyReward';
  /** @deprecated Field is deprecated, use colorBackgroundLogoImageUrl instead */
  campaignOwnerImageUrl: Maybe<Scalars['URL']>;
  campaignOwnerName: Maybe<Scalars['String']>;
  categoryIcon: Maybe<Scalars['String']>;
  colorBackgroundLogoImageUrl: Maybe<Scalars['URL']>;
  daysFulfilledWithin: Maybe<Scalars['Int']>;
  dollarValue: Maybe<MonetaryAmount>;
  fulfillmentDate: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFoundMoneyPlus: Maybe<Scalars['Boolean']>;
  originationDate: Maybe<Scalars['String']>;
  originationType: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};

export type FoundMoneySummary = {
  __typename?: 'FoundMoneySummary';
  totalFulfilledRewardsDollarValue: Maybe<MonetaryAmount>;
  totalMatchedDollarValue: Maybe<MonetaryAmount>;
  totalPendingRewardsDollarValue: Maybe<MonetaryAmount>;
  totalRewardsDollarValue: Maybe<MonetaryAmount>;
};

/** A user who was referred by an existing Acorns User */
export type Friend = {
  __typename?: 'Friend';
  /** The first name of the referred user's advocate */
  advocateFirstName: Maybe<Scalars['String']>;
  /** The last name of the referred user's advocate */
  advocateLastName: Maybe<Scalars['String']>;
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive: Maybe<Scalars['String']>;
  /**
   * If the Friend object resolved via the Advocate query, advocateUserId
   * corresponds to the argument passed in at the root level.
   * If Friend object resolved via the Friend query, advocateUserId is the
   * first advocate that is returned by Extole.
   */
  advocateUserId: Maybe<Scalars['ID']>;
  /** A list of all campaigns that the friend is participating in */
  campaigns: Maybe<Array<ReferralCampaign>>;
  email: Scalars['String'];
  friendExperienceContent: Maybe<FriendExperienceContent>;
  name: Maybe<Scalars['String']>;
  /** Status based on activity of friend */
  status: Maybe<FriendStatus>;
  userId: Maybe<Scalars['ID']>;
};

/** The content that supports user experience */
export type FriendExperienceContent = {
  __typename?: 'FriendExperienceContent';
  /** The first name of the referred user's advocate */
  advocateFirstName: Maybe<Scalars['String']>;
  /** The last name of the referred user's advocate */
  advocateLastName: Maybe<Scalars['String']>;
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive: Maybe<Scalars['String']>;
};

/** A summary of information around a referred user */
export type FriendHistory = {
  __typename?: 'FriendHistory';
  /** User ID of the Advocate user */
  advocateUserId: Maybe<Scalars['ID']>;
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID'];
  /** When the friend account was created */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The first name of the advocate's friend */
  friendFirstName: Maybe<Scalars['String']>;
  /** The last name of the advocate's friend */
  friendLastName: Maybe<Scalars['String']>;
  /** High level status indicating referred user reward status */
  status: Maybe<FriendStatusV2>;
  /** User ID of the referred user */
  userId: Scalars['ID'];
};

export type FriendHistoryConnection = {
  __typename?: 'FriendHistoryConnection';
  edges: Maybe<Array<FriendHistoryEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type FriendHistoryEdge = {
  __typename?: 'FriendHistoryEdge';
  cursor: Scalars['String'];
  node: FriendHistory;
};

/** Status of friend */
export enum FriendStatus {
  /** Friend has finished required steps to qualify for reward */
  COMPLETE = 'COMPLETE',
  /** Friend did not complete required steps in allotted time frame */
  EXPIRED = 'EXPIRED',
  /** Reward has been given to Friend/Advocate */
  FULFILLED = 'FULFILLED',
  /** Friend has registered */
  PENDING = 'PENDING',
  /** Advocate sent invite but user has not completed any steps */
  SENT = 'SENT'
}

/** Status of friend */
export enum FriendStatusV2 {
  /** Friend has finished required steps to qualify for reward */
  COMPLETE = 'COMPLETE',
  /** Friend has invested */
  CONFIRMING_ELIGIBILITY = 'CONFIRMING_ELIGIBILITY',
  /** Friend is ineligible for reward */
  INELIGIBLE = 'INELIGIBLE',
  /** Friend has signed up or created first investment */
  IN_PROGRESS = 'IN_PROGRESS'
}

export type FriendSummary = {
  __typename?: 'FriendSummary';
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID'];
  /** First name of the referred user */
  name: Maybe<Scalars['String']>;
  /** High level status indicating referred user reward status */
  status: Maybe<FriendStatus>;
  userId: Scalars['ID'];
};

export type FriendV2Output = {
  __typename?: 'FriendV2Output';
  advocate: Maybe<AdvocateV2>;
  campaign: Maybe<CampaignV2>;
  userId: Maybe<Scalars['ID']>;
};

export type Fund = Security & {
  __typename?: 'Fund';
  currentPrice: BigCurrencyAmount;
  displayName: Scalars['String'];
  earliestPriceDate: Scalars['Date'];
  headlines: Array<SecurityHeadline>;
  id: Scalars['ID'];
  lastClosePrice: BigCurrencyAmount;
  lastUpdatedAt: Scalars['DateTime'];
  longName: Scalars['String'];
  marketCap: Scalars['BigDecimal'];
  numberOfHoldings: Scalars['Int'];
  openPrice: BigCurrencyAmount;
  profile: SecurityProfile;
  /** @deprecated Use `Security.headlines` instead. */
  securityHeadlines: Array<SecurityHeadline>;
  /** @deprecated Use `Security.profile` instead. */
  securityProfile: SecurityProfile;
  shortName: Scalars['String'];
  symbol: Scalars['TickerSymbol'];
  topHoldings: Array<TopHolding>;
  type: SecurityType;
  volume: Scalars['BigDecimal'];
  week52High: BigCurrencyAmount;
  week52Low: BigCurrencyAmount;
};

/** Boolean indicating if the user can fund spend in activation */
export type FundSpendInActivationPayload = {
  __typename?: 'FundSpendInActivationPayload';
  /** Boolean indicating if the user can fund spend in activation */
  eligible: Scalars['Boolean'];
};

/** A Funding Source for the acorns user */
export type FundingSource = {
  __typename?: 'FundingSource';
  alert: Maybe<Scalars['JSON']>;
  /** The type of the funding source. */
  fundingType: Scalars['String'];
  /** The bank icon of the funding source */
  icon: Maybe<Scalars['URL']>;
  last4: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rdvSettledAt: Maybe<Scalars['DateTime']>;
  rdvTriggeredAt: Maybe<Scalars['DateTime']>;
  /** Deprecated - use fundType instead. */
  type: Scalars['String'];
  verificationStatus: Scalars['Int'];
  verified: Maybe<Scalars['Boolean']>;
};

/** A Funding Source for the acorns user */
export type FundingSourceAccount = TimestampsInterface & {
  __typename?: 'FundingSourceAccount';
  accountName: Scalars['String'];
  alert: Maybe<Scalars['JSON']>;
  balance: Maybe<Scalars['Float']>;
  bankRoutingNumber: Maybe<Scalars['String']>;
  canCancel: Scalars['Boolean'];
  canRetriggerRdv: Scalars['Boolean'];
  canTriggerRdv: Scalars['Boolean'];
  /** Indicates whether the user is allowed to verify RDV */
  canVerifyRdv: Maybe<Scalars['Boolean']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  frozen: Scalars['Boolean'];
  /** The type of the funding source. */
  fundType: FundingSourceType;
  /** The bank icon of the funding source */
  icon: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  institutionId: Maybe<Scalars['String']>;
  institutionName: Scalars['String'];
  insufficientFunds: Maybe<Scalars['Boolean']>;
  last4: Maybe<Scalars['String']>;
  linked: Scalars['Boolean'];
  linkedSubaccountId: Maybe<Scalars['ID']>;
  /** The logo url from Linked Accounts Service */
  logoUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Identifies whether the user has indicated that they prefer to withdraw funds to this account. */
  preferredWithdrawalAccount: Scalars['Boolean'];
  rdvSettledAt: Maybe<Scalars['DateTime']>;
  rdvTriggeredAt: Maybe<Scalars['DateTime']>;
  /** The role of the funding source. */
  role: Maybe<FundingSourceRoleEnum>;
  /** The status of the funding source. */
  status: FundingSourceStatus;
  transfersApproved: Scalars['Boolean'];
  /** Deprecated - use fundType instead. */
  type: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  uuid: Maybe<Scalars['ID']>;
  verificationStatus: Scalars['Int'];
  verified: Maybe<Scalars['Boolean']>;
};

/** Funding Source with account and routing already exists for user */
export type FundingSourceAlreadyExists = {
  __typename?: 'FundingSourceAlreadyExists';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** Account credentials linked by too many users */
export type FundingSourceCredentialsExceedLinkLimit = {
  __typename?: 'FundingSourceCredentialsExceedLinkLimit';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type FundingSourceInfo = {
  __typename?: 'FundingSourceInfo';
  accountNumberLastFour: Maybe<Scalars['String']>;
  alert: Maybe<Scalars['JSON']>;
  balance: Maybe<Scalars['Float']>;
  /** @deprecated Will move in the future */
  canChange: Scalars['Boolean'];
  /** @deprecated Will move in the future */
  changeRequiresApproval: Scalars['Boolean'];
  icon: Maybe<Scalars['URL']>;
  linkedSubaccountId: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  rdvSettledAt: Maybe<Scalars['DateTime']>;
  rdvTriggeredAt: Maybe<Scalars['DateTime']>;
  type: Maybe<FundingSourceType>;
  verificationStatus: Maybe<Scalars['Int']>;
  verified: Maybe<Scalars['Boolean']>;
};

/** The user needs to verify their RDVs to close their early account */
export type FundingSourceRequiresRdvException = {
  __typename?: 'FundingSourceRequiresRdvException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export enum FundingSourceRoleEnum {
  /** The subaccount is the primary funding source of the user */
  primaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  secondaryFunding = 'secondaryFunding'
}

export enum FundingSourceStatus {
  /** Documents have been requested to verify the funding source. */
  docsRequired = 'docsRequired',
  /** RDV verification attempts exhausted. */
  frozen = 'frozen',
  /** Funding Source is waiting on RDV triggers. */
  pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  rdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  rdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  success = 'success',
  /** Awaiting admin approval. No user action is required. */
  unapproved = 'unapproved'
}

export enum FundingSourceStatusEnum {
  /** Documents have been requested to verify the funding source. */
  docsRequired = 'docsRequired',
  /** RDV verification attempts exhausted. */
  frozen = 'frozen',
  /** Funding Source is waiting on RDV triggers. */
  pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  rdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  rdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  success = 'success',
  /** Awaiting admin approval. No user action is required. */
  unapproved = 'unapproved'
}

export enum FundingSourceType {
  ach = 'ach',
  paypal = 'paypal',
  spend = 'spend'
}

export enum FundsAvailability {
  /** User wants easy access to cash in an emergency */
  emergency = 'emergency',
  /** User is planning to save and not withdraw until retirement */
  retirement = 'retirement'
}

export enum Funnel {
  /** Core funnel */
  core = 'core',
  /** Direct to mobile funnel */
  direct_to_mobile = 'direct_to_mobile',
  /** Early funnel */
  early = 'early',
  /** Later funnel */
  later = 'later',
  /** Simple registration funnel */
  simple_reg = 'simple_reg',
  /** Spend funnel */
  spend = 'spend',
  /** Tiered registration funnel */
  tiered_reg = 'tiered_reg'
}

export type FunnelMetadata = {
  __typename?: 'FunnelMetadata';
  name: FunnelName;
  version: Scalars['String'];
};

export enum FunnelName {
  DEFAULT = 'DEFAULT',
  MIGHTY_OAK_CARD = 'MIGHTY_OAK_CARD',
  REFERRALS = 'REFERRALS'
}

export type GenerateDocumentUploadSessionInput = {
  /** Acorns subaccount for identity processing that is requesting to generate a document upload session */
  product: IdentitySubaccount;
};

export type GenerateDocumentUploadSessionResult = DocumentUploadSession;

/** Attributes for generating a layer linked account session. */
export type GenerateLayerLinkSessionInput = {
  /** Android package name for the Acorns app. */
  androidPackageName?: InputMaybe<Scalars['String']>;
  /** ISO 639-1 code representing the language. Default is 'EN'. */
  language?: InputMaybe<LinkSessionLanguage>;
  /** The configuration of the Plaid session to generate for the customer. Defaulted to Acorns' standard configuration. */
  linkCustomization?: InputMaybe<LinkCustomization>;
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: InputMaybe<Scalars['URL']>;
};

/** Returns a Link Token to use with Account Linking. */
export type GenerateLayerLinkSessionResult = PlaidLayerLinkSession | UnrecoverableError;

/** Attributes for generating a linked account session. */
export type GenerateLinkSessionInput = {
  /** Android package name for the Acorns app */
  androidPackageName?: InputMaybe<Scalars['String']>;
  /** The URL to redirect the client to after customer has finished linking account. */
  authRequired?: InputMaybe<Scalars['Boolean']>;
  /** Acorns Financial Institution ID */
  institutionId: Scalars['ID'];
  /** Flag indicating a web view client default is true */
  isWebview?: InputMaybe<Scalars['Boolean']>;
  /** ISO 639-1 code representing the language. default is 'EN' */
  language?: InputMaybe<LinkSessionLanguage>;
  /** Linked Account ID for Linked Account to relink */
  linkedAccountId?: InputMaybe<Scalars['ID']>;
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: InputMaybe<Scalars['URL']>;
};

export type GenerateReferralCodeResult = Invitation;

/** Returns Base 64 encoded string of PDF for Front-end */
export type GenerateUpdatedPdfPayload = {
  __typename?: 'GenerateUpdatedPdfPayload';
  /** Base 64 Encoded String of PDF */
  pdf: Scalars['String'];
};

export type GetUsersBankFromAccountTypePayload = {
  __typename?: 'GetUsersBankFromAccountTypePayload';
  bankType: BankType;
};

/** Object representing a grow prospect */
export type GrowProspect = Prospect & {
  __typename?: 'GrowProspect';
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type HelpFormContent = {
  __typename?: 'HelpFormContent';
  body: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export enum HelpFormType {
  CONTACT = 'CONTACT',
  EARN_MISSING_CREDIT = 'EARN_MISSING_CREDIT',
  SPEND_DISPUTE = 'SPEND_DISPUTE'
}

export type HelpcenterBannerContent = {
  __typename?: 'HelpcenterBannerContent';
  bannerText: Scalars['String'];
  bannerType: HelpcenterBannerType;
  currentVersion: Scalars['String'];
  publishedVersion: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
};

export type HelpcenterBannerErrors = {
  __typename?: 'HelpcenterBannerErrors';
  error: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export enum HelpcenterBannerType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export type HelpcenterContentInput = {
  bannerText?: InputMaybe<Scalars['String']>;
  bannerType?: InputMaybe<HelpcenterBannerType>;
  publish?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type HideMessageByExternalIdInput = {
  externalMessageId: Scalars['ID'];
};

export type HideMessageInput = {
  messageId: Scalars['ID'];
};

/** The Individual Security on the ETF */
export type Holding = {
  __typename?: 'Holding';
  /** Indicates the amount of every dollar that will go towards buying a share of the stock */
  amount: Scalars['Float'];
  /** The name of the stock */
  name: Scalars['String'];
  /** Indicates the percent of every dollar that will go towards buying a share of the stock */
  percent: Scalars['Float'];
  /** The Symbol of the stock */
  symbol: Scalars['String'];
};

/** Holding transfer information; ex: beneficiaryTransfer, external transfer, and external transfer reversed */
export type HoldingsTransfer = {
  __typename?: 'HoldingsTransfer';
  /** Holdings transfer type */
  transferType: HoldingsTransferType;
};

/** Defines the different types of holdings transfers. */
export enum HoldingsTransferType {
  BENEFICIARY_TRANSFER = 'BENEFICIARY_TRANSFER',
  EXTERNAL_TRANSFER = 'EXTERNAL_TRANSFER',
  EXTERNAL_TRANSFER_REVERSED = 'EXTERNAL_TRANSFER_REVERSED'
}

/** An IRA Distribution or a withdraw investment for Later account */
export type IraDistribution = {
  __typename?: 'IRADistribution';
  /** created at date and time of IRA Distribution */
  createdAt: Scalars['DateTime'];
  /** Stubbed Field: Federal withholdings for Later account */
  federalWithholdings: Maybe<MonetaryAmount>;
  /** ID of the IRA Distribution */
  id: Scalars['ID'];
  /** Investment ID of the IRA Distribution from the investment table */
  investmentId: Scalars['ID'];
  /** Stubbed Field: State withholdings for Later account */
  stateWithholdings: Maybe<MonetaryAmount>;
  /** update at date and time of IRA Distribution */
  updatedAt: Scalars['DateTime'];
};

export enum IconType {
  ICON_ADD_GOAL = 'ICON_ADD_GOAL',
  ICON_ALERT = 'ICON_ALERT',
  ICON_ALERT_GREY = 'ICON_ALERT_GREY',
  ICON_ALERT_PAUSE = 'ICON_ALERT_PAUSE',
  ICON_ALERT_PENDING = 'ICON_ALERT_PENDING',
  ICON_ALERT_RED = 'ICON_ALERT_RED',
  ICON_ALERT_YELLOW = 'ICON_ALERT_YELLOW',
  ICON_ARROW = 'ICON_ARROW',
  ICON_ARTICLE = 'ICON_ARTICLE',
  ICON_ARTICLE12 = 'ICON_ARTICLE12',
  ICON_AUDIO = 'ICON_AUDIO',
  ICON_BABY_KIDS = 'ICON_BABY_KIDS',
  ICON_CARD = 'ICON_CARD',
  ICON_CATEGORY_BABY = 'ICON_CATEGORY_BABY',
  ICON_CATEGORY_BEAUTY = 'ICON_CATEGORY_BEAUTY',
  ICON_CATEGORY_CAR = 'ICON_CATEGORY_CAR',
  ICON_CATEGORY_CLOTHING = 'ICON_CATEGORY_CLOTHING',
  ICON_CATEGORY_COLLEGE = 'ICON_CATEGORY_COLLEGE',
  ICON_CATEGORY_ENTERTAINMENT = 'ICON_CATEGORY_ENTERTAINMENT',
  ICON_CATEGORY_FLOWERS = 'ICON_CATEGORY_FLOWERS',
  ICON_CATEGORY_FOOD = 'ICON_CATEGORY_FOOD',
  ICON_CATEGORY_FOOTBALL = 'ICON_CATEGORY_FOOTBALL',
  ICON_CATEGORY_HEALTH = 'ICON_CATEGORY_HEALTH',
  ICON_CATEGORY_HOME = 'ICON_CATEGORY_HOME',
  ICON_CATEGORY_PET = 'ICON_CATEGORY_PET',
  ICON_CATEGORY_PHONE = 'ICON_CATEGORY_PHONE',
  ICON_CATEGORY_SHOE = 'ICON_CATEGORY_SHOE',
  ICON_CHECK_HUB = 'ICON_CHECK_HUB',
  ICON_CHECK_IN = 'ICON_CHECK_IN',
  ICON_CIRCLE_CHECK = 'ICON_CIRCLE_CHECK',
  ICON_CIRCLE_CLOCK = 'ICON_CIRCLE_CLOCK',
  ICON_CIRCLE_INFO = 'ICON_CIRCLE_INFO',
  ICON_CIRCLE_PAUSE = 'ICON_CIRCLE_PAUSE',
  ICON_CIRCLE_X = 'ICON_CIRCLE_X',
  ICON_CLOSE = 'ICON_CLOSE',
  ICON_CLOTHING = 'ICON_CLOTHING',
  ICON_DEPOSIT_CHECK = 'ICON_DEPOSIT_CHECK',
  ICON_DIRECT_DEPOSIT = 'ICON_DIRECT_DEPOSIT',
  ICON_DISCLOSURE_RIGHT = 'ICON_DISCLOSURE_RIGHT',
  ICON_DROP_PIN = 'ICON_DROP_PIN',
  ICON_EARN_JOBS = 'ICON_EARN_JOBS',
  ICON_ELECTRONICS = 'ICON_ELECTRONICS',
  ICON_ENTERTAINMENT = 'ICON_ENTERTAINMENT',
  ICON_EXPAND = 'ICON_EXPAND',
  ICON_FAST_QUOTE = 'ICON_FAST_QUOTE',
  ICON_FAVORITES = 'ICON_FAVORITES',
  ICON_FINANCIAL_WELLNESS = 'ICON_FINANCIAL_WELLNESS',
  ICON_FLOWERS_GIFTS = 'ICON_FLOWERS_GIFTS',
  ICON_FOOD_GOURMET = 'ICON_FOOD_GOURMET',
  ICON_GRAD_CAP = 'ICON_GRAD_CAP',
  ICON_HEALTH_BEAUTY = 'ICON_HEALTH_BEAUTY',
  ICON_HEALTH_WELLNESS = 'ICON_HEALTH_WELLNESS',
  ICON_HISTORY = 'ICON_HISTORY',
  ICON_HOME_DECOR = 'ICON_HOME_DECOR',
  ICON_INSTANT = 'ICON_INSTANT',
  ICON_INTERSTITIAL_ACHIEVEMENTS = 'ICON_INTERSTITIAL_ACHIEVEMENTS',
  ICON_INTERSTITIAL_ADD = 'ICON_INTERSTITIAL_ADD',
  ICON_INTERSTITIAL_APY = 'ICON_INTERSTITIAL_APY',
  ICON_INTERSTITIAL_AUTO_REFILL = 'ICON_INTERSTITIAL_AUTO_REFILL',
  ICON_INTERSTITIAL_BANK = 'ICON_INTERSTITIAL_BANK',
  ICON_INTERSTITIAL_CALCULATOR = 'ICON_INTERSTITIAL_CALCULATOR',
  ICON_INTERSTITIAL_CALENDAR = 'ICON_INTERSTITIAL_CALENDAR',
  ICON_INTERSTITIAL_CHECK = 'ICON_INTERSTITIAL_CHECK',
  ICON_INTERSTITIAL_CHECK_ACTIVE = 'ICON_INTERSTITIAL_CHECK_ACTIVE',
  ICON_INTERSTITIAL_CONFIDENT = 'ICON_INTERSTITIAL_CONFIDENT',
  ICON_INTERSTITIAL_CREDIT_CARD = 'ICON_INTERSTITIAL_CREDIT_CARD',
  ICON_INTERSTITIAL_DEPOSIT = 'ICON_INTERSTITIAL_DEPOSIT',
  ICON_INTERSTITIAL_DOCUMENTS = 'ICON_INTERSTITIAL_DOCUMENTS',
  ICON_INTERSTITIAL_DOLLAR = 'ICON_INTERSTITIAL_DOLLAR',
  ICON_INTERSTITIAL_DOLLAR_SIGN = 'ICON_INTERSTITIAL_DOLLAR_SIGN',
  ICON_INTERSTITIAL_EARN_JOBS = 'ICON_INTERSTITIAL_EARN_JOBS',
  ICON_INTERSTITIAL_ENTRIES = 'ICON_INTERSTITIAL_ENTRIES',
  ICON_INTERSTITIAL_FAST_QUOTE = 'ICON_INTERSTITIAL_FAST_QUOTE',
  ICON_INTERSTITIAL_FEELING_GOOD = 'ICON_INTERSTITIAL_FEELING_GOOD',
  ICON_INTERSTITIAL_GETTING_STARTED1 = 'ICON_INTERSTITIAL_GETTING_STARTED1',
  ICON_INTERSTITIAL_GETTING_STARTED2 = 'ICON_INTERSTITIAL_GETTING_STARTED2',
  ICON_INTERSTITIAL_HEALTH_ADD = 'ICON_INTERSTITIAL_HEALTH_ADD',
  ICON_INTERSTITIAL_LEARN = 'ICON_INTERSTITIAL_LEARN',
  ICON_INTERSTITIAL_MATCH = 'ICON_INTERSTITIAL_MATCH',
  ICON_INTERSTITIAL_NEXT_DAY = 'ICON_INTERSTITIAL_NEXT_DAY',
  ICON_INTERSTITIAL_NUMBER = 'ICON_INTERSTITIAL_NUMBER',
  ICON_INTERSTITIAL_OFFERS = 'ICON_INTERSTITIAL_OFFERS',
  ICON_INTERSTITIAL_PIE = 'ICON_INTERSTITIAL_PIE',
  ICON_INTERSTITIAL_PIN = 'ICON_INTERSTITIAL_PIN',
  ICON_INTERSTITIAL_PROFILE = 'ICON_INTERSTITIAL_PROFILE',
  ICON_INTERSTITIAL_RECURRING = 'ICON_INTERSTITIAL_RECURRING',
  ICON_INTERSTITIAL_RENTERS = 'ICON_INTERSTITIAL_RENTERS',
  ICON_INTERSTITIAL_ROUND_UP = 'ICON_INTERSTITIAL_ROUND_UP',
  ICON_INTERSTITIAL_ROUND_UPS = 'ICON_INTERSTITIAL_ROUND_UPS',
  ICON_INTERSTITIAL_ROUND_UP_BILL = 'ICON_INTERSTITIAL_ROUND_UP_BILL',
  ICON_INTERSTITIAL_SAVE = 'ICON_INTERSTITIAL_SAVE',
  ICON_INTERSTITIAL_SEND_CHECK = 'ICON_INTERSTITIAL_SEND_CHECK',
  ICON_INTERSTITIAL_SHIPPING = 'ICON_INTERSTITIAL_SHIPPING',
  ICON_INTERSTITIAL_SIDE_HUSTLES = 'ICON_INTERSTITIAL_SIDE_HUSTLES',
  ICON_INTERSTITIAL_SIMPLY_SPEND = 'ICON_INTERSTITIAL_SIMPLY_SPEND',
  ICON_INTERSTITIAL_SMART_DEPOSIT = 'ICON_INTERSTITIAL_SMART_DEPOSIT',
  ICON_INTERSTITIAL_SMART_DEPOSIT_ACTIVE = 'ICON_INTERSTITIAL_SMART_DEPOSIT_ACTIVE',
  ICON_INTERSTITIAL_TIMER = 'ICON_INTERSTITIAL_TIMER',
  ICON_INTERSTITIAL_TREE = 'ICON_INTERSTITIAL_TREE',
  ICON_INTERSTITIAL_TWO_FACTOR_AUTH = 'ICON_INTERSTITIAL_TWO_FACTOR_AUTH',
  ICON_INTERSTITIAL_WALLET = 'ICON_INTERSTITIAL_WALLET',
  ICON_INVEST = 'ICON_INVEST',
  ICON_LEARNING_CENTER = 'ICON_LEARNING_CENTER',
  ICON_LIGHTNING_BOLT = 'ICON_LIGHTNING_BOLT',
  ICON_LIVE = 'ICON_LIVE',
  ICON_LOCAL_OFFERS = 'ICON_LOCAL_OFFERS',
  ICON_LOCATION = 'ICON_LOCATION',
  ICON_LOCK = 'ICON_LOCK',
  ICON_LOCK_SOLID = 'ICON_LOCK_SOLID',
  ICON_MINI_ARROW_LRG_DOWN = 'ICON_MINI_ARROW_LRG_DOWN',
  ICON_MINI_ARROW_LRG_UP = 'ICON_MINI_ARROW_LRG_UP',
  ICON_MINI_ARROW_SM_DOWN = 'ICON_MINI_ARROW_SM_DOWN',
  ICON_MINI_ARROW_SM_UP = 'ICON_MINI_ARROW_SM_UP',
  ICON_MINI_ARTICLE = 'ICON_MINI_ARTICLE',
  ICON_MINI_AUDIO = 'ICON_MINI_AUDIO',
  ICON_MINI_CHECKMARK = 'ICON_MINI_CHECKMARK',
  ICON_MINI_INDICATOR_TRIANGLE = 'ICON_MINI_INDICATOR_TRIANGLE',
  ICON_MINI_LIGHTNING_BOLT = 'ICON_MINI_LIGHTNING_BOLT',
  ICON_MINI_LOCK = 'ICON_MINI_LOCK',
  ICON_MINI_NEW = 'ICON_MINI_NEW',
  ICON_MINI_PLAY = 'ICON_MINI_PLAY',
  ICON_MINI_SELECTION_CHECK = 'ICON_MINI_SELECTION_CHECK',
  ICON_MINUS = 'ICON_MINUS',
  ICON_NEW = 'ICON_NEW',
  ICON_ONE_TIME = 'ICON_ONE_TIME',
  ICON_PETS = 'ICON_PETS',
  ICON_PLANE = 'ICON_PLANE',
  ICON_PLAY_MINI = 'ICON_PLAY_MINI',
  ICON_PLAY_VIDEO = 'ICON_PLAY_VIDEO',
  ICON_PLUS = 'ICON_PLUS',
  ICON_PRODUCT_BANKING = 'ICON_PRODUCT_BANKING',
  ICON_PRODUCT_BENEFITS = 'ICON_PRODUCT_BENEFITS',
  ICON_PRODUCT_COLOR_ACHIEVEMENTS = 'ICON_PRODUCT_COLOR_ACHIEVEMENTS',
  ICON_PRODUCT_COLOR_EARLY = 'ICON_PRODUCT_COLOR_EARLY',
  ICON_PRODUCT_COLOR_EARN = 'ICON_PRODUCT_COLOR_EARN',
  ICON_PRODUCT_COLOR_EMERGENCY_FUND = 'ICON_PRODUCT_COLOR_EMERGENCY_FUND',
  ICON_PRODUCT_COLOR_GROW = 'ICON_PRODUCT_COLOR_GROW',
  ICON_PRODUCT_COLOR_INVEST = 'ICON_PRODUCT_COLOR_INVEST',
  ICON_PRODUCT_COLOR_INVITE = 'ICON_PRODUCT_COLOR_INVITE',
  ICON_PRODUCT_COLOR_LATER = 'ICON_PRODUCT_COLOR_LATER',
  ICON_PRODUCT_COLOR_LOCAL_FOUND_MONEY = 'ICON_PRODUCT_COLOR_LOCAL_FOUND_MONEY',
  ICON_PRODUCT_COLOR_PROTECT = 'ICON_PRODUCT_COLOR_PROTECT',
  ICON_PRODUCT_COLOR_SAVE = 'ICON_PRODUCT_COLOR_SAVE',
  ICON_PRODUCT_COLOR_SPEND = 'ICON_PRODUCT_COLOR_SPEND',
  ICON_PRODUCT_EARLY = 'ICON_PRODUCT_EARLY',
  ICON_PRODUCT_EARN = 'ICON_PRODUCT_EARN',
  ICON_PRODUCT_EMERGENCY = 'ICON_PRODUCT_EMERGENCY',
  ICON_PRODUCT_GO_HENRY = 'ICON_PRODUCT_GO_HENRY',
  ICON_PRODUCT_GROW = 'ICON_PRODUCT_GROW',
  ICON_PRODUCT_INVEST = 'ICON_PRODUCT_INVEST',
  ICON_PRODUCT_INVEST_HUB = 'ICON_PRODUCT_INVEST_HUB',
  ICON_PRODUCT_INVEST_PRODUCT = 'ICON_PRODUCT_INVEST_PRODUCT',
  ICON_PRODUCT_LATER = 'ICON_PRODUCT_LATER',
  ICON_PRODUCT_PROTECT = 'ICON_PRODUCT_PROTECT',
  ICON_PRODUCT_SAVE = 'ICON_PRODUCT_SAVE',
  ICON_PRODUCT_SPEND = 'ICON_PRODUCT_SPEND',
  ICON_PROTECTED = 'ICON_PROTECTED',
  ICON_REVERSAL = 'ICON_REVERSAL',
  ICON_ROUND_UPS = 'ICON_ROUND_UPS',
  ICON_SCOOTER = 'ICON_SCOOTER',
  ICON_SEARCH = 'ICON_SEARCH',
  ICON_SEND_CHECK = 'ICON_SEND_CHECK',
  ICON_SEND_MONEY_INSTANT = 'ICON_SEND_MONEY_INSTANT',
  ICON_SHARE = 'ICON_SHARE',
  ICON_SHOES_ACCESSORIES = 'ICON_SHOES_ACCESSORIES',
  ICON_SIDE_HUSTLES = 'ICON_SIDE_HUSTLES',
  ICON_SIMPLY_SPEND = 'ICON_SIMPLY_SPEND',
  ICON_SPORTS_OUTDOORS = 'ICON_SPORTS_OUTDOORS',
  ICON_TIMER = 'ICON_TIMER',
  ICON_TRANSACTION_ACORNS = 'ICON_TRANSACTION_ACORNS',
  ICON_TRANSACTION_ATM = 'ICON_TRANSACTION_ATM',
  ICON_TRANSACTION_BANK_FEE = 'ICON_TRANSACTION_BANK_FEE',
  ICON_TRANSACTION_CHECK = 'ICON_TRANSACTION_CHECK',
  ICON_TRANSACTION_CHECK_DEPOSIT = 'ICON_TRANSACTION_CHECK_DEPOSIT',
  ICON_TRANSACTION_DIRECT_DEPOSIT = 'ICON_TRANSACTION_DIRECT_DEPOSIT',
  ICON_TRANSACTION_DISTRIBUTION = 'ICON_TRANSACTION_DISTRIBUTION',
  ICON_TRANSACTION_DIVIDEND = 'ICON_TRANSACTION_DIVIDEND',
  ICON_TRANSACTION_EARN_REWARD = 'ICON_TRANSACTION_EARN_REWARD',
  ICON_TRANSACTION_EARN_REWARDS_MATCH = 'ICON_TRANSACTION_EARN_REWARDS_MATCH',
  ICON_TRANSACTION_GIFT = 'ICON_TRANSACTION_GIFT',
  ICON_TRANSACTION_GO_HENRY = 'ICON_TRANSACTION_GO_HENRY',
  ICON_TRANSACTION_HAMBURGER = 'ICON_TRANSACTION_HAMBURGER',
  ICON_TRANSACTION_ID = 'ICON_TRANSACTION_ID',
  ICON_TRANSACTION_INSTANT_ROUND_UP = 'ICON_TRANSACTION_INSTANT_ROUND_UP',
  ICON_TRANSACTION_ONE_TIME = 'ICON_TRANSACTION_ONE_TIME',
  ICON_TRANSACTION_ORIGINAL_TRANSACTION = 'ICON_TRANSACTION_ORIGINAL_TRANSACTION',
  ICON_TRANSACTION_REBALANCE = 'ICON_TRANSACTION_REBALANCE',
  ICON_TRANSACTION_RECURRING_DEPOSIT = 'ICON_TRANSACTION_RECURRING_DEPOSIT',
  ICON_TRANSACTION_REFUND = 'ICON_TRANSACTION_REFUND',
  ICON_TRANSACTION_ROUND_UP = 'ICON_TRANSACTION_ROUND_UP',
  ICON_TRANSACTION_SPEND_CARD = 'ICON_TRANSACTION_SPEND_CARD',
  ICON_TRANSACTION_STATUS = 'ICON_TRANSACTION_STATUS',
  ICON_TRANSACTION_TRANSFER_IN = 'ICON_TRANSACTION_TRANSFER_IN',
  ICON_TRANSACTION_TRANSFER_IN_OUT = 'ICON_TRANSACTION_TRANSFER_IN_OUT',
  ICON_TRANSACTION_TRANSFER_OUT = 'ICON_TRANSACTION_TRANSFER_OUT',
  ICON_TRANSACTION_TYPE = 'ICON_TRANSACTION_TYPE',
  ICON_TRANSFER = 'ICON_TRANSFER',
  ICON_TRAVEL_TRANSPORTATION = 'ICON_TRAVEL_TRANSPORTATION',
  ICON_TRUSTED_PARTNERS = 'ICON_TRUSTED_PARTNERS',
  ICON_UTILITY_ACCESSIBILITY = 'ICON_UTILITY_ACCESSIBILITY',
  ICON_UTILITY_ACCOUNT_DETAILS = 'ICON_UTILITY_ACCOUNT_DETAILS',
  ICON_UTILITY_ACHIEVEMENT = 'ICON_UTILITY_ACHIEVEMENT',
  ICON_UTILITY_ACORN = 'ICON_UTILITY_ACORN',
  ICON_UTILITY_ADD = 'ICON_UTILITY_ADD',
  ICON_UTILITY_AI = 'ICON_UTILITY_AI',
  ICON_UTILITY_ALERT = 'ICON_UTILITY_ALERT',
  ICON_UTILITY_APY = 'ICON_UTILITY_APY',
  ICON_UTILITY_ARROW_LEFT = 'ICON_UTILITY_ARROW_LEFT',
  ICON_UTILITY_ARROW_RIGHT = 'ICON_UTILITY_ARROW_RIGHT',
  ICON_UTILITY_AR_EXPERIENCE = 'ICON_UTILITY_AR_EXPERIENCE',
  ICON_UTILITY_BACKUP_CODES = 'ICON_UTILITY_BACKUP_CODES',
  ICON_UTILITY_BAG = 'ICON_UTILITY_BAG',
  ICON_UTILITY_BANK = 'ICON_UTILITY_BANK',
  ICON_UTILITY_BANK_ADD = 'ICON_UTILITY_BANK_ADD',
  ICON_UTILITY_BANK_FEES = 'ICON_UTILITY_BANK_FEES',
  ICON_UTILITY_BELL = 'ICON_UTILITY_BELL',
  ICON_UTILITY_BELL_FILLED = 'ICON_UTILITY_BELL_FILLED',
  ICON_UTILITY_BENEFICIARIES = 'ICON_UTILITY_BENEFICIARIES',
  ICON_UTILITY_BINOCULARS = 'ICON_UTILITY_BINOCULARS',
  ICON_UTILITY_BIRTHDAY = 'ICON_UTILITY_BIRTHDAY',
  ICON_UTILITY_BONDS = 'ICON_UTILITY_BONDS',
  ICON_UTILITY_BOOK = 'ICON_UTILITY_BOOK',
  ICON_UTILITY_BOOKMARK = 'ICON_UTILITY_BOOKMARK',
  ICON_UTILITY_BOOKMARK_FILLED = 'ICON_UTILITY_BOOKMARK_FILLED',
  ICON_UTILITY_BOX = 'ICON_UTILITY_BOX',
  ICON_UTILITY_BUDGETING = 'ICON_UTILITY_BUDGETING',
  ICON_UTILITY_CALENDAR = 'ICON_UTILITY_CALENDAR',
  ICON_UTILITY_CAMERA = 'ICON_UTILITY_CAMERA',
  ICON_UTILITY_CANCEL = 'ICON_UTILITY_CANCEL',
  ICON_UTILITY_CAR = 'ICON_UTILITY_CAR',
  ICON_UTILITY_CASH_OWED = 'ICON_UTILITY_CASH_OWED',
  ICON_UTILITY_CELL_TOWER = 'ICON_UTILITY_CELL_TOWER',
  ICON_UTILITY_CHAT_BUBBLE = 'ICON_UTILITY_CHAT_BUBBLE',
  ICON_UTILITY_CHECKMARK = 'ICON_UTILITY_CHECKMARK',
  ICON_UTILITY_CLOSE = 'ICON_UTILITY_CLOSE',
  ICON_UTILITY_COIN = 'ICON_UTILITY_COIN',
  ICON_UTILITY_COLLAPSE_MENU = 'ICON_UTILITY_COLLAPSE_MENU',
  ICON_UTILITY_COMPANY_BUILDING = 'ICON_UTILITY_COMPANY_BUILDING',
  ICON_UTILITY_CONTROLLER = 'ICON_UTILITY_CONTROLLER',
  ICON_UTILITY_COPY = 'ICON_UTILITY_COPY',
  ICON_UTILITY_CRANE = 'ICON_UTILITY_CRANE',
  ICON_UTILITY_CREDIT = 'ICON_UTILITY_CREDIT',
  ICON_UTILITY_CRYPTO = 'ICON_UTILITY_CRYPTO',
  ICON_UTILITY_CURRENT_LOCATION = 'ICON_UTILITY_CURRENT_LOCATION',
  ICON_UTILITY_CUSTOMIZE = 'ICON_UTILITY_CUSTOMIZE',
  ICON_UTILITY_CUSTOM_STOCKS = 'ICON_UTILITY_CUSTOM_STOCKS',
  ICON_UTILITY_CYBER_SECURITY = 'ICON_UTILITY_CYBER_SECURITY',
  ICON_UTILITY_DELETE = 'ICON_UTILITY_DELETE',
  ICON_UTILITY_DOCUMENTS = 'ICON_UTILITY_DOCUMENTS',
  ICON_UTILITY_DOCUMENT_DOWNLOAD = 'ICON_UTILITY_DOCUMENT_DOWNLOAD',
  ICON_UTILITY_DOCUMENT_UPLOAD = 'ICON_UTILITY_DOCUMENT_UPLOAD',
  ICON_UTILITY_DOTS = 'ICON_UTILITY_DOTS',
  ICON_UTILITY_DOWN = 'ICON_UTILITY_DOWN',
  ICON_UTILITY_DOWN_FILLED = 'ICON_UTILITY_DOWN_FILLED',
  ICON_UTILITY_EARN_JOBS = 'ICON_UTILITY_EARN_JOBS',
  ICON_UTILITY_EDIT = 'ICON_UTILITY_EDIT',
  ICON_UTILITY_ENTRIES = 'ICON_UTILITY_ENTRIES',
  ICON_UTILITY_ETH = 'ICON_UTILITY_ETH',
  ICON_UTILITY_EXPAND = 'ICON_UTILITY_EXPAND',
  ICON_UTILITY_EXPAND_MENU = 'ICON_UTILITY_EXPAND_MENU',
  ICON_UTILITY_FACE = 'ICON_UTILITY_FACE',
  ICON_UTILITY_FACE_ID = 'ICON_UTILITY_FACE_ID',
  ICON_UTILITY_FAST_QUOTE = 'ICON_UTILITY_FAST_QUOTE',
  ICON_UTILITY_FILTER = 'ICON_UTILITY_FILTER',
  ICON_UTILITY_FLAME = 'ICON_UTILITY_FLAME',
  ICON_UTILITY_FLASH_OFF = 'ICON_UTILITY_FLASH_OFF',
  ICON_UTILITY_FLASH_ON = 'ICON_UTILITY_FLASH_ON',
  ICON_UTILITY_FLEXIBLE = 'ICON_UTILITY_FLEXIBLE',
  ICON_UTILITY_GIFT = 'ICON_UTILITY_GIFT',
  ICON_UTILITY_GOAL = 'ICON_UTILITY_GOAL',
  ICON_UTILITY_GOVERNMENT = 'ICON_UTILITY_GOVERNMENT',
  ICON_UTILITY_GRAD_CAP = 'ICON_UTILITY_GRAD_CAP',
  ICON_UTILITY_HAMBURGER_MENU = 'ICON_UTILITY_HAMBURGER_MENU',
  ICON_UTILITY_HEALTH = 'ICON_UTILITY_HEALTH',
  ICON_UTILITY_HEART = 'ICON_UTILITY_HEART',
  ICON_UTILITY_HEART_ADD = 'ICON_UTILITY_HEART_ADD',
  ICON_UTILITY_HEART_FILLED = 'ICON_UTILITY_HEART_FILLED',
  ICON_UTILITY_HELP = 'ICON_UTILITY_HELP',
  ICON_UTILITY_HIDE = 'ICON_UTILITY_HIDE',
  ICON_UTILITY_HISTORY = 'ICON_UTILITY_HISTORY',
  ICON_UTILITY_HOME = 'ICON_UTILITY_HOME',
  ICON_UTILITY_INFO = 'ICON_UTILITY_INFO',
  ICON_UTILITY_INVESTOR_PROFILE = 'ICON_UTILITY_INVESTOR_PROFILE',
  ICON_UTILITY_INVITE = 'ICON_UTILITY_INVITE',
  ICON_UTILITY_JOB_ALERTS = 'ICON_UTILITY_JOB_ALERTS',
  ICON_UTILITY_KEYPAD = 'ICON_UTILITY_KEYPAD',
  ICON_UTILITY_LAPTOP = 'ICON_UTILITY_LAPTOP',
  ICON_UTILITY_LARGE_CHECKMARK = 'ICON_UTILITY_LARGE_CHECKMARK',
  ICON_UTILITY_LARGE_PLUS = 'ICON_UTILITY_LARGE_PLUS',
  ICON_UTILITY_LEAF = 'ICON_UTILITY_LEAF',
  ICON_UTILITY_LIBRARY = 'ICON_UTILITY_LIBRARY',
  ICON_UTILITY_LIGHTBULB = 'ICON_UTILITY_LIGHTBULB',
  ICON_UTILITY_LOCAL_OFFERS = 'ICON_UTILITY_LOCAL_OFFERS',
  ICON_UTILITY_LOGIN_ACTIVITY = 'ICON_UTILITY_LOGIN_ACTIVITY',
  ICON_UTILITY_LOG_OUT = 'ICON_UTILITY_LOG_OUT',
  ICON_UTILITY_MAIL = 'ICON_UTILITY_MAIL',
  ICON_UTILITY_MANUAL_LINKING = 'ICON_UTILITY_MANUAL_LINKING',
  ICON_UTILITY_MAP_PIN = 'ICON_UTILITY_MAP_PIN',
  ICON_UTILITY_MATCH = 'ICON_UTILITY_MATCH',
  ICON_UTILITY_MEDIA = 'ICON_UTILITY_MEDIA',
  ICON_UTILITY_MENU = 'ICON_UTILITY_MENU',
  ICON_UTILITY_MOBILE_PHONE = 'ICON_UTILITY_MOBILE_PHONE',
  ICON_UTILITY_MORNING = 'ICON_UTILITY_MORNING',
  ICON_UTILITY_NEW = 'ICON_UTILITY_NEW',
  ICON_UTILITY_NIGHT = 'ICON_UTILITY_NIGHT',
  ICON_UTILITY_NOTIFICATIONS = 'ICON_UTILITY_NOTIFICATIONS',
  ICON_UTILITY_ONE_TIME = 'ICON_UTILITY_ONE_TIME',
  ICON_UTILITY_PASSWORD = 'ICON_UTILITY_PASSWORD',
  ICON_UTILITY_PAUSE = 'ICON_UTILITY_PAUSE',
  ICON_UTILITY_PET = 'ICON_UTILITY_PET',
  ICON_UTILITY_PHONE = 'ICON_UTILITY_PHONE',
  ICON_UTILITY_PIN = 'ICON_UTILITY_PIN',
  ICON_UTILITY_PLANE = 'ICON_UTILITY_PLANE',
  ICON_UTILITY_PLUG = 'ICON_UTILITY_PLUG',
  ICON_UTILITY_POINTER = 'ICON_UTILITY_POINTER',
  ICON_UTILITY_PORTFOLIO_TYPE = 'ICON_UTILITY_PORTFOLIO_TYPE',
  ICON_UTILITY_POTENTIAL = 'ICON_UTILITY_POTENTIAL',
  ICON_UTILITY_PREFERENCES = 'ICON_UTILITY_PREFERENCES',
  ICON_UTILITY_PROFILE = 'ICON_UTILITY_PROFILE',
  ICON_UTILITY_QR = 'ICON_UTILITY_QR',
  ICON_UTILITY_QUESTIONNAIRE = 'ICON_UTILITY_QUESTIONNAIRE',
  ICON_UTILITY_QUESTION_MARK = 'ICON_UTILITY_QUESTION_MARK',
  ICON_UTILITY_QUICK_WITHDRAW = 'ICON_UTILITY_QUICK_WITHDRAW',
  ICON_UTILITY_RELOAD = 'ICON_UTILITY_RELOAD',
  ICON_UTILITY_RENTERS = 'ICON_UTILITY_RENTERS',
  ICON_UTILITY_RISK = 'ICON_UTILITY_RISK',
  ICON_UTILITY_ROCKET = 'ICON_UTILITY_ROCKET',
  ICON_UTILITY_ROUND_UPS_REAL_TIME = 'ICON_UTILITY_ROUND_UPS_REAL_TIME',
  ICON_UTILITY_SAFARI = 'ICON_UTILITY_SAFARI',
  ICON_UTILITY_SCALES = 'ICON_UTILITY_SCALES',
  ICON_UTILITY_SCIENCE = 'ICON_UTILITY_SCIENCE',
  ICON_UTILITY_SCOOTER = 'ICON_UTILITY_SCOOTER',
  ICON_UTILITY_SEARCH = 'ICON_UTILITY_SEARCH',
  ICON_UTILITY_SETTINGS = 'ICON_UTILITY_SETTINGS',
  ICON_UTILITY_SHARE_ANDROID = 'ICON_UTILITY_SHARE_ANDROID',
  ICON_UTILITY_SHARE_IOS = 'ICON_UTILITY_SHARE_IOS',
  ICON_UTILITY_SHARE_LINK = 'ICON_UTILITY_SHARE_LINK',
  ICON_UTILITY_SHIELD_CHECK = 'ICON_UTILITY_SHIELD_CHECK',
  ICON_UTILITY_SHIPPING = 'ICON_UTILITY_SHIPPING',
  ICON_UTILITY_SHOW = 'ICON_UTILITY_SHOW',
  ICON_UTILITY_SILVERWARE = 'ICON_UTILITY_SILVERWARE',
  ICON_UTILITY_SINGLE_COIN = 'ICON_UTILITY_SINGLE_COIN',
  ICON_UTILITY_SMART_DEPOSIT_SHINE = 'ICON_UTILITY_SMART_DEPOSIT_SHINE',
  ICON_UTILITY_SORT = 'ICON_UTILITY_SORT',
  ICON_UTILITY_SPACE = 'ICON_UTILITY_SPACE',
  ICON_UTILITY_SPEND_CARD_DISPUTE = 'ICON_UTILITY_SPEND_CARD_DISPUTE',
  ICON_UTILITY_SPEND_CARD_LOCKED = 'ICON_UTILITY_SPEND_CARD_LOCKED',
  ICON_UTILITY_SPRAY_BOTTLE = 'ICON_UTILITY_SPRAY_BOTTLE',
  ICON_UTILITY_SPROUT = 'ICON_UTILITY_SPROUT',
  ICON_UTILITY_STACKED_COINS = 'ICON_UTILITY_STACKED_COINS',
  ICON_UTILITY_STAR = 'ICON_UTILITY_STAR',
  ICON_UTILITY_STOCKS = 'ICON_UTILITY_STOCKS',
  ICON_UTILITY_SUBSCRIPTION = 'ICON_UTILITY_SUBSCRIPTION',
  ICON_UTILITY_SUN = 'ICON_UTILITY_SUN',
  ICON_UTILITY_TAX = 'ICON_UTILITY_TAX',
  ICON_UTILITY_TEXT_MESSAGE = 'ICON_UTILITY_TEXT_MESSAGE',
  ICON_UTILITY_THEMATIC_INVESTMENTS = 'ICON_UTILITY_THEMATIC_INVESTMENTS',
  ICON_UTILITY_TIMER = 'ICON_UTILITY_TIMER',
  ICON_UTILITY_TOUCH_ID = 'ICON_UTILITY_TOUCH_ID',
  ICON_UTILITY_TRASH = 'ICON_UTILITY_TRASH',
  ICON_UTILITY_TREE = 'ICON_UTILITY_TREE',
  ICON_UTILITY_TWO_FACTOR_AUTH = 'ICON_UTILITY_TWO_FACTOR_AUTH',
  ICON_UTILITY_UP = 'ICON_UTILITY_UP',
  ICON_UTILITY_UP_FILLED = 'ICON_UTILITY_UP_FILLED',
  ICON_UTILITY_WAND = 'ICON_UTILITY_WAND',
  ICON_UTILITY_WITHDRAW = 'ICON_UTILITY_WITHDRAW',
  ICON_VIDEO = 'ICON_VIDEO',
  ICON_VIDEO12 = 'ICON_VIDEO12',
  ICON_VIDEO_CONTROLS_10S_FORWARD = 'ICON_VIDEO_CONTROLS_10S_FORWARD',
  ICON_VIDEO_CONTROLS_10S_REWIND = 'ICON_VIDEO_CONTROLS_10S_REWIND',
  ICON_VIDEO_CONTROLS_MUTED = 'ICON_VIDEO_CONTROLS_MUTED',
  ICON_VIDEO_CONTROLS_PAUSE = 'ICON_VIDEO_CONTROLS_PAUSE',
  ICON_VIDEO_CONTROLS_PLAY = 'ICON_VIDEO_CONTROLS_PLAY',
  ICON_VIDEO_CONTROLS_REPLAY = 'ICON_VIDEO_CONTROLS_REPLAY',
  ICON_VIDEO_CONTROLS_SOUND_ON = 'ICON_VIDEO_CONTROLS_SOUND_ON',
  ICON_VIEWS = 'ICON_VIEWS',
  ICON_WITHDRAW = 'ICON_WITHDRAW'
}

/** Identity Document Requested Alert. */
export type IdentityDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'IdentityDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export enum IdentitySubaccount {
  BANK = 'BANK',
  INVEST = 'INVEST'
}

export type IdentityVerification = {
  canRetry: Maybe<Scalars['Boolean']>;
  verificationStatus: VerificationStatus;
};

export type Image = {
  __typename?: 'Image';
  url: Scalars['String'];
};

export enum ImageType {
  back = 'back',
  front = 'front'
}

export type ImplicitToken = {
  __typename?: 'ImplicitToken';
  token: Scalars['String'];
};

/**
 * An abstract representation of some reward a subscriber will be afforded
 * upon subscription to some Offer.
 */
export type Incentive = {
  /**
   * Arbitrary human-readable identifier that can be used by clients
   * to localize related copy.
   */
  copyKey: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Description of what the incentive provides the subscriber. */
  description: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type IncorrectOldPasswordException = {
  __typename?: 'IncorrectOldPasswordException';
  message: Maybe<Scalars['String']>;
};

/** One of the entered deposit amounts was incorrect */
export type IncorrectRdvAmounts = {
  __typename?: 'IncorrectRdvAmounts';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type IncorrectSecurityAnswerException = {
  __typename?: 'IncorrectSecurityAnswerException';
  message: Maybe<Scalars['String']>;
};

export type IncorrectSsnException = {
  __typename?: 'IncorrectSsnException';
  message: Maybe<Scalars['String']>;
};

export enum IneligibleReasons {
  REQUIRED_ACCOUNTS_NOT_OPEN = 'REQUIRED_ACCOUNTS_NOT_OPEN',
  SUBSCRIPTION_TIER_INELIGIBLE = 'SUBSCRIPTION_TIER_INELIGIBLE'
}

export type InitiateBankAccountInput = {
  accountType: BankAccountType;
  bankType: BankType;
  goals?: InputMaybe<Array<InputMaybe<BankAccountGoalInput>>>;
  isReopen?: InputMaybe<Scalars['Boolean']>;
};

export type InitiateBankAccountResponse = {
  __typename?: 'InitiateBankAccountResponse';
  accountType: BankAccountType;
  bankType: BankType;
};

export type InitiateBankingKycInput = {
  accountTypes: Array<BankAccountTypeConfig>;
};

export type InitiateBankingKycPayload = {
  __typename?: 'InitiateBankingKYCPayload';
  kycStatus: Maybe<KycStatus>;
  message: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type InitiateChallengeInput = {
  authenticatorId: Scalars['ID'];
  mfaToken: Scalars['ID'];
  userId: Scalars['ID'];
};

export type InitiateChallengeResult = AuthenticatorNotFoundException | ChallengeRateExceededException | EmailAuthChallenge | InvalidMfaTokenException | PhoneNumberOptedOutException | SmsAuthChallenge;

export type InitiateEmailChallengeInput = {
  email: Scalars['EmailAddress'];
};

export type InitiateEmailChallengeResult = ChallengeRateExceededException | EmailAuthChallenge | ExistingEmailVerifiedException;

export type InitiateMoneyAssignmentInput = {
  transactionId: Scalars['ID'];
};

export type InitiateMoneyAssignmentResult = InitiateMoneyAssignmentSuccess | MoneyAssignmentAlreadyTransferredError | MoneyAssignmentNotFoundError;

export type InitiateMoneyAssignmentSuccess = {
  __typename?: 'InitiateMoneyAssignmentSuccess';
  moneyAssignment: MoneyManagerMoneyAssignment;
};

export type InitiatePushChallengeResult = ChallengeRateExceededException | InitiatePushChallengeSuccess | NoRegisteredPushAuthenticatorsException;

export type InitiatePushChallengeSuccess = {
  __typename?: 'InitiatePushChallengeSuccess';
  challenges: Maybe<Array<PushAuthChallenge>>;
};

export type InitiateSmsChallengeInput = {
  phoneNumber: Scalars['PhoneNumber'];
};

export type InitiateSmsChallengeResult = ChallengeRateExceededException | InvalidPhoneNumberException | PhoneNumberOptedOutException | SmsAuthChallenge;

export type InitiateTransferInput = {
  /** Amount of currency to transfer */
  amount: CurrencyAmountInput;
  /** UUID of account to move money from */
  fromAccountId: Scalars['ID'];
  /** Idempotency key for customer request */
  nonce?: InputMaybe<Scalars['ID']>;
  /** UUID of account to move money into */
  toAccountId: Scalars['ID'];
};

export type InitiateTransferPayload = {
  __typename?: 'InitiateTransferPayload';
  transfer: Maybe<Transfer>;
};

export type InitiateVerificationResult = VerificationProfile;

export type InstitutionNotSupportedError = {
  __typename?: 'InstitutionNotSupportedError';
  message: Scalars['String'];
};

/** Insufficient Funds user alert. */
export type InsufficientFundsUserAlert = UserAlertsItem & {
  __typename?: 'InsufficientFundsUserAlert';
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export type Intent = {
  __typename?: 'Intent';
  amount: CurrencyAmount;
  /** @deprecated Use `nonce` as the unique identifier for Intents instead. */
  id: Scalars['ID'];
  nonce: Scalars['UUID'];
  status: Maybe<IntentStatus>;
};

/** Input the account types of the transfer. */
export type IntentFilterInput = {
  fromAccountType?: InputMaybe<Scalars['String']>;
  toAccountType?: InputMaybe<Scalars['String']>;
};

export enum IntentStatus {
  CANCELED = 'CANCELED',
  CANCELING = 'CANCELING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  REVERSED = 'REVERSED',
  REVERSING = 'REVERSING',
  SUBMITTED = 'SUBMITTED'
}

export type InteractionRatingResponse = {
  __typename?: 'InteractionRatingResponse';
  interactionId: Scalars['String'];
  message: Scalars['String'];
};

/** Internal Error */
export type InternalErrorException = {
  __typename?: 'InternalErrorException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** The account number is invalid */
export type InvalidAccountNumber = {
  __typename?: 'InvalidAccountNumber';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** Investment Account must be a Custodial account */
export type InvalidAccountTypeException = {
  __typename?: 'InvalidAccountTypeException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type InvalidAcornsEarlyTokenException = {
  __typename?: 'InvalidAcornsEarlyTokenException';
  message: Scalars['String'];
};

/** Risk Level cannot be changed on Later and Early accounts */
export type InvalidActionOnAccount = {
  __typename?: 'InvalidActionOnAccount';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type InvalidAddressError = {
  __typename?: 'InvalidAddressError';
  /** Error details. Not for user display. */
  errorMessage: Maybe<Scalars['String']>;
  requestId: Scalars['ID'];
};

/** Invalid Address */
export type InvalidAddressException = {
  __typename?: 'InvalidAddressException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Allocations exceed max threshold for non managed portfolios */
export type InvalidAllocationPercentError = {
  __typename?: 'InvalidAllocationPercentError';
  /** Maximum allocation percent for the given portfolio Type */
  maxAllocationPercent: Scalars['Int'];
};

export type InvalidAppleAccountException = {
  __typename?: 'InvalidAppleAccountException';
  message: Maybe<Scalars['String']>;
  subId: Maybe<Scalars['String']>;
};

export type InvalidContentTypeException = {
  __typename?: 'InvalidContentTypeException';
  contentType: Scalars['String'];
};

/** Occurs when exactly one conversion ID (email, phone, etc) was not provided */
export type InvalidConversionIdentifierException = {
  __typename?: 'InvalidConversionIdentifierException';
  message: Scalars['String'];
};

export type InvalidCredentialsException = {
  __typename?: 'InvalidCredentialsException';
  message: Maybe<Scalars['String']>;
};

export type InvalidDateException = {
  __typename?: 'InvalidDateException';
  message: Scalars['String'];
};

/** Date of birth does not meet validity criteria */
export type InvalidDateOfBirthException = {
  __typename?: 'InvalidDateOfBirthException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type InvalidDeviceParametersException = {
  __typename?: 'InvalidDeviceParametersException';
  message: Maybe<Scalars['String']>;
};

/** Invalid email id */
export type InvalidEmailException = {
  __typename?: 'InvalidEmailException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** The file uploaded does not have an allowed file extension */
export type InvalidFile = {
  __typename?: 'InvalidFile';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** First Name does not meet validity criteria */
export type InvalidFirstNameException = {
  __typename?: 'InvalidFirstNameException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type InvalidGoogleAccountException = {
  __typename?: 'InvalidGoogleAccountException';
  message: Maybe<Scalars['String']>;
  subId: Maybe<Scalars['String']>;
};

export type InvalidIdentityTokenException = {
  __typename?: 'InvalidIdentityTokenException';
  message: Maybe<Scalars['String']>;
};

/** Invalid Investment Account */
export type InvalidInvestmentAccountException = {
  __typename?: 'InvalidInvestmentAccountException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Last Name does not meet validity criteria */
export type InvalidLastNameException = {
  __typename?: 'InvalidLastNameException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** This account is not supported */
export type InvalidManualLink = {
  __typename?: 'InvalidManualLink';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type InvalidMfaTokenException = {
  __typename?: 'InvalidMfaTokenException';
  userId: Maybe<Scalars['ID']>;
};

export type InvalidOauthAppClientIdException = {
  __typename?: 'InvalidOauthAppClientIdException';
  oauthAppClientId: Scalars['ID'];
};

export type InvalidOptionException = {
  __typename?: 'InvalidOptionException';
  message: Scalars['String'];
};

export type InvalidPasswordException = {
  __typename?: 'InvalidPasswordException';
  message: Maybe<Scalars['String']>;
};

export type InvalidPasswordResetException = {
  __typename?: 'InvalidPasswordResetException';
  errors: Array<PasswordResetErrors>;
};

export type InvalidPasswordResetTokenException = {
  __typename?: 'InvalidPasswordResetTokenException';
  invalidToken: Scalars['String'];
};

/** Invalid Phone Number */
export type InvalidPhoneException = {
  __typename?: 'InvalidPhoneException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type InvalidPhoneNumberException = {
  __typename?: 'InvalidPhoneNumberException';
  message: Maybe<Scalars['String']>;
};

export type InvalidPinException = {
  __typename?: 'InvalidPinException';
  message: Maybe<Scalars['String']>;
};

/** Portfolio ID must be valid */
export type InvalidPortfolioIdException = {
  __typename?: 'InvalidPortfolioIdException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type InvalidPromoCodeError = {
  __typename?: 'InvalidPromoCodeError';
  name: Scalars['String'];
};

export type InvalidReferralRelationship = {
  __typename?: 'InvalidReferralRelationship';
  message: Scalars['String'];
};

/** The routing number provided is unsupported or invalid */
export type InvalidRoutingNumber = {
  __typename?: 'InvalidRoutingNumber';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** The provided security is not valid for allocation */
export type InvalidSecurityError = {
  __typename?: 'InvalidSecurityError';
  /** ID of the invalid security */
  securityId: Scalars['ID'];
};

/** Invalid Security For Allocation */
export type InvalidSecurityForAllocationError = {
  __typename?: 'InvalidSecurityForAllocationError';
  reason: InvalidSecurityForAllocationReasonEnum;
  /** ID of the invalid security */
  securityId: Scalars['ID'];
};

export enum InvalidSecurityForAllocationReasonEnum {
  SECURITY_DEACTIVATED = 'SECURITY_DEACTIVATED'
}

/** Returned when a given singleRuleId does not match with a rule in the ruleset to be updated */
export type InvalidSingleRuleIdError = {
  __typename?: 'InvalidSingleRuleIdError';
  message: Scalars['String'];
};

/** Occurs when attribution does not match standardized attributes */
export type InvalidSourceAttributesException = {
  __typename?: 'InvalidSourceAttributesException';
  incorrectAttributes: Array<Scalars['String']>;
};

/** SSN does not meet validity criteria */
export type InvalidSsnException = {
  __typename?: 'InvalidSsnException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Custodian is not able to open an account based on their residential address */
export type InvalidStateException = {
  __typename?: 'InvalidStateException';
  /** message */
  message: Maybe<Scalars['String']>;
  /** Custodian's State */
  state: Maybe<Scalars['String']>;
};

/** User is not in the correct subscription tier for the requested investment account */
export type InvalidSubscriptionTierException = {
  __typename?: 'InvalidSubscriptionTierException';
  /** User current subscription tier */
  currentUserTierKey: Maybe<Scalars['String']>;
};

/** The given termination age is not valid for the custodian's state */
export type InvalidTerminationAgeException = {
  __typename?: 'InvalidTerminationAgeException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type InvalidTier = {
  __typename?: 'InvalidTier';
  message: Scalars['String'];
  validTiers: Array<Tier>;
};

export type InvalidTierForMigrationError = {
  __typename?: 'InvalidTierForMigrationError';
  message: Scalars['String'];
};

export type InvalidTierPrice = {
  __typename?: 'InvalidTierPrice';
  message: Scalars['String'];
  validTierPrices: Array<TierPrice>;
};

export type InvalidTierPriceCombination = {
  __typename?: 'InvalidTierPriceCombination';
  message: Scalars['String'];
  tier: Tier;
};

/** Returned if there is no available tier based on the provided tierPriceId */
export type InvalidTierPriceId = {
  __typename?: 'InvalidTierPriceId';
  message: Scalars['String'];
};

export type InvalidUserIdException = {
  __typename?: 'InvalidUserIdException';
  message: Scalars['String'];
};

export type InvalidUserTokenException = {
  __typename?: 'InvalidUserTokenException';
  userTokenId: Scalars['ID'];
};

export type InvestHistorySummary = PastSummary & {
  __typename?: 'InvestHistorySummary';
  dividends: CurrencyAmount;
  earnRewards: CurrencyAmount;
  moneyIn: CurrencyAmount;
  moneyOut: CurrencyAmount;
  referralRewards: CurrencyAmount;
};

/** Enum for valid keys in Investing Strategy Factors */
export enum InvestingStrategyFactorKey {
  AGE = 'AGE',
  ANNUAL_INCOME = 'ANNUAL_INCOME',
  COMBINED_ANNUAL_INCOME = 'COMBINED_ANNUAL_INCOME',
  EMPLOYEES = 'EMPLOYEES',
  EMPLOYMENT_STATUS = 'EMPLOYMENT_STATUS',
  FILING_TYPE = 'FILING_TYPE',
  FINANCIAL_EDUCATION = 'FINANCIAL_EDUCATION',
  INVESTMENT_GOAL = 'INVESTMENT_GOAL',
  MARITAL_STATUS = 'MARITAL_STATUS',
  NET_WORTH = 'NET_WORTH',
  NET_WORTH_ESTIMATE = 'NET_WORTH_ESTIMATE',
  SELF_EMPLOYED_INCOME = 'SELF_EMPLOYED_INCOME',
  THEME = 'THEME'
}

/** Factors affecting outcome of recommendation */
export type InvestingStrategyFactors = {
  key: InvestingStrategyFactorKey;
  value: Scalars['JSON'];
};

/** Investment class fields declarations and definitions */
export type Investment = {
  __typename?: 'Investment';
  allocations: Maybe<Array<InvestmentAllocation>>;
  /**
   * Non-negative dollar amount invested as either a credit or debit. Debit amounts are not guaranteed to match the original requested amount due to market fluctuation.
   * @deprecated Use the more explicit requestedAmount and transferredAmount fields.
   */
  amount: Scalars['Float'];
  /** Amount collected by Acorns to cover owed money. */
  amountCollected: Maybe<MonetaryAmount>;
  /** Cash Owed from chargeback on this investment. */
  cashOwed: Maybe<MonetaryAmount>;
  createdAt: Scalars['DateTime'];
  /** @deprecated Legacy field do not use will always be null. */
  description: Maybe<Scalars['String']>;
  /** @deprecated Legacy field do not use will always be null. */
  details: Maybe<Scalars['JSON']>;
  /** Dividend's security name */
  dividendInvestmentSecurityName: Maybe<Scalars['String']>;
  /** Dividend's security ticker */
  dividendInvestmentSecurityTicker: Maybe<Scalars['String']>;
  /** Stubbed Field: Campaign ID for found money reward investment */
  earnRewardCampaignId: Maybe<Scalars['ID']>;
  /** Name of partner for found money reward investment */
  earnRewardInvestmentPartner: Maybe<Scalars['String']>;
  /** Url logo for found money reward investment */
  earnRewardInvestmentPartnerLogoUrl: Maybe<Scalars['URL']>;
  /** Type of earn reward investment */
  earnRewardInvestmentType: Maybe<EarnRewardInvestType>;
  /** Estimated date for an investment to be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  executionDate: Maybe<Scalars['DateTime']>;
  /** Holdings Transfer Information */
  holdingsTransfer: Maybe<HoldingsTransfer>;
  /** Unique identifier of the Investment. */
  id: Scalars['ID'];
  /** Investment account details */
  investmentAccount: InvestmentAccount;
  /** Stubbed Field: Status of investment */
  investmentStatus: Maybe<InvestmentStatusV2>;
  /** Transaction type of the investment */
  investmentTransactionType: InvestmentTransactionType;
  /** Stubbed Field: Type of investment */
  investmentType: Maybe<InvestmentType>;
  /** An IRA Distribution or a withdraw investment for Later account */
  iraDistribution: Maybe<IraDistribution>;
  moneyManagerAllocation: Maybe<MoneyManagerAllocation>;
  /** Unique nonce for the investment */
  nonce: Maybe<Scalars['ID']>;
  /** Note for outside contribution investment */
  outsideContributionNote: Maybe<Scalars['String']>;
  /** Name of the person who made an outside contribution */
  outsideContributionNoteAuthor: Maybe<Scalars['String']>;
  pending: Maybe<Scalars['Boolean']>;
  /** Percentage of match a credit Match investment received */
  percentageMatch: Maybe<Scalars['Float']>;
  receivedAt: Maybe<Scalars['DateTime']>;
  /** Reason for the reinvestment */
  reinvestmentReason: Maybe<ReinvestmentReason>;
  requestedAmount: MonetaryAmount;
  reversible: Scalars['Boolean'];
  /** Stubbed Field: Name for round up investment */
  roundUpMerchantName: Maybe<Scalars['String']>;
  /** Stubbed Field: Multiplier for round up invesment */
  roundUpMultiplier: Maybe<Scalars['Int']>;
  /** Stubbed Field: Transaction amount for round up investment */
  roundUpTransactionAmount: Maybe<MonetaryAmount>;
  /** Type of the round up */
  roundUpType: Maybe<InvestmentRoundUpType>;
  /** @deprecated Legacy field do not use will always be null. */
  shares: Maybe<Scalars['Int']>;
  /** @deprecated Legacy field do not use will cause operations to fail. */
  status: InvestmentStatus;
  /** URLs that can be used to download documentation of the trade */
  tradeConfirmationUrls: Maybe<Array<Scalars['URL']>>;
  /** Stubbed Field: Exact traded amount for an investment after considering other factors; ex: cash owed deductions */
  tradedAmount: Maybe<MonetaryAmount>;
  transferredAmount: Maybe<MonetaryAmount>;
  type: Scalars['String'];
  /** @deprecated Legacy field do not use will always be null. */
  typeHelp: Maybe<Scalars['String']>;
  /** User ID for the investment */
  userId: Scalars['ID'];
};

/** Investment Account Object */
export type InvestmentAccount = TimestampsInterface & {
  __typename?: 'InvestmentAccount';
  beneficiary: Maybe<Beneficiary>;
  /** Internal ID of the beneficiary */
  beneficiaryId: Maybe<Scalars['ID']>;
  cashBalance: MonetaryAmount;
  cashOwed: MonetaryAmount;
  closedAt: Maybe<Scalars['DateTime']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  currentBalance: Maybe<MonetaryAmount>;
  currentBalanceWithPending: MonetaryAmount;
  /** Whether or not the user has made their first investment on this account. */
  hasInvested: Scalars['Boolean'];
  /** Internal UUID of the Investment Account */
  id: Scalars['ID'];
  investmentAccountType: InvestmentAccountType;
  /** Name of the Investment Account */
  name: Scalars['String'];
  /** The net investments in this investment account. */
  netInvestments: MonetaryAmount;
  pendingBalance: MonetaryAmount;
  pendingWithdrawals: Array<Withdrawal>;
  performance: Maybe<Performance>;
  portfolio: Maybe<Portfolio>;
  portfolios: Maybe<Array<BasePortfolio>>;
  product: InvestmentProduct;
  /** Recap of the investment account's activity and statistics over the last quarter. */
  quarterlyRecap: Maybe<InvestmentAccountRecap>;
  /** Whether or not quarterly recap generation is enabled for this investment account. */
  quarterlyRecapsEnabled: Scalars['Boolean'];
  recommendedPortfolio: Maybe<Portfolio>;
  recurringInvestmentSettings: Maybe<RecurringInvestmentSettings>;
  /** The current status of the account */
  requirements: AccountRequirements;
  /** The all-time returns in this investment account. */
  returnsAllTime: MonetaryAmount;
  status: InvestmentAccountStatus;
  summary: InvestmentAccountSummary;
  /** The total account value in this investment account. */
  totalAccountValue: MonetaryAmount;
  /** The total amount that is invested in bonds in this investment account. */
  totalBonds: MonetaryAmount;
  /** The total amount that is invested in crypto in this investment account. */
  totalCrypto: MonetaryAmount;
  /** The total amount that is invested in equities in this investment account. */
  totalEquities: MonetaryAmount;
  /** Total matched contributions all-time. */
  totalMatched: MonetaryAmount;
  /** Total matched contribution amount by tax year. */
  totalMatchedByYear: MonetaryAmount;
  transferability: Maybe<InvestmentAccountTransferability>;
  trustedContact: Maybe<TrustedContact>;
  type: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** Age of the account owner */
  userAge: Maybe<Scalars['Int']>;
  /** UUID for the user */
  userId: Scalars['ID'];
  /** @deprecated Use id instead. */
  uuid: Scalars['ID'];
  /** Withdrawing from this account would incur a tax penalty */
  withdrawalsIncurTaxPenalty: Maybe<Scalars['Boolean']>;
  yearToDateReturn: Maybe<MarketReturn>;
};


/** Investment Account Object */
export type InvestmentAccountPerformanceArgs = {
  days: Scalars['Int'];
};


/** Investment Account Object */
export type InvestmentAccountSummaryArgs = {
  endPeriod?: InputMaybe<Scalars['Date']>;
  startPeriod?: InputMaybe<Scalars['Date']>;
};


/** Investment Account Object */
export type InvestmentAccountTotalMatchedByYearArgs = {
  year: Scalars['Int'];
};

export type InvestmentAccountAlreadyClosed = {
  __typename?: 'InvestmentAccountAlreadyClosed';
  /** Date and Time of account closure if account is already closed */
  accountClosedAt: Scalars['DateTime'];
};

export type InvestmentAccountClosureInProgress = {
  __typename?: 'InvestmentAccountClosureInProgress';
  /** Message displayed to customer when closure is already in progress */
  clientMessage: Scalars['String'];
};

export enum InvestmentAccountClosureReason {
  /** Can't afford at this time */
  CANT_AFFORD_AT_THIS_TIME = 'CANT_AFFORD_AT_THIS_TIME',
  /** Change age of transfer */
  CHANGE_AGE_OF_TRANSFER = 'CHANGE_AGE_OF_TRANSFER',
  /** Going to a competitor */
  GOING_TO_A_COMPETITOR = 'GOING_TO_A_COMPETITOR',
  /** Had a bad experience */
  HAD_A_BAD_EXPERIENCE = 'HAD_A_BAD_EXPERIENCE',
  /** Not seeing the value */
  NOT_SEEING_THE_VALUE = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NO_LONGER_USE = 'NO_LONGER_USE',
  /** Other */
  OTHER = 'OTHER',
  /** Rolling over to another ira */
  ROLLING_OVER_TO_ANOTHER_IRA = 'ROLLING_OVER_TO_ANOTHER_IRA',
  /** Switching to another savings plan */
  SWITCHING_TO_ANOTHER_SAVINGS_PLAN = 'SWITCHING_TO_ANOTHER_SAVINGS_PLAN',
  /** Using funds for another purpose */
  USING_FUNDS_FOR_ANOTHER_PURPOSE = 'USING_FUNDS_FOR_ANOTHER_PURPOSE',
  /** Using funds for the good of the child */
  WITHDRAWAL_FOR_CHILD = 'WITHDRAWAL_FOR_CHILD'
}

/** The state of a customers request to close an Investment Account. Only one may be active at a time. */
export type InvestmentAccountClosureRequest = {
  __typename?: 'InvestmentAccountClosureRequest';
  id: Scalars['ID'];
};

/** Generic Error */
export type InvestmentAccountCreationException = {
  __typename?: 'InvestmentAccountCreationException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Investment account must transfer funds before closure */
export type InvestmentAccountNeedsTransferException = {
  __typename?: 'InvestmentAccountNeedsTransferException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** The investment account is still open. */
export type InvestmentAccountNotClosedException = {
  __typename?: 'InvestmentAccountNotClosedException';
  /** Type of investment account */
  accountType: Maybe<InvestmentAccountType>;
};

/** Investment Account Not Found */
export type InvestmentAccountNotFoundException = {
  __typename?: 'InvestmentAccountNotFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Investment Account Not Supported */
export type InvestmentAccountNotSupportedException = {
  __typename?: 'InvestmentAccountNotSupportedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Outside contribution made to an investment account. */
export type InvestmentAccountOutsideContribution = {
  __typename?: 'InvestmentAccountOutsideContribution';
  /** Monetary amount of the contribution. */
  amount: MonetaryAmount;
  /** Name of the contributor */
  contributorName: Scalars['String'];
  /** Note from the contributor. */
  note: Maybe<Scalars['String']>;
};

/** Aggregation of investment account activity and stats over a period of time. */
export type InvestmentAccountRecap = {
  __typename?: 'InvestmentAccountRecap';
  /** Age of the investment account's beneficiary. */
  beneficiaryAge: Maybe<Scalars['Int']>;
  /** Nickname of the investment account's custodian. */
  beneficiaryCustodianNickname: Maybe<Scalars['String']>;
  /** First name of the investment account's beneficiary. */
  beneficiaryFirstName: Maybe<Scalars['String']>;
  /** Last name of the investment account's beneficiary. */
  beneficiaryLastName: Maybe<Scalars['String']>;
  /** Contributions to the investment account made by non-owners. */
  contributionsByOthers: Maybe<Array<InvestmentAccountOutsideContribution>>;
  /** Creation date of the investment account recap. */
  createdAt: Scalars['Date'];
  /** Start date of the investment account recap. */
  endsAt: Scalars['Date'];
  /** Unique identifier of the investment account recap. */
  id: Scalars['ID'];
  /** Investment account for which the recap was generated for. */
  investmentAccount: InvestmentAccount;
  /** Unique identifier of the investment account for which the investment account recap was generated for. */
  investmentAccountId: Scalars['ID'];
  /** Latest value of the investment account over the timeframe of the recap. */
  latestAccountValue: Maybe<MonetaryAmount>;
  /** Market value of the investment account over the timeframe. */
  performance: Maybe<Performance>;
  /** Whether or not the recap has public access enabled. */
  public: Scalars['Boolean'];
  /** Web URL that the recap is publicly available at. */
  publicUrl: Maybe<Scalars['URL']>;
  /** Start date of the investment account recap. */
  startsAt: Scalars['Date'];
  /** Total amount contributed to the investment account over the timeframe. */
  totalContributions: Maybe<MonetaryAmount>;
  /** Total amount contributed to the investment account by non-owners over the timeframe. Only applies to UGMA and UTMA type investment accounts. */
  totalContributionsByOthers: Maybe<MonetaryAmount>;
  /** Date of last update made to the investment account recap. */
  updatedAt: Scalars['Date'];
  /** Record of whether or not the recap has been viewed by the investment account owner. */
  viewed: Scalars['Boolean'];
};

/** Investment Account Recap Not Found */
export type InvestmentAccountRecapNotFoundException = {
  __typename?: 'InvestmentAccountRecapNotFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export enum InvestmentAccountReopenCheck {
  /** Account locked check */
  ACCOUNT_LOCKED_CHECK = 'ACCOUNT_LOCKED_CHECK',
  /** Account suspended check */
  ACCOUNT_SUSPENDED_CHECK = 'ACCOUNT_SUSPENDED_CHECK',
  /** Backup withholding check */
  BACKUP_WITHHOLDING_CHECK = 'BACKUP_WITHHOLDING_CHECK',
  /** Investment collections check */
  INVESTMENT_COLLECTIONS_CHECK = 'INVESTMENT_COLLECTIONS_CHECK',
  /** Spend collections check */
  SPEND_COLLECTIONS_CHECK = 'SPEND_COLLECTIONS_CHECK',
  /** Underage check */
  UNDERAGE_CHECK = 'UNDERAGE_CHECK'
}

/** An investment account reopen request */
export type InvestmentAccountReopenRequest = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequest';
  /** A list of actions performed on this account reopen request */
  adminActions: Array<InvestmentAccountReopenRequestAction>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** The ID of the reopen request */
  id: Scalars['Int'];
  /** The investment account for which this reopen request was made */
  investmentAccount: InvestmentAccount;
  /** The UUID of the investment account for which this request was made */
  investmentAccountId: Scalars['ID'];
  /** A list of update notes for this investment account reopen request */
  notes: Array<InvestmentAccountReopenRequestNote>;
  /** A list of reopen checks for this investment account reopen request */
  reopenChecks: Array<UserInvestmentAccountReopenCheck>;
  /** The state of the investment account reopen request */
  state: InvestmentAccountReopenRequestState;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** The owner of the investment account associated with the reopen_request */
  user: User_V2;
  /** The ID of the user to whom the investment account the request was made for belongs */
  userId: Scalars['Int'];
};

/** An admin action performed on an investment account reopen request */
export type InvestmentAccountReopenRequestAction = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestAction';
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** The starting state of the reopen request */
  fromState: Scalars['String'];
  /** The UUID of the reopen request admin action */
  id: Scalars['ID'];
  /** The investment account for the corresponding reopen request */
  investmentAccount: InvestmentAccount;
  /** A note associated with this action */
  note: Maybe<InvestmentAccountReopenRequestNote>;
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest;
  /** The end state of the reopen request */
  toState: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** A note sent to the user regarding an investment account reopen request */
export type InvestmentAccountReopenRequestNote = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestNote';
  /** The action associated with this note */
  adminAction: InvestmentAccountReopenRequestAction;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** A boolean indicating if an email has been sent for this note */
  emailSent: Scalars['Boolean'];
  /** The UUID of the reopen request note */
  id: Scalars['ID'];
  /** The note text */
  note: Scalars['String'];
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export enum InvestmentAccountReopenRequestState {
  /** Indicates that the request has been approved */
  APPROVED = 'APPROVED',
  /** Indicates that the request must be reviewed by invest ops */
  PENDING_REVIEW = 'PENDING_REVIEW',
  /** Indicates that the request is pending user action */
  PENDING_USER_ACTION = 'PENDING_USER_ACTION',
  /** Indicates that the request has been rejected */
  REJECTED = 'REJECTED',
  /** Indicates that the request has been made but not yet processed */
  REQUESTED = 'REQUESTED'
}

export enum InvestmentAccountStatus {
  /** Investment account is closed */
  CLOSED = 'CLOSED',
  /** Investment account has reached transfer age */
  LOCKED_FOR_TRANSFER = 'LOCKED_FOR_TRANSFER',
  /** Investment account is open */
  OPEN = 'OPEN',
  /** Account has started account closure process */
  PENDING_CLOSURE = 'PENDING_CLOSURE',
  /** Account has been created but is not fully activated/open */
  PENDING_OPEN = 'PENDING_OPEN',
  /** Account has started account reopen process */
  PENDING_REOPEN = 'PENDING_REOPEN'
}

/** Investment account summary data */
export type InvestmentAccountSummary = {
  __typename?: 'InvestmentAccountSummary';
  /** The date of the user's first investment into this account */
  firstInvestmentDate: Maybe<Scalars['DateTime']>;
  /** The date of the user's most recent one-time investment into this account */
  mostRecentOneTimeInvestmentDate: Maybe<Scalars['DateTime']>;
  /**
   * The total credits credited to this account.
   * @deprecated Use referral_rewards and found_money_rewards instead
   */
  totalCredits: Scalars['Float'];
  /** The total amount deposited by the user into this account. Does not include rewards */
  totalDeposits: Scalars['Float'];
  /** The total amount contributed by the user on the current year for this account */
  totalDepositsCurrentYear: Scalars['Float'];
  /** The total amount contributed by the user on the current year within the specified timeframe for this account */
  totalDepositsCurrentYearWithinTimeFrame: Scalars['Float'];
  /** The total amount contributed by the user on the previous year for this account */
  totalDepositsPreviousYear: Scalars['Float'];
  /** The total dividends invested in this account. */
  totalDividends: Scalars['Float'];
  /** The total found money rewards allocated to this account */
  totalFoundMoneyRewards: Scalars['Float'];
  /** The total amount invested into this account. Includes rewards */
  totalInvested: Scalars['Float'];
  /**
   * The total amount contributed by the user on the current year for this account
   * @deprecated Use total_deposits_current_year
   */
  totalInvestedCurrentYear: Scalars['Float'];
  /** The total amount invested into this account. Includes rewards but excludes investments created from Acorns Transfer such as from checking or emergency fund */
  totalInvestedExcludingAcornsBanking: Scalars['Float'];
  /**
   * The total amount contributed by the user on the previous year for this account
   * @deprecated Use total_deposits_previous_year
   */
  totalInvestedPreviousYear: Scalars['Float'];
  /** The total amount matched rewarded */
  totalMatchRewards: Scalars['Float'];
  /** The total amount of matched rewards removed */
  totalMatchRewardsRemovalAmount: Scalars['Float'];
  /** The total one time investments made in this account. */
  totalOneTime: Scalars['Float'];
  /** The total outside contributions to this account. */
  totalOutsideContributions: Scalars['Float'];
  /** The total plan investments invested with this account. */
  totalPlan: Scalars['Float'];
  /** The recurring investment total invested in this account. */
  totalRecurring: Scalars['Float'];
  /** The total referral rewards to this account. */
  totalReferralRewards: Scalars['Float'];
  /** The total round ups contributed to this account. */
  totalRoundUps: Scalars['Float'];
  /** The total real time round ups contributed to this account. */
  totalRtru: Scalars['Float'];
  /** The total amount withdrawn for this account */
  totalWithdrawn: Scalars['Float'];
  /** The total amount withdrawn for this account. Excludes withdrawn to Acorns accounts such as from checking or emergency fund */
  totalWithdrawnExcludingAcornsBanking: Scalars['Float'];
};

/** Transfer information for the given investment account */
export type InvestmentAccountTransferability = {
  __typename?: 'InvestmentAccountTransferability';
  /** The beneficiary investment account's age of transfer */
  transferAge: Scalars['Int'];
  /** The beneficiary investment account's date of transfer */
  transferDate: Scalars['Date'];
  /** The beneficiary investment account's age of transfer reached */
  transferReached: Scalars['Boolean'];
  /** The beneficiary investment account's state of residence */
  transferStateCode: UsStateCodes;
};

export enum InvestmentAccountType {
  /** Basic investment account */
  BASIC_INVESTMENT = 'BASIC_INVESTMENT',
  /** Roth IRA investment account */
  ROTH_IRA = 'ROTH_IRA',
  /** Simplified Employee Pension investment account */
  SIMPLIFIED_EMPLOYEE_PENSION = 'SIMPLIFIED_EMPLOYEE_PENSION',
  /** Traditional IRA investment account */
  TRADITIONAL_IRA = 'TRADITIONAL_IRA',
  /** Uniform Gift to Minors Act Custodial Investment Account */
  UGMA = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  UTMA = 'UTMA',
  /** @deprecated Use BASIC_INVESTMENT. */
  acornsInvestingAccount = 'acornsInvestingAccount',
  /** @deprecated Use ROTH_IRA */
  rothIRA = 'rothIRA',
  /** @deprecated Use SIMPLIFIED_EMPLOYEE_PENSION */
  simplifiedEmployeePension = 'simplifiedEmployeePension',
  /** @deprecated Use TRADITIONAL_IRA. */
  traditionalIRA = 'traditionalIRA'
}

export enum InvestmentAccountTypes {
  RothIRA = 'RothIRA',
  SimplifiedEmployeePension = 'SimplifiedEmployeePension',
  TraditionalIRA = 'TraditionalIRA'
}

/** Filter for InvestmentAccountsByUserId query */
export type InvestmentAccountsByUserIdFilter = {
  /** Optionally filter by account status */
  accountStatus?: InputMaybe<InvestmentAccountStatus>;
  /** Investment Account Product Name */
  product?: InputMaybe<InvestmentProduct>;
};

/** Additional pagination information */
export type InvestmentAggregation = {
  __typename?: 'InvestmentAggregation';
  totalPendingAmount: Maybe<MonetaryAmount>;
};

/** Amount of an asset that was bought or sold for a specific Investment. */
export type InvestmentAllocation = {
  __typename?: 'InvestmentAllocation';
  /** Dollar amount sold or bought of the associated security. */
  amount: Scalars['Float'];
  /** Price that the shares of the associated security were bought or sold at. */
  price: MonetaryAmount;
  /** Indicates whether the shares were allocated to a self-directed Portfolio. */
  selfDirected: Scalars['Boolean'];
  /** Shares sold or bought of the associated security. */
  shares: Scalars['Float'];
  /** Indicates the state of the holding allocated to the portfolio. */
  status: InvestmentAllocationStatus;
  /** Trading symbol of the associated security. */
  symbol: Scalars['String'];
  /** Indicates the type of holding allocated to the portfolio. */
  type: InvestmentAllocationType;
};

export enum InvestmentAllocationStatus {
  /** Shares that have been returned due to a declined funding transfer. */
  CHARGEBACK = 'CHARGEBACK',
  /** Shares that have been bought or sold but are not yet settled to the account. */
  PENDING = 'PENDING',
  /** Shares that have settled in the account. */
  SETTLED = 'SETTLED'
}

export enum InvestmentAllocationType {
  BUY = 'BUY',
  SELL = 'SELL'
}

export type InvestmentCategory = {
  __typename?: 'InvestmentCategory';
  bond: Scalars['Float'];
  crypto: Scalars['Float'];
  equity: Scalars['Float'];
  realEstate: Scalars['Float'];
};

/** An individual edge within the paginated list of Investment */
export type InvestmentEdge = {
  __typename?: 'InvestmentEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID'];
  /** The Investment record in the edge */
  node: Investment;
};

export enum InvestmentFrequency {
  daily = 'daily',
  monthly = 'monthly',
  weekly = 'weekly'
}

export enum InvestmentGoal {
  /** User is looking for a balanced portfolio */
  BALANCED = 'BALANCED',
  /** User is looking for conservative growth in their investments */
  CONSERVATIVE = 'CONSERVATIVE',
  /** User is looking for exponential growth in their investments */
  EXPONENTIAL_GROWTH = 'EXPONENTIAL_GROWTH',
  /** User is looking for moderate growth in their investments */
  MODERATE_GROWTH = 'MODERATE_GROWTH',
  /** User is looking to reduce risk in their investments */
  REDUCED_RISK = 'REDUCED_RISK'
}

/** When investment id and investment account id do not match */
export type InvestmentNotFoundException = {
  __typename?: 'InvestmentNotFoundException';
  /** ID */
  id: Maybe<Scalars['ID']>;
};

/** Relay style pagination information for Investment */
export type InvestmentPagination = {
  __typename?: 'InvestmentPagination';
  aggregation: Maybe<InvestmentAggregation>;
  edges: Array<InvestmentEdge>;
  pageInfo: PageInfo;
};

export enum InvestmentProduct {
  /** Early investment product */
  EARLY = 'EARLY',
  /** Invest investment product */
  INVEST = 'INVEST',
  /** Later investment product */
  LATER = 'LATER'
}

export enum InvestmentRoundUpType {
  AUTOMATIC = 'AUTOMATIC',
  REAL_TIME = 'REAL_TIME'
}

export enum InvestmentStatus {
  all = 'all',
  finished = 'finished',
  unfinished = 'unfinished'
}

/** Investment statuses that are used by frontend clients and external queries */
export enum InvestmentStatusV2 {
  /** Investment not translated */
  NOT_TRANSLATED = 'NOT_TRANSLATED',
  /** Investment pending authorization */
  PENDING = 'PENDING',
  /** Investment refunded */
  REFUNDED = 'REFUNDED',
  /** Investment returned */
  RETURNED = 'RETURNED',
  /** Investment reversed */
  REVERSED = 'REVERSED',
  /** Investment revoked */
  REVOKED = 'REVOKED',
  /** Investment settled */
  SETTLED = 'SETTLED',
  /** Investment transferred */
  TRANSFERRING = 'TRANSFERRING'
}

export enum InvestmentTransactionType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

/** All investment types */
export enum InvestmentType {
  AUTOMATED_REBALANCE = 'AUTOMATED_REBALANCE',
  CASH_OWED_COLLECTION = 'CASH_OWED_COLLECTION',
  CASH_REINVESTMENT = 'CASH_REINVESTMENT',
  DIRECT_DEPOSIT_SPLIT = 'DIRECT_DEPOSIT_SPLIT',
  DIVIDEND = 'DIVIDEND',
  EARLY_GIFT = 'EARLY_GIFT',
  EARN_REWARD = 'EARN_REWARD',
  FEE = 'FEE',
  GIFT_CARD = 'GIFT_CARD',
  HOLDINGS_TRANSFER = 'HOLDINGS_TRANSFER',
  IRA_TRANSFER = 'IRA_TRANSFER',
  MATCH = 'MATCH',
  MATCH_REMOVAL = 'MATCH_REMOVAL',
  ONE_TIME_INVESTMENT = 'ONE_TIME_INVESTMENT',
  RECURRING_INVESTMENT = 'RECURRING_INVESTMENT',
  REFUND = 'REFUND',
  REVERSAL = 'REVERSAL',
  ROUND_UP = 'ROUND_UP',
  SECURITY_LIQUIDATION = 'SECURITY_LIQUIDATION',
  WITHDRAWAL = 'WITHDRAWAL'
}

/** Types of investments available */
export enum InvestmentTypes {
  /** Credit investment (lump sum deposit) */
  credit = 'credit',
  /** Debit investment (withdrawal) */
  debit = 'debit'
}

/** Investment cannot be cancelled */
export type InvestmentUncancellableException = {
  __typename?: 'InvestmentUncancellableException';
  /** ID */
  id: Maybe<Scalars['ID']>;
};

/** Investments Paused user alert. */
export type InvestmentsPausedUserAlert = UserAlertsItem & {
  __typename?: 'InvestmentsPausedUserAlert';
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export type InvestorQuestionsInput = {
  employedAffiliatedWithBrokerDealer?: InputMaybe<Scalars['Boolean']>;
  shareholderOrDirector?: InputMaybe<Scalars['Boolean']>;
  subjectToBackupWithholding?: InputMaybe<Scalars['Boolean']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Scalars['DateTime'];
  id: Scalars['ReferralCode'];
};

/** Type wrapper for the Invoice object from the billing vendor */
export type Invoice = {
  __typename?: 'Invoice';
  account: Maybe<VendorCustomerAccount>;
  id: Maybe<Scalars['String']>;
  lineItems: Maybe<Array<Maybe<InvoiceLineItem>>>;
  lineItemsAmountSum: Maybe<Scalars['Float']>;
  /**
   * Default type for state is 'all'.
   * Possible types are 'open', 'pending', 'processing', 'past_due', 'paid', 'closed', 'failed', 'voided'
   */
  state: Maybe<Scalars['String']>;
  uuid: Maybe<Scalars['String']>;
};

export type InvoiceCollection = {
  __typename?: 'InvoiceCollection';
  chargeInvoice: Maybe<Invoice>;
  creditInvoices: Maybe<Array<Maybe<Invoice>>>;
  object: Maybe<Scalars['String']>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  discount: Maybe<Scalars['Float']>;
  discountAmount: Maybe<Scalars['Float']>;
  feeCategory: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  addOnCode: Maybe<Scalars['String']>;
  addOnId: Maybe<Scalars['String']>;
  amount: Maybe<Scalars['Float']>;
  description: Maybe<Scalars['String']>;
  discount: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['String']>;
  object: Maybe<Scalars['String']>;
  origin: Maybe<Scalars['String']>;
  /** Possible types are 'invoiced' and 'pending' */
  state: Maybe<Scalars['String']>;
  subtotal: Maybe<Scalars['Float']>;
  type: Maybe<Scalars['String']>;
};

/** Job alert display info */
export type JobAlert = {
  __typename?: 'JobAlert';
  id: Scalars['ID'];
  /** desired job description */
  keyPhrase: Scalars['String'];
  /** desired job location */
  location: Scalars['String'];
};

/** Specifies the alert criteria */
export type JobAlertCriteriaInput = {
  filters: Array<JobSearchFilterInput>;
  location: JobLocationInput;
};

export type JobLocation = {
  __typename?: 'JobLocation';
  city: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type JobLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  /** flexible text field to input location as a single string (e.g. "New York, NY 10010" */
  value?: InputMaybe<Scalars['String']>;
};

export type JobOffer = {
  __typename?: 'JobOffer';
  /** Company logo or generic default */
  companyLogo: Image;
  /** Hiring company */
  companyName: Scalars['String'];
  id: Scalars['ID'];
  /** Relevant job industry */
  industryName: Maybe<Scalars['String']>;
  /** Job role */
  jobName: Scalars['String'];
  /** Job location */
  location: OfferLocation;
  /** Salary details */
  salary: Maybe<JobOfferSalary>;
  /** List of tags to display */
  tags: Array<Scalars['String']>;
  /** Redirect URL for job posting */
  url: Scalars['URL'];
};

export type JobOfferSalary = {
  __typename?: 'JobOfferSalary';
  interval: SalaryInterval;
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
};

/** Specifies the search criteria */
export type JobSearchCriteria = {
  __typename?: 'JobSearchCriteria';
  filters: Array<JobSearchFilter>;
  location: JobLocation;
  /** Specifies the search radius in miles */
  searchRadius: Maybe<Scalars['Int']>;
};

/** Specifies the search criteria */
export type JobSearchCriteriaInput = {
  filters: Array<JobSearchFilterInput>;
  location: JobLocationInput;
  searchRadius?: InputMaybe<Scalars['Int']>;
};

/** Specifies which values to filter jobs by */
export type JobSearchFilter = {
  __typename?: 'JobSearchFilter';
  key: JobSearchFilterKey;
  value: Scalars['String'];
};

/** Specifies which values to filter jobs by */
export type JobSearchFilterInput = {
  key: JobSearchFilterKey;
  value: Scalars['String'];
};

/** Supported types of search criteria */
export enum JobSearchFilterKey {
  /** finds jobs with exact match for company name */
  COMPANY = 'COMPANY',
  /** finds jobs that have metadata matching this phrase */
  KEY_PHRASE = 'KEY_PHRASE'
}

/** Display wrapper for featured job searches */
export type JobSearchOffer = {
  __typename?: 'JobSearchOffer';
  /** Background/featured image */
  backgroundImage: Image;
  /** Display body for the offer */
  body: Maybe<Scalars['String']>;
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image;
  id: Scalars['ID'];
  /** Company/partner logo */
  logo: Maybe<Image>;
  /** List of filters used when searching for jobs */
  searchFilters: Array<JobSearchFilter>;
  /** Display subtitle for the offer */
  subtitle: Maybe<Scalars['String']>;
  /** Display title for the offer */
  title: Scalars['String'];
};

export type JobSearchPage = {
  __typename?: 'JobSearchPage';
  recentSearches: Array<JobSearchCriteria>;
};

export enum KycStatus {
  accepted = 'accepted',
  actionRequired = 'actionRequired',
  failure = 'failure',
  pending = 'pending'
}

export type LadderLinkResponse = {
  __typename?: 'LadderLinkResponse';
  id: Scalars['ID'];
  url: Scalars['String'];
  urlExpires: Scalars['Int'];
};

export type LadderQuote = {
  __typename?: 'LadderQuote';
  coverage: Maybe<Scalars['Int']>;
  monthlyPremium: Maybe<Scalars['Float']>;
  term: Maybe<Scalars['Int']>;
};

export type LadderQuoteStatus = {
  __typename?: 'LadderQuoteStatus';
  complete: Maybe<Scalars['Boolean']>;
  eligible: Maybe<Scalars['Boolean']>;
  valid: Maybe<Scalars['Boolean']>;
};

export type LadderResponse = {
  __typename?: 'LadderResponse';
  id: Scalars['String'];
  quoteStatus: Maybe<LadderQuoteStatus>;
  quotes: Array<Maybe<LadderQuote>>;
};

/** Object for a Later Account */
export type LaterAccount = {
  __typename?: 'LaterAccount';
  /** Unique identifier of the Later Account. */
  accountId: Scalars['ID'];
  /** Account number of the Later Account. */
  accountNumber: Maybe<Scalars['String']>;
  /** Amount of the Later Account. */
  amount: Scalars['Float'];
  /** Code of the Later Account. */
  code: LaterAccountCodes;
  /** Contribution limit of the Later Account. */
  contributionLimit: Scalars['Float'];
  /** Name of the Later Account. */
  name: Scalars['String'];
  /** Performance of the Later Account. */
  performance: Maybe<LaterPortfolioPerformance>;
  /** Portfolio ID of the Later Account. */
  portfolioId: Scalars['ID'];
  /** Name of the portfolio of the Later Account. */
  portfolioName: Scalars['String'];
  /** Recurring investment settings for the account. */
  recurringSettings: Maybe<RecurringInvestmentSettings>;
  /** Status of the Later Account. */
  status: Maybe<LaterAccountStatus>;
};

export type LaterAccountAlreadyVerified = LaterTypedException & {
  __typename?: 'LaterAccountAlreadyVerified';
  id: Scalars['ID'];
  message: Scalars['String'];
};

/** All later account codes */
export enum LaterAccountCodes {
  ROTH = 'ROTH',
  SEP = 'SEP',
  TRADITIONAL = 'TRADITIONAL'
}

export type LaterAccountIneligibleForVerification = LaterTypedException & {
  __typename?: 'LaterAccountIneligibleForVerification';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type LaterAccountInfo = {
  __typename?: 'LaterAccountInfo';
  investmentAccountId: Scalars['ID'];
  plan: InvestmentAccountTypes;
  status: LaterAccountStatus;
  userId: Scalars['ID'];
};

export type LaterAccountInfoOrError = LaterAccountAlreadyVerified | LaterAccountIneligibleForVerification | LaterAccountInfo | LaterAccountNotFound;

export type LaterAccountNotFound = LaterTypedException & {
  __typename?: 'LaterAccountNotFound';
  id: Scalars['ID'];
  message: Scalars['String'];
};

/** When required taxWithholdings information was not provided for a Later account */
export type LaterAccountRequiresTaxWithholdings = {
  __typename?: 'LaterAccountRequiresTaxWithholdings';
  /** message */
  errorMessage: Maybe<Scalars['String']>;
};

/** When required withdrawalReason information was not provided for a Later account */
export type LaterAccountRequiresWithdrawalReason = {
  __typename?: 'LaterAccountRequiresWithdrawalReason';
  /** message */
  errorMessage: Maybe<Scalars['String']>;
};

/** All later account statuses */
export enum LaterAccountStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  FAILED_TO_CREATE = 'FAILED_TO_CREATE',
  HIDDEN = 'HIDDEN',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING'
}

/** When the sum of the required taxWithholdings information exceeded 100 */
export type LaterAccountTaxWithholdingsPercentageExceeded = {
  __typename?: 'LaterAccountTaxWithholdingsPercentageExceeded';
  /** message */
  errorMessage: Maybe<Scalars['String']>;
};

export type LaterBeneficiary = {
  accountId: Scalars['String'];
  beneficiaryId: Maybe<Scalars['ID']>;
  percentageShare: Maybe<Scalars['Float']>;
  type: Maybe<BeneficiaryType>;
};

export type LaterContributionAbilityResult = ContributionAbilityByYear;

export type LaterContributionLimitMet = {
  __typename?: 'LaterContributionLimitMet';
  year: Scalars['Int'];
};

/** Sell shares to pay down cash owed by the customer. */
export type LaterDebtCollectionItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterDebtCollectionItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type LaterDividendsItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterDividendsItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  etfCategory: Scalars['String'];
  etfTicker: Scalars['String'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type LaterFeeInvestmentItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterFeeInvestmentItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type LaterFullContributionSuccess = {
  __typename?: 'LaterFullContributionSuccess';
  year: Scalars['Int'];
};

export type LaterHistoryItem = {
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  pending: Maybe<Scalars['Boolean']>;
  reversible: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  taxYear: Scalars['Int'];
  tradeConfirmUrl: Maybe<Scalars['String']>;
  type: Maybe<LaterHistoryItemType>;
};

export enum LaterHistoryItemType {
  deposit = 'deposit',
  rollover = 'rollover',
  transfer = 'transfer',
  withdrawal = 'withdrawal'
}

export type LaterHistorySummary = PastSummary & {
  __typename?: 'LaterHistorySummary';
  currentYear: Scalars['String'];
  dividends: CurrencyAmount;
  iraMatchRewards: CurrencyAmount;
  moneyIn: CurrencyAmount;
  moneyOut: CurrencyAmount;
  previousYear: Scalars['String'];
  previousYearContributions: CurrencyAmount;
};

export type LaterIndividualBeneficiary = LaterBeneficiary & {
  __typename?: 'LaterIndividualBeneficiary';
  accountId: Scalars['String'];
  addressLine1: Maybe<Scalars['String']>;
  addressLine2: Maybe<Scalars['String']>;
  beneficiaryId: Maybe<Scalars['ID']>;
  birthDate: Scalars['DateTime'];
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  percentageShare: Maybe<Scalars['Float']>;
  relationship: Scalars['String'];
  state: Maybe<Scalars['String']>;
  type: Maybe<BeneficiaryType>;
  zip: Maybe<Scalars['String']>;
};

export type LaterIndividualBeneficiaryResponse = {
  __typename?: 'LaterIndividualBeneficiaryResponse';
  accountId: Scalars['ID'];
  addressLine1: Maybe<Scalars['String']>;
  addressLine2: Maybe<Scalars['String']>;
  beneficiaryId: Scalars['ID'];
  birthDate: Maybe<Scalars['DateTime']>;
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  percentageShare: Maybe<Scalars['Float']>;
  relationship: Scalars['String'];
  state: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
};

/** A generic money movement line item for the Later account */
export type LaterInvestmentItem = PastCoreTradedItem & PastItem & PastUserTransferItem & {
  __typename?: 'LaterInvestmentItem';
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** The percentage that the user elected for withholding */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A matching investment made into a customers account by the firm. */
export type LaterMatchItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterMatchItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A removal of matching investments made into a customers account by the firm. */
export type LaterMatchRemovalItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterMatchRemovalItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type LaterPartialContributionSuccess = {
  __typename?: 'LaterPartialContributionSuccess';
  acceptedAmount: CurrencyAmount;
  year: Scalars['Int'];
};

/** Performance of a Later Portfolio */
export type LaterPortfolioPerformance = {
  __typename?: 'LaterPortfolioPerformance';
  /** Period market change of the Later Portfolio. */
  periodMarketChange: Scalars['Float'];
  /** Period market change percent of the Later Portfolio. */
  periodMarketChangePercent: Scalars['Float'];
  /** Period market change percent without fees of the Later Portfolio. */
  periodMarketChangePercentWithoutFees: Scalars['Float'];
  /** Period market change without fees of the Later Portfolio. */
  periodMarketChangeWithoutFees: Scalars['Float'];
};

export type LaterProgramAccountContributionInput = {
  amount: CurrencyAmountInput;
  fundingTransferCreated?: InputMaybe<Scalars['Boolean']>;
  nonce: Scalars['ID'];
  programAccountType: ProgramAccountType;
  year?: InputMaybe<Scalars['Int']>;
};

export type LaterProgramAccountContributionResult = LaterContributionLimitMet | LaterFullContributionSuccess | LaterPartialContributionSuccess;

export type LaterRebalanceItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterRebalanceItem';
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Cash that is refunded to the customer */
export type LaterRefundedItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterRefundedItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Cash that is reinvested into the investment account */
export type LaterReinvestmentItem = PastCoreTradedItem & PastItem & {
  __typename?: 'LaterReinvestmentItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type LaterTypedException = {
  id: Scalars['ID'];
  message: Scalars['String'];
};

/** Object representing an outside contribution prospect */
export type LaterWaitlistProspect = Prospect & {
  __typename?: 'LaterWaitlistProspect';
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type LaterWithdrawal = LaterHistoryItem & {
  __typename?: 'LaterWithdrawal';
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  earlyDistributionTaxExceptionReason: Maybe<Scalars['String']>;
  federalTaxes: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  pending: Maybe<Scalars['Boolean']>;
  reversible: Maybe<Scalars['Boolean']>;
  stateTaxes: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  taxYear: Scalars['Int'];
  tradeConfirmUrl: Maybe<Scalars['String']>;
  type: Maybe<LaterHistoryItemType>;
  withdrawalId: Scalars['ID'];
  withdrawalType: Maybe<LaterWithdrawalType>;
};

export type LaterWithdrawalItem = PastCoreTradedItem & PastItem & PastUserTransferItem & {
  __typename?: 'LaterWithdrawalItem';
  amount: CurrencyAmount;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  federalWithholdings: Maybe<LaterWithholdingValues>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  stateWithholdings: Maybe<LaterWithholdingValues>;
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Reason for withdrawing from a later account */
export enum LaterWithdrawalReason {
  direct_transfer = 'direct_transfer',
  early_withdrawal = 'early_withdrawal',
  over_contribution = 'over_contribution',
  retirement = 'retirement',
  rollover = 'rollover'
}

/** Reason for withdrawing from a later account Deprecated - this can be derived from the LaterWithdrawalReason below */
export enum LaterWithdrawalType {
  EarlyDistribution = 'EarlyDistribution',
  IneligibleContribution = 'IneligibleContribution',
  NormalDistribution = 'NormalDistribution'
}

/** Tuple of fields related to withholdings elected at either the state or federal level */
export type LaterWithholdingValues = {
  __typename?: 'LaterWithholdingValues';
  amount: CurrencyAmount;
  /** The percentage that the user elected for withholding */
  percentage: Scalars['Float'];
};

/** Customer information used for link session */
export type LayerLinkSession = {
  __typename?: 'LayerLinkSession';
  /** City associated with address of customer */
  city: Maybe<Scalars['String']>;
  /** Country associated with address of customer */
  country: Maybe<Scalars['String']>;
  /** Date of birth of customer */
  dateOfBirth: Maybe<Scalars['Date']>;
  /** First name of customer */
  firstName: Maybe<Scalars['String']>;
  /** Last name of customer */
  lastName: Maybe<Scalars['String']>;
  linkedSubaccounts: Maybe<Array<LinkedSubaccount>>;
  /** Phone number of customer */
  phoneNumber: Scalars['String'];
  /** SSN of customer */
  ssn: Maybe<Scalars['String']>;
  /** State associated with address of customer */
  state: Maybe<Scalars['String']>;
  /** Street associated with address of customer */
  street1: Maybe<Scalars['String']>;
  /** Street (line 2) associated with address of customer */
  street2: Maybe<Scalars['String']>;
  /** Zip code associated with address of customer */
  zipCode: Maybe<Scalars['String']>;
};

/** Attributes for identifiers to create Layer session */
export type LayerLinkSessionInput = {
  /** Code to authorize user-permissioned identity information */
  publicToken: Scalars['String'];
};

export type LearnAnswer = {
  __typename?: 'LearnAnswer';
  id: Scalars['ID'];
  isCorrect: Scalars['Boolean'];
  value: Scalars['String'];
};

export type LearnAnswerInput = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type LearnArticle = {
  __typename?: 'LearnArticle';
  authors: Array<LearnAuthor>;
  body: Scalars['String'];
  contentImage: Maybe<LearnVisualAsset>;
  disclaimer: Scalars['String'];
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  featuredVideos: Array<LearnMediaReference>;
  id: Scalars['ID'];
  learnProductKey: Maybe<LearnProductKey>;
  mainBody: Scalars['String'];
  metadata: LearnMetadata;
  publishedAt: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  tags: Array<LearnTag>;
  /** @deprecated Tier will be removed */
  tier: LearnTier;
  title: Scalars['String'];
  topics: Array<LearnTopic>;
};

export type LearnArticlePreview = {
  __typename?: 'LearnArticlePreview';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  isCompleted: Scalars['Boolean'];
  primaryTopicName: Scalars['String'];
  productRequired: Maybe<Scalars['String']>;
  progress: Maybe<LearnProgress>;
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String'];
  title: Scalars['String'];
  views: Scalars['Int'];
};

export type LearnArticlePreviewLocked = {
  __typename?: 'LearnArticlePreviewLocked';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  lockedReason: Maybe<Scalars['String']>;
  primaryTopicName: Scalars['String'];
  productRequired: Scalars['String'];
  title: Scalars['String'];
  views: Scalars['Int'];
};

export enum LearnAspectRatioType {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT'
}

export type LearnAuthor = {
  __typename?: 'LearnAuthor';
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  photo: Maybe<LearnVisualAsset>;
};

export type LearnConnection = {
  edges: Array<LearnEdge>;
  pageInfo: LearnPageInfo;
};

export type LearnContentCategory = LearnTier | LearnTopic;

export type LearnContentCommunityStats = LearnContentStats;

export type LearnContentDuration = Milliseconds;

export type LearnContentElapsedMillisecondsUpdatedResult = {
  __typename?: 'LearnContentElapsedMillisecondsUpdatedResult';
  contentId: Scalars['ID'];
  elapsedTime: Milliseconds;
};

export type LearnContentFilterByTierIdInput = {
  contentType?: InputMaybe<LearnSearchContentType>;
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>;
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>;
  tierId: Scalars['ID'];
  topicId?: InputMaybe<Scalars['ID']>;
  viewStatus?: InputMaybe<LearnContentViewStatus>;
};

export type LearnContentFilterByTopicIdInput = {
  contentType?: InputMaybe<LearnSearchContentType>;
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>;
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>;
  tierId?: InputMaybe<Scalars['ID']>;
  topicId: Scalars['ID'];
  viewStatus?: InputMaybe<LearnContentViewStatus>;
};

export type LearnContentFilterInput = {
  contentType?: InputMaybe<LearnSearchContentType>;
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>;
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>;
  tierId?: InputMaybe<Scalars['ID']>;
  topicId?: InputMaybe<Scalars['ID']>;
  viewStatus?: InputMaybe<LearnContentViewStatus>;
};

export type LearnContentInteractionState = LearnInteractionState;

export type LearnContentPageInput = {
  after?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
};

export type LearnContentPreview = CoursePreview | CoursePreviewLocked | LearnArticlePreview | LearnArticlePreviewLocked | LearnMediaPreview | LearnMediaPreviewLocked | LearnPollPreview | LearnPollPreviewLocked | LessonPreview | LessonPreviewLocked | QuizPreview | QuizPreviewLocked;

export enum LearnContentSortType {
  DURATION = 'DURATION',
  MOST_RECENT = 'MOST_RECENT',
  MOST_RELEVANT = 'MOST_RELEVANT',
  MOST_VIEWED = 'MOST_VIEWED',
  TRENDING = 'TRENDING'
}

export type LearnContentStats = {
  __typename?: 'LearnContentStats';
  communityAvg: Maybe<Scalars['Int']>;
  views: Maybe<Scalars['Int']>;
};

export enum LearnContentType {
  ARTICLE = 'ARTICLE',
  COURSE = 'COURSE',
  LESSON = 'LESSON',
  MEDIA_ARTICLE = 'MEDIA_ARTICLE',
  POLL = 'POLL',
  QUIZ = 'QUIZ'
}

export enum LearnContentViewStatus {
  UNVIEWED = 'UNVIEWED',
  VIEWED = 'VIEWED'
}

export type LearnCourse = Course | CourseLocked;

export type LearnCoursePreview = CoursePreview | CoursePreviewLocked;

export type LearnEdge = {
  cursor: Scalars['ID'];
};

export type LearnHubCitation = {
  __typename?: 'LearnHubCitation';
  id: Scalars['ID'];
};

export type LearnInsight = {
  __typename?: 'LearnInsight';
  cuePointMillis: Milliseconds;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type LearnInteractionState = {
  __typename?: 'LearnInteractionState';
  elapsedTime: Maybe<LearnContentDuration>;
  isFavorites: Scalars['Boolean'];
  isHelpful: Maybe<Scalars['Boolean']>;
  progress: Maybe<LearnProgress>;
};

export type LearnMedia = LearnMediaArticle;

export type LearnMediaArticle = {
  __typename?: 'LearnMediaArticle';
  audioTheme: Maybe<LearnMediaTheme>;
  authors: Array<LearnAuthor>;
  featuredImage: Maybe<LearnVisualAsset>;
  id: Scalars['ID'];
  insights: Array<LearnInsight>;
  media: LearnMediaReference;
  metadata: LearnMetadata;
  polls: Array<LearnPoll>;
  preEventDescription: Maybe<Scalars['String']>;
  startsAt: Maybe<Scalars['String']>;
  tags: Array<LearnTag>;
  /** @deprecated Tier will be removed */
  tier: LearnTier;
  title: Scalars['String'];
  topics: Array<LearnTopic>;
};

export type LearnMediaPreview = {
  __typename?: 'LearnMediaPreview';
  audioTheme: Maybe<LearnMediaTheme>;
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  isCompleted: Scalars['Boolean'];
  mediaType: Maybe<LearnMediaType>;
  primaryTopicName: Scalars['String'];
  productRequired: Maybe<Scalars['String']>;
  progress: Maybe<LearnProgress>;
  startsAt: Maybe<Scalars['String']>;
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String'];
  title: Scalars['String'];
  views: Scalars['Int'];
};

export type LearnMediaPreviewLocked = {
  __typename?: 'LearnMediaPreviewLocked';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  lockedReason: Maybe<Scalars['String']>;
  mediaType: Maybe<LearnMediaType>;
  primaryTopicName: Scalars['String'];
  productRequired: Scalars['String'];
  title: Scalars['String'];
  views: Scalars['Int'];
};

export type LearnMediaReference = {
  __typename?: 'LearnMediaReference';
  aspectRatio: LearnAspectRatioType;
  duration: LearnContentDuration;
  featuredImage: Maybe<LearnVisualAsset>;
  id: Scalars['ID'];
  reference: Scalars['String'];
  theme: Maybe<LearnMediaTheme>;
  title: Maybe<Scalars['String']>;
  transcript: Maybe<Scalars['String']>;
  type: LearnMediaType;
};

export type LearnMediaTheme = LearnThemeLiteral;

export enum LearnMediaType {
  AUDIO = 'AUDIO',
  LIVE_VIDEO = 'LIVE_VIDEO',
  VIDEO = 'VIDEO'
}

export type LearnMetadata = {
  __typename?: 'LearnMetadata';
  contentStats: Maybe<LearnContentCommunityStats>;
  interactionState: Maybe<LearnContentInteractionState>;
};

export type LearnNextStepAction = {
  __typename?: 'LearnNextStepAction';
  ctaLabel: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  illustration: Maybe<Image>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type LearnPageInfo = {
  __typename?: 'LearnPageInfo';
  count: Scalars['Int'];
  cursor: Scalars['ID'];
  hasNextPage: Scalars['Boolean'];
};

export type LearnPoll = {
  __typename?: 'LearnPoll';
  cuePointMillis: Maybe<Milliseconds>;
  id: Scalars['ID'];
  options: Maybe<Array<Scalars['String']>>;
  pollType: LearnPollType;
  question: Scalars['String'];
  title: Scalars['String'];
};

export type LearnPollOption = {
  __typename?: 'LearnPollOption';
  count: Scalars['Int'];
  option: Scalars['String'];
};

export type LearnPollPreview = {
  __typename?: 'LearnPollPreview';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  options: Maybe<Array<LearnPollOption>>;
  pollType: LearnPollType;
  question: Scalars['String'];
  title: Scalars['String'];
};

export type LearnPollPreviewLocked = {
  __typename?: 'LearnPollPreviewLocked';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  lockedReason: Maybe<Scalars['String']>;
  productRequired: Scalars['String'];
  title: Scalars['String'];
};

export type LearnPollResponse = {
  __typename?: 'LearnPollResponse';
  isSuccess: Scalars['Boolean'];
  selectedOption: Scalars['String'];
  stats: Maybe<Array<LearnPollOption>>;
};

export enum LearnPollType {
  EMOJI = 'EMOJI',
  OPTION = 'OPTION',
  YES_NO = 'YES_NO'
}

export enum LearnProductKey {
  LEARN = 'LEARN',
  LEARN_PREMIUM = 'LEARN_PREMIUM'
}

export type LearnProgress = {
  __typename?: 'LearnProgress';
  currentValue: Scalars['Int'];
  unitType: LearnProgressUnit;
};

export type LearnProgressInput = {
  currentValue: Scalars['Int'];
  unitType: LearnProgressUnit;
};

export enum LearnProgressUnit {
  PERCENTS = 'PERCENTS',
  SECONDS = 'SECONDS',
  STAGES = 'STAGES'
}

export type LearnProgressUpdatedResult = {
  __typename?: 'LearnProgressUpdatedResult';
  contentId: Scalars['ID'];
  progress: LearnProgress;
};

export type LearnQuestion = {
  __typename?: 'LearnQuestion';
  answers: Array<LearnAnswer>;
  id: Scalars['ID'];
  incrementStep: Maybe<Scalars['Int']>;
  insight: Maybe<LearnQuestionInsight>;
  questionBody: Scalars['String'];
  questionType: LearnQuestionType;
  rangeEnd: Maybe<Scalars['Int']>;
  rangeLabel: Maybe<Scalars['String']>;
  rangeStart: Maybe<Scalars['Int']>;
  rangeType: Maybe<LearnRangeType>;
  statement: Maybe<Scalars['String']>;
  statementHighLight: Maybe<Scalars['String']>;
  unitType: Maybe<Scalars['String']>;
};

export type LearnQuestionInsight = {
  __typename?: 'LearnQuestionInsight';
  featuredImage: Maybe<Image>;
  id: Scalars['ID'];
  insightText: Scalars['String'];
  media: Maybe<LearnMediaReference>;
  mediaType: Maybe<LearnMediaType>;
  title: Scalars['String'];
};

export enum LearnQuestionType {
  FILL_IN_THE_BLANK = 'FILL_IN_THE_BLANK',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMERIC_RANGE = 'NUMERIC_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TWO_OPTIONS = 'TWO_OPTIONS'
}

export type LearnQuiz = Quiz | QuizLocked;

export type LearnQuizAnswerResult = {
  __typename?: 'LearnQuizAnswerResult';
  isCorrect: Scalars['Boolean'];
  questionId: Scalars['ID'];
  quizId: Scalars['ID'];
};

export type LearnQuizPreview = QuizPreview | QuizPreviewLocked;

export enum LearnRangeType {
  DIAL = 'DIAL',
  SLIDER = 'SLIDER'
}

export enum LearnSearchContentType {
  ARTICLE = 'ARTICLE',
  AUDIO = 'AUDIO',
  COURSE = 'COURSE',
  VIDEO = 'VIDEO'
}

export type LearnSearchTermSavedResult = {
  __typename?: 'LearnSearchTermSavedResult';
  term: Scalars['String'];
};

export type LearnTag = {
  __typename?: 'LearnTag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LearnThemeLiteral = {
  __typename?: 'LearnThemeLiteral';
  value: Scalars['String'];
};

export type LearnTier = {
  __typename?: 'LearnTier';
  icon: LearnVisualAsset;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LearnTopic = {
  __typename?: 'LearnTopic';
  icon: LearnVisualAsset;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LearnVisualAsset = Image;

export type LegacyAlertDismissalSuccess = {
  __typename?: 'LegacyAlertDismissalSuccess';
  id: Scalars['ID'];
};

/** An upload from backend */
export type LegacyUploadDocument = {
  __typename?: 'LegacyUploadDocument';
  documentType: DocumentType;
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Input for creating a legacy document upload */
export type LegacyUploadDocumentInput = {
  /** the type of document being uploaded */
  documentType: DocumentType;
  /** the multipart document upload file */
  upload: Scalars['Upload'];
};

/** LegacyUploadDocumentResult */
export type LegacyUploadDocumentResult = FileDoesNotExistInS3 | FileTooLarge | InvalidFile | LegacyUploadDocument | UploadDoesNotExist;

export type Lesson = {
  __typename?: 'Lesson';
  authors: Array<LearnAuthor>;
  featuredImage: Image;
  id: Scalars['ID'];
  insights: Array<LearnInsight>;
  media: LearnMediaReference;
  metadata: LearnMetadata;
  polls: Array<LearnPoll>;
  title: Scalars['String'];
};

export type LessonPreview = {
  __typename?: 'LessonPreview';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  parentContentId: Scalars['ID'];
  title: Scalars['String'];
};

export type LessonPreviewLocked = {
  __typename?: 'LessonPreviewLocked';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  lockedReason: Maybe<Scalars['String']>;
  parentContentId: Scalars['ID'];
  productRequired: Scalars['String'];
  title: Scalars['String'];
};

export enum LinkCustomization {
  /** A link customization for optionally accessing the users ssn. */
  CARD_LINK = 'CARD_LINK',
  /** The standard link customization. */
  DEFAULT = 'DEFAULT',
  /** A link customization for only accessing funding source information. */
  FUNDING_SOURCE_LINK = 'FUNDING_SOURCE_LINK',
  /** A link customization for not requiring the users name. */
  SANS_NAME_LINK = 'SANS_NAME_LINK'
}

/** Input for creating a manual, ACH funding source */
export type LinkManualFundingSourceInput = {
  /** the account number of the funding source being linked */
  accountNumber: Scalars['String'];
  /** the routing number of the funding source being linked */
  routingNumber: Scalars['RoutingNumber'];
};

/** LinkManualFundingSourceResult */
export type LinkManualFundingSourceResult = CurrentBankStatementNotProvided | FundingSourceAccount | FundingSourceAlreadyExists | FundingSourceCredentialsExceedLinkLimit | InvalidAccountNumber | InvalidManualLink | InvalidRoutingNumber | PreviousFundingSourcePending | RdvVerificationRequired;

export type LinkOidcCredentialsInput = {
  idToken: Scalars['String'];
  nonce: Scalars['String'];
  oidcProvider: OidcProvider;
  udid: Scalars['String'];
};

export type LinkOidcCredentialsResult = InvalidAppleAccountException | InvalidIdentityTokenException | LinkOidcCredentialsSuccess | OidcCredentialsAlreadyLinkedException | OidcCredentialsTakenException;

export type LinkOidcCredentialsSuccess = {
  __typename?: 'LinkOidcCredentialsSuccess';
  email: Scalars['EmailAddress'];
  oidcProvider: OidcProvider;
  userId: Scalars['ID'];
};

export enum LinkProviderType {
  /** Direct bank provider type. */
  DIRECT_BANK = 'DIRECT_BANK',
  /** Plaid provider type */
  PLAID = 'PLAID',
  /** Spend provider type. */
  SPEND = 'SPEND'
}

/** Attributes for a linked account created through Plaid Link */
export type LinkSessionInput = {
  /** The Authorization Code returned from the Authorization Server */
  authorizationCode: Scalars['String'];
  /** Flag to determine if round-ups should be disabled */
  disableRoundUps?: InputMaybe<Scalars['Boolean']>;
  /** Financial Institution ID */
  financialInstitutionId: Scalars['String'];
  /** Vendor session correlation id */
  linkSessionId?: InputMaybe<Scalars['String']>;
  /** Linked Account ID */
  linkedAccountId?: InputMaybe<Scalars['String']>;
};

export enum LinkSessionLanguage {
  /** English */
  EN = 'EN',
  /** Spanish */
  ES = 'ES',
  /** French */
  FR = 'FR',
  /** Dutch */
  NL = 'NL'
}

/** Returns a Link Token or Link URL for use with Account Linking. */
export type LinkSessionResult = RawLinkSession | UnrecoverableLinkedAccountError | WebviewLinkSession;

/** Miscellaneous attributes about a Linked Account */
export type LinkedAccount = TimestampsInterface & {
  __typename?: 'LinkedAccount';
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Error code attached to operation done on account */
  errorCode: Maybe<Scalars['String']>;
  /** Plaid account ID */
  externalId: Maybe<Scalars['ID']>;
  /** Source of linked account (plaid or spend) */
  externalSource: LinkedAccountExternalSourceEnum;
  financialInstitution: Maybe<FinancialInstitution>;
  /** ID of the financial institution this linked account is for */
  financialInstitutionId: Maybe<Scalars['ID']>;
  /** Linked Account ID */
  id: Scalars['ID'];
  /** Name of the associated institution this linked account is for */
  institutionName: Maybe<Scalars['String']>;
  /** Is the account linked? */
  linked: Scalars['Boolean'];
  linkedSubaccounts: Array<LinkedSubaccount>;
  /** The logo url for the institution associated with the account */
  logoUrl: Scalars['String'];
  /** This field should only be fetched for initializing a Plaid Link session */
  publicToken: Maybe<Scalars['String']>;
  /** Status indicating potential user action required */
  status: LinkedAccountStatusEnum;
  /** DateTime of when Transactions were last synced for financial institution */
  transactionsLastSyncedAt: Maybe<Scalars['DateTime']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** Correlated User UUID */
  userId: Scalars['ID'];
};

/** A Linked Account Alert. */
export type LinkedAccountAlert = UserAlertsItem & {
  __typename?: 'LinkedAccountAlert';
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** Response from linked account alert query */
export type LinkedAccountAlertsResponse = LinkedAccountAlert | RelinkLinkedAccountAlert;

export enum LinkedAccountExternalSourceEnum {
  /** The link was created directly between the corresponding bank's API and Acorns */
  direct_bank = 'direct_bank',
  /** The user linked by manually entering an account & routing number */
  manual = 'manual',
  /** PayPal direct connection was used to link this account */
  paypal = 'paypal',
  /** The link was created through Plaid and represents an external financial institution */
  plaid = 'plaid',
  /** This account has an internal Acorns spend account associated with it */
  spend = 'spend'
}

export enum LinkedAccountLinkingErrorsEnum {
  /** Online banking system is down */
  INSTITUTION_DOWN = 'INSTITUTION_DOWN',
  /** Online banking system is unresponsive */
  INSTITUTION_NOT_AVAILABLE = 'INSTITUTION_NOT_AVAILABLE',
  /** Online banking system is unresponsive */
  INSTITUTION_NOT_RESPONDING = 'INSTITUTION_NOT_RESPONDING',
  /** Online banking system is not supported anymore */
  INSTITUTION_NO_LONGER_SUPPORTED = 'INSTITUTION_NO_LONGER_SUPPORTED',
  /** Server error */
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  /** Error with incorrect institution security questions */
  INVALID_MFA = 'INVALID_MFA',
  /** Online banking credentials have been updated */
  INVALID_UPDATED_USERNAME = 'INVALID_UPDATED_USERNAME',
  /** Online banking account is locked */
  ITEM_LOCKED = 'ITEM_LOCKED',
  /** Error with institution security settings */
  ITEM_NOT_SUPPORTED = 'ITEM_NOT_SUPPORTED',
  /** Error with institution security questions */
  MFA_NOT_SUPPORTED = 'MFA_NOT_SUPPORTED',
  /** Online banking account is not fully set up */
  USER_SETUP_REQUIRED = 'USER_SETUP_REQUIRED'
}

export type LinkedAccountNotFound = {
  __typename?: 'LinkedAccountNotFound';
  message: Scalars['String'];
};

export enum LinkedAccountStatusEnum {
  /** The user must take action with their financial institution to fix the issue */
  externalAction = 'externalAction',
  /** The user must relink and update their linked account to continue functioning */
  relink = 'relink',
  /** The linked account is working and requires no action */
  success = 'success',
  /** The linked account or financial institution is no longer supported and can be unlinked */
  unsupported = 'unsupported'
}

/** An individual account between an individual user and financial institution */
export type LinkedSubaccount = TimestampsInterface & {
  __typename?: 'LinkedSubaccount';
  /** Last 4 Digits of Account Number */
  accountNumberLastFour: Maybe<Scalars['String']>;
  /** Roles this linked account can be assigned to */
  allowedRoles: Array<LinkedSubaccountRoleEnum>;
  /** Balance available (via Plaid/Spend) */
  balanceAvailable: Maybe<Scalars['Float']>;
  /** Current balance of subaccount (via Plaid/Spend) */
  balanceCurrent: Maybe<Scalars['Float']>;
  /** Spending limit of balance */
  balanceLimit: Maybe<Scalars['Float']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Plaid ID for linked subaccount */
  externalId: Maybe<Scalars['String']>;
  /** External source of subaccount (plaid, spend, paypal, manual) */
  externalSource: Maybe<Scalars['String']>;
  /** Internal ID for linked subaccount */
  id: Scalars['ID'];
  /** Subaccount Linked? */
  linked: Scalars['Boolean'];
  linkedAccount: LinkedAccount;
  /** Internal ID for the corresponding linked account */
  linkedAccountId: Scalars['ID'];
  /** Name of linked subaccount (Department) */
  name: Scalars['String'];
  /** Official name (verbose) */
  officialName: Maybe<Scalars['String']>;
  paymentEngines: Array<LinkedSubaccountPaymentEngineEnum>;
  /** The role of the linked subaccount */
  role: Maybe<LinkedSubaccountRoleEnum>;
  /** Financial institution routing number. */
  routingNumber: Maybe<Scalars['String']>;
  /** The status of the linked subaccount */
  status: Maybe<FundingSourceStatusEnum>;
  /** Subtype (ie checking) */
  subaccountSubtype: Scalars['String'];
  /** Type (depository, credit) */
  subaccountType: Scalars['String'];
  /** Transactions count */
  transactionsLastSyncedCount: Scalars['Int'];
  /** RDVs and docs have been verified and approved for this account */
  transfersApproved: Maybe<Scalars['Boolean']>;
  /** Is the account at risk or does it have insufficient funds? */
  transfersAtRisk: Maybe<Scalars['Boolean']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /**
   * Subaccount Verified?
   * @deprecated This will be removed in favor of "transfersApproved"
   */
  verified: Maybe<Scalars['Boolean']>;
};

export enum LinkedSubaccountPaymentEngineEnum {
  /** The linked subaccount is linked in ProfitStars */
  profitStars = 'profitStars'
}

export enum LinkedSubaccountRoleEnum {
  /** The subaccount is the primary funding source of the user */
  primaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  secondaryFunding = 'secondaryFunding'
}

/** Liquidation information */
export type Liquidation = TimestampsInterface & {
  __typename?: 'Liquidation';
  accountId: Scalars['ID'];
  billingCycle: BillingCycle;
  billingCycleId: Scalars['ID'];
  collectedAmount: Scalars['Float'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  feeExecutions: Array<Maybe<FeeExecution>>;
  id: Scalars['ID'];
  investmentId: Scalars['ID'];
  requestedAmount: Scalars['Float'];
  state: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Liquidation of holdings is currently unavailable. */
export type LiquidationUnavailableError = {
  __typename?: 'LiquidationUnavailableError';
  /** Reason for liquidation being unavailable. */
  reason: LiquidationUnavailableReason;
};

export enum LiquidationUnavailableReason {
  /** The funding source is frozen. */
  FUNDING_SOURCE_FROZEN = 'FUNDING_SOURCE_FROZEN',
  /** The associated funding source requires RDV. */
  FUNDING_SOURCE_RDV_REQUIRED = 'FUNDING_SOURCE_RDV_REQUIRED',
  /** No funding source exists for the investment account. */
  FUNDING_SOURCE_REQUIRED = 'FUNDING_SOURCE_REQUIRED'
}

export type LockBankCardInput = {
  lockReason: BankCardTemporaryLockReason;
};

export type LockBankCardPayload = {
  __typename?: 'LockBankCardPayload';
  bankCard: Maybe<BankCard>;
};

export type LoginAccess = {
  __typename?: 'LoginAccess';
  loginAllowed: Scalars['Boolean'];
  loginRevokedAt: Maybe<Scalars['DateTime']>;
  loginRevokedReason: Maybe<Scalars['String']>;
};

export type LoginRateLimitedException = {
  __typename?: 'LoginRateLimitedException';
  message: Maybe<Scalars['String']>;
};

export type LogoutDeviceInput = {
  deviceId: Scalars['ID'];
};

export type LogoutDeviceResult = DeviceNotFoundException | LogoutDeviceSuccess | RefreshTokenNotFoundException;

export type LogoutDeviceSuccess = {
  __typename?: 'LogoutDeviceSuccess';
  Device: Device;
};

export type LogoutResult = AuthTokenNotFoundException | LogoutSuccess | RefreshTokenNotFoundException;

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess';
  userId: Scalars['ID'];
};

export enum MailInDocumentType {
  BILL_NEGOTIATION = 'BILL_NEGOTIATION',
  FEE_NEGOTIATION = 'FEE_NEGOTIATION'
}

/** Input for makeInvestment mutation */
export type MakeInvestmentInput = {
  /** Dollar amount of investment */
  amount: Scalars['Float'];
  /** Correlation ID used to correlate this investment request with device/fraud parameters */
  correlationId?: InputMaybe<Scalars['String']>;
  /** Funding source ID */
  fundingSourceId?: InputMaybe<Scalars['ID']>;
  /** Investment account ID */
  investmentAccountId?: InputMaybe<Scalars['ID']>;
  /** Payment method. Note: This will be overridden by the funding source's payment method in the backend. */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** Type of investment (credit, debit) */
  type: InvestmentTypes;
};

/** Return type for makeInvestment mutation */
export type MakeInvestmentPayload = {
  __typename?: 'MakeInvestmentPayload';
  /** ID of the created investment */
  id: Scalars['ID'];
  /** Optional success/error message */
  message: Maybe<Scalars['String']>;
};

export type MalformedRecurringTransferException = {
  __typename?: 'MalformedRecurringTransferException';
  pathExceptions: Array<RecurringTransferPathException>;
};

export enum ManagePayoutRelationshipAction {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export enum ManagePayoutRelationshipResult {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}

export enum MaritalStatus {
  /** User is currently in a civil union */
  civil_union = 'civil_union',
  /** User is no longer married due to legal separation */
  divorced = 'divorced',
  /** User is married currently */
  married = 'married',
  /** User has never been married */
  single = 'single',
  /** User is no longer married due to death of spouse */
  widowed = 'widowed'
}

export type MarkAllAsReadResult = MarkAllAsReadSuccess | UpdateMessageFailed;

export type MarkAllAsReadSuccess = {
  __typename?: 'MarkAllAsReadSuccess';
  markedAsReadCount: Scalars['Int'];
};

export type MarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID'];
};

export type MarkLearnContentAsHelpfulResult = RecordDoesNotExistError | UpdateLearnContentHelpfulnessResult;

export type MarkLearnContentAsViewedInput = {
  contentId: Scalars['ID'];
};

export type MarkLearnContentAsViewedResult = RecordDoesNotExistError | ViewedLearnContentResult;

/** Information about the stock market (U.S. only) */
export type Market = {
  __typename?: 'Market';
  /** Indicates whether or not the market is open for trading */
  isOpen: Scalars['Boolean'];
};

export type MarketReturn = {
  __typename?: 'MarketReturn';
  marketValue: MonetaryAmount;
  percent: Scalars['Float'];
};

/** A match program entitles eligible investment accounts to matching contributions provided by Acorns. */
export type MatchProgram = TimestampsInterface & {
  __typename?: 'MatchProgram';
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Description of the Program Match */
  description: Scalars['String'];
  /** Investment Account types supports by the program */
  eligibleInvestmentAccountTypes: Array<InvestmentAccountType>;
  /** ID of the Program Match */
  id: Scalars['ID'];
  /** Match percentage for the program */
  matchPercentage: Scalars['Float'];
  /** Name of the Program Match */
  name: Scalars['String'];
  /** Description of the Program Match */
  requiredContributionVestingDays: Scalars['Int'];
  /** Tier the program is available on. */
  tier: Maybe<Tier>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Cannot open early account because the custodian is already at max */
export type MaxAccountsCreatedException = {
  __typename?: 'MaxAccountsCreatedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type Message = {
  body: MessageTextAsset;
  cardColor: Maybe<CardColor>;
  deepLink: Maybe<Scalars['URL']>;
  delay: Maybe<Scalars['Int']>;
  externalId: Scalars['ID'];
  icon: Maybe<MessageVisualAsset>;
  id: Scalars['ID'];
  messageCategory: Maybe<MessageCategory>;
  messageType: MessageType;
  platforms: Array<Platform>;
  priority: Maybe<Scalars['Int']>;
  title: MessageTextAsset;
  trackingId: Maybe<Scalars['ID']>;
};

export enum MessageCategory {
  ACCOUNT = 'ACCOUNT',
  BANKING = 'BANKING',
  BENEFITS_HUB = 'BENEFITS_HUB',
  BRAZE = 'BRAZE',
  EARN = 'EARN',
  INVEST = 'INVEST',
  LATER = 'LATER',
  MILESTONE = 'MILESTONE',
  ONBOARDING = 'ONBOARDING'
}

/** Specifies a Message Connection */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges: Array<MessageEdge>;
  pageInfo: MessagePageInfo;
};

/** Specifies a Message Edge */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['ID'];
  node: Message;
};

export type MessageFeedbackInput = {
  customFeedback?: InputMaybe<Scalars['String']>;
  feedbackReason: MessageFeedbackReason;
};

export enum MessageFeedbackReason {
  INACCURATE_INFORMATION = 'INACCURATE_INFORMATION',
  NOT_HELPFUL = 'NOT_HELPFUL',
  OFFENSIVE = 'OFFENSIVE',
  OTHER = 'OTHER'
}

/** Specifies Page Information */
export type MessagePageInfo = {
  __typename?: 'MessagePageInfo';
  endCursor: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
};

export type MessagePageInput = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};

export enum MessageStatus {
  DISMISSED = 'DISMISSED',
  READ = 'READ'
}

/** A pair of a status and a desired boolean for it. */
export type MessageStatusFilterInput = {
  key: MessageStatus;
  value: Scalars['Boolean'];
};

export type MessageTextAsset = StringKeyAsset;

export enum MessageType {
  ALERT = 'ALERT',
  NOTIFICATION = 'NOTIFICATION'
}

export type MessageVisualAsset = DesignLibraryIcon | Image;

export type MfaMissingAuthAlert = AuthAlert & {
  __typename?: 'MfaMissingAuthAlert';
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/** Value of money measured in currency */
export type MicrosMoney = {
  __typename?: 'MicrosMoney';
  /** System of money that is used in a particular country */
  currency: Currency;
  /** Monetary value */
  value: Scalars['Micros'];
};

/** The mighty oak card waiver for a user */
export type MightyOakCardWaiver = {
  __typename?: 'MightyOakCardWaiver';
  mightyOakCardWaiverPeriodEndDate: Scalars['String'];
  userId: Scalars['ID'];
};

/** Mighty Oak Waiver expired */
export type MightyOakCardWaiverExpiredException = {
  __typename?: 'MightyOakCardWaiverExpiredException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Mighty Oak Waiver not found */
export type MightyOakCardWaiverNotFoundException = {
  __typename?: 'MightyOakCardWaiverNotFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** result from attempting to create a provisional waiver for a user */
export type MightyOakWaiverResult = BillingProfileNotFoundException | MightyOakCardWaiver | MightyOakCardWaiverExpiredException | MightyOakCardWaiverNotFoundException;

export type Milestone = {
  __typename?: 'Milestone';
  /** how many account points the user has earned for this milestone so far */
  accountPoints: AccountPoints;
  /**
   * how many challenge points the user has earned for completing this milestone. The specific challenge is indicated by the ID
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  challengePoints: Maybe<ChallengePointsEarned>;
  /** key that maps to client-defined milestone description */
  descriptionKey: Scalars['StringKey'];
  /** optional destination label and deep link for milestone action */
  destination: Maybe<Destination>;
  /**
   * key that maps to client-defined milestone details
   * @deprecated leverage accountPoints.detailsKey
   */
  detailsKey: Maybe<Scalars['StringKey']>;
  /** milestone education tip content */
  educationTip: EducationTip;
  /** the first time the user completed the milestone */
  firstCompletedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** @deprecated No longer needed since the logo will be dynamically set based on milestone status. Use 'logo' instead */
  inactiveLogo: Maybe<Image>;
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean'];
  /** the most recent time the user completed the milestone */
  lastCompletedAt: Maybe<Scalars['DateTime']>;
  /** logo that matches the milestone status */
  logo: Image;
  /** @deprecated Do not use anymore. This field has been replaced by nameKey. */
  name: Scalars['String'];
  /** key that maps to descriptive identifier */
  nameKey: Scalars['StringKey'];
  /** information the user's progress towards completion */
  progress: MilestoneProgress;
  /** milestone rule enum which can be used for grouping and fetch string mappings */
  rule: MilestoneRuleType;
  /** key that maps to simplified descriptive identifier */
  simpleNameKey: Scalars['StringKey'];
  /** the user-specific status */
  status: MilestoneStatus;
  /** the milestone category */
  theme: MilestoneTheme;
  /** how many times the user completed this milestone */
  timesCompleted: Scalars['Int'];
};


export type MilestoneChallengePointsArgs = {
  challengeId: Scalars['ID'];
};

export type MilestoneAccountLevelDefinition = {
  __typename?: 'MilestoneAccountLevelDefinition';
  /** image to display as the background when the level is active */
  activeBackground: Image;
  /** image to display as the foreground when the level is active */
  activeForeground: Image;
  /** level id, e.g. 3 */
  id: Scalars['Int'];
  /** image to display as the background when the level is inactive */
  inactiveBackground: Image;
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int'];
  /** minimum points needed for the level */
  min: Scalars['Int'];
};

export type MilestoneAchievementActionRule = {
  __typename?: 'MilestoneAchievementActionRule';
  actions: Array<MilestoneAchievementActionType>;
  milestoneID: Scalars['ID'];
};

export enum MilestoneAchievementActionType {
  ANALYTICS_EVENT = 'ANALYTICS_EVENT',
  NATIVE_NOTIFICATION = 'NATIVE_NOTIFICATION'
}

export type MilestoneByThemeFilterInput = {
  /** No longer in use. Will be ignored if provided. */
  challengeId?: InputMaybe<Scalars['ID']>;
  rule?: InputMaybe<MilestoneRuleType>;
};

export type MilestoneChallenge = {
  __typename?: 'MilestoneChallenge';
  /** Static date label for when the challenge becomes inactive (NOTE: is relative to PST) */
  closingAt: Scalars['String'];
  /** additional information about this challenge */
  details: Maybe<Scalars['String']>;
  /** Internal UTC timestamp. For display, use 'closingAt'instead */
  endsAt: Scalars['DateTime'];
  /** optional deeplink to challenge FAQ */
  faqDeepLink: Maybe<Scalars['URL']>;
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>;
  id: Scalars['ID'];
  /** optional logo for the challenge */
  logo: Maybe<Image>;
  /** number of milestones the user has completed for the challenge */
  milestonesCompleted: DiscreteMilestoneProgress;
  /** descriptive identifier */
  name: Scalars['String'];
  /** number of points the user has earned for the challenge. May be null if not applicable to the current challenge */
  pointsEarned: Maybe<DiscreteMilestoneProgress>;
  /** optional deeplink to official challenge rules */
  rulesDeepLink: Maybe<Scalars['URL']>;
};

export type MilestoneChallengePointsRule = {
  __typename?: 'MilestoneChallengePointsRule';
  challengeID: Scalars['ID'];
  /** legal copy about how points are earned */
  details: Scalars['String'];
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int'];
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int'];
  /** summarized information about how points are earned */
  summary: Maybe<Scalars['String']>;
};

export type MilestoneDefinition = {
  __typename?: 'MilestoneDefinition';
  accountPointsRule: Maybe<AccountPointsRule>;
  /** optional datetime arg required for some milestone rules (e.g. ACTIVE_CUSTOMER) */
  arg1DateTime: Maybe<Scalars['DateTime']>;
  /** optional integer arg required for some milestone rules (e.g. BALANCED_REACHED) */
  arg1Int: Maybe<Scalars['Int']>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  challengePointsRule: Maybe<MilestoneChallengePointsRule>;
  id: Scalars['ID'];
  /** optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo: Maybe<Image>;
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean'];
  /** default logo */
  logo: Image;
  /** list of MilestoneGroupID for groups to which this milestone belongs */
  milestoneGroups: Array<Scalars['ID']>;
  /** descriptive identifier */
  name: Scalars['String'];
  /** the rule that determines how this milestone changes status */
  rule: MilestoneRule;
  /** the milestone category */
  theme: MilestoneTheme;
};


export type MilestoneDefinitionChallengePointsRuleArgs = {
  challengeId: Scalars['ID'];
};

export type MilestoneEligibility = {
  __typename?: 'MilestoneEligibility';
  eligible: Scalars['Boolean'];
  scope: MilestoneEligibilityScope;
};

export enum MilestoneEligibilityScope {
  ACCOUNT_SETUP_COMPLETE = 'ACCOUNT_SETUP_COMPLETE',
  /** @deprecated this value was only used for the AccountSetup feature experiment that is now over */
  ACCOUNT_SETUP_EXP = 'ACCOUNT_SETUP_EXP'
}

export type MilestoneGroup = MilestoneRuleGroup | MilestoneThemeGroup;

export type MilestoneGroupAchievementActionRule = {
  __typename?: 'MilestoneGroupAchievementActionRule';
  actions: Array<MilestoneAchievementActionType>;
  milestoneGroupID: Scalars['ID'];
};

export type MilestoneGroupDefinition = {
  __typename?: 'MilestoneGroupDefinition';
  id: Scalars['ID'];
  milestoneIDs: Array<Scalars['ID']>;
};

export type MilestoneHub = {
  __typename?: 'MilestoneHub';
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>;
  /** static list of min and max values for each account level */
  levelDefinitions: Array<MilestoneAccountLevelDefinition>;
  userAccount: MilestoneHubAccount;
};

export type MilestoneHubAccount = {
  __typename?: 'MilestoneHubAccount';
  /** shows progress of points earned vs points needed to move to the next level. NOTE: the currentInt can exceed the targetInt if the user is at the highest level */
  accountPointsProgress: DiscreteMilestoneProgress;
  /** current level achieved */
  currentLevel: Scalars['Int'];
  /** shows progress of milestones completed vs milestones available */
  milestoneProgress: DiscreteMilestoneProgress;
};

export type MilestoneHubDefinition = {
  __typename?: 'MilestoneHubDefinition';
  id: Scalars['ID'];
  milestoneIds: Array<Scalars['ID']>;
};

export type MilestoneProgress = CurrencyMilestoneProgress | DiscreteMilestoneProgress;

/** defines how a milestone is completed */
export type MilestoneRule = {
  __typename?: 'MilestoneRule';
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput;
  id: Scalars['ID'];
  /** the rule name */
  name: Scalars['String'];
  /** the milestone supported themes */
  themes: Array<MilestoneTheme>;
};

export enum MilestoneRuleArgInput {
  DATETIME = 'DATETIME',
  INT = 'INT',
  NONE = 'NONE'
}

export type MilestoneRuleGroup = {
  __typename?: 'MilestoneRuleGroup';
  contents: Array<MilestoneRuleGroupContent>;
  descriptionKey: Scalars['StringKey'];
  groupCompletion: DiscreteMilestoneProgress;
  logo: Image;
  nameKey: Scalars['StringKey'];
  rule: MilestoneRuleType;
};

export type MilestoneRuleGroupContent = Milestone;

export enum MilestoneRuleType {
  ACTIVE_CUSTOMER = 'ACTIVE_CUSTOMER',
  BALANCE_REACHED = 'BALANCE_REACHED',
  CARD_ACTIVATION = 'CARD_ACTIVATION',
  /** @deprecated Use CREATE_ACORNS_ACCOUNT instead */
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION',
  CREATE_ACORNS_ACCOUNT = 'CREATE_ACORNS_ACCOUNT',
  FIRST_INVESTMENT = 'FIRST_INVESTMENT',
  FUNDING_SOURCE_LINKED = 'FUNDING_SOURCE_LINKED',
  REALTIME_ROUNDUP = 'REALTIME_ROUNDUP',
  RECURRING_INVESTMENT_MONTHLY = 'RECURRING_INVESTMENT_MONTHLY',
  REWARD_CREATED = 'REWARD_CREATED',
  ROUNDUP = 'ROUNDUP',
  SIGNUP = 'SIGNUP',
  SMART_DEPOSIT_COMPLETED = 'SMART_DEPOSIT_COMPLETED',
  VERIFIED = 'VERIFIED'
}

export enum MilestoneStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  LOCKED = 'LOCKED',
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING'
}

export enum MilestoneTheme {
  ACCOUNT_SETUP = 'ACCOUNT_SETUP',
  ACORNS = 'ACORNS',
  EARLY = 'EARLY',
  EARN = 'EARN',
  INVEST = 'INVEST',
  LATER = 'LATER',
  SPEND = 'SPEND'
}

export type MilestoneThemeGroup = {
  __typename?: 'MilestoneThemeGroup';
  contents: Array<MilestoneThemeGroupContent>;
  descriptionKey: Scalars['StringKey'];
  destination: Maybe<Destination>;
  groupCompletion: DiscreteMilestoneProgress;
  groupPointsProgress: Maybe<DiscreteMilestoneProgress>;
  isLocked: Scalars['Boolean'];
  logo: Image;
  nameKey: Scalars['StringKey'];
  theme: MilestoneTheme;
};

export type MilestoneThemeGroupContent = Milestone | MilestoneRuleGroup;

export type Milliseconds = {
  __typename?: 'Milliseconds';
  value: Scalars['Int'];
};

export type MillisecondsInput = {
  value: Scalars['Int'];
};

/** Miscellaneous document requested. */
export type MiscDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'MiscDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** Returned when the provided distribution units are not all matching */
export type MismatchedDistributionUnitsError = {
  __typename?: 'MismatchedDistributionUnitsError';
  message: Scalars['String'];
};

/** Missing required agreements for user */
export type MissingAgreementsException = {
  __typename?: 'MissingAgreementsException';
  userId: Maybe<Scalars['ID']>;
};

/** Cannot open early account because the beneficiary does not have an SSN */
export type MissingBeneficiarySsnException = {
  __typename?: 'MissingBeneficiarySsnException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** The user needs to attach a funding source to close their early account */
export type MissingFundingSourceException = {
  __typename?: 'MissingFundingSourceException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type MissingRequiredAgreementsException = {
  __typename?: 'MissingRequiredAgreementsException';
  message: Maybe<Scalars['String']>;
};

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlert = Alert & {
  __typename?: 'MissingSsnBeneficiaryAlert';
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary;
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID'];
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String'];
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlertItem = UserAlertsItem & {
  __typename?: 'MissingSsnBeneficiaryAlertItem';
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** Returned when an existing customer ruleset is not found, and no override archetype ruleset was provided. */
export type MissingValidRulesetError = {
  __typename?: 'MissingValidRulesetError';
  message: Scalars['String'];
};

export type ModifyMoneyAssignmentInput = {
  /** The target account IDs and amount to assign for each account */
  accountAssignments: Array<AccountMoneyAssignmentInput>;
  /** The incoming transaction ID for money assignment between accounts */
  transactionId: Scalars['ID'];
};

export type ModifyMoneyAssignmentResult = ModifyMoneyAssignmentSuccess | MoneyAssignmentAlreadyTransferredError | MoneyAssignmentNotFoundError;

export type ModifyMoneyAssignmentSuccess = {
  __typename?: 'ModifyMoneyAssignmentSuccess';
  moneyAssignment: MoneyManagerMoneyAssignment;
};

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  currency: Currency;
  value: Scalars['Float'];
};

/** Input for anything money related */
export type MonetaryAmountInput = {
  /** The currency of the amount */
  currency: Currency;
  /** The total amount */
  value: Scalars['Float'];
};

/** A monetrary reward that will be provided to a subscriber in some fashion. */
export type MonetaryIncentive = Incentive & {
  __typename?: 'MonetaryIncentive';
  /** Amount of the monetary reward. */
  amount: CurrencyAmount;
  copyKey: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  /** Is the monetary reward recurring. */
  recurring: Scalars['Boolean'];
  /** Total amount of the reward if recurring. */
  totalAmount: CurrencyAmount;
  /**
   * Arbitrary string denoting to fulfillment processes how monetary
   * reward should be provided to a subscriber.
   *
   * Ex. "INVESTMENT"
   */
  type: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type MoneyAssignmentAlreadyTransferredError = {
  __typename?: 'MoneyAssignmentAlreadyTransferredError';
  message: Scalars['String'];
};

export type MoneyAssignmentConnection = {
  __typename?: 'MoneyAssignmentConnection';
  edges: Array<MoneyAssignmentEdge>;
  pageInfo: MoneyManagerPageInfo;
};

export type MoneyAssignmentEdge = {
  __typename?: 'MoneyAssignmentEdge';
  cursor: Scalars['String'];
  node: MoneyManagerMoneyAssignment;
};

export type MoneyAssignmentNotFoundError = {
  __typename?: 'MoneyAssignmentNotFoundError';
  message: Scalars['String'];
};

export type MoneyInEventInput = {
  accountId: Scalars['String'];
  customerTag: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  ingestedAt: Scalars['String'];
  transactionAmount: Scalars['String'];
  transactionId: Scalars['String'];
  transactionTag: Scalars['String'];
  transactionTypeCode: Scalars['String'];
};

/** The target account as the result of a MoneyAssignment */
export type MoneyManagerAllocation = {
  __typename?: 'MoneyManagerAllocation';
  amount: MoneyRulesCurrencyAmount;
  associatedTransferId: Maybe<Scalars['ID']>;
  beneficiary: Maybe<Beneficiary>;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  destinationAccount: MoneyRulesDestination;
  id: Scalars['ID'];
  moneyAssignment: MoneyManagerMoneyAssignment;
  /**
   * Deprecated - Use rules instead
   * @deprecated Field no longer supported
   */
  rule: MoneyRulesRule;
  rules: Array<MoneyRulesRule>;
  status: MoneyManagerAllocationStatus;
  transferId: Maybe<Scalars['ID']>;
  userId: Scalars['ID'];
};

export enum MoneyManagerAllocationNotEditableReason {
  LATER_LIMIT_REACHED = 'LATER_LIMIT_REACHED',
  NO_PERCENTAGE_REMAINING = 'NO_PERCENTAGE_REMAINING'
}

/** Represents the allocation amount details. */
export type MoneyManagerAllocationOption = {
  __typename?: 'MoneyManagerAllocationOption';
  /** The amount of the allocation. */
  amount: MoneyRulesCurrencyAmount;
  /** Deposit amounts normalized to various cadences. */
  normalizedAmounts: Maybe<MoneyManagerNormalizedAmounts>;
  /** The remainder details of the allocation for other accounts. */
  otherAccountsRemainder: MoneyManagerAllocationRemainder;
  /** The percentage of the allocation. */
  percent: Scalars['Float'];
  /** The remainder details of the allocation. */
  remainder: MoneyManagerAllocationRemainder;
};

/** Input object for allocation amounts query. */
export type MoneyManagerAllocationOptionsInput = {
  /** Pass in an archetype to use as a "starting point" for the algorithm instead of the customer's current ruleset */
  archetype?: InputMaybe<MoneyRulesArchetype>;
  /** Any staged rules to consider when calculating allocation options */
  stagedRules?: InputMaybe<Array<MoneyManagerStagedRulesInput>>;
  /** The target account identifier to get allocation options for */
  targetAccountId: Scalars['ID'];
  /** Set as `true` to base the algorithm on all deposit amounts rather than just the next deposit. */
  useTotalDepositAmount?: InputMaybe<Scalars['Boolean']>;
};

/** Represents the remainder details for the allocation option */
export type MoneyManagerAllocationRemainder = {
  __typename?: 'MoneyManagerAllocationRemainder';
  /** The amount of the remainder allocation. */
  amount: MoneyRulesCurrencyAmount;
  /** The percentage of the remainder allocation. */
  percent: Scalars['Float'];
};

/** Similar to a MoneyManagerAllocation, but stripped down */
export type MoneyManagerAllocationResult = {
  __typename?: 'MoneyManagerAllocationResult';
  amount: MoneyRulesCurrencyAmount;
  destinationAccount: MoneyRulesDestination;
  rulePriority: Scalars['Int'];
};

export enum MoneyManagerAllocationStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type MoneyManagerAutomationTarget = {
  __typename?: 'MoneyManagerAutomationTarget';
  amount: MoneyRulesCurrencyAmount;
  /** Was the goal set by the customer? */
  customSelection: Scalars['Boolean'];
  /** The suggested period of the original target suggestion. */
  suggestedPeriod: Maybe<MoneyManagerPeriod>;
  type: MoneyManagerAutomationTargetType;
};

export enum MoneyManagerAutomationTargetType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS'
}

export enum MoneyManagerCancelReason {
  CLOSED_ACCOUNT = 'CLOSED_ACCOUNT',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  SUBSCRIPTION_STATUS = 'SUBSCRIPTION_STATUS',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export type MoneyManagerCascadeObjective = {
  __typename?: 'MoneyManagerCascadeObjective';
  accountType: ProductAccountType;
  /** Is this active for the customer's current state? */
  isLocked: Scalars['Boolean'];
  objectiveType: MoneyManagerCascadeObjectiveType;
  /** Target & contribution data. Null for OVERFLOW objectives (or in a weird case where we're having trouble getting Later data) */
  target: Maybe<MoneyManagerCascadeTarget>;
};

export enum MoneyManagerCascadeObjectiveType {
  BALANCE = 'BALANCE',
  OVERFLOW = 'OVERFLOW'
}

export type MoneyManagerCascadeTarget = {
  __typename?: 'MoneyManagerCascadeTarget';
  /** Can the customer change this value? */
  isEditable: Scalars['Boolean'];
  /** Balance in (or contributions YTD to) the destination account */
  progressAmount: MoneyRulesCurrencyAmount;
  /** How close is the customer to the target? 0-100 */
  progressPercentage: Maybe<Scalars['Int']>;
  /** The automation target or contribution limit for the accountType */
  targetAmount: Maybe<MoneyRulesCurrencyAmount>;
};

export type MoneyManagerCategoriesInput = {
  amount?: InputMaybe<MoneyRulesCurrencyAmountInput>;
  archetype?: InputMaybe<MoneyRulesArchetype>;
  stagedRules?: InputMaybe<Array<MoneyManagerStagedRulesInput>>;
  /** Base calculations on the customer's monthly deposit amount, instead of their next predicted paycheck. Default: False */
  useMonthlyDepositAmount?: InputMaybe<Scalars['Boolean']>;
};

export type MoneyManagerCategoriesResult = MoneyManagerCategoriesSuccess;

export type MoneyManagerCategoriesSuccess = {
  __typename?: 'MoneyManagerCategoriesSuccess';
  categories: Array<MoneyManagerCategory>;
};

export type MoneyManagerCategory = {
  __typename?: 'MoneyManagerCategory';
  allocations: Array<MoneyManagerCategoryAllocation>;
  categoryAmount: Maybe<MoneyRulesCurrencyAmount>;
  categoryPercent: Scalars['Float'];
  categoryType: MoneyManagerCategoryType;
  isActive: Scalars['Boolean'];
};

export type MoneyManagerCategoryAllocation = {
  __typename?: 'MoneyManagerCategoryAllocation';
  accountId: Scalars['ID'];
  accountType: ProductAccountType;
  amount: Maybe<MoneyRulesCurrencyAmount>;
  beneficiary: Maybe<Beneficiary>;
  isEditable: Scalars['Boolean'];
  /** Deposit amounts normalized to various cadences */
  normalizedAmounts: Maybe<MoneyManagerNormalizedAmounts>;
  notEditableReason: Maybe<MoneyManagerAllocationNotEditableReason>;
  percent: Scalars['Float'];
  singleRuleId: Maybe<Scalars['Int']>;
};

export enum MoneyManagerCategoryType {
  GIVING = 'GIVING',
  INVESTING = 'INVESTING',
  KIDS = 'KIDS',
  SAVING = 'SAVING',
  SPENDING = 'SPENDING'
}

export type MoneyManagerDeposit = {
  amount: MoneyRulesCurrencyAmount;
  category: MoneyManagerDepositCategory;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type MoneyManagerDepositAssignment = MoneyManagerMoneyAssignment & {
  __typename?: 'MoneyManagerDepositAssignment';
  allocations: Array<MoneyManagerAllocation>;
  amount: MoneyRulesCurrencyAmount;
  cancelReason: Maybe<MoneyManagerCancelReason>;
  createdAt: Scalars['DateTime'];
  deposit: MoneyManagerDeposit;
  id: Scalars['ID'];
  status: MoneyManagerMoneyAssignmentStatus;
  type: MoneyManagerMoneyAssignmentType;
  userId: Scalars['String'];
};

export enum MoneyManagerDepositCategory {
  ONE_TIME = 'ONE_TIME',
  OTHER = 'OTHER',
  PAYCHECK = 'PAYCHECK',
  RECURRING = 'RECURRING'
}

export enum MoneyManagerDepositState {
  /** The customer has never had the Money Manager process a deposit and is waiting for the first deposit to arrive */
  AWAITING_FIRST_DEPOSIT = 'AWAITING_FIRST_DEPOSIT',
  /** The most recent deposit has arrived and has been split and waiting for the next deposit */
  AWAITING_NEXT_DEPOSIT = 'AWAITING_NEXT_DEPOSIT',
  /** The current deposit has arrived and is pending */
  DEPOSIT_ARRIVED = 'DEPOSIT_ARRIVED'
}

/** Represents the current summary and state of money manager deposits */
export type MoneyManagerDepositSummary = {
  __typename?: 'MoneyManagerDepositSummary';
  /** The amount of the deposit based off the deposit state */
  amount: Maybe<MoneyRulesCurrencyAmount>;
  /** The type of deposit based off the deposit state */
  depositType: Maybe<MoneyManagerDepositCategory>;
  /** Most recently created pending MoneyAssignment that has not yet been split */
  pendingMoneyAssignment: Maybe<MoneyManagerMoneyAssignment>;
  /** The projected deposit amount based on annual income */
  predictedDepositAmount: Maybe<MoneyRulesCurrencyAmount>;
  /** The state of Money Manager deposits for the customer */
  state: Maybe<MoneyManagerDepositState>;
};

export type MoneyManagerEligibilityResult = {
  __typename?: 'MoneyManagerEligibilityResult';
  ineligibleReasons: Maybe<Array<IneligibleReasons>>;
  isEligible: Scalars['Boolean'];
};

export type MoneyManagerError = {
  message: Scalars['String'];
};

export type MoneyManagerGlobalConfig = {
  __typename?: 'MoneyManagerGlobalConfig';
  recurringDepositsConfig: MoneyManagerRecurringDepositsConfig;
};

export type MoneyManagerInputError = MoneyManagerError & {
  __typename?: 'MoneyManagerInputError';
  message: Scalars['String'];
};

export type MoneyManagerMoneyAssignment = {
  allocations: Array<MoneyManagerAllocation>;
  amount: MoneyRulesCurrencyAmount;
  cancelReason: Maybe<MoneyManagerCancelReason>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The status of the MoneyAssignment as a whole including the Assignment Target Allocations */
  status: MoneyManagerMoneyAssignmentStatus;
  type: MoneyManagerMoneyAssignmentType;
  userId: Scalars['String'];
};

export enum MoneyManagerMoneyAssignmentStatus {
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED',
  TRANSFERRING = 'TRANSFERRING'
}

export enum MoneyManagerMoneyAssignmentType {
  DEPOSIT = 'DEPOSIT',
  REBALANCE = 'REBALANCE'
}

export type MoneyManagerNormalizedAmounts = {
  __typename?: 'MoneyManagerNormalizedAmounts';
  daily: Maybe<MoneyRulesCurrencyAmount>;
  monthly: Maybe<MoneyRulesCurrencyAmount>;
  weekly: Maybe<MoneyRulesCurrencyAmount>;
  yearly: Maybe<MoneyRulesCurrencyAmount>;
};

export type MoneyManagerPageInfo = {
  __typename?: 'MoneyManagerPageInfo';
  hasNextPage: Scalars['Boolean'];
  /** We don't actually have the ability to determine if there was a previous page. Will return true if a cursor was provided */
  hasPreviousPage: Scalars['Boolean'];
  limit: Scalars['Int'];
};

export type MoneyManagerPageInput = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type MoneyManagerPaycheck = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerPaycheck';
  amount: MoneyRulesCurrencyAmount;
  category: MoneyManagerDepositCategory;
  createdAt: Scalars['DateTime'];
  employer: Scalars['String'];
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type MoneyManagerPeriod = {
  __typename?: 'MoneyManagerPeriod';
  unit: MoneyManagerPeriodUnit;
  value: Scalars['Int'];
};

export type MoneyManagerPeriodInput = {
  unit: MoneyManagerPeriodUnit;
  value: Scalars['Int'];
};

export enum MoneyManagerPeriodUnit {
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

/** Mirrors MoneyManagerAllocationResult */
export type MoneyManagerRebalanceAllocationInput = {
  amount: MoneyRulesCurrencyAmountInput;
  destination: MoneyRulesDestinationInput;
  rulePriority: Scalars['Int'];
};

export type MoneyManagerRebalanceAssignment = MoneyManagerMoneyAssignment & {
  __typename?: 'MoneyManagerRebalanceAssignment';
  accountId: Scalars['ID'];
  allocations: Array<MoneyManagerAllocation>;
  amount: MoneyRulesCurrencyAmount;
  cancelReason: Maybe<MoneyManagerCancelReason>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  sourceAccountType: MoneyManagerRebalanceSourceAccountType;
  status: MoneyManagerMoneyAssignmentStatus;
  type: MoneyManagerMoneyAssignmentType;
  userId: Scalars['String'];
};

/** Similar to a MoneyManagerAssignment, but stripped down */
export type MoneyManagerRebalanceResult = {
  __typename?: 'MoneyManagerRebalanceResult';
  allocations: Array<MoneyManagerAllocationResult>;
  createdAt: Scalars['DateTime'];
  ruleset: MoneyManagerRebalanceRuleset;
  sourceAccountId: Scalars['ID'];
  sourceAccountType: MoneyManagerRebalanceSourceAccountType;
  sourceAmount: MoneyRulesCurrencyAmount;
};

export type MoneyManagerRebalanceRuleset = {
  __typename?: 'MoneyManagerRebalanceRuleset';
  archetype: MoneyRulesArchetype;
  createdAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export type MoneyManagerRebalanceRulesetInput = {
  archetype: MoneyRulesArchetype;
  createdAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

/** Contains only SourceAccountTypes allowed for rebalances */
export enum MoneyManagerRebalanceSourceAccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS'
}

export enum MoneyManagerRebalanceSuppressionSource {
  CLIENT_HOME = 'CLIENT_HOME',
  MONEY_MANAGER_LANDER = 'MONEY_MANAGER_LANDER',
  MONEY_MANAGER_REBALANCE_FLOW = 'MONEY_MANAGER_REBALANCE_FLOW'
}

export type MoneyManagerRebalancesResponse = {
  __typename?: 'MoneyManagerRebalancesResponse';
  rebalances: Array<Maybe<MoneyManagerRebalanceResult>>;
};

export type MoneyManagerRecurringDeposit = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerRecurringDeposit';
  amount: MoneyRulesCurrencyAmount;
  category: MoneyManagerDepositCategory;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type MoneyManagerRecurringDepositsConfig = {
  __typename?: 'MoneyManagerRecurringDepositsConfig';
  allowedFrequencies: Array<MoneyManagerRecurringFrequency>;
  maximumAmount: MoneyRulesCurrencyAmount;
  minimumAmount: MoneyRulesCurrencyAmount;
};

export enum MoneyManagerRecurringFrequency {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type MoneyManagerRulesetNotFoundError = MoneyManagerError & {
  __typename?: 'MoneyManagerRulesetNotFoundError';
  message: Scalars['String'];
};

export type MoneyManagerScheduledDeposit = {
  amount: MoneyRulesCurrencyAmount;
  expectedDate: Maybe<Scalars['DateTime']>;
};

export type MoneyManagerScheduledPaycheck = MoneyManagerScheduledDeposit & {
  __typename?: 'MoneyManagerScheduledPaycheck';
  amount: MoneyRulesCurrencyAmount;
  employer: Scalars['String'];
  expectedDate: Maybe<Scalars['DateTime']>;
};

export type MoneyManagerScheduledRecurringDeposit = MoneyManagerScheduledDeposit & {
  __typename?: 'MoneyManagerScheduledRecurringDeposit';
  amount: MoneyRulesCurrencyAmount;
  expectedDate: Maybe<Scalars['DateTime']>;
};

export type MoneyManagerSettings = {
  __typename?: 'MoneyManagerSettings';
  depositSources: Array<MoneyRulesSourceSetting>;
  processRecurringDeposits: Scalars['Boolean'];
  status: MoneyManagerStatus;
  suppressRebalancesUntil: Maybe<Scalars['DateTime']>;
  userId: Scalars['ID'];
};

export type MoneyManagerSourceSetting = {
  __typename?: 'MoneyManagerSourceSetting';
  depositType: MoneyRulesDepositType;
  displayName: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  source: Scalars['String'];
};

/** Input type for MoneyManager allocation. */
export type MoneyManagerStagedRulesInput = {
  distribution: MoneyRulesDistributionInput;
  singleRuleId: Scalars['Int'];
};

export enum MoneyManagerState {
  /** The customer has never had the Money Manager turned on */
  NOT_SETUP = 'NOT_SETUP',
  /** The Money Manager is turned off */
  OFF = 'OFF',
  /** The Money Manager is turned on */
  ON = 'ON'
}

export enum MoneyManagerStatus {
  NOT_SETUP = 'NOT_SETUP',
  OFF = 'OFF',
  ON = 'ON'
}

/** Represents the current summary and state of the money manager */
export type MoneyManagerSummary = {
  __typename?: 'MoneyManagerSummary';
  depositSummary: MoneyManagerDepositSummary;
  /** The amount received by the Money Manager this month */
  receivedThisPeriodAmount: MoneyRulesCurrencyAmount;
  /** The amount scheduled for the Money Manager for this month */
  scheduledThisPeriodAmount: MoneyRulesCurrencyAmount;
  /**
   * The state of the Money Manager for the customer
   * @deprecated Use status on MoneyManagerSettings instead
   */
  state: MoneyManagerState;
};

export enum MoneyRulesAccountType {
  CHECKING = 'CHECKING',
  EARLY = 'EARLY',
  INVEST = 'INVEST',
  LATER = 'LATER',
  SAVINGS = 'SAVINGS'
}

export enum MoneyRulesArchetype {
  DEBT_FOCUSED = 'DEBT_FOCUSED',
  DEFAULT = 'DEFAULT',
  DEFAULT_REBALANCE = 'DEFAULT_REBALANCE',
  GIVING_FOCUSED = 'GIVING_FOCUSED'
}

export type MoneyRulesArchetypesInput = {
  archetypes?: InputMaybe<Array<MoneyRulesArchetype>>;
  date?: InputMaybe<Scalars['DateTime']>;
};

export type MoneyRulesArchetypesResult = MoneyRulesArchetypesSuccess;

export type MoneyRulesArchetypesSuccess = {
  __typename?: 'MoneyRulesArchetypesSuccess';
  rulesets: Array<MoneyRulesRuleset>;
};

export type MoneyRulesCancelMoneyAssignmentSuccess = {
  __typename?: 'MoneyRulesCancelMoneyAssignmentSuccess';
  moneyAssignment: MoneyManagerMoneyAssignment;
};

export type MoneyRulesCondition = {
  __typename?: 'MoneyRulesCondition';
  fallback: Maybe<MoneyRulesDestination>;
  type: MoneyRulesConditionType;
  unit: MoneyRulesConditionUnit;
  value: Scalars['Float'];
};

export type MoneyRulesConditionInput = {
  fallback?: InputMaybe<MoneyRulesDestinationInput>;
  type: MoneyRulesConditionType;
  unit: MoneyRulesConditionUnit;
  value: Scalars['Float'];
};

export enum MoneyRulesConditionType {
  DEBT_EXISTS = 'DEBT_EXISTS',
  HIGH_INTEREST_DEBT_EXISTS = 'HIGH_INTEREST_DEBT_EXISTS',
  SOURCE_AMOUNT_AT_LEAST = 'SOURCE_AMOUNT_AT_LEAST'
}

export enum MoneyRulesConditionUnit {
  CURRENCY = 'CURRENCY'
}

export type MoneyRulesCurrencyAmount = {
  __typename?: 'MoneyRulesCurrencyAmount';
  currency: Currency;
  value: Scalars['Float'];
};

export type MoneyRulesCurrencyAmountInput = {
  currency: Currency;
  value: Scalars['Float'];
};

export enum MoneyRulesDepositType {
  ONE_TIME = 'ONE_TIME',
  PAYCHECK = 'PAYCHECK',
  RECURRING = 'RECURRING'
}

export type MoneyRulesDestination = {
  __typename?: 'MoneyRulesDestination';
  accountId: Scalars['String'];
  accountType: MoneyRulesAccountType;
};

export type MoneyRulesDestinationInput = {
  accountId: Scalars['String'];
  accountType: MoneyRulesAccountType;
};

export type MoneyRulesDistribution = {
  __typename?: 'MoneyRulesDistribution';
  unit: MoneyRulesDistributionUnit;
  value: Scalars['Float'];
};

export type MoneyRulesDistributionInput = {
  unit: MoneyRulesDistributionUnit;
  value: Scalars['Float'];
};

export enum MoneyRulesDistributionUnit {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export type MoneyRulesMoneySource = {
  __typename?: 'MoneyRulesMoneySource';
  accountId: Scalars['String'];
  accountType: MoneyRulesAccountType;
  amount: MoneyRulesCurrencyAmount;
};

export type MoneyRulesMoneySourceInput = {
  accountId: Scalars['String'];
  accountType: MoneyRulesAccountType;
  amount: MoneyRulesCurrencyAmountInput;
};

export type MoneyRulesMoneySplit = {
  __typename?: 'MoneyRulesMoneySplit';
  destination: MoneyRulesDestination;
  distribution: MoneyRulesDistribution;
};

export type MoneyRulesRule = {
  __typename?: 'MoneyRulesRule';
  conditions: Array<MoneyRulesCondition>;
  destination: MoneyRulesDestination;
  distribution: MoneyRulesDistribution;
  priority: Scalars['Int'];
  ruleType: MoneyRulesRuleType;
};

export type MoneyRulesRuleInput = {
  conditions: Array<MoneyRulesConditionInput>;
  destination: MoneyRulesDestinationInput;
  distribution: MoneyRulesDistributionInput;
  priority: Scalars['Int'];
  ruleType: MoneyRulesRuleType;
};

export enum MoneyRulesRuleType {
  FLAT_PCT = 'FLAT_PCT',
  FLAT_PCT_UP_TO_LATER_GOAL = 'FLAT_PCT_UP_TO_LATER_GOAL',
  FLAT_VALUE = 'FLAT_VALUE',
  FULL_REMAINDER = 'FULL_REMAINDER',
  UP_TO_CHECKING_GOAL = 'UP_TO_CHECKING_GOAL',
  UP_TO_SAVINGS_GOAL = 'UP_TO_SAVINGS_GOAL'
}

export type MoneyRulesRuleset = {
  __typename?: 'MoneyRulesRuleset';
  archetype: MoneyRulesArchetype;
  createdAt: Scalars['DateTime'];
  isCustomized: Scalars['Boolean'];
  minimumAmount: Scalars['Int'];
  rules: Array<MoneyRulesRule>;
};

export type MoneyRulesRulesetInput = {
  archetype: MoneyRulesArchetype;
  minimumAmount: Scalars['Int'];
  rules: Array<MoneyRulesRuleInput>;
};

export type MoneyRulesRulesetNotFoundException = {
  __typename?: 'MoneyRulesRulesetNotFoundException';
  message: Scalars['String'];
};

export type MoneyRulesSettings = {
  __typename?: 'MoneyRulesSettings';
  depositSources: Array<MoneyRulesSourceSetting>;
  /** @deprecated Use status instead */
  moneyManagerEnabled: Scalars['Boolean'];
  processRecurringDeposits: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type MoneyRulesSourceSetting = {
  __typename?: 'MoneyRulesSourceSetting';
  depositType: MoneyRulesDepositType;
  displayName: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  source: Scalars['String'];
};

export type MoneyRulesSplitOverridesInput = {
  acornsIncomePercentage?: InputMaybe<Scalars['Float']>;
  adjustForAcornsIncomeShare?: InputMaybe<Scalars['Boolean']>;
  grossYearlyIncome?: InputMaybe<Scalars['Int']>;
  stateOfResidence?: InputMaybe<StateCode>;
};

export type MoneyRulesSuggestedSplits = {
  __typename?: 'MoneyRulesSuggestedSplits';
  moneySource: MoneyRulesMoneySource;
  rulesetVersion: Maybe<Scalars['Int']>;
  splits: Array<Maybe<MoneyRulesMoneySplit>>;
};

export type MoneyRulesSuggestionResult = MoneyRulesSuggestedSplits;

export type MoneyRulesUpdateArchetypeResult = MoneyRulesUpdateRulesetSuccess;

export type MoneyRulesUpdateCustomerMoneyRulesResult = MoneyRulesUpdateRulesetSuccess;

export type MoneyRulesUpdateRulesetSuccess = {
  __typename?: 'MoneyRulesUpdateRulesetSuccess';
  resultingRuleset: MoneyRulesRuleset;
};

export type MonthlyTotal = {
  __typename?: 'MonthlyTotal';
  isPredicted: Scalars['Boolean'];
  totalAmount: FormattedMonetaryAmount;
  yearMonth: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Placeholder mutation to provide a valid root type for the schema. */
  _placeholder: Maybe<Scalars['Boolean']>;
  /** DEPRECATED - use agreeToAcceptanceDocument instead */
  acceptDocument: AcceptDocumentResponse;
  activateBankCard: Maybe<ActivateBankCardPayload>;
  /** @implicit(userId: ID!) */
  addCohortEligibility: AddCohortEligibilityResult;
  /** @implicit(userId: String!) */
  addFavoritePartnerOffers: FavoritePartnerOfferGroup;
  /** Saves new search term and returns that term when it is saved */
  addSearchTermToLearnSearchHistory: AddSearchTermToLearnSearchHistoryResult;
  /** Adds a security to a portfolio */
  addSecurityToPortfolio: AddSecurityToPortfolioResult;
  /** Add a Self Directed Portfolio */
  addSelfDirectedPortfolio: AddSelfDirectedPortfolioResult;
  /** Add a trusted contact for a user */
  addTrustedContact: UpdateTrustedContactResult;
  agreeToAcceptanceDocument: Maybe<Scalars['Void']>;
  /** Validate a challenge. */
  answerChallenge: AnswerChallengeResult;
  /** @implicit(userId: ID!) */
  answerLearnQuizQuestion: AnswerLearnQuizQuestionResult;
  /** Apply a promotion to an existing subscription. May entitle a subscriber to promotional pricing for their subscription and/or additional incentives. */
  applyPromotion: ApplyPromotionResult;
  /** Apply a promotional waiver */
  applyPromotionalWaiver: Maybe<ApplyPromotionalWaiverResult>;
  /** Apply a provisional (open ended) waiver */
  applyProvisionalWaiver: Maybe<ApplyProvisionalWaiverResult>;
  archiveInvalidSmartDepositSettings: ArchiveInvalidSmartDepositRecordsResult;
  /** @implicit(userId: String!) */
  askFinancialAdvisorQuestion: FinancialAdvisorQuestionResponse;
  /** Assign a linked subaccount to a role (i.e. funding source) */
  assignLinkedSubaccount: Maybe<LinkedSubaccount>;
  /** Request an AuthSession for the provided credentials. */
  authenticate: AuthenticateResult;
  authenticateForFeeNegotiation: AuthenticateForFeeNegotiationResult;
  authenticateForFeeNegotiationChallenge: AuthenticateNegotiationStatusResult;
  authenticateForFeeNegotiationChallengeMethod: AuthenticateNegotiationStatusResult;
  /** Batch adds tier-subscription items for users for specified user uuids, tierIds, tierPriceId */
  batchAddTierSubscriptions: BatchAddTierSubscriptionsResult;
  /** @implicit(userId: ID!) */
  blockDevice: BlockDeviceResult;
  cancelCheckPayment: Maybe<CancelCheckPaymentResult>;
  /** @implicit(userId: UUID!) */
  cancelIntent: CancelIntentResult;
  /** Cancel pending investment */
  cancelInvestment: CancelInvestmentResult;
  /** Cancel an existing account closure request */
  cancelInvestmentAccountClosureRequest: CancelInvestmentAccountClosureRequestResult;
  /** Gives the customer the ability to cancel a pending Money Assignment */
  cancelMoneyAssignment: Maybe<CancelMoneyAssignmentResult>;
  /** @implicit(userId: ID!) */
  cancelRecurringTransfer: Maybe<CancelRecurringTransferResult>;
  cancelTransfer: Maybe<CancelTransferPayload>;
  /** Change the amount of an outside contribution payment intent */
  changeOutsideContributionAmount: ChangeOutsideContributionAmountResult;
  changePIN: Maybe<Scalars['Void']>;
  /** Changes a users password if password change criteria is met */
  changePassword: Maybe<Scalars['Void']>;
  /** @implicit(userId: ID!) */
  changePasswordAuth: ChangePasswordResult;
  clearSupportSiteCache: Maybe<ClearSupportSiteCache>;
  closeBankAccount: CloseBankAccountResult;
  /** Start the account closure process for the specified investment account */
  closeInvestmentAccount: CloseInvestmentAccountResult;
  /** Close an open Acorns user account */
  closeUserAccount: CloseUserAccountResult;
  completeCheckDeposit: Maybe<CompleteCheckDepositPayload>;
  /** Mark account as having completed the registration funnel */
  completeFunnelOnboarding: CompleteFunnelOnboardingResult;
  completeRegistration: Maybe<User>;
  configureSplitDepositDirectDepositIntentSetting: ConfigureSplitDepositDirectDepositIntentPayload;
  configureSplitDepositDirectDepositSetting: ConfigureSplitDepositDirectDepositSettingPayload;
  connectACHAccount: ConnectAchAccountResult;
  connectLadderCustomer: Maybe<LadderLinkResponse>;
  consumeUserToken: ConsumeUserTokenResult;
  /** @implicit(userId: ID!) */
  createAuthProfile: CreateAuthProfileResult;
  createAuthenticatedSupportTicket: Maybe<SupportTicket>;
  /** @deprecated External createBankAccount is no longer supported. For creating a checking account, we use orderBankCard mutation. */
  createBankAccount: Maybe<CreateBankAccountPayload>;
  /** Create a beneficiary */
  createBeneficiary: CreateBeneficiaryResult;
  /** Get Pinwheel Link Token */
  createDirectDepositLinkInfo: CreateDirectDepositLinkInfoSwitch;
  createDocumentUpload: CreateDocumentUpload;
  createIRAWithProfile: Maybe<CreateInvestmentAccountResponse>;
  /** @implicit(userId: UUID!) */
  createIntent: CreateIntentResult;
  /** Calculates portfolio recommendation based off of specific factors for specific account type */
  createInvestingStrategyRecommendation: CreateInvestingStrategyRecommendationResult;
  createInvestmentAccount: Maybe<CreateInvestmentAccountResponse>;
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  createJobAlert: Maybe<CreateJobAlertResult>;
  createLadderQuote: Maybe<LadderResponse>;
  createLaterContribution: Maybe<Scalars['Void']>;
  /** (Internal-only) Provision a new offer. */
  createOffer: CreateOfferResult;
  /** Create a new Outside Contribution */
  createOutsideContribution: CreateOutsideContributionResult;
  /** Generate outside contribution payment token */
  createOutsideContributionCheckoutCart: CreateOutsideContributionCheckoutCartResult;
  /** Create a linked account */
  createPlaidLinkedAccount: Maybe<LinkedAccount>;
  /** Create a Prospect User */
  createProspectUser: CreateProspectUserResult;
  createReferralCampaign: CreateReferralCampaignResult;
  createReferralCampaignReward: CreateReferralCampaignRewardResult;
  createReferralPayout: CreateReferralPayoutResult;
  /** @implicit(userId: ID!) */
  createReferralRelationship: CreateReferralRelationshipResult;
  /** (Internal-only) Create a refund for a given invoice */
  createRefund: Maybe<CreateRefundResult>;
  createSavingsAccount: CreateSavingsAccountResult;
  /** (Internal-only) Provision a new subscription migration. */
  createSubscriptionMigration: CreateSubscriptionMigrationResult;
  /** @deprecated Replaced with createSupportTicketOrException mutation. */
  createSupportTicket: Maybe<SupportTicket>;
  createSupportTicketOrException: Maybe<SupportTicketResponse>;
  createSupportTicketWithCustomFields: Maybe<SupportTicketWithCustomFieldsResponse>;
  createSuspendedUserSupportTicket: Maybe<SupportTicketWithCustomFieldsResponse>;
  /** Create a presigned post for direct to s3 file upload */
  createUploadUrl: CreateUploadUrlResult;
  createUser: Maybe<Session>;
  /** Creates a new user and user profile */
  createUserProfile: CreateUserProfileResult;
  /** Create a billing vendor invoice */
  createVendorInvoice: Maybe<CreateVendorInvoiceResult>;
  /** Create a new billing vendor line item */
  createVendorLineItem: Maybe<CreateVendorLineItemResult>;
  /** Deactivates the specified account and returns the newley deactived account. */
  deactivateAccount: Maybe<Account>;
  /** Deactivate a beneficiary that is no longer used */
  deactivateBeneficiary: DeactivateBeneficiaryResult;
  /** Deactivate a user's subscription */
  deactivateTierSubscription: DeactivateTierSubscriptionResult;
  deleteExpiredBankCardOrder: Maybe<DeleteExpiredBankCardOrderResult>;
  /** Deletes a trusted contact for a user */
  deleteTrustedContact: DeleteTrustedContactResult;
  /** Deregister and Authenticator. */
  deregisterAuthenticator: DeregisterAuthenticatorResult;
  destroySession: Maybe<Scalars['Void']>;
  /** @implicit(userId: ID!) */
  dismissMessage: UpdateMessageResult;
  /** @implicit(userId: ID!) */
  dismissMessages: DismissMessagesResult;
  /** Edit a trusted contact for a user */
  editTrustedContact: UpdateTrustedContactResult;
  /** Enable quarterly investment account recaps for an investment account. */
  enableQuarterlyRecaps: EnableQuarterlyRecapsResult;
  /** Explicitly end the chat session. */
  endChatSession: EndChatSessionResponse;
  exchangeAcornsEarlyToken: ExchangeAcornsEarlyTokenResult;
  /** Executes money manager rebalances based on the provided rebalance assignments */
  executeMoneyManagerRebalances: ExecuteMoneyManagerRebalancesResult;
  /** Expire a promotional waiver */
  expirePromotionalWaiver: Maybe<ExpirePromotionalWaiverResult>;
  /** Mark an open billing vendor invoice as failed */
  failVendorInvoice: Maybe<FailVendorInvoiceResult>;
  /** Record an action feed event */
  feedEvent: Maybe<ActionFeedEventResponse>;
  /** Creates session input to initialize SDK for document upload and verification */
  generateDocumentUploadSession: GenerateDocumentUploadSessionResult;
  /** Generate a link token for layer account linking */
  generateLayerLinkSession: GenerateLayerLinkSessionResult;
  /** Generate a Link Token and return either the Link Token of Link URL for use with Account Linking. */
  generateLinkSession: LinkSessionResult;
  /** @implicit(userId: ID!) */
  generateReferralCode: GenerateReferralCodeResult;
  /** @implicit(userId: ID!) */
  hideMessage: UpdateMessageResult;
  /** @implicit(userId: ID!) */
  hideMessageByExternalId: UpdateMessageResult;
  initiateBankAccountCreation: InitiateBankAccountResponse;
  initiateBankingKYC: InitiateBankingKycPayload;
  /** Initiate challenge following credentials validation. */
  initiateChallenge: InitiateChallengeResult;
  /** Initiate registration of an EmailAuthenticator. */
  initiateEmailChallenge: InitiateEmailChallengeResult;
  initiateLaterProgramAccountContribution: Maybe<LaterProgramAccountContributionResult>;
  /** Gives the customer the ability to immediately start the allocation of a pending Money Assignment */
  initiateMoneyAssignment: Maybe<InitiateMoneyAssignmentResult>;
  /** @implicit(userId: ID!) */
  initiatePartnerDataShare: PartnerDataShareResponse;
  /** Initiate sending push notifications to registered PushAuthenticator(s). */
  initiatePushChallenge: InitiatePushChallengeResult;
  /** Initiate registration of a PhoneAuthenticator. */
  initiateSMSChallenge: InitiateSmsChallengeResult;
  initiateTransfer: Maybe<InitiateTransferPayload>;
  /** @implicit(userId: ID!) */
  initiateVerification: InitiateVerificationResult;
  laterCreateIndividualBeneficiary: Maybe<LaterIndividualBeneficiaryResponse>;
  laterTotalLiquidation: Maybe<Scalars['Void']>;
  /** Make a withdrawal from a later account One of either earlyDistributionTaxExceptionReason or reason is required; reason is newer/preferred withdrawalType is no longer supported, since it can be derived */
  laterWithdrawal: Maybe<Scalars['Void']>;
  /** Legacy document upload */
  legacyUploadDocument: LegacyUploadDocumentResult;
  linkACHAccount: Maybe<Scalars['Void']>;
  /** Link a funding source via account and routing number */
  linkManualFundingSource: LinkManualFundingSourceResult;
  /** Link OIDC credentials to an existing account */
  linkOidcCredentials: LinkOidcCredentialsResult;
  lockBankCard: Maybe<LockBankCardPayload>;
  /** @implicit(userId: ID!) */
  logout: LogoutResult;
  /** @implicit(userId: ID!) */
  logoutDevice: LogoutDeviceResult;
  /** Creates a new investment */
  makeInvestment: MakeInvestmentPayload;
  managePayoutRelationship: PayoutRelationshipResult;
  /** @implicit(userId: ID!) */
  markAllAsRead: MarkAllAsReadResult;
  /** Marks content with given ID as helpful and returns ID and helpful flag or error if it does not exist */
  markLearnContentAsHelpful: MarkLearnContentAsHelpfulResult;
  /** Saves content as viewed and returns id and date when it is viewed or error if content does not exist */
  markLearnContentAsViewed: MarkLearnContentAsViewedResult;
  /** Gives the customer the ability update the assignment target amounts for a pending Money Assignment */
  modifyMoneyAssignment: ModifyMoneyAssignmentResult;
  /** Open a Core InvestmentAccount */
  openCoreInvestmentAccount: OpenCoreInvestmentAccountResult;
  /** Create an Acorns Early Account */
  openEarlyAccount: OpenEarlyAccountResult;
  orderBankCard: Maybe<OrderBankCardResult>;
  /** @implicit(userId: String!) */
  postBankFeeNegotiation: BenefitsMessage;
  /** @implicit(userId: String!) */
  postUserReportedBankFeeRefund: BenefitsMessage;
  /** Rate a message where canRate is true. */
  rateChatMessage: RateChatMessageResponse;
  /** @implicit(userId: String!) */
  rateFinancialAdvisorResponse: InteractionRatingResponse;
  /** @implicit(userId: ID!) */
  readMessage: UpdateMessageResult;
  /** Record view_at timestamp on investment account recap. */
  recordInvestmentAccountRecapView: RecordInvestmentAccountRecapViewResult;
  /** Record an Action or Event from Friend */
  recordReferralEvent: RecordReferralEventResult;
  /** Record an external payment for manual billing vendor invoices */
  recordVendorExternalTransaction: Maybe<RecordVendorExternalTransactionResult>;
  redeemGiftcard: Maybe<Scalars['Void']>;
  refreshAuthToken: RefreshAuthTokenResult;
  /** @deprecated Implicit cookie auth no longer supported. */
  refreshCookie: Maybe<Scalars['Void']>;
  /** Regenerate public token for an investment account recap. */
  regenerateInvestmentAccountRecapPublicToken: RegenerateInvestmentAccountRecapPublicTokenResult;
  registerCredentials: RegisterCredentialsResult;
  /** Register a PushAuthenticator and SNS device token. */
  registerDeviceTokenAndPushAuthenticator: RegisterDeviceTokenAndPushAuthenticatorResult;
  /** Register an EmailAuthenticator. */
  registerEmailAuthenticator: RegisterEmailAuthenticatorResult;
  /** Registers linked subaccount after beginning the link session */
  registerLayerLinkSession: RegisterLayerLinkSessionResult;
  /** Save a linked account */
  registerLinkSession: Maybe<RegisterLinkSessionResult>;
  /** Register OIDC credentials */
  registerOidcCredentials: RegisterOidcCredentialsResult;
  /** Register a PhoneAuthenticator. */
  registerPhoneAuthenticator: RegisterPhoneAuthenticatorResult;
  /** Registers a prospect user with associated source attributes */
  registerProspect: RegisterProspectResult;
  /** Re-initiate registration of an Authenticator. */
  reinitiateChallenge: ReinitiateSmsChallengeResult;
  reissueBankCard: Maybe<ReissueBankCardResult>;
  /** @implicit(userId: ID!) */
  removeCohortEligibility: RemoveCohortEligibilityResult;
  /** @implicit(userId: String!) */
  removeFavoritePartnerOffers: FavoritePartnerOfferGroup;
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  removeJobAlert: Maybe<RemoveJobAlertResult>;
  /** Removes a security from a portfolio */
  removeSecurityFromPortfolio: RemoveSecurityFromPortfolioResult;
  /** Start the process for removing a self directed portfolio from an investment account */
  removeSelfDirectedPortfolio: RemoveSelfDirectedPortfolioResult;
  /** Reopen a closed Acorns user account */
  reopenUserAccount: ReopenUserAccountResult;
  reportBankCardLostStolen: Maybe<ReportBankCardLostStolenPayload>;
  requestAccountClosure: Maybe<Scalars['Void']>;
  /** Attempts to close a single or multiple Early investment accounts */
  requestEarlyAccountClosure: Array<RequestEarlyAccountClosureResult>;
  /** Attempts to reopen an investment account. */
  requestInvestmentAccountReopen: RequestInvestmentAccountReopenResult;
  /** Requests start of layer session for user-permissioned information */
  requestLayerSession: RequestLayerSessionResult;
  /** Request to be waived from being migrated to a new Subscription. */
  requestSubscriptionMigrationWaiver: RequestSubscriptionMigrationWaiverResult;
  /** Resends an already sent chat message. For use when the bot does not respond in a reasonable timeframe */
  resendChatMessage: ResendChatMessageResponse;
  resetPIN: Maybe<Scalars['Void']>;
  resetPassword: Maybe<Scalars['Void']>;
  /** Resets a password if the password reset token exists (legacy Backend flow) */
  resetPasswordByToken: ResetPasswordByTokenResult;
  /** Resets a password if the password reset token exists (updated flow through web app) */
  resetPasswordWithToken: ResetPasswordWithTokenResult;
  /** Saves poll respond and returns stats for related poll or error if poll does not exists */
  respondToLearnPoll: RespondToLearnPollResult;
  /** Restore user login access */
  restoreLoginAccess: RestoreLoginAccessResult;
  /** Retriggers RDVs for the user. */
  retriggerRdvs: RetriggerRdvsResult;
  revokeLoginAccess: RevokeLoginAccessResult;
  /** Revokes given reset password token */
  revokePasswordResetToken: RevokePasswordResetTokenResult;
  /** Update a single round up profile for a user */
  roundUpProfile: Maybe<RoundUpProfile>;
  /** Save upload url after direct s3 upload and create upload record */
  saveUploadUrl: LegacyUploadDocumentResult;
  /** Save uploads url after direct s3 upload and create upload record one by one */
  saveUploadUrls: SaveUploadUrlsResult;
  /** @implicit(userId: ID!) */
  scheduleRecurringTransfer: Maybe<ScheduleRecurringTransferResult>;
  sendBrazeEvent: Scalars['String'];
  /** Send a chat message as a user to the bot. The bot will respond asynchronously on the subscription for the user's session. */
  sendChatMessage: SendChatMessageResponse;
  sendCheckPayment: Maybe<SendCheckPaymentResult>;
  /**
   * Send a referral event to Extole. User ID is a required field on the input type,
   * but is not a field level argument as this mutation is only used internally
   */
  sendReferralEvent: Maybe<Scalars['Boolean']>;
  sessionRefresh: Maybe<Session>;
  /** @implicit(userId: ID!) */
  setAuthenticationPIN: SetAuthenticationPinResult;
  /** Update a beneficiary's SSN/TIN */
  setBeneficiarySsn: SetBeneficiarySsnResult;
  /** @implicit(userId: ID!) */
  setDefaultAuthenticator: SetDefaultAuthenticatorResult;
  /** @implicit(userId: String!) */
  setFavoritePartnerOffers: FavoritePartnerOfferGroup;
  /** Set a given investment account recap's public access. */
  setInvestmentAccountRecapPublicAccess: SetInvestmentAccountRecapPublicAccessResult;
  /** Updates a plaid account with a new linking error code. Returns the updated linked account. */
  setLinkingError: Maybe<LinkedAccount>;
  /** Set the manual flag to true on a round up */
  setManualRoundUps: Array<RoundUp>;
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.updateNegotiationStatus instead
   */
  setNegotiationStatus: SetNegotiationStatusResult;
  setPortfolio: User;
  /** Set a funding source as preferred withdrawal account */
  setPreferredWithdrawalAccount: SetPreferredWithdrawalAccountResult;
  setReferralCampaignFlags: SetReferralCampaignFlagsResult;
  /** @implicit(userId: String!) */
  setUserPartnerStatus: UserPartnerStatusResponse;
  splitDeposit: SplitDepositMutation;
  splitDepositSettings: SplitDepositSettingsMutation;
  /** Add a direct deposit employer */
  startAcornsPdfSwitch: Maybe<Scalars['Boolean']>;
  /** Start a chat session with the bot */
  startChatSession: StartChatSessionResponse;
  startCheckDeposit: Maybe<StartCheckDepositPayload>;
  /** Persists a user intention of perform an online switch. */
  startOnlineSwitch: StartOnlineSwitchPayload;
  /** Submits a direct deposit switch via ClickSwitch */
  startSubmittableSwitch: Maybe<StartSubmittableSwitchPayload>;
  stopRecurringInvestment: RecurringInvestmentPayload;
  stub: Maybe<Scalars['String']>;
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.postUserReportedBankFeeRefund instead
   */
  submitBankFeeNegotiation: SubmitBankFeeNegotiationResult;
  /** Submit Earn missing credit request */
  submitEarnMissingCreditRequest: SubmitEarnMissingCreditRequestResult;
  submitRDVs: Scalars['Boolean'];
  submitSpendTransactionsDispute: SpendTransactionsDisputeResult;
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.postUserReportedBankFeeRefund instead
   */
  submitUserReportedBankFeeRefund: SubmitUserReportedBankFeeRefundResult;
  /** Eventually will replace the current 'subscribeUserToTier' mutation */
  subscribeToTier: SubscribeToTierResult;
  /**
   * Attempt to subscribe a user to a specific Tier + TierPrice
   * Reliant on some synchronous calls to service (for statuses)
   */
  subscribeUserToTier: SubscribeUserToTierResult;
  /**
   * Subscribes a user to the cheapest default tier based on their current open accounts
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByOpenAccounts: TierSubscription;
  /**
   * Subscribes a user to the cheapest default tier available with provided productKey
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByProductKey: TierSubscription;
  /** Mark an open billing vendor invoice as successful */
  succeedVendorInvoice: Maybe<SucceedVendorInvoiceResult>;
  /**
   * Suppresses money manager rebalances until a specified future date. This prevents automatic rebalancing of investments
   * for the given user until the specified date. The date must be in the future.
   */
  suppressMoneyManagerRebalances: SuppressMoneyManagerRebalancesResult;
  /** @deprecated Use Mutation.suspendUserDeposits or Mutation.unsuspendUserDeposits instead */
  suspendDeposits: Maybe<Scalars['Void']>;
  /** Suspend user deposits */
  suspendUserDeposits: Scalars['Void'];
  /** @implicit(userId: String!) */
  syncBankFeeTransactions: SyncBankFeeTransactionsResult;
  /** Syncs a user's current primary funding source to vendor */
  syncFundingSourceToVendor: Maybe<SyncFundingSourceToVendorResult>;
  /** Returns the tax withholding amounts for state and federal */
  taxWithholdingAmounts: Maybe<TaxWithholdingAmounts>;
  /** Unauthenticated mutation for creating a presigned post for direct to s3 file upload */
  unauthenticatedCreateUploadUrl: CreateUploadUrlResult;
  /** Unauthenticated mutation for saving upload url after direct s3 upload and create upload record */
  unauthenticatedSaveUploadUrl: UnauthenticatedSaveUploadUrlResult;
  /** @implicit(userId: ID!) */
  unblockDevice: UnblockDeviceResult;
  /** Unlink account and all attached subaccounts */
  unlinkLinkedAccount: Maybe<LinkedAccount>;
  unlockBankCard: Maybe<UnlockBankCardPayload>;
  /** Removes content with given ID from helpful section and returns ID and helpful flag or error if it does not exist */
  unmarkLearnContentAsHelpful: UnmarkLearnContentAsHelpfulResult;
  /** Unsubscribes a user to from their current tier */
  unsubscribeUserFromTier: UnsubscribeUserFromTierResult;
  /** Unsuspend user deposits */
  unsuspendUserDeposits: Scalars['Void'];
  /** Updates Account Portfolio */
  updateAccountPortfolio: UpdateAccountPortfolioResponse;
  /** Update a single address for a user */
  updateAddress: Maybe<Address>;
  /** Updates source attribution data for a user */
  updateAttribution: UpdateAttributionResult;
  /** @implicit(userId: ID!) */
  updateAuthEmail: UpdateAuthEmailResult;
  /** @implicit(userId: ID!) */
  updateAuthPhoneNumber: UpdateAuthPhoneNumberResult;
  updateBankAccountGoal: UpdateBankAccountGoalResult;
  updateBankCardPin: Maybe<UpdateBankCardPinPayload>;
  updateBanners: Maybe<Array<Maybe<BannersResponse>>>;
  /** Update a beneficiary's basic info */
  updateBeneficiaryInfo: UpdateBeneficiaryInfoResult;
  /** @implicit(userId: String!) */
  updateBenefitStatus: UpdateBenefitStatusResponse;
  updateContactInfo: Maybe<User>;
  /** @implicit(userId: ID!) */
  updateCredentials: UpdateCredentialsResult;
  /** @implicit(userId: ID!) */
  updateCustomerMoneyRules: Maybe<MoneyRulesUpdateCustomerMoneyRulesResult>;
  /** Updates elapsed time, the time the user spent in the quiz. */
  updateElapsedTimeForLearnQuiz: UpdateElapsedTimeForLearnQuizResult;
  updateEmail: Maybe<User>;
  updateEmployment: Maybe<User>;
  /** @deprecated Replaced with updateBanners mutation. */
  updateHelpcenterBanner: Maybe<HelpcenterBannerResponse>;
  updateInvestorQuestions: Maybe<User>;
  updateLadderQuote: Maybe<LadderResponse>;
  /** Updates progress for related content and returns id and progress for that content or error if related content does not exist */
  updateLearnContentProgress: UpdateLearnProgressResult;
  /** Updates a plaid account with a new link session id. To be used after re-authenticating a linked account */
  updateLinkedAccount: Maybe<LinkedAccount>;
  /** Update money manager allocations */
  updateMoneyManagerAllocations: UpdateMoneyManagerAllocationsResult;
  /** Sets a money manager automation target. */
  updateMoneyManagerAutomationTarget: UpdateMoneyManagerAutomationTargetResult;
  /** Update the money manager settings for a customer */
  updateMoneyManagerSettings: UpdateMoneyManagerSettingsResult;
  /**
   * Update the money rules source settings for a customer
   * @deprecated Use updateMoneyManagerSettings instead
   */
  updateMoneyRulesSourceSettings: Maybe<UpdateMoneyRulesSourceSettingsResult>;
  /** @implicit(userId: String!) */
  updateNegotiationStatus: BenefitsMessage;
  updateNotification: Maybe<Scalars['Void']>;
  /** Returns the user profile with the updated optedOutOfTargeting field */
  updateOptOutOfTargeting: Maybe<Profile>;
  /** Updates user profile information */
  updatePersonalInfo: Maybe<User>;
  /** Update the securities and target allocation percentages of the portfolio */
  updatePortfolioSecurities: UpdatePortfolioSecuritiesResult;
  /** Update a single profile for a user */
  updateProfile: Maybe<Profile>;
  /** Update the JSON configuration file associated with promoted brands */
  updatePromotedCampaigns: Maybe<UpdatePromotedCampaignsResult>;
  /** Update the recurring investment settings for the specified InvestmentAccount (defaults to the authenticated User's Core InvestmentAccount if not specified). */
  updateRecurringInvestment: RecurringInvestmentPayload;
  updateReferralCampaign: UpdateReferralCampaignResult;
  updateReferralPayout: UpdateReferralPayoutResult;
  /** Mutation to update referral relationship status */
  updateReferralRelationship: UpdateReferralRelationshipResult;
  /**
   * Update a Referral Reward as Rewarded or Cancelled.
   * Returns UpdateReferralRewardError if given rewardId is not found
   */
  updateReferralRewardStatus: UpdateReferralRewardResponse;
  /** @implicit(userId: ID) */
  updateReferralUserProfile: Maybe<Scalars['ID']>;
  /** Updates a registration record */
  updateRegistration: Result;
  /** Update a single Round Up Account for a given ID */
  updateRoundUpAccount: Maybe<RoundUpAccount>;
  /** Update a certificate or card signature for a user */
  updateSignature: Maybe<Signature>;
  /** Update a user's suitability */
  updateSuitability: Maybe<Suitability_UpdateSuitabilityResult>;
  /** Mutation to update user profile and automation target. */
  updateUserProfileAndAutomationTarget: UpdateUserProfileAndAutomationTargetResult;
  /**
   * Update the user switch state in the Direct Deposit Database using the
   * switchState Enum. This switch state provides us insight into the status of a
   * user in the PDF DD flow.
   */
  updateUserSwitchState: UpdateUserSwitchState;
  /** @implicit(userId: ID!) */
  updateVerificationProfile: UpdateVerificationProfileResult;
  /** Upgrade to JWT authentication */
  upgradeAuthentication: UpgradeAuthenticationResult;
  uploadAudienceList: Scalars['String'];
  uploadCheck: Maybe<UploadCheckPayload>;
  uploadDocuments: Array<FileOrException>;
  uploadUnsolicitedDocuments: Array<FileOrException>;
  /** Create or update a User Match Record */
  upsertUserMatch: UpsertUserMatchResult;
  /** Request an MFA token for the provided credentials. */
  validateCredentials: ValidateCredentialsResult;
  /** Validate a user suspended upload token */
  validateUserSuspendedUploadToken: ValidateUserSuspendedUploadTokenResult;
  vendAuthSession: VendAuthSessionResult;
  verifyDevice: VerifyDeviceResult;
  /** @implicit(userId: ID!) */
  verifyIdentityByDocuments: VerifyIdentityByDocumentsResult;
  /** Verify and create a later account */
  verifyLaterAccountOrError: LaterAccountInfoOrError;
  /** @implicit(userId: ID!) */
  verifyPasswords: VerifyPasswordsResult;
  /** Verify a user's manually linked funding source with RDVs */
  verifyRdvs: VerifyRdvsResult;
};


export type MutationAcceptDocumentArgs = {
  input: AcceptDocumentInput;
};


export type MutationActivateBankCardArgs = {
  input: ActivateBankCardInput;
};


export type MutationAddCohortEligibilityArgs = {
  input: AddCohortEligibilityInput;
};


export type MutationAddFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput;
};


export type MutationAddSearchTermToLearnSearchHistoryArgs = {
  input: AddSearchTermToLearnSearchHistoryInput;
};


export type MutationAddSecurityToPortfolioArgs = {
  input: AddSecurityToPortfolioInput;
};


export type MutationAddSelfDirectedPortfolioArgs = {
  input: AddSelfDirectedPortfolioInput;
};


export type MutationAddTrustedContactArgs = {
  input: TrustedContactInput;
};


export type MutationAgreeToAcceptanceDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationAnswerChallengeArgs = {
  input: ChallengeAnswerInput;
};


export type MutationAnswerLearnQuizQuestionArgs = {
  input: AnswerLearnQuizQuestionInput;
};


export type MutationApplyPromotionArgs = {
  input: ApplyPromotionInput;
};


export type MutationApplyPromotionalWaiverArgs = {
  input: ApplyPromotionalWaiverInput;
};


export type MutationApplyProvisionalWaiverArgs = {
  waiverPeriodEndDate: Scalars['String'];
  waiverReason: Scalars['String'];
};


export type MutationAskFinancialAdvisorQuestionArgs = {
  question: Scalars['String'];
  sessionId: Scalars['String'];
};


export type MutationAssignLinkedSubaccountArgs = {
  input: AssignLinkedSubaccountInput;
  linkedSubaccountId: Scalars['ID'];
};


export type MutationAuthenticateArgs = {
  alternateAuthenticatorId?: InputMaybe<Scalars['ID']>;
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>;
  input: AuthenticateInput;
  vendIdToken?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAuthenticateForFeeNegotiationArgs = {
  input: AuthenticateForFeeNegotiationInput;
};


export type MutationAuthenticateForFeeNegotiationChallengeArgs = {
  input: AuthenticateForFeeNegotiationChallengeInput;
};


export type MutationAuthenticateForFeeNegotiationChallengeMethodArgs = {
  input: AuthenticateForFeeNegotiationChallengeMethodInput;
};


export type MutationBatchAddTierSubscriptionsArgs = {
  input: BatchAddTierSubscriptionsInput;
};


export type MutationBlockDeviceArgs = {
  input: BlockDeviceInput;
};


export type MutationCancelCheckPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationCancelIntentArgs = {
  nonce: Scalars['UUID'];
};


export type MutationCancelInvestmentArgs = {
  input: CancelInvestmentInput;
};


export type MutationCancelInvestmentAccountClosureRequestArgs = {
  input: CancelInvestmentAccountClosureRequestInput;
};


export type MutationCancelMoneyAssignmentArgs = {
  input: CancelMoneyAssignmentInput;
};


export type MutationCancelRecurringTransferArgs = {
  id: Scalars['ID'];
};


export type MutationCancelTransferArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationChangeOutsideContributionAmountArgs = {
  input: ChangeOutsideContributionAmountInput;
};


export type MutationChangePinArgs = {
  answer: Scalars['String'];
  newPIN: Scalars['String'];
  oldPIN: Scalars['String'];
  questionId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  securityAnswer?: InputMaybe<SecurityAnswer>;
};


export type MutationChangePasswordAuthArgs = {
  input: ChangePasswordInput;
};


export type MutationCloseBankAccountArgs = {
  input: CloseBankAccountInput;
};


export type MutationCloseInvestmentAccountArgs = {
  input: CloseInvestmentAccountInput;
};


export type MutationCompleteCheckDepositArgs = {
  input: CompleteCheckDepositInput;
};


export type MutationConfigureSplitDepositDirectDepositIntentSettingArgs = {
  input: ConfigureSplitDepositDirectDepositIntentSettingInput;
};


export type MutationConfigureSplitDepositDirectDepositSettingArgs = {
  input: ConfigureSplitDepositDirectDepositSettingInput;
};


export type MutationConnectAchAccountArgs = {
  input: ConnectAchAccountInput;
};


export type MutationConnectLadderCustomerArgs = {
  quoteId: Scalars['ID'];
};


export type MutationConsumeUserTokenArgs = {
  userTokenId: Scalars['ID'];
};


export type MutationCreateAuthProfileArgs = {
  input?: InputMaybe<CreateAuthProfileInput>;
};


export type MutationCreateAuthenticatedSupportTicketArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};


export type MutationCreateBeneficiaryArgs = {
  input: BeneficiaryInput;
};


export type MutationCreateDirectDepositLinkInfoArgs = {
  input: CreateDirectDepositLinkInfoInput;
};


export type MutationCreateDocumentUploadArgs = {
  input: CreateDocumentUploadInput;
};


export type MutationCreateIraWithProfileArgs = {
  iraType?: InputMaybe<InvestmentAccountTypes>;
  profileAttributes: Array<InputMaybe<ProfileAttribute>>;
};


export type MutationCreateIntentArgs = {
  input: CreateIntentInput;
};


export type MutationCreateInvestingStrategyRecommendationArgs = {
  input: CreateInvestingStrategyRecommendationInput;
};


export type MutationCreateInvestmentAccountArgs = {
  iraType?: InputMaybe<InvestmentAccountTypes>;
  portfolioId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateJobAlertArgs = {
  alertCriteria: JobAlertCriteriaInput;
};


export type MutationCreateLadderQuoteArgs = {
  address: Scalars['String'];
  age: Scalars['Int'];
  city: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  state: StateCode;
  zip: Scalars['String'];
};


export type MutationCreateLaterContributionArgs = {
  accountId: Scalars['ID'];
  amount: Scalars['Float'];
  year?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateOfferArgs = {
  input: CreateOfferInput;
};


export type MutationCreateOutsideContributionArgs = {
  input: CreateOutsideContributionInput;
};


export type MutationCreateOutsideContributionCheckoutCartArgs = {
  input: CreateOutsideContributionCheckoutCartInput;
};


export type MutationCreatePlaidLinkedAccountArgs = {
  input: CreatePlaidLinkedAccountInput;
  publicToken: Scalars['String'];
};


export type MutationCreateProspectUserArgs = {
  input: CreateProspectUserInput;
};


export type MutationCreateReferralCampaignArgs = {
  input: CreateReferralCampaignInput;
};


export type MutationCreateReferralCampaignRewardArgs = {
  input: CreateReferralCampaignRewardInput;
};


export type MutationCreateReferralPayoutArgs = {
  input: CreateReferralPayoutInput;
};


export type MutationCreateReferralRelationshipArgs = {
  referralCode: Scalars['String'];
};


export type MutationCreateRefundArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationCreateSavingsAccountArgs = {
  input: CreateSavingsAccountInput;
};


export type MutationCreateSubscriptionMigrationArgs = {
  input: CreateSubscriptionMigrationInput;
};


export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateSupportTicketOrExceptionArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateSupportTicketWithCustomFieldsArgs = {
  input: CreateCustomSupportTicketInput;
};


export type MutationCreateSuspendedUserSupportTicketArgs = {
  input: CreateSuspendedUserSupportTicketInput;
};


export type MutationCreateUploadUrlArgs = {
  input: CreateUploadUrlInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput;
};


export type MutationCreateVendorInvoiceArgs = {
  input: CreateVendorInvoiceInput;
};


export type MutationCreateVendorLineItemArgs = {
  input: CreateVendorLineItemInput;
};


export type MutationDeactivateAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationDeactivateBeneficiaryArgs = {
  id: Scalars['ID'];
};


export type MutationDeactivateTierSubscriptionArgs = {
  input: DeactivateTierSubscriptionInput;
};


export type MutationDeleteTrustedContactArgs = {
  id: Scalars['ID'];
};


export type MutationDeregisterAuthenticatorArgs = {
  input: DeregisterAuthenticatorInput;
};


export type MutationDismissMessageArgs = {
  input: DismissMessageInput;
};


export type MutationDismissMessagesArgs = {
  input: DismissMessagesInput;
};


export type MutationEditTrustedContactArgs = {
  id: Scalars['ID'];
  input: TrustedContactInput;
};


export type MutationEnableQuarterlyRecapsArgs = {
  input: EnableQuarterlyRecapsInput;
};


export type MutationEndChatSessionArgs = {
  sessionId: Scalars['ID'];
};


export type MutationExchangeAcornsEarlyTokenArgs = {
  token: Scalars['String'];
};


export type MutationExecuteMoneyManagerRebalancesArgs = {
  input: ExecuteMoneyManagerRebalancesInput;
};


export type MutationExpirePromotionalWaiverArgs = {
  input: ExpirePromotionalWaiverInput;
};


export type MutationFailVendorInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationFeedEventArgs = {
  feedEvent: ActionFeedEvent;
};


export type MutationGenerateDocumentUploadSessionArgs = {
  input: GenerateDocumentUploadSessionInput;
};


export type MutationGenerateLayerLinkSessionArgs = {
  input: GenerateLayerLinkSessionInput;
};


export type MutationGenerateLinkSessionArgs = {
  input: GenerateLinkSessionInput;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationHideMessageArgs = {
  input: HideMessageInput;
};


export type MutationHideMessageByExternalIdArgs = {
  input: HideMessageByExternalIdInput;
};


export type MutationInitiateBankAccountCreationArgs = {
  input: InitiateBankAccountInput;
};


export type MutationInitiateBankingKycArgs = {
  input: InitiateBankingKycInput;
};


export type MutationInitiateChallengeArgs = {
  input: InitiateChallengeInput;
};


export type MutationInitiateEmailChallengeArgs = {
  input: InitiateEmailChallengeInput;
};


export type MutationInitiateLaterProgramAccountContributionArgs = {
  input: LaterProgramAccountContributionInput;
};


export type MutationInitiateMoneyAssignmentArgs = {
  input: InitiateMoneyAssignmentInput;
};


export type MutationInitiatePartnerDataShareArgs = {
  input: PartnerDataShareInput;
};


export type MutationInitiateSmsChallengeArgs = {
  input: InitiateSmsChallengeInput;
};


export type MutationInitiateTransferArgs = {
  input: InitiateTransferInput;
};


export type MutationLaterCreateIndividualBeneficiaryArgs = {
  accountId: Scalars['ID'];
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  birthDate: Scalars['DateTime'];
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  percentageShare?: InputMaybe<Scalars['Float']>;
  relationship?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationLaterTotalLiquidationArgs = {
  input?: InputMaybe<LaterTotalLiquidationInput>;
  investmentAccountId: Scalars['ID'];
};


export type MutationLaterWithdrawalArgs = {
  amount: Scalars['Float'];
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>;
  federalTaxes: Scalars['Float'];
  investmentAccountId: Scalars['ID'];
  reason?: InputMaybe<LaterWithdrawalReason>;
  stateTaxes: Scalars['Float'];
  taxYear: Scalars['Int'];
  withdrawalType?: InputMaybe<LaterWithdrawalType>;
};


export type MutationLegacyUploadDocumentArgs = {
  input: LegacyUploadDocumentInput;
};


export type MutationLinkAchAccountArgs = {
  account: Scalars['String'];
  routing: Scalars['String'];
};


export type MutationLinkManualFundingSourceArgs = {
  input: LinkManualFundingSourceInput;
};


export type MutationLinkOidcCredentialsArgs = {
  input: LinkOidcCredentialsInput;
};


export type MutationLockBankCardArgs = {
  input: LockBankCardInput;
};


export type MutationLogoutDeviceArgs = {
  input: LogoutDeviceInput;
};


export type MutationMakeInvestmentArgs = {
  input: MakeInvestmentInput;
};


export type MutationManagePayoutRelationshipArgs = {
  input: ManagePayoutRelationshipInput;
};


export type MutationMarkLearnContentAsHelpfulArgs = {
  input: MarkLearnContentAsHelpfulInput;
};


export type MutationMarkLearnContentAsViewedArgs = {
  input: MarkLearnContentAsViewedInput;
};


export type MutationModifyMoneyAssignmentArgs = {
  input: ModifyMoneyAssignmentInput;
};


export type MutationOpenCoreInvestmentAccountArgs = {
  input: OpenCoreInvestmentAccountInput;
};


export type MutationOpenEarlyAccountArgs = {
  input: OpenEarlyAccountInput;
};


export type MutationOrderBankCardArgs = {
  input: OrderBankCardInput;
};


export type MutationPostBankFeeNegotiationArgs = {
  linkedAccountId: Scalars['String'];
};


export type MutationPostUserReportedBankFeeRefundArgs = {
  submissionId: Scalars['String'];
  totalRefunds: Scalars['Float'];
};


export type MutationRateChatMessageArgs = {
  feedbackInput?: InputMaybe<MessageFeedbackInput>;
  messageId: Scalars['ID'];
  rating?: InputMaybe<Scalars['Int']>;
};


export type MutationRateFinancialAdvisorResponseArgs = {
  interactionId: Scalars['String'];
  rating: Scalars['Int'];
};


export type MutationReadMessageArgs = {
  input: ReadMessageInput;
};


export type MutationRecordInvestmentAccountRecapViewArgs = {
  input: RecordInvestmentAccountRecapViewInput;
};


export type MutationRecordReferralEventArgs = {
  input: RecordReferralEventInput;
};


export type MutationRecordVendorExternalTransactionArgs = {
  input: RecordVendorExternalTransactionInput;
  invoiceId: Scalars['ID'];
};


export type MutationRedeemGiftcardArgs = {
  pin: Scalars['String'];
};


export type MutationRefreshAuthTokenArgs = {
  input: RefreshAuthTokenInput;
};


export type MutationRegenerateInvestmentAccountRecapPublicTokenArgs = {
  input: RegenerateInvestmentAccountRecapPublicTokenInput;
};


export type MutationRegisterCredentialsArgs = {
  input: RegisterCredentialsInput;
};


export type MutationRegisterDeviceTokenAndPushAuthenticatorArgs = {
  input: RegisterDeviceTokenAndPushAuthenticatorInput;
};


export type MutationRegisterEmailAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput;
  input: RegisterEmailAuthenticatorInput;
};


export type MutationRegisterLayerLinkSessionArgs = {
  input: LayerLinkSessionInput;
};


export type MutationRegisterLinkSessionArgs = {
  input: LinkSessionInput;
};


export type MutationRegisterOidcCredentialsArgs = {
  input: RegisterOidcCredentialsInput;
};


export type MutationRegisterPhoneAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput;
  input: RegisterPhoneAuthenticatorInput;
};


export type MutationRegisterProspectArgs = {
  input: RegisterProspectInput;
};


export type MutationReinitiateChallengeArgs = {
  input: ReinitiateSmsChallengeInput;
};


export type MutationReissueBankCardArgs = {
  input: ReissueBankCardInput;
};


export type MutationRemoveCohortEligibilityArgs = {
  input: RemoveCohortEligibilityInput;
};


export type MutationRemoveFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput;
};


export type MutationRemoveJobAlertArgs = {
  id: Scalars['String'];
};


export type MutationRemoveSecurityFromPortfolioArgs = {
  input: RemoveSecurityFromPortfolioInput;
};


export type MutationRemoveSelfDirectedPortfolioArgs = {
  input: RemoveSelfDirectedPortfolioInput;
};


export type MutationReportBankCardLostStolenArgs = {
  input: ReportBankCardLostStolenInput;
};


export type MutationRequestAccountClosureArgs = {
  input: RequestAccountClosureInput;
};


export type MutationRequestEarlyAccountClosureArgs = {
  input: RequestEarlyAccountClosureInput;
};


export type MutationRequestInvestmentAccountReopenArgs = {
  input: RequestInvestmentAccountReopenInput;
};


export type MutationRequestLayerSessionArgs = {
  input: RequestLayerSessionInput;
};


export type MutationRequestSubscriptionMigrationWaiverArgs = {
  input: RequestSubscriptionMigrationWaiverInput;
};


export type MutationResendChatMessageArgs = {
  messageId: Scalars['ID'];
  sessionId: Scalars['ID'];
};


export type MutationResetPinArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordByTokenArgs = {
  input: ResetPasswordByTokenInput;
};


export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput;
};


export type MutationRespondToLearnPollArgs = {
  input: RespondToLearnPollInput;
};


export type MutationRestoreLoginAccessArgs = {
  input: RestoreLoginAccessInput;
};


export type MutationRevokeLoginAccessArgs = {
  input: RevokeLoginAccessInput;
};


export type MutationRevokePasswordResetTokenArgs = {
  input: RevokePasswordResetTokenInput;
};


export type MutationRoundUpProfileArgs = {
  input: RoundUpProfileInput;
};


export type MutationSaveUploadUrlArgs = {
  input: SaveUploadUrlInput;
};


export type MutationSaveUploadUrlsArgs = {
  input: SaveUploadUrlsInput;
};


export type MutationScheduleRecurringTransferArgs = {
  input: ScheduleRecurringTransferInput;
};


export type MutationSendBrazeEventArgs = {
  input: SendBrazeEventInput;
};


export type MutationSendChatMessageArgs = {
  message: Scalars['String'];
  metadata?: InputMaybe<ChatMessageMetadataInput>;
  sessionId: Scalars['ID'];
};


export type MutationSendCheckPaymentArgs = {
  input: SendCheckPaymentInput;
};


export type MutationSendReferralEventArgs = {
  input: ReferralEventInput;
};


export type MutationSessionRefreshArgs = {
  longSession?: InputMaybe<Scalars['Boolean']>;
  pin: Scalars['String'];
};


export type MutationSetAuthenticationPinArgs = {
  input: SetAuthenticationPinInput;
};


export type MutationSetBeneficiarySsnArgs = {
  id: Scalars['ID'];
  ssn: Scalars['String'];
};


export type MutationSetDefaultAuthenticatorArgs = {
  input: SetDefaultAuthenticatorInput;
};


export type MutationSetFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput;
};


export type MutationSetInvestmentAccountRecapPublicAccessArgs = {
  input: SetInvestmentAccountRecapPublicAccessInput;
};


export type MutationSetLinkingErrorArgs = {
  linkedAccountId: Scalars['ID'];
  linkingErrorCode: SetLinkingErrorInput;
};


export type MutationSetManualRoundUpsArgs = {
  roundUpIds: Array<Scalars['ID']>;
};


export type MutationSetNegotiationStatusArgs = {
  input: SetNegotiationStatusInput;
};


export type MutationSetPortfolioArgs = {
  input: SetPortfolioInput;
};


export type MutationSetPreferredWithdrawalAccountArgs = {
  input: SetPreferredWithdrawalAccountInput;
};


export type MutationSetReferralCampaignFlagsArgs = {
  input: SetReferralCampaignFlagsInput;
};


export type MutationSetUserPartnerStatusArgs = {
  input: PartnerStatusInput;
};


export type MutationSplitDepositArgs = {
  id: Scalars['ID'];
};


export type MutationSplitDepositSettingsArgs = {
  employerHidden?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationStartAcornsPdfSwitchArgs = {
  input: StartAcornsPdfSwitchInput;
};


export type MutationStartChatSessionArgs = {
  originatingContext?: InputMaybe<ChatContext>;
  supportedChatFeatures?: InputMaybe<Array<ChatFeatures>>;
  type?: InputMaybe<SessionType>;
};


export type MutationStartCheckDepositArgs = {
  input: StartCheckDepositInput;
};


export type MutationStartOnlineSwitchArgs = {
  input: StartOnlineSwitchInput;
};


export type MutationStartSubmittableSwitchArgs = {
  input: StartSubmittableSwitchInput;
};


export type MutationStopRecurringInvestmentArgs = {
  investmentAccountId?: InputMaybe<Scalars['String']>;
};


export type MutationStubArgs = {
  id: Scalars['UUID'];
};


export type MutationSubmitBankFeeNegotiationArgs = {
  input: SubmitBankFeeNegotiationInput;
};


export type MutationSubmitEarnMissingCreditRequestArgs = {
  input: SubmitEarnMissingCreditRequestInput;
};


export type MutationSubmitRdVsArgs = {
  deposits: Array<InputMaybe<Scalars['Float']>>;
};


export type MutationSubmitSpendTransactionsDisputeArgs = {
  input: SubmitSpendTransactionsDisputeInput;
};


export type MutationSubmitUserReportedBankFeeRefundArgs = {
  input: SubmitUserReportedBankFeeRefundInput;
};


export type MutationSubscribeToTierArgs = {
  input: SubscribeToTierInput;
};


export type MutationSubscribeUserToTierArgs = {
  input: SubscribeUserToTierInput;
};


export type MutationSubscribeUserToTierByProductKeyArgs = {
  input?: InputMaybe<SubscribeUserToTierByProductKeyInput>;
};


export type MutationSucceedVendorInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationSuppressMoneyManagerRebalancesArgs = {
  input: SuppressMoneyManagerRebalancesInput;
};


export type MutationSuspendDepositsArgs = {
  suspended: Scalars['Boolean'];
};


export type MutationSyncBankFeeTransactionsArgs = {
  input: SyncBankFeeTransactionsInput;
};


export type MutationTaxWithholdingAmountsArgs = {
  investmentId: Scalars['ID'];
  totalSharesAmount: CurrencyAmountInput;
};


export type MutationUnauthenticatedCreateUploadUrlArgs = {
  input: UnauthenticatedCreateUploadUrlInput;
};


export type MutationUnauthenticatedSaveUploadUrlArgs = {
  input: UnauthenticatedSaveUploadUrlInput;
};


export type MutationUnblockDeviceArgs = {
  input: UnblockDeviceInput;
};


export type MutationUnlinkLinkedAccountArgs = {
  linkedAccountId: Scalars['ID'];
};


export type MutationUnmarkLearnContentAsHelpfulArgs = {
  input: UnmarkLearnContentAsHelpfulInput;
};


export type MutationUnsubscribeUserFromTierArgs = {
  input?: InputMaybe<UnsubscribeUserFromTierInput>;
};


export type MutationUpdateAccountPortfolioArgs = {
  input: UpdateAccountPortfolioInput;
};


export type MutationUpdateAddressArgs = {
  addressType: AddressType;
  input: AddressInput;
  ownerId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateAttributionArgs = {
  input: UpdateAttributionInput;
};


export type MutationUpdateAuthEmailArgs = {
  input: UpdateAuthEmailInput;
};


export type MutationUpdateAuthPhoneNumberArgs = {
  input: UpdateAuthPhoneNumberInput;
};


export type MutationUpdateBankAccountGoalArgs = {
  input: UpdateBankAccountGoalInput;
};


export type MutationUpdateBankCardPinArgs = {
  input: UpdateBankCardPinInput;
};


export type MutationUpdateBannersArgs = {
  input: UpdateBannersInput;
};


export type MutationUpdateBeneficiaryInfoArgs = {
  id: Scalars['ID'];
  input: BeneficiaryInfoInput;
};


export type MutationUpdateBenefitStatusArgs = {
  input: UpdateBenefitStatusInput;
};


export type MutationUpdateContactInfoArgs = {
  input: ContactInfoInput;
};


export type MutationUpdateCredentialsArgs = {
  input: UserCredentialsInput;
};


export type MutationUpdateCustomerMoneyRulesArgs = {
  input: MoneyRulesRulesetInput;
};


export type MutationUpdateElapsedTimeForLearnQuizArgs = {
  input: UpdateElapsedTimeForLearnQuizInput;
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String'];
};


export type MutationUpdateEmploymentArgs = {
  input: EmploymentInput;
};


export type MutationUpdateHelpcenterBannerArgs = {
  input: HelpcenterContentInput;
};


export type MutationUpdateInvestorQuestionsArgs = {
  input: InvestorQuestionsInput;
};


export type MutationUpdateLadderQuoteArgs = {
  coverage: Scalars['Int'];
  quoteId: Scalars['ID'];
};


export type MutationUpdateLearnContentProgressArgs = {
  input: UpdateLearnProgressInput;
};


export type MutationUpdateLinkedAccountArgs = {
  input: UpdateLinkedAccountInput;
  linkedAccountId: Scalars['ID'];
};


export type MutationUpdateMoneyManagerAllocationsArgs = {
  input: UpdateMoneyManagerAllocationsInput;
};


export type MutationUpdateMoneyManagerAutomationTargetArgs = {
  input: UpdateMoneyManagerAutomationTargetInput;
};


export type MutationUpdateMoneyManagerSettingsArgs = {
  input: UpdateMoneyManagerSettingsInput;
};


export type MutationUpdateMoneyRulesSourceSettingsArgs = {
  input: UpdateMoneyRulesSourceSettingsInput;
};


export type MutationUpdateNegotiationStatusArgs = {
  negotiationStatusInput: NegotiationStatus;
};


export type MutationUpdateNotificationArgs = {
  active: Scalars['Boolean'];
  category?: InputMaybe<Scalars['String']>;
  channel: Scalars['String'];
  subcategory?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateOptOutOfTargetingArgs = {
  input: UpdateOptOutOfTargetingInput;
};


export type MutationUpdatePersonalInfoArgs = {
  input: PersonalInfoInput;
};


export type MutationUpdatePortfolioSecuritiesArgs = {
  input: UpdatePortfolioSecuritiesInput;
};


export type MutationUpdateProfileArgs = {
  input: ProfileInput;
};


export type MutationUpdatePromotedCampaignsArgs = {
  input?: InputMaybe<UpdatePromotedCampaignsInput>;
};


export type MutationUpdateRecurringInvestmentArgs = {
  input: RecurringInvestmentInput;
};


export type MutationUpdateReferralCampaignArgs = {
  input: UpdateReferralCampaignInput;
};


export type MutationUpdateReferralPayoutArgs = {
  input: UpdateReferralPayoutInput;
};


export type MutationUpdateReferralRelationshipArgs = {
  input: UpdateReferralRelationshipInput;
};


export type MutationUpdateReferralRewardStatusArgs = {
  rewardId: Scalars['ID'];
  rewardStatus: ReferralRewardUpdateStatus;
};


export type MutationUpdateReferralUserProfileArgs = {
  email: Scalars['String'];
  updateInfo: ReferralUserUpdateInput;
};


export type MutationUpdateRegistrationArgs = {
  input: RegistrationInput;
};


export type MutationUpdateRoundUpAccountArgs = {
  enabled: Scalars['Boolean'];
  linkedSubaccountId: Scalars['ID'];
};


export type MutationUpdateSignatureArgs = {
  signatureType: SignatureType;
  svgFile: Scalars['String'];
};


export type MutationUpdateSuitabilityArgs = {
  suitabilityInput: Array<Suitability_SuitabilityInput>;
};


export type MutationUpdateUserProfileAndAutomationTargetArgs = {
  input: UpdateUserProfileAndAutomationTargetInput;
};


export type MutationUpdateUserSwitchStateArgs = {
  input: UpdateUserSwitchStateInput;
};


export type MutationUpdateVerificationProfileArgs = {
  input: VerificationProfileInput;
};


export type MutationUploadAudienceListArgs = {
  input: UploadAudienceListInput;
};


export type MutationUploadCheckArgs = {
  input: UploadCheckInput;
};


export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput;
};


export type MutationUploadUnsolicitedDocumentsArgs = {
  input: UploadUnsolicitedDocumentsInput;
};


export type MutationUpsertUserMatchArgs = {
  input: UpsertUserMatchInput;
};


export type MutationValidateCredentialsArgs = {
  input: ValidateCredentialsInput;
};


export type MutationValidateUserSuspendedUploadTokenArgs = {
  input: ValidateUserSuspendedUploadTokenInput;
};


export type MutationVendAuthSessionArgs = {
  input: VendAuthSessionInput;
};


export type MutationVerifyDeviceArgs = {
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>;
  input: VerifyDeviceInput;
};


export type MutationVerifyIdentityByDocumentsArgs = {
  input: ValidateDocumentsInput;
};


export type MutationVerifyLaterAccountOrErrorArgs = {
  investmentAccountId: Scalars['ID'];
};


export type MutationVerifyPasswordsArgs = {
  input: VerifyPasswordsInput;
};


export type MutationVerifyRdvsArgs = {
  input: VerifyRdvsInput;
};

export type NativeLoginInput = {
  email: Scalars['EmailAddress'];
  password: Scalars['String'];
};

/** The provided security percent is negative */
export type NegativeSecurityPercentError = {
  __typename?: 'NegativeSecurityPercentError';
  /** The security in question */
  securityId: Scalars['ID'];
};

export enum NegotiationMethod {
  AUTOMATIC = 'AUTOMATIC',
  LETTER = 'LETTER'
}

export type NegotiationServiceConnectionFailure = {
  __typename?: 'NegotiationServiceConnectionFailure';
  message: Scalars['String'];
};

export type NegotiationStatus = {
  negotiationMethod: NegotiationType;
  operator: Scalars['String'];
  refundAmount?: InputMaybe<Scalars['Float']>;
  status: BankFeeNegotiationInternalStatus;
  submissionId: Scalars['ID'];
};

export enum NegotiationType {
  AUTOMATED_NEGOTIATION = 'AUTOMATED_NEGOTIATION',
  MAIL_IN_NEGOTIATION = 'MAIL_IN_NEGOTIATION'
}

export enum NetTermsType {
  eom = 'eom',
  net = 'net'
}

/** The next billing date for a user */
export type NextBillingDate = {
  __typename?: 'NextBillingDate';
  next_billing_date: Maybe<Scalars['String']>;
};

export type NextTransferDateResult = MalformedRecurringTransferException | RecurringTransferDate;

/** Cannot open early account because the beneficiary id is invalid */
export type NoBeneficiaryFoundException = {
  __typename?: 'NoBeneficiaryFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** No Funding Source Alert. */
export type NoFundingSourceUserAlert = UserAlertsItem & {
  __typename?: 'NoFundingSourceUserAlert';
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export type NoProspectRecord = {
  __typename?: 'NoProspectRecord';
  message: Scalars['String'];
};

export type NoRegisteredPushAuthenticatorsException = {
  __typename?: 'NoRegisteredPushAuthenticatorsException';
  userId: Scalars['ID'];
};

/** The user needs to close all other investment accounts before closing this account */
export type NonBasicAccountOpenException = {
  __typename?: 'NonBasicAccountOpenException';
  /** message */
  errorMessage: Maybe<Scalars['String']>;
};

/** Returned when one or more singleRuleId's are not unique */
export type NonUniqueSingleRuleIdsError = {
  __typename?: 'NonUniqueSingleRuleIdsError';
  message: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Boolean'];
  category: Maybe<Scalars['String']>;
  subcategory: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type NotificationMessage = Message & {
  __typename?: 'NotificationMessage';
  body: MessageTextAsset;
  cardColor: Maybe<CardColor>;
  createdAt: Scalars['DateTime'];
  deepLink: Maybe<Scalars['URL']>;
  delay: Maybe<Scalars['Int']>;
  externalId: Scalars['ID'];
  icon: Maybe<MessageVisualAsset>;
  id: Scalars['ID'];
  isDismissed: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  messageCategory: MessageCategory;
  messageType: MessageType;
  platforms: Array<Platform>;
  priority: Maybe<Scalars['Int']>;
  readAt: Maybe<Scalars['DateTime']>;
  title: MessageTextAsset;
  trackingId: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
};

export type Notifications = {
  __typename?: 'Notifications';
  emails: Maybe<Array<Maybe<Notification>>>;
  pushes: Maybe<Array<Maybe<Notification>>>;
};

export type OauthApp = {
  __typename?: 'OauthApp';
  accessTokenAudience: Array<Maybe<Scalars['String']>>;
  accessTokenExpiry: Maybe<Scalars['Int']>;
  active: Scalars['Boolean'];
  contactEmail: Maybe<Scalars['String']>;
  contactName: Maybe<Scalars['String']>;
  contract: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalApp: Scalars['Boolean'];
  imageUri: Scalars['String'];
  name: Scalars['String'];
  oauthAppId: Scalars['ID'];
  pageType: Scalars['String'];
  redirectUri: Maybe<Scalars['String']>;
  refreshTokenExpiry: Maybe<Scalars['Int']>;
  scopes: Array<OauthAppScope>;
  secret: Maybe<Scalars['String']>;
  type: OauthAppType;
  updatedAt: Scalars['DateTime'];
};

export type OauthAppClient = {
  __typename?: 'OauthAppClient';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  imageUri: Scalars['String'];
  name: Scalars['String'];
  oauthAppClientId: Scalars['ID'];
  oauthAppId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type OauthAppClientNotFoundException = {
  __typename?: 'OauthAppClientNotFoundException';
  oauthAppClientId: Scalars['ID'];
};

export type OauthAppImageUpload = {
  __typename?: 'OauthAppImageUpload';
  expiresAt: Scalars['DateTime'];
  uploadUrl: Scalars['URL'];
};

export type OauthAppNotFoundException = {
  __typename?: 'OauthAppNotFoundException';
  oauthAppId: Scalars['ID'];
};

export type OauthAppScope = {
  __typename?: 'OauthAppScope';
  description: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
};

export enum OauthAppType {
  AGGREGATOR = 'AGGREGATOR',
  PARTNER = 'PARTNER'
}

/** Occupation that a user can select */
export type Occupation = {
  __typename?: 'Occupation';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Offer = {
  __typename?: 'Offer';
  /**
   * Meta field enabling clients to delegate to the backend
   * more logic determining when it is valid to present the Offer.
   *
   * Examples: "SUBSCRIPTION_CANCELLATION", "PASSIONS_PRODUCT_EXPLORATION"
   */
  availableIn: Maybe<Array<Scalars['String']>>;
  /** The cohort of subscribers the Offer is available to (driven by the Offer type). */
  availableTo: OfferAvailability;
  createdAt: Scalars['DateTime'];
  /** Once subscribed to how long is the Offer valid for. */
  expiresAfter: Maybe<OfferExpiration>;
  expiresAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** What the Offer entitles a subscriber access to. */
  offering: Offering;
  /** Amount the subscriber agrees to pay for access to the Offer's offering. */
  price: OfferPrice;
  /** URL to the terms and conditions of the Offer. */
  termsUrl: Scalars['URL'];
  /** Indicates semantics of the Offer (generally whom it is available to and when). */
  type: OfferType;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum OfferAvailability {
  ALL = 'ALL',
  CANCELLED = 'CANCELLED',
  EXISTING = 'EXISTING',
  NEW = 'NEW',
  NONE = 'NONE'
}

export type OfferExpiration = {
  __typename?: 'OfferExpiration';
  period: OfferExpirationPeriod;
  value: Scalars['Int'];
};

export enum OfferExpirationPeriod {
  MONTH = 'MONTH'
}

export enum OfferGroupsType {
  CATEGORY = 'CATEGORY',
  RANKED = 'RANKED'
}

export type OfferLocation = {
  __typename?: 'OfferLocation';
  city: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
};

export type OfferLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type OfferPrice = {
  __typename?: 'OfferPrice';
  amount: CurrencyAmount;
  type: OfferPriceType;
};

export type OfferPriceInput = {
  amount: CurrencyAmountInput;
  type: OfferPriceType;
};

export enum OfferPriceType {
  FREE = 'FREE',
  MONTHLY = 'MONTHLY'
}

export enum OfferType {
  PROMOTIONAL = 'PROMOTIONAL',
  STANDARD = 'STANDARD'
}

/** An Offering is something that a subscriber subscribes to access to. */
export type Offering = Product | Tier;

export type OidcCredentialsAlreadyLinkedException = {
  __typename?: 'OidcCredentialsAlreadyLinkedException';
  subId: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type OidcCredentialsNotFoundException = {
  __typename?: 'OidcCredentialsNotFoundException';
  oidcProvider: Maybe<OidcProvider>;
  userId: Scalars['ID'];
};

export type OidcCredentialsTakenException = {
  __typename?: 'OidcCredentialsTakenException';
  subId: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type OidcLoginInput = {
  idToken: Scalars['String'];
  nonce: Scalars['String'];
};

export enum OidcProvider {
  ACORNS_EARLY = 'ACORNS_EARLY',
  APPLE = 'APPLE',
  GOOGLE = 'GOOGLE'
}

export type OnboardingBenefitsInput = {
  product?: InputMaybe<OnboardingProducts>;
};

export enum OnboardingGroups {
  FAMILY = 'FAMILY',
  FEATURED = 'FEATURED',
  FUTURE = 'FUTURE',
  SECURITY = 'SECURITY'
}

export type OnboardingProductStatus = {
  __typename?: 'OnboardingProductStatus';
  claimStatus: ClaimStatus;
  claimedOn: Maybe<Scalars['String']>;
  details: Maybe<Array<Maybe<ClaimStatusDetails>>>;
  expiresOn: Maybe<Scalars['String']>;
  updatedBy: Maybe<Scalars['String']>;
  updatedOn: Maybe<Scalars['String']>;
};

export type OnboardingProductTile = {
  __typename?: 'OnboardingProductTile';
  claimDetails: OnboardingProductStatus;
  product: OnboardingProducts;
  status: BenefitProductStatus;
};

export enum OnboardingProducts {
  BENEFITS_GOHENRY_STANDARD = 'BENEFITS_GOHENRY_STANDARD',
  BENEFITS_INSURANCE_STANDARD = 'BENEFITS_INSURANCE_STANDARD',
  BENEFITS_TAXFILING_STANDARD = 'BENEFITS_TAXFILING_STANDARD',
  BENEFITS_WILL_STANDARD = 'BENEFITS_WILL_STANDARD',
  EARLY = 'EARLY',
  EARN = 'EARN',
  EARN_CHOICE = 'EARN_CHOICE',
  EARN_PRIME = 'EARN_PRIME',
  EMERGENCY_FUND = 'EMERGENCY_FUND',
  INVEST = 'INVEST',
  LATER = 'LATER',
  LATER_MATCH = 'LATER_MATCH',
  SELF_DIRECTED_INVEST = 'SELF_DIRECTED_INVEST',
  SPEND = 'SPEND'
}

export enum OnboardingRequirement {
  AFFILIATED_WITH_BROKER_DEALER = 'AFFILIATED_WITH_BROKER_DEALER',
  ANNUAL_INCOME = 'ANNUAL_INCOME',
  CHECKING_SIGNATURE = 'CHECKING_SIGNATURE',
  COMBINED_ANNUAL_INCOME = 'COMBINED_ANNUAL_INCOME',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  ECBSV = 'ECBSV',
  EMPLOYEES = 'EMPLOYEES',
  EMPLOYMENT_STATUS = 'EMPLOYMENT_STATUS',
  FILING_TYPE = 'FILING_TYPE',
  FINANCIAL_EDUCATION = 'FINANCIAL_EDUCATION',
  FIRST_NAME = 'FIRST_NAME',
  INTRO_INVESTMENT_ACCOUNTS = 'INTRO_INVESTMENT_ACCOUNTS',
  INVESTMENT_GOAL = 'INVESTMENT_GOAL',
  LANDING_CHECKING_ACCOUNT = 'LANDING_CHECKING_ACCOUNT',
  LAST_NAME = 'LAST_NAME',
  LINKED_FUNDING_SOURCE = 'LINKED_FUNDING_SOURCE',
  MAILING_ADDRESS = 'MAILING_ADDRESS',
  MARITAL_STATUS = 'MARITAL_STATUS',
  NET_WORTH = 'NET_WORTH',
  OCCUPATION = 'OCCUPATION',
  PHONE_NUMBER = 'PHONE_NUMBER',
  RESIDENTIAL_ADDRESS = 'RESIDENTIAL_ADDRESS',
  REVIEW_SAVINGS_ACCOUNT = 'REVIEW_SAVINGS_ACCOUNT',
  REVIEW_SUMMARY = 'REVIEW_SUMMARY',
  SELF_EMPLOYED_INCOME = 'SELF_EMPLOYED_INCOME',
  SHAREHOLDER_OR_DIRECTOR = 'SHAREHOLDER_OR_DIRECTOR',
  SOCIAL_SECURITY_NUMBER = 'SOCIAL_SECURITY_NUMBER',
  SUBJECT_TO_BACKUP_WITHHOLDING = 'SUBJECT_TO_BACKUP_WITHHOLDING',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS'
}

export type OnboardingTileGroup = {
  __typename?: 'OnboardingTileGroup';
  group: OnboardingGroups;
  products: Maybe<Array<Maybe<OnboardingProductTile>>>;
};

export type OnboardingTipItem = {
  __typename?: 'OnboardingTipItem';
  body: Scalars['String'];
  headline: Scalars['String'];
  id: Scalars['ID'];
  image: Image;
  title: Scalars['String'];
  type: OnboardingTipType;
};

export enum OnboardingTipType {
  /** feature */
  feature = 'feature',
  /** introduction */
  intro = 'intro'
}

export type OnboardingTips = {
  __typename?: 'OnboardingTips';
  items: Array<OnboardingTipItem>;
};

export enum OnboardingType {
  CHECKING = 'CHECKING',
  EARLY = 'EARLY',
  EMERGENCY_SAVINGS = 'EMERGENCY_SAVINGS',
  INVEST = 'INVEST',
  LATER = 'LATER',
  MONEY_MANAGER = 'MONEY_MANAGER'
}

/** Online Switches are performed through the Employer's URL. */
export type OnlineSwitch = SwitchInterface & {
  __typename?: 'OnlineSwitch';
  source: SwitchSource;
  type: SwitchType;
  /** Employer URL */
  url: Scalars['String'];
  vendorTargetId: Maybe<Scalars['ID']>;
};

/** Cannot close user account if user has open spend/investment accounts */
export type OpenAccountsException = {
  __typename?: 'OpenAccountsException';
  /** User's open account types */
  openAccountTypes: Maybe<Array<Scalars['String']>>;
};

/** Input for creating a Core InvestmentAccount */
export type OpenCoreInvestmentAccountInput = {
  /** ID of the portfolio for this investment account */
  portfolioId: Scalars['String'];
};

/** Result from opening a Core InvestmentAccount */
export type OpenCoreInvestmentAccountResult = CoreAccountAlreadyExistsException | InvalidPortfolioIdException | InvestmentAccount | InvestmentAccountCreationException | UserClosedException | UserNotFoundException;

/** Input for creating an early investment account */
export type OpenEarlyAccountInput = {
  /** Beneficiary ID */
  beneficiaryId: Scalars['ID'];
  /** Name of investment account */
  investmentAccountName?: InputMaybe<Scalars['String']>;
  /** State in which to open the investment account (defaults to custodian's state) */
  stateCode?: InputMaybe<Scalars['String']>;
  /** Termination age of the investment account */
  terminationAge: Scalars['Int'];
};

/** Result from opening an Early Investment Account */
export type OpenEarlyAccountResult = BeneficiaryAccountExistsException | CoreAccountClosedException | InternalErrorException | InvalidStateException | InvalidSubscriptionTierException | InvalidTerminationAgeException | InvestmentAccount | MaxAccountsCreatedException | MissingBeneficiarySsnException | NoBeneficiaryFoundException | UserClosedException | UserNotFoundException | UserNotVerifiedException;

export enum OperationStage {
  AUTH_COMPLETED = 'AUTH_COMPLETED',
  AUTH_FAILED = 'AUTH_FAILED',
  AWAITING_TFA_CODE = 'AWAITING_TFA_CODE',
  AWAITING_TFA_OPTION = 'AWAITING_TFA_OPTION',
  PROCESSING_CREDENTIALS = 'PROCESSING_CREDENTIALS',
  PROCESSING_TFA_CODE = 'PROCESSING_TFA_CODE',
  PROCESSING_TFA_OPTION = 'PROCESSING_TFA_OPTION'
}

export enum Order {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OrderBankCardInput = {
  bankCardTier?: InputMaybe<BankCardTier>;
  bankType?: InputMaybe<BankType>;
  employmentStatus?: InputMaybe<Scalars['String']>;
  isDocumentsAccepted: Scalars['Boolean'];
  isReopen?: InputMaybe<Scalars['Boolean']>;
  paymentProcessor?: InputMaybe<BankCardPaymentProcessor>;
  prefundTransfer?: InputMaybe<BankCardPrefundTransfer>;
  requestVersion?: InputMaybe<RequestVersions>;
};

export type OrderBankCardResult = BankCardOrder;

export enum Origin {
  external_gift_card = 'external_gift_card',
  prepayment = 'prepayment'
}

/** Outside contribution object */
export type OutsideContribution = TimestampsInterface & {
  __typename?: 'OutsideContribution';
  accountId: Scalars['ID'];
  checkoutCart: OutsideContributionCheckoutCart;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  failureReason: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  investmentId: Maybe<Scalars['ID']>;
  note: Maybe<Scalars['String']>;
  noteAuthor: Maybe<Scalars['String']>;
  paymentMethodId: Scalars['ID'];
  state: ContributionState;
  transferRequestId: Maybe<Scalars['ID']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** an outside contribution checkout cart object */
export type OutsideContributionCheckoutCart = TimestampsInterface & {
  __typename?: 'OutsideContributionCheckoutCart';
  code: OutsideContributionCode;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  feeAmount: Scalars['String'];
  id: Scalars['ID'];
  investmentAmount: Scalars['String'];
  paymentIntentId: Scalars['ID'];
  status: CheckoutCartStatus;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

/** Code for outside contribution */
export type OutsideContributionCode = TimestampsInterface & {
  __typename?: 'OutsideContributionCode';
  /** Unique code that has one-to-one relationship with investment Account */
  code: Scalars['String'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  investmentAccountId: Scalars['ID'];
  recipientFirstName: Scalars['String'];
  /** This is the id of who the contribution is going to. Most likely beneficiary id */
  recipientId: Scalars['ID'];
  signupBonusUrl: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  userId: Scalars['ID'];
};

/** Object representing an outside contribution prospect */
export type OutsideContributionProspect = Prospect & {
  __typename?: 'OutsideContributionProspect';
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type OverrideInput = {
  originalAutoAdd?: InputMaybe<Scalars['ID']>;
  originalFallback?: InputMaybe<Scalars['ID']>;
  originalQa?: InputMaybe<Scalars['ID']>;
};

export enum PackageStatus {
  /** Available for Pickup */
  availableForPickup = 'availableForPickup',
  /** Customer Recall */
  customerRecall = 'customerRecall',
  /** Dead Letter */
  deadLetter = 'deadLetter',
  /** Delivered */
  delivered = 'delivered',
  /** Delivery Status Not Updated */
  deliveryStatusNotUpdated = 'deliveryStatusNotUpdated',
  /** Forwarded to New Address */
  forwardedToNewAddress = 'forwardedToNewAddress',
  /** Logged at USPS */
  loggedAtUSPS = 'loggedAtUSPS',
  /** New Item */
  newItem = 'newItem',
  /** Found – No Status */
  noStatus = 'noStatus',
  /** Not Found */
  notFound = 'notFound',
  /** Notice Left for Recipient */
  noticeLeftForRecipient = 'noticeLeftForRecipient',
  /** Other */
  other = 'other',
  /** Out for Delivery */
  outForDelivery = 'outForDelivery',
  /** Returned to Sender */
  returnedToSender = 'returnedToSender',
  /** Scanned in Route */
  scannedInRoute = 'scannedInRoute',
  /** Undeliverable */
  undeliverable = 'undeliverable'
}

/** Pagination meta information about the current response */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Indicates records exist after the given cursor */
  hasNextPage: Scalars['Boolean'];
  /** Indicates records exist before the given cursor */
  hasPreviousPage: Scalars['Boolean'];
  /** Number of records returned in the response */
  limit: Scalars['Int'];
};

/** Pagination input to fetch pages of records */
export type PageInput = {
  /** Cursor to fetch records starting after */
  after?: InputMaybe<Scalars['ID']>;
  /** How many records to return */
  first?: InputMaybe<Scalars['Int']>;
};

export enum PageName {
  ABOUT_PORTFOLIO = 'ABOUT_PORTFOLIO',
  ADDRESS_EDIT = 'ADDRESS_EDIT',
  ADDRESS_INVALID = 'ADDRESS_INVALID',
  ADDRESS_PREVIEW = 'ADDRESS_PREVIEW',
  ADDRESS_SUGGESTION = 'ADDRESS_SUGGESTION',
  /** @deprecated Animation removed as a page in the web funnel */
  ANALYZING = 'ANALYZING',
  BANK_LINK_SUCCESS = 'BANK_LINK_SUCCESS',
  CARD_ORDER_REVIEW = 'CARD_ORDER_REVIEW',
  CARD_SIGNATURE = 'CARD_SIGNATURE',
  CHOOSE_FUNDING_SOURCE = 'CHOOSE_FUNDING_SOURCE',
  CONTACT_INFO = 'CONTACT_INFO',
  CRYPTO_LANDER = 'CRYPTO_LANDER',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  DIRECT_BANK_INTEGRATION = 'DIRECT_BANK_INTEGRATION',
  DIRECT_BANK_INTEGRATION_REDIRECT = 'DIRECT_BANK_INTEGRATION_REDIRECT',
  DIRECT_TO_MOBILE = 'DIRECT_TO_MOBILE',
  /** @deprecated Page removed from funnel */
  ESG_DETAILS = 'ESG_DETAILS',
  /** @deprecated Page removed from funnel */
  ESG_EDUCATION = 'ESG_EDUCATION',
  FUNDING = 'FUNDING',
  HDYHAU = 'HDYHAU',
  INSTITUTIONS = 'INSTITUTIONS',
  INVESTOR_QUESTIONS = 'INVESTOR_QUESTIONS',
  INVEST_INTERSTITIAL = 'INVEST_INTERSTITIAL',
  LATER_INTERSTITIAL = 'LATER_INTERSTITIAL',
  MANUAL_FUNDING_SOURCE = 'MANUAL_FUNDING_SOURCE',
  MFA_SET_UP = 'MFA_SET_UP',
  MOC_REFERRAL_REMINDER = 'MOC_REFERRAL_REMINDER',
  MOC_ROUTING_INTERSTITIAL = 'MOC_ROUTING_INTERSTITIAL',
  MOC_SUCCESS = 'MOC_SUCCESS',
  OCCUPATION = 'OCCUPATION',
  ONE_TIME_DEPOSIT = 'ONE_TIME_DEPOSIT',
  ONE_TIME_INVESTMENT = 'ONE_TIME_INVESTMENT',
  PERSONAL_INFO = 'PERSONAL_INFO',
  PHONE_NUMBER = 'PHONE_NUMBER',
  PLAID_LINK_REDIRECT = 'PLAID_LINK_REDIRECT',
  PORTFOLIO_DETAILS = 'PORTFOLIO_DETAILS',
  PREVIEW_PORTFOLIO = 'PREVIEW_PORTFOLIO',
  PRICING_INTERSTITIAL = 'PRICING_INTERSTITIAL',
  PRODUCT_ONBOARDING = 'PRODUCT_ONBOARDING',
  PROGRESS_SCREEN_1 = 'PROGRESS_SCREEN_1',
  PROGRESS_SCREEN_2 = 'PROGRESS_SCREEN_2',
  PROGRESS_SCREEN_3 = 'PROGRESS_SCREEN_3',
  RECURRING_DEPOSIT = 'RECURRING_DEPOSIT',
  RECURRING_INVESTMENT = 'RECURRING_INVESTMENT',
  /** @deprecated Page removed from funnel */
  REFERRAL_DISCLOSURE = 'REFERRAL_DISCLOSURE',
  /** @deprecated Page removed from funnel */
  REFERRAL_REWARD = 'REFERRAL_REWARD',
  ROUND_UPS_FUNDING = 'ROUND_UPS_FUNDING',
  ROUND_UPS_INTERSTITIAL = 'ROUND_UPS_INTERSTITIAL',
  ROUND_UPS_PAST = 'ROUND_UPS_PAST',
  ROUND_UPS_SET_UP = 'ROUND_UPS_SET_UP',
  SECOND_CHANCE_BANK_LINK = 'SECOND_CHANCE_BANK_LINK',
  SECOND_CHANCE_INSTITUTIONS = 'SECOND_CHANCE_INSTITUTIONS',
  /** @deprecated Page removed from funnel */
  SELECT_PORTFOLIO_THEME = 'SELECT_PORTFOLIO_THEME',
  /** @deprecated Page removed from funnel */
  SELECT_TIER = 'SELECT_TIER',
  /** @deprecated The shipping address page was originally rolled out with multiple components combined in one. This has been replaced with ADDRESS_EDIT, ADDRESS_INVALID, ADDRESS_PREVIEW, and ADDRESS_SUGGESTION. */
  SHIPPING_ADDRESS = 'SHIPPING_ADDRESS',
  SIGNUP = 'SIGNUP',
  SSN = 'SSN',
  SUBSCRIPTION_ACTIVE = 'SUBSCRIPTION_ACTIVE',
  SUCCESS = 'SUCCESS',
  SUITABILITY_QUESTIONS = 'SUITABILITY_QUESTIONS'
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** Query attributes for Direct Deposit Parameterized PDF Generation */
export type ParameterizedPdfInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID'];
  /** Date Signed */
  dateSigned: Scalars['String'];
  /** Value of Amount Option Chosen */
  distributionAmount?: InputMaybe<Scalars['Float']>;
  /** Amount Option */
  distributionType: DirectDepositDistribution;
  /** Employer Name */
  employerName: Scalars['String'];
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>;
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>;
};

export type PartnerDataShare = {
  __typename?: 'PartnerDataShare';
  partner: BenefitsPartner;
  userId: Scalars['ID'];
};

export type PartnerDataShareInput = {
  product: BenefitsProduct;
};

export type PartnerDataShareResponse = PartnerDataShare | ProductNotSupportedException;

export type PartnerDetailsResponse = {
  __typename?: 'PartnerDetailsResponse';
  partnerLogoUrl: Scalars['String'];
  partnerName: BenefitsPartner;
};

export type PartnerDocumentUrlResponse = {
  __typename?: 'PartnerDocumentUrlResponse';
  documentUrl: Scalars['String'];
};

export type PartnerOfferGroup = {
  __typename?: 'PartnerOfferGroup';
  /** display body for the group */
  body: Maybe<Scalars['String']>;
  carouselType: CarouselType;
  id: Scalars['ID'];
  /** list of offers in the group */
  offers: Array<PartnerOfferGroupItem>;
  /** display title for the group */
  title: Maybe<Scalars['String']>;
};

/** Used to customize offer group contents */
export type PartnerOfferGroupFilterInput = {
  /** Location is required for job offers */
  location?: InputMaybe<OfferLocationInput>;
};

export type PartnerOfferGroupItem = EarnOffer | JobOffer | JobSearchOffer | PromoOffer;

/** Specifies the offer group type input */
export type PartnerOfferGroupsTypeInput = {
  type: OfferGroupsType;
};

export type PartnerStatusInput = {
  acornsPartnerStatus: AcornsPartnerStatus;
  partner: BenefitsPartner;
  partnerData?: InputMaybe<Scalars['String']>;
  partnerEventPayload?: InputMaybe<Scalars['String']>;
  partnerStatus?: InputMaybe<Scalars['String']>;
  partnerUpdatedDt?: InputMaybe<Scalars['DateTime']>;
  product: BenefitsProduct;
};

export type PartnerUrlInput = {
  product: BenefitsProduct;
  /** Optional boolean flag to control customer data sharing */
  shareCustomerData?: InputMaybe<Scalars['Boolean']>;
};

export type PartnerUrlResponse = {
  __typename?: 'PartnerUrlResponse';
  partnerUrl: Scalars['String'];
  status: AcornsPartnerStatus;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum PasswordResetErrors {
  INVALID_PASSWORD_LENGTH = 'INVALID_PASSWORD_LENGTH',
  INVALID_PASSWORD_MISSING_LOWER_CASE = 'INVALID_PASSWORD_MISSING_LOWER_CASE',
  INVALID_PASSWORD_MISSING_NUMBER = 'INVALID_PASSWORD_MISSING_NUMBER',
  INVALID_PASSWORD_MISSING_SPECIAL_CHARACTER = 'INVALID_PASSWORD_MISSING_SPECIAL_CHARACTER',
  INVALID_PASSWORD_MISSING_UPPER_CASE = 'INVALID_PASSWORD_MISSING_UPPER_CASE',
  INVALID_SSN = 'INVALID_SSN',
  NEW_PASSWORD_MATCHES_OLD_PASSWORD = 'NEW_PASSWORD_MATCHES_OLD_PASSWORD',
  PASSWORDS_DO_NOT_MATCH = 'PASSWORDS_DO_NOT_MATCH'
}

export type PasswordResetForm = {
  __typename?: 'PasswordResetForm';
  fields: Array<Maybe<PasswordResetFormFields>>;
  userId: Maybe<Scalars['ID']>;
};

export type PasswordResetFormFields = {
  __typename?: 'PasswordResetFormFields';
  key: Scalars['String'];
  value: Maybe<Scalars['String']>;
};

/** Decorator type for items that have attached notes for display */
export type PastAnnotatedItem = {
  /** Past Item ID */
  id: Scalars['ID'];
  /** Annotation on the item */
  note: Maybe<Scalars['String']>;
  /** Author of the note */
  noteAuthor: Maybe<Scalars['String']>;
};

/** Recurrence setting for a recurring Transfer */
export type PastBeneficiaryInfo = {
  __typename?: 'PastBeneficiaryInfo';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type PastBeneficiaryTransferInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastBeneficiaryTransferInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastCashOwedCollectionInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastCashOwedCollectionInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastCashReinvestmentInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastCashReinvestmentInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A base set of fields that each type of PastItem must implement */
export type PastCoreCombinedItem = {
  /** Past Item ID */
  id: Scalars['ID'];
  isCombinedInvestment: Scalars['Boolean'];
};

/** A generic money movement line item for the Core account */
export type PastCoreItem = PastItem & {
  __typename?: 'PastCoreItem';
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Metrics for core to be displayed in the summary */
export type PastCoreSummary = {
  __typename?: 'PastCoreSummary';
  dividends: CurrencyAmount;
  foundMoneyRewards: CurrencyAmount;
  investments: CurrencyAmount;
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount;
  referralRewards: CurrencyAmount;
  withdrawals: CurrencyAmount;
};

/** A base set of fields that each traded PastItem must implement */
export type PastCoreTradedItem = {
  /** Past Item ID */
  id: Scalars['ID'];
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>;
};

export type PastDividendInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastDividendInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A base set of fields all Early items share */
export type PastEarlyItem = {
  beneficiaryAccountId: Scalars['String'];
  beneficiaryId: Scalars['String'];
};

/** Metrics for early to be displayed in the summary */
export type PastEarlySummary = {
  __typename?: 'PastEarlySummary';
  contributions: CurrencyAmount;
  dividends: CurrencyAmount;
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount;
  withdrawals: CurrencyAmount;
};

export type PastEmployeeContributionInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastEmployeeContributionInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastExternalTransferInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastExternalTransferInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastExternalTransferReversedInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastExternalTransferReversedInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastFeeInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastFeeInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastGiftCardInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastGiftCardInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastIraTransferInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastIRATransferInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A base set of fields that each type of PastItem must implement */
export type PastInvestmentItem = {
  accountName: Scalars['String'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
};

/** A base set of fields that each type of PastItem must implement */
export type PastItem = {
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** PastItem connection object */
export type PastItemConnection = {
  __typename?: 'PastItemConnection';
  edges: Array<PastItemEdge>;
  pageInfo: PageInfo;
};

export type PastItemEdge = {
  __typename?: 'PastItemEdge';
  cursor: Scalars['ID'];
  node: Maybe<PastItem>;
};

export enum PastItemStatus {
  complete = 'complete',
  pending = 'pending',
  selling = 'selling',
  transferring = 'transferring'
}

export type PastItemsAccountFilter = {
  /** Requested Account ID */
  id: Scalars['ID'];
  /** Product Account Type */
  productAccountType: ProductAccountType;
};

export type PastLaterSummary = {
  __typename?: 'PastLaterSummary';
  contributions: CurrencyAmount;
  currentYearContributions: CurrencyAmount;
  dividends: CurrencyAmount;
  netReturns: CurrencyAmount;
  priorYearContributions: CurrencyAmount;
  withdrawals: CurrencyAmount;
};

export type PastLumpSumInvestment = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastLumpSumInvestment';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastMatchInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastMatchInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastMatchRemovalInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastMatchRemovalInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastMoneyManagerAllocation = {
  __typename?: 'PastMoneyManagerAllocation';
  allocationAmount: Maybe<CurrencyAmount>;
  allocationPercent: Scalars['Float'];
  targetAccountId: Scalars['ID'];
  targetAccountType: ProductAccountType;
};

export type PastMoneyManagerAllocations = {
  allocations: Array<PastMoneyManagerAllocation>;
};

/** Recurring information for a money manager recurring transfer */
export type PastMoneyManagerRecurrenceItem = PastMoneyManagerAllocations & PastScheduledItemV2 & {
  __typename?: 'PastMoneyManagerRecurrenceItem';
  accountType: ProductAccountType;
  allocations: Array<PastMoneyManagerAllocation>;
  amount: CurrencyAmount;
  recurrence: PastRecurrenceSettingsV2;
};

/** Money Manager paycheck information */
export type PastMoneyManagerScheduledPaycheckItem = PastMoneyManagerAllocations & PastScheduledItemV2 & {
  __typename?: 'PastMoneyManagerScheduledPaycheckItem';
  accountType: ProductAccountType;
  allocations: Array<PastMoneyManagerAllocation>;
  amount: CurrencyAmount;
  employer: Scalars['String'];
  expectedNextDeposit: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PastOutsideContributionInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastOutsideContributionInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastRealTimeRoundUpInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastRealTimeRoundUpInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastRebalanceInvestmentItem = PastInvestmentItem & PastItem & {
  __typename?: 'PastRebalanceInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  /** The current state of the item */
  status: PastItemStatus;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Recurring information for a recurring transfer */
export type PastRecurrenceItem = PastScheduledItem & {
  __typename?: 'PastRecurrenceItem';
  /** type of account transactions is associated with */
  accountType: ProductAccountType;
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount;
  beneficiary: Maybe<PastBeneficiaryInfo>;
  recurrence: PastRecurrenceSettings;
};

/** Recurring information for a recurring transfer */
export type PastRecurrenceItemV2 = PastScheduledItemV2 & {
  __typename?: 'PastRecurrenceItemV2';
  /** type of account transactions is associated with */
  accountType: ProductAccountType;
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount;
  beneficiary: Maybe<Beneficiary>;
  recurrence: PastRecurrenceSettingsV2;
};

/** Recurrence setting for a recurring Transfer */
export type PastRecurrenceSettings = {
  __typename?: 'PastRecurrenceSettings';
  accountId: Scalars['String'];
  /** @deprecated Use daysOfMonth instead */
  dayOfMonth: Maybe<Scalars['Float']>;
  daysOfMonth: Maybe<Array<Scalars['Float']>>;
  frequency: RecurrenceFrequency;
  id: Maybe<Scalars['String']>;
  weekday: Maybe<DayOfWeek>;
};

/** Recurrence setting for a recurring Transfer */
export type PastRecurrenceSettingsV2 = {
  __typename?: 'PastRecurrenceSettingsV2';
  accountId: Scalars['String'];
  /** @deprecated Use daysOfMonth instead. */
  dayOfMonth: Maybe<Scalars['Float']>;
  daysOfMonth: Maybe<Array<Scalars['Float']>>;
  frequency: RecurrenceFrequency;
  id: Maybe<Scalars['String']>;
  weekday: Maybe<DayOfWeek>;
};

export type PastRecurringInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastRecurringInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastReferralRewardInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastReferralRewardInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastReferralRewardMatchInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastReferralRewardMatchInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastRefundInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastRefundInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastReversalInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastReversalInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastRewardInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastRewardInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  merchantName: Maybe<Scalars['String']>;
  moneyManagerTransfer: Scalars['Boolean'];
  partnerLogoUrl: Maybe<Scalars['URL']>;
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastRewardMatchInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastRewardMatchInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  merchantName: Maybe<Scalars['String']>;
  moneyManagerTransfer: Scalars['Boolean'];
  partnerLogoUrl: Maybe<Scalars['URL']>;
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastRoundUpItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastRoundUpItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastRoundUpMatchInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastRoundUpMatchInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A base set of fields that each type of PastScheduledItem must implement */
export type PastScheduledItem = {
  /** type of account transactions is associated with */
  accountType: ProductAccountType;
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount;
};

/** A base set of fields that each type of PastScheduledItem must implement */
export type PastScheduledItemV2 = {
  /** type of account transactions is associated with */
  accountType: ProductAccountType;
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount;
};

export type PastSecurityLiquidationInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastSecurityLiquidationInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PastSmartDepositInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastSmartDepositInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A generic money movement line item for the Spend account */
export type PastSpendItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'PastSpendItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Metrics for spend to be displayed in the summary */
export type PastSpendSummary = {
  __typename?: 'PastSpendSummary';
  /** Primary account's current available balance */
  availableBalance: Maybe<CurrencyAmount>;
  /**
   * Withdrawals for this month. Current month is based on current PST time
   * @deprecated Use
   */
  debits: Maybe<CurrencyAmount>;
  /** Withdrawals/purchases for the last 30 days. Based on current PST time */
  debitsLast30Days: Maybe<CurrencyAmount>;
  /**
   * One time or direct deposits for this month. Current month is based on current PST time
   * @deprecated Use
   */
  deposits: Maybe<CurrencyAmount>;
  /** One time or direct deposits for the last 30 days. Based on current PST time */
  depositsLast30Days: Maybe<CurrencyAmount>;
  /** @deprecated Will be displayed on Past Core Summary */
  foundMoneyPlus: Maybe<CurrencyAmount>;
  instantRoundUps: Maybe<CurrencyAmount>;
};

/** Recurrence setting for a recurring Transfer */
export type PastSplitDepositAllocationSettings = {
  __typename?: 'PastSplitDepositAllocationSettings';
  allocationList: Array<PastSplitDepositAllocations>;
  expectedNextDeposit: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Recurrence setting for a recurring Transfer */
export type PastSplitDepositAllocationSettingsV2 = {
  __typename?: 'PastSplitDepositAllocationSettingsV2';
  allocationList: Array<PastSplitDepositAllocationsV2>;
  expectedNextDeposit: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PastSplitDepositAllocations = {
  __typename?: 'PastSplitDepositAllocations';
  allocationAmount: Maybe<CurrencyAmount>;
  allocationPercent: Scalars['String'];
  name: Maybe<Scalars['String']>;
  targetAccountId: Scalars['ID'];
  targetAccountType: SplitDepositTargetAccountType;
};

export type PastSplitDepositAllocationsV2 = {
  __typename?: 'PastSplitDepositAllocationsV2';
  allocationAmount: Maybe<CurrencyAmount>;
  allocationPercent: Scalars['String'];
  name: Maybe<Scalars['String']>;
  targetAccountId: Scalars['ID'];
  targetAccountType: SplitDepositTargetAccountType;
};

/** Split Paycheck information for a direct deposit */
export type PastSplitDepositItem = PastScheduledItem & {
  __typename?: 'PastSplitDepositItem';
  /** type of account transactions is associated with */
  accountType: ProductAccountType;
  allocations: PastSplitDepositAllocationSettings;
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount;
  awaitingConfiguration: Scalars['Boolean'];
  moneyManagerTransfer: Scalars['Boolean'];
};

/** Split Paycheck information for a direct deposit */
export type PastSplitDepositItemV2 = PastScheduledItemV2 & {
  __typename?: 'PastSplitDepositItemV2';
  /** type of account transactions is associated with */
  accountType: ProductAccountType;
  allocations: PastSplitDepositAllocationSettingsV2;
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount;
  awaitingConfiguration: Scalars['Boolean'];
};

/** A base set of fields for transaction summary that each type of HistorySummary must implement */
export type PastSummary = {
  moneyIn: CurrencyAmount;
  moneyOut: CurrencyAmount;
};

export type PastSummaryFilter = {
  /** Requested Account ID and Type */
  account?: InputMaybe<PastItemsAccountFilter>;
  /** Time to filter transaction by */
  timeframe?: InputMaybe<TimeFrameFilter>;
};

/** A base set of fields that each type of PastItem must implement */
export type PastTargetedTransferItem = {
  sourceAccountTitle: Maybe<Scalars['String']>;
  targetAccountTitle: Maybe<Scalars['String']>;
};

/** Adds an estimated completion date field for items that correspond to user external transfers */
export type PastUserTransferItem = {
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
};

export type PastWithdrawalInvestmentItem = PastInvestmentItem & PastItem & PastTargetedTransferItem & {
  __typename?: 'PastWithdrawalInvestmentItem';
  accountName: Scalars['String'];
  amount: Maybe<CurrencyAmount>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type PayoutRelationshipResult = {
  __typename?: 'PayoutRelationshipResult';
  action: Maybe<ManagePayoutRelationshipAction>;
  result: Maybe<ManagePayoutRelationshipResult>;
};

/** Query attributes for Direct Deposit PDF URL Generation */
export type PdfDownloadUrlInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID'];
  /** Employer Name */
  employerName: Scalars['String'];
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>;
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Returns URL with JWT token to lambda for Front-end */
export type PdfDownloadUrlPayload = {
  __typename?: 'PdfDownloadUrlPayload';
  /** PDF Download URL */
  url: Scalars['String'];
};

/** Performance values for a given Investment Account */
export type Performance = {
  __typename?: 'Performance';
  /** Investment account values based on previous market day's closing prices */
  accountValues: Maybe<Array<Maybe<AccountValue>>>;
  /** The dollar change in account value over the reporting period */
  marketChange: Maybe<Scalars['Float']>;
  /** The percentage change in account value over the reporting period */
  marketChangePercent: Maybe<Scalars['Float']>;
  /** The percentage change in account value over the reporting period (excluding fees) */
  marketChangePercentWithoutFees: Maybe<Scalars['Float']>;
  /** The dollar change in account value over the reporting period (excluding fees) */
  marketChangeWithoutFees: Maybe<Scalars['Float']>;
  /** Investment account value based on previous market day's closing prices */
  previousCloseAmount: Maybe<Scalars['Float']>;
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested: Maybe<Scalars['Float']>;
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending: Maybe<Scalars['Float']>;
};

/** User profile update fields */
export type PersonalInfoInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  usCitizen?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Miscellaneous attributes and information about a user's phone numbers */
export type Phone = TimestampsInterface & {
  __typename?: 'Phone';
  /** Country code */
  countryCode: Scalars['String'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Internal ID for phone */
  id: Scalars['ID'];
  /** Phone Number */
  phoneNumber: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** Internal ID for user */
  userId: Scalars['ID'];
  /** Phone has been verified */
  verified: Scalars['Boolean'];
};

export type PhoneAuthenticator = Authenticator & {
  __typename?: 'PhoneAuthenticator';
  createdAt: Scalars['DateTime'];
  deviceId: Scalars['ID'];
  id: Scalars['ID'];
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>;
  lastUsedAt: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  phoneNumber: Scalars['PhoneNumber'];
  type: AuthType;
  updatedAt: Scalars['DateTime'];
};

export type PhoneNumberOptedOutException = {
  __typename?: 'PhoneNumberOptedOutException';
  message: Maybe<Scalars['String']>;
};

export type PhoneRedirect = {
  __typename?: 'PhoneRedirect';
  title: Scalars['String'];
};

export enum PinwheelLinkTokenRequiredJobs {
  DirectDepositSwitch = 'DirectDepositSwitch'
}

/** The link token for use in the client. */
export type PlaidLayerLinkSession = {
  __typename?: 'PlaidLayerLinkSession';
  /** The Link Token a client should use for account linking. */
  token: Scalars['String'];
};

export enum Platform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  UNDEFINED = 'UNDEFINED',
  WEB = 'WEB'
}

export type PoliciesRecordDoesNotExistException = {
  __typename?: 'PoliciesRecordDoesNotExistException';
  policyInput: Maybe<Scalars['String']>;
};

export type Policy = {
  __typename?: 'Policy';
  name: Scalars['String'];
};

export type PolicyNotAddedException = {
  __typename?: 'PolicyNotAddedException';
  policyInput: Maybe<Scalars['String']>;
};

/** Acorns Managed Portfolio Object */
export type Portfolio = BasePortfolio & {
  __typename?: 'Portfolio';
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation;
  cashOwed: MonetaryAmount;
  currentAllocationPercentage: Scalars['Float'];
  currentBalance: MonetaryAmount;
  currentBalanceWithPending: MonetaryAmount;
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>;
  /** Description of the portfolio */
  description: Scalars['String'];
  /**
   * Indicates the ETFs that the portfolio is composed of
   * @deprecated Use BasePortfolio.portfolioSecurityAllocations instead
   */
  etfs: Maybe<Array<Etf>>;
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount).
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  holdings: Maybe<Array<PortfolioHolding>>;
  /** ID of the Portfolio */
  id: Scalars['ID'];
  /** Indicates the minimum ratio that must be allocated to the managed portfolio */
  minimumManagedAllocationPercent: Scalars['Float'];
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String'];
  /** Indicates a key based off of the portfolio name */
  nameKey: Scalars['String'];
  pendingBalance: MonetaryAmount;
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities: Maybe<Array<PortfolioSecurity>>;
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<Array<PortfolioSecurityAllocation>>;
  /** Indicates the display priority */
  position: Maybe<Scalars['Int']>;
  /** Indicates the projection of the portfolio */
  projection: Maybe<PortfolioProjection>;
  /** Indicates how risky the portfolio is */
  riskLevel: PortfolioRiskLevel;
  /** Indicates if the portfolio is standard or sustainable */
  theme: PortfolioTheme;
  yearToDateReturn: Maybe<MarketReturn>;
};

/** Portfolio Allocation Object */
export type PortfolioAllocation = {
  __typename?: 'PortfolioAllocation';
  /** Percentage of investment allocated to this portfolio */
  allocationPercent: Scalars['Float'];
  /** ID of the PortfolioAllocation */
  portfolioId: Scalars['ID'];
};

export type PortfolioAlreadyRemovedError = {
  __typename?: 'PortfolioAlreadyRemovedError';
  /** Date and Time of removal if portfolio is already removed */
  portfolioRemovedAt: Scalars['DateTime'];
};

export enum PortfolioCustomizationLevel {
  /** Additional pre-approved Security's may be added to the Portfolio at pre-set allocations. */
  ADDON = 'ADDON',
  /** Portfolio holdings and allocation percentages are fully configurable. */
  FULLY_CONFIGURED = 'FULLY_CONFIGURED',
  /** Portfolio holdings and allocation percentages are pre-set. */
  NONE = 'NONE'
}

/** Portfolio Holding */
export type PortfolioHolding = {
  __typename?: 'PortfolioHolding';
  /** The dollar amount of shares a user has */
  amount: Scalars['Float'];
  id: Scalars['ID'];
  /** The Acorns-assigned name of the ETF */
  name: Scalars['String'];
  /** The actual percentage of a user's portfolio the ETF accounts for */
  percentage: Scalars['Float'];
  /** The quanity of shares a user has */
  shares: Scalars['Float'];
  /** The ETF's trading symbol */
  symbol: Scalars['String'];
};

/** Portfolio Not Found */
export type PortfolioNotFoundException = {
  __typename?: 'PortfolioNotFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Portfolio Not Supported */
export type PortfolioNotSupportedException = {
  __typename?: 'PortfolioNotSupportedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Portfolio Projection */
export type PortfolioProjection = {
  __typename?: 'PortfolioProjection';
  /** The projected average growth rate */
  averageGrowthRate: Scalars['Float'];
  /** The projected highest growth rate */
  highestGrowthRate: Scalars['Float'];
  /** The projected lowest growth rate */
  lowestGrowthRate: Scalars['Float'];
};

export type PortfolioRemovalInProgressError = {
  __typename?: 'PortfolioRemovalInProgressError';
  /** Message displayed to customer when a portfolio removal is already in progress */
  clientMessage: Scalars['String'];
};

export enum PortfolioRiskLevel {
  AGGRESSIVE = 'AGGRESSIVE',
  CONSERVATIVE = 'CONSERVATIVE',
  CUSTOM = 'CUSTOM',
  MODERATE = 'MODERATE',
  MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
  MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE'
}

/** Portfolio Security */
export type PortfolioSecurity = {
  __typename?: 'PortfolioSecurity';
  /** The current percentage of the market value over the customer's total balance */
  currentAllocationPercentage: Scalars['Float'];
  id: Scalars['ID'];
  /** The market value of shares owned by the customer */
  marketValue: MonetaryAmount;
  /** The Acorns-assigned name of the security */
  name: Scalars['String'];
  /** The quantity of shares a user has */
  shares: Scalars['Float'];
  /** The security's trading symbol */
  symbol: Scalars['String'];
  /**
   * DEPRECATED: The target percentage of the market value over the customer's total balance
   * @deprecated Will not be populated with self directed investments release.
   */
  targetAllocationPercentage: Maybe<Scalars['Float']>;
  /** The customer's returns for today */
  todaysReturn: MarketReturn;
  /** The customer's returns for all time for the security */
  totalReturn: MarketReturn;
};

/** Security allocation */
export type PortfolioSecurityAllocation = {
  __typename?: 'PortfolioSecurityAllocation';
  allocationPercent: Scalars['Float'];
  /** @deprecated Use Security.displayName instead */
  displayName: Scalars['String'];
  id: Scalars['ID'];
  /** Indicates the investment category for the security */
  investmentCategories: InvestmentCategory;
  /** @deprecated Use Security.shortName instead */
  name: Scalars['String'];
  /** Indicates whether the Security can be removed from an Investment Account's base Portfolio. */
  removableFromBasePortfolio: Scalars['Boolean'];
  security: Maybe<Security>;
  symbol: Scalars['String'];
};

/** Portfolio Security Limit Reached */
export type PortfolioSecurityLimitReached = {
  __typename?: 'PortfolioSecurityLimitReached';
  /** Maximum amount of security allowed */
  limit: Scalars['Int'];
};

export enum PortfolioTheme {
  SELF_DIRECTED = 'SELF_DIRECTED',
  STANDARD = 'STANDARD',
  SUSTAINABLE = 'SUSTAINABLE'
}

/** Failed to update portfolio on investment account */
export type PortfolioUpdateFailedException = {
  __typename?: 'PortfolioUpdateFailedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type PositiveCurrencyAmountInput = {
  currency: Currency;
  value: Scalars['PositiveFloat'];
};

/** the selected funding source is not eligible to be preferred. It's either inactive or unlinked */
export type PreferredAccountNotEligibleError = {
  __typename?: 'PreferredAccountNotEligibleError';
  /** requested funding source is not eligible */
  fundingSourceUuid: Maybe<Scalars['ID']>;
};

/** The user has only one active FS. Must have two to set preferred withdrawal account */
export type PreferredAccountNotSupportedError = {
  __typename?: 'PreferredAccountNotSupportedError';
  /** doesn't support setting preferred account for the user. */
  userUuid: Maybe<Scalars['ID']>;
};

/** Presentation-driven entity for an associated Product */
export type PresentableProduct = {
  __typename?: 'PresentableProduct';
  /** Keys to strings to display description of associated product */
  descriptionKeys: Array<Scalars['StringKey']>;
  /** Associated product */
  product: Product;
};

export enum PresentableWithdrawalStatus {
  canceled = 'canceled',
  complete = 'complete',
  failed = 'failed',
  pending = 'pending',
  refunded = 'refunded',
  sellingInvestments = 'sellingInvestments',
  transferring = 'transferring'
}

/** Existing funding source in pending state */
export type PreviousFundingSourcePending = {
  __typename?: 'PreviousFundingSourcePending';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** Canonical representation of an Acorns product that can be used and billed for. */
export type Product = {
  __typename?: 'Product';
  /** Indicates whether or not the Product is available to new Users. */
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  descriptionKeys: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  key: ProductKey;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ProductAccountType {
  BROKERAGE = 'BROKERAGE',
  CHECKING = 'CHECKING',
  CUSTODIAL = 'CUSTODIAL',
  RETIREMENT = 'RETIREMENT',
  SAVINGS = 'SAVINGS'
}

/** Ref for product name */
export enum ProductKey {
  BENEFITS_GOHENRY_STANDARD = 'BENEFITS_GOHENRY_STANDARD',
  BENEFITS_INSURANCE_STANDARD = 'BENEFITS_INSURANCE_STANDARD',
  BENEFITS_TAXFILING_STANDARD = 'BENEFITS_TAXFILING_STANDARD',
  BENEFITS_WILL_STANDARD = 'BENEFITS_WILL_STANDARD',
  EARLY = 'EARLY',
  EARLY_MATCH = 'EARLY_MATCH',
  EARLY_PUBLISHING = 'EARLY_PUBLISHING',
  EARLY_SELF_DIRECTED_INVEST = 'EARLY_SELF_DIRECTED_INVEST',
  EARN = 'EARN',
  EARN_CHOICE = 'EARN_CHOICE',
  EARN_PRIME = 'EARN_PRIME',
  EMERGENCY_FUND = 'EMERGENCY_FUND',
  INVEST = 'INVEST',
  LATER = 'LATER',
  LATER_MATCH = 'LATER_MATCH',
  LEARN = 'LEARN',
  LEARN_PREMIUM = 'LEARN_PREMIUM',
  MIGHTY_OAK_CARD = 'MIGHTY_OAK_CARD',
  MONEY_MANAGER = 'MONEY_MANAGER',
  PREMIUM_EDUCATION = 'PREMIUM_EDUCATION',
  SELF_DIRECTED_INVEST = 'SELF_DIRECTED_INVEST',
  SPEND = 'SPEND',
  STANDARD_BENEFITS_INSURANCE = 'STANDARD_BENEFITS_INSURANCE'
}

export type ProductNotSupportedException = {
  __typename?: 'ProductNotSupportedException';
  message: Scalars['String'];
};

export enum ProductSetupTipType {
  /** Banking - setup digital wallet */
  banking_digital_wallet = 'banking_digital_wallet',
  /** Banking - setup direct deposit */
  banking_mighty_oak_card_direct_deposit = 'banking_mighty_oak_card_direct_deposit',
  /** home - try benefits hub */
  benefits_hub = 'benefits_hub',
  /** checking engagement wizard - activate card */
  checking_engagement_wizard_activate_card = 'checking_engagement_wizard_activate_card',
  /** checking engagement wizard - add to digital wallet */
  checking_engagement_wizard_digital_wallet = 'checking_engagement_wizard_digital_wallet',
  /** checking engagement wizard - direct deposit */
  checking_engagement_wizard_direct_deposit = 'checking_engagement_wizard_direct_deposit',
  /** checking engagement wizard - set up emergency fund */
  checking_engagement_wizard_emergency_fund = 'checking_engagement_wizard_emergency_fund',
  /** checking engagement wizard - go henry account connected */
  checking_engagement_wizard_go_henry = 'checking_engagement_wizard_go_henry',
  /** checking engagement wizard - pay bills */
  checking_engagement_wizard_pay_bills = 'checking_engagement_wizard_pay_bills',
  /** checking engagement wizard - set auto roundups */
  checking_engagement_wizard_set_auto_roundups = 'checking_engagement_wizard_set_auto_roundups',
  /** early - setup direct deposit */
  early_direct_deposit = 'early_direct_deposit',
  /** early - setup recurring transfers */
  early_recurring_transfer = 'early_recurring_transfer',
  /** early - try sustainable portfolio */
  early_try_sustainable_portfolio = 'early_try_sustainable_portfolio',
  /** home - earn android extension */
  earn_android_extension = 'earn_android_extension',
  /** home - earn safari extension */
  earn_safari_extension = 'earn_safari_extension',
  /** home - harvest bank fees */
  harvest_bank_fees = 'harvest_bank_fees',
  /** home - link primary checking */
  home_link_primary_checking = 'home_link_primary_checking',
  /** home - link roundup cards */
  home_link_roundup_cards = 'home_link_roundup_cards',
  /** home - set auto roundups */
  home_set_auto_roundups = 'home_set_auto_roundups',
  /** home - try self-directed portfolio */
  home_try_self_directed_portfolio = 'home_try_self_directed_portfolio',
  /** home - try sustainable portfolio */
  home_try_sustainable_portfolio = 'home_try_sustainable_portfolio',
  /** invest - add bitcoin to diversified portfolio */
  invest_add_bitcoin = 'invest_add_bitcoin',
  /** invest hub - link primary checking */
  invest_hub_link_primary_checking = 'invest_hub_link_primary_checking',
  /** invest hub - link roundup cards */
  invest_hub_link_roundup_cards = 'invest_hub_link_roundup_cards',
  /** invest hub - set auto roundups */
  invest_hub_set_auto_roundups = 'invest_hub_set_auto_roundups',
  /** invest hub - try self-directed portfolio */
  invest_hub_try_self_directed_portfolio = 'invest_hub_try_self_directed_portfolio',
  /** invest - link primary checking */
  invest_link_primary_checking = 'invest_link_primary_checking',
  /** invest - link roundup cards */
  invest_link_roundup_cards = 'invest_link_roundup_cards',
  /** invest - make first investment */
  invest_make_first_investment = 'invest_make_first_investment',
  /** invest - schedule regular deposits */
  invest_schedule_regular_deposits = 'invest_schedule_regular_deposits',
  /** invest - set auto roundups */
  invest_set_auto_roundups = 'invest_set_auto_roundups',
  /** invest - try self-directed portfolio */
  invest_try_self_directed_portfolio = 'invest_try_self_directed_portfolio',
  /** invest - try sustainable portfolio */
  invest_try_sustainable_portfolio = 'invest_try_sustainable_portfolio',
  /** later - link primary checking */
  later_link_primary_checking = 'later_link_primary_checking',
  /** later - make first investment */
  later_make_first_investment = 'later_make_first_investment',
  /** later schedule regular deposits */
  later_schedule_regular_deposits = 'later_schedule_regular_deposits',
  /** later - set a beneficiary */
  later_set_a_beneficiary = 'later_set_a_beneficiary',
  /** later - try sustainable portfolio */
  later_try_sustainable_portfolio = 'later_try_sustainable_portfolio',
  /**
   * all contexts - nps survey
   * @deprecated deprecated tip no longer used on clients
   */
  nps_survey = 'nps_survey',
  /** home - path to million promotion */
  path_to_million = 'path_to_million',
  /** all contexts - referral promotion */
  referral_promotion = 'referral_promotion',
  /** spend - setup direct deposit */
  spend_direct_deposit = 'spend_direct_deposit',
  /** spend - incentive to setup direct deposit */
  spend_direct_deposit_incentive = 'spend_direct_deposit_incentive',
  /** spend - setup recurring deposit */
  spend_recurring_deposit = 'spend_recurring_deposit',
  /** spend - set spend as primary */
  spend_set_as_primary = 'spend_set_as_primary',
  /** spend - setup smart deposit */
  spend_smart_deposit = 'spend_smart_deposit',
  /** spend - smart deposit sweepstakes */
  spend_smart_deposit_sweepstakes = 'spend_smart_deposit_sweepstakes',
  /** home - wildfire chrome extension */
  wildfire_chrome_extension = 'wildfire_chrome_extension'
}

export enum ProductType {
  core = 'core',
  early = 'early',
  later = 'later',
  save = 'save',
  spend = 'spend'
}

/** Miscellaneous attributes and information about a user */
export type Profile = TimestampsInterface & {
  __typename?: 'Profile';
  /** Annual income */
  annualIncome: Maybe<Scalars['Int']>;
  /** Combined annual income */
  combinedAnnualIncome: Maybe<Scalars['Int']>;
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Debt */
  debt: Maybe<Scalars['Boolean']>;
  /** Employees */
  employees: Maybe<Employees>;
  /** Employment status */
  employmentStatus: Maybe<EmploymentStatus>;
  /** Filing type */
  filingType: Maybe<FilingType>;
  /** Financial education */
  financialEducation: Maybe<FinancialEducation>;
  /** First name */
  firstName: Maybe<Scalars['String']>;
  /** Funds availability */
  fundsAvailability: Maybe<FundsAvailability>;
  /** High-interest debt */
  highInterestDebt: Maybe<Scalars['Boolean']>;
  /** Investment goal */
  investmentGoal: Maybe<InvestmentGoal>;
  /** Last name */
  lastName: Maybe<Scalars['String']>;
  /** Marital status */
  maritalStatus: Maybe<MaritalStatus>;
  /** Monthly expenses */
  monthlyExpenses: Maybe<Scalars['Float']>;
  /** Net worth */
  netWorth: Maybe<Scalars['Float']>;
  /** has user opted out of targeting */
  optedOutOfTargeting: Scalars['Boolean'];
  /** Retirement plan access */
  retirementPlanAccess: Maybe<RetirementPlanAccess>;
  /** Self employed income */
  selfEmployedIncome: Maybe<Scalars['Int']>;
  /** Signature type */
  signatures: Array<Maybe<Signature>>;
  /** Last four of SSN */
  ssnLastFour: Maybe<Scalars['String']>;
  /** User has paused their transfers */
  transfersPaused: Maybe<Scalars['Boolean']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** Internal ID for user */
  userId: Scalars['ID'];
};

export type ProfileAttribute = {
  key: Scalars['String'];
  value: Scalars['JSON'];
};

/** Changeable attributes for user profiles */
export type ProfileInput = {
  /** Non-self employed income */
  annualIncome?: InputMaybe<Scalars['Int']>;
  /** Total annual income */
  combinedAnnualIncome?: InputMaybe<Scalars['Int']>;
  /** Debt */
  debt?: InputMaybe<Scalars['Boolean']>;
  /** Number of employees the user has (if self employed) */
  employees?: InputMaybe<Employees>;
  /** Status of user's employment */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** How the user files their taxes */
  filingType?: InputMaybe<FilingType>;
  /** User's level of financial education */
  financialEducation?: InputMaybe<FinancialEducation>;
  /** Funds availability */
  fundsAvailability?: InputMaybe<FundsAvailability>;
  /** High-interest debt */
  highInterestDebt?: InputMaybe<Scalars['Boolean']>;
  /** User's investment goal */
  investmentGoal?: InputMaybe<InvestmentGoal>;
  /** Marital status */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Monthly expenses */
  monthlyExpenses?: InputMaybe<Scalars['Float']>;
  /** Net worth */
  netWorth?: InputMaybe<Scalars['Float']>;
  /** How the user wants to access their retirement plan */
  retirementPlanAccess?: InputMaybe<RetirementPlanAccess>;
  /** Self employed income */
  selfEmployedIncome?: InputMaybe<Scalars['Int']>;
  /** Pause transfers */
  transfersPaused?: InputMaybe<Scalars['Boolean']>;
};

export enum ProgramAccountType {
  PLAN = 'PLAN'
}

export type PromoCode = {
  __typename?: 'PromoCode';
  businessLine: PromoCodeBusinessLine;
  channel: Scalars['String'];
  condensedTitle: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  internalMemo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  publishEnd: Maybe<Scalars['DateTime']>;
  publishStart: Scalars['DateTime'];
  qualificationAction: PromoCodeQualificationAction;
  qualificationAmount: Scalars['Int'];
  rewards: Array<PromoCodeReward>;
  status: PromoCodeStatus;
  termsUrl: Maybe<Scalars['URL']>;
  title: Scalars['String'];
};

export enum PromoCodeBusinessLine {
  AFFILIATE = 'AFFILIATE',
  BRAND = 'BRAND',
  ORGANIC = 'ORGANIC',
  PAID_MEDIA = 'PAID_MEDIA'
}

export type PromoCodeCustomer = {
  __typename?: 'PromoCodeCustomer';
  promoCode: PromoCode;
  userId: Scalars['ID'];
};

export type PromoCodeEdge = {
  __typename?: 'PromoCodeEdge';
  cursor: Scalars['String'];
  node: PromoCode;
};

export type PromoCodeFieldLengthError = {
  __typename?: 'PromoCodeFieldLengthError';
  field: Scalars['String'];
  max: Scalars['Int'];
};

export type PromoCodePaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']>;
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type PromoCodePaginatedInfo = {
  __typename?: 'PromoCodePaginatedInfo';
  /** Cursor corresponding to the last node in the list of edges */
  endCursor: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean'];
  /** Cursor corresponding to the first node in the list of edges */
  startCursor: Maybe<Scalars['String']>;
};

export enum PromoCodeQualificationAction {
  INITIAL_INVESTMENT = 'INITIAL_INVESTMENT',
  INITIAL_RECURRING_INVESTMENT = 'INITIAL_RECURRING_INVESTMENT',
  INITIAL_ROUNDUP = 'INITIAL_ROUNDUP',
  INITIAL_SUBSCRIPTION_PAYMENT = 'INITIAL_SUBSCRIPTION_PAYMENT'
}

export type PromoCodeReward = {
  __typename?: 'PromoCodeReward';
  amount: Scalars['Float'];
  id: Scalars['ID'];
  type: PromoCodeRewardType;
};

export type PromoCodeRewardEdge = {
  __typename?: 'PromoCodeRewardEdge';
  cursor: Scalars['String'];
  node: PromoCodeReward;
};

export enum PromoCodeRewardType {
  INVESTMENT = 'INVESTMENT',
  OTHER = 'OTHER'
}

export type PromoCodeRewardsConnection = {
  __typename?: 'PromoCodeRewardsConnection';
  edges: Maybe<Array<PromoCodeRewardEdge>>;
  pageInfo: PromoCodePaginatedInfo;
};

export enum PromoCodeStatus {
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED'
}

export type PromoCodesConnection = {
  __typename?: 'PromoCodesConnection';
  edges: Maybe<Array<PromoCodeEdge>>;
  pageInfo: PromoCodePaginatedInfo;
};

/** Display wrapper for featured promo offer */
export type PromoOffer = {
  __typename?: 'PromoOffer';
  /** Background/featured image */
  backgroundImage: Image;
  /** Display body for the offer */
  body: Maybe<Scalars['String']>;
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image;
  id: Scalars['ID'];
  /** Company/partner logo */
  logo: Maybe<Image>;
  /** Partner url */
  partnerUrl: Scalars['URL'];
  /** Display subtitle for the offer */
  subtitle: Maybe<Scalars['String']>;
  /** Display title for the offer */
  title: Scalars['String'];
};

export type PromotedBenefit = {
  __typename?: 'PromotedBenefit';
  product: BenefitsTrackerProducts;
  promotedThrough: Array<BenefitPromotedThrough>;
};

export type PromotedCampaigns = {
  __typename?: 'PromotedCampaigns';
  campaignIds: Array<Maybe<Scalars['ID']>>;
};

/** Time-bound pricing and/or additional incentives offered to subscibers of a particular offering (tier or product). */
export type Promotion = {
  __typename?: 'Promotion';
  /** Wether or not the promotion is available for new applications. */
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  /** How long the promotion lasts once applied to a subscription. */
  duration: Maybe<PromotionDuration>;
  /** When the promotion is set to expire and become inactive. */
  expiresAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Additional incentives the promotion entitles subscribers to. */
  incentives: Maybe<Array<Incentive>>;
  name: Scalars['String'];
  /** Services that the promotion is for. */
  offering: Offering;
  /** Metadata indicating in what contexts a client should present the promotion. */
  presentInContexts: Array<Scalars['String']>;
  /** Link to legal terms and conditions of the promotion. */
  termsUrl: Scalars['URL'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type PromotionConsumedError = {
  __typename?: 'PromotionConsumedError';
  message: Scalars['String'];
};

export type PromotionDuration = {
  __typename?: 'PromotionDuration';
  period: PromotionDurationPeriod;
  periodCount: Scalars['Int'];
};

export enum PromotionDurationPeriod {
  MONTH = 'MONTH'
}

export type PromotionExpiredError = {
  __typename?: 'PromotionExpiredError';
  expiredAt: Scalars['DateTime'];
  message: Scalars['String'];
};

export type PromotionFilterInput = {
  presentInContexts?: InputMaybe<PromotionPresentInContextsFilterInput>;
};

export type PromotionNotFoundError = {
  __typename?: 'PromotionNotFoundError';
  message: Scalars['String'];
};

export type PromotionPresentInContextsFilterInput = {
  in?: InputMaybe<Array<Scalars['String']>>;
};

/** promotional waiver */
export type PromotionalWaiver = {
  __typename?: 'PromotionalWaiver';
  promotion: Maybe<WaiverPromotion>;
  promotionalWaiverPeriodEndDate: Scalars['String'];
  userId: Scalars['ID'];
};

export type PromotionalWaiver_V2 = {
  __typename?: 'PromotionalWaiver_V2';
  promotion: WaiverPromotion_V2;
  promotionalWaiverPeriodEndDate: Scalars['String'];
  userId: Scalars['ID'];
};

export type Prospect = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export enum ProspectType {
  GROW = 'GROW',
  LATER_WAITLIST = 'LATER_WAITLIST',
  OUTSIDE_CONTRIBUTION = 'OUTSIDE_CONTRIBUTION'
}

/** provisional fee waiver */
export type ProvisionalWaiver = {
  __typename?: 'ProvisionalWaiver';
  userId: Scalars['ID'];
  waiverPeriodEndDate: Scalars['String'];
  waiverReason: Maybe<Scalars['String']>;
};

export type ProvisionalWaiver_V2 = {
  __typename?: 'ProvisionalWaiver_V2';
  userId: Scalars['ID'];
  waiverPeriodEndDate: Scalars['String'];
  waiverReason: Scalars['String'];
};

/** Statuses after a campaign is published */
export enum PublishedCampaignStatus {
  COMPLETE = 'COMPLETE',
  LIVE = 'LIVE',
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED'
}

export type PushAuthChallenge = AuthChallenge & {
  __typename?: 'PushAuthChallenge';
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deviceId: Scalars['ID'];
  id: Scalars['ID'];
  pushState: ChallengePushState;
  updatedAt: Scalars['DateTime'];
};

export type PushAuthenticator = Authenticator & {
  __typename?: 'PushAuthenticator';
  createdAt: Scalars['DateTime'];
  deviceId: Scalars['ID'];
  deviceType: DeviceType;
  id: Scalars['ID'];
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>;
  lastUsedAt: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: AuthType;
  updatedAt: Scalars['DateTime'];
};

export type PushAuthenticatorAlreadyExistsException = {
  __typename?: 'PushAuthenticatorAlreadyExistsException';
  authenticatorId: Scalars['ID'];
  message: Maybe<Scalars['String']>;
};

export type QualificationSubTypeMismatchError = {
  __typename?: 'QualificationSubTypeMismatchError';
  message: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** Fetch mighty oak card waiver for user. */
  MightyOakCardWaiver: MightyOakWaiverResult;
  /** Get an acceptance document by type */
  acceptanceDocument: Maybe<AcceptanceDocument>;
  /** Get a list of documents the user needs to accept */
  acceptanceDocuments: Maybe<Array<Maybe<AcceptanceDocument>>>;
  accountPointsRuleByMilestoneId: Maybe<AccountPointsRule>;
  accountPointsRules: Maybe<Array<AccountPointsRule>>;
  accountStrength: Maybe<AccountStrengthResult>;
  /** Fetch a list of accounts for a user */
  accounts: Array<Maybe<Account>>;
  /** query action feed cards */
  actionFeed: Maybe<Array<Maybe<ActionCard>>>;
  /** Query for the list of eligible Action Screen widgets for the current user */
  actionScreen: Array<ActionScreenComponent>;
  /** @implicit(userId: String) */
  activeEarnOffers: EarnOfferQueryPage;
  /** @deprecated Field no longer supported */
  activeReferralCampaigns: Maybe<ActiveReferralCampaignOutput>;
  /** @deprecated Use the past queries instead. */
  activity: Maybe<Array<Maybe<Activity>>>;
  /** query account summary information */
  activitySummary: Maybe<ActivitySummaryResponse>;
  /** Used to determine if an address is deliverable or offer corrections to make it deliverable. */
  addressDeliverability: Maybe<AddressDeliverabilityResult>;
  /** Fetch a list of addresses for a user */
  addresses: Array<Maybe<Address>>;
  /** @implicit(userId: ID!) */
  advocate: Maybe<Advocate>;
  /**
   * @implicit(userId: ID!)
   * @deprecated Field no longer supported
   */
  advocateFriendsStatuses: Maybe<AdvocateFriendsStatuses>;
  /** Fetch all beneficiary alerts for a user */
  alertHubBeneficiaryAlerts: Maybe<Array<AlertHubBeneficiaryAlert>>;
  /** Get all acceptance documents */
  allAcceptanceDocuments: Maybe<Array<Maybe<AcceptanceDocument>>>;
  /** Pulls all accounts for a customer. */
  allAccounts: Array<CustomerAccount>;
  allBankAccounts: Maybe<Array<Maybe<BankAccount>>>;
  allBankCards: Maybe<Array<Maybe<BankCard>>>;
  allBankDocuments: Maybe<Array<Maybe<BankDocument>>>;
  allBankStatements: Maybe<Array<Maybe<BankStatement>>>;
  allBankTransactions: Maybe<BankTransactionConnection>;
  /** Get the Card Delivery Status */
  allCardTrackingStatuses: Maybe<Array<CardDeliveryStatus>>;
  /** Fetch pages of messages for the user starting from the most recent message */
  allChatHistoryMessages: AllChatHistoryMessages;
  allCheckPayments: Maybe<AllCheckPaymentsResult>;
  allCloseAccountReasons: Maybe<Array<Maybe<CloseAccountReason>>>;
  /** Returns list of categories and nested subcategories for dynamic values in contact form */
  allContactCategories: Maybe<Array<ContactCategory>>;
  /** @deprecated Use Query.investmentAccountsByUserId instead. */
  allInvestmentAccounts: Maybe<Array<InvestmentAccount>>;
  /** Fetches all messages for a user. Leverages Hedwig's DB for notifications/alerts and queries external services for alerts. Make sure a `x-client-platform` header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  allMessages: Maybe<Array<Message>>;
  /** Fetch all Core items for the Past screen. */
  allPastCoreItemChildren: Maybe<Array<PastItem>>;
  /** Fetch all Core items for the Past screen. Defaults to only return non-pending transactions */
  allPastCoreItems: Maybe<PastItemConnection>;
  /** Fetch all Early items for the Past screen. Defaults to only return non-pending transactions */
  allPastEarlyItems: Maybe<PastItemConnection>;
  allPastItems: Maybe<PastItemConnection>;
  /** Fetch all Later items for the Past screen. Defaults to only return non-pending transactions */
  allPastLaterItems: Maybe<PastItemConnection>;
  /** Fetch all pending items across all product types. */
  allPastPendingItems: Maybe<Array<PastItem>>;
  /** Fetch all of a users scheduled transactions from their product accounts */
  allPastScheduledItems: Maybe<Array<PastScheduledItem>>;
  /** Fetch all of a users scheduled transactions from their product accounts */
  allPastScheduledItemsV2: Maybe<Array<PastScheduledItemV2>>;
  allPastSpendItems: Maybe<PastItemConnection>;
  allReturnedCheckDeposits: Maybe<Array<ReturnedCheckDeposit>>;
  allSuitabilityQuestions: Maybe<Array<Maybe<SuitabilityQuestion>>>;
  /** Returns all support articles */
  allSupportArticles: Maybe<Array<Maybe<SupportArticle>>>;
  /** Returns all the current categories within the Help Center */
  allSupportCategories: Maybe<Array<Maybe<SupportCategory>>>;
  /** Returns all support sections */
  allSupportSections: Maybe<Array<Maybe<SupportSection>>>;
  /** Returns all support ticket forms */
  allSupportTicketForms: Maybe<Array<Maybe<SupportTicketForm>>>;
  allTransferableFrom: Maybe<Array<TransferableFrom>>;
  allTransferableTo: Maybe<Array<TransferableTo>>;
  /** Fetch all trusted contacts for a user by user uuid */
  allTrustedContactsByUserId: Array<Maybe<TrustedContact>>;
  /** @implicit(userId: ID!) */
  authAlerts: Maybe<Array<AuthAlert>>;
  /** @implicit(userId: ID!) */
  authProfile: Maybe<AuthProfile>;
  authenticateForFeeNegotiationStatusByLinkedAccountId: Maybe<AuthenticateForFeeNegotiationStatus>;
  /** Returns backend job batches for order types */
  backendJobBatchAutomatedOrders: Maybe<Array<BackendJobBatch>>;
  /** Returns backend job batches for money movement */
  backendJobBatchMoneyMovement: Maybe<Array<BackendJobBatch>>;
  /** Returns backend job batches for order types */
  backendJobBatchOrders: Maybe<Array<BackendJobBatch>>;
  /** Returns backend job batches for profit star deposits */
  backendJobBatchProfitStars: Maybe<Array<BackendJobBatch>>;
  /** Returns all order aggregation stats */
  backendJobBatchSummary: Maybe<BackendJobBatchSummary>;
  bankAccountClosureReasons: Array<BankAccountClosureReason>;
  bankAccountDisclosures: Maybe<Array<Maybe<BankAccountDisclosure>>>;
  /** Returns the bank account state for a given account type. */
  bankAccountState: Maybe<BankAccountStateResult>;
  bankCardOrder: Maybe<BankCardOrder>;
  /** Returns a temporary encrypted token for a digitally active bank card's display details */
  bankCardPanDisplay: BankCardPanDisplayResult;
  /** Returns an encrypted token for virtual bank card provisioning */
  bankCardProvisioningDetails: BankCardProvisioningDetailsResult;
  bankCardReissue: Maybe<BankCardReissue>;
  /** @implicit(userId: String!) */
  bankFeeNegotiationsByUserId: FeeNegotiationSummary;
  /**
   * @implicit(userId: ID!)
   * @deprecated Use query.bankFeesByUserId instead
   */
  bankFeeSummaryByUserId: Maybe<BankFeeSummary>;
  /** @implicit(userId: ID!) */
  bankFeesByUserId: Maybe<Array<BankFee>>;
  /** Returns interest rates for banking products. Omit filter to return data for all products. */
  bankInterestRates: BankInterestRatesResult;
  /** @deprecated Incorrect and no longer in use, we are removing this method in the future */
  bankMetadata: Maybe<BankMetadata>;
  bankTransaction: Maybe<BankTransaction>;
  bankingEmploymentStatuses: Array<Scalars['String']>;
  /** Returns banking feature eligibility and action required to satisfy the eligibility requirement */
  bankingFeatureEligibility: Maybe<BankingFeatureEligibility>;
  /**
   * Returns the KYC status and verification details for the user, if it exists.
   * This is used to determine if the user has completed Banking KYC and if any action is required.
   */
  bankingKycDetails: Maybe<BankingKyc>;
  /** Returns Acorns banners information data */
  banners: Maybe<Array<Maybe<BannersResponse>>>;
  /** Fetch all beneficiaries for a user */
  beneficiaries: Maybe<Array<Beneficiary>>;
  /** Fetch a beneficiary with a given ID */
  beneficiary: Maybe<Beneficiary>;
  /** Fetch all beneficiary alerts for a user */
  beneficiaryAlerts: Maybe<Array<Alert>>;
  /** @implicit(userId: String!) */
  benefitPartnerByUserId: BenefitPartnerResponse;
  /** Fetch billing cycles given an ID */
  billingCycle: Maybe<BillingCycle>;
  /** Fetch billing cycles given a user ID */
  billingCycles: Maybe<Array<BillingCycle>>;
  /** Fetch the data used in determining how a user is billed */
  billingProfile: Maybe<BillingProfile>;
  /** @implicit(userId: ID!) */
  calculateMoneySplits: Maybe<MoneyRulesSuggestionResult>;
  /** @implicit(userId: ID!) */
  campaignHistory: Maybe<CampaignHistoryConnection>;
  /** @implicit(userId: ID!) */
  challenges: Maybe<Array<AuthChallenge>>;
  /** Fetch messages for the user in the session starting from the most recent message */
  chatHistoryMessagesBySessionId: AllChatHistoryMessages;
  /** Investment account closure reasons */
  closureReasonsByInvestmentAccountType: Array<InvestmentAccountClosureReason>;
  /** @implicit(userId: ID!) */
  cohortEligibility: Array<CohortEligibility>;
  /** @implicit(userId: ID!) */
  cohortEligibility_v2: Maybe<Array<CohortEligibility_V2>>;
  /** Fetch the combined performance of user's investment accounts */
  combinedPerformanceByUserId: CombinedPerformance;
  /** Returns info for completed quiz such as user score, average score, number of total and correct questions */
  completedQuizByQuizId: Maybe<CompletedQuiz>;
  /** @implicit(userId: String!) */
  connectionsByUserId: ConnectionSummary;
  /** Returns contact form alert message if it has been set in Zesty */
  contactFormAlert: Maybe<ContactFormAlert>;
  /**
   * Returns a course or null if it does not exist
   * @deprecated This endpoint is being removed and being replaced by course_v2 in order to support locked content
   */
  course: Maybe<Course>;
  /** Returns a learn course or null if it does not exist */
  course_v2: Maybe<LearnCourse>;
  /**
   * Returns a list of courses for given tier
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  coursesByTierId: Maybe<Array<CoursePreview>>;
  /** Returns a list of courses for given topic */
  coursesByTopicId: Maybe<Array<CoursePreview>>;
  /** Returns a list of courses for given topic */
  coursesByTopicId_v2: Maybe<Array<LearnCoursePreview>>;
  /** Returns a personalized list of courses */
  coursesPersonalizedByUserId: Maybe<Array<CoursePreview>>;
  /** Get the currently offered crypto ETF that can be added to a managed Portfolio. */
  cryptoEtf: Maybe<Etf>;
  /** Fetch a user's customer account closure record */
  customerAccountClosureRequest: Maybe<CustomerAccountClosure>;
  /**
   * Get a customer's Earn onboarding program and status
   * @deprecated The Earn Onboarding program has been discontinued
   */
  customerEarnOnboardingProgram: Maybe<CustomerEarnOnboardingProgram>;
  /** @implicit(userId: ID!) */
  customerMoneyRules: Maybe<CustomerMoneyRulesResult>;
  /** @implicit(userId: ID!) */
  device: Maybe<Device>;
  /** @implicit(userId: ID!) */
  devicesByUserId: Maybe<Array<Device>>;
  /** Return the user's direct deposit status */
  directDepositInfo: DirectDepositInfoPayload;
  /** Return the user switches' state */
  directDepositState: DirectDepositStatePayload;
  /** Returns portfolio diversification information for a provided customer */
  diversificationInfoByInvestmentAccountId: Maybe<DiversificationInfo>;
  documentRequest: Maybe<DocumentRequest>;
  documentRequests: Maybe<DocumentRequestsConnection>;
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountClosureReasons: Array<InvestmentAccountClosureReason>;
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountStateRegulation: EarlyAccountStateRegulationResult;
  /** DEPRECATED - Use InvestmentAccountTransferability instead */
  earlyAccountTransferInfo: Maybe<EarlyAccountTransferInfo>;
  /** Get a list of Earn CTA Data */
  earnCTADataByUserId: Maybe<Array<EarnCtaRecord>>;
  /** Retrieve EarnOffer by campaignOfferId with fall back support by campaignId */
  earnOfferByCampaignOfferId: Maybe<EarnOffer>;
  /** Get the reward information associated with investment IDs */
  earnRewardsByInvestmentIds: Maybe<Array<EarnReward>>;
  /** @deprecated Use feature specific eligibility queries. */
  eligibility: Maybe<Eligibility>;
  /** Check for existence of credentials and formatting of input for a given email */
  emailAddressValidation: EmailAddressValidation;
  estimatedCheckPaymentDates: Maybe<EstimatedCheckPaymentDates>;
  /** The estimated clawback match */
  estimatedMatchRemoval: Maybe<MonetaryAmount>;
  estimatedTransferDates: Maybe<EstimatedTransferDatesPayload>;
  /** Fetches stored information about the ETF. */
  etf: Maybe<Etf>;
  /** Evaluates check deposit session to determine if it is submittable. */
  evaluateCheckDeposit: Maybe<EvaluateCheckDepositPayload>;
  /** @implicit(userId: ID!) */
  extoleCampaignHistory: Maybe<ExtoleCampaignHistoryConnection>;
  /** @implicit(userId: ID!) */
  extoleReferralHistory: Maybe<ExtoleReferralHistory>;
  /** Retrieves list of favorite EarnOffers that the user is currently eligible for */
  favoriteEarnOffers: FavoritePartnerOfferGroup;
  /** Returns a personalized list of featured learn content */
  featuredLearnContentPersonalizedByUserId: Maybe<Array<FeaturedLearnContentPreview>>;
  /** @implicit(userId: ID!) */
  featuredMilestones: FeaturedMilestones;
  /**
   * @implicit(userId: ID!)
   * @deprecated This will no longer be used to support the account setup user state, replace with featuredMilestones
   */
  featuredMilestones_v2: Maybe<FeaturedMilestonesV2>;
  /** Fetch a fee given the ID */
  fee: Maybe<Fee>;
  /** Fetch all fees given an argument */
  fees: Maybe<Array<Fee>>;
  financialAdvisorQuestions: FinancialAdvisorQuestionsResponse;
  financialGoalsRecommendation: FinancialGoalsResult;
  /** Fetch a Financial Institution by external ID */
  financialInstitution: Maybe<FinancialInstitution>;
  /** Fetch all Financial Institutions */
  financialInstitutions: FinancialInstitutionTypePagination;
  /** query finish setup information */
  finishSetup: Maybe<FinishSetup>;
  /** Returns acorns footer content */
  footerContent: Maybe<FooterContent>;
  /**
   * Get a list of Found Money rewards
   * @deprecated This has been replaced by foundMoneyRewardsV2
   */
  foundMoneyRewards: Maybe<Array<Maybe<FoundMoneyReward>>>;
  /** Get a list of Found Money rewards */
  foundMoneyRewardsV2: Maybe<Array<EarnReward>>;
  /** Get a summary of all Found Money rewards */
  foundMoneySummary: Maybe<FoundMoneySummary>;
  /**
   * @implicit(userId: ID!)
   * @deprecated Field no longer supported
   */
  friend: Maybe<Friend>;
  /** @implicit(userId: ID!) */
  friendV2: Maybe<FriendV2Output>;
  fundSpendInActivation: Maybe<FundSpendInActivationPayload>;
  /** Fetches a list of funding source(s) for the user */
  fundingSourceAccounts: Maybe<Array<FundingSourceAccount>>;
  /** Get information about a user's primary funding source */
  fundingSourceInfo: Maybe<FundingSourceInfo>;
  /** Generate Updated Base 64 Encoded PDF String */
  generateUpdatedPdf: Maybe<GenerateUpdatedPdfPayload>;
  /** @implicit(userId: ID!) */
  getBillingHistory: Maybe<Array<BillingInvoice>>;
  getPartnerDetails: PartnerDetailsResponse;
  /** @implicit(userId: String!) */
  getPartnerDocumentByUserId: PartnerDocumentUrlResponse;
  /** @implicit(userId: String!) */
  getPartnerUrl: PartnerUrlResponse;
  /** @deprecated No longer in use */
  getUsersBankFromAccountType: Maybe<GetUsersBankFromAccountTypePayload>;
  /** Lookup billing vendor invoice by invoice id */
  getVendorInvoice: Maybe<Invoice>;
  /** Returns help form submission content */
  helpFormContent: Maybe<HelpFormContent>;
  /**
   * Returns helpcenter banner information data
   * @deprecated Replaced with banners query.
   */
  helpcenterBanner: Maybe<HelpcenterBannerResponse>;
  /** Returns instant support articles from search term currently in search field */
  instantSearchSupportArticles: Maybe<Array<Maybe<SearchSupportArticleResult>>>;
  /** @implicit(userId: UUID!) */
  intent: Maybe<Intent>;
  /** @implicit(userId: UUID!) */
  intents: Array<Intent>;
  /** Retrieve an Investment by it's unqiue `id`. */
  investment: Maybe<Investment>;
  /** Fetches an investment account for the authorized user */
  investmentAccount: Maybe<InvestmentAccount>;
  /** Return an investment account by the beneficiary ID */
  investmentAccountByBeneficiaryId: Maybe<InvestmentAccount>;
  /** Get an investment account recap by it's unique id. */
  investmentAccountRecap: Maybe<InvestmentAccountRecap>;
  /** Get an investment account recap by it's unique public token. */
  investmentAccountRecapByPublicToken: Maybe<InvestmentAccountRecap>;
  /** Fetch user's investment accounts */
  investmentAccountsByUserId: Array<InvestmentAccount>;
  /** Returns investments between the provided date range (default is 1 month) for the provided investment account id */
  investmentsByInvestmentAccountId: Maybe<InvestmentPagination>;
  /** Fetch user's referral invitation */
  invitationForUser: Maybe<Referral>;
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  jobAlerts: Maybe<Array<JobAlert>>;
  jobEducationContent: Maybe<Jobs_Education>;
  /** @implicit(userId: String!) */
  jobSearch: Maybe<Array<Jobs_Offer>>;
  /** @implicit(userId: String!) */
  jobSearchPage: Maybe<JobSearchPage>;
  /** @implicit(userId: String!) */
  jobSearchV2: Maybe<Jobs_OfferConnection>;
  /** Fetch later accounts for the provided user */
  laterAccounts: Maybe<Array<Maybe<LaterAccount>>>;
  laterBeneficiaries: Maybe<Array<Maybe<LaterIndividualBeneficiary>>>;
  /**
   * Contribution ability per year; only years in the current "tax window" returned
   * @deprecated Use laterUserContributionAbility
   */
  laterContributionAbility: Maybe<Array<Maybe<ContributionAbility>>>;
  laterContributionHistory: Maybe<Array<ContributionHistoryItem>>;
  laterHistory: Maybe<Array<Maybe<LaterHistoryItem>>>;
  laterUserContributionAbility: Maybe<LaterContributionAbilityResult>;
  /** Returns the Article with given id */
  learnArticle: Maybe<LearnArticle>;
  /** Returns all results that match given term. Results can be filtered and sorted. */
  learnContentBySearchTerm: Maybe<ContentPreviewConnection>;
  /**
   * Returns all results that match given tier. Results can be filtered and sorted.
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  learnContentByTierId: Maybe<ContentPreviewConnection>;
  /** Returns all results that match given topic. Results can be filtered and sorted. */
  learnContentByTopicId: Maybe<ContentPreviewConnection>;
  /** Returns a list of all Learn Hub tiers and topics combined */
  learnContentCategories: Maybe<Array<LearnContentCategory>>;
  /** Returns a list of content previews corresponding the given content ids */
  learnContentPreviewsByContentIds: Maybe<Array<LearnContentPreview>>;
  /** Returns up to 3 recommendations for search terms of at least 3 chars */
  learnContentRecommendationsBySearchTerm: Maybe<Array<LearnContentPreview>>;
  /** Returns recent search terms and popular searches */
  learnContentSearchHistoryByUserId: Maybe<SearchHistory>;
  /** Returns a learn media content or null if one does not exist for the ID */
  learnMedia: Maybe<LearnMedia>;
  /** Returns a list of course next step actions */
  learnNextStepActionsByCourseId: Maybe<Array<LearnNextStepAction>>;
  /** Returns a list of next step actions for the requested media */
  learnNextStepActionsByMediaId: Maybe<Array<LearnNextStepAction>>;
  /** Returns a list of question insights related to the incorrect questions */
  learnQuestionInsightsByQuizId: Maybe<Array<LearnQuestionInsight>>;
  /** Returns a list of learn content for given action feed context */
  learnWidgetContent: Maybe<Array<LearnContentPreview>>;
  /** Fetch a linked account */
  linkedAccount: Maybe<LinkedAccount>;
  /** Fetch alerts for linked account */
  linkedAccountAlerts: Maybe<Array<LinkedAccountAlertsResponse>>;
  /** Fetch webhook URLs */
  linkedAccountWebhooks: Webhooks;
  /** Fetch linked accounts for a given user */
  linkedAccounts: Array<LinkedAccount>;
  /** Fetch a linked subaccount */
  linkedSubaccount: Maybe<LinkedSubaccount>;
  /** Fetch linked subaccounts for a given user */
  linkedSubaccounts: Array<LinkedSubaccount>;
  /** Fetch a liquidation given the ID */
  liquidation: Maybe<Liquidation>;
  /** Fetch all liquidations given an argument */
  liquidations: Maybe<Array<Liquidation>>;
  /** Get a list of all active waiver coupons from the vendor */
  listActiveWaivers: Array<WaiverCoupon>;
  /** @implicit(userId: ID!) */
  listBenefitsByUserId: Maybe<Array<BenefitTileGroup>>;
  /** Retrieve all currently active coupon redemptions for a user */
  listUserWaiverCoupons: Maybe<Array<RedeemedWaiverCoupon>>;
  /** Get information about the stock market (U.S. only) */
  market: Maybe<Market>;
  /** Get a match program by it's id. */
  matchProgram: Maybe<MatchProgram>;
  /** Fetches a message based on a user ID and internal message ID. */
  message: Maybe<Message>;
  /** Fetches a message based on a user ID and external message ID. */
  messageByExternalId: Maybe<Message>;
  /** Fetches messages for a user. Supports pagination (offset/count) and filtering. Make sure an x-client-platform header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  messages: Maybe<MessageConnection>;
  /** @implicit(userId: ID!) */
  milestone: Maybe<Milestone>;
  milestoneAccountLevelDefinitions: Maybe<Array<MilestoneAccountLevelDefinition>>;
  milestoneAchievementActionRule: Maybe<MilestoneAchievementActionRule>;
  milestoneAchievementActionRules: Array<MilestoneAchievementActionRule>;
  milestoneAchievementActionTypes: Array<MilestoneAchievementActionType>;
  /**
   * @implicit(userId: ID!)
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  milestoneChallenge: Maybe<MilestoneChallenge>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRuleByMilestoneIdByChallengeId: Maybe<MilestoneChallengePointsRule>;
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRulesByMilestoneId: Maybe<Array<MilestoneChallengePointsRule>>;
  milestoneDefinition: Maybe<MilestoneDefinition>;
  milestoneDefinitions: Maybe<Array<MilestoneDefinition>>;
  /** @implicit(userId: ID!) */
  milestoneEligibilityByScopes: Maybe<Array<MilestoneEligibility>>;
  milestoneGroupAchievementActionRule: Maybe<MilestoneGroupAchievementActionRule>;
  milestoneGroupAchievementActionRules: Maybe<Array<MilestoneGroupAchievementActionRule>>;
  milestoneGroupDefinition: Maybe<MilestoneGroupDefinition>;
  milestoneGroupDefinitions: Maybe<Array<MilestoneGroupDefinition>>;
  /** @implicit(userId: ID!) */
  milestoneHub: Maybe<MilestoneHub>;
  milestoneHubDefinition: Maybe<MilestoneHubDefinition>;
  milestoneHubDefinitions: Array<MilestoneHubDefinition>;
  /**
   * @implicit(userId: ID!)
   * @deprecated This query was only relevant for the initial rollout of milestone hub, replace with milestoneEligibilityByScopes
   */
  milestoneHubEligible: Maybe<Eligibility>;
  milestoneRules: Maybe<Array<MilestoneRule>>;
  /** @implicit(userId: ID!) */
  milestonesByTheme: Maybe<MilestoneThemeGroup>;
  /** @implicit(userId: ID!) */
  moneyAssignment: Maybe<MoneyManagerMoneyAssignment>;
  /** Get the possible allocation amounts for a given account based off the customers existing rules and any staged rules */
  moneyManagerAllocationOptions: Array<MoneyManagerAllocationOption>;
  /** @implicit(userId: ID!) */
  moneyManagerAllocationsByTransferIds: Maybe<Array<MoneyManagerAllocation>>;
  /** Retrieves the default money manager automation targets for a user based on their income. */
  moneyManagerAutomationTargetDefaults: Array<MoneyManagerAutomationTarget>;
  /** @implicit(userId: ID!) */
  moneyManagerAutomationTargets: Array<MoneyManagerAutomationTarget>;
  /** @implicit(userId: ID!) */
  moneyManagerCascadeObjectives: Array<MoneyManagerCascadeObjective>;
  /** @implicit(userId: ID!) */
  moneyManagerCategories: Maybe<MoneyManagerCategoriesResult>;
  /** @implicit(userId: ID!) */
  moneyManagerDepositHistory: MoneyAssignmentConnection;
  /** @implicit(userId: ID!) */
  moneyManagerEligibility: MoneyManagerEligibilityResult;
  moneyManagerGlobalConfig: MoneyManagerGlobalConfig;
  /** @implicit(userId: ID!) */
  moneyManagerMoneyAssignmentsByReferenceIds: Array<MoneyManagerMoneyAssignment>;
  /** @implicit(userId: ID!) */
  moneyManagerPaychecks: Array<MoneyManagerPaycheck>;
  /** @implicit(userId: ID!) */
  moneyManagerRebalances: MoneyManagerRebalancesResponse;
  /** @implicit(userId: ID!) */
  moneyManagerScheduledDeposits: Array<MoneyManagerScheduledDeposit>;
  /** @implicit(userId: ID!) */
  moneyManagerScheduledPaycheckPerEmployer: Array<Maybe<MoneyManagerScheduledPaycheck>>;
  /** @implicit(userId: ID!) */
  moneyManagerSettings: MoneyManagerSettings;
  /** @implicit(userId: ID!) */
  moneyManagerSummary: Maybe<MoneyManagerSummary>;
  moneyRulesArchetypes: Maybe<MoneyRulesArchetypesResult>;
  /**
   * @implicit(userId: ID!)
   * @deprecated Use moneyManagerSettings instead
   */
  moneyRulesSettings: Maybe<MoneyRulesSettings>;
  /** Fetch the next billing date for a user */
  nextBillingDate: Maybe<NextBillingDate>;
  nextTransferDate: Maybe<NextTransferDateResult>;
  notifications: Maybe<Notifications>;
  /** Fetch a list of occupations */
  occupations: Maybe<Array<Maybe<Occupation>>>;
  offer: Maybe<Offer>;
  /** @implicit(userId: ID!) */
  onboardingBenefits: Maybe<Array<OnboardingTileGroup>>;
  /** Determines requirements that have not been met yet for specific onboarding flow */
  onboardingRequirements: Maybe<Array<OnboardingRequirement>>;
  /** query the account onboarding tips modal */
  onboardingTips: Maybe<OnboardingTips>;
  /** Fetch a code given the code uuid */
  outsideContributionCode: Maybe<OutsideContributionCode>;
  /** Fetch a code given the code string */
  outsideContributionCodeByCode: Maybe<OutsideContributionCode>;
  /** Fetch a code given the investment account id */
  outsideContributionCodeByInvestmentAccountId: Maybe<OutsideContributionCode>;
  /** Base 64 Encoded Parameterized PDF String */
  parameterizedPdf: Maybe<GenerateUpdatedPdfPayload>;
  partnerOfferGroup: Maybe<PartnerOfferGroup>;
  partnerOfferGroupCategories: Maybe<Array<PartnerOfferGroup>>;
  /** @implicit(deviceId: String) */
  partnerOfferGroupsByType: Maybe<Array<PartnerOfferGroup>>;
  passwordResetFormFieldsByToken: Maybe<PasswordResetForm>;
  pastCoreSummary: Maybe<PastCoreSummary>;
  pastEarlySummary: Maybe<PastEarlySummary>;
  pastLaterSummary: Maybe<PastLaterSummary>;
  /** Totals for Spend */
  pastSpendSummary: Maybe<PastSpendSummary>;
  pastSpendTransactionItem: Maybe<PastItem>;
  pastSummary: Maybe<PastSummary>;
  payoutRelationships: Array<Maybe<ReferralPayoutRelationship>>;
  /** PDF Download URL */
  pdfDownloadUrl: Maybe<PdfDownloadUrlPayload>;
  /** @implicit(userId: ID!) */
  pendingMoneyAssignments: Array<MoneyManagerMoneyAssignment>;
  /** @deprecated Calculations have been updated in newer API's. Use InvestmentAccount.performance instead. */
  performance: Maybe<Performance>;
  /** @implicit(userId: String) */
  personalizedEarnOffers: Maybe<Array<EarnOffer>>;
  /** Get personalized offers for a given user */
  personalizedFoundMoney: Maybe<Array<FoundMoneyCampaignV2>>;
  /** Portfolios */
  portfolios: Array<Portfolio>;
  /** Lookup a specific Product by it's unique id. */
  product: Maybe<Product>;
  /** Lookup a specific Product by it's unique key. */
  productByKey: Maybe<Product>;
  /** List all Products. */
  products: Maybe<Array<Product>>;
  /** Fetch a single profile for a user */
  profile: Profile;
  /** @implicit(userId: ID!) */
  promoCodeApplied: Maybe<PromoCode>;
  /**
   * @implicit(userId: ID!)
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  promoMilestoneChallengeId: Maybe<Scalars['ID']>;
  /** @implicit(userId: ID!) */
  promotedBenefitsByUserId: Array<PromotedBenefit>;
  promotedCampaigns: Maybe<PromotedCampaigns>;
  /** @implicit(userId: String) */
  promotedEarnOffers: Maybe<Array<EarnOffer>>;
  /** Lookup a particular promotion by it's unique id. */
  promotion: Maybe<Promotion>;
  /** Get a list of promotions to which a user is eligible. */
  promotionsByUserId: Maybe<Array<Promotion>>;
  /** Returns quiz with given id or null if it does not exists */
  quiz: Maybe<Quiz>;
  /** Fetch the user's recommended portfolio */
  recommendedPortfolio: Maybe<Suitability_Portfolio>;
  /** Get recommended search terms for clients to populate the AI search page with */
  recommendedSearchTerms: Array<Scalars['String']>;
  /** Fetch recurring investment settings for the specified InvestmentAccount (defaults to the authenticated User's Core InvestmentAccount if not specified). */
  recurringInvestmentSettings: Maybe<RecurringInvestmentSettings>;
  /** @implicit(userId: ID!) */
  recurringTransfers: Maybe<Array<Maybe<RecurringTransfer>>>;
  referralCampaignRewards: Maybe<ReferralRewardsConnection>;
  referralCampaigns: Maybe<ReferralCampaignConnection>;
  /** Fetch user's referral */
  referralForUser: Maybe<Referral>;
  /** @implicit(userId: ID!) */
  referralHistory: Maybe<ReferralHistory>;
  referralPayouts: Maybe<ReferralPayoutConnection>;
  referralRelationships: Maybe<ReferralRelationshipConnection>;
  /** @implicit(userId: ID!) */
  registeredAuthenticators: Maybe<Array<Authenticator>>;
  /** Fetches a registration record for a prospective user */
  registration: Result;
  /** Retrieves contextual information to direct user's registration funnel experience */
  registrationFunnel: Maybe<RegistrationFunnel>;
  /** Returns related Course for Article */
  relatedCourseByArticleId: Maybe<Course>;
  /** Returns related Course for Article */
  relatedCourseByArticleId_v2: Maybe<LearnCourse>;
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId: Maybe<Array<CoursePreview>>;
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId_v2: Maybe<Array<LearnCoursePreview>>;
  /** Returns a list of related articles based on primary topic */
  relatedLearnContentByArticleId: Maybe<Array<LearnContentPreview>>;
  /** Returns a list of learn content related to the provided media ID */
  relatedLearnContentByMediaId: Maybe<Array<LearnContentPreview>>;
  /** Returns related Quiz for Course */
  relatedQuizByCourseId: Maybe<Quiz>;
  /** Returns related Quiz for Course */
  relatedQuizByCourseId_v2: Maybe<LearnQuiz>;
  /** Returns a list of 5 quizzes that are contained in courses with similar tags as the given course */
  relatedQuizzesByCourseId: Maybe<Array<QuizPreview>>;
  /** Returns a list of 5 quizzes that are contained in courses with similar tags as the given course */
  relatedQuizzesByCourseId_v2: Maybe<Array<LearnQuizPreview>>;
  remoteStrings: Maybe<Scalars['JSON']>;
  /** Fetch a round up account for a specified linked subaccount */
  roundUpAccount: Maybe<RoundUpAccount>;
  /** List round up accounts for a given user */
  roundUpAccounts: Array<RoundUpAccount>;
  /** Fetch a single round up profile for a user */
  roundUpProfile: Maybe<RoundUpProfile>;
  /** List round ups for a given user */
  roundUps: RoundUpTypePagination;
  sampleMailInDocument: Maybe<SampleMailInDocument>;
  savingsAccountEligibilityByUserId: Maybe<SavingsAccountEligibility>;
  /** @implicit(deviceId: String) */
  searchActiveEarnOffers: EarnOfferQueryPage;
  /** Employer Search */
  searchEmployers: Maybe<SearchEmployersPayload>;
  /** Fuzzy search for securities of the provided types (declared in SearchSecuritiesInput.securityTypes) by symbol and company name. Securities are selected as "candidates" and then ordered by SearchSecuritiesInput.orderby. Results are served using a cursor-based pagination dictated by the page-size SearchSecuritiesInput.limit and the cursor SearchSecuritiesInput.after */
  searchSecurities: Maybe<SearchSecuritiesResponse>;
  /** Returns all relevant support articles and all categories given a query */
  searchSupportArticles: Maybe<SearchSupportResult>;
  /** Search for securities of the provided types (declared in SecuritiesBySectorInput.securityTypes) that are a part of any/all of the provided trading sectors in SecuritiesBySectorInput.sectors. Securities of the requested type that contain 1+ of the provided trading sectors are selected and then ordered by SecuritiesBySectorInput.orderBy. Results are served using a cursor-based pagination dictated by the page-size SecuritiesBySectorInput.limit and the cursor SecuritiesBySectorInput.after. */
  securitiesBySector: Maybe<SecuritiesBySectorResponse>;
  securitiesBySymbols: Maybe<SecuritiesBySymbolsResponse>;
  securityBySymbol: Maybe<Security>;
  securityPerformanceBySymbol: Maybe<SecurityPerformance>;
  /** Provide historical end of day prices for many Securities */
  securityPerformancesBySymbol: Maybe<Array<SecurityPerformance>>;
  settings: Maybe<Settings>;
  /** Fetch a list of signatures for a user */
  signatures: Array<Maybe<Signature>>;
  smartDepositMetadata: Maybe<SmartDepositMetadataResult>;
  /**
   * Pulls all accounts a customer can withdraw from.
   * @deprecated Deprecated, replace with AllAccounts.CustomerAccountsByTransferAction(ONE_TIME_DEPOSIT)
   */
  sourceAccounts: Array<CustomerAccount>;
  spendAccount: Maybe<SpendAccount>;
  spendAlerts: Maybe<Array<Maybe<SpendAlert>>>;
  spendAtms: Maybe<SpendAtmsResult>;
  splitDepositSettings: Maybe<SplitDepositSettings>;
  splitDepositSettingsByUserId: Maybe<Array<SplitDepositSettings>>;
  /** Gets a list of the requesting user's statement documents based on investment account and statement type */
  statements: Maybe<Array<Maybe<Statement>>>;
  subscriptionMigration: Maybe<SubscriptionMigration>;
  subscriptionMigrationWaiver: Maybe<SubscriptionMigrationWaiver>;
  /** @implicit(userId: ID!) */
  subscriptionMigrationWaiversByUserId: Maybe<Array<SubscriptionMigrationWaiver>>;
  /** @implicit(userId: ID!) */
  suggestedMoneyRules: Maybe<SuggestedMoneyRulesResult>;
  /** Fetch all suitability questions and answers */
  suitabilityResponses: Maybe<Array<Suitability_SuitabilityResponse>>;
  /** Return if a client should use suitability service for a particular user */
  suitabilityServiceEnabled: Maybe<Scalars['Boolean']>;
  /** Returns support article given an id */
  supportArticle: Maybe<SupportArticle>;
  /** Returns all articles in section given a sectionId */
  supportArticlesBySectionId: Maybe<Array<Maybe<SupportArticle>>>;
  /** Returns support category given an id */
  supportCategory: Maybe<SupportCategory>;
  /**
   * See if in-app support chat is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail.
   * @deprecated Replaced with more general supportSchedule query.
   */
  supportChatEnabled: Scalars['Boolean'];
  /** Returns most common faq articles if it has been set in Zesty */
  supportMostCommonFaq: Maybe<Array<ContactFaq>>;
  /** See if specified support channel is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail. */
  supportSchedule: Maybe<ScheduleResult>;
  /** Returns support section given an id */
  supportSection: Maybe<SupportSection>;
  /** Returns all support sections by category id */
  supportSectionsByCategoryId: Maybe<Array<Maybe<SupportSection>>>;
  /** Return the given support ticket form by id */
  supportTicketForm: Maybe<SupportTicketForm>;
  supportTicketFormField: Maybe<SupportTicketFormField>;
  /** Returns if a bank is eligible for Plaid Verification. */
  supportsPlaidVerification: SupportsPlaidVerificationResult;
  /**
   * Pulls all accounts a customer can deposit into.
   * @deprecated Deprecated, replace with AllAccounts.CustomerAccountsByTransferAction(ONE_TIME_WITHDRAWAL)
   */
  targetAccounts: Array<CustomerAccount>;
  /** Gets the requesting user's Tax Statements for all of the user accounts for the year provided */
  taxStatementsByTaxYear: StatementPagination;
  /** Lookup a Tier by it's unique id. */
  tier: Maybe<Tier>;
  /**
   * Returns a tier group w/ tiers, products, prices, etc. Can not be tied to
   * a specfic user (needs to support anonymous users).
   * id is optional for case of returning default
   */
  tierGroup: Maybe<TierGroup>;
  /** TierGroup for specific user (includes the Tier they are subscribed to) */
  tierGroupForUser: Maybe<TierGroup>;
  /**
   * Returns the cheapest tier option for a given user's open accounts
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByOpenAccounts: Maybe<TierOption>;
  /**
   * Returns the cheapest tier option for a given product key
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByProductKey: Maybe<TierOption>;
  /**
   * For a given TierPriceId, returns the TierOption associated with that price id.
   * Returns InvalidTierPriceId if the tier price id is not found.
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByTierPriceId: Maybe<TierOptionByTierPriceIdResult>;
  /** Any arbitrary subscription (current or historical) */
  tierSubscription: Maybe<TierSubscription>;
  /** A User's TierSubscription by User.uuid. */
  tierSubscriptionByUserId: Maybe<TierSubscription>;
  /**
   * The current subscription for an arbitrary user
   * @deprecated Use Query.tierSubscriptionByUserId.
   */
  tierSubscriptionForUser: Maybe<TierSubscriptionForUser>;
  /** All of a Users's TierSubscriptions by User.uuid. */
  tierSubscriptionHistoryByUserId: Maybe<TierSubscriptionConnection>;
  /** Show all active tiers */
  tiers: Maybe<Array<Tier>>;
  /** @deprecated Toggles no longer supported. This will always returns true. */
  toggle: Maybe<Toggle>;
  /** Top Employers */
  topEmployers: TopEmployerPayload;
  /**
   * Returns a list of trending content for given tier
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  trendingLearnContentByTierId: Maybe<Array<TrendingLearnContentPreview>>;
  /** Returns a list of trending content for given topic */
  trendingLearnContentByTopicId: Maybe<Array<TrendingLearnContentPreview>>;
  /** Returns a personalized list of trending learn content */
  trendingLearnContentPersonalizedByUserId: Maybe<Array<TrendingLearnContentPreview>>;
  /** Get the currently authenticated user */
  user: Maybe<User>;
  /** An array of the alerts for a user. */
  userAlerts: Maybe<Array<UserAlertsResponse>>;
  /** @implicit(userId: String!) */
  userBenefitsStatus: BenefitsStatusResponse;
  /** Fetch all credentials types for a given user */
  userCredentials: Array<Maybe<UserCredentials>>;
  /** Fetch a single user's external matches */
  userMatches: Array<Maybe<UserMatch>>;
  /** Gets user status with respect to being closed, verified, or registration complete. */
  userStatus: Maybe<UserStatus>;
  /** @implicit(userId: ID!) */
  userTokensByUserId: Array<Maybe<UserToken>>;
  /** Returns user winback score */
  userWinbackScore: Maybe<UserWinbackScoreRes>;
  validatePasswordResetToken: ValidatePasswordResetTokenResult;
  /** @implicit(userId: ID!) */
  verificationProfile: Maybe<VerificationProfile>;
  verifyCheckPaymentRecipientAddress: Maybe<VerifyCheckPaymentRecipientAddressResult>;
  verifyPromoCode: Maybe<VerifyPromoCodeResponse>;
  withholdingDefaults: Maybe<WithholdingDefaults>;
  /** Estimated withholding amounts (only on gains for Roth IRAs) */
  withholdingEstimates: Maybe<WithholdingEstimates>;
  yearLaterReport: YearLaterReport;
};


export type QueryAcceptanceDocumentArgs = {
  type: Scalars['String'];
};


export type QueryAcceptanceDocumentsArgs = {
  requiredFor?: InputMaybe<Scalars['String']>;
};


export type QueryAccountPointsRuleByMilestoneIdArgs = {
  milestoneID: Scalars['ID'];
};


export type QueryAccountStrengthArgs = {
  accountId?: InputMaybe<Scalars['String']>;
};


export type QueryAccountsArgs = {
  status?: InputMaybe<Array<InputMaybe<AccountStatus>>>;
};


export type QueryActionFeedArgs = {
  input?: InputMaybe<ActionCardsInput>;
};


export type QueryActionScreenArgs = {
  screenContext?: InputMaybe<ActionScreenContext>;
};


export type QueryActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
};


export type QueryActivityArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryActivitySummaryArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<ActivitySummaryProduct>;
};


export type QueryAddressDeliverabilityArgs = {
  input: AddressDeliverabilityInput;
};


export type QueryAddressesArgs = {
  addressType?: InputMaybe<AddressType>;
};


export type QueryAllAcceptanceDocumentsArgs = {
  requiredFor?: InputMaybe<Scalars['String']>;
};


export type QueryAllAccountsArgs = {
  filter?: InputMaybe<AllAccountsFilterInput>;
};


export type QueryAllBankAccountsArgs = {
  input: AllBankAccountsInput;
};


export type QueryAllBankCardsArgs = {
  filter?: InputMaybe<AllBankCardsFilter>;
};


export type QueryAllBankDocumentsArgs = {
  input: AllBankDocumentsInput;
};


export type QueryAllBankTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<PageInput>;
};


export type QueryAllCardTrackingStatusesArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllChatHistoryMessagesArgs = {
  pagination: PaginationInput;
};


export type QueryAllCheckPaymentsArgs = {
  pageInput?: InputMaybe<PageInput>;
};


export type QueryAllMessagesArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>;
  statusFilters?: InputMaybe<Array<MessageStatusFilterInput>>;
  typeFilters?: InputMaybe<Array<MessageType>>;
};


export type QueryAllPastCoreItemChildrenArgs = {
  pastItemId: Scalars['ID'];
};


export type QueryAllPastCoreItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AllPastCoreItemsSchemaFilter>;
  pagination?: InputMaybe<PageInput>;
};


export type QueryAllPastEarlyItemsArgs = {
  beneficiaryAccountId: Scalars['String'];
  excludeFees?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AllPastEarlyItemsSchemaFilter>;
  pagination?: InputMaybe<PageInput>;
};


export type QueryAllPastItemsArgs = {
  filter?: InputMaybe<AllPastItemsFilter>;
  pagination?: InputMaybe<PageInput>;
};


export type QueryAllPastLaterItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AllPastLaterItemsSchemaFilter>;
  pagination?: InputMaybe<PageInput>;
};


export type QueryAllPastPendingItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllPastScheduledItemsArgs = {
  filter?: InputMaybe<AllPastScheduledItemsFilter>;
};


export type QueryAllPastScheduledItemsV2Args = {
  filter?: InputMaybe<AllPastScheduledItemsFilterV2>;
};


export type QueryAllPastSpendItemsArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AllPastSpendItemsSchemaFilter>;
  pagination?: InputMaybe<PageInput>;
};


export type QueryAllSupportArticlesArgs = {
  filter?: InputMaybe<AllSupportArticlesFilterInput>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllSupportSectionsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllTransferableToArgs = {
  input: AllTransferableToInput;
};


export type QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs = {
  linkedAccountId: Scalars['ID'];
};


export type QueryBackendJobBatchAutomatedOrdersArgs = {
  filter: BackendJobBatchAutomatedOrdersFilterInput;
};


export type QueryBackendJobBatchMoneyMovementArgs = {
  filter: BackendJobBatchMoneyMovementFilterInput;
};


export type QueryBackendJobBatchOrdersArgs = {
  filter: BackendJobBatchOrdersFilterInput;
};


export type QueryBackendJobBatchProfitStarsArgs = {
  filter: BackendJobBatchProfitStarsFilterInput;
};


export type QueryBackendJobBatchSummaryArgs = {
  filter: BackendJobBatchSummaryFilterInput;
};


export type QueryBankAccountDisclosuresArgs = {
  input: BankAccountDisclosureFilter;
};


export type QueryBankAccountStateArgs = {
  accountType?: InputMaybe<BankAccountType>;
};


export type QueryBankCardProvisioningDetailsArgs = {
  input: BankCardProvisioningDetailsInput;
};


export type QueryBankFeesByUserIdArgs = {
  filter?: InputMaybe<BankFeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  statusFilter?: InputMaybe<Array<InputMaybe<FeeStatusFilter>>>;
};


export type QueryBankInterestRatesArgs = {
  productFilter?: InputMaybe<Array<InputMaybe<BankingProduct>>>;
};


export type QueryBankTransactionArgs = {
  bankAccountType?: InputMaybe<BankAccountType>;
  id: Scalars['ID'];
};


export type QueryBankingFeatureEligibilityArgs = {
  feature: BankingEligibilityFeature;
};


export type QueryBeneficiaryArgs = {
  id: Scalars['ID'];
};


export type QueryBenefitPartnerByUserIdArgs = {
  input: BenefitPartnerInput;
};


export type QueryBillingCycleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBillingCyclesArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>;
};


export type QueryCalculateMoneySplitsArgs = {
  moneySource: MoneyRulesMoneySourceInput;
  overrides?: InputMaybe<MoneyRulesSplitOverridesInput>;
};


export type QueryCampaignHistoryArgs = {
  filter: CampaignHistoryFilter;
  page: ReferralPaginatedFilter;
};


export type QueryChallengesArgs = {
  deliveryType?: InputMaybe<ChallengeDeliveryType>;
};


export type QueryChatHistoryMessagesBySessionIdArgs = {
  pagination: PaginationInput;
  sessionId: Scalars['ID'];
};


export type QueryClosureReasonsByInvestmentAccountTypeArgs = {
  product?: InputMaybe<InvestmentProduct>;
};


export type QueryCohortEligibilityArgs = {
  scopes: Array<CohortEligibilityScope>;
};


export type QueryCohortEligibility_V2Args = {
  filter?: InputMaybe<CohortEligibility_V2FilterInput>;
};


export type QueryCombinedPerformanceByUserIdArgs = {
  days?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<InvestmentAccountsByUserIdFilter>;
};


export type QueryCompletedQuizByQuizIdArgs = {
  quizId: Scalars['ID'];
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
};


export type QueryCourse_V2Args = {
  id: Scalars['ID'];
};


export type QueryCoursesByTierIdArgs = {
  tierId: Scalars['ID'];
};


export type QueryCoursesByTopicIdArgs = {
  topicId: Scalars['ID'];
};


export type QueryCoursesByTopicId_V2Args = {
  topicId: Scalars['ID'];
};


export type QueryCustomerEarnOnboardingProgramArgs = {
  verifiedAt?: InputMaybe<Scalars['DateTime']>;
};


export type QueryDevicesByUserIdArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDiversificationInfoByInvestmentAccountIdArgs = {
  input: DiversificationInfoByInvestmentAccountIdInput;
};


export type QueryDocumentRequestArgs = {
  input: DocumentRequestInput;
};


export type QueryDocumentRequestsArgs = {
  input: DocumentRequestsInput;
};


export type QueryEarlyAccountStateRegulationArgs = {
  stateCode?: InputMaybe<Scalars['String']>;
};


export type QueryEarlyAccountTransferInfoArgs = {
  investmentAccountId: Scalars['ID'];
};


export type QueryEarnOfferByCampaignOfferIdArgs = {
  campaignOfferId: Scalars['String'];
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>;
  origin: Scalars['String'];
  sessionId: Scalars['String'];
};


export type QueryEarnRewardsByInvestmentIdsArgs = {
  investmentIds: Array<Scalars['ID']>;
};


export type QueryEligibilityArgs = {
  eligibilityScope: EligibilityScope;
};


export type QueryEmailAddressValidationArgs = {
  email: Scalars['EmailAddress'];
};


export type QueryEstimatedMatchRemovalArgs = {
  investmentAccountId: Scalars['ID'];
  withdrawalAmount: MonetaryAmountInput;
};


export type QueryEstimatedTransferDatesArgs = {
  input: EstimatedTransferDatesInput;
};


export type QueryEtfArgs = {
  symbol: Scalars['String'];
};


export type QueryEvaluateCheckDepositArgs = {
  input: EvaluateCheckDepositInput;
};


export type QueryExtoleCampaignHistoryArgs = {
  page: ReferralPaginatedFilter;
};


export type QueryFeeArgs = {
  id: Scalars['ID'];
};


export type QueryFeesArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  billingCycleId?: InputMaybe<Scalars['ID']>;
};


export type QueryFinancialGoalsRecommendationArgs = {
  input: FinancialGoalsInput;
};


export type QueryFinancialInstitutionArgs = {
  externalId: Scalars['String'];
  linkable?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFinancialInstitutionsArgs = {
  includeBlacklisted?: InputMaybe<Scalars['Boolean']>;
  includeDirectBank?: InputMaybe<Scalars['Boolean']>;
  pageInput?: InputMaybe<PageInput>;
  q?: InputMaybe<Scalars['String']>;
  supportsAuth?: InputMaybe<Scalars['Boolean']>;
  supportsFunding?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFinishSetupArgs = {
  accountId: Scalars['ID'];
  feedContext: FeedContext;
};


export type QueryFriendArgs = {
  advocateReferralCode?: InputMaybe<Scalars['String']>;
};


export type QueryGenerateUpdatedPdfArgs = {
  input: PdfDownloadUrlInput;
};


export type QueryGetBillingHistoryArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>;
};


export type QueryGetPartnerDetailsArgs = {
  input: PartnerUrlInput;
};


export type QueryGetPartnerDocumentByUserIdArgs = {
  input: PartnerUrlInput;
};


export type QueryGetPartnerUrlArgs = {
  input: PartnerUrlInput;
};


export type QueryGetUsersBankFromAccountTypeArgs = {
  type: BankAccountType;
};


export type QueryGetVendorInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type QueryHelpFormContentArgs = {
  form: HelpFormType;
};


export type QueryInstantSearchSupportArticlesArgs = {
  isPrivate: Scalars['Boolean'];
  query: Scalars['String'];
};


export type QueryIntentArgs = {
  nonce: Scalars['UUID'];
};


export type QueryIntentsArgs = {
  filter: IntentFilterInput;
};


export type QueryInvestmentArgs = {
  id: Scalars['ID'];
};


export type QueryInvestmentAccountArgs = {
  id: Scalars['ID'];
};


export type QueryInvestmentAccountByBeneficiaryIdArgs = {
  beneficiaryId: Scalars['ID'];
};


export type QueryInvestmentAccountRecapArgs = {
  id: Scalars['ID'];
};


export type QueryInvestmentAccountRecapByPublicTokenArgs = {
  publicToken: Scalars['ID'];
};


export type QueryInvestmentAccountsByUserIdArgs = {
  filter?: InputMaybe<InvestmentAccountsByUserIdFilter>;
};


export type QueryInvestmentsByInvestmentAccountIdArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  investmentAccountId: Scalars['ID'];
  pageInput?: InputMaybe<PageInput>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryJobSearchArgs = {
  searchCriteria: JobSearchCriteriaInput;
};


export type QueryJobSearchV2Args = {
  pagination: PageInput;
  saveAsRecentSearch?: InputMaybe<Scalars['Boolean']>;
  searchCriteria: JobSearchCriteriaInput;
};


export type QueryLaterBeneficiariesArgs = {
  investmentAccountId: Scalars['ID'];
};


export type QueryLaterContributionAbilityArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>;
};


export type QueryLaterContributionHistoryArgs = {
  investmentAccountId: Scalars['ID'];
};


export type QueryLaterHistoryArgs = {
  accountId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryLearnArticleArgs = {
  id: Scalars['ID'];
};


export type QueryLearnContentBySearchTermArgs = {
  filter?: InputMaybe<LearnContentFilterInput>;
  pagination: LearnContentPageInput;
  sort?: InputMaybe<LearnContentSortType>;
  term: Scalars['String'];
};


export type QueryLearnContentByTierIdArgs = {
  filter: LearnContentFilterByTierIdInput;
  pagination: LearnContentPageInput;
  sort?: InputMaybe<LearnContentSortType>;
};


export type QueryLearnContentByTopicIdArgs = {
  filter: LearnContentFilterByTopicIdInput;
  pagination: LearnContentPageInput;
  sort?: InputMaybe<LearnContentSortType>;
};


export type QueryLearnContentPreviewsByContentIdsArgs = {
  contentIds: Array<Scalars['ID']>;
};


export type QueryLearnContentRecommendationsBySearchTermArgs = {
  term: Scalars['String'];
};


export type QueryLearnMediaArgs = {
  id: Scalars['ID'];
};


export type QueryLearnNextStepActionsByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type QueryLearnNextStepActionsByMediaIdArgs = {
  mediaId: Scalars['ID'];
};


export type QueryLearnQuestionInsightsByQuizIdArgs = {
  quizId: Scalars['ID'];
};


export type QueryLearnWidgetContentArgs = {
  context: ActionFeedContext;
};


export type QueryLinkedAccountArgs = {
  linkedAccountId: Scalars['ID'];
};


export type QueryLinkedAccountsArgs = {
  externalSources?: InputMaybe<Array<LinkedAccountExternalSourceEnum>>;
  linked?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID'];
};


export type QueryLinkedSubaccountsArgs = {
  linked?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLiquidationArgs = {
  id: Scalars['ID'];
};


export type QueryLiquidationsArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  billingCycleId?: InputMaybe<Scalars['ID']>;
};


export type QueryListBenefitsByUserIdArgs = {
  group?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<BenefitsTrackerProducts>;
};


export type QueryMatchProgramArgs = {
  id: Scalars['ID'];
};


export type QueryMessageArgs = {
  id: Scalars['ID'];
};


export type QueryMessageByExternalIdArgs = {
  externalId: Scalars['ID'];
};


export type QueryMessagesArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>;
  pagination?: InputMaybe<MessagePageInput>;
  statusFilters?: InputMaybe<Array<MessageStatusFilterInput>>;
  typeFilters?: InputMaybe<Array<MessageType>>;
};


export type QueryMilestoneArgs = {
  id: Scalars['ID'];
};


export type QueryMilestoneAchievementActionRuleArgs = {
  milestoneID: Scalars['ID'];
};


export type QueryMilestoneChallengeArgs = {
  id: Scalars['ID'];
};


export type QueryMilestoneChallengePointsRuleByMilestoneIdByChallengeIdArgs = {
  challengeID: Scalars['ID'];
  milestoneID: Scalars['ID'];
};


export type QueryMilestoneChallengePointsRulesByMilestoneIdArgs = {
  milestoneID: Scalars['ID'];
};


export type QueryMilestoneDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryMilestoneEligibilityByScopesArgs = {
  scopes: Array<MilestoneEligibilityScope>;
};


export type QueryMilestoneGroupAchievementActionRuleArgs = {
  milestoneGroupID: Scalars['ID'];
};


export type QueryMilestoneGroupDefinitionArgs = {
  groupID: Scalars['ID'];
};


export type QueryMilestoneHubDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryMilestoneHubEligibleArgs = {
  registrationCompletedAt: Scalars['DateTime'];
};


export type QueryMilestonesByThemeArgs = {
  filter?: InputMaybe<MilestoneByThemeFilterInput>;
  theme: MilestoneTheme;
};


export type QueryMoneyAssignmentArgs = {
  id: Scalars['ID'];
};


export type QueryMoneyManagerAllocationOptionsArgs = {
  input: MoneyManagerAllocationOptionsInput;
};


export type QueryMoneyManagerAllocationsByTransferIdsArgs = {
  transferIds: Array<Scalars['ID']>;
};


export type QueryMoneyManagerCategoriesArgs = {
  input?: InputMaybe<MoneyManagerCategoriesInput>;
};


export type QueryMoneyManagerDepositHistoryArgs = {
  pagination?: InputMaybe<MoneyManagerPageInput>;
};


export type QueryMoneyManagerMoneyAssignmentsByReferenceIdsArgs = {
  referenceIds: Array<Scalars['ID']>;
};


export type QueryMoneyManagerPaychecksArgs = {
  employer?: InputMaybe<Scalars['String']>;
};


export type QueryMoneyRulesArchetypesArgs = {
  input?: InputMaybe<MoneyRulesArchetypesInput>;
};


export type QueryNextTransferDateArgs = {
  recurrenceRule: RecurrenceRuleInput;
};


export type QueryOfferArgs = {
  id: Scalars['ID'];
};


export type QueryOnboardingBenefitsArgs = {
  input?: InputMaybe<OnboardingBenefitsInput>;
};


export type QueryOnboardingRequirementsArgs = {
  onboardingType: OnboardingType;
};


export type QueryOnboardingTipsArgs = {
  feedContext: FeedContext;
};


export type QueryOutsideContributionCodeArgs = {
  id: Scalars['ID'];
};


export type QueryOutsideContributionCodeByCodeArgs = {
  code: Scalars['String'];
};


export type QueryOutsideContributionCodeByInvestmentAccountIdArgs = {
  investmentAccountId: Scalars['ID'];
};


export type QueryParameterizedPdfArgs = {
  input: ParameterizedPdfInput;
};


export type QueryPartnerOfferGroupArgs = {
  filter?: InputMaybe<PartnerOfferGroupFilterInput>;
  id: Scalars['String'];
};


export type QueryPartnerOfferGroupCategoriesArgs = {
  ids: Array<Scalars['ID']>;
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>;
};


export type QueryPartnerOfferGroupsByTypeArgs = {
  partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput;
};


export type QueryPasswordResetFormFieldsByTokenArgs = {
  resetToken: Scalars['String'];
};


export type QueryPastEarlySummaryArgs = {
  beneficiaryAccountId: Scalars['String'];
};


export type QueryPastLaterSummaryArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>;
};


export type QueryPastSpendTransactionItemArgs = {
  accountType?: InputMaybe<BankAccountType>;
  transactionId: Scalars['String'];
};


export type QueryPastSummaryArgs = {
  pastSummaryFilter?: InputMaybe<PastSummaryFilter>;
};


export type QueryPayoutRelationshipsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  payoutId?: InputMaybe<Scalars['ID']>;
  relationshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryPdfDownloadUrlArgs = {
  input: PdfDownloadUrlInput;
};


export type QueryPerformanceArgs = {
  days: Scalars['Int'];
  investmentAccountId?: InputMaybe<Scalars['ID']>;
  start: Scalars['DateTime'];
};


export type QueryPortfoliosArgs = {
  customizedWithSecuritySymbols?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductByKeyArgs = {
  productKey: ProductKey;
};


export type QueryPromotedBenefitsByUserIdArgs = {
  product?: InputMaybe<BenefitsTrackerProducts>;
};


export type QueryPromotionArgs = {
  id: Scalars['ID'];
};


export type QueryPromotionsByUserIdArgs = {
  filter?: InputMaybe<PromotionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryQuizArgs = {
  id: Scalars['ID'];
};


export type QueryRecommendedSearchTermsArgs = {
  category?: InputMaybe<SearchTermCategory>;
};


export type QueryRecurringInvestmentSettingsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>;
};


export type QueryRecurringTransfersArgs = {
  filter?: InputMaybe<RecurringTransfersFilterInput>;
};


export type QueryReferralCampaignRewardsArgs = {
  filter: ReferralPaginatedFilter;
};


export type QueryReferralCampaignsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  filter: ReferralPaginatedFilter;
};


export type QueryReferralPayoutsArgs = {
  filter: ReferralPayoutsFilter;
  page: ReferralPaginatedFilter;
};


export type QueryReferralRelationshipsArgs = {
  filter: ReferralRelationshipsFilter;
  page: ReferralPaginatedFilter;
};


export type QueryRegistrationFunnelArgs = {
  filter: RegistrationFunnelFilter;
};


export type QueryRelatedCourseByArticleIdArgs = {
  articleId: Scalars['ID'];
};


export type QueryRelatedCourseByArticleId_V2Args = {
  articleId: Scalars['ID'];
};


export type QueryRelatedCoursePreviewsByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type QueryRelatedCoursePreviewsByCourseId_V2Args = {
  courseId: Scalars['ID'];
};


export type QueryRelatedLearnContentByArticleIdArgs = {
  articleId: Scalars['ID'];
};


export type QueryRelatedLearnContentByMediaIdArgs = {
  mediaId: Scalars['ID'];
};


export type QueryRelatedQuizByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type QueryRelatedQuizByCourseId_V2Args = {
  courseId: Scalars['ID'];
};


export type QueryRelatedQuizzesByCourseIdArgs = {
  courseId: Scalars['ID'];
};


export type QueryRelatedQuizzesByCourseId_V2Args = {
  courseId: Scalars['ID'];
};


export type QueryRoundUpAccountArgs = {
  linkedSubaccountId: Scalars['ID'];
};


export type QueryRoundUpsArgs = {
  autoInvestable?: InputMaybe<Scalars['Boolean']>;
  instant?: InputMaybe<Scalars['Boolean']>;
  investmentId?: InputMaybe<Scalars['ID']>;
  manual?: InputMaybe<Scalars['Boolean']>;
  pageInput?: InputMaybe<PageInput>;
  state?: InputMaybe<Array<RoundUpState>>;
  targetAccountId?: InputMaybe<Scalars['ID']>;
  transactionDateAfter?: InputMaybe<Scalars['String']>;
  transactionDateBefore?: InputMaybe<Scalars['String']>;
};


export type QuerySampleMailInDocumentArgs = {
  typeFilter: MailInDocumentType;
};


export type QuerySavingsAccountEligibilityByUserIdArgs = {
  type: SavingsAccountType;
};


export type QuerySearchActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
};


export type QuerySearchEmployersArgs = {
  input: SearchEmployersInput;
};


export type QuerySearchSecuritiesArgs = {
  input: SearchSecuritiesInput;
};


export type QuerySearchSupportArticlesArgs = {
  isPrivate: Scalars['Boolean'];
  query: Scalars['String'];
};


export type QuerySecuritiesBySectorArgs = {
  input: SecuritiesBySectorInput;
};


export type QuerySecuritiesBySymbolsArgs = {
  input: SecuritiesBySymbolsInput;
};


export type QuerySecurityBySymbolArgs = {
  input: SecurityBySymbolInput;
};


export type QuerySecurityPerformanceBySymbolArgs = {
  input: SecurityPerformanceBySymbolInput;
};


export type QuerySecurityPerformancesBySymbolArgs = {
  input: SecurityPerformancesBySymbolInput;
};


export type QuerySignaturesArgs = {
  signatureType?: InputMaybe<SignatureType>;
};


export type QuerySmartDepositMetadataArgs = {
  smartDepositMetadataInput: SmartDepositMetadataInput;
};


export type QuerySourceAccountsArgs = {
  filter?: InputMaybe<SourceAccountsFilterInput>;
};


export type QuerySpendAtmsArgs = {
  input: SpendAtmsInput;
};


export type QuerySplitDepositSettingsArgs = {
  id: Scalars['ID'];
};


export type QuerySplitDepositSettingsByUserIdArgs = {
  filter?: InputMaybe<SplitDepositSettingsFilterInput>;
  normalizeToFrequency?: InputMaybe<SplitDepositNormalizationFrequency>;
};


export type QueryStatementsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};


export type QuerySubscriptionMigrationArgs = {
  id: Scalars['ID'];
};


export type QuerySubscriptionMigrationWaiverArgs = {
  id: Scalars['ID'];
};


export type QuerySupportArticleArgs = {
  id: Scalars['ID'];
  isPrivate?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySupportArticlesBySectionIdArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  sectionId: Scalars['ID'];
};


export type QuerySupportCategoryArgs = {
  categoryId: Scalars['ID'];
};


export type QuerySupportScheduleArgs = {
  input: ScheduleInput;
};


export type QuerySupportSectionArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  sectionId: Scalars['ID'];
};


export type QuerySupportSectionsByCategoryIdArgs = {
  categoryId: Scalars['ID'];
  isPrivate?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySupportTicketFormArgs = {
  id: Scalars['ID'];
};


export type QuerySupportTicketFormFieldArgs = {
  id: Scalars['ID'];
};


export type QuerySupportsPlaidVerificationArgs = {
  routingNumber: Scalars['String'];
};


export type QueryTargetAccountsArgs = {
  filter?: InputMaybe<TargetAccountsFilterInput>;
};


export type QueryTaxStatementsByTaxYearArgs = {
  pageInput?: InputMaybe<PageInput>;
  taxYear: Scalars['Int'];
};


export type QueryTierArgs = {
  id: Scalars['ID'];
};


export type QueryTierGroupArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryTierOptionByProductKeyArgs = {
  productKey: ProductKey;
  tierGroupId?: InputMaybe<Scalars['ID']>;
};


export type QueryTierOptionByTierPriceIdArgs = {
  tierPriceId: Scalars['ID'];
};


export type QueryTierSubscriptionArgs = {
  id: Scalars['ID'];
};


export type QueryTierSubscriptionHistoryByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


export type QueryToggleArgs = {
  context?: InputMaybe<Scalars['JSON']>;
  projectId: Scalars['String'];
  toggleId: Scalars['String'];
};


export type QueryTrendingLearnContentByTierIdArgs = {
  tierId: Scalars['ID'];
};


export type QueryTrendingLearnContentByTopicIdArgs = {
  topicId: Scalars['ID'];
};


export type QueryUserBenefitsStatusArgs = {
  benefitProductKey?: InputMaybe<Scalars['String']>;
  tierKey: Scalars['String'];
};


export type QueryUserCredentialsArgs = {
  credentialsType?: InputMaybe<CredentialsType>;
};


export type QueryValidatePasswordResetTokenArgs = {
  resetToken: Scalars['String'];
};


export type QueryVerifyCheckPaymentRecipientAddressArgs = {
  input: VerifyCheckPaymentRecipientAddressInputType;
};


export type QueryVerifyPromoCodeArgs = {
  name: Scalars['String'];
};


export type QueryWithholdingDefaultsArgs = {
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>;
  investmentAccountId: Scalars['ID'];
  withdrawalAmount: CurrencyAmountInput;
};


export type QueryWithholdingEstimatesArgs = {
  federalWithholdingPercentage: Scalars['Float'];
  investmentAccountId: Scalars['ID'];
  reason?: InputMaybe<LaterWithdrawalReason>;
  stateWithholdingPercentage: Scalars['Float'];
  withdrawalAmount: CurrencyAmountInput;
};


export type QueryYearLaterReportArgs = {
  year: Scalars['Int'];
};

export type Quiz = {
  __typename?: 'Quiz';
  authors: Array<LearnAuthor>;
  description: Scalars['String'];
  duration: LearnContentDuration;
  featuredImage: Maybe<LearnVisualAsset>;
  id: Scalars['ID'];
  metadata: LearnMetadata;
  questions: Array<LearnQuestion>;
  theme: QuizTheme;
  /** @deprecated Tier will be removed */
  tier: LearnTier;
  title: Scalars['String'];
  topics: Array<LearnTopic>;
};

export type QuizLocked = {
  __typename?: 'QuizLocked';
  duration: LearnContentDuration;
  featuredImage: Maybe<LearnVisualAsset>;
  id: Scalars['ID'];
  numQuestions: Scalars['Int'];
  productRequired: Scalars['String'];
  title: Scalars['String'];
};

export type QuizPreview = {
  __typename?: 'QuizPreview';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  isCompleted: Scalars['Boolean'];
  primaryTopicName: Scalars['String'];
  productRequired: Maybe<Scalars['String']>;
  progress: Maybe<LearnProgress>;
  quizTheme: QuizTheme;
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String'];
  title: Scalars['String'];
};

export type QuizPreviewLocked = {
  __typename?: 'QuizPreviewLocked';
  contentId: Scalars['ID'];
  contentType: LearnContentType;
  duration: LearnContentDuration;
  featuredImage: LearnVisualAsset;
  lockedReason: Maybe<Scalars['String']>;
  primaryTopicName: Scalars['String'];
  productRequired: Scalars['String'];
  quizTheme: QuizTheme;
  title: Scalars['String'];
};

export type QuizTheme = LearnThemeLiteral;

export type RateLimitDoesNotExistException = {
  __typename?: 'RateLimitDoesNotExistException';
  userId: Maybe<Scalars['ID']>;
};

export type RateLimitStatus = {
  __typename?: 'RateLimitStatus';
  /** The remaining duration of the block in milliseconds */
  challengeBlockDurationRemaining: Maybe<Scalars['Int']>;
  isBlocked: Scalars['Boolean'];
  /** The remaining duration of the block in milliseconds */
  loginBlockDurationRemaining: Maybe<Scalars['Int']>;
};

/** The link token for use in the client created account link URL. */
export type RawLinkSession = {
  __typename?: 'RawLinkSession';
  /** The External ID that should be used in the link creation process. */
  externalId: Scalars['ID'];
  /** The Link Token a client should use for account linking. */
  token: Scalars['String'];
};

/** RDVs are required user alert. */
export type RdvRequiredUserAlert = UserAlertsItem & {
  __typename?: 'RdvRequiredUserAlert';
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** The current funding source must be verified with RDVs prior to linking */
export type RdvVerificationRequired = {
  __typename?: 'RdvVerificationRequired';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** The RDVs were unable to be triggered */
export type RdvsNotTriggered = {
  __typename?: 'RdvsNotTriggered';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type ReadMessageInput = {
  messageId: Scalars['ID'];
};

export type RebalanceAlreadyExecutedError = {
  __typename?: 'RebalanceAlreadyExecutedError';
  customerId: Scalars['ID'];
};

export type RebalanceSourceInsufficientBalanceError = {
  __typename?: 'RebalanceSourceInsufficientBalanceError';
  customerId: Scalars['ID'];
};

export type RecaptchaException = {
  __typename?: 'RecaptchaException';
  errorCodes: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Recommended investing strategy */
export type RecommendedInvestingStrategy = {
  __typename?: 'RecommendedInvestingStrategy';
  accountSubtype: SuitabilityAccountSubtype;
  accountType: SuitabilityAccountType;
  /** Timestamp when recommendation was recorded */
  createdAt: Scalars['DateTime'];
  portfolioId: Maybe<Scalars['ID']>;
};

export type RecordDoesNotExistError = {
  __typename?: 'RecordDoesNotExistError';
  message: Scalars['String'];
};

/** Record view_at for investment account recap. */
export type RecordInvestmentAccountRecapViewInput = {
  /** The unique identifier of the investment account recap for which to update view_at timestamp. */
  investmentAccountRecapId: Scalars['ID'];
};

/** Result of record view_at timestamp for investment account recap. */
export type RecordInvestmentAccountRecapViewResult = InvestmentAccountRecap | InvestmentAccountRecapNotFoundException;

export type RecordReferralEventInput = {
  /** Time Event got Recorded */
  eventRecordedAt?: InputMaybe<Scalars['DateTime']>;
  /** Type of referral event */
  eventType: ReferralEventTypeV2;
  /** Friend who triggered the Event */
  friendId: Scalars['ID'];
  /** subType of the Event */
  subType?: InputMaybe<ReferralEventType>;
};

export type RecordReferralEventResult = QualificationSubTypeMismatchError | ReferralEventV2 | ReferralRelationshipMissingError | RelationshipAlreadyQualifiedError;

export type RecordVendorExternalTransactionInput = {
  amount?: InputMaybe<Scalars['Float']>;
  collectedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<SubscriptionPaymentMethod>;
};

export type RecordVendorExternalTransactionResult = BillingVendorError | Transaction;

export enum RecurrenceFrequency {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule';
  byMonthDay: Maybe<Array<Scalars['Int']>>;
  byWeekDay: Maybe<Array<DayOfWeek>>;
  endDate: Maybe<Scalars['DateTime']>;
  frequency: RecurrenceFrequency;
  interval: Scalars['Int'];
  startDate: Maybe<Scalars['DateTime']>;
};

export type RecurrenceRuleInput = {
  byMonthDay?: InputMaybe<Array<Scalars['Int']>>;
  byWeekDay?: InputMaybe<Array<DayOfWeek>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  frequency: RecurrenceFrequency;
  interval: Scalars['Int'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Input type for recurring investment settings */
export type RecurringInvestmentInput = {
  /** The amount to invest on a recurring basis */
  amount: Scalars['Float'];
  /** The day of the week/month for the recurring investment */
  day: Scalars['Int'];
  /** The frequency of the recurring investment (daily, weekly, monthly) */
  frequency: InvestmentFrequency;
  /** Investment Account ID */
  investmentAccountId?: InputMaybe<Scalars['String']>;
  /** Source Account ID */
  sourceAccountId?: InputMaybe<Scalars['String']>;
};

export type RecurringInvestmentPayload = {
  __typename?: 'RecurringInvestmentPayload';
  recurringInvestmentSettings: RecurringInvestmentSettings;
};

/** Recurring deposit settings for an account */
export type RecurringInvestmentSettings = TimestampsInterface & {
  __typename?: 'RecurringInvestmentSettings';
  amount: Maybe<Scalars['Float']>;
  /** Created at */
  createdAt: Scalars['DateTime'];
  day: Maybe<Scalars['Int']>;
  frequency: Maybe<InvestmentFrequency>;
  /** Investment account ID */
  investmentAccountId: Scalars['ID'];
  /** Next scheduled date of a configured recurring investment. */
  nextInvestmentAt: Maybe<Scalars['Date']>;
  /** Accounts Gateway ID of the account that will be debited for the recurring investment */
  sourceAccountId: Maybe<Scalars['String']>;
  /** Updated at */
  updatedAt: Scalars['DateTime'];
};

export type RecurringTransfer = {
  __typename?: 'RecurringTransfer';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  nextTransferDate: Maybe<Scalars['Date']>;
  recurrenceRule: RecurrenceRule;
  transferEvent: RecurringTransferEvent;
};

export type RecurringTransferAccount = {
  __typename?: 'RecurringTransferAccount';
  id: Scalars['ID'];
  type: RecurringTransferAccountType;
};

export type RecurringTransferAccountIdFilterInput = {
  filter?: InputMaybe<RecurringTransferDirectionFilterInput>;
  targetAccountId: Scalars['ID'];
};

export type RecurringTransferAccountInput = {
  id: Scalars['ID'];
  type: RecurringTransferAccountType;
};

export enum RecurringTransferAccountType {
  SPEND = 'SPEND'
}

export type RecurringTransferDate = {
  __typename?: 'RecurringTransferDate';
  nextTransferDate: Maybe<Scalars['Date']>;
};

export enum RecurringTransferDirection {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL'
}

export type RecurringTransferDirectionFilterInput = {
  direction: RecurringTransferDirection;
};

export type RecurringTransferEvent = {
  __typename?: 'RecurringTransferEvent';
  amount: CurrencyAmount;
  direction: RecurringTransferDirection;
  fundingSource: RecurringTransferFundingSource;
  targetAccount: RecurringTransferAccount;
};

export type RecurringTransferEventInput = {
  amount: CurrencyAmountInput;
  direction: RecurringTransferDirection;
  fundingSource: RecurringTransferFundingSourceInput;
  targetAccount: RecurringTransferAccountInput;
};

export type RecurringTransferFundingSource = {
  __typename?: 'RecurringTransferFundingSource';
  id: Scalars['ID'];
  type: RecurringTransferFundingSourceType;
};

export type RecurringTransferFundingSourceInput = {
  id: Scalars['ID'];
  type: RecurringTransferFundingSourceType;
};

export enum RecurringTransferFundingSourceType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export type RecurringTransferPathException = {
  __typename?: 'RecurringTransferPathException';
  exception: RecurringTransferPathExceptionCase;
  path: Array<Scalars['String']>;
};

export enum RecurringTransferPathExceptionCase {
  BLANK = 'BLANK',
  INVALID_VALUE = 'INVALID_VALUE'
}

export type RecurringTransfersFilterInput = {
  filter?: InputMaybe<RecurringTransferAccountIdFilterInput>;
  targetAccountType: RecurringTransferAccountType;
};

export type RedeemedWaiverCoupon = {
  __typename?: 'RedeemedWaiverCoupon';
  couponId: Maybe<Scalars['String']>;
  discountAmount: Scalars['Float'];
  discountType: Scalars['String'];
  waiverPeriodEndDate: Scalars['String'];
  waiverType: Scalars['String'];
};

/** Fetch a referral */
export type Referral = {
  __typename?: 'Referral';
  code: Scalars['String'];
  referreeRewardAmount: Scalars['Float'];
  referrerRewardAmount: Scalars['Float'];
  url: Scalars['String'];
};

/** Object with friend campaign information such as completed events and reward statuses */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign';
  /** The email of the advocate participating in the campaign */
  advocateEmail: Scalars['String'];
  /**
   * Advocate Reward for completing all necessary steps. The object assumes that the
   * advocateUserId on type ReferralCampaign is the user that will receive the reward, but
   * friends can potentially have multiple advocates. Further investigation may be required.
   */
  advocateRewards: Maybe<Array<ReferralReward>>;
  /** The id of the advocate participating in the campaign */
  advocateUserId: Maybe<Scalars['ID']>;
  /** The id of the referral campaign that is also associated with the campaign id in Extole */
  campaignId: Scalars['ID'];
  /** A list of events and their statuses to earn reward */
  events: Maybe<Array<ReferralEvent>>;
  /** The email of the friend participating in the campaign */
  friendEmail: Scalars['String'];
  /** Friend Reward for completing all necessary steps */
  friendRewards: Maybe<Array<ReferralReward>>;
  /** The id of the friend participating in the campaign */
  friendUserId: Maybe<Scalars['ID']>;
  /** The name of the campaign */
  name: Maybe<Scalars['String']>;
};

export type ReferralCampaignConnection = {
  __typename?: 'ReferralCampaignConnection';
  autoAddCampaignId: Maybe<Scalars['ID']>;
  edges: Maybe<Array<ReferralCampaignEdge>>;
  fallbackCampaignId: Maybe<Scalars['ID']>;
  pageInfo: ReferralPaginatedInfo;
};

export type ReferralCampaignEdge = {
  __typename?: 'ReferralCampaignEdge';
  cursor: Scalars['String'];
  node: ReferralCampaignV2;
};

export type ReferralCampaignReward = {
  __typename?: 'ReferralCampaignReward';
  amount: Scalars['Float'];
  hurdle: Scalars['Int'];
  id: Scalars['ID'];
  repeated: Scalars['Boolean'];
  targets: Array<ReferralCampaignRewardTarget>;
  type: ReferralCampaignRewardType;
};

export enum ReferralCampaignRewardTarget {
  ADVOCATE = 'ADVOCATE',
  FRIEND = 'FRIEND'
}

export enum ReferralCampaignRewardType {
  INVESTMENT = 'INVESTMENT',
  OTHER = 'OTHER'
}

export type ReferralCampaignV2 = {
  __typename?: 'ReferralCampaignV2';
  actionFeedDesc: Maybe<Scalars['String']>;
  activeInHouseCampaign: Maybe<Scalars['Boolean']>;
  autoAdd: Scalars['Boolean'];
  background: Scalars['String'];
  condensedTitle: Maybe<Scalars['String']>;
  description: Scalars['String'];
  eligibilityEnd: Maybe<Scalars['DateTime']>;
  fallback: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  icon: Scalars['String'];
  id: Maybe<Scalars['ID']>;
  internalMemo: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  publishEnd: Maybe<Scalars['DateTime']>;
  publishStart: Scalars['DateTime'];
  publishedStatus: Maybe<PublishedCampaignStatus>;
  qa: Scalars['Boolean'];
  qualificationAction: Scalars['String'];
  qualificationAmount: Scalars['Int'];
  rewards: Array<ReferralCampaignReward>;
  status: CampaignStatus;
  title: Scalars['String'];
};

/** Object containing status of event associated with a Referral */
export type ReferralEvent = {
  __typename?: 'ReferralEvent';
  /** Date event was completed if status is 'COMPLETED' */
  dateCompleted: Maybe<Scalars['DateTime']>;
  /**
   * Referral event nonce
   * @deprecated Field no longer supported
   */
  referralEventId: Maybe<Scalars['String']>;
  /** Type of referral event */
  referralEventType: ReferralEventType;
  /** Status based on activity of friend */
  status: ReferralEventStatus;
};

/** input type specifying the parameters to create an event */
export type ReferralEventInput = {
  eventDetails?: InputMaybe<Scalars['JSON']>;
  eventNonce?: InputMaybe<Scalars['ID']>;
  eventType: ReferralEventType;
  userId: Scalars['String'];
};

/** Status of referral events */
export enum ReferralEventStatus {
  /** Friend has completed event */
  COMPLETED = 'COMPLETED',
  /** Friend has not started or completed event */
  NOT_STARTED = 'NOT_STARTED',
  /** Friend has initiated event but event has not fully processed */
  PENDING = 'PENDING'
}

/** Descriptions of User actions needed to earn reward */
export enum ReferralEventType {
  /** User has made a transfer into a Spend Account */
  DEPOSIT_SPEND = 'DEPOSIT_SPEND',
  /** User has opened an Early account */
  EARLY_ACCOUNT_OPENED = 'EARLY_ACCOUNT_OPENED',
  /** User has a funding source linked */
  FS_LINKED = 'FS_LINKED',
  /** User has made initial investment into core account */
  INVEST_CORE = 'INVEST_CORE',
  /** User has made initial investment into early account */
  INVEST_EARLY = 'INVEST_EARLY',
  /** User has made initial investment into later account */
  INVEST_LATER = 'INVEST_LATER',
  /** User has opened a Later account */
  LATER_ACCOUNT_OPENED = 'LATER_ACCOUNT_OPENED',
  /** User has signed the referral agreement */
  REFERRAL_AGREEMENT_SIGNED = 'REFERRAL_AGREEMENT_SIGNED',
  /** User has completed registration */
  REGISTRATION_COMPLETED = 'REGISTRATION_COMPLETED',
  /** User has initialized the registration process */
  SIGNED_UP = 'SIGNED_UP',
  /** User has opened a Spend account */
  SPEND_ACCOUNT_OPENED = 'SPEND_ACCOUNT_OPENED',
  /** User has paid their subscription */
  SUBSCRIPTION_PAID = 'SUBSCRIPTION_PAID',
  /** Unknown referral event type */
  UNKNOWN = 'UNKNOWN',
  /** User has been verified */
  USER_VERIFIED = 'USER_VERIFIED'
}

/** Descriptions of Friend Events */
export enum ReferralEventTypeV2 {
  /** User has made initial investment */
  FIRST_HOLDINGS_CREATED = 'FIRST_HOLDINGS_CREATED',
  /** User has completed registration */
  USER_REGISTRATION_COMPLETED = 'USER_REGISTRATION_COMPLETED'
}

/** Object containing status of event associated with a Referra In-house platform */
export type ReferralEventV2 = {
  __typename?: 'ReferralEventV2';
  /** Advocate who is associated the Event */
  advocateId: Scalars['ID'];
  /** Campaign associated the Event */
  campaignId: Scalars['ID'];
  /** Time Event got Created */
  created: Scalars['DateTime'];
  /** Is it an Eligible Event */
  eligible: Scalars['Boolean'];
  /** Time Event got Recorded */
  eventRecordedAt: Maybe<Scalars['DateTime']>;
  /** Type of referral event */
  eventType: ReferralEventTypeV2;
  /** Friend who triggered the Event */
  friendId: Scalars['ID'];
  /** Referral event Id */
  id: Scalars['ID'];
  /** Relationship associated the Event */
  relationshipId: Scalars['ID'];
};

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistory = {
  __typename?: 'ReferralHistory';
  friendHistory: Maybe<FriendHistoryConnection>;
  friendSummary: Maybe<Array<FriendSummary>>;
  /** The number of completed referrals for a user */
  numCompletedReferrals: Maybe<Scalars['Int']>;
  /** The number of status pending referrals for a user */
  numPendingReferrals: Maybe<Scalars['Int']>;
  /** The total monetary reward amount the user has earned */
  totalReferralRewardsEarned: Maybe<CurrencyAmount>;
  userId: Maybe<Scalars['ID']>;
};


/** Object that holds referral statistics for an Acorns User */
export type ReferralHistoryFriendHistoryArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  filter: ReferralPaginatedFilter;
};

export type ReferralPaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']>;
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ReferralPaginatedInfo = {
  __typename?: 'ReferralPaginatedInfo';
  /** Cursor corresponding to the last node in the list of edges */
  endCursor: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean'];
  /** Cursor corresponding to the first node in the list of edges */
  startCursor: Maybe<Scalars['String']>;
};

export type ReferralPayout = {
  __typename?: 'ReferralPayout';
  advocateId: Maybe<Scalars['ID']>;
  advocateOfferId: Maybe<Scalars['String']>;
  campaign: Maybe<ReferralCampaignV2>;
  created: Maybe<Scalars['DateTime']>;
  friendId: Maybe<Scalars['ID']>;
  friendOfferId: Maybe<Scalars['String']>;
  payoutId: Scalars['ID'];
  reason: Maybe<Scalars['String']>;
  reward: Maybe<ReferralCampaignReward>;
  status: Maybe<ReferralPayoutStatus>;
  statusChangeAt: Maybe<Scalars['DateTime']>;
  statusChangeBy: Maybe<Scalars['String']>;
  updated: Maybe<Scalars['DateTime']>;
};

export type ReferralPayoutConnection = {
  __typename?: 'ReferralPayoutConnection';
  edges: Maybe<Array<ReferralPayoutEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type ReferralPayoutEdge = {
  __typename?: 'ReferralPayoutEdge';
  cursor: Scalars['String'];
  node: ReferralPayout;
};

export type ReferralPayoutExistsError = {
  __typename?: 'ReferralPayoutExistsError';
  message: Scalars['String'];
};

export type ReferralPayoutRelationship = {
  __typename?: 'ReferralPayoutRelationship';
  advocateId: Maybe<Scalars['ID']>;
  archived: Maybe<Scalars['Boolean']>;
  created: Maybe<Scalars['DateTime']>;
  friendId: Maybe<Scalars['ID']>;
  payoutId: Scalars['ID'];
  payoutRelationshipId: Maybe<Scalars['ID']>;
  relationshipId: Scalars['ID'];
};

export enum ReferralPayoutStatus {
  /** Only Advocate among multi-targets is rewarded */
  ADVOCATE_ONLY_REWARDED = 'ADVOCATE_ONLY_REWARDED',
  /** Payout has met the hurdle in the holdout period */
  APPROVED = 'APPROVED',
  /** Payout have been Cancelled or Paid outside the Automated system */
  CANCELLED = 'CANCELLED',
  /** Payout has been disqualified due to validation check fails */
  DISQUALIFIED = 'DISQUALIFIED',
  /** Payout have expired as the eligibility end date passed for disqualified payout */
  EXPIRED = 'EXPIRED',
  /** Only Friend among multi-targets is rewarded */
  FRIEND_ONLY_REWARDED = 'FRIEND_ONLY_REWARDED',
  /** Payout have been sent for fulfillment */
  FULFILLED = 'FULFILLED',
  /** Payout started the process for fulfillment */
  FULFILLING = 'FULFILLING',
  /** Payout has been created, but hurdle not met yet */
  PENDING = 'PENDING',
  /** Payout has been rejected manually (not used) */
  REJECTED = 'REJECTED',
  /** All target rewarded are invested */
  REWARDED = 'REWARDED',
  /** All target rewards failed to be invested */
  REWARD_FAILED = 'REWARD_FAILED'
}

export type ReferralPayoutsFilter = {
  advocateId?: InputMaybe<Scalars['ID']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  displayCancelled?: InputMaybe<Scalars['Boolean']>;
  payoutId?: InputMaybe<Scalars['ID']>;
  statusList?: InputMaybe<Array<ReferralPayoutStatus>>;
};

export type ReferralRelationship = {
  __typename?: 'ReferralRelationship';
  advocateId: Scalars['ID'];
  campaignId: Scalars['ID'];
  friendId: Scalars['ID'];
  status: ReferralRelationshipStatus;
  statusChangeAt: Maybe<Scalars['DateTime']>;
};

export type ReferralRelationshipConnection = {
  __typename?: 'ReferralRelationshipConnection';
  edges: Maybe<Array<ReferralRelationshipEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export type ReferralRelationshipEdge = {
  __typename?: 'ReferralRelationshipEdge';
  cursor: Scalars['String'];
  node: ReferralRelationship;
};

export type ReferralRelationshipMissingError = {
  __typename?: 'ReferralRelationshipMissingError';
  message: Scalars['String'];
};

/** Status of referral relationship */
export enum ReferralRelationshipStatus {
  /** Relationship has been created */
  CREATED = 'CREATED',
  /** Relationship is eligible for payout */
  ELIGIBLE = 'ELIGIBLE',
  /** Relationship payout has been fulfilled */
  FULFILLED = 'FULFILLED',
  /** Relationship is ineligible for payout */
  INELIGIBLE = 'INELIGIBLE',
  /** Friend has completed first inevestment */
  INVESTED = 'INVESTED',
  /** Friend has completed registration */
  REGISTERED = 'REGISTERED',
  /** Friend should reinvest since old investement do not qualify */
  REINVEST_NEEDED = 'REINVEST_NEEDED',
  /** Friend was rewarded */
  REWARDED = 'REWARDED',
  /** Friend reward investment failed - Advocate might have still been rewarded */
  REWARD_FAILED = 'REWARD_FAILED'
}

export type ReferralRelationshipsFilter = {
  friendId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<ReferralRelationshipStatus>;
};

/** Object containing reward information for completing a campaign */
export type ReferralReward = {
  __typename?: 'ReferralReward';
  /** Name of the referral reward */
  name: Maybe<Scalars['String']>;
  /** The date the reward was fulfilled (if applicable) */
  rewardFulfilledAtDate: Maybe<Scalars['DateTime']>;
  /** The status of the reward associated with activity campaign */
  rewardStatus: Maybe<ReferralRewardStatus>;
  /** Value of reward for completing all events in a campaign */
  value: Scalars['String'];
  /** Value type for completing all events in a campaign */
  valueType: Maybe<ReferralValueType>;
};

export type ReferralRewardEdge = {
  __typename?: 'ReferralRewardEdge';
  cursor: Scalars['String'];
  node: ReferralCampaignReward;
};

/** The current status of a referral reward */
export enum ReferralRewardStatus {
  /** User has earned reward by completing all campaign steps, but reward still needs to be issued. */
  EARNED = 'EARNED',
  /** Reward has been issued by Acorns */
  FULFILLED = 'FULFILLED',
  /** Reward has not been created */
  NOT_CREATED = 'NOT_CREATED'
}

/** Summary of updated reward */
export type ReferralRewardSummary = {
  __typename?: 'ReferralRewardSummary';
  /** The Acorns User acting as an advocate for this referral reward */
  advocateUserId: Maybe<Scalars['ID']>;
  /** Status of this referral for Friend/Acorns User */
  status: ReferralRewardStatus;
};

export enum ReferralRewardUpdateStatus {
  /** Referral has been cancelled */
  CANCELLED = 'CANCELLED',
  /** User and Friend have been rewarded */
  REWARDED = 'REWARDED'
}

export type ReferralRewardsConnection = {
  __typename?: 'ReferralRewardsConnection';
  edges: Maybe<Array<ReferralRewardEdge>>;
  pageInfo: ReferralPaginatedInfo;
};

export enum ReferralStatus {
  /** Referral has been cancelled */
  CANCELLED = 'CANCELLED',
  /** User and Friend have completed referral and should be rewarded */
  COMPLETED = 'COMPLETED',
  /** Referral has expired because events were not finished before campaign end date */
  EXPIRED = 'EXPIRED',
  /** Friend has used referral code but still has events they need to complete */
  PENDING = 'PENDING',
  /** User and Friend have been rewarded */
  REWARDED = 'REWARDED',
  /** Referral has been sent to a friend */
  SENT = 'SENT'
}

/** input type specifyig the parameters that can be updated */
export type ReferralUserUpdateInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Value types of reward associated with completion of a referral */
export enum ReferralValueType {
  USD = 'USD'
}

export type RefreshAuthTokenInput = {
  pin?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

export type RefreshAuthTokenRateLimitedException = {
  __typename?: 'RefreshAuthTokenRateLimitedException';
  message: Maybe<Scalars['String']>;
};

export type RefreshAuthTokenResult = AuthSession | InvalidPinException | RefreshAuthTokenRateLimitedException | TokenExpiredException | UserSuspendedException;

export type RefreshTokenNotFoundException = {
  __typename?: 'RefreshTokenNotFoundException';
  userId: Scalars['ID'];
};

export type RefundBankAccount = {
  __typename?: 'RefundBankAccount';
  accountNickname: Maybe<Scalars['String']>;
  accountNumber: Maybe<Scalars['String']>;
  accountType: Maybe<Scalars['String']>;
};

/** Configuration for regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenInput = {
  /** The unique identifier of the investment account recap for which a public token is being regenerated. */
  id: Scalars['ID'];
};

/** Result of regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenResult = InvestmentAccountRecap | InvestmentAccountRecapNotFoundException;

export type RegisterAccountTypeResult = RegisterAccountTypeResultTemporaryImpl;

export type RegisterAccountTypeResultTemporaryImpl = {
  __typename?: 'RegisterAccountTypeResultTemporaryImpl';
  someField: Scalars['String'];
};

export type RegisterCredentialsInput = {
  acceptanceDocumentVersionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email: Scalars['EmailAddress'];
  password: Scalars['String'];
  udid: Scalars['String'];
  usResident?: InputMaybe<Scalars['Boolean']>;
};

export type RegisterCredentialsResult = AuthSession | EmailTakenException | InvalidPasswordException | MissingRequiredAgreementsException;

export type RegisterDeviceTokenAndPushAuthenticatorInput = {
  deviceId: Scalars['ID'];
  deviceToken: Scalars['String'];
  deviceType: DeviceType;
  name?: InputMaybe<Scalars['String']>;
};

export type RegisterDeviceTokenAndPushAuthenticatorResult = InvalidDeviceParametersException | PushAuthenticator | PushAuthenticatorAlreadyExistsException;

export type RegisterEmailAuthenticatorInput = {
  email: Scalars['EmailAddress'];
  name?: InputMaybe<Scalars['String']>;
  setDefault?: InputMaybe<Scalars['Boolean']>;
};

export type RegisterEmailAuthenticatorResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthenticatorTypeAlreadyRegisteredException | EmailAuthenticator | ExistingEmailVerifiedException;

/** Returns Layer session information */
export type RegisterLayerLinkSessionResult = LayerLinkSession | UnrecoverableError;

/** Returns a Linked Account Type or AsyncLinkSessionResult. */
export type RegisterLinkSessionResult = AsyncLinkSessionResult | LinkedAccount;

export type RegisterOidcCredentialsInput = {
  /** Identity token signed by external Oidc provider */
  idToken: Scalars['String'];
  /** Nonce used in the request to prevent replay attacks. */
  nonce: Scalars['String'];
  oidcProvider: OidcProvider;
  /** A unique identifier representing the Device the client is running on. */
  udid: Scalars['String'];
};

export type RegisterOidcCredentialsResult = AuthSession | EmailTakenException | InvalidAppleAccountException | InvalidCredentialsException | InvalidGoogleAccountException | UserSuspendedException | ValidateCredentialsSuccess;

export type RegisterPhoneAuthenticatorInput = {
  name?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['PhoneNumber'];
  setDefault?: InputMaybe<Scalars['Boolean']>;
};

export type RegisterPhoneAuthenticatorResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthenticatorTypeAlreadyRegisteredException | InvalidPhoneNumberException | PhoneAuthenticator;

export type RegisterPhoneAuthenticatorWithoutChallengeResult = InvalidPhoneNumberException | PhoneAuthenticator;

/** Input for the registerProspect mutation initially registering a prospect user. */
export type RegisterProspectInput = {
  /** Flag indicating if source identifier can be overridden or not */
  amendableSource?: InputMaybe<Scalars['Boolean']>;
  /** Email address for prospect used during initial sign-up */
  email?: InputMaybe<Scalars['String']>;
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: SourceAttributesInput;
};

/** Union for the result of the registerProspect mutation */
export type RegisterProspectResult = InvalidConversionIdentifierException | InvalidSourceAttributesException | RegistrationFunnel;

/** Properties for displaying drawer content on page */
export type RegistrationDrawerContent = {
  __typename?: 'RegistrationDrawerContent';
  body: Scalars['String'];
  image: Scalars['URL'];
  title: Scalars['String'];
};

/** Information about funnel experience */
export type RegistrationFunnel = {
  __typename?: 'RegistrationFunnel';
  /** List of pages within funnel */
  flow: Array<RegistrationPage>;
  /** User's funnel information */
  metadata: FunnelMetadata;
  sourceAttributes: SourceAttributes;
};

/** Available fields to filter for a specific user's funnel experience */
export type RegistrationFunnelFilter = {
  /** Email address for prospect that was used during initial sign up */
  email?: InputMaybe<Scalars['String']>;
  /** User's unique identifier */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Registration fields */
export type RegistrationInput = {
  /** The entry point for a registration */
  funnel: Funnel;
};

/** Single page within registration flow */
export type RegistrationPage = {
  __typename?: 'RegistrationPage';
  actions: Array<RegistrationPageAction>;
  content: Maybe<RegistrationPageContent>;
  isBackEnabled: Scalars['Boolean'];
  name: PageName;
};

/** CTAs that can be performed on the page */
export type RegistrationPageAction = {
  __typename?: 'RegistrationPageAction';
  /** Page that CTA will route to */
  nextPage: PageName;
  type: ActionType;
};

/** Base interface for registration page components */
export type RegistrationPageContent = {
  campaignId: Scalars['String'];
  title: Scalars['String'];
};

/** Properties for displaying banner on page */
export type RegistrationProminenceBannerContent = RegistrationPageContent & {
  __typename?: 'RegistrationProminenceBannerContent';
  campaignId: Scalars['String'];
  drawer: Maybe<RegistrationDrawerContent>;
  icon: Scalars['URL'];
  title: Scalars['String'];
};

export type ReinitiateSmsChallengeInput = {
  challengeId: Scalars['ID'];
};

export type ReinitiateSmsChallengeResult = AuthChallengeExpiredException | ChallengeRateExceededException | EmailAuthChallenge | PhoneNumberOptedOutException | SmsAuthChallenge;

/** The reason why the reinvestment was created */
export enum ReinvestmentReason {
  /** Reinvestment was created due to a debit overselling than what was requested */
  OVERSELL = 'OVERSELL'
}

export type ReissueBankCardEligibility = ReissueBankCardEligible | ReissueBankCardIneligible;

export type ReissueBankCardEligible = {
  __typename?: 'ReissueBankCardEligible';
  originalCardCreatedAt: Scalars['Date'];
};

export type ReissueBankCardExistsError = {
  __typename?: 'ReissueBankCardExistsError';
  /** BankCardRequest id / new bank card id */
  id: Scalars['ID'];
};

export type ReissueBankCardIneligible = {
  __typename?: 'ReissueBankCardIneligible';
  issues: Array<Maybe<ReissueBankCardIneligibleIssue>>;
};

export enum ReissueBankCardIneligibleIssue {
  ACTIVE_BANK_CARD_REQUEST = 'ACTIVE_BANK_CARD_REQUEST',
  CARD_ADMIN_LOCKED = 'CARD_ADMIN_LOCKED',
  FIRST_CARD_NOT_ISSUED_YET = 'FIRST_CARD_NOT_ISSUED_YET'
}

export type ReissueBankCardInput = {
  mailingAddress: BankCardRequestMailingAddressInput;
  reason: BankCardRequestReason;
  reasonComment?: InputMaybe<Scalars['String']>;
  reasonDate?: InputMaybe<Scalars['Date']>;
};

export type ReissueBankCardResult = BankCardRequest | ReissueBankCardExistsError;

export enum RejectedReason {
  documentExpired = 'documentExpired',
  incorrectDocumentType = 'incorrectDocumentType',
  incorrectName = 'incorrectName',
  invalidResidentialAddress = 'invalidResidentialAddress',
  mismatchedName = 'mismatchedName',
  missingName = 'missingName',
  noVisibleDate = 'noVisibleDate',
  notEligibleForPromotion = 'notEligibleForPromotion',
  poorImageQuality = 'poorImageQuality',
  ssnAlreadyUsed = 'ssnAlreadyUsed'
}

export type RelationshipAlreadyQualifiedError = {
  __typename?: 'RelationshipAlreadyQualifiedError';
  message: Scalars['String'];
};

/** Relink Linked Account Alert. */
export type RelinkLinkedAccountAlert = UserAlertsItem & {
  __typename?: 'RelinkLinkedAccountAlert';
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export type RemoveAccountTypeResult = RemoveAccountTypeResultTemporaryImpl;

export type RemoveAccountTypeResultTemporaryImpl = {
  __typename?: 'RemoveAccountTypeResultTemporaryImpl';
  someField: Scalars['String'];
};

/** Input for removing cohorts */
export type RemoveCohortEligibilityInput = {
  /** List of cohort slugs to remove */
  remove: Array<Scalars['String']>;
};

/** Removed Cohorts Result */
export type RemoveCohortEligibilityResult = UserCohorts;

export type RemoveJobAlertResult = RemovedJobAlert;

export type RemovePolicyInput = {
  name: Scalars['String'];
};

export type RemovePolicyResult = PoliciesRecordDoesNotExistException | ValidPolicies;

/** Input to remove a security from a portfolio */
export type RemoveSecurityFromPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID'];
  /** The market exchange symbol of the ETF to remove from the portfolio */
  symbol: Scalars['String'];
};

/** Result from removing a security from a portfolio */
export type RemoveSecurityFromPortfolioResult = InvestmentAccountNotFoundException | InvestmentAccountNotSupportedException | Portfolio | PortfolioNotFoundException | PortfolioNotSupportedException | SecurityNotSupportedException;

/** Remove self directed portfolio from an investment account closure request */
export type RemoveSelfDirectedPortfolioInput = {
  /** List of closure reason keys */
  accountClosureReasons?: InputMaybe<Array<Scalars['String']>>;
  /** Any closure reason comments the user may have */
  comments?: InputMaybe<Scalars['String']>;
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID'];
};

/** Self Directed Portfolio Closure Response */
export type RemoveSelfDirectedPortfolioResult = AccountNotFoundException | InvestmentAccount | InvestmentAccountAlreadyClosed | InvestmentAccountClosureInProgress | PortfolioAlreadyRemovedError | PortfolioNotFoundException | PortfolioRemovalInProgressError;

/** Indicates remove operation succeeded */
export type RemovedJobAlert = {
  __typename?: 'RemovedJobAlert';
  id: Scalars['ID'];
};

/** Reopen User Account Response */
export type ReopenUserAccountResult = UserNotFoundException | UserReopenLockedException | UserReopenSuspendedException | User_V2;

export type ReplayMoneyAssignmentError = {
  __typename?: 'ReplayMoneyAssignmentError';
  error: Scalars['String'];
};

export type ReplayMoneyAssignmentSuccess = {
  __typename?: 'ReplayMoneyAssignmentSuccess';
  moneyAssignmentId: Scalars['ID'];
};

export type ReplayMoneyManagerMoneyAssignmentInput = {
  forceReallocate: Scalars['Boolean'];
  moneyAssignmentId: Scalars['ID'];
  transferDelayInMilliseconds: Scalars['Int'];
};

export type ReplayMoneyManagerMoneyAssignmentResult = ReplayMoneyAssignmentError | ReplayMoneyAssignmentSuccess;

export type ReportBankCardLostStolenInput = {
  lockReason: BankCardPermanentLockReason;
};

export type ReportBankCardLostStolenPayload = {
  __typename?: 'ReportBankCardLostStolenPayload';
  bankCard: Maybe<BankCard>;
};

export type RequestAccountClosureInput = {
  comments?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
};

/** Input for closing an early investment account */
export type RequestEarlyAccountClosureInput = {
  /** The ID's of the early accounts to be closed */
  investmentAccountIds: Array<Scalars['ID']>;
  /** The reason for the account closure */
  reason: InvestmentAccountClosureReason;
};

/** Result from closing an Investment Account */
export type RequestEarlyAccountClosureResult = AccountAlreadyClosedException | ClosureRequestExistsException | FundingSourceRequiresRdvException | InternalErrorException | InvalidAccountTypeException | InvestmentAccount | InvestmentAccountNeedsTransferException | MissingFundingSourceException;

/** Input for requesting to reopen an investment account */
export type RequestInvestmentAccountReopenInput = {
  /** The ID of the investment account to be reopened */
  investmentAccountId: Scalars['ID'];
};

/** Result from requesting to reopen an investment account */
export type RequestInvestmentAccountReopenResult = ExistingRequestPendingReview | ExistingRequestPendingUserAction | InvalidSubscriptionTierException | InvestmentAccountNotClosedException | InvestmentAccountNotFoundException | InvestmentAccountReopenRequest;

export type RequestLayerSessionInput = {
  publicToken: Scalars['String'];
};

export type RequestLayerSessionResult = RequestedLayerLinkSession | UnrecoverableError;

export type RequestSubscriptionMigrationWaiverInput = {
  reason: SubscriptionMigrationWaiverReason;
  subscriptionMigrationId: Scalars['ID'];
};

export type RequestSubscriptionMigrationWaiverResult = InvalidTierForMigrationError | SubscriptionMigrationInvalidError | SubscriptionMigrationWaiver;

export enum RequestVersions {
  SEPTEMBER_2022 = 'SEPTEMBER_2022'
}

/** Submitted customer information */
export type RequestedLayerLinkSession = {
  __typename?: 'RequestedLayerLinkSession';
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  dateOfBirth: Maybe<Scalars['Date']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  ssnStorageResult: SsnStorageResult;
  state: Maybe<Scalars['String']>;
  street1: Maybe<Scalars['String']>;
  street2: Maybe<Scalars['String']>;
  zipCode: Maybe<Scalars['String']>;
};

export type ResendChatMessageResponse = ChatHistoryMessage | ChatHistoryMessageNotFound;

export type ResetPasswordByTokenException = {
  __typename?: 'ResetPasswordByTokenException';
  message: Maybe<Scalars['String']>;
};

export type ResetPasswordByTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']>;
  newPw: Scalars['String'];
  newPwConfirmation: Scalars['String'];
  resetToken: Scalars['String'];
  securityAnswer?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordByTokenResult = IncorrectSecurityAnswerException | IncorrectSsnException | InvalidPasswordException | ResetPasswordByTokenException | ResetPasswordByTokenSuccess | UserCredentialsNotFoundException;

export type ResetPasswordByTokenSuccess = {
  __typename?: 'ResetPasswordByTokenSuccess';
  userId: Scalars['ID'];
};

export type ResetPasswordWithTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetToken: Scalars['String'];
};

export type ResetPasswordWithTokenResult = InvalidPasswordResetException | InvalidPasswordResetTokenException | ResetPasswordWithTokenSuccess | UserCredentialsNotFoundException;

export type ResetPasswordWithTokenSuccess = {
  __typename?: 'ResetPasswordWithTokenSuccess';
  userId: Scalars['ID'];
};

export type ResetRateLimitResult = RateLimitDoesNotExistException | ResetRateLimitSuccess;

export type ResetRateLimitSuccess = {
  __typename?: 'ResetRateLimitSuccess';
  challengeRateLimitReset: Maybe<Scalars['Boolean']>;
  loginRateLimitReset: Maybe<Scalars['Boolean']>;
  userId: Maybe<Scalars['ID']>;
};

export type ResourceNotFoundError = {
  __typename?: 'ResourceNotFoundError';
  requestId: Scalars['ID'];
};

export type RespondToLearnPollInput = {
  pollId: Scalars['ID'];
  selectedOption: Scalars['String'];
};

export type RespondToLearnPollResult = InvalidOptionException | LearnPollResponse | RecordDoesNotExistError;

export type RestoreLoginAccessInput = {
  userId: Scalars['ID'];
};

export type RestoreLoginAccessResult = AuthProfile | AuthProfileNotFoundException;

/** A registration record for a prospective user */
export type Result = {
  __typename?: 'Result';
  funnel: Funnel;
};

export enum RetirementPlanAccess {
  /** Married user and spouse have access to a retirement plan */
  both = 'both',
  /** Neither married user nor spouse have access to a retirement plan */
  neither = 'neither',
  /** Single user has no access to retirement plan */
  no = 'no',
  /** Married user has access to a retirement plan without spouse */
  onlyMe = 'onlyMe',
  /** Married user does not have access to a retirement plan, but spouse does */
  spouse = 'spouse',
  /** Single user has access to an employer's retirement plan */
  yes = 'yes'
}

/** Result from attempting to retrigger RDVs */
export type RetriggerRdvsResult = FundingSourceAccount | RdvsNotTriggered;

/** A returned check */
export type ReturnedCheckDeposit = {
  __typename?: 'ReturnedCheckDeposit';
  /** Amount for check. */
  amount: CurrencyAmount;
  /** Returned Check Deposit Image URL for back of check. */
  backCheckImageUrl: Scalars['String'];
  /** Returned Check Deposit Image URL for front of check. */
  frontCheckImageUrl: Scalars['String'];
  /** Date check was returned. */
  rejectedDate: Scalars['DateTime'];
};

export enum RevenueScheduleType {
  at_invoice = 'at_invoice',
  at_range_end = 'at_range_end',
  at_range_start = 'at_range_start',
  evenly = 'evenly',
  never = 'never'
}

export enum RevokeAccessReasons {
  CORE_ACCOUNT_REVIEW = 'CORE_ACCOUNT_REVIEW',
  CORE_BROKER_DEALER_ASSOCIATION = 'CORE_BROKER_DEALER_ASSOCIATION',
  CORE_CASTLE_LOCK = 'CORE_CASTLE_LOCK',
  CORE_CHARGEBACK = 'CORE_CHARGEBACK',
  CORE_COLLECTION = 'CORE_COLLECTION',
  CORE_DISPUTED_TRANSACTION = 'CORE_DISPUTED_TRANSACTION',
  CORE_LEIN_LEVY_LOCK = 'CORE_LEIN_LEVY_LOCK',
  CORE_PENDING_APPROVAL_APPLICATION_WITHDRAWN = 'CORE_PENDING_APPROVAL_APPLICATION_WITHDRAWN',
  CORE_POTENTIAL_ACCOUNT_TAKEOVER = 'CORE_POTENTIAL_ACCOUNT_TAKEOVER',
  CORE_SUSPICIOUS_INVESTMENT_ACTIVITY = 'CORE_SUSPICIOUS_INVESTMENT_ACTIVITY',
  CORE_W9_REQUIRED = 'CORE_W9_REQUIRED',
  DECEASED = 'DECEASED',
  DELAYED_RISK_WITHDRAWALS = 'DELAYED_RISK_WITHDRAWALS',
  DUPLICATE_ACCOUNT = 'DUPLICATE_ACCOUNT',
  EARLY_TRANSFER_IN_PROGRESS = 'EARLY_TRANSFER_IN_PROGRESS',
  FRAUD = 'FRAUD',
  LATER_ROLLOVER_IN_PROGRESS = 'LATER_ROLLOVER_IN_PROGRESS',
  OTHER_NOT_LISTED = 'OTHER_NOT_LISTED',
  PLAID_MISMATCH = 'PLAID_MISMATCH',
  PROFIT_STARS_DISPUTE = 'PROFIT_STARS_DISPUTE',
  REFERRAL_PROMOTION_FRAUD = 'REFERRAL_PROMOTION_FRAUD',
  SPEND_DISPUTED_INCOMING_TRANSFER_R10 = 'SPEND_DISPUTED_INCOMING_TRANSFER_R10',
  SPEND_GENERAL_SUSPENSION = 'SPEND_GENERAL_SUSPENSION',
  SPEND_RETURNED_TRANSFER = 'SPEND_RETURNED_TRANSFER',
  SPEND_SUSPICIOUS_TRANSFER_ACTIVITY = 'SPEND_SUSPICIOUS_TRANSFER_ACTIVITY',
  SUSPICIOUS_MRDC_CONTACT_SPEND_RISK = 'SUSPICIOUS_MRDC_CONTACT_SPEND_RISK',
  SUSPICIOUS_MRDC_PENDING_CLOSURE = 'SUSPICIOUS_MRDC_PENDING_CLOSURE',
  THREE_WAY_CALL_REQUIRED = 'THREE_WAY_CALL_REQUIRED',
  UNDERAGE = 'UNDERAGE',
  UNSUPPORTED_CUSTOMER = 'UNSUPPORTED_CUSTOMER'
}

export type RevokeLoginAccessInput = {
  reason: RevokeAccessReasons;
  userId: Scalars['ID'];
};

export type RevokeLoginAccessResult = AuthProfile | UserCredentialsNotFoundException;

export type RevokePasswordResetTokenInput = {
  plaintextToken: Scalars['String'];
};

export type RevokePasswordResetTokenResult = InvalidPasswordResetTokenException | RevokePasswordResetTokenSuccess;

export type RevokePasswordResetTokenSuccess = {
  __typename?: 'RevokePasswordResetTokenSuccess';
  userId: Scalars['String'];
};

export enum RiskStatus {
  confirmable = 'confirmable',
  fixable = 'fixable',
  hard_reject = 'hard_reject'
}

/** A transaction with excess change to invest into an Acorns account */
export type RoundUp = TimestampsInterface & {
  __typename?: 'RoundUp';
  amount: Scalars['Float'];
  change: Scalars['Float'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  instant: Scalars['Boolean'];
  investmentId: Maybe<Scalars['ID']>;
  investmentNonce: Maybe<Scalars['ID']>;
  linkedSubaccountId: Scalars['ID'];
  manual: Scalars['Boolean'];
  multiplier: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  roundUpAccount: RoundUpAccount;
  roundUpProfile: RoundUpProfile;
  state: RoundUpState;
  /** The target account in which this round up has been invested. */
  targetAccountId: Maybe<Scalars['ID']>;
  total: Maybe<Scalars['Float']>;
  transactionDate: Scalars['DateTime'];
  transactionDisplayDate: Scalars['Date'];
  transactionId: Scalars['ID'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

/** Round up settings for a specific linked account */
export type RoundUpAccount = TimestampsInterface & {
  __typename?: 'RoundUpAccount';
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  linkedSubaccountId: Scalars['ID'];
  roundUpProfile: RoundUpProfile;
  roundUps: Array<RoundUp>;
  startDate: Maybe<Scalars['String']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

/** Round up settings for a user */
export type RoundUpProfile = TimestampsInterface & {
  __typename?: 'RoundUpProfile';
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  multiplier: Scalars['Float'];
  realTimeRoundUpEligible: Scalars['Boolean'];
  roundUpAccounts: Array<RoundUpAccount>;
  roundUpCount: Scalars['Int'];
  roundUpTotal: Scalars['Float'];
  roundUps: Array<RoundUp>;
  roundUpsEnabled: Scalars['Boolean'];
  /** True if user has auto roundups off (making all roundups manual, even from Spend accounts)or at least one enabled non-spend roundup account. */
  showRoundUpsProgress: Scalars['Boolean'];
  /** The target account to which a user's round up investments will be made. */
  targetAccountId: Maybe<Scalars['ID']>;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
  wholeDollarAmount: Scalars['Float'];
};


/** Round up settings for a user */
export type RoundUpProfileRoundUpCountArgs = {
  spend?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Array<RoundUpState>>;
  targetAccountId?: InputMaybe<Scalars['ID']>;
};


/** Round up settings for a user */
export type RoundUpProfileRoundUpTotalArgs = {
  spend?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Array<RoundUpState>>;
  targetAccountId?: InputMaybe<Scalars['ID']>;
};

/** Changeable attributes for user profiles */
export type RoundUpProfileInput = {
  /** Round up multiplier */
  multiplier?: InputMaybe<Scalars['Float']>;
  /** Toggle global user setting for auto round ups */
  roundUpsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Acorns account ID of roundups destination */
  targetAccountId?: InputMaybe<Scalars['ID']>;
  /** Round up to custom dollar amount */
  wholeDollarAmount?: InputMaybe<Scalars['Float']>;
};

export enum RoundUpState {
  /**
   * Round ups that will be invested automatically
   * @deprecated Use waiting state instead
   */
  autoInvestable = 'autoInvestable',
  /** Round ups that were canceled, either before or after an investment was created */
  canceled = 'canceled',
  /** Round ups associated with an investment */
  invested = 'invested',
  /** Round ups that have yet to be invested */
  pending = 'pending',
  /** Round ups that requested to be invested but have not been transferred */
  roundedUp = 'roundedUp',
  /** Round ups which are ready to be invested */
  waiting = 'waiting'
}

export enum RoundUpType {
  auto = 'auto',
  realTime = 'realTime'
}

/** An individual edge within the paginated list of RoundUpType */
export type RoundUpTypeEdge = {
  __typename?: 'RoundUpTypeEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID'];
  /** The RoundUpType record in the edge */
  node: RoundUp;
};

/** Relay style pagination information for RoundUpType */
export type RoundUpTypePagination = {
  __typename?: 'RoundUpTypePagination';
  edges: Array<RoundUpTypeEdge>;
  pageInfo: PageInfo;
};

export type SmsAuthChallenge = AuthChallenge & {
  __typename?: 'SMSAuthChallenge';
  alternateAuthenticators: Array<AuthenticatorInfo>;
  challengeTrigger: ChallengeTriggers;
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  maskedPhoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** SSN supporting document requested user alert. */
export type SsnDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'SSNDocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export enum SsnStorageResult {
  EXISTS = 'EXISTS',
  INVALID = 'INVALID',
  SUCCESS = 'SUCCESS'
}

export enum SalaryInterval {
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type SamePasswordsException = {
  __typename?: 'SamePasswordsException';
  message: Maybe<Scalars['String']>;
};

export type SampleMailInDocument = {
  __typename?: 'SampleMailInDocument';
  letterUrl: Maybe<Scalars['URL']>;
  mailType: MailInDocumentType;
};

export type SaveInterestPaidItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SaveInterestPaidItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  /** The calendar month in which this interest was earned. */
  monthEarned: Scalars['String'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SaveTransferInItem = PastItem & PastTargetedTransferItem & PastUserTransferItem & SpendItem & {
  __typename?: 'SaveTransferInItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SaveTransferOutItem = PastItem & PastTargetedTransferItem & PastUserTransferItem & SpendItem & {
  __typename?: 'SaveTransferOutItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** Input for saving an upload url after direct to s3 upload */
export type SaveUploadUrlInput = {
  /** the upload uuid from the upload object */
  uploadUuid: Scalars['ID'];
};

/** Input for saving an upload url after direct to s3 upload */
export type SaveUploadUrlsInput = {
  /** a field where the user can add additional info for their uploads */
  additionalInfo?: InputMaybe<Scalars['String']>;
  /** collection of uploads uuid from the uploads object */
  uploadsUuid: Array<Scalars['ID']>;
};

/** LegacyUploadDocumentResult */
export type SaveUploadUrlsResult = DocumentUploads | UploadSaveError;

export type SavingsAccountEligibility = {
  __typename?: 'SavingsAccountEligibility';
  isEligibleForOpen: Scalars['Boolean'];
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>;
};

export enum SavingsAccountEligibilityRequirement {
  NEEDS_CHECKING_ACCOUNT = 'NEEDS_CHECKING_ACCOUNT',
  NEEDS_DIRECT_DEPOSIT = 'NEEDS_DIRECT_DEPOSIT',
  NEEDS_OTHER_BANKING_PARTNER = 'NEEDS_OTHER_BANKING_PARTNER'
}

export enum SavingsAccountType {
  EMERGENCY_SAVINGS = 'EMERGENCY_SAVINGS'
}

export type ScheduleInput = {
  type: ScheduleType;
};

export type ScheduleRecurringTransferInput = {
  recurrenceRule: RecurrenceRuleInput;
  transferEvent: RecurringTransferEventInput;
};

export type ScheduleRecurringTransferResult = MalformedRecurringTransferException | RecurringTransfer;

export type ScheduleResult = {
  __typename?: 'ScheduleResult';
  active: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
};

export enum ScheduleType {
  chat = 'chat',
  email = 'email',
  phone = 'phone'
}

export type Scope = {
  __typename?: 'Scope';
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Query attributes for Employer Search */
export type SearchEmployersInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID'];
  /** Search Term */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>;
  /** Switch Type */
  switchType?: InputMaybe<SwitchType>;
};

/** Search Results */
export type SearchEmployersPayload = {
  __typename?: 'SearchEmployersPayload';
  results: Maybe<Array<Employer>>;
  /** Unique Tracking ID */
  trackingId: Scalars['ID'];
};

export type SearchHistory = {
  __typename?: 'SearchHistory';
  popularSearches: Maybe<Array<Scalars['String']>>;
  recentSearches: Array<Scalars['String']>;
};

export type SearchSecuritiesInput = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchSecuritiesOrderBy>;
  search: Scalars['String'];
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>;
};

export enum SearchSecuritiesOrderBy {
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by match score in descending order */
  BEST_MATCH = 'BEST_MATCH',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by market cap in descending order */
  MARKET_CAP = 'MARKET_CAP',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by share price (open_price) in descending order */
  SHARE_PRICE = 'SHARE_PRICE'
}

export type SearchSecuritiesPageInfo = {
  __typename?: 'SearchSecuritiesPageInfo';
  count: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nextPageCursor: Maybe<Scalars['String']>;
  prevPageCursor: Maybe<Scalars['String']>;
  totalMatches: Maybe<Scalars['Int']>;
};

export type SearchSecuritiesResponse = {
  __typename?: 'SearchSecuritiesResponse';
  pageInfo: Maybe<SearchSecuritiesPageInfo>;
  securities: Array<Security>;
};

export type SearchSupportArticleResult = {
  __typename?: 'SearchSupportArticleResult';
  author: SupportAuthor;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  draft: Scalars['Boolean'];
  editedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  outdated: Scalars['Boolean'];
  position: Maybe<Scalars['Int']>;
  promoted: Scalars['Boolean'];
  resultType: Scalars['String'];
  section: SupportSection;
  slug: Scalars['String'];
  snippet: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SearchSupportResult = {
  __typename?: 'SearchSupportResult';
  relevantSearchArticles: Array<Maybe<SearchSupportArticleResult>>;
  relevantSearchCategories: Array<Maybe<SupportCategory>>;
};

export enum SearchTermCategory {
  BENEFITS_HUB = 'BENEFITS_HUB',
  DEFAULT = 'DEFAULT',
  REFERRALS_LANDER = 'REFERRALS_LANDER'
}

/** Secret Squirrel Error */
export type SecretSquirrelException = {
  __typename?: 'SecretSquirrelException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type SecuritiesBySectorInput = {
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SecuritiesBySectorOrderBy>;
  sectors: Array<TradingSector>;
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>;
};

export enum SecuritiesBySectorOrderBy {
  /** Securities that contain the provided trading sector(s) ordered by market cap in descending order */
  MARKET_CAP = 'MARKET_CAP',
  /** Securities that contain the provided trading sector(s) ordered by share price (open_price) in descending order */
  SHARE_PRICE = 'SHARE_PRICE'
}

export type SecuritiesBySectorPageInfo = {
  __typename?: 'SecuritiesBySectorPageInfo';
  count: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nextPageCursor: Maybe<Scalars['String']>;
  prevPageCursor: Maybe<Scalars['String']>;
  totalMatches: Maybe<Scalars['Int']>;
};

export type SecuritiesBySectorResponse = {
  __typename?: 'SecuritiesBySectorResponse';
  pageInfo: Maybe<SecuritiesBySectorPageInfo>;
  securities: Array<Security>;
};

export type SecuritiesBySymbolsInput = {
  symbols: Array<Scalars['TickerSymbol']>;
};

export type SecuritiesBySymbolsResponse = {
  __typename?: 'SecuritiesBySymbolsResponse';
  securities: Array<Security>;
};

export type Security = {
  currentPrice: BigCurrencyAmount;
  displayName: Scalars['String'];
  earliestPriceDate: Scalars['Date'];
  headlines: Array<SecurityHeadline>;
  id: Scalars['ID'];
  lastClosePrice: BigCurrencyAmount;
  lastUpdatedAt: Scalars['DateTime'];
  longName: Scalars['String'];
  marketCap: Scalars['BigDecimal'];
  openPrice: BigCurrencyAmount;
  profile: SecurityProfile;
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>;
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile;
  shortName: Scalars['String'];
  symbol: Scalars['TickerSymbol'];
  type: SecurityType;
  volume: Scalars['BigDecimal'];
  week52High: BigCurrencyAmount;
  week52Low: BigCurrencyAmount;
};

/** Describes a target allocation percentage for the specified security */
export type SecurityAllocationTarget = {
  /** ID or Symbol of the targeted security */
  securityId: Scalars['String'];
  /** Target allocation percentage, ex: 33 -> 33% */
  securityPercent: Scalars['Int'];
};

export type SecurityAnswer = {
  questionId: Scalars['ID'];
  response: Scalars['String'];
};

export type SecurityBySymbolInput = {
  symbol: Scalars['TickerSymbol'];
};

/** Individualized diversification information by security */
export type SecurityDiversificationInfo = {
  __typename?: 'SecurityDiversificationInfo';
  /** Metric representing the security's contribution to the overall diversification of the portfolio */
  diversificationFactor: Scalars['Float'];
  /** Security symbol */
  symbol: Scalars['String'];
};

export type SecurityGain = {
  __typename?: 'SecurityGain';
  marketValue: Maybe<BigCurrencyAmount>;
  percent: Maybe<Scalars['BigDecimal']>;
};

export type SecurityHeadline = {
  __typename?: 'SecurityHeadline';
  createdAt: Scalars['DateTime'];
  headline: Scalars['String'];
  source: Scalars['String'];
  storyUrl: Scalars['URL'];
  thumbnailUrl: Maybe<Scalars['URL']>;
};

/** Security Not Supported */
export type SecurityNotSupportedException = {
  __typename?: 'SecurityNotSupportedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type SecurityPerformance = {
  __typename?: 'SecurityPerformance';
  gain: SecurityGain;
  prices: Maybe<Array<SecurityPrice>>;
  symbol: Scalars['TickerSymbol'];
};

export type SecurityPerformanceBySymbolInput = {
  /** Only the Date component is used */
  endDate: Scalars['DateTime'];
  /** Only the Date component is used */
  interval?: InputMaybe<Scalars['Int']>;
  maxPoints?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  symbol: Scalars['TickerSymbol'];
};

export type SecurityPerformancesBySymbolInput = {
  /** Only the Date component is used */
  endDate: Scalars['DateTime'];
  /** Only the Date component is used */
  interval?: InputMaybe<Scalars['Int']>;
  maxPoints?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  symbols: Array<Scalars['TickerSymbol']>;
};

export type SecurityPrice = {
  __typename?: 'SecurityPrice';
  date: Scalars['Date'];
  marketValue: BigCurrencyAmount;
  timestamp: Scalars['DateTime'];
  unadjustedMarketValue: Maybe<BigCurrencyAmount>;
};

export type SecurityProfile = {
  __typename?: 'SecurityProfile';
  defaultLogoUrl: Maybe<Scalars['URL']>;
  description: Maybe<Scalars['String']>;
  logoUrl: Maybe<Scalars['URL']>;
  tradingSectors: Array<TradingSector>;
};

export enum SecurityType {
  BOND = 'BOND',
  ETF = 'ETF',
  STOCK = 'STOCK'
}

/** User Directed Portfolio Object */
export type SelfDirectedPortfolio = BasePortfolio & {
  __typename?: 'SelfDirectedPortfolio';
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation;
  cashOwed: MonetaryAmount;
  currentAllocationPercentage: Scalars['Float'];
  currentBalance: MonetaryAmount;
  currentBalanceWithPending: MonetaryAmount;
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>;
  /** Description of the portfolio */
  description: Scalars['String'];
  /** ID of the Portfolio */
  id: Scalars['ID'];
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String'];
  pendingBalance: MonetaryAmount;
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities: Maybe<Array<PortfolioSecurity>>;
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<Array<PortfolioSecurityAllocation>>;
  /** Contains requirement statuses for removing the portfolio */
  requirements: AccountRequirements;
  status: SelfDirectedPortfolioStatus;
  yearToDateReturn: Maybe<MarketReturn>;
};

export enum SelfDirectedPortfolioStatus {
  /** Self Directed Portfolio has been removed */
  CLOSED = 'CLOSED',
  /** Self Directed Portfolio is open */
  OPEN = 'OPEN',
  /** Self Directed Portfolio has started the closure process */
  PENDING_CLOSURE = 'PENDING_CLOSURE'
}

export type SendBrazeEventInput = {
  event: BrazeEvent;
  userId: Scalars['ID'];
};

export type SendChatMessageResponse = ChatHistoryMessage | ChatMessageSizeOutOfBounds | ChatSessionNotFound | ChatUnavailableError;

export type SendCheckPaymentInput = {
  amount: CurrencyAmountInput;
  fromAccountId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  nonce: Scalars['String'];
  recipient: CheckPaymentRecipientInput;
  recipientAddress: CheckPaymentAddressInput;
};

/** Check or errors */
export type SendCheckPaymentResult = AuthorizationError | CheckPayment | DuplicateActionError | InvalidAddressError;

export type Session = {
  __typename?: 'Session';
  redirectUrl: Maybe<Scalars['String']>;
  refreshToken: Maybe<Scalars['ID']>;
  token: Scalars['ID'];
  uuid: Scalars['ID'];
};

export enum SessionType {
  BEHAVIORAL = 'BEHAVIORAL',
  DEFAULT = 'DEFAULT'
}

export type SetAuthenticationPinInput = {
  pin: Scalars['String'];
  pinConfirmation: Scalars['String'];
};

export type SetAuthenticationPinResult = InvalidPinException | SetAuthenticationPinSuccess | UserCredentialsNotFoundException;

export type SetAuthenticationPinSuccess = {
  __typename?: 'SetAuthenticationPINSuccess';
  userId: Scalars['ID'];
};

/** Response to a beneficiary ssn update */
export type SetBeneficiarySsnResult = Beneficiary | BeneficiaryNotFoundException | InternalErrorException | InvalidSsnException | SecretSquirrelException | SsnAlreadyInUseException | SsnMatchesCustodianException | SsnUpdateForbiddenException;

export type SetDefaultAuthenticatorInput = {
  authenticatorId: Scalars['ID'];
};

export type SetDefaultAuthenticatorResult = AuthenticatorAlreadyDefaultException | AuthenticatorNotFoundException | EmailAuthenticator | PhoneAuthenticator;

/** Configuration for setting public access of investment account recaps. */
export type SetInvestmentAccountRecapPublicAccessInput = {
  /** The unique identifier of the investment account recap for which public access is being modified. */
  id: Scalars['ID'];
  /** Whether or not the recap is public. */
  public: Scalars['Boolean'];
};

/** Result of modifying the public access of an investment account recap. */
export type SetInvestmentAccountRecapPublicAccessResult = InvestmentAccountRecap | InvestmentAccountRecapNotFoundException;

/** Options to set an account with a linking error */
export type SetLinkingErrorInput = {
  /** Error to give the linked account */
  code: LinkedAccountLinkingErrorsEnum;
};

export type SetNegotiationStatusInput = {
  negotiationMethod: NegotiationMethod;
  operator: Scalars['String'];
  refundAmount?: InputMaybe<Scalars['Float']>;
  status: BankFeeNegotiationStatus;
  submissionId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type SetNegotiationStatusResult = {
  __typename?: 'SetNegotiationStatusResult';
  message: Scalars['String'];
};

export type SetPortfolioInput = {
  id: Scalars['ID'];
};

/** Input for setting a funding source as preferred withdrawal account */
export type SetPreferredWithdrawalAccountInput = {
  /** the uuid of the funding source being set */
  fundingSourceUuid: Scalars['ID'];
};

/** Result of setting a funding source as preferred withdrawal account. */
export type SetPreferredWithdrawalAccountResult = FundingSourceAccount | PreferredAccountNotEligibleError | PreferredAccountNotSupportedError;

export type SetReferralCampaignFlagsInput = {
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  campaignId: Scalars['ID'];
  fallback?: InputMaybe<Scalars['Boolean']>;
  override?: InputMaybe<OverrideInput>;
  qa?: InputMaybe<Scalars['Boolean']>;
};

export type SetReferralCampaignFlagsResult = {
  __typename?: 'SetReferralCampaignFlagsResult';
  autoAdd: Scalars['Boolean'];
  fallback: Scalars['Boolean'];
  id: Scalars['ID'];
  qa: Scalars['Boolean'];
};

export type SetUpTip = {
  __typename?: 'SetUpTip';
  backgroundImage: Image;
  body: Scalars['String'];
  ctaDetails: ActionFeedCta;
  id: Scalars['ID'];
  image: Image;
  type: ProductSetupTipType;
};

export type Settings = {
  __typename?: 'Settings';
  /** @deprecated Highly non-performant! */
  allowDebitCard: Scalars['Boolean'];
  /** @deprecated Highly non-performant! */
  automaticRoundup: Scalars['Boolean'];
  depositsSuspended: Maybe<Scalars['Boolean']>;
  /** @deprecated Highly non-performant! */
  dollarRoundupAmount: Scalars['Float'];
  /** @deprecated Highly non-performant! */
  notifications: Notifications;
  /** @deprecated Highly non-performant! */
  roundupMultiplier: Scalars['Int'];
  /** @deprecated Highly non-performant! */
  threshold: Scalars['Int'];
};

export type Signature = TimestampsInterface & {
  __typename?: 'Signature';
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Type of profile */
  profile: Maybe<Profile>;
  /** Type of signature */
  signatureType: SignatureType;
  /** SVG file */
  svgFile: Scalars['String'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** Internal ID for user */
  userId: Scalars['ID'];
};

export enum SignatureType {
  /** A signature used for a user's bank fee negotiation */
  bankFeeNegotiation = 'bankFeeNegotiation',
  /** A signature for the user investment certificate */
  certificate = 'certificate',
  /** A signature used for the user spend debit card */
  debitCard = 'debitCard',
  /** A signature used for the user direct deposit PDF form */
  directDeposit = 'directDeposit',
  /** A signature used for a user's utility bill negotiation */
  utilityBillNegotiation = 'utilityBillNegotiation'
}

export type SiteWideBannerContent = {
  __typename?: 'SiteWideBannerContent';
  bannerText: Scalars['String'];
  currentVersion: Scalars['String'];
  publishedVersion: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
};

export type SiteWideBannerContentInput = {
  bannerText?: InputMaybe<Scalars['String']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type SmartDepositMetadataInput = {
  supportedTargetAccounts: Array<SplitDepositTargetAccountType>;
};

export type SmartDepositMetadataResult = {
  __typename?: 'SmartDepositMetadataResult';
  recommendedAllocations: Array<SplitDepositAllocation>;
  targetAccounts: Array<SplitDepositTargetAccount>;
};

/** Optional filter for getting customer accounts a user can withdraw from. */
export type SourceAccountsFilterInput = {
  /** Filter accounts that are able to withdraw from at this time. */
  isWithdrawalAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Filter accounts that can withdraw to a specified account. */
  targetAccountId?: InputMaybe<Scalars['ID']>;
};

/** Extra detailed attributes for source of user's arrival to registration. */
export type SourceAttributes = {
  __typename?: 'SourceAttributes';
  /** s2 - Affiliate for Impact Radius or campaign ID */
  affiliateCampaignID: Maybe<Scalars['String']>;
  /** Unique ID for user journey exposed by Button */
  buttonSourceToken: Maybe<Scalars['String']>;
  /** carrier - Mobile carrier */
  carrier: Maybe<Scalars['String']>;
  /** clickid - Unique Impact Radius referral ID */
  clickID: Maybe<Scalars['String']>;
  /** code - Referral code of advocate the user registered with */
  code: Maybe<Scalars['String']>;
  /** s4 - Customer incentive offers */
  freeformIdentifier: Maybe<Scalars['String']>;
  /** promoCode - Promotional code name */
  promoCode: Maybe<Scalars['String']>;
  /** referral_code - Referral code of referrer (either user-to-user or partner) that the user registered with */
  referralCode: Maybe<Scalars['String']>;
  /** s3 - Customer incentive offers */
  s3: Maybe<Scalars['String']>;
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String'];
};

/** Source attribute object represented as is today. Should be normalized moving forward. */
export type SourceAttributesInput = {
  /** Unnormalized source attributes for supporting backwards compatibility with existing services */
  rawJSON: Scalars['String'];
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String'];
};

export type SpendAtmReimbursementItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendATMReimbursementItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendAtmWithdrawalItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendATMWithdrawalItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendAccount = {
  __typename?: 'SpendAccount';
  accountId: Maybe<Scalars['ID']>;
  bankCardOrder: Maybe<BankCardOrder>;
  bankType: Maybe<BankType>;
  isDirectDepositIncentiveEligible: Scalars['Boolean'];
  isEligible: Scalars['Boolean'];
  isEligibleForPremiumCardUpgrade: Maybe<Scalars['Boolean']>;
  isReopenable: Maybe<Scalars['Boolean']>;
  lockReason: Maybe<BankAccountLockReason>;
  status: SpendAccountStatus;
};

export enum SpendAccountStatus {
  CLOSED = 'CLOSED',
  LOCKED = 'LOCKED',
  NOT_OPENED = 'NOT_OPENED',
  OPEN = 'OPEN',
  OPENING = 'OPENING',
  REOPENING = 'REOPENING'
}

export type SpendAlert = {
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export type SpendAtm = {
  __typename?: 'SpendAtm';
  address: SpendAtmAddress;
  atmName: Scalars['String'];
  imageUrl: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
};

export type SpendAtmAddress = {
  __typename?: 'SpendAtmAddress';
  addressLine: Maybe<Scalars['String']>;
  cityName: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  postalCode: Maybe<Scalars['String']>;
  stateCode: Maybe<Scalars['String']>;
};

export type SpendAtmVendorUnavailableError = {
  __typename?: 'SpendAtmVendorUnavailableError';
  requestId: Maybe<Scalars['String']>;
};

export type SpendAtmsCoordinateInput = {
  latitude: Scalars['String'];
  longitude: Scalars['String'];
};

export type SpendAtmsInput = {
  searchCoordinate: SpendAtmsCoordinateInput;
  searchRadius?: InputMaybe<Scalars['Float']>;
};

export type SpendAtmsPayload = {
  __typename?: 'SpendAtmsPayload';
  atms: Maybe<Array<Maybe<SpendAtm>>>;
  executedSearchRadius: Maybe<Scalars['String']>;
};

export type SpendAtmsResult = SpendAtmVendorUnavailableError | SpendAtmsPayload;

export type SpendBillPayItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendBillPayItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendCheckDepositItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendCheckDepositItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendCheckPaymentItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendCheckPaymentItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendDigitalWalletItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendDigitalWalletItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendDirectDepositItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendDirectDepositItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendDisputesResponse = {
  __typename?: 'SpendDisputesResponse';
  creationDateTime: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  disputeDateTime: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['Int']>;
  questions: Array<SpendTransactionsDisputeQuestions>;
  transactions: Array<SpendTransactionsResponse>;
};

export type SpendECheckItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendECheckItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendInterestPaidItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendInterestPaidItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  /** The calendar month in which this interest was earned. */
  monthEarned: Scalars['String'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

/** A base set of fields that each PastItem from Spend transactions must implement */
export type SpendItem = {
  accountName: Scalars['String'];
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
};

export type SpendPurchaseItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendPurchaseItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendRealTimeRoundUpItem = PastItem & PastTargetedTransferItem & SpendItem & {
  __typename?: 'SpendRealTimeRoundUpItem';
  accountName: Scalars['String'];
  /** The investment amount after being multiplied. */
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** Past Item ID */
  id: Scalars['ID'];
  /** The investment amount prior to being multiplied */
  initialAmount: Maybe<CurrencyAmount>;
  moneyManagerTransfer: Scalars['Boolean'];
  multiplier: Maybe<Scalars['Int']>;
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendTransactionsDisputeCustomersResponse = {
  __typename?: 'SpendTransactionsDisputeCustomersResponse';
  accountNumber: Maybe<Scalars['String']>;
  applicationCode: Maybe<Scalars['String']>;
  customerNumber: Maybe<Scalars['String']>;
  disputes: Array<SpendDisputesResponse>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  productCode: Maybe<Scalars['String']>;
};

export type SpendTransactionsDisputeQuestions = {
  __typename?: 'SpendTransactionsDisputeQuestions';
  answer: Maybe<Scalars['String']>;
  question: Maybe<Scalars['String']>;
};

export type SpendTransactionsDisputeResponse = {
  __typename?: 'SpendTransactionsDisputeResponse';
  bankType: BankType;
  customers: SpendTransactionsDisputeCustomersResponse;
};

export type SpendTransactionsDisputeResult = SpendTransactionsDisputeResponse;

export type SpendTransactionsInput = {
  amount: Scalars['String'];
  availableAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  settledAt?: InputMaybe<Scalars['DateTime']>;
  status: BankTransactionStatus;
  tag?: InputMaybe<Scalars['String']>;
  type: BankTransactionType;
  typeCode: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  voidedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SpendTransactionsResponse = {
  __typename?: 'SpendTransactionsResponse';
  amount: Scalars['Float'];
  coreTransactionId: Scalars['String'];
  description: Scalars['String'];
  disputedAmount: Scalars['Float'];
  id: Maybe<Scalars['Int']>;
  postingDate: Scalars['DateTime'];
  status: Maybe<Scalars['String']>;
  transactionCode: Scalars['String'];
};

export type SpendTransferInItem = PastItem & PastTargetedTransferItem & PastUserTransferItem & SpendItem & {
  __typename?: 'SpendTransferInItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SpendTransferOutItem = PastItem & PastTargetedTransferItem & PastUserTransferItem & SpendItem & {
  __typename?: 'SpendTransferOutItem';
  accountName: Scalars['String'];
  amount: CurrencyAmount;
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>;
  /** When this was first created */
  createdAt: Scalars['DateTime'];
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String'];
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean'];
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>;
  /** Past Item ID */
  id: Scalars['ID'];
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>;
  moneyManagerTransfer: Scalars['Boolean'];
  productAccountType: ProductAccountType;
  /** The corresponding product of the item */
  productType: ProductType;
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean'];
  sourceAccountTitle: Maybe<Scalars['String']>;
  /** The current state of the item */
  status: PastItemStatus;
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String'];
  targetAccountTitle: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  transactionDescription: Scalars['String'];
  transactionType: TransactionType;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export type SplitDeposit = {
  __typename?: 'SplitDeposit';
  allocations: Array<SplitDepositAllocation>;
  createdAt: Scalars['String'];
  distributedAt: Maybe<Scalars['String']>;
  expectedNextDepositAmount: Maybe<Scalars['String']>;
  expectedNextDepositAt: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isCancelable: Scalars['Boolean'];
  isCanceled: Scalars['Boolean'];
  isUsingRecommendedAllocations: Scalars['Boolean'];
  /** @deprecated deprecated, use allocations instead */
  savingsRatePercent: Scalars['String'];
  settingsId: Scalars['ID'];
  /** @deprecated deprecated, use allocations instead */
  splitDistribution: DistributionAmounts;
  transactionAmount: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
  willDistributeAutomaticallyAt: Maybe<Scalars['String']>;
};

export type SplitDepositAllocation = {
  allocationPercent: Scalars['String'];
  nickname: Maybe<Scalars['String']>;
  targetAccountId: Scalars['ID'];
  targetAccountType: SplitDepositTargetAccountType;
};

export type SplitDepositAllocationInput = {
  allocationPercent: Scalars['String'];
  nickname?: InputMaybe<Scalars['String']>;
  targetAccountId: Scalars['ID'];
  targetAccountType: SplitDepositTargetAccountType;
};

export type SplitDepositDailyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositDailyRecurrenceRule';
  frequency: SplitDepositRecurrenceFrequency;
};

export type SplitDepositDirectDepositAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositDirectDepositAllocation';
  allocationPercent: Scalars['String'];
  nickname: Maybe<Scalars['String']>;
  normalizedAmount: Maybe<FormattedMonetaryAmount>;
  normalizedDailyAmount: Maybe<Scalars['String']>;
  targetAccountId: Scalars['ID'];
  targetAccountType: SplitDepositTargetAccountType;
};

export type SplitDepositDirectDepositIntentSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositIntentSetting';
  allocations: Array<SplitDepositDirectDepositAllocation>;
  createdAt: Scalars['String'];
  deposits: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean'];
  /** @deprecated deprecated */
  employerName: Scalars['String'];
  estimatedPaycheckAmount: CurrencyAmount;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isUsingRecommendedAllocations: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};


export type SplitDepositDirectDepositIntentSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Order>;
};

export type SplitDepositDirectDepositSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositSetting';
  allocations: Array<SplitDepositDirectDepositAllocation>;
  awaitingConfiguration: Scalars['Boolean'];
  createdAt: Scalars['String'];
  deposits: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean'];
  /** @deprecated deprecated */
  employerName: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isUsingRecommendedAllocations: Scalars['Boolean'];
  monthlyTotals: Array<MonthlyTotal>;
  name: Scalars['String'];
  normalizedAmount: Maybe<FormattedMonetaryAmount>;
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String'];
  totalAmounts: Maybe<TotalAmounts>;
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};


export type SplitDepositDirectDepositSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Order>;
};

export type SplitDepositMonthlyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositMonthlyRecurrenceRule';
  byMonthDay: Array<Scalars['Int']>;
  frequency: SplitDepositRecurrenceFrequency;
};

export type SplitDepositMutation = {
  __typename?: 'SplitDepositMutation';
  cancel: SplitDeposit;
  execute: SplitDeposit;
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

export enum SplitDepositNormalizationFrequency {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export type SplitDepositRecurrenceAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositRecurrenceAllocation';
  allocationPercent: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  legacyRecurrenceAmount: Maybe<FormattedMonetaryAmount>;
  legacyRecurrenceRule: Maybe<SplitDepositRecurrenceRule>;
  nickname: Maybe<Scalars['String']>;
  targetAccountId: Scalars['ID'];
  targetAccountType: SplitDepositTargetAccountType;
};

export enum SplitDepositRecurrenceFrequency {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type SplitDepositRecurrenceRule = {
  frequency: SplitDepositRecurrenceFrequency;
};

export type SplitDepositRecurrenceSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositRecurrenceSetting';
  allocations: Array<SplitDepositRecurrenceAllocation>;
  createdAt: Scalars['String'];
  deposits: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean'];
  /** @deprecated deprecated */
  employerName: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  monthlyTotals: Array<MonthlyTotal>;
  name: Scalars['String'];
  normalizedAmount: Maybe<FormattedMonetaryAmount>;
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};


export type SplitDepositRecurrenceSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Order>;
};

export enum SplitDepositSettingType {
  DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
  DIRECT_DEPOSIT_INTENT = 'DIRECT_DEPOSIT_INTENT',
  RECURRENCE = 'RECURRENCE'
}

export type SplitDepositSettings = {
  allocations: Array<SplitDepositAllocation>;
  createdAt: Scalars['String'];
  deposits: Maybe<Array<SplitDeposit>>;
  /** @deprecated deprecated */
  distributionType: DistributionType;
  /** @deprecated use name instead */
  employer: Scalars['String'];
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean'];
  /** @deprecated deprecated */
  employerName: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean'];
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};


export type SplitDepositSettingsDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Order>;
};

export type SplitDepositSettingsFilterInput = {
  settingTypes: Array<SplitDepositSettingType>;
  showHiddenEmployerSettings?: InputMaybe<Scalars['Boolean']>;
};

export type SplitDepositSettingsMutation = {
  __typename?: 'SplitDepositSettingsMutation';
  configure: SplitDepositSettings;
  employer: Scalars['String'];
  employerHidden: Scalars['Boolean'];
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type SplitDepositSettingsMutationConfigureArgs = {
  input: ConfigureSettingsInput;
};

export type SplitDepositTargetAccount = {
  __typename?: 'SplitDepositTargetAccount';
  nickname: Maybe<Scalars['String']>;
  targetAccountId: Maybe<Scalars['ID']>;
  targetAccountType: SplitDepositTargetAccountType;
};

export enum SplitDepositTargetAccountType {
  EARLY = 'EARLY',
  INVEST = 'INVEST',
  LATER = 'LATER',
  SAVE = 'SAVE',
  SPEND = 'SPEND'
}

export type SplitDepositWeeklyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositWeeklyRecurrenceRule';
  byWeekDay: Array<DayOfWeek>;
  frequency: SplitDepositRecurrenceFrequency;
};

/** This SSN already belongs to another beneficiary for this custodian */
export type SsnAlreadyInUseException = {
  __typename?: 'SsnAlreadyInUseException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** This SSN is a duplicate of the current custodian's SSN */
export type SsnMatchesCustodianException = {
  __typename?: 'SsnMatchesCustodianException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Beneficiary's ssn cannot be updated */
export type SsnUpdateForbiddenException = {
  __typename?: 'SsnUpdateForbiddenException';
  /** message */
  message: Maybe<Scalars['String']>;
};

/** Attributes for starting PDF Switch */
export type StartAcornsPdfSwitchInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID'];
  /** Employer Name */
  employerName?: InputMaybe<Scalars['String']>;
  /** [DEPRECATED] Use employerName instead. */
  name?: InputMaybe<Scalars['String']>;
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>;
};

/** Starts a check deposit session. */
export type StartCheckDepositInput = {
  /** The client info to pass to Ensenta for validation purposes */
  clientInfo: ClientInfo;
};

/** Starts a check deposit session with our vendor. */
export type StartCheckDepositPayload = {
  __typename?: 'StartCheckDepositPayload';
  /** Token that represents a session with our vendor. */
  sessionToken: Scalars['String'];
};

/** Attributes for starting Online Switch */
export type StartOnlineSwitchInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID'];
  /** Employer ID */
  employerId: Scalars['ID'];
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>;
};

export type StartOnlineSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartOnlineSwitchPayload';
  userSwitch: UserSwitch;
};

/** Changeable attributes for addresses */
export type StartSubmittableSwitchAddressInput = {
  /** City */
  city: Scalars['String'];
  /** Country */
  country: Scalars['String'];
  /** State */
  state: Scalars['String'];
  /** Street 1 */
  street1: Scalars['String'];
  /** Street 2 */
  street2?: InputMaybe<Scalars['String']>;
  /** Zip code */
  zipCode: Scalars['String'];
};

/** Attributes for starting Submittable Switch */
export type StartSubmittableSwitchInput = {
  /** Bank Account ID */
  bankAccountId?: InputMaybe<Scalars['ID']>;
  /** Employer ID */
  employerId: Scalars['ID'];
  /** Employer Address */
  employerLocationAddress?: InputMaybe<StartSubmittableSwitchAddressInput>;
  /** Employee ID */
  nonSsnEmployeeId?: InputMaybe<Scalars['String']>;
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>;
};

export type StartSubmittableSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartSubmittableSwitchPayload';
  userSwitch: UserSwitch;
};

export enum StateCode {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AS = 'AS',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  FM = 'FM',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MH = 'MH',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  PW = 'PW',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VI = 'VI',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY'
}

/** Statement */
export type Statement = {
  __typename?: 'Statement';
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableId: Maybe<Scalars['ID']>;
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableType: Maybe<Scalars['String']>;
  /** created at date and time of Statement */
  createdAt: Scalars['DateTime'];
  day: Scalars['Int'];
  /** update at date and time of Statement */
  endDate: Maybe<Scalars['DateTime']>;
  /**
   * Deprecated do not use
   * @deprecated Use taxFormType instead
   */
  formType: Maybe<FormType>;
  id: Scalars['ID'];
  /** Unique identifier of the investment account for which the statement was generated for. */
  investmentAccountId: Scalars['ID'];
  investmentAccountType: Maybe<InvestmentAccountType>;
  /**
   * Deprecated do not use
   * @deprecated Use statementLink instead
   */
  link: Maybe<StatementLink>;
  month: Scalars['Int'];
  portfolioType: StatementPortfolioType;
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  s3Filename: Maybe<Scalars['String']>;
  /** created at date and time of Statement */
  startDate: Maybe<Scalars['DateTime']>;
  statementLink: Maybe<Scalars['String']>;
  statementType: StatementType;
  taxFormType: Maybe<TaxFormType>;
  /** update at date and time of Statement */
  updatedAt: Maybe<Scalars['DateTime']>;
  uploaded: Maybe<Scalars['Boolean']>;
  year: Scalars['Int'];
};

/** An individual edge within the paginated list of Statement */
export type StatementEdge = {
  __typename?: 'StatementEdge';
  /** The unique key used for pagination */
  cursor: Scalars['ID'];
  /** The Statement record in the edge */
  node: Statement;
};

/** StatementLink */
export type StatementLink = {
  __typename?: 'StatementLink';
  downloadUrl: Scalars['String'];
  url: Scalars['String'];
};

/** Relay style pagination information for Statement */
export type StatementPagination = {
  __typename?: 'StatementPagination';
  edges: Array<StatementEdge>;
  pageInfo: PageInfo;
};

export enum StatementPortfolioType {
  CUSTOMIZED = 'CUSTOMIZED',
  MANAGED = 'MANAGED',
  SELF_DIRECTED = 'SELF_DIRECTED'
}

export enum StatementType {
  /** user trade or chargeback confirmation */
  daily_user_trade_confirmation = 'daily_user_trade_confirmation',
  /** tax statements */
  tax = 'tax',
  /** monthly statements */
  user = 'user'
}

export type Stock = Security & {
  __typename?: 'Stock';
  currentPrice: BigCurrencyAmount;
  displayName: Scalars['String'];
  earliestPriceDate: Scalars['Date'];
  headlines: Array<SecurityHeadline>;
  id: Scalars['ID'];
  lastClosePrice: BigCurrencyAmount;
  lastUpdatedAt: Scalars['DateTime'];
  longName: Scalars['String'];
  marketCap: Scalars['BigDecimal'];
  openPrice: BigCurrencyAmount;
  profile: SecurityProfile;
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>;
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile;
  shortName: Scalars['String'];
  symbol: Scalars['TickerSymbol'];
  type: SecurityType;
  volume: Scalars['BigDecimal'];
  week52High: BigCurrencyAmount;
  week52Low: BigCurrencyAmount;
};

/** There was a problem when making the deposits */
export type StoredRdvDepositsInvalid = {
  __typename?: 'StoredRdvDepositsInvalid';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** Deposits have not been initiated yet */
export type StoredRdvDepositsMissing = {
  __typename?: 'StoredRdvDepositsMissing';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type StringKeyAsset = {
  __typename?: 'StringKeyAsset';
  args: Array<Scalars['String']>;
  key: Scalars['StringKey'];
};

export type SubcategoryMessage = {
  __typename?: 'SubcategoryMessage';
  body: Maybe<Scalars['String']>;
  ctaText: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Submission = {
  __typename?: 'Submission';
  bank: BankName;
  created: Scalars['DateTime'];
  feeSynopsis: Maybe<Scalars['String']>;
  key: Scalars['String'];
  linkedAccountId: Scalars['ID'];
  status: SubmissionStatus;
  updated: Scalars['DateTime'];
};

export type SubmissionError = {
  __typename?: 'SubmissionError';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum SubmissionStatus {
  COLLECT = 'COLLECT',
  COMPLETED = 'COMPLETED',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  DELAY_CHARGE = 'DELAY_CHARGE',
  MAIL_IN_ERROR = 'MAIL_IN_ERROR',
  MAIL_IN_ESCALATED = 'MAIL_IN_ESCALATED',
  MAIL_IN_PENDING = 'MAIL_IN_PENDING',
  MAIL_IN_SENT = 'MAIL_IN_SENT',
  PENDING = 'PENDING'
}

export type SubmitBankFeeNegotiationInput = {
  linkedAccountId: Scalars['ID'];
};

export type SubmitBankFeeNegotiationResponse = {
  __typename?: 'SubmitBankFeeNegotiationResponse';
  message: Scalars['String'];
  status: Scalars['String'];
};

export type SubmitBankFeeNegotiationResult = LinkedAccountNotFound | SubmitBankFeeNegotiationResponse;

export type SubmitEarnMissingCreditRequestInput = {
  extensionMerchantName?: InputMaybe<Scalars['String']>;
  merchantId: Scalars['ID'];
  method: EarnPurchaseMethod;
  orderNumber: Scalars['String'];
  proofOfPurchaseUrl: Scalars['URL'];
  purchaseDate: Scalars['Date'];
  subTotal: Scalars['Float'];
  total: Scalars['Float'];
};

export type SubmitEarnMissingCreditRequestResult = EarnMissingCreditRequest | EarnMissingCreditRequestPurchaseDateError;

export type SubmitSpendTransactionsDisputeInput = {
  cardNumber: Scalars['String'];
  disputeReason: Scalars['String'];
  eSignature: Scalars['String'];
  merchantInfo: Scalars['String'];
  message: Scalars['String'];
  selectedTransactions: Array<SpendTransactionsInput>;
  spendCardDetails: Scalars['String'];
};

export type SubmitUserReportedBankFeeRefundInput = {
  refundAmount: Scalars['Amount'];
  submissionId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type SubmitUserReportedBankFeeRefundResult = {
  __typename?: 'SubmitUserReportedBankFeeRefundResult';
  message: Scalars['String'];
};

/** Submittable Switches are performed via Click Switch API. */
export type SubmittableSwitch = SwitchInterface & {
  __typename?: 'SubmittableSwitch';
  requiresEmployerMailingAddress: Maybe<Scalars['Boolean']>;
  requiresNonSsnEmployeeId: Maybe<Scalars['Boolean']>;
  requiresSsnLastFour: Maybe<Scalars['Boolean']>;
  source: SwitchSource;
  type: SwitchType;
  vendorTargetId: Scalars['ID'];
};

export type SubscribeToTierInput = {
  feedback?: InputMaybe<Scalars['String']>;
  tierId: Scalars['ID'];
  tierPriceId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type SubscribeToTierResult = InvalidTier | InvalidTierPrice | TierSubscription;

export type SubscribeUserToTierByProductKeyInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
  /**
   * Subscription requests with an effective date earlier than the current subscription's createdAt
   * timestamp will be ignored. Defaults to current time.
   */
  effectiveAt?: InputMaybe<Scalars['DateTime']>;
  productKey: ProductKey;
  tierGroupId?: InputMaybe<Scalars['ID']>;
};

export type SubscribeUserToTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
  tierPriceId: Scalars['ID'];
};

export type SubscribeUserToTierResult = InvalidTierPriceId | TierDowngradeActionRequired | TierSubscription;

export type SubscriberIneligibleError = {
  __typename?: 'SubscriberIneligibleError';
  message: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to user/bot messages for a particular session */
  onChatMessage: ChatHistoryMessage;
  /** Subscribe to user/bot messages for a particular session. This subscription supports both full messages and partial messages */
  onChatMessageStream: ChatMessageStreamResponse;
  /** Returns new messages created */
  onMessageCreated: Message;
};


export type SubscriptionOnChatMessageArgs = {
  sessionId: Scalars['ID'];
};


export type SubscriptionOnChatMessageStreamArgs = {
  sessionId: Scalars['ID'];
};


export type SubscriptionOnMessageCreatedArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>;
  typeFilters?: InputMaybe<Array<MessageType>>;
};

export type SubscriptionMigration = {
  __typename?: 'SubscriptionMigration';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  effectiveAt: Scalars['DateTime'];
  fromTier: Tier;
  id: Scalars['ID'];
  toTier: Tier;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type SubscriptionMigrationInvalidError = {
  __typename?: 'SubscriptionMigrationInvalidError';
  message: Scalars['String'];
};

export type SubscriptionMigrationWaiver = {
  __typename?: 'SubscriptionMigrationWaiver';
  accepted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  migration: SubscriptionMigration;
  reason: SubscriptionMigrationWaiverReason;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum SubscriptionMigrationWaiverReason {
  FINANCIAL_HARDSHIP = 'FINANCIAL_HARDSHIP'
}

export enum SubscriptionPaymentMethod {
  ach = 'ach',
  amazon = 'amazon',
  apple_pay = 'apple_pay',
  bachs = 'bachs',
  check = 'check',
  credit_card = 'credit_card',
  eft = 'eft',
  google_pay = 'google_pay',
  money_order = 'money_order',
  other = 'other',
  paypal = 'paypal',
  roku = 'roku',
  sepadirectdebit = 'sepadirectdebit',
  wire_transfer = 'wire_transfer'
}

/** transition actions for a subscription */
export enum SubscriptionTransitionAction {
  ADD_PROMOTION = 'ADD_PROMOTION',
  DEACTIVATE = 'DEACTIVATE',
  DOWNGRADE = 'DOWNGRADE',
  UPGRADE = 'UPGRADE'
}

export type SucceedVendorInvoiceResult = BillingVendorError | Invoice;

export type SuggestedMoneyRulesResult = SuggestedMoneyRulesSuccess;

export type SuggestedMoneyRulesSuccess = {
  __typename?: 'SuggestedMoneyRulesSuccess';
  adjustedForIncome: Scalars['Boolean'];
  resultingCategories: Array<MoneyManagerCategory>;
  resultingRuleset: MoneyRulesRuleset;
};

export enum SuitabilityAccountSubtype {
  INDIVIDUAL = 'INDIVIDUAL',
  ROTH_IRA = 'ROTH_IRA',
  SEP_IRA = 'SEP_IRA',
  TRADITIONAL_IRA = 'TRADITIONAL_IRA'
}

export enum SuitabilityAccountType {
  BROKERAGE = 'BROKERAGE',
  RETIREMENT = 'RETIREMENT'
}

export type SuitabilityAnswer = {
  __typename?: 'SuitabilityAnswer';
  answer: Scalars['String'];
  id: Scalars['ID'];
};

export type SuitabilityInput = {
  answerId: Scalars['ID'];
  questionId: Scalars['ID'];
};

export type SuitabilityQuestion = {
  __typename?: 'SuitabilityQuestion';
  answers: Array<Maybe<SuitabilityAnswer>>;
  defaultAnswer: SuitabilityAnswer;
  id: Scalars['ID'];
  pickerId: Scalars['ID'];
  placeholder: Scalars['String'];
};

export type SummaryItem = {
  __typename?: 'SummaryItem';
  amount: CurrencyAmount;
  title: Scalars['String'];
};

export type SupportArticle = {
  __typename?: 'SupportArticle';
  author: SupportAuthor;
  body: Scalars['String'];
  draft: Maybe<Scalars['Boolean']>;
  editedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  labels: Maybe<Array<Maybe<Scalars['String']>>>;
  private: Maybe<Scalars['Boolean']>;
  promoted: Maybe<Scalars['Boolean']>;
  section: SupportSection;
  sectionId: Scalars['ID'];
  slug: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SupportAuthor = {
  __typename?: 'SupportAuthor';
  id: Scalars['ID'];
  name: Scalars['String'];
  photo: SupportAuthorPhoto;
};

export type SupportAuthorPhoto = {
  __typename?: 'SupportAuthorPhoto';
  contentUrl: Scalars['String'];
};

export type SupportCategory = {
  __typename?: 'SupportCategory';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SupportCitation = {
  __typename?: 'SupportCitation';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type SupportSection = {
  __typename?: 'SupportSection';
  articles: Array<Maybe<SupportArticle>>;
  category: SupportCategory;
  categoryId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  description: Scalars['String'];
  id: Scalars['ID'];
  reportingTag: Maybe<Scalars['String']>;
  subCategory: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  url: Scalars['String'];
};

export type SupportTicketForm = {
  __typename?: 'SupportTicketForm';
  active: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  displayName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Maybe<Scalars['Boolean']>;
  ticketFields: Maybe<Array<Maybe<SupportTicketFormField>>>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type SupportTicketFormField = {
  __typename?: 'SupportTicketFormField';
  active: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['DateTime']>;
  customFieldOptions: Maybe<Array<Maybe<CustomFieldOption>>>;
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  required: Maybe<Scalars['Boolean']>;
  systemFieldOptions: Maybe<Array<Maybe<CustomFieldOption>>>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type SupportTicketResponse = RecaptchaException | SupportTicket;

export type SupportTicketWithCustomFieldsResponse = SubmissionError | SupportTicket;

export type SupportUser = {
  __typename?: 'SupportUser';
  email: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** Response returned if the bank is supported for Plaid Verification. */
export type SupportsPlaidVerificationResult = {
  __typename?: 'SupportsPlaidVerificationResult';
  /** Plaid Verification supports this Bank */
  supportsPlaidVerificationType: Scalars['Boolean'];
};

export type SuppressMoneyManagerRebalancesError = {
  __typename?: 'SuppressMoneyManagerRebalancesError';
  message: Scalars['String'];
};

export type SuppressMoneyManagerRebalancesInput = {
  rebalanceSuppressionSource: MoneyManagerRebalanceSuppressionSource;
};

export type SuppressMoneyManagerRebalancesResult = SuppressMoneyManagerRebalancesError | SuppressMoneyManagerRebalancesSuccess;

export type SuppressMoneyManagerRebalancesSuccess = {
  __typename?: 'SuppressMoneyManagerRebalancesSuccess';
  rebalancesSuppressedFrom: MoneyManagerRebalanceSuppressionSource;
};

/** Common attributes for all Switch Types */
export type SwitchInterface = {
  source: SwitchSource;
  type: SwitchType;
};

export enum SwitchMethod {
  /** Used clickswitch */
  clickswitch = 'clickswitch',
  /** Used clickswitch and online */
  clickswitchOnline = 'clickswitchOnline',
  /** Used clickswitch, online, and PDF */
  clickswitchOnlinePdf = 'clickswitchOnlinePdf',
  /** Used clickswitch and PDF */
  clickswitchPdf = 'clickswitchPdf',
  /** None */
  none = 'none',
  /** Used online */
  online = 'online',
  /** Used online and PDF */
  onlinePdf = 'onlinePdf',
  /** Used pdf */
  pdf = 'pdf',
  /** Unknown */
  unknown = 'unknown'
}

export type SwitchPayloadInterface = {
  userSwitch: UserSwitch;
};

export enum SwitchSource {
  acorns = 'acorns',
  clickSwitch = 'clickSwitch'
}

export enum SwitchState {
  /** Attempted to setup direct deposit */
  attempted = 'attempted',
  /** User has not interacted with direct deposit in Acorns */
  noInteraction = 'noInteraction',
  /** Completed direct deposit setup */
  switched = 'switched',
  /** Viewed PDF screen or went to Online Portal */
  viewed = 'viewed'
}

export enum SwitchStatus {
  /** Deposit confirmed in Spend account */
  completed = 'completed',
  /** New for processing */
  new = 'new',
  /** PDF downloaded */
  pdfDownloaded = 'pdfDownloaded',
  /** PDF generated */
  pdfGenerated = 'pdfGenerated',
  /** Ready for processing */
  ready = 'ready',
  /** Sent to ClickSwitch */
  submitted = 'submitted'
}

export enum SwitchType {
  /** Online */
  online = 'online',
  /** Default PDF */
  pdf = 'pdf',
  /** Submittable Generic */
  submittable = 'submittable',
  /** Submittable Custom */
  submittableCustom = 'submittableCustom'
}

export type SyncBankFeeTransactionsInput = {
  userId: Scalars['ID'];
};

export type SyncBankFeeTransactionsResult = {
  __typename?: 'SyncBankFeeTransactionsResult';
  message: Scalars['String'];
};

export type SyncFundingSourceToVendorResult = BillingVendorError | DuplicateBillingInfoError | VendorBillingInfo;

export type SyncSupportAccountInput = {
  id: Scalars['ID'];
};

export type SyncSupportAccountResponse = {
  __typename?: 'SyncSupportAccountResponse';
  eventId: Scalars['String'];
};

export type SystemCardLockedSpendAlert = SpendAlert & {
  __typename?: 'SystemCardLockedSpendAlert';
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/** Optional filter for getting customer accounts a user can deposit to. */
export type TargetAccountsFilterInput = {
  /** Filter accounts that are able to be deposited into at this time. */
  isDepositAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Filter accounts that a specified account can deposit into. */
  sourceAccountId?: InputMaybe<Scalars['ID']>;
};

export enum TaxApplicationStatus {
  CANCELLED = 'CANCELLED',
  NOT_STARTED = 'NOT_STARTED',
  QUESTIONNAIRE_COMPLETED = 'QUESTIONNAIRE_COMPLETED',
  QUESTIONNAIRE_IN_PROGRESS = 'QUESTIONNAIRE_IN_PROGRESS',
  READY_TO_SUBMIT = 'READY_TO_SUBMIT',
  SUBMITTED = 'SUBMITTED'
}

export type TaxFilingPartner = {
  __typename?: 'TaxFilingPartner';
  accountUsed: Maybe<RefundBankAccount>;
  disqualificationReason: Maybe<Scalars['String']>;
  federalReturn: Maybe<TaxReturn>;
  isStateFiled: Maybe<Scalars['Boolean']>;
  isUserDisqualified: Maybe<Scalars['Boolean']>;
  netRefundAmount: Maybe<MonetaryAmount>;
  refundToAcorns: Maybe<Scalars['Boolean']>;
  stateReturns: Maybe<Array<Maybe<TaxReturn>>>;
  taxAppStatus: TaxApplicationStatus;
};

export enum TaxFormType {
  form1099 = 'form1099',
  form1099BDIV = 'form1099BDIV',
  form1099MISC = 'form1099MISC',
  form1099R = 'form1099R',
  form1099R1 = 'form1099R1',
  form1099R2 = 'form1099R2',
  form1099R4 = 'form1099R4',
  form1099R7 = 'form1099R7',
  form1099R8 = 'form1099R8',
  form1099RE = 'form1099RE',
  form1099RJ = 'form1099RJ',
  form1099RQ = 'form1099RQ',
  form1099RT = 'form1099RT',
  form5498 = 'form5498',
  other = 'other'
}

export type TaxReturn = {
  __typename?: 'TaxReturn';
  lastSubmissionDate: Maybe<Scalars['Date']>;
  refundAmount: MonetaryAmount;
  rejectedReason: Maybe<Scalars['String']>;
  returnStatus: TaxReturnStatus;
  taxLocationCode: Scalars['String'];
};

export enum TaxReturnStatus {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_LEGACY = 'ACCEPTED_LEGACY',
  FILED_PENDING_RESPONSE = 'FILED_PENDING_RESPONSE',
  NOT_FILED = 'NOT_FILED',
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  REJECTED = 'REJECTED',
  RETRYABLE = 'RETRYABLE',
  SUBMITTED = 'SUBMITTED'
}

export type TaxWithholdingAmounts = {
  __typename?: 'TaxWithholdingAmounts';
  /** total amount that will be withheld from the feds */
  federalWithholdingAmount: MonetaryAmount;
  /** total amount that will be withheld from the state */
  stateWithholdingAmount: MonetaryAmount;
};

export type TaxWithholdings = {
  federalTaxPercentage: Scalars['Float'];
  stateTaxPercentage: Scalars['Float'];
};

export enum TfaNotification {
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
}

export type TfaOptions = {
  __typename?: 'TfaOptions';
  email: Maybe<Array<Scalars['String']>>;
  notification: Maybe<Array<TfaNotification>>;
  phone: Maybe<Array<Scalars['String']>>;
  question: Maybe<Array<Scalars['String']>>;
};

export enum TfaStatus {
  AUTHORIZED = 'AUTHORIZED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  REQUIRED = 'REQUIRED'
}

export enum TfaType {
  EMAIL = 'EMAIL',
  NOTIFICATION = 'NOTIFICATION',
  PENDING = 'PENDING',
  PHONE = 'PHONE',
  QUESTION = 'QUESTION'
}

export type Tier = {
  __typename?: 'Tier';
  /** Indicates whether a tier is active or deprecated */
  active: Scalars['Boolean'];
  /** Image asset path in CDN */
  assetPath: Maybe<Scalars['String']>;
  /** Associated grouping of products */
  bundles: Maybe<Array<Bundle>>;
  description: Scalars['String'];
  /** Name of tier to display in certain positions where space is limited */
  displayName: Maybe<Scalars['String']>;
  /** @deprecated Use Query.products and Tier.products instead. */
  excludedProducts: Array<TierProduct>;
  id: Scalars['ID'];
  /** @deprecated Use Query.products and Tier.products instead. */
  includedProducts: Array<TierProduct>;
  key: TierKey;
  matchProgram: Maybe<MatchProgram>;
  name: Scalars['String'];
  /** Associated Products available when subscribed to this Tier. */
  products: Maybe<Array<Product>>;
  /**
   * (DONT USE) Internal only, may be removed without warning.
   * @deprecated Use Query.tierGroupForUser to determine the subscriber's Tier Group.
   */
  tierGroupId: Scalars['ID'];
  /** Price of Tier */
  tierPrice: TierPrice;
};


export type TierMatchProgramArgs = {
  investmentAccountType: InvestmentAccountType;
};

/** Individual action in a list of required actions */
export type TierDowngradeAction = {
  __typename?: 'TierDowngradeAction';
  key: TierDowngradeActionKey;
};

/** Actions that must be taken to complete a downgrade workflow */
export enum TierDowngradeActionKey {
  CLOSE_EARLY_ACCOUNT = 'CLOSE_EARLY_ACCOUNT',
  CLOSE_EMERGENCY_FUND_ACCOUNT = 'CLOSE_EMERGENCY_FUND_ACCOUNT',
  CLOSE_INVEST_ACCOUNT = 'CLOSE_INVEST_ACCOUNT',
  CLOSE_LATER_ACCOUNT = 'CLOSE_LATER_ACCOUNT',
  CLOSE_SELF_DIRECTED_INVEST = 'CLOSE_SELF_DIRECTED_INVEST',
  CLOSE_SPEND_ACCOUNT = 'CLOSE_SPEND_ACCOUNT'
}

/** The list of required actions */
export type TierDowngradeActionRequired = {
  __typename?: 'TierDowngradeActionRequired';
  actions: Array<TierDowngradeAction>;
};

/** Grouping of Tiers w/default tier, etc. */
export type TierGroup = {
  __typename?: 'TierGroup';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  /** Used to key A/B test off of */
  id: Scalars['ID'];
  /** Tier ID which is the "preferred" one (i.e "Acorns recommends") */
  preferredTierId: Scalars['ID'];
  tierOptions: Array<TierOption>;
  updatedAt: Scalars['DateTime'];
  winbackTierOption: Maybe<TierOption>;
};

export enum TierKey {
  /** Hardship $1 tier for our winback campaign */
  ASSIST = 'ASSIST',
  /** Legacy $2 SPEND tier */
  BRONZE = 'BRONZE',
  COPPER = 'COPPER',
  /** Promotional tier for Cricket Wireless subscribers. */
  CRICKET = 'CRICKET',
  GOLD = 'GOLD',
  /** Promotional free tier for active military and veterans */
  MILITARY = 'MILITARY',
  NULL = 'NULL',
  PLATINUM = 'PLATINUM',
  SILVER = 'SILVER'
}

/** Combination of a Tier and available prices to choose from. */
export type TierOption = {
  __typename?: 'TierOption';
  preferredTierPrice: TierPrice;
  tier: Tier;
  tierPrices: Array<TierPrice>;
};

export type TierOptionByTierPriceIdResult = InvalidTierPriceId | TierOption;

/** Pricing configuration used for a tier */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `amountV2`. */
  amount: CurrencyAmount;
  amountV2: MicrosMoney;
  billingFrequency: BillingFrequency;
  id: Scalars['ID'];
  /** (DONT USE) Internal only, may be removed without warning. */
  tierId: Scalars['ID'];
};

/** (Deprecated) Minimal representation of an Acorns product. */
export type TierProduct = {
  __typename?: 'TierProduct';
  /** used as unique identifier for this product */
  key: ProductKey;
};

/** Unique combo of Tier and TierPrice tied to a User */
export type TierSubscription = {
  __typename?: 'TierSubscription';
  /** Reference to an Promotion the subscriber is actively consuming. */
  activePromotion: Maybe<Promotion>;
  createdAt: Scalars['DateTime'];
  createdBy: Maybe<TierSubscriptionCreatedBy>;
  id: Scalars['ID'];
  migration: Maybe<SubscriptionMigration>;
  migrationId: Maybe<Scalars['ID']>;
  /** The Offer the subscriber subscribed to for access to their Tier. */
  offer: Maybe<Offer>;
  /** Indicates when the subscribers current Offer expires. */
  offerExpiresAt: Maybe<Scalars['DateTime']>;
  /** Previous tier subscription the user had before this one. */
  previous: Maybe<TierSubscription>;
  /** Indicates when a promotion was applied to the subscription. */
  promotionAppliedAt: Maybe<Scalars['DateTime']>;
  /** Indication of when a subscribers promotion ends. */
  promotionExpiresAt: Maybe<Scalars['DateTime']>;
  status: TierSubscriptionStatus;
  tier: Tier;
  tierPrice: TierPrice;
  transition: Maybe<TierSubscriptionTransition>;
  updatedAt: Scalars['DateTime'];
  /** Flag to indicate if the subscription is being managed by our billing/subscription vendor */
  vendorIntegrated: Maybe<Scalars['Boolean']>;
};

export type TierSubscriptionAlreadyDeactivated = {
  __typename?: 'TierSubscriptionAlreadyDeactivated';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type TierSubscriptionConnection = {
  __typename?: 'TierSubscriptionConnection';
  edges: Array<TierSubscription>;
  pageInfo: TierSubscriptionPageInfo;
};

export enum TierSubscriptionCreatedBy {
  /** Subscription created by the pre-launch backfill script */
  BACKFILL = 'BACKFILL',
  /** Flag to indicate user ought to be billed by the "legacy" billing system */
  LEGACY_USER = 'LEGACY_USER',
  /** Subscription record that was created as a result of a migration */
  MIGRATION = 'MIGRATION',
  /** User auto-subscribed based on the status of their open accounts */
  SUBSCRIBED_BY_OPEN_ACCOUNTS = 'SUBSCRIBED_BY_OPEN_ACCOUNTS',
  /** Subscription created via INTERNAL client request (either an admin or an internal process) */
  SYSTEM = 'SYSTEM',
  /** Subscription created via EXTERNAL client request */
  USER = 'USER'
}

/** account deactivation reasons */
export enum TierSubscriptionDeactivationReason {
  ACORNS_COSTS_TOO_MUCH = 'ACORNS_COSTS_TOO_MUCH',
  CANT_AFFORD_TO_INVEST_AT_THIS_TIME = 'CANT_AFFORD_TO_INVEST_AT_THIS_TIME',
  CONCERNED_ABOUT_THE_MARKET = 'CONCERNED_ABOUT_THE_MARKET',
  DONT_WANT_TO_INVEST = 'DONT_WANT_TO_INVEST',
  NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS = 'NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS',
  NOT_SURE_HOW_ACORNS_WORKS = 'NOT_SURE_HOW_ACORNS_WORKS',
  NOT_THE_RIGHT_TIME_TO_INVEST = 'NOT_THE_RIGHT_TIME_TO_INVEST',
  OTHER = 'OTHER',
  POOR_INVESTMENT_PERFORMANCE = 'POOR_INVESTMENT_PERFORMANCE',
  SWITCHING_TO_ANOTHER_SERVICE = 'SWITCHING_TO_ANOTHER_SERVICE',
  THIS_IS_TEMPORARY_ILL_BE_BACK = 'THIS_IS_TEMPORARY_ILL_BE_BACK',
  TROUBLE_CONNECTING_MY_BANK = 'TROUBLE_CONNECTING_MY_BANK',
  UNEXPECTED_CHARGES_TO_MY_BANK = 'UNEXPECTED_CHARGES_TO_MY_BANK'
}

export type TierSubscriptionForUser = TierSubscription | TierSubscriptionNotFound | TierSubscriptionUnsubscribed;

/** Returned if there is no found tier subscription */
export type TierSubscriptionNotFound = {
  __typename?: 'TierSubscriptionNotFound';
  message: Scalars['String'];
};

/** Metadata for pagination of Tier Subscription History */
export type TierSubscriptionPageInfo = {
  __typename?: 'TierSubscriptionPageInfo';
  cursor: Maybe<Scalars['String']>;
  hasNext: Scalars['Boolean'];
};

/** Status of a tier subscription */
export enum TierSubscriptionStatus {
  /** An active subscription */
  ACTIVE = 'ACTIVE',
  /** A cancelled subscription */
  INACTIVE = 'INACTIVE',
  /** In the process of either upgrading or downgrading a subscription */
  TRANSITIONING = 'TRANSITIONING'
}

/** Information about a transitioning subscription */
export type TierSubscriptionTransition = {
  __typename?: 'TierSubscriptionTransition';
  desiredTier: Maybe<Tier>;
  /** Once we've decoupled our Tier and TierPrice, we'll need to make sure we're subscribing the user to the proper Tier and TierPrice */
  desiredTierPrice: Maybe<TierPrice>;
  initiatedAt: Scalars['DateTime'];
  subscriptionDeactivationReason: Maybe<TierSubscriptionDeactivationReason>;
  transitionAction: SubscriptionTransitionAction;
};

/** User has unsubscribed from their tier (account closed) */
export type TierSubscriptionUnsubscribed = {
  __typename?: 'TierSubscriptionUnsubscribed';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export enum TimeFrameFilter {
  month = 'month',
  ninetyDays = 'ninetyDays',
  thirtyDays = 'thirtyDays',
  year = 'year'
}

export type TimestampsInterface = {
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export type Toggle = {
  __typename?: 'Toggle';
  id: Scalars['String'];
  invalid: Maybe<Scalars['Boolean']>;
  value: Scalars['Boolean'];
};

export type TokenExpiredException = {
  __typename?: 'TokenExpiredException';
  message: Maybe<Scalars['String']>;
};

/** Top Employer Name and Logo */
export type TopEmployer = {
  __typename?: 'TopEmployer';
  /** Employer Name */
  employerName: Scalars['String'];
  /** Employer switch type */
  employerSwitchType: SwitchType;
  /** Employer Logo URL */
  logo: Scalars['String'];
  /** Employer online URL */
  onlineSwitchUrl: Maybe<Scalars['String']>;
};

/** Top Employer List */
export type TopEmployerPayload = {
  __typename?: 'TopEmployerPayload';
  topEmployersList: Array<TopEmployer>;
};

export type TopHolding = {
  __typename?: 'TopHolding';
  /** The market value that this security makes up of the ETF */
  marketValue: BigCurrencyAmount;
  /** The number of shares that this security makes up of the ETF */
  numberOfShares: Maybe<Scalars['BigDecimal']>;
  securityName: Scalars['String'];
  /** The percentage of shares that this security makes up of the ETF */
  sharePercentage: Scalars['BigDecimal'];
  symbol: Maybe<Scalars['TickerSymbol']>;
};

export type TotalAmounts = {
  __typename?: 'TotalAmounts';
  totalContributedAmount: CurrencyAmount;
  totalDepositedAmount: CurrencyAmount;
};

export enum TradingSector {
  BASIC_MATERIALS = 'BASIC_MATERIALS',
  COMMUNICATION_SERVICES = 'COMMUNICATION_SERVICES',
  CONSUMER_CYCLICAL = 'CONSUMER_CYCLICAL',
  CONSUMER_DEFENSIVE = 'CONSUMER_DEFENSIVE',
  ENERGY = 'ENERGY',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  HEALTH_CARE = 'HEALTH_CARE',
  INDUSTRIALS = 'INDUSTRIALS',
  REAL_ESTATE = 'REAL_ESTATE',
  TECHNOLOGY = 'TECHNOLOGY',
  UTILITIES = 'UTILITIES'
}

export type Transaction = {
  __typename?: 'Transaction';
  amount: Maybe<Scalars['Float']>;
  backupPaymentMethodUsed: Maybe<Scalars['Boolean']>;
  collectedAt: Maybe<Scalars['DateTime']>;
  collectionMethod: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['String']>;
  object: Maybe<Scalars['String']>;
  origin: Maybe<Scalars['String']>;
  originalTransactionId: Maybe<Scalars['String']>;
  refunded: Maybe<Scalars['Boolean']>;
  status: Maybe<Scalars['String']>;
  subscriptionIds: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Maybe<Scalars['Boolean']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  uuid: Maybe<Scalars['String']>;
  voidedAt: Maybe<Scalars['DateTime']>;
};

export enum TransactionCategory {
  FEE = 'FEE',
  REFUND = 'REFUND'
}

export enum TransactionType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

/** Transfer transactions object */
export type Transfer = {
  __typename?: 'Transfer';
  amount: CurrencyAmount;
  /** When this was cancelled. NULL if never cancelled */
  canceledAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  from: TransferableAccount;
  id: Scalars['ID'];
  state: TransferState;
  to: TransferableAccount;
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime'];
};

export enum TransferAction {
  /** Initiate a one time deposit to the top level account. */
  ONE_TIME_DEPOSIT = 'ONE_TIME_DEPOSIT',
  /** Initiate a one time withdrawal from the top level account. */
  ONE_TIME_WITHDRAWAL = 'ONE_TIME_WITHDRAWAL',
  /** Initiate a recurring deposit to the top level account. */
  RECURRING_DEPOSIT = 'RECURRING_DEPOSIT'
}

export enum TransferState {
  canceled = 'canceled',
  completed = 'completed',
  initiated = 'initiated',
  transferring = 'transferring'
}

export type TransferableAccount = {
  __typename?: 'TransferableAccount';
  /** The last 4 digits of the account or null if unavailable */
  accountNumberMasked: Maybe<Scalars['String']>;
  /** A snapshot of the accounts last balance if available to acorns. External accounts wont have this. This is the value of the AVAILABLE balance. */
  balance: Maybe<CurrencyAmount>;
  /** Whether an account is linked from plaid, spend, paypal, direct_bank or manual */
  externalSource: Maybe<ExternalSource>;
  id: Scalars['ID'];
  /** The name of the account. e.g. Chase Checking */
  name: Scalars['String'];
  /** The type of Acorns account we are tracking for the user */
  type: TransferableAccountTypeEnum;
};

export enum TransferableAccountTypeEnum {
  core = 'core',
  early = 'early',
  external = 'external',
  later = 'later',
  save = 'save',
  spend = 'spend'
}

/** Info on accounts that can be transferred from */
export type TransferableFrom = {
  __typename?: 'TransferableFrom';
  from: TransferableAccount;
};

/** Info about accounts that can be transferred to */
export type TransferableTo = {
  __typename?: 'TransferableTo';
  /** This field will be null if there is no max limit */
  max: Maybe<CurrencyAmount>;
  /** This field will be null if there is no max limit */
  min: Maybe<CurrencyAmount>;
  to: TransferableAccount;
};

export type TrendingLearnContentPreview = LearnArticlePreview | LearnArticlePreviewLocked | LearnMediaPreview | LearnMediaPreviewLocked;

/** Entity describing the TrustedContact for a user's InvestmentAccount(s) */
export type TrustedContact = {
  __typename?: 'TrustedContact';
  /** Email of trusted contact */
  email: Scalars['Email'];
  /** First name of the trusted contact */
  firstName: Scalars['String'];
  /** ID of the trusted contact */
  id: Scalars['ID'];
  investmentAccounts: Array<Maybe<InvestmentAccount>>;
  /** Last name of the trusted contact */
  lastName: Scalars['String'];
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber'];
  /** ID of the user that the contact belongs to */
  userId: Scalars['ID'];
};

/** Trusted contact email/phone not unique under user scope */
export type TrustedContactAlreadyExistsException = {
  __typename?: 'TrustedContactAlreadyExistsException';
  /** attributes that failed uniqueness check */
  attributes: Array<Scalars['String']>;
  /** error message */
  message: Scalars['String'];
};

/** Fields for adding/editing a trusted contact. */
export type TrustedContactInput = {
  /** Email of trusted contact */
  email: Scalars['Email'];
  /** First name of the trusted contact */
  firstName: Scalars['String'];
  /** All investment account ids that this TrustedContact should be assigned to */
  investmentAccountIds: Array<Scalars['ID']>;
  /** Last name of the trusted contact */
  lastName: Scalars['String'];
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber'];
};

/** Trusted contact email invalid */
export type TrustedContactInvalidEmail = {
  __typename?: 'TrustedContactInvalidEmail';
  /** error message */
  message: Scalars['String'];
};

/** Trusted contact phone number invalid */
export type TrustedContactInvalidPhoneNumber = {
  __typename?: 'TrustedContactInvalidPhoneNumber';
  /** error message */
  message: Scalars['String'];
};

/** TrustedContact does not exist */
export type TrustedContactNotFoundException = {
  __typename?: 'TrustedContactNotFoundException';
  /** message */
  message: Scalars['String'];
};

export enum Type {
  charge = 'charge',
  credit = 'credit'
}

export enum UsStateCodes {
  /** Armed Forces America */
  AA = 'AA',
  /** Armed Forces Europe */
  AE = 'AE',
  /** Alaska */
  AK = 'AK',
  /** Alabama */
  AL = 'AL',
  /** Armed Forces Pacific */
  AP = 'AP',
  /** Arkansas */
  AR = 'AR',
  /** American Samoa */
  AS = 'AS',
  /** Arizona */
  AZ = 'AZ',
  /** California */
  CA = 'CA',
  /** Colorado */
  CO = 'CO',
  /** Connecticut */
  CT = 'CT',
  /** District Of Columbia */
  DC = 'DC',
  /** Delaware */
  DE = 'DE',
  /** Florida */
  FL = 'FL',
  /** Federated States Of Micronesia */
  FM = 'FM',
  /** Georgia */
  GA = 'GA',
  /** Guam */
  GU = 'GU',
  /** Hawaii */
  HI = 'HI',
  /** Iowa */
  IA = 'IA',
  /** Idaho */
  ID = 'ID',
  /** Illinois */
  IL = 'IL',
  /** Indiana */
  IN = 'IN',
  /** Kansas */
  KS = 'KS',
  /** Kentucky */
  KY = 'KY',
  /** Louisiana */
  LA = 'LA',
  /** Massachusetts */
  MA = 'MA',
  /** Maryland */
  MD = 'MD',
  /** Maine */
  ME = 'ME',
  /** Marshall Islands */
  MH = 'MH',
  /** Michigan */
  MI = 'MI',
  /** Minnesota */
  MN = 'MN',
  /** Missouri */
  MO = 'MO',
  /** Northern Mariana Islands */
  MP = 'MP',
  /** Mississippi */
  MS = 'MS',
  /** Montana */
  MT = 'MT',
  /** North Carolina */
  NC = 'NC',
  /** North Dakota */
  ND = 'ND',
  /** Nebraska */
  NE = 'NE',
  /** New Hampshire */
  NH = 'NH',
  /** New Jersey */
  NJ = 'NJ',
  /** New Mexico */
  NM = 'NM',
  /** Nevada */
  NV = 'NV',
  /** New York */
  NY = 'NY',
  /** Ohio */
  OH = 'OH',
  /** Oklahoma */
  OK = 'OK',
  /** Oregon */
  OR = 'OR',
  /** Pennsylvania */
  PA = 'PA',
  /** Puerto Rico */
  PR = 'PR',
  /** Palau */
  PW = 'PW',
  /** Rhode Island */
  RI = 'RI',
  /** South Carolina */
  SC = 'SC',
  /** South Dakota */
  SD = 'SD',
  /** Tennessee */
  TN = 'TN',
  /** Texas */
  TX = 'TX',
  /** Utah */
  UT = 'UT',
  /** Virginia */
  VA = 'VA',
  /** U.S. Virgin Islands */
  VI = 'VI',
  /** Vermont */
  VT = 'VT',
  /** Washington */
  WA = 'WA',
  /** Wisconsin */
  WI = 'WI',
  /** West Virginia */
  WV = 'WV',
  /** Wyoming */
  WY = 'WY'
}

export type UnableToCancelCheckError = {
  __typename?: 'UnableToCancelCheckError';
  requestId: Scalars['ID'];
};

/** Input for unauthenticated creation of an upload url for direct to s3 upload */
export type UnauthenticatedCreateUploadUrlInput = {
  /** the document type of the upload document */
  documentType: DocumentType;
  /** the file_name upload document */
  fileName: Scalars['String'];
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String'];
};

/** Input for saving an upload url after direct to s3 upload */
export type UnauthenticatedSaveUploadUrlInput = {
  /** the suspended upload additional info */
  additionalInfo?: InputMaybe<Scalars['String']>;
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String'];
  /** the upload uuid from the upload object */
  uploadUuids: Array<Scalars['ID']>;
};

/** LegacyUploadDocumentResult */
export type UnauthenticatedSaveUploadUrlResult = DocumentUploads | UploadSaveError;

export type UnauthorizedException = {
  __typename?: 'UnauthorizedException';
  message: Maybe<Scalars['String']>;
};

export type UnauthorizedModifyLockedContentError = {
  __typename?: 'UnauthorizedModifyLockedContentError';
  message: Scalars['String'];
};

export type UnblockDeviceInput = {
  deviceId: Scalars['ID'];
};

export type UnblockDeviceResult = Device | DeviceNotFoundException;

export type UnlinkOidcCredentialsInput = {
  oidcProvider: OidcProvider;
};

export type UnlinkOidcCredentialsResult = OidcCredentialsNotFoundException | UnlinkOidcCredentialsSuccess;

export type UnlinkOidcCredentialsSuccess = {
  __typename?: 'UnlinkOidcCredentialsSuccess';
  email: Maybe<Scalars['EmailAddress']>;
  oidcProvider: Maybe<OidcProvider>;
  status: Maybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type UnlockBankCardPayload = {
  __typename?: 'UnlockBankCardPayload';
  bankCard: Maybe<BankCard>;
};

export type UnmarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID'];
};

export type UnmarkLearnContentAsHelpfulResult = RecordDoesNotExistError | UpdateLearnContentHelpfulnessResult;

/** Account is not eligible for onboarding completion due to missing required info */
export type UnmetRequirementsException = {
  __typename?: 'UnmetRequirementsException';
  requirements: Array<OnboardingRequirement>;
};

/** Error indicating that request cannot be retried */
export type UnrecoverableError = {
  __typename?: 'UnrecoverableError';
  /** Reason why error occurred */
  reason: Scalars['String'];
};

/** The LinkedAccount associated with the linked_account_id will never be valid with the external provider */
export type UnrecoverableLinkedAccountError = {
  __typename?: 'UnrecoverableLinkedAccountError';
  /** ID of the unrecoverable LinkedAccount */
  linkedAccountId: Scalars['ID'];
};

export type UnsubscribeUserFromTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>;
};

export type UnsubscribeUserFromTierResult = TierDowngradeActionRequired | TierSubscriptionUnsubscribed;

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlert = Alert & {
  __typename?: 'UnverifiedBeneficiarySsnAlert';
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary;
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID'];
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String'];
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlertItem = UserAlertsItem & {
  __typename?: 'UnverifiedBeneficiarySsnAlertItem';
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** Source attribute object containing properties that can be updated. */
export type UpdatableAttributesInput = {
  /** Name of targeted group for ad in Adjust */
  adGroup?: InputMaybe<Scalars['String']>;
  /** Name of campaign in Adjust */
  campaign?: InputMaybe<Scalars['String']>;
  /** Click label of install with referral ID in Adjust */
  clickLabel?: InputMaybe<Scalars['String']>;
  /** Creative content name in Adjust */
  creative?: InputMaybe<Scalars['String']>;
  /** Name of funnel user wants to experience */
  funnel?: InputMaybe<FunnelName>;
  /** Identifier for the prospect's attribution channel */
  sourceID?: InputMaybe<Scalars['String']>;
  /** Full name of tracker in Adjust */
  trackerName?: InputMaybe<Scalars['String']>;
  /** Six character token ID in Adjust */
  trackerToken?: InputMaybe<Scalars['String']>;
};

/** Input to update account portfolio */
export type UpdateAccountPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID'];
  /** Portfolio Risk Type */
  riskLevel: PortfolioRiskLevel;
  /** Portfolio theme */
  theme: PortfolioTheme;
};

/** Update Account Portfolio Response */
export type UpdateAccountPortfolioResponse = InvalidActionOnAccount | InvestmentAccount | InvestmentAccountNotFoundException | PortfolioNotFoundException | PortfolioUpdateFailedException;

export type UpdateAttributionInput = {
  /** Email address for prospect used during initial sign-up */
  email?: InputMaybe<Scalars['String']>;
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: UpdatableAttributesInput;
  /** Unique user identifier */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Union for the result of the updateAttribution mutation */
export type UpdateAttributionResult = InvalidConversionIdentifierException | InvalidSourceAttributesException | NoProspectRecord | RegistrationFunnel;

export type UpdateAuthEmailInput = {
  email: Scalars['EmailAddress'];
};

export type UpdateAuthEmailResult = AuthProfile | ExistingEmailVerifiedException;

export type UpdateAuthPhoneNumberInput = {
  phoneNumber: Scalars['PhoneNumber'];
};

export type UpdateAuthPhoneNumberResult = AuthProfile | InvalidPhoneNumberException;

export type UpdateBankAccountGoalInput = {
  accountId: Scalars['ID'];
  currentGoal: BankAccountGoalInput;
};

export type UpdateBankAccountGoalPayload = {
  __typename?: 'UpdateBankAccountGoalPayload';
  requestId: Scalars['ID'];
};

export type UpdateBankAccountGoalResult = UpdateBankAccountGoalPayload;

export type UpdateBankCardPinInput = {
  newPin: Scalars['BankCardPin'];
};

export type UpdateBankCardPinPayload = {
  __typename?: 'UpdateBankCardPinPayload';
  bankCard: Maybe<BankCard>;
};

export type UpdateBannersInput = {
  helpcenter?: InputMaybe<HelpcenterContentInput>;
  sitewide?: InputMaybe<SiteWideBannerContentInput>;
};

/** Response to a beneficiary update */
export type UpdateBeneficiaryInfoResult = Beneficiary | BeneficiaryNotFoundException | InternalErrorException | InvalidAddressException | InvalidEmailException | InvalidPhoneException;

export type UpdateBenefitStatusInput = {
  benefitProductKey: BenefitsTrackerProducts;
  claimStatus: ClaimStatus;
  claimedOn?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Array<InputMaybe<BenefitStatusDetail>>>;
  expiresOn?: InputMaybe<Scalars['DateTime']>;
  updatedBy: Scalars['String'];
};

export type UpdateBenefitStatusResponse = {
  __typename?: 'UpdateBenefitStatusResponse';
  message: Scalars['String'];
};

export type UpdateCredentialsResult = BlockedEmailDomainException | Credentials | EmailTakenException | UserCredentialsNotFoundException;

export type UpdateDelegateResult = DelegateDefinition;

export type UpdateElapsedTimeForLearnQuizInput = {
  elapsedTimeMilliseconds: MillisecondsInput;
  quizId: Scalars['ID'];
};

export type UpdateElapsedTimeForLearnQuizResult = LearnContentElapsedMillisecondsUpdatedResult | RecordDoesNotExistError;

export type UpdateLearnContentHelpfulnessResult = {
  __typename?: 'UpdateLearnContentHelpfulnessResult';
  contentId: Scalars['ID'];
  isHelpful: Scalars['Boolean'];
};

export type UpdateLearnProgressInput = {
  contentId: Scalars['ID'];
  contentProgress: LearnProgressInput;
};

export type UpdateLearnProgressResult = LearnProgressUpdatedResult | RecordDoesNotExistError;

/** Attributes for updating the linked account */
export type UpdateLinkedAccountInput = {
  /** Plaid link session id */
  linkSessionId: Scalars['String'];
};

export type UpdateMessageFailed = {
  __typename?: 'UpdateMessageFailed';
  errorMessage: Scalars['String'];
};

export type UpdateMessageIgnored = {
  __typename?: 'UpdateMessageIgnored';
  requestId: Scalars['ID'];
};

export type UpdateMessageResult = AlertMessage | LegacyAlertDismissalSuccess | NotificationMessage | UpdateMessageIgnored;

export type UpdateMessagesFailure = {
  __typename?: 'UpdateMessagesFailure';
  errorMessage: Scalars['String'];
};

/** Input type for updating MoneyManager allocations. */
export type UpdateMoneyManagerAllocationsInput = {
  allocations: Array<MoneyManagerStagedRulesInput>;
  archetype?: InputMaybe<MoneyRulesArchetype>;
  isCustomized: Scalars['Boolean'];
};

/** Represents the result of the updateMoneyManagerAllocations mutation, which can be either a success or an error. */
export type UpdateMoneyManagerAllocationsResult = AcornsValidationError | AllocationAmountsSumExceedingMaxError | InvalidSingleRuleIdError | MismatchedDistributionUnitsError | MissingValidRulesetError | NonUniqueSingleRuleIdsError | UpdateMoneyManagerAllocationsSuccess;

/**
 * Represents a successful update of MoneyManager allocations.
 * Returns the list of money rules after the change.
 */
export type UpdateMoneyManagerAllocationsSuccess = {
  __typename?: 'UpdateMoneyManagerAllocationsSuccess';
  categories: Array<MoneyManagerCategory>;
  rules: Array<MoneyRulesRule>;
};

export type UpdateMoneyManagerAutomationTargetInput = {
  amount: MoneyRulesCurrencyAmountInput;
  customSelection: Scalars['Boolean'];
  suggestedPeriod?: InputMaybe<MoneyManagerPeriodInput>;
  type: MoneyManagerAutomationTargetType;
};

export type UpdateMoneyManagerAutomationTargetResult = MoneyManagerInputError | UpdateMoneyManagerAutomationTargetSuccess;

/** The new state of the user's automation targets */
export type UpdateMoneyManagerAutomationTargetSuccess = {
  __typename?: 'UpdateMoneyManagerAutomationTargetSuccess';
  automationTargets: Array<Maybe<MoneyManagerAutomationTarget>>;
};

export type UpdateMoneyManagerSettingsFailure = {
  __typename?: 'UpdateMoneyManagerSettingsFailure';
  reason: Scalars['String'];
};

export type UpdateMoneyManagerSettingsInput = {
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']>;
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMoneyManagerSettingsResult = UpdateMoneyManagerSettingsFailure | UpdateMoneyManagerSettingsSuccess;

export type UpdateMoneyManagerSettingsSuccess = {
  __typename?: 'UpdateMoneyManagerSettingsSuccess';
  settings: Maybe<MoneyManagerSettings>;
};

export type UpdateMoneyRulesSourceSettingsFailure = {
  __typename?: 'UpdateMoneyRulesSourceSettingsFailure';
  reason: Scalars['String'];
};

export type UpdateMoneyRulesSourceSettingsInput = {
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']>;
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMoneyRulesSourceSettingsResult = UpdateMoneyRulesSourceSettingsFailure | UpdateMoneyRulesSourceSettingsSuccess;

export type UpdateMoneyRulesSourceSettingsSuccess = {
  __typename?: 'UpdateMoneyRulesSourceSettingsSuccess';
  settings: Maybe<MoneyRulesSettings>;
};

export type UpdateOauthAppInput = {
  accessTokenAudience?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accessTokenExpiry?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<Scalars['String']>;
  externalApp?: InputMaybe<Scalars['Boolean']>;
  imageUri?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageType?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  refreshTokenExpiry?: InputMaybe<Scalars['Int']>;
  scopeIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<OauthAppType>;
};

export type UpdateOauthAppResult = OauthApp | OauthAppNotFoundException;

/** Changes opt_out_of_targeting field */
export type UpdateOptOutOfTargetingInput = {
  /** Has user opted out of targeting? */
  optedOutOfTargeting: Scalars['Boolean'];
};

/** Input for updatePortfolioSecurities */
export type UpdatePortfolioSecuritiesInput = {
  /** Investment Account ID */
  investmentAccountId: Scalars['ID'];
  /** Portfolio ID */
  portfolioId: Scalars['ID'];
  /** List of Securities and their target allocation percent */
  securityAllocations: Array<SecurityAllocationTarget>;
};

/** Result of updating a portfolio's securities */
export type UpdatePortfolioSecuritiesResult = CustomerAgreementRequiredException | InvalidAllocationPercentError | InvalidSecurityError | InvalidSecurityForAllocationError | InvestmentAccount | LiquidationUnavailableError | NegativeSecurityPercentError | PortfolioSecurityLimitReached;

export type UpdatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine;
  channel: Scalars['String'];
  condensedTitle: Scalars['String'];
  cursor: Scalars['String'];
  description: Scalars['String'];
  internalMemo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  publishEnd?: InputMaybe<Scalars['DateTime']>;
  publishStart: Scalars['DateTime'];
  qualificationAction: PromoCodeQualificationAction;
  qualificationAmount: Scalars['Int'];
  rewards?: InputMaybe<Array<Scalars['ID']>>;
  status: PromoCodeStatus;
  termsUrl?: InputMaybe<Scalars['URL']>;
  title: Scalars['String'];
};

export type UpdatePromoCodeResult = DuplicatePromoCodeError | PromoCode | PromoCodeFieldLengthError;

export type UpdatePromotedCampaignsInput = {
  campaignIds: Array<InputMaybe<Scalars['ID']>>;
};

export type UpdatePromotedCampaignsResult = PromotedCampaigns;

export type UpdateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<CampaignBackgroundType>;
  condensedTitle?: InputMaybe<Scalars['String']>;
  cursor: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  eligibilityEnd?: InputMaybe<Scalars['DateTime']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<CampaignIconType>;
  internalMemo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishEnd?: InputMaybe<Scalars['DateTime']>;
  publishStart?: InputMaybe<Scalars['DateTime']>;
  qualificationAction?: InputMaybe<CampaignQualificationActionType>;
  qualificationAmount?: InputMaybe<Scalars['Int']>;
  rewards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<CampaignStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateReferralCampaignResult = ReferralCampaignV2;

export type UpdateReferralPayoutInput = {
  advocateOfferId?: InputMaybe<Scalars['String']>;
  friendOfferId?: InputMaybe<Scalars['String']>;
  payoutId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  status: ReferralPayoutStatus;
  statusChangeBy: Scalars['String'];
};

export type UpdateReferralPayoutResult = ReferralPayout;

export type UpdateReferralRelationshipInput = {
  friendId: Scalars['ID'];
  status: ReferralRelationshipStatus;
  /** Status of the referral relationship */
  statusDetails?: InputMaybe<ReferralStatusDetails>;
};

export type UpdateReferralRelationshipResult = ReferralRelationship;

/** Returned if failure updating reward */
export type UpdateReferralRewardError = {
  __typename?: 'UpdateReferralRewardError';
  message: Scalars['String'];
};

export type UpdateReferralRewardResponse = ReferralRewardSummary | UpdateReferralRewardError;

export type UpdateScopeException = {
  __typename?: 'UpdateScopeException';
  message: Scalars['String'];
};

export type UpdateScopeInput = {
  description?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateScopeResult = Scope | UpdateScopeException;

/** Response to a trusted contact update/insert */
export type UpdateTrustedContactResult = InternalErrorException | TrustedContact | TrustedContactAlreadyExistsException | TrustedContactInvalidEmail | TrustedContactInvalidPhoneNumber | TrustedContactNotFoundException;

/** Input type for updating user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetInput = {
  /** The annual income of the user. */
  annualIncome: Scalars['Int'];
};

/** Represents the result of the updateUserProfileAndAutomationTarget mutation, which can be either a success or an error. */
export type UpdateUserProfileAndAutomationTargetResult = UpdateUserProfileAndAutomationTargetSuccess;

/** Represents a successful update of user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetSuccess = {
  __typename?: 'UpdateUserProfileAndAutomationTargetSuccess';
  /** The updated annual income of the user. */
  annualIncome: Scalars['Int'];
  /** The newly updated automation targets of the user. */
  automationTargets: Array<MoneyManagerAutomationTarget>;
  /** The newly updated objective progress data. */
  cascadeObjectives: Array<MoneyManagerCascadeObjective>;
  /** The types of the updated automation targets. */
  updatedTargetTypes: Array<MoneyManagerAutomationTargetType>;
};

/** Describes the update user switch state return type. */
export type UpdateUserSwitchState = UpdateUserSwitchStateFailure | UpdateUserSwitchStatePayload;

/** Update User Switch State Returns Failure */
export type UpdateUserSwitchStateFailure = {
  __typename?: 'UpdateUserSwitchStateFailure';
  failureMessage: Scalars['String'];
};

/** Mutation attributes for updating a user switch state in the Direct Deposit database */
export type UpdateUserSwitchStateInput = {
  /** Switch State */
  switchState: SwitchState;
};

/** Update User Switch State Return Payload */
export type UpdateUserSwitchStatePayload = {
  __typename?: 'UpdateUserSwitchStatePayload';
  /** Switch State */
  switchState: SwitchState;
  /** User ID */
  userId: Scalars['ID'];
};

export type UpdateVerificationProfileResult = VerificationProfile;

export type UpgradeAuthenticationResult = AuthSession | AuthenticationAlreadyUpgradedException | UserCredentialsNotFoundException;

/** Uploads a check image to the provided session. */
export type UploadCheckInput = {
  checkImage: CheckImage;
  /** The session the image will be uploaded to. */
  sessionToken: Scalars['String'];
};

/** Response from uploading a check image. */
export type UploadCheckPayload = {
  __typename?: 'UploadCheckPayload';
  /** Session image was uploaded to. */
  sessionToken: Scalars['String'];
};

export type UploadDocumentsInput = {
  documentRequestId: Scalars['ID'];
  documentType: DocumentType;
  documents: Array<Scalars['Upload']>;
};

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExist = {
  __typename?: 'UploadDoesNotExist';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExistError = {
  __typename?: 'UploadDoesNotExistError';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The upload uuid */
  uploadUuid: Maybe<Scalars['ID']>;
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>;
};

export type UploadFailedError = {
  __typename?: 'UploadFailedError';
  message: Scalars['String'];
};

export type UploadOauthAppImageResult = InvalidContentTypeException | OauthAppImageUpload;

/** Errors from backend upload */
export type UploadSaveError = {
  __typename?: 'UploadSaveError';
  uploadExceptions: Array<UploadSaveExceptions>;
};

/** Exceptions from upload error */
export type UploadSaveExceptions = FileDoesNotExistError | UploadDoesNotExistError;

export type UploadUnsolicitedDocumentsInput = {
  documentType: DocumentType;
  documents: Array<Scalars['Upload']>;
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DocumentStatus>;
};

/** An upload url */
export type UploadUrl = {
  __typename?: 'UploadUrl';
  key: Scalars['String'];
  policy: Scalars['String'];
  uploadUuid: Scalars['ID'];
  url: Scalars['String'];
  userId: Scalars['ID'];
  xAmzAlgorithm: Scalars['String'];
  xAmzCredential: Scalars['String'];
  xAmzDate: Scalars['String'];
  xAmzSecurityToken: Scalars['String'];
  xAmzSignature: Scalars['String'];
};

/** Changeable attributes for creating user matches */
export type UpsertUserMatchInput = {
  /** ID representation of the user in a external system */
  externalId: Scalars['String'];
  /** The external system that the user is in */
  externalSource: ExternalUserSource;
  /** Information used to identify the match */
  matchedCriteria?: InputMaybe<Array<Scalars['String']>>;
  /** Current match status with external system */
  matchedStatus?: InputMaybe<UserMatchStatus>;
};

/** Response to a user match creation or update attempt */
export type UpsertUserMatchResult = InternalErrorException | UserMatch;

/** Entity representing the shared User object type used to resolve fields that belong to Auth Service */
export type User = {
  __typename?: 'User';
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  alerts: Maybe<Array<UserAlert>>;
  allocationProfileId: Maybe<Scalars['ID']>;
  city: Maybe<Scalars['String']>;
  closedAt: Maybe<Scalars['DateTime']>;
  /** @deprecated Use InvestmentAccount.userAge or InvestmentAccount.withdrawalsIncurTaxPenalty instead. */
  dob: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** @deprecated Field no longer supported */
  employedAffiliatedWithBrokerDealer: Maybe<Scalars['Boolean']>;
  employer: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  fundingSource: Maybe<FundingSource>;
  fundingSourceChangeRequiresApproval: Maybe<Scalars['Boolean']>;
  investmentAccounts: Maybe<Array<InvestmentAccount>>;
  lastName: Maybe<Scalars['String']>;
  occupation: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
  pinCreated: Maybe<Scalars['Boolean']>;
  portfolio: Maybe<Portfolio>;
  registrationComplete: Maybe<Scalars['Boolean']>;
  registrationCompletedAt: Maybe<Scalars['DateTime']>;
  /** @deprecated Field no longer supported */
  shareholderOrDirector: Maybe<Scalars['Boolean']>;
  sourceId: Maybe<Scalars['String']>;
  state: Maybe<Scalars['USStateName']>;
  /** @deprecated Field no longer supported */
  subjectToBackupWithholding: Maybe<Scalars['Boolean']>;
  uploads: Array<UserUpload>;
  usCitizen: Maybe<Scalars['Boolean']>;
  uuid: Scalars['ID'];
  verified: Maybe<Scalars['Boolean']>;
  zip: Maybe<Scalars['String']>;
};

/** A user alert. */
export type UserAlert = UserAlertsItem & {
  __typename?: 'UserAlert';
  description: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  metadata: Maybe<Scalars['String']>;
  title: Scalars['String'];
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

export type UserAlertsItem = {
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** Response from user alert query */
export type UserAlertsResponse = AddressDocumentRequestedUserAlert | BankDocumentRequestedUserAlert | IdentityDocumentRequestedUserAlert | InsufficientFundsUserAlert | InvestmentsPausedUserAlert | MiscDocumentRequestedUserAlert | NoFundingSourceUserAlert | RdvRequiredUserAlert | SsnDocumentRequestedUserAlert | UserAlert | W9DocumentRequestedUserAlert;

export type UserCardLockedSpendAlert = SpendAlert & {
  __typename?: 'UserCardLockedSpendAlert';
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/** The provided user is closed */
export type UserClosedException = {
  __typename?: 'UserClosedException';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The provided user id */
  userId: Maybe<Scalars['ID']>;
};

export type UserCohorts = {
  __typename?: 'UserCohorts';
  /** Updated list of cohorts */
  cohorts: Array<Scalars['String']>;
  /** User's user_id */
  userId: Scalars['String'];
};

export type UserCredentials = {
  __typename?: 'UserCredentials';
  identifier: Scalars['String'];
  type: CredentialsType;
  userId: Scalars['ID'];
};

export type UserCredentialsInput = {
  email: Scalars['EmailAddress'];
};

export type UserCredentialsNotFoundException = {
  __typename?: 'UserCredentialsNotFoundException';
  message: Maybe<Scalars['String']>;
};

/** User already exists */
export type UserExistsException = {
  __typename?: 'UserExistsException';
  userId: Maybe<Scalars['ID']>;
};

/** A reopen check for an investment account reopen request. */
export type UserInvestmentAccountReopenCheck = TimestampsInterface & {
  __typename?: 'UserInvestmentAccountReopenCheck';
  /** The ID of the reopen request to which this check belongs. */
  accountReopenRequestId: Scalars['Int'];
  /** Date time the record was created */
  createdAt: Scalars['DateTime'];
  /** The UUID of the investment account for which this check was made. */
  investmentAccountId: Scalars['ID'];
  /** A boolean indicating whether this check passed or failed. */
  passed: Scalars['Boolean'];
  /** The check type. */
  reopenCheckType: InvestmentAccountReopenCheck;
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime'];
  /** UUID of the user to whom the account the reopen request was made for belongs. */
  userUuid: Scalars['ID'];
};

export type UserLockedException = {
  __typename?: 'UserLockedException';
  message: Maybe<Scalars['String']>;
};

/** record of a user matching in an external system */
export type UserMatch = {
  __typename?: 'UserMatch';
  /** Id of user in external system */
  externalId: Scalars['ID'];
  externalMetadata: Maybe<ExternalMetadata>;
  externalSource: ExternalUserSource;
  /** Acorns user id */
  id: Scalars['ID'];
  matchedAt: Scalars['DateTime'];
  matchedCriteria: Maybe<Array<Scalars['String']>>;
  matchedStatus: UserMatchStatus;
};

export enum UserMatchStatus {
  USER_MATCH_STATUS_ELIGIBLE = 'USER_MATCH_STATUS_ELIGIBLE',
  USER_MATCH_STATUS_INELIGIBLE_CANCELLED = 'USER_MATCH_STATUS_INELIGIBLE_CANCELLED',
  USER_MATCH_STATUS_INELIGIBLE_INCORRECT_TIER = 'USER_MATCH_STATUS_INELIGIBLE_INCORRECT_TIER',
  USER_MATCH_STATUS_INVALID = 'USER_MATCH_STATUS_INVALID'
}

/** No user was found for the ID provided */
export type UserNotFound = {
  __typename?: 'UserNotFound';
  /** The provided user id */
  userId: Maybe<Scalars['ID']>;
};

/** No user was found for the ID provided */
export type UserNotFoundException = {
  __typename?: 'UserNotFoundException';
  /** message */
  message: Maybe<Scalars['String']>;
  /** The provided user id */
  userId: Maybe<Scalars['ID']>;
};

/** User is not a US resident */
export type UserNotUsResidentException = {
  __typename?: 'UserNotUSResidentException';
  userId: Maybe<Scalars['ID']>;
};

/** Custodian must be verified in order to open an Early Account */
export type UserNotVerifiedException = {
  __typename?: 'UserNotVerifiedException';
  /** message */
  message: Maybe<Scalars['String']>;
};

export type UserPartnerStatusResponse = {
  __typename?: 'UserPartnerStatusResponse';
  message: Scalars['String'];
};

/** The provided user is locked */
export type UserReopenLockedException = {
  __typename?: 'UserReopenLockedException';
  /** The date the user was locked */
  lockedAt: Scalars['DateTime'];
  /** The provided user id */
  userId: Maybe<Scalars['ID']>;
};

/** The provided user is suspended */
export type UserReopenSuspendedException = {
  __typename?: 'UserReopenSuspendedException';
  /** The date the user was suspended */
  suspendedAt: Scalars['DateTime'];
  /** The reason the user was suspended */
  suspendedReason: Maybe<Scalars['String']>;
  /** The provided user id */
  userId: Maybe<Scalars['ID']>;
};

/** User Status */
export type UserStatus = {
  __typename?: 'UserStatus';
  age: Scalars['Int'];
  closed: Scalars['Boolean'];
  closedAt: Maybe<Scalars['DateTime']>;
  registrationComplete: Scalars['Boolean'];
  registrationCompleteAt: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  verified: Scalars['Boolean'];
  verifiedAt: Maybe<Scalars['DateTime']>;
};

export type UserSuspendedException = {
  __typename?: 'UserSuspendedException';
  message: Maybe<Scalars['String']>;
  suspendedToken: Maybe<Scalars['String']>;
  suspensionReasonValid: Maybe<Scalars['Boolean']>;
};

/** Token has incorrect length */
export type UserSuspendedUploadTokenLengthError = {
  __typename?: 'UserSuspendedUploadTokenLengthError';
  /** expected length of token */
  length: Scalars['Int'];
};

/** Validation response for suspended upload token */
export type UserSuspendedUploadTokenValidation = {
  __typename?: 'UserSuspendedUploadTokenValidation';
  reason: Scalars['String'];
  tokenValid: Scalars['Boolean'];
};

/** Describes a user request for a direct deposit switch. */
export type UserSwitch = {
  __typename?: 'UserSwitch';
  /** Creation Date */
  createdAt: Scalars['String'];
  /** Switch ID */
  id: Scalars['ID'];
  /** Indicates whether the user is already depositing on the Spend account or not. */
  isComplete: Scalars['Boolean'];
  /** Status of the direct deposit switch. */
  status: SwitchStatus;
  /** Switch Type */
  switchType: SwitchType;
  /** Last Updated Date */
  updatedAt: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
  /** Switch ID provided by the vendor. */
  vendorSwitchId: Maybe<Scalars['ID']>;
};

export type UserToken = {
  __typename?: 'UserToken';
  consumedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  oauthAppClientId: Maybe<Scalars['ID']>;
  oauthAppId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
  userScopes: Array<Maybe<Scalars['String']>>;
  userTokenId: Scalars['ID'];
};

export type UserUpload = {
  __typename?: 'UserUpload';
  createdAt: Scalars['DateTime'];
  documentType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Object representing an acorns user */
export type User_V2 = {
  __typename?: 'User_v2';
  closedAt: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  uuid: Scalars['ID'];
};

export type ValidPolicies = {
  __typename?: 'ValidPolicies';
  policies: Maybe<Array<Maybe<Policy>>>;
};

export type ValidateCredentialsInput = {
  credentialsType?: CredentialsType;
  nativeLoginInput?: InputMaybe<NativeLoginInput>;
  oidcLoginInput?: InputMaybe<OidcLoginInput>;
  udid: Scalars['String'];
};

export type ValidateCredentialsResult = AuthSession | DeviceBlockedException | InvalidCredentialsException | LoginRateLimitedException | OidcCredentialsNotFoundException | UserSuspendedException | ValidateCredentialsSuccess;

export type ValidateCredentialsSuccess = {
  __typename?: 'ValidateCredentialsSuccess';
  authenticators: Maybe<Array<Authenticator>>;
  mfaToken: Scalars['String'];
  userId: Scalars['ID'];
};

export type ValidateDocumentsInput = {
  /**
   * ID of document provided by Socure
   * @deprecated APIs have been upgraded to V5. Use transactionToken instead.
   */
  documentId?: InputMaybe<Scalars['ID']>;
  /** Acorns subaccount for processing uploaded documents */
  product?: InputMaybe<IdentitySubaccount>;
  /** Token retrieved from the API response of the Document Request endpoint */
  transactionToken?: InputMaybe<Scalars['String']>;
};

export type ValidatePasswordResetTokenResult = InvalidPasswordResetTokenException | ValidatePasswordResetTokenSuccess;

export type ValidatePasswordResetTokenSuccess = {
  __typename?: 'ValidatePasswordResetTokenSuccess';
  displaySsnField: Scalars['Boolean'];
};

/** Input for validating a user suspended upload token */
export type ValidateUserSuspendedUploadTokenInput = {
  /** Upload token */
  token: Scalars['String'];
};

/** Result from validating document uploader token */
export type ValidateUserSuspendedUploadTokenResult = UserSuspendedUploadTokenLengthError | UserSuspendedUploadTokenValidation;

export type ValidationError = {
  __typename?: 'ValidationError';
  errorCode: Scalars['String'];
  errorMessage: Maybe<Scalars['String']>;
  /** The nonce of the intent. */
  intentId: Scalars['UUID'];
};

export type VendAuthSessionInput = {
  challengeAnswerInput: ChallengeAnswerInput;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  udid: Scalars['String'];
  userId: Scalars['ID'];
};

export type VendAuthSessionResult = AuthChallengeAnswerAttemptsExhaustedException | AuthChallengeAnswerIncorrectException | AuthChallengeExpiredException | AuthSession | ChallengeRateExceededException | DeviceBlockedException | UserSuspendedException;

export type VendorBillingInfo = {
  __typename?: 'VendorBillingInfo';
  accountType: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  lastFour: Maybe<Scalars['String']>;
  primary: Maybe<Scalars['Boolean']>;
  routingNumber: Maybe<Scalars['String']>;
};

export type VendorCustomerAccount = {
  __typename?: 'VendorCustomerAccount';
  billTo: Maybe<Scalars['String']>;
  code: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  dunningCampaignId: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  object: Maybe<Scalars['String']>;
  parentAccountId: Maybe<Scalars['String']>;
};

export type VendorIntegrationError = {
  __typename?: 'VendorIntegrationError';
  message: Scalars['String'];
};

export type VendorRefundInvoiceError = {
  __typename?: 'VendorRefundInvoiceError';
  message: Scalars['String'];
};

export type VerificationDetails = {
  __typename?: 'VerificationDetails';
  /**
   * This field indicates whether this KYC verification result is still valid and usable for the user today, regardless of its status (e.g., success, soft fail, hard fail).
   * When true, the banking KYC is either tied to an active account or part of an ongoing KYC process. When false, the user’s account may be closed or archived, making this KYC result no longer reusable.
   * Per our current approved BANK guidelines, a new KYC verification must be initiated within banking if the user goes through a reopen process.
   */
  isActive: Maybe<Scalars['Boolean']>;
  response: Maybe<Scalars['String']>;
  vendor: Maybe<Scalars['String']>;
};

export type VerificationProfile = {
  __typename?: 'VerificationProfile';
  /** Session ID calculated by Socure */
  deviceSessionId: Maybe<Scalars['String']>;
  /** Status of submitted documents after initial identity verification */
  documentVerification: Maybe<DocumentVerification>;
  /** SSN verification consent */
  eCBSV: Ecbsv;
  /**
   * Flag indicating whether eCBSV can be used or not for verification
   * @deprecated Use `eCBSV.consent` instead
   */
  eCBSVConsent: Scalars['Boolean'];
  /** Customer's IP address used during registration */
  ipAddress: Maybe<Scalars['String']>;
};

export type VerificationProfileInput = {
  /** Session ID calculated by Socure */
  deviceSessionId?: InputMaybe<Scalars['String']>;
  /** Customer's acceptance or declination of consent to utilize eCBSV */
  eCBSVConsent?: InputMaybe<Scalars['Boolean']>;
};

export enum VerificationStatus {
  actionRequired = 'actionRequired',
  actionRequiredDueToFailure = 'actionRequiredDueToFailure',
  failure = 'failure',
  pending = 'pending',
  success = 'success'
}

export type VerifyCheckPaymentRecipientAddressInputType = {
  recipient: CheckPaymentRecipientInput;
  recipientAddress: CheckPaymentAddressInput;
};

/** Address deliverable by mail carrier or InvalidAddressError */
export type VerifyCheckPaymentRecipientAddressResult = AuthorizationError | CheckPaymentRecipientAddressType | InvalidAddressError;

export type VerifyDeviceInput = {
  deviceId: Scalars['ID'];
};

export type VerifyDeviceResult = DeviceNotFoundException | EmailAuthChallenge | SmsAuthChallenge;

export type VerifyIdentityByDocumentsResult = DocumentVerification;

export type VerifyPasswordsInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type VerifyPasswordsResult = IncorrectOldPasswordException | InvalidPasswordException | SamePasswordsException | UnauthorizedException | VerifyPasswordsSuccess;

export type VerifyPasswordsSuccess = {
  __typename?: 'VerifyPasswordsSuccess';
  isValid: Scalars['Boolean'];
};

export type VerifyPromoCodeResponse = InvalidPromoCodeError | PromoCode;

/** Input for verifying RDVs */
export type VerifyRdvsInput = {
  /** Deposit amounts inputted by user. Example: [0.77, 0.23] */
  deposits: Array<Scalars['Float']>;
};

/** Result from attempting to verify RDVs */
export type VerifyRdvsResult = AccountFrozen | FundingSourceAccount | IncorrectRdvAmounts | StoredRdvDepositsInvalid | StoredRdvDepositsMissing;

export type VersionMismatchException = {
  __typename?: 'VersionMismatchException';
  latestVersion: Maybe<Scalars['ID']>;
};

export type ViewedLearnContentResult = {
  __typename?: 'ViewedLearnContentResult';
  contentId: Scalars['ID'];
};

/** W9 document requested. */
export type W9DocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'W9DocumentRequestedUserAlert';
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType;
  /** The type of the alert */
  type: Scalars['String'];
  /** The user ID associated to the alert */
  userId: Scalars['ID'];
};

/** result from attempting to create a provisional waiver for a user */
export type Waiver = MightyOakCardWaiver | PromotionalWaiver | ProvisionalWaiver;

export type WaiverCoupon = {
  __typename?: 'WaiverCoupon';
  couponId: Scalars['String'];
  discountAmount: Scalars['Float'];
  discountType: Scalars['String'];
  monthsToWaive: Scalars['Int'];
  waiverType: Scalars['String'];
};

export type WaiverCreationException = {
  __typename?: 'WaiverCreationException';
  message: Scalars['String'];
};

export type WaiverDeletionException = {
  __typename?: 'WaiverDeletionException';
  message: Scalars['String'];
};

export enum WaiverPromotion {
  /** Cricket Wireless Promotion */
  CRICKET = 'CRICKET',
  /** Mighty Oak Card Promotion */
  MIGHTY_OAK_CARD = 'MIGHTY_OAK_CARD'
}

export enum WaiverPromotion_V2 {
  CRICKET = 'CRICKET',
  MIGHTY_OAK_CARD = 'MIGHTY_OAK_CARD'
}

/** URLs for linked account webhooks */
export type Webhooks = {
  __typename?: 'Webhooks';
  /** URL for plaid webhooks */
  plaid: Scalars['String'];
};

/** A URL which represents the location of the account linking source the client should use. */
export type WebviewLinkSession = {
  __typename?: 'WebviewLinkSession';
  /** The URL a client should use for account linking. */
  url: Scalars['URL'];
};

/** Withdrawal Investment Object */
export type Withdrawal = {
  __typename?: 'Withdrawal';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  presentableWithdrawalStatus: PresentableWithdrawalStatus;
};

export type WithholdingDefaults = {
  __typename?: 'WithholdingDefaults';
  federalWithholdingPercentage: Scalars['Float'];
  showFederalWithholdingField: Scalars['Boolean'];
  showStateWithholdingField: Scalars['Boolean'];
  stateWithholdingPercentage: Scalars['Float'];
};

export type WithholdingEstimates = {
  __typename?: 'WithholdingEstimates';
  /** estimated amount that will be delivered to the customer */
  estimatedCustomerAmount: MonetaryAmount;
  /** estimated total amount that will be withheld for federal taxes */
  estimatedFederalWithholdingAmount: MonetaryAmount;
  /** estimated total amount that will be withheld for state taxes */
  estimatedStateWithholdingAmount: MonetaryAmount;
  /** estimated earnings that will be taxed */
  estimatedTaxableEarnings: MonetaryAmount;
  /** estimated total amount that will be withheld (state and federal) */
  estimatedTotalWithholdingAmount: MonetaryAmount;
};

export type YearLaterReport = {
  __typename?: 'YearLaterReport';
  accountBalance: Scalars['Float'];
  accountCreationDate: Scalars['String'];
  accountPerformance: Scalars['Float'];
  accountType: Scalars['String'];
  firstDepositAmountForYear: Maybe<Scalars['Float']>;
  firstDepositDateForYear: Maybe<Scalars['String']>;
  recurringContributionAmount: Scalars['Float'];
  recurringContributionFrequency: Maybe<InvestmentFrequency>;
  totalDeposits: Scalars['Float'];
  totalDepositsForYear: Scalars['Float'];
  totalDividends: Scalars['Float'];
  totalNetReturns: Scalars['Float'];
  totalWithdrawals: Scalars['Float'];
  userAge: Scalars['Int'];
};

/** Filter schema for the allPasyscheduledItems Query */
export type AllPastScheduledItemsFilter = {
  account?: InputMaybe<PastItemsAccountFilter>;
};

/** Filter schema for the allPasyscheduledItems Query */
export type AllPastScheduledItemsFilterV2 = {
  account?: InputMaybe<PastItemsAccountFilter>;
};

export type EndChatSessionResponse = ChatSession | ChatSessionNotFound;

export type HelpcenterBannerResponse = HelpcenterBannerContent | HelpcenterBannerErrors;

export type Jobs_Article = {
  __typename?: 'jobs_Article';
  body: Scalars['String'];
  cta: Maybe<Cta>;
  eyebrow: Scalars['String'];
  id: Scalars['ID'];
  image: Maybe<Image>;
  title: Scalars['String'];
};

export type Jobs_Education = {
  __typename?: 'jobs_Education';
  articles: Array<Jobs_Article>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Jobs_Offer = {
  __typename?: 'jobs_Offer';
  /** Company logo or generic default */
  companyLogo: Image;
  /** Hiring company */
  companyName: Scalars['String'];
  id: Scalars['ID'];
  /** Relevant job industry */
  industryName: Maybe<Scalars['String']>;
  /** Job role */
  jobName: Scalars['String'];
  /** Job location */
  location: JobLocation;
  /** Salary details */
  salary: Maybe<Jobs_OfferSalary>;
  /** List of tags to display */
  tags: Array<Scalars['String']>;
  /** Redirect URL for job posting */
  url: Scalars['URL'];
};

/** Specifies a Job Offer Connection */
export type Jobs_OfferConnection = {
  __typename?: 'jobs_OfferConnection';
  edges: Array<Jobs_OfferEdge>;
  pageInfo: PageInfo;
};

/** Specifies a Job Offer Edge */
export type Jobs_OfferEdge = {
  __typename?: 'jobs_OfferEdge';
  cursor: Scalars['ID'];
  node: Jobs_Offer;
};

export type Jobs_OfferSalary = {
  __typename?: 'jobs_OfferSalary';
  interval: SalaryInterval;
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
};

export type LaterTotalLiquidationInput = {
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>;
  federalTaxes: Scalars['Float'];
  reason?: InputMaybe<LaterWithdrawalReason>;
  stateTaxes: Scalars['Float'];
  taxYear: Scalars['Int'];
  withdrawalType?: InputMaybe<LaterWithdrawalType>;
};

export type ManagePayoutRelationshipInput = {
  action: ManagePayoutRelationshipAction;
  payoutId: Scalars['ID'];
  relationshipId: Scalars['ID'];
};

export type RateChatMessageResponse = ChatHistoryMessage | ChatHistoryMessageCustomFeedbackOutOfBounds | ChatHistoryMessageNotFound | ChatHistoryMessageNotRatable | ChatHistoryMessageRatingFailed | ChatHistoryMessageRatingOutOfBounds;

export enum ReferralStatusDetails {
  ACORNS_EMPLOYEE = 'ACORNS_EMPLOYEE',
  CAMPAIGN_EXPIRED = 'CAMPAIGN_EXPIRED',
  INACTIVE_SUBSCRIPTION = 'INACTIVE_SUBSCRIPTION',
  INVEST_ACCOUNT_CLOSED = 'INVEST_ACCOUNT_CLOSED',
  MANUAL_PAYOUT = 'MANUAL_PAYOUT',
  USER_SUSPENED = 'USER_SUSPENED'
}

export type StartChatSessionResponse = ChatSession | ChatUnavailableError;

/** Recommended portfolio for user based off their suitability responses */
export type Suitability_Portfolio = {
  __typename?: 'suitability_Portfolio';
  /** the portfolio description */
  description: Scalars['String'];
  /** The portfolio ID */
  id: Scalars['ID'];
  /** The portfolio name */
  name: Scalars['String'];
};

/** Possible answer for a suitability question */
export type Suitability_SuitabilityAnswer = {
  __typename?: 'suitability_SuitabilityAnswer';
  /** Human readable text to display a description to an answer */
  description: Maybe<Scalars['String']>;
  /** Internal ID for a suitability answer */
  id: Scalars['ID'];
  /** Value for clients to use to fetch strings */
  key: Scalars['String'];
  /** Summary of an answer used for displaying why a portfolio was recommended */
  summary: Maybe<Scalars['String']>;
  /** Human readable text to display an answer to a suitability question */
  text: Scalars['String'];
};

/** A user's input to update their suitabiliity */
export type Suitability_SuitabilityInput = {
  /** The answer ID */
  answerId: Scalars['ID'];
  /** The question ID */
  questionId: Scalars['ID'];
};

/** Suitability question asked for recommending portfolios */
export type Suitability_SuitabilityQuestion = {
  __typename?: 'suitability_SuitabilityQuestion';
  /** Default answer to the related suitability question */
  defaultAnswer: Maybe<Suitability_SuitabilityAnswer>;
  /** Internal ID for a suitability question */
  id: Scalars['ID'];
  /** Value for clients to use to fetch strings */
  key: Scalars['String'];
  /** Possible answers to be selected for the related question */
  possibleAnswers: Array<Suitability_SuitabilityAnswer>;
  /** Human readable text to display the suitability question */
  text: Scalars['String'];
};

/** A given user's suitability response for each question and answer */
export type Suitability_SuitabilityResponse = {
  __typename?: 'suitability_SuitabilityResponse';
  /** Associated answer to the suitability question */
  answer: Maybe<Suitability_SuitabilityAnswer>;
  /** Default answer to the related suitability question */
  question: Suitability_SuitabilityQuestion;
};

/** Return wrapper type for the UpdateSuitability mutation */
export type Suitability_UpdateSuitabilityResult = {
  __typename?: 'suitability_UpdateSuitabilityResult';
  /** The recommended portfolio for the user's suitability responses */
  recommendedPortfolio: Maybe<Suitability_Portfolio>;
  /** Internal ID for a suitability answer */
  suitabilityResponses: Array<Suitability_SuitabilityResponse>;
};

export type UploadAudienceListInput = {
  cohortName: Scalars['String'];
};

export type UserWinbackErrors = {
  __typename?: 'userWinbackErrors';
  error: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export type UserWinbackScore = {
  __typename?: 'userWinbackScore';
  churnProbability: Maybe<Scalars['Float']>;
  predictedRevenue: Maybe<Scalars['Float']>;
  userId: Maybe<Scalars['String']>;
};

export type UserWinbackScoreRes = UserWinbackErrors | UserWinbackScore;

export type PlaidLinkWebhookQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaidLinkWebhookQuery = { __typename?: 'Query', linkedAccountWebhooks: { __typename?: 'Webhooks', plaid: string } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', registrationComplete: boolean, uuid: string, email: string } };

export type ProgramAgreementQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramAgreementQuery = { __typename?: 'Query', acceptanceDocument: { __typename?: 'AcceptanceDocument', url: any } };

export type CreateIraWithProfileMutationVariables = Exact<{
  iraType?: InputMaybe<InvestmentAccountTypes>;
  profileAttributes: Array<InputMaybe<ProfileAttribute>> | InputMaybe<ProfileAttribute>;
}>;


export type CreateIraWithProfileMutation = { __typename?: 'Mutation', createIRAWithProfile: { __typename?: 'CreateInvestmentAccountResponse', iraType: InvestmentAccountTypes, id: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename: 'AuthTokenNotFoundException' } | { __typename: 'LogoutSuccess' } | { __typename: 'RefreshTokenNotFoundException' } };

export type RefreshAuthTokensMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshAuthTokensMutation = { __typename?: 'Mutation', refreshAuthToken: { __typename: 'AuthSession', token: string, refreshToken: string } | { __typename: 'InvalidPinException' } | { __typename: 'RefreshAuthTokenRateLimitedException' } | { __typename: 'TokenExpiredException' } | { __typename: 'UserSuspendedException' } };

export type UserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', registrationComplete: boolean, state: any, alerts: Array<{ __typename?: 'UserAlert', type: string }> }, userStatus: { __typename?: 'UserStatus', age: number }, allBankAccounts: Array<{ __typename?: 'BankAccount', type: BankAccountType }> };

export type UserRegistrationAndAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRegistrationAndAccountsQuery = { __typename?: 'Query', fundingSourceAccounts: Array<{ __typename?: 'FundingSourceAccount', institutionName: string, logoUrl: string, last4: string, role: FundingSourceRoleEnum }> };

export type PlaidLayerLinkedAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaidLayerLinkedAccountsQuery = { __typename?: 'Query', linkedAccounts: Array<{ __typename?: 'LinkedAccount', institutionName: string, linkedSubaccounts: Array<{ __typename?: 'LinkedSubaccount', accountNumberLastFour: string, name: string, allowedRoles: Array<LinkedSubaccountRoleEnum>, linkedAccount: { __typename?: 'LinkedAccount', logoUrl: string, financialInstitution: { __typename?: 'FinancialInstitution', directBank: boolean, logoUrl: string, name: string } } }> }> };

export type LinkedAccountsFundingSourceTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type LinkedAccountsFundingSourceTypeQuery = { __typename?: 'Query', roundUpProfile: { __typename?: 'RoundUpProfile', roundUpsEnabled: boolean }, user: { __typename?: 'User', registrationComplete: boolean }, linkedAccounts: Array<{ __typename?: 'LinkedAccount', externalSource: LinkedAccountExternalSourceEnum, institutionName: string, linkedSubaccounts: Array<{ __typename?: 'LinkedSubaccount', role: LinkedSubaccountRoleEnum }> }> };

export type UpdateContactInfoMutationVariables = Exact<{
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type UpdateContactInfoMutation = { __typename?: 'Mutation', updateContactInfo: { __typename?: 'User', uuid: string } };

export type UpdatePhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', updateContactInfo: { __typename: 'User' } };

export type UserResidentialAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type UserResidentialAddressQuery = { __typename?: 'Query', user: { __typename?: 'User', address1: string, address2: string, city: string, state: any, zip: string, phoneNumber: string }, profile: { __typename?: 'Profile', createdAt: any } };

export type UpdateDateOfBirthMutationVariables = Exact<{
  dob?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDateOfBirthMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', uuid: string } };

export type FundingSourceInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type FundingSourceInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', uploads: Array<{ __typename?: 'UserUpload', id: string, documentType: string, createdAt: any }> }, fundingSourceInfo: { __typename?: 'FundingSourceInfo', name: string, accountNumberLastFour: string, balance: number, linkedSubaccountId: string, canChange: boolean, changeRequiresApproval: boolean, verified: boolean, verificationStatus: number } };

export type RegistrationCompleteQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistrationCompleteQuery = { __typename?: 'Query', user: { __typename?: 'User', registrationComplete: boolean } };

export type OpenInvestAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenInvestAccountQuery = { __typename?: 'Query', investmentAccountsByUserId: Array<{ __typename?: 'InvestmentAccount', id: string }> };

export type UpdateInvestorQuestionsMutationVariables = Exact<{
  employedAffiliatedWithBrokerDealer: Scalars['Boolean'];
  shareholderOrDirector: Scalars['Boolean'];
  subjectToBackupWithholding: Scalars['Boolean'];
}>;


export type UpdateInvestorQuestionsMutation = { __typename?: 'Mutation', updateInvestorQuestions: { __typename?: 'User', uuid: string } };

export type UpgradeForLaterProductMutationVariables = Exact<{
  tierPriceId: Scalars['ID'];
}>;


export type UpgradeForLaterProductMutation = { __typename?: 'Mutation', subscribeUserToTier: { __typename: 'InvalidTierPriceId' } | { __typename: 'TierDowngradeActionRequired' } | { __typename: 'TierSubscription' } };

export type TiersForLaterQueryVariables = Exact<{ [key: string]: never; }>;


export type TiersForLaterQuery = { __typename?: 'Query', tierGroupForUser: { __typename?: 'TierGroup', tierOptions: Array<{ __typename?: 'TierOption', tier: { __typename?: 'Tier', name: string, products: Array<{ __typename?: 'Product', key: ProductKey }>, tierPrice: { __typename?: 'TierPrice', id: string, billingFrequency: BillingFrequency, amountV2: { __typename?: 'MicrosMoney', value: any, currency: Currency } } } }> } };

export type TierSubscriptionForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TierSubscriptionForUserQuery = { __typename?: 'Query', tierSubscriptionByUserId: { __typename?: 'TierSubscription', id: string, tierPrice: { __typename?: 'TierPrice', id: string, billingFrequency: BillingFrequency, amount: { __typename?: 'CurrencyAmount', value: number } }, tier: { __typename?: 'Tier', name: string, products: Array<{ __typename?: 'Product', key: ProductKey }>, matchProgram: { __typename?: 'MatchProgram', matchPercentage: number } } } };

export type CoreSuitabilityQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoreSuitabilityQuestionsQuery = { __typename?: 'Query', suitabilityResponses: Array<{ __typename?: 'suitability_SuitabilityResponse', question: { __typename?: 'suitability_SuitabilityQuestion', text: string, id: string, key: string, possibleAnswers: Array<{ __typename?: 'suitability_SuitabilityAnswer', text: string, description: string, summary: string, id: string, key: string }> } }> };

export type SetPortfolioMutationVariables = Exact<{
  input: SetPortfolioInput;
}>;


export type SetPortfolioMutation = { __typename?: 'Mutation', setPortfolio: { __typename?: 'User', portfolio: { __typename?: 'Portfolio', id: string, name: string } } };

export type UpdateProfileMutationVariables = Exact<{
  input: ProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', annualIncome: number } };

export type UpdateLaterSuitabilityMutationVariables = Exact<{
  input: Array<Suitability_SuitabilityInput> | Suitability_SuitabilityInput;
}>;


export type UpdateLaterSuitabilityMutation = { __typename?: 'Mutation', updateSuitability: { __typename?: 'suitability_UpdateSuitabilityResult', recommendedPortfolio: { __typename?: 'suitability_Portfolio', id: string } } };

export type UserQueryMfaSetupQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQueryMfaSetupQuery = { __typename?: 'Query', user: { __typename?: 'User', phoneNumber: string } };

export type LinkAchAccountMutationVariables = Exact<{
  routing: Scalars['String'];
  account: Scalars['String'];
}>;


export type LinkAchAccountMutation = { __typename?: 'Mutation', linkACHAccount: any };

export type UpdateNameMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type UpdateNameMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', uuid: string } };

export type UserNameInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNameInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', firstName: string, lastName: string }, profile: { __typename?: 'Profile', createdAt: any } };

export type PersonalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', firstName: string, lastName: string, phoneNumber: string }, profile: { __typename?: 'Profile', createdAt: any } };

export type UpdatePersonalInfoMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePersonalInfoMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', uuid: string } };

export type UpdatePersonalInfoSignupMutationVariables = Exact<{
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePersonalInfoSignupMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', uuid: string } };

export type AuthProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthProfileQuery = { __typename?: 'Query', authProfile: { __typename?: 'AuthProfile', emailVerifiedAt: any, phoneNumberVerifiedAt: any } };

export type GenerateLayerLinkSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateLayerLinkSessionMutation = { __typename?: 'Mutation', generateLayerLinkSession: { __typename?: 'PlaidLayerLinkSession', token: string } | { __typename?: 'UnrecoverableError', reason: string } };

export type RequestLayerSessionMutationVariables = Exact<{
  input: RequestLayerSessionInput;
}>;


export type RequestLayerSessionMutation = { __typename?: 'Mutation', requestLayerSession: { __typename?: 'RequestedLayerLinkSession', zipCode: string, street2: string, street1: string, state: string, ssnStorageResult: SsnStorageResult, lastName: string, firstName: string, dateOfBirth: any, country: string, city: string } | { __typename?: 'UnrecoverableError', reason: string } };

export type UpdateContactInfoPhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type UpdateContactInfoPhoneNumberMutation = { __typename?: 'Mutation', updateContactInfo: { __typename: 'User' } };

export type UserPhoneNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPhoneNumberQuery = { __typename?: 'Query', user: { __typename?: 'User', phoneNumber: string } };

export type OpenInvestmentAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenInvestmentAccountsQuery = { __typename?: 'Query', investmentAccountsByUserId: Array<{ __typename?: 'InvestmentAccount', id: string, product: InvestmentProduct, investmentAccountType: InvestmentAccountType, portfolio: { __typename?: 'Portfolio', id: string, name: string } }> };

export type OpenCoreInvestmentAccountMutationVariables = Exact<{
  input: OpenCoreInvestmentAccountInput;
}>;


export type OpenCoreInvestmentAccountMutation = { __typename?: 'Mutation', openCoreInvestmentAccount: { __typename: 'CoreAccountAlreadyExistsException' } | { __typename: 'InvalidPortfolioIdException' } | { __typename: 'InvestmentAccount' } | { __typename: 'InvestmentAccountCreationException' } | { __typename: 'UserClosedException' } | { __typename: 'UserNotFoundException' } };

export type AllPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPortfoliosQuery = { __typename?: 'Query', user: { __typename?: 'User', fundingSource: { __typename?: 'FundingSource', type: string } }, userStatus: { __typename?: 'UserStatus', age: number }, roundUpProfile: { __typename?: 'RoundUpProfile', roundUpsEnabled: boolean }, linkedAccounts: Array<{ __typename?: 'LinkedAccount', externalSource: LinkedAccountExternalSourceEnum }>, portfolios: Array<{ __typename?: 'Portfolio', id: string, name: string, description: string, riskLevel: PortfolioRiskLevel, theme: PortfolioTheme, projection: { __typename?: 'PortfolioProjection', averageGrowthRate: number, highestGrowthRate: number, lowestGrowthRate: number }, portfolioSecurityAllocations: Array<{ __typename?: 'PortfolioSecurityAllocation', allocationPercent: number, security: { __typename?: 'Fund', displayName: string, symbol: any } | { __typename?: 'Stock', displayName: string, symbol: any }, investmentCategories: { __typename?: 'InvestmentCategory', bond: number, crypto: number } }> }> };

export type CreateInvestingStrategyRecommendationMutationVariables = Exact<{
  input: CreateInvestingStrategyRecommendationInput;
}>;


export type CreateInvestingStrategyRecommendationMutation = { __typename?: 'Mutation', createInvestingStrategyRecommendation: { __typename?: 'BadRequestError', message: string } | { __typename?: 'RecommendedInvestingStrategy', accountSubtype: SuitabilityAccountSubtype, portfolioId: string } };

export type CreateLaterAccountMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  accountSubtype: InvestmentAccountTypes;
}>;


export type CreateLaterAccountMutation = { __typename?: 'Mutation', createInvestmentAccount: { __typename?: 'CreateInvestmentAccountResponse', id: string } };

export type UpdateSuitabilityProfileMutationVariables = Exact<{
  input: ProfileInput;
}>;


export type UpdateSuitabilityProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', userId: string } };

export type SuitabilityResponsesQueryVariables = Exact<{ [key: string]: never; }>;


export type SuitabilityResponsesQuery = { __typename?: 'Query', suitabilityResponses: Array<{ __typename?: 'suitability_SuitabilityResponse', answer: { __typename?: 'suitability_SuitabilityAnswer', id: string, summary: string } }> };

export type UpdateAccountPortfolioMutationVariables = Exact<{
  investmentAccountId: Scalars['ID'];
  theme: PortfolioTheme;
  riskLevel: PortfolioRiskLevel;
}>;


export type UpdateAccountPortfolioMutation = { __typename?: 'Mutation', updateAccountPortfolio: { __typename?: 'InvalidActionOnAccount' } | { __typename?: 'InvestmentAccount', id: string } | { __typename?: 'InvestmentAccountNotFoundException' } | { __typename?: 'PortfolioNotFoundException' } | { __typename?: 'PortfolioUpdateFailedException' } };

export type UserInvestmentDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInvestmentDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', sourceId: string, fundingSource: { __typename?: 'FundingSource', type: string } }, roundUpProfile: { __typename?: 'RoundUpProfile', roundUpsEnabled: boolean }, linkedAccounts: Array<{ __typename?: 'LinkedAccount', externalSource: LinkedAccountExternalSourceEnum }>, portfolios: Array<{ __typename?: 'Portfolio', id: string, name: string, description: string, riskLevel: PortfolioRiskLevel, theme: PortfolioTheme, projection: { __typename?: 'PortfolioProjection', averageGrowthRate: number, highestGrowthRate: number, lowestGrowthRate: number }, portfolioSecurityAllocations: Array<{ __typename?: 'PortfolioSecurityAllocation', allocationPercent: number, security: { __typename?: 'Fund', displayName: string, symbol: any } | { __typename?: 'Stock', displayName: string, symbol: any }, investmentCategories: { __typename?: 'InvestmentCategory', bond: number, crypto: number } }> }>, recommendedPortfolio: { __typename?: 'suitability_Portfolio', id: string, name: string } };

export type DynamicSubscriptionPricingContentQueryVariables = Exact<{ [key: string]: never; }>;


export type DynamicSubscriptionPricingContentQuery = { __typename?: 'Query', user: { __typename?: 'User', uuid: string }, tierGroupForUser: { __typename?: 'TierGroup', id: string, preferredTierId: string, tierOptions: Array<{ __typename?: 'TierOption', preferredTierPrice: { __typename?: 'TierPrice', billingFrequency: BillingFrequency, amountV2: { __typename?: 'MicrosMoney', value: any, currency: Currency } }, tier: { __typename?: 'Tier', id: string, assetPath: string, key: TierKey, name: string, displayName: string, description: string, tierPrice: { __typename?: 'TierPrice', id: string, amountV2: { __typename?: 'MicrosMoney', value: any, currency: Currency } }, products: Array<{ __typename?: 'Product', key: ProductKey }>, bundles: Array<{ __typename?: 'Bundle', name: string, iconPath: string, products: Array<{ __typename?: 'PresentableProduct', descriptionKeys: Array<any>, product: { __typename?: 'Product', key: ProductKey } }> }> } }> } };

export type SubscribeToTierMutationVariables = Exact<{
  input: SubscribeToTierInput;
}>;


export type SubscribeToTierMutation = { __typename?: 'Mutation', subscribeToTier: { __typename: 'InvalidTier' } | { __typename: 'InvalidTierPrice' } | { __typename: 'TierSubscription', id: string } };

export type SubscriptionPricingContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPricingContentQuery = { __typename?: 'Query', user: { __typename?: 'User', uuid: string }, tierGroupForUser: { __typename?: 'TierGroup', id: string, preferredTierId: string, tierOptions: Array<{ __typename?: 'TierOption', preferredTierPrice: { __typename?: 'TierPrice', billingFrequency: BillingFrequency, amountV2: { __typename?: 'MicrosMoney', currency: Currency, value: any } }, tier: { __typename?: 'Tier', id: string, assetPath: string, key: TierKey, name: string, displayName: string, description: string, tierPrice: { __typename?: 'TierPrice', id: string, amountV2: { __typename?: 'MicrosMoney', currency: Currency, value: any } }, products: Array<{ __typename?: 'Product', key: ProductKey }>, bundles: Array<{ __typename?: 'Bundle', name: string, iconPath: string, products: Array<{ __typename?: 'PresentableProduct', descriptionKeys: Array<any>, product: { __typename?: 'Product', key: ProductKey } }> }> } }> } };

export type EarlyBeneficiariesQueryVariables = Exact<{ [key: string]: never; }>;


export type EarlyBeneficiariesQuery = { __typename?: 'Query', beneficiaries: Array<{ __typename?: 'Beneficiary', id: string, ssnPresent: boolean, investmentAccount: { __typename?: 'InvestmentAccount', id: string, status: InvestmentAccountStatus } }> };

export type ProductOnboardingAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductOnboardingAccountsQuery = { __typename?: 'Query', investmentAccountsByUserId: Array<{ __typename?: 'InvestmentAccount', id: string }>, tierSubscriptionByUserId: { __typename?: 'TierSubscription', tier: { __typename?: 'Tier', key: TierKey, products: Array<{ __typename?: 'Product', key: ProductKey }> } } };

export type UpdateRoundUpAccountMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
  linkedSubaccountId: Scalars['ID'];
}>;


export type UpdateRoundUpAccountMutation = { __typename?: 'Mutation', updateRoundUpAccount: { __typename?: 'RoundUpAccount', enabled: boolean } };

export type LinkedAccountsAndFundingSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type LinkedAccountsAndFundingSourceQuery = { __typename?: 'Query', linkedAccounts: Array<{ __typename?: 'LinkedAccount', id: string, createdAt: any, externalId: string, externalSource: LinkedAccountExternalSourceEnum, linked: boolean, status: LinkedAccountStatusEnum, financialInstitution: { __typename?: 'FinancialInstitution', id: string, externalId: string, logoUrl: string, name: string }, linkedSubaccounts: Array<{ __typename?: 'LinkedSubaccount', accountNumberLastFour: string, allowedRoles: Array<LinkedSubaccountRoleEnum>, balanceAvailable: number, balanceCurrent: number, id: string, linked: boolean, name: string, role: LinkedSubaccountRoleEnum, status: FundingSourceStatusEnum, subaccountType: string }> }>, roundUpProfile: { __typename?: 'RoundUpProfile', roundUpsEnabled: boolean, multiplier: number, roundUpAccounts: Array<{ __typename?: 'RoundUpAccount', createdAt: any, linkedSubaccountId: string, startDate: string, updatedAt: any, enabled: boolean }> } };

export type FundingSourceAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type FundingSourceAccountsQuery = { __typename?: 'Query', fundingSourceAccounts: Array<{ __typename?: 'FundingSourceAccount', role: FundingSourceRoleEnum }> };

export type SetManualRoundUpsMutationVariables = Exact<{
  roundUpIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetManualRoundUpsMutation = { __typename?: 'Mutation', setManualRoundUps: Array<{ __typename?: 'RoundUp', change: number }> };

export type RoundUpTransactionsQueryVariables = Exact<{
  state?: InputMaybe<Array<RoundUpState> | RoundUpState>;
  pageInput?: InputMaybe<PageInput>;
}>;


export type RoundUpTransactionsQuery = { __typename?: 'Query', roundUps: { __typename?: 'RoundUpTypePagination', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, limit: number }, edges: Array<{ __typename?: 'RoundUpTypeEdge', cursor: string, node: { __typename?: 'RoundUp', amount: number, change: number, instant: boolean, manual: boolean, multiplier: number, name: string, state: RoundUpState, transactionDate: any, transactionId: string } }> } };

export type UpdateRoundUpProfileMutationVariables = Exact<{
  roundUpsEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateRoundUpProfileMutation = { __typename?: 'Mutation', roundUpProfile: { __typename?: 'RoundUpProfile', roundUpsEnabled: boolean } };

export type RoundUpsEnabledCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type RoundUpsEnabledCheckQuery = { __typename?: 'Query', roundUpProfile: { __typename?: 'RoundUpProfile', roundUpsEnabled: boolean } };

export type CaptureEcbsvConsentMutationVariables = Exact<{
  consent?: InputMaybe<Scalars['Boolean']>;
}>;


export type CaptureEcbsvConsentMutation = { __typename?: 'Mutation', updateVerificationProfile: { __typename: 'VerificationProfile' } };

export type VerificationProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type VerificationProfileQuery = { __typename?: 'Query', verificationProfile: { __typename?: 'VerificationProfile', eCBSV: { __typename?: 'Ecbsv', providedAt: any } } };

export type UpdatePersonalInfoSsnMutationVariables = Exact<{
  input: PersonalInfoInput;
}>;


export type UpdatePersonalInfoSsnMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', uuid: string } };

export type UpdateAddressMutationVariables = Exact<{
  addressType: AddressType;
  input: AddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename: 'Address' } };

export type UpdateResidentialAddressMutationVariables = Exact<{
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
}>;


export type UpdateResidentialAddressMutation = { __typename?: 'Mutation', updateContactInfo: { __typename?: 'User', uuid: string } };

export type UserAddressValidationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAddressValidationQuery = { __typename?: 'Query', user: { __typename?: 'User', firstName: string, lastName: string }, residentialAddress: Array<{ __typename?: 'Address', street1: string, street2: string, city: string, state: string, zipCode: string, addressType: AddressType }>, mailingAddress: Array<{ __typename?: 'Address', street1: string, street2: string, city: string, state: string, zipCode: string, addressType: AddressType }> };

type AddressDeliverabilityDetails_AddressDeliverabilityCorrectedAddress_Fragment = { __typename: 'AddressDeliverabilityCorrectedAddress', city: string, country: string, state: string, street1: string, street2: string, zipCode: string };

type AddressDeliverabilityDetails_AddressDeliverabilityUnavailableError_Fragment = { __typename: 'AddressDeliverabilityUnavailableError' };

type AddressDeliverabilityDetails_AddressDeliverabilityVerificationError_Fragment = { __typename: 'AddressDeliverabilityVerificationError' };

type AddressDeliverabilityDetails_AddressDeliverabilityVerified_Fragment = { __typename: 'AddressDeliverabilityVerified' };

export type AddressDeliverabilityDetailsFragment = AddressDeliverabilityDetails_AddressDeliverabilityCorrectedAddress_Fragment | AddressDeliverabilityDetails_AddressDeliverabilityUnavailableError_Fragment | AddressDeliverabilityDetails_AddressDeliverabilityVerificationError_Fragment | AddressDeliverabilityDetails_AddressDeliverabilityVerified_Fragment;

export type VerifyDeliveryAddressQueryVariables = Exact<{
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  country: Scalars['String'];
}>;


export type VerifyDeliveryAddressQuery = { __typename?: 'Query', addressDeliverability: { __typename: 'AddressDeliverabilityCorrectedAddress', city: string, country: string, state: string, street1: string, street2: string, zipCode: string } | { __typename: 'AddressDeliverabilityUnavailableError' } | { __typename: 'AddressDeliverabilityVerificationError' } | { __typename: 'AddressDeliverabilityVerified' } };

export type EmailAddressValidationQueryVariables = Exact<{
  email: Scalars['EmailAddress'];
}>;


export type EmailAddressValidationQuery = { __typename?: 'Query', emailAddressValidation: { __typename?: 'EmailAddressValidation', credentialsExist: boolean, possibleTypo: boolean, suggestion: any } };

export type VerifyPromoCodeQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type VerifyPromoCodeQuery = { __typename?: 'Query', verifyPromoCode: { __typename: 'InvalidPromoCodeError', name: string } | { __typename: 'PromoCode', name: string, title: string, condensedTitle: string, description: string, channel: string, termsUrl: any } };

export type CreateUserMutationVariables = Exact<{
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  authorizationAccessToken?: InputMaybe<Scalars['String']>;
  authorizationExpiresAt?: InputMaybe<Scalars['DateTime']>;
  authorizationProvider?: InputMaybe<Scalars['String']>;
  authorizationRefreshToken?: InputMaybe<Scalars['String']>;
  authorizationUid?: InputMaybe<Scalars['String']>;
  captchaToken?: InputMaybe<Scalars['String']>;
  clientCredentialsToken?: InputMaybe<Scalars['String']>;
  codeGroup?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  invitationCode?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  sourceAttributes?: InputMaybe<Scalars['JSON']>;
  sourceId?: InputMaybe<Scalars['String']>;
  udid: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'Session', token: string, uuid: string, refreshToken: string } };

export type CreateLaterContributionMutationVariables = Exact<{
  accountId: Scalars['ID'];
  amount: Scalars['Float'];
}>;


export type CreateLaterContributionMutation = { __typename?: 'Mutation', createLaterContribution: any };

export type StartInvestingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type StartInvestingInfoQuery = { __typename?: 'Query', recurringInvestmentSettings: { __typename?: 'RecurringInvestmentSettings', amount: number }, fundingSourceInfo: { __typename?: 'FundingSourceInfo', verified: boolean, type: FundingSourceType, name: string, accountNumberLastFour: string }, laterAccounts: Array<{ __typename?: 'LaterAccount', accountId: string }> };

export type LaterStartInvestingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type LaterStartInvestingInfoQuery = { __typename?: 'Query', investmentAccountsByUserId: Array<{ __typename?: 'InvestmentAccount', id: string, recurringInvestmentSettings: { __typename?: 'RecurringInvestmentSettings', amount: number } }>, linkedAccounts: Array<{ __typename?: 'LinkedAccount', linkedSubaccounts: Array<{ __typename?: 'LinkedSubaccount', role: LinkedSubaccountRoleEnum }> }> };

export type LinkedSubaccountRolesFragment = { __typename?: 'LinkedAccount', linkedSubaccounts: Array<{ __typename?: 'LinkedSubaccount', role: LinkedSubaccountRoleEnum }> };

export type MakeInvestmentMutationVariables = Exact<{
  amount: Scalars['Float'];
}>;


export type MakeInvestmentMutation = { __typename?: 'Mutation', makeInvestment: { __typename?: 'MakeInvestmentPayload', id: string } };

export type UpdateRecurringInvestmentMutationVariables = Exact<{
  input: RecurringInvestmentInput;
}>;


export type UpdateRecurringInvestmentMutation = { __typename?: 'Mutation', updateRecurringInvestment: { __typename?: 'RecurringInvestmentPayload', recurringInvestmentSettings: { __typename?: 'RecurringInvestmentSettings', amount: number, frequency: InvestmentFrequency, day: number } } };

export type CompleteFunnelOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type CompleteFunnelOnboardingMutation = { __typename?: 'Mutation', completeFunnelOnboarding: { __typename: 'RegistrationFunnel' } | { __typename: 'UnmetRequirementsException', requirements: Array<OnboardingRequirement> } };

export type SubscribedTierNameQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscribedTierNameQuery = { __typename?: 'Query', tierSubscriptionByUserId: { __typename?: 'TierSubscription', tier: { __typename?: 'Tier', name: string, key: TierKey } }, user: { __typename?: 'User', firstName: string } };

export type MocUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MocUserDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', email: string, firstName: string }, spendAccount: { __typename?: 'SpendAccount', accountId: string, bankCardOrder: { __typename?: 'BankCardOrder', kycStatus: KycStatus } }, linkedAccounts: Array<{ __typename?: 'LinkedAccount', id: string, externalSource: LinkedAccountExternalSourceEnum }> };

export type UserSuitabilityResponsesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSuitabilityResponsesQuery = { __typename?: 'Query', user: { __typename?: 'User', investmentAccounts: Array<{ __typename?: 'InvestmentAccount', product: InvestmentProduct, status: InvestmentAccountStatus }> }, suitabilityResponses: Array<{ __typename?: 'suitability_SuitabilityResponse', question: { __typename?: 'suitability_SuitabilityQuestion', text: string, id: string, possibleAnswers: Array<{ __typename?: 'suitability_SuitabilityAnswer', text: string, description: string, summary: string, id: string }> }, answer: { __typename?: 'suitability_SuitabilityAnswer', text: string } }> };

export type UpdateSuitabilityMutationVariables = Exact<{
  input: Array<Suitability_SuitabilityInput> | Suitability_SuitabilityInput;
}>;


export type UpdateSuitabilityMutation = { __typename?: 'Mutation', updateSuitability: { __typename?: 'suitability_UpdateSuitabilityResult', recommendedPortfolio: { __typename?: 'suitability_Portfolio', id: string } } };

export type ExchangeAcornsEarlyTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ExchangeAcornsEarlyTokenMutation = { __typename?: 'Mutation', exchangeAcornsEarlyToken: { __typename: 'AcornsEarlyUserDetails', externalId: string, email: string, credentialsExist: boolean, phoneNumber: string, firstName: string, lastName: string, address1: string, address2: string, city: string, state: string, zipCode: string } | { __typename: 'InvalidAcornsEarlyTokenException' } };

export type UpdateEarlyCustomerAddressMutationVariables = Exact<{
  addressType: AddressType;
  input: AddressInput;
}>;


export type UpdateEarlyCustomerAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename: 'Address' } };

export type UpdateEarlyCustomerInfoMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEarlyCustomerInfoMutation = { __typename?: 'Mutation', updatePersonalInfo: { __typename?: 'User', uuid: string } };

export type UpsertUserMatchMutationVariables = Exact<{
  input: UpsertUserMatchInput;
}>;


export type UpsertUserMatchMutation = { __typename?: 'Mutation', upsertUserMatch: { __typename: 'InternalErrorException' } | { __typename: 'UserMatch', externalMetadata: { __typename?: 'ExternalMetadata', isSubscriptionActive: boolean, membership: ExternalSubscriptionType } } };

export type UserMatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMatchesQuery = { __typename?: 'Query', userMatches: Array<{ __typename?: 'UserMatch', externalMetadata: { __typename?: 'ExternalMetadata', isSubscriptionActive: boolean, membership: ExternalSubscriptionType } }> };

export type ContextUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ContextUserQuery = { __typename?: 'Query', user: { __typename?: 'User', email: string } };

export type OnboardingRequirementsQueryVariables = Exact<{
  onboardingType: OnboardingType;
}>;


export type OnboardingRequirementsQuery = { __typename?: 'Query', onboardingRequirements: Array<OnboardingRequirement> };

export type RegisterProspectMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
  rawJson: Scalars['String'];
}>;


export type RegisterProspectMutation = { __typename?: 'Mutation', registerProspect: { __typename: 'InvalidConversionIdentifierException', message: string } | { __typename: 'InvalidSourceAttributesException', incorrectAttributes: Array<string> } | { __typename: 'RegistrationFunnel', sourceAttributes: { __typename?: 'SourceAttributes', affiliateCampaignID: string, freeformIdentifier: string }, metadata: { __typename?: 'FunnelMetadata', name: FunnelName, version: string }, flow: Array<{ __typename?: 'RegistrationPage', name: PageName, isBackEnabled: boolean, actions: Array<{ __typename?: 'RegistrationPageAction', type: ActionType, nextPage: PageName }>, content: { __typename?: 'RegistrationProminenceBannerContent', title: string, campaignId: string, icon: any, drawer: { __typename?: 'RegistrationDrawerContent', body: string, image: any, title: string } } }> } };

export type RegistrationFunnelQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type RegistrationFunnelQuery = { __typename?: 'Query', registrationFunnel: { __typename: 'RegistrationFunnel', sourceAttributes: { __typename?: 'SourceAttributes', affiliateCampaignID: string, freeformIdentifier: string }, metadata: { __typename?: 'FunnelMetadata', name: FunnelName, version: string }, flow: Array<{ __typename?: 'RegistrationPage', name: PageName, isBackEnabled: boolean, actions: Array<{ __typename?: 'RegistrationPageAction', type: ActionType, nextPage: PageName }>, content: { __typename?: 'RegistrationProminenceBannerContent', campaignId: string, title: string, icon: any, drawer: { __typename?: 'RegistrationDrawerContent', body: string, image: any, title: string } } }> } };

export type RegistrationCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistrationCheckQuery = { __typename?: 'Query', user: { __typename?: 'User', registrationComplete: boolean, uuid: string } };

export type BankInterestRatesQueryVariables = Exact<{
  productFilter?: InputMaybe<Array<InputMaybe<BankingProduct>> | InputMaybe<BankingProduct>>;
}>;


export type BankInterestRatesQuery = { __typename?: 'Query', bankInterestRates: { __typename?: 'BankInterestRates', bankInterestRates: Array<{ __typename?: 'BankInterestRate', currentApy: string, liveDate: string, productName: BankingProduct }> } | { __typename?: 'BankServiceFailure', reason: string, retryable: boolean } };

export type LinkedAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type LinkedAccountsQuery = { __typename?: 'Query', user: { __typename?: 'User', registrationComplete: boolean, uploads: Array<{ __typename?: 'UserUpload', id: string, documentType: string, createdAt: any }> }, fundingSourceInfo: { __typename?: 'FundingSourceInfo', name: string, balance: number, verified: boolean, verificationStatus: number, linkedSubaccountId: string, changeRequiresApproval: boolean }, linkedAccounts: Array<{ __typename?: 'LinkedAccount', id: string, createdAt: any, externalId: string, externalSource: LinkedAccountExternalSourceEnum, linked: boolean, status: LinkedAccountStatusEnum, financialInstitution: { __typename?: 'FinancialInstitution', id: string, externalId: string, logoUrl: string, name: string }, linkedSubaccounts: Array<{ __typename?: 'LinkedSubaccount', accountNumberLastFour: string, allowedRoles: Array<LinkedSubaccountRoleEnum>, balanceAvailable: number, balanceCurrent: number, id: string, linked: boolean, name: string, role: LinkedSubaccountRoleEnum, status: FundingSourceStatusEnum, subaccountType: string }> }> };

export type SetPrimaryFundingSourceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetPrimaryFundingSourceMutation = { __typename?: 'Mutation', assignLinkedSubaccount: { __typename?: 'LinkedSubaccount', id: string, updatedAt: any } };

export type FundingSourceInfoBankLinkingQueryVariables = Exact<{ [key: string]: never; }>;


export type FundingSourceInfoBankLinkingQuery = { __typename?: 'Query', fundingSourceInfo: { __typename?: 'FundingSourceInfo', type: FundingSourceType, name: string, accountNumberLastFour: string, balance: number, linkedSubaccountId: string, canChange: boolean, changeRequiresApproval: boolean, verified: boolean, verificationStatus: number } };

export type CaptureDeviceSessionIdMutationVariables = Exact<{
  deviceSessionId?: InputMaybe<Scalars['String']>;
}>;


export type CaptureDeviceSessionIdMutation = { __typename?: 'Mutation', updateVerificationProfile: { __typename: 'VerificationProfile' } };

export const AddressDeliverabilityDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment AddressDeliverabilityDetails on AddressDeliverabilityResult {
  __typename
  ... on AddressDeliverabilityCorrectedAddress {
    city
    country
    state
    street1
    street2
    zipCode
  }
}
    `;
export const LinkedSubaccountRolesFragmentDoc = /*#__PURE__*/ gql`
    fragment LinkedSubaccountRoles on LinkedAccount {
  linkedSubaccounts {
    role
  }
}
    `;
export const PlaidLinkWebhookDocument = /*#__PURE__*/ gql`
    query PlaidLinkWebhook {
  linkedAccountWebhooks {
    plaid
  }
}
    `;

/**
 * __usePlaidLinkWebhookQuery__
 *
 * To run a query within a React component, call `usePlaidLinkWebhookQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaidLinkWebhookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaidLinkWebhookQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaidLinkWebhookQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlaidLinkWebhookQuery, PlaidLinkWebhookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlaidLinkWebhookQuery, PlaidLinkWebhookQueryVariables>(PlaidLinkWebhookDocument, options);
      }
export function usePlaidLinkWebhookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlaidLinkWebhookQuery, PlaidLinkWebhookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlaidLinkWebhookQuery, PlaidLinkWebhookQueryVariables>(PlaidLinkWebhookDocument, options);
        }
export type PlaidLinkWebhookQueryHookResult = ReturnType<typeof usePlaidLinkWebhookQuery>;
export type PlaidLinkWebhookLazyQueryHookResult = ReturnType<typeof usePlaidLinkWebhookLazyQuery>;
export type PlaidLinkWebhookQueryResult = ApolloReactCommon.QueryResult<PlaidLinkWebhookQuery, PlaidLinkWebhookQueryVariables>;
export const UserDocument = /*#__PURE__*/ gql`
    query User {
  user {
    registrationComplete
    uuid
    email
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = ApolloReactCommon.QueryResult<UserQuery, UserQueryVariables>;
export const ProgramAgreementDocument = /*#__PURE__*/ gql`
    query ProgramAgreement {
  acceptanceDocument(type: "program_agreement") {
    url
  }
}
    `;

/**
 * __useProgramAgreementQuery__
 *
 * To run a query within a React component, call `useProgramAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramAgreementQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramAgreementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProgramAgreementQuery, ProgramAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProgramAgreementQuery, ProgramAgreementQueryVariables>(ProgramAgreementDocument, options);
      }
export function useProgramAgreementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProgramAgreementQuery, ProgramAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProgramAgreementQuery, ProgramAgreementQueryVariables>(ProgramAgreementDocument, options);
        }
export type ProgramAgreementQueryHookResult = ReturnType<typeof useProgramAgreementQuery>;
export type ProgramAgreementLazyQueryHookResult = ReturnType<typeof useProgramAgreementLazyQuery>;
export type ProgramAgreementQueryResult = ApolloReactCommon.QueryResult<ProgramAgreementQuery, ProgramAgreementQueryVariables>;
export const CreateIraWithProfileDocument = /*#__PURE__*/ gql`
    mutation createIRAWithProfile($iraType: InvestmentAccountTypes, $profileAttributes: [ProfileAttribute]!) {
  createIRAWithProfile(iraType: $iraType, profileAttributes: $profileAttributes) {
    iraType
    id
  }
}
    `;
export type CreateIraWithProfileMutationFn = ApolloReactCommon.MutationFunction<CreateIraWithProfileMutation, CreateIraWithProfileMutationVariables>;

/**
 * __useCreateIraWithProfileMutation__
 *
 * To run a mutation, you first call `useCreateIraWithProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIraWithProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIraWithProfileMutation, { data, loading, error }] = useCreateIraWithProfileMutation({
 *   variables: {
 *      iraType: // value for 'iraType'
 *      profileAttributes: // value for 'profileAttributes'
 *   },
 * });
 */
export function useCreateIraWithProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateIraWithProfileMutation, CreateIraWithProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateIraWithProfileMutation, CreateIraWithProfileMutationVariables>(CreateIraWithProfileDocument, options);
      }
export type CreateIraWithProfileMutationHookResult = ReturnType<typeof useCreateIraWithProfileMutation>;
export type CreateIraWithProfileMutationResult = ApolloReactCommon.MutationResult<CreateIraWithProfileMutation>;
export type CreateIraWithProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateIraWithProfileMutation, CreateIraWithProfileMutationVariables>;
export const LogoutDocument = /*#__PURE__*/ gql`
    mutation Logout {
  logout {
    __typename
  }
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshAuthTokensDocument = /*#__PURE__*/ gql`
    mutation RefreshAuthTokens($refreshToken: String!) {
  refreshAuthToken(input: {refreshToken: $refreshToken}) {
    __typename
    ... on AuthSession {
      token
      refreshToken
    }
  }
}
    `;
export type RefreshAuthTokensMutationFn = ApolloReactCommon.MutationFunction<RefreshAuthTokensMutation, RefreshAuthTokensMutationVariables>;

/**
 * __useRefreshAuthTokensMutation__
 *
 * To run a mutation, you first call `useRefreshAuthTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAuthTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAuthTokensMutation, { data, loading, error }] = useRefreshAuthTokensMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshAuthTokensMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshAuthTokensMutation, RefreshAuthTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefreshAuthTokensMutation, RefreshAuthTokensMutationVariables>(RefreshAuthTokensDocument, options);
      }
export type RefreshAuthTokensMutationHookResult = ReturnType<typeof useRefreshAuthTokensMutation>;
export type RefreshAuthTokensMutationResult = ApolloReactCommon.MutationResult<RefreshAuthTokensMutation>;
export type RefreshAuthTokensMutationOptions = ApolloReactCommon.BaseMutationOptions<RefreshAuthTokensMutation, RefreshAuthTokensMutationVariables>;
export const UserDetailsDocument = /*#__PURE__*/ gql`
    query UserDetails {
  user {
    registrationComplete
    state
    alerts {
      type
    }
  }
  userStatus {
    age
  }
  allBankAccounts(input: {type: spend}) {
    type
  }
}
    `;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsQueryResult = ApolloReactCommon.QueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export const UserRegistrationAndAccountsDocument = /*#__PURE__*/ gql`
    query UserRegistrationAndAccounts {
  fundingSourceAccounts {
    institutionName
    logoUrl
    last4
    role
  }
}
    `;

/**
 * __useUserRegistrationAndAccountsQuery__
 *
 * To run a query within a React component, call `useUserRegistrationAndAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRegistrationAndAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRegistrationAndAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRegistrationAndAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserRegistrationAndAccountsQuery, UserRegistrationAndAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserRegistrationAndAccountsQuery, UserRegistrationAndAccountsQueryVariables>(UserRegistrationAndAccountsDocument, options);
      }
export function useUserRegistrationAndAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserRegistrationAndAccountsQuery, UserRegistrationAndAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserRegistrationAndAccountsQuery, UserRegistrationAndAccountsQueryVariables>(UserRegistrationAndAccountsDocument, options);
        }
export type UserRegistrationAndAccountsQueryHookResult = ReturnType<typeof useUserRegistrationAndAccountsQuery>;
export type UserRegistrationAndAccountsLazyQueryHookResult = ReturnType<typeof useUserRegistrationAndAccountsLazyQuery>;
export type UserRegistrationAndAccountsQueryResult = ApolloReactCommon.QueryResult<UserRegistrationAndAccountsQuery, UserRegistrationAndAccountsQueryVariables>;
export const PlaidLayerLinkedAccountsDocument = /*#__PURE__*/ gql`
    query PlaidLayerLinkedAccounts {
  linkedAccounts(linked: true) {
    institutionName
    linkedSubaccounts {
      accountNumberLastFour
      name
      allowedRoles
      linkedAccount {
        logoUrl
        financialInstitution {
          directBank
          logoUrl
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePlaidLayerLinkedAccountsQuery__
 *
 * To run a query within a React component, call `usePlaidLayerLinkedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaidLayerLinkedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaidLayerLinkedAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaidLayerLinkedAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlaidLayerLinkedAccountsQuery, PlaidLayerLinkedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlaidLayerLinkedAccountsQuery, PlaidLayerLinkedAccountsQueryVariables>(PlaidLayerLinkedAccountsDocument, options);
      }
export function usePlaidLayerLinkedAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlaidLayerLinkedAccountsQuery, PlaidLayerLinkedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlaidLayerLinkedAccountsQuery, PlaidLayerLinkedAccountsQueryVariables>(PlaidLayerLinkedAccountsDocument, options);
        }
export type PlaidLayerLinkedAccountsQueryHookResult = ReturnType<typeof usePlaidLayerLinkedAccountsQuery>;
export type PlaidLayerLinkedAccountsLazyQueryHookResult = ReturnType<typeof usePlaidLayerLinkedAccountsLazyQuery>;
export type PlaidLayerLinkedAccountsQueryResult = ApolloReactCommon.QueryResult<PlaidLayerLinkedAccountsQuery, PlaidLayerLinkedAccountsQueryVariables>;
export const LinkedAccountsFundingSourceTypeDocument = /*#__PURE__*/ gql`
    query LinkedAccountsFundingSourceType {
  roundUpProfile {
    roundUpsEnabled
  }
  user {
    registrationComplete
  }
  linkedAccounts {
    externalSource
    institutionName
    linkedSubaccounts {
      role
    }
  }
}
    `;

/**
 * __useLinkedAccountsFundingSourceTypeQuery__
 *
 * To run a query within a React component, call `useLinkedAccountsFundingSourceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountsFundingSourceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountsFundingSourceTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkedAccountsFundingSourceTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LinkedAccountsFundingSourceTypeQuery, LinkedAccountsFundingSourceTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LinkedAccountsFundingSourceTypeQuery, LinkedAccountsFundingSourceTypeQueryVariables>(LinkedAccountsFundingSourceTypeDocument, options);
      }
export function useLinkedAccountsFundingSourceTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LinkedAccountsFundingSourceTypeQuery, LinkedAccountsFundingSourceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LinkedAccountsFundingSourceTypeQuery, LinkedAccountsFundingSourceTypeQueryVariables>(LinkedAccountsFundingSourceTypeDocument, options);
        }
export type LinkedAccountsFundingSourceTypeQueryHookResult = ReturnType<typeof useLinkedAccountsFundingSourceTypeQuery>;
export type LinkedAccountsFundingSourceTypeLazyQueryHookResult = ReturnType<typeof useLinkedAccountsFundingSourceTypeLazyQuery>;
export type LinkedAccountsFundingSourceTypeQueryResult = ApolloReactCommon.QueryResult<LinkedAccountsFundingSourceTypeQuery, LinkedAccountsFundingSourceTypeQueryVariables>;
export const UpdateContactInfoDocument = /*#__PURE__*/ gql`
    mutation UpdateContactInfo($address1: String!, $address2: String!, $city: String!, $state: String!, $zip: String!, $phoneNumber: String!) {
  updateContactInfo(
    input: {address1: $address1, address2: $address2, city: $city, state: $state, zip: $zip, phoneNumber: $phoneNumber}
  ) {
    uuid
  }
}
    `;
export type UpdateContactInfoMutationFn = ApolloReactCommon.MutationFunction<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>;

/**
 * __useUpdateContactInfoMutation__
 *
 * To run a mutation, you first call `useUpdateContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactInfoMutation, { data, loading, error }] = useUpdateContactInfoMutation({
 *   variables: {
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateContactInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>(UpdateContactInfoDocument, options);
      }
export type UpdateContactInfoMutationHookResult = ReturnType<typeof useUpdateContactInfoMutation>;
export type UpdateContactInfoMutationResult = ApolloReactCommon.MutationResult<UpdateContactInfoMutation>;
export type UpdateContactInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>;
export const UpdatePhoneNumberDocument = /*#__PURE__*/ gql`
    mutation UpdatePhoneNumber($phoneNumber: String!) {
  updateContactInfo(input: {phoneNumber: $phoneNumber}) {
    __typename
  }
}
    `;
export type UpdatePhoneNumberMutationFn = ApolloReactCommon.MutationFunction<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;

/**
 * __useUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberMutation, { data, loading, error }] = useUpdatePhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdatePhoneNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>(UpdatePhoneNumberDocument, options);
      }
export type UpdatePhoneNumberMutationHookResult = ReturnType<typeof useUpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationResult = ApolloReactCommon.MutationResult<UpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const UserResidentialAddressDocument = /*#__PURE__*/ gql`
    query UserResidentialAddress {
  user {
    address1
    address2
    city
    state
    zip
    phoneNumber
  }
  profile {
    createdAt
  }
}
    `;

/**
 * __useUserResidentialAddressQuery__
 *
 * To run a query within a React component, call `useUserResidentialAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserResidentialAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserResidentialAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserResidentialAddressQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserResidentialAddressQuery, UserResidentialAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserResidentialAddressQuery, UserResidentialAddressQueryVariables>(UserResidentialAddressDocument, options);
      }
export function useUserResidentialAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserResidentialAddressQuery, UserResidentialAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserResidentialAddressQuery, UserResidentialAddressQueryVariables>(UserResidentialAddressDocument, options);
        }
export type UserResidentialAddressQueryHookResult = ReturnType<typeof useUserResidentialAddressQuery>;
export type UserResidentialAddressLazyQueryHookResult = ReturnType<typeof useUserResidentialAddressLazyQuery>;
export type UserResidentialAddressQueryResult = ApolloReactCommon.QueryResult<UserResidentialAddressQuery, UserResidentialAddressQueryVariables>;
export const UpdateDateOfBirthDocument = /*#__PURE__*/ gql`
    mutation UpdateDateOfBirth($dob: String) {
  updatePersonalInfo(input: {dob: $dob}) {
    uuid
  }
}
    `;
export type UpdateDateOfBirthMutationFn = ApolloReactCommon.MutationFunction<UpdateDateOfBirthMutation, UpdateDateOfBirthMutationVariables>;

/**
 * __useUpdateDateOfBirthMutation__
 *
 * To run a mutation, you first call `useUpdateDateOfBirthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDateOfBirthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDateOfBirthMutation, { data, loading, error }] = useUpdateDateOfBirthMutation({
 *   variables: {
 *      dob: // value for 'dob'
 *   },
 * });
 */
export function useUpdateDateOfBirthMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDateOfBirthMutation, UpdateDateOfBirthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDateOfBirthMutation, UpdateDateOfBirthMutationVariables>(UpdateDateOfBirthDocument, options);
      }
export type UpdateDateOfBirthMutationHookResult = ReturnType<typeof useUpdateDateOfBirthMutation>;
export type UpdateDateOfBirthMutationResult = ApolloReactCommon.MutationResult<UpdateDateOfBirthMutation>;
export type UpdateDateOfBirthMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDateOfBirthMutation, UpdateDateOfBirthMutationVariables>;
export const FundingSourceInfoDocument = /*#__PURE__*/ gql`
    query FundingSourceInfo {
  user {
    uploads {
      id
      documentType
      createdAt
    }
  }
  fundingSourceInfo {
    name
    accountNumberLastFour
    balance
    linkedSubaccountId
    canChange
    changeRequiresApproval
    verified
    verificationStatus
  }
}
    `;

/**
 * __useFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingSourceInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FundingSourceInfoQuery, FundingSourceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundingSourceInfoQuery, FundingSourceInfoQueryVariables>(FundingSourceInfoDocument, options);
      }
export function useFundingSourceInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundingSourceInfoQuery, FundingSourceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundingSourceInfoQuery, FundingSourceInfoQueryVariables>(FundingSourceInfoDocument, options);
        }
export type FundingSourceInfoQueryHookResult = ReturnType<typeof useFundingSourceInfoQuery>;
export type FundingSourceInfoLazyQueryHookResult = ReturnType<typeof useFundingSourceInfoLazyQuery>;
export type FundingSourceInfoQueryResult = ApolloReactCommon.QueryResult<FundingSourceInfoQuery, FundingSourceInfoQueryVariables>;
export const RegistrationCompleteDocument = /*#__PURE__*/ gql`
    query RegistrationComplete {
  user {
    registrationComplete
  }
}
    `;

/**
 * __useRegistrationCompleteQuery__
 *
 * To run a query within a React component, call `useRegistrationCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationCompleteQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistrationCompleteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistrationCompleteQuery, RegistrationCompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistrationCompleteQuery, RegistrationCompleteQueryVariables>(RegistrationCompleteDocument, options);
      }
export function useRegistrationCompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistrationCompleteQuery, RegistrationCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistrationCompleteQuery, RegistrationCompleteQueryVariables>(RegistrationCompleteDocument, options);
        }
export type RegistrationCompleteQueryHookResult = ReturnType<typeof useRegistrationCompleteQuery>;
export type RegistrationCompleteLazyQueryHookResult = ReturnType<typeof useRegistrationCompleteLazyQuery>;
export type RegistrationCompleteQueryResult = ApolloReactCommon.QueryResult<RegistrationCompleteQuery, RegistrationCompleteQueryVariables>;
export const OpenInvestAccountDocument = /*#__PURE__*/ gql`
    query OpenInvestAccount {
  investmentAccountsByUserId(filter: {product: INVEST, accountStatus: OPEN}) {
    id
  }
}
    `;

/**
 * __useOpenInvestAccountQuery__
 *
 * To run a query within a React component, call `useOpenInvestAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenInvestAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenInvestAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenInvestAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpenInvestAccountQuery, OpenInvestAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OpenInvestAccountQuery, OpenInvestAccountQueryVariables>(OpenInvestAccountDocument, options);
      }
export function useOpenInvestAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpenInvestAccountQuery, OpenInvestAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OpenInvestAccountQuery, OpenInvestAccountQueryVariables>(OpenInvestAccountDocument, options);
        }
export type OpenInvestAccountQueryHookResult = ReturnType<typeof useOpenInvestAccountQuery>;
export type OpenInvestAccountLazyQueryHookResult = ReturnType<typeof useOpenInvestAccountLazyQuery>;
export type OpenInvestAccountQueryResult = ApolloReactCommon.QueryResult<OpenInvestAccountQuery, OpenInvestAccountQueryVariables>;
export const UpdateInvestorQuestionsDocument = /*#__PURE__*/ gql`
    mutation UpdateInvestorQuestions($employedAffiliatedWithBrokerDealer: Boolean!, $shareholderOrDirector: Boolean!, $subjectToBackupWithholding: Boolean!) {
  updateInvestorQuestions(
    input: {employedAffiliatedWithBrokerDealer: $employedAffiliatedWithBrokerDealer, shareholderOrDirector: $shareholderOrDirector, subjectToBackupWithholding: $subjectToBackupWithholding}
  ) {
    uuid
  }
}
    `;
export type UpdateInvestorQuestionsMutationFn = ApolloReactCommon.MutationFunction<UpdateInvestorQuestionsMutation, UpdateInvestorQuestionsMutationVariables>;

/**
 * __useUpdateInvestorQuestionsMutation__
 *
 * To run a mutation, you first call `useUpdateInvestorQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvestorQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvestorQuestionsMutation, { data, loading, error }] = useUpdateInvestorQuestionsMutation({
 *   variables: {
 *      employedAffiliatedWithBrokerDealer: // value for 'employedAffiliatedWithBrokerDealer'
 *      shareholderOrDirector: // value for 'shareholderOrDirector'
 *      subjectToBackupWithholding: // value for 'subjectToBackupWithholding'
 *   },
 * });
 */
export function useUpdateInvestorQuestionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInvestorQuestionsMutation, UpdateInvestorQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateInvestorQuestionsMutation, UpdateInvestorQuestionsMutationVariables>(UpdateInvestorQuestionsDocument, options);
      }
export type UpdateInvestorQuestionsMutationHookResult = ReturnType<typeof useUpdateInvestorQuestionsMutation>;
export type UpdateInvestorQuestionsMutationResult = ApolloReactCommon.MutationResult<UpdateInvestorQuestionsMutation>;
export type UpdateInvestorQuestionsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInvestorQuestionsMutation, UpdateInvestorQuestionsMutationVariables>;
export const UpgradeForLaterProductDocument = /*#__PURE__*/ gql`
    mutation UpgradeForLaterProduct($tierPriceId: ID!) {
  subscribeUserToTier(input: {tierPriceId: $tierPriceId}) {
    __typename
  }
}
    `;
export type UpgradeForLaterProductMutationFn = ApolloReactCommon.MutationFunction<UpgradeForLaterProductMutation, UpgradeForLaterProductMutationVariables>;

/**
 * __useUpgradeForLaterProductMutation__
 *
 * To run a mutation, you first call `useUpgradeForLaterProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeForLaterProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeForLaterProductMutation, { data, loading, error }] = useUpgradeForLaterProductMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useUpgradeForLaterProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeForLaterProductMutation, UpgradeForLaterProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeForLaterProductMutation, UpgradeForLaterProductMutationVariables>(UpgradeForLaterProductDocument, options);
      }
export type UpgradeForLaterProductMutationHookResult = ReturnType<typeof useUpgradeForLaterProductMutation>;
export type UpgradeForLaterProductMutationResult = ApolloReactCommon.MutationResult<UpgradeForLaterProductMutation>;
export type UpgradeForLaterProductMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeForLaterProductMutation, UpgradeForLaterProductMutationVariables>;
export const TiersForLaterDocument = /*#__PURE__*/ gql`
    query TiersForLater {
  tierGroupForUser {
    tierOptions {
      tier {
        name
        products {
          key
        }
        tierPrice {
          id
          amountV2 {
            value
            currency
          }
          billingFrequency
        }
      }
    }
  }
}
    `;

/**
 * __useTiersForLaterQuery__
 *
 * To run a query within a React component, call `useTiersForLaterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiersForLaterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiersForLaterQuery({
 *   variables: {
 *   },
 * });
 */
export function useTiersForLaterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TiersForLaterQuery, TiersForLaterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TiersForLaterQuery, TiersForLaterQueryVariables>(TiersForLaterDocument, options);
      }
export function useTiersForLaterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TiersForLaterQuery, TiersForLaterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TiersForLaterQuery, TiersForLaterQueryVariables>(TiersForLaterDocument, options);
        }
export type TiersForLaterQueryHookResult = ReturnType<typeof useTiersForLaterQuery>;
export type TiersForLaterLazyQueryHookResult = ReturnType<typeof useTiersForLaterLazyQuery>;
export type TiersForLaterQueryResult = ApolloReactCommon.QueryResult<TiersForLaterQuery, TiersForLaterQueryVariables>;
export const TierSubscriptionForUserDocument = /*#__PURE__*/ gql`
    query TierSubscriptionForUser {
  tierSubscriptionByUserId {
    id
    tierPrice {
      id
      billingFrequency
      amount {
        value
      }
    }
    tier {
      name
      products {
        key
      }
      matchProgram(investmentAccountType: ROTH_IRA) {
        matchPercentage
      }
    }
  }
}
    `;

/**
 * __useTierSubscriptionForUserQuery__
 *
 * To run a query within a React component, call `useTierSubscriptionForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierSubscriptionForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierSubscriptionForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierSubscriptionForUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TierSubscriptionForUserQuery, TierSubscriptionForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TierSubscriptionForUserQuery, TierSubscriptionForUserQueryVariables>(TierSubscriptionForUserDocument, options);
      }
export function useTierSubscriptionForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TierSubscriptionForUserQuery, TierSubscriptionForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TierSubscriptionForUserQuery, TierSubscriptionForUserQueryVariables>(TierSubscriptionForUserDocument, options);
        }
export type TierSubscriptionForUserQueryHookResult = ReturnType<typeof useTierSubscriptionForUserQuery>;
export type TierSubscriptionForUserLazyQueryHookResult = ReturnType<typeof useTierSubscriptionForUserLazyQuery>;
export type TierSubscriptionForUserQueryResult = ApolloReactCommon.QueryResult<TierSubscriptionForUserQuery, TierSubscriptionForUserQueryVariables>;
export const CoreSuitabilityQuestionsDocument = /*#__PURE__*/ gql`
    query CoreSuitabilityQuestions {
  suitabilityResponses {
    question {
      text
      id
      key
      possibleAnswers {
        text
        description
        summary
        id
        key
      }
    }
  }
}
    `;

/**
 * __useCoreSuitabilityQuestionsQuery__
 *
 * To run a query within a React component, call `useCoreSuitabilityQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreSuitabilityQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreSuitabilityQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoreSuitabilityQuestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CoreSuitabilityQuestionsQuery, CoreSuitabilityQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CoreSuitabilityQuestionsQuery, CoreSuitabilityQuestionsQueryVariables>(CoreSuitabilityQuestionsDocument, options);
      }
export function useCoreSuitabilityQuestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CoreSuitabilityQuestionsQuery, CoreSuitabilityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CoreSuitabilityQuestionsQuery, CoreSuitabilityQuestionsQueryVariables>(CoreSuitabilityQuestionsDocument, options);
        }
export type CoreSuitabilityQuestionsQueryHookResult = ReturnType<typeof useCoreSuitabilityQuestionsQuery>;
export type CoreSuitabilityQuestionsLazyQueryHookResult = ReturnType<typeof useCoreSuitabilityQuestionsLazyQuery>;
export type CoreSuitabilityQuestionsQueryResult = ApolloReactCommon.QueryResult<CoreSuitabilityQuestionsQuery, CoreSuitabilityQuestionsQueryVariables>;
export const SetPortfolioDocument = /*#__PURE__*/ gql`
    mutation setPortfolio($input: SetPortfolioInput!) {
  setPortfolio(input: $input) {
    portfolio {
      id
      name
    }
  }
}
    `;
export type SetPortfolioMutationFn = ApolloReactCommon.MutationFunction<SetPortfolioMutation, SetPortfolioMutationVariables>;

/**
 * __useSetPortfolioMutation__
 *
 * To run a mutation, you first call `useSetPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPortfolioMutation, { data, loading, error }] = useSetPortfolioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPortfolioMutation, SetPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPortfolioMutation, SetPortfolioMutationVariables>(SetPortfolioDocument, options);
      }
export type SetPortfolioMutationHookResult = ReturnType<typeof useSetPortfolioMutation>;
export type SetPortfolioMutationResult = ApolloReactCommon.MutationResult<SetPortfolioMutation>;
export type SetPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<SetPortfolioMutation, SetPortfolioMutationVariables>;
export const UpdateProfileDocument = /*#__PURE__*/ gql`
    mutation UpdateProfile($input: ProfileInput!) {
  updateProfile(input: $input) {
    annualIncome
  }
}
    `;
export type UpdateProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = ApolloReactCommon.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UpdateLaterSuitabilityDocument = /*#__PURE__*/ gql`
    mutation UpdateLaterSuitability($input: [suitability_SuitabilityInput!]!) {
  updateSuitability(suitabilityInput: $input) {
    recommendedPortfolio {
      id
    }
  }
}
    `;
export type UpdateLaterSuitabilityMutationFn = ApolloReactCommon.MutationFunction<UpdateLaterSuitabilityMutation, UpdateLaterSuitabilityMutationVariables>;

/**
 * __useUpdateLaterSuitabilityMutation__
 *
 * To run a mutation, you first call `useUpdateLaterSuitabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaterSuitabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaterSuitabilityMutation, { data, loading, error }] = useUpdateLaterSuitabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaterSuitabilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLaterSuitabilityMutation, UpdateLaterSuitabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLaterSuitabilityMutation, UpdateLaterSuitabilityMutationVariables>(UpdateLaterSuitabilityDocument, options);
      }
export type UpdateLaterSuitabilityMutationHookResult = ReturnType<typeof useUpdateLaterSuitabilityMutation>;
export type UpdateLaterSuitabilityMutationResult = ApolloReactCommon.MutationResult<UpdateLaterSuitabilityMutation>;
export type UpdateLaterSuitabilityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLaterSuitabilityMutation, UpdateLaterSuitabilityMutationVariables>;
export const UserQueryMfaSetupDocument = /*#__PURE__*/ gql`
    query UserQueryMfaSetup {
  user {
    phoneNumber
  }
}
    `;

/**
 * __useUserQueryMfaSetupQuery__
 *
 * To run a query within a React component, call `useUserQueryMfaSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryMfaSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryMfaSetupQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQueryMfaSetupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserQueryMfaSetupQuery, UserQueryMfaSetupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQueryMfaSetupQuery, UserQueryMfaSetupQueryVariables>(UserQueryMfaSetupDocument, options);
      }
export function useUserQueryMfaSetupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQueryMfaSetupQuery, UserQueryMfaSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQueryMfaSetupQuery, UserQueryMfaSetupQueryVariables>(UserQueryMfaSetupDocument, options);
        }
export type UserQueryMfaSetupQueryHookResult = ReturnType<typeof useUserQueryMfaSetupQuery>;
export type UserQueryMfaSetupLazyQueryHookResult = ReturnType<typeof useUserQueryMfaSetupLazyQuery>;
export type UserQueryMfaSetupQueryResult = ApolloReactCommon.QueryResult<UserQueryMfaSetupQuery, UserQueryMfaSetupQueryVariables>;
export const LinkAchAccountDocument = /*#__PURE__*/ gql`
    mutation LinkACHAccount($routing: String!, $account: String!) {
  linkACHAccount(routing: $routing, account: $account)
}
    `;
export type LinkAchAccountMutationFn = ApolloReactCommon.MutationFunction<LinkAchAccountMutation, LinkAchAccountMutationVariables>;

/**
 * __useLinkAchAccountMutation__
 *
 * To run a mutation, you first call `useLinkAchAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAchAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAchAccountMutation, { data, loading, error }] = useLinkAchAccountMutation({
 *   variables: {
 *      routing: // value for 'routing'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useLinkAchAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkAchAccountMutation, LinkAchAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkAchAccountMutation, LinkAchAccountMutationVariables>(LinkAchAccountDocument, options);
      }
export type LinkAchAccountMutationHookResult = ReturnType<typeof useLinkAchAccountMutation>;
export type LinkAchAccountMutationResult = ApolloReactCommon.MutationResult<LinkAchAccountMutation>;
export type LinkAchAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkAchAccountMutation, LinkAchAccountMutationVariables>;
export const UpdateNameDocument = /*#__PURE__*/ gql`
    mutation UpdateName($firstName: String, $lastName: String) {
  updatePersonalInfo(input: {firstName: $firstName, lastName: $lastName}) {
    uuid
  }
}
    `;
export type UpdateNameMutationFn = ApolloReactCommon.MutationFunction<UpdateNameMutation, UpdateNameMutationVariables>;

/**
 * __useUpdateNameMutation__
 *
 * To run a mutation, you first call `useUpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNameMutation, { data, loading, error }] = useUpdateNameMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNameMutation, UpdateNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNameMutation, UpdateNameMutationVariables>(UpdateNameDocument, options);
      }
export type UpdateNameMutationHookResult = ReturnType<typeof useUpdateNameMutation>;
export type UpdateNameMutationResult = ApolloReactCommon.MutationResult<UpdateNameMutation>;
export type UpdateNameMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNameMutation, UpdateNameMutationVariables>;
export const UserNameInfoDocument = /*#__PURE__*/ gql`
    query UserNameInfo {
  user {
    firstName
    lastName
  }
  profile {
    createdAt
  }
}
    `;

/**
 * __useUserNameInfoQuery__
 *
 * To run a query within a React component, call `useUserNameInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNameInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNameInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNameInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserNameInfoQuery, UserNameInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserNameInfoQuery, UserNameInfoQueryVariables>(UserNameInfoDocument, options);
      }
export function useUserNameInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserNameInfoQuery, UserNameInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserNameInfoQuery, UserNameInfoQueryVariables>(UserNameInfoDocument, options);
        }
export type UserNameInfoQueryHookResult = ReturnType<typeof useUserNameInfoQuery>;
export type UserNameInfoLazyQueryHookResult = ReturnType<typeof useUserNameInfoLazyQuery>;
export type UserNameInfoQueryResult = ApolloReactCommon.QueryResult<UserNameInfoQuery, UserNameInfoQueryVariables>;
export const PersonalInfoDocument = /*#__PURE__*/ gql`
    query PersonalInfo {
  user {
    firstName
    lastName
    phoneNumber
  }
  profile {
    createdAt
  }
}
    `;

/**
 * __usePersonalInfoQuery__
 *
 * To run a query within a React component, call `usePersonalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PersonalInfoQuery, PersonalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PersonalInfoQuery, PersonalInfoQueryVariables>(PersonalInfoDocument, options);
      }
export function usePersonalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PersonalInfoQuery, PersonalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PersonalInfoQuery, PersonalInfoQueryVariables>(PersonalInfoDocument, options);
        }
export type PersonalInfoQueryHookResult = ReturnType<typeof usePersonalInfoQuery>;
export type PersonalInfoLazyQueryHookResult = ReturnType<typeof usePersonalInfoLazyQuery>;
export type PersonalInfoQueryResult = ApolloReactCommon.QueryResult<PersonalInfoQuery, PersonalInfoQueryVariables>;
export const UpdatePersonalInfoDocument = /*#__PURE__*/ gql`
    mutation updatePersonalInfo($firstName: String, $lastName: String, $dob: String) {
  updatePersonalInfo(
    input: {firstName: $firstName, lastName: $lastName, dob: $dob}
  ) {
    uuid
  }
}
    `;
export type UpdatePersonalInfoMutationFn = ApolloReactCommon.MutationFunction<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>;

/**
 * __useUpdatePersonalInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalInfoMutation, { data, loading, error }] = useUpdatePersonalInfoMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dob: // value for 'dob'
 *   },
 * });
 */
export function useUpdatePersonalInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>(UpdatePersonalInfoDocument, options);
      }
export type UpdatePersonalInfoMutationHookResult = ReturnType<typeof useUpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationResult = ApolloReactCommon.MutationResult<UpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>;
export const UpdatePersonalInfoSignupDocument = /*#__PURE__*/ gql`
    mutation UpdatePersonalInfoSignup($address1: String, $address2: String, $city: String, $dob: String, $email: String, $firstName: String, $lastName: String, $phoneNumber: String, $state: String, $ssn: String, $zip: String) {
  updatePersonalInfo(
    input: {address1: $address1, address2: $address2, city: $city, dob: $dob, email: $email, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, ssn: $ssn, state: $state, zip: $zip}
  ) {
    uuid
  }
}
    `;
export type UpdatePersonalInfoSignupMutationFn = ApolloReactCommon.MutationFunction<UpdatePersonalInfoSignupMutation, UpdatePersonalInfoSignupMutationVariables>;

/**
 * __useUpdatePersonalInfoSignupMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalInfoSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalInfoSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalInfoSignupMutation, { data, loading, error }] = useUpdatePersonalInfoSignupMutation({
 *   variables: {
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      dob: // value for 'dob'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      state: // value for 'state'
 *      ssn: // value for 'ssn'
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useUpdatePersonalInfoSignupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePersonalInfoSignupMutation, UpdatePersonalInfoSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePersonalInfoSignupMutation, UpdatePersonalInfoSignupMutationVariables>(UpdatePersonalInfoSignupDocument, options);
      }
export type UpdatePersonalInfoSignupMutationHookResult = ReturnType<typeof useUpdatePersonalInfoSignupMutation>;
export type UpdatePersonalInfoSignupMutationResult = ApolloReactCommon.MutationResult<UpdatePersonalInfoSignupMutation>;
export type UpdatePersonalInfoSignupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePersonalInfoSignupMutation, UpdatePersonalInfoSignupMutationVariables>;
export const AuthProfileDocument = /*#__PURE__*/ gql`
    query AuthProfile {
  authProfile {
    emailVerifiedAt
    phoneNumberVerifiedAt
  }
}
    `;

/**
 * __useAuthProfileQuery__
 *
 * To run a query within a React component, call `useAuthProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AuthProfileQuery, AuthProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AuthProfileQuery, AuthProfileQueryVariables>(AuthProfileDocument, options);
      }
export function useAuthProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthProfileQuery, AuthProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AuthProfileQuery, AuthProfileQueryVariables>(AuthProfileDocument, options);
        }
export type AuthProfileQueryHookResult = ReturnType<typeof useAuthProfileQuery>;
export type AuthProfileLazyQueryHookResult = ReturnType<typeof useAuthProfileLazyQuery>;
export type AuthProfileQueryResult = ApolloReactCommon.QueryResult<AuthProfileQuery, AuthProfileQueryVariables>;
export const GenerateLayerLinkSessionDocument = /*#__PURE__*/ gql`
    mutation GenerateLayerLinkSession {
  generateLayerLinkSession(input: {}) {
    ... on PlaidLayerLinkSession {
      token
    }
    ... on UnrecoverableError {
      reason
    }
  }
}
    `;
export type GenerateLayerLinkSessionMutationFn = ApolloReactCommon.MutationFunction<GenerateLayerLinkSessionMutation, GenerateLayerLinkSessionMutationVariables>;

/**
 * __useGenerateLayerLinkSessionMutation__
 *
 * To run a mutation, you first call `useGenerateLayerLinkSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLayerLinkSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLayerLinkSessionMutation, { data, loading, error }] = useGenerateLayerLinkSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateLayerLinkSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateLayerLinkSessionMutation, GenerateLayerLinkSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateLayerLinkSessionMutation, GenerateLayerLinkSessionMutationVariables>(GenerateLayerLinkSessionDocument, options);
      }
export type GenerateLayerLinkSessionMutationHookResult = ReturnType<typeof useGenerateLayerLinkSessionMutation>;
export type GenerateLayerLinkSessionMutationResult = ApolloReactCommon.MutationResult<GenerateLayerLinkSessionMutation>;
export type GenerateLayerLinkSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateLayerLinkSessionMutation, GenerateLayerLinkSessionMutationVariables>;
export const RequestLayerSessionDocument = /*#__PURE__*/ gql`
    mutation RequestLayerSession($input: RequestLayerSessionInput!) {
  requestLayerSession(input: $input) {
    ... on RequestedLayerLinkSession {
      zipCode
      street2
      street1
      state
      ssnStorageResult
      lastName
      firstName
      dateOfBirth
      country
      city
    }
    ... on UnrecoverableError {
      reason
    }
  }
}
    `;
export type RequestLayerSessionMutationFn = ApolloReactCommon.MutationFunction<RequestLayerSessionMutation, RequestLayerSessionMutationVariables>;

/**
 * __useRequestLayerSessionMutation__
 *
 * To run a mutation, you first call `useRequestLayerSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLayerSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLayerSessionMutation, { data, loading, error }] = useRequestLayerSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestLayerSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestLayerSessionMutation, RequestLayerSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestLayerSessionMutation, RequestLayerSessionMutationVariables>(RequestLayerSessionDocument, options);
      }
export type RequestLayerSessionMutationHookResult = ReturnType<typeof useRequestLayerSessionMutation>;
export type RequestLayerSessionMutationResult = ApolloReactCommon.MutationResult<RequestLayerSessionMutation>;
export type RequestLayerSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestLayerSessionMutation, RequestLayerSessionMutationVariables>;
export const UpdateContactInfoPhoneNumberDocument = /*#__PURE__*/ gql`
    mutation UpdateContactInfoPhoneNumber($phoneNumber: String!) {
  updateContactInfo(input: {phoneNumber: $phoneNumber}) {
    __typename
  }
}
    `;
export type UpdateContactInfoPhoneNumberMutationFn = ApolloReactCommon.MutationFunction<UpdateContactInfoPhoneNumberMutation, UpdateContactInfoPhoneNumberMutationVariables>;

/**
 * __useUpdateContactInfoPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateContactInfoPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactInfoPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactInfoPhoneNumberMutation, { data, loading, error }] = useUpdateContactInfoPhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateContactInfoPhoneNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactInfoPhoneNumberMutation, UpdateContactInfoPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContactInfoPhoneNumberMutation, UpdateContactInfoPhoneNumberMutationVariables>(UpdateContactInfoPhoneNumberDocument, options);
      }
export type UpdateContactInfoPhoneNumberMutationHookResult = ReturnType<typeof useUpdateContactInfoPhoneNumberMutation>;
export type UpdateContactInfoPhoneNumberMutationResult = ApolloReactCommon.MutationResult<UpdateContactInfoPhoneNumberMutation>;
export type UpdateContactInfoPhoneNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContactInfoPhoneNumberMutation, UpdateContactInfoPhoneNumberMutationVariables>;
export const UserPhoneNumberDocument = /*#__PURE__*/ gql`
    query UserPhoneNumber {
  user {
    phoneNumber
  }
}
    `;

/**
 * __useUserPhoneNumberQuery__
 *
 * To run a query within a React component, call `useUserPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPhoneNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPhoneNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>(UserPhoneNumberDocument, options);
      }
export function useUserPhoneNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>(UserPhoneNumberDocument, options);
        }
export type UserPhoneNumberQueryHookResult = ReturnType<typeof useUserPhoneNumberQuery>;
export type UserPhoneNumberLazyQueryHookResult = ReturnType<typeof useUserPhoneNumberLazyQuery>;
export type UserPhoneNumberQueryResult = ApolloReactCommon.QueryResult<UserPhoneNumberQuery, UserPhoneNumberQueryVariables>;
export const OpenInvestmentAccountsDocument = /*#__PURE__*/ gql`
    query OpenInvestmentAccounts {
  investmentAccountsByUserId(filter: {accountStatus: OPEN}) {
    id
    product
    investmentAccountType
    portfolio {
      id
      name
    }
  }
}
    `;

/**
 * __useOpenInvestmentAccountsQuery__
 *
 * To run a query within a React component, call `useOpenInvestmentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenInvestmentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenInvestmentAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenInvestmentAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpenInvestmentAccountsQuery, OpenInvestmentAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OpenInvestmentAccountsQuery, OpenInvestmentAccountsQueryVariables>(OpenInvestmentAccountsDocument, options);
      }
export function useOpenInvestmentAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpenInvestmentAccountsQuery, OpenInvestmentAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OpenInvestmentAccountsQuery, OpenInvestmentAccountsQueryVariables>(OpenInvestmentAccountsDocument, options);
        }
export type OpenInvestmentAccountsQueryHookResult = ReturnType<typeof useOpenInvestmentAccountsQuery>;
export type OpenInvestmentAccountsLazyQueryHookResult = ReturnType<typeof useOpenInvestmentAccountsLazyQuery>;
export type OpenInvestmentAccountsQueryResult = ApolloReactCommon.QueryResult<OpenInvestmentAccountsQuery, OpenInvestmentAccountsQueryVariables>;
export const OpenCoreInvestmentAccountDocument = /*#__PURE__*/ gql`
    mutation openCoreInvestmentAccount($input: OpenCoreInvestmentAccountInput!) {
  openCoreInvestmentAccount(input: $input) {
    __typename
  }
}
    `;
export type OpenCoreInvestmentAccountMutationFn = ApolloReactCommon.MutationFunction<OpenCoreInvestmentAccountMutation, OpenCoreInvestmentAccountMutationVariables>;

/**
 * __useOpenCoreInvestmentAccountMutation__
 *
 * To run a mutation, you first call `useOpenCoreInvestmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenCoreInvestmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openCoreInvestmentAccountMutation, { data, loading, error }] = useOpenCoreInvestmentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenCoreInvestmentAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenCoreInvestmentAccountMutation, OpenCoreInvestmentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OpenCoreInvestmentAccountMutation, OpenCoreInvestmentAccountMutationVariables>(OpenCoreInvestmentAccountDocument, options);
      }
export type OpenCoreInvestmentAccountMutationHookResult = ReturnType<typeof useOpenCoreInvestmentAccountMutation>;
export type OpenCoreInvestmentAccountMutationResult = ApolloReactCommon.MutationResult<OpenCoreInvestmentAccountMutation>;
export type OpenCoreInvestmentAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<OpenCoreInvestmentAccountMutation, OpenCoreInvestmentAccountMutationVariables>;
export const AllPortfoliosDocument = /*#__PURE__*/ gql`
    query AllPortfolios {
  user {
    fundingSource {
      type
    }
  }
  userStatus {
    age
  }
  roundUpProfile {
    roundUpsEnabled
  }
  linkedAccounts {
    externalSource
  }
  portfolios {
    id
    name
    description
    projection {
      averageGrowthRate
      highestGrowthRate
      lowestGrowthRate
    }
    portfolioSecurityAllocations {
      allocationPercent
      security {
        displayName
        symbol
      }
      investmentCategories {
        bond
        crypto
      }
    }
    riskLevel
    theme
  }
}
    `;

/**
 * __useAllPortfoliosQuery__
 *
 * To run a query within a React component, call `useAllPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPortfoliosQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPortfoliosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllPortfoliosQuery, AllPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllPortfoliosQuery, AllPortfoliosQueryVariables>(AllPortfoliosDocument, options);
      }
export function useAllPortfoliosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllPortfoliosQuery, AllPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllPortfoliosQuery, AllPortfoliosQueryVariables>(AllPortfoliosDocument, options);
        }
export type AllPortfoliosQueryHookResult = ReturnType<typeof useAllPortfoliosQuery>;
export type AllPortfoliosLazyQueryHookResult = ReturnType<typeof useAllPortfoliosLazyQuery>;
export type AllPortfoliosQueryResult = ApolloReactCommon.QueryResult<AllPortfoliosQuery, AllPortfoliosQueryVariables>;
export const CreateInvestingStrategyRecommendationDocument = /*#__PURE__*/ gql`
    mutation CreateInvestingStrategyRecommendation($input: CreateInvestingStrategyRecommendationInput!) {
  createInvestingStrategyRecommendation(input: $input) {
    ... on BadRequestError {
      message
    }
    ... on RecommendedInvestingStrategy {
      accountSubtype
      portfolioId
    }
  }
}
    `;
export type CreateInvestingStrategyRecommendationMutationFn = ApolloReactCommon.MutationFunction<CreateInvestingStrategyRecommendationMutation, CreateInvestingStrategyRecommendationMutationVariables>;

/**
 * __useCreateInvestingStrategyRecommendationMutation__
 *
 * To run a mutation, you first call `useCreateInvestingStrategyRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvestingStrategyRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvestingStrategyRecommendationMutation, { data, loading, error }] = useCreateInvestingStrategyRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvestingStrategyRecommendationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvestingStrategyRecommendationMutation, CreateInvestingStrategyRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInvestingStrategyRecommendationMutation, CreateInvestingStrategyRecommendationMutationVariables>(CreateInvestingStrategyRecommendationDocument, options);
      }
export type CreateInvestingStrategyRecommendationMutationHookResult = ReturnType<typeof useCreateInvestingStrategyRecommendationMutation>;
export type CreateInvestingStrategyRecommendationMutationResult = ApolloReactCommon.MutationResult<CreateInvestingStrategyRecommendationMutation>;
export type CreateInvestingStrategyRecommendationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvestingStrategyRecommendationMutation, CreateInvestingStrategyRecommendationMutationVariables>;
export const CreateLaterAccountDocument = /*#__PURE__*/ gql`
    mutation CreateLaterAccount($portfolioId: String!, $accountSubtype: InvestmentAccountTypes!) {
  createInvestmentAccount(iraType: $accountSubtype, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateLaterAccountMutationFn = ApolloReactCommon.MutationFunction<CreateLaterAccountMutation, CreateLaterAccountMutationVariables>;

/**
 * __useCreateLaterAccountMutation__
 *
 * To run a mutation, you first call `useCreateLaterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaterAccountMutation, { data, loading, error }] = useCreateLaterAccountMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      accountSubtype: // value for 'accountSubtype'
 *   },
 * });
 */
export function useCreateLaterAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLaterAccountMutation, CreateLaterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLaterAccountMutation, CreateLaterAccountMutationVariables>(CreateLaterAccountDocument, options);
      }
export type CreateLaterAccountMutationHookResult = ReturnType<typeof useCreateLaterAccountMutation>;
export type CreateLaterAccountMutationResult = ApolloReactCommon.MutationResult<CreateLaterAccountMutation>;
export type CreateLaterAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLaterAccountMutation, CreateLaterAccountMutationVariables>;
export const UpdateSuitabilityProfileDocument = /*#__PURE__*/ gql`
    mutation UpdateSuitabilityProfile($input: ProfileInput!) {
  updateProfile(input: $input) {
    userId
  }
}
    `;
export type UpdateSuitabilityProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateSuitabilityProfileMutation, UpdateSuitabilityProfileMutationVariables>;

/**
 * __useUpdateSuitabilityProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSuitabilityProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuitabilityProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuitabilityProfileMutation, { data, loading, error }] = useUpdateSuitabilityProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSuitabilityProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSuitabilityProfileMutation, UpdateSuitabilityProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSuitabilityProfileMutation, UpdateSuitabilityProfileMutationVariables>(UpdateSuitabilityProfileDocument, options);
      }
export type UpdateSuitabilityProfileMutationHookResult = ReturnType<typeof useUpdateSuitabilityProfileMutation>;
export type UpdateSuitabilityProfileMutationResult = ApolloReactCommon.MutationResult<UpdateSuitabilityProfileMutation>;
export type UpdateSuitabilityProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSuitabilityProfileMutation, UpdateSuitabilityProfileMutationVariables>;
export const SuitabilityResponsesDocument = /*#__PURE__*/ gql`
    query SuitabilityResponses {
  suitabilityResponses {
    answer {
      id
      summary
    }
  }
}
    `;

/**
 * __useSuitabilityResponsesQuery__
 *
 * To run a query within a React component, call `useSuitabilityResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuitabilityResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuitabilityResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuitabilityResponsesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuitabilityResponsesQuery, SuitabilityResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuitabilityResponsesQuery, SuitabilityResponsesQueryVariables>(SuitabilityResponsesDocument, options);
      }
export function useSuitabilityResponsesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuitabilityResponsesQuery, SuitabilityResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuitabilityResponsesQuery, SuitabilityResponsesQueryVariables>(SuitabilityResponsesDocument, options);
        }
export type SuitabilityResponsesQueryHookResult = ReturnType<typeof useSuitabilityResponsesQuery>;
export type SuitabilityResponsesLazyQueryHookResult = ReturnType<typeof useSuitabilityResponsesLazyQuery>;
export type SuitabilityResponsesQueryResult = ApolloReactCommon.QueryResult<SuitabilityResponsesQuery, SuitabilityResponsesQueryVariables>;
export const UpdateAccountPortfolioDocument = /*#__PURE__*/ gql`
    mutation UpdateAccountPortfolio($investmentAccountId: ID!, $theme: PortfolioTheme!, $riskLevel: PortfolioRiskLevel!) {
  updateAccountPortfolio(
    input: {investmentAccountId: $investmentAccountId, theme: $theme, riskLevel: $riskLevel}
  ) {
    ... on InvestmentAccount {
      id
    }
  }
}
    `;
export type UpdateAccountPortfolioMutationFn = ApolloReactCommon.MutationFunction<UpdateAccountPortfolioMutation, UpdateAccountPortfolioMutationVariables>;

/**
 * __useUpdateAccountPortfolioMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPortfolioMutation, { data, loading, error }] = useUpdateAccountPortfolioMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      theme: // value for 'theme'
 *      riskLevel: // value for 'riskLevel'
 *   },
 * });
 */
export function useUpdateAccountPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountPortfolioMutation, UpdateAccountPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccountPortfolioMutation, UpdateAccountPortfolioMutationVariables>(UpdateAccountPortfolioDocument, options);
      }
export type UpdateAccountPortfolioMutationHookResult = ReturnType<typeof useUpdateAccountPortfolioMutation>;
export type UpdateAccountPortfolioMutationResult = ApolloReactCommon.MutationResult<UpdateAccountPortfolioMutation>;
export type UpdateAccountPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccountPortfolioMutation, UpdateAccountPortfolioMutationVariables>;
export const UserInvestmentDetailsDocument = /*#__PURE__*/ gql`
    query UserInvestmentDetails {
  user {
    sourceId
    fundingSource {
      type
    }
  }
  roundUpProfile {
    roundUpsEnabled
  }
  linkedAccounts {
    externalSource
  }
  portfolios {
    id
    name
    description
    projection {
      averageGrowthRate
      highestGrowthRate
      lowestGrowthRate
    }
    portfolioSecurityAllocations {
      allocationPercent
      security {
        displayName
        symbol
      }
      investmentCategories {
        bond
        crypto
      }
    }
    riskLevel
    theme
  }
  recommendedPortfolio {
    id
    name
  }
}
    `;

/**
 * __useUserInvestmentDetailsQuery__
 *
 * To run a query within a React component, call `useUserInvestmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvestmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvestmentDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInvestmentDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserInvestmentDetailsQuery, UserInvestmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserInvestmentDetailsQuery, UserInvestmentDetailsQueryVariables>(UserInvestmentDetailsDocument, options);
      }
export function useUserInvestmentDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserInvestmentDetailsQuery, UserInvestmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserInvestmentDetailsQuery, UserInvestmentDetailsQueryVariables>(UserInvestmentDetailsDocument, options);
        }
export type UserInvestmentDetailsQueryHookResult = ReturnType<typeof useUserInvestmentDetailsQuery>;
export type UserInvestmentDetailsLazyQueryHookResult = ReturnType<typeof useUserInvestmentDetailsLazyQuery>;
export type UserInvestmentDetailsQueryResult = ApolloReactCommon.QueryResult<UserInvestmentDetailsQuery, UserInvestmentDetailsQueryVariables>;
export const DynamicSubscriptionPricingContentDocument = /*#__PURE__*/ gql`
    query DynamicSubscriptionPricingContent {
  user {
    uuid
  }
  tierGroupForUser {
    id
    preferredTierId
    tierOptions {
      preferredTierPrice {
        amountV2 {
          value
          currency
        }
        billingFrequency
      }
      tier {
        id
        assetPath
        key
        name
        displayName
        description
        tierPrice {
          id
          amountV2 {
            value
            currency
          }
        }
        products {
          key
        }
        bundles {
          name
          iconPath
          products {
            descriptionKeys
            product {
              key
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDynamicSubscriptionPricingContentQuery__
 *
 * To run a query within a React component, call `useDynamicSubscriptionPricingContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicSubscriptionPricingContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicSubscriptionPricingContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useDynamicSubscriptionPricingContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DynamicSubscriptionPricingContentQuery, DynamicSubscriptionPricingContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DynamicSubscriptionPricingContentQuery, DynamicSubscriptionPricingContentQueryVariables>(DynamicSubscriptionPricingContentDocument, options);
      }
export function useDynamicSubscriptionPricingContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DynamicSubscriptionPricingContentQuery, DynamicSubscriptionPricingContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DynamicSubscriptionPricingContentQuery, DynamicSubscriptionPricingContentQueryVariables>(DynamicSubscriptionPricingContentDocument, options);
        }
export type DynamicSubscriptionPricingContentQueryHookResult = ReturnType<typeof useDynamicSubscriptionPricingContentQuery>;
export type DynamicSubscriptionPricingContentLazyQueryHookResult = ReturnType<typeof useDynamicSubscriptionPricingContentLazyQuery>;
export type DynamicSubscriptionPricingContentQueryResult = ApolloReactCommon.QueryResult<DynamicSubscriptionPricingContentQuery, DynamicSubscriptionPricingContentQueryVariables>;
export const SubscribeToTierDocument = /*#__PURE__*/ gql`
    mutation subscribeToTier($input: SubscribeToTierInput!) {
  subscribeToTier(input: $input) {
    __typename
    ... on TierSubscription {
      id
    }
  }
}
    `;
export type SubscribeToTierMutationFn = ApolloReactCommon.MutationFunction<SubscribeToTierMutation, SubscribeToTierMutationVariables>;

/**
 * __useSubscribeToTierMutation__
 *
 * To run a mutation, you first call `useSubscribeToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToTierMutation, { data, loading, error }] = useSubscribeToTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToTierMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubscribeToTierMutation, SubscribeToTierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubscribeToTierMutation, SubscribeToTierMutationVariables>(SubscribeToTierDocument, options);
      }
export type SubscribeToTierMutationHookResult = ReturnType<typeof useSubscribeToTierMutation>;
export type SubscribeToTierMutationResult = ApolloReactCommon.MutationResult<SubscribeToTierMutation>;
export type SubscribeToTierMutationOptions = ApolloReactCommon.BaseMutationOptions<SubscribeToTierMutation, SubscribeToTierMutationVariables>;
export const SubscriptionPricingContentDocument = /*#__PURE__*/ gql`
    query SubscriptionPricingContent {
  user {
    uuid
  }
  tierGroupForUser {
    id
    preferredTierId
    tierOptions {
      preferredTierPrice {
        amountV2 {
          currency
          value
        }
        billingFrequency
      }
      tier {
        id
        assetPath
        key
        name
        displayName
        description
        tierPrice {
          id
          amountV2 {
            currency
            value
          }
        }
        products {
          key
        }
        bundles {
          name
          iconPath
          products {
            descriptionKeys
            product {
              key
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSubscriptionPricingContentQuery__
 *
 * To run a query within a React component, call `useSubscriptionPricingContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPricingContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPricingContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPricingContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionPricingContentQuery, SubscriptionPricingContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionPricingContentQuery, SubscriptionPricingContentQueryVariables>(SubscriptionPricingContentDocument, options);
      }
export function useSubscriptionPricingContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionPricingContentQuery, SubscriptionPricingContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionPricingContentQuery, SubscriptionPricingContentQueryVariables>(SubscriptionPricingContentDocument, options);
        }
export type SubscriptionPricingContentQueryHookResult = ReturnType<typeof useSubscriptionPricingContentQuery>;
export type SubscriptionPricingContentLazyQueryHookResult = ReturnType<typeof useSubscriptionPricingContentLazyQuery>;
export type SubscriptionPricingContentQueryResult = ApolloReactCommon.QueryResult<SubscriptionPricingContentQuery, SubscriptionPricingContentQueryVariables>;
export const EarlyBeneficiariesDocument = /*#__PURE__*/ gql`
    query EarlyBeneficiaries {
  beneficiaries {
    id
    ssnPresent
    investmentAccount {
      id
      status
    }
  }
}
    `;

/**
 * __useEarlyBeneficiariesQuery__
 *
 * To run a query within a React component, call `useEarlyBeneficiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyBeneficiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyBeneficiariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyBeneficiariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EarlyBeneficiariesQuery, EarlyBeneficiariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EarlyBeneficiariesQuery, EarlyBeneficiariesQueryVariables>(EarlyBeneficiariesDocument, options);
      }
export function useEarlyBeneficiariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EarlyBeneficiariesQuery, EarlyBeneficiariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EarlyBeneficiariesQuery, EarlyBeneficiariesQueryVariables>(EarlyBeneficiariesDocument, options);
        }
export type EarlyBeneficiariesQueryHookResult = ReturnType<typeof useEarlyBeneficiariesQuery>;
export type EarlyBeneficiariesLazyQueryHookResult = ReturnType<typeof useEarlyBeneficiariesLazyQuery>;
export type EarlyBeneficiariesQueryResult = ApolloReactCommon.QueryResult<EarlyBeneficiariesQuery, EarlyBeneficiariesQueryVariables>;
export const ProductOnboardingAccountsDocument = /*#__PURE__*/ gql`
    query ProductOnboardingAccounts {
  investmentAccountsByUserId(filter: {accountStatus: OPEN, product: LATER}) {
    id
  }
  tierSubscriptionByUserId {
    tier {
      key
      products {
        key
      }
    }
  }
}
    `;

/**
 * __useProductOnboardingAccountsQuery__
 *
 * To run a query within a React component, call `useProductOnboardingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOnboardingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOnboardingAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductOnboardingAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductOnboardingAccountsQuery, ProductOnboardingAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOnboardingAccountsQuery, ProductOnboardingAccountsQueryVariables>(ProductOnboardingAccountsDocument, options);
      }
export function useProductOnboardingAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOnboardingAccountsQuery, ProductOnboardingAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOnboardingAccountsQuery, ProductOnboardingAccountsQueryVariables>(ProductOnboardingAccountsDocument, options);
        }
export type ProductOnboardingAccountsQueryHookResult = ReturnType<typeof useProductOnboardingAccountsQuery>;
export type ProductOnboardingAccountsLazyQueryHookResult = ReturnType<typeof useProductOnboardingAccountsLazyQuery>;
export type ProductOnboardingAccountsQueryResult = ApolloReactCommon.QueryResult<ProductOnboardingAccountsQuery, ProductOnboardingAccountsQueryVariables>;
export const UpdateRoundUpAccountDocument = /*#__PURE__*/ gql`
    mutation UpdateRoundUpAccount($enabled: Boolean!, $linkedSubaccountId: ID!) {
  updateRoundUpAccount(enabled: $enabled, linkedSubaccountId: $linkedSubaccountId) {
    enabled
  }
}
    `;
export type UpdateRoundUpAccountMutationFn = ApolloReactCommon.MutationFunction<UpdateRoundUpAccountMutation, UpdateRoundUpAccountMutationVariables>;

/**
 * __useUpdateRoundUpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateRoundUpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoundUpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoundUpAccountMutation, { data, loading, error }] = useUpdateRoundUpAccountMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      linkedSubaccountId: // value for 'linkedSubaccountId'
 *   },
 * });
 */
export function useUpdateRoundUpAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRoundUpAccountMutation, UpdateRoundUpAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRoundUpAccountMutation, UpdateRoundUpAccountMutationVariables>(UpdateRoundUpAccountDocument, options);
      }
export type UpdateRoundUpAccountMutationHookResult = ReturnType<typeof useUpdateRoundUpAccountMutation>;
export type UpdateRoundUpAccountMutationResult = ApolloReactCommon.MutationResult<UpdateRoundUpAccountMutation>;
export type UpdateRoundUpAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRoundUpAccountMutation, UpdateRoundUpAccountMutationVariables>;
export const LinkedAccountsAndFundingSourceDocument = /*#__PURE__*/ gql`
    query LinkedAccountsAndFundingSource {
  linkedAccounts(linked: true) {
    id
    createdAt
    externalId
    externalSource
    linked
    status
    financialInstitution {
      id
      externalId
      logoUrl
      name
    }
    linkedSubaccounts {
      accountNumberLastFour
      allowedRoles
      balanceAvailable
      balanceCurrent
      id
      linked
      name
      role
      status
      subaccountType
    }
  }
  roundUpProfile {
    roundUpsEnabled
    multiplier
    roundUpAccounts {
      createdAt
      linkedSubaccountId
      startDate
      updatedAt
      enabled
    }
  }
}
    `;

/**
 * __useLinkedAccountsAndFundingSourceQuery__
 *
 * To run a query within a React component, call `useLinkedAccountsAndFundingSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountsAndFundingSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountsAndFundingSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkedAccountsAndFundingSourceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LinkedAccountsAndFundingSourceQuery, LinkedAccountsAndFundingSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LinkedAccountsAndFundingSourceQuery, LinkedAccountsAndFundingSourceQueryVariables>(LinkedAccountsAndFundingSourceDocument, options);
      }
export function useLinkedAccountsAndFundingSourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LinkedAccountsAndFundingSourceQuery, LinkedAccountsAndFundingSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LinkedAccountsAndFundingSourceQuery, LinkedAccountsAndFundingSourceQueryVariables>(LinkedAccountsAndFundingSourceDocument, options);
        }
export type LinkedAccountsAndFundingSourceQueryHookResult = ReturnType<typeof useLinkedAccountsAndFundingSourceQuery>;
export type LinkedAccountsAndFundingSourceLazyQueryHookResult = ReturnType<typeof useLinkedAccountsAndFundingSourceLazyQuery>;
export type LinkedAccountsAndFundingSourceQueryResult = ApolloReactCommon.QueryResult<LinkedAccountsAndFundingSourceQuery, LinkedAccountsAndFundingSourceQueryVariables>;
export const FundingSourceAccountsDocument = /*#__PURE__*/ gql`
    query FundingSourceAccounts {
  fundingSourceAccounts {
    role
  }
}
    `;

/**
 * __useFundingSourceAccountsQuery__
 *
 * To run a query within a React component, call `useFundingSourceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingSourceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingSourceAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingSourceAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FundingSourceAccountsQuery, FundingSourceAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundingSourceAccountsQuery, FundingSourceAccountsQueryVariables>(FundingSourceAccountsDocument, options);
      }
export function useFundingSourceAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundingSourceAccountsQuery, FundingSourceAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundingSourceAccountsQuery, FundingSourceAccountsQueryVariables>(FundingSourceAccountsDocument, options);
        }
export type FundingSourceAccountsQueryHookResult = ReturnType<typeof useFundingSourceAccountsQuery>;
export type FundingSourceAccountsLazyQueryHookResult = ReturnType<typeof useFundingSourceAccountsLazyQuery>;
export type FundingSourceAccountsQueryResult = ApolloReactCommon.QueryResult<FundingSourceAccountsQuery, FundingSourceAccountsQueryVariables>;
export const SetManualRoundUpsDocument = /*#__PURE__*/ gql`
    mutation setManualRoundUps($roundUpIds: [ID!]!) {
  setManualRoundUps(roundUpIds: $roundUpIds) {
    change
  }
}
    `;
export type SetManualRoundUpsMutationFn = ApolloReactCommon.MutationFunction<SetManualRoundUpsMutation, SetManualRoundUpsMutationVariables>;

/**
 * __useSetManualRoundUpsMutation__
 *
 * To run a mutation, you first call `useSetManualRoundUpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetManualRoundUpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setManualRoundUpsMutation, { data, loading, error }] = useSetManualRoundUpsMutation({
 *   variables: {
 *      roundUpIds: // value for 'roundUpIds'
 *   },
 * });
 */
export function useSetManualRoundUpsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetManualRoundUpsMutation, SetManualRoundUpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetManualRoundUpsMutation, SetManualRoundUpsMutationVariables>(SetManualRoundUpsDocument, options);
      }
export type SetManualRoundUpsMutationHookResult = ReturnType<typeof useSetManualRoundUpsMutation>;
export type SetManualRoundUpsMutationResult = ApolloReactCommon.MutationResult<SetManualRoundUpsMutation>;
export type SetManualRoundUpsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetManualRoundUpsMutation, SetManualRoundUpsMutationVariables>;
export const RoundUpTransactionsDocument = /*#__PURE__*/ gql`
    query RoundUpTransactions($state: [RoundUpState!], $pageInput: PageInput) {
  roundUps(state: $state, pageInput: $pageInput) {
    pageInfo {
      hasNextPage
      limit
    }
    edges {
      cursor
      node {
        amount
        change
        instant
        manual
        multiplier
        name
        state
        transactionDate
        transactionId
      }
    }
  }
}
    `;

/**
 * __useRoundUpTransactionsQuery__
 *
 * To run a query within a React component, call `useRoundUpTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundUpTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundUpTransactionsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useRoundUpTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RoundUpTransactionsQuery, RoundUpTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RoundUpTransactionsQuery, RoundUpTransactionsQueryVariables>(RoundUpTransactionsDocument, options);
      }
export function useRoundUpTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RoundUpTransactionsQuery, RoundUpTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RoundUpTransactionsQuery, RoundUpTransactionsQueryVariables>(RoundUpTransactionsDocument, options);
        }
export type RoundUpTransactionsQueryHookResult = ReturnType<typeof useRoundUpTransactionsQuery>;
export type RoundUpTransactionsLazyQueryHookResult = ReturnType<typeof useRoundUpTransactionsLazyQuery>;
export type RoundUpTransactionsQueryResult = ApolloReactCommon.QueryResult<RoundUpTransactionsQuery, RoundUpTransactionsQueryVariables>;
export const UpdateRoundUpProfileDocument = /*#__PURE__*/ gql`
    mutation UpdateRoundUpProfile($roundUpsEnabled: Boolean) {
  roundUpProfile(input: {roundUpsEnabled: $roundUpsEnabled}) {
    roundUpsEnabled
  }
}
    `;
export type UpdateRoundUpProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateRoundUpProfileMutation, UpdateRoundUpProfileMutationVariables>;

/**
 * __useUpdateRoundUpProfileMutation__
 *
 * To run a mutation, you first call `useUpdateRoundUpProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoundUpProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoundUpProfileMutation, { data, loading, error }] = useUpdateRoundUpProfileMutation({
 *   variables: {
 *      roundUpsEnabled: // value for 'roundUpsEnabled'
 *   },
 * });
 */
export function useUpdateRoundUpProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRoundUpProfileMutation, UpdateRoundUpProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRoundUpProfileMutation, UpdateRoundUpProfileMutationVariables>(UpdateRoundUpProfileDocument, options);
      }
export type UpdateRoundUpProfileMutationHookResult = ReturnType<typeof useUpdateRoundUpProfileMutation>;
export type UpdateRoundUpProfileMutationResult = ApolloReactCommon.MutationResult<UpdateRoundUpProfileMutation>;
export type UpdateRoundUpProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRoundUpProfileMutation, UpdateRoundUpProfileMutationVariables>;
export const RoundUpsEnabledCheckDocument = /*#__PURE__*/ gql`
    query RoundUpsEnabledCheck {
  roundUpProfile {
    roundUpsEnabled
  }
}
    `;

/**
 * __useRoundUpsEnabledCheckQuery__
 *
 * To run a query within a React component, call `useRoundUpsEnabledCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundUpsEnabledCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundUpsEnabledCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoundUpsEnabledCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RoundUpsEnabledCheckQuery, RoundUpsEnabledCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RoundUpsEnabledCheckQuery, RoundUpsEnabledCheckQueryVariables>(RoundUpsEnabledCheckDocument, options);
      }
export function useRoundUpsEnabledCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RoundUpsEnabledCheckQuery, RoundUpsEnabledCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RoundUpsEnabledCheckQuery, RoundUpsEnabledCheckQueryVariables>(RoundUpsEnabledCheckDocument, options);
        }
export type RoundUpsEnabledCheckQueryHookResult = ReturnType<typeof useRoundUpsEnabledCheckQuery>;
export type RoundUpsEnabledCheckLazyQueryHookResult = ReturnType<typeof useRoundUpsEnabledCheckLazyQuery>;
export type RoundUpsEnabledCheckQueryResult = ApolloReactCommon.QueryResult<RoundUpsEnabledCheckQuery, RoundUpsEnabledCheckQueryVariables>;
export const CaptureEcbsvConsentDocument = /*#__PURE__*/ gql`
    mutation CaptureEcbsvConsent($consent: Boolean) {
  updateVerificationProfile(input: {eCBSVConsent: $consent}) {
    __typename
  }
}
    `;
export type CaptureEcbsvConsentMutationFn = ApolloReactCommon.MutationFunction<CaptureEcbsvConsentMutation, CaptureEcbsvConsentMutationVariables>;

/**
 * __useCaptureEcbsvConsentMutation__
 *
 * To run a mutation, you first call `useCaptureEcbsvConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureEcbsvConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureEcbsvConsentMutation, { data, loading, error }] = useCaptureEcbsvConsentMutation({
 *   variables: {
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useCaptureEcbsvConsentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CaptureEcbsvConsentMutation, CaptureEcbsvConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CaptureEcbsvConsentMutation, CaptureEcbsvConsentMutationVariables>(CaptureEcbsvConsentDocument, options);
      }
export type CaptureEcbsvConsentMutationHookResult = ReturnType<typeof useCaptureEcbsvConsentMutation>;
export type CaptureEcbsvConsentMutationResult = ApolloReactCommon.MutationResult<CaptureEcbsvConsentMutation>;
export type CaptureEcbsvConsentMutationOptions = ApolloReactCommon.BaseMutationOptions<CaptureEcbsvConsentMutation, CaptureEcbsvConsentMutationVariables>;
export const VerificationProfileDocument = /*#__PURE__*/ gql`
    query VerificationProfile {
  verificationProfile {
    eCBSV {
      providedAt
    }
  }
}
    `;

/**
 * __useVerificationProfileQuery__
 *
 * To run a query within a React component, call `useVerificationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerificationProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VerificationProfileQuery, VerificationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VerificationProfileQuery, VerificationProfileQueryVariables>(VerificationProfileDocument, options);
      }
export function useVerificationProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VerificationProfileQuery, VerificationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VerificationProfileQuery, VerificationProfileQueryVariables>(VerificationProfileDocument, options);
        }
export type VerificationProfileQueryHookResult = ReturnType<typeof useVerificationProfileQuery>;
export type VerificationProfileLazyQueryHookResult = ReturnType<typeof useVerificationProfileLazyQuery>;
export type VerificationProfileQueryResult = ApolloReactCommon.QueryResult<VerificationProfileQuery, VerificationProfileQueryVariables>;
export const UpdatePersonalInfoSsnDocument = /*#__PURE__*/ gql`
    mutation UpdatePersonalInfoSSN($input: PersonalInfoInput!) {
  updatePersonalInfo(input: $input) {
    uuid
  }
}
    `;
export type UpdatePersonalInfoSsnMutationFn = ApolloReactCommon.MutationFunction<UpdatePersonalInfoSsnMutation, UpdatePersonalInfoSsnMutationVariables>;

/**
 * __useUpdatePersonalInfoSsnMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalInfoSsnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalInfoSsnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalInfoSsnMutation, { data, loading, error }] = useUpdatePersonalInfoSsnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonalInfoSsnMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePersonalInfoSsnMutation, UpdatePersonalInfoSsnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePersonalInfoSsnMutation, UpdatePersonalInfoSsnMutationVariables>(UpdatePersonalInfoSsnDocument, options);
      }
export type UpdatePersonalInfoSsnMutationHookResult = ReturnType<typeof useUpdatePersonalInfoSsnMutation>;
export type UpdatePersonalInfoSsnMutationResult = ApolloReactCommon.MutationResult<UpdatePersonalInfoSsnMutation>;
export type UpdatePersonalInfoSsnMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePersonalInfoSsnMutation, UpdatePersonalInfoSsnMutationVariables>;
export const UpdateAddressDocument = /*#__PURE__*/ gql`
    mutation UpdateAddress($addressType: AddressType!, $input: AddressInput!) {
  updateAddress(input: $input, addressType: $addressType) {
    __typename
  }
}
    `;
export type UpdateAddressMutationFn = ApolloReactCommon.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      addressType: // value for 'addressType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = ApolloReactCommon.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdateResidentialAddressDocument = /*#__PURE__*/ gql`
    mutation UpdateResidentialAddress($address1: String!, $address2: String!, $city: String!, $state: String!, $zip: String!) {
  updateContactInfo(
    input: {address1: $address1, address2: $address2, city: $city, state: $state, zip: $zip}
  ) {
    uuid
  }
}
    `;
export type UpdateResidentialAddressMutationFn = ApolloReactCommon.MutationFunction<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>;

/**
 * __useUpdateResidentialAddressMutation__
 *
 * To run a mutation, you first call `useUpdateResidentialAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResidentialAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResidentialAddressMutation, { data, loading, error }] = useUpdateResidentialAddressMutation({
 *   variables: {
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useUpdateResidentialAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>(UpdateResidentialAddressDocument, options);
      }
export type UpdateResidentialAddressMutationHookResult = ReturnType<typeof useUpdateResidentialAddressMutation>;
export type UpdateResidentialAddressMutationResult = ApolloReactCommon.MutationResult<UpdateResidentialAddressMutation>;
export type UpdateResidentialAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>;
export const UserAddressValidationDocument = /*#__PURE__*/ gql`
    query UserAddressValidation {
  user {
    firstName
    lastName
  }
  residentialAddress: addresses(addressType: residential) {
    street1
    street2
    city
    state
    zipCode
    addressType
  }
  mailingAddress: addresses(addressType: mailing) {
    street1
    street2
    city
    state
    zipCode
    addressType
  }
}
    `;

/**
 * __useUserAddressValidationQuery__
 *
 * To run a query within a React component, call `useUserAddressValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAddressValidationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAddressValidationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserAddressValidationQuery, UserAddressValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserAddressValidationQuery, UserAddressValidationQueryVariables>(UserAddressValidationDocument, options);
      }
export function useUserAddressValidationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserAddressValidationQuery, UserAddressValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserAddressValidationQuery, UserAddressValidationQueryVariables>(UserAddressValidationDocument, options);
        }
export type UserAddressValidationQueryHookResult = ReturnType<typeof useUserAddressValidationQuery>;
export type UserAddressValidationLazyQueryHookResult = ReturnType<typeof useUserAddressValidationLazyQuery>;
export type UserAddressValidationQueryResult = ApolloReactCommon.QueryResult<UserAddressValidationQuery, UserAddressValidationQueryVariables>;
export const VerifyDeliveryAddressDocument = /*#__PURE__*/ gql`
    query VerifyDeliveryAddress($street1: String!, $street2: String, $city: String!, $state: String!, $zipCode: String!, $country: String!) {
  addressDeliverability(
    input: {street1: $street1, street2: $street2, city: $city, state: $state, zipCode: $zipCode, country: $country}
  ) {
    ...AddressDeliverabilityDetails
  }
}
    ${AddressDeliverabilityDetailsFragmentDoc}`;

/**
 * __useVerifyDeliveryAddressQuery__
 *
 * To run a query within a React component, call `useVerifyDeliveryAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyDeliveryAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyDeliveryAddressQuery({
 *   variables: {
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipCode: // value for 'zipCode'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useVerifyDeliveryAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VerifyDeliveryAddressQuery, VerifyDeliveryAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VerifyDeliveryAddressQuery, VerifyDeliveryAddressQueryVariables>(VerifyDeliveryAddressDocument, options);
      }
export function useVerifyDeliveryAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VerifyDeliveryAddressQuery, VerifyDeliveryAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VerifyDeliveryAddressQuery, VerifyDeliveryAddressQueryVariables>(VerifyDeliveryAddressDocument, options);
        }
export type VerifyDeliveryAddressQueryHookResult = ReturnType<typeof useVerifyDeliveryAddressQuery>;
export type VerifyDeliveryAddressLazyQueryHookResult = ReturnType<typeof useVerifyDeliveryAddressLazyQuery>;
export type VerifyDeliveryAddressQueryResult = ApolloReactCommon.QueryResult<VerifyDeliveryAddressQuery, VerifyDeliveryAddressQueryVariables>;
export const EmailAddressValidationDocument = /*#__PURE__*/ gql`
    query EmailAddressValidation($email: EmailAddress!) {
  emailAddressValidation(email: $email) {
    credentialsExist
    possibleTypo
    suggestion
  }
}
    `;

/**
 * __useEmailAddressValidationQuery__
 *
 * To run a query within a React component, call `useEmailAddressValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressValidationQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailAddressValidationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EmailAddressValidationQuery, EmailAddressValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EmailAddressValidationQuery, EmailAddressValidationQueryVariables>(EmailAddressValidationDocument, options);
      }
export function useEmailAddressValidationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmailAddressValidationQuery, EmailAddressValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EmailAddressValidationQuery, EmailAddressValidationQueryVariables>(EmailAddressValidationDocument, options);
        }
export type EmailAddressValidationQueryHookResult = ReturnType<typeof useEmailAddressValidationQuery>;
export type EmailAddressValidationLazyQueryHookResult = ReturnType<typeof useEmailAddressValidationLazyQuery>;
export type EmailAddressValidationQueryResult = ApolloReactCommon.QueryResult<EmailAddressValidationQuery, EmailAddressValidationQueryVariables>;
export const VerifyPromoCodeDocument = /*#__PURE__*/ gql`
    query verifyPromoCode($name: String!) {
  verifyPromoCode(name: $name) {
    ... on PromoCode {
      name
      title
      condensedTitle
      description
      channel
      termsUrl
      __typename
    }
    ... on InvalidPromoCodeError {
      name
      __typename
    }
  }
}
    `;

/**
 * __useVerifyPromoCodeQuery__
 *
 * To run a query within a React component, call `useVerifyPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyPromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyPromoCodeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useVerifyPromoCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>(VerifyPromoCodeDocument, options);
      }
export function useVerifyPromoCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>(VerifyPromoCodeDocument, options);
        }
export type VerifyPromoCodeQueryHookResult = ReturnType<typeof useVerifyPromoCodeQuery>;
export type VerifyPromoCodeLazyQueryHookResult = ReturnType<typeof useVerifyPromoCodeLazyQuery>;
export type VerifyPromoCodeQueryResult = ApolloReactCommon.QueryResult<VerifyPromoCodeQuery, VerifyPromoCodeQueryVariables>;
export const CreateUserDocument = /*#__PURE__*/ gql`
    mutation CreateUser($acceptanceDocumentVersionUuids: [String]!, $authorizationAccessToken: String, $authorizationExpiresAt: DateTime, $authorizationProvider: String, $authorizationRefreshToken: String, $authorizationUid: String, $captchaToken: String, $clientCredentialsToken: String, $codeGroup: String, $email: String!, $invitationCode: String, $password: String!, $sourceAttributes: JSON, $sourceId: String, $udid: String!) {
  createUser(
    input: {acceptanceDocumentVersionUuids: $acceptanceDocumentVersionUuids, authorizationAccessToken: $authorizationAccessToken, authorizationExpiresAt: $authorizationExpiresAt, authorizationProvider: $authorizationProvider, authorizationRefreshToken: $authorizationRefreshToken, authorizationUid: $authorizationUid, captchaToken: $captchaToken, clientCredentialsToken: $clientCredentialsToken, codeGroup: $codeGroup, email: $email, invitationCode: $invitationCode, password: $password, sourceAttributes: $sourceAttributes, sourceId: $sourceId, udid: $udid, usResident: true, withBasicAccount: false}
  ) {
    token
    uuid
    refreshToken
  }
}
    `;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      acceptanceDocumentVersionUuids: // value for 'acceptanceDocumentVersionUuids'
 *      authorizationAccessToken: // value for 'authorizationAccessToken'
 *      authorizationExpiresAt: // value for 'authorizationExpiresAt'
 *      authorizationProvider: // value for 'authorizationProvider'
 *      authorizationRefreshToken: // value for 'authorizationRefreshToken'
 *      authorizationUid: // value for 'authorizationUid'
 *      captchaToken: // value for 'captchaToken'
 *      clientCredentialsToken: // value for 'clientCredentialsToken'
 *      codeGroup: // value for 'codeGroup'
 *      email: // value for 'email'
 *      invitationCode: // value for 'invitationCode'
 *      password: // value for 'password'
 *      sourceAttributes: // value for 'sourceAttributes'
 *      sourceId: // value for 'sourceId'
 *      udid: // value for 'udid'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateLaterContributionDocument = /*#__PURE__*/ gql`
    mutation CreateLaterContribution($accountId: ID!, $amount: Float!) {
  createLaterContribution(accountId: $accountId, amount: $amount)
}
    `;
export type CreateLaterContributionMutationFn = ApolloReactCommon.MutationFunction<CreateLaterContributionMutation, CreateLaterContributionMutationVariables>;

/**
 * __useCreateLaterContributionMutation__
 *
 * To run a mutation, you first call `useCreateLaterContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaterContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaterContributionMutation, { data, loading, error }] = useCreateLaterContributionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCreateLaterContributionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLaterContributionMutation, CreateLaterContributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLaterContributionMutation, CreateLaterContributionMutationVariables>(CreateLaterContributionDocument, options);
      }
export type CreateLaterContributionMutationHookResult = ReturnType<typeof useCreateLaterContributionMutation>;
export type CreateLaterContributionMutationResult = ApolloReactCommon.MutationResult<CreateLaterContributionMutation>;
export type CreateLaterContributionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLaterContributionMutation, CreateLaterContributionMutationVariables>;
export const StartInvestingInfoDocument = /*#__PURE__*/ gql`
    query StartInvestingInfo {
  recurringInvestmentSettings {
    amount
  }
  fundingSourceInfo {
    verified
    type
    name
    accountNumberLastFour
  }
  laterAccounts {
    accountId
  }
}
    `;

/**
 * __useStartInvestingInfoQuery__
 *
 * To run a query within a React component, call `useStartInvestingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartInvestingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartInvestingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useStartInvestingInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StartInvestingInfoQuery, StartInvestingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StartInvestingInfoQuery, StartInvestingInfoQueryVariables>(StartInvestingInfoDocument, options);
      }
export function useStartInvestingInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StartInvestingInfoQuery, StartInvestingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StartInvestingInfoQuery, StartInvestingInfoQueryVariables>(StartInvestingInfoDocument, options);
        }
export type StartInvestingInfoQueryHookResult = ReturnType<typeof useStartInvestingInfoQuery>;
export type StartInvestingInfoLazyQueryHookResult = ReturnType<typeof useStartInvestingInfoLazyQuery>;
export type StartInvestingInfoQueryResult = ApolloReactCommon.QueryResult<StartInvestingInfoQuery, StartInvestingInfoQueryVariables>;
export const LaterStartInvestingInfoDocument = /*#__PURE__*/ gql`
    query LaterStartInvestingInfo {
  investmentAccountsByUserId(filter: {accountStatus: OPEN, product: LATER}) {
    id
    recurringInvestmentSettings {
      amount
    }
  }
  linkedAccounts(linked: true) {
    ...LinkedSubaccountRoles
  }
}
    ${LinkedSubaccountRolesFragmentDoc}`;

/**
 * __useLaterStartInvestingInfoQuery__
 *
 * To run a query within a React component, call `useLaterStartInvestingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterStartInvestingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterStartInvestingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterStartInvestingInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LaterStartInvestingInfoQuery, LaterStartInvestingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LaterStartInvestingInfoQuery, LaterStartInvestingInfoQueryVariables>(LaterStartInvestingInfoDocument, options);
      }
export function useLaterStartInvestingInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LaterStartInvestingInfoQuery, LaterStartInvestingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LaterStartInvestingInfoQuery, LaterStartInvestingInfoQueryVariables>(LaterStartInvestingInfoDocument, options);
        }
export type LaterStartInvestingInfoQueryHookResult = ReturnType<typeof useLaterStartInvestingInfoQuery>;
export type LaterStartInvestingInfoLazyQueryHookResult = ReturnType<typeof useLaterStartInvestingInfoLazyQuery>;
export type LaterStartInvestingInfoQueryResult = ApolloReactCommon.QueryResult<LaterStartInvestingInfoQuery, LaterStartInvestingInfoQueryVariables>;
export const MakeInvestmentDocument = /*#__PURE__*/ gql`
    mutation MakeInvestment($amount: Float!) {
  makeInvestment(input: {amount: $amount, type: credit}) {
    id
  }
}
    `;
export type MakeInvestmentMutationFn = ApolloReactCommon.MutationFunction<MakeInvestmentMutation, MakeInvestmentMutationVariables>;

/**
 * __useMakeInvestmentMutation__
 *
 * To run a mutation, you first call `useMakeInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeInvestmentMutation, { data, loading, error }] = useMakeInvestmentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useMakeInvestmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MakeInvestmentMutation, MakeInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MakeInvestmentMutation, MakeInvestmentMutationVariables>(MakeInvestmentDocument, options);
      }
export type MakeInvestmentMutationHookResult = ReturnType<typeof useMakeInvestmentMutation>;
export type MakeInvestmentMutationResult = ApolloReactCommon.MutationResult<MakeInvestmentMutation>;
export type MakeInvestmentMutationOptions = ApolloReactCommon.BaseMutationOptions<MakeInvestmentMutation, MakeInvestmentMutationVariables>;
export const UpdateRecurringInvestmentDocument = /*#__PURE__*/ gql`
    mutation UpdateRecurringInvestment($input: RecurringInvestmentInput!) {
  updateRecurringInvestment(input: $input) {
    recurringInvestmentSettings {
      amount
      frequency
      day
    }
  }
}
    `;
export type UpdateRecurringInvestmentMutationFn = ApolloReactCommon.MutationFunction<UpdateRecurringInvestmentMutation, UpdateRecurringInvestmentMutationVariables>;

/**
 * __useUpdateRecurringInvestmentMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringInvestmentMutation, { data, loading, error }] = useUpdateRecurringInvestmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRecurringInvestmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRecurringInvestmentMutation, UpdateRecurringInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRecurringInvestmentMutation, UpdateRecurringInvestmentMutationVariables>(UpdateRecurringInvestmentDocument, options);
      }
export type UpdateRecurringInvestmentMutationHookResult = ReturnType<typeof useUpdateRecurringInvestmentMutation>;
export type UpdateRecurringInvestmentMutationResult = ApolloReactCommon.MutationResult<UpdateRecurringInvestmentMutation>;
export type UpdateRecurringInvestmentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRecurringInvestmentMutation, UpdateRecurringInvestmentMutationVariables>;
export const CompleteFunnelOnboardingDocument = /*#__PURE__*/ gql`
    mutation CompleteFunnelOnboarding {
  completeFunnelOnboarding {
    __typename
    ... on UnmetRequirementsException {
      requirements
    }
  }
}
    `;
export type CompleteFunnelOnboardingMutationFn = ApolloReactCommon.MutationFunction<CompleteFunnelOnboardingMutation, CompleteFunnelOnboardingMutationVariables>;

/**
 * __useCompleteFunnelOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteFunnelOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteFunnelOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeFunnelOnboardingMutation, { data, loading, error }] = useCompleteFunnelOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompleteFunnelOnboardingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteFunnelOnboardingMutation, CompleteFunnelOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteFunnelOnboardingMutation, CompleteFunnelOnboardingMutationVariables>(CompleteFunnelOnboardingDocument, options);
      }
export type CompleteFunnelOnboardingMutationHookResult = ReturnType<typeof useCompleteFunnelOnboardingMutation>;
export type CompleteFunnelOnboardingMutationResult = ApolloReactCommon.MutationResult<CompleteFunnelOnboardingMutation>;
export type CompleteFunnelOnboardingMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteFunnelOnboardingMutation, CompleteFunnelOnboardingMutationVariables>;
export const SubscribedTierNameDocument = /*#__PURE__*/ gql`
    query SubscribedTierName {
  tierSubscriptionByUserId {
    tier {
      name
      key
    }
  }
  user {
    firstName
  }
}
    `;

/**
 * __useSubscribedTierNameQuery__
 *
 * To run a query within a React component, call `useSubscribedTierNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribedTierNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribedTierNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscribedTierNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscribedTierNameQuery, SubscribedTierNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscribedTierNameQuery, SubscribedTierNameQueryVariables>(SubscribedTierNameDocument, options);
      }
export function useSubscribedTierNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscribedTierNameQuery, SubscribedTierNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscribedTierNameQuery, SubscribedTierNameQueryVariables>(SubscribedTierNameDocument, options);
        }
export type SubscribedTierNameQueryHookResult = ReturnType<typeof useSubscribedTierNameQuery>;
export type SubscribedTierNameLazyQueryHookResult = ReturnType<typeof useSubscribedTierNameLazyQuery>;
export type SubscribedTierNameQueryResult = ApolloReactCommon.QueryResult<SubscribedTierNameQuery, SubscribedTierNameQueryVariables>;
export const MocUserDetailsDocument = /*#__PURE__*/ gql`
    query MocUserDetails {
  user {
    email
    firstName
  }
  spendAccount {
    accountId
    bankCardOrder {
      kycStatus
    }
  }
  linkedAccounts(linked: true) {
    id
    externalSource
  }
}
    `;

/**
 * __useMocUserDetailsQuery__
 *
 * To run a query within a React component, call `useMocUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMocUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMocUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMocUserDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MocUserDetailsQuery, MocUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MocUserDetailsQuery, MocUserDetailsQueryVariables>(MocUserDetailsDocument, options);
      }
export function useMocUserDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MocUserDetailsQuery, MocUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MocUserDetailsQuery, MocUserDetailsQueryVariables>(MocUserDetailsDocument, options);
        }
export type MocUserDetailsQueryHookResult = ReturnType<typeof useMocUserDetailsQuery>;
export type MocUserDetailsLazyQueryHookResult = ReturnType<typeof useMocUserDetailsLazyQuery>;
export type MocUserDetailsQueryResult = ApolloReactCommon.QueryResult<MocUserDetailsQuery, MocUserDetailsQueryVariables>;
export const UserSuitabilityResponsesDocument = /*#__PURE__*/ gql`
    query UserSuitabilityResponses {
  user {
    investmentAccounts {
      product
      status
    }
  }
  suitabilityResponses {
    question {
      text
      id
      possibleAnswers {
        text
        description
        summary
        id
      }
    }
    answer {
      text
    }
  }
}
    `;

/**
 * __useUserSuitabilityResponsesQuery__
 *
 * To run a query within a React component, call `useUserSuitabilityResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSuitabilityResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSuitabilityResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSuitabilityResponsesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserSuitabilityResponsesQuery, UserSuitabilityResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserSuitabilityResponsesQuery, UserSuitabilityResponsesQueryVariables>(UserSuitabilityResponsesDocument, options);
      }
export function useUserSuitabilityResponsesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSuitabilityResponsesQuery, UserSuitabilityResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserSuitabilityResponsesQuery, UserSuitabilityResponsesQueryVariables>(UserSuitabilityResponsesDocument, options);
        }
export type UserSuitabilityResponsesQueryHookResult = ReturnType<typeof useUserSuitabilityResponsesQuery>;
export type UserSuitabilityResponsesLazyQueryHookResult = ReturnType<typeof useUserSuitabilityResponsesLazyQuery>;
export type UserSuitabilityResponsesQueryResult = ApolloReactCommon.QueryResult<UserSuitabilityResponsesQuery, UserSuitabilityResponsesQueryVariables>;
export const UpdateSuitabilityDocument = /*#__PURE__*/ gql`
    mutation UpdateSuitability($input: [suitability_SuitabilityInput!]!) {
  updateSuitability(suitabilityInput: $input) {
    recommendedPortfolio {
      id
    }
  }
}
    `;
export type UpdateSuitabilityMutationFn = ApolloReactCommon.MutationFunction<UpdateSuitabilityMutation, UpdateSuitabilityMutationVariables>;

/**
 * __useUpdateSuitabilityMutation__
 *
 * To run a mutation, you first call `useUpdateSuitabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuitabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuitabilityMutation, { data, loading, error }] = useUpdateSuitabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSuitabilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSuitabilityMutation, UpdateSuitabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSuitabilityMutation, UpdateSuitabilityMutationVariables>(UpdateSuitabilityDocument, options);
      }
export type UpdateSuitabilityMutationHookResult = ReturnType<typeof useUpdateSuitabilityMutation>;
export type UpdateSuitabilityMutationResult = ApolloReactCommon.MutationResult<UpdateSuitabilityMutation>;
export type UpdateSuitabilityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSuitabilityMutation, UpdateSuitabilityMutationVariables>;
export const ExchangeAcornsEarlyTokenDocument = /*#__PURE__*/ gql`
    mutation ExchangeAcornsEarlyToken($token: String!) {
  exchangeAcornsEarlyToken(token: $token) {
    __typename
    ... on AcornsEarlyUserDetails {
      externalId
      email
      credentialsExist
      phoneNumber
      firstName
      lastName
      address1
      address2
      city
      state
      zipCode
    }
  }
}
    `;
export type ExchangeAcornsEarlyTokenMutationFn = ApolloReactCommon.MutationFunction<ExchangeAcornsEarlyTokenMutation, ExchangeAcornsEarlyTokenMutationVariables>;

/**
 * __useExchangeAcornsEarlyTokenMutation__
 *
 * To run a mutation, you first call `useExchangeAcornsEarlyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeAcornsEarlyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeAcornsEarlyTokenMutation, { data, loading, error }] = useExchangeAcornsEarlyTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useExchangeAcornsEarlyTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExchangeAcornsEarlyTokenMutation, ExchangeAcornsEarlyTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExchangeAcornsEarlyTokenMutation, ExchangeAcornsEarlyTokenMutationVariables>(ExchangeAcornsEarlyTokenDocument, options);
      }
export type ExchangeAcornsEarlyTokenMutationHookResult = ReturnType<typeof useExchangeAcornsEarlyTokenMutation>;
export type ExchangeAcornsEarlyTokenMutationResult = ApolloReactCommon.MutationResult<ExchangeAcornsEarlyTokenMutation>;
export type ExchangeAcornsEarlyTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<ExchangeAcornsEarlyTokenMutation, ExchangeAcornsEarlyTokenMutationVariables>;
export const UpdateEarlyCustomerAddressDocument = /*#__PURE__*/ gql`
    mutation UpdateEarlyCustomerAddress($addressType: AddressType!, $input: AddressInput!) {
  updateAddress(input: $input, addressType: $addressType) {
    __typename
  }
}
    `;
export type UpdateEarlyCustomerAddressMutationFn = ApolloReactCommon.MutationFunction<UpdateEarlyCustomerAddressMutation, UpdateEarlyCustomerAddressMutationVariables>;

/**
 * __useUpdateEarlyCustomerAddressMutation__
 *
 * To run a mutation, you first call `useUpdateEarlyCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEarlyCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEarlyCustomerAddressMutation, { data, loading, error }] = useUpdateEarlyCustomerAddressMutation({
 *   variables: {
 *      addressType: // value for 'addressType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEarlyCustomerAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEarlyCustomerAddressMutation, UpdateEarlyCustomerAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEarlyCustomerAddressMutation, UpdateEarlyCustomerAddressMutationVariables>(UpdateEarlyCustomerAddressDocument, options);
      }
export type UpdateEarlyCustomerAddressMutationHookResult = ReturnType<typeof useUpdateEarlyCustomerAddressMutation>;
export type UpdateEarlyCustomerAddressMutationResult = ApolloReactCommon.MutationResult<UpdateEarlyCustomerAddressMutation>;
export type UpdateEarlyCustomerAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEarlyCustomerAddressMutation, UpdateEarlyCustomerAddressMutationVariables>;
export const UpdateEarlyCustomerInfoDocument = /*#__PURE__*/ gql`
    mutation UpdateEarlyCustomerInfo($firstName: String, $lastName: String, $phoneNumber: String) {
  updatePersonalInfo(
    input: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber}
  ) {
    uuid
  }
}
    `;
export type UpdateEarlyCustomerInfoMutationFn = ApolloReactCommon.MutationFunction<UpdateEarlyCustomerInfoMutation, UpdateEarlyCustomerInfoMutationVariables>;

/**
 * __useUpdateEarlyCustomerInfoMutation__
 *
 * To run a mutation, you first call `useUpdateEarlyCustomerInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEarlyCustomerInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEarlyCustomerInfoMutation, { data, loading, error }] = useUpdateEarlyCustomerInfoMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateEarlyCustomerInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEarlyCustomerInfoMutation, UpdateEarlyCustomerInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEarlyCustomerInfoMutation, UpdateEarlyCustomerInfoMutationVariables>(UpdateEarlyCustomerInfoDocument, options);
      }
export type UpdateEarlyCustomerInfoMutationHookResult = ReturnType<typeof useUpdateEarlyCustomerInfoMutation>;
export type UpdateEarlyCustomerInfoMutationResult = ApolloReactCommon.MutationResult<UpdateEarlyCustomerInfoMutation>;
export type UpdateEarlyCustomerInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEarlyCustomerInfoMutation, UpdateEarlyCustomerInfoMutationVariables>;
export const UpsertUserMatchDocument = /*#__PURE__*/ gql`
    mutation UpsertUserMatch($input: UpsertUserMatchInput!) {
  upsertUserMatch(input: $input) {
    __typename
    ... on UserMatch {
      externalMetadata {
        isSubscriptionActive
        membership
      }
    }
  }
}
    `;
export type UpsertUserMatchMutationFn = ApolloReactCommon.MutationFunction<UpsertUserMatchMutation, UpsertUserMatchMutationVariables>;

/**
 * __useUpsertUserMatchMutation__
 *
 * To run a mutation, you first call `useUpsertUserMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserMatchMutation, { data, loading, error }] = useUpsertUserMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserMatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertUserMatchMutation, UpsertUserMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertUserMatchMutation, UpsertUserMatchMutationVariables>(UpsertUserMatchDocument, options);
      }
export type UpsertUserMatchMutationHookResult = ReturnType<typeof useUpsertUserMatchMutation>;
export type UpsertUserMatchMutationResult = ApolloReactCommon.MutationResult<UpsertUserMatchMutation>;
export type UpsertUserMatchMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertUserMatchMutation, UpsertUserMatchMutationVariables>;
export const UserMatchesDocument = /*#__PURE__*/ gql`
    query UserMatches {
  userMatches {
    externalMetadata {
      isSubscriptionActive
      membership
    }
  }
}
    `;

/**
 * __useUserMatchesQuery__
 *
 * To run a query within a React component, call `useUserMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMatchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMatchesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserMatchesQuery, UserMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserMatchesQuery, UserMatchesQueryVariables>(UserMatchesDocument, options);
      }
export function useUserMatchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserMatchesQuery, UserMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserMatchesQuery, UserMatchesQueryVariables>(UserMatchesDocument, options);
        }
export type UserMatchesQueryHookResult = ReturnType<typeof useUserMatchesQuery>;
export type UserMatchesLazyQueryHookResult = ReturnType<typeof useUserMatchesLazyQuery>;
export type UserMatchesQueryResult = ApolloReactCommon.QueryResult<UserMatchesQuery, UserMatchesQueryVariables>;
export const ContextUserDocument = /*#__PURE__*/ gql`
    query ContextUser {
  user {
    email
  }
}
    `;

/**
 * __useContextUserQuery__
 *
 * To run a query within a React component, call `useContextUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useContextUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContextUserQuery, ContextUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContextUserQuery, ContextUserQueryVariables>(ContextUserDocument, options);
      }
export function useContextUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContextUserQuery, ContextUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContextUserQuery, ContextUserQueryVariables>(ContextUserDocument, options);
        }
export type ContextUserQueryHookResult = ReturnType<typeof useContextUserQuery>;
export type ContextUserLazyQueryHookResult = ReturnType<typeof useContextUserLazyQuery>;
export type ContextUserQueryResult = ApolloReactCommon.QueryResult<ContextUserQuery, ContextUserQueryVariables>;
export const OnboardingRequirementsDocument = /*#__PURE__*/ gql`
    query OnboardingRequirements($onboardingType: OnboardingType!) {
  onboardingRequirements(onboardingType: $onboardingType)
}
    `;

/**
 * __useOnboardingRequirementsQuery__
 *
 * To run a query within a React component, call `useOnboardingRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingRequirementsQuery({
 *   variables: {
 *      onboardingType: // value for 'onboardingType'
 *   },
 * });
 */
export function useOnboardingRequirementsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OnboardingRequirementsQuery, OnboardingRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OnboardingRequirementsQuery, OnboardingRequirementsQueryVariables>(OnboardingRequirementsDocument, options);
      }
export function useOnboardingRequirementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OnboardingRequirementsQuery, OnboardingRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OnboardingRequirementsQuery, OnboardingRequirementsQueryVariables>(OnboardingRequirementsDocument, options);
        }
export type OnboardingRequirementsQueryHookResult = ReturnType<typeof useOnboardingRequirementsQuery>;
export type OnboardingRequirementsLazyQueryHookResult = ReturnType<typeof useOnboardingRequirementsLazyQuery>;
export type OnboardingRequirementsQueryResult = ApolloReactCommon.QueryResult<OnboardingRequirementsQuery, OnboardingRequirementsQueryVariables>;
export const RegisterProspectDocument = /*#__PURE__*/ gql`
    mutation RegisterProspect($email: String, $sourceId: String!, $rawJson: String!) {
  registerProspect(
    input: {email: $email, sourceAttributes: {sourceID: $sourceId, rawJSON: $rawJson}}
  ) {
    __typename
    ... on InvalidSourceAttributesException {
      incorrectAttributes
    }
    ... on InvalidConversionIdentifierException {
      message
    }
    ... on RegistrationFunnel {
      sourceAttributes {
        affiliateCampaignID
        freeformIdentifier
      }
      metadata {
        name
        version
      }
      flow {
        name
        actions {
          type
          nextPage
        }
        isBackEnabled
        content {
          ... on RegistrationProminenceBannerContent {
            title
            campaignId
            icon
            drawer {
              body
              image
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type RegisterProspectMutationFn = ApolloReactCommon.MutationFunction<RegisterProspectMutation, RegisterProspectMutationVariables>;

/**
 * __useRegisterProspectMutation__
 *
 * To run a mutation, you first call `useRegisterProspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProspectMutation, { data, loading, error }] = useRegisterProspectMutation({
 *   variables: {
 *      email: // value for 'email'
 *      sourceId: // value for 'sourceId'
 *      rawJson: // value for 'rawJson'
 *   },
 * });
 */
export function useRegisterProspectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterProspectMutation, RegisterProspectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterProspectMutation, RegisterProspectMutationVariables>(RegisterProspectDocument, options);
      }
export type RegisterProspectMutationHookResult = ReturnType<typeof useRegisterProspectMutation>;
export type RegisterProspectMutationResult = ApolloReactCommon.MutationResult<RegisterProspectMutation>;
export type RegisterProspectMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterProspectMutation, RegisterProspectMutationVariables>;
export const RegistrationFunnelDocument = /*#__PURE__*/ gql`
    query RegistrationFunnel($userId: ID) {
  registrationFunnel(filter: {userId: $userId}) {
    __typename
    sourceAttributes {
      affiliateCampaignID
      freeformIdentifier
    }
    metadata {
      name
      version
    }
    flow {
      name
      actions {
        type
        nextPage
      }
      isBackEnabled
      content {
        ... on RegistrationProminenceBannerContent {
          campaignId
          title
          icon
          drawer {
            body
            image
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRegistrationFunnelQuery__
 *
 * To run a query within a React component, call `useRegistrationFunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationFunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationFunnelQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRegistrationFunnelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistrationFunnelQuery, RegistrationFunnelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistrationFunnelQuery, RegistrationFunnelQueryVariables>(RegistrationFunnelDocument, options);
      }
export function useRegistrationFunnelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistrationFunnelQuery, RegistrationFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistrationFunnelQuery, RegistrationFunnelQueryVariables>(RegistrationFunnelDocument, options);
        }
export type RegistrationFunnelQueryHookResult = ReturnType<typeof useRegistrationFunnelQuery>;
export type RegistrationFunnelLazyQueryHookResult = ReturnType<typeof useRegistrationFunnelLazyQuery>;
export type RegistrationFunnelQueryResult = ApolloReactCommon.QueryResult<RegistrationFunnelQuery, RegistrationFunnelQueryVariables>;
export const RegistrationCheckDocument = /*#__PURE__*/ gql`
    query RegistrationCheck {
  user {
    registrationComplete
    uuid
  }
}
    `;

/**
 * __useRegistrationCheckQuery__
 *
 * To run a query within a React component, call `useRegistrationCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistrationCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistrationCheckQuery, RegistrationCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistrationCheckQuery, RegistrationCheckQueryVariables>(RegistrationCheckDocument, options);
      }
export function useRegistrationCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistrationCheckQuery, RegistrationCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistrationCheckQuery, RegistrationCheckQueryVariables>(RegistrationCheckDocument, options);
        }
export type RegistrationCheckQueryHookResult = ReturnType<typeof useRegistrationCheckQuery>;
export type RegistrationCheckLazyQueryHookResult = ReturnType<typeof useRegistrationCheckLazyQuery>;
export type RegistrationCheckQueryResult = ApolloReactCommon.QueryResult<RegistrationCheckQuery, RegistrationCheckQueryVariables>;
export const BankInterestRatesDocument = /*#__PURE__*/ gql`
    query BankInterestRates($productFilter: [BankingProduct]) {
  bankInterestRates(productFilter: $productFilter) {
    ... on BankInterestRates {
      bankInterestRates {
        currentApy
        liveDate
        productName
      }
    }
    ... on BankServiceFailure {
      reason
      retryable
    }
  }
}
    `;

/**
 * __useBankInterestRatesQuery__
 *
 * To run a query within a React component, call `useBankInterestRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankInterestRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankInterestRatesQuery({
 *   variables: {
 *      productFilter: // value for 'productFilter'
 *   },
 * });
 */
export function useBankInterestRatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BankInterestRatesQuery, BankInterestRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BankInterestRatesQuery, BankInterestRatesQueryVariables>(BankInterestRatesDocument, options);
      }
export function useBankInterestRatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BankInterestRatesQuery, BankInterestRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BankInterestRatesQuery, BankInterestRatesQueryVariables>(BankInterestRatesDocument, options);
        }
export type BankInterestRatesQueryHookResult = ReturnType<typeof useBankInterestRatesQuery>;
export type BankInterestRatesLazyQueryHookResult = ReturnType<typeof useBankInterestRatesLazyQuery>;
export type BankInterestRatesQueryResult = ApolloReactCommon.QueryResult<BankInterestRatesQuery, BankInterestRatesQueryVariables>;
export const LinkedAccountsDocument = /*#__PURE__*/ gql`
    query LinkedAccounts {
  user {
    uploads {
      id
      documentType
      createdAt
    }
    registrationComplete
  }
  fundingSourceInfo {
    name
    balance
    verified
    verificationStatus
    linkedSubaccountId
    changeRequiresApproval
  }
  linkedAccounts(linked: true) {
    id
    createdAt
    externalId
    externalSource
    linked
    status
    financialInstitution {
      id
      externalId
      logoUrl
      name
    }
    linkedSubaccounts {
      accountNumberLastFour
      allowedRoles
      balanceAvailable
      balanceCurrent
      id
      linked
      name
      role
      status
      subaccountType
    }
  }
}
    `;

/**
 * __useLinkedAccountsQuery__
 *
 * To run a query within a React component, call `useLinkedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkedAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LinkedAccountsQuery, LinkedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LinkedAccountsQuery, LinkedAccountsQueryVariables>(LinkedAccountsDocument, options);
      }
export function useLinkedAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LinkedAccountsQuery, LinkedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LinkedAccountsQuery, LinkedAccountsQueryVariables>(LinkedAccountsDocument, options);
        }
export type LinkedAccountsQueryHookResult = ReturnType<typeof useLinkedAccountsQuery>;
export type LinkedAccountsLazyQueryHookResult = ReturnType<typeof useLinkedAccountsLazyQuery>;
export type LinkedAccountsQueryResult = ApolloReactCommon.QueryResult<LinkedAccountsQuery, LinkedAccountsQueryVariables>;
export const SetPrimaryFundingSourceDocument = /*#__PURE__*/ gql`
    mutation SetPrimaryFundingSource($id: ID!) {
  assignLinkedSubaccount(linkedSubaccountId: $id, input: {role: primaryFunding}) {
    id
    updatedAt
  }
}
    `;
export type SetPrimaryFundingSourceMutationFn = ApolloReactCommon.MutationFunction<SetPrimaryFundingSourceMutation, SetPrimaryFundingSourceMutationVariables>;

/**
 * __useSetPrimaryFundingSourceMutation__
 *
 * To run a mutation, you first call `useSetPrimaryFundingSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryFundingSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryFundingSourceMutation, { data, loading, error }] = useSetPrimaryFundingSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPrimaryFundingSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPrimaryFundingSourceMutation, SetPrimaryFundingSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPrimaryFundingSourceMutation, SetPrimaryFundingSourceMutationVariables>(SetPrimaryFundingSourceDocument, options);
      }
export type SetPrimaryFundingSourceMutationHookResult = ReturnType<typeof useSetPrimaryFundingSourceMutation>;
export type SetPrimaryFundingSourceMutationResult = ApolloReactCommon.MutationResult<SetPrimaryFundingSourceMutation>;
export type SetPrimaryFundingSourceMutationOptions = ApolloReactCommon.BaseMutationOptions<SetPrimaryFundingSourceMutation, SetPrimaryFundingSourceMutationVariables>;
export const FundingSourceInfoBankLinkingDocument = /*#__PURE__*/ gql`
    query FundingSourceInfoBankLinking {
  fundingSourceInfo {
    type
    name
    accountNumberLastFour
    balance
    linkedSubaccountId
    canChange
    changeRequiresApproval
    verified
    verificationStatus
  }
}
    `;

/**
 * __useFundingSourceInfoBankLinkingQuery__
 *
 * To run a query within a React component, call `useFundingSourceInfoBankLinkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingSourceInfoBankLinkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingSourceInfoBankLinkingQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingSourceInfoBankLinkingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FundingSourceInfoBankLinkingQuery, FundingSourceInfoBankLinkingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundingSourceInfoBankLinkingQuery, FundingSourceInfoBankLinkingQueryVariables>(FundingSourceInfoBankLinkingDocument, options);
      }
export function useFundingSourceInfoBankLinkingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundingSourceInfoBankLinkingQuery, FundingSourceInfoBankLinkingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundingSourceInfoBankLinkingQuery, FundingSourceInfoBankLinkingQueryVariables>(FundingSourceInfoBankLinkingDocument, options);
        }
export type FundingSourceInfoBankLinkingQueryHookResult = ReturnType<typeof useFundingSourceInfoBankLinkingQuery>;
export type FundingSourceInfoBankLinkingLazyQueryHookResult = ReturnType<typeof useFundingSourceInfoBankLinkingLazyQuery>;
export type FundingSourceInfoBankLinkingQueryResult = ApolloReactCommon.QueryResult<FundingSourceInfoBankLinkingQuery, FundingSourceInfoBankLinkingQueryVariables>;
export const CaptureDeviceSessionIdDocument = /*#__PURE__*/ gql`
    mutation CaptureDeviceSessionId($deviceSessionId: String) {
  updateVerificationProfile(input: {deviceSessionId: $deviceSessionId}) {
    __typename
  }
}
    `;
export type CaptureDeviceSessionIdMutationFn = ApolloReactCommon.MutationFunction<CaptureDeviceSessionIdMutation, CaptureDeviceSessionIdMutationVariables>;

/**
 * __useCaptureDeviceSessionIdMutation__
 *
 * To run a mutation, you first call `useCaptureDeviceSessionIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureDeviceSessionIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureDeviceSessionIdMutation, { data, loading, error }] = useCaptureDeviceSessionIdMutation({
 *   variables: {
 *      deviceSessionId: // value for 'deviceSessionId'
 *   },
 * });
 */
export function useCaptureDeviceSessionIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CaptureDeviceSessionIdMutation, CaptureDeviceSessionIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CaptureDeviceSessionIdMutation, CaptureDeviceSessionIdMutationVariables>(CaptureDeviceSessionIdDocument, options);
      }
export type CaptureDeviceSessionIdMutationHookResult = ReturnType<typeof useCaptureDeviceSessionIdMutation>;
export type CaptureDeviceSessionIdMutationResult = ApolloReactCommon.MutationResult<CaptureDeviceSessionIdMutation>;
export type CaptureDeviceSessionIdMutationOptions = ApolloReactCommon.BaseMutationOptions<CaptureDeviceSessionIdMutation, CaptureDeviceSessionIdMutationVariables>;


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes = {
  AbstractSwitch: ( AcornsPdfSwitch ) | ( OnlineSwitch ) | ( SubmittableSwitch );
  AcceptDocumentResponse: ( AcceptedDocument ) | ( DocumentNotFound ) | ( UserNotFound );
  ActionScreenComponent: ( ActionWidget );
  ActivateOauthAppClientResult: ( OauthAppClient ) | ( OauthAppClientNotFoundException );
  ActivateOauthAppResult: ( OauthApp ) | ( OauthAppNotFoundException );
  AddCohortEligibilityResult: ( UserCohorts );
  AddPolicyResult: ( AddPolicySuccess ) | ( PoliciesRecordDoesNotExistException ) | ( PolicyNotAddedException );
  AddSearchTermToLearnSearchHistoryResult: ( LearnSearchTermSavedResult );
  AddSecurityToPortfolioResult: ( InvestmentAccountNotFoundException ) | ( InvestmentAccountNotSupportedException ) | ( Portfolio ) | ( PortfolioNotFoundException ) | ( PortfolioNotSupportedException ) | ( SecurityNotSupportedException );
  AddSelfDirectedPortfolioResult: ( CustomerAgreementRequiredException ) | ( InvalidInvestmentAccountException ) | ( InvalidSubscriptionTierException ) | ( InvestmentAccount ) | ( PortfolioNotFoundException );
  AddressDeliverabilityResult: ( AddressDeliverabilityCorrectedAddress ) | ( AddressDeliverabilityUnavailableError ) | ( AddressDeliverabilityVerificationError ) | ( AddressDeliverabilityVerified );
  AlertHubBeneficiaryAlert: ( MissingSsnBeneficiaryAlertItem ) | ( UnverifiedBeneficiarySsnAlertItem );
  AllCheckPaymentsResult: ( AuthorizationError ) | ( CheckPaymentConnection );
  AnswerChallengeResult: ( AnswerChallengeSuccess ) | ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException );
  AnswerLearnQuizQuestionResult: ( LearnQuizAnswerResult ) | ( RecordDoesNotExistError ) | ( UnauthorizedModifyLockedContentError );
  ApplyPromoCodeResult: ( InvalidPromoCodeError ) | ( PromoCodeCustomer );
  ApplyPromotionResult: ( PromotionConsumedError ) | ( PromotionExpiredError ) | ( PromotionNotFoundError ) | ( SubscriberIneligibleError ) | ( TierSubscription );
  ApplyPromotionalWaiverResult: ( InvalidDateException ) | ( InvalidUserIdException ) | ( PromotionalWaiver_V2 ) | ( WaiverCreationException );
  ApplyProvisionalWaiverResult: ( InvalidDateException ) | ( InvalidUserIdException ) | ( ProvisionalWaiver_V2 ) | ( WaiverCreationException );
  AuthenticateForFeeNegotiationResult: ( AuthenticateForFeeNegotiationStatus ) | ( LinkedAccountNotFound ) | ( NegotiationServiceConnectionFailure );
  AuthenticateNegotiationStatusResult: ( AuthenticateForFeeNegotiationStatus ) | ( LinkedAccountNotFound );
  AuthenticateResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthSession ) | ( AuthenticatorTypeAlreadyRegisteredException ) | ( AuthenticatorUnavailableException ) | ( ChallengeRateExceededException ) | ( DeviceBlockedException ) | ( EmailAuthChallenge ) | ( InvalidCredentialsException ) | ( LoginRateLimitedException ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge ) | ( UserLockedException ) | ( UserSuspendedException );
  BankCardPanDisplayResult: ( BankCardPanDisplayPayload );
  BankCardProvisioningDetailsResult: ( BankCardProvisioningDetailsPayload );
  BankInterestRatesResult: ( BankInterestRates ) | ( BankServiceFailure );
  BannersResponse: ( BannersErrors ) | ( HelpcenterBannerContent ) | ( SiteWideBannerContent );
  BatchAddTierSubscriptionsResult: ( BatchAddTierSubscriptions ) | ( InvalidTier ) | ( InvalidTierPrice );
  BenefitPartnerResponse: ( ProductNotSupportedException ) | ( TaxFilingPartner );
  BlockDeviceResult: ( Device ) | ( DeviceNotFoundException );
  CancelCheckPaymentResult: ( AuthorizationError ) | ( CheckPayment ) | ( ResourceNotFoundError ) | ( UnableToCancelCheckError );
  CancelIntentResult: ( Intent ) | ( ValidationError );
  CancelInvestmentAccountClosureRequestResult: ( AccountClosedException ) | ( AccountNotFoundException ) | ( ClosureRequestDoesNotExistException ) | ( InvestmentAccount );
  CancelInvestmentResult: ( CancelInvestmentPayload ) | ( InvestmentNotFoundException ) | ( InvestmentUncancellableException );
  CancelMoneyAssignmentResult: ( MoneyAssignmentAlreadyTransferredError ) | ( MoneyAssignmentNotFoundError ) | ( MoneyRulesCancelMoneyAssignmentSuccess );
  CancelRecurringTransferResult: ( RecurringTransfer ) | ( VersionMismatchException );
  ChangeOutsideContributionAmountResult: ( ContributionAmountAboveThresholdError ) | ( ContributionAmountBelowThresholdError ) | ( OutsideContributionCheckoutCart );
  ChangePasswordResult: ( ChangePasswordSuccess ) | ( IncorrectOldPasswordException ) | ( IncorrectSecurityAnswerException ) | ( InvalidPasswordException );
  ChatHistoryCitationV2: ( LearnHubCitation ) | ( SupportCitation );
  ChatMessageStreamResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversTypes['ChatWidget']> } ) | ( ChatHistoryMessageBody ) | ( Omit<ChatHistoryMessageFooter, 'chatWidgets'> & { chatWidgets: Array<ResolversTypes['ChatWidget']> } ) | ( ChatHistoryMessageHeader );
  ChatWidget: ( ChatChoiceWidget ) | ( Omit<CitationWidget, 'citations'> & { citations: Array<ResolversTypes['ChatHistoryCitationV2']> } ) | ( CustomerSupportChatWidget ) | ( DeeplinkWidget );
  CloseBankAccountResult: ( BankAccount ) | ( BankAccountNotFoundError );
  CloseInvestmentAccountResult: ( AccountNotFoundException ) | ( InvestmentAccount ) | ( InvestmentAccountAlreadyClosed ) | ( InvestmentAccountClosureInProgress ) | ( LaterAccountRequiresTaxWithholdings ) | ( LaterAccountRequiresWithdrawalReason ) | ( LaterAccountTaxWithholdingsPercentageExceeded ) | ( NonBasicAccountOpenException );
  CloseUserAccountResult: ( OpenAccountsException ) | ( UserNotFoundException ) | ( User_V2 );
  CompleteFunnelOnboardingResult: ( RegistrationFunnel ) | ( UnmetRequirementsException );
  ConnectACHAccountResult: ( ConnectAchAccountSucceeded ) | ( InstitutionNotSupportedError );
  ConsumeUserTokenResult: ( InvalidUserTokenException ) | ( UserToken );
  CourseTheme: ( LearnThemeLiteral );
  CreateAuthProfileResult: ( AuthProfile ) | ( AuthProfileAlreadyExistsException );
  CreateBeneficiaryResult: ( Beneficiary ) | ( BeneficiaryExceedsAgeLimitException ) | ( InternalErrorException ) | ( InvalidDateOfBirthException ) | ( InvalidFirstNameException ) | ( InvalidLastNameException );
  CreateDelegateResult: ( DelegateDefinition );
  CreateDirectDepositLinkInfoSwitch: ( CreateDirectDepositLinkInfoFailure ) | ( CreateDirectDepositLinkInfoPayload );
  CreateImplicitTokenForUserResult: ( ImplicitToken ) | ( InvalidOauthAppClientIdException ) | ( OauthAppNotFoundException );
  CreateIntentResult: ( Intent ) | ( ValidationError );
  CreateInvestingStrategyRecommendationResult: ( BadRequestError ) | ( RecommendedInvestingStrategy );
  CreateJobAlertResult: ( JobAlert );
  CreateOauthAppResult: ( OauthApp );
  CreateOfferResult: ( Omit<Offer, 'offering'> & { offering: ResolversTypes['Offering'] } );
  CreateOutsideContributionCheckoutCartResult: ( ContributionAmountAboveThresholdError ) | ( ContributionAmountBelowThresholdError ) | ( OutsideContributionCheckoutCart );
  CreateOutsideContributionResult: ( ContributionActionRequiredError ) | ( ContributionCardDeclinedError ) | ( ContributionInvalidOwnerEmailError ) | ( OutsideContribution );
  CreatePromoCodeResult: ( DuplicatePromoCodeError ) | ( PromoCode ) | ( PromoCodeFieldLengthError );
  CreatePromoCodeRewardResult: ( DuplicatePromoCodeRewardError ) | ( PromoCodeReward );
  CreateProspectUserResult: ( GrowProspect ) | ( InternalErrorException ) | ( LaterWaitlistProspect ) | ( OutsideContributionProspect ) | ( User_V2 );
  CreateReferralCampaignResult: ( ReferralCampaignV2 );
  CreateReferralCampaignRewardResult: ( ReferralCampaignReward );
  CreateReferralPayoutResult: ( ReferralPayout ) | ( ReferralPayoutExistsError );
  CreateReferralRelationshipResult: ( InvalidReferralRelationship ) | ( ReferralRelationship );
  CreateRefundResult: ( BillingInvoice ) | ( CreateRefundError ) | ( VendorIntegrationError ) | ( VendorRefundInvoiceError );
  CreateSavingsAccountResult: ( CreateSavingsAccountPayload ) | ( CreateSavingsAccountVerificationError );
  CreateScopeResult: ( CreateScopeException ) | ( Scope );
  CreateSubscriptionMigrationResult: ( SubscriptionMigration );
  CreateUploadUrlResult: ( UploadUrl );
  CreateUserProfileResult: ( MissingAgreementsException ) | ( User ) | ( UserExistsException ) | ( UserNotUsResidentException );
  CreateVendorInvoiceResult: ( BillingVendorError ) | ( InvoiceCollection );
  CreateVendorLineItemResult: ( BillingVendorError ) | ( InvoiceLineItem );
  CustomerEarnOnboardingProgram: ( CustomerEarnOnboardingProgramControl ) | ( CustomerEarnOnboardingProgramFeature );
  CustomerMoneyRulesResult: ( CustomerMoneyRulesResultSuccess ) | ( MoneyRulesRulesetNotFoundException );
  DeactivateBeneficiaryResult: ( Beneficiary ) | ( BeneficiaryNotFoundException ) | ( InternalErrorException );
  DeactivateOauthAppClientResult: ( OauthAppClient ) | ( OauthAppClientNotFoundException );
  DeactivateOauthAppResult: ( OauthApp ) | ( OauthAppNotFoundException );
  DeactivateTierSubscriptionResult: ( TierSubscription ) | ( TierSubscriptionAlreadyDeactivated );
  DeleteDelegateResult: ( DeleteDelegateResultTemporaryImpl );
  DeleteExpiredBankCardOrderResult: ( BankCardOrder ) | ( DeleteExpiredBankCardOrderCardTierNotFoundError ) | ( DeleteExpiredBankCardOrderNotExpiredError ) | ( DeleteExpiredBankCardOrderNotFoundError );
  DeleteOauthAppResult: ( DeleteOauthAppSuccess ) | ( OauthAppNotFoundException );
  DeleteTrustedContactResult: ( InternalErrorException ) | ( TrustedContact ) | ( TrustedContactNotFoundException );
  DeregisterAuthenticatorResult: ( AuthenticatorNotFoundException ) | ( EmailAuthenticator ) | ( PhoneAuthenticator );
  DismissMessagesResult: ( DismissMessagesSuccess ) | ( UpdateMessagesFailure );
  EarlyAccountStateRegulationResult: ( EarlyAccountStateRegulation ) | ( InternalErrorException ) | ( InvalidStateException ) | ( UserNotFoundException );
  EnableQuarterlyRecapsResult: ( InvalidSubscriptionTierException ) | ( InvestmentAccount ) | ( InvestmentAccountNotFoundException ) | ( InvestmentAccountNotSupportedException );
  ExchangeAcornsEarlyTokenResult: ( AcornsEarlyUserDetails ) | ( InvalidAcornsEarlyTokenException );
  ExecuteMoneyInResult: ( ExecuteMoneyInError ) | ( ExecuteMoneyInSuccess );
  ExecuteMoneyManagerRebalancesResult: ( ExecuteMoneyManagerRebalancesSuccess ) | ( RebalanceAlreadyExecutedError ) | ( RebalanceSourceInsufficientBalanceError );
  ExpirePromotionalWaiverResult: ( InvalidUserIdException ) | ( PromotionalWaiver_V2 ) | ( WaiverDeletionException );
  FailVendorInvoiceResult: ( BillingVendorError ) | ( Invoice );
  FeaturedLearnContentPreview: ( Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversTypes['LearnMediaTheme']>, duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } );
  FeaturedMilestonesV2: ( AccountSetupMilestones ) | ( FeaturedMilestones );
  FileOrException: ( File ) | ( FileSizeError ) | ( UploadFailedError );
  GenerateDocumentUploadSessionResult: ( DocumentUploadSession );
  GenerateLayerLinkSessionResult: ( PlaidLayerLinkSession ) | ( UnrecoverableError );
  GenerateReferralCodeResult: ( Invitation );
  InitiateChallengeResult: ( AuthenticatorNotFoundException ) | ( ChallengeRateExceededException ) | ( EmailAuthChallenge ) | ( InvalidMfaTokenException ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge );
  InitiateEmailChallengeResult: ( ChallengeRateExceededException ) | ( EmailAuthChallenge ) | ( ExistingEmailVerifiedException );
  InitiateMoneyAssignmentResult: ( InitiateMoneyAssignmentSuccess ) | ( MoneyAssignmentAlreadyTransferredError ) | ( MoneyAssignmentNotFoundError );
  InitiatePushChallengeResult: ( ChallengeRateExceededException ) | ( InitiatePushChallengeSuccess ) | ( NoRegisteredPushAuthenticatorsException );
  InitiateSMSChallengeResult: ( ChallengeRateExceededException ) | ( InvalidPhoneNumberException ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge );
  InitiateVerificationResult: ( VerificationProfile );
  LaterAccountInfoOrError: ( LaterAccountAlreadyVerified ) | ( LaterAccountIneligibleForVerification ) | ( LaterAccountInfo ) | ( LaterAccountNotFound );
  LaterContributionAbilityResult: ( ContributionAbilityByYear );
  LaterProgramAccountContributionResult: ( LaterContributionLimitMet ) | ( LaterFullContributionSuccess ) | ( LaterPartialContributionSuccess );
  LearnContentCategory: ( Omit<LearnTier, 'icon'> & { icon: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnTopic, 'icon'> & { icon: ResolversTypes['LearnVisualAsset'] } );
  LearnContentCommunityStats: ( LearnContentStats );
  LearnContentDuration: ( Milliseconds );
  LearnContentInteractionState: ( Omit<LearnInteractionState, 'elapsedTime'> & { elapsedTime: Maybe<ResolversTypes['LearnContentDuration']> } );
  LearnContentPreview: ( Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversTypes['CourseTheme'], duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<CoursePreviewLocked, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversTypes['CourseTheme'], duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversTypes['LearnMediaTheme']>, duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( LearnPollPreview ) | ( LearnPollPreviewLocked ) | ( Omit<LessonPreview, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LessonPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], quizTheme: ResolversTypes['QuizTheme'] } ) | ( Omit<QuizPreviewLocked, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], quizTheme: ResolversTypes['QuizTheme'] } );
  LearnCourse: ( Omit<Course, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], theme: ResolversTypes['CourseTheme'] } ) | ( Omit<CourseLocked, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], theme: ResolversTypes['CourseTheme'] } );
  LearnCoursePreview: ( Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversTypes['CourseTheme'], duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<CoursePreviewLocked, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversTypes['CourseTheme'], duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } );
  LearnMedia: ( Omit<LearnMediaArticle, 'audioTheme' | 'featuredImage'> & { audioTheme: Maybe<ResolversTypes['LearnMediaTheme']>, featuredImage: Maybe<ResolversTypes['LearnVisualAsset']> } );
  LearnMediaTheme: ( LearnThemeLiteral );
  LearnQuiz: ( Omit<Quiz, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: Maybe<ResolversTypes['LearnVisualAsset']>, theme: ResolversTypes['QuizTheme'] } ) | ( Omit<QuizLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: Maybe<ResolversTypes['LearnVisualAsset']> } );
  LearnQuizPreview: ( Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], quizTheme: ResolversTypes['QuizTheme'] } ) | ( Omit<QuizPreviewLocked, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], quizTheme: ResolversTypes['QuizTheme'] } );
  LearnVisualAsset: ( Image );
  LegacyUploadDocumentResult: ( FileDoesNotExistInS3 ) | ( FileTooLarge ) | ( InvalidFile ) | ( LegacyUploadDocument ) | ( UploadDoesNotExist );
  LinkManualFundingSourceResult: ( CurrentBankStatementNotProvided ) | ( FundingSourceAccount ) | ( FundingSourceAlreadyExists ) | ( FundingSourceCredentialsExceedLinkLimit ) | ( InvalidAccountNumber ) | ( InvalidManualLink ) | ( InvalidRoutingNumber ) | ( PreviousFundingSourcePending ) | ( RdvVerificationRequired );
  LinkOidcCredentialsResult: ( InvalidAppleAccountException ) | ( InvalidIdentityTokenException ) | ( LinkOidcCredentialsSuccess ) | ( OidcCredentialsAlreadyLinkedException ) | ( OidcCredentialsTakenException );
  LinkSessionResult: ( RawLinkSession ) | ( UnrecoverableLinkedAccountError ) | ( WebviewLinkSession );
  LinkedAccountAlertsResponse: ( LinkedAccountAlert ) | ( RelinkLinkedAccountAlert );
  LogoutDeviceResult: ( DeviceNotFoundException ) | ( LogoutDeviceSuccess ) | ( RefreshTokenNotFoundException );
  LogoutResult: ( AuthTokenNotFoundException ) | ( LogoutSuccess ) | ( RefreshTokenNotFoundException );
  MarkAllAsReadResult: ( MarkAllAsReadSuccess ) | ( UpdateMessageFailed );
  MarkLearnContentAsHelpfulResult: ( RecordDoesNotExistError ) | ( UpdateLearnContentHelpfulnessResult );
  MarkLearnContentAsViewedResult: ( RecordDoesNotExistError ) | ( ViewedLearnContentResult );
  MessageTextAsset: ( StringKeyAsset );
  MessageVisualAsset: ( DesignLibraryIcon ) | ( Image );
  MightyOakWaiverResult: ( BillingProfileNotFoundException ) | ( MightyOakCardWaiver ) | ( MightyOakCardWaiverExpiredException ) | ( MightyOakCardWaiverNotFoundException );
  MilestoneGroup: ( Omit<MilestoneRuleGroup, 'contents'> & { contents: Array<ResolversTypes['MilestoneRuleGroupContent']> } ) | ( Omit<MilestoneThemeGroup, 'contents'> & { contents: Array<ResolversTypes['MilestoneThemeGroupContent']> } );
  MilestoneProgress: ( CurrencyMilestoneProgress ) | ( DiscreteMilestoneProgress );
  MilestoneRuleGroupContent: ( Omit<Milestone, 'progress'> & { progress: ResolversTypes['MilestoneProgress'] } );
  MilestoneThemeGroupContent: ( Omit<Milestone, 'progress'> & { progress: ResolversTypes['MilestoneProgress'] } ) | ( Omit<MilestoneRuleGroup, 'contents'> & { contents: Array<ResolversTypes['MilestoneRuleGroupContent']> } );
  ModifyMoneyAssignmentResult: ( ModifyMoneyAssignmentSuccess ) | ( MoneyAssignmentAlreadyTransferredError ) | ( MoneyAssignmentNotFoundError );
  MoneyManagerCategoriesResult: ( MoneyManagerCategoriesSuccess );
  MoneyRulesArchetypesResult: ( MoneyRulesArchetypesSuccess );
  MoneyRulesSuggestionResult: ( MoneyRulesSuggestedSplits );
  MoneyRulesUpdateArchetypeResult: ( MoneyRulesUpdateRulesetSuccess );
  MoneyRulesUpdateCustomerMoneyRulesResult: ( MoneyRulesUpdateRulesetSuccess );
  NextTransferDateResult: ( MalformedRecurringTransferException ) | ( RecurringTransferDate );
  Offering: ( Product ) | ( Tier );
  OpenCoreInvestmentAccountResult: ( CoreAccountAlreadyExistsException ) | ( InvalidPortfolioIdException ) | ( InvestmentAccount ) | ( InvestmentAccountCreationException ) | ( UserClosedException ) | ( UserNotFoundException );
  OpenEarlyAccountResult: ( BeneficiaryAccountExistsException ) | ( CoreAccountClosedException ) | ( InternalErrorException ) | ( InvalidStateException ) | ( InvalidSubscriptionTierException ) | ( InvalidTerminationAgeException ) | ( InvestmentAccount ) | ( MaxAccountsCreatedException ) | ( MissingBeneficiarySsnException ) | ( NoBeneficiaryFoundException ) | ( UserClosedException ) | ( UserNotFoundException ) | ( UserNotVerifiedException );
  OrderBankCardResult: ( BankCardOrder );
  PartnerDataShareResponse: ( PartnerDataShare ) | ( ProductNotSupportedException );
  PartnerOfferGroupItem: ( EarnOffer ) | ( JobOffer ) | ( JobSearchOffer ) | ( PromoOffer );
  QuizTheme: ( LearnThemeLiteral );
  RecordInvestmentAccountRecapViewResult: ( InvestmentAccountRecap ) | ( InvestmentAccountRecapNotFoundException );
  RecordReferralEventResult: ( QualificationSubTypeMismatchError ) | ( ReferralEventV2 ) | ( ReferralRelationshipMissingError ) | ( RelationshipAlreadyQualifiedError );
  RecordVendorExternalTransactionResult: ( BillingVendorError ) | ( Transaction );
  RefreshAuthTokenResult: ( AuthSession ) | ( InvalidPinException ) | ( RefreshAuthTokenRateLimitedException ) | ( TokenExpiredException ) | ( UserSuspendedException );
  RegenerateInvestmentAccountRecapPublicTokenResult: ( InvestmentAccountRecap ) | ( InvestmentAccountRecapNotFoundException );
  RegisterAccountTypeResult: ( RegisterAccountTypeResultTemporaryImpl );
  RegisterCredentialsResult: ( AuthSession ) | ( EmailTakenException ) | ( InvalidPasswordException ) | ( MissingRequiredAgreementsException );
  RegisterDeviceTokenAndPushAuthenticatorResult: ( InvalidDeviceParametersException ) | ( PushAuthenticator ) | ( PushAuthenticatorAlreadyExistsException );
  RegisterEmailAuthenticatorResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthenticatorTypeAlreadyRegisteredException ) | ( EmailAuthenticator ) | ( ExistingEmailVerifiedException );
  RegisterLayerLinkSessionResult: ( LayerLinkSession ) | ( UnrecoverableError );
  RegisterLinkSessionResult: ( AsyncLinkSessionResult ) | ( LinkedAccount );
  RegisterOidcCredentialsResult: ( AuthSession ) | ( EmailTakenException ) | ( InvalidAppleAccountException ) | ( InvalidCredentialsException ) | ( InvalidGoogleAccountException ) | ( UserSuspendedException ) | ( ValidateCredentialsSuccess );
  RegisterPhoneAuthenticatorResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthenticatorTypeAlreadyRegisteredException ) | ( InvalidPhoneNumberException ) | ( PhoneAuthenticator );
  RegisterPhoneAuthenticatorWithoutChallengeResult: ( InvalidPhoneNumberException ) | ( PhoneAuthenticator );
  RegisterProspectResult: ( InvalidConversionIdentifierException ) | ( InvalidSourceAttributesException ) | ( RegistrationFunnel );
  ReinitiateSMSChallengeResult: ( AuthChallengeExpiredException ) | ( ChallengeRateExceededException ) | ( EmailAuthChallenge ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge );
  ReissueBankCardEligibility: ( ReissueBankCardEligible ) | ( ReissueBankCardIneligible );
  ReissueBankCardResult: ( BankCardRequest ) | ( ReissueBankCardExistsError );
  RemoveAccountTypeResult: ( RemoveAccountTypeResultTemporaryImpl );
  RemoveCohortEligibilityResult: ( UserCohorts );
  RemoveJobAlertResult: ( RemovedJobAlert );
  RemovePolicyResult: ( PoliciesRecordDoesNotExistException ) | ( ValidPolicies );
  RemoveSecurityFromPortfolioResult: ( InvestmentAccountNotFoundException ) | ( InvestmentAccountNotSupportedException ) | ( Portfolio ) | ( PortfolioNotFoundException ) | ( PortfolioNotSupportedException ) | ( SecurityNotSupportedException );
  RemoveSelfDirectedPortfolioResult: ( AccountNotFoundException ) | ( InvestmentAccount ) | ( InvestmentAccountAlreadyClosed ) | ( InvestmentAccountClosureInProgress ) | ( PortfolioAlreadyRemovedError ) | ( PortfolioNotFoundException ) | ( PortfolioRemovalInProgressError );
  ReopenUserAccountResult: ( UserNotFoundException ) | ( UserReopenLockedException ) | ( UserReopenSuspendedException ) | ( User_V2 );
  ReplayMoneyManagerMoneyAssignmentResult: ( ReplayMoneyAssignmentError ) | ( ReplayMoneyAssignmentSuccess );
  RequestEarlyAccountClosureResult: ( AccountAlreadyClosedException ) | ( ClosureRequestExistsException ) | ( FundingSourceRequiresRdvException ) | ( InternalErrorException ) | ( InvalidAccountTypeException ) | ( InvestmentAccount ) | ( InvestmentAccountNeedsTransferException ) | ( MissingFundingSourceException );
  RequestInvestmentAccountReopenResult: ( ExistingRequestPendingReview ) | ( ExistingRequestPendingUserAction ) | ( InvalidSubscriptionTierException ) | ( InvestmentAccountNotClosedException ) | ( InvestmentAccountNotFoundException ) | ( InvestmentAccountReopenRequest );
  RequestLayerSessionResult: ( RequestedLayerLinkSession ) | ( UnrecoverableError );
  RequestSubscriptionMigrationWaiverResult: ( InvalidTierForMigrationError ) | ( SubscriptionMigrationInvalidError ) | ( SubscriptionMigrationWaiver );
  ResendChatMessageResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversTypes['ChatWidget']> } ) | ( ChatHistoryMessageNotFound );
  ResetPasswordByTokenResult: ( IncorrectSecurityAnswerException ) | ( IncorrectSsnException ) | ( InvalidPasswordException ) | ( ResetPasswordByTokenException ) | ( ResetPasswordByTokenSuccess ) | ( UserCredentialsNotFoundException );
  ResetPasswordWithTokenResult: ( InvalidPasswordResetException ) | ( InvalidPasswordResetTokenException ) | ( ResetPasswordWithTokenSuccess ) | ( UserCredentialsNotFoundException );
  ResetRateLimitResult: ( RateLimitDoesNotExistException ) | ( ResetRateLimitSuccess );
  RespondToLearnPollResult: ( InvalidOptionException ) | ( LearnPollResponse ) | ( RecordDoesNotExistError );
  RestoreLoginAccessResult: ( AuthProfile ) | ( AuthProfileNotFoundException );
  RetriggerRdvsResult: ( FundingSourceAccount ) | ( RdvsNotTriggered );
  RevokeLoginAccessResult: ( AuthProfile ) | ( UserCredentialsNotFoundException );
  RevokePasswordResetTokenResult: ( InvalidPasswordResetTokenException ) | ( RevokePasswordResetTokenSuccess );
  SaveUploadUrlsResult: ( DocumentUploads ) | ( Omit<UploadSaveError, 'uploadExceptions'> & { uploadExceptions: Array<ResolversTypes['UploadSaveExceptions']> } );
  ScheduleRecurringTransferResult: ( MalformedRecurringTransferException ) | ( RecurringTransfer );
  SendChatMessageResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversTypes['ChatWidget']> } ) | ( ChatMessageSizeOutOfBounds ) | ( ChatSessionNotFound ) | ( ChatUnavailableError );
  SendCheckPaymentResult: ( AuthorizationError ) | ( CheckPayment ) | ( DuplicateActionError ) | ( InvalidAddressError );
  SetAuthenticationPINResult: ( InvalidPinException ) | ( SetAuthenticationPinSuccess ) | ( UserCredentialsNotFoundException );
  SetBeneficiarySsnResult: ( Beneficiary ) | ( BeneficiaryNotFoundException ) | ( InternalErrorException ) | ( InvalidSsnException ) | ( SecretSquirrelException ) | ( SsnAlreadyInUseException ) | ( SsnMatchesCustodianException ) | ( SsnUpdateForbiddenException );
  SetDefaultAuthenticatorResult: ( AuthenticatorAlreadyDefaultException ) | ( AuthenticatorNotFoundException ) | ( EmailAuthenticator ) | ( PhoneAuthenticator );
  SetInvestmentAccountRecapPublicAccessResult: ( InvestmentAccountRecap ) | ( InvestmentAccountRecapNotFoundException );
  SetPreferredWithdrawalAccountResult: ( FundingSourceAccount ) | ( PreferredAccountNotEligibleError ) | ( PreferredAccountNotSupportedError );
  SpendAtmsResult: ( SpendAtmVendorUnavailableError ) | ( SpendAtmsPayload );
  SpendTransactionsDisputeResult: ( SpendTransactionsDisputeResponse );
  SubmitBankFeeNegotiationResult: ( LinkedAccountNotFound ) | ( SubmitBankFeeNegotiationResponse );
  SubmitEarnMissingCreditRequestResult: ( EarnMissingCreditRequest ) | ( EarnMissingCreditRequestPurchaseDateError );
  SubscribeToTierResult: ( InvalidTier ) | ( InvalidTierPrice ) | ( TierSubscription );
  SubscribeUserToTierResult: ( InvalidTierPriceId ) | ( TierDowngradeActionRequired ) | ( TierSubscription );
  SucceedVendorInvoiceResult: ( BillingVendorError ) | ( Invoice );
  SuggestedMoneyRulesResult: ( SuggestedMoneyRulesSuccess );
  SupportTicketResponse: ( RecaptchaException ) | ( SupportTicket );
  SupportTicketWithCustomFieldsResponse: ( SubmissionError ) | ( SupportTicket );
  SuppressMoneyManagerRebalancesResult: ( SuppressMoneyManagerRebalancesError ) | ( SuppressMoneyManagerRebalancesSuccess );
  SyncFundingSourceToVendorResult: ( BillingVendorError ) | ( DuplicateBillingInfoError ) | ( VendorBillingInfo );
  TierOptionByTierPriceIdResult: ( InvalidTierPriceId ) | ( TierOption );
  TierSubscriptionForUser: ( TierSubscription ) | ( TierSubscriptionNotFound ) | ( TierSubscriptionUnsubscribed );
  TrendingLearnContentPreview: ( Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversTypes['LearnMediaTheme']>, duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] } );
  UnauthenticatedSaveUploadUrlResult: ( DocumentUploads ) | ( Omit<UploadSaveError, 'uploadExceptions'> & { uploadExceptions: Array<ResolversTypes['UploadSaveExceptions']> } );
  UnblockDeviceResult: ( Device ) | ( DeviceNotFoundException );
  UnlinkOidcCredentialsResult: ( OidcCredentialsNotFoundException ) | ( UnlinkOidcCredentialsSuccess );
  UnmarkLearnContentAsHelpfulResult: ( RecordDoesNotExistError ) | ( UpdateLearnContentHelpfulnessResult );
  UnsubscribeUserFromTierResult: ( TierDowngradeActionRequired ) | ( TierSubscriptionUnsubscribed );
  UpdateAccountPortfolioResponse: ( InvalidActionOnAccount ) | ( InvestmentAccount ) | ( InvestmentAccountNotFoundException ) | ( PortfolioNotFoundException ) | ( PortfolioUpdateFailedException );
  UpdateAttributionResult: ( InvalidConversionIdentifierException ) | ( InvalidSourceAttributesException ) | ( NoProspectRecord ) | ( RegistrationFunnel );
  UpdateAuthEmailResult: ( AuthProfile ) | ( ExistingEmailVerifiedException );
  UpdateAuthPhoneNumberResult: ( AuthProfile ) | ( InvalidPhoneNumberException );
  UpdateBankAccountGoalResult: ( UpdateBankAccountGoalPayload );
  UpdateBeneficiaryInfoResult: ( Beneficiary ) | ( BeneficiaryNotFoundException ) | ( InternalErrorException ) | ( InvalidAddressException ) | ( InvalidEmailException ) | ( InvalidPhoneException );
  UpdateCredentialsResult: ( BlockedEmailDomainException ) | ( Credentials ) | ( EmailTakenException ) | ( UserCredentialsNotFoundException );
  UpdateDelegateResult: ( DelegateDefinition );
  UpdateElapsedTimeForLearnQuizResult: ( LearnContentElapsedMillisecondsUpdatedResult ) | ( RecordDoesNotExistError );
  UpdateLearnProgressResult: ( LearnProgressUpdatedResult ) | ( RecordDoesNotExistError );
  UpdateMessageResult: ( Omit<AlertMessage, 'body' | 'icon' | 'title'> & { body: ResolversTypes['MessageTextAsset'], icon: Maybe<ResolversTypes['MessageVisualAsset']>, title: ResolversTypes['MessageTextAsset'] } ) | ( LegacyAlertDismissalSuccess ) | ( Omit<NotificationMessage, 'body' | 'icon' | 'title'> & { body: ResolversTypes['MessageTextAsset'], icon: Maybe<ResolversTypes['MessageVisualAsset']>, title: ResolversTypes['MessageTextAsset'] } ) | ( UpdateMessageIgnored );
  UpdateMoneyManagerAllocationsResult: ( AcornsValidationError ) | ( AllocationAmountsSumExceedingMaxError ) | ( InvalidSingleRuleIdError ) | ( MismatchedDistributionUnitsError ) | ( MissingValidRulesetError ) | ( NonUniqueSingleRuleIdsError ) | ( UpdateMoneyManagerAllocationsSuccess );
  UpdateMoneyManagerAutomationTargetResult: ( MoneyManagerInputError ) | ( UpdateMoneyManagerAutomationTargetSuccess );
  UpdateMoneyManagerSettingsResult: ( UpdateMoneyManagerSettingsFailure ) | ( UpdateMoneyManagerSettingsSuccess );
  UpdateMoneyRulesSourceSettingsResult: ( UpdateMoneyRulesSourceSettingsFailure ) | ( UpdateMoneyRulesSourceSettingsSuccess );
  UpdateOauthAppResult: ( OauthApp ) | ( OauthAppNotFoundException );
  UpdatePortfolioSecuritiesResult: ( CustomerAgreementRequiredException ) | ( InvalidAllocationPercentError ) | ( InvalidSecurityError ) | ( InvalidSecurityForAllocationError ) | ( InvestmentAccount ) | ( LiquidationUnavailableError ) | ( NegativeSecurityPercentError ) | ( PortfolioSecurityLimitReached );
  UpdatePromoCodeResult: ( DuplicatePromoCodeError ) | ( PromoCode ) | ( PromoCodeFieldLengthError );
  UpdatePromotedCampaignsResult: ( PromotedCampaigns );
  UpdateReferralCampaignResult: ( ReferralCampaignV2 );
  UpdateReferralPayoutResult: ( ReferralPayout );
  UpdateReferralRelationshipResult: ( ReferralRelationship );
  UpdateReferralRewardResponse: ( ReferralRewardSummary ) | ( UpdateReferralRewardError );
  UpdateScopeResult: ( Scope ) | ( UpdateScopeException );
  UpdateTrustedContactResult: ( InternalErrorException ) | ( TrustedContact ) | ( TrustedContactAlreadyExistsException ) | ( TrustedContactInvalidEmail ) | ( TrustedContactInvalidPhoneNumber ) | ( TrustedContactNotFoundException );
  UpdateUserProfileAndAutomationTargetResult: ( UpdateUserProfileAndAutomationTargetSuccess );
  UpdateUserSwitchState: ( UpdateUserSwitchStateFailure ) | ( UpdateUserSwitchStatePayload );
  UpdateVerificationProfileResult: ( VerificationProfile );
  UpgradeAuthenticationResult: ( AuthSession ) | ( AuthenticationAlreadyUpgradedException ) | ( UserCredentialsNotFoundException );
  UploadOauthAppImageResult: ( InvalidContentTypeException ) | ( OauthAppImageUpload );
  UploadSaveExceptions: ( FileDoesNotExistError ) | ( UploadDoesNotExistError );
  UpsertUserMatchResult: ( InternalErrorException ) | ( UserMatch );
  UserAlertsResponse: ( AddressDocumentRequestedUserAlert ) | ( BankDocumentRequestedUserAlert ) | ( IdentityDocumentRequestedUserAlert ) | ( InsufficientFundsUserAlert ) | ( InvestmentsPausedUserAlert ) | ( MiscDocumentRequestedUserAlert ) | ( NoFundingSourceUserAlert ) | ( RdvRequiredUserAlert ) | ( SsnDocumentRequestedUserAlert ) | ( UserAlert ) | ( W9DocumentRequestedUserAlert );
  ValidateCredentialsResult: ( AuthSession ) | ( DeviceBlockedException ) | ( InvalidCredentialsException ) | ( LoginRateLimitedException ) | ( OidcCredentialsNotFoundException ) | ( UserSuspendedException ) | ( ValidateCredentialsSuccess );
  ValidatePasswordResetTokenResult: ( InvalidPasswordResetTokenException ) | ( ValidatePasswordResetTokenSuccess );
  ValidateUserSuspendedUploadTokenResult: ( UserSuspendedUploadTokenLengthError ) | ( UserSuspendedUploadTokenValidation );
  VendAuthSessionResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthSession ) | ( ChallengeRateExceededException ) | ( DeviceBlockedException ) | ( UserSuspendedException );
  VerifyCheckPaymentRecipientAddressResult: ( AuthorizationError ) | ( CheckPaymentRecipientAddressType ) | ( InvalidAddressError );
  VerifyDeviceResult: ( DeviceNotFoundException ) | ( EmailAuthChallenge ) | ( SmsAuthChallenge );
  VerifyIdentityByDocumentsResult: ( DocumentVerification );
  VerifyPasswordsResult: ( IncorrectOldPasswordException ) | ( InvalidPasswordException ) | ( SamePasswordsException ) | ( UnauthorizedException ) | ( VerifyPasswordsSuccess );
  VerifyPromoCodeResponse: ( InvalidPromoCodeError ) | ( PromoCode );
  VerifyRdvsResult: ( AccountFrozen ) | ( FundingSourceAccount ) | ( IncorrectRdvAmounts ) | ( StoredRdvDepositsInvalid ) | ( StoredRdvDepositsMissing );
  Waiver: ( MightyOakCardWaiver ) | ( PromotionalWaiver ) | ( ProvisionalWaiver );
  endChatSessionResponse: ( ChatSession ) | ( ChatSessionNotFound );
  helpcenterBannerResponse: ( HelpcenterBannerContent ) | ( HelpcenterBannerErrors );
  rateChatMessageResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversTypes['ChatWidget']> } ) | ( ChatHistoryMessageCustomFeedbackOutOfBounds ) | ( ChatHistoryMessageNotFound ) | ( ChatHistoryMessageNotRatable ) | ( ChatHistoryMessageRatingFailed ) | ( ChatHistoryMessageRatingOutOfBounds );
  startChatSessionResponse: ( ChatSession ) | ( ChatUnavailableError );
  userWinbackScoreRes: ( UserWinbackErrors ) | ( UserWinbackScore );
};

/** Mapping of union parent types */
export type ResolversUnionParentTypes = {
  AbstractSwitch: ( AcornsPdfSwitch ) | ( OnlineSwitch ) | ( SubmittableSwitch );
  AcceptDocumentResponse: ( AcceptedDocument ) | ( DocumentNotFound ) | ( UserNotFound );
  ActionScreenComponent: ( ActionWidget );
  ActivateOauthAppClientResult: ( OauthAppClient ) | ( OauthAppClientNotFoundException );
  ActivateOauthAppResult: ( OauthApp ) | ( OauthAppNotFoundException );
  AddCohortEligibilityResult: ( UserCohorts );
  AddPolicyResult: ( AddPolicySuccess ) | ( PoliciesRecordDoesNotExistException ) | ( PolicyNotAddedException );
  AddSearchTermToLearnSearchHistoryResult: ( LearnSearchTermSavedResult );
  AddSecurityToPortfolioResult: ( InvestmentAccountNotFoundException ) | ( InvestmentAccountNotSupportedException ) | ( Portfolio ) | ( PortfolioNotFoundException ) | ( PortfolioNotSupportedException ) | ( SecurityNotSupportedException );
  AddSelfDirectedPortfolioResult: ( CustomerAgreementRequiredException ) | ( InvalidInvestmentAccountException ) | ( InvalidSubscriptionTierException ) | ( InvestmentAccount ) | ( PortfolioNotFoundException );
  AddressDeliverabilityResult: ( AddressDeliverabilityCorrectedAddress ) | ( AddressDeliverabilityUnavailableError ) | ( AddressDeliverabilityVerificationError ) | ( AddressDeliverabilityVerified );
  AlertHubBeneficiaryAlert: ( MissingSsnBeneficiaryAlertItem ) | ( UnverifiedBeneficiarySsnAlertItem );
  AllCheckPaymentsResult: ( AuthorizationError ) | ( CheckPaymentConnection );
  AnswerChallengeResult: ( AnswerChallengeSuccess ) | ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException );
  AnswerLearnQuizQuestionResult: ( LearnQuizAnswerResult ) | ( RecordDoesNotExistError ) | ( UnauthorizedModifyLockedContentError );
  ApplyPromoCodeResult: ( InvalidPromoCodeError ) | ( PromoCodeCustomer );
  ApplyPromotionResult: ( PromotionConsumedError ) | ( PromotionExpiredError ) | ( PromotionNotFoundError ) | ( SubscriberIneligibleError ) | ( TierSubscription );
  ApplyPromotionalWaiverResult: ( InvalidDateException ) | ( InvalidUserIdException ) | ( PromotionalWaiver_V2 ) | ( WaiverCreationException );
  ApplyProvisionalWaiverResult: ( InvalidDateException ) | ( InvalidUserIdException ) | ( ProvisionalWaiver_V2 ) | ( WaiverCreationException );
  AuthenticateForFeeNegotiationResult: ( AuthenticateForFeeNegotiationStatus ) | ( LinkedAccountNotFound ) | ( NegotiationServiceConnectionFailure );
  AuthenticateNegotiationStatusResult: ( AuthenticateForFeeNegotiationStatus ) | ( LinkedAccountNotFound );
  AuthenticateResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthSession ) | ( AuthenticatorTypeAlreadyRegisteredException ) | ( AuthenticatorUnavailableException ) | ( ChallengeRateExceededException ) | ( DeviceBlockedException ) | ( EmailAuthChallenge ) | ( InvalidCredentialsException ) | ( LoginRateLimitedException ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge ) | ( UserLockedException ) | ( UserSuspendedException );
  BankCardPanDisplayResult: ( BankCardPanDisplayPayload );
  BankCardProvisioningDetailsResult: ( BankCardProvisioningDetailsPayload );
  BankInterestRatesResult: ( BankInterestRates ) | ( BankServiceFailure );
  BannersResponse: ( BannersErrors ) | ( HelpcenterBannerContent ) | ( SiteWideBannerContent );
  BatchAddTierSubscriptionsResult: ( BatchAddTierSubscriptions ) | ( InvalidTier ) | ( InvalidTierPrice );
  BenefitPartnerResponse: ( ProductNotSupportedException ) | ( TaxFilingPartner );
  BlockDeviceResult: ( Device ) | ( DeviceNotFoundException );
  CancelCheckPaymentResult: ( AuthorizationError ) | ( CheckPayment ) | ( ResourceNotFoundError ) | ( UnableToCancelCheckError );
  CancelIntentResult: ( Intent ) | ( ValidationError );
  CancelInvestmentAccountClosureRequestResult: ( AccountClosedException ) | ( AccountNotFoundException ) | ( ClosureRequestDoesNotExistException ) | ( InvestmentAccount );
  CancelInvestmentResult: ( CancelInvestmentPayload ) | ( InvestmentNotFoundException ) | ( InvestmentUncancellableException );
  CancelMoneyAssignmentResult: ( MoneyAssignmentAlreadyTransferredError ) | ( MoneyAssignmentNotFoundError ) | ( MoneyRulesCancelMoneyAssignmentSuccess );
  CancelRecurringTransferResult: ( RecurringTransfer ) | ( VersionMismatchException );
  ChangeOutsideContributionAmountResult: ( ContributionAmountAboveThresholdError ) | ( ContributionAmountBelowThresholdError ) | ( OutsideContributionCheckoutCart );
  ChangePasswordResult: ( ChangePasswordSuccess ) | ( IncorrectOldPasswordException ) | ( IncorrectSecurityAnswerException ) | ( InvalidPasswordException );
  ChatHistoryCitationV2: ( LearnHubCitation ) | ( SupportCitation );
  ChatMessageStreamResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversParentTypes['ChatWidget']> } ) | ( ChatHistoryMessageBody ) | ( Omit<ChatHistoryMessageFooter, 'chatWidgets'> & { chatWidgets: Array<ResolversParentTypes['ChatWidget']> } ) | ( ChatHistoryMessageHeader );
  ChatWidget: ( ChatChoiceWidget ) | ( Omit<CitationWidget, 'citations'> & { citations: Array<ResolversParentTypes['ChatHistoryCitationV2']> } ) | ( CustomerSupportChatWidget ) | ( DeeplinkWidget );
  CloseBankAccountResult: ( BankAccount ) | ( BankAccountNotFoundError );
  CloseInvestmentAccountResult: ( AccountNotFoundException ) | ( InvestmentAccount ) | ( InvestmentAccountAlreadyClosed ) | ( InvestmentAccountClosureInProgress ) | ( LaterAccountRequiresTaxWithholdings ) | ( LaterAccountRequiresWithdrawalReason ) | ( LaterAccountTaxWithholdingsPercentageExceeded ) | ( NonBasicAccountOpenException );
  CloseUserAccountResult: ( OpenAccountsException ) | ( UserNotFoundException ) | ( User_V2 );
  CompleteFunnelOnboardingResult: ( RegistrationFunnel ) | ( UnmetRequirementsException );
  ConnectACHAccountResult: ( ConnectAchAccountSucceeded ) | ( InstitutionNotSupportedError );
  ConsumeUserTokenResult: ( InvalidUserTokenException ) | ( UserToken );
  CourseTheme: ( LearnThemeLiteral );
  CreateAuthProfileResult: ( AuthProfile ) | ( AuthProfileAlreadyExistsException );
  CreateBeneficiaryResult: ( Beneficiary ) | ( BeneficiaryExceedsAgeLimitException ) | ( InternalErrorException ) | ( InvalidDateOfBirthException ) | ( InvalidFirstNameException ) | ( InvalidLastNameException );
  CreateDelegateResult: ( DelegateDefinition );
  CreateDirectDepositLinkInfoSwitch: ( CreateDirectDepositLinkInfoFailure ) | ( CreateDirectDepositLinkInfoPayload );
  CreateImplicitTokenForUserResult: ( ImplicitToken ) | ( InvalidOauthAppClientIdException ) | ( OauthAppNotFoundException );
  CreateIntentResult: ( Intent ) | ( ValidationError );
  CreateInvestingStrategyRecommendationResult: ( BadRequestError ) | ( RecommendedInvestingStrategy );
  CreateJobAlertResult: ( JobAlert );
  CreateOauthAppResult: ( OauthApp );
  CreateOfferResult: ( Omit<Offer, 'offering'> & { offering: ResolversParentTypes['Offering'] } );
  CreateOutsideContributionCheckoutCartResult: ( ContributionAmountAboveThresholdError ) | ( ContributionAmountBelowThresholdError ) | ( OutsideContributionCheckoutCart );
  CreateOutsideContributionResult: ( ContributionActionRequiredError ) | ( ContributionCardDeclinedError ) | ( ContributionInvalidOwnerEmailError ) | ( OutsideContribution );
  CreatePromoCodeResult: ( DuplicatePromoCodeError ) | ( PromoCode ) | ( PromoCodeFieldLengthError );
  CreatePromoCodeRewardResult: ( DuplicatePromoCodeRewardError ) | ( PromoCodeReward );
  CreateProspectUserResult: ( GrowProspect ) | ( InternalErrorException ) | ( LaterWaitlistProspect ) | ( OutsideContributionProspect ) | ( User_V2 );
  CreateReferralCampaignResult: ( ReferralCampaignV2 );
  CreateReferralCampaignRewardResult: ( ReferralCampaignReward );
  CreateReferralPayoutResult: ( ReferralPayout ) | ( ReferralPayoutExistsError );
  CreateReferralRelationshipResult: ( InvalidReferralRelationship ) | ( ReferralRelationship );
  CreateRefundResult: ( BillingInvoice ) | ( CreateRefundError ) | ( VendorIntegrationError ) | ( VendorRefundInvoiceError );
  CreateSavingsAccountResult: ( CreateSavingsAccountPayload ) | ( CreateSavingsAccountVerificationError );
  CreateScopeResult: ( CreateScopeException ) | ( Scope );
  CreateSubscriptionMigrationResult: ( SubscriptionMigration );
  CreateUploadUrlResult: ( UploadUrl );
  CreateUserProfileResult: ( MissingAgreementsException ) | ( User ) | ( UserExistsException ) | ( UserNotUsResidentException );
  CreateVendorInvoiceResult: ( BillingVendorError ) | ( InvoiceCollection );
  CreateVendorLineItemResult: ( BillingVendorError ) | ( InvoiceLineItem );
  CustomerEarnOnboardingProgram: ( CustomerEarnOnboardingProgramControl ) | ( CustomerEarnOnboardingProgramFeature );
  CustomerMoneyRulesResult: ( CustomerMoneyRulesResultSuccess ) | ( MoneyRulesRulesetNotFoundException );
  DeactivateBeneficiaryResult: ( Beneficiary ) | ( BeneficiaryNotFoundException ) | ( InternalErrorException );
  DeactivateOauthAppClientResult: ( OauthAppClient ) | ( OauthAppClientNotFoundException );
  DeactivateOauthAppResult: ( OauthApp ) | ( OauthAppNotFoundException );
  DeactivateTierSubscriptionResult: ( TierSubscription ) | ( TierSubscriptionAlreadyDeactivated );
  DeleteDelegateResult: ( DeleteDelegateResultTemporaryImpl );
  DeleteExpiredBankCardOrderResult: ( BankCardOrder ) | ( DeleteExpiredBankCardOrderCardTierNotFoundError ) | ( DeleteExpiredBankCardOrderNotExpiredError ) | ( DeleteExpiredBankCardOrderNotFoundError );
  DeleteOauthAppResult: ( DeleteOauthAppSuccess ) | ( OauthAppNotFoundException );
  DeleteTrustedContactResult: ( InternalErrorException ) | ( TrustedContact ) | ( TrustedContactNotFoundException );
  DeregisterAuthenticatorResult: ( AuthenticatorNotFoundException ) | ( EmailAuthenticator ) | ( PhoneAuthenticator );
  DismissMessagesResult: ( DismissMessagesSuccess ) | ( UpdateMessagesFailure );
  EarlyAccountStateRegulationResult: ( EarlyAccountStateRegulation ) | ( InternalErrorException ) | ( InvalidStateException ) | ( UserNotFoundException );
  EnableQuarterlyRecapsResult: ( InvalidSubscriptionTierException ) | ( InvestmentAccount ) | ( InvestmentAccountNotFoundException ) | ( InvestmentAccountNotSupportedException );
  ExchangeAcornsEarlyTokenResult: ( AcornsEarlyUserDetails ) | ( InvalidAcornsEarlyTokenException );
  ExecuteMoneyInResult: ( ExecuteMoneyInError ) | ( ExecuteMoneyInSuccess );
  ExecuteMoneyManagerRebalancesResult: ( ExecuteMoneyManagerRebalancesSuccess ) | ( RebalanceAlreadyExecutedError ) | ( RebalanceSourceInsufficientBalanceError );
  ExpirePromotionalWaiverResult: ( InvalidUserIdException ) | ( PromotionalWaiver_V2 ) | ( WaiverDeletionException );
  FailVendorInvoiceResult: ( BillingVendorError ) | ( Invoice );
  FeaturedLearnContentPreview: ( Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversParentTypes['LearnMediaTheme']>, duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } );
  FeaturedMilestonesV2: ( AccountSetupMilestones ) | ( FeaturedMilestones );
  FileOrException: ( File ) | ( FileSizeError ) | ( UploadFailedError );
  GenerateDocumentUploadSessionResult: ( DocumentUploadSession );
  GenerateLayerLinkSessionResult: ( PlaidLayerLinkSession ) | ( UnrecoverableError );
  GenerateReferralCodeResult: ( Invitation );
  InitiateChallengeResult: ( AuthenticatorNotFoundException ) | ( ChallengeRateExceededException ) | ( EmailAuthChallenge ) | ( InvalidMfaTokenException ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge );
  InitiateEmailChallengeResult: ( ChallengeRateExceededException ) | ( EmailAuthChallenge ) | ( ExistingEmailVerifiedException );
  InitiateMoneyAssignmentResult: ( InitiateMoneyAssignmentSuccess ) | ( MoneyAssignmentAlreadyTransferredError ) | ( MoneyAssignmentNotFoundError );
  InitiatePushChallengeResult: ( ChallengeRateExceededException ) | ( InitiatePushChallengeSuccess ) | ( NoRegisteredPushAuthenticatorsException );
  InitiateSMSChallengeResult: ( ChallengeRateExceededException ) | ( InvalidPhoneNumberException ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge );
  InitiateVerificationResult: ( VerificationProfile );
  LaterAccountInfoOrError: ( LaterAccountAlreadyVerified ) | ( LaterAccountIneligibleForVerification ) | ( LaterAccountInfo ) | ( LaterAccountNotFound );
  LaterContributionAbilityResult: ( ContributionAbilityByYear );
  LaterProgramAccountContributionResult: ( LaterContributionLimitMet ) | ( LaterFullContributionSuccess ) | ( LaterPartialContributionSuccess );
  LearnContentCategory: ( Omit<LearnTier, 'icon'> & { icon: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnTopic, 'icon'> & { icon: ResolversParentTypes['LearnVisualAsset'] } );
  LearnContentCommunityStats: ( LearnContentStats );
  LearnContentDuration: ( Milliseconds );
  LearnContentInteractionState: ( Omit<LearnInteractionState, 'elapsedTime'> & { elapsedTime: Maybe<ResolversParentTypes['LearnContentDuration']> } );
  LearnContentPreview: ( Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversParentTypes['CourseTheme'], duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<CoursePreviewLocked, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversParentTypes['CourseTheme'], duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversParentTypes['LearnMediaTheme']>, duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( LearnPollPreview ) | ( LearnPollPreviewLocked ) | ( Omit<LessonPreview, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LessonPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], quizTheme: ResolversParentTypes['QuizTheme'] } ) | ( Omit<QuizPreviewLocked, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], quizTheme: ResolversParentTypes['QuizTheme'] } );
  LearnCourse: ( Omit<Course, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], theme: ResolversParentTypes['CourseTheme'] } ) | ( Omit<CourseLocked, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], theme: ResolversParentTypes['CourseTheme'] } );
  LearnCoursePreview: ( Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversParentTypes['CourseTheme'], duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<CoursePreviewLocked, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversParentTypes['CourseTheme'], duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } );
  LearnMedia: ( Omit<LearnMediaArticle, 'audioTheme' | 'featuredImage'> & { audioTheme: Maybe<ResolversParentTypes['LearnMediaTheme']>, featuredImage: Maybe<ResolversParentTypes['LearnVisualAsset']> } );
  LearnMediaTheme: ( LearnThemeLiteral );
  LearnQuiz: ( Omit<Quiz, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: Maybe<ResolversParentTypes['LearnVisualAsset']>, theme: ResolversParentTypes['QuizTheme'] } ) | ( Omit<QuizLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: Maybe<ResolversParentTypes['LearnVisualAsset']> } );
  LearnQuizPreview: ( Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], quizTheme: ResolversParentTypes['QuizTheme'] } ) | ( Omit<QuizPreviewLocked, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], quizTheme: ResolversParentTypes['QuizTheme'] } );
  LearnVisualAsset: ( Image );
  LegacyUploadDocumentResult: ( FileDoesNotExistInS3 ) | ( FileTooLarge ) | ( InvalidFile ) | ( LegacyUploadDocument ) | ( UploadDoesNotExist );
  LinkManualFundingSourceResult: ( CurrentBankStatementNotProvided ) | ( FundingSourceAccount ) | ( FundingSourceAlreadyExists ) | ( FundingSourceCredentialsExceedLinkLimit ) | ( InvalidAccountNumber ) | ( InvalidManualLink ) | ( InvalidRoutingNumber ) | ( PreviousFundingSourcePending ) | ( RdvVerificationRequired );
  LinkOidcCredentialsResult: ( InvalidAppleAccountException ) | ( InvalidIdentityTokenException ) | ( LinkOidcCredentialsSuccess ) | ( OidcCredentialsAlreadyLinkedException ) | ( OidcCredentialsTakenException );
  LinkSessionResult: ( RawLinkSession ) | ( UnrecoverableLinkedAccountError ) | ( WebviewLinkSession );
  LinkedAccountAlertsResponse: ( LinkedAccountAlert ) | ( RelinkLinkedAccountAlert );
  LogoutDeviceResult: ( DeviceNotFoundException ) | ( LogoutDeviceSuccess ) | ( RefreshTokenNotFoundException );
  LogoutResult: ( AuthTokenNotFoundException ) | ( LogoutSuccess ) | ( RefreshTokenNotFoundException );
  MarkAllAsReadResult: ( MarkAllAsReadSuccess ) | ( UpdateMessageFailed );
  MarkLearnContentAsHelpfulResult: ( RecordDoesNotExistError ) | ( UpdateLearnContentHelpfulnessResult );
  MarkLearnContentAsViewedResult: ( RecordDoesNotExistError ) | ( ViewedLearnContentResult );
  MessageTextAsset: ( StringKeyAsset );
  MessageVisualAsset: ( DesignLibraryIcon ) | ( Image );
  MightyOakWaiverResult: ( BillingProfileNotFoundException ) | ( MightyOakCardWaiver ) | ( MightyOakCardWaiverExpiredException ) | ( MightyOakCardWaiverNotFoundException );
  MilestoneGroup: ( Omit<MilestoneRuleGroup, 'contents'> & { contents: Array<ResolversParentTypes['MilestoneRuleGroupContent']> } ) | ( Omit<MilestoneThemeGroup, 'contents'> & { contents: Array<ResolversParentTypes['MilestoneThemeGroupContent']> } );
  MilestoneProgress: ( CurrencyMilestoneProgress ) | ( DiscreteMilestoneProgress );
  MilestoneRuleGroupContent: ( Omit<Milestone, 'progress'> & { progress: ResolversParentTypes['MilestoneProgress'] } );
  MilestoneThemeGroupContent: ( Omit<Milestone, 'progress'> & { progress: ResolversParentTypes['MilestoneProgress'] } ) | ( Omit<MilestoneRuleGroup, 'contents'> & { contents: Array<ResolversParentTypes['MilestoneRuleGroupContent']> } );
  ModifyMoneyAssignmentResult: ( ModifyMoneyAssignmentSuccess ) | ( MoneyAssignmentAlreadyTransferredError ) | ( MoneyAssignmentNotFoundError );
  MoneyManagerCategoriesResult: ( MoneyManagerCategoriesSuccess );
  MoneyRulesArchetypesResult: ( MoneyRulesArchetypesSuccess );
  MoneyRulesSuggestionResult: ( MoneyRulesSuggestedSplits );
  MoneyRulesUpdateArchetypeResult: ( MoneyRulesUpdateRulesetSuccess );
  MoneyRulesUpdateCustomerMoneyRulesResult: ( MoneyRulesUpdateRulesetSuccess );
  NextTransferDateResult: ( MalformedRecurringTransferException ) | ( RecurringTransferDate );
  Offering: ( Product ) | ( Tier );
  OpenCoreInvestmentAccountResult: ( CoreAccountAlreadyExistsException ) | ( InvalidPortfolioIdException ) | ( InvestmentAccount ) | ( InvestmentAccountCreationException ) | ( UserClosedException ) | ( UserNotFoundException );
  OpenEarlyAccountResult: ( BeneficiaryAccountExistsException ) | ( CoreAccountClosedException ) | ( InternalErrorException ) | ( InvalidStateException ) | ( InvalidSubscriptionTierException ) | ( InvalidTerminationAgeException ) | ( InvestmentAccount ) | ( MaxAccountsCreatedException ) | ( MissingBeneficiarySsnException ) | ( NoBeneficiaryFoundException ) | ( UserClosedException ) | ( UserNotFoundException ) | ( UserNotVerifiedException );
  OrderBankCardResult: ( BankCardOrder );
  PartnerDataShareResponse: ( PartnerDataShare ) | ( ProductNotSupportedException );
  PartnerOfferGroupItem: ( EarnOffer ) | ( JobOffer ) | ( JobSearchOffer ) | ( PromoOffer );
  QuizTheme: ( LearnThemeLiteral );
  RecordInvestmentAccountRecapViewResult: ( InvestmentAccountRecap ) | ( InvestmentAccountRecapNotFoundException );
  RecordReferralEventResult: ( QualificationSubTypeMismatchError ) | ( ReferralEventV2 ) | ( ReferralRelationshipMissingError ) | ( RelationshipAlreadyQualifiedError );
  RecordVendorExternalTransactionResult: ( BillingVendorError ) | ( Transaction );
  RefreshAuthTokenResult: ( AuthSession ) | ( InvalidPinException ) | ( RefreshAuthTokenRateLimitedException ) | ( TokenExpiredException ) | ( UserSuspendedException );
  RegenerateInvestmentAccountRecapPublicTokenResult: ( InvestmentAccountRecap ) | ( InvestmentAccountRecapNotFoundException );
  RegisterAccountTypeResult: ( RegisterAccountTypeResultTemporaryImpl );
  RegisterCredentialsResult: ( AuthSession ) | ( EmailTakenException ) | ( InvalidPasswordException ) | ( MissingRequiredAgreementsException );
  RegisterDeviceTokenAndPushAuthenticatorResult: ( InvalidDeviceParametersException ) | ( PushAuthenticator ) | ( PushAuthenticatorAlreadyExistsException );
  RegisterEmailAuthenticatorResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthenticatorTypeAlreadyRegisteredException ) | ( EmailAuthenticator ) | ( ExistingEmailVerifiedException );
  RegisterLayerLinkSessionResult: ( LayerLinkSession ) | ( UnrecoverableError );
  RegisterLinkSessionResult: ( AsyncLinkSessionResult ) | ( LinkedAccount );
  RegisterOidcCredentialsResult: ( AuthSession ) | ( EmailTakenException ) | ( InvalidAppleAccountException ) | ( InvalidCredentialsException ) | ( InvalidGoogleAccountException ) | ( UserSuspendedException ) | ( ValidateCredentialsSuccess );
  RegisterPhoneAuthenticatorResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthenticatorTypeAlreadyRegisteredException ) | ( InvalidPhoneNumberException ) | ( PhoneAuthenticator );
  RegisterPhoneAuthenticatorWithoutChallengeResult: ( InvalidPhoneNumberException ) | ( PhoneAuthenticator );
  RegisterProspectResult: ( InvalidConversionIdentifierException ) | ( InvalidSourceAttributesException ) | ( RegistrationFunnel );
  ReinitiateSMSChallengeResult: ( AuthChallengeExpiredException ) | ( ChallengeRateExceededException ) | ( EmailAuthChallenge ) | ( PhoneNumberOptedOutException ) | ( SmsAuthChallenge );
  ReissueBankCardEligibility: ( ReissueBankCardEligible ) | ( ReissueBankCardIneligible );
  ReissueBankCardResult: ( BankCardRequest ) | ( ReissueBankCardExistsError );
  RemoveAccountTypeResult: ( RemoveAccountTypeResultTemporaryImpl );
  RemoveCohortEligibilityResult: ( UserCohorts );
  RemoveJobAlertResult: ( RemovedJobAlert );
  RemovePolicyResult: ( PoliciesRecordDoesNotExistException ) | ( ValidPolicies );
  RemoveSecurityFromPortfolioResult: ( InvestmentAccountNotFoundException ) | ( InvestmentAccountNotSupportedException ) | ( Portfolio ) | ( PortfolioNotFoundException ) | ( PortfolioNotSupportedException ) | ( SecurityNotSupportedException );
  RemoveSelfDirectedPortfolioResult: ( AccountNotFoundException ) | ( InvestmentAccount ) | ( InvestmentAccountAlreadyClosed ) | ( InvestmentAccountClosureInProgress ) | ( PortfolioAlreadyRemovedError ) | ( PortfolioNotFoundException ) | ( PortfolioRemovalInProgressError );
  ReopenUserAccountResult: ( UserNotFoundException ) | ( UserReopenLockedException ) | ( UserReopenSuspendedException ) | ( User_V2 );
  ReplayMoneyManagerMoneyAssignmentResult: ( ReplayMoneyAssignmentError ) | ( ReplayMoneyAssignmentSuccess );
  RequestEarlyAccountClosureResult: ( AccountAlreadyClosedException ) | ( ClosureRequestExistsException ) | ( FundingSourceRequiresRdvException ) | ( InternalErrorException ) | ( InvalidAccountTypeException ) | ( InvestmentAccount ) | ( InvestmentAccountNeedsTransferException ) | ( MissingFundingSourceException );
  RequestInvestmentAccountReopenResult: ( ExistingRequestPendingReview ) | ( ExistingRequestPendingUserAction ) | ( InvalidSubscriptionTierException ) | ( InvestmentAccountNotClosedException ) | ( InvestmentAccountNotFoundException ) | ( InvestmentAccountReopenRequest );
  RequestLayerSessionResult: ( RequestedLayerLinkSession ) | ( UnrecoverableError );
  RequestSubscriptionMigrationWaiverResult: ( InvalidTierForMigrationError ) | ( SubscriptionMigrationInvalidError ) | ( SubscriptionMigrationWaiver );
  ResendChatMessageResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversParentTypes['ChatWidget']> } ) | ( ChatHistoryMessageNotFound );
  ResetPasswordByTokenResult: ( IncorrectSecurityAnswerException ) | ( IncorrectSsnException ) | ( InvalidPasswordException ) | ( ResetPasswordByTokenException ) | ( ResetPasswordByTokenSuccess ) | ( UserCredentialsNotFoundException );
  ResetPasswordWithTokenResult: ( InvalidPasswordResetException ) | ( InvalidPasswordResetTokenException ) | ( ResetPasswordWithTokenSuccess ) | ( UserCredentialsNotFoundException );
  ResetRateLimitResult: ( RateLimitDoesNotExistException ) | ( ResetRateLimitSuccess );
  RespondToLearnPollResult: ( InvalidOptionException ) | ( LearnPollResponse ) | ( RecordDoesNotExistError );
  RestoreLoginAccessResult: ( AuthProfile ) | ( AuthProfileNotFoundException );
  RetriggerRdvsResult: ( FundingSourceAccount ) | ( RdvsNotTriggered );
  RevokeLoginAccessResult: ( AuthProfile ) | ( UserCredentialsNotFoundException );
  RevokePasswordResetTokenResult: ( InvalidPasswordResetTokenException ) | ( RevokePasswordResetTokenSuccess );
  SaveUploadUrlsResult: ( DocumentUploads ) | ( Omit<UploadSaveError, 'uploadExceptions'> & { uploadExceptions: Array<ResolversParentTypes['UploadSaveExceptions']> } );
  ScheduleRecurringTransferResult: ( MalformedRecurringTransferException ) | ( RecurringTransfer );
  SendChatMessageResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversParentTypes['ChatWidget']> } ) | ( ChatMessageSizeOutOfBounds ) | ( ChatSessionNotFound ) | ( ChatUnavailableError );
  SendCheckPaymentResult: ( AuthorizationError ) | ( CheckPayment ) | ( DuplicateActionError ) | ( InvalidAddressError );
  SetAuthenticationPINResult: ( InvalidPinException ) | ( SetAuthenticationPinSuccess ) | ( UserCredentialsNotFoundException );
  SetBeneficiarySsnResult: ( Beneficiary ) | ( BeneficiaryNotFoundException ) | ( InternalErrorException ) | ( InvalidSsnException ) | ( SecretSquirrelException ) | ( SsnAlreadyInUseException ) | ( SsnMatchesCustodianException ) | ( SsnUpdateForbiddenException );
  SetDefaultAuthenticatorResult: ( AuthenticatorAlreadyDefaultException ) | ( AuthenticatorNotFoundException ) | ( EmailAuthenticator ) | ( PhoneAuthenticator );
  SetInvestmentAccountRecapPublicAccessResult: ( InvestmentAccountRecap ) | ( InvestmentAccountRecapNotFoundException );
  SetPreferredWithdrawalAccountResult: ( FundingSourceAccount ) | ( PreferredAccountNotEligibleError ) | ( PreferredAccountNotSupportedError );
  SpendAtmsResult: ( SpendAtmVendorUnavailableError ) | ( SpendAtmsPayload );
  SpendTransactionsDisputeResult: ( SpendTransactionsDisputeResponse );
  SubmitBankFeeNegotiationResult: ( LinkedAccountNotFound ) | ( SubmitBankFeeNegotiationResponse );
  SubmitEarnMissingCreditRequestResult: ( EarnMissingCreditRequest ) | ( EarnMissingCreditRequestPurchaseDateError );
  SubscribeToTierResult: ( InvalidTier ) | ( InvalidTierPrice ) | ( TierSubscription );
  SubscribeUserToTierResult: ( InvalidTierPriceId ) | ( TierDowngradeActionRequired ) | ( TierSubscription );
  SucceedVendorInvoiceResult: ( BillingVendorError ) | ( Invoice );
  SuggestedMoneyRulesResult: ( SuggestedMoneyRulesSuccess );
  SupportTicketResponse: ( RecaptchaException ) | ( SupportTicket );
  SupportTicketWithCustomFieldsResponse: ( SubmissionError ) | ( SupportTicket );
  SuppressMoneyManagerRebalancesResult: ( SuppressMoneyManagerRebalancesError ) | ( SuppressMoneyManagerRebalancesSuccess );
  SyncFundingSourceToVendorResult: ( BillingVendorError ) | ( DuplicateBillingInfoError ) | ( VendorBillingInfo );
  TierOptionByTierPriceIdResult: ( InvalidTierPriceId ) | ( TierOption );
  TierSubscriptionForUser: ( TierSubscription ) | ( TierSubscriptionNotFound ) | ( TierSubscriptionUnsubscribed );
  TrendingLearnContentPreview: ( Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversParentTypes['LearnMediaTheme']>, duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } ) | ( Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] } );
  UnauthenticatedSaveUploadUrlResult: ( DocumentUploads ) | ( Omit<UploadSaveError, 'uploadExceptions'> & { uploadExceptions: Array<ResolversParentTypes['UploadSaveExceptions']> } );
  UnblockDeviceResult: ( Device ) | ( DeviceNotFoundException );
  UnlinkOidcCredentialsResult: ( OidcCredentialsNotFoundException ) | ( UnlinkOidcCredentialsSuccess );
  UnmarkLearnContentAsHelpfulResult: ( RecordDoesNotExistError ) | ( UpdateLearnContentHelpfulnessResult );
  UnsubscribeUserFromTierResult: ( TierDowngradeActionRequired ) | ( TierSubscriptionUnsubscribed );
  UpdateAccountPortfolioResponse: ( InvalidActionOnAccount ) | ( InvestmentAccount ) | ( InvestmentAccountNotFoundException ) | ( PortfolioNotFoundException ) | ( PortfolioUpdateFailedException );
  UpdateAttributionResult: ( InvalidConversionIdentifierException ) | ( InvalidSourceAttributesException ) | ( NoProspectRecord ) | ( RegistrationFunnel );
  UpdateAuthEmailResult: ( AuthProfile ) | ( ExistingEmailVerifiedException );
  UpdateAuthPhoneNumberResult: ( AuthProfile ) | ( InvalidPhoneNumberException );
  UpdateBankAccountGoalResult: ( UpdateBankAccountGoalPayload );
  UpdateBeneficiaryInfoResult: ( Beneficiary ) | ( BeneficiaryNotFoundException ) | ( InternalErrorException ) | ( InvalidAddressException ) | ( InvalidEmailException ) | ( InvalidPhoneException );
  UpdateCredentialsResult: ( BlockedEmailDomainException ) | ( Credentials ) | ( EmailTakenException ) | ( UserCredentialsNotFoundException );
  UpdateDelegateResult: ( DelegateDefinition );
  UpdateElapsedTimeForLearnQuizResult: ( LearnContentElapsedMillisecondsUpdatedResult ) | ( RecordDoesNotExistError );
  UpdateLearnProgressResult: ( LearnProgressUpdatedResult ) | ( RecordDoesNotExistError );
  UpdateMessageResult: ( Omit<AlertMessage, 'body' | 'icon' | 'title'> & { body: ResolversParentTypes['MessageTextAsset'], icon: Maybe<ResolversParentTypes['MessageVisualAsset']>, title: ResolversParentTypes['MessageTextAsset'] } ) | ( LegacyAlertDismissalSuccess ) | ( Omit<NotificationMessage, 'body' | 'icon' | 'title'> & { body: ResolversParentTypes['MessageTextAsset'], icon: Maybe<ResolversParentTypes['MessageVisualAsset']>, title: ResolversParentTypes['MessageTextAsset'] } ) | ( UpdateMessageIgnored );
  UpdateMoneyManagerAllocationsResult: ( AcornsValidationError ) | ( AllocationAmountsSumExceedingMaxError ) | ( InvalidSingleRuleIdError ) | ( MismatchedDistributionUnitsError ) | ( MissingValidRulesetError ) | ( NonUniqueSingleRuleIdsError ) | ( UpdateMoneyManagerAllocationsSuccess );
  UpdateMoneyManagerAutomationTargetResult: ( MoneyManagerInputError ) | ( UpdateMoneyManagerAutomationTargetSuccess );
  UpdateMoneyManagerSettingsResult: ( UpdateMoneyManagerSettingsFailure ) | ( UpdateMoneyManagerSettingsSuccess );
  UpdateMoneyRulesSourceSettingsResult: ( UpdateMoneyRulesSourceSettingsFailure ) | ( UpdateMoneyRulesSourceSettingsSuccess );
  UpdateOauthAppResult: ( OauthApp ) | ( OauthAppNotFoundException );
  UpdatePortfolioSecuritiesResult: ( CustomerAgreementRequiredException ) | ( InvalidAllocationPercentError ) | ( InvalidSecurityError ) | ( InvalidSecurityForAllocationError ) | ( InvestmentAccount ) | ( LiquidationUnavailableError ) | ( NegativeSecurityPercentError ) | ( PortfolioSecurityLimitReached );
  UpdatePromoCodeResult: ( DuplicatePromoCodeError ) | ( PromoCode ) | ( PromoCodeFieldLengthError );
  UpdatePromotedCampaignsResult: ( PromotedCampaigns );
  UpdateReferralCampaignResult: ( ReferralCampaignV2 );
  UpdateReferralPayoutResult: ( ReferralPayout );
  UpdateReferralRelationshipResult: ( ReferralRelationship );
  UpdateReferralRewardResponse: ( ReferralRewardSummary ) | ( UpdateReferralRewardError );
  UpdateScopeResult: ( Scope ) | ( UpdateScopeException );
  UpdateTrustedContactResult: ( InternalErrorException ) | ( TrustedContact ) | ( TrustedContactAlreadyExistsException ) | ( TrustedContactInvalidEmail ) | ( TrustedContactInvalidPhoneNumber ) | ( TrustedContactNotFoundException );
  UpdateUserProfileAndAutomationTargetResult: ( UpdateUserProfileAndAutomationTargetSuccess );
  UpdateUserSwitchState: ( UpdateUserSwitchStateFailure ) | ( UpdateUserSwitchStatePayload );
  UpdateVerificationProfileResult: ( VerificationProfile );
  UpgradeAuthenticationResult: ( AuthSession ) | ( AuthenticationAlreadyUpgradedException ) | ( UserCredentialsNotFoundException );
  UploadOauthAppImageResult: ( InvalidContentTypeException ) | ( OauthAppImageUpload );
  UploadSaveExceptions: ( FileDoesNotExistError ) | ( UploadDoesNotExistError );
  UpsertUserMatchResult: ( InternalErrorException ) | ( UserMatch );
  UserAlertsResponse: ( AddressDocumentRequestedUserAlert ) | ( BankDocumentRequestedUserAlert ) | ( IdentityDocumentRequestedUserAlert ) | ( InsufficientFundsUserAlert ) | ( InvestmentsPausedUserAlert ) | ( MiscDocumentRequestedUserAlert ) | ( NoFundingSourceUserAlert ) | ( RdvRequiredUserAlert ) | ( SsnDocumentRequestedUserAlert ) | ( UserAlert ) | ( W9DocumentRequestedUserAlert );
  ValidateCredentialsResult: ( AuthSession ) | ( DeviceBlockedException ) | ( InvalidCredentialsException ) | ( LoginRateLimitedException ) | ( OidcCredentialsNotFoundException ) | ( UserSuspendedException ) | ( ValidateCredentialsSuccess );
  ValidatePasswordResetTokenResult: ( InvalidPasswordResetTokenException ) | ( ValidatePasswordResetTokenSuccess );
  ValidateUserSuspendedUploadTokenResult: ( UserSuspendedUploadTokenLengthError ) | ( UserSuspendedUploadTokenValidation );
  VendAuthSessionResult: ( AuthChallengeAnswerAttemptsExhaustedException ) | ( AuthChallengeAnswerIncorrectException ) | ( AuthChallengeExpiredException ) | ( AuthSession ) | ( ChallengeRateExceededException ) | ( DeviceBlockedException ) | ( UserSuspendedException );
  VerifyCheckPaymentRecipientAddressResult: ( AuthorizationError ) | ( CheckPaymentRecipientAddressType ) | ( InvalidAddressError );
  VerifyDeviceResult: ( DeviceNotFoundException ) | ( EmailAuthChallenge ) | ( SmsAuthChallenge );
  VerifyIdentityByDocumentsResult: ( DocumentVerification );
  VerifyPasswordsResult: ( IncorrectOldPasswordException ) | ( InvalidPasswordException ) | ( SamePasswordsException ) | ( UnauthorizedException ) | ( VerifyPasswordsSuccess );
  VerifyPromoCodeResponse: ( InvalidPromoCodeError ) | ( PromoCode );
  VerifyRdvsResult: ( AccountFrozen ) | ( FundingSourceAccount ) | ( IncorrectRdvAmounts ) | ( StoredRdvDepositsInvalid ) | ( StoredRdvDepositsMissing );
  Waiver: ( MightyOakCardWaiver ) | ( PromotionalWaiver ) | ( ProvisionalWaiver );
  endChatSessionResponse: ( ChatSession ) | ( ChatSessionNotFound );
  helpcenterBannerResponse: ( HelpcenterBannerContent ) | ( HelpcenterBannerErrors );
  rateChatMessageResponse: ( Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversParentTypes['ChatWidget']> } ) | ( ChatHistoryMessageCustomFeedbackOutOfBounds ) | ( ChatHistoryMessageNotFound ) | ( ChatHistoryMessageNotRatable ) | ( ChatHistoryMessageRatingFailed ) | ( ChatHistoryMessageRatingOutOfBounds );
  startChatSessionResponse: ( ChatSession ) | ( ChatUnavailableError );
  userWinbackScoreRes: ( UserWinbackErrors ) | ( UserWinbackScore );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AbstractSwitch: ResolverTypeWrapper<ResolversUnionTypes['AbstractSwitch']>;
  AcceptDocumentInput: AcceptDocumentInput;
  AcceptDocumentResponse: ResolverTypeWrapper<ResolversUnionTypes['AcceptDocumentResponse']>;
  AcceptanceDocument: ResolverTypeWrapper<AcceptanceDocument>;
  AcceptanceDocumentType: AcceptanceDocumentType;
  AcceptedDocument: ResolverTypeWrapper<AcceptedDocument>;
  Account: ResolverTypeWrapper<Account>;
  AccountAchievement: ResolverTypeWrapper<AccountAchievement>;
  AccountAlreadyClosedException: ResolverTypeWrapper<AccountAlreadyClosedException>;
  AccountClosedException: ResolverTypeWrapper<AccountClosedException>;
  AccountFrozen: ResolverTypeWrapper<AccountFrozen>;
  AccountMoneyAssignmentInput: AccountMoneyAssignmentInput;
  AccountNotFoundException: ResolverTypeWrapper<AccountNotFoundException>;
  AccountNumber: ResolverTypeWrapper<Scalars['AccountNumber']>;
  AccountPoints: ResolverTypeWrapper<AccountPoints>;
  AccountPointsRule: ResolverTypeWrapper<AccountPointsRule>;
  AccountRequirement: ResolverTypeWrapper<AccountRequirement>;
  AccountRequirementStatus: AccountRequirementStatus;
  AccountRequirementType: AccountRequirementType;
  AccountRequirements: ResolverTypeWrapper<AccountRequirements>;
  AccountSetupMilestones: ResolverTypeWrapper<AccountSetupMilestones>;
  AccountStatus: AccountStatus;
  AccountStrengthResult: ResolverTypeWrapper<AccountStrengthResult>;
  AccountType: AccountType;
  AccountValue: ResolverTypeWrapper<AccountValue>;
  AchievementItem: AchievementItem;
  AcornsEarlyUserDetails: ResolverTypeWrapper<AcornsEarlyUserDetails>;
  AcornsPartnerStatus: AcornsPartnerStatus;
  AcornsPdfSwitch: ResolverTypeWrapper<AcornsPdfSwitch>;
  AcornsValidationError: ResolverTypeWrapper<AcornsValidationError>;
  ActionCard: ResolverTypeWrapper<ActionCard>;
  ActionCardButton: ResolverTypeWrapper<ActionCardButton>;
  ActionCardStyle: ActionCardStyle;
  ActionCardsInput: ActionCardsInput;
  ActionFeedContext: ActionFeedContext;
  ActionFeedCta: ResolverTypeWrapper<ActionFeedCta>;
  ActionFeedCtaType: ActionFeedCtaType;
  ActionFeedEvent: ActionFeedEvent;
  ActionFeedEventAction: ActionFeedEventAction;
  ActionFeedEventResponse: ResolverTypeWrapper<ActionFeedEventResponse>;
  ActionFeedEventType: ActionFeedEventType;
  ActionScreenComponent: ResolverTypeWrapper<ResolversUnionTypes['ActionScreenComponent']>;
  ActionScreenContext: ActionScreenContext;
  ActionType: ActionType;
  ActionWidget: ResolverTypeWrapper<ActionWidget>;
  ActivateBankCardInput: ActivateBankCardInput;
  ActivateBankCardPayload: ResolverTypeWrapper<ActivateBankCardPayload>;
  ActivateOauthAppClientResult: ResolverTypeWrapper<ResolversUnionTypes['ActivateOauthAppClientResult']>;
  ActivateOauthAppResult: ResolverTypeWrapper<ResolversUnionTypes['ActivateOauthAppResult']>;
  ActiveReferralCampaignOutput: ResolverTypeWrapper<ActiveReferralCampaignOutput>;
  Activity: ResolverTypeWrapper<Activity>;
  ActivitySummaryProduct: ActivitySummaryProduct;
  ActivitySummaryResponse: ResolverTypeWrapper<ActivitySummaryResponse>;
  ActivityType: ActivityType;
  AddCohortEligibilityInput: AddCohortEligibilityInput;
  AddCohortEligibilityResult: ResolverTypeWrapper<ResolversUnionTypes['AddCohortEligibilityResult']>;
  AddPolicyInput: AddPolicyInput;
  AddPolicyResult: ResolverTypeWrapper<ResolversUnionTypes['AddPolicyResult']>;
  AddPolicySuccess: ResolverTypeWrapper<AddPolicySuccess>;
  AddSearchTermToLearnSearchHistoryInput: AddSearchTermToLearnSearchHistoryInput;
  AddSearchTermToLearnSearchHistoryResult: ResolverTypeWrapper<ResolversUnionTypes['AddSearchTermToLearnSearchHistoryResult']>;
  AddSecurityToPortfolioInput: AddSecurityToPortfolioInput;
  AddSecurityToPortfolioResult: ResolverTypeWrapper<ResolversUnionTypes['AddSecurityToPortfolioResult']>;
  AddSelfDirectedPortfolioInput: AddSelfDirectedPortfolioInput;
  AddSelfDirectedPortfolioResult: ResolverTypeWrapper<ResolversUnionTypes['AddSelfDirectedPortfolioResult']>;
  Address: ResolverTypeWrapper<Address>;
  AddressDeliverabilityAdditionalInfo: ResolverTypeWrapper<AddressDeliverabilityAdditionalInfo>;
  AddressDeliverabilityCorrectedAddress: ResolverTypeWrapper<AddressDeliverabilityCorrectedAddress>;
  AddressDeliverabilityInput: AddressDeliverabilityInput;
  AddressDeliverabilityResult: ResolverTypeWrapper<ResolversUnionTypes['AddressDeliverabilityResult']>;
  AddressDeliverabilityUnavailableError: ResolverTypeWrapper<AddressDeliverabilityUnavailableError>;
  AddressDeliverabilityVerificationError: ResolverTypeWrapper<AddressDeliverabilityVerificationError>;
  AddressDeliverabilityVerificationErrorFailureReason: AddressDeliverabilityVerificationErrorFailureReason;
  AddressDeliverabilityVerified: ResolverTypeWrapper<AddressDeliverabilityVerified>;
  AddressDocumentRequestedUserAlert: ResolverTypeWrapper<AddressDocumentRequestedUserAlert>;
  AddressInput: AddressInput;
  AddressType: AddressType;
  AddressVerification: ResolversTypes['BankCardOrderAddressVerification'] | ResolversTypes['BankingKycAddressVerification'];
  Advocate: ResolverTypeWrapper<Advocate>;
  AdvocateFriendsStatuses: ResolverTypeWrapper<AdvocateFriendsStatuses>;
  AdvocateV2: ResolverTypeWrapper<AdvocateV2>;
  Alert: ResolversTypes['MissingSsnBeneficiaryAlert'] | ResolversTypes['UnverifiedBeneficiarySsnAlert'];
  AlertHubBeneficiaryAlert: ResolverTypeWrapper<ResolversUnionTypes['AlertHubBeneficiaryAlert']>;
  AlertMessage: ResolverTypeWrapper<Omit<AlertMessage, 'body' | 'icon' | 'title'> & { body: ResolversTypes['MessageTextAsset'], icon: Maybe<ResolversTypes['MessageVisualAsset']>, title: ResolversTypes['MessageTextAsset'] }>;
  AllAccountHistorySummary: ResolverTypeWrapper<AllAccountHistorySummary>;
  AllAccountsFilterInput: AllAccountsFilterInput;
  AllBankAccountsInput: AllBankAccountsInput;
  AllBankCardsFilter: AllBankCardsFilter;
  AllBankDocumentsInput: AllBankDocumentsInput;
  AllChatHistoryMessages: ResolverTypeWrapper<AllChatHistoryMessages>;
  AllCheckPaymentsResult: ResolverTypeWrapper<ResolversUnionTypes['AllCheckPaymentsResult']>;
  AllPastCoreItemsSchemaFilter: AllPastCoreItemsSchemaFilter;
  AllPastEarlyItemsSchemaFilter: AllPastEarlyItemsSchemaFilter;
  AllPastItemsFilter: AllPastItemsFilter;
  AllPastLaterItemsSchemaFilter: AllPastLaterItemsSchemaFilter;
  AllPastSpendItemsSchemaFilter: AllPastSpendItemsSchemaFilter;
  AllSupportArticlesFilterInput: AllSupportArticlesFilterInput;
  AllTransferableToInput: AllTransferableToInput;
  AllocationAmountsSumExceedingMaxError: ResolverTypeWrapper<AllocationAmountsSumExceedingMaxError>;
  Amount: ResolverTypeWrapper<Scalars['Amount']>;
  AnswerChallengeResult: ResolverTypeWrapper<ResolversUnionTypes['AnswerChallengeResult']>;
  AnswerChallengeSuccess: ResolverTypeWrapper<AnswerChallengeSuccess>;
  AnswerLearnQuizQuestionInput: AnswerLearnQuizQuestionInput;
  AnswerLearnQuizQuestionResult: ResolverTypeWrapper<ResolversUnionTypes['AnswerLearnQuizQuestionResult']>;
  ApplyPromoCodeResult: ResolverTypeWrapper<ResolversUnionTypes['ApplyPromoCodeResult']>;
  ApplyPromotionInput: ApplyPromotionInput;
  ApplyPromotionResult: ResolverTypeWrapper<ResolversUnionTypes['ApplyPromotionResult']>;
  ApplyPromotionalWaiverInput: ApplyPromotionalWaiverInput;
  ApplyPromotionalWaiverResult: ResolverTypeWrapper<ResolversUnionTypes['ApplyPromotionalWaiverResult']>;
  ApplyProvisionalWaiverResult: ResolverTypeWrapper<ResolversUnionTypes['ApplyProvisionalWaiverResult']>;
  ArchiveInvalidSmartDepositRecordsResult: ResolverTypeWrapper<ArchiveInvalidSmartDepositRecordsResult>;
  AssignLinkedSubaccountInput: AssignLinkedSubaccountInput;
  AsyncLinkSessionResult: ResolverTypeWrapper<AsyncLinkSessionResult>;
  AuthAlert: ResolversTypes['MfaMissingAuthAlert'];
  AuthChallenge: ResolversTypes['EmailAuthChallenge'] | ResolversTypes['PushAuthChallenge'] | ResolversTypes['SMSAuthChallenge'];
  AuthChallengeAnswerAttemptsExhaustedException: ResolverTypeWrapper<AuthChallengeAnswerAttemptsExhaustedException>;
  AuthChallengeAnswerIncorrectException: ResolverTypeWrapper<AuthChallengeAnswerIncorrectException>;
  AuthChallengeExpiredException: ResolverTypeWrapper<AuthChallengeExpiredException>;
  AuthProfile: ResolverTypeWrapper<AuthProfile>;
  AuthProfileAlreadyExistsException: ResolverTypeWrapper<AuthProfileAlreadyExistsException>;
  AuthProfileNotFoundException: ResolverTypeWrapper<AuthProfileNotFoundException>;
  AuthSession: ResolverTypeWrapper<AuthSession>;
  AuthTokenNotFoundException: ResolverTypeWrapper<AuthTokenNotFoundException>;
  AuthType: AuthType;
  AuthenticateForFeeNegotiationChallengeInput: AuthenticateForFeeNegotiationChallengeInput;
  AuthenticateForFeeNegotiationChallengeMethodInput: AuthenticateForFeeNegotiationChallengeMethodInput;
  AuthenticateForFeeNegotiationInput: AuthenticateForFeeNegotiationInput;
  AuthenticateForFeeNegotiationResult: ResolverTypeWrapper<ResolversUnionTypes['AuthenticateForFeeNegotiationResult']>;
  AuthenticateForFeeNegotiationStatus: ResolverTypeWrapper<AuthenticateForFeeNegotiationStatus>;
  AuthenticateInput: AuthenticateInput;
  AuthenticateNegotiationStatusResult: ResolverTypeWrapper<ResolversUnionTypes['AuthenticateNegotiationStatusResult']>;
  AuthenticateResult: ResolverTypeWrapper<ResolversUnionTypes['AuthenticateResult']>;
  AuthenticationAlreadyUpgradedException: ResolverTypeWrapper<AuthenticationAlreadyUpgradedException>;
  Authenticator: ResolversTypes['EmailAuthenticator'] | ResolversTypes['PhoneAuthenticator'] | ResolversTypes['PushAuthenticator'];
  AuthenticatorAlreadyDefaultException: ResolverTypeWrapper<AuthenticatorAlreadyDefaultException>;
  AuthenticatorInfo: ResolverTypeWrapper<AuthenticatorInfo>;
  AuthenticatorNotFoundException: ResolverTypeWrapper<AuthenticatorNotFoundException>;
  AuthenticatorTypeAlreadyRegisteredException: ResolverTypeWrapper<AuthenticatorTypeAlreadyRegisteredException>;
  AuthenticatorUnavailableException: ResolverTypeWrapper<AuthenticatorUnavailableException>;
  AuthorizationError: ResolverTypeWrapper<AuthorizationError>;
  AutomationError: ResolverTypeWrapper<AutomationError>;
  AutomationErrorCode: AutomationErrorCode;
  BackendJobBatch: ResolverTypeWrapper<BackendJobBatch>;
  BackendJobBatchAutomatedOrdersFilterInput: BackendJobBatchAutomatedOrdersFilterInput;
  BackendJobBatchMoneyMovementFilterInput: BackendJobBatchMoneyMovementFilterInput;
  BackendJobBatchOrdersFilterInput: BackendJobBatchOrdersFilterInput;
  BackendJobBatchProfitStarsFilterInput: BackendJobBatchProfitStarsFilterInput;
  BackendJobBatchStatus: BackendJobBatchStatus;
  BackendJobBatchSummary: ResolverTypeWrapper<BackendJobBatchSummary>;
  BackendJobBatchSummaryFilterInput: BackendJobBatchSummaryFilterInput;
  BackendJobBatchTimeframe: BackendJobBatchTimeframe;
  BackendJobBatchType: BackendJobBatchType;
  BadRequestError: ResolverTypeWrapper<BadRequestError>;
  BadgeCategory: BadgeCategory;
  BankAccount: ResolverTypeWrapper<BankAccount>;
  BankAccountClosureReason: BankAccountClosureReason;
  BankAccountDisclosure: ResolverTypeWrapper<BankAccountDisclosure>;
  BankAccountDisclosureFilter: BankAccountDisclosureFilter;
  BankAccountGoal: ResolverTypeWrapper<BankAccountGoal>;
  BankAccountGoalInput: BankAccountGoalInput;
  BankAccountGoalType: BankAccountGoalType;
  BankAccountGoals: ResolverTypeWrapper<BankAccountGoals>;
  BankAccountLockReason: BankAccountLockReason;
  BankAccountNotFoundError: ResolverTypeWrapper<BankAccountNotFoundError>;
  BankAccountRequirement: ResolverTypeWrapper<BankAccountRequirement>;
  BankAccountRequirementStatus: BankAccountRequirementStatus;
  BankAccountRequirementType: BankAccountRequirementType;
  BankAccountRequirements: ResolverTypeWrapper<BankAccountRequirements>;
  BankAccountState: ResolverTypeWrapper<BankAccountState>;
  BankAccountStateResult: ResolverTypeWrapper<BankAccountStateResult>;
  BankAccountStateStatus: BankAccountStateStatus;
  BankAccountStatus: BankAccountStatus;
  BankAccountType: BankAccountType;
  BankAccountTypeConfig: BankAccountTypeConfig;
  BankCard: ResolverTypeWrapper<BankCard>;
  BankCardLockReason: BankCardLockReason;
  BankCardLockTypeCode: BankCardLockTypeCode;
  BankCardOrder: ResolverTypeWrapper<BankCardOrder>;
  BankCardOrderAddressVerification: ResolverTypeWrapper<BankCardOrderAddressVerification>;
  BankCardOrderAddressVerificationActions: BankCardOrderAddressVerificationActions;
  BankCardOrderFailureReason: BankCardOrderFailureReason;
  BankCardOrderFundingSourceVerification: ResolverTypeWrapper<BankCardOrderFundingSourceVerification>;
  BankCardOrderFundingSourceVerificationActions: BankCardOrderFundingSourceVerificationActions;
  BankCardOrderFundingSourceVerificationPendingReason: BankCardOrderFundingSourceVerificationPendingReason;
  BankCardOrderIdentityVerification: ResolverTypeWrapper<BankCardOrderIdentityVerification>;
  BankCardOrderIdentityVerificationActions: BankCardOrderIdentityVerificationActions;
  BankCardOrderPrefundVerification: ResolverTypeWrapper<BankCardOrderPrefundVerification>;
  BankCardOrderPrefundVerificationActions: BankCardOrderPrefundVerificationActions;
  BankCardOrderStatus: BankCardOrderStatus;
  BankCardOrderVerificationStatus: BankCardOrderVerificationStatus;
  BankCardPanDisplayPayload: ResolverTypeWrapper<BankCardPanDisplayPayload>;
  BankCardPanDisplayResult: ResolverTypeWrapper<ResolversUnionTypes['BankCardPanDisplayResult']>;
  BankCardPaymentProcessor: BankCardPaymentProcessor;
  BankCardPermanentLockReason: BankCardPermanentLockReason;
  BankCardPin: ResolverTypeWrapper<Scalars['BankCardPin']>;
  BankCardPrefundTransfer: BankCardPrefundTransfer;
  BankCardProvisioningDetailsInput: BankCardProvisioningDetailsInput;
  BankCardProvisioningDetailsPayload: ResolverTypeWrapper<BankCardProvisioningDetailsPayload>;
  BankCardProvisioningDetailsResult: ResolverTypeWrapper<ResolversUnionTypes['BankCardProvisioningDetailsResult']>;
  BankCardReissue: ResolverTypeWrapper<Omit<BankCardReissue, 'reissueBankCardEligibility'> & { reissueBankCardEligibility: ResolversTypes['ReissueBankCardEligibility'] }>;
  BankCardRequest: ResolverTypeWrapper<BankCardRequest>;
  BankCardRequestMailingAddress: ResolverTypeWrapper<BankCardRequestMailingAddress>;
  BankCardRequestMailingAddressInput: BankCardRequestMailingAddressInput;
  BankCardRequestReason: BankCardRequestReason;
  BankCardRequestStatus: BankCardRequestStatus;
  BankCardStatus: BankCardStatus;
  BankCardTemporaryLockReason: BankCardTemporaryLockReason;
  BankCardTier: BankCardTier;
  BankCardType: BankCardType;
  BankConnection: ResolverTypeWrapper<BankConnection>;
  BankConnectionStatus: BankConnectionStatus;
  BankDocument: ResolverTypeWrapper<BankDocument>;
  BankDocumentRequestedUserAlert: ResolverTypeWrapper<BankDocumentRequestedUserAlert>;
  BankFee: ResolverTypeWrapper<BankFee>;
  BankFeeConnection: ResolverTypeWrapper<BankFeeConnection>;
  BankFeeFilter: BankFeeFilter;
  BankFeeNegotiationExternalStatus: BankFeeNegotiationExternalStatus;
  BankFeeNegotiationInternalStatus: BankFeeNegotiationInternalStatus;
  BankFeeNegotiationStatus: BankFeeNegotiationStatus;
  BankFeeSummary: ResolverTypeWrapper<BankFeeSummary>;
  BankFeeType: BankFeeType;
  BankInterestRate: ResolverTypeWrapper<BankInterestRate>;
  BankInterestRates: ResolverTypeWrapper<BankInterestRates>;
  BankInterestRatesResult: ResolverTypeWrapper<ResolversUnionTypes['BankInterestRatesResult']>;
  BankMetadata: ResolverTypeWrapper<BankMetadata>;
  BankMetadataTotals: ResolverTypeWrapper<BankMetadataTotals>;
  BankName: BankName;
  BankServiceFailure: ResolverTypeWrapper<BankServiceFailure>;
  BankStatement: ResolverTypeWrapper<BankStatement>;
  BankStatementType: BankStatementType;
  BankTransaction: ResolverTypeWrapper<BankTransaction>;
  BankTransactionConnection: ResolverTypeWrapper<BankTransactionConnection>;
  BankTransactionEdge: ResolverTypeWrapper<BankTransactionEdge>;
  BankTransactionNachaInfo: ResolverTypeWrapper<BankTransactionNachaInfo>;
  BankTransactionStatus: BankTransactionStatus;
  BankTransactionType: BankTransactionType;
  BankType: BankType;
  BankingEligibilityFeature: BankingEligibilityFeature;
  BankingEligibilityReason: BankingEligibilityReason;
  BankingFeatureEligibility: ResolverTypeWrapper<BankingFeatureEligibility>;
  BankingKyc: ResolverTypeWrapper<BankingKyc>;
  BankingKycAddressVerification: ResolverTypeWrapper<BankingKycAddressVerification>;
  BankingKycIdentityVerification: ResolverTypeWrapper<BankingKycIdentityVerification>;
  BankingProduct: BankingProduct;
  BannersErrors: ResolverTypeWrapper<BannersErrors>;
  BannersResponse: ResolverTypeWrapper<ResolversUnionTypes['BannersResponse']>;
  BasePortfolio: ResolversTypes['Portfolio'] | ResolversTypes['SelfDirectedPortfolio'];
  BatchAddTierSubscriptions: ResolverTypeWrapper<BatchAddTierSubscriptions>;
  BatchAddTierSubscriptionsInput: BatchAddTierSubscriptionsInput;
  BatchAddTierSubscriptionsResult: ResolverTypeWrapper<ResolversUnionTypes['BatchAddTierSubscriptionsResult']>;
  Beneficiary: ResolverTypeWrapper<Beneficiary>;
  BeneficiaryAccountExistsException: ResolverTypeWrapper<BeneficiaryAccountExistsException>;
  BeneficiaryExceedsAgeLimitException: ResolverTypeWrapper<BeneficiaryExceedsAgeLimitException>;
  BeneficiaryInfoInput: BeneficiaryInfoInput;
  BeneficiaryInput: BeneficiaryInput;
  BeneficiaryNotFoundException: ResolverTypeWrapper<BeneficiaryNotFoundException>;
  BeneficiaryType: BeneficiaryType;
  BenefitPartnerInput: BenefitPartnerInput;
  BenefitPartnerResponse: ResolverTypeWrapper<ResolversUnionTypes['BenefitPartnerResponse']>;
  BenefitProductStatus: BenefitProductStatus;
  BenefitProductTile: ResolverTypeWrapper<BenefitProductTile>;
  BenefitPromotedThrough: BenefitPromotedThrough;
  BenefitStatus: ResolverTypeWrapper<BenefitStatus>;
  BenefitStatusDetail: BenefitStatusDetail;
  BenefitTileGroup: ResolverTypeWrapper<BenefitTileGroup>;
  BenefitsMessage: ResolverTypeWrapper<BenefitsMessage>;
  BenefitsPartner: BenefitsPartner;
  BenefitsProduct: BenefitsProduct;
  BenefitsStatusResponse: ResolverTypeWrapper<BenefitsStatusResponse>;
  BenefitsTrackerProducts: BenefitsTrackerProducts;
  BigCurrencyAmount: ResolverTypeWrapper<BigCurrencyAmount>;
  BigDecimal: ResolverTypeWrapper<Scalars['BigDecimal']>;
  BillingCycle: ResolverTypeWrapper<BillingCycle>;
  BillingCycleState: BillingCycleState;
  BillingFrequency: BillingFrequency;
  BillingInvoice: ResolverTypeWrapper<BillingInvoice>;
  BillingProfile: ResolverTypeWrapper<Omit<BillingProfile, 'waivers'> & { waivers: Maybe<Array<ResolversTypes['Waiver']>> }>;
  BillingProfileNotFoundException: ResolverTypeWrapper<BillingProfileNotFoundException>;
  BillingVendorError: ResolverTypeWrapper<BillingVendorError>;
  BlockDeviceInput: BlockDeviceInput;
  BlockDeviceResult: ResolverTypeWrapper<ResolversUnionTypes['BlockDeviceResult']>;
  BlockedEmailDomainException: ResolverTypeWrapper<BlockedEmailDomainException>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BrazeEvent: BrazeEvent;
  Bundle: ResolverTypeWrapper<Bundle>;
  CacheControlScope: CacheControlScope;
  CampaignBackgroundType: CampaignBackgroundType;
  CampaignFilterType: CampaignFilterType;
  CampaignHistoryConnection: ResolverTypeWrapper<CampaignHistoryConnection>;
  CampaignHistoryEdge: ResolverTypeWrapper<CampaignHistoryEdge>;
  CampaignHistoryFilter: CampaignHistoryFilter;
  CampaignIconType: CampaignIconType;
  CampaignQualificationActionType: CampaignQualificationActionType;
  CampaignRewardFilterType: CampaignRewardFilterType;
  CampaignStatus: CampaignStatus;
  CampaignV2: ResolverTypeWrapper<CampaignV2>;
  CancelCheckPaymentResult: ResolverTypeWrapper<ResolversUnionTypes['CancelCheckPaymentResult']>;
  CancelIntentResult: ResolverTypeWrapper<ResolversUnionTypes['CancelIntentResult']>;
  CancelInvestmentAccountClosureRequestInput: CancelInvestmentAccountClosureRequestInput;
  CancelInvestmentAccountClosureRequestResult: ResolverTypeWrapper<ResolversUnionTypes['CancelInvestmentAccountClosureRequestResult']>;
  CancelInvestmentInput: CancelInvestmentInput;
  CancelInvestmentPayload: ResolverTypeWrapper<CancelInvestmentPayload>;
  CancelInvestmentResult: ResolverTypeWrapper<ResolversUnionTypes['CancelInvestmentResult']>;
  CancelMoneyAssignmentInput: CancelMoneyAssignmentInput;
  CancelMoneyAssignmentResult: ResolverTypeWrapper<ResolversUnionTypes['CancelMoneyAssignmentResult']>;
  CancelRecurringTransferResult: ResolverTypeWrapper<ResolversUnionTypes['CancelRecurringTransferResult']>;
  CancelTransferPayload: ResolverTypeWrapper<CancelTransferPayload>;
  CardColor: CardColor;
  CardDeliveryStatus: ResolverTypeWrapper<CardDeliveryStatus>;
  CardNumberMasked: ResolverTypeWrapper<Scalars['CardNumberMasked']>;
  CarouselType: CarouselType;
  ChallengeAnswerInput: ChallengeAnswerInput;
  ChallengeDeliveryType: ChallengeDeliveryType;
  ChallengePointsEarned: ResolverTypeWrapper<ChallengePointsEarned>;
  ChallengePushState: ChallengePushState;
  ChallengeRateExceededException: ResolverTypeWrapper<ChallengeRateExceededException>;
  ChallengeTriggers: ChallengeTriggers;
  ChangeOutsideContributionAmountInput: ChangeOutsideContributionAmountInput;
  ChangeOutsideContributionAmountResult: ResolverTypeWrapper<ResolversUnionTypes['ChangeOutsideContributionAmountResult']>;
  ChangePasswordInput: ChangePasswordInput;
  ChangePasswordResult: ResolverTypeWrapper<ResolversUnionTypes['ChangePasswordResult']>;
  ChangePasswordSuccess: ResolverTypeWrapper<ChangePasswordSuccess>;
  ChatActionData: ResolverTypeWrapper<ChatActionData>;
  ChatActionDataInput: ChatActionDataInput;
  ChatAuthor: ChatAuthor;
  ChatChoice: ResolverTypeWrapper<ChatChoice>;
  ChatChoiceActionData: ResolverTypeWrapper<ChatChoiceActionData>;
  ChatChoiceActionMetadata: ResolverTypeWrapper<ChatChoiceActionMetadata>;
  ChatChoiceWidget: ResolverTypeWrapper<ChatChoiceWidget>;
  ChatContext: ChatContext;
  ChatDeeplink: ResolverTypeWrapper<ChatDeeplink>;
  ChatFeatures: ChatFeatures;
  ChatHistoryCitation: ResolverTypeWrapper<ChatHistoryCitation>;
  ChatHistoryCitationV2: ResolverTypeWrapper<ResolversUnionTypes['ChatHistoryCitationV2']>;
  ChatHistoryMessage: ResolverTypeWrapper<Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversTypes['ChatWidget']> }>;
  ChatHistoryMessageBody: ResolverTypeWrapper<ChatHistoryMessageBody>;
  ChatHistoryMessageCustomFeedbackOutOfBounds: ResolverTypeWrapper<ChatHistoryMessageCustomFeedbackOutOfBounds>;
  ChatHistoryMessageEdge: ResolverTypeWrapper<ChatHistoryMessageEdge>;
  ChatHistoryMessageError: ResolversTypes['ChatHistoryMessageCustomFeedbackOutOfBounds'] | ResolversTypes['ChatHistoryMessageNotFound'] | ResolversTypes['ChatHistoryMessageNotRatable'] | ResolversTypes['ChatHistoryMessageRatingFailed'] | ResolversTypes['ChatHistoryMessageRatingOutOfBounds'] | ResolversTypes['ChatMessageSizeOutOfBounds'];
  ChatHistoryMessageFooter: ResolverTypeWrapper<Omit<ChatHistoryMessageFooter, 'chatWidgets'> & { chatWidgets: Array<ResolversTypes['ChatWidget']> }>;
  ChatHistoryMessageHeader: ResolverTypeWrapper<ChatHistoryMessageHeader>;
  ChatHistoryMessageNotFound: ResolverTypeWrapper<ChatHistoryMessageNotFound>;
  ChatHistoryMessageNotRatable: ResolverTypeWrapper<ChatHistoryMessageNotRatable>;
  ChatHistoryMessageRatingFailed: ResolverTypeWrapper<ChatHistoryMessageRatingFailed>;
  ChatHistoryMessageRatingOutOfBounds: ResolverTypeWrapper<ChatHistoryMessageRatingOutOfBounds>;
  ChatMessageMetadata: ResolverTypeWrapper<ChatMessageMetadata>;
  ChatMessageMetadataInput: ChatMessageMetadataInput;
  ChatMessageSizeOutOfBounds: ResolverTypeWrapper<ChatMessageSizeOutOfBounds>;
  ChatMessageStreamResponse: ResolverTypeWrapper<ResolversUnionTypes['ChatMessageStreamResponse']>;
  ChatRedirect: ResolverTypeWrapper<ChatRedirect>;
  ChatSession: ResolverTypeWrapper<ChatSession>;
  ChatSessionNotFound: ResolverTypeWrapper<ChatSessionNotFound>;
  ChatUnavailableError: ResolverTypeWrapper<ChatUnavailableError>;
  ChatWidget: ResolverTypeWrapper<ResolversUnionTypes['ChatWidget']>;
  CheckImage: CheckImage;
  CheckPayment: ResolverTypeWrapper<CheckPayment>;
  CheckPaymentAddress: ResolverTypeWrapper<CheckPaymentAddress>;
  CheckPaymentAddressInput: CheckPaymentAddressInput;
  CheckPaymentConnection: ResolverTypeWrapper<CheckPaymentConnection>;
  CheckPaymentEdge: ResolverTypeWrapper<CheckPaymentEdge>;
  CheckPaymentFailureReason: CheckPaymentFailureReason;
  CheckPaymentRecipient: ResolverTypeWrapper<CheckPaymentRecipient>;
  CheckPaymentRecipientAddressType: ResolverTypeWrapper<CheckPaymentRecipientAddressType>;
  CheckPaymentRecipientInput: CheckPaymentRecipientInput;
  CheckPaymentStatus: CheckPaymentStatus;
  CheckingHistorySummary: ResolverTypeWrapper<CheckingHistorySummary>;
  CheckoutCartStatus: CheckoutCartStatus;
  CitationType: CitationType;
  CitationWidget: ResolverTypeWrapper<Omit<CitationWidget, 'citations'> & { citations: Array<ResolversTypes['ChatHistoryCitationV2']> }>;
  ClaimStatus: ClaimStatus;
  ClaimStatusDetails: ResolverTypeWrapper<ClaimStatusDetails>;
  ClearSupportSiteCache: ResolverTypeWrapper<ClearSupportSiteCache>;
  ClientInfo: ClientInfo;
  CloseAccountReason: ResolverTypeWrapper<CloseAccountReason>;
  CloseBankAccountInput: CloseBankAccountInput;
  CloseBankAccountResult: ResolverTypeWrapper<ResolversUnionTypes['CloseBankAccountResult']>;
  CloseInvestmentAccountInput: CloseInvestmentAccountInput;
  CloseInvestmentAccountResult: ResolverTypeWrapper<ResolversUnionTypes['CloseInvestmentAccountResult']>;
  CloseUserAccountResult: ResolverTypeWrapper<ResolversUnionTypes['CloseUserAccountResult']>;
  ClosureRequestDoesNotExistException: ResolverTypeWrapper<ClosureRequestDoesNotExistException>;
  ClosureRequestExistsException: ResolverTypeWrapper<ClosureRequestExistsException>;
  CohortEligibility: ResolverTypeWrapper<CohortEligibility>;
  CohortEligibilityScope: CohortEligibilityScope;
  CohortEligibility_v2: ResolverTypeWrapper<CohortEligibility_V2>;
  CohortEligibility_v2FilterInput: CohortEligibility_V2FilterInput;
  CollectionMethod: CollectionMethod;
  CombinedPerformance: ResolverTypeWrapper<CombinedPerformance>;
  CompleteCheckDepositInput: CompleteCheckDepositInput;
  CompleteCheckDepositPayload: ResolverTypeWrapper<CompleteCheckDepositPayload>;
  CompleteFunnelOnboardingResult: ResolverTypeWrapper<ResolversUnionTypes['CompleteFunnelOnboardingResult']>;
  CompletedQuiz: ResolverTypeWrapper<CompletedQuiz>;
  ConfigureSettingsInput: ConfigureSettingsInput;
  ConfigureSplitDepositDirectDepositIntentPayload: ResolverTypeWrapper<ConfigureSplitDepositDirectDepositIntentPayload>;
  ConfigureSplitDepositDirectDepositIntentSettingInput: ConfigureSplitDepositDirectDepositIntentSettingInput;
  ConfigureSplitDepositDirectDepositSettingInput: ConfigureSplitDepositDirectDepositSettingInput;
  ConfigureSplitDepositDirectDepositSettingPayload: ResolverTypeWrapper<ConfigureSplitDepositDirectDepositSettingPayload>;
  ConnectACHAccountInput: ConnectAchAccountInput;
  ConnectACHAccountResult: ResolverTypeWrapper<ResolversUnionTypes['ConnectACHAccountResult']>;
  ConnectACHAccountSucceeded: ResolverTypeWrapper<ConnectAchAccountSucceeded>;
  ConnectionStatus: ConnectionStatus;
  ConnectionSummary: ResolverTypeWrapper<ConnectionSummary>;
  ConsumeUserTokenResult: ResolverTypeWrapper<ResolversUnionTypes['ConsumeUserTokenResult']>;
  ContactCategory: ResolverTypeWrapper<ContactCategory>;
  ContactFaq: ResolverTypeWrapper<ContactFaq>;
  ContactFormAlert: ResolverTypeWrapper<ContactFormAlert>;
  ContactInfoInput: ContactInfoInput;
  ContactSubcategory: ResolverTypeWrapper<ContactSubcategory>;
  ContentPreviewConnection: ResolverTypeWrapper<ContentPreviewConnection>;
  ContentPreviewEdge: ResolverTypeWrapper<Omit<ContentPreviewEdge, 'node'> & { node: ResolversTypes['LearnContentPreview'] }>;
  ContextEntryInput: ContextEntryInput;
  ContributionAbility: ResolverTypeWrapper<ContributionAbility>;
  ContributionAbilityByYear: ResolverTypeWrapper<ContributionAbilityByYear>;
  ContributionActionRequiredError: ResolverTypeWrapper<ContributionActionRequiredError>;
  ContributionAmountAboveThresholdError: ResolverTypeWrapper<ContributionAmountAboveThresholdError>;
  ContributionAmountBelowThresholdError: ResolverTypeWrapper<ContributionAmountBelowThresholdError>;
  ContributionCardDeclinedError: ResolverTypeWrapper<ContributionCardDeclinedError>;
  ContributionHistoryItem: ResolverTypeWrapper<ContributionHistoryItem>;
  ContributionInvalidOwnerEmailError: ResolverTypeWrapper<ContributionInvalidOwnerEmailError>;
  ContributionRequiredAction: ContributionRequiredAction;
  ContributionState: ContributionState;
  CoreACHSubscriptionFeeItem: ResolverTypeWrapper<CoreAchSubscriptionFeeItem>;
  CoreAccountAlreadyExistsException: ResolverTypeWrapper<CoreAccountAlreadyExistsException>;
  CoreAccountClosedException: ResolverTypeWrapper<CoreAccountClosedException>;
  CoreAdjustmentItem: ResolverTypeWrapper<CoreAdjustmentItem>;
  CoreCashForwardItem: ResolverTypeWrapper<CoreCashForwardItem>;
  CoreCollectionItem: ResolverTypeWrapper<CoreCollectionItem>;
  CoreDebtCollectionItem: ResolverTypeWrapper<CoreDebtCollectionItem>;
  CoreDividendsItem: ResolverTypeWrapper<CoreDividendsItem>;
  CoreEmployeeCreditItem: ResolverTypeWrapper<CoreEmployeeCreditItem>;
  CoreFeeInvestmentItem: ResolverTypeWrapper<CoreFeeInvestmentItem>;
  CoreFoundMoneyRewardItem: ResolverTypeWrapper<CoreFoundMoneyRewardItem>;
  CoreGiftCardCreditRedemptionItem: ResolverTypeWrapper<CoreGiftCardCreditRedemptionItem>;
  CoreHoldingsTransferInItem: ResolverTypeWrapper<CoreHoldingsTransferInItem>;
  CoreInvestmentItem: ResolverTypeWrapper<CoreInvestmentItem>;
  CoreLocalFoundMoneyItem: ResolverTypeWrapper<CoreLocalFoundMoneyItem>;
  CorePartnerRewardItem: ResolverTypeWrapper<CorePartnerRewardItem>;
  CoreRebalanceItem: ResolverTypeWrapper<CoreRebalanceItem>;
  CoreReferralRewardItem: ResolverTypeWrapper<CoreReferralRewardItem>;
  CoreRefundedItem: ResolverTypeWrapper<CoreRefundedItem>;
  CoreReinvestmentItem: ResolverTypeWrapper<CoreReinvestmentItem>;
  CoreRoundUpsItem: ResolverTypeWrapper<CoreRoundUpsItem>;
  CoreWithdrawalItem: ResolverTypeWrapper<CoreWithdrawalItem>;
  Course: ResolverTypeWrapper<Omit<Course, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], theme: ResolversTypes['CourseTheme'] }>;
  CourseLocked: ResolverTypeWrapper<Omit<CourseLocked, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], theme: ResolversTypes['CourseTheme'] }>;
  CoursePreview: ResolverTypeWrapper<Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversTypes['CourseTheme'], duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  CoursePreviewLocked: ResolverTypeWrapper<Omit<CoursePreviewLocked, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversTypes['CourseTheme'], duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  CourseTheme: ResolverTypeWrapper<ResolversUnionTypes['CourseTheme']>;
  CreateAuthProfileInput: CreateAuthProfileInput;
  CreateAuthProfileResult: ResolverTypeWrapper<ResolversUnionTypes['CreateAuthProfileResult']>;
  CreateBankAccountInput: CreateBankAccountInput;
  CreateBankAccountPayload: ResolverTypeWrapper<CreateBankAccountPayload>;
  CreateBeneficiaryResult: ResolverTypeWrapper<ResolversUnionTypes['CreateBeneficiaryResult']>;
  CreateCustomSupportTicketInput: CreateCustomSupportTicketInput;
  CreateDelegateResult: ResolverTypeWrapper<ResolversUnionTypes['CreateDelegateResult']>;
  CreateDirectDepositLinkInfoFailure: ResolverTypeWrapper<CreateDirectDepositLinkInfoFailure>;
  CreateDirectDepositLinkInfoInput: CreateDirectDepositLinkInfoInput;
  CreateDirectDepositLinkInfoPayload: ResolverTypeWrapper<CreateDirectDepositLinkInfoPayload>;
  CreateDirectDepositLinkInfoSwitch: ResolverTypeWrapper<ResolversUnionTypes['CreateDirectDepositLinkInfoSwitch']>;
  CreateDocumentUpload: ResolverTypeWrapper<CreateDocumentUpload>;
  CreateDocumentUploadInput: CreateDocumentUploadInput;
  CreateImplicitTokenForUserInput: CreateImplicitTokenForUserInput;
  CreateImplicitTokenForUserResult: ResolverTypeWrapper<ResolversUnionTypes['CreateImplicitTokenForUserResult']>;
  CreateIntentInput: CreateIntentInput;
  CreateIntentResult: ResolverTypeWrapper<ResolversUnionTypes['CreateIntentResult']>;
  CreateInvestingStrategyRecommendationInput: CreateInvestingStrategyRecommendationInput;
  CreateInvestingStrategyRecommendationResult: ResolverTypeWrapper<ResolversUnionTypes['CreateInvestingStrategyRecommendationResult']>;
  CreateInvestmentAccountResponse: ResolverTypeWrapper<CreateInvestmentAccountResponse>;
  CreateJobAlertResult: ResolverTypeWrapper<ResolversUnionTypes['CreateJobAlertResult']>;
  CreateOauthAppInput: CreateOauthAppInput;
  CreateOauthAppResult: ResolverTypeWrapper<ResolversUnionTypes['CreateOauthAppResult']>;
  CreateOfferInput: CreateOfferInput;
  CreateOfferResult: ResolverTypeWrapper<ResolversUnionTypes['CreateOfferResult']>;
  CreateOutsideContributionCheckoutCartInput: CreateOutsideContributionCheckoutCartInput;
  CreateOutsideContributionCheckoutCartResult: ResolverTypeWrapper<ResolversUnionTypes['CreateOutsideContributionCheckoutCartResult']>;
  CreateOutsideContributionInput: CreateOutsideContributionInput;
  CreateOutsideContributionResult: ResolverTypeWrapper<ResolversUnionTypes['CreateOutsideContributionResult']>;
  CreatePinwheelLinkToken: ResolverTypeWrapper<CreatePinwheelLinkToken>;
  CreatePlaidLinkedAccountInput: CreatePlaidLinkedAccountInput;
  CreatePromoCodeInput: CreatePromoCodeInput;
  CreatePromoCodeResult: ResolverTypeWrapper<ResolversUnionTypes['CreatePromoCodeResult']>;
  CreatePromoCodeRewardInput: CreatePromoCodeRewardInput;
  CreatePromoCodeRewardResult: ResolverTypeWrapper<ResolversUnionTypes['CreatePromoCodeRewardResult']>;
  CreateProspectUserInput: CreateProspectUserInput;
  CreateProspectUserResult: ResolverTypeWrapper<ResolversUnionTypes['CreateProspectUserResult']>;
  CreateReferralCampaignInput: CreateReferralCampaignInput;
  CreateReferralCampaignResult: ResolverTypeWrapper<ResolversUnionTypes['CreateReferralCampaignResult']>;
  CreateReferralCampaignRewardInput: CreateReferralCampaignRewardInput;
  CreateReferralCampaignRewardResult: ResolverTypeWrapper<ResolversUnionTypes['CreateReferralCampaignRewardResult']>;
  CreateReferralPayoutInput: CreateReferralPayoutInput;
  CreateReferralPayoutResult: ResolverTypeWrapper<ResolversUnionTypes['CreateReferralPayoutResult']>;
  CreateReferralRelationshipResult: ResolverTypeWrapper<ResolversUnionTypes['CreateReferralRelationshipResult']>;
  CreateRefundError: ResolverTypeWrapper<CreateRefundError>;
  CreateRefundResult: ResolverTypeWrapper<ResolversUnionTypes['CreateRefundResult']>;
  CreateSavingsAccountInput: CreateSavingsAccountInput;
  CreateSavingsAccountPayload: ResolverTypeWrapper<CreateSavingsAccountPayload>;
  CreateSavingsAccountResult: ResolverTypeWrapper<ResolversUnionTypes['CreateSavingsAccountResult']>;
  CreateSavingsAccountVerificationError: ResolverTypeWrapper<CreateSavingsAccountVerificationError>;
  CreateScopeException: ResolverTypeWrapper<CreateScopeException>;
  CreateScopeInput: CreateScopeInput;
  CreateScopeResult: ResolverTypeWrapper<ResolversUnionTypes['CreateScopeResult']>;
  CreateSubscriptionMigrationInput: CreateSubscriptionMigrationInput;
  CreateSubscriptionMigrationResult: ResolverTypeWrapper<ResolversUnionTypes['CreateSubscriptionMigrationResult']>;
  CreateSupportTicketInput: CreateSupportTicketInput;
  CreateSuspendedUserSupportTicketInput: CreateSuspendedUserSupportTicketInput;
  CreateUploadUrlInput: CreateUploadUrlInput;
  CreateUploadUrlResult: ResolverTypeWrapper<ResolversUnionTypes['CreateUploadUrlResult']>;
  CreateUserInput: CreateUserInput;
  CreateUserProfileInput: CreateUserProfileInput;
  CreateUserProfileResult: ResolverTypeWrapper<ResolversUnionTypes['CreateUserProfileResult']>;
  CreateVendorInvoiceInput: CreateVendorInvoiceInput;
  CreateVendorInvoiceResult: ResolverTypeWrapper<ResolversUnionTypes['CreateVendorInvoiceResult']>;
  CreateVendorLineItemInput: CreateVendorLineItemInput;
  CreateVendorLineItemResult: ResolverTypeWrapper<ResolversUnionTypes['CreateVendorLineItemResult']>;
  CredentialStatus: CredentialStatus;
  Credentials: ResolverTypeWrapper<Credentials>;
  CredentialsType: CredentialsType;
  Credit: ResolverTypeWrapper<Credit>;
  CreditReasonCode: CreditReasonCode;
  Cta: ResolverTypeWrapper<Cta>;
  CtaType: CtaType;
  Currency: Currency;
  CurrencyAmount: ResolverTypeWrapper<CurrencyAmount>;
  CurrencyAmountInput: CurrencyAmountInput;
  CurrencyMilestoneProgress: ResolverTypeWrapper<CurrencyMilestoneProgress>;
  CurrentBankStatementNotProvided: ResolverTypeWrapper<CurrentBankStatementNotProvided>;
  CustomFieldInput: CustomFieldInput;
  CustomFieldOption: ResolverTypeWrapper<CustomFieldOption>;
  CustomerAccount: ResolverTypeWrapper<CustomerAccount>;
  CustomerAccountClosure: ResolverTypeWrapper<CustomerAccountClosure>;
  CustomerAccountClosureState: CustomerAccountClosureState;
  CustomerAccountStatus: CustomerAccountStatus;
  CustomerAgreementRequiredException: ResolverTypeWrapper<CustomerAgreementRequiredException>;
  CustomerEarnOnboardingMilestone: ResolverTypeWrapper<CustomerEarnOnboardingMilestone>;
  CustomerEarnOnboardingProgram: ResolverTypeWrapper<ResolversUnionTypes['CustomerEarnOnboardingProgram']>;
  CustomerEarnOnboardingProgramControl: ResolverTypeWrapper<CustomerEarnOnboardingProgramControl>;
  CustomerEarnOnboardingProgramFeature: ResolverTypeWrapper<CustomerEarnOnboardingProgramFeature>;
  CustomerEarnOnboardingStatus: CustomerEarnOnboardingStatus;
  CustomerMoneyRulesResult: ResolverTypeWrapper<ResolversUnionTypes['CustomerMoneyRulesResult']>;
  CustomerMoneyRulesResultSuccess: ResolverTypeWrapper<CustomerMoneyRulesResultSuccess>;
  CustomerSupportChatWidget: ResolverTypeWrapper<CustomerSupportChatWidget>;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  DayOfWeek: DayOfWeek;
  DeactivateBeneficiaryResult: ResolverTypeWrapper<ResolversUnionTypes['DeactivateBeneficiaryResult']>;
  DeactivateOauthAppClientResult: ResolverTypeWrapper<ResolversUnionTypes['DeactivateOauthAppClientResult']>;
  DeactivateOauthAppResult: ResolverTypeWrapper<ResolversUnionTypes['DeactivateOauthAppResult']>;
  DeactivateTierSubscriptionInput: DeactivateTierSubscriptionInput;
  DeactivateTierSubscriptionResult: ResolverTypeWrapper<ResolversUnionTypes['DeactivateTierSubscriptionResult']>;
  DealType: DealType;
  DeeplinkWidget: ResolverTypeWrapper<DeeplinkWidget>;
  DelegateDefinition: ResolverTypeWrapper<DelegateDefinition>;
  DelegateDefinitionInput: DelegateDefinitionInput;
  DelegateFilterInput: DelegateFilterInput;
  DeleteDelegateResult: ResolverTypeWrapper<ResolversUnionTypes['DeleteDelegateResult']>;
  DeleteDelegateResultTemporaryImpl: ResolverTypeWrapper<DeleteDelegateResultTemporaryImpl>;
  DeleteExpiredBankCardOrderCardTierNotFoundError: ResolverTypeWrapper<DeleteExpiredBankCardOrderCardTierNotFoundError>;
  DeleteExpiredBankCardOrderNotExpiredError: ResolverTypeWrapper<DeleteExpiredBankCardOrderNotExpiredError>;
  DeleteExpiredBankCardOrderNotFoundError: ResolverTypeWrapper<DeleteExpiredBankCardOrderNotFoundError>;
  DeleteExpiredBankCardOrderResult: ResolverTypeWrapper<ResolversUnionTypes['DeleteExpiredBankCardOrderResult']>;
  DeleteOauthAppResult: ResolverTypeWrapper<ResolversUnionTypes['DeleteOauthAppResult']>;
  DeleteOauthAppSuccess: ResolverTypeWrapper<DeleteOauthAppSuccess>;
  DeleteScopeSuccess: ResolverTypeWrapper<DeleteScopeSuccess>;
  DeleteTrustedContactResult: ResolverTypeWrapper<ResolversUnionTypes['DeleteTrustedContactResult']>;
  DepositField: DepositField;
  DepositRiskFactor: ResolverTypeWrapper<DepositRiskFactor>;
  DeregisterAuthenticatorInput: DeregisterAuthenticatorInput;
  DeregisterAuthenticatorResult: ResolverTypeWrapper<ResolversUnionTypes['DeregisterAuthenticatorResult']>;
  DesignLibraryIcon: ResolverTypeWrapper<DesignLibraryIcon>;
  Destination: ResolverTypeWrapper<Destination>;
  Device: ResolverTypeWrapper<Device>;
  DeviceBlockedException: ResolverTypeWrapper<DeviceBlockedException>;
  DeviceNotFoundException: ResolverTypeWrapper<DeviceNotFoundException>;
  DeviceType: DeviceType;
  DigitalWalletDevice: ResolverTypeWrapper<DigitalWalletDevice>;
  DigitalWalletDeviceType: DigitalWalletDeviceType;
  DigitalWalletToken: ResolverTypeWrapper<DigitalWalletToken>;
  DirectDepositDistribution: DirectDepositDistribution;
  DirectDepositInfo: ResolverTypeWrapper<DirectDepositInfo>;
  DirectDepositInfoPayload: ResolverTypeWrapper<DirectDepositInfoPayload>;
  DirectDepositState: ResolverTypeWrapper<DirectDepositState>;
  DirectDepositStatePayload: ResolverTypeWrapper<DirectDepositStatePayload>;
  DirectDepositStatus: DirectDepositStatus;
  DirectDepositVendor: DirectDepositVendor;
  DiscreteMilestoneProgress: ResolverTypeWrapper<DiscreteMilestoneProgress>;
  DismissMessageInput: DismissMessageInput;
  DismissMessagesInput: DismissMessagesInput;
  DismissMessagesResult: ResolverTypeWrapper<ResolversUnionTypes['DismissMessagesResult']>;
  DismissMessagesSuccess: ResolverTypeWrapper<DismissMessagesSuccess>;
  DistributionAmounts: ResolverTypeWrapper<DistributionAmounts>;
  DistributionType: DistributionType;
  DiversificationBucket: ResolverTypeWrapper<DiversificationBucket>;
  DiversificationBucketType: DiversificationBucketType;
  DiversificationInfo: ResolverTypeWrapper<DiversificationInfo>;
  DiversificationInfoByInvestmentAccountIdInput: DiversificationInfoByInvestmentAccountIdInput;
  Document: ResolverTypeWrapper<Document>;
  DocumentInput: DocumentInput;
  DocumentNotFound: ResolverTypeWrapper<DocumentNotFound>;
  DocumentQueryType: DocumentQueryType;
  DocumentRequest: ResolverTypeWrapper<DocumentRequest>;
  DocumentRequestEdge: ResolverTypeWrapper<DocumentRequestEdge>;
  DocumentRequestInput: DocumentRequestInput;
  DocumentRequestsConnection: ResolverTypeWrapper<DocumentRequestsConnection>;
  DocumentRequestsInput: DocumentRequestsInput;
  DocumentRequestsPageInfo: ResolverTypeWrapper<DocumentRequestsPageInfo>;
  DocumentRequestsPageInput: DocumentRequestsPageInput;
  DocumentStatus: DocumentStatus;
  DocumentType: DocumentType;
  DocumentUploadSession: ResolverTypeWrapper<DocumentUploadSession>;
  DocumentUploads: ResolverTypeWrapper<DocumentUploads>;
  DocumentVerification: ResolverTypeWrapper<DocumentVerification>;
  DocumentVerificationDecision: DocumentVerificationDecision;
  DuplicateActionError: ResolverTypeWrapper<DuplicateActionError>;
  DuplicateBillingInfoError: ResolverTypeWrapper<DuplicateBillingInfoError>;
  DuplicatePromoCodeError: ResolverTypeWrapper<DuplicatePromoCodeError>;
  DuplicatePromoCodeRewardError: ResolverTypeWrapper<DuplicatePromoCodeRewardError>;
  ETF: ResolverTypeWrapper<Etf>;
  ETFGain: ResolverTypeWrapper<EtfGain>;
  ETFPerformance: ResolverTypeWrapper<EtfPerformance>;
  ETFPrice: ResolverTypeWrapper<EtfPrice>;
  ETFTimescale: EtfTimescale;
  EarlyAccountStateRegulation: ResolverTypeWrapper<EarlyAccountStateRegulation>;
  EarlyAccountStateRegulationResult: ResolverTypeWrapper<ResolversUnionTypes['EarlyAccountStateRegulationResult']>;
  EarlyAccountTransferInfo: ResolverTypeWrapper<EarlyAccountTransferInfo>;
  EarlyDebtCollectionItem: ResolverTypeWrapper<EarlyDebtCollectionItem>;
  EarlyDividendsItem: ResolverTypeWrapper<EarlyDividendsItem>;
  EarlyFeeInvestmentItem: ResolverTypeWrapper<EarlyFeeInvestmentItem>;
  EarlyGiftItem: ResolverTypeWrapper<EarlyGiftItem>;
  EarlyHistorySummary: ResolverTypeWrapper<EarlyHistorySummary>;
  EarlyInvestmentAccountType: EarlyInvestmentAccountType;
  EarlyInvestmentItem: ResolverTypeWrapper<EarlyInvestmentItem>;
  EarlyMatchItem: ResolverTypeWrapper<EarlyMatchItem>;
  EarlyMatchRemovalItem: ResolverTypeWrapper<EarlyMatchRemovalItem>;
  EarlyRefundedItem: ResolverTypeWrapper<EarlyRefundedItem>;
  EarlyReinvestmentItem: ResolverTypeWrapper<EarlyReinvestmentItem>;
  EarlyWithdrawalItem: ResolverTypeWrapper<EarlyWithdrawalItem>;
  EarnCTARecord: ResolverTypeWrapper<EarnCtaRecord>;
  EarnMissingCreditRequest: ResolverTypeWrapper<EarnMissingCreditRequest>;
  EarnMissingCreditRequestPurchaseDateError: ResolverTypeWrapper<EarnMissingCreditRequestPurchaseDateError>;
  EarnOffer: ResolverTypeWrapper<EarnOffer>;
  EarnOfferCtaDetails: ResolverTypeWrapper<EarnOfferCtaDetails>;
  EarnOfferIncentiveRate: EarnOfferIncentiveRate;
  EarnOfferIncentiveTemplate: EarnOfferIncentiveTemplate;
  EarnOfferIncentiveType: EarnOfferIncentiveType;
  EarnOfferQueryPage: ResolverTypeWrapper<EarnOfferQueryPage>;
  EarnOnboardingMilestoneCta: ResolverTypeWrapper<EarnOnboardingMilestoneCta>;
  EarnOnboardingMilestoneCtaType: EarnOnboardingMilestoneCtaType;
  EarnPageInfo: ResolverTypeWrapper<EarnPageInfo>;
  EarnPurchaseMethod: EarnPurchaseMethod;
  EarnReward: ResolverTypeWrapper<EarnReward>;
  EarnRewardFulfillmentType: EarnRewardFulfillmentType;
  EarnRewardInvestType: EarnRewardInvestType;
  EarnRewardStatus: EarnRewardStatus;
  EarnRewardType: EarnRewardType;
  Ecbsv: ResolverTypeWrapper<Ecbsv>;
  EducationTip: ResolverTypeWrapper<EducationTip>;
  Eligibility: ResolverTypeWrapper<Eligibility>;
  EligibilityScope: EligibilityScope;
  Email: ResolverTypeWrapper<Scalars['Email']>;
  EmailAddress: ResolverTypeWrapper<Scalars['EmailAddress']>;
  EmailAddressValidation: ResolverTypeWrapper<EmailAddressValidation>;
  EmailAuthChallenge: ResolverTypeWrapper<EmailAuthChallenge>;
  EmailAuthenticator: ResolverTypeWrapper<EmailAuthenticator>;
  EmailRedirect: ResolverTypeWrapper<EmailRedirect>;
  EmailTakenException: ResolverTypeWrapper<EmailTakenException>;
  EmergencyFundHistorySummary: ResolverTypeWrapper<EmergencyFundHistorySummary>;
  Employees: Employees;
  Employer: ResolverTypeWrapper<Omit<Employer, 'switch'> & { switch: ResolversTypes['AbstractSwitch'] }>;
  EmploymentInput: EmploymentInput;
  EmploymentStatus: EmploymentStatus;
  EnableQuarterlyRecapsInput: EnableQuarterlyRecapsInput;
  EnableQuarterlyRecapsResult: ResolverTypeWrapper<ResolversUnionTypes['EnableQuarterlyRecapsResult']>;
  EstimatedCheckPaymentDates: ResolverTypeWrapper<EstimatedCheckPaymentDates>;
  EstimatedTransferDatesInput: EstimatedTransferDatesInput;
  EstimatedTransferDatesPayload: ResolverTypeWrapper<EstimatedTransferDatesPayload>;
  EvaluateCheckDepositInput: EvaluateCheckDepositInput;
  EvaluateCheckDepositPayload: ResolverTypeWrapper<EvaluateCheckDepositPayload>;
  ExchangeAcornsEarlyTokenResult: ResolverTypeWrapper<ResolversUnionTypes['ExchangeAcornsEarlyTokenResult']>;
  ExecuteMoneyInError: ResolverTypeWrapper<ExecuteMoneyInError>;
  ExecuteMoneyInInput: ExecuteMoneyInInput;
  ExecuteMoneyInResult: ResolverTypeWrapper<ResolversUnionTypes['ExecuteMoneyInResult']>;
  ExecuteMoneyInSuccess: ResolverTypeWrapper<ExecuteMoneyInSuccess>;
  ExecuteMoneyManagerRebalancesInput: ExecuteMoneyManagerRebalancesInput;
  ExecuteMoneyManagerRebalancesResult: ResolverTypeWrapper<ResolversUnionTypes['ExecuteMoneyManagerRebalancesResult']>;
  ExecuteMoneyManagerRebalancesSuccess: ResolverTypeWrapper<ExecuteMoneyManagerRebalancesSuccess>;
  ExecutionAudit: ResolverTypeWrapper<ExecutionAudit>;
  ExistingEmailVerifiedException: ResolverTypeWrapper<ExistingEmailVerifiedException>;
  ExistingRequestPendingReview: ResolverTypeWrapper<ExistingRequestPendingReview>;
  ExistingRequestPendingUserAction: ResolverTypeWrapper<ExistingRequestPendingUserAction>;
  ExperienceContent: ResolverTypeWrapper<ExperienceContent>;
  ExpirePromotionalWaiverInput: ExpirePromotionalWaiverInput;
  ExpirePromotionalWaiverResult: ResolverTypeWrapper<ResolversUnionTypes['ExpirePromotionalWaiverResult']>;
  ExternalMetadata: ResolverTypeWrapper<ExternalMetadata>;
  ExternalSource: ExternalSource;
  ExternalSubscriptionType: ExternalSubscriptionType;
  ExternalUserSource: ExternalUserSource;
  ExtoleCampaignHistoryConnection: ResolverTypeWrapper<ExtoleCampaignHistoryConnection>;
  ExtoleCampaignHistoryEdge: ResolverTypeWrapper<ExtoleCampaignHistoryEdge>;
  ExtoleReferralCampaign: ResolverTypeWrapper<ExtoleReferralCampaign>;
  ExtoleReferralHistory: ResolverTypeWrapper<ExtoleReferralHistory>;
  FailVendorInvoiceResult: ResolverTypeWrapper<ResolversUnionTypes['FailVendorInvoiceResult']>;
  FavoritePartnerOfferGroup: ResolverTypeWrapper<Omit<FavoritePartnerOfferGroup, 'offers'> & { offers: Array<ResolversTypes['PartnerOfferGroupItem']> }>;
  FavoritePartnerOfferInput: FavoritePartnerOfferInput;
  FeaturedLearnContentPreview: ResolverTypeWrapper<ResolversUnionTypes['FeaturedLearnContentPreview']>;
  FeaturedMilestones: ResolverTypeWrapper<FeaturedMilestones>;
  FeaturedMilestonesV2: ResolverTypeWrapper<ResolversUnionTypes['FeaturedMilestonesV2']>;
  Fee: ResolverTypeWrapper<Fee>;
  FeeExecution: ResolverTypeWrapper<FeeExecution>;
  FeeExecutionMethod: FeeExecutionMethod;
  FeeNegotiation: ResolverTypeWrapper<FeeNegotiation>;
  FeeNegotiationSummary: ResolverTypeWrapper<FeeNegotiationSummary>;
  FeeStatus: FeeStatus;
  FeeStatusFilter: FeeStatusFilter;
  FeeStatusSummary: ResolverTypeWrapper<FeeStatusSummary>;
  FeeType: FeeType;
  FeedContext: FeedContext;
  File: ResolverTypeWrapper<File>;
  FileDoesNotExistError: ResolverTypeWrapper<FileDoesNotExistError>;
  FileDoesNotExistInS3: ResolverTypeWrapper<FileDoesNotExistInS3>;
  FileOrException: ResolverTypeWrapper<ResolversUnionTypes['FileOrException']>;
  FileSizeError: ResolverTypeWrapper<FileSizeError>;
  FileTooLarge: ResolverTypeWrapper<FileTooLarge>;
  FilingType: FilingType;
  FinancialAdvisorQuestionResponse: ResolverTypeWrapper<FinancialAdvisorQuestionResponse>;
  FinancialAdvisorQuestionsResponse: ResolverTypeWrapper<FinancialAdvisorQuestionsResponse>;
  FinancialEducation: FinancialEducation;
  FinancialGoalsInput: FinancialGoalsInput;
  FinancialGoalsResult: ResolverTypeWrapper<FinancialGoalsResult>;
  FinancialInstitution: ResolverTypeWrapper<FinancialInstitution>;
  FinancialInstitutionTypeEdge: ResolverTypeWrapper<FinancialInstitutionTypeEdge>;
  FinancialInstitutionTypePagination: ResolverTypeWrapper<FinancialInstitutionTypePagination>;
  FinishSetup: ResolverTypeWrapper<FinishSetup>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FooterContent: ResolverTypeWrapper<FooterContent>;
  FormType: FormType;
  FormattedMonetaryAmount: ResolverTypeWrapper<FormattedMonetaryAmount>;
  FoundMoneyCampaignOfferV2: ResolverTypeWrapper<FoundMoneyCampaignOfferV2>;
  FoundMoneyCampaignV2: ResolverTypeWrapper<FoundMoneyCampaignV2>;
  FoundMoneyReward: ResolverTypeWrapper<FoundMoneyReward>;
  FoundMoneySummary: ResolverTypeWrapper<FoundMoneySummary>;
  Friend: ResolverTypeWrapper<Friend>;
  FriendExperienceContent: ResolverTypeWrapper<FriendExperienceContent>;
  FriendHistory: ResolverTypeWrapper<FriendHistory>;
  FriendHistoryConnection: ResolverTypeWrapper<FriendHistoryConnection>;
  FriendHistoryEdge: ResolverTypeWrapper<FriendHistoryEdge>;
  FriendStatus: FriendStatus;
  FriendStatusV2: FriendStatusV2;
  FriendSummary: ResolverTypeWrapper<FriendSummary>;
  FriendV2Output: ResolverTypeWrapper<FriendV2Output>;
  Fund: ResolverTypeWrapper<Fund>;
  FundSpendInActivationPayload: ResolverTypeWrapper<FundSpendInActivationPayload>;
  FundingSource: ResolverTypeWrapper<FundingSource>;
  FundingSourceAccount: ResolverTypeWrapper<FundingSourceAccount>;
  FundingSourceAlreadyExists: ResolverTypeWrapper<FundingSourceAlreadyExists>;
  FundingSourceCredentialsExceedLinkLimit: ResolverTypeWrapper<FundingSourceCredentialsExceedLinkLimit>;
  FundingSourceInfo: ResolverTypeWrapper<FundingSourceInfo>;
  FundingSourceRequiresRdvException: ResolverTypeWrapper<FundingSourceRequiresRdvException>;
  FundingSourceRoleEnum: FundingSourceRoleEnum;
  FundingSourceStatus: FundingSourceStatus;
  FundingSourceStatusEnum: FundingSourceStatusEnum;
  FundingSourceType: FundingSourceType;
  FundsAvailability: FundsAvailability;
  Funnel: Funnel;
  FunnelMetadata: ResolverTypeWrapper<FunnelMetadata>;
  FunnelName: FunnelName;
  GenerateDocumentUploadSessionInput: GenerateDocumentUploadSessionInput;
  GenerateDocumentUploadSessionResult: ResolverTypeWrapper<ResolversUnionTypes['GenerateDocumentUploadSessionResult']>;
  GenerateLayerLinkSessionInput: GenerateLayerLinkSessionInput;
  GenerateLayerLinkSessionResult: ResolverTypeWrapper<ResolversUnionTypes['GenerateLayerLinkSessionResult']>;
  GenerateLinkSessionInput: GenerateLinkSessionInput;
  GenerateReferralCodeResult: ResolverTypeWrapper<ResolversUnionTypes['GenerateReferralCodeResult']>;
  GenerateUpdatedPdfPayload: ResolverTypeWrapper<GenerateUpdatedPdfPayload>;
  GetUsersBankFromAccountTypePayload: ResolverTypeWrapper<GetUsersBankFromAccountTypePayload>;
  GrowProspect: ResolverTypeWrapper<GrowProspect>;
  HelpFormContent: ResolverTypeWrapper<HelpFormContent>;
  HelpFormType: HelpFormType;
  HelpcenterBannerContent: ResolverTypeWrapper<HelpcenterBannerContent>;
  HelpcenterBannerErrors: ResolverTypeWrapper<HelpcenterBannerErrors>;
  HelpcenterBannerType: HelpcenterBannerType;
  HelpcenterContentInput: HelpcenterContentInput;
  HideMessageByExternalIdInput: HideMessageByExternalIdInput;
  HideMessageInput: HideMessageInput;
  Holding: ResolverTypeWrapper<Holding>;
  HoldingsTransfer: ResolverTypeWrapper<HoldingsTransfer>;
  HoldingsTransferType: HoldingsTransferType;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IRADistribution: ResolverTypeWrapper<IraDistribution>;
  IconType: IconType;
  IdentityDocumentRequestedUserAlert: ResolverTypeWrapper<IdentityDocumentRequestedUserAlert>;
  IdentitySubaccount: IdentitySubaccount;
  IdentityVerification: ResolversTypes['BankCardOrderIdentityVerification'] | ResolversTypes['BankingKycIdentityVerification'];
  Image: ResolverTypeWrapper<Image>;
  ImageType: ImageType;
  ImplicitToken: ResolverTypeWrapper<ImplicitToken>;
  Incentive: ResolversTypes['MonetaryIncentive'];
  IncorrectOldPasswordException: ResolverTypeWrapper<IncorrectOldPasswordException>;
  IncorrectRdvAmounts: ResolverTypeWrapper<IncorrectRdvAmounts>;
  IncorrectSecurityAnswerException: ResolverTypeWrapper<IncorrectSecurityAnswerException>;
  IncorrectSsnException: ResolverTypeWrapper<IncorrectSsnException>;
  IneligibleReasons: IneligibleReasons;
  InitiateBankAccountInput: InitiateBankAccountInput;
  InitiateBankAccountResponse: ResolverTypeWrapper<InitiateBankAccountResponse>;
  InitiateBankingKYCInput: InitiateBankingKycInput;
  InitiateBankingKYCPayload: ResolverTypeWrapper<InitiateBankingKycPayload>;
  InitiateChallengeInput: InitiateChallengeInput;
  InitiateChallengeResult: ResolverTypeWrapper<ResolversUnionTypes['InitiateChallengeResult']>;
  InitiateEmailChallengeInput: InitiateEmailChallengeInput;
  InitiateEmailChallengeResult: ResolverTypeWrapper<ResolversUnionTypes['InitiateEmailChallengeResult']>;
  InitiateMoneyAssignmentInput: InitiateMoneyAssignmentInput;
  InitiateMoneyAssignmentResult: ResolverTypeWrapper<ResolversUnionTypes['InitiateMoneyAssignmentResult']>;
  InitiateMoneyAssignmentSuccess: ResolverTypeWrapper<InitiateMoneyAssignmentSuccess>;
  InitiatePushChallengeResult: ResolverTypeWrapper<ResolversUnionTypes['InitiatePushChallengeResult']>;
  InitiatePushChallengeSuccess: ResolverTypeWrapper<InitiatePushChallengeSuccess>;
  InitiateSMSChallengeInput: InitiateSmsChallengeInput;
  InitiateSMSChallengeResult: ResolverTypeWrapper<ResolversUnionTypes['InitiateSMSChallengeResult']>;
  InitiateTransferInput: InitiateTransferInput;
  InitiateTransferPayload: ResolverTypeWrapper<InitiateTransferPayload>;
  InitiateVerificationResult: ResolverTypeWrapper<ResolversUnionTypes['InitiateVerificationResult']>;
  InstitutionNotSupportedError: ResolverTypeWrapper<InstitutionNotSupportedError>;
  InsufficientFundsUserAlert: ResolverTypeWrapper<InsufficientFundsUserAlert>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Intent: ResolverTypeWrapper<Intent>;
  IntentFilterInput: IntentFilterInput;
  IntentStatus: IntentStatus;
  InteractionRatingResponse: ResolverTypeWrapper<InteractionRatingResponse>;
  InternalErrorException: ResolverTypeWrapper<InternalErrorException>;
  InvalidAccountNumber: ResolverTypeWrapper<InvalidAccountNumber>;
  InvalidAccountTypeException: ResolverTypeWrapper<InvalidAccountTypeException>;
  InvalidAcornsEarlyTokenException: ResolverTypeWrapper<InvalidAcornsEarlyTokenException>;
  InvalidActionOnAccount: ResolverTypeWrapper<InvalidActionOnAccount>;
  InvalidAddressError: ResolverTypeWrapper<InvalidAddressError>;
  InvalidAddressException: ResolverTypeWrapper<InvalidAddressException>;
  InvalidAllocationPercentError: ResolverTypeWrapper<InvalidAllocationPercentError>;
  InvalidAppleAccountException: ResolverTypeWrapper<InvalidAppleAccountException>;
  InvalidContentTypeException: ResolverTypeWrapper<InvalidContentTypeException>;
  InvalidConversionIdentifierException: ResolverTypeWrapper<InvalidConversionIdentifierException>;
  InvalidCredentialsException: ResolverTypeWrapper<InvalidCredentialsException>;
  InvalidDateException: ResolverTypeWrapper<InvalidDateException>;
  InvalidDateOfBirthException: ResolverTypeWrapper<InvalidDateOfBirthException>;
  InvalidDeviceParametersException: ResolverTypeWrapper<InvalidDeviceParametersException>;
  InvalidEmailException: ResolverTypeWrapper<InvalidEmailException>;
  InvalidFile: ResolverTypeWrapper<InvalidFile>;
  InvalidFirstNameException: ResolverTypeWrapper<InvalidFirstNameException>;
  InvalidGoogleAccountException: ResolverTypeWrapper<InvalidGoogleAccountException>;
  InvalidIdentityTokenException: ResolverTypeWrapper<InvalidIdentityTokenException>;
  InvalidInvestmentAccountException: ResolverTypeWrapper<InvalidInvestmentAccountException>;
  InvalidLastNameException: ResolverTypeWrapper<InvalidLastNameException>;
  InvalidManualLink: ResolverTypeWrapper<InvalidManualLink>;
  InvalidMfaTokenException: ResolverTypeWrapper<InvalidMfaTokenException>;
  InvalidOauthAppClientIdException: ResolverTypeWrapper<InvalidOauthAppClientIdException>;
  InvalidOptionException: ResolverTypeWrapper<InvalidOptionException>;
  InvalidPasswordException: ResolverTypeWrapper<InvalidPasswordException>;
  InvalidPasswordResetException: ResolverTypeWrapper<InvalidPasswordResetException>;
  InvalidPasswordResetTokenException: ResolverTypeWrapper<InvalidPasswordResetTokenException>;
  InvalidPhoneException: ResolverTypeWrapper<InvalidPhoneException>;
  InvalidPhoneNumberException: ResolverTypeWrapper<InvalidPhoneNumberException>;
  InvalidPinException: ResolverTypeWrapper<InvalidPinException>;
  InvalidPortfolioIdException: ResolverTypeWrapper<InvalidPortfolioIdException>;
  InvalidPromoCodeError: ResolverTypeWrapper<InvalidPromoCodeError>;
  InvalidReferralRelationship: ResolverTypeWrapper<InvalidReferralRelationship>;
  InvalidRoutingNumber: ResolverTypeWrapper<InvalidRoutingNumber>;
  InvalidSecurityError: ResolverTypeWrapper<InvalidSecurityError>;
  InvalidSecurityForAllocationError: ResolverTypeWrapper<InvalidSecurityForAllocationError>;
  InvalidSecurityForAllocationReasonEnum: InvalidSecurityForAllocationReasonEnum;
  InvalidSingleRuleIdError: ResolverTypeWrapper<InvalidSingleRuleIdError>;
  InvalidSourceAttributesException: ResolverTypeWrapper<InvalidSourceAttributesException>;
  InvalidSsnException: ResolverTypeWrapper<InvalidSsnException>;
  InvalidStateException: ResolverTypeWrapper<InvalidStateException>;
  InvalidSubscriptionTierException: ResolverTypeWrapper<InvalidSubscriptionTierException>;
  InvalidTerminationAgeException: ResolverTypeWrapper<InvalidTerminationAgeException>;
  InvalidTier: ResolverTypeWrapper<InvalidTier>;
  InvalidTierForMigrationError: ResolverTypeWrapper<InvalidTierForMigrationError>;
  InvalidTierPrice: ResolverTypeWrapper<InvalidTierPrice>;
  InvalidTierPriceCombination: ResolverTypeWrapper<InvalidTierPriceCombination>;
  InvalidTierPriceId: ResolverTypeWrapper<InvalidTierPriceId>;
  InvalidUserIdException: ResolverTypeWrapper<InvalidUserIdException>;
  InvalidUserTokenException: ResolverTypeWrapper<InvalidUserTokenException>;
  InvestHistorySummary: ResolverTypeWrapper<InvestHistorySummary>;
  InvestingStrategyFactorKey: InvestingStrategyFactorKey;
  InvestingStrategyFactors: InvestingStrategyFactors;
  Investment: ResolverTypeWrapper<Investment>;
  InvestmentAccount: ResolverTypeWrapper<InvestmentAccount>;
  InvestmentAccountAlreadyClosed: ResolverTypeWrapper<InvestmentAccountAlreadyClosed>;
  InvestmentAccountClosureInProgress: ResolverTypeWrapper<InvestmentAccountClosureInProgress>;
  InvestmentAccountClosureReason: InvestmentAccountClosureReason;
  InvestmentAccountClosureRequest: ResolverTypeWrapper<InvestmentAccountClosureRequest>;
  InvestmentAccountCreationException: ResolverTypeWrapper<InvestmentAccountCreationException>;
  InvestmentAccountNeedsTransferException: ResolverTypeWrapper<InvestmentAccountNeedsTransferException>;
  InvestmentAccountNotClosedException: ResolverTypeWrapper<InvestmentAccountNotClosedException>;
  InvestmentAccountNotFoundException: ResolverTypeWrapper<InvestmentAccountNotFoundException>;
  InvestmentAccountNotSupportedException: ResolverTypeWrapper<InvestmentAccountNotSupportedException>;
  InvestmentAccountOutsideContribution: ResolverTypeWrapper<InvestmentAccountOutsideContribution>;
  InvestmentAccountRecap: ResolverTypeWrapper<InvestmentAccountRecap>;
  InvestmentAccountRecapNotFoundException: ResolverTypeWrapper<InvestmentAccountRecapNotFoundException>;
  InvestmentAccountReopenCheck: InvestmentAccountReopenCheck;
  InvestmentAccountReopenRequest: ResolverTypeWrapper<InvestmentAccountReopenRequest>;
  InvestmentAccountReopenRequestAction: ResolverTypeWrapper<InvestmentAccountReopenRequestAction>;
  InvestmentAccountReopenRequestNote: ResolverTypeWrapper<InvestmentAccountReopenRequestNote>;
  InvestmentAccountReopenRequestState: InvestmentAccountReopenRequestState;
  InvestmentAccountStatus: InvestmentAccountStatus;
  InvestmentAccountSummary: ResolverTypeWrapper<InvestmentAccountSummary>;
  InvestmentAccountTransferability: ResolverTypeWrapper<InvestmentAccountTransferability>;
  InvestmentAccountType: InvestmentAccountType;
  InvestmentAccountTypes: InvestmentAccountTypes;
  InvestmentAccountsByUserIdFilter: InvestmentAccountsByUserIdFilter;
  InvestmentAggregation: ResolverTypeWrapper<InvestmentAggregation>;
  InvestmentAllocation: ResolverTypeWrapper<InvestmentAllocation>;
  InvestmentAllocationStatus: InvestmentAllocationStatus;
  InvestmentAllocationType: InvestmentAllocationType;
  InvestmentCategory: ResolverTypeWrapper<InvestmentCategory>;
  InvestmentEdge: ResolverTypeWrapper<InvestmentEdge>;
  InvestmentFrequency: InvestmentFrequency;
  InvestmentGoal: InvestmentGoal;
  InvestmentNotFoundException: ResolverTypeWrapper<InvestmentNotFoundException>;
  InvestmentPagination: ResolverTypeWrapper<InvestmentPagination>;
  InvestmentProduct: InvestmentProduct;
  InvestmentRoundUpType: InvestmentRoundUpType;
  InvestmentStatus: InvestmentStatus;
  InvestmentStatusV2: InvestmentStatusV2;
  InvestmentTransactionType: InvestmentTransactionType;
  InvestmentType: InvestmentType;
  InvestmentTypes: InvestmentTypes;
  InvestmentUncancellableException: ResolverTypeWrapper<InvestmentUncancellableException>;
  InvestmentsPausedUserAlert: ResolverTypeWrapper<InvestmentsPausedUserAlert>;
  InvestorQuestionsInput: InvestorQuestionsInput;
  Invitation: ResolverTypeWrapper<Invitation>;
  Invoice: ResolverTypeWrapper<Invoice>;
  InvoiceCollection: ResolverTypeWrapper<InvoiceCollection>;
  InvoiceItem: ResolverTypeWrapper<InvoiceItem>;
  InvoiceLineItem: ResolverTypeWrapper<InvoiceLineItem>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  JobAlert: ResolverTypeWrapper<JobAlert>;
  JobAlertCriteriaInput: JobAlertCriteriaInput;
  JobLocation: ResolverTypeWrapper<JobLocation>;
  JobLocationInput: JobLocationInput;
  JobOffer: ResolverTypeWrapper<JobOffer>;
  JobOfferSalary: ResolverTypeWrapper<JobOfferSalary>;
  JobSearchCriteria: ResolverTypeWrapper<JobSearchCriteria>;
  JobSearchCriteriaInput: JobSearchCriteriaInput;
  JobSearchFilter: ResolverTypeWrapper<JobSearchFilter>;
  JobSearchFilterInput: JobSearchFilterInput;
  JobSearchFilterKey: JobSearchFilterKey;
  JobSearchOffer: ResolverTypeWrapper<JobSearchOffer>;
  JobSearchPage: ResolverTypeWrapper<JobSearchPage>;
  KycStatus: KycStatus;
  LadderLinkResponse: ResolverTypeWrapper<LadderLinkResponse>;
  LadderQuote: ResolverTypeWrapper<LadderQuote>;
  LadderQuoteStatus: ResolverTypeWrapper<LadderQuoteStatus>;
  LadderResponse: ResolverTypeWrapper<LadderResponse>;
  LaterAccount: ResolverTypeWrapper<LaterAccount>;
  LaterAccountAlreadyVerified: ResolverTypeWrapper<LaterAccountAlreadyVerified>;
  LaterAccountCodes: LaterAccountCodes;
  LaterAccountIneligibleForVerification: ResolverTypeWrapper<LaterAccountIneligibleForVerification>;
  LaterAccountInfo: ResolverTypeWrapper<LaterAccountInfo>;
  LaterAccountInfoOrError: ResolverTypeWrapper<ResolversUnionTypes['LaterAccountInfoOrError']>;
  LaterAccountNotFound: ResolverTypeWrapper<LaterAccountNotFound>;
  LaterAccountRequiresTaxWithholdings: ResolverTypeWrapper<LaterAccountRequiresTaxWithholdings>;
  LaterAccountRequiresWithdrawalReason: ResolverTypeWrapper<LaterAccountRequiresWithdrawalReason>;
  LaterAccountStatus: LaterAccountStatus;
  LaterAccountTaxWithholdingsPercentageExceeded: ResolverTypeWrapper<LaterAccountTaxWithholdingsPercentageExceeded>;
  LaterBeneficiary: ResolversTypes['LaterIndividualBeneficiary'];
  LaterContributionAbilityResult: ResolverTypeWrapper<ResolversUnionTypes['LaterContributionAbilityResult']>;
  LaterContributionLimitMet: ResolverTypeWrapper<LaterContributionLimitMet>;
  LaterDebtCollectionItem: ResolverTypeWrapper<LaterDebtCollectionItem>;
  LaterDividendsItem: ResolverTypeWrapper<LaterDividendsItem>;
  LaterFeeInvestmentItem: ResolverTypeWrapper<LaterFeeInvestmentItem>;
  LaterFullContributionSuccess: ResolverTypeWrapper<LaterFullContributionSuccess>;
  LaterHistoryItem: ResolversTypes['LaterWithdrawal'];
  LaterHistoryItemType: LaterHistoryItemType;
  LaterHistorySummary: ResolverTypeWrapper<LaterHistorySummary>;
  LaterIndividualBeneficiary: ResolverTypeWrapper<LaterIndividualBeneficiary>;
  LaterIndividualBeneficiaryResponse: ResolverTypeWrapper<LaterIndividualBeneficiaryResponse>;
  LaterInvestmentItem: ResolverTypeWrapper<LaterInvestmentItem>;
  LaterMatchItem: ResolverTypeWrapper<LaterMatchItem>;
  LaterMatchRemovalItem: ResolverTypeWrapper<LaterMatchRemovalItem>;
  LaterPartialContributionSuccess: ResolverTypeWrapper<LaterPartialContributionSuccess>;
  LaterPortfolioPerformance: ResolverTypeWrapper<LaterPortfolioPerformance>;
  LaterProgramAccountContributionInput: LaterProgramAccountContributionInput;
  LaterProgramAccountContributionResult: ResolverTypeWrapper<ResolversUnionTypes['LaterProgramAccountContributionResult']>;
  LaterRebalanceItem: ResolverTypeWrapper<LaterRebalanceItem>;
  LaterRefundedItem: ResolverTypeWrapper<LaterRefundedItem>;
  LaterReinvestmentItem: ResolverTypeWrapper<LaterReinvestmentItem>;
  LaterTypedException: ResolversTypes['LaterAccountAlreadyVerified'] | ResolversTypes['LaterAccountIneligibleForVerification'] | ResolversTypes['LaterAccountNotFound'];
  LaterWaitlistProspect: ResolverTypeWrapper<LaterWaitlistProspect>;
  LaterWithdrawal: ResolverTypeWrapper<LaterWithdrawal>;
  LaterWithdrawalItem: ResolverTypeWrapper<LaterWithdrawalItem>;
  LaterWithdrawalReason: LaterWithdrawalReason;
  LaterWithdrawalType: LaterWithdrawalType;
  LaterWithholdingValues: ResolverTypeWrapper<LaterWithholdingValues>;
  LayerLinkSession: ResolverTypeWrapper<LayerLinkSession>;
  LayerLinkSessionInput: LayerLinkSessionInput;
  LearnAnswer: ResolverTypeWrapper<LearnAnswer>;
  LearnAnswerInput: LearnAnswerInput;
  LearnArticle: ResolverTypeWrapper<Omit<LearnArticle, 'contentImage' | 'duration' | 'featuredImage'> & { contentImage: Maybe<ResolversTypes['LearnVisualAsset']>, duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  LearnArticlePreview: ResolverTypeWrapper<Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  LearnArticlePreviewLocked: ResolverTypeWrapper<Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  LearnAspectRatioType: LearnAspectRatioType;
  LearnAuthor: ResolverTypeWrapper<Omit<LearnAuthor, 'photo'> & { photo: Maybe<ResolversTypes['LearnVisualAsset']> }>;
  LearnConnection: ResolversTypes['ContentPreviewConnection'];
  LearnContentCategory: ResolverTypeWrapper<ResolversUnionTypes['LearnContentCategory']>;
  LearnContentCommunityStats: ResolverTypeWrapper<ResolversUnionTypes['LearnContentCommunityStats']>;
  LearnContentDuration: ResolverTypeWrapper<ResolversUnionTypes['LearnContentDuration']>;
  LearnContentElapsedMillisecondsUpdatedResult: ResolverTypeWrapper<LearnContentElapsedMillisecondsUpdatedResult>;
  LearnContentFilterByTierIdInput: LearnContentFilterByTierIdInput;
  LearnContentFilterByTopicIdInput: LearnContentFilterByTopicIdInput;
  LearnContentFilterInput: LearnContentFilterInput;
  LearnContentInteractionState: ResolverTypeWrapper<ResolversUnionTypes['LearnContentInteractionState']>;
  LearnContentPageInput: LearnContentPageInput;
  LearnContentPreview: ResolverTypeWrapper<ResolversUnionTypes['LearnContentPreview']>;
  LearnContentSortType: LearnContentSortType;
  LearnContentStats: ResolverTypeWrapper<LearnContentStats>;
  LearnContentType: LearnContentType;
  LearnContentViewStatus: LearnContentViewStatus;
  LearnCourse: ResolverTypeWrapper<ResolversUnionTypes['LearnCourse']>;
  LearnCoursePreview: ResolverTypeWrapper<ResolversUnionTypes['LearnCoursePreview']>;
  LearnEdge: ResolversTypes['ContentPreviewEdge'];
  LearnHubCitation: ResolverTypeWrapper<LearnHubCitation>;
  LearnInsight: ResolverTypeWrapper<LearnInsight>;
  LearnInteractionState: ResolverTypeWrapper<Omit<LearnInteractionState, 'elapsedTime'> & { elapsedTime: Maybe<ResolversTypes['LearnContentDuration']> }>;
  LearnMedia: ResolverTypeWrapper<ResolversUnionTypes['LearnMedia']>;
  LearnMediaArticle: ResolverTypeWrapper<Omit<LearnMediaArticle, 'audioTheme' | 'featuredImage'> & { audioTheme: Maybe<ResolversTypes['LearnMediaTheme']>, featuredImage: Maybe<ResolversTypes['LearnVisualAsset']> }>;
  LearnMediaPreview: ResolverTypeWrapper<Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversTypes['LearnMediaTheme']>, duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  LearnMediaPreviewLocked: ResolverTypeWrapper<Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  LearnMediaReference: ResolverTypeWrapper<Omit<LearnMediaReference, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: Maybe<ResolversTypes['LearnVisualAsset']>, theme: Maybe<ResolversTypes['LearnMediaTheme']> }>;
  LearnMediaTheme: ResolverTypeWrapper<ResolversUnionTypes['LearnMediaTheme']>;
  LearnMediaType: LearnMediaType;
  LearnMetadata: ResolverTypeWrapper<Omit<LearnMetadata, 'contentStats' | 'interactionState'> & { contentStats: Maybe<ResolversTypes['LearnContentCommunityStats']>, interactionState: Maybe<ResolversTypes['LearnContentInteractionState']> }>;
  LearnNextStepAction: ResolverTypeWrapper<LearnNextStepAction>;
  LearnPageInfo: ResolverTypeWrapper<LearnPageInfo>;
  LearnPoll: ResolverTypeWrapper<LearnPoll>;
  LearnPollOption: ResolverTypeWrapper<LearnPollOption>;
  LearnPollPreview: ResolverTypeWrapper<LearnPollPreview>;
  LearnPollPreviewLocked: ResolverTypeWrapper<LearnPollPreviewLocked>;
  LearnPollResponse: ResolverTypeWrapper<LearnPollResponse>;
  LearnPollType: LearnPollType;
  LearnProductKey: LearnProductKey;
  LearnProgress: ResolverTypeWrapper<LearnProgress>;
  LearnProgressInput: LearnProgressInput;
  LearnProgressUnit: LearnProgressUnit;
  LearnProgressUpdatedResult: ResolverTypeWrapper<LearnProgressUpdatedResult>;
  LearnQuestion: ResolverTypeWrapper<LearnQuestion>;
  LearnQuestionInsight: ResolverTypeWrapper<LearnQuestionInsight>;
  LearnQuestionType: LearnQuestionType;
  LearnQuiz: ResolverTypeWrapper<ResolversUnionTypes['LearnQuiz']>;
  LearnQuizAnswerResult: ResolverTypeWrapper<LearnQuizAnswerResult>;
  LearnQuizPreview: ResolverTypeWrapper<ResolversUnionTypes['LearnQuizPreview']>;
  LearnRangeType: LearnRangeType;
  LearnSearchContentType: LearnSearchContentType;
  LearnSearchTermSavedResult: ResolverTypeWrapper<LearnSearchTermSavedResult>;
  LearnTag: ResolverTypeWrapper<LearnTag>;
  LearnThemeLiteral: ResolverTypeWrapper<LearnThemeLiteral>;
  LearnTier: ResolverTypeWrapper<Omit<LearnTier, 'icon'> & { icon: ResolversTypes['LearnVisualAsset'] }>;
  LearnTopic: ResolverTypeWrapper<Omit<LearnTopic, 'icon'> & { icon: ResolversTypes['LearnVisualAsset'] }>;
  LearnVisualAsset: ResolverTypeWrapper<ResolversUnionTypes['LearnVisualAsset']>;
  LegacyAlertDismissalSuccess: ResolverTypeWrapper<LegacyAlertDismissalSuccess>;
  LegacyUploadDocument: ResolverTypeWrapper<LegacyUploadDocument>;
  LegacyUploadDocumentInput: LegacyUploadDocumentInput;
  LegacyUploadDocumentResult: ResolverTypeWrapper<ResolversUnionTypes['LegacyUploadDocumentResult']>;
  Lesson: ResolverTypeWrapper<Lesson>;
  LessonPreview: ResolverTypeWrapper<Omit<LessonPreview, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  LessonPreviewLocked: ResolverTypeWrapper<Omit<LessonPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'] }>;
  LinkCustomization: LinkCustomization;
  LinkManualFundingSourceInput: LinkManualFundingSourceInput;
  LinkManualFundingSourceResult: ResolverTypeWrapper<ResolversUnionTypes['LinkManualFundingSourceResult']>;
  LinkOidcCredentialsInput: LinkOidcCredentialsInput;
  LinkOidcCredentialsResult: ResolverTypeWrapper<ResolversUnionTypes['LinkOidcCredentialsResult']>;
  LinkOidcCredentialsSuccess: ResolverTypeWrapper<LinkOidcCredentialsSuccess>;
  LinkProviderType: LinkProviderType;
  LinkSessionInput: LinkSessionInput;
  LinkSessionLanguage: LinkSessionLanguage;
  LinkSessionResult: ResolverTypeWrapper<ResolversUnionTypes['LinkSessionResult']>;
  LinkedAccount: ResolverTypeWrapper<LinkedAccount>;
  LinkedAccountAlert: ResolverTypeWrapper<LinkedAccountAlert>;
  LinkedAccountAlertsResponse: ResolverTypeWrapper<ResolversUnionTypes['LinkedAccountAlertsResponse']>;
  LinkedAccountExternalSourceEnum: LinkedAccountExternalSourceEnum;
  LinkedAccountLinkingErrorsEnum: LinkedAccountLinkingErrorsEnum;
  LinkedAccountNotFound: ResolverTypeWrapper<LinkedAccountNotFound>;
  LinkedAccountStatusEnum: LinkedAccountStatusEnum;
  LinkedSubaccount: ResolverTypeWrapper<LinkedSubaccount>;
  LinkedSubaccountPaymentEngineEnum: LinkedSubaccountPaymentEngineEnum;
  LinkedSubaccountRoleEnum: LinkedSubaccountRoleEnum;
  Liquidation: ResolverTypeWrapper<Liquidation>;
  LiquidationUnavailableError: ResolverTypeWrapper<LiquidationUnavailableError>;
  LiquidationUnavailableReason: LiquidationUnavailableReason;
  LockBankCardInput: LockBankCardInput;
  LockBankCardPayload: ResolverTypeWrapper<LockBankCardPayload>;
  LoginAccess: ResolverTypeWrapper<LoginAccess>;
  LoginRateLimitedException: ResolverTypeWrapper<LoginRateLimitedException>;
  LogoutDeviceInput: LogoutDeviceInput;
  LogoutDeviceResult: ResolverTypeWrapper<ResolversUnionTypes['LogoutDeviceResult']>;
  LogoutDeviceSuccess: ResolverTypeWrapper<LogoutDeviceSuccess>;
  LogoutResult: ResolverTypeWrapper<ResolversUnionTypes['LogoutResult']>;
  LogoutSuccess: ResolverTypeWrapper<LogoutSuccess>;
  MailInDocumentType: MailInDocumentType;
  MakeInvestmentInput: MakeInvestmentInput;
  MakeInvestmentPayload: ResolverTypeWrapper<MakeInvestmentPayload>;
  MalformedRecurringTransferException: ResolverTypeWrapper<MalformedRecurringTransferException>;
  ManagePayoutRelationshipAction: ManagePayoutRelationshipAction;
  ManagePayoutRelationshipResult: ManagePayoutRelationshipResult;
  MaritalStatus: MaritalStatus;
  MarkAllAsReadResult: ResolverTypeWrapper<ResolversUnionTypes['MarkAllAsReadResult']>;
  MarkAllAsReadSuccess: ResolverTypeWrapper<MarkAllAsReadSuccess>;
  MarkLearnContentAsHelpfulInput: MarkLearnContentAsHelpfulInput;
  MarkLearnContentAsHelpfulResult: ResolverTypeWrapper<ResolversUnionTypes['MarkLearnContentAsHelpfulResult']>;
  MarkLearnContentAsViewedInput: MarkLearnContentAsViewedInput;
  MarkLearnContentAsViewedResult: ResolverTypeWrapper<ResolversUnionTypes['MarkLearnContentAsViewedResult']>;
  Market: ResolverTypeWrapper<Market>;
  MarketReturn: ResolverTypeWrapper<MarketReturn>;
  MatchProgram: ResolverTypeWrapper<MatchProgram>;
  MaxAccountsCreatedException: ResolverTypeWrapper<MaxAccountsCreatedException>;
  Message: ResolversTypes['AlertMessage'] | ResolversTypes['NotificationMessage'];
  MessageCategory: MessageCategory;
  MessageConnection: ResolverTypeWrapper<MessageConnection>;
  MessageEdge: ResolverTypeWrapper<MessageEdge>;
  MessageFeedbackInput: MessageFeedbackInput;
  MessageFeedbackReason: MessageFeedbackReason;
  MessagePageInfo: ResolverTypeWrapper<MessagePageInfo>;
  MessagePageInput: MessagePageInput;
  MessageStatus: MessageStatus;
  MessageStatusFilterInput: MessageStatusFilterInput;
  MessageTextAsset: ResolverTypeWrapper<ResolversUnionTypes['MessageTextAsset']>;
  MessageType: MessageType;
  MessageVisualAsset: ResolverTypeWrapper<ResolversUnionTypes['MessageVisualAsset']>;
  MfaMissingAuthAlert: ResolverTypeWrapper<MfaMissingAuthAlert>;
  Micros: ResolverTypeWrapper<Scalars['Micros']>;
  MicrosMoney: ResolverTypeWrapper<MicrosMoney>;
  MightyOakCardWaiver: ResolverTypeWrapper<MightyOakCardWaiver>;
  MightyOakCardWaiverExpiredException: ResolverTypeWrapper<MightyOakCardWaiverExpiredException>;
  MightyOakCardWaiverNotFoundException: ResolverTypeWrapper<MightyOakCardWaiverNotFoundException>;
  MightyOakWaiverResult: ResolverTypeWrapper<ResolversUnionTypes['MightyOakWaiverResult']>;
  Milestone: ResolverTypeWrapper<Omit<Milestone, 'progress'> & { progress: ResolversTypes['MilestoneProgress'] }>;
  MilestoneAccountLevelDefinition: ResolverTypeWrapper<MilestoneAccountLevelDefinition>;
  MilestoneAchievementActionRule: ResolverTypeWrapper<MilestoneAchievementActionRule>;
  MilestoneAchievementActionType: MilestoneAchievementActionType;
  MilestoneByThemeFilterInput: MilestoneByThemeFilterInput;
  MilestoneChallenge: ResolverTypeWrapper<Omit<MilestoneChallenge, 'groupedMilestones'> & { groupedMilestones: Array<ResolversTypes['MilestoneGroup']> }>;
  MilestoneChallengePointsRule: ResolverTypeWrapper<MilestoneChallengePointsRule>;
  MilestoneDefinition: ResolverTypeWrapper<MilestoneDefinition>;
  MilestoneEligibility: ResolverTypeWrapper<MilestoneEligibility>;
  MilestoneEligibilityScope: MilestoneEligibilityScope;
  MilestoneGroup: ResolverTypeWrapper<ResolversUnionTypes['MilestoneGroup']>;
  MilestoneGroupAchievementActionRule: ResolverTypeWrapper<MilestoneGroupAchievementActionRule>;
  MilestoneGroupDefinition: ResolverTypeWrapper<MilestoneGroupDefinition>;
  MilestoneHub: ResolverTypeWrapper<Omit<MilestoneHub, 'groupedMilestones'> & { groupedMilestones: Array<ResolversTypes['MilestoneGroup']> }>;
  MilestoneHubAccount: ResolverTypeWrapper<MilestoneHubAccount>;
  MilestoneHubDefinition: ResolverTypeWrapper<MilestoneHubDefinition>;
  MilestoneProgress: ResolverTypeWrapper<ResolversUnionTypes['MilestoneProgress']>;
  MilestoneRule: ResolverTypeWrapper<MilestoneRule>;
  MilestoneRuleArgInput: MilestoneRuleArgInput;
  MilestoneRuleGroup: ResolverTypeWrapper<Omit<MilestoneRuleGroup, 'contents'> & { contents: Array<ResolversTypes['MilestoneRuleGroupContent']> }>;
  MilestoneRuleGroupContent: ResolverTypeWrapper<ResolversUnionTypes['MilestoneRuleGroupContent']>;
  MilestoneRuleType: MilestoneRuleType;
  MilestoneStatus: MilestoneStatus;
  MilestoneTheme: MilestoneTheme;
  MilestoneThemeGroup: ResolverTypeWrapper<Omit<MilestoneThemeGroup, 'contents'> & { contents: Array<ResolversTypes['MilestoneThemeGroupContent']> }>;
  MilestoneThemeGroupContent: ResolverTypeWrapper<ResolversUnionTypes['MilestoneThemeGroupContent']>;
  Milliseconds: ResolverTypeWrapper<Milliseconds>;
  MillisecondsInput: MillisecondsInput;
  MiscDocumentRequestedUserAlert: ResolverTypeWrapper<MiscDocumentRequestedUserAlert>;
  MismatchedDistributionUnitsError: ResolverTypeWrapper<MismatchedDistributionUnitsError>;
  MissingAgreementsException: ResolverTypeWrapper<MissingAgreementsException>;
  MissingBeneficiarySsnException: ResolverTypeWrapper<MissingBeneficiarySsnException>;
  MissingFundingSourceException: ResolverTypeWrapper<MissingFundingSourceException>;
  MissingRequiredAgreementsException: ResolverTypeWrapper<MissingRequiredAgreementsException>;
  MissingSsnBeneficiaryAlert: ResolverTypeWrapper<MissingSsnBeneficiaryAlert>;
  MissingSsnBeneficiaryAlertItem: ResolverTypeWrapper<MissingSsnBeneficiaryAlertItem>;
  MissingValidRulesetError: ResolverTypeWrapper<MissingValidRulesetError>;
  ModifyMoneyAssignmentInput: ModifyMoneyAssignmentInput;
  ModifyMoneyAssignmentResult: ResolverTypeWrapper<ResolversUnionTypes['ModifyMoneyAssignmentResult']>;
  ModifyMoneyAssignmentSuccess: ResolverTypeWrapper<ModifyMoneyAssignmentSuccess>;
  MonetaryAmount: ResolverTypeWrapper<MonetaryAmount>;
  MonetaryAmountInput: MonetaryAmountInput;
  MonetaryIncentive: ResolverTypeWrapper<MonetaryIncentive>;
  MoneyAssignmentAlreadyTransferredError: ResolverTypeWrapper<MoneyAssignmentAlreadyTransferredError>;
  MoneyAssignmentConnection: ResolverTypeWrapper<MoneyAssignmentConnection>;
  MoneyAssignmentEdge: ResolverTypeWrapper<MoneyAssignmentEdge>;
  MoneyAssignmentNotFoundError: ResolverTypeWrapper<MoneyAssignmentNotFoundError>;
  MoneyInEventInput: MoneyInEventInput;
  MoneyManagerAllocation: ResolverTypeWrapper<MoneyManagerAllocation>;
  MoneyManagerAllocationNotEditableReason: MoneyManagerAllocationNotEditableReason;
  MoneyManagerAllocationOption: ResolverTypeWrapper<MoneyManagerAllocationOption>;
  MoneyManagerAllocationOptionsInput: MoneyManagerAllocationOptionsInput;
  MoneyManagerAllocationRemainder: ResolverTypeWrapper<MoneyManagerAllocationRemainder>;
  MoneyManagerAllocationResult: ResolverTypeWrapper<MoneyManagerAllocationResult>;
  MoneyManagerAllocationStatus: MoneyManagerAllocationStatus;
  MoneyManagerAutomationTarget: ResolverTypeWrapper<MoneyManagerAutomationTarget>;
  MoneyManagerAutomationTargetType: MoneyManagerAutomationTargetType;
  MoneyManagerCancelReason: MoneyManagerCancelReason;
  MoneyManagerCascadeObjective: ResolverTypeWrapper<MoneyManagerCascadeObjective>;
  MoneyManagerCascadeObjectiveType: MoneyManagerCascadeObjectiveType;
  MoneyManagerCascadeTarget: ResolverTypeWrapper<MoneyManagerCascadeTarget>;
  MoneyManagerCategoriesInput: MoneyManagerCategoriesInput;
  MoneyManagerCategoriesResult: ResolverTypeWrapper<ResolversUnionTypes['MoneyManagerCategoriesResult']>;
  MoneyManagerCategoriesSuccess: ResolverTypeWrapper<MoneyManagerCategoriesSuccess>;
  MoneyManagerCategory: ResolverTypeWrapper<MoneyManagerCategory>;
  MoneyManagerCategoryAllocation: ResolverTypeWrapper<MoneyManagerCategoryAllocation>;
  MoneyManagerCategoryType: MoneyManagerCategoryType;
  MoneyManagerDeposit: ResolversTypes['MoneyManagerPaycheck'] | ResolversTypes['MoneyManagerRecurringDeposit'];
  MoneyManagerDepositAssignment: ResolverTypeWrapper<MoneyManagerDepositAssignment>;
  MoneyManagerDepositCategory: MoneyManagerDepositCategory;
  MoneyManagerDepositState: MoneyManagerDepositState;
  MoneyManagerDepositSummary: ResolverTypeWrapper<MoneyManagerDepositSummary>;
  MoneyManagerEligibilityResult: ResolverTypeWrapper<MoneyManagerEligibilityResult>;
  MoneyManagerError: ResolversTypes['MoneyManagerInputError'] | ResolversTypes['MoneyManagerRulesetNotFoundError'];
  MoneyManagerGlobalConfig: ResolverTypeWrapper<MoneyManagerGlobalConfig>;
  MoneyManagerInputError: ResolverTypeWrapper<MoneyManagerInputError>;
  MoneyManagerMoneyAssignment: ResolversTypes['MoneyManagerDepositAssignment'] | ResolversTypes['MoneyManagerRebalanceAssignment'];
  MoneyManagerMoneyAssignmentStatus: MoneyManagerMoneyAssignmentStatus;
  MoneyManagerMoneyAssignmentType: MoneyManagerMoneyAssignmentType;
  MoneyManagerNormalizedAmounts: ResolverTypeWrapper<MoneyManagerNormalizedAmounts>;
  MoneyManagerPageInfo: ResolverTypeWrapper<MoneyManagerPageInfo>;
  MoneyManagerPageInput: MoneyManagerPageInput;
  MoneyManagerPaycheck: ResolverTypeWrapper<MoneyManagerPaycheck>;
  MoneyManagerPeriod: ResolverTypeWrapper<MoneyManagerPeriod>;
  MoneyManagerPeriodInput: MoneyManagerPeriodInput;
  MoneyManagerPeriodUnit: MoneyManagerPeriodUnit;
  MoneyManagerRebalanceAllocationInput: MoneyManagerRebalanceAllocationInput;
  MoneyManagerRebalanceAssignment: ResolverTypeWrapper<MoneyManagerRebalanceAssignment>;
  MoneyManagerRebalanceResult: ResolverTypeWrapper<MoneyManagerRebalanceResult>;
  MoneyManagerRebalanceRuleset: ResolverTypeWrapper<MoneyManagerRebalanceRuleset>;
  MoneyManagerRebalanceRulesetInput: MoneyManagerRebalanceRulesetInput;
  MoneyManagerRebalanceSourceAccountType: MoneyManagerRebalanceSourceAccountType;
  MoneyManagerRebalanceSuppressionSource: MoneyManagerRebalanceSuppressionSource;
  MoneyManagerRebalancesResponse: ResolverTypeWrapper<MoneyManagerRebalancesResponse>;
  MoneyManagerRecurringDeposit: ResolverTypeWrapper<MoneyManagerRecurringDeposit>;
  MoneyManagerRecurringDepositsConfig: ResolverTypeWrapper<MoneyManagerRecurringDepositsConfig>;
  MoneyManagerRecurringFrequency: MoneyManagerRecurringFrequency;
  MoneyManagerRulesetNotFoundError: ResolverTypeWrapper<MoneyManagerRulesetNotFoundError>;
  MoneyManagerScheduledDeposit: ResolversTypes['MoneyManagerScheduledPaycheck'] | ResolversTypes['MoneyManagerScheduledRecurringDeposit'];
  MoneyManagerScheduledPaycheck: ResolverTypeWrapper<MoneyManagerScheduledPaycheck>;
  MoneyManagerScheduledRecurringDeposit: ResolverTypeWrapper<MoneyManagerScheduledRecurringDeposit>;
  MoneyManagerSettings: ResolverTypeWrapper<MoneyManagerSettings>;
  MoneyManagerSourceSetting: ResolverTypeWrapper<MoneyManagerSourceSetting>;
  MoneyManagerStagedRulesInput: MoneyManagerStagedRulesInput;
  MoneyManagerState: MoneyManagerState;
  MoneyManagerStatus: MoneyManagerStatus;
  MoneyManagerSummary: ResolverTypeWrapper<MoneyManagerSummary>;
  MoneyRulesAccountType: MoneyRulesAccountType;
  MoneyRulesArchetype: MoneyRulesArchetype;
  MoneyRulesArchetypesInput: MoneyRulesArchetypesInput;
  MoneyRulesArchetypesResult: ResolverTypeWrapper<ResolversUnionTypes['MoneyRulesArchetypesResult']>;
  MoneyRulesArchetypesSuccess: ResolverTypeWrapper<MoneyRulesArchetypesSuccess>;
  MoneyRulesCancelMoneyAssignmentSuccess: ResolverTypeWrapper<MoneyRulesCancelMoneyAssignmentSuccess>;
  MoneyRulesCondition: ResolverTypeWrapper<MoneyRulesCondition>;
  MoneyRulesConditionInput: MoneyRulesConditionInput;
  MoneyRulesConditionType: MoneyRulesConditionType;
  MoneyRulesConditionUnit: MoneyRulesConditionUnit;
  MoneyRulesCurrencyAmount: ResolverTypeWrapper<MoneyRulesCurrencyAmount>;
  MoneyRulesCurrencyAmountInput: MoneyRulesCurrencyAmountInput;
  MoneyRulesDepositType: MoneyRulesDepositType;
  MoneyRulesDestination: ResolverTypeWrapper<MoneyRulesDestination>;
  MoneyRulesDestinationInput: MoneyRulesDestinationInput;
  MoneyRulesDistribution: ResolverTypeWrapper<MoneyRulesDistribution>;
  MoneyRulesDistributionInput: MoneyRulesDistributionInput;
  MoneyRulesDistributionUnit: MoneyRulesDistributionUnit;
  MoneyRulesMoneySource: ResolverTypeWrapper<MoneyRulesMoneySource>;
  MoneyRulesMoneySourceInput: MoneyRulesMoneySourceInput;
  MoneyRulesMoneySplit: ResolverTypeWrapper<MoneyRulesMoneySplit>;
  MoneyRulesRule: ResolverTypeWrapper<MoneyRulesRule>;
  MoneyRulesRuleInput: MoneyRulesRuleInput;
  MoneyRulesRuleType: MoneyRulesRuleType;
  MoneyRulesRuleset: ResolverTypeWrapper<MoneyRulesRuleset>;
  MoneyRulesRulesetInput: MoneyRulesRulesetInput;
  MoneyRulesRulesetNotFoundException: ResolverTypeWrapper<MoneyRulesRulesetNotFoundException>;
  MoneyRulesSettings: ResolverTypeWrapper<MoneyRulesSettings>;
  MoneyRulesSourceSetting: ResolverTypeWrapper<MoneyRulesSourceSetting>;
  MoneyRulesSplitOverridesInput: MoneyRulesSplitOverridesInput;
  MoneyRulesSuggestedSplits: ResolverTypeWrapper<MoneyRulesSuggestedSplits>;
  MoneyRulesSuggestionResult: ResolverTypeWrapper<ResolversUnionTypes['MoneyRulesSuggestionResult']>;
  MoneyRulesUpdateArchetypeResult: ResolverTypeWrapper<ResolversUnionTypes['MoneyRulesUpdateArchetypeResult']>;
  MoneyRulesUpdateCustomerMoneyRulesResult: ResolverTypeWrapper<ResolversUnionTypes['MoneyRulesUpdateCustomerMoneyRulesResult']>;
  MoneyRulesUpdateRulesetSuccess: ResolverTypeWrapper<MoneyRulesUpdateRulesetSuccess>;
  MonthlyTotal: ResolverTypeWrapper<MonthlyTotal>;
  Mutation: ResolverTypeWrapper<{}>;
  NativeLoginInput: NativeLoginInput;
  NegativeSecurityPercentError: ResolverTypeWrapper<NegativeSecurityPercentError>;
  NegotiationMethod: NegotiationMethod;
  NegotiationServiceConnectionFailure: ResolverTypeWrapper<NegotiationServiceConnectionFailure>;
  NegotiationStatus: NegotiationStatus;
  NegotiationType: NegotiationType;
  NetTermsType: NetTermsType;
  NextBillingDate: ResolverTypeWrapper<NextBillingDate>;
  NextTransferDateResult: ResolverTypeWrapper<ResolversUnionTypes['NextTransferDateResult']>;
  NoBeneficiaryFoundException: ResolverTypeWrapper<NoBeneficiaryFoundException>;
  NoFundingSourceUserAlert: ResolverTypeWrapper<NoFundingSourceUserAlert>;
  NoProspectRecord: ResolverTypeWrapper<NoProspectRecord>;
  NoRegisteredPushAuthenticatorsException: ResolverTypeWrapper<NoRegisteredPushAuthenticatorsException>;
  NonBasicAccountOpenException: ResolverTypeWrapper<NonBasicAccountOpenException>;
  NonUniqueSingleRuleIdsError: ResolverTypeWrapper<NonUniqueSingleRuleIdsError>;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationMessage: ResolverTypeWrapper<Omit<NotificationMessage, 'body' | 'icon' | 'title'> & { body: ResolversTypes['MessageTextAsset'], icon: Maybe<ResolversTypes['MessageVisualAsset']>, title: ResolversTypes['MessageTextAsset'] }>;
  Notifications: ResolverTypeWrapper<Notifications>;
  OauthApp: ResolverTypeWrapper<OauthApp>;
  OauthAppClient: ResolverTypeWrapper<OauthAppClient>;
  OauthAppClientNotFoundException: ResolverTypeWrapper<OauthAppClientNotFoundException>;
  OauthAppImageUpload: ResolverTypeWrapper<OauthAppImageUpload>;
  OauthAppNotFoundException: ResolverTypeWrapper<OauthAppNotFoundException>;
  OauthAppScope: ResolverTypeWrapper<OauthAppScope>;
  OauthAppType: OauthAppType;
  Occupation: ResolverTypeWrapper<Occupation>;
  Offer: ResolverTypeWrapper<Omit<Offer, 'offering'> & { offering: ResolversTypes['Offering'] }>;
  OfferAvailability: OfferAvailability;
  OfferExpiration: ResolverTypeWrapper<OfferExpiration>;
  OfferExpirationPeriod: OfferExpirationPeriod;
  OfferGroupsType: OfferGroupsType;
  OfferLocation: ResolverTypeWrapper<OfferLocation>;
  OfferLocationInput: OfferLocationInput;
  OfferPrice: ResolverTypeWrapper<OfferPrice>;
  OfferPriceInput: OfferPriceInput;
  OfferPriceType: OfferPriceType;
  OfferType: OfferType;
  Offering: ResolverTypeWrapper<ResolversUnionTypes['Offering']>;
  OidcCredentialsAlreadyLinkedException: ResolverTypeWrapper<OidcCredentialsAlreadyLinkedException>;
  OidcCredentialsNotFoundException: ResolverTypeWrapper<OidcCredentialsNotFoundException>;
  OidcCredentialsTakenException: ResolverTypeWrapper<OidcCredentialsTakenException>;
  OidcLoginInput: OidcLoginInput;
  OidcProvider: OidcProvider;
  OnboardingBenefitsInput: OnboardingBenefitsInput;
  OnboardingGroups: OnboardingGroups;
  OnboardingProductStatus: ResolverTypeWrapper<OnboardingProductStatus>;
  OnboardingProductTile: ResolverTypeWrapper<OnboardingProductTile>;
  OnboardingProducts: OnboardingProducts;
  OnboardingRequirement: OnboardingRequirement;
  OnboardingTileGroup: ResolverTypeWrapper<OnboardingTileGroup>;
  OnboardingTipItem: ResolverTypeWrapper<OnboardingTipItem>;
  OnboardingTipType: OnboardingTipType;
  OnboardingTips: ResolverTypeWrapper<OnboardingTips>;
  OnboardingType: OnboardingType;
  OnlineSwitch: ResolverTypeWrapper<OnlineSwitch>;
  OpenAccountsException: ResolverTypeWrapper<OpenAccountsException>;
  OpenCoreInvestmentAccountInput: OpenCoreInvestmentAccountInput;
  OpenCoreInvestmentAccountResult: ResolverTypeWrapper<ResolversUnionTypes['OpenCoreInvestmentAccountResult']>;
  OpenEarlyAccountInput: OpenEarlyAccountInput;
  OpenEarlyAccountResult: ResolverTypeWrapper<ResolversUnionTypes['OpenEarlyAccountResult']>;
  OperationStage: OperationStage;
  Order: Order;
  OrderBankCardInput: OrderBankCardInput;
  OrderBankCardResult: ResolverTypeWrapper<ResolversUnionTypes['OrderBankCardResult']>;
  Origin: Origin;
  OutsideContribution: ResolverTypeWrapper<OutsideContribution>;
  OutsideContributionCheckoutCart: ResolverTypeWrapper<OutsideContributionCheckoutCart>;
  OutsideContributionCode: ResolverTypeWrapper<OutsideContributionCode>;
  OutsideContributionProspect: ResolverTypeWrapper<OutsideContributionProspect>;
  OverrideInput: OverrideInput;
  PackageStatus: PackageStatus;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PageInput: PageInput;
  PageName: PageName;
  PaginationInput: PaginationInput;
  ParameterizedPdfInput: ParameterizedPdfInput;
  PartnerDataShare: ResolverTypeWrapper<PartnerDataShare>;
  PartnerDataShareInput: PartnerDataShareInput;
  PartnerDataShareResponse: ResolverTypeWrapper<ResolversUnionTypes['PartnerDataShareResponse']>;
  PartnerDetailsResponse: ResolverTypeWrapper<PartnerDetailsResponse>;
  PartnerDocumentUrlResponse: ResolverTypeWrapper<PartnerDocumentUrlResponse>;
  PartnerOfferGroup: ResolverTypeWrapper<Omit<PartnerOfferGroup, 'offers'> & { offers: Array<ResolversTypes['PartnerOfferGroupItem']> }>;
  PartnerOfferGroupFilterInput: PartnerOfferGroupFilterInput;
  PartnerOfferGroupItem: ResolverTypeWrapper<ResolversUnionTypes['PartnerOfferGroupItem']>;
  PartnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput;
  PartnerStatusInput: PartnerStatusInput;
  PartnerUrlInput: PartnerUrlInput;
  PartnerUrlResponse: ResolverTypeWrapper<PartnerUrlResponse>;
  PasswordResetErrors: PasswordResetErrors;
  PasswordResetForm: ResolverTypeWrapper<PasswordResetForm>;
  PasswordResetFormFields: ResolverTypeWrapper<PasswordResetFormFields>;
  PastAnnotatedItem: ResolversTypes['EarlyGiftItem'];
  PastBeneficiaryInfo: ResolverTypeWrapper<PastBeneficiaryInfo>;
  PastBeneficiaryTransferInvestmentItem: ResolverTypeWrapper<PastBeneficiaryTransferInvestmentItem>;
  PastCashOwedCollectionInvestmentItem: ResolverTypeWrapper<PastCashOwedCollectionInvestmentItem>;
  PastCashReinvestmentInvestmentItem: ResolverTypeWrapper<PastCashReinvestmentInvestmentItem>;
  PastCoreCombinedItem: ResolversTypes['CoreInvestmentItem'] | ResolversTypes['CoreRoundUpsItem'];
  PastCoreItem: ResolverTypeWrapper<PastCoreItem>;
  PastCoreSummary: ResolverTypeWrapper<PastCoreSummary>;
  PastCoreTradedItem: ResolversTypes['CoreAdjustmentItem'] | ResolversTypes['CoreDebtCollectionItem'] | ResolversTypes['CoreDividendsItem'] | ResolversTypes['CoreEmployeeCreditItem'] | ResolversTypes['CoreFeeInvestmentItem'] | ResolversTypes['CoreFoundMoneyRewardItem'] | ResolversTypes['CoreGiftCardCreditRedemptionItem'] | ResolversTypes['CoreInvestmentItem'] | ResolversTypes['CoreLocalFoundMoneyItem'] | ResolversTypes['CorePartnerRewardItem'] | ResolversTypes['CoreRebalanceItem'] | ResolversTypes['CoreReferralRewardItem'] | ResolversTypes['CoreRefundedItem'] | ResolversTypes['CoreReinvestmentItem'] | ResolversTypes['CoreRoundUpsItem'] | ResolversTypes['CoreWithdrawalItem'] | ResolversTypes['EarlyDebtCollectionItem'] | ResolversTypes['EarlyDividendsItem'] | ResolversTypes['EarlyFeeInvestmentItem'] | ResolversTypes['EarlyGiftItem'] | ResolversTypes['EarlyInvestmentItem'] | ResolversTypes['EarlyMatchItem'] | ResolversTypes['EarlyMatchRemovalItem'] | ResolversTypes['EarlyRefundedItem'] | ResolversTypes['EarlyReinvestmentItem'] | ResolversTypes['EarlyWithdrawalItem'] | ResolversTypes['LaterDebtCollectionItem'] | ResolversTypes['LaterDividendsItem'] | ResolversTypes['LaterFeeInvestmentItem'] | ResolversTypes['LaterInvestmentItem'] | ResolversTypes['LaterMatchItem'] | ResolversTypes['LaterMatchRemovalItem'] | ResolversTypes['LaterRebalanceItem'] | ResolversTypes['LaterRefundedItem'] | ResolversTypes['LaterReinvestmentItem'] | ResolversTypes['LaterWithdrawalItem'];
  PastDividendInvestmentItem: ResolverTypeWrapper<PastDividendInvestmentItem>;
  PastEarlyItem: ResolversTypes['EarlyDividendsItem'] | ResolversTypes['EarlyFeeInvestmentItem'] | ResolversTypes['EarlyGiftItem'] | ResolversTypes['EarlyInvestmentItem'] | ResolversTypes['EarlyMatchItem'] | ResolversTypes['EarlyMatchRemovalItem'] | ResolversTypes['EarlyRefundedItem'] | ResolversTypes['EarlyReinvestmentItem'] | ResolversTypes['EarlyWithdrawalItem'];
  PastEarlySummary: ResolverTypeWrapper<PastEarlySummary>;
  PastEmployeeContributionInvestmentItem: ResolverTypeWrapper<PastEmployeeContributionInvestmentItem>;
  PastExternalTransferInvestmentItem: ResolverTypeWrapper<PastExternalTransferInvestmentItem>;
  PastExternalTransferReversedInvestmentItem: ResolverTypeWrapper<PastExternalTransferReversedInvestmentItem>;
  PastFeeInvestmentItem: ResolverTypeWrapper<PastFeeInvestmentItem>;
  PastGiftCardInvestmentItem: ResolverTypeWrapper<PastGiftCardInvestmentItem>;
  PastIRATransferInvestmentItem: ResolverTypeWrapper<PastIraTransferInvestmentItem>;
  PastInvestmentItem: ResolversTypes['PastBeneficiaryTransferInvestmentItem'] | ResolversTypes['PastCashOwedCollectionInvestmentItem'] | ResolversTypes['PastCashReinvestmentInvestmentItem'] | ResolversTypes['PastDividendInvestmentItem'] | ResolversTypes['PastEmployeeContributionInvestmentItem'] | ResolversTypes['PastExternalTransferInvestmentItem'] | ResolversTypes['PastExternalTransferReversedInvestmentItem'] | ResolversTypes['PastFeeInvestmentItem'] | ResolversTypes['PastGiftCardInvestmentItem'] | ResolversTypes['PastIRATransferInvestmentItem'] | ResolversTypes['PastLumpSumInvestment'] | ResolversTypes['PastMatchInvestmentItem'] | ResolversTypes['PastMatchRemovalInvestmentItem'] | ResolversTypes['PastOutsideContributionInvestmentItem'] | ResolversTypes['PastRealTimeRoundUpInvestmentItem'] | ResolversTypes['PastRebalanceInvestmentItem'] | ResolversTypes['PastRecurringInvestmentItem'] | ResolversTypes['PastReferralRewardInvestmentItem'] | ResolversTypes['PastReferralRewardMatchInvestmentItem'] | ResolversTypes['PastRefundInvestmentItem'] | ResolversTypes['PastReversalInvestmentItem'] | ResolversTypes['PastRewardInvestmentItem'] | ResolversTypes['PastRewardMatchInvestmentItem'] | ResolversTypes['PastRoundUpItem'] | ResolversTypes['PastRoundUpMatchInvestmentItem'] | ResolversTypes['PastSecurityLiquidationInvestmentItem'] | ResolversTypes['PastSmartDepositInvestmentItem'] | ResolversTypes['PastWithdrawalInvestmentItem'];
  PastItem: ResolversTypes['CoreACHSubscriptionFeeItem'] | ResolversTypes['CoreAdjustmentItem'] | ResolversTypes['CoreCashForwardItem'] | ResolversTypes['CoreCollectionItem'] | ResolversTypes['CoreDebtCollectionItem'] | ResolversTypes['CoreDividendsItem'] | ResolversTypes['CoreEmployeeCreditItem'] | ResolversTypes['CoreFeeInvestmentItem'] | ResolversTypes['CoreFoundMoneyRewardItem'] | ResolversTypes['CoreGiftCardCreditRedemptionItem'] | ResolversTypes['CoreHoldingsTransferInItem'] | ResolversTypes['CoreInvestmentItem'] | ResolversTypes['CoreLocalFoundMoneyItem'] | ResolversTypes['CorePartnerRewardItem'] | ResolversTypes['CoreRebalanceItem'] | ResolversTypes['CoreReferralRewardItem'] | ResolversTypes['CoreRefundedItem'] | ResolversTypes['CoreReinvestmentItem'] | ResolversTypes['CoreRoundUpsItem'] | ResolversTypes['CoreWithdrawalItem'] | ResolversTypes['EarlyDebtCollectionItem'] | ResolversTypes['EarlyDividendsItem'] | ResolversTypes['EarlyFeeInvestmentItem'] | ResolversTypes['EarlyGiftItem'] | ResolversTypes['EarlyInvestmentItem'] | ResolversTypes['EarlyMatchItem'] | ResolversTypes['EarlyMatchRemovalItem'] | ResolversTypes['EarlyRefundedItem'] | ResolversTypes['EarlyReinvestmentItem'] | ResolversTypes['EarlyWithdrawalItem'] | ResolversTypes['LaterDebtCollectionItem'] | ResolversTypes['LaterDividendsItem'] | ResolversTypes['LaterFeeInvestmentItem'] | ResolversTypes['LaterInvestmentItem'] | ResolversTypes['LaterMatchItem'] | ResolversTypes['LaterMatchRemovalItem'] | ResolversTypes['LaterRebalanceItem'] | ResolversTypes['LaterRefundedItem'] | ResolversTypes['LaterReinvestmentItem'] | ResolversTypes['LaterWithdrawalItem'] | ResolversTypes['PastBeneficiaryTransferInvestmentItem'] | ResolversTypes['PastCashOwedCollectionInvestmentItem'] | ResolversTypes['PastCashReinvestmentInvestmentItem'] | ResolversTypes['PastCoreItem'] | ResolversTypes['PastDividendInvestmentItem'] | ResolversTypes['PastEmployeeContributionInvestmentItem'] | ResolversTypes['PastExternalTransferInvestmentItem'] | ResolversTypes['PastExternalTransferReversedInvestmentItem'] | ResolversTypes['PastFeeInvestmentItem'] | ResolversTypes['PastGiftCardInvestmentItem'] | ResolversTypes['PastIRATransferInvestmentItem'] | ResolversTypes['PastLumpSumInvestment'] | ResolversTypes['PastMatchInvestmentItem'] | ResolversTypes['PastMatchRemovalInvestmentItem'] | ResolversTypes['PastOutsideContributionInvestmentItem'] | ResolversTypes['PastRealTimeRoundUpInvestmentItem'] | ResolversTypes['PastRebalanceInvestmentItem'] | ResolversTypes['PastRecurringInvestmentItem'] | ResolversTypes['PastReferralRewardInvestmentItem'] | ResolversTypes['PastReferralRewardMatchInvestmentItem'] | ResolversTypes['PastRefundInvestmentItem'] | ResolversTypes['PastReversalInvestmentItem'] | ResolversTypes['PastRewardInvestmentItem'] | ResolversTypes['PastRewardMatchInvestmentItem'] | ResolversTypes['PastRoundUpItem'] | ResolversTypes['PastRoundUpMatchInvestmentItem'] | ResolversTypes['PastSecurityLiquidationInvestmentItem'] | ResolversTypes['PastSmartDepositInvestmentItem'] | ResolversTypes['PastSpendItem'] | ResolversTypes['PastWithdrawalInvestmentItem'] | ResolversTypes['SaveInterestPaidItem'] | ResolversTypes['SaveTransferInItem'] | ResolversTypes['SaveTransferOutItem'] | ResolversTypes['SpendATMReimbursementItem'] | ResolversTypes['SpendATMWithdrawalItem'] | ResolversTypes['SpendBillPayItem'] | ResolversTypes['SpendCheckDepositItem'] | ResolversTypes['SpendCheckPaymentItem'] | ResolversTypes['SpendDigitalWalletItem'] | ResolversTypes['SpendDirectDepositItem'] | ResolversTypes['SpendECheckItem'] | ResolversTypes['SpendInterestPaidItem'] | ResolversTypes['SpendPurchaseItem'] | ResolversTypes['SpendRealTimeRoundUpItem'] | ResolversTypes['SpendTransferInItem'] | ResolversTypes['SpendTransferOutItem'];
  PastItemConnection: ResolverTypeWrapper<PastItemConnection>;
  PastItemEdge: ResolverTypeWrapper<PastItemEdge>;
  PastItemStatus: PastItemStatus;
  PastItemsAccountFilter: PastItemsAccountFilter;
  PastLaterSummary: ResolverTypeWrapper<PastLaterSummary>;
  PastLumpSumInvestment: ResolverTypeWrapper<PastLumpSumInvestment>;
  PastMatchInvestmentItem: ResolverTypeWrapper<PastMatchInvestmentItem>;
  PastMatchRemovalInvestmentItem: ResolverTypeWrapper<PastMatchRemovalInvestmentItem>;
  PastMoneyManagerAllocation: ResolverTypeWrapper<PastMoneyManagerAllocation>;
  PastMoneyManagerAllocations: ResolversTypes['PastMoneyManagerRecurrenceItem'] | ResolversTypes['PastMoneyManagerScheduledPaycheckItem'];
  PastMoneyManagerRecurrenceItem: ResolverTypeWrapper<PastMoneyManagerRecurrenceItem>;
  PastMoneyManagerScheduledPaycheckItem: ResolverTypeWrapper<PastMoneyManagerScheduledPaycheckItem>;
  PastOutsideContributionInvestmentItem: ResolverTypeWrapper<PastOutsideContributionInvestmentItem>;
  PastRealTimeRoundUpInvestmentItem: ResolverTypeWrapper<PastRealTimeRoundUpInvestmentItem>;
  PastRebalanceInvestmentItem: ResolverTypeWrapper<PastRebalanceInvestmentItem>;
  PastRecurrenceItem: ResolverTypeWrapper<PastRecurrenceItem>;
  PastRecurrenceItemV2: ResolverTypeWrapper<PastRecurrenceItemV2>;
  PastRecurrenceSettings: ResolverTypeWrapper<PastRecurrenceSettings>;
  PastRecurrenceSettingsV2: ResolverTypeWrapper<PastRecurrenceSettingsV2>;
  PastRecurringInvestmentItem: ResolverTypeWrapper<PastRecurringInvestmentItem>;
  PastReferralRewardInvestmentItem: ResolverTypeWrapper<PastReferralRewardInvestmentItem>;
  PastReferralRewardMatchInvestmentItem: ResolverTypeWrapper<PastReferralRewardMatchInvestmentItem>;
  PastRefundInvestmentItem: ResolverTypeWrapper<PastRefundInvestmentItem>;
  PastReversalInvestmentItem: ResolverTypeWrapper<PastReversalInvestmentItem>;
  PastRewardInvestmentItem: ResolverTypeWrapper<PastRewardInvestmentItem>;
  PastRewardMatchInvestmentItem: ResolverTypeWrapper<PastRewardMatchInvestmentItem>;
  PastRoundUpItem: ResolverTypeWrapper<PastRoundUpItem>;
  PastRoundUpMatchInvestmentItem: ResolverTypeWrapper<PastRoundUpMatchInvestmentItem>;
  PastScheduledItem: ResolversTypes['PastRecurrenceItem'] | ResolversTypes['PastSplitDepositItem'];
  PastScheduledItemV2: ResolversTypes['PastMoneyManagerRecurrenceItem'] | ResolversTypes['PastMoneyManagerScheduledPaycheckItem'] | ResolversTypes['PastRecurrenceItemV2'] | ResolversTypes['PastSplitDepositItemV2'];
  PastSecurityLiquidationInvestmentItem: ResolverTypeWrapper<PastSecurityLiquidationInvestmentItem>;
  PastSmartDepositInvestmentItem: ResolverTypeWrapper<PastSmartDepositInvestmentItem>;
  PastSpendItem: ResolverTypeWrapper<PastSpendItem>;
  PastSpendSummary: ResolverTypeWrapper<PastSpendSummary>;
  PastSplitDepositAllocationSettings: ResolverTypeWrapper<PastSplitDepositAllocationSettings>;
  PastSplitDepositAllocationSettingsV2: ResolverTypeWrapper<PastSplitDepositAllocationSettingsV2>;
  PastSplitDepositAllocations: ResolverTypeWrapper<PastSplitDepositAllocations>;
  PastSplitDepositAllocationsV2: ResolverTypeWrapper<PastSplitDepositAllocationsV2>;
  PastSplitDepositItem: ResolverTypeWrapper<PastSplitDepositItem>;
  PastSplitDepositItemV2: ResolverTypeWrapper<PastSplitDepositItemV2>;
  PastSummary: ResolversTypes['AllAccountHistorySummary'] | ResolversTypes['CheckingHistorySummary'] | ResolversTypes['EarlyHistorySummary'] | ResolversTypes['EmergencyFundHistorySummary'] | ResolversTypes['InvestHistorySummary'] | ResolversTypes['LaterHistorySummary'];
  PastSummaryFilter: PastSummaryFilter;
  PastTargetedTransferItem: ResolversTypes['PastBeneficiaryTransferInvestmentItem'] | ResolversTypes['PastCashOwedCollectionInvestmentItem'] | ResolversTypes['PastCashReinvestmentInvestmentItem'] | ResolversTypes['PastDividendInvestmentItem'] | ResolversTypes['PastEmployeeContributionInvestmentItem'] | ResolversTypes['PastExternalTransferInvestmentItem'] | ResolversTypes['PastExternalTransferReversedInvestmentItem'] | ResolversTypes['PastFeeInvestmentItem'] | ResolversTypes['PastGiftCardInvestmentItem'] | ResolversTypes['PastIRATransferInvestmentItem'] | ResolversTypes['PastLumpSumInvestment'] | ResolversTypes['PastMatchInvestmentItem'] | ResolversTypes['PastMatchRemovalInvestmentItem'] | ResolversTypes['PastOutsideContributionInvestmentItem'] | ResolversTypes['PastRealTimeRoundUpInvestmentItem'] | ResolversTypes['PastRecurringInvestmentItem'] | ResolversTypes['PastReferralRewardInvestmentItem'] | ResolversTypes['PastReferralRewardMatchInvestmentItem'] | ResolversTypes['PastRefundInvestmentItem'] | ResolversTypes['PastReversalInvestmentItem'] | ResolversTypes['PastRewardInvestmentItem'] | ResolversTypes['PastRewardMatchInvestmentItem'] | ResolversTypes['PastRoundUpItem'] | ResolversTypes['PastRoundUpMatchInvestmentItem'] | ResolversTypes['PastSecurityLiquidationInvestmentItem'] | ResolversTypes['PastSmartDepositInvestmentItem'] | ResolversTypes['PastSpendItem'] | ResolversTypes['PastWithdrawalInvestmentItem'] | ResolversTypes['SaveInterestPaidItem'] | ResolversTypes['SaveTransferInItem'] | ResolversTypes['SaveTransferOutItem'] | ResolversTypes['SpendATMReimbursementItem'] | ResolversTypes['SpendATMWithdrawalItem'] | ResolversTypes['SpendBillPayItem'] | ResolversTypes['SpendCheckDepositItem'] | ResolversTypes['SpendCheckPaymentItem'] | ResolversTypes['SpendDigitalWalletItem'] | ResolversTypes['SpendDirectDepositItem'] | ResolversTypes['SpendECheckItem'] | ResolversTypes['SpendInterestPaidItem'] | ResolversTypes['SpendPurchaseItem'] | ResolversTypes['SpendRealTimeRoundUpItem'] | ResolversTypes['SpendTransferInItem'] | ResolversTypes['SpendTransferOutItem'];
  PastUserTransferItem: ResolversTypes['CoreInvestmentItem'] | ResolversTypes['CoreRoundUpsItem'] | ResolversTypes['CoreWithdrawalItem'] | ResolversTypes['EarlyInvestmentItem'] | ResolversTypes['EarlyWithdrawalItem'] | ResolversTypes['LaterInvestmentItem'] | ResolversTypes['LaterWithdrawalItem'] | ResolversTypes['SaveTransferInItem'] | ResolversTypes['SaveTransferOutItem'] | ResolversTypes['SpendTransferInItem'] | ResolversTypes['SpendTransferOutItem'];
  PastWithdrawalInvestmentItem: ResolverTypeWrapper<PastWithdrawalInvestmentItem>;
  PayoutRelationshipResult: ResolverTypeWrapper<PayoutRelationshipResult>;
  PdfDownloadUrlInput: PdfDownloadUrlInput;
  PdfDownloadUrlPayload: ResolverTypeWrapper<PdfDownloadUrlPayload>;
  Performance: ResolverTypeWrapper<Performance>;
  PersonalInfoInput: PersonalInfoInput;
  Phone: ResolverTypeWrapper<Phone>;
  PhoneAuthenticator: ResolverTypeWrapper<PhoneAuthenticator>;
  PhoneNumber: ResolverTypeWrapper<Scalars['PhoneNumber']>;
  PhoneNumberOptedOutException: ResolverTypeWrapper<PhoneNumberOptedOutException>;
  PhoneRedirect: ResolverTypeWrapper<PhoneRedirect>;
  PinwheelLinkTokenRequiredJobs: PinwheelLinkTokenRequiredJobs;
  PlaidLayerLinkSession: ResolverTypeWrapper<PlaidLayerLinkSession>;
  Platform: Platform;
  PoliciesRecordDoesNotExistException: ResolverTypeWrapper<PoliciesRecordDoesNotExistException>;
  Policy: ResolverTypeWrapper<Policy>;
  PolicyNotAddedException: ResolverTypeWrapper<PolicyNotAddedException>;
  Portfolio: ResolverTypeWrapper<Portfolio>;
  PortfolioAllocation: ResolverTypeWrapper<PortfolioAllocation>;
  PortfolioAlreadyRemovedError: ResolverTypeWrapper<PortfolioAlreadyRemovedError>;
  PortfolioCustomizationLevel: PortfolioCustomizationLevel;
  PortfolioHolding: ResolverTypeWrapper<PortfolioHolding>;
  PortfolioNotFoundException: ResolverTypeWrapper<PortfolioNotFoundException>;
  PortfolioNotSupportedException: ResolverTypeWrapper<PortfolioNotSupportedException>;
  PortfolioProjection: ResolverTypeWrapper<PortfolioProjection>;
  PortfolioRemovalInProgressError: ResolverTypeWrapper<PortfolioRemovalInProgressError>;
  PortfolioRiskLevel: PortfolioRiskLevel;
  PortfolioSecurity: ResolverTypeWrapper<PortfolioSecurity>;
  PortfolioSecurityAllocation: ResolverTypeWrapper<PortfolioSecurityAllocation>;
  PortfolioSecurityLimitReached: ResolverTypeWrapper<PortfolioSecurityLimitReached>;
  PortfolioTheme: PortfolioTheme;
  PortfolioUpdateFailedException: ResolverTypeWrapper<PortfolioUpdateFailedException>;
  PositiveCurrencyAmountInput: PositiveCurrencyAmountInput;
  PositiveFloat: ResolverTypeWrapper<Scalars['PositiveFloat']>;
  PreferredAccountNotEligibleError: ResolverTypeWrapper<PreferredAccountNotEligibleError>;
  PreferredAccountNotSupportedError: ResolverTypeWrapper<PreferredAccountNotSupportedError>;
  PresentableProduct: ResolverTypeWrapper<PresentableProduct>;
  PresentableWithdrawalStatus: PresentableWithdrawalStatus;
  PreviousFundingSourcePending: ResolverTypeWrapper<PreviousFundingSourcePending>;
  Product: ResolverTypeWrapper<Product>;
  ProductAccountType: ProductAccountType;
  ProductKey: ProductKey;
  ProductNotSupportedException: ResolverTypeWrapper<ProductNotSupportedException>;
  ProductSetupTipType: ProductSetupTipType;
  ProductType: ProductType;
  Profile: ResolverTypeWrapper<Profile>;
  ProfileAttribute: ProfileAttribute;
  ProfileInput: ProfileInput;
  ProgramAccountType: ProgramAccountType;
  PromoCode: ResolverTypeWrapper<PromoCode>;
  PromoCodeBusinessLine: PromoCodeBusinessLine;
  PromoCodeCustomer: ResolverTypeWrapper<PromoCodeCustomer>;
  PromoCodeEdge: ResolverTypeWrapper<PromoCodeEdge>;
  PromoCodeFieldLengthError: ResolverTypeWrapper<PromoCodeFieldLengthError>;
  PromoCodePaginatedFilter: PromoCodePaginatedFilter;
  PromoCodePaginatedInfo: ResolverTypeWrapper<PromoCodePaginatedInfo>;
  PromoCodeQualificationAction: PromoCodeQualificationAction;
  PromoCodeReward: ResolverTypeWrapper<PromoCodeReward>;
  PromoCodeRewardEdge: ResolverTypeWrapper<PromoCodeRewardEdge>;
  PromoCodeRewardType: PromoCodeRewardType;
  PromoCodeRewardsConnection: ResolverTypeWrapper<PromoCodeRewardsConnection>;
  PromoCodeStatus: PromoCodeStatus;
  PromoCodesConnection: ResolverTypeWrapper<PromoCodesConnection>;
  PromoOffer: ResolverTypeWrapper<PromoOffer>;
  PromotedBenefit: ResolverTypeWrapper<PromotedBenefit>;
  PromotedCampaigns: ResolverTypeWrapper<PromotedCampaigns>;
  Promotion: ResolverTypeWrapper<Omit<Promotion, 'offering'> & { offering: ResolversTypes['Offering'] }>;
  PromotionConsumedError: ResolverTypeWrapper<PromotionConsumedError>;
  PromotionDuration: ResolverTypeWrapper<PromotionDuration>;
  PromotionDurationPeriod: PromotionDurationPeriod;
  PromotionExpiredError: ResolverTypeWrapper<PromotionExpiredError>;
  PromotionFilterInput: PromotionFilterInput;
  PromotionNotFoundError: ResolverTypeWrapper<PromotionNotFoundError>;
  PromotionPresentInContextsFilterInput: PromotionPresentInContextsFilterInput;
  PromotionalWaiver: ResolverTypeWrapper<PromotionalWaiver>;
  PromotionalWaiver_V2: ResolverTypeWrapper<PromotionalWaiver_V2>;
  Prospect: ResolversTypes['GrowProspect'] | ResolversTypes['LaterWaitlistProspect'] | ResolversTypes['OutsideContributionProspect'];
  ProspectType: ProspectType;
  ProvisionalWaiver: ResolverTypeWrapper<ProvisionalWaiver>;
  ProvisionalWaiver_V2: ResolverTypeWrapper<ProvisionalWaiver_V2>;
  PublishedCampaignStatus: PublishedCampaignStatus;
  PushAuthChallenge: ResolverTypeWrapper<PushAuthChallenge>;
  PushAuthenticator: ResolverTypeWrapper<PushAuthenticator>;
  PushAuthenticatorAlreadyExistsException: ResolverTypeWrapper<PushAuthenticatorAlreadyExistsException>;
  QualificationSubTypeMismatchError: ResolverTypeWrapper<QualificationSubTypeMismatchError>;
  Query: ResolverTypeWrapper<{}>;
  Quiz: ResolverTypeWrapper<Omit<Quiz, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: Maybe<ResolversTypes['LearnVisualAsset']>, theme: ResolversTypes['QuizTheme'] }>;
  QuizLocked: ResolverTypeWrapper<Omit<QuizLocked, 'duration' | 'featuredImage'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: Maybe<ResolversTypes['LearnVisualAsset']> }>;
  QuizPreview: ResolverTypeWrapper<Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], quizTheme: ResolversTypes['QuizTheme'] }>;
  QuizPreviewLocked: ResolverTypeWrapper<Omit<QuizPreviewLocked, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversTypes['LearnContentDuration'], featuredImage: ResolversTypes['LearnVisualAsset'], quizTheme: ResolversTypes['QuizTheme'] }>;
  QuizTheme: ResolverTypeWrapper<ResolversUnionTypes['QuizTheme']>;
  RateLimitDoesNotExistException: ResolverTypeWrapper<RateLimitDoesNotExistException>;
  RateLimitStatus: ResolverTypeWrapper<RateLimitStatus>;
  RawLinkSession: ResolverTypeWrapper<RawLinkSession>;
  RdvRequiredUserAlert: ResolverTypeWrapper<RdvRequiredUserAlert>;
  RdvVerificationRequired: ResolverTypeWrapper<RdvVerificationRequired>;
  RdvsNotTriggered: ResolverTypeWrapper<RdvsNotTriggered>;
  ReadMessageInput: ReadMessageInput;
  RebalanceAlreadyExecutedError: ResolverTypeWrapper<RebalanceAlreadyExecutedError>;
  RebalanceSourceInsufficientBalanceError: ResolverTypeWrapper<RebalanceSourceInsufficientBalanceError>;
  RecaptchaException: ResolverTypeWrapper<RecaptchaException>;
  RecommendedInvestingStrategy: ResolverTypeWrapper<RecommendedInvestingStrategy>;
  RecordDoesNotExistError: ResolverTypeWrapper<RecordDoesNotExistError>;
  RecordInvestmentAccountRecapViewInput: RecordInvestmentAccountRecapViewInput;
  RecordInvestmentAccountRecapViewResult: ResolverTypeWrapper<ResolversUnionTypes['RecordInvestmentAccountRecapViewResult']>;
  RecordReferralEventInput: RecordReferralEventInput;
  RecordReferralEventResult: ResolverTypeWrapper<ResolversUnionTypes['RecordReferralEventResult']>;
  RecordVendorExternalTransactionInput: RecordVendorExternalTransactionInput;
  RecordVendorExternalTransactionResult: ResolverTypeWrapper<ResolversUnionTypes['RecordVendorExternalTransactionResult']>;
  RecurrenceFrequency: RecurrenceFrequency;
  RecurrenceRule: ResolverTypeWrapper<RecurrenceRule>;
  RecurrenceRuleInput: RecurrenceRuleInput;
  RecurringInvestmentInput: RecurringInvestmentInput;
  RecurringInvestmentPayload: ResolverTypeWrapper<RecurringInvestmentPayload>;
  RecurringInvestmentSettings: ResolverTypeWrapper<RecurringInvestmentSettings>;
  RecurringTransfer: ResolverTypeWrapper<RecurringTransfer>;
  RecurringTransferAccount: ResolverTypeWrapper<RecurringTransferAccount>;
  RecurringTransferAccountIdFilterInput: RecurringTransferAccountIdFilterInput;
  RecurringTransferAccountInput: RecurringTransferAccountInput;
  RecurringTransferAccountType: RecurringTransferAccountType;
  RecurringTransferDate: ResolverTypeWrapper<RecurringTransferDate>;
  RecurringTransferDirection: RecurringTransferDirection;
  RecurringTransferDirectionFilterInput: RecurringTransferDirectionFilterInput;
  RecurringTransferEvent: ResolverTypeWrapper<RecurringTransferEvent>;
  RecurringTransferEventInput: RecurringTransferEventInput;
  RecurringTransferFundingSource: ResolverTypeWrapper<RecurringTransferFundingSource>;
  RecurringTransferFundingSourceInput: RecurringTransferFundingSourceInput;
  RecurringTransferFundingSourceType: RecurringTransferFundingSourceType;
  RecurringTransferPathException: ResolverTypeWrapper<RecurringTransferPathException>;
  RecurringTransferPathExceptionCase: RecurringTransferPathExceptionCase;
  RecurringTransfersFilterInput: RecurringTransfersFilterInput;
  RedeemedWaiverCoupon: ResolverTypeWrapper<RedeemedWaiverCoupon>;
  Referral: ResolverTypeWrapper<Referral>;
  ReferralCampaign: ResolverTypeWrapper<ReferralCampaign>;
  ReferralCampaignConnection: ResolverTypeWrapper<ReferralCampaignConnection>;
  ReferralCampaignEdge: ResolverTypeWrapper<ReferralCampaignEdge>;
  ReferralCampaignReward: ResolverTypeWrapper<ReferralCampaignReward>;
  ReferralCampaignRewardTarget: ReferralCampaignRewardTarget;
  ReferralCampaignRewardType: ReferralCampaignRewardType;
  ReferralCampaignV2: ResolverTypeWrapper<ReferralCampaignV2>;
  ReferralCode: ResolverTypeWrapper<Scalars['ReferralCode']>;
  ReferralEvent: ResolverTypeWrapper<ReferralEvent>;
  ReferralEventInput: ReferralEventInput;
  ReferralEventStatus: ReferralEventStatus;
  ReferralEventType: ReferralEventType;
  ReferralEventTypeV2: ReferralEventTypeV2;
  ReferralEventV2: ResolverTypeWrapper<ReferralEventV2>;
  ReferralHistory: ResolverTypeWrapper<ReferralHistory>;
  ReferralPaginatedFilter: ReferralPaginatedFilter;
  ReferralPaginatedInfo: ResolverTypeWrapper<ReferralPaginatedInfo>;
  ReferralPayout: ResolverTypeWrapper<ReferralPayout>;
  ReferralPayoutConnection: ResolverTypeWrapper<ReferralPayoutConnection>;
  ReferralPayoutEdge: ResolverTypeWrapper<ReferralPayoutEdge>;
  ReferralPayoutExistsError: ResolverTypeWrapper<ReferralPayoutExistsError>;
  ReferralPayoutRelationship: ResolverTypeWrapper<ReferralPayoutRelationship>;
  ReferralPayoutStatus: ReferralPayoutStatus;
  ReferralPayoutsFilter: ReferralPayoutsFilter;
  ReferralRelationship: ResolverTypeWrapper<ReferralRelationship>;
  ReferralRelationshipConnection: ResolverTypeWrapper<ReferralRelationshipConnection>;
  ReferralRelationshipEdge: ResolverTypeWrapper<ReferralRelationshipEdge>;
  ReferralRelationshipMissingError: ResolverTypeWrapper<ReferralRelationshipMissingError>;
  ReferralRelationshipStatus: ReferralRelationshipStatus;
  ReferralRelationshipsFilter: ReferralRelationshipsFilter;
  ReferralReward: ResolverTypeWrapper<ReferralReward>;
  ReferralRewardEdge: ResolverTypeWrapper<ReferralRewardEdge>;
  ReferralRewardStatus: ReferralRewardStatus;
  ReferralRewardSummary: ResolverTypeWrapper<ReferralRewardSummary>;
  ReferralRewardUpdateStatus: ReferralRewardUpdateStatus;
  ReferralRewardsConnection: ResolverTypeWrapper<ReferralRewardsConnection>;
  ReferralStatus: ReferralStatus;
  ReferralUserUpdateInput: ReferralUserUpdateInput;
  ReferralValueType: ReferralValueType;
  RefreshAuthTokenInput: RefreshAuthTokenInput;
  RefreshAuthTokenRateLimitedException: ResolverTypeWrapper<RefreshAuthTokenRateLimitedException>;
  RefreshAuthTokenResult: ResolverTypeWrapper<ResolversUnionTypes['RefreshAuthTokenResult']>;
  RefreshTokenNotFoundException: ResolverTypeWrapper<RefreshTokenNotFoundException>;
  RefundBankAccount: ResolverTypeWrapper<RefundBankAccount>;
  RegenerateInvestmentAccountRecapPublicTokenInput: RegenerateInvestmentAccountRecapPublicTokenInput;
  RegenerateInvestmentAccountRecapPublicTokenResult: ResolverTypeWrapper<ResolversUnionTypes['RegenerateInvestmentAccountRecapPublicTokenResult']>;
  RegisterAccountTypeResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterAccountTypeResult']>;
  RegisterAccountTypeResultTemporaryImpl: ResolverTypeWrapper<RegisterAccountTypeResultTemporaryImpl>;
  RegisterCredentialsInput: RegisterCredentialsInput;
  RegisterCredentialsResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterCredentialsResult']>;
  RegisterDeviceTokenAndPushAuthenticatorInput: RegisterDeviceTokenAndPushAuthenticatorInput;
  RegisterDeviceTokenAndPushAuthenticatorResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterDeviceTokenAndPushAuthenticatorResult']>;
  RegisterEmailAuthenticatorInput: RegisterEmailAuthenticatorInput;
  RegisterEmailAuthenticatorResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterEmailAuthenticatorResult']>;
  RegisterLayerLinkSessionResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterLayerLinkSessionResult']>;
  RegisterLinkSessionResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterLinkSessionResult']>;
  RegisterOidcCredentialsInput: RegisterOidcCredentialsInput;
  RegisterOidcCredentialsResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterOidcCredentialsResult']>;
  RegisterPhoneAuthenticatorInput: RegisterPhoneAuthenticatorInput;
  RegisterPhoneAuthenticatorResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterPhoneAuthenticatorResult']>;
  RegisterPhoneAuthenticatorWithoutChallengeResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterPhoneAuthenticatorWithoutChallengeResult']>;
  RegisterProspectInput: RegisterProspectInput;
  RegisterProspectResult: ResolverTypeWrapper<ResolversUnionTypes['RegisterProspectResult']>;
  RegistrationDrawerContent: ResolverTypeWrapper<RegistrationDrawerContent>;
  RegistrationFunnel: ResolverTypeWrapper<RegistrationFunnel>;
  RegistrationFunnelFilter: RegistrationFunnelFilter;
  RegistrationInput: RegistrationInput;
  RegistrationPage: ResolverTypeWrapper<RegistrationPage>;
  RegistrationPageAction: ResolverTypeWrapper<RegistrationPageAction>;
  RegistrationPageContent: ResolversTypes['RegistrationProminenceBannerContent'];
  RegistrationProminenceBannerContent: ResolverTypeWrapper<RegistrationProminenceBannerContent>;
  ReinitiateSMSChallengeInput: ReinitiateSmsChallengeInput;
  ReinitiateSMSChallengeResult: ResolverTypeWrapper<ResolversUnionTypes['ReinitiateSMSChallengeResult']>;
  ReinvestmentReason: ReinvestmentReason;
  ReissueBankCardEligibility: ResolverTypeWrapper<ResolversUnionTypes['ReissueBankCardEligibility']>;
  ReissueBankCardEligible: ResolverTypeWrapper<ReissueBankCardEligible>;
  ReissueBankCardExistsError: ResolverTypeWrapper<ReissueBankCardExistsError>;
  ReissueBankCardIneligible: ResolverTypeWrapper<ReissueBankCardIneligible>;
  ReissueBankCardIneligibleIssue: ReissueBankCardIneligibleIssue;
  ReissueBankCardInput: ReissueBankCardInput;
  ReissueBankCardResult: ResolverTypeWrapper<ResolversUnionTypes['ReissueBankCardResult']>;
  RejectedReason: RejectedReason;
  RelationshipAlreadyQualifiedError: ResolverTypeWrapper<RelationshipAlreadyQualifiedError>;
  RelinkLinkedAccountAlert: ResolverTypeWrapper<RelinkLinkedAccountAlert>;
  RemoveAccountTypeResult: ResolverTypeWrapper<ResolversUnionTypes['RemoveAccountTypeResult']>;
  RemoveAccountTypeResultTemporaryImpl: ResolverTypeWrapper<RemoveAccountTypeResultTemporaryImpl>;
  RemoveCohortEligibilityInput: RemoveCohortEligibilityInput;
  RemoveCohortEligibilityResult: ResolverTypeWrapper<ResolversUnionTypes['RemoveCohortEligibilityResult']>;
  RemoveJobAlertResult: ResolverTypeWrapper<ResolversUnionTypes['RemoveJobAlertResult']>;
  RemovePolicyInput: RemovePolicyInput;
  RemovePolicyResult: ResolverTypeWrapper<ResolversUnionTypes['RemovePolicyResult']>;
  RemoveSecurityFromPortfolioInput: RemoveSecurityFromPortfolioInput;
  RemoveSecurityFromPortfolioResult: ResolverTypeWrapper<ResolversUnionTypes['RemoveSecurityFromPortfolioResult']>;
  RemoveSelfDirectedPortfolioInput: RemoveSelfDirectedPortfolioInput;
  RemoveSelfDirectedPortfolioResult: ResolverTypeWrapper<ResolversUnionTypes['RemoveSelfDirectedPortfolioResult']>;
  RemovedJobAlert: ResolverTypeWrapper<RemovedJobAlert>;
  ReopenUserAccountResult: ResolverTypeWrapper<ResolversUnionTypes['ReopenUserAccountResult']>;
  ReplayMoneyAssignmentError: ResolverTypeWrapper<ReplayMoneyAssignmentError>;
  ReplayMoneyAssignmentSuccess: ResolverTypeWrapper<ReplayMoneyAssignmentSuccess>;
  ReplayMoneyManagerMoneyAssignmentInput: ReplayMoneyManagerMoneyAssignmentInput;
  ReplayMoneyManagerMoneyAssignmentResult: ResolverTypeWrapper<ResolversUnionTypes['ReplayMoneyManagerMoneyAssignmentResult']>;
  ReportBankCardLostStolenInput: ReportBankCardLostStolenInput;
  ReportBankCardLostStolenPayload: ResolverTypeWrapper<ReportBankCardLostStolenPayload>;
  RequestAccountClosureInput: RequestAccountClosureInput;
  RequestEarlyAccountClosureInput: RequestEarlyAccountClosureInput;
  RequestEarlyAccountClosureResult: ResolverTypeWrapper<ResolversUnionTypes['RequestEarlyAccountClosureResult']>;
  RequestInvestmentAccountReopenInput: RequestInvestmentAccountReopenInput;
  RequestInvestmentAccountReopenResult: ResolverTypeWrapper<ResolversUnionTypes['RequestInvestmentAccountReopenResult']>;
  RequestLayerSessionInput: RequestLayerSessionInput;
  RequestLayerSessionResult: ResolverTypeWrapper<ResolversUnionTypes['RequestLayerSessionResult']>;
  RequestSubscriptionMigrationWaiverInput: RequestSubscriptionMigrationWaiverInput;
  RequestSubscriptionMigrationWaiverResult: ResolverTypeWrapper<ResolversUnionTypes['RequestSubscriptionMigrationWaiverResult']>;
  RequestVersions: RequestVersions;
  RequestedLayerLinkSession: ResolverTypeWrapper<RequestedLayerLinkSession>;
  ResendChatMessageResponse: ResolverTypeWrapper<ResolversUnionTypes['ResendChatMessageResponse']>;
  ResetPasswordByTokenException: ResolverTypeWrapper<ResetPasswordByTokenException>;
  ResetPasswordByTokenInput: ResetPasswordByTokenInput;
  ResetPasswordByTokenResult: ResolverTypeWrapper<ResolversUnionTypes['ResetPasswordByTokenResult']>;
  ResetPasswordByTokenSuccess: ResolverTypeWrapper<ResetPasswordByTokenSuccess>;
  ResetPasswordWithTokenInput: ResetPasswordWithTokenInput;
  ResetPasswordWithTokenResult: ResolverTypeWrapper<ResolversUnionTypes['ResetPasswordWithTokenResult']>;
  ResetPasswordWithTokenSuccess: ResolverTypeWrapper<ResetPasswordWithTokenSuccess>;
  ResetRateLimitResult: ResolverTypeWrapper<ResolversUnionTypes['ResetRateLimitResult']>;
  ResetRateLimitSuccess: ResolverTypeWrapper<ResetRateLimitSuccess>;
  ResourceNotFoundError: ResolverTypeWrapper<ResourceNotFoundError>;
  RespondToLearnPollInput: RespondToLearnPollInput;
  RespondToLearnPollResult: ResolverTypeWrapper<ResolversUnionTypes['RespondToLearnPollResult']>;
  RestoreLoginAccessInput: RestoreLoginAccessInput;
  RestoreLoginAccessResult: ResolverTypeWrapper<ResolversUnionTypes['RestoreLoginAccessResult']>;
  Result: ResolverTypeWrapper<Result>;
  RetirementPlanAccess: RetirementPlanAccess;
  RetriggerRdvsResult: ResolverTypeWrapper<ResolversUnionTypes['RetriggerRdvsResult']>;
  ReturnedCheckDeposit: ResolverTypeWrapper<ReturnedCheckDeposit>;
  RevenueScheduleType: RevenueScheduleType;
  RevokeAccessReasons: RevokeAccessReasons;
  RevokeLoginAccessInput: RevokeLoginAccessInput;
  RevokeLoginAccessResult: ResolverTypeWrapper<ResolversUnionTypes['RevokeLoginAccessResult']>;
  RevokePasswordResetTokenInput: RevokePasswordResetTokenInput;
  RevokePasswordResetTokenResult: ResolverTypeWrapper<ResolversUnionTypes['RevokePasswordResetTokenResult']>;
  RevokePasswordResetTokenSuccess: ResolverTypeWrapper<RevokePasswordResetTokenSuccess>;
  RiskStatus: RiskStatus;
  RoundUp: ResolverTypeWrapper<RoundUp>;
  RoundUpAccount: ResolverTypeWrapper<RoundUpAccount>;
  RoundUpProfile: ResolverTypeWrapper<RoundUpProfile>;
  RoundUpProfileInput: RoundUpProfileInput;
  RoundUpState: RoundUpState;
  RoundUpType: RoundUpType;
  RoundUpTypeEdge: ResolverTypeWrapper<RoundUpTypeEdge>;
  RoundUpTypePagination: ResolverTypeWrapper<RoundUpTypePagination>;
  RoutingNumber: ResolverTypeWrapper<Scalars['RoutingNumber']>;
  SMSAuthChallenge: ResolverTypeWrapper<SmsAuthChallenge>;
  SSNDocumentRequestedUserAlert: ResolverTypeWrapper<SsnDocumentRequestedUserAlert>;
  SSNStorageResult: SsnStorageResult;
  SalaryInterval: SalaryInterval;
  SamePasswordsException: ResolverTypeWrapper<SamePasswordsException>;
  SampleMailInDocument: ResolverTypeWrapper<SampleMailInDocument>;
  SaveInterestPaidItem: ResolverTypeWrapper<SaveInterestPaidItem>;
  SaveTransferInItem: ResolverTypeWrapper<SaveTransferInItem>;
  SaveTransferOutItem: ResolverTypeWrapper<SaveTransferOutItem>;
  SaveUploadUrlInput: SaveUploadUrlInput;
  SaveUploadUrlsInput: SaveUploadUrlsInput;
  SaveUploadUrlsResult: ResolverTypeWrapper<ResolversUnionTypes['SaveUploadUrlsResult']>;
  SavingsAccountEligibility: ResolverTypeWrapper<SavingsAccountEligibility>;
  SavingsAccountEligibilityRequirement: SavingsAccountEligibilityRequirement;
  SavingsAccountType: SavingsAccountType;
  ScheduleInput: ScheduleInput;
  ScheduleRecurringTransferInput: ScheduleRecurringTransferInput;
  ScheduleRecurringTransferResult: ResolverTypeWrapper<ResolversUnionTypes['ScheduleRecurringTransferResult']>;
  ScheduleResult: ResolverTypeWrapper<ScheduleResult>;
  ScheduleType: ScheduleType;
  Scope: ResolverTypeWrapper<Scope>;
  SearchEmployersInput: SearchEmployersInput;
  SearchEmployersPayload: ResolverTypeWrapper<SearchEmployersPayload>;
  SearchHistory: ResolverTypeWrapper<SearchHistory>;
  SearchSecuritiesInput: SearchSecuritiesInput;
  SearchSecuritiesOrderBy: SearchSecuritiesOrderBy;
  SearchSecuritiesPageInfo: ResolverTypeWrapper<SearchSecuritiesPageInfo>;
  SearchSecuritiesResponse: ResolverTypeWrapper<SearchSecuritiesResponse>;
  SearchSupportArticleResult: ResolverTypeWrapper<SearchSupportArticleResult>;
  SearchSupportResult: ResolverTypeWrapper<SearchSupportResult>;
  SearchTermCategory: SearchTermCategory;
  SecretSquirrelException: ResolverTypeWrapper<SecretSquirrelException>;
  SecuritiesBySectorInput: SecuritiesBySectorInput;
  SecuritiesBySectorOrderBY: SecuritiesBySectorOrderBy;
  SecuritiesBySectorPageInfo: ResolverTypeWrapper<SecuritiesBySectorPageInfo>;
  SecuritiesBySectorResponse: ResolverTypeWrapper<SecuritiesBySectorResponse>;
  SecuritiesBySymbolsInput: SecuritiesBySymbolsInput;
  SecuritiesBySymbolsResponse: ResolverTypeWrapper<SecuritiesBySymbolsResponse>;
  Security: ResolversTypes['Fund'] | ResolversTypes['Stock'];
  SecurityAllocationTarget: SecurityAllocationTarget;
  SecurityAnswer: SecurityAnswer;
  SecurityBySymbolInput: SecurityBySymbolInput;
  SecurityDiversificationInfo: ResolverTypeWrapper<SecurityDiversificationInfo>;
  SecurityGain: ResolverTypeWrapper<SecurityGain>;
  SecurityHeadline: ResolverTypeWrapper<SecurityHeadline>;
  SecurityNotSupportedException: ResolverTypeWrapper<SecurityNotSupportedException>;
  SecurityPerformance: ResolverTypeWrapper<SecurityPerformance>;
  SecurityPerformanceBySymbolInput: SecurityPerformanceBySymbolInput;
  SecurityPerformancesBySymbolInput: SecurityPerformancesBySymbolInput;
  SecurityPrice: ResolverTypeWrapper<SecurityPrice>;
  SecurityProfile: ResolverTypeWrapper<SecurityProfile>;
  SecurityType: SecurityType;
  SelfDirectedPortfolio: ResolverTypeWrapper<SelfDirectedPortfolio>;
  SelfDirectedPortfolioStatus: SelfDirectedPortfolioStatus;
  SendBrazeEventInput: SendBrazeEventInput;
  SendChatMessageResponse: ResolverTypeWrapper<ResolversUnionTypes['SendChatMessageResponse']>;
  SendCheckPaymentInput: SendCheckPaymentInput;
  SendCheckPaymentResult: ResolverTypeWrapper<ResolversUnionTypes['SendCheckPaymentResult']>;
  Session: ResolverTypeWrapper<Session>;
  SessionType: SessionType;
  SetAuthenticationPINInput: SetAuthenticationPinInput;
  SetAuthenticationPINResult: ResolverTypeWrapper<ResolversUnionTypes['SetAuthenticationPINResult']>;
  SetAuthenticationPINSuccess: ResolverTypeWrapper<SetAuthenticationPinSuccess>;
  SetBeneficiarySsnResult: ResolverTypeWrapper<ResolversUnionTypes['SetBeneficiarySsnResult']>;
  SetDefaultAuthenticatorInput: SetDefaultAuthenticatorInput;
  SetDefaultAuthenticatorResult: ResolverTypeWrapper<ResolversUnionTypes['SetDefaultAuthenticatorResult']>;
  SetInvestmentAccountRecapPublicAccessInput: SetInvestmentAccountRecapPublicAccessInput;
  SetInvestmentAccountRecapPublicAccessResult: ResolverTypeWrapper<ResolversUnionTypes['SetInvestmentAccountRecapPublicAccessResult']>;
  SetLinkingErrorInput: SetLinkingErrorInput;
  SetNegotiationStatusInput: SetNegotiationStatusInput;
  SetNegotiationStatusResult: ResolverTypeWrapper<SetNegotiationStatusResult>;
  SetPortfolioInput: SetPortfolioInput;
  SetPreferredWithdrawalAccountInput: SetPreferredWithdrawalAccountInput;
  SetPreferredWithdrawalAccountResult: ResolverTypeWrapper<ResolversUnionTypes['SetPreferredWithdrawalAccountResult']>;
  SetReferralCampaignFlagsInput: SetReferralCampaignFlagsInput;
  SetReferralCampaignFlagsResult: ResolverTypeWrapper<SetReferralCampaignFlagsResult>;
  SetUpTip: ResolverTypeWrapper<SetUpTip>;
  Settings: ResolverTypeWrapper<Settings>;
  Signature: ResolverTypeWrapper<Signature>;
  SignatureType: SignatureType;
  SiteWideBannerContent: ResolverTypeWrapper<SiteWideBannerContent>;
  SiteWideBannerContentInput: SiteWideBannerContentInput;
  SmartDepositMetadataInput: SmartDepositMetadataInput;
  SmartDepositMetadataResult: ResolverTypeWrapper<SmartDepositMetadataResult>;
  SourceAccountsFilterInput: SourceAccountsFilterInput;
  SourceAttributes: ResolverTypeWrapper<SourceAttributes>;
  SourceAttributesInput: SourceAttributesInput;
  SpendATMReimbursementItem: ResolverTypeWrapper<SpendAtmReimbursementItem>;
  SpendATMWithdrawalItem: ResolverTypeWrapper<SpendAtmWithdrawalItem>;
  SpendAccount: ResolverTypeWrapper<SpendAccount>;
  SpendAccountStatus: SpendAccountStatus;
  SpendAlert: ResolversTypes['SystemCardLockedSpendAlert'] | ResolversTypes['UserCardLockedSpendAlert'];
  SpendAtm: ResolverTypeWrapper<SpendAtm>;
  SpendAtmAddress: ResolverTypeWrapper<SpendAtmAddress>;
  SpendAtmVendorUnavailableError: ResolverTypeWrapper<SpendAtmVendorUnavailableError>;
  SpendAtmsCoordinateInput: SpendAtmsCoordinateInput;
  SpendAtmsInput: SpendAtmsInput;
  SpendAtmsPayload: ResolverTypeWrapper<SpendAtmsPayload>;
  SpendAtmsResult: ResolverTypeWrapper<ResolversUnionTypes['SpendAtmsResult']>;
  SpendBillPayItem: ResolverTypeWrapper<SpendBillPayItem>;
  SpendCheckDepositItem: ResolverTypeWrapper<SpendCheckDepositItem>;
  SpendCheckPaymentItem: ResolverTypeWrapper<SpendCheckPaymentItem>;
  SpendDigitalWalletItem: ResolverTypeWrapper<SpendDigitalWalletItem>;
  SpendDirectDepositItem: ResolverTypeWrapper<SpendDirectDepositItem>;
  SpendDisputesResponse: ResolverTypeWrapper<SpendDisputesResponse>;
  SpendECheckItem: ResolverTypeWrapper<SpendECheckItem>;
  SpendInterestPaidItem: ResolverTypeWrapper<SpendInterestPaidItem>;
  SpendItem: ResolversTypes['PastSpendItem'] | ResolversTypes['SaveInterestPaidItem'] | ResolversTypes['SaveTransferInItem'] | ResolversTypes['SaveTransferOutItem'] | ResolversTypes['SpendATMReimbursementItem'] | ResolversTypes['SpendATMWithdrawalItem'] | ResolversTypes['SpendBillPayItem'] | ResolversTypes['SpendCheckDepositItem'] | ResolversTypes['SpendCheckPaymentItem'] | ResolversTypes['SpendDigitalWalletItem'] | ResolversTypes['SpendDirectDepositItem'] | ResolversTypes['SpendECheckItem'] | ResolversTypes['SpendInterestPaidItem'] | ResolversTypes['SpendPurchaseItem'] | ResolversTypes['SpendRealTimeRoundUpItem'] | ResolversTypes['SpendTransferInItem'] | ResolversTypes['SpendTransferOutItem'];
  SpendPurchaseItem: ResolverTypeWrapper<SpendPurchaseItem>;
  SpendRealTimeRoundUpItem: ResolverTypeWrapper<SpendRealTimeRoundUpItem>;
  SpendTransactionsDisputeCustomersResponse: ResolverTypeWrapper<SpendTransactionsDisputeCustomersResponse>;
  SpendTransactionsDisputeQuestions: ResolverTypeWrapper<SpendTransactionsDisputeQuestions>;
  SpendTransactionsDisputeResponse: ResolverTypeWrapper<SpendTransactionsDisputeResponse>;
  SpendTransactionsDisputeResult: ResolverTypeWrapper<ResolversUnionTypes['SpendTransactionsDisputeResult']>;
  SpendTransactionsInput: SpendTransactionsInput;
  SpendTransactionsResponse: ResolverTypeWrapper<SpendTransactionsResponse>;
  SpendTransferInItem: ResolverTypeWrapper<SpendTransferInItem>;
  SpendTransferOutItem: ResolverTypeWrapper<SpendTransferOutItem>;
  SplitDeposit: ResolverTypeWrapper<SplitDeposit>;
  SplitDepositAllocation: ResolversTypes['SplitDepositDirectDepositAllocation'] | ResolversTypes['SplitDepositRecurrenceAllocation'];
  SplitDepositAllocationInput: SplitDepositAllocationInput;
  SplitDepositDailyRecurrenceRule: ResolverTypeWrapper<SplitDepositDailyRecurrenceRule>;
  SplitDepositDirectDepositAllocation: ResolverTypeWrapper<SplitDepositDirectDepositAllocation>;
  SplitDepositDirectDepositIntentSetting: ResolverTypeWrapper<SplitDepositDirectDepositIntentSetting>;
  SplitDepositDirectDepositSetting: ResolverTypeWrapper<SplitDepositDirectDepositSetting>;
  SplitDepositMonthlyRecurrenceRule: ResolverTypeWrapper<SplitDepositMonthlyRecurrenceRule>;
  SplitDepositMutation: ResolverTypeWrapper<SplitDepositMutation>;
  SplitDepositNormalizationFrequency: SplitDepositNormalizationFrequency;
  SplitDepositRecurrenceAllocation: ResolverTypeWrapper<SplitDepositRecurrenceAllocation>;
  SplitDepositRecurrenceFrequency: SplitDepositRecurrenceFrequency;
  SplitDepositRecurrenceRule: ResolversTypes['SplitDepositDailyRecurrenceRule'] | ResolversTypes['SplitDepositMonthlyRecurrenceRule'] | ResolversTypes['SplitDepositWeeklyRecurrenceRule'];
  SplitDepositRecurrenceSetting: ResolverTypeWrapper<SplitDepositRecurrenceSetting>;
  SplitDepositSettingType: SplitDepositSettingType;
  SplitDepositSettings: ResolversTypes['SplitDepositDirectDepositIntentSetting'] | ResolversTypes['SplitDepositDirectDepositSetting'] | ResolversTypes['SplitDepositRecurrenceSetting'];
  SplitDepositSettingsFilterInput: SplitDepositSettingsFilterInput;
  SplitDepositSettingsMutation: ResolverTypeWrapper<SplitDepositSettingsMutation>;
  SplitDepositTargetAccount: ResolverTypeWrapper<SplitDepositTargetAccount>;
  SplitDepositTargetAccountType: SplitDepositTargetAccountType;
  SplitDepositWeeklyRecurrenceRule: ResolverTypeWrapper<SplitDepositWeeklyRecurrenceRule>;
  SsnAlreadyInUseException: ResolverTypeWrapper<SsnAlreadyInUseException>;
  SsnMatchesCustodianException: ResolverTypeWrapper<SsnMatchesCustodianException>;
  SsnUpdateForbiddenException: ResolverTypeWrapper<SsnUpdateForbiddenException>;
  StartAcornsPdfSwitchInput: StartAcornsPdfSwitchInput;
  StartCheckDepositInput: StartCheckDepositInput;
  StartCheckDepositPayload: ResolverTypeWrapper<StartCheckDepositPayload>;
  StartOnlineSwitchInput: StartOnlineSwitchInput;
  StartOnlineSwitchPayload: ResolverTypeWrapper<StartOnlineSwitchPayload>;
  StartSubmittableSwitchAddressInput: StartSubmittableSwitchAddressInput;
  StartSubmittableSwitchInput: StartSubmittableSwitchInput;
  StartSubmittableSwitchPayload: ResolverTypeWrapper<StartSubmittableSwitchPayload>;
  StateCode: StateCode;
  Statement: ResolverTypeWrapper<Statement>;
  StatementEdge: ResolverTypeWrapper<StatementEdge>;
  StatementLink: ResolverTypeWrapper<StatementLink>;
  StatementPagination: ResolverTypeWrapper<StatementPagination>;
  StatementPortfolioType: StatementPortfolioType;
  StatementType: StatementType;
  Stock: ResolverTypeWrapper<Stock>;
  StoredRdvDepositsInvalid: ResolverTypeWrapper<StoredRdvDepositsInvalid>;
  StoredRdvDepositsMissing: ResolverTypeWrapper<StoredRdvDepositsMissing>;
  String: ResolverTypeWrapper<Scalars['String']>;
  StringKey: ResolverTypeWrapper<Scalars['StringKey']>;
  StringKeyAsset: ResolverTypeWrapper<StringKeyAsset>;
  SubcategoryMessage: ResolverTypeWrapper<SubcategoryMessage>;
  Submission: ResolverTypeWrapper<Submission>;
  SubmissionError: ResolverTypeWrapper<SubmissionError>;
  SubmissionStatus: SubmissionStatus;
  SubmitBankFeeNegotiationInput: SubmitBankFeeNegotiationInput;
  SubmitBankFeeNegotiationResponse: ResolverTypeWrapper<SubmitBankFeeNegotiationResponse>;
  SubmitBankFeeNegotiationResult: ResolverTypeWrapper<ResolversUnionTypes['SubmitBankFeeNegotiationResult']>;
  SubmitEarnMissingCreditRequestInput: SubmitEarnMissingCreditRequestInput;
  SubmitEarnMissingCreditRequestResult: ResolverTypeWrapper<ResolversUnionTypes['SubmitEarnMissingCreditRequestResult']>;
  SubmitSpendTransactionsDisputeInput: SubmitSpendTransactionsDisputeInput;
  SubmitUserReportedBankFeeRefundInput: SubmitUserReportedBankFeeRefundInput;
  SubmitUserReportedBankFeeRefundResult: ResolverTypeWrapper<SubmitUserReportedBankFeeRefundResult>;
  SubmittableSwitch: ResolverTypeWrapper<SubmittableSwitch>;
  SubscribeToTierInput: SubscribeToTierInput;
  SubscribeToTierResult: ResolverTypeWrapper<ResolversUnionTypes['SubscribeToTierResult']>;
  SubscribeUserToTierByProductKeyInput: SubscribeUserToTierByProductKeyInput;
  SubscribeUserToTierInput: SubscribeUserToTierInput;
  SubscribeUserToTierResult: ResolverTypeWrapper<ResolversUnionTypes['SubscribeUserToTierResult']>;
  SubscriberIneligibleError: ResolverTypeWrapper<SubscriberIneligibleError>;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionMigration: ResolverTypeWrapper<SubscriptionMigration>;
  SubscriptionMigrationInvalidError: ResolverTypeWrapper<SubscriptionMigrationInvalidError>;
  SubscriptionMigrationWaiver: ResolverTypeWrapper<SubscriptionMigrationWaiver>;
  SubscriptionMigrationWaiverReason: SubscriptionMigrationWaiverReason;
  SubscriptionPaymentMethod: SubscriptionPaymentMethod;
  SubscriptionTransitionAction: SubscriptionTransitionAction;
  SucceedVendorInvoiceResult: ResolverTypeWrapper<ResolversUnionTypes['SucceedVendorInvoiceResult']>;
  SuggestedMoneyRulesResult: ResolverTypeWrapper<ResolversUnionTypes['SuggestedMoneyRulesResult']>;
  SuggestedMoneyRulesSuccess: ResolverTypeWrapper<SuggestedMoneyRulesSuccess>;
  SuitabilityAccountSubtype: SuitabilityAccountSubtype;
  SuitabilityAccountType: SuitabilityAccountType;
  SuitabilityAnswer: ResolverTypeWrapper<SuitabilityAnswer>;
  SuitabilityInput: SuitabilityInput;
  SuitabilityQuestion: ResolverTypeWrapper<SuitabilityQuestion>;
  SummaryItem: ResolverTypeWrapper<SummaryItem>;
  SupportArticle: ResolverTypeWrapper<SupportArticle>;
  SupportAuthor: ResolverTypeWrapper<SupportAuthor>;
  SupportAuthorPhoto: ResolverTypeWrapper<SupportAuthorPhoto>;
  SupportCategory: ResolverTypeWrapper<SupportCategory>;
  SupportCitation: ResolverTypeWrapper<SupportCitation>;
  SupportSection: ResolverTypeWrapper<SupportSection>;
  SupportTicket: ResolverTypeWrapper<SupportTicket>;
  SupportTicketForm: ResolverTypeWrapper<SupportTicketForm>;
  SupportTicketFormField: ResolverTypeWrapper<SupportTicketFormField>;
  SupportTicketResponse: ResolverTypeWrapper<ResolversUnionTypes['SupportTicketResponse']>;
  SupportTicketWithCustomFieldsResponse: ResolverTypeWrapper<ResolversUnionTypes['SupportTicketWithCustomFieldsResponse']>;
  SupportUser: ResolverTypeWrapper<SupportUser>;
  SupportsPlaidVerificationResult: ResolverTypeWrapper<SupportsPlaidVerificationResult>;
  SuppressMoneyManagerRebalancesError: ResolverTypeWrapper<SuppressMoneyManagerRebalancesError>;
  SuppressMoneyManagerRebalancesInput: SuppressMoneyManagerRebalancesInput;
  SuppressMoneyManagerRebalancesResult: ResolverTypeWrapper<ResolversUnionTypes['SuppressMoneyManagerRebalancesResult']>;
  SuppressMoneyManagerRebalancesSuccess: ResolverTypeWrapper<SuppressMoneyManagerRebalancesSuccess>;
  SwitchInterface: ResolversTypes['AcornsPdfSwitch'] | ResolversTypes['OnlineSwitch'] | ResolversTypes['SubmittableSwitch'];
  SwitchMethod: SwitchMethod;
  SwitchPayloadInterface: ResolversTypes['StartOnlineSwitchPayload'] | ResolversTypes['StartSubmittableSwitchPayload'];
  SwitchSource: SwitchSource;
  SwitchState: SwitchState;
  SwitchStatus: SwitchStatus;
  SwitchType: SwitchType;
  SyncBankFeeTransactionsInput: SyncBankFeeTransactionsInput;
  SyncBankFeeTransactionsResult: ResolverTypeWrapper<SyncBankFeeTransactionsResult>;
  SyncFundingSourceToVendorResult: ResolverTypeWrapper<ResolversUnionTypes['SyncFundingSourceToVendorResult']>;
  SyncSupportAccountInput: SyncSupportAccountInput;
  SyncSupportAccountResponse: ResolverTypeWrapper<SyncSupportAccountResponse>;
  SystemCardLockedSpendAlert: ResolverTypeWrapper<SystemCardLockedSpendAlert>;
  TargetAccountsFilterInput: TargetAccountsFilterInput;
  TaxApplicationStatus: TaxApplicationStatus;
  TaxFilingPartner: ResolverTypeWrapper<TaxFilingPartner>;
  TaxFormType: TaxFormType;
  TaxReturn: ResolverTypeWrapper<TaxReturn>;
  TaxReturnStatus: TaxReturnStatus;
  TaxWithholdingAmounts: ResolverTypeWrapper<TaxWithholdingAmounts>;
  TaxWithholdings: TaxWithholdings;
  TfaNotification: TfaNotification;
  TfaOptions: ResolverTypeWrapper<TfaOptions>;
  TfaStatus: TfaStatus;
  TfaType: TfaType;
  TickerSymbol: ResolverTypeWrapper<Scalars['TickerSymbol']>;
  Tier: ResolverTypeWrapper<Tier>;
  TierDowngradeAction: ResolverTypeWrapper<TierDowngradeAction>;
  TierDowngradeActionKey: TierDowngradeActionKey;
  TierDowngradeActionRequired: ResolverTypeWrapper<TierDowngradeActionRequired>;
  TierGroup: ResolverTypeWrapper<TierGroup>;
  TierKey: TierKey;
  TierOption: ResolverTypeWrapper<TierOption>;
  TierOptionByTierPriceIdResult: ResolverTypeWrapper<ResolversUnionTypes['TierOptionByTierPriceIdResult']>;
  TierPrice: ResolverTypeWrapper<TierPrice>;
  TierProduct: ResolverTypeWrapper<TierProduct>;
  TierSubscription: ResolverTypeWrapper<TierSubscription>;
  TierSubscriptionAlreadyDeactivated: ResolverTypeWrapper<TierSubscriptionAlreadyDeactivated>;
  TierSubscriptionConnection: ResolverTypeWrapper<TierSubscriptionConnection>;
  TierSubscriptionCreatedBy: TierSubscriptionCreatedBy;
  TierSubscriptionDeactivationReason: TierSubscriptionDeactivationReason;
  TierSubscriptionForUser: ResolverTypeWrapper<ResolversUnionTypes['TierSubscriptionForUser']>;
  TierSubscriptionNotFound: ResolverTypeWrapper<TierSubscriptionNotFound>;
  TierSubscriptionPageInfo: ResolverTypeWrapper<TierSubscriptionPageInfo>;
  TierSubscriptionStatus: TierSubscriptionStatus;
  TierSubscriptionTransition: ResolverTypeWrapper<TierSubscriptionTransition>;
  TierSubscriptionUnsubscribed: ResolverTypeWrapper<TierSubscriptionUnsubscribed>;
  Time: ResolverTypeWrapper<Scalars['Time']>;
  TimeFrameFilter: TimeFrameFilter;
  TimestampsInterface: ResolversTypes['Account'] | ResolversTypes['Address'] | ResolversTypes['Beneficiary'] | ResolversTypes['BillingCycle'] | ResolversTypes['Credit'] | ResolversTypes['ExecutionAudit'] | ResolversTypes['Fee'] | ResolversTypes['FeeExecution'] | ResolversTypes['FinancialInstitution'] | ResolversTypes['FundingSourceAccount'] | ResolversTypes['InvestmentAccount'] | ResolversTypes['InvestmentAccountReopenRequest'] | ResolversTypes['InvestmentAccountReopenRequestAction'] | ResolversTypes['InvestmentAccountReopenRequestNote'] | ResolversTypes['LinkedAccount'] | ResolversTypes['LinkedSubaccount'] | ResolversTypes['Liquidation'] | ResolversTypes['MatchProgram'] | ResolversTypes['OutsideContribution'] | ResolversTypes['OutsideContributionCheckoutCart'] | ResolversTypes['OutsideContributionCode'] | ResolversTypes['Phone'] | ResolversTypes['Profile'] | ResolversTypes['RecurringInvestmentSettings'] | ResolversTypes['RoundUp'] | ResolversTypes['RoundUpAccount'] | ResolversTypes['RoundUpProfile'] | ResolversTypes['Signature'] | ResolversTypes['UserInvestmentAccountReopenCheck'];
  Toggle: ResolverTypeWrapper<Toggle>;
  TokenExpiredException: ResolverTypeWrapper<TokenExpiredException>;
  TopEmployer: ResolverTypeWrapper<TopEmployer>;
  TopEmployerPayload: ResolverTypeWrapper<TopEmployerPayload>;
  TopHolding: ResolverTypeWrapper<TopHolding>;
  TotalAmounts: ResolverTypeWrapper<TotalAmounts>;
  TradingSector: TradingSector;
  Transaction: ResolverTypeWrapper<Transaction>;
  TransactionCategory: TransactionCategory;
  TransactionType: TransactionType;
  Transfer: ResolverTypeWrapper<Transfer>;
  TransferAction: TransferAction;
  TransferState: TransferState;
  TransferableAccount: ResolverTypeWrapper<TransferableAccount>;
  TransferableAccountTypeEnum: TransferableAccountTypeEnum;
  TransferableFrom: ResolverTypeWrapper<TransferableFrom>;
  TransferableTo: ResolverTypeWrapper<TransferableTo>;
  TrendingLearnContentPreview: ResolverTypeWrapper<ResolversUnionTypes['TrendingLearnContentPreview']>;
  TrustedContact: ResolverTypeWrapper<TrustedContact>;
  TrustedContactAlreadyExistsException: ResolverTypeWrapper<TrustedContactAlreadyExistsException>;
  TrustedContactInput: TrustedContactInput;
  TrustedContactInvalidEmail: ResolverTypeWrapper<TrustedContactInvalidEmail>;
  TrustedContactInvalidPhoneNumber: ResolverTypeWrapper<TrustedContactInvalidPhoneNumber>;
  TrustedContactNotFoundException: ResolverTypeWrapper<TrustedContactNotFoundException>;
  Type: Type;
  URL: ResolverTypeWrapper<Scalars['URL']>;
  USStateCodes: UsStateCodes;
  USStateName: ResolverTypeWrapper<Scalars['USStateName']>;
  UUID: ResolverTypeWrapper<Scalars['UUID']>;
  UnableToCancelCheckError: ResolverTypeWrapper<UnableToCancelCheckError>;
  UnauthenticatedCreateUploadUrlInput: UnauthenticatedCreateUploadUrlInput;
  UnauthenticatedSaveUploadUrlInput: UnauthenticatedSaveUploadUrlInput;
  UnauthenticatedSaveUploadUrlResult: ResolverTypeWrapper<ResolversUnionTypes['UnauthenticatedSaveUploadUrlResult']>;
  UnauthorizedException: ResolverTypeWrapper<UnauthorizedException>;
  UnauthorizedModifyLockedContentError: ResolverTypeWrapper<UnauthorizedModifyLockedContentError>;
  UnblockDeviceInput: UnblockDeviceInput;
  UnblockDeviceResult: ResolverTypeWrapper<ResolversUnionTypes['UnblockDeviceResult']>;
  UnlinkOidcCredentialsInput: UnlinkOidcCredentialsInput;
  UnlinkOidcCredentialsResult: ResolverTypeWrapper<ResolversUnionTypes['UnlinkOidcCredentialsResult']>;
  UnlinkOidcCredentialsSuccess: ResolverTypeWrapper<UnlinkOidcCredentialsSuccess>;
  UnlockBankCardPayload: ResolverTypeWrapper<UnlockBankCardPayload>;
  UnmarkLearnContentAsHelpfulInput: UnmarkLearnContentAsHelpfulInput;
  UnmarkLearnContentAsHelpfulResult: ResolverTypeWrapper<ResolversUnionTypes['UnmarkLearnContentAsHelpfulResult']>;
  UnmetRequirementsException: ResolverTypeWrapper<UnmetRequirementsException>;
  UnrecoverableError: ResolverTypeWrapper<UnrecoverableError>;
  UnrecoverableLinkedAccountError: ResolverTypeWrapper<UnrecoverableLinkedAccountError>;
  UnsubscribeUserFromTierInput: UnsubscribeUserFromTierInput;
  UnsubscribeUserFromTierResult: ResolverTypeWrapper<ResolversUnionTypes['UnsubscribeUserFromTierResult']>;
  UnverifiedBeneficiarySsnAlert: ResolverTypeWrapper<UnverifiedBeneficiarySsnAlert>;
  UnverifiedBeneficiarySsnAlertItem: ResolverTypeWrapper<UnverifiedBeneficiarySsnAlertItem>;
  UpdatableAttributesInput: UpdatableAttributesInput;
  UpdateAccountPortfolioInput: UpdateAccountPortfolioInput;
  UpdateAccountPortfolioResponse: ResolverTypeWrapper<ResolversUnionTypes['UpdateAccountPortfolioResponse']>;
  UpdateAttributionInput: UpdateAttributionInput;
  UpdateAttributionResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateAttributionResult']>;
  UpdateAuthEmailInput: UpdateAuthEmailInput;
  UpdateAuthEmailResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateAuthEmailResult']>;
  UpdateAuthPhoneNumberInput: UpdateAuthPhoneNumberInput;
  UpdateAuthPhoneNumberResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateAuthPhoneNumberResult']>;
  UpdateBankAccountGoalInput: UpdateBankAccountGoalInput;
  UpdateBankAccountGoalPayload: ResolverTypeWrapper<UpdateBankAccountGoalPayload>;
  UpdateBankAccountGoalResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateBankAccountGoalResult']>;
  UpdateBankCardPinInput: UpdateBankCardPinInput;
  UpdateBankCardPinPayload: ResolverTypeWrapper<UpdateBankCardPinPayload>;
  UpdateBannersInput: UpdateBannersInput;
  UpdateBeneficiaryInfoResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateBeneficiaryInfoResult']>;
  UpdateBenefitStatusInput: UpdateBenefitStatusInput;
  UpdateBenefitStatusResponse: ResolverTypeWrapper<UpdateBenefitStatusResponse>;
  UpdateCredentialsResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateCredentialsResult']>;
  UpdateDelegateResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateDelegateResult']>;
  UpdateElapsedTimeForLearnQuizInput: UpdateElapsedTimeForLearnQuizInput;
  UpdateElapsedTimeForLearnQuizResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateElapsedTimeForLearnQuizResult']>;
  UpdateLearnContentHelpfulnessResult: ResolverTypeWrapper<UpdateLearnContentHelpfulnessResult>;
  UpdateLearnProgressInput: UpdateLearnProgressInput;
  UpdateLearnProgressResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateLearnProgressResult']>;
  UpdateLinkedAccountInput: UpdateLinkedAccountInput;
  UpdateMessageFailed: ResolverTypeWrapper<UpdateMessageFailed>;
  UpdateMessageIgnored: ResolverTypeWrapper<UpdateMessageIgnored>;
  UpdateMessageResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateMessageResult']>;
  UpdateMessagesFailure: ResolverTypeWrapper<UpdateMessagesFailure>;
  UpdateMoneyManagerAllocationsInput: UpdateMoneyManagerAllocationsInput;
  UpdateMoneyManagerAllocationsResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateMoneyManagerAllocationsResult']>;
  UpdateMoneyManagerAllocationsSuccess: ResolverTypeWrapper<UpdateMoneyManagerAllocationsSuccess>;
  UpdateMoneyManagerAutomationTargetInput: UpdateMoneyManagerAutomationTargetInput;
  UpdateMoneyManagerAutomationTargetResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateMoneyManagerAutomationTargetResult']>;
  UpdateMoneyManagerAutomationTargetSuccess: ResolverTypeWrapper<UpdateMoneyManagerAutomationTargetSuccess>;
  UpdateMoneyManagerSettingsFailure: ResolverTypeWrapper<UpdateMoneyManagerSettingsFailure>;
  UpdateMoneyManagerSettingsInput: UpdateMoneyManagerSettingsInput;
  UpdateMoneyManagerSettingsResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateMoneyManagerSettingsResult']>;
  UpdateMoneyManagerSettingsSuccess: ResolverTypeWrapper<UpdateMoneyManagerSettingsSuccess>;
  UpdateMoneyRulesSourceSettingsFailure: ResolverTypeWrapper<UpdateMoneyRulesSourceSettingsFailure>;
  UpdateMoneyRulesSourceSettingsInput: UpdateMoneyRulesSourceSettingsInput;
  UpdateMoneyRulesSourceSettingsResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateMoneyRulesSourceSettingsResult']>;
  UpdateMoneyRulesSourceSettingsSuccess: ResolverTypeWrapper<UpdateMoneyRulesSourceSettingsSuccess>;
  UpdateOauthAppInput: UpdateOauthAppInput;
  UpdateOauthAppResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateOauthAppResult']>;
  UpdateOptOutOfTargetingInput: UpdateOptOutOfTargetingInput;
  UpdatePortfolioSecuritiesInput: UpdatePortfolioSecuritiesInput;
  UpdatePortfolioSecuritiesResult: ResolverTypeWrapper<ResolversUnionTypes['UpdatePortfolioSecuritiesResult']>;
  UpdatePromoCodeInput: UpdatePromoCodeInput;
  UpdatePromoCodeResult: ResolverTypeWrapper<ResolversUnionTypes['UpdatePromoCodeResult']>;
  UpdatePromotedCampaignsInput: UpdatePromotedCampaignsInput;
  UpdatePromotedCampaignsResult: ResolverTypeWrapper<ResolversUnionTypes['UpdatePromotedCampaignsResult']>;
  UpdateReferralCampaignInput: UpdateReferralCampaignInput;
  UpdateReferralCampaignResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateReferralCampaignResult']>;
  UpdateReferralPayoutInput: UpdateReferralPayoutInput;
  UpdateReferralPayoutResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateReferralPayoutResult']>;
  UpdateReferralRelationshipInput: UpdateReferralRelationshipInput;
  UpdateReferralRelationshipResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateReferralRelationshipResult']>;
  UpdateReferralRewardError: ResolverTypeWrapper<UpdateReferralRewardError>;
  UpdateReferralRewardResponse: ResolverTypeWrapper<ResolversUnionTypes['UpdateReferralRewardResponse']>;
  UpdateScopeException: ResolverTypeWrapper<UpdateScopeException>;
  UpdateScopeInput: UpdateScopeInput;
  UpdateScopeResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateScopeResult']>;
  UpdateTrustedContactResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateTrustedContactResult']>;
  UpdateUserProfileAndAutomationTargetInput: UpdateUserProfileAndAutomationTargetInput;
  UpdateUserProfileAndAutomationTargetResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateUserProfileAndAutomationTargetResult']>;
  UpdateUserProfileAndAutomationTargetSuccess: ResolverTypeWrapper<UpdateUserProfileAndAutomationTargetSuccess>;
  UpdateUserSwitchState: ResolverTypeWrapper<ResolversUnionTypes['UpdateUserSwitchState']>;
  UpdateUserSwitchStateFailure: ResolverTypeWrapper<UpdateUserSwitchStateFailure>;
  UpdateUserSwitchStateInput: UpdateUserSwitchStateInput;
  UpdateUserSwitchStatePayload: ResolverTypeWrapper<UpdateUserSwitchStatePayload>;
  UpdateVerificationProfileResult: ResolverTypeWrapper<ResolversUnionTypes['UpdateVerificationProfileResult']>;
  UpgradeAuthenticationResult: ResolverTypeWrapper<ResolversUnionTypes['UpgradeAuthenticationResult']>;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  UploadCheckInput: UploadCheckInput;
  UploadCheckPayload: ResolverTypeWrapper<UploadCheckPayload>;
  UploadDocumentsInput: UploadDocumentsInput;
  UploadDoesNotExist: ResolverTypeWrapper<UploadDoesNotExist>;
  UploadDoesNotExistError: ResolverTypeWrapper<UploadDoesNotExistError>;
  UploadFailedError: ResolverTypeWrapper<UploadFailedError>;
  UploadOauthAppImageResult: ResolverTypeWrapper<ResolversUnionTypes['UploadOauthAppImageResult']>;
  UploadSaveError: ResolverTypeWrapper<Omit<UploadSaveError, 'uploadExceptions'> & { uploadExceptions: Array<ResolversTypes['UploadSaveExceptions']> }>;
  UploadSaveExceptions: ResolverTypeWrapper<ResolversUnionTypes['UploadSaveExceptions']>;
  UploadUnsolicitedDocumentsInput: UploadUnsolicitedDocumentsInput;
  UploadUrl: ResolverTypeWrapper<UploadUrl>;
  UpsertUserMatchInput: UpsertUserMatchInput;
  UpsertUserMatchResult: ResolverTypeWrapper<ResolversUnionTypes['UpsertUserMatchResult']>;
  User: ResolverTypeWrapper<User>;
  UserAlert: ResolverTypeWrapper<UserAlert>;
  UserAlertsItem: ResolversTypes['AddressDocumentRequestedUserAlert'] | ResolversTypes['BankDocumentRequestedUserAlert'] | ResolversTypes['IdentityDocumentRequestedUserAlert'] | ResolversTypes['InsufficientFundsUserAlert'] | ResolversTypes['InvestmentsPausedUserAlert'] | ResolversTypes['LinkedAccountAlert'] | ResolversTypes['MiscDocumentRequestedUserAlert'] | ResolversTypes['MissingSsnBeneficiaryAlertItem'] | ResolversTypes['NoFundingSourceUserAlert'] | ResolversTypes['RdvRequiredUserAlert'] | ResolversTypes['RelinkLinkedAccountAlert'] | ResolversTypes['SSNDocumentRequestedUserAlert'] | ResolversTypes['UnverifiedBeneficiarySsnAlertItem'] | ResolversTypes['UserAlert'] | ResolversTypes['W9DocumentRequestedUserAlert'];
  UserAlertsResponse: ResolverTypeWrapper<ResolversUnionTypes['UserAlertsResponse']>;
  UserCardLockedSpendAlert: ResolverTypeWrapper<UserCardLockedSpendAlert>;
  UserClosedException: ResolverTypeWrapper<UserClosedException>;
  UserCohorts: ResolverTypeWrapper<UserCohorts>;
  UserCredentials: ResolverTypeWrapper<UserCredentials>;
  UserCredentialsInput: UserCredentialsInput;
  UserCredentialsNotFoundException: ResolverTypeWrapper<UserCredentialsNotFoundException>;
  UserExistsException: ResolverTypeWrapper<UserExistsException>;
  UserInvestmentAccountReopenCheck: ResolverTypeWrapper<UserInvestmentAccountReopenCheck>;
  UserLockedException: ResolverTypeWrapper<UserLockedException>;
  UserMatch: ResolverTypeWrapper<UserMatch>;
  UserMatchStatus: UserMatchStatus;
  UserNotFound: ResolverTypeWrapper<UserNotFound>;
  UserNotFoundException: ResolverTypeWrapper<UserNotFoundException>;
  UserNotUSResidentException: ResolverTypeWrapper<UserNotUsResidentException>;
  UserNotVerifiedException: ResolverTypeWrapper<UserNotVerifiedException>;
  UserPartnerStatusResponse: ResolverTypeWrapper<UserPartnerStatusResponse>;
  UserReopenLockedException: ResolverTypeWrapper<UserReopenLockedException>;
  UserReopenSuspendedException: ResolverTypeWrapper<UserReopenSuspendedException>;
  UserStatus: ResolverTypeWrapper<UserStatus>;
  UserSuspendedException: ResolverTypeWrapper<UserSuspendedException>;
  UserSuspendedUploadTokenLengthError: ResolverTypeWrapper<UserSuspendedUploadTokenLengthError>;
  UserSuspendedUploadTokenValidation: ResolverTypeWrapper<UserSuspendedUploadTokenValidation>;
  UserSwitch: ResolverTypeWrapper<UserSwitch>;
  UserToken: ResolverTypeWrapper<UserToken>;
  UserUpload: ResolverTypeWrapper<UserUpload>;
  User_v2: ResolverTypeWrapper<User_V2>;
  ValidPolicies: ResolverTypeWrapper<ValidPolicies>;
  ValidateCredentialsInput: ValidateCredentialsInput;
  ValidateCredentialsResult: ResolverTypeWrapper<ResolversUnionTypes['ValidateCredentialsResult']>;
  ValidateCredentialsSuccess: ResolverTypeWrapper<ValidateCredentialsSuccess>;
  ValidateDocumentsInput: ValidateDocumentsInput;
  ValidatePasswordResetTokenResult: ResolverTypeWrapper<ResolversUnionTypes['ValidatePasswordResetTokenResult']>;
  ValidatePasswordResetTokenSuccess: ResolverTypeWrapper<ValidatePasswordResetTokenSuccess>;
  ValidateUserSuspendedUploadTokenInput: ValidateUserSuspendedUploadTokenInput;
  ValidateUserSuspendedUploadTokenResult: ResolverTypeWrapper<ResolversUnionTypes['ValidateUserSuspendedUploadTokenResult']>;
  ValidationError: ResolverTypeWrapper<ValidationError>;
  VendAuthSessionInput: VendAuthSessionInput;
  VendAuthSessionResult: ResolverTypeWrapper<ResolversUnionTypes['VendAuthSessionResult']>;
  VendorBillingInfo: ResolverTypeWrapper<VendorBillingInfo>;
  VendorCustomerAccount: ResolverTypeWrapper<VendorCustomerAccount>;
  VendorIntegrationError: ResolverTypeWrapper<VendorIntegrationError>;
  VendorRefundInvoiceError: ResolverTypeWrapper<VendorRefundInvoiceError>;
  VerificationDetails: ResolverTypeWrapper<VerificationDetails>;
  VerificationProfile: ResolverTypeWrapper<VerificationProfile>;
  VerificationProfileInput: VerificationProfileInput;
  VerificationStatus: VerificationStatus;
  VerifyCheckPaymentRecipientAddressInputType: VerifyCheckPaymentRecipientAddressInputType;
  VerifyCheckPaymentRecipientAddressResult: ResolverTypeWrapper<ResolversUnionTypes['VerifyCheckPaymentRecipientAddressResult']>;
  VerifyDeviceInput: VerifyDeviceInput;
  VerifyDeviceResult: ResolverTypeWrapper<ResolversUnionTypes['VerifyDeviceResult']>;
  VerifyIdentityByDocumentsResult: ResolverTypeWrapper<ResolversUnionTypes['VerifyIdentityByDocumentsResult']>;
  VerifyPasswordsInput: VerifyPasswordsInput;
  VerifyPasswordsResult: ResolverTypeWrapper<ResolversUnionTypes['VerifyPasswordsResult']>;
  VerifyPasswordsSuccess: ResolverTypeWrapper<VerifyPasswordsSuccess>;
  VerifyPromoCodeResponse: ResolverTypeWrapper<ResolversUnionTypes['VerifyPromoCodeResponse']>;
  VerifyRdvsInput: VerifyRdvsInput;
  VerifyRdvsResult: ResolverTypeWrapper<ResolversUnionTypes['VerifyRdvsResult']>;
  VersionMismatchException: ResolverTypeWrapper<VersionMismatchException>;
  ViewedLearnContentResult: ResolverTypeWrapper<ViewedLearnContentResult>;
  Void: ResolverTypeWrapper<Scalars['Void']>;
  W9DocumentRequestedUserAlert: ResolverTypeWrapper<W9DocumentRequestedUserAlert>;
  Waiver: ResolverTypeWrapper<ResolversUnionTypes['Waiver']>;
  WaiverCoupon: ResolverTypeWrapper<WaiverCoupon>;
  WaiverCreationException: ResolverTypeWrapper<WaiverCreationException>;
  WaiverDeletionException: ResolverTypeWrapper<WaiverDeletionException>;
  WaiverPromotion: WaiverPromotion;
  WaiverPromotion_V2: WaiverPromotion_V2;
  Webhooks: ResolverTypeWrapper<Webhooks>;
  WebviewLinkSession: ResolverTypeWrapper<WebviewLinkSession>;
  Withdrawal: ResolverTypeWrapper<Withdrawal>;
  WithholdingDefaults: ResolverTypeWrapper<WithholdingDefaults>;
  WithholdingEstimates: ResolverTypeWrapper<WithholdingEstimates>;
  YearLaterReport: ResolverTypeWrapper<YearLaterReport>;
  allPastScheduledItemsFilter: AllPastScheduledItemsFilter;
  allPastScheduledItemsFilterV2: AllPastScheduledItemsFilterV2;
  endChatSessionResponse: ResolverTypeWrapper<ResolversUnionTypes['endChatSessionResponse']>;
  helpcenterBannerResponse: ResolverTypeWrapper<ResolversUnionTypes['helpcenterBannerResponse']>;
  jobs_Article: ResolverTypeWrapper<Jobs_Article>;
  jobs_Education: ResolverTypeWrapper<Jobs_Education>;
  jobs_Offer: ResolverTypeWrapper<Jobs_Offer>;
  jobs_OfferConnection: ResolverTypeWrapper<Jobs_OfferConnection>;
  jobs_OfferEdge: ResolverTypeWrapper<Jobs_OfferEdge>;
  jobs_OfferSalary: ResolverTypeWrapper<Jobs_OfferSalary>;
  laterTotalLiquidationInput: LaterTotalLiquidationInput;
  managePayoutRelationshipInput: ManagePayoutRelationshipInput;
  rateChatMessageResponse: ResolverTypeWrapper<ResolversUnionTypes['rateChatMessageResponse']>;
  referralStatusDetails: ReferralStatusDetails;
  startChatSessionResponse: ResolverTypeWrapper<ResolversUnionTypes['startChatSessionResponse']>;
  suitability_Portfolio: ResolverTypeWrapper<Suitability_Portfolio>;
  suitability_SuitabilityAnswer: ResolverTypeWrapper<Suitability_SuitabilityAnswer>;
  suitability_SuitabilityInput: Suitability_SuitabilityInput;
  suitability_SuitabilityQuestion: ResolverTypeWrapper<Suitability_SuitabilityQuestion>;
  suitability_SuitabilityResponse: ResolverTypeWrapper<Suitability_SuitabilityResponse>;
  suitability_UpdateSuitabilityResult: ResolverTypeWrapper<Suitability_UpdateSuitabilityResult>;
  uploadAudienceListInput: UploadAudienceListInput;
  userWinbackErrors: ResolverTypeWrapper<UserWinbackErrors>;
  userWinbackScore: ResolverTypeWrapper<UserWinbackScore>;
  userWinbackScoreRes: ResolverTypeWrapper<ResolversUnionTypes['userWinbackScoreRes']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AbstractSwitch: ResolversUnionParentTypes['AbstractSwitch'];
  AcceptDocumentInput: AcceptDocumentInput;
  AcceptDocumentResponse: ResolversUnionParentTypes['AcceptDocumentResponse'];
  AcceptanceDocument: AcceptanceDocument;
  AcceptedDocument: AcceptedDocument;
  Account: Account;
  AccountAchievement: AccountAchievement;
  AccountAlreadyClosedException: AccountAlreadyClosedException;
  AccountClosedException: AccountClosedException;
  AccountFrozen: AccountFrozen;
  AccountMoneyAssignmentInput: AccountMoneyAssignmentInput;
  AccountNotFoundException: AccountNotFoundException;
  AccountNumber: Scalars['AccountNumber'];
  AccountPoints: AccountPoints;
  AccountPointsRule: AccountPointsRule;
  AccountRequirement: AccountRequirement;
  AccountRequirements: AccountRequirements;
  AccountSetupMilestones: AccountSetupMilestones;
  AccountStrengthResult: AccountStrengthResult;
  AccountValue: AccountValue;
  AcornsEarlyUserDetails: AcornsEarlyUserDetails;
  AcornsPdfSwitch: AcornsPdfSwitch;
  AcornsValidationError: AcornsValidationError;
  ActionCard: ActionCard;
  ActionCardButton: ActionCardButton;
  ActionCardsInput: ActionCardsInput;
  ActionFeedCta: ActionFeedCta;
  ActionFeedEvent: ActionFeedEvent;
  ActionFeedEventResponse: ActionFeedEventResponse;
  ActionScreenComponent: ResolversUnionParentTypes['ActionScreenComponent'];
  ActionWidget: ActionWidget;
  ActivateBankCardInput: ActivateBankCardInput;
  ActivateBankCardPayload: ActivateBankCardPayload;
  ActivateOauthAppClientResult: ResolversUnionParentTypes['ActivateOauthAppClientResult'];
  ActivateOauthAppResult: ResolversUnionParentTypes['ActivateOauthAppResult'];
  ActiveReferralCampaignOutput: ActiveReferralCampaignOutput;
  Activity: Activity;
  ActivitySummaryResponse: ActivitySummaryResponse;
  AddCohortEligibilityInput: AddCohortEligibilityInput;
  AddCohortEligibilityResult: ResolversUnionParentTypes['AddCohortEligibilityResult'];
  AddPolicyInput: AddPolicyInput;
  AddPolicyResult: ResolversUnionParentTypes['AddPolicyResult'];
  AddPolicySuccess: AddPolicySuccess;
  AddSearchTermToLearnSearchHistoryInput: AddSearchTermToLearnSearchHistoryInput;
  AddSearchTermToLearnSearchHistoryResult: ResolversUnionParentTypes['AddSearchTermToLearnSearchHistoryResult'];
  AddSecurityToPortfolioInput: AddSecurityToPortfolioInput;
  AddSecurityToPortfolioResult: ResolversUnionParentTypes['AddSecurityToPortfolioResult'];
  AddSelfDirectedPortfolioInput: AddSelfDirectedPortfolioInput;
  AddSelfDirectedPortfolioResult: ResolversUnionParentTypes['AddSelfDirectedPortfolioResult'];
  Address: Address;
  AddressDeliverabilityAdditionalInfo: AddressDeliverabilityAdditionalInfo;
  AddressDeliverabilityCorrectedAddress: AddressDeliverabilityCorrectedAddress;
  AddressDeliverabilityInput: AddressDeliverabilityInput;
  AddressDeliverabilityResult: ResolversUnionParentTypes['AddressDeliverabilityResult'];
  AddressDeliverabilityUnavailableError: AddressDeliverabilityUnavailableError;
  AddressDeliverabilityVerificationError: AddressDeliverabilityVerificationError;
  AddressDeliverabilityVerified: AddressDeliverabilityVerified;
  AddressDocumentRequestedUserAlert: AddressDocumentRequestedUserAlert;
  AddressInput: AddressInput;
  AddressVerification: ResolversParentTypes['BankCardOrderAddressVerification'] | ResolversParentTypes['BankingKycAddressVerification'];
  Advocate: Advocate;
  AdvocateFriendsStatuses: AdvocateFriendsStatuses;
  AdvocateV2: AdvocateV2;
  Alert: ResolversParentTypes['MissingSsnBeneficiaryAlert'] | ResolversParentTypes['UnverifiedBeneficiarySsnAlert'];
  AlertHubBeneficiaryAlert: ResolversUnionParentTypes['AlertHubBeneficiaryAlert'];
  AlertMessage: Omit<AlertMessage, 'body' | 'icon' | 'title'> & { body: ResolversParentTypes['MessageTextAsset'], icon: Maybe<ResolversParentTypes['MessageVisualAsset']>, title: ResolversParentTypes['MessageTextAsset'] };
  AllAccountHistorySummary: AllAccountHistorySummary;
  AllAccountsFilterInput: AllAccountsFilterInput;
  AllBankAccountsInput: AllBankAccountsInput;
  AllBankCardsFilter: AllBankCardsFilter;
  AllBankDocumentsInput: AllBankDocumentsInput;
  AllChatHistoryMessages: AllChatHistoryMessages;
  AllCheckPaymentsResult: ResolversUnionParentTypes['AllCheckPaymentsResult'];
  AllPastCoreItemsSchemaFilter: AllPastCoreItemsSchemaFilter;
  AllPastEarlyItemsSchemaFilter: AllPastEarlyItemsSchemaFilter;
  AllPastItemsFilter: AllPastItemsFilter;
  AllPastLaterItemsSchemaFilter: AllPastLaterItemsSchemaFilter;
  AllPastSpendItemsSchemaFilter: AllPastSpendItemsSchemaFilter;
  AllSupportArticlesFilterInput: AllSupportArticlesFilterInput;
  AllTransferableToInput: AllTransferableToInput;
  AllocationAmountsSumExceedingMaxError: AllocationAmountsSumExceedingMaxError;
  Amount: Scalars['Amount'];
  AnswerChallengeResult: ResolversUnionParentTypes['AnswerChallengeResult'];
  AnswerChallengeSuccess: AnswerChallengeSuccess;
  AnswerLearnQuizQuestionInput: AnswerLearnQuizQuestionInput;
  AnswerLearnQuizQuestionResult: ResolversUnionParentTypes['AnswerLearnQuizQuestionResult'];
  ApplyPromoCodeResult: ResolversUnionParentTypes['ApplyPromoCodeResult'];
  ApplyPromotionInput: ApplyPromotionInput;
  ApplyPromotionResult: ResolversUnionParentTypes['ApplyPromotionResult'];
  ApplyPromotionalWaiverInput: ApplyPromotionalWaiverInput;
  ApplyPromotionalWaiverResult: ResolversUnionParentTypes['ApplyPromotionalWaiverResult'];
  ApplyProvisionalWaiverResult: ResolversUnionParentTypes['ApplyProvisionalWaiverResult'];
  ArchiveInvalidSmartDepositRecordsResult: ArchiveInvalidSmartDepositRecordsResult;
  AssignLinkedSubaccountInput: AssignLinkedSubaccountInput;
  AsyncLinkSessionResult: AsyncLinkSessionResult;
  AuthAlert: ResolversParentTypes['MfaMissingAuthAlert'];
  AuthChallenge: ResolversParentTypes['EmailAuthChallenge'] | ResolversParentTypes['PushAuthChallenge'] | ResolversParentTypes['SMSAuthChallenge'];
  AuthChallengeAnswerAttemptsExhaustedException: AuthChallengeAnswerAttemptsExhaustedException;
  AuthChallengeAnswerIncorrectException: AuthChallengeAnswerIncorrectException;
  AuthChallengeExpiredException: AuthChallengeExpiredException;
  AuthProfile: AuthProfile;
  AuthProfileAlreadyExistsException: AuthProfileAlreadyExistsException;
  AuthProfileNotFoundException: AuthProfileNotFoundException;
  AuthSession: AuthSession;
  AuthTokenNotFoundException: AuthTokenNotFoundException;
  AuthenticateForFeeNegotiationChallengeInput: AuthenticateForFeeNegotiationChallengeInput;
  AuthenticateForFeeNegotiationChallengeMethodInput: AuthenticateForFeeNegotiationChallengeMethodInput;
  AuthenticateForFeeNegotiationInput: AuthenticateForFeeNegotiationInput;
  AuthenticateForFeeNegotiationResult: ResolversUnionParentTypes['AuthenticateForFeeNegotiationResult'];
  AuthenticateForFeeNegotiationStatus: AuthenticateForFeeNegotiationStatus;
  AuthenticateInput: AuthenticateInput;
  AuthenticateNegotiationStatusResult: ResolversUnionParentTypes['AuthenticateNegotiationStatusResult'];
  AuthenticateResult: ResolversUnionParentTypes['AuthenticateResult'];
  AuthenticationAlreadyUpgradedException: AuthenticationAlreadyUpgradedException;
  Authenticator: ResolversParentTypes['EmailAuthenticator'] | ResolversParentTypes['PhoneAuthenticator'] | ResolversParentTypes['PushAuthenticator'];
  AuthenticatorAlreadyDefaultException: AuthenticatorAlreadyDefaultException;
  AuthenticatorInfo: AuthenticatorInfo;
  AuthenticatorNotFoundException: AuthenticatorNotFoundException;
  AuthenticatorTypeAlreadyRegisteredException: AuthenticatorTypeAlreadyRegisteredException;
  AuthenticatorUnavailableException: AuthenticatorUnavailableException;
  AuthorizationError: AuthorizationError;
  AutomationError: AutomationError;
  BackendJobBatch: BackendJobBatch;
  BackendJobBatchAutomatedOrdersFilterInput: BackendJobBatchAutomatedOrdersFilterInput;
  BackendJobBatchMoneyMovementFilterInput: BackendJobBatchMoneyMovementFilterInput;
  BackendJobBatchOrdersFilterInput: BackendJobBatchOrdersFilterInput;
  BackendJobBatchProfitStarsFilterInput: BackendJobBatchProfitStarsFilterInput;
  BackendJobBatchSummary: BackendJobBatchSummary;
  BackendJobBatchSummaryFilterInput: BackendJobBatchSummaryFilterInput;
  BadRequestError: BadRequestError;
  BankAccount: BankAccount;
  BankAccountDisclosure: BankAccountDisclosure;
  BankAccountDisclosureFilter: BankAccountDisclosureFilter;
  BankAccountGoal: BankAccountGoal;
  BankAccountGoalInput: BankAccountGoalInput;
  BankAccountGoals: BankAccountGoals;
  BankAccountNotFoundError: BankAccountNotFoundError;
  BankAccountRequirement: BankAccountRequirement;
  BankAccountRequirements: BankAccountRequirements;
  BankAccountState: BankAccountState;
  BankAccountStateResult: BankAccountStateResult;
  BankAccountTypeConfig: BankAccountTypeConfig;
  BankCard: BankCard;
  BankCardOrder: BankCardOrder;
  BankCardOrderAddressVerification: BankCardOrderAddressVerification;
  BankCardOrderFundingSourceVerification: BankCardOrderFundingSourceVerification;
  BankCardOrderIdentityVerification: BankCardOrderIdentityVerification;
  BankCardOrderPrefundVerification: BankCardOrderPrefundVerification;
  BankCardPanDisplayPayload: BankCardPanDisplayPayload;
  BankCardPanDisplayResult: ResolversUnionParentTypes['BankCardPanDisplayResult'];
  BankCardPin: Scalars['BankCardPin'];
  BankCardPrefundTransfer: BankCardPrefundTransfer;
  BankCardProvisioningDetailsInput: BankCardProvisioningDetailsInput;
  BankCardProvisioningDetailsPayload: BankCardProvisioningDetailsPayload;
  BankCardProvisioningDetailsResult: ResolversUnionParentTypes['BankCardProvisioningDetailsResult'];
  BankCardReissue: Omit<BankCardReissue, 'reissueBankCardEligibility'> & { reissueBankCardEligibility: ResolversParentTypes['ReissueBankCardEligibility'] };
  BankCardRequest: BankCardRequest;
  BankCardRequestMailingAddress: BankCardRequestMailingAddress;
  BankCardRequestMailingAddressInput: BankCardRequestMailingAddressInput;
  BankConnection: BankConnection;
  BankDocument: BankDocument;
  BankDocumentRequestedUserAlert: BankDocumentRequestedUserAlert;
  BankFee: BankFee;
  BankFeeConnection: BankFeeConnection;
  BankFeeFilter: BankFeeFilter;
  BankFeeSummary: BankFeeSummary;
  BankInterestRate: BankInterestRate;
  BankInterestRates: BankInterestRates;
  BankInterestRatesResult: ResolversUnionParentTypes['BankInterestRatesResult'];
  BankMetadata: BankMetadata;
  BankMetadataTotals: BankMetadataTotals;
  BankServiceFailure: BankServiceFailure;
  BankStatement: BankStatement;
  BankTransaction: BankTransaction;
  BankTransactionConnection: BankTransactionConnection;
  BankTransactionEdge: BankTransactionEdge;
  BankTransactionNachaInfo: BankTransactionNachaInfo;
  BankingFeatureEligibility: BankingFeatureEligibility;
  BankingKyc: BankingKyc;
  BankingKycAddressVerification: BankingKycAddressVerification;
  BankingKycIdentityVerification: BankingKycIdentityVerification;
  BannersErrors: BannersErrors;
  BannersResponse: ResolversUnionParentTypes['BannersResponse'];
  BasePortfolio: ResolversParentTypes['Portfolio'] | ResolversParentTypes['SelfDirectedPortfolio'];
  BatchAddTierSubscriptions: BatchAddTierSubscriptions;
  BatchAddTierSubscriptionsInput: BatchAddTierSubscriptionsInput;
  BatchAddTierSubscriptionsResult: ResolversUnionParentTypes['BatchAddTierSubscriptionsResult'];
  Beneficiary: Beneficiary;
  BeneficiaryAccountExistsException: BeneficiaryAccountExistsException;
  BeneficiaryExceedsAgeLimitException: BeneficiaryExceedsAgeLimitException;
  BeneficiaryInfoInput: BeneficiaryInfoInput;
  BeneficiaryInput: BeneficiaryInput;
  BeneficiaryNotFoundException: BeneficiaryNotFoundException;
  BenefitPartnerInput: BenefitPartnerInput;
  BenefitPartnerResponse: ResolversUnionParentTypes['BenefitPartnerResponse'];
  BenefitProductTile: BenefitProductTile;
  BenefitStatus: BenefitStatus;
  BenefitTileGroup: BenefitTileGroup;
  BenefitsMessage: BenefitsMessage;
  BenefitsStatusResponse: BenefitsStatusResponse;
  BigCurrencyAmount: BigCurrencyAmount;
  BigDecimal: Scalars['BigDecimal'];
  BillingCycle: BillingCycle;
  BillingInvoice: BillingInvoice;
  BillingProfile: Omit<BillingProfile, 'waivers'> & { waivers: Maybe<Array<ResolversParentTypes['Waiver']>> };
  BillingProfileNotFoundException: BillingProfileNotFoundException;
  BillingVendorError: BillingVendorError;
  BlockDeviceInput: BlockDeviceInput;
  BlockDeviceResult: ResolversUnionParentTypes['BlockDeviceResult'];
  BlockedEmailDomainException: BlockedEmailDomainException;
  Boolean: Scalars['Boolean'];
  Bundle: Bundle;
  CampaignHistoryConnection: CampaignHistoryConnection;
  CampaignHistoryEdge: CampaignHistoryEdge;
  CampaignHistoryFilter: CampaignHistoryFilter;
  CampaignV2: CampaignV2;
  CancelCheckPaymentResult: ResolversUnionParentTypes['CancelCheckPaymentResult'];
  CancelIntentResult: ResolversUnionParentTypes['CancelIntentResult'];
  CancelInvestmentAccountClosureRequestInput: CancelInvestmentAccountClosureRequestInput;
  CancelInvestmentAccountClosureRequestResult: ResolversUnionParentTypes['CancelInvestmentAccountClosureRequestResult'];
  CancelInvestmentInput: CancelInvestmentInput;
  CancelInvestmentPayload: CancelInvestmentPayload;
  CancelInvestmentResult: ResolversUnionParentTypes['CancelInvestmentResult'];
  CancelMoneyAssignmentInput: CancelMoneyAssignmentInput;
  CancelMoneyAssignmentResult: ResolversUnionParentTypes['CancelMoneyAssignmentResult'];
  CancelRecurringTransferResult: ResolversUnionParentTypes['CancelRecurringTransferResult'];
  CancelTransferPayload: CancelTransferPayload;
  CardDeliveryStatus: CardDeliveryStatus;
  CardNumberMasked: Scalars['CardNumberMasked'];
  ChallengeAnswerInput: ChallengeAnswerInput;
  ChallengePointsEarned: ChallengePointsEarned;
  ChallengeRateExceededException: ChallengeRateExceededException;
  ChangeOutsideContributionAmountInput: ChangeOutsideContributionAmountInput;
  ChangeOutsideContributionAmountResult: ResolversUnionParentTypes['ChangeOutsideContributionAmountResult'];
  ChangePasswordInput: ChangePasswordInput;
  ChangePasswordResult: ResolversUnionParentTypes['ChangePasswordResult'];
  ChangePasswordSuccess: ChangePasswordSuccess;
  ChatActionData: ChatActionData;
  ChatActionDataInput: ChatActionDataInput;
  ChatChoice: ChatChoice;
  ChatChoiceActionData: ChatChoiceActionData;
  ChatChoiceActionMetadata: ChatChoiceActionMetadata;
  ChatChoiceWidget: ChatChoiceWidget;
  ChatDeeplink: ChatDeeplink;
  ChatHistoryCitation: ChatHistoryCitation;
  ChatHistoryCitationV2: ResolversUnionParentTypes['ChatHistoryCitationV2'];
  ChatHistoryMessage: Omit<ChatHistoryMessage, 'chatWidgets'> & { chatWidgets: Array<ResolversParentTypes['ChatWidget']> };
  ChatHistoryMessageBody: ChatHistoryMessageBody;
  ChatHistoryMessageCustomFeedbackOutOfBounds: ChatHistoryMessageCustomFeedbackOutOfBounds;
  ChatHistoryMessageEdge: ChatHistoryMessageEdge;
  ChatHistoryMessageError: ResolversParentTypes['ChatHistoryMessageCustomFeedbackOutOfBounds'] | ResolversParentTypes['ChatHistoryMessageNotFound'] | ResolversParentTypes['ChatHistoryMessageNotRatable'] | ResolversParentTypes['ChatHistoryMessageRatingFailed'] | ResolversParentTypes['ChatHistoryMessageRatingOutOfBounds'] | ResolversParentTypes['ChatMessageSizeOutOfBounds'];
  ChatHistoryMessageFooter: Omit<ChatHistoryMessageFooter, 'chatWidgets'> & { chatWidgets: Array<ResolversParentTypes['ChatWidget']> };
  ChatHistoryMessageHeader: ChatHistoryMessageHeader;
  ChatHistoryMessageNotFound: ChatHistoryMessageNotFound;
  ChatHistoryMessageNotRatable: ChatHistoryMessageNotRatable;
  ChatHistoryMessageRatingFailed: ChatHistoryMessageRatingFailed;
  ChatHistoryMessageRatingOutOfBounds: ChatHistoryMessageRatingOutOfBounds;
  ChatMessageMetadata: ChatMessageMetadata;
  ChatMessageMetadataInput: ChatMessageMetadataInput;
  ChatMessageSizeOutOfBounds: ChatMessageSizeOutOfBounds;
  ChatMessageStreamResponse: ResolversUnionParentTypes['ChatMessageStreamResponse'];
  ChatRedirect: ChatRedirect;
  ChatSession: ChatSession;
  ChatSessionNotFound: ChatSessionNotFound;
  ChatUnavailableError: ChatUnavailableError;
  ChatWidget: ResolversUnionParentTypes['ChatWidget'];
  CheckImage: CheckImage;
  CheckPayment: CheckPayment;
  CheckPaymentAddress: CheckPaymentAddress;
  CheckPaymentAddressInput: CheckPaymentAddressInput;
  CheckPaymentConnection: CheckPaymentConnection;
  CheckPaymentEdge: CheckPaymentEdge;
  CheckPaymentRecipient: CheckPaymentRecipient;
  CheckPaymentRecipientAddressType: CheckPaymentRecipientAddressType;
  CheckPaymentRecipientInput: CheckPaymentRecipientInput;
  CheckingHistorySummary: CheckingHistorySummary;
  CitationWidget: Omit<CitationWidget, 'citations'> & { citations: Array<ResolversParentTypes['ChatHistoryCitationV2']> };
  ClaimStatusDetails: ClaimStatusDetails;
  ClearSupportSiteCache: ClearSupportSiteCache;
  ClientInfo: ClientInfo;
  CloseAccountReason: CloseAccountReason;
  CloseBankAccountInput: CloseBankAccountInput;
  CloseBankAccountResult: ResolversUnionParentTypes['CloseBankAccountResult'];
  CloseInvestmentAccountInput: CloseInvestmentAccountInput;
  CloseInvestmentAccountResult: ResolversUnionParentTypes['CloseInvestmentAccountResult'];
  CloseUserAccountResult: ResolversUnionParentTypes['CloseUserAccountResult'];
  ClosureRequestDoesNotExistException: ClosureRequestDoesNotExistException;
  ClosureRequestExistsException: ClosureRequestExistsException;
  CohortEligibility: CohortEligibility;
  CohortEligibility_v2: CohortEligibility_V2;
  CohortEligibility_v2FilterInput: CohortEligibility_V2FilterInput;
  CombinedPerformance: CombinedPerformance;
  CompleteCheckDepositInput: CompleteCheckDepositInput;
  CompleteCheckDepositPayload: CompleteCheckDepositPayload;
  CompleteFunnelOnboardingResult: ResolversUnionParentTypes['CompleteFunnelOnboardingResult'];
  CompletedQuiz: CompletedQuiz;
  ConfigureSettingsInput: ConfigureSettingsInput;
  ConfigureSplitDepositDirectDepositIntentPayload: ConfigureSplitDepositDirectDepositIntentPayload;
  ConfigureSplitDepositDirectDepositIntentSettingInput: ConfigureSplitDepositDirectDepositIntentSettingInput;
  ConfigureSplitDepositDirectDepositSettingInput: ConfigureSplitDepositDirectDepositSettingInput;
  ConfigureSplitDepositDirectDepositSettingPayload: ConfigureSplitDepositDirectDepositSettingPayload;
  ConnectACHAccountInput: ConnectAchAccountInput;
  ConnectACHAccountResult: ResolversUnionParentTypes['ConnectACHAccountResult'];
  ConnectACHAccountSucceeded: ConnectAchAccountSucceeded;
  ConnectionSummary: ConnectionSummary;
  ConsumeUserTokenResult: ResolversUnionParentTypes['ConsumeUserTokenResult'];
  ContactCategory: ContactCategory;
  ContactFaq: ContactFaq;
  ContactFormAlert: ContactFormAlert;
  ContactInfoInput: ContactInfoInput;
  ContactSubcategory: ContactSubcategory;
  ContentPreviewConnection: ContentPreviewConnection;
  ContentPreviewEdge: Omit<ContentPreviewEdge, 'node'> & { node: ResolversParentTypes['LearnContentPreview'] };
  ContextEntryInput: ContextEntryInput;
  ContributionAbility: ContributionAbility;
  ContributionAbilityByYear: ContributionAbilityByYear;
  ContributionActionRequiredError: ContributionActionRequiredError;
  ContributionAmountAboveThresholdError: ContributionAmountAboveThresholdError;
  ContributionAmountBelowThresholdError: ContributionAmountBelowThresholdError;
  ContributionCardDeclinedError: ContributionCardDeclinedError;
  ContributionHistoryItem: ContributionHistoryItem;
  ContributionInvalidOwnerEmailError: ContributionInvalidOwnerEmailError;
  CoreACHSubscriptionFeeItem: CoreAchSubscriptionFeeItem;
  CoreAccountAlreadyExistsException: CoreAccountAlreadyExistsException;
  CoreAccountClosedException: CoreAccountClosedException;
  CoreAdjustmentItem: CoreAdjustmentItem;
  CoreCashForwardItem: CoreCashForwardItem;
  CoreCollectionItem: CoreCollectionItem;
  CoreDebtCollectionItem: CoreDebtCollectionItem;
  CoreDividendsItem: CoreDividendsItem;
  CoreEmployeeCreditItem: CoreEmployeeCreditItem;
  CoreFeeInvestmentItem: CoreFeeInvestmentItem;
  CoreFoundMoneyRewardItem: CoreFoundMoneyRewardItem;
  CoreGiftCardCreditRedemptionItem: CoreGiftCardCreditRedemptionItem;
  CoreHoldingsTransferInItem: CoreHoldingsTransferInItem;
  CoreInvestmentItem: CoreInvestmentItem;
  CoreLocalFoundMoneyItem: CoreLocalFoundMoneyItem;
  CorePartnerRewardItem: CorePartnerRewardItem;
  CoreRebalanceItem: CoreRebalanceItem;
  CoreReferralRewardItem: CoreReferralRewardItem;
  CoreRefundedItem: CoreRefundedItem;
  CoreReinvestmentItem: CoreReinvestmentItem;
  CoreRoundUpsItem: CoreRoundUpsItem;
  CoreWithdrawalItem: CoreWithdrawalItem;
  Course: Omit<Course, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], theme: ResolversParentTypes['CourseTheme'] };
  CourseLocked: Omit<CourseLocked, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], theme: ResolversParentTypes['CourseTheme'] };
  CoursePreview: Omit<CoursePreview, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversParentTypes['CourseTheme'], duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  CoursePreviewLocked: Omit<CoursePreviewLocked, 'courseTheme' | 'duration' | 'featuredImage'> & { courseTheme: ResolversParentTypes['CourseTheme'], duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  CourseTheme: ResolversUnionParentTypes['CourseTheme'];
  CreateAuthProfileInput: CreateAuthProfileInput;
  CreateAuthProfileResult: ResolversUnionParentTypes['CreateAuthProfileResult'];
  CreateBankAccountInput: CreateBankAccountInput;
  CreateBankAccountPayload: CreateBankAccountPayload;
  CreateBeneficiaryResult: ResolversUnionParentTypes['CreateBeneficiaryResult'];
  CreateCustomSupportTicketInput: CreateCustomSupportTicketInput;
  CreateDelegateResult: ResolversUnionParentTypes['CreateDelegateResult'];
  CreateDirectDepositLinkInfoFailure: CreateDirectDepositLinkInfoFailure;
  CreateDirectDepositLinkInfoInput: CreateDirectDepositLinkInfoInput;
  CreateDirectDepositLinkInfoPayload: CreateDirectDepositLinkInfoPayload;
  CreateDirectDepositLinkInfoSwitch: ResolversUnionParentTypes['CreateDirectDepositLinkInfoSwitch'];
  CreateDocumentUpload: CreateDocumentUpload;
  CreateDocumentUploadInput: CreateDocumentUploadInput;
  CreateImplicitTokenForUserInput: CreateImplicitTokenForUserInput;
  CreateImplicitTokenForUserResult: ResolversUnionParentTypes['CreateImplicitTokenForUserResult'];
  CreateIntentInput: CreateIntentInput;
  CreateIntentResult: ResolversUnionParentTypes['CreateIntentResult'];
  CreateInvestingStrategyRecommendationInput: CreateInvestingStrategyRecommendationInput;
  CreateInvestingStrategyRecommendationResult: ResolversUnionParentTypes['CreateInvestingStrategyRecommendationResult'];
  CreateInvestmentAccountResponse: CreateInvestmentAccountResponse;
  CreateJobAlertResult: ResolversUnionParentTypes['CreateJobAlertResult'];
  CreateOauthAppInput: CreateOauthAppInput;
  CreateOauthAppResult: ResolversUnionParentTypes['CreateOauthAppResult'];
  CreateOfferInput: CreateOfferInput;
  CreateOfferResult: ResolversUnionParentTypes['CreateOfferResult'];
  CreateOutsideContributionCheckoutCartInput: CreateOutsideContributionCheckoutCartInput;
  CreateOutsideContributionCheckoutCartResult: ResolversUnionParentTypes['CreateOutsideContributionCheckoutCartResult'];
  CreateOutsideContributionInput: CreateOutsideContributionInput;
  CreateOutsideContributionResult: ResolversUnionParentTypes['CreateOutsideContributionResult'];
  CreatePinwheelLinkToken: CreatePinwheelLinkToken;
  CreatePlaidLinkedAccountInput: CreatePlaidLinkedAccountInput;
  CreatePromoCodeInput: CreatePromoCodeInput;
  CreatePromoCodeResult: ResolversUnionParentTypes['CreatePromoCodeResult'];
  CreatePromoCodeRewardInput: CreatePromoCodeRewardInput;
  CreatePromoCodeRewardResult: ResolversUnionParentTypes['CreatePromoCodeRewardResult'];
  CreateProspectUserInput: CreateProspectUserInput;
  CreateProspectUserResult: ResolversUnionParentTypes['CreateProspectUserResult'];
  CreateReferralCampaignInput: CreateReferralCampaignInput;
  CreateReferralCampaignResult: ResolversUnionParentTypes['CreateReferralCampaignResult'];
  CreateReferralCampaignRewardInput: CreateReferralCampaignRewardInput;
  CreateReferralCampaignRewardResult: ResolversUnionParentTypes['CreateReferralCampaignRewardResult'];
  CreateReferralPayoutInput: CreateReferralPayoutInput;
  CreateReferralPayoutResult: ResolversUnionParentTypes['CreateReferralPayoutResult'];
  CreateReferralRelationshipResult: ResolversUnionParentTypes['CreateReferralRelationshipResult'];
  CreateRefundError: CreateRefundError;
  CreateRefundResult: ResolversUnionParentTypes['CreateRefundResult'];
  CreateSavingsAccountInput: CreateSavingsAccountInput;
  CreateSavingsAccountPayload: CreateSavingsAccountPayload;
  CreateSavingsAccountResult: ResolversUnionParentTypes['CreateSavingsAccountResult'];
  CreateSavingsAccountVerificationError: CreateSavingsAccountVerificationError;
  CreateScopeException: CreateScopeException;
  CreateScopeInput: CreateScopeInput;
  CreateScopeResult: ResolversUnionParentTypes['CreateScopeResult'];
  CreateSubscriptionMigrationInput: CreateSubscriptionMigrationInput;
  CreateSubscriptionMigrationResult: ResolversUnionParentTypes['CreateSubscriptionMigrationResult'];
  CreateSupportTicketInput: CreateSupportTicketInput;
  CreateSuspendedUserSupportTicketInput: CreateSuspendedUserSupportTicketInput;
  CreateUploadUrlInput: CreateUploadUrlInput;
  CreateUploadUrlResult: ResolversUnionParentTypes['CreateUploadUrlResult'];
  CreateUserInput: CreateUserInput;
  CreateUserProfileInput: CreateUserProfileInput;
  CreateUserProfileResult: ResolversUnionParentTypes['CreateUserProfileResult'];
  CreateVendorInvoiceInput: CreateVendorInvoiceInput;
  CreateVendorInvoiceResult: ResolversUnionParentTypes['CreateVendorInvoiceResult'];
  CreateVendorLineItemInput: CreateVendorLineItemInput;
  CreateVendorLineItemResult: ResolversUnionParentTypes['CreateVendorLineItemResult'];
  Credentials: Credentials;
  Credit: Credit;
  Cta: Cta;
  CurrencyAmount: CurrencyAmount;
  CurrencyAmountInput: CurrencyAmountInput;
  CurrencyMilestoneProgress: CurrencyMilestoneProgress;
  CurrentBankStatementNotProvided: CurrentBankStatementNotProvided;
  CustomFieldInput: CustomFieldInput;
  CustomFieldOption: CustomFieldOption;
  CustomerAccount: CustomerAccount;
  CustomerAccountClosure: CustomerAccountClosure;
  CustomerAgreementRequiredException: CustomerAgreementRequiredException;
  CustomerEarnOnboardingMilestone: CustomerEarnOnboardingMilestone;
  CustomerEarnOnboardingProgram: ResolversUnionParentTypes['CustomerEarnOnboardingProgram'];
  CustomerEarnOnboardingProgramControl: CustomerEarnOnboardingProgramControl;
  CustomerEarnOnboardingProgramFeature: CustomerEarnOnboardingProgramFeature;
  CustomerMoneyRulesResult: ResolversUnionParentTypes['CustomerMoneyRulesResult'];
  CustomerMoneyRulesResultSuccess: CustomerMoneyRulesResultSuccess;
  CustomerSupportChatWidget: CustomerSupportChatWidget;
  Date: Scalars['Date'];
  DateTime: Scalars['DateTime'];
  DeactivateBeneficiaryResult: ResolversUnionParentTypes['DeactivateBeneficiaryResult'];
  DeactivateOauthAppClientResult: ResolversUnionParentTypes['DeactivateOauthAppClientResult'];
  DeactivateOauthAppResult: ResolversUnionParentTypes['DeactivateOauthAppResult'];
  DeactivateTierSubscriptionInput: DeactivateTierSubscriptionInput;
  DeactivateTierSubscriptionResult: ResolversUnionParentTypes['DeactivateTierSubscriptionResult'];
  DeeplinkWidget: DeeplinkWidget;
  DelegateDefinition: DelegateDefinition;
  DelegateDefinitionInput: DelegateDefinitionInput;
  DelegateFilterInput: DelegateFilterInput;
  DeleteDelegateResult: ResolversUnionParentTypes['DeleteDelegateResult'];
  DeleteDelegateResultTemporaryImpl: DeleteDelegateResultTemporaryImpl;
  DeleteExpiredBankCardOrderCardTierNotFoundError: DeleteExpiredBankCardOrderCardTierNotFoundError;
  DeleteExpiredBankCardOrderNotExpiredError: DeleteExpiredBankCardOrderNotExpiredError;
  DeleteExpiredBankCardOrderNotFoundError: DeleteExpiredBankCardOrderNotFoundError;
  DeleteExpiredBankCardOrderResult: ResolversUnionParentTypes['DeleteExpiredBankCardOrderResult'];
  DeleteOauthAppResult: ResolversUnionParentTypes['DeleteOauthAppResult'];
  DeleteOauthAppSuccess: DeleteOauthAppSuccess;
  DeleteScopeSuccess: DeleteScopeSuccess;
  DeleteTrustedContactResult: ResolversUnionParentTypes['DeleteTrustedContactResult'];
  DepositRiskFactor: DepositRiskFactor;
  DeregisterAuthenticatorInput: DeregisterAuthenticatorInput;
  DeregisterAuthenticatorResult: ResolversUnionParentTypes['DeregisterAuthenticatorResult'];
  DesignLibraryIcon: DesignLibraryIcon;
  Destination: Destination;
  Device: Device;
  DeviceBlockedException: DeviceBlockedException;
  DeviceNotFoundException: DeviceNotFoundException;
  DigitalWalletDevice: DigitalWalletDevice;
  DigitalWalletToken: DigitalWalletToken;
  DirectDepositInfo: DirectDepositInfo;
  DirectDepositInfoPayload: DirectDepositInfoPayload;
  DirectDepositState: DirectDepositState;
  DirectDepositStatePayload: DirectDepositStatePayload;
  DiscreteMilestoneProgress: DiscreteMilestoneProgress;
  DismissMessageInput: DismissMessageInput;
  DismissMessagesInput: DismissMessagesInput;
  DismissMessagesResult: ResolversUnionParentTypes['DismissMessagesResult'];
  DismissMessagesSuccess: DismissMessagesSuccess;
  DistributionAmounts: DistributionAmounts;
  DiversificationBucket: DiversificationBucket;
  DiversificationInfo: DiversificationInfo;
  DiversificationInfoByInvestmentAccountIdInput: DiversificationInfoByInvestmentAccountIdInput;
  Document: Document;
  DocumentInput: DocumentInput;
  DocumentNotFound: DocumentNotFound;
  DocumentRequest: DocumentRequest;
  DocumentRequestEdge: DocumentRequestEdge;
  DocumentRequestInput: DocumentRequestInput;
  DocumentRequestsConnection: DocumentRequestsConnection;
  DocumentRequestsInput: DocumentRequestsInput;
  DocumentRequestsPageInfo: DocumentRequestsPageInfo;
  DocumentRequestsPageInput: DocumentRequestsPageInput;
  DocumentUploadSession: DocumentUploadSession;
  DocumentUploads: DocumentUploads;
  DocumentVerification: DocumentVerification;
  DuplicateActionError: DuplicateActionError;
  DuplicateBillingInfoError: DuplicateBillingInfoError;
  DuplicatePromoCodeError: DuplicatePromoCodeError;
  DuplicatePromoCodeRewardError: DuplicatePromoCodeRewardError;
  ETF: Etf;
  ETFGain: EtfGain;
  ETFPerformance: EtfPerformance;
  ETFPrice: EtfPrice;
  EarlyAccountStateRegulation: EarlyAccountStateRegulation;
  EarlyAccountStateRegulationResult: ResolversUnionParentTypes['EarlyAccountStateRegulationResult'];
  EarlyAccountTransferInfo: EarlyAccountTransferInfo;
  EarlyDebtCollectionItem: EarlyDebtCollectionItem;
  EarlyDividendsItem: EarlyDividendsItem;
  EarlyFeeInvestmentItem: EarlyFeeInvestmentItem;
  EarlyGiftItem: EarlyGiftItem;
  EarlyHistorySummary: EarlyHistorySummary;
  EarlyInvestmentItem: EarlyInvestmentItem;
  EarlyMatchItem: EarlyMatchItem;
  EarlyMatchRemovalItem: EarlyMatchRemovalItem;
  EarlyRefundedItem: EarlyRefundedItem;
  EarlyReinvestmentItem: EarlyReinvestmentItem;
  EarlyWithdrawalItem: EarlyWithdrawalItem;
  EarnCTARecord: EarnCtaRecord;
  EarnMissingCreditRequest: EarnMissingCreditRequest;
  EarnMissingCreditRequestPurchaseDateError: EarnMissingCreditRequestPurchaseDateError;
  EarnOffer: EarnOffer;
  EarnOfferCtaDetails: EarnOfferCtaDetails;
  EarnOfferQueryPage: EarnOfferQueryPage;
  EarnOnboardingMilestoneCta: EarnOnboardingMilestoneCta;
  EarnPageInfo: EarnPageInfo;
  EarnReward: EarnReward;
  Ecbsv: Ecbsv;
  EducationTip: EducationTip;
  Eligibility: Eligibility;
  Email: Scalars['Email'];
  EmailAddress: Scalars['EmailAddress'];
  EmailAddressValidation: EmailAddressValidation;
  EmailAuthChallenge: EmailAuthChallenge;
  EmailAuthenticator: EmailAuthenticator;
  EmailRedirect: EmailRedirect;
  EmailTakenException: EmailTakenException;
  EmergencyFundHistorySummary: EmergencyFundHistorySummary;
  Employer: Omit<Employer, 'switch'> & { switch: ResolversParentTypes['AbstractSwitch'] };
  EmploymentInput: EmploymentInput;
  EnableQuarterlyRecapsInput: EnableQuarterlyRecapsInput;
  EnableQuarterlyRecapsResult: ResolversUnionParentTypes['EnableQuarterlyRecapsResult'];
  EstimatedCheckPaymentDates: EstimatedCheckPaymentDates;
  EstimatedTransferDatesInput: EstimatedTransferDatesInput;
  EstimatedTransferDatesPayload: EstimatedTransferDatesPayload;
  EvaluateCheckDepositInput: EvaluateCheckDepositInput;
  EvaluateCheckDepositPayload: EvaluateCheckDepositPayload;
  ExchangeAcornsEarlyTokenResult: ResolversUnionParentTypes['ExchangeAcornsEarlyTokenResult'];
  ExecuteMoneyInError: ExecuteMoneyInError;
  ExecuteMoneyInInput: ExecuteMoneyInInput;
  ExecuteMoneyInResult: ResolversUnionParentTypes['ExecuteMoneyInResult'];
  ExecuteMoneyInSuccess: ExecuteMoneyInSuccess;
  ExecuteMoneyManagerRebalancesInput: ExecuteMoneyManagerRebalancesInput;
  ExecuteMoneyManagerRebalancesResult: ResolversUnionParentTypes['ExecuteMoneyManagerRebalancesResult'];
  ExecuteMoneyManagerRebalancesSuccess: ExecuteMoneyManagerRebalancesSuccess;
  ExecutionAudit: ExecutionAudit;
  ExistingEmailVerifiedException: ExistingEmailVerifiedException;
  ExistingRequestPendingReview: ExistingRequestPendingReview;
  ExistingRequestPendingUserAction: ExistingRequestPendingUserAction;
  ExperienceContent: ExperienceContent;
  ExpirePromotionalWaiverInput: ExpirePromotionalWaiverInput;
  ExpirePromotionalWaiverResult: ResolversUnionParentTypes['ExpirePromotionalWaiverResult'];
  ExternalMetadata: ExternalMetadata;
  ExtoleCampaignHistoryConnection: ExtoleCampaignHistoryConnection;
  ExtoleCampaignHistoryEdge: ExtoleCampaignHistoryEdge;
  ExtoleReferralCampaign: ExtoleReferralCampaign;
  ExtoleReferralHistory: ExtoleReferralHistory;
  FailVendorInvoiceResult: ResolversUnionParentTypes['FailVendorInvoiceResult'];
  FavoritePartnerOfferGroup: Omit<FavoritePartnerOfferGroup, 'offers'> & { offers: Array<ResolversParentTypes['PartnerOfferGroupItem']> };
  FavoritePartnerOfferInput: FavoritePartnerOfferInput;
  FeaturedLearnContentPreview: ResolversUnionParentTypes['FeaturedLearnContentPreview'];
  FeaturedMilestones: FeaturedMilestones;
  FeaturedMilestonesV2: ResolversUnionParentTypes['FeaturedMilestonesV2'];
  Fee: Fee;
  FeeExecution: FeeExecution;
  FeeNegotiation: FeeNegotiation;
  FeeNegotiationSummary: FeeNegotiationSummary;
  FeeStatusSummary: FeeStatusSummary;
  File: File;
  FileDoesNotExistError: FileDoesNotExistError;
  FileDoesNotExistInS3: FileDoesNotExistInS3;
  FileOrException: ResolversUnionParentTypes['FileOrException'];
  FileSizeError: FileSizeError;
  FileTooLarge: FileTooLarge;
  FinancialAdvisorQuestionResponse: FinancialAdvisorQuestionResponse;
  FinancialAdvisorQuestionsResponse: FinancialAdvisorQuestionsResponse;
  FinancialGoalsInput: FinancialGoalsInput;
  FinancialGoalsResult: FinancialGoalsResult;
  FinancialInstitution: FinancialInstitution;
  FinancialInstitutionTypeEdge: FinancialInstitutionTypeEdge;
  FinancialInstitutionTypePagination: FinancialInstitutionTypePagination;
  FinishSetup: FinishSetup;
  Float: Scalars['Float'];
  FooterContent: FooterContent;
  FormattedMonetaryAmount: FormattedMonetaryAmount;
  FoundMoneyCampaignOfferV2: FoundMoneyCampaignOfferV2;
  FoundMoneyCampaignV2: FoundMoneyCampaignV2;
  FoundMoneyReward: FoundMoneyReward;
  FoundMoneySummary: FoundMoneySummary;
  Friend: Friend;
  FriendExperienceContent: FriendExperienceContent;
  FriendHistory: FriendHistory;
  FriendHistoryConnection: FriendHistoryConnection;
  FriendHistoryEdge: FriendHistoryEdge;
  FriendSummary: FriendSummary;
  FriendV2Output: FriendV2Output;
  Fund: Fund;
  FundSpendInActivationPayload: FundSpendInActivationPayload;
  FundingSource: FundingSource;
  FundingSourceAccount: FundingSourceAccount;
  FundingSourceAlreadyExists: FundingSourceAlreadyExists;
  FundingSourceCredentialsExceedLinkLimit: FundingSourceCredentialsExceedLinkLimit;
  FundingSourceInfo: FundingSourceInfo;
  FundingSourceRequiresRdvException: FundingSourceRequiresRdvException;
  FunnelMetadata: FunnelMetadata;
  GenerateDocumentUploadSessionInput: GenerateDocumentUploadSessionInput;
  GenerateDocumentUploadSessionResult: ResolversUnionParentTypes['GenerateDocumentUploadSessionResult'];
  GenerateLayerLinkSessionInput: GenerateLayerLinkSessionInput;
  GenerateLayerLinkSessionResult: ResolversUnionParentTypes['GenerateLayerLinkSessionResult'];
  GenerateLinkSessionInput: GenerateLinkSessionInput;
  GenerateReferralCodeResult: ResolversUnionParentTypes['GenerateReferralCodeResult'];
  GenerateUpdatedPdfPayload: GenerateUpdatedPdfPayload;
  GetUsersBankFromAccountTypePayload: GetUsersBankFromAccountTypePayload;
  GrowProspect: GrowProspect;
  HelpFormContent: HelpFormContent;
  HelpcenterBannerContent: HelpcenterBannerContent;
  HelpcenterBannerErrors: HelpcenterBannerErrors;
  HelpcenterContentInput: HelpcenterContentInput;
  HideMessageByExternalIdInput: HideMessageByExternalIdInput;
  HideMessageInput: HideMessageInput;
  Holding: Holding;
  HoldingsTransfer: HoldingsTransfer;
  ID: Scalars['ID'];
  IRADistribution: IraDistribution;
  IdentityDocumentRequestedUserAlert: IdentityDocumentRequestedUserAlert;
  IdentityVerification: ResolversParentTypes['BankCardOrderIdentityVerification'] | ResolversParentTypes['BankingKycIdentityVerification'];
  Image: Image;
  ImplicitToken: ImplicitToken;
  Incentive: ResolversParentTypes['MonetaryIncentive'];
  IncorrectOldPasswordException: IncorrectOldPasswordException;
  IncorrectRdvAmounts: IncorrectRdvAmounts;
  IncorrectSecurityAnswerException: IncorrectSecurityAnswerException;
  IncorrectSsnException: IncorrectSsnException;
  InitiateBankAccountInput: InitiateBankAccountInput;
  InitiateBankAccountResponse: InitiateBankAccountResponse;
  InitiateBankingKYCInput: InitiateBankingKycInput;
  InitiateBankingKYCPayload: InitiateBankingKycPayload;
  InitiateChallengeInput: InitiateChallengeInput;
  InitiateChallengeResult: ResolversUnionParentTypes['InitiateChallengeResult'];
  InitiateEmailChallengeInput: InitiateEmailChallengeInput;
  InitiateEmailChallengeResult: ResolversUnionParentTypes['InitiateEmailChallengeResult'];
  InitiateMoneyAssignmentInput: InitiateMoneyAssignmentInput;
  InitiateMoneyAssignmentResult: ResolversUnionParentTypes['InitiateMoneyAssignmentResult'];
  InitiateMoneyAssignmentSuccess: InitiateMoneyAssignmentSuccess;
  InitiatePushChallengeResult: ResolversUnionParentTypes['InitiatePushChallengeResult'];
  InitiatePushChallengeSuccess: InitiatePushChallengeSuccess;
  InitiateSMSChallengeInput: InitiateSmsChallengeInput;
  InitiateSMSChallengeResult: ResolversUnionParentTypes['InitiateSMSChallengeResult'];
  InitiateTransferInput: InitiateTransferInput;
  InitiateTransferPayload: InitiateTransferPayload;
  InitiateVerificationResult: ResolversUnionParentTypes['InitiateVerificationResult'];
  InstitutionNotSupportedError: InstitutionNotSupportedError;
  InsufficientFundsUserAlert: InsufficientFundsUserAlert;
  Int: Scalars['Int'];
  Intent: Intent;
  IntentFilterInput: IntentFilterInput;
  InteractionRatingResponse: InteractionRatingResponse;
  InternalErrorException: InternalErrorException;
  InvalidAccountNumber: InvalidAccountNumber;
  InvalidAccountTypeException: InvalidAccountTypeException;
  InvalidAcornsEarlyTokenException: InvalidAcornsEarlyTokenException;
  InvalidActionOnAccount: InvalidActionOnAccount;
  InvalidAddressError: InvalidAddressError;
  InvalidAddressException: InvalidAddressException;
  InvalidAllocationPercentError: InvalidAllocationPercentError;
  InvalidAppleAccountException: InvalidAppleAccountException;
  InvalidContentTypeException: InvalidContentTypeException;
  InvalidConversionIdentifierException: InvalidConversionIdentifierException;
  InvalidCredentialsException: InvalidCredentialsException;
  InvalidDateException: InvalidDateException;
  InvalidDateOfBirthException: InvalidDateOfBirthException;
  InvalidDeviceParametersException: InvalidDeviceParametersException;
  InvalidEmailException: InvalidEmailException;
  InvalidFile: InvalidFile;
  InvalidFirstNameException: InvalidFirstNameException;
  InvalidGoogleAccountException: InvalidGoogleAccountException;
  InvalidIdentityTokenException: InvalidIdentityTokenException;
  InvalidInvestmentAccountException: InvalidInvestmentAccountException;
  InvalidLastNameException: InvalidLastNameException;
  InvalidManualLink: InvalidManualLink;
  InvalidMfaTokenException: InvalidMfaTokenException;
  InvalidOauthAppClientIdException: InvalidOauthAppClientIdException;
  InvalidOptionException: InvalidOptionException;
  InvalidPasswordException: InvalidPasswordException;
  InvalidPasswordResetException: InvalidPasswordResetException;
  InvalidPasswordResetTokenException: InvalidPasswordResetTokenException;
  InvalidPhoneException: InvalidPhoneException;
  InvalidPhoneNumberException: InvalidPhoneNumberException;
  InvalidPinException: InvalidPinException;
  InvalidPortfolioIdException: InvalidPortfolioIdException;
  InvalidPromoCodeError: InvalidPromoCodeError;
  InvalidReferralRelationship: InvalidReferralRelationship;
  InvalidRoutingNumber: InvalidRoutingNumber;
  InvalidSecurityError: InvalidSecurityError;
  InvalidSecurityForAllocationError: InvalidSecurityForAllocationError;
  InvalidSingleRuleIdError: InvalidSingleRuleIdError;
  InvalidSourceAttributesException: InvalidSourceAttributesException;
  InvalidSsnException: InvalidSsnException;
  InvalidStateException: InvalidStateException;
  InvalidSubscriptionTierException: InvalidSubscriptionTierException;
  InvalidTerminationAgeException: InvalidTerminationAgeException;
  InvalidTier: InvalidTier;
  InvalidTierForMigrationError: InvalidTierForMigrationError;
  InvalidTierPrice: InvalidTierPrice;
  InvalidTierPriceCombination: InvalidTierPriceCombination;
  InvalidTierPriceId: InvalidTierPriceId;
  InvalidUserIdException: InvalidUserIdException;
  InvalidUserTokenException: InvalidUserTokenException;
  InvestHistorySummary: InvestHistorySummary;
  InvestingStrategyFactors: InvestingStrategyFactors;
  Investment: Investment;
  InvestmentAccount: InvestmentAccount;
  InvestmentAccountAlreadyClosed: InvestmentAccountAlreadyClosed;
  InvestmentAccountClosureInProgress: InvestmentAccountClosureInProgress;
  InvestmentAccountClosureRequest: InvestmentAccountClosureRequest;
  InvestmentAccountCreationException: InvestmentAccountCreationException;
  InvestmentAccountNeedsTransferException: InvestmentAccountNeedsTransferException;
  InvestmentAccountNotClosedException: InvestmentAccountNotClosedException;
  InvestmentAccountNotFoundException: InvestmentAccountNotFoundException;
  InvestmentAccountNotSupportedException: InvestmentAccountNotSupportedException;
  InvestmentAccountOutsideContribution: InvestmentAccountOutsideContribution;
  InvestmentAccountRecap: InvestmentAccountRecap;
  InvestmentAccountRecapNotFoundException: InvestmentAccountRecapNotFoundException;
  InvestmentAccountReopenRequest: InvestmentAccountReopenRequest;
  InvestmentAccountReopenRequestAction: InvestmentAccountReopenRequestAction;
  InvestmentAccountReopenRequestNote: InvestmentAccountReopenRequestNote;
  InvestmentAccountSummary: InvestmentAccountSummary;
  InvestmentAccountTransferability: InvestmentAccountTransferability;
  InvestmentAccountsByUserIdFilter: InvestmentAccountsByUserIdFilter;
  InvestmentAggregation: InvestmentAggregation;
  InvestmentAllocation: InvestmentAllocation;
  InvestmentCategory: InvestmentCategory;
  InvestmentEdge: InvestmentEdge;
  InvestmentNotFoundException: InvestmentNotFoundException;
  InvestmentPagination: InvestmentPagination;
  InvestmentUncancellableException: InvestmentUncancellableException;
  InvestmentsPausedUserAlert: InvestmentsPausedUserAlert;
  InvestorQuestionsInput: InvestorQuestionsInput;
  Invitation: Invitation;
  Invoice: Invoice;
  InvoiceCollection: InvoiceCollection;
  InvoiceItem: InvoiceItem;
  InvoiceLineItem: InvoiceLineItem;
  JSON: Scalars['JSON'];
  JobAlert: JobAlert;
  JobAlertCriteriaInput: JobAlertCriteriaInput;
  JobLocation: JobLocation;
  JobLocationInput: JobLocationInput;
  JobOffer: JobOffer;
  JobOfferSalary: JobOfferSalary;
  JobSearchCriteria: JobSearchCriteria;
  JobSearchCriteriaInput: JobSearchCriteriaInput;
  JobSearchFilter: JobSearchFilter;
  JobSearchFilterInput: JobSearchFilterInput;
  JobSearchOffer: JobSearchOffer;
  JobSearchPage: JobSearchPage;
  LadderLinkResponse: LadderLinkResponse;
  LadderQuote: LadderQuote;
  LadderQuoteStatus: LadderQuoteStatus;
  LadderResponse: LadderResponse;
  LaterAccount: LaterAccount;
  LaterAccountAlreadyVerified: LaterAccountAlreadyVerified;
  LaterAccountIneligibleForVerification: LaterAccountIneligibleForVerification;
  LaterAccountInfo: LaterAccountInfo;
  LaterAccountInfoOrError: ResolversUnionParentTypes['LaterAccountInfoOrError'];
  LaterAccountNotFound: LaterAccountNotFound;
  LaterAccountRequiresTaxWithholdings: LaterAccountRequiresTaxWithholdings;
  LaterAccountRequiresWithdrawalReason: LaterAccountRequiresWithdrawalReason;
  LaterAccountTaxWithholdingsPercentageExceeded: LaterAccountTaxWithholdingsPercentageExceeded;
  LaterBeneficiary: ResolversParentTypes['LaterIndividualBeneficiary'];
  LaterContributionAbilityResult: ResolversUnionParentTypes['LaterContributionAbilityResult'];
  LaterContributionLimitMet: LaterContributionLimitMet;
  LaterDebtCollectionItem: LaterDebtCollectionItem;
  LaterDividendsItem: LaterDividendsItem;
  LaterFeeInvestmentItem: LaterFeeInvestmentItem;
  LaterFullContributionSuccess: LaterFullContributionSuccess;
  LaterHistoryItem: ResolversParentTypes['LaterWithdrawal'];
  LaterHistorySummary: LaterHistorySummary;
  LaterIndividualBeneficiary: LaterIndividualBeneficiary;
  LaterIndividualBeneficiaryResponse: LaterIndividualBeneficiaryResponse;
  LaterInvestmentItem: LaterInvestmentItem;
  LaterMatchItem: LaterMatchItem;
  LaterMatchRemovalItem: LaterMatchRemovalItem;
  LaterPartialContributionSuccess: LaterPartialContributionSuccess;
  LaterPortfolioPerformance: LaterPortfolioPerformance;
  LaterProgramAccountContributionInput: LaterProgramAccountContributionInput;
  LaterProgramAccountContributionResult: ResolversUnionParentTypes['LaterProgramAccountContributionResult'];
  LaterRebalanceItem: LaterRebalanceItem;
  LaterRefundedItem: LaterRefundedItem;
  LaterReinvestmentItem: LaterReinvestmentItem;
  LaterTypedException: ResolversParentTypes['LaterAccountAlreadyVerified'] | ResolversParentTypes['LaterAccountIneligibleForVerification'] | ResolversParentTypes['LaterAccountNotFound'];
  LaterWaitlistProspect: LaterWaitlistProspect;
  LaterWithdrawal: LaterWithdrawal;
  LaterWithdrawalItem: LaterWithdrawalItem;
  LaterWithholdingValues: LaterWithholdingValues;
  LayerLinkSession: LayerLinkSession;
  LayerLinkSessionInput: LayerLinkSessionInput;
  LearnAnswer: LearnAnswer;
  LearnAnswerInput: LearnAnswerInput;
  LearnArticle: Omit<LearnArticle, 'contentImage' | 'duration' | 'featuredImage'> & { contentImage: Maybe<ResolversParentTypes['LearnVisualAsset']>, duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  LearnArticlePreview: Omit<LearnArticlePreview, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  LearnArticlePreviewLocked: Omit<LearnArticlePreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  LearnAuthor: Omit<LearnAuthor, 'photo'> & { photo: Maybe<ResolversParentTypes['LearnVisualAsset']> };
  LearnConnection: ResolversParentTypes['ContentPreviewConnection'];
  LearnContentCategory: ResolversUnionParentTypes['LearnContentCategory'];
  LearnContentCommunityStats: ResolversUnionParentTypes['LearnContentCommunityStats'];
  LearnContentDuration: ResolversUnionParentTypes['LearnContentDuration'];
  LearnContentElapsedMillisecondsUpdatedResult: LearnContentElapsedMillisecondsUpdatedResult;
  LearnContentFilterByTierIdInput: LearnContentFilterByTierIdInput;
  LearnContentFilterByTopicIdInput: LearnContentFilterByTopicIdInput;
  LearnContentFilterInput: LearnContentFilterInput;
  LearnContentInteractionState: ResolversUnionParentTypes['LearnContentInteractionState'];
  LearnContentPageInput: LearnContentPageInput;
  LearnContentPreview: ResolversUnionParentTypes['LearnContentPreview'];
  LearnContentStats: LearnContentStats;
  LearnCourse: ResolversUnionParentTypes['LearnCourse'];
  LearnCoursePreview: ResolversUnionParentTypes['LearnCoursePreview'];
  LearnEdge: ResolversParentTypes['ContentPreviewEdge'];
  LearnHubCitation: LearnHubCitation;
  LearnInsight: LearnInsight;
  LearnInteractionState: Omit<LearnInteractionState, 'elapsedTime'> & { elapsedTime: Maybe<ResolversParentTypes['LearnContentDuration']> };
  LearnMedia: ResolversUnionParentTypes['LearnMedia'];
  LearnMediaArticle: Omit<LearnMediaArticle, 'audioTheme' | 'featuredImage'> & { audioTheme: Maybe<ResolversParentTypes['LearnMediaTheme']>, featuredImage: Maybe<ResolversParentTypes['LearnVisualAsset']> };
  LearnMediaPreview: Omit<LearnMediaPreview, 'audioTheme' | 'duration' | 'featuredImage'> & { audioTheme: Maybe<ResolversParentTypes['LearnMediaTheme']>, duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  LearnMediaPreviewLocked: Omit<LearnMediaPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  LearnMediaReference: Omit<LearnMediaReference, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: Maybe<ResolversParentTypes['LearnVisualAsset']>, theme: Maybe<ResolversParentTypes['LearnMediaTheme']> };
  LearnMediaTheme: ResolversUnionParentTypes['LearnMediaTheme'];
  LearnMetadata: Omit<LearnMetadata, 'contentStats' | 'interactionState'> & { contentStats: Maybe<ResolversParentTypes['LearnContentCommunityStats']>, interactionState: Maybe<ResolversParentTypes['LearnContentInteractionState']> };
  LearnNextStepAction: LearnNextStepAction;
  LearnPageInfo: LearnPageInfo;
  LearnPoll: LearnPoll;
  LearnPollOption: LearnPollOption;
  LearnPollPreview: LearnPollPreview;
  LearnPollPreviewLocked: LearnPollPreviewLocked;
  LearnPollResponse: LearnPollResponse;
  LearnProgress: LearnProgress;
  LearnProgressInput: LearnProgressInput;
  LearnProgressUpdatedResult: LearnProgressUpdatedResult;
  LearnQuestion: LearnQuestion;
  LearnQuestionInsight: LearnQuestionInsight;
  LearnQuiz: ResolversUnionParentTypes['LearnQuiz'];
  LearnQuizAnswerResult: LearnQuizAnswerResult;
  LearnQuizPreview: ResolversUnionParentTypes['LearnQuizPreview'];
  LearnSearchTermSavedResult: LearnSearchTermSavedResult;
  LearnTag: LearnTag;
  LearnThemeLiteral: LearnThemeLiteral;
  LearnTier: Omit<LearnTier, 'icon'> & { icon: ResolversParentTypes['LearnVisualAsset'] };
  LearnTopic: Omit<LearnTopic, 'icon'> & { icon: ResolversParentTypes['LearnVisualAsset'] };
  LearnVisualAsset: ResolversUnionParentTypes['LearnVisualAsset'];
  LegacyAlertDismissalSuccess: LegacyAlertDismissalSuccess;
  LegacyUploadDocument: LegacyUploadDocument;
  LegacyUploadDocumentInput: LegacyUploadDocumentInput;
  LegacyUploadDocumentResult: ResolversUnionParentTypes['LegacyUploadDocumentResult'];
  Lesson: Lesson;
  LessonPreview: Omit<LessonPreview, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  LessonPreviewLocked: Omit<LessonPreviewLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'] };
  LinkManualFundingSourceInput: LinkManualFundingSourceInput;
  LinkManualFundingSourceResult: ResolversUnionParentTypes['LinkManualFundingSourceResult'];
  LinkOidcCredentialsInput: LinkOidcCredentialsInput;
  LinkOidcCredentialsResult: ResolversUnionParentTypes['LinkOidcCredentialsResult'];
  LinkOidcCredentialsSuccess: LinkOidcCredentialsSuccess;
  LinkSessionInput: LinkSessionInput;
  LinkSessionResult: ResolversUnionParentTypes['LinkSessionResult'];
  LinkedAccount: LinkedAccount;
  LinkedAccountAlert: LinkedAccountAlert;
  LinkedAccountAlertsResponse: ResolversUnionParentTypes['LinkedAccountAlertsResponse'];
  LinkedAccountNotFound: LinkedAccountNotFound;
  LinkedSubaccount: LinkedSubaccount;
  Liquidation: Liquidation;
  LiquidationUnavailableError: LiquidationUnavailableError;
  LockBankCardInput: LockBankCardInput;
  LockBankCardPayload: LockBankCardPayload;
  LoginAccess: LoginAccess;
  LoginRateLimitedException: LoginRateLimitedException;
  LogoutDeviceInput: LogoutDeviceInput;
  LogoutDeviceResult: ResolversUnionParentTypes['LogoutDeviceResult'];
  LogoutDeviceSuccess: LogoutDeviceSuccess;
  LogoutResult: ResolversUnionParentTypes['LogoutResult'];
  LogoutSuccess: LogoutSuccess;
  MakeInvestmentInput: MakeInvestmentInput;
  MakeInvestmentPayload: MakeInvestmentPayload;
  MalformedRecurringTransferException: MalformedRecurringTransferException;
  MarkAllAsReadResult: ResolversUnionParentTypes['MarkAllAsReadResult'];
  MarkAllAsReadSuccess: MarkAllAsReadSuccess;
  MarkLearnContentAsHelpfulInput: MarkLearnContentAsHelpfulInput;
  MarkLearnContentAsHelpfulResult: ResolversUnionParentTypes['MarkLearnContentAsHelpfulResult'];
  MarkLearnContentAsViewedInput: MarkLearnContentAsViewedInput;
  MarkLearnContentAsViewedResult: ResolversUnionParentTypes['MarkLearnContentAsViewedResult'];
  Market: Market;
  MarketReturn: MarketReturn;
  MatchProgram: MatchProgram;
  MaxAccountsCreatedException: MaxAccountsCreatedException;
  Message: ResolversParentTypes['AlertMessage'] | ResolversParentTypes['NotificationMessage'];
  MessageConnection: MessageConnection;
  MessageEdge: MessageEdge;
  MessageFeedbackInput: MessageFeedbackInput;
  MessagePageInfo: MessagePageInfo;
  MessagePageInput: MessagePageInput;
  MessageStatusFilterInput: MessageStatusFilterInput;
  MessageTextAsset: ResolversUnionParentTypes['MessageTextAsset'];
  MessageVisualAsset: ResolversUnionParentTypes['MessageVisualAsset'];
  MfaMissingAuthAlert: MfaMissingAuthAlert;
  Micros: Scalars['Micros'];
  MicrosMoney: MicrosMoney;
  MightyOakCardWaiver: MightyOakCardWaiver;
  MightyOakCardWaiverExpiredException: MightyOakCardWaiverExpiredException;
  MightyOakCardWaiverNotFoundException: MightyOakCardWaiverNotFoundException;
  MightyOakWaiverResult: ResolversUnionParentTypes['MightyOakWaiverResult'];
  Milestone: Omit<Milestone, 'progress'> & { progress: ResolversParentTypes['MilestoneProgress'] };
  MilestoneAccountLevelDefinition: MilestoneAccountLevelDefinition;
  MilestoneAchievementActionRule: MilestoneAchievementActionRule;
  MilestoneByThemeFilterInput: MilestoneByThemeFilterInput;
  MilestoneChallenge: Omit<MilestoneChallenge, 'groupedMilestones'> & { groupedMilestones: Array<ResolversParentTypes['MilestoneGroup']> };
  MilestoneChallengePointsRule: MilestoneChallengePointsRule;
  MilestoneDefinition: MilestoneDefinition;
  MilestoneEligibility: MilestoneEligibility;
  MilestoneGroup: ResolversUnionParentTypes['MilestoneGroup'];
  MilestoneGroupAchievementActionRule: MilestoneGroupAchievementActionRule;
  MilestoneGroupDefinition: MilestoneGroupDefinition;
  MilestoneHub: Omit<MilestoneHub, 'groupedMilestones'> & { groupedMilestones: Array<ResolversParentTypes['MilestoneGroup']> };
  MilestoneHubAccount: MilestoneHubAccount;
  MilestoneHubDefinition: MilestoneHubDefinition;
  MilestoneProgress: ResolversUnionParentTypes['MilestoneProgress'];
  MilestoneRule: MilestoneRule;
  MilestoneRuleGroup: Omit<MilestoneRuleGroup, 'contents'> & { contents: Array<ResolversParentTypes['MilestoneRuleGroupContent']> };
  MilestoneRuleGroupContent: ResolversUnionParentTypes['MilestoneRuleGroupContent'];
  MilestoneThemeGroup: Omit<MilestoneThemeGroup, 'contents'> & { contents: Array<ResolversParentTypes['MilestoneThemeGroupContent']> };
  MilestoneThemeGroupContent: ResolversUnionParentTypes['MilestoneThemeGroupContent'];
  Milliseconds: Milliseconds;
  MillisecondsInput: MillisecondsInput;
  MiscDocumentRequestedUserAlert: MiscDocumentRequestedUserAlert;
  MismatchedDistributionUnitsError: MismatchedDistributionUnitsError;
  MissingAgreementsException: MissingAgreementsException;
  MissingBeneficiarySsnException: MissingBeneficiarySsnException;
  MissingFundingSourceException: MissingFundingSourceException;
  MissingRequiredAgreementsException: MissingRequiredAgreementsException;
  MissingSsnBeneficiaryAlert: MissingSsnBeneficiaryAlert;
  MissingSsnBeneficiaryAlertItem: MissingSsnBeneficiaryAlertItem;
  MissingValidRulesetError: MissingValidRulesetError;
  ModifyMoneyAssignmentInput: ModifyMoneyAssignmentInput;
  ModifyMoneyAssignmentResult: ResolversUnionParentTypes['ModifyMoneyAssignmentResult'];
  ModifyMoneyAssignmentSuccess: ModifyMoneyAssignmentSuccess;
  MonetaryAmount: MonetaryAmount;
  MonetaryAmountInput: MonetaryAmountInput;
  MonetaryIncentive: MonetaryIncentive;
  MoneyAssignmentAlreadyTransferredError: MoneyAssignmentAlreadyTransferredError;
  MoneyAssignmentConnection: MoneyAssignmentConnection;
  MoneyAssignmentEdge: MoneyAssignmentEdge;
  MoneyAssignmentNotFoundError: MoneyAssignmentNotFoundError;
  MoneyInEventInput: MoneyInEventInput;
  MoneyManagerAllocation: MoneyManagerAllocation;
  MoneyManagerAllocationOption: MoneyManagerAllocationOption;
  MoneyManagerAllocationOptionsInput: MoneyManagerAllocationOptionsInput;
  MoneyManagerAllocationRemainder: MoneyManagerAllocationRemainder;
  MoneyManagerAllocationResult: MoneyManagerAllocationResult;
  MoneyManagerAutomationTarget: MoneyManagerAutomationTarget;
  MoneyManagerCascadeObjective: MoneyManagerCascadeObjective;
  MoneyManagerCascadeTarget: MoneyManagerCascadeTarget;
  MoneyManagerCategoriesInput: MoneyManagerCategoriesInput;
  MoneyManagerCategoriesResult: ResolversUnionParentTypes['MoneyManagerCategoriesResult'];
  MoneyManagerCategoriesSuccess: MoneyManagerCategoriesSuccess;
  MoneyManagerCategory: MoneyManagerCategory;
  MoneyManagerCategoryAllocation: MoneyManagerCategoryAllocation;
  MoneyManagerDeposit: ResolversParentTypes['MoneyManagerPaycheck'] | ResolversParentTypes['MoneyManagerRecurringDeposit'];
  MoneyManagerDepositAssignment: MoneyManagerDepositAssignment;
  MoneyManagerDepositSummary: MoneyManagerDepositSummary;
  MoneyManagerEligibilityResult: MoneyManagerEligibilityResult;
  MoneyManagerError: ResolversParentTypes['MoneyManagerInputError'] | ResolversParentTypes['MoneyManagerRulesetNotFoundError'];
  MoneyManagerGlobalConfig: MoneyManagerGlobalConfig;
  MoneyManagerInputError: MoneyManagerInputError;
  MoneyManagerMoneyAssignment: ResolversParentTypes['MoneyManagerDepositAssignment'] | ResolversParentTypes['MoneyManagerRebalanceAssignment'];
  MoneyManagerNormalizedAmounts: MoneyManagerNormalizedAmounts;
  MoneyManagerPageInfo: MoneyManagerPageInfo;
  MoneyManagerPageInput: MoneyManagerPageInput;
  MoneyManagerPaycheck: MoneyManagerPaycheck;
  MoneyManagerPeriod: MoneyManagerPeriod;
  MoneyManagerPeriodInput: MoneyManagerPeriodInput;
  MoneyManagerRebalanceAllocationInput: MoneyManagerRebalanceAllocationInput;
  MoneyManagerRebalanceAssignment: MoneyManagerRebalanceAssignment;
  MoneyManagerRebalanceResult: MoneyManagerRebalanceResult;
  MoneyManagerRebalanceRuleset: MoneyManagerRebalanceRuleset;
  MoneyManagerRebalanceRulesetInput: MoneyManagerRebalanceRulesetInput;
  MoneyManagerRebalancesResponse: MoneyManagerRebalancesResponse;
  MoneyManagerRecurringDeposit: MoneyManagerRecurringDeposit;
  MoneyManagerRecurringDepositsConfig: MoneyManagerRecurringDepositsConfig;
  MoneyManagerRulesetNotFoundError: MoneyManagerRulesetNotFoundError;
  MoneyManagerScheduledDeposit: ResolversParentTypes['MoneyManagerScheduledPaycheck'] | ResolversParentTypes['MoneyManagerScheduledRecurringDeposit'];
  MoneyManagerScheduledPaycheck: MoneyManagerScheduledPaycheck;
  MoneyManagerScheduledRecurringDeposit: MoneyManagerScheduledRecurringDeposit;
  MoneyManagerSettings: MoneyManagerSettings;
  MoneyManagerSourceSetting: MoneyManagerSourceSetting;
  MoneyManagerStagedRulesInput: MoneyManagerStagedRulesInput;
  MoneyManagerSummary: MoneyManagerSummary;
  MoneyRulesArchetypesInput: MoneyRulesArchetypesInput;
  MoneyRulesArchetypesResult: ResolversUnionParentTypes['MoneyRulesArchetypesResult'];
  MoneyRulesArchetypesSuccess: MoneyRulesArchetypesSuccess;
  MoneyRulesCancelMoneyAssignmentSuccess: MoneyRulesCancelMoneyAssignmentSuccess;
  MoneyRulesCondition: MoneyRulesCondition;
  MoneyRulesConditionInput: MoneyRulesConditionInput;
  MoneyRulesCurrencyAmount: MoneyRulesCurrencyAmount;
  MoneyRulesCurrencyAmountInput: MoneyRulesCurrencyAmountInput;
  MoneyRulesDestination: MoneyRulesDestination;
  MoneyRulesDestinationInput: MoneyRulesDestinationInput;
  MoneyRulesDistribution: MoneyRulesDistribution;
  MoneyRulesDistributionInput: MoneyRulesDistributionInput;
  MoneyRulesMoneySource: MoneyRulesMoneySource;
  MoneyRulesMoneySourceInput: MoneyRulesMoneySourceInput;
  MoneyRulesMoneySplit: MoneyRulesMoneySplit;
  MoneyRulesRule: MoneyRulesRule;
  MoneyRulesRuleInput: MoneyRulesRuleInput;
  MoneyRulesRuleset: MoneyRulesRuleset;
  MoneyRulesRulesetInput: MoneyRulesRulesetInput;
  MoneyRulesRulesetNotFoundException: MoneyRulesRulesetNotFoundException;
  MoneyRulesSettings: MoneyRulesSettings;
  MoneyRulesSourceSetting: MoneyRulesSourceSetting;
  MoneyRulesSplitOverridesInput: MoneyRulesSplitOverridesInput;
  MoneyRulesSuggestedSplits: MoneyRulesSuggestedSplits;
  MoneyRulesSuggestionResult: ResolversUnionParentTypes['MoneyRulesSuggestionResult'];
  MoneyRulesUpdateArchetypeResult: ResolversUnionParentTypes['MoneyRulesUpdateArchetypeResult'];
  MoneyRulesUpdateCustomerMoneyRulesResult: ResolversUnionParentTypes['MoneyRulesUpdateCustomerMoneyRulesResult'];
  MoneyRulesUpdateRulesetSuccess: MoneyRulesUpdateRulesetSuccess;
  MonthlyTotal: MonthlyTotal;
  Mutation: {};
  NativeLoginInput: NativeLoginInput;
  NegativeSecurityPercentError: NegativeSecurityPercentError;
  NegotiationServiceConnectionFailure: NegotiationServiceConnectionFailure;
  NegotiationStatus: NegotiationStatus;
  NextBillingDate: NextBillingDate;
  NextTransferDateResult: ResolversUnionParentTypes['NextTransferDateResult'];
  NoBeneficiaryFoundException: NoBeneficiaryFoundException;
  NoFundingSourceUserAlert: NoFundingSourceUserAlert;
  NoProspectRecord: NoProspectRecord;
  NoRegisteredPushAuthenticatorsException: NoRegisteredPushAuthenticatorsException;
  NonBasicAccountOpenException: NonBasicAccountOpenException;
  NonUniqueSingleRuleIdsError: NonUniqueSingleRuleIdsError;
  Notification: Notification;
  NotificationMessage: Omit<NotificationMessage, 'body' | 'icon' | 'title'> & { body: ResolversParentTypes['MessageTextAsset'], icon: Maybe<ResolversParentTypes['MessageVisualAsset']>, title: ResolversParentTypes['MessageTextAsset'] };
  Notifications: Notifications;
  OauthApp: OauthApp;
  OauthAppClient: OauthAppClient;
  OauthAppClientNotFoundException: OauthAppClientNotFoundException;
  OauthAppImageUpload: OauthAppImageUpload;
  OauthAppNotFoundException: OauthAppNotFoundException;
  OauthAppScope: OauthAppScope;
  Occupation: Occupation;
  Offer: Omit<Offer, 'offering'> & { offering: ResolversParentTypes['Offering'] };
  OfferExpiration: OfferExpiration;
  OfferLocation: OfferLocation;
  OfferLocationInput: OfferLocationInput;
  OfferPrice: OfferPrice;
  OfferPriceInput: OfferPriceInput;
  Offering: ResolversUnionParentTypes['Offering'];
  OidcCredentialsAlreadyLinkedException: OidcCredentialsAlreadyLinkedException;
  OidcCredentialsNotFoundException: OidcCredentialsNotFoundException;
  OidcCredentialsTakenException: OidcCredentialsTakenException;
  OidcLoginInput: OidcLoginInput;
  OnboardingBenefitsInput: OnboardingBenefitsInput;
  OnboardingProductStatus: OnboardingProductStatus;
  OnboardingProductTile: OnboardingProductTile;
  OnboardingTileGroup: OnboardingTileGroup;
  OnboardingTipItem: OnboardingTipItem;
  OnboardingTips: OnboardingTips;
  OnlineSwitch: OnlineSwitch;
  OpenAccountsException: OpenAccountsException;
  OpenCoreInvestmentAccountInput: OpenCoreInvestmentAccountInput;
  OpenCoreInvestmentAccountResult: ResolversUnionParentTypes['OpenCoreInvestmentAccountResult'];
  OpenEarlyAccountInput: OpenEarlyAccountInput;
  OpenEarlyAccountResult: ResolversUnionParentTypes['OpenEarlyAccountResult'];
  OrderBankCardInput: OrderBankCardInput;
  OrderBankCardResult: ResolversUnionParentTypes['OrderBankCardResult'];
  OutsideContribution: OutsideContribution;
  OutsideContributionCheckoutCart: OutsideContributionCheckoutCart;
  OutsideContributionCode: OutsideContributionCode;
  OutsideContributionProspect: OutsideContributionProspect;
  OverrideInput: OverrideInput;
  PageInfo: PageInfo;
  PageInput: PageInput;
  PaginationInput: PaginationInput;
  ParameterizedPdfInput: ParameterizedPdfInput;
  PartnerDataShare: PartnerDataShare;
  PartnerDataShareInput: PartnerDataShareInput;
  PartnerDataShareResponse: ResolversUnionParentTypes['PartnerDataShareResponse'];
  PartnerDetailsResponse: PartnerDetailsResponse;
  PartnerDocumentUrlResponse: PartnerDocumentUrlResponse;
  PartnerOfferGroup: Omit<PartnerOfferGroup, 'offers'> & { offers: Array<ResolversParentTypes['PartnerOfferGroupItem']> };
  PartnerOfferGroupFilterInput: PartnerOfferGroupFilterInput;
  PartnerOfferGroupItem: ResolversUnionParentTypes['PartnerOfferGroupItem'];
  PartnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput;
  PartnerStatusInput: PartnerStatusInput;
  PartnerUrlInput: PartnerUrlInput;
  PartnerUrlResponse: PartnerUrlResponse;
  PasswordResetForm: PasswordResetForm;
  PasswordResetFormFields: PasswordResetFormFields;
  PastAnnotatedItem: ResolversParentTypes['EarlyGiftItem'];
  PastBeneficiaryInfo: PastBeneficiaryInfo;
  PastBeneficiaryTransferInvestmentItem: PastBeneficiaryTransferInvestmentItem;
  PastCashOwedCollectionInvestmentItem: PastCashOwedCollectionInvestmentItem;
  PastCashReinvestmentInvestmentItem: PastCashReinvestmentInvestmentItem;
  PastCoreCombinedItem: ResolversParentTypes['CoreInvestmentItem'] | ResolversParentTypes['CoreRoundUpsItem'];
  PastCoreItem: PastCoreItem;
  PastCoreSummary: PastCoreSummary;
  PastCoreTradedItem: ResolversParentTypes['CoreAdjustmentItem'] | ResolversParentTypes['CoreDebtCollectionItem'] | ResolversParentTypes['CoreDividendsItem'] | ResolversParentTypes['CoreEmployeeCreditItem'] | ResolversParentTypes['CoreFeeInvestmentItem'] | ResolversParentTypes['CoreFoundMoneyRewardItem'] | ResolversParentTypes['CoreGiftCardCreditRedemptionItem'] | ResolversParentTypes['CoreInvestmentItem'] | ResolversParentTypes['CoreLocalFoundMoneyItem'] | ResolversParentTypes['CorePartnerRewardItem'] | ResolversParentTypes['CoreRebalanceItem'] | ResolversParentTypes['CoreReferralRewardItem'] | ResolversParentTypes['CoreRefundedItem'] | ResolversParentTypes['CoreReinvestmentItem'] | ResolversParentTypes['CoreRoundUpsItem'] | ResolversParentTypes['CoreWithdrawalItem'] | ResolversParentTypes['EarlyDebtCollectionItem'] | ResolversParentTypes['EarlyDividendsItem'] | ResolversParentTypes['EarlyFeeInvestmentItem'] | ResolversParentTypes['EarlyGiftItem'] | ResolversParentTypes['EarlyInvestmentItem'] | ResolversParentTypes['EarlyMatchItem'] | ResolversParentTypes['EarlyMatchRemovalItem'] | ResolversParentTypes['EarlyRefundedItem'] | ResolversParentTypes['EarlyReinvestmentItem'] | ResolversParentTypes['EarlyWithdrawalItem'] | ResolversParentTypes['LaterDebtCollectionItem'] | ResolversParentTypes['LaterDividendsItem'] | ResolversParentTypes['LaterFeeInvestmentItem'] | ResolversParentTypes['LaterInvestmentItem'] | ResolversParentTypes['LaterMatchItem'] | ResolversParentTypes['LaterMatchRemovalItem'] | ResolversParentTypes['LaterRebalanceItem'] | ResolversParentTypes['LaterRefundedItem'] | ResolversParentTypes['LaterReinvestmentItem'] | ResolversParentTypes['LaterWithdrawalItem'];
  PastDividendInvestmentItem: PastDividendInvestmentItem;
  PastEarlyItem: ResolversParentTypes['EarlyDividendsItem'] | ResolversParentTypes['EarlyFeeInvestmentItem'] | ResolversParentTypes['EarlyGiftItem'] | ResolversParentTypes['EarlyInvestmentItem'] | ResolversParentTypes['EarlyMatchItem'] | ResolversParentTypes['EarlyMatchRemovalItem'] | ResolversParentTypes['EarlyRefundedItem'] | ResolversParentTypes['EarlyReinvestmentItem'] | ResolversParentTypes['EarlyWithdrawalItem'];
  PastEarlySummary: PastEarlySummary;
  PastEmployeeContributionInvestmentItem: PastEmployeeContributionInvestmentItem;
  PastExternalTransferInvestmentItem: PastExternalTransferInvestmentItem;
  PastExternalTransferReversedInvestmentItem: PastExternalTransferReversedInvestmentItem;
  PastFeeInvestmentItem: PastFeeInvestmentItem;
  PastGiftCardInvestmentItem: PastGiftCardInvestmentItem;
  PastIRATransferInvestmentItem: PastIraTransferInvestmentItem;
  PastInvestmentItem: ResolversParentTypes['PastBeneficiaryTransferInvestmentItem'] | ResolversParentTypes['PastCashOwedCollectionInvestmentItem'] | ResolversParentTypes['PastCashReinvestmentInvestmentItem'] | ResolversParentTypes['PastDividendInvestmentItem'] | ResolversParentTypes['PastEmployeeContributionInvestmentItem'] | ResolversParentTypes['PastExternalTransferInvestmentItem'] | ResolversParentTypes['PastExternalTransferReversedInvestmentItem'] | ResolversParentTypes['PastFeeInvestmentItem'] | ResolversParentTypes['PastGiftCardInvestmentItem'] | ResolversParentTypes['PastIRATransferInvestmentItem'] | ResolversParentTypes['PastLumpSumInvestment'] | ResolversParentTypes['PastMatchInvestmentItem'] | ResolversParentTypes['PastMatchRemovalInvestmentItem'] | ResolversParentTypes['PastOutsideContributionInvestmentItem'] | ResolversParentTypes['PastRealTimeRoundUpInvestmentItem'] | ResolversParentTypes['PastRebalanceInvestmentItem'] | ResolversParentTypes['PastRecurringInvestmentItem'] | ResolversParentTypes['PastReferralRewardInvestmentItem'] | ResolversParentTypes['PastReferralRewardMatchInvestmentItem'] | ResolversParentTypes['PastRefundInvestmentItem'] | ResolversParentTypes['PastReversalInvestmentItem'] | ResolversParentTypes['PastRewardInvestmentItem'] | ResolversParentTypes['PastRewardMatchInvestmentItem'] | ResolversParentTypes['PastRoundUpItem'] | ResolversParentTypes['PastRoundUpMatchInvestmentItem'] | ResolversParentTypes['PastSecurityLiquidationInvestmentItem'] | ResolversParentTypes['PastSmartDepositInvestmentItem'] | ResolversParentTypes['PastWithdrawalInvestmentItem'];
  PastItem: ResolversParentTypes['CoreACHSubscriptionFeeItem'] | ResolversParentTypes['CoreAdjustmentItem'] | ResolversParentTypes['CoreCashForwardItem'] | ResolversParentTypes['CoreCollectionItem'] | ResolversParentTypes['CoreDebtCollectionItem'] | ResolversParentTypes['CoreDividendsItem'] | ResolversParentTypes['CoreEmployeeCreditItem'] | ResolversParentTypes['CoreFeeInvestmentItem'] | ResolversParentTypes['CoreFoundMoneyRewardItem'] | ResolversParentTypes['CoreGiftCardCreditRedemptionItem'] | ResolversParentTypes['CoreHoldingsTransferInItem'] | ResolversParentTypes['CoreInvestmentItem'] | ResolversParentTypes['CoreLocalFoundMoneyItem'] | ResolversParentTypes['CorePartnerRewardItem'] | ResolversParentTypes['CoreRebalanceItem'] | ResolversParentTypes['CoreReferralRewardItem'] | ResolversParentTypes['CoreRefundedItem'] | ResolversParentTypes['CoreReinvestmentItem'] | ResolversParentTypes['CoreRoundUpsItem'] | ResolversParentTypes['CoreWithdrawalItem'] | ResolversParentTypes['EarlyDebtCollectionItem'] | ResolversParentTypes['EarlyDividendsItem'] | ResolversParentTypes['EarlyFeeInvestmentItem'] | ResolversParentTypes['EarlyGiftItem'] | ResolversParentTypes['EarlyInvestmentItem'] | ResolversParentTypes['EarlyMatchItem'] | ResolversParentTypes['EarlyMatchRemovalItem'] | ResolversParentTypes['EarlyRefundedItem'] | ResolversParentTypes['EarlyReinvestmentItem'] | ResolversParentTypes['EarlyWithdrawalItem'] | ResolversParentTypes['LaterDebtCollectionItem'] | ResolversParentTypes['LaterDividendsItem'] | ResolversParentTypes['LaterFeeInvestmentItem'] | ResolversParentTypes['LaterInvestmentItem'] | ResolversParentTypes['LaterMatchItem'] | ResolversParentTypes['LaterMatchRemovalItem'] | ResolversParentTypes['LaterRebalanceItem'] | ResolversParentTypes['LaterRefundedItem'] | ResolversParentTypes['LaterReinvestmentItem'] | ResolversParentTypes['LaterWithdrawalItem'] | ResolversParentTypes['PastBeneficiaryTransferInvestmentItem'] | ResolversParentTypes['PastCashOwedCollectionInvestmentItem'] | ResolversParentTypes['PastCashReinvestmentInvestmentItem'] | ResolversParentTypes['PastCoreItem'] | ResolversParentTypes['PastDividendInvestmentItem'] | ResolversParentTypes['PastEmployeeContributionInvestmentItem'] | ResolversParentTypes['PastExternalTransferInvestmentItem'] | ResolversParentTypes['PastExternalTransferReversedInvestmentItem'] | ResolversParentTypes['PastFeeInvestmentItem'] | ResolversParentTypes['PastGiftCardInvestmentItem'] | ResolversParentTypes['PastIRATransferInvestmentItem'] | ResolversParentTypes['PastLumpSumInvestment'] | ResolversParentTypes['PastMatchInvestmentItem'] | ResolversParentTypes['PastMatchRemovalInvestmentItem'] | ResolversParentTypes['PastOutsideContributionInvestmentItem'] | ResolversParentTypes['PastRealTimeRoundUpInvestmentItem'] | ResolversParentTypes['PastRebalanceInvestmentItem'] | ResolversParentTypes['PastRecurringInvestmentItem'] | ResolversParentTypes['PastReferralRewardInvestmentItem'] | ResolversParentTypes['PastReferralRewardMatchInvestmentItem'] | ResolversParentTypes['PastRefundInvestmentItem'] | ResolversParentTypes['PastReversalInvestmentItem'] | ResolversParentTypes['PastRewardInvestmentItem'] | ResolversParentTypes['PastRewardMatchInvestmentItem'] | ResolversParentTypes['PastRoundUpItem'] | ResolversParentTypes['PastRoundUpMatchInvestmentItem'] | ResolversParentTypes['PastSecurityLiquidationInvestmentItem'] | ResolversParentTypes['PastSmartDepositInvestmentItem'] | ResolversParentTypes['PastSpendItem'] | ResolversParentTypes['PastWithdrawalInvestmentItem'] | ResolversParentTypes['SaveInterestPaidItem'] | ResolversParentTypes['SaveTransferInItem'] | ResolversParentTypes['SaveTransferOutItem'] | ResolversParentTypes['SpendATMReimbursementItem'] | ResolversParentTypes['SpendATMWithdrawalItem'] | ResolversParentTypes['SpendBillPayItem'] | ResolversParentTypes['SpendCheckDepositItem'] | ResolversParentTypes['SpendCheckPaymentItem'] | ResolversParentTypes['SpendDigitalWalletItem'] | ResolversParentTypes['SpendDirectDepositItem'] | ResolversParentTypes['SpendECheckItem'] | ResolversParentTypes['SpendInterestPaidItem'] | ResolversParentTypes['SpendPurchaseItem'] | ResolversParentTypes['SpendRealTimeRoundUpItem'] | ResolversParentTypes['SpendTransferInItem'] | ResolversParentTypes['SpendTransferOutItem'];
  PastItemConnection: PastItemConnection;
  PastItemEdge: PastItemEdge;
  PastItemsAccountFilter: PastItemsAccountFilter;
  PastLaterSummary: PastLaterSummary;
  PastLumpSumInvestment: PastLumpSumInvestment;
  PastMatchInvestmentItem: PastMatchInvestmentItem;
  PastMatchRemovalInvestmentItem: PastMatchRemovalInvestmentItem;
  PastMoneyManagerAllocation: PastMoneyManagerAllocation;
  PastMoneyManagerAllocations: ResolversParentTypes['PastMoneyManagerRecurrenceItem'] | ResolversParentTypes['PastMoneyManagerScheduledPaycheckItem'];
  PastMoneyManagerRecurrenceItem: PastMoneyManagerRecurrenceItem;
  PastMoneyManagerScheduledPaycheckItem: PastMoneyManagerScheduledPaycheckItem;
  PastOutsideContributionInvestmentItem: PastOutsideContributionInvestmentItem;
  PastRealTimeRoundUpInvestmentItem: PastRealTimeRoundUpInvestmentItem;
  PastRebalanceInvestmentItem: PastRebalanceInvestmentItem;
  PastRecurrenceItem: PastRecurrenceItem;
  PastRecurrenceItemV2: PastRecurrenceItemV2;
  PastRecurrenceSettings: PastRecurrenceSettings;
  PastRecurrenceSettingsV2: PastRecurrenceSettingsV2;
  PastRecurringInvestmentItem: PastRecurringInvestmentItem;
  PastReferralRewardInvestmentItem: PastReferralRewardInvestmentItem;
  PastReferralRewardMatchInvestmentItem: PastReferralRewardMatchInvestmentItem;
  PastRefundInvestmentItem: PastRefundInvestmentItem;
  PastReversalInvestmentItem: PastReversalInvestmentItem;
  PastRewardInvestmentItem: PastRewardInvestmentItem;
  PastRewardMatchInvestmentItem: PastRewardMatchInvestmentItem;
  PastRoundUpItem: PastRoundUpItem;
  PastRoundUpMatchInvestmentItem: PastRoundUpMatchInvestmentItem;
  PastScheduledItem: ResolversParentTypes['PastRecurrenceItem'] | ResolversParentTypes['PastSplitDepositItem'];
  PastScheduledItemV2: ResolversParentTypes['PastMoneyManagerRecurrenceItem'] | ResolversParentTypes['PastMoneyManagerScheduledPaycheckItem'] | ResolversParentTypes['PastRecurrenceItemV2'] | ResolversParentTypes['PastSplitDepositItemV2'];
  PastSecurityLiquidationInvestmentItem: PastSecurityLiquidationInvestmentItem;
  PastSmartDepositInvestmentItem: PastSmartDepositInvestmentItem;
  PastSpendItem: PastSpendItem;
  PastSpendSummary: PastSpendSummary;
  PastSplitDepositAllocationSettings: PastSplitDepositAllocationSettings;
  PastSplitDepositAllocationSettingsV2: PastSplitDepositAllocationSettingsV2;
  PastSplitDepositAllocations: PastSplitDepositAllocations;
  PastSplitDepositAllocationsV2: PastSplitDepositAllocationsV2;
  PastSplitDepositItem: PastSplitDepositItem;
  PastSplitDepositItemV2: PastSplitDepositItemV2;
  PastSummary: ResolversParentTypes['AllAccountHistorySummary'] | ResolversParentTypes['CheckingHistorySummary'] | ResolversParentTypes['EarlyHistorySummary'] | ResolversParentTypes['EmergencyFundHistorySummary'] | ResolversParentTypes['InvestHistorySummary'] | ResolversParentTypes['LaterHistorySummary'];
  PastSummaryFilter: PastSummaryFilter;
  PastTargetedTransferItem: ResolversParentTypes['PastBeneficiaryTransferInvestmentItem'] | ResolversParentTypes['PastCashOwedCollectionInvestmentItem'] | ResolversParentTypes['PastCashReinvestmentInvestmentItem'] | ResolversParentTypes['PastDividendInvestmentItem'] | ResolversParentTypes['PastEmployeeContributionInvestmentItem'] | ResolversParentTypes['PastExternalTransferInvestmentItem'] | ResolversParentTypes['PastExternalTransferReversedInvestmentItem'] | ResolversParentTypes['PastFeeInvestmentItem'] | ResolversParentTypes['PastGiftCardInvestmentItem'] | ResolversParentTypes['PastIRATransferInvestmentItem'] | ResolversParentTypes['PastLumpSumInvestment'] | ResolversParentTypes['PastMatchInvestmentItem'] | ResolversParentTypes['PastMatchRemovalInvestmentItem'] | ResolversParentTypes['PastOutsideContributionInvestmentItem'] | ResolversParentTypes['PastRealTimeRoundUpInvestmentItem'] | ResolversParentTypes['PastRecurringInvestmentItem'] | ResolversParentTypes['PastReferralRewardInvestmentItem'] | ResolversParentTypes['PastReferralRewardMatchInvestmentItem'] | ResolversParentTypes['PastRefundInvestmentItem'] | ResolversParentTypes['PastReversalInvestmentItem'] | ResolversParentTypes['PastRewardInvestmentItem'] | ResolversParentTypes['PastRewardMatchInvestmentItem'] | ResolversParentTypes['PastRoundUpItem'] | ResolversParentTypes['PastRoundUpMatchInvestmentItem'] | ResolversParentTypes['PastSecurityLiquidationInvestmentItem'] | ResolversParentTypes['PastSmartDepositInvestmentItem'] | ResolversParentTypes['PastSpendItem'] | ResolversParentTypes['PastWithdrawalInvestmentItem'] | ResolversParentTypes['SaveInterestPaidItem'] | ResolversParentTypes['SaveTransferInItem'] | ResolversParentTypes['SaveTransferOutItem'] | ResolversParentTypes['SpendATMReimbursementItem'] | ResolversParentTypes['SpendATMWithdrawalItem'] | ResolversParentTypes['SpendBillPayItem'] | ResolversParentTypes['SpendCheckDepositItem'] | ResolversParentTypes['SpendCheckPaymentItem'] | ResolversParentTypes['SpendDigitalWalletItem'] | ResolversParentTypes['SpendDirectDepositItem'] | ResolversParentTypes['SpendECheckItem'] | ResolversParentTypes['SpendInterestPaidItem'] | ResolversParentTypes['SpendPurchaseItem'] | ResolversParentTypes['SpendRealTimeRoundUpItem'] | ResolversParentTypes['SpendTransferInItem'] | ResolversParentTypes['SpendTransferOutItem'];
  PastUserTransferItem: ResolversParentTypes['CoreInvestmentItem'] | ResolversParentTypes['CoreRoundUpsItem'] | ResolversParentTypes['CoreWithdrawalItem'] | ResolversParentTypes['EarlyInvestmentItem'] | ResolversParentTypes['EarlyWithdrawalItem'] | ResolversParentTypes['LaterInvestmentItem'] | ResolversParentTypes['LaterWithdrawalItem'] | ResolversParentTypes['SaveTransferInItem'] | ResolversParentTypes['SaveTransferOutItem'] | ResolversParentTypes['SpendTransferInItem'] | ResolversParentTypes['SpendTransferOutItem'];
  PastWithdrawalInvestmentItem: PastWithdrawalInvestmentItem;
  PayoutRelationshipResult: PayoutRelationshipResult;
  PdfDownloadUrlInput: PdfDownloadUrlInput;
  PdfDownloadUrlPayload: PdfDownloadUrlPayload;
  Performance: Performance;
  PersonalInfoInput: PersonalInfoInput;
  Phone: Phone;
  PhoneAuthenticator: PhoneAuthenticator;
  PhoneNumber: Scalars['PhoneNumber'];
  PhoneNumberOptedOutException: PhoneNumberOptedOutException;
  PhoneRedirect: PhoneRedirect;
  PlaidLayerLinkSession: PlaidLayerLinkSession;
  PoliciesRecordDoesNotExistException: PoliciesRecordDoesNotExistException;
  Policy: Policy;
  PolicyNotAddedException: PolicyNotAddedException;
  Portfolio: Portfolio;
  PortfolioAllocation: PortfolioAllocation;
  PortfolioAlreadyRemovedError: PortfolioAlreadyRemovedError;
  PortfolioHolding: PortfolioHolding;
  PortfolioNotFoundException: PortfolioNotFoundException;
  PortfolioNotSupportedException: PortfolioNotSupportedException;
  PortfolioProjection: PortfolioProjection;
  PortfolioRemovalInProgressError: PortfolioRemovalInProgressError;
  PortfolioSecurity: PortfolioSecurity;
  PortfolioSecurityAllocation: PortfolioSecurityAllocation;
  PortfolioSecurityLimitReached: PortfolioSecurityLimitReached;
  PortfolioUpdateFailedException: PortfolioUpdateFailedException;
  PositiveCurrencyAmountInput: PositiveCurrencyAmountInput;
  PositiveFloat: Scalars['PositiveFloat'];
  PreferredAccountNotEligibleError: PreferredAccountNotEligibleError;
  PreferredAccountNotSupportedError: PreferredAccountNotSupportedError;
  PresentableProduct: PresentableProduct;
  PreviousFundingSourcePending: PreviousFundingSourcePending;
  Product: Product;
  ProductNotSupportedException: ProductNotSupportedException;
  Profile: Profile;
  ProfileAttribute: ProfileAttribute;
  ProfileInput: ProfileInput;
  PromoCode: PromoCode;
  PromoCodeCustomer: PromoCodeCustomer;
  PromoCodeEdge: PromoCodeEdge;
  PromoCodeFieldLengthError: PromoCodeFieldLengthError;
  PromoCodePaginatedFilter: PromoCodePaginatedFilter;
  PromoCodePaginatedInfo: PromoCodePaginatedInfo;
  PromoCodeReward: PromoCodeReward;
  PromoCodeRewardEdge: PromoCodeRewardEdge;
  PromoCodeRewardsConnection: PromoCodeRewardsConnection;
  PromoCodesConnection: PromoCodesConnection;
  PromoOffer: PromoOffer;
  PromotedBenefit: PromotedBenefit;
  PromotedCampaigns: PromotedCampaigns;
  Promotion: Omit<Promotion, 'offering'> & { offering: ResolversParentTypes['Offering'] };
  PromotionConsumedError: PromotionConsumedError;
  PromotionDuration: PromotionDuration;
  PromotionExpiredError: PromotionExpiredError;
  PromotionFilterInput: PromotionFilterInput;
  PromotionNotFoundError: PromotionNotFoundError;
  PromotionPresentInContextsFilterInput: PromotionPresentInContextsFilterInput;
  PromotionalWaiver: PromotionalWaiver;
  PromotionalWaiver_V2: PromotionalWaiver_V2;
  Prospect: ResolversParentTypes['GrowProspect'] | ResolversParentTypes['LaterWaitlistProspect'] | ResolversParentTypes['OutsideContributionProspect'];
  ProvisionalWaiver: ProvisionalWaiver;
  ProvisionalWaiver_V2: ProvisionalWaiver_V2;
  PushAuthChallenge: PushAuthChallenge;
  PushAuthenticator: PushAuthenticator;
  PushAuthenticatorAlreadyExistsException: PushAuthenticatorAlreadyExistsException;
  QualificationSubTypeMismatchError: QualificationSubTypeMismatchError;
  Query: {};
  Quiz: Omit<Quiz, 'duration' | 'featuredImage' | 'theme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: Maybe<ResolversParentTypes['LearnVisualAsset']>, theme: ResolversParentTypes['QuizTheme'] };
  QuizLocked: Omit<QuizLocked, 'duration' | 'featuredImage'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: Maybe<ResolversParentTypes['LearnVisualAsset']> };
  QuizPreview: Omit<QuizPreview, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], quizTheme: ResolversParentTypes['QuizTheme'] };
  QuizPreviewLocked: Omit<QuizPreviewLocked, 'duration' | 'featuredImage' | 'quizTheme'> & { duration: ResolversParentTypes['LearnContentDuration'], featuredImage: ResolversParentTypes['LearnVisualAsset'], quizTheme: ResolversParentTypes['QuizTheme'] };
  QuizTheme: ResolversUnionParentTypes['QuizTheme'];
  RateLimitDoesNotExistException: RateLimitDoesNotExistException;
  RateLimitStatus: RateLimitStatus;
  RawLinkSession: RawLinkSession;
  RdvRequiredUserAlert: RdvRequiredUserAlert;
  RdvVerificationRequired: RdvVerificationRequired;
  RdvsNotTriggered: RdvsNotTriggered;
  ReadMessageInput: ReadMessageInput;
  RebalanceAlreadyExecutedError: RebalanceAlreadyExecutedError;
  RebalanceSourceInsufficientBalanceError: RebalanceSourceInsufficientBalanceError;
  RecaptchaException: RecaptchaException;
  RecommendedInvestingStrategy: RecommendedInvestingStrategy;
  RecordDoesNotExistError: RecordDoesNotExistError;
  RecordInvestmentAccountRecapViewInput: RecordInvestmentAccountRecapViewInput;
  RecordInvestmentAccountRecapViewResult: ResolversUnionParentTypes['RecordInvestmentAccountRecapViewResult'];
  RecordReferralEventInput: RecordReferralEventInput;
  RecordReferralEventResult: ResolversUnionParentTypes['RecordReferralEventResult'];
  RecordVendorExternalTransactionInput: RecordVendorExternalTransactionInput;
  RecordVendorExternalTransactionResult: ResolversUnionParentTypes['RecordVendorExternalTransactionResult'];
  RecurrenceRule: RecurrenceRule;
  RecurrenceRuleInput: RecurrenceRuleInput;
  RecurringInvestmentInput: RecurringInvestmentInput;
  RecurringInvestmentPayload: RecurringInvestmentPayload;
  RecurringInvestmentSettings: RecurringInvestmentSettings;
  RecurringTransfer: RecurringTransfer;
  RecurringTransferAccount: RecurringTransferAccount;
  RecurringTransferAccountIdFilterInput: RecurringTransferAccountIdFilterInput;
  RecurringTransferAccountInput: RecurringTransferAccountInput;
  RecurringTransferDate: RecurringTransferDate;
  RecurringTransferDirectionFilterInput: RecurringTransferDirectionFilterInput;
  RecurringTransferEvent: RecurringTransferEvent;
  RecurringTransferEventInput: RecurringTransferEventInput;
  RecurringTransferFundingSource: RecurringTransferFundingSource;
  RecurringTransferFundingSourceInput: RecurringTransferFundingSourceInput;
  RecurringTransferPathException: RecurringTransferPathException;
  RecurringTransfersFilterInput: RecurringTransfersFilterInput;
  RedeemedWaiverCoupon: RedeemedWaiverCoupon;
  Referral: Referral;
  ReferralCampaign: ReferralCampaign;
  ReferralCampaignConnection: ReferralCampaignConnection;
  ReferralCampaignEdge: ReferralCampaignEdge;
  ReferralCampaignReward: ReferralCampaignReward;
  ReferralCampaignV2: ReferralCampaignV2;
  ReferralCode: Scalars['ReferralCode'];
  ReferralEvent: ReferralEvent;
  ReferralEventInput: ReferralEventInput;
  ReferralEventV2: ReferralEventV2;
  ReferralHistory: ReferralHistory;
  ReferralPaginatedFilter: ReferralPaginatedFilter;
  ReferralPaginatedInfo: ReferralPaginatedInfo;
  ReferralPayout: ReferralPayout;
  ReferralPayoutConnection: ReferralPayoutConnection;
  ReferralPayoutEdge: ReferralPayoutEdge;
  ReferralPayoutExistsError: ReferralPayoutExistsError;
  ReferralPayoutRelationship: ReferralPayoutRelationship;
  ReferralPayoutsFilter: ReferralPayoutsFilter;
  ReferralRelationship: ReferralRelationship;
  ReferralRelationshipConnection: ReferralRelationshipConnection;
  ReferralRelationshipEdge: ReferralRelationshipEdge;
  ReferralRelationshipMissingError: ReferralRelationshipMissingError;
  ReferralRelationshipsFilter: ReferralRelationshipsFilter;
  ReferralReward: ReferralReward;
  ReferralRewardEdge: ReferralRewardEdge;
  ReferralRewardSummary: ReferralRewardSummary;
  ReferralRewardsConnection: ReferralRewardsConnection;
  ReferralUserUpdateInput: ReferralUserUpdateInput;
  RefreshAuthTokenInput: RefreshAuthTokenInput;
  RefreshAuthTokenRateLimitedException: RefreshAuthTokenRateLimitedException;
  RefreshAuthTokenResult: ResolversUnionParentTypes['RefreshAuthTokenResult'];
  RefreshTokenNotFoundException: RefreshTokenNotFoundException;
  RefundBankAccount: RefundBankAccount;
  RegenerateInvestmentAccountRecapPublicTokenInput: RegenerateInvestmentAccountRecapPublicTokenInput;
  RegenerateInvestmentAccountRecapPublicTokenResult: ResolversUnionParentTypes['RegenerateInvestmentAccountRecapPublicTokenResult'];
  RegisterAccountTypeResult: ResolversUnionParentTypes['RegisterAccountTypeResult'];
  RegisterAccountTypeResultTemporaryImpl: RegisterAccountTypeResultTemporaryImpl;
  RegisterCredentialsInput: RegisterCredentialsInput;
  RegisterCredentialsResult: ResolversUnionParentTypes['RegisterCredentialsResult'];
  RegisterDeviceTokenAndPushAuthenticatorInput: RegisterDeviceTokenAndPushAuthenticatorInput;
  RegisterDeviceTokenAndPushAuthenticatorResult: ResolversUnionParentTypes['RegisterDeviceTokenAndPushAuthenticatorResult'];
  RegisterEmailAuthenticatorInput: RegisterEmailAuthenticatorInput;
  RegisterEmailAuthenticatorResult: ResolversUnionParentTypes['RegisterEmailAuthenticatorResult'];
  RegisterLayerLinkSessionResult: ResolversUnionParentTypes['RegisterLayerLinkSessionResult'];
  RegisterLinkSessionResult: ResolversUnionParentTypes['RegisterLinkSessionResult'];
  RegisterOidcCredentialsInput: RegisterOidcCredentialsInput;
  RegisterOidcCredentialsResult: ResolversUnionParentTypes['RegisterOidcCredentialsResult'];
  RegisterPhoneAuthenticatorInput: RegisterPhoneAuthenticatorInput;
  RegisterPhoneAuthenticatorResult: ResolversUnionParentTypes['RegisterPhoneAuthenticatorResult'];
  RegisterPhoneAuthenticatorWithoutChallengeResult: ResolversUnionParentTypes['RegisterPhoneAuthenticatorWithoutChallengeResult'];
  RegisterProspectInput: RegisterProspectInput;
  RegisterProspectResult: ResolversUnionParentTypes['RegisterProspectResult'];
  RegistrationDrawerContent: RegistrationDrawerContent;
  RegistrationFunnel: RegistrationFunnel;
  RegistrationFunnelFilter: RegistrationFunnelFilter;
  RegistrationInput: RegistrationInput;
  RegistrationPage: RegistrationPage;
  RegistrationPageAction: RegistrationPageAction;
  RegistrationPageContent: ResolversParentTypes['RegistrationProminenceBannerContent'];
  RegistrationProminenceBannerContent: RegistrationProminenceBannerContent;
  ReinitiateSMSChallengeInput: ReinitiateSmsChallengeInput;
  ReinitiateSMSChallengeResult: ResolversUnionParentTypes['ReinitiateSMSChallengeResult'];
  ReissueBankCardEligibility: ResolversUnionParentTypes['ReissueBankCardEligibility'];
  ReissueBankCardEligible: ReissueBankCardEligible;
  ReissueBankCardExistsError: ReissueBankCardExistsError;
  ReissueBankCardIneligible: ReissueBankCardIneligible;
  ReissueBankCardInput: ReissueBankCardInput;
  ReissueBankCardResult: ResolversUnionParentTypes['ReissueBankCardResult'];
  RelationshipAlreadyQualifiedError: RelationshipAlreadyQualifiedError;
  RelinkLinkedAccountAlert: RelinkLinkedAccountAlert;
  RemoveAccountTypeResult: ResolversUnionParentTypes['RemoveAccountTypeResult'];
  RemoveAccountTypeResultTemporaryImpl: RemoveAccountTypeResultTemporaryImpl;
  RemoveCohortEligibilityInput: RemoveCohortEligibilityInput;
  RemoveCohortEligibilityResult: ResolversUnionParentTypes['RemoveCohortEligibilityResult'];
  RemoveJobAlertResult: ResolversUnionParentTypes['RemoveJobAlertResult'];
  RemovePolicyInput: RemovePolicyInput;
  RemovePolicyResult: ResolversUnionParentTypes['RemovePolicyResult'];
  RemoveSecurityFromPortfolioInput: RemoveSecurityFromPortfolioInput;
  RemoveSecurityFromPortfolioResult: ResolversUnionParentTypes['RemoveSecurityFromPortfolioResult'];
  RemoveSelfDirectedPortfolioInput: RemoveSelfDirectedPortfolioInput;
  RemoveSelfDirectedPortfolioResult: ResolversUnionParentTypes['RemoveSelfDirectedPortfolioResult'];
  RemovedJobAlert: RemovedJobAlert;
  ReopenUserAccountResult: ResolversUnionParentTypes['ReopenUserAccountResult'];
  ReplayMoneyAssignmentError: ReplayMoneyAssignmentError;
  ReplayMoneyAssignmentSuccess: ReplayMoneyAssignmentSuccess;
  ReplayMoneyManagerMoneyAssignmentInput: ReplayMoneyManagerMoneyAssignmentInput;
  ReplayMoneyManagerMoneyAssignmentResult: ResolversUnionParentTypes['ReplayMoneyManagerMoneyAssignmentResult'];
  ReportBankCardLostStolenInput: ReportBankCardLostStolenInput;
  ReportBankCardLostStolenPayload: ReportBankCardLostStolenPayload;
  RequestAccountClosureInput: RequestAccountClosureInput;
  RequestEarlyAccountClosureInput: RequestEarlyAccountClosureInput;
  RequestEarlyAccountClosureResult: ResolversUnionParentTypes['RequestEarlyAccountClosureResult'];
  RequestInvestmentAccountReopenInput: RequestInvestmentAccountReopenInput;
  RequestInvestmentAccountReopenResult: ResolversUnionParentTypes['RequestInvestmentAccountReopenResult'];
  RequestLayerSessionInput: RequestLayerSessionInput;
  RequestLayerSessionResult: ResolversUnionParentTypes['RequestLayerSessionResult'];
  RequestSubscriptionMigrationWaiverInput: RequestSubscriptionMigrationWaiverInput;
  RequestSubscriptionMigrationWaiverResult: ResolversUnionParentTypes['RequestSubscriptionMigrationWaiverResult'];
  RequestedLayerLinkSession: RequestedLayerLinkSession;
  ResendChatMessageResponse: ResolversUnionParentTypes['ResendChatMessageResponse'];
  ResetPasswordByTokenException: ResetPasswordByTokenException;
  ResetPasswordByTokenInput: ResetPasswordByTokenInput;
  ResetPasswordByTokenResult: ResolversUnionParentTypes['ResetPasswordByTokenResult'];
  ResetPasswordByTokenSuccess: ResetPasswordByTokenSuccess;
  ResetPasswordWithTokenInput: ResetPasswordWithTokenInput;
  ResetPasswordWithTokenResult: ResolversUnionParentTypes['ResetPasswordWithTokenResult'];
  ResetPasswordWithTokenSuccess: ResetPasswordWithTokenSuccess;
  ResetRateLimitResult: ResolversUnionParentTypes['ResetRateLimitResult'];
  ResetRateLimitSuccess: ResetRateLimitSuccess;
  ResourceNotFoundError: ResourceNotFoundError;
  RespondToLearnPollInput: RespondToLearnPollInput;
  RespondToLearnPollResult: ResolversUnionParentTypes['RespondToLearnPollResult'];
  RestoreLoginAccessInput: RestoreLoginAccessInput;
  RestoreLoginAccessResult: ResolversUnionParentTypes['RestoreLoginAccessResult'];
  Result: Result;
  RetriggerRdvsResult: ResolversUnionParentTypes['RetriggerRdvsResult'];
  ReturnedCheckDeposit: ReturnedCheckDeposit;
  RevokeLoginAccessInput: RevokeLoginAccessInput;
  RevokeLoginAccessResult: ResolversUnionParentTypes['RevokeLoginAccessResult'];
  RevokePasswordResetTokenInput: RevokePasswordResetTokenInput;
  RevokePasswordResetTokenResult: ResolversUnionParentTypes['RevokePasswordResetTokenResult'];
  RevokePasswordResetTokenSuccess: RevokePasswordResetTokenSuccess;
  RoundUp: RoundUp;
  RoundUpAccount: RoundUpAccount;
  RoundUpProfile: RoundUpProfile;
  RoundUpProfileInput: RoundUpProfileInput;
  RoundUpTypeEdge: RoundUpTypeEdge;
  RoundUpTypePagination: RoundUpTypePagination;
  RoutingNumber: Scalars['RoutingNumber'];
  SMSAuthChallenge: SmsAuthChallenge;
  SSNDocumentRequestedUserAlert: SsnDocumentRequestedUserAlert;
  SamePasswordsException: SamePasswordsException;
  SampleMailInDocument: SampleMailInDocument;
  SaveInterestPaidItem: SaveInterestPaidItem;
  SaveTransferInItem: SaveTransferInItem;
  SaveTransferOutItem: SaveTransferOutItem;
  SaveUploadUrlInput: SaveUploadUrlInput;
  SaveUploadUrlsInput: SaveUploadUrlsInput;
  SaveUploadUrlsResult: ResolversUnionParentTypes['SaveUploadUrlsResult'];
  SavingsAccountEligibility: SavingsAccountEligibility;
  ScheduleInput: ScheduleInput;
  ScheduleRecurringTransferInput: ScheduleRecurringTransferInput;
  ScheduleRecurringTransferResult: ResolversUnionParentTypes['ScheduleRecurringTransferResult'];
  ScheduleResult: ScheduleResult;
  Scope: Scope;
  SearchEmployersInput: SearchEmployersInput;
  SearchEmployersPayload: SearchEmployersPayload;
  SearchHistory: SearchHistory;
  SearchSecuritiesInput: SearchSecuritiesInput;
  SearchSecuritiesPageInfo: SearchSecuritiesPageInfo;
  SearchSecuritiesResponse: SearchSecuritiesResponse;
  SearchSupportArticleResult: SearchSupportArticleResult;
  SearchSupportResult: SearchSupportResult;
  SecretSquirrelException: SecretSquirrelException;
  SecuritiesBySectorInput: SecuritiesBySectorInput;
  SecuritiesBySectorPageInfo: SecuritiesBySectorPageInfo;
  SecuritiesBySectorResponse: SecuritiesBySectorResponse;
  SecuritiesBySymbolsInput: SecuritiesBySymbolsInput;
  SecuritiesBySymbolsResponse: SecuritiesBySymbolsResponse;
  Security: ResolversParentTypes['Fund'] | ResolversParentTypes['Stock'];
  SecurityAllocationTarget: SecurityAllocationTarget;
  SecurityAnswer: SecurityAnswer;
  SecurityBySymbolInput: SecurityBySymbolInput;
  SecurityDiversificationInfo: SecurityDiversificationInfo;
  SecurityGain: SecurityGain;
  SecurityHeadline: SecurityHeadline;
  SecurityNotSupportedException: SecurityNotSupportedException;
  SecurityPerformance: SecurityPerformance;
  SecurityPerformanceBySymbolInput: SecurityPerformanceBySymbolInput;
  SecurityPerformancesBySymbolInput: SecurityPerformancesBySymbolInput;
  SecurityPrice: SecurityPrice;
  SecurityProfile: SecurityProfile;
  SelfDirectedPortfolio: SelfDirectedPortfolio;
  SendBrazeEventInput: SendBrazeEventInput;
  SendChatMessageResponse: ResolversUnionParentTypes['SendChatMessageResponse'];
  SendCheckPaymentInput: SendCheckPaymentInput;
  SendCheckPaymentResult: ResolversUnionParentTypes['SendCheckPaymentResult'];
  Session: Session;
  SetAuthenticationPINInput: SetAuthenticationPinInput;
  SetAuthenticationPINResult: ResolversUnionParentTypes['SetAuthenticationPINResult'];
  SetAuthenticationPINSuccess: SetAuthenticationPinSuccess;
  SetBeneficiarySsnResult: ResolversUnionParentTypes['SetBeneficiarySsnResult'];
  SetDefaultAuthenticatorInput: SetDefaultAuthenticatorInput;
  SetDefaultAuthenticatorResult: ResolversUnionParentTypes['SetDefaultAuthenticatorResult'];
  SetInvestmentAccountRecapPublicAccessInput: SetInvestmentAccountRecapPublicAccessInput;
  SetInvestmentAccountRecapPublicAccessResult: ResolversUnionParentTypes['SetInvestmentAccountRecapPublicAccessResult'];
  SetLinkingErrorInput: SetLinkingErrorInput;
  SetNegotiationStatusInput: SetNegotiationStatusInput;
  SetNegotiationStatusResult: SetNegotiationStatusResult;
  SetPortfolioInput: SetPortfolioInput;
  SetPreferredWithdrawalAccountInput: SetPreferredWithdrawalAccountInput;
  SetPreferredWithdrawalAccountResult: ResolversUnionParentTypes['SetPreferredWithdrawalAccountResult'];
  SetReferralCampaignFlagsInput: SetReferralCampaignFlagsInput;
  SetReferralCampaignFlagsResult: SetReferralCampaignFlagsResult;
  SetUpTip: SetUpTip;
  Settings: Settings;
  Signature: Signature;
  SiteWideBannerContent: SiteWideBannerContent;
  SiteWideBannerContentInput: SiteWideBannerContentInput;
  SmartDepositMetadataInput: SmartDepositMetadataInput;
  SmartDepositMetadataResult: SmartDepositMetadataResult;
  SourceAccountsFilterInput: SourceAccountsFilterInput;
  SourceAttributes: SourceAttributes;
  SourceAttributesInput: SourceAttributesInput;
  SpendATMReimbursementItem: SpendAtmReimbursementItem;
  SpendATMWithdrawalItem: SpendAtmWithdrawalItem;
  SpendAccount: SpendAccount;
  SpendAlert: ResolversParentTypes['SystemCardLockedSpendAlert'] | ResolversParentTypes['UserCardLockedSpendAlert'];
  SpendAtm: SpendAtm;
  SpendAtmAddress: SpendAtmAddress;
  SpendAtmVendorUnavailableError: SpendAtmVendorUnavailableError;
  SpendAtmsCoordinateInput: SpendAtmsCoordinateInput;
  SpendAtmsInput: SpendAtmsInput;
  SpendAtmsPayload: SpendAtmsPayload;
  SpendAtmsResult: ResolversUnionParentTypes['SpendAtmsResult'];
  SpendBillPayItem: SpendBillPayItem;
  SpendCheckDepositItem: SpendCheckDepositItem;
  SpendCheckPaymentItem: SpendCheckPaymentItem;
  SpendDigitalWalletItem: SpendDigitalWalletItem;
  SpendDirectDepositItem: SpendDirectDepositItem;
  SpendDisputesResponse: SpendDisputesResponse;
  SpendECheckItem: SpendECheckItem;
  SpendInterestPaidItem: SpendInterestPaidItem;
  SpendItem: ResolversParentTypes['PastSpendItem'] | ResolversParentTypes['SaveInterestPaidItem'] | ResolversParentTypes['SaveTransferInItem'] | ResolversParentTypes['SaveTransferOutItem'] | ResolversParentTypes['SpendATMReimbursementItem'] | ResolversParentTypes['SpendATMWithdrawalItem'] | ResolversParentTypes['SpendBillPayItem'] | ResolversParentTypes['SpendCheckDepositItem'] | ResolversParentTypes['SpendCheckPaymentItem'] | ResolversParentTypes['SpendDigitalWalletItem'] | ResolversParentTypes['SpendDirectDepositItem'] | ResolversParentTypes['SpendECheckItem'] | ResolversParentTypes['SpendInterestPaidItem'] | ResolversParentTypes['SpendPurchaseItem'] | ResolversParentTypes['SpendRealTimeRoundUpItem'] | ResolversParentTypes['SpendTransferInItem'] | ResolversParentTypes['SpendTransferOutItem'];
  SpendPurchaseItem: SpendPurchaseItem;
  SpendRealTimeRoundUpItem: SpendRealTimeRoundUpItem;
  SpendTransactionsDisputeCustomersResponse: SpendTransactionsDisputeCustomersResponse;
  SpendTransactionsDisputeQuestions: SpendTransactionsDisputeQuestions;
  SpendTransactionsDisputeResponse: SpendTransactionsDisputeResponse;
  SpendTransactionsDisputeResult: ResolversUnionParentTypes['SpendTransactionsDisputeResult'];
  SpendTransactionsInput: SpendTransactionsInput;
  SpendTransactionsResponse: SpendTransactionsResponse;
  SpendTransferInItem: SpendTransferInItem;
  SpendTransferOutItem: SpendTransferOutItem;
  SplitDeposit: SplitDeposit;
  SplitDepositAllocation: ResolversParentTypes['SplitDepositDirectDepositAllocation'] | ResolversParentTypes['SplitDepositRecurrenceAllocation'];
  SplitDepositAllocationInput: SplitDepositAllocationInput;
  SplitDepositDailyRecurrenceRule: SplitDepositDailyRecurrenceRule;
  SplitDepositDirectDepositAllocation: SplitDepositDirectDepositAllocation;
  SplitDepositDirectDepositIntentSetting: SplitDepositDirectDepositIntentSetting;
  SplitDepositDirectDepositSetting: SplitDepositDirectDepositSetting;
  SplitDepositMonthlyRecurrenceRule: SplitDepositMonthlyRecurrenceRule;
  SplitDepositMutation: SplitDepositMutation;
  SplitDepositRecurrenceAllocation: SplitDepositRecurrenceAllocation;
  SplitDepositRecurrenceRule: ResolversParentTypes['SplitDepositDailyRecurrenceRule'] | ResolversParentTypes['SplitDepositMonthlyRecurrenceRule'] | ResolversParentTypes['SplitDepositWeeklyRecurrenceRule'];
  SplitDepositRecurrenceSetting: SplitDepositRecurrenceSetting;
  SplitDepositSettings: ResolversParentTypes['SplitDepositDirectDepositIntentSetting'] | ResolversParentTypes['SplitDepositDirectDepositSetting'] | ResolversParentTypes['SplitDepositRecurrenceSetting'];
  SplitDepositSettingsFilterInput: SplitDepositSettingsFilterInput;
  SplitDepositSettingsMutation: SplitDepositSettingsMutation;
  SplitDepositTargetAccount: SplitDepositTargetAccount;
  SplitDepositWeeklyRecurrenceRule: SplitDepositWeeklyRecurrenceRule;
  SsnAlreadyInUseException: SsnAlreadyInUseException;
  SsnMatchesCustodianException: SsnMatchesCustodianException;
  SsnUpdateForbiddenException: SsnUpdateForbiddenException;
  StartAcornsPdfSwitchInput: StartAcornsPdfSwitchInput;
  StartCheckDepositInput: StartCheckDepositInput;
  StartCheckDepositPayload: StartCheckDepositPayload;
  StartOnlineSwitchInput: StartOnlineSwitchInput;
  StartOnlineSwitchPayload: StartOnlineSwitchPayload;
  StartSubmittableSwitchAddressInput: StartSubmittableSwitchAddressInput;
  StartSubmittableSwitchInput: StartSubmittableSwitchInput;
  StartSubmittableSwitchPayload: StartSubmittableSwitchPayload;
  Statement: Statement;
  StatementEdge: StatementEdge;
  StatementLink: StatementLink;
  StatementPagination: StatementPagination;
  Stock: Stock;
  StoredRdvDepositsInvalid: StoredRdvDepositsInvalid;
  StoredRdvDepositsMissing: StoredRdvDepositsMissing;
  String: Scalars['String'];
  StringKey: Scalars['StringKey'];
  StringKeyAsset: StringKeyAsset;
  SubcategoryMessage: SubcategoryMessage;
  Submission: Submission;
  SubmissionError: SubmissionError;
  SubmitBankFeeNegotiationInput: SubmitBankFeeNegotiationInput;
  SubmitBankFeeNegotiationResponse: SubmitBankFeeNegotiationResponse;
  SubmitBankFeeNegotiationResult: ResolversUnionParentTypes['SubmitBankFeeNegotiationResult'];
  SubmitEarnMissingCreditRequestInput: SubmitEarnMissingCreditRequestInput;
  SubmitEarnMissingCreditRequestResult: ResolversUnionParentTypes['SubmitEarnMissingCreditRequestResult'];
  SubmitSpendTransactionsDisputeInput: SubmitSpendTransactionsDisputeInput;
  SubmitUserReportedBankFeeRefundInput: SubmitUserReportedBankFeeRefundInput;
  SubmitUserReportedBankFeeRefundResult: SubmitUserReportedBankFeeRefundResult;
  SubmittableSwitch: SubmittableSwitch;
  SubscribeToTierInput: SubscribeToTierInput;
  SubscribeToTierResult: ResolversUnionParentTypes['SubscribeToTierResult'];
  SubscribeUserToTierByProductKeyInput: SubscribeUserToTierByProductKeyInput;
  SubscribeUserToTierInput: SubscribeUserToTierInput;
  SubscribeUserToTierResult: ResolversUnionParentTypes['SubscribeUserToTierResult'];
  SubscriberIneligibleError: SubscriberIneligibleError;
  Subscription: {};
  SubscriptionMigration: SubscriptionMigration;
  SubscriptionMigrationInvalidError: SubscriptionMigrationInvalidError;
  SubscriptionMigrationWaiver: SubscriptionMigrationWaiver;
  SucceedVendorInvoiceResult: ResolversUnionParentTypes['SucceedVendorInvoiceResult'];
  SuggestedMoneyRulesResult: ResolversUnionParentTypes['SuggestedMoneyRulesResult'];
  SuggestedMoneyRulesSuccess: SuggestedMoneyRulesSuccess;
  SuitabilityAnswer: SuitabilityAnswer;
  SuitabilityInput: SuitabilityInput;
  SuitabilityQuestion: SuitabilityQuestion;
  SummaryItem: SummaryItem;
  SupportArticle: SupportArticle;
  SupportAuthor: SupportAuthor;
  SupportAuthorPhoto: SupportAuthorPhoto;
  SupportCategory: SupportCategory;
  SupportCitation: SupportCitation;
  SupportSection: SupportSection;
  SupportTicket: SupportTicket;
  SupportTicketForm: SupportTicketForm;
  SupportTicketFormField: SupportTicketFormField;
  SupportTicketResponse: ResolversUnionParentTypes['SupportTicketResponse'];
  SupportTicketWithCustomFieldsResponse: ResolversUnionParentTypes['SupportTicketWithCustomFieldsResponse'];
  SupportUser: SupportUser;
  SupportsPlaidVerificationResult: SupportsPlaidVerificationResult;
  SuppressMoneyManagerRebalancesError: SuppressMoneyManagerRebalancesError;
  SuppressMoneyManagerRebalancesInput: SuppressMoneyManagerRebalancesInput;
  SuppressMoneyManagerRebalancesResult: ResolversUnionParentTypes['SuppressMoneyManagerRebalancesResult'];
  SuppressMoneyManagerRebalancesSuccess: SuppressMoneyManagerRebalancesSuccess;
  SwitchInterface: ResolversParentTypes['AcornsPdfSwitch'] | ResolversParentTypes['OnlineSwitch'] | ResolversParentTypes['SubmittableSwitch'];
  SwitchPayloadInterface: ResolversParentTypes['StartOnlineSwitchPayload'] | ResolversParentTypes['StartSubmittableSwitchPayload'];
  SyncBankFeeTransactionsInput: SyncBankFeeTransactionsInput;
  SyncBankFeeTransactionsResult: SyncBankFeeTransactionsResult;
  SyncFundingSourceToVendorResult: ResolversUnionParentTypes['SyncFundingSourceToVendorResult'];
  SyncSupportAccountInput: SyncSupportAccountInput;
  SyncSupportAccountResponse: SyncSupportAccountResponse;
  SystemCardLockedSpendAlert: SystemCardLockedSpendAlert;
  TargetAccountsFilterInput: TargetAccountsFilterInput;
  TaxFilingPartner: TaxFilingPartner;
  TaxReturn: TaxReturn;
  TaxWithholdingAmounts: TaxWithholdingAmounts;
  TaxWithholdings: TaxWithholdings;
  TfaOptions: TfaOptions;
  TickerSymbol: Scalars['TickerSymbol'];
  Tier: Tier;
  TierDowngradeAction: TierDowngradeAction;
  TierDowngradeActionRequired: TierDowngradeActionRequired;
  TierGroup: TierGroup;
  TierOption: TierOption;
  TierOptionByTierPriceIdResult: ResolversUnionParentTypes['TierOptionByTierPriceIdResult'];
  TierPrice: TierPrice;
  TierProduct: TierProduct;
  TierSubscription: TierSubscription;
  TierSubscriptionAlreadyDeactivated: TierSubscriptionAlreadyDeactivated;
  TierSubscriptionConnection: TierSubscriptionConnection;
  TierSubscriptionForUser: ResolversUnionParentTypes['TierSubscriptionForUser'];
  TierSubscriptionNotFound: TierSubscriptionNotFound;
  TierSubscriptionPageInfo: TierSubscriptionPageInfo;
  TierSubscriptionTransition: TierSubscriptionTransition;
  TierSubscriptionUnsubscribed: TierSubscriptionUnsubscribed;
  Time: Scalars['Time'];
  TimestampsInterface: ResolversParentTypes['Account'] | ResolversParentTypes['Address'] | ResolversParentTypes['Beneficiary'] | ResolversParentTypes['BillingCycle'] | ResolversParentTypes['Credit'] | ResolversParentTypes['ExecutionAudit'] | ResolversParentTypes['Fee'] | ResolversParentTypes['FeeExecution'] | ResolversParentTypes['FinancialInstitution'] | ResolversParentTypes['FundingSourceAccount'] | ResolversParentTypes['InvestmentAccount'] | ResolversParentTypes['InvestmentAccountReopenRequest'] | ResolversParentTypes['InvestmentAccountReopenRequestAction'] | ResolversParentTypes['InvestmentAccountReopenRequestNote'] | ResolversParentTypes['LinkedAccount'] | ResolversParentTypes['LinkedSubaccount'] | ResolversParentTypes['Liquidation'] | ResolversParentTypes['MatchProgram'] | ResolversParentTypes['OutsideContribution'] | ResolversParentTypes['OutsideContributionCheckoutCart'] | ResolversParentTypes['OutsideContributionCode'] | ResolversParentTypes['Phone'] | ResolversParentTypes['Profile'] | ResolversParentTypes['RecurringInvestmentSettings'] | ResolversParentTypes['RoundUp'] | ResolversParentTypes['RoundUpAccount'] | ResolversParentTypes['RoundUpProfile'] | ResolversParentTypes['Signature'] | ResolversParentTypes['UserInvestmentAccountReopenCheck'];
  Toggle: Toggle;
  TokenExpiredException: TokenExpiredException;
  TopEmployer: TopEmployer;
  TopEmployerPayload: TopEmployerPayload;
  TopHolding: TopHolding;
  TotalAmounts: TotalAmounts;
  Transaction: Transaction;
  Transfer: Transfer;
  TransferableAccount: TransferableAccount;
  TransferableFrom: TransferableFrom;
  TransferableTo: TransferableTo;
  TrendingLearnContentPreview: ResolversUnionParentTypes['TrendingLearnContentPreview'];
  TrustedContact: TrustedContact;
  TrustedContactAlreadyExistsException: TrustedContactAlreadyExistsException;
  TrustedContactInput: TrustedContactInput;
  TrustedContactInvalidEmail: TrustedContactInvalidEmail;
  TrustedContactInvalidPhoneNumber: TrustedContactInvalidPhoneNumber;
  TrustedContactNotFoundException: TrustedContactNotFoundException;
  URL: Scalars['URL'];
  USStateName: Scalars['USStateName'];
  UUID: Scalars['UUID'];
  UnableToCancelCheckError: UnableToCancelCheckError;
  UnauthenticatedCreateUploadUrlInput: UnauthenticatedCreateUploadUrlInput;
  UnauthenticatedSaveUploadUrlInput: UnauthenticatedSaveUploadUrlInput;
  UnauthenticatedSaveUploadUrlResult: ResolversUnionParentTypes['UnauthenticatedSaveUploadUrlResult'];
  UnauthorizedException: UnauthorizedException;
  UnauthorizedModifyLockedContentError: UnauthorizedModifyLockedContentError;
  UnblockDeviceInput: UnblockDeviceInput;
  UnblockDeviceResult: ResolversUnionParentTypes['UnblockDeviceResult'];
  UnlinkOidcCredentialsInput: UnlinkOidcCredentialsInput;
  UnlinkOidcCredentialsResult: ResolversUnionParentTypes['UnlinkOidcCredentialsResult'];
  UnlinkOidcCredentialsSuccess: UnlinkOidcCredentialsSuccess;
  UnlockBankCardPayload: UnlockBankCardPayload;
  UnmarkLearnContentAsHelpfulInput: UnmarkLearnContentAsHelpfulInput;
  UnmarkLearnContentAsHelpfulResult: ResolversUnionParentTypes['UnmarkLearnContentAsHelpfulResult'];
  UnmetRequirementsException: UnmetRequirementsException;
  UnrecoverableError: UnrecoverableError;
  UnrecoverableLinkedAccountError: UnrecoverableLinkedAccountError;
  UnsubscribeUserFromTierInput: UnsubscribeUserFromTierInput;
  UnsubscribeUserFromTierResult: ResolversUnionParentTypes['UnsubscribeUserFromTierResult'];
  UnverifiedBeneficiarySsnAlert: UnverifiedBeneficiarySsnAlert;
  UnverifiedBeneficiarySsnAlertItem: UnverifiedBeneficiarySsnAlertItem;
  UpdatableAttributesInput: UpdatableAttributesInput;
  UpdateAccountPortfolioInput: UpdateAccountPortfolioInput;
  UpdateAccountPortfolioResponse: ResolversUnionParentTypes['UpdateAccountPortfolioResponse'];
  UpdateAttributionInput: UpdateAttributionInput;
  UpdateAttributionResult: ResolversUnionParentTypes['UpdateAttributionResult'];
  UpdateAuthEmailInput: UpdateAuthEmailInput;
  UpdateAuthEmailResult: ResolversUnionParentTypes['UpdateAuthEmailResult'];
  UpdateAuthPhoneNumberInput: UpdateAuthPhoneNumberInput;
  UpdateAuthPhoneNumberResult: ResolversUnionParentTypes['UpdateAuthPhoneNumberResult'];
  UpdateBankAccountGoalInput: UpdateBankAccountGoalInput;
  UpdateBankAccountGoalPayload: UpdateBankAccountGoalPayload;
  UpdateBankAccountGoalResult: ResolversUnionParentTypes['UpdateBankAccountGoalResult'];
  UpdateBankCardPinInput: UpdateBankCardPinInput;
  UpdateBankCardPinPayload: UpdateBankCardPinPayload;
  UpdateBannersInput: UpdateBannersInput;
  UpdateBeneficiaryInfoResult: ResolversUnionParentTypes['UpdateBeneficiaryInfoResult'];
  UpdateBenefitStatusInput: UpdateBenefitStatusInput;
  UpdateBenefitStatusResponse: UpdateBenefitStatusResponse;
  UpdateCredentialsResult: ResolversUnionParentTypes['UpdateCredentialsResult'];
  UpdateDelegateResult: ResolversUnionParentTypes['UpdateDelegateResult'];
  UpdateElapsedTimeForLearnQuizInput: UpdateElapsedTimeForLearnQuizInput;
  UpdateElapsedTimeForLearnQuizResult: ResolversUnionParentTypes['UpdateElapsedTimeForLearnQuizResult'];
  UpdateLearnContentHelpfulnessResult: UpdateLearnContentHelpfulnessResult;
  UpdateLearnProgressInput: UpdateLearnProgressInput;
  UpdateLearnProgressResult: ResolversUnionParentTypes['UpdateLearnProgressResult'];
  UpdateLinkedAccountInput: UpdateLinkedAccountInput;
  UpdateMessageFailed: UpdateMessageFailed;
  UpdateMessageIgnored: UpdateMessageIgnored;
  UpdateMessageResult: ResolversUnionParentTypes['UpdateMessageResult'];
  UpdateMessagesFailure: UpdateMessagesFailure;
  UpdateMoneyManagerAllocationsInput: UpdateMoneyManagerAllocationsInput;
  UpdateMoneyManagerAllocationsResult: ResolversUnionParentTypes['UpdateMoneyManagerAllocationsResult'];
  UpdateMoneyManagerAllocationsSuccess: UpdateMoneyManagerAllocationsSuccess;
  UpdateMoneyManagerAutomationTargetInput: UpdateMoneyManagerAutomationTargetInput;
  UpdateMoneyManagerAutomationTargetResult: ResolversUnionParentTypes['UpdateMoneyManagerAutomationTargetResult'];
  UpdateMoneyManagerAutomationTargetSuccess: UpdateMoneyManagerAutomationTargetSuccess;
  UpdateMoneyManagerSettingsFailure: UpdateMoneyManagerSettingsFailure;
  UpdateMoneyManagerSettingsInput: UpdateMoneyManagerSettingsInput;
  UpdateMoneyManagerSettingsResult: ResolversUnionParentTypes['UpdateMoneyManagerSettingsResult'];
  UpdateMoneyManagerSettingsSuccess: UpdateMoneyManagerSettingsSuccess;
  UpdateMoneyRulesSourceSettingsFailure: UpdateMoneyRulesSourceSettingsFailure;
  UpdateMoneyRulesSourceSettingsInput: UpdateMoneyRulesSourceSettingsInput;
  UpdateMoneyRulesSourceSettingsResult: ResolversUnionParentTypes['UpdateMoneyRulesSourceSettingsResult'];
  UpdateMoneyRulesSourceSettingsSuccess: UpdateMoneyRulesSourceSettingsSuccess;
  UpdateOauthAppInput: UpdateOauthAppInput;
  UpdateOauthAppResult: ResolversUnionParentTypes['UpdateOauthAppResult'];
  UpdateOptOutOfTargetingInput: UpdateOptOutOfTargetingInput;
  UpdatePortfolioSecuritiesInput: UpdatePortfolioSecuritiesInput;
  UpdatePortfolioSecuritiesResult: ResolversUnionParentTypes['UpdatePortfolioSecuritiesResult'];
  UpdatePromoCodeInput: UpdatePromoCodeInput;
  UpdatePromoCodeResult: ResolversUnionParentTypes['UpdatePromoCodeResult'];
  UpdatePromotedCampaignsInput: UpdatePromotedCampaignsInput;
  UpdatePromotedCampaignsResult: ResolversUnionParentTypes['UpdatePromotedCampaignsResult'];
  UpdateReferralCampaignInput: UpdateReferralCampaignInput;
  UpdateReferralCampaignResult: ResolversUnionParentTypes['UpdateReferralCampaignResult'];
  UpdateReferralPayoutInput: UpdateReferralPayoutInput;
  UpdateReferralPayoutResult: ResolversUnionParentTypes['UpdateReferralPayoutResult'];
  UpdateReferralRelationshipInput: UpdateReferralRelationshipInput;
  UpdateReferralRelationshipResult: ResolversUnionParentTypes['UpdateReferralRelationshipResult'];
  UpdateReferralRewardError: UpdateReferralRewardError;
  UpdateReferralRewardResponse: ResolversUnionParentTypes['UpdateReferralRewardResponse'];
  UpdateScopeException: UpdateScopeException;
  UpdateScopeInput: UpdateScopeInput;
  UpdateScopeResult: ResolversUnionParentTypes['UpdateScopeResult'];
  UpdateTrustedContactResult: ResolversUnionParentTypes['UpdateTrustedContactResult'];
  UpdateUserProfileAndAutomationTargetInput: UpdateUserProfileAndAutomationTargetInput;
  UpdateUserProfileAndAutomationTargetResult: ResolversUnionParentTypes['UpdateUserProfileAndAutomationTargetResult'];
  UpdateUserProfileAndAutomationTargetSuccess: UpdateUserProfileAndAutomationTargetSuccess;
  UpdateUserSwitchState: ResolversUnionParentTypes['UpdateUserSwitchState'];
  UpdateUserSwitchStateFailure: UpdateUserSwitchStateFailure;
  UpdateUserSwitchStateInput: UpdateUserSwitchStateInput;
  UpdateUserSwitchStatePayload: UpdateUserSwitchStatePayload;
  UpdateVerificationProfileResult: ResolversUnionParentTypes['UpdateVerificationProfileResult'];
  UpgradeAuthenticationResult: ResolversUnionParentTypes['UpgradeAuthenticationResult'];
  Upload: Scalars['Upload'];
  UploadCheckInput: UploadCheckInput;
  UploadCheckPayload: UploadCheckPayload;
  UploadDocumentsInput: UploadDocumentsInput;
  UploadDoesNotExist: UploadDoesNotExist;
  UploadDoesNotExistError: UploadDoesNotExistError;
  UploadFailedError: UploadFailedError;
  UploadOauthAppImageResult: ResolversUnionParentTypes['UploadOauthAppImageResult'];
  UploadSaveError: Omit<UploadSaveError, 'uploadExceptions'> & { uploadExceptions: Array<ResolversParentTypes['UploadSaveExceptions']> };
  UploadSaveExceptions: ResolversUnionParentTypes['UploadSaveExceptions'];
  UploadUnsolicitedDocumentsInput: UploadUnsolicitedDocumentsInput;
  UploadUrl: UploadUrl;
  UpsertUserMatchInput: UpsertUserMatchInput;
  UpsertUserMatchResult: ResolversUnionParentTypes['UpsertUserMatchResult'];
  User: User;
  UserAlert: UserAlert;
  UserAlertsItem: ResolversParentTypes['AddressDocumentRequestedUserAlert'] | ResolversParentTypes['BankDocumentRequestedUserAlert'] | ResolversParentTypes['IdentityDocumentRequestedUserAlert'] | ResolversParentTypes['InsufficientFundsUserAlert'] | ResolversParentTypes['InvestmentsPausedUserAlert'] | ResolversParentTypes['LinkedAccountAlert'] | ResolversParentTypes['MiscDocumentRequestedUserAlert'] | ResolversParentTypes['MissingSsnBeneficiaryAlertItem'] | ResolversParentTypes['NoFundingSourceUserAlert'] | ResolversParentTypes['RdvRequiredUserAlert'] | ResolversParentTypes['RelinkLinkedAccountAlert'] | ResolversParentTypes['SSNDocumentRequestedUserAlert'] | ResolversParentTypes['UnverifiedBeneficiarySsnAlertItem'] | ResolversParentTypes['UserAlert'] | ResolversParentTypes['W9DocumentRequestedUserAlert'];
  UserAlertsResponse: ResolversUnionParentTypes['UserAlertsResponse'];
  UserCardLockedSpendAlert: UserCardLockedSpendAlert;
  UserClosedException: UserClosedException;
  UserCohorts: UserCohorts;
  UserCredentials: UserCredentials;
  UserCredentialsInput: UserCredentialsInput;
  UserCredentialsNotFoundException: UserCredentialsNotFoundException;
  UserExistsException: UserExistsException;
  UserInvestmentAccountReopenCheck: UserInvestmentAccountReopenCheck;
  UserLockedException: UserLockedException;
  UserMatch: UserMatch;
  UserNotFound: UserNotFound;
  UserNotFoundException: UserNotFoundException;
  UserNotUSResidentException: UserNotUsResidentException;
  UserNotVerifiedException: UserNotVerifiedException;
  UserPartnerStatusResponse: UserPartnerStatusResponse;
  UserReopenLockedException: UserReopenLockedException;
  UserReopenSuspendedException: UserReopenSuspendedException;
  UserStatus: UserStatus;
  UserSuspendedException: UserSuspendedException;
  UserSuspendedUploadTokenLengthError: UserSuspendedUploadTokenLengthError;
  UserSuspendedUploadTokenValidation: UserSuspendedUploadTokenValidation;
  UserSwitch: UserSwitch;
  UserToken: UserToken;
  UserUpload: UserUpload;
  User_v2: User_V2;
  ValidPolicies: ValidPolicies;
  ValidateCredentialsInput: ValidateCredentialsInput;
  ValidateCredentialsResult: ResolversUnionParentTypes['ValidateCredentialsResult'];
  ValidateCredentialsSuccess: ValidateCredentialsSuccess;
  ValidateDocumentsInput: ValidateDocumentsInput;
  ValidatePasswordResetTokenResult: ResolversUnionParentTypes['ValidatePasswordResetTokenResult'];
  ValidatePasswordResetTokenSuccess: ValidatePasswordResetTokenSuccess;
  ValidateUserSuspendedUploadTokenInput: ValidateUserSuspendedUploadTokenInput;
  ValidateUserSuspendedUploadTokenResult: ResolversUnionParentTypes['ValidateUserSuspendedUploadTokenResult'];
  ValidationError: ValidationError;
  VendAuthSessionInput: VendAuthSessionInput;
  VendAuthSessionResult: ResolversUnionParentTypes['VendAuthSessionResult'];
  VendorBillingInfo: VendorBillingInfo;
  VendorCustomerAccount: VendorCustomerAccount;
  VendorIntegrationError: VendorIntegrationError;
  VendorRefundInvoiceError: VendorRefundInvoiceError;
  VerificationDetails: VerificationDetails;
  VerificationProfile: VerificationProfile;
  VerificationProfileInput: VerificationProfileInput;
  VerifyCheckPaymentRecipientAddressInputType: VerifyCheckPaymentRecipientAddressInputType;
  VerifyCheckPaymentRecipientAddressResult: ResolversUnionParentTypes['VerifyCheckPaymentRecipientAddressResult'];
  VerifyDeviceInput: VerifyDeviceInput;
  VerifyDeviceResult: ResolversUnionParentTypes['VerifyDeviceResult'];
  VerifyIdentityByDocumentsResult: ResolversUnionParentTypes['VerifyIdentityByDocumentsResult'];
  VerifyPasswordsInput: VerifyPasswordsInput;
  VerifyPasswordsResult: ResolversUnionParentTypes['VerifyPasswordsResult'];
  VerifyPasswordsSuccess: VerifyPasswordsSuccess;
  VerifyPromoCodeResponse: ResolversUnionParentTypes['VerifyPromoCodeResponse'];
  VerifyRdvsInput: VerifyRdvsInput;
  VerifyRdvsResult: ResolversUnionParentTypes['VerifyRdvsResult'];
  VersionMismatchException: VersionMismatchException;
  ViewedLearnContentResult: ViewedLearnContentResult;
  Void: Scalars['Void'];
  W9DocumentRequestedUserAlert: W9DocumentRequestedUserAlert;
  Waiver: ResolversUnionParentTypes['Waiver'];
  WaiverCoupon: WaiverCoupon;
  WaiverCreationException: WaiverCreationException;
  WaiverDeletionException: WaiverDeletionException;
  Webhooks: Webhooks;
  WebviewLinkSession: WebviewLinkSession;
  Withdrawal: Withdrawal;
  WithholdingDefaults: WithholdingDefaults;
  WithholdingEstimates: WithholdingEstimates;
  YearLaterReport: YearLaterReport;
  allPastScheduledItemsFilter: AllPastScheduledItemsFilter;
  allPastScheduledItemsFilterV2: AllPastScheduledItemsFilterV2;
  endChatSessionResponse: ResolversUnionParentTypes['endChatSessionResponse'];
  helpcenterBannerResponse: ResolversUnionParentTypes['helpcenterBannerResponse'];
  jobs_Article: Jobs_Article;
  jobs_Education: Jobs_Education;
  jobs_Offer: Jobs_Offer;
  jobs_OfferConnection: Jobs_OfferConnection;
  jobs_OfferEdge: Jobs_OfferEdge;
  jobs_OfferSalary: Jobs_OfferSalary;
  laterTotalLiquidationInput: LaterTotalLiquidationInput;
  managePayoutRelationshipInput: ManagePayoutRelationshipInput;
  rateChatMessageResponse: ResolversUnionParentTypes['rateChatMessageResponse'];
  startChatSessionResponse: ResolversUnionParentTypes['startChatSessionResponse'];
  suitability_Portfolio: Suitability_Portfolio;
  suitability_SuitabilityAnswer: Suitability_SuitabilityAnswer;
  suitability_SuitabilityInput: Suitability_SuitabilityInput;
  suitability_SuitabilityQuestion: Suitability_SuitabilityQuestion;
  suitability_SuitabilityResponse: Suitability_SuitabilityResponse;
  suitability_UpdateSuitabilityResult: Suitability_UpdateSuitabilityResult;
  uploadAudienceListInput: UploadAudienceListInput;
  userWinbackErrors: UserWinbackErrors;
  userWinbackScore: UserWinbackScore;
  userWinbackScoreRes: ResolversUnionParentTypes['userWinbackScoreRes'];
};

export type AuthzDirectiveArgs = {
  denyAll?: Maybe<Array<Scalars['String']>>;
  denyAny?: Maybe<Array<Scalars['String']>>;
  requireAll?: Maybe<Array<Scalars['String']>>;
  requireAny?: Maybe<Array<Scalars['String']>>;
};

export type AuthzDirectiveResolver<Result, Parent, ContextType = any, Args = AuthzDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type DraftDirectiveArgs = {
  goLiveDate?: Maybe<Scalars['String']>;
};

export type DraftDirectiveResolver<Result, Parent, ContextType = any, Args = DraftDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ImplicitDirectiveArgs = {
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ImplicitDirectiveResolver<Result, Parent, ContextType = any, Args = ImplicitDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Inct1661BandAidDirectiveArgs = { };

export type Inct1661BandAidDirectiveResolver<Result, Parent, ContextType = any, Args = Inct1661BandAidDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type RateLimitDirectiveArgs = {
  max?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  window?: Maybe<Scalars['String']>;
};

export type RateLimitDirectiveResolver<Result, Parent, ContextType = any, Args = RateLimitDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SkipAuthDirectiveArgs = { };

export type SkipAuthDirectiveResolver<Result, Parent, ContextType = any, Args = SkipAuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SupergraphDirectiveArgs = {
  name: Scalars['String'];
};

export type SupergraphDirectiveResolver<Result, Parent, ContextType = any, Args = SupergraphDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AbstractSwitchResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbstractSwitch'] = ResolversParentTypes['AbstractSwitch']> = {
  __resolveType: TypeResolveFn<'AcornsPdfSwitch' | 'OnlineSwitch' | 'SubmittableSwitch', ParentType, ContextType>;
};

export type AcceptDocumentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptDocumentResponse'] = ResolversParentTypes['AcceptDocumentResponse']> = {
  __resolveType: TypeResolveFn<'AcceptedDocument' | 'DocumentNotFound' | 'UserNotFound', ParentType, ContextType>;
};

export type AcceptanceDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptanceDocument'] = ResolversParentTypes['AcceptanceDocument']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mustScrollToBottom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiredFor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcceptedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptedDocument'] = ResolversParentTypes['AcceptedDocument']> = {
  acceptedDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  documentType?: Resolver<ResolversTypes['AcceptanceDocumentType'], ParentType, ContextType>;
  documentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = {
  accountType?: Resolver<ResolversTypes['AccountType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  creatorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AccountStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountAchievementResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountAchievement'] = ResolversParentTypes['AccountAchievement']> = {
  achievement?: Resolver<ResolversTypes['AchievementItem'], ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dateCompleted?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountAlreadyClosedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountAlreadyClosedException'] = ResolversParentTypes['AccountAlreadyClosedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountClosedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountClosedException'] = ResolversParentTypes['AccountClosedException']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountFrozenResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountFrozen'] = ResolversParentTypes['AccountFrozen']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountNotFoundException'] = ResolversParentTypes['AccountNotFoundException']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AccountNumberScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AccountNumber'], any> {
  name: 'AccountNumber';
}

export type AccountPointsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPoints'] = ResolversParentTypes['AccountPoints']> = {
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detailsKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  earned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pointsPerCompletion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountPointsRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPointsRule'] = ResolversParentTypes['AccountPointsRule']> = {
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detailsKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  milestoneID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pointsPerCompletion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountRequirementResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountRequirement'] = ResolversParentTypes['AccountRequirement']> = {
  actionable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AccountRequirementStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AccountRequirementType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountRequirementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountRequirements'] = ResolversParentTypes['AccountRequirements']> = {
  close?: Resolver<Array<ResolversTypes['AccountRequirement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountSetupMilestonesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountSetupMilestones'] = ResolversParentTypes['AccountSetupMilestones']> = {
  descriptionKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>;
  groupProgress?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>;
  milestones?: Resolver<Array<ResolversTypes['Milestone']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountStrengthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountStrengthResult'] = ResolversParentTypes['AccountStrengthResult']> = {
  achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountAchievement']>>>, ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountValue'] = ResolversParentTypes['AccountValue']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcornsEarlyUserDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcornsEarlyUserDetails'] = ResolversParentTypes['AcornsEarlyUserDetails']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credentialsExist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcornsPdfSwitchResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcornsPdfSwitch'] = ResolversParentTypes['AcornsPdfSwitch']> = {
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcornsValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcornsValidationError'] = ResolversParentTypes['AcornsValidationError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionCard'] = ResolversParentTypes['ActionCard']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaDetails?: Resolver<Maybe<ResolversTypes['ActionCardButton']>, ParentType, ContextType>;
  eyebrow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  ownerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  style?: Resolver<ResolversTypes['ActionCardStyle'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userCardDigest?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  widget?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionCardButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionCardButton'] = ResolversParentTypes['ActionCardButton']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  videoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionFeedCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionFeedCta'] = ResolversParentTypes['ActionFeedCta']> = {
  hideCardIfUnknown?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionFeedCtaType']>, ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionFeedEventResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionFeedEventResponse'] = ResolversParentTypes['ActionFeedEventResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionScreenComponentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionScreenComponent'] = ResolversParentTypes['ActionScreenComponent']> = {
  __resolveType: TypeResolveFn<'ActionWidget', ParentType, ContextType>;
};

export type ActionWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionWidget'] = ResolversParentTypes['ActionWidget']> = {
  digest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivateBankCardPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateBankCardPayload'] = ResolversParentTypes['ActivateBankCardPayload']> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivateOauthAppClientResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateOauthAppClientResult'] = ResolversParentTypes['ActivateOauthAppClientResult']> = {
  __resolveType: TypeResolveFn<'OauthAppClient' | 'OauthAppClientNotFoundException', ParentType, ContextType>;
};

export type ActivateOauthAppResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateOauthAppResult'] = ResolversParentTypes['ActivateOauthAppResult']> = {
  __resolveType: TypeResolveFn<'OauthApp' | 'OauthAppNotFoundException', ParentType, ContextType>;
};

export type ActiveReferralCampaignOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveReferralCampaignOutput'] = ResolversParentTypes['ActiveReferralCampaignOutput']> = {
  campaigns?: Resolver<Array<Maybe<ResolversTypes['ReferralCampaignV2']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Activity'] = ResolversParentTypes['Activity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ActivityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivitySummaryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivitySummaryResponse'] = ResolversParentTypes['ActivitySummaryResponse']> = {
  activitySummaryItems?: Resolver<Maybe<Array<ResolversTypes['SummaryItem']>>, ParentType, ContextType>;
  numberOfDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  totalV2?: Resolver<Maybe<ResolversTypes['MicrosMoney']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddCohortEligibilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddCohortEligibilityResult'] = ResolversParentTypes['AddCohortEligibilityResult']> = {
  __resolveType: TypeResolveFn<'UserCohorts', ParentType, ContextType>;
};

export type AddPolicyResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddPolicyResult'] = ResolversParentTypes['AddPolicyResult']> = {
  __resolveType: TypeResolveFn<'AddPolicySuccess' | 'PoliciesRecordDoesNotExistException' | 'PolicyNotAddedException', ParentType, ContextType>;
};

export type AddPolicySuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddPolicySuccess'] = ResolversParentTypes['AddPolicySuccess']> = {
  policies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Policy']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSearchTermToLearnSearchHistoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSearchTermToLearnSearchHistoryResult'] = ResolversParentTypes['AddSearchTermToLearnSearchHistoryResult']> = {
  __resolveType: TypeResolveFn<'LearnSearchTermSavedResult', ParentType, ContextType>;
};

export type AddSecurityToPortfolioResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSecurityToPortfolioResult'] = ResolversParentTypes['AddSecurityToPortfolioResult']> = {
  __resolveType: TypeResolveFn<'InvestmentAccountNotFoundException' | 'InvestmentAccountNotSupportedException' | 'Portfolio' | 'PortfolioNotFoundException' | 'PortfolioNotSupportedException' | 'SecurityNotSupportedException', ParentType, ContextType>;
};

export type AddSelfDirectedPortfolioResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSelfDirectedPortfolioResult'] = ResolversParentTypes['AddSelfDirectedPortfolioResult']> = {
  __resolveType: TypeResolveFn<'CustomerAgreementRequiredException' | 'InvalidInvestmentAccountException' | 'InvalidSubscriptionTierException' | 'InvestmentAccount' | 'PortfolioNotFoundException', ParentType, ContextType>;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  addressType?: Resolver<ResolversTypes['AddressType'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressDeliverabilityAdditionalInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressDeliverabilityAdditionalInfo'] = ResolversParentTypes['AddressDeliverabilityAdditionalInfo']> = {
  isBusiness?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPoBox?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPrivateMailbox?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVacant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressDeliverabilityCorrectedAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressDeliverabilityCorrectedAddress'] = ResolversParentTypes['AddressDeliverabilityCorrectedAddress']> = {
  additionalInfo?: Resolver<Maybe<ResolversTypes['AddressDeliverabilityAdditionalInfo']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressDeliverabilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressDeliverabilityResult'] = ResolversParentTypes['AddressDeliverabilityResult']> = {
  __resolveType: TypeResolveFn<'AddressDeliverabilityCorrectedAddress' | 'AddressDeliverabilityUnavailableError' | 'AddressDeliverabilityVerificationError' | 'AddressDeliverabilityVerified', ParentType, ContextType>;
};

export type AddressDeliverabilityUnavailableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressDeliverabilityUnavailableError'] = ResolversParentTypes['AddressDeliverabilityUnavailableError']> = {
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressDeliverabilityVerificationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressDeliverabilityVerificationError'] = ResolversParentTypes['AddressDeliverabilityVerificationError']> = {
  failureReason?: Resolver<Maybe<ResolversTypes['AddressDeliverabilityVerificationErrorFailureReason']>, ParentType, ContextType>;
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressDeliverabilityVerifiedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressDeliverabilityVerified'] = ResolversParentTypes['AddressDeliverabilityVerified']> = {
  additionalInfo?: Resolver<Maybe<ResolversTypes['AddressDeliverabilityAdditionalInfo']>, ParentType, ContextType>;
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressDocumentRequestedUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressDocumentRequestedUserAlert'] = ResolversParentTypes['AddressDocumentRequestedUserAlert']> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressVerification'] = ResolversParentTypes['AddressVerification']> = {
  __resolveType: TypeResolveFn<'BankCardOrderAddressVerification' | 'BankingKycAddressVerification', ParentType, ContextType>;
  verificationStatus?: Resolver<ResolversTypes['VerificationStatus'], ParentType, ContextType>;
};

export type AdvocateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Advocate'] = ResolversParentTypes['Advocate']> = {
  campaign?: Resolver<Maybe<ResolversTypes['ReferralCampaignV2']>, ParentType, ContextType>;
  experienceContent?: Resolver<Maybe<ResolversTypes['ExperienceContent']>, ParentType, ContextType>;
  friends?: Resolver<Maybe<Array<ResolversTypes['Friend']>>, ParentType, ContextType>;
  referralCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  referralHistory?: Resolver<Maybe<ResolversTypes['ReferralHistory']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvocateFriendsStatusesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvocateFriendsStatuses'] = ResolversParentTypes['AdvocateFriendsStatuses']> = {
  friends?: Resolver<Maybe<Array<ResolversTypes['Friend']>>, ParentType, ContextType>;
  referralCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvocateV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvocateV2'] = ResolversParentTypes['AdvocateV2']> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['Alert'] = ResolversParentTypes['Alert']> = {
  __resolveType: TypeResolveFn<'MissingSsnBeneficiaryAlert' | 'UnverifiedBeneficiarySsnAlert', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AlertHubBeneficiaryAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertHubBeneficiaryAlert'] = ResolversParentTypes['AlertHubBeneficiaryAlert']> = {
  __resolveType: TypeResolveFn<'MissingSsnBeneficiaryAlertItem' | 'UnverifiedBeneficiarySsnAlertItem', ParentType, ContextType>;
};

export type AlertMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertMessage'] = ResolversParentTypes['AlertMessage']> = {
  body?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>;
  cardColor?: Resolver<Maybe<ResolversTypes['CardColor']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  delay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['MessageVisualAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDismissed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messageCategory?: Resolver<ResolversTypes['MessageCategory'], ParentType, ContextType>;
  messageType?: Resolver<ResolversTypes['MessageType'], ParentType, ContextType>;
  platforms?: Resolver<Array<ResolversTypes['Platform']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>;
  trackingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllAccountHistorySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllAccountHistorySummary'] = ResolversParentTypes['AllAccountHistorySummary']> = {
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  earnRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyIn?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyOut?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  referralRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllChatHistoryMessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllChatHistoryMessages'] = ResolversParentTypes['AllChatHistoryMessages']> = {
  edges?: Resolver<Array<ResolversTypes['ChatHistoryMessageEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllCheckPaymentsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllCheckPaymentsResult'] = ResolversParentTypes['AllCheckPaymentsResult']> = {
  __resolveType: TypeResolveFn<'AuthorizationError' | 'CheckPaymentConnection', ParentType, ContextType>;
};

export type AllocationAmountsSumExceedingMaxErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllocationAmountsSumExceedingMaxError'] = ResolversParentTypes['AllocationAmountsSumExceedingMaxError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AmountScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Amount'], any> {
  name: 'Amount';
}

export type AnswerChallengeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnswerChallengeResult'] = ResolversParentTypes['AnswerChallengeResult']> = {
  __resolveType: TypeResolveFn<'AnswerChallengeSuccess' | 'AuthChallengeAnswerAttemptsExhaustedException' | 'AuthChallengeAnswerIncorrectException' | 'AuthChallengeExpiredException', ParentType, ContextType>;
};

export type AnswerChallengeSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnswerChallengeSuccess'] = ResolversParentTypes['AnswerChallengeSuccess']> = {
  authenticatorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  deliveryType?: Resolver<ResolversTypes['ChallengeDeliveryType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnswerLearnQuizQuestionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnswerLearnQuizQuestionResult'] = ResolversParentTypes['AnswerLearnQuizQuestionResult']> = {
  __resolveType: TypeResolveFn<'LearnQuizAnswerResult' | 'RecordDoesNotExistError' | 'UnauthorizedModifyLockedContentError', ParentType, ContextType>;
};

export type ApplyPromoCodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyPromoCodeResult'] = ResolversParentTypes['ApplyPromoCodeResult']> = {
  __resolveType: TypeResolveFn<'InvalidPromoCodeError' | 'PromoCodeCustomer', ParentType, ContextType>;
};

export type ApplyPromotionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyPromotionResult'] = ResolversParentTypes['ApplyPromotionResult']> = {
  __resolveType: TypeResolveFn<'PromotionConsumedError' | 'PromotionExpiredError' | 'PromotionNotFoundError' | 'SubscriberIneligibleError' | 'TierSubscription', ParentType, ContextType>;
};

export type ApplyPromotionalWaiverResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyPromotionalWaiverResult'] = ResolversParentTypes['ApplyPromotionalWaiverResult']> = {
  __resolveType: TypeResolveFn<'InvalidDateException' | 'InvalidUserIdException' | 'PromotionalWaiver_V2' | 'WaiverCreationException', ParentType, ContextType>;
};

export type ApplyProvisionalWaiverResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyProvisionalWaiverResult'] = ResolversParentTypes['ApplyProvisionalWaiverResult']> = {
  __resolveType: TypeResolveFn<'InvalidDateException' | 'InvalidUserIdException' | 'ProvisionalWaiver_V2' | 'WaiverCreationException', ParentType, ContextType>;
};

export type ArchiveInvalidSmartDepositRecordsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ArchiveInvalidSmartDepositRecordsResult'] = ResolversParentTypes['ArchiveInvalidSmartDepositRecordsResult']> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AsyncLinkSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AsyncLinkSessionResult'] = ResolversParentTypes['AsyncLinkSessionResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthAlert'] = ResolversParentTypes['AuthAlert']> = {
  __resolveType: TypeResolveFn<'MfaMissingAuthAlert', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AuthChallengeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthChallenge'] = ResolversParentTypes['AuthChallenge']> = {
  __resolveType: TypeResolveFn<'EmailAuthChallenge' | 'PushAuthChallenge' | 'SMSAuthChallenge', ParentType, ContextType>;
  alternateAuthenticators?: Resolver<Array<ResolversTypes['AuthenticatorInfo']>, ParentType, ContextType>;
  challengeTrigger?: Resolver<ResolversTypes['ChallengeTriggers'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type AuthChallengeAnswerAttemptsExhaustedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthChallengeAnswerAttemptsExhaustedException'] = ResolversParentTypes['AuthChallengeAnswerAttemptsExhaustedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthChallengeAnswerIncorrectExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthChallengeAnswerIncorrectException'] = ResolversParentTypes['AuthChallengeAnswerIncorrectException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthChallengeExpiredExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthChallengeExpiredException'] = ResolversParentTypes['AuthChallengeExpiredException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthProfile'] = ResolversParentTypes['AuthProfile']> = {
  defaultAuthenticator?: Resolver<Maybe<ResolversTypes['Authenticator']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['EmailAddress']>, ParentType, ContextType>;
  emailVerifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  loginAccess?: Resolver<Maybe<ResolversTypes['LoginAccess']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberVerifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  privateRelayUnverified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  requireLoginChallenge?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthProfileAlreadyExistsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthProfileAlreadyExistsException'] = ResolversParentTypes['AuthProfileAlreadyExistsException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthProfileNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthProfileNotFoundException'] = ResolversParentTypes['AuthProfileNotFoundException']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthSession'] = ResolversParentTypes['AuthSession']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identityToken?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  redirectUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  token?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthTokenNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthTokenNotFoundException'] = ResolversParentTypes['AuthTokenNotFoundException']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticateForFeeNegotiationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticateForFeeNegotiationResult'] = ResolversParentTypes['AuthenticateForFeeNegotiationResult']> = {
  __resolveType: TypeResolveFn<'AuthenticateForFeeNegotiationStatus' | 'LinkedAccountNotFound' | 'NegotiationServiceConnectionFailure', ParentType, ContextType>;
};

export type AuthenticateForFeeNegotiationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticateForFeeNegotiationStatus'] = ResolversParentTypes['AuthenticateForFeeNegotiationStatus']> = {
  credentialStatus?: Resolver<ResolversTypes['CredentialStatus'], ParentType, ContextType>;
  operationError?: Resolver<Maybe<ResolversTypes['AutomationError']>, ParentType, ContextType>;
  operationStage?: Resolver<ResolversTypes['OperationStage'], ParentType, ContextType>;
  tfaMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tfaOptions?: Resolver<Maybe<ResolversTypes['TfaOptions']>, ParentType, ContextType>;
  tfaStatus?: Resolver<ResolversTypes['TfaStatus'], ParentType, ContextType>;
  tfaType?: Resolver<ResolversTypes['TfaType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticateNegotiationStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticateNegotiationStatusResult'] = ResolversParentTypes['AuthenticateNegotiationStatusResult']> = {
  __resolveType: TypeResolveFn<'AuthenticateForFeeNegotiationStatus' | 'LinkedAccountNotFound', ParentType, ContextType>;
};

export type AuthenticateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticateResult'] = ResolversParentTypes['AuthenticateResult']> = {
  __resolveType: TypeResolveFn<'AuthChallengeAnswerAttemptsExhaustedException' | 'AuthChallengeAnswerIncorrectException' | 'AuthChallengeExpiredException' | 'AuthSession' | 'AuthenticatorTypeAlreadyRegisteredException' | 'AuthenticatorUnavailableException' | 'ChallengeRateExceededException' | 'DeviceBlockedException' | 'EmailAuthChallenge' | 'InvalidCredentialsException' | 'LoginRateLimitedException' | 'PhoneNumberOptedOutException' | 'SMSAuthChallenge' | 'UserLockedException' | 'UserSuspendedException', ParentType, ContextType>;
};

export type AuthenticationAlreadyUpgradedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticationAlreadyUpgradedException'] = ResolversParentTypes['AuthenticationAlreadyUpgradedException']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Authenticator'] = ResolversParentTypes['Authenticator']> = {
  __resolveType: TypeResolveFn<'EmailAuthenticator' | 'PhoneAuthenticator' | 'PushAuthenticator', ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastAuthenticatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type AuthenticatorAlreadyDefaultExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticatorAlreadyDefaultException'] = ResolversParentTypes['AuthenticatorAlreadyDefaultException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticatorInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticatorInfo'] = ResolversParentTypes['AuthenticatorInfo']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticatorNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticatorNotFoundException'] = ResolversParentTypes['AuthenticatorNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticatorTypeAlreadyRegisteredExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticatorTypeAlreadyRegisteredException'] = ResolversParentTypes['AuthenticatorTypeAlreadyRegisteredException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticatorUnavailableExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticatorUnavailableException'] = ResolversParentTypes['AuthenticatorUnavailableException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizationError'] = ResolversParentTypes['AuthorizationError']> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutomationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomationError'] = ResolversParentTypes['AutomationError']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['AutomationErrorCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BackendJobBatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['BackendJobBatch'] = ResolversParentTypes['BackendJobBatch']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failedJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pendingPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processedJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BackendJobBatchStatus'], ParentType, ContextType>;
  successPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BackendJobBatchType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BackendJobBatchSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BackendJobBatchSummary'] = ResolversParentTypes['BackendJobBatchSummary']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  customerCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalHoldingsAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalInvestmentAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalInvestmentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BadRequestErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BadRequestError'] = ResolversParentTypes['BadRequestError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = {
  accountHolderReferenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableBalanceAndIncomingBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentAPY?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  goals?: Resolver<ResolversTypes['BankAccountGoals'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPendingClosure?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lockReason?: Resolver<Maybe<ResolversTypes['BankAccountLockReason']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  requirements?: Resolver<ResolversTypes['BankAccountRequirements'], ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankAccountStatus'], ParentType, ContextType>;
  totalBalance?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BankAccountType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountDisclosureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountDisclosure'] = ResolversParentTypes['BankAccountDisclosure']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mustScrollToBottom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiredFor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountGoalResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountGoal'] = ResolversParentTypes['BankAccountGoal']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BankAccountGoalType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountGoalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountGoals'] = ResolversParentTypes['BankAccountGoals']> = {
  currentGoal?: Resolver<Maybe<ResolversTypes['BankAccountGoal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountNotFoundError'] = ResolversParentTypes['BankAccountNotFoundError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountRequirementResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountRequirement'] = ResolversParentTypes['BankAccountRequirement']> = {
  actionable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankAccountRequirementStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BankAccountRequirementType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountRequirementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountRequirements'] = ResolversParentTypes['BankAccountRequirements']> = {
  close?: Resolver<Array<ResolversTypes['BankAccountRequirement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountState'] = ResolversParentTypes['BankAccountState']> = {
  accountType?: Resolver<ResolversTypes['BankAccountType'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankAccountStateStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountStateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountStateResult'] = ResolversParentTypes['BankAccountStateResult']> = {
  accounts?: Resolver<Array<ResolversTypes['BankAccountState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCard'] = ResolversParentTypes['BankCard']> = {
  activatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>;
  cardNumberMasked?: Resolver<Maybe<ResolversTypes['CardNumberMasked']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  digitalWalletTokens?: Resolver<Array<ResolversTypes['DigitalWalletToken']>, ParentType, ContextType>;
  expireMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expireYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDigitalOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDigitallyProvisioned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lockReason?: Resolver<Maybe<ResolversTypes['BankCardLockReason']>, ParentType, ContextType>;
  lockTypeCode?: Resolver<ResolversTypes['BankCardLockTypeCode'], ParentType, ContextType>;
  paymentProcessor?: Resolver<ResolversTypes['BankCardPaymentProcessor'], ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankCardStatus'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['BankCardTier'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BankCardType'], ParentType, ContextType>;
  userActivatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardOrder'] = ResolversParentTypes['BankCardOrder']> = {
  addressVerification?: Resolver<Maybe<ResolversTypes['BankCardOrderAddressVerification']>, ParentType, ContextType>;
  bankCardTier?: Resolver<Maybe<ResolversTypes['BankCardTier']>, ParentType, ContextType>;
  bankType?: Resolver<Maybe<ResolversTypes['BankType']>, ParentType, ContextType>;
  cardOrderStatus?: Resolver<ResolversTypes['BankCardOrderStatus'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['BankCardOrderFailureReason']>, ParentType, ContextType>;
  fundingInitiated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fundingSourceVerification?: Resolver<Maybe<ResolversTypes['BankCardOrderFundingSourceVerification']>, ParentType, ContextType>;
  identityVerification?: Resolver<Maybe<ResolversTypes['BankCardOrderIdentityVerification']>, ParentType, ContextType>;
  isKycHighRisk?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  kycStatus?: Resolver<Maybe<ResolversTypes['KycStatus']>, ParentType, ContextType>;
  prefundVerification?: Resolver<Maybe<ResolversTypes['BankCardOrderPrefundVerification']>, ParentType, ContextType>;
  requestVersion?: Resolver<Maybe<ResolversTypes['RequestVersions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardOrderAddressVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardOrderAddressVerification'] = ResolversParentTypes['BankCardOrderAddressVerification']> = {
  actionRequired?: Resolver<Maybe<ResolversTypes['BankCardOrderAddressVerificationActions']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>;
  verificationStatus?: Resolver<ResolversTypes['VerificationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardOrderFundingSourceVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardOrderFundingSourceVerification'] = ResolversParentTypes['BankCardOrderFundingSourceVerification']> = {
  actionRequired?: Resolver<Maybe<ResolversTypes['BankCardOrderFundingSourceVerificationActions']>, ParentType, ContextType>;
  pendingReason?: Resolver<Maybe<ResolversTypes['BankCardOrderFundingSourceVerificationPendingReason']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardOrderIdentityVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardOrderIdentityVerification'] = ResolversParentTypes['BankCardOrderIdentityVerification']> = {
  actionRequired?: Resolver<Maybe<ResolversTypes['BankCardOrderIdentityVerificationActions']>, ParentType, ContextType>;
  canRetry?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  documentUploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>;
  verificationStatus?: Resolver<ResolversTypes['VerificationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardOrderPrefundVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardOrderPrefundVerification'] = ResolversParentTypes['BankCardOrderPrefundVerification']> = {
  actionRequired?: Resolver<Maybe<ResolversTypes['BankCardOrderPrefundVerificationActions']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankCardOrderVerificationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardPanDisplayPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardPanDisplayPayload'] = ResolversParentTypes['BankCardPanDisplayPayload']> = {
  bankCard?: Resolver<ResolversTypes['BankCard'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardPanDisplayResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardPanDisplayResult'] = ResolversParentTypes['BankCardPanDisplayResult']> = {
  __resolveType: TypeResolveFn<'BankCardPanDisplayPayload', ParentType, ContextType>;
};

export interface BankCardPinScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BankCardPin'], any> {
  name: 'BankCardPin';
}

export type BankCardProvisioningDetailsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardProvisioningDetailsPayload'] = ResolversParentTypes['BankCardProvisioningDetailsPayload']> = {
  cardNumberMasked?: Resolver<Maybe<ResolversTypes['CardNumberMasked']>, ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardProvisioningDetailsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardProvisioningDetailsResult'] = ResolversParentTypes['BankCardProvisioningDetailsResult']> = {
  __resolveType: TypeResolveFn<'BankCardProvisioningDetailsPayload', ParentType, ContextType>;
};

export type BankCardReissueResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardReissue'] = ResolversParentTypes['BankCardReissue']> = {
  bankCardRequest?: Resolver<Maybe<ResolversTypes['BankCardRequest']>, ParentType, ContextType>;
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>;
  reissueBankCardEligibility?: Resolver<ResolversTypes['ReissueBankCardEligibility'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardRequest'] = ResolversParentTypes['BankCardRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActivated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isReissue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  mailingAddress?: Resolver<Maybe<ResolversTypes['BankCardRequestMailingAddress']>, ParentType, ContextType>;
  previousBankCardId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  previousBankCardTier?: Resolver<Maybe<ResolversTypes['BankCardTier']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['BankCardRequestReason'], ParentType, ContextType>;
  reasonComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  requestedDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankCardRequestStatus'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCardRequestMailingAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCardRequestMailingAddress'] = ResolversParentTypes['BankCardRequestMailingAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankConnection'] = ResolversParentTypes['BankConnection']> = {
  accountStatus?: Resolver<Maybe<ResolversTypes['BankConnectionStatus']>, ParentType, ContextType>;
  bank?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastSubmissionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  negotiationType?: Resolver<Maybe<ResolversTypes['NegotiationType']>, ParentType, ContextType>;
  nextSubmissionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  totalNegotiableFees?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankDocument'] = ResolversParentTypes['BankDocument']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankDocumentRequestedUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankDocumentRequestedUserAlert'] = ResolversParentTypes['BankDocumentRequestedUserAlert']> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankFee'] = ResolversParentTypes['BankFee']> = {
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['TransactionCategory']>, ParentType, ContextType>;
  digit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  linkedSubAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FeeStatus']>, ParentType, ContextType>;
  submissionKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BankFeeType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankFeeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankFeeConnection'] = ResolversParentTypes['BankFeeConnection']> = {
  bank?: Resolver<ResolversTypes['BankName'], ParentType, ContextType>;
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  feeSynopsis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  latestSubmission?: Resolver<Maybe<ResolversTypes['Submission']>, ParentType, ContextType>;
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  mailInEligibility?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ConnectionStatus'], ParentType, ContextType>;
  submissions?: Resolver<Maybe<Array<ResolversTypes['Submission']>>, ParentType, ContextType>;
  totalNegotiableFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankFeeSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankFeeSummary'] = ResolversParentTypes['BankFeeSummary']> = {
  coffeeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  feesFound?: Resolver<ResolversTypes['FeeStatusSummary'], ParentType, ContextType>;
  linkedAccounts?: Resolver<Array<ResolversTypes['BankFeeConnection']>, ParentType, ContextType>;
  totalNegotiableFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  totalNegotiatedFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  totalReimbursedFees?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankInterestRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankInterestRate'] = ResolversParentTypes['BankInterestRate']> = {
  currentApy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['BankingProduct'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankInterestRatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankInterestRates'] = ResolversParentTypes['BankInterestRates']> = {
  bankInterestRates?: Resolver<Maybe<Array<ResolversTypes['BankInterestRate']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankInterestRatesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankInterestRatesResult'] = ResolversParentTypes['BankInterestRatesResult']> = {
  __resolveType: TypeResolveFn<'BankInterestRates' | 'BankServiceFailure', ParentType, ContextType>;
};

export type BankMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankMetadata'] = ResolversParentTypes['BankMetadata']> = {
  totals?: Resolver<Maybe<ResolversTypes['BankMetadataTotals']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankMetadataTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankMetadataTotals'] = ResolversParentTypes['BankMetadataTotals']> = {
  oak?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  royalOak?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankServiceFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankServiceFailure'] = ResolversParentTypes['BankServiceFailure']> = {
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retryable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankStatementResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankStatement'] = ResolversParentTypes['BankStatement']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BankStatementType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransaction'] = ResolversParentTypes['BankTransaction']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nachaCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nachaInfo?: Resolver<Maybe<ResolversTypes['BankTransactionNachaInfo']>, ParentType, ContextType>;
  settledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankTransactionStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BankTransactionType'], ParentType, ContextType>;
  typeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  voidedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionConnection'] = ResolversParentTypes['BankTransactionConnection']> = {
  edges?: Resolver<Array<Maybe<ResolversTypes['BankTransactionEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionEdge'] = ResolversParentTypes['BankTransactionEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BankTransaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankTransactionNachaInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionNachaInfo'] = ResolversParentTypes['BankTransactionNachaInfo']> = {
  companyDiscretionaryData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyEntryDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyIdentification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isEarlyDeposit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nachaSettledDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  standardEntryClassCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankingFeatureEligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankingFeatureEligibility'] = ResolversParentTypes['BankingFeatureEligibility']> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['BankingEligibilityReason']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankingKycResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankingKyc'] = ResolversParentTypes['BankingKyc']> = {
  addressVerification?: Resolver<Maybe<ResolversTypes['AddressVerification']>, ParentType, ContextType>;
  identityVerification?: Resolver<Maybe<ResolversTypes['IdentityVerification']>, ParentType, ContextType>;
  kycStatus?: Resolver<Maybe<ResolversTypes['KycStatus']>, ParentType, ContextType>;
  verificationDetails?: Resolver<Maybe<ResolversTypes['VerificationDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankingKycAddressVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankingKycAddressVerification'] = ResolversParentTypes['BankingKycAddressVerification']> = {
  verificationStatus?: Resolver<ResolversTypes['VerificationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankingKycIdentityVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankingKycIdentityVerification'] = ResolversParentTypes['BankingKycIdentityVerification']> = {
  canRetry?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  verificationStatus?: Resolver<ResolversTypes['VerificationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannersErrorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannersErrors'] = ResolversParentTypes['BannersErrors']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannersResponse'] = ResolversParentTypes['BannersResponse']> = {
  __resolveType: TypeResolveFn<'BannersErrors' | 'HelpcenterBannerContent' | 'SiteWideBannerContent', ParentType, ContextType>;
};

export type BasePortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['BasePortfolio'] = ResolversParentTypes['BasePortfolio']> = {
  __resolveType: TypeResolveFn<'Portfolio' | 'SelfDirectedPortfolio', ParentType, ContextType>;
  accountAllocation?: Resolver<ResolversTypes['PortfolioAllocation'], ParentType, ContextType>;
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  customizationLevel?: Resolver<Maybe<ResolversTypes['PortfolioCustomizationLevel']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  portfolioSecurities?: Resolver<Maybe<Array<ResolversTypes['PortfolioSecurity']>>, ParentType, ContextType>;
  portfolioSecurityAllocations?: Resolver<Maybe<Array<ResolversTypes['PortfolioSecurityAllocation']>>, ParentType, ContextType>;
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>;
};

export type BatchAddTierSubscriptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchAddTierSubscriptions'] = ResolversParentTypes['BatchAddTierSubscriptions']> = {
  addedIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  unaddedIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchAddTierSubscriptionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchAddTierSubscriptionsResult'] = ResolversParentTypes['BatchAddTierSubscriptionsResult']> = {
  __resolveType: TypeResolveFn<'BatchAddTierSubscriptions' | 'InvalidTier' | 'InvalidTierPrice', ParentType, ContextType>;
};

export type BeneficiaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Beneficiary'] = ResolversParentTypes['Beneficiary']> = {
  addresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['Address']>>>, ParentType, ContextType>;
  age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  custodianId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  custodianNickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  eligibleForContributionTooltip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['Email']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccount?: Resolver<Maybe<ResolversTypes['InvestmentAccount']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Phone']>>>, ParentType, ContextType>;
  ssnPresent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryAccountExistsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BeneficiaryAccountExistsException'] = ResolversParentTypes['BeneficiaryAccountExistsException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryExceedsAgeLimitExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BeneficiaryExceedsAgeLimitException'] = ResolversParentTypes['BeneficiaryExceedsAgeLimitException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BeneficiaryNotFoundException'] = ResolversParentTypes['BeneficiaryNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitPartnerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitPartnerResponse'] = ResolversParentTypes['BenefitPartnerResponse']> = {
  __resolveType: TypeResolveFn<'ProductNotSupportedException' | 'TaxFilingPartner', ParentType, ContextType>;
};

export type BenefitProductTileResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitProductTile'] = ResolversParentTypes['BenefitProductTile']> = {
  product?: Resolver<ResolversTypes['BenefitsTrackerProducts'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitProductStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitStatus'] = ResolversParentTypes['BenefitStatus']> = {
  benefitProductKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  claimStatus?: Resolver<ResolversTypes['ClaimStatus'], ParentType, ContextType>;
  claimedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<Array<Maybe<ResolversTypes['ClaimStatusDetails']>>>, ParentType, ContextType>;
  expiresOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitTileGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitTileGroup'] = ResolversParentTypes['BenefitTileGroup']> = {
  group?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['BenefitProductTile']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitsMessage'] = ResolversParentTypes['BenefitsMessage']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitsStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitsStatusResponse'] = ResolversParentTypes['BenefitsStatusResponse']> = {
  benefitsStatus?: Resolver<Array<ResolversTypes['BenefitStatus']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BigCurrencyAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BigCurrencyAmount'] = ResolversParentTypes['BigCurrencyAmount']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigDecimalScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigDecimal'], any> {
  name: 'BigDecimal';
}

export type BillingCycleResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingCycle'] = ResolversParentTypes['BillingCycle']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  adhoc?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountCollected?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountOwed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  callbackUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  credits?: Resolver<Array<Maybe<ResolversTypes['Credit']>>, ParentType, ContextType, Partial<BillingCycleCreditsArgs>>;
  endDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  executionAudits?: Resolver<Array<Maybe<ResolversTypes['ExecutionAudit']>>, ParentType, ContextType>;
  extension?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fees?: Resolver<Array<Maybe<ResolversTypes['Fee']>>, ParentType, ContextType, Partial<BillingCycleFeesArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  liquidations?: Resolver<Array<Maybe<ResolversTypes['Liquidation']>>, ParentType, ContextType>;
  nonce?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['BillingCycleState'], ParentType, ContextType>;
  tierSubscription?: Resolver<Maybe<ResolversTypes['TierSubscription']>, ParentType, ContextType>;
  tierSubscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingInvoice'] = ResolversParentTypes['BillingInvoice']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountCollected?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountOwed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  executionMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  invoiceItems?: Resolver<Array<Maybe<ResolversTypes['InvoiceItem']>>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['BillingCycleState'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  vendorIntegrated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingProfile'] = ResolversParentTypes['BillingProfile']> = {
  mightyOakCardWaiver?: Resolver<Maybe<ResolversTypes['MightyOakCardWaiver']>, ParentType, ContextType>;
  provisionalWaiver?: Resolver<Maybe<ResolversTypes['ProvisionalWaiver']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userVerifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waivers?: Resolver<Maybe<Array<ResolversTypes['Waiver']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingProfileNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingProfileNotFoundException'] = ResolversParentTypes['BillingProfileNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingVendorErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingVendorError'] = ResolversParentTypes['BillingVendorError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockDeviceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockDeviceResult'] = ResolversParentTypes['BlockDeviceResult']> = {
  __resolveType: TypeResolveFn<'Device' | 'DeviceNotFoundException', ParentType, ContextType>;
};

export type BlockedEmailDomainExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockedEmailDomainException'] = ResolversParentTypes['BlockedEmailDomainException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bundle'] = ResolversParentTypes['Bundle']> = {
  iconPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['PresentableProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignHistoryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignHistoryConnection'] = ResolversParentTypes['CampaignHistoryConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CampaignHistoryEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ReferralPaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignHistoryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignHistoryEdge'] = ResolversParentTypes['CampaignHistoryEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eligibilityMet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hurdleMet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ReferralCampaignV2'], ParentType, ContextType>;
  numCompletedReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numNonQualifiedReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numPendingReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numQualifiedReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampaignV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignV2'] = ResolversParentTypes['CampaignV2']> = {
  campaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelCheckPaymentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelCheckPaymentResult'] = ResolversParentTypes['CancelCheckPaymentResult']> = {
  __resolveType: TypeResolveFn<'AuthorizationError' | 'CheckPayment' | 'ResourceNotFoundError' | 'UnableToCancelCheckError', ParentType, ContextType>;
};

export type CancelIntentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelIntentResult'] = ResolversParentTypes['CancelIntentResult']> = {
  __resolveType: TypeResolveFn<'Intent' | 'ValidationError', ParentType, ContextType>;
};

export type CancelInvestmentAccountClosureRequestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelInvestmentAccountClosureRequestResult'] = ResolversParentTypes['CancelInvestmentAccountClosureRequestResult']> = {
  __resolveType: TypeResolveFn<'AccountClosedException' | 'AccountNotFoundException' | 'ClosureRequestDoesNotExistException' | 'InvestmentAccount', ParentType, ContextType>;
};

export type CancelInvestmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelInvestmentPayload'] = ResolversParentTypes['CancelInvestmentPayload']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelInvestmentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelInvestmentResult'] = ResolversParentTypes['CancelInvestmentResult']> = {
  __resolveType: TypeResolveFn<'CancelInvestmentPayload' | 'InvestmentNotFoundException' | 'InvestmentUncancellableException', ParentType, ContextType>;
};

export type CancelMoneyAssignmentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelMoneyAssignmentResult'] = ResolversParentTypes['CancelMoneyAssignmentResult']> = {
  __resolveType: TypeResolveFn<'MoneyAssignmentAlreadyTransferredError' | 'MoneyAssignmentNotFoundError' | 'MoneyRulesCancelMoneyAssignmentSuccess', ParentType, ContextType>;
};

export type CancelRecurringTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelRecurringTransferResult'] = ResolversParentTypes['CancelRecurringTransferResult']> = {
  __resolveType: TypeResolveFn<'RecurringTransfer' | 'VersionMismatchException', ParentType, ContextType>;
};

export type CancelTransferPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelTransferPayload'] = ResolversParentTypes['CancelTransferPayload']> = {
  transactionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardDeliveryStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardDeliveryStatus'] = ResolversParentTypes['CardDeliveryStatus']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  picNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PackageStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CardNumberMaskedScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CardNumberMasked'], any> {
  name: 'CardNumberMasked';
}

export type ChallengePointsEarnedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChallengePointsEarned'] = ResolversParentTypes['ChallengePointsEarned']> = {
  challengeID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  earningProgress?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChallengeRateExceededExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChallengeRateExceededException'] = ResolversParentTypes['ChallengeRateExceededException']> = {
  errorCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeOutsideContributionAmountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeOutsideContributionAmountResult'] = ResolversParentTypes['ChangeOutsideContributionAmountResult']> = {
  __resolveType: TypeResolveFn<'ContributionAmountAboveThresholdError' | 'ContributionAmountBelowThresholdError' | 'OutsideContributionCheckoutCart', ParentType, ContextType>;
};

export type ChangePasswordResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangePasswordResult'] = ResolversParentTypes['ChangePasswordResult']> = {
  __resolveType: TypeResolveFn<'ChangePasswordSuccess' | 'IncorrectOldPasswordException' | 'IncorrectSecurityAnswerException' | 'InvalidPasswordException', ParentType, ContextType>;
};

export type ChangePasswordSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangePasswordSuccess'] = ResolversParentTypes['ChangePasswordSuccess']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatActionDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatActionData'] = ResolversParentTypes['ChatActionData']> = {
  apiScope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modelScope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatChoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatChoice'] = ResolversParentTypes['ChatChoice']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['ChatChoiceActionMetadata']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatChoiceActionDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatChoiceActionData'] = ResolversParentTypes['ChatChoiceActionData']> = {
  apiScope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modelScope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatChoiceActionMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatChoiceActionMetadata'] = ResolversParentTypes['ChatChoiceActionMetadata']> = {
  actionData?: Resolver<Maybe<ResolversTypes['ChatChoiceActionData']>, ParentType, ContextType>;
  actionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatChoiceWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatChoiceWidget'] = ResolversParentTypes['ChatChoiceWidget']> = {
  choices?: Resolver<Array<ResolversTypes['ChatChoice']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatDeeplinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatDeeplink'] = ResolversParentTypes['ChatDeeplink']> = {
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryCitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryCitation'] = ResolversParentTypes['ChatHistoryCitation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CitationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryCitationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryCitationV2'] = ResolversParentTypes['ChatHistoryCitationV2']> = {
  __resolveType: TypeResolveFn<'LearnHubCitation' | 'SupportCitation', ParentType, ContextType>;
};

export type ChatHistoryMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessage'] = ResolversParentTypes['ChatHistoryMessage']> = {
  author?: Resolver<ResolversTypes['ChatAuthor'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  canRate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  chatWidgets?: Resolver<Array<ResolversTypes['ChatWidget']>, ParentType, ContextType>;
  citations?: Resolver<Array<ResolversTypes['ChatHistoryCitation']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  customFeedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deeplinks?: Resolver<Array<ResolversTypes['ChatDeeplink']>, ParentType, ContextType>;
  feedbackReason?: Resolver<Maybe<ResolversTypes['MessageFeedbackReason']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['ChatMessageMetadata']>, ParentType, ContextType>;
  originatingMessageId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ragSessionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageBodyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageBody'] = ResolversParentTypes['ChatHistoryMessageBody']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sentAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageCustomFeedbackOutOfBoundsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageCustomFeedbackOutOfBounds'] = ResolversParentTypes['ChatHistoryMessageCustomFeedbackOutOfBounds']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageEdge'] = ResolversParentTypes['ChatHistoryMessageEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChatHistoryMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageError'] = ResolversParentTypes['ChatHistoryMessageError']> = {
  __resolveType: TypeResolveFn<'ChatHistoryMessageCustomFeedbackOutOfBounds' | 'ChatHistoryMessageNotFound' | 'ChatHistoryMessageNotRatable' | 'ChatHistoryMessageRatingFailed' | 'ChatHistoryMessageRatingOutOfBounds' | 'ChatMessageSizeOutOfBounds', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ChatHistoryMessageFooterResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageFooter'] = ResolversParentTypes['ChatHistoryMessageFooter']> = {
  canRate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  chatWidgets?: Resolver<Array<ResolversTypes['ChatWidget']>, ParentType, ContextType>;
  citations?: Resolver<Array<ResolversTypes['ChatHistoryCitation']>, ParentType, ContextType>;
  deeplinks?: Resolver<Array<ResolversTypes['ChatDeeplink']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sentAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageHeaderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageHeader'] = ResolversParentTypes['ChatHistoryMessageHeader']> = {
  author?: Resolver<ResolversTypes['ChatAuthor'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  originatingMessageId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageNotFound'] = ResolversParentTypes['ChatHistoryMessageNotFound']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageNotRatableResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageNotRatable'] = ResolversParentTypes['ChatHistoryMessageNotRatable']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageRatingFailedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageRatingFailed'] = ResolversParentTypes['ChatHistoryMessageRatingFailed']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHistoryMessageRatingOutOfBoundsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHistoryMessageRatingOutOfBounds'] = ResolversParentTypes['ChatHistoryMessageRatingOutOfBounds']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageMetadata'] = ResolversParentTypes['ChatMessageMetadata']> = {
  actionData?: Resolver<Maybe<ResolversTypes['ChatActionData']>, ParentType, ContextType>;
  actionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageSizeOutOfBoundsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageSizeOutOfBounds'] = ResolversParentTypes['ChatMessageSizeOutOfBounds']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageStreamResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageStreamResponse'] = ResolversParentTypes['ChatMessageStreamResponse']> = {
  __resolveType: TypeResolveFn<'ChatHistoryMessage' | 'ChatHistoryMessageBody' | 'ChatHistoryMessageFooter' | 'ChatHistoryMessageHeader', ParentType, ContextType>;
};

export type ChatRedirectResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatRedirect'] = ResolversParentTypes['ChatRedirect']> = {
  conversationCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  conversationContext?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaExpiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatSession'] = ResolversParentTypes['ChatSession']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  originatingContext?: Resolver<Maybe<ResolversTypes['ChatContext']>, ParentType, ContextType>;
  supportedChatFeatures?: Resolver<Array<ResolversTypes['ChatFeatures']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SessionType']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatSessionNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatSessionNotFound'] = ResolversParentTypes['ChatSessionNotFound']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatUnavailableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatUnavailableError'] = ResolversParentTypes['ChatUnavailableError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatWidget'] = ResolversParentTypes['ChatWidget']> = {
  __resolveType: TypeResolveFn<'ChatChoiceWidget' | 'CitationWidget' | 'CustomerSupportChatWidget' | 'DeeplinkWidget', ParentType, ContextType>;
};

export type CheckPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckPayment'] = ResolversParentTypes['CheckPayment']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  canceledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  checkNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  estimatedArrivalAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['CheckPaymentFailureReason']>, ParentType, ContextType>;
  fromAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  memo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientAddress?: Resolver<ResolversTypes['CheckPaymentAddress'], ParentType, ContextType>;
  recipientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckPaymentStatus'], ParentType, ContextType>;
  trackingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckPaymentAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckPaymentAddress'] = ResolversParentTypes['CheckPaymentAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckPaymentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckPaymentConnection'] = ResolversParentTypes['CheckPaymentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CheckPaymentEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckPaymentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckPaymentEdge'] = ResolversParentTypes['CheckPaymentEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CheckPayment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckPaymentRecipientResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckPaymentRecipient'] = ResolversParentTypes['CheckPaymentRecipient']> = {
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckPaymentRecipientAddressTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckPaymentRecipientAddressType'] = ResolversParentTypes['CheckPaymentRecipientAddressType']> = {
  recipient?: Resolver<ResolversTypes['CheckPaymentRecipient'], ParentType, ContextType>;
  recipientAddress?: Resolver<ResolversTypes['CheckPaymentAddress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckingHistorySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckingHistorySummary'] = ResolversParentTypes['CheckingHistorySummary']> = {
  interestEarned?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  moneyIn?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyOut?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CitationWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CitationWidget'] = ResolversParentTypes['CitationWidget']> = {
  citations?: Resolver<Array<ResolversTypes['ChatHistoryCitationV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimStatusDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClaimStatusDetails'] = ResolversParentTypes['ClaimStatusDetails']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['BenefitStatusDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClearSupportSiteCacheResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClearSupportSiteCache'] = ResolversParentTypes['ClearSupportSiteCache']> = {
  eventIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloseAccountReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseAccountReason'] = ResolversParentTypes['CloseAccountReason']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloseBankAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseBankAccountResult'] = ResolversParentTypes['CloseBankAccountResult']> = {
  __resolveType: TypeResolveFn<'BankAccount' | 'BankAccountNotFoundError', ParentType, ContextType>;
};

export type CloseInvestmentAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseInvestmentAccountResult'] = ResolversParentTypes['CloseInvestmentAccountResult']> = {
  __resolveType: TypeResolveFn<'AccountNotFoundException' | 'InvestmentAccount' | 'InvestmentAccountAlreadyClosed' | 'InvestmentAccountClosureInProgress' | 'LaterAccountRequiresTaxWithholdings' | 'LaterAccountRequiresWithdrawalReason' | 'LaterAccountTaxWithholdingsPercentageExceeded' | 'NonBasicAccountOpenException', ParentType, ContextType>;
};

export type CloseUserAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseUserAccountResult'] = ResolversParentTypes['CloseUserAccountResult']> = {
  __resolveType: TypeResolveFn<'OpenAccountsException' | 'UserNotFoundException' | 'User_v2', ParentType, ContextType>;
};

export type ClosureRequestDoesNotExistExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClosureRequestDoesNotExistException'] = ResolversParentTypes['ClosureRequestDoesNotExistException']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClosureRequestExistsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClosureRequestExistsException'] = ResolversParentTypes['ClosureRequestExistsException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CohortEligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CohortEligibility'] = ResolversParentTypes['CohortEligibility']> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CohortEligibilityScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CohortEligibility_V2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CohortEligibility_v2'] = ResolversParentTypes['CohortEligibility_v2']> = {
  cohort?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CombinedPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CombinedPerformance'] = ResolversParentTypes['CombinedPerformance']> = {
  accountValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountValue']>>>, ParentType, ContextType>;
  bondValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  cryptoValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  currentBalance?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  marketChange?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  marketChangePercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketChangePercentWithoutFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketChangeWithoutFees?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  netInvestments?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  stockValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  totalInvested?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  totalInvestedWithPending?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompleteCheckDepositPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompleteCheckDepositPayload'] = ResolversParentTypes['CompleteCheckDepositPayload']> = {
  sessionToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompleteFunnelOnboardingResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompleteFunnelOnboardingResult'] = ResolversParentTypes['CompleteFunnelOnboardingResult']> = {
  __resolveType: TypeResolveFn<'RegistrationFunnel' | 'UnmetRequirementsException', ParentType, ContextType>;
};

export type CompletedQuizResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompletedQuiz'] = ResolversParentTypes['CompletedQuiz']> = {
  communityAvgPercents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  correctQuestions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalQuestions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userScorePercents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigureSplitDepositDirectDepositIntentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentPayload'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositIntentPayload']> = {
  intent?: Resolver<ResolversTypes['SplitDepositDirectDepositIntentSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigureSplitDepositDirectDepositSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingPayload'] = ResolversParentTypes['ConfigureSplitDepositDirectDepositSettingPayload']> = {
  setting?: Resolver<ResolversTypes['SplitDepositDirectDepositSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectAchAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectACHAccountResult'] = ResolversParentTypes['ConnectACHAccountResult']> = {
  __resolveType: TypeResolveFn<'ConnectACHAccountSucceeded' | 'InstitutionNotSupportedError', ParentType, ContextType>;
};

export type ConnectAchAccountSucceededResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectACHAccountSucceeded'] = ResolversParentTypes['ConnectACHAccountSucceeded']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionSummary'] = ResolversParentTypes['ConnectionSummary']> = {
  connections?: Resolver<Maybe<Array<ResolversTypes['BankConnection']>>, ParentType, ContextType>;
  totalEligibleFeeCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalEligibleFees?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  totalEligibleFeesForUser?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  userEligibility?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsumeUserTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConsumeUserTokenResult'] = ResolversParentTypes['ConsumeUserTokenResult']> = {
  __resolveType: TypeResolveFn<'InvalidUserTokenException' | 'UserToken', ParentType, ContextType>;
};

export type ContactCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactCategory'] = ResolversParentTypes['ContactCategory']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subcategories?: Resolver<Maybe<Array<ResolversTypes['ContactSubcategory']>>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactFaqResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactFaq'] = ResolversParentTypes['ContactFaq']> = {
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactFormAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactFormAlert'] = ResolversParentTypes['ContactFormAlert']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactSubcategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactSubcategory'] = ResolversParentTypes['ContactSubcategory']> = {
  chatEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  faqs?: Resolver<Array<ResolversTypes['ContactFaq']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['SubcategoryMessage']>, ParentType, ContextType>;
  phoneEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentPreviewConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentPreviewConnection'] = ResolversParentTypes['ContentPreviewConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ContentPreviewEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['LearnPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentPreviewEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentPreviewEdge'] = ResolversParentTypes['ContentPreviewEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['LearnContentPreview'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionAbilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionAbility'] = ResolversParentTypes['ContributionAbility']> = {
  canContribute?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  planLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  remaining?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yearToDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionAbilityByYearResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionAbilityByYear'] = ResolversParentTypes['ContributionAbilityByYear']> = {
  contributionAbilities?: Resolver<Maybe<Array<ResolversTypes['ContributionAbility']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionActionRequiredErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionActionRequiredError'] = ResolversParentTypes['ContributionActionRequiredError']> = {
  paymentIntentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  redirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAction?: Resolver<ResolversTypes['ContributionRequiredAction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionAmountAboveThresholdErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionAmountAboveThresholdError'] = ResolversParentTypes['ContributionAmountAboveThresholdError']> = {
  maximumThresholdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionAmountBelowThresholdErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionAmountBelowThresholdError'] = ResolversParentTypes['ContributionAmountBelowThresholdError']> = {
  minimumThresholdAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionCardDeclinedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionCardDeclinedError'] = ResolversParentTypes['ContributionCardDeclinedError']> = {
  paymentIntentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionHistoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionHistoryItem'] = ResolversParentTypes['ContributionHistoryItem']> = {
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContributionInvalidOwnerEmailErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionInvalidOwnerEmailError'] = ResolversParentTypes['ContributionInvalidOwnerEmailError']> = {
  providedEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreAchSubscriptionFeeItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreACHSubscriptionFeeItem'] = ResolversParentTypes['CoreACHSubscriptionFeeItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreAccountAlreadyExistsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreAccountAlreadyExistsException'] = ResolversParentTypes['CoreAccountAlreadyExistsException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreAccountClosedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreAccountClosedException'] = ResolversParentTypes['CoreAccountClosedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreAdjustmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreAdjustmentItem'] = ResolversParentTypes['CoreAdjustmentItem']> = {
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreCashForwardItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreCashForwardItem'] = ResolversParentTypes['CoreCashForwardItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  relatedMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreCollectionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreCollectionItem'] = ResolversParentTypes['CoreCollectionItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreDebtCollectionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreDebtCollectionItem'] = ResolversParentTypes['CoreDebtCollectionItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreDividendsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreDividendsItem'] = ResolversParentTypes['CoreDividendsItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  etfCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  etfTicker?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreEmployeeCreditItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreEmployeeCreditItem'] = ResolversParentTypes['CoreEmployeeCreditItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreFeeInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreFeeInvestmentItem'] = ResolversParentTypes['CoreFeeInvestmentItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreFoundMoneyRewardItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreFoundMoneyRewardItem'] = ResolversParentTypes['CoreFoundMoneyRewardItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreGiftCardCreditRedemptionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreGiftCardCreditRedemptionItem'] = ResolversParentTypes['CoreGiftCardCreditRedemptionItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreHoldingsTransferInItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreHoldingsTransferInItem'] = ResolversParentTypes['CoreHoldingsTransferInItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreInvestmentItem'] = ResolversParentTypes['CoreInvestmentItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCombinedInvestment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreLocalFoundMoneyItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreLocalFoundMoneyItem'] = ResolversParentTypes['CoreLocalFoundMoneyItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CorePartnerRewardItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorePartnerRewardItem'] = ResolversParentTypes['CorePartnerRewardItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreRebalanceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreRebalanceItem'] = ResolversParentTypes['CoreRebalanceItem']> = {
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreReferralRewardItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreReferralRewardItem'] = ResolversParentTypes['CoreReferralRewardItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreRefundedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreRefundedItem'] = ResolversParentTypes['CoreRefundedItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreReinvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreReinvestmentItem'] = ResolversParentTypes['CoreReinvestmentItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreRoundUpsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreRoundUpsItem'] = ResolversParentTypes['CoreRoundUpsItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  isCombinedInvestment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  multiplier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  transactionAmount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RoundUpType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoreWithdrawalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreWithdrawalItem'] = ResolversParentTypes['CoreWithdrawalItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Course'] = ResolversParentTypes['Course']> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  learnProductKey?: Resolver<Maybe<ResolversTypes['LearnProductKey']>, ParentType, ContextType>;
  lessons?: Resolver<Array<ResolversTypes['Lesson']>, ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['LearnTag']>, ParentType, ContextType>;
  theme?: Resolver<ResolversTypes['CourseTheme'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseLocked'] = ResolversParentTypes['CourseLocked']> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lessons?: Resolver<Array<ResolversTypes['Lesson']>, ParentType, ContextType>;
  numLessons?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  theme?: Resolver<ResolversTypes['CourseTheme'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoursePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoursePreview'] = ResolversParentTypes['CoursePreview']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  courseTheme?: Resolver<ResolversTypes['CourseTheme'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  numberOfLessons?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>;
  relatedQuizProgress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>;
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoursePreviewLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoursePreviewLocked'] = ResolversParentTypes['CoursePreviewLocked']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  courseTheme?: Resolver<ResolversTypes['CourseTheme'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  lockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfLessons?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseThemeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseTheme'] = ResolversParentTypes['CourseTheme']> = {
  __resolveType: TypeResolveFn<'LearnThemeLiteral', ParentType, ContextType>;
};

export type CreateAuthProfileResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAuthProfileResult'] = ResolversParentTypes['CreateAuthProfileResult']> = {
  __resolveType: TypeResolveFn<'AuthProfile' | 'AuthProfileAlreadyExistsException', ParentType, ContextType>;
};

export type CreateBankAccountPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBankAccountPayload'] = ResolversParentTypes['CreateBankAccountPayload']> = {
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateBeneficiaryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBeneficiaryResult'] = ResolversParentTypes['CreateBeneficiaryResult']> = {
  __resolveType: TypeResolveFn<'Beneficiary' | 'BeneficiaryExceedsAgeLimitException' | 'InternalErrorException' | 'InvalidDateOfBirthException' | 'InvalidFirstNameException' | 'InvalidLastNameException', ParentType, ContextType>;
};

export type CreateDelegateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDelegateResult'] = ResolversParentTypes['CreateDelegateResult']> = {
  __resolveType: TypeResolveFn<'DelegateDefinition', ParentType, ContextType>;
};

export type CreateDirectDepositLinkInfoFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDirectDepositLinkInfoFailure'] = ResolversParentTypes['CreateDirectDepositLinkInfoFailure']> = {
  failureMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDirectDepositLinkInfoPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDirectDepositLinkInfoPayload'] = ResolversParentTypes['CreateDirectDepositLinkInfoPayload']> = {
  results?: Resolver<ResolversTypes['CreatePinwheelLinkToken'], ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDirectDepositLinkInfoSwitchResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDirectDepositLinkInfoSwitch'] = ResolversParentTypes['CreateDirectDepositLinkInfoSwitch']> = {
  __resolveType: TypeResolveFn<'CreateDirectDepositLinkInfoFailure' | 'CreateDirectDepositLinkInfoPayload', ParentType, ContextType>;
};

export type CreateDocumentUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDocumentUpload'] = ResolversParentTypes['CreateDocumentUpload']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  requestedDocumentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateImplicitTokenForUserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateImplicitTokenForUserResult'] = ResolversParentTypes['CreateImplicitTokenForUserResult']> = {
  __resolveType: TypeResolveFn<'ImplicitToken' | 'InvalidOauthAppClientIdException' | 'OauthAppNotFoundException', ParentType, ContextType>;
};

export type CreateIntentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateIntentResult'] = ResolversParentTypes['CreateIntentResult']> = {
  __resolveType: TypeResolveFn<'Intent' | 'ValidationError', ParentType, ContextType>;
};

export type CreateInvestingStrategyRecommendationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateInvestingStrategyRecommendationResult'] = ResolversParentTypes['CreateInvestingStrategyRecommendationResult']> = {
  __resolveType: TypeResolveFn<'BadRequestError' | 'RecommendedInvestingStrategy', ParentType, ContextType>;
};

export type CreateInvestmentAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateInvestmentAccountResponse'] = ResolversParentTypes['CreateInvestmentAccountResponse']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  iraType?: Resolver<ResolversTypes['InvestmentAccountTypes'], ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateJobAlertResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateJobAlertResult'] = ResolversParentTypes['CreateJobAlertResult']> = {
  __resolveType: TypeResolveFn<'JobAlert', ParentType, ContextType>;
};

export type CreateOauthAppResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOauthAppResult'] = ResolversParentTypes['CreateOauthAppResult']> = {
  __resolveType: TypeResolveFn<'OauthApp', ParentType, ContextType>;
};

export type CreateOfferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOfferResult'] = ResolversParentTypes['CreateOfferResult']> = {
  __resolveType: TypeResolveFn<'Offer', ParentType, ContextType>;
};

export type CreateOutsideContributionCheckoutCartResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOutsideContributionCheckoutCartResult'] = ResolversParentTypes['CreateOutsideContributionCheckoutCartResult']> = {
  __resolveType: TypeResolveFn<'ContributionAmountAboveThresholdError' | 'ContributionAmountBelowThresholdError' | 'OutsideContributionCheckoutCart', ParentType, ContextType>;
};

export type CreateOutsideContributionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOutsideContributionResult'] = ResolversParentTypes['CreateOutsideContributionResult']> = {
  __resolveType: TypeResolveFn<'ContributionActionRequiredError' | 'ContributionCardDeclinedError' | 'ContributionInvalidOwnerEmailError' | 'OutsideContribution', ParentType, ContextType>;
};

export type CreatePinwheelLinkTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePinwheelLinkToken'] = ResolversParentTypes['CreatePinwheelLinkToken']> = {
  expires?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatePromoCodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePromoCodeResult'] = ResolversParentTypes['CreatePromoCodeResult']> = {
  __resolveType: TypeResolveFn<'DuplicatePromoCodeError' | 'PromoCode' | 'PromoCodeFieldLengthError', ParentType, ContextType>;
};

export type CreatePromoCodeRewardResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePromoCodeRewardResult'] = ResolversParentTypes['CreatePromoCodeRewardResult']> = {
  __resolveType: TypeResolveFn<'DuplicatePromoCodeRewardError' | 'PromoCodeReward', ParentType, ContextType>;
};

export type CreateProspectUserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateProspectUserResult'] = ResolversParentTypes['CreateProspectUserResult']> = {
  __resolveType: TypeResolveFn<'GrowProspect' | 'InternalErrorException' | 'LaterWaitlistProspect' | 'OutsideContributionProspect' | 'User_v2', ParentType, ContextType>;
};

export type CreateReferralCampaignResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateReferralCampaignResult'] = ResolversParentTypes['CreateReferralCampaignResult']> = {
  __resolveType: TypeResolveFn<'ReferralCampaignV2', ParentType, ContextType>;
};

export type CreateReferralCampaignRewardResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateReferralCampaignRewardResult'] = ResolversParentTypes['CreateReferralCampaignRewardResult']> = {
  __resolveType: TypeResolveFn<'ReferralCampaignReward', ParentType, ContextType>;
};

export type CreateReferralPayoutResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateReferralPayoutResult'] = ResolversParentTypes['CreateReferralPayoutResult']> = {
  __resolveType: TypeResolveFn<'ReferralPayout' | 'ReferralPayoutExistsError', ParentType, ContextType>;
};

export type CreateReferralRelationshipResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateReferralRelationshipResult'] = ResolversParentTypes['CreateReferralRelationshipResult']> = {
  __resolveType: TypeResolveFn<'InvalidReferralRelationship' | 'ReferralRelationship', ParentType, ContextType>;
};

export type CreateRefundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateRefundError'] = ResolversParentTypes['CreateRefundError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateRefundResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateRefundResult'] = ResolversParentTypes['CreateRefundResult']> = {
  __resolveType: TypeResolveFn<'BillingInvoice' | 'CreateRefundError' | 'VendorIntegrationError' | 'VendorRefundInvoiceError', ParentType, ContextType>;
};

export type CreateSavingsAccountPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSavingsAccountPayload'] = ResolversParentTypes['CreateSavingsAccountPayload']> = {
  bankAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSavingsAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSavingsAccountResult'] = ResolversParentTypes['CreateSavingsAccountResult']> = {
  __resolveType: TypeResolveFn<'CreateSavingsAccountPayload' | 'CreateSavingsAccountVerificationError', ParentType, ContextType>;
};

export type CreateSavingsAccountVerificationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSavingsAccountVerificationError'] = ResolversParentTypes['CreateSavingsAccountVerificationError']> = {
  notEligibleReasons?: Resolver<Array<ResolversTypes['SavingsAccountEligibilityRequirement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateScopeExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateScopeException'] = ResolversParentTypes['CreateScopeException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateScopeResult'] = ResolversParentTypes['CreateScopeResult']> = {
  __resolveType: TypeResolveFn<'CreateScopeException' | 'Scope', ParentType, ContextType>;
};

export type CreateSubscriptionMigrationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSubscriptionMigrationResult'] = ResolversParentTypes['CreateSubscriptionMigrationResult']> = {
  __resolveType: TypeResolveFn<'SubscriptionMigration', ParentType, ContextType>;
};

export type CreateUploadUrlResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUploadUrlResult'] = ResolversParentTypes['CreateUploadUrlResult']> = {
  __resolveType: TypeResolveFn<'UploadUrl', ParentType, ContextType>;
};

export type CreateUserProfileResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserProfileResult'] = ResolversParentTypes['CreateUserProfileResult']> = {
  __resolveType: TypeResolveFn<'MissingAgreementsException' | 'User' | 'UserExistsException' | 'UserNotUSResidentException', ParentType, ContextType>;
};

export type CreateVendorInvoiceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateVendorInvoiceResult'] = ResolversParentTypes['CreateVendorInvoiceResult']> = {
  __resolveType: TypeResolveFn<'BillingVendorError' | 'InvoiceCollection', ParentType, ContextType>;
};

export type CreateVendorLineItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateVendorLineItemResult'] = ResolversParentTypes['CreateVendorLineItemResult']> = {
  __resolveType: TypeResolveFn<'BillingVendorError' | 'InvoiceLineItem', ParentType, ContextType>;
};

export type CredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Credentials'] = ResolversParentTypes['Credentials']> = {
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditResolvers<ContextType = any, ParentType extends ResolversParentTypes['Credit'] = ResolversParentTypes['Credit']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  assessedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCycle?: Resolver<ResolversTypes['BillingCycle'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  discountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Cta'] = ResolversParentTypes['Cta']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CtaType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyAmount'] = ResolversParentTypes['CurrencyAmount']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyMilestoneProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyMilestoneProgress'] = ResolversParentTypes['CurrencyMilestoneProgress']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  currentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  targetAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentBankStatementNotProvidedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentBankStatementNotProvided'] = ResolversParentTypes['CurrentBankStatementNotProvided']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomFieldOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomFieldOption'] = ResolversParentTypes['CustomFieldOption']> = {
  default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  raw_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAccount'] = ResolversParentTypes['CustomerAccount']> = {
  balance?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  beneficiary?: Resolver<Maybe<ResolversTypes['Beneficiary']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  customerAccountsByTransferAction?: Resolver<Array<Maybe<ResolversTypes['CustomerAccount']>>, ParentType, ContextType, RequireFields<CustomerAccountCustomerAccountsByTransferActionArgs, 'transferAction'>>;
  customerNotice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['FinancialInstitution']>, ParentType, ContextType>;
  isDepositAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isWithdrawalAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mask?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CustomerAccountStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAccountClosureResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAccountClosure'] = ResolversParentTypes['CustomerAccountClosure']> = {
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  closureState?: Resolver<ResolversTypes['CustomerAccountClosureState'], ParentType, ContextType>;
  requestedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  requestedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  workflowId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAgreementRequiredExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAgreementRequiredException'] = ResolversParentTypes['CustomerAgreementRequiredException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAcceptanceDocumentTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerEarnOnboardingMilestoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerEarnOnboardingMilestone'] = ResolversParentTypes['CustomerEarnOnboardingMilestone']> = {
  badgeText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  completionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  completionTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  primaryCta?: Resolver<ResolversTypes['EarnOnboardingMilestoneCta'], ParentType, ContextType>;
  reward?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  secondaryCta?: Resolver<Maybe<ResolversTypes['EarnOnboardingMilestoneCta']>, ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerEarnOnboardingProgramResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerEarnOnboardingProgram'] = ResolversParentTypes['CustomerEarnOnboardingProgram']> = {
  __resolveType: TypeResolveFn<'CustomerEarnOnboardingProgramControl' | 'CustomerEarnOnboardingProgramFeature', ParentType, ContextType>;
};

export type CustomerEarnOnboardingProgramControlResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerEarnOnboardingProgramControl'] = ResolversParentTypes['CustomerEarnOnboardingProgramControl']> = {
  experimentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  variantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerEarnOnboardingProgramFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerEarnOnboardingProgramFeature'] = ResolversParentTypes['CustomerEarnOnboardingProgramFeature']> = {
  activePeriodDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  closeAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  closurePeriodDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  completionLogoUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  completionTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  experiment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  milestones?: Resolver<Array<ResolversTypes['CustomerEarnOnboardingMilestone']>, ParentType, ContextType>;
  primaryCta?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CustomerEarnOnboardingStatus'], ParentType, ContextType>;
  subTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  termsLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerMoneyRulesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerMoneyRulesResult'] = ResolversParentTypes['CustomerMoneyRulesResult']> = {
  __resolveType: TypeResolveFn<'CustomerMoneyRulesResultSuccess' | 'MoneyRulesRulesetNotFoundException', ParentType, ContextType>;
};

export type CustomerMoneyRulesResultSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerMoneyRulesResultSuccess'] = ResolversParentTypes['CustomerMoneyRulesResultSuccess']> = {
  resultingRuleset?: Resolver<ResolversTypes['MoneyRulesRuleset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerSupportChatWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerSupportChatWidget'] = ResolversParentTypes['CustomerSupportChatWidget']> = {
  chatRedirect?: Resolver<Maybe<ResolversTypes['ChatRedirect']>, ParentType, ContextType>;
  emailRedirect?: Resolver<Maybe<ResolversTypes['EmailRedirect']>, ParentType, ContextType>;
  phoneRedirect?: Resolver<Maybe<ResolversTypes['PhoneRedirect']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeactivateBeneficiaryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateBeneficiaryResult'] = ResolversParentTypes['DeactivateBeneficiaryResult']> = {
  __resolveType: TypeResolveFn<'Beneficiary' | 'BeneficiaryNotFoundException' | 'InternalErrorException', ParentType, ContextType>;
};

export type DeactivateOauthAppClientResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateOauthAppClientResult'] = ResolversParentTypes['DeactivateOauthAppClientResult']> = {
  __resolveType: TypeResolveFn<'OauthAppClient' | 'OauthAppClientNotFoundException', ParentType, ContextType>;
};

export type DeactivateOauthAppResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateOauthAppResult'] = ResolversParentTypes['DeactivateOauthAppResult']> = {
  __resolveType: TypeResolveFn<'OauthApp' | 'OauthAppNotFoundException', ParentType, ContextType>;
};

export type DeactivateTierSubscriptionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateTierSubscriptionResult'] = ResolversParentTypes['DeactivateTierSubscriptionResult']> = {
  __resolveType: TypeResolveFn<'TierSubscription' | 'TierSubscriptionAlreadyDeactivated', ParentType, ContextType>;
};

export type DeeplinkWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeeplinkWidget'] = ResolversParentTypes['DeeplinkWidget']> = {
  deeplinks?: Resolver<Array<ResolversTypes['ChatDeeplink']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DelegateDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DelegateDefinition'] = ResolversParentTypes['DelegateDefinition']> = {
  departmentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  qualifiedHostName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDelegateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteDelegateResult'] = ResolversParentTypes['DeleteDelegateResult']> = {
  __resolveType: TypeResolveFn<'DeleteDelegateResultTemporaryImpl', ParentType, ContextType>;
};

export type DeleteDelegateResultTemporaryImplResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteDelegateResultTemporaryImpl'] = ResolversParentTypes['DeleteDelegateResultTemporaryImpl']> = {
  someField?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteExpiredBankCardOrderCardTierNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderCardTierNotFoundError'] = ResolversParentTypes['DeleteExpiredBankCardOrderCardTierNotFoundError']> = {
  failureMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteExpiredBankCardOrderNotExpiredErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderNotExpiredError'] = ResolversParentTypes['DeleteExpiredBankCardOrderNotExpiredError']> = {
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteExpiredBankCardOrderNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderNotFoundError'] = ResolversParentTypes['DeleteExpiredBankCardOrderNotFoundError']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteExpiredBankCardOrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteExpiredBankCardOrderResult'] = ResolversParentTypes['DeleteExpiredBankCardOrderResult']> = {
  __resolveType: TypeResolveFn<'BankCardOrder' | 'DeleteExpiredBankCardOrderCardTierNotFoundError' | 'DeleteExpiredBankCardOrderNotExpiredError' | 'DeleteExpiredBankCardOrderNotFoundError', ParentType, ContextType>;
};

export type DeleteOauthAppResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOauthAppResult'] = ResolversParentTypes['DeleteOauthAppResult']> = {
  __resolveType: TypeResolveFn<'DeleteOauthAppSuccess' | 'OauthAppNotFoundException', ParentType, ContextType>;
};

export type DeleteOauthAppSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOauthAppSuccess'] = ResolversParentTypes['DeleteOauthAppSuccess']> = {
  oauthAppId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteScopeSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteScopeSuccess'] = ResolversParentTypes['DeleteScopeSuccess']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTrustedContactResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteTrustedContactResult'] = ResolversParentTypes['DeleteTrustedContactResult']> = {
  __resolveType: TypeResolveFn<'InternalErrorException' | 'TrustedContact' | 'TrustedContactNotFoundException', ParentType, ContextType>;
};

export type DepositRiskFactorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DepositRiskFactor'] = ResolversParentTypes['DepositRiskFactor']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<Array<ResolversTypes['DepositField']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RiskStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeregisterAuthenticatorResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeregisterAuthenticatorResult'] = ResolversParentTypes['DeregisterAuthenticatorResult']> = {
  __resolveType: TypeResolveFn<'AuthenticatorNotFoundException' | 'EmailAuthenticator' | 'PhoneAuthenticator', ParentType, ContextType>;
};

export type DesignLibraryIconResolvers<ContextType = any, ParentType extends ResolversParentTypes['DesignLibraryIcon'] = ResolversParentTypes['DesignLibraryIcon']> = {
  icon?: Resolver<ResolversTypes['IconType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DestinationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Destination'] = ResolversParentTypes['Destination']> = {
  deepLink?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  labelKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Device'] = ResolversParentTypes['Device']> = {
  appVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockTrigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deviceAdid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstLoginAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  hasActiveSession?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isBlocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastLoginAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceBlockedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceBlockedException'] = ResolversParentTypes['DeviceBlockedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceNotFoundException'] = ResolversParentTypes['DeviceNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DigitalWalletDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DigitalWalletDevice'] = ResolversParentTypes['DigitalWalletDevice']> = {
  deviceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceType?: Resolver<ResolversTypes['DigitalWalletDeviceType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DigitalWalletTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['DigitalWalletToken'] = ResolversParentTypes['DigitalWalletToken']> = {
  device?: Resolver<ResolversTypes['DigitalWalletDevice'], ParentType, ContextType>;
  isDeviceProvisioned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tokenStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectDepositInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectDepositInfo'] = ResolversParentTypes['DirectDepositInfo']> = {
  status?: Resolver<ResolversTypes['DirectDepositStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectDepositInfoPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectDepositInfoPayload'] = ResolversParentTypes['DirectDepositInfoPayload']> = {
  info?: Resolver<Maybe<ResolversTypes['DirectDepositInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectDepositStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectDepositState'] = ResolversParentTypes['DirectDepositState']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  switchMethod?: Resolver<ResolversTypes['SwitchMethod'], ParentType, ContextType>;
  switchState?: Resolver<ResolversTypes['SwitchState'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectDepositStatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectDepositStatePayload'] = ResolversParentTypes['DirectDepositStatePayload']> = {
  state?: Resolver<Maybe<ResolversTypes['DirectDepositState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscreteMilestoneProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscreteMilestoneProgress'] = ResolversParentTypes['DiscreteMilestoneProgress']> = {
  currentInt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  targetInt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DismissMessagesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissMessagesResult'] = ResolversParentTypes['DismissMessagesResult']> = {
  __resolveType: TypeResolveFn<'DismissMessagesSuccess' | 'UpdateMessagesFailure', ParentType, ContextType>;
};

export type DismissMessagesSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissMessagesSuccess'] = ResolversParentTypes['DismissMessagesSuccess']> = {
  dismissedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionAmountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionAmounts'] = ResolversParentTypes['DistributionAmounts']> = {
  investment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  retirement?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  savings?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiversificationBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiversificationBucket'] = ResolversParentTypes['DiversificationBucket']> = {
  bucketName?: Resolver<ResolversTypes['DiversificationBucketType'], ParentType, ContextType>;
  minDiversificationScoreThreshold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiversificationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiversificationInfo'] = ResolversParentTypes['DiversificationInfo']> = {
  diversificationBuckets?: Resolver<Array<ResolversTypes['DiversificationBucket']>, ParentType, ContextType>;
  securityDiversificationInfo?: Resolver<Array<ResolversTypes['SecurityDiversificationInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = {
  uploadedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentNotFound'] = ResolversParentTypes['DocumentNotFound']> = {
  documentType?: Resolver<ResolversTypes['AcceptanceDocumentType'], ParentType, ContextType>;
  documentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRequest'] = ResolversParentTypes['DocumentRequest']> = {
  acceptedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  canceledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  documentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<ResolversTypes['Document']>>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parentRequest?: Resolver<Maybe<ResolversTypes['DocumentRequest']>, ParentType, ContextType>;
  parentRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  rejectedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rejectedNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectedReason?: Resolver<Maybe<ResolversTypes['RejectedReason']>, ParentType, ContextType>;
  requestKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestedFileCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requesterId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DocumentStatus'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRequestEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRequestEdge'] = ResolversParentTypes['DocumentRequestEdge']> = {
  node?: Resolver<Maybe<ResolversTypes['DocumentRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRequestsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRequestsConnection'] = ResolversParentTypes['DocumentRequestsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DocumentRequestEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['DocumentRequestsPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRequestsPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRequestsPageInfo'] = ResolversParentTypes['DocumentRequestsPageInfo']> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNext?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentUploadSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentUploadSession'] = ResolversParentTypes['DocumentUploadSession']> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentUploadsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentUploads'] = ResolversParentTypes['DocumentUploads']> = {
  uploadDocuments?: Resolver<Array<ResolversTypes['LegacyUploadDocument']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentVerification'] = ResolversParentTypes['DocumentVerification']> = {
  decision?: Resolver<ResolversTypes['DocumentVerificationDecision'], ParentType, ContextType>;
  outstandingIssues?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  verificationCriteriaMet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateActionErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateActionError'] = ResolversParentTypes['DuplicateActionError']> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicateBillingInfoErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateBillingInfoError'] = ResolversParentTypes['DuplicateBillingInfoError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicatePromoCodeErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicatePromoCodeError'] = ResolversParentTypes['DuplicatePromoCodeError']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuplicatePromoCodeRewardErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicatePromoCodeRewardError'] = ResolversParentTypes['DuplicatePromoCodeRewardError']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PromoCodeRewardType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EtfResolvers<ContextType = any, ParentType extends ResolversParentTypes['ETF'] = ResolversParentTypes['ETF']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  annualHigh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  annualLow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currentPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  holdings?: Resolver<Maybe<Array<ResolversTypes['Holding']>>, ParentType, ContextType>;
  investmentCategories?: Resolver<ResolversTypes['InvestmentCategory'], ParentType, ContextType>;
  lastClosePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  netAssets?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  openPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ownedShares?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['ETFPerformance'], ParentType, ContextType, RequireFields<EtfPerformanceArgs, 'timescale' | 'timespan'>>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceRangeOverWeek?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  volume?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ytdReturn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ytdReturnPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EtfGainResolvers<ContextType = any, ParentType extends ResolversParentTypes['ETFGain'] = ResolversParentTypes['ETFGain']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EtfPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ETFPerformance'] = ResolversParentTypes['ETFPerformance']> = {
  gain?: Resolver<Maybe<ResolversTypes['ETFGain']>, ParentType, ContextType>;
  prices?: Resolver<Maybe<Array<ResolversTypes['ETFPrice']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EtfPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ETFPrice'] = ResolversParentTypes['ETFPrice']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyAccountStateRegulationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyAccountStateRegulation'] = ResolversParentTypes['EarlyAccountStateRegulation']> = {
  accountType?: Resolver<ResolversTypes['EarlyInvestmentAccountType'], ParentType, ContextType>;
  defaultAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxAge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minAge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stateCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyAccountStateRegulationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyAccountStateRegulationResult'] = ResolversParentTypes['EarlyAccountStateRegulationResult']> = {
  __resolveType: TypeResolveFn<'EarlyAccountStateRegulation' | 'InternalErrorException' | 'InvalidStateException' | 'UserNotFoundException', ParentType, ContextType>;
};

export type EarlyAccountTransferInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyAccountTransferInfo'] = ResolversParentTypes['EarlyAccountTransferInfo']> = {
  stateCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  terminationAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  terminationDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyDebtCollectionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyDebtCollectionItem'] = ResolversParentTypes['EarlyDebtCollectionItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyDividendsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyDividendsItem'] = ResolversParentTypes['EarlyDividendsItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  etfCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  etfTicker?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyFeeInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyFeeInvestmentItem'] = ResolversParentTypes['EarlyFeeInvestmentItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyGiftItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyGiftItem'] = ResolversParentTypes['EarlyGiftItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyHistorySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyHistorySummary'] = ResolversParentTypes['EarlyHistorySummary']> = {
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  earlyInvestMatches?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  giftsReceived?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyIn?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyOut?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyInvestmentItem'] = ResolversParentTypes['EarlyInvestmentItem']> = {
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyMatchItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyMatchItem'] = ResolversParentTypes['EarlyMatchItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyMatchRemovalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyMatchRemovalItem'] = ResolversParentTypes['EarlyMatchRemovalItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyRefundedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyRefundedItem'] = ResolversParentTypes['EarlyRefundedItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyReinvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyReinvestmentItem'] = ResolversParentTypes['EarlyReinvestmentItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarlyWithdrawalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarlyWithdrawalItem'] = ResolversParentTypes['EarlyWithdrawalItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnCtaRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnCTARecord'] = ResolversParentTypes['EarnCTARecord']> = {
  ctaDates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Date']>>>, ParentType, ContextType>;
  devicePlatform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnMissingCreditRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnMissingCreditRequest'] = ResolversParentTypes['EarnMissingCreditRequest']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  extensionMerchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['EarnPurchaseMethod'], ParentType, ContextType>;
  orderNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  proofOfPurchaseUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  purchaseDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  subTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnMissingCreditRequestPurchaseDateErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnMissingCreditRequestPurchaseDateError'] = ResolversParentTypes['EarnMissingCreditRequestPurchaseDateError']> = {
  maxDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnOfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnOffer'] = ResolversParentTypes['EarnOffer']> = {
  affiliateCategoryList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  affiliateCategoryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundColorHex?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  backgroundImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  badgeCategory?: Resolver<Maybe<ResolversTypes['BadgeCategory']>, ParentType, ContextType>;
  campaignDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  campaignOfferId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  colorBackgroundLogoImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  colorImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  ctaDetails?: Resolver<ResolversTypes['EarnOfferCtaDetails'], ParentType, ContextType>;
  dealType?: Resolver<Maybe<ResolversTypes['DealType']>, ParentType, ContextType>;
  desktopBackgroundImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  details?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  devicePlatforms?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  displayBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displaySubtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  exclusions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  favoriteRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  featuredCategoryOffer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  featuredCategoryOfferRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  incentiveAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  incentiveRate?: Resolver<Maybe<ResolversTypes['EarnOfferIncentiveRate']>, ParentType, ContextType>;
  incentiveSummary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  incentiveType?: Resolver<Maybe<ResolversTypes['EarnOfferIncentiveType']>, ParentType, ContextType>;
  isFavorite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  keyphraseCategoryNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  merchantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ownerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  promoted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  promotionRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  termsAndConditionsUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visibilityEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibilityStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webviewEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnOfferCtaDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnOfferCtaDetails'] = ResolversParentTypes['EarnOfferCtaDetails']> = {
  android?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buttonUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chromeExt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  internallyRouted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ios?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notificationTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  repeatTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userMetadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  web?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnOfferQueryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnOfferQueryPage'] = ResolversParentTypes['EarnOfferQueryPage']> = {
  earnOffers?: Resolver<Array<ResolversTypes['EarnOffer']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['EarnPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnOnboardingMilestoneCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnOnboardingMilestoneCta'] = ResolversParentTypes['EarnOnboardingMilestoneCta']> = {
  destination?: Resolver<ResolversTypes['EarnOnboardingMilestoneCtaType'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnPageInfo'] = ResolversParentTypes['EarnPageInfo']> = {
  endCursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnReward'] = ResolversParentTypes['EarnReward']> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  colorBackgroundLogoImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedFulfilledAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fulfilledAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fulfillmentType?: Resolver<ResolversTypes['EarnRewardFulfillmentType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  incentiveAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  investmentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  linked?: Resolver<Maybe<Array<ResolversTypes['EarnReward']>>, ParentType, ContextType>;
  originationDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['EarnRewardStatus']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EarnRewardType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EcbsvResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ecbsv'] = ResolversParentTypes['Ecbsv']> = {
  consent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  providedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EducationTipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EducationTip'] = ResolversParentTypes['EducationTip']> = {
  detailsKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  summaryKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Eligibility'] = ResolversParentTypes['Eligibility']> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Email'], any> {
  name: 'Email';
}

export interface EmailAddressScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EmailAddress'], any> {
  name: 'EmailAddress';
}

export type EmailAddressValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAddressValidation'] = ResolversParentTypes['EmailAddressValidation']> = {
  credentialsExist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deliverable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>;
  nativeCredentialsEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  oidcAssociated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  oidcProviders?: Resolver<Maybe<Array<Maybe<ResolversTypes['OidcProvider']>>>, ParentType, ContextType>;
  possibleTypo?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  suggestion?: Resolver<Maybe<ResolversTypes['EmailAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailAuthChallengeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAuthChallenge'] = ResolversParentTypes['EmailAuthChallenge']> = {
  alternateAuthenticators?: Resolver<Array<ResolversTypes['AuthenticatorInfo']>, ParentType, ContextType>;
  challengeTrigger?: Resolver<ResolversTypes['ChallengeTriggers'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maskedEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailAuthenticatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAuthenticator'] = ResolversParentTypes['EmailAuthenticator']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastAuthenticatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailRedirectResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailRedirect'] = ResolversParentTypes['EmailRedirect']> = {
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailTakenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailTakenException'] = ResolversParentTypes['EmailTakenException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmergencyFundHistorySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmergencyFundHistorySummary'] = ResolversParentTypes['EmergencyFundHistorySummary']> = {
  interestEarned?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  moneyIn?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyOut?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employer'] = ResolversParentTypes['Employer']> = {
  clickSwitchTargetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  dunsName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dunsNumber?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  switch?: Resolver<ResolversTypes['AbstractSwitch'], ParentType, ContextType>;
  switchType?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnableQuarterlyRecapsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnableQuarterlyRecapsResult'] = ResolversParentTypes['EnableQuarterlyRecapsResult']> = {
  __resolveType: TypeResolveFn<'InvalidSubscriptionTierException' | 'InvestmentAccount' | 'InvestmentAccountNotFoundException' | 'InvestmentAccountNotSupportedException', ParentType, ContextType>;
};

export type EstimatedCheckPaymentDatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedCheckPaymentDates'] = ResolversParentTypes['EstimatedCheckPaymentDates']> = {
  estimatedArrivalAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  estimatedShippingAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  estimatedTransferAtText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedTransferDatesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedTransferDatesPayload'] = ResolversParentTypes['EstimatedTransferDatesPayload']> = {
  estimatedTransferCompletedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EvaluateCheckDepositPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvaluateCheckDepositPayload'] = ResolversParentTypes['EvaluateCheckDepositPayload']> = {
  ocrAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  riskFactors?: Resolver<Array<ResolversTypes['DepositRiskFactor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExchangeAcornsEarlyTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExchangeAcornsEarlyTokenResult'] = ResolversParentTypes['ExchangeAcornsEarlyTokenResult']> = {
  __resolveType: TypeResolveFn<'AcornsEarlyUserDetails' | 'InvalidAcornsEarlyTokenException', ParentType, ContextType>;
};

export type ExecuteMoneyInErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteMoneyInError'] = ResolversParentTypes['ExecuteMoneyInError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteMoneyInResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteMoneyInResult'] = ResolversParentTypes['ExecuteMoneyInResult']> = {
  __resolveType: TypeResolveFn<'ExecuteMoneyInError' | 'ExecuteMoneyInSuccess', ParentType, ContextType>;
};

export type ExecuteMoneyInSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteMoneyInSuccess'] = ResolversParentTypes['ExecuteMoneyInSuccess']> = {
  workflowId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteMoneyManagerRebalancesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteMoneyManagerRebalancesResult'] = ResolversParentTypes['ExecuteMoneyManagerRebalancesResult']> = {
  __resolveType: TypeResolveFn<'ExecuteMoneyManagerRebalancesSuccess' | 'RebalanceAlreadyExecutedError' | 'RebalanceSourceInsufficientBalanceError', ParentType, ContextType>;
};

export type ExecuteMoneyManagerRebalancesSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecuteMoneyManagerRebalancesSuccess'] = ResolversParentTypes['ExecuteMoneyManagerRebalancesSuccess']> = {
  assignment?: Resolver<ResolversTypes['MoneyManagerRebalanceAssignment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecutionAuditResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutionAudit'] = ResolversParentTypes['ExecutionAudit']> = {
  billingCycleId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  decisionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExistingEmailVerifiedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingEmailVerifiedException'] = ResolversParentTypes['ExistingEmailVerifiedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExistingRequestPendingReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingRequestPendingReview'] = ResolversParentTypes['ExistingRequestPendingReview']> = {
  reopenRequest?: Resolver<ResolversTypes['InvestmentAccountReopenRequest'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExistingRequestPendingUserActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingRequestPendingUserAction'] = ResolversParentTypes['ExistingRequestPendingUserAction']> = {
  reopenRequest?: Resolver<ResolversTypes['InvestmentAccountReopenRequest'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperienceContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExperienceContent'] = ResolversParentTypes['ExperienceContent']> = {
  campaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  pillAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shareableLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpirePromotionalWaiverResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpirePromotionalWaiverResult'] = ResolversParentTypes['ExpirePromotionalWaiverResult']> = {
  __resolveType: TypeResolveFn<'InvalidUserIdException' | 'PromotionalWaiver_V2' | 'WaiverDeletionException', ParentType, ContextType>;
};

export type ExternalMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalMetadata'] = ResolversParentTypes['ExternalMetadata']> = {
  isSubscriptionActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  membership?: Resolver<Maybe<ResolversTypes['ExternalSubscriptionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtoleCampaignHistoryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtoleCampaignHistoryConnection'] = ResolversParentTypes['ExtoleCampaignHistoryConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ExtoleCampaignHistoryEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ReferralPaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtoleCampaignHistoryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtoleCampaignHistoryEdge'] = ResolversParentTypes['ExtoleCampaignHistoryEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hurdleMet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ExtoleReferralCampaign'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtoleReferralCampaignResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtoleReferralCampaign'] = ResolversParentTypes['ExtoleReferralCampaign']> = {
  advocateRewardAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  eligibilityEnd?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  friendRewardAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hurdle?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  publishEnd?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  publishStart?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PublishedCampaignStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtoleReferralHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtoleReferralHistory'] = ResolversParentTypes['ExtoleReferralHistory']> = {
  extoleFriendHistory?: Resolver<Maybe<ResolversTypes['FriendHistoryConnection']>, ParentType, ContextType, RequireFields<ExtoleReferralHistoryExtoleFriendHistoryArgs, 'filter'>>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FailVendorInvoiceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['FailVendorInvoiceResult'] = ResolversParentTypes['FailVendorInvoiceResult']> = {
  __resolveType: TypeResolveFn<'BillingVendorError' | 'Invoice', ParentType, ContextType>;
};

export type FavoritePartnerOfferGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['FavoritePartnerOfferGroup'] = ResolversParentTypes['FavoritePartnerOfferGroup']> = {
  offers?: Resolver<Array<ResolversTypes['PartnerOfferGroupItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeaturedLearnContentPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedLearnContentPreview'] = ResolversParentTypes['FeaturedLearnContentPreview']> = {
  __resolveType: TypeResolveFn<'LearnArticlePreview' | 'LearnMediaPreview', ParentType, ContextType>;
};

export type FeaturedMilestonesResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedMilestones'] = ResolversParentTypes['FeaturedMilestones']> = {
  milestones?: Resolver<Array<ResolversTypes['Milestone']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeaturedMilestonesV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedMilestonesV2'] = ResolversParentTypes['FeaturedMilestonesV2']> = {
  __resolveType: TypeResolveFn<'AccountSetupMilestones' | 'FeaturedMilestones', ParentType, ContextType>;
};

export type FeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Fee'] = ResolversParentTypes['Fee']> = {
  accountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountCollected?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  assessedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  billingCycle?: Resolver<ResolversTypes['BillingCycle'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feeCategoryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeExecutions?: Resolver<Array<Maybe<ResolversTypes['FeeExecution']>>, ParentType, ContextType>;
  feeType?: Resolver<ResolversTypes['FeeType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeExecutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeExecution'] = ResolversParentTypes['FeeExecution']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountCollected?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountRequested?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  executionMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  fundingAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeNegotiationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeNegotiation'] = ResolversParentTypes['FeeNegotiation']> = {
  connection?: Resolver<Maybe<ResolversTypes['BankConnection']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  displayStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeSynopsis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internalStatus?: Resolver<Maybe<ResolversTypes['BankFeeNegotiationInternalStatus']>, ParentType, ContextType>;
  negotiatedAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  refundAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BankFeeNegotiationExternalStatus']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeNegotiationSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeNegotiationSummary'] = ResolversParentTypes['FeeNegotiationSummary']> = {
  negotiations?: Resolver<Maybe<Array<ResolversTypes['FeeNegotiation']>>, ParentType, ContextType>;
  totalRefundedFees?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeStatusSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeStatusSummary'] = ResolversParentTypes['FeeStatusSummary']> = {
  negotiable?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  negotiated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  processing?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unnegotiable?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileResolvers<ContextType = any, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = {
  documentRequestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  encoding?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mimetype?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileDoesNotExistErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileDoesNotExistError'] = ResolversParentTypes['FileDoesNotExistError']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileDoesNotExistInS3Resolvers<ContextType = any, ParentType extends ResolversParentTypes['FileDoesNotExistInS3'] = ResolversParentTypes['FileDoesNotExistInS3']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOrExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileOrException'] = ResolversParentTypes['FileOrException']> = {
  __resolveType: TypeResolveFn<'File' | 'FileSizeError' | 'UploadFailedError', ParentType, ContextType>;
};

export type FileSizeErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileSizeError'] = ResolversParentTypes['FileSizeError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileTooLargeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileTooLarge'] = ResolversParentTypes['FileTooLarge']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialAdvisorQuestionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialAdvisorQuestionResponse'] = ResolversParentTypes['FinancialAdvisorQuestionResponse']> = {
  interactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialAdvisorQuestionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialAdvisorQuestionsResponse'] = ResolversParentTypes['FinancialAdvisorQuestionsResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialGoalsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialGoalsResult'] = ResolversParentTypes['FinancialGoalsResult']> = {
  age?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  balance?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  cumulativeContributions?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  totalContributions?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialInstitutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialInstitution'] = ResolversParentTypes['FinancialInstitution']> = {
  blacklisted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  boost?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  directBank?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasMfa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  linkProviderType?: Resolver<Maybe<ResolversTypes['LinkProviderType']>, ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  oauthUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialInstitutionTypeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialInstitutionTypeEdge'] = ResolversParentTypes['FinancialInstitutionTypeEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FinancialInstitution'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialInstitutionTypePaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialInstitutionTypePagination'] = ResolversParentTypes['FinancialInstitutionTypePagination']> = {
  edges?: Resolver<Array<ResolversTypes['FinancialInstitutionTypeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinishSetupResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinishSetup'] = ResolversParentTypes['FinishSetup']> = {
  eyebrow?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tips?: Resolver<Array<ResolversTypes['SetUpTip']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FooterContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['FooterContent'] = ResolversParentTypes['FooterContent']> = {
  acornsLogoAsset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disclosures?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkColumn1Header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkColumn2Header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkColumn3Header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mainCTAText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mainCTAUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mainHeadline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormattedMonetaryAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormattedMonetaryAmount'] = ResolversParentTypes['FormattedMonetaryAmount']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FoundMoneyCampaignOfferV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['FoundMoneyCampaignOfferV2'] = ResolversParentTypes['FoundMoneyCampaignOfferV2']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  incentiveSummary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FoundMoneyCampaignV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['FoundMoneyCampaignV2'] = ResolversParentTypes['FoundMoneyCampaignV2']> = {
  backgroundColorHex?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  backgroundImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  cohortSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  colorBackgroundLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  colorImageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  offers?: Resolver<Array<ResolversTypes['FoundMoneyCampaignOfferV2']>, ParentType, ContextType>;
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FoundMoneyRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['FoundMoneyReward'] = ResolversParentTypes['FoundMoneyReward']> = {
  campaignOwnerImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  campaignOwnerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  colorBackgroundLogoImageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  daysFulfilledWithin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dollarValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  fulfillmentDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFoundMoneyPlus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FoundMoneySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FoundMoneySummary'] = ResolversParentTypes['FoundMoneySummary']> = {
  totalFulfilledRewardsDollarValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  totalMatchedDollarValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  totalPendingRewardsDollarValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  totalRewardsDollarValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FriendResolvers<ContextType = any, ParentType extends ResolversParentTypes['Friend'] = ResolversParentTypes['Friend']> = {
  advocateFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advocateLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advocateMinimumIncentive?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advocateUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  campaigns?: Resolver<Maybe<Array<ResolversTypes['ReferralCampaign']>>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  friendExperienceContent?: Resolver<Maybe<ResolversTypes['FriendExperienceContent']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FriendStatus']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FriendExperienceContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['FriendExperienceContent'] = ResolversParentTypes['FriendExperienceContent']> = {
  advocateFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advocateLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advocateMinimumIncentive?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FriendHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FriendHistory'] = ResolversParentTypes['FriendHistory']> = {
  advocateUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  friendFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  friendLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FriendStatusV2']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FriendHistoryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FriendHistoryConnection'] = ResolversParentTypes['FriendHistoryConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['FriendHistoryEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ReferralPaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FriendHistoryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FriendHistoryEdge'] = ResolversParentTypes['FriendHistoryEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FriendHistory'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FriendSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FriendSummary'] = ResolversParentTypes['FriendSummary']> = {
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FriendStatus']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FriendV2OutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['FriendV2Output'] = ResolversParentTypes['FriendV2Output']> = {
  advocate?: Resolver<Maybe<ResolversTypes['AdvocateV2']>, ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['CampaignV2']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundResolvers<ContextType = any, ParentType extends ResolversParentTypes['Fund'] = ResolversParentTypes['Fund']> = {
  currentPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  earliestPriceDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  headlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastClosePrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  lastUpdatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  longName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  marketCap?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  numberOfHoldings?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>;
  securityHeadlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>;
  securityProfile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>;
  topHoldings?: Resolver<Array<ResolversTypes['TopHolding']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SecurityType'], ParentType, ContextType>;
  volume?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  week52High?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  week52Low?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundSpendInActivationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundSpendInActivationPayload'] = ResolversParentTypes['FundSpendInActivationPayload']> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundingSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingSource'] = ResolversParentTypes['FundingSource']> = {
  alert?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  fundingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  last4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rdvSettledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rdvTriggeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verificationStatus?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundingSourceAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingSourceAccount'] = ResolversParentTypes['FundingSourceAccount']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  alert?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bankRoutingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canCancel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canRetriggerRdv?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canTriggerRdv?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canVerifyRdv?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  frozen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fundType?: Resolver<ResolversTypes['FundingSourceType'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  insufficientFunds?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  last4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedSubaccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preferredWithdrawalAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rdvSettledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rdvTriggeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['FundingSourceRoleEnum']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FundingSourceStatus'], ParentType, ContextType>;
  transfersApproved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  verificationStatus?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundingSourceAlreadyExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingSourceAlreadyExists'] = ResolversParentTypes['FundingSourceAlreadyExists']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundingSourceCredentialsExceedLinkLimitResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingSourceCredentialsExceedLinkLimit'] = ResolversParentTypes['FundingSourceCredentialsExceedLinkLimit']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundingSourceInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingSourceInfo'] = ResolversParentTypes['FundingSourceInfo']> = {
  accountNumberLastFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alert?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  canChange?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  changeRequiresApproval?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  linkedSubaccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rdvSettledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rdvTriggeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FundingSourceType']>, ParentType, ContextType>;
  verificationStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundingSourceRequiresRdvExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingSourceRequiresRdvException'] = ResolversParentTypes['FundingSourceRequiresRdvException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FunnelMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FunnelMetadata'] = ResolversParentTypes['FunnelMetadata']> = {
  name?: Resolver<ResolversTypes['FunnelName'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateDocumentUploadSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateDocumentUploadSessionResult'] = ResolversParentTypes['GenerateDocumentUploadSessionResult']> = {
  __resolveType: TypeResolveFn<'DocumentUploadSession', ParentType, ContextType>;
};

export type GenerateLayerLinkSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateLayerLinkSessionResult'] = ResolversParentTypes['GenerateLayerLinkSessionResult']> = {
  __resolveType: TypeResolveFn<'PlaidLayerLinkSession' | 'UnrecoverableError', ParentType, ContextType>;
};

export type GenerateReferralCodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateReferralCodeResult'] = ResolversParentTypes['GenerateReferralCodeResult']> = {
  __resolveType: TypeResolveFn<'Invitation', ParentType, ContextType>;
};

export type GenerateUpdatedPdfPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateUpdatedPdfPayload'] = ResolversParentTypes['GenerateUpdatedPdfPayload']> = {
  pdf?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetUsersBankFromAccountTypePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetUsersBankFromAccountTypePayload'] = ResolversParentTypes['GetUsersBankFromAccountTypePayload']> = {
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GrowProspectResolvers<ContextType = any, ParentType extends ResolversParentTypes['GrowProspect'] = ResolversParentTypes['GrowProspect']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HelpFormContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['HelpFormContent'] = ResolversParentTypes['HelpFormContent']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HelpcenterBannerContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['HelpcenterBannerContent'] = ResolversParentTypes['HelpcenterBannerContent']> = {
  bannerText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bannerType?: Resolver<ResolversTypes['HelpcenterBannerType'], ParentType, ContextType>;
  currentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HelpcenterBannerErrorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['HelpcenterBannerErrors'] = ResolversParentTypes['HelpcenterBannerErrors']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Holding'] = ResolversParentTypes['Holding']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingsTransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['HoldingsTransfer'] = ResolversParentTypes['HoldingsTransfer']> = {
  transferType?: Resolver<ResolversTypes['HoldingsTransferType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IraDistributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IRADistribution'] = ResolversParentTypes['IRADistribution']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  federalWithholdings?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  stateWithholdings?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityDocumentRequestedUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityDocumentRequestedUserAlert'] = ResolversParentTypes['IdentityDocumentRequestedUserAlert']> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityVerification'] = ResolversParentTypes['IdentityVerification']> = {
  __resolveType: TypeResolveFn<'BankCardOrderIdentityVerification' | 'BankingKycIdentityVerification', ParentType, ContextType>;
  canRetry?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  verificationStatus?: Resolver<ResolversTypes['VerificationStatus'], ParentType, ContextType>;
};

export type ImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImplicitTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImplicitToken'] = ResolversParentTypes['ImplicitToken']> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IncentiveResolvers<ContextType = any, ParentType extends ResolversParentTypes['Incentive'] = ResolversParentTypes['Incentive']> = {
  __resolveType: TypeResolveFn<'MonetaryIncentive', ParentType, ContextType>;
  copyKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
};

export type IncorrectOldPasswordExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncorrectOldPasswordException'] = ResolversParentTypes['IncorrectOldPasswordException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IncorrectRdvAmountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncorrectRdvAmounts'] = ResolversParentTypes['IncorrectRdvAmounts']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IncorrectSecurityAnswerExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncorrectSecurityAnswerException'] = ResolversParentTypes['IncorrectSecurityAnswerException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IncorrectSsnExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncorrectSsnException'] = ResolversParentTypes['IncorrectSsnException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateBankAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateBankAccountResponse'] = ResolversParentTypes['InitiateBankAccountResponse']> = {
  accountType?: Resolver<ResolversTypes['BankAccountType'], ParentType, ContextType>;
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateBankingKycPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateBankingKYCPayload'] = ResolversParentTypes['InitiateBankingKYCPayload']> = {
  kycStatus?: Resolver<Maybe<ResolversTypes['KycStatus']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateChallengeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateChallengeResult'] = ResolversParentTypes['InitiateChallengeResult']> = {
  __resolveType: TypeResolveFn<'AuthenticatorNotFoundException' | 'ChallengeRateExceededException' | 'EmailAuthChallenge' | 'InvalidMfaTokenException' | 'PhoneNumberOptedOutException' | 'SMSAuthChallenge', ParentType, ContextType>;
};

export type InitiateEmailChallengeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateEmailChallengeResult'] = ResolversParentTypes['InitiateEmailChallengeResult']> = {
  __resolveType: TypeResolveFn<'ChallengeRateExceededException' | 'EmailAuthChallenge' | 'ExistingEmailVerifiedException', ParentType, ContextType>;
};

export type InitiateMoneyAssignmentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateMoneyAssignmentResult'] = ResolversParentTypes['InitiateMoneyAssignmentResult']> = {
  __resolveType: TypeResolveFn<'InitiateMoneyAssignmentSuccess' | 'MoneyAssignmentAlreadyTransferredError' | 'MoneyAssignmentNotFoundError', ParentType, ContextType>;
};

export type InitiateMoneyAssignmentSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateMoneyAssignmentSuccess'] = ResolversParentTypes['InitiateMoneyAssignmentSuccess']> = {
  moneyAssignment?: Resolver<ResolversTypes['MoneyManagerMoneyAssignment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiatePushChallengeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiatePushChallengeResult'] = ResolversParentTypes['InitiatePushChallengeResult']> = {
  __resolveType: TypeResolveFn<'ChallengeRateExceededException' | 'InitiatePushChallengeSuccess' | 'NoRegisteredPushAuthenticatorsException', ParentType, ContextType>;
};

export type InitiatePushChallengeSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiatePushChallengeSuccess'] = ResolversParentTypes['InitiatePushChallengeSuccess']> = {
  challenges?: Resolver<Maybe<Array<ResolversTypes['PushAuthChallenge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateSmsChallengeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateSMSChallengeResult'] = ResolversParentTypes['InitiateSMSChallengeResult']> = {
  __resolveType: TypeResolveFn<'ChallengeRateExceededException' | 'InvalidPhoneNumberException' | 'PhoneNumberOptedOutException' | 'SMSAuthChallenge', ParentType, ContextType>;
};

export type InitiateTransferPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateTransferPayload'] = ResolversParentTypes['InitiateTransferPayload']> = {
  transfer?: Resolver<Maybe<ResolversTypes['Transfer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateVerificationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateVerificationResult'] = ResolversParentTypes['InitiateVerificationResult']> = {
  __resolveType: TypeResolveFn<'VerificationProfile', ParentType, ContextType>;
};

export type InstitutionNotSupportedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstitutionNotSupportedError'] = ResolversParentTypes['InstitutionNotSupportedError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InsufficientFundsUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['InsufficientFundsUserAlert'] = ResolversParentTypes['InsufficientFundsUserAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Intent'] = ResolversParentTypes['Intent']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nonce?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['IntentStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InteractionRatingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InteractionRatingResponse'] = ResolversParentTypes['InteractionRatingResponse']> = {
  interactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalErrorExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalErrorException'] = ResolversParentTypes['InternalErrorException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAccountNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAccountNumber'] = ResolversParentTypes['InvalidAccountNumber']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAccountTypeExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAccountTypeException'] = ResolversParentTypes['InvalidAccountTypeException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAcornsEarlyTokenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAcornsEarlyTokenException'] = ResolversParentTypes['InvalidAcornsEarlyTokenException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidActionOnAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidActionOnAccount'] = ResolversParentTypes['InvalidActionOnAccount']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAddressErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAddressError'] = ResolversParentTypes['InvalidAddressError']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAddressExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAddressException'] = ResolversParentTypes['InvalidAddressException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAllocationPercentErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAllocationPercentError'] = ResolversParentTypes['InvalidAllocationPercentError']> = {
  maxAllocationPercent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAppleAccountExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAppleAccountException'] = ResolversParentTypes['InvalidAppleAccountException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidContentTypeExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidContentTypeException'] = ResolversParentTypes['InvalidContentTypeException']> = {
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidConversionIdentifierExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidConversionIdentifierException'] = ResolversParentTypes['InvalidConversionIdentifierException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidCredentialsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidCredentialsException'] = ResolversParentTypes['InvalidCredentialsException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidDateExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidDateException'] = ResolversParentTypes['InvalidDateException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidDateOfBirthExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidDateOfBirthException'] = ResolversParentTypes['InvalidDateOfBirthException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidDeviceParametersExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidDeviceParametersException'] = ResolversParentTypes['InvalidDeviceParametersException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidEmailExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidEmailException'] = ResolversParentTypes['InvalidEmailException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidFile'] = ResolversParentTypes['InvalidFile']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidFirstNameExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidFirstNameException'] = ResolversParentTypes['InvalidFirstNameException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidGoogleAccountExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidGoogleAccountException'] = ResolversParentTypes['InvalidGoogleAccountException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidIdentityTokenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidIdentityTokenException'] = ResolversParentTypes['InvalidIdentityTokenException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidInvestmentAccountExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidInvestmentAccountException'] = ResolversParentTypes['InvalidInvestmentAccountException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidLastNameExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidLastNameException'] = ResolversParentTypes['InvalidLastNameException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidManualLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidManualLink'] = ResolversParentTypes['InvalidManualLink']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidMfaTokenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidMfaTokenException'] = ResolversParentTypes['InvalidMfaTokenException']> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidOauthAppClientIdExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidOauthAppClientIdException'] = ResolversParentTypes['InvalidOauthAppClientIdException']> = {
  oauthAppClientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidOptionExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidOptionException'] = ResolversParentTypes['InvalidOptionException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPasswordExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPasswordException'] = ResolversParentTypes['InvalidPasswordException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPasswordResetExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPasswordResetException'] = ResolversParentTypes['InvalidPasswordResetException']> = {
  errors?: Resolver<Array<ResolversTypes['PasswordResetErrors']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPasswordResetTokenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPasswordResetTokenException'] = ResolversParentTypes['InvalidPasswordResetTokenException']> = {
  invalidToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPhoneExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPhoneException'] = ResolversParentTypes['InvalidPhoneException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPhoneNumberExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPhoneNumberException'] = ResolversParentTypes['InvalidPhoneNumberException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPinExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPinException'] = ResolversParentTypes['InvalidPinException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPortfolioIdExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPortfolioIdException'] = ResolversParentTypes['InvalidPortfolioIdException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidPromoCodeErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidPromoCodeError'] = ResolversParentTypes['InvalidPromoCodeError']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidReferralRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidReferralRelationship'] = ResolversParentTypes['InvalidReferralRelationship']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidRoutingNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidRoutingNumber'] = ResolversParentTypes['InvalidRoutingNumber']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidSecurityErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidSecurityError'] = ResolversParentTypes['InvalidSecurityError']> = {
  securityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidSecurityForAllocationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidSecurityForAllocationError'] = ResolversParentTypes['InvalidSecurityForAllocationError']> = {
  reason?: Resolver<ResolversTypes['InvalidSecurityForAllocationReasonEnum'], ParentType, ContextType>;
  securityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidSingleRuleIdErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidSingleRuleIdError'] = ResolversParentTypes['InvalidSingleRuleIdError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidSourceAttributesExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidSourceAttributesException'] = ResolversParentTypes['InvalidSourceAttributesException']> = {
  incorrectAttributes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidSsnExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidSsnException'] = ResolversParentTypes['InvalidSsnException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidStateExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidStateException'] = ResolversParentTypes['InvalidStateException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidSubscriptionTierExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidSubscriptionTierException'] = ResolversParentTypes['InvalidSubscriptionTierException']> = {
  currentUserTierKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidTerminationAgeExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidTerminationAgeException'] = ResolversParentTypes['InvalidTerminationAgeException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidTier'] = ResolversParentTypes['InvalidTier']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  validTiers?: Resolver<Array<ResolversTypes['Tier']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidTierForMigrationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidTierForMigrationError'] = ResolversParentTypes['InvalidTierForMigrationError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidTierPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidTierPrice'] = ResolversParentTypes['InvalidTierPrice']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  validTierPrices?: Resolver<Array<ResolversTypes['TierPrice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidTierPriceCombinationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidTierPriceCombination'] = ResolversParentTypes['InvalidTierPriceCombination']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidTierPriceIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidTierPriceId'] = ResolversParentTypes['InvalidTierPriceId']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidUserIdExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidUserIdException'] = ResolversParentTypes['InvalidUserIdException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidUserTokenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidUserTokenException'] = ResolversParentTypes['InvalidUserTokenException']> = {
  userTokenId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestHistorySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestHistorySummary'] = ResolversParentTypes['InvestHistorySummary']> = {
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  earnRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyIn?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyOut?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  referralRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Investment'] = ResolversParentTypes['Investment']> = {
  allocations?: Resolver<Maybe<Array<ResolversTypes['InvestmentAllocation']>>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountCollected?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  cashOwed?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  dividendInvestmentSecurityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dividendInvestmentSecurityTicker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  earnRewardCampaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  earnRewardInvestmentPartner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  earnRewardInvestmentPartnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  earnRewardInvestmentType?: Resolver<Maybe<ResolversTypes['EarnRewardInvestType']>, ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  holdingsTransfer?: Resolver<Maybe<ResolversTypes['HoldingsTransfer']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccount?: Resolver<ResolversTypes['InvestmentAccount'], ParentType, ContextType>;
  investmentStatus?: Resolver<Maybe<ResolversTypes['InvestmentStatusV2']>, ParentType, ContextType>;
  investmentTransactionType?: Resolver<ResolversTypes['InvestmentTransactionType'], ParentType, ContextType>;
  investmentType?: Resolver<Maybe<ResolversTypes['InvestmentType']>, ParentType, ContextType>;
  iraDistribution?: Resolver<Maybe<ResolversTypes['IRADistribution']>, ParentType, ContextType>;
  moneyManagerAllocation?: Resolver<Maybe<ResolversTypes['MoneyManagerAllocation']>, ParentType, ContextType>;
  nonce?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  outsideContributionNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outsideContributionNoteAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  percentageMatch?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  reinvestmentReason?: Resolver<Maybe<ResolversTypes['ReinvestmentReason']>, ParentType, ContextType>;
  requestedAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roundUpMerchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roundUpMultiplier?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roundUpTransactionAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  roundUpType?: Resolver<Maybe<ResolversTypes['InvestmentRoundUpType']>, ParentType, ContextType>;
  shares?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InvestmentStatus'], ParentType, ContextType>;
  tradeConfirmationUrls?: Resolver<Maybe<Array<ResolversTypes['URL']>>, ParentType, ContextType>;
  tradedAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  transferredAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  typeHelp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccount'] = ResolversParentTypes['InvestmentAccount']> = {
  beneficiary?: Resolver<Maybe<ResolversTypes['Beneficiary']>, ParentType, ContextType>;
  beneficiaryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  cashBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentBalance?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  hasInvested?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccountType?: Resolver<ResolversTypes['InvestmentAccountType'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  netInvestments?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  pendingWithdrawals?: Resolver<Array<ResolversTypes['Withdrawal']>, ParentType, ContextType>;
  performance?: Resolver<Maybe<ResolversTypes['Performance']>, ParentType, ContextType, RequireFields<InvestmentAccountPerformanceArgs, 'days'>>;
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolios?: Resolver<Maybe<Array<ResolversTypes['BasePortfolio']>>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['InvestmentProduct'], ParentType, ContextType>;
  quarterlyRecap?: Resolver<Maybe<ResolversTypes['InvestmentAccountRecap']>, ParentType, ContextType>;
  quarterlyRecapsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recommendedPortfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  recurringInvestmentSettings?: Resolver<Maybe<ResolversTypes['RecurringInvestmentSettings']>, ParentType, ContextType>;
  requirements?: Resolver<ResolversTypes['AccountRequirements'], ParentType, ContextType>;
  returnsAllTime?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InvestmentAccountStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['InvestmentAccountSummary'], ParentType, ContextType, Partial<InvestmentAccountSummaryArgs>>;
  totalAccountValue?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  totalBonds?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  totalCrypto?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  totalEquities?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  totalMatched?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  totalMatchedByYear?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType, RequireFields<InvestmentAccountTotalMatchedByYearArgs, 'year'>>;
  transferability?: Resolver<Maybe<ResolversTypes['InvestmentAccountTransferability']>, ParentType, ContextType>;
  trustedContact?: Resolver<Maybe<ResolversTypes['TrustedContact']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userAge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  withdrawalsIncurTaxPenalty?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountAlreadyClosedResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountAlreadyClosed'] = ResolversParentTypes['InvestmentAccountAlreadyClosed']> = {
  accountClosedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountClosureInProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountClosureInProgress'] = ResolversParentTypes['InvestmentAccountClosureInProgress']> = {
  clientMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountClosureRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountClosureRequest'] = ResolversParentTypes['InvestmentAccountClosureRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountCreationExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountCreationException'] = ResolversParentTypes['InvestmentAccountCreationException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountNeedsTransferExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountNeedsTransferException'] = ResolversParentTypes['InvestmentAccountNeedsTransferException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountNotClosedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountNotClosedException'] = ResolversParentTypes['InvestmentAccountNotClosedException']> = {
  accountType?: Resolver<Maybe<ResolversTypes['InvestmentAccountType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountNotFoundException'] = ResolversParentTypes['InvestmentAccountNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountNotSupportedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountNotSupportedException'] = ResolversParentTypes['InvestmentAccountNotSupportedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountOutsideContributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountOutsideContribution'] = ResolversParentTypes['InvestmentAccountOutsideContribution']> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  contributorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountRecapResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountRecap'] = ResolversParentTypes['InvestmentAccountRecap']> = {
  beneficiaryAge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  beneficiaryCustodianNickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beneficiaryFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beneficiaryLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contributionsByOthers?: Resolver<Maybe<Array<ResolversTypes['InvestmentAccountOutsideContribution']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  endsAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccount?: Resolver<ResolversTypes['InvestmentAccount'], ParentType, ContextType>;
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latestAccountValue?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  performance?: Resolver<Maybe<ResolversTypes['Performance']>, ParentType, ContextType>;
  public?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publicUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  startsAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  totalContributions?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  totalContributionsByOthers?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountRecapNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountRecapNotFoundException'] = ResolversParentTypes['InvestmentAccountRecapNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountReopenRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountReopenRequest'] = ResolversParentTypes['InvestmentAccountReopenRequest']> = {
  adminActions?: Resolver<Array<ResolversTypes['InvestmentAccountReopenRequestAction']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  investmentAccount?: Resolver<ResolversTypes['InvestmentAccount'], ParentType, ContextType>;
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  notes?: Resolver<Array<ResolversTypes['InvestmentAccountReopenRequestNote']>, ParentType, ContextType>;
  reopenChecks?: Resolver<Array<ResolversTypes['UserInvestmentAccountReopenCheck']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['InvestmentAccountReopenRequestState'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User_v2'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountReopenRequestActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountReopenRequestAction'] = ResolversParentTypes['InvestmentAccountReopenRequestAction']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fromState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccount?: Resolver<ResolversTypes['InvestmentAccount'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['InvestmentAccountReopenRequestNote']>, ParentType, ContextType>;
  reopenRequest?: Resolver<ResolversTypes['InvestmentAccountReopenRequest'], ParentType, ContextType>;
  toState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountReopenRequestNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountReopenRequestNote'] = ResolversParentTypes['InvestmentAccountReopenRequestNote']> = {
  adminAction?: Resolver<ResolversTypes['InvestmentAccountReopenRequestAction'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  emailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reopenRequest?: Resolver<ResolversTypes['InvestmentAccountReopenRequest'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountSummary'] = ResolversParentTypes['InvestmentAccountSummary']> = {
  firstInvestmentDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  mostRecentOneTimeInvestmentDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  totalCredits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDeposits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDepositsCurrentYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDepositsCurrentYearWithinTimeFrame?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDepositsPreviousYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDividends?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalFoundMoneyRewards?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalInvested?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalInvestedCurrentYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalInvestedExcludingAcornsBanking?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalInvestedPreviousYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalMatchRewards?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalMatchRewardsRemovalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalOneTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalOutsideContributions?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPlan?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalRecurring?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalReferralRewards?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalRoundUps?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalRtru?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalWithdrawn?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalWithdrawnExcludingAcornsBanking?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAccountTransferabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAccountTransferability'] = ResolversParentTypes['InvestmentAccountTransferability']> = {
  transferAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transferDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  transferReached?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transferStateCode?: Resolver<ResolversTypes['USStateCodes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAggregationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAggregation'] = ResolversParentTypes['InvestmentAggregation']> = {
  totalPendingAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentAllocation'] = ResolversParentTypes['InvestmentAllocation']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  selfDirected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InvestmentAllocationStatus'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['InvestmentAllocationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentCategory'] = ResolversParentTypes['InvestmentCategory']> = {
  bond?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  crypto?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  equity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  realEstate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentEdge'] = ResolversParentTypes['InvestmentEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Investment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentNotFoundException'] = ResolversParentTypes['InvestmentNotFoundException']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentPagination'] = ResolversParentTypes['InvestmentPagination']> = {
  aggregation?: Resolver<Maybe<ResolversTypes['InvestmentAggregation']>, ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['InvestmentEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentUncancellableExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentUncancellableException'] = ResolversParentTypes['InvestmentUncancellableException']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentsPausedUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentsPausedUserAlert'] = ResolversParentTypes['InvestmentsPausedUserAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invitation'] = ResolversParentTypes['Invitation']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ReferralCode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  account?: Resolver<Maybe<ResolversTypes['VendorCustomerAccount']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lineItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['InvoiceLineItem']>>>, ParentType, ContextType>;
  lineItemsAmountSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceCollection'] = ResolversParentTypes['InvoiceCollection']> = {
  chargeInvoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType>;
  creditInvoices?: Resolver<Maybe<Array<Maybe<ResolversTypes['Invoice']>>>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceItem'] = ResolversParentTypes['InvoiceItem']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feeCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceLineItem'] = ResolversParentTypes['InvoiceLineItem']> = {
  addOnCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOnId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type JobAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobAlert'] = ResolversParentTypes['JobAlert']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  keyPhrase?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobLocation'] = ResolversParentTypes['JobLocation']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobOfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobOffer'] = ResolversParentTypes['JobOffer']> = {
  companyLogo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['OfferLocation'], ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['JobOfferSalary']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobOfferSalaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobOfferSalary'] = ResolversParentTypes['JobOfferSalary']> = {
  interval?: Resolver<ResolversTypes['SalaryInterval'], ParentType, ContextType>;
  maxValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobSearchCriteriaResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobSearchCriteria'] = ResolversParentTypes['JobSearchCriteria']> = {
  filters?: Resolver<Array<ResolversTypes['JobSearchFilter']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['JobLocation'], ParentType, ContextType>;
  searchRadius?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobSearchFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobSearchFilter'] = ResolversParentTypes['JobSearchFilter']> = {
  key?: Resolver<ResolversTypes['JobSearchFilterKey'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobSearchOfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobSearchOffer'] = ResolversParentTypes['JobSearchOffer']> = {
  backgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  desktopBackgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  searchFilters?: Resolver<Array<ResolversTypes['JobSearchFilter']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobSearchPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobSearchPage'] = ResolversParentTypes['JobSearchPage']> = {
  recentSearches?: Resolver<Array<ResolversTypes['JobSearchCriteria']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LadderLinkResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LadderLinkResponse'] = ResolversParentTypes['LadderLinkResponse']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  urlExpires?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LadderQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['LadderQuote'] = ResolversParentTypes['LadderQuote']> = {
  coverage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  monthlyPremium?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  term?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LadderQuoteStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['LadderQuoteStatus'] = ResolversParentTypes['LadderQuoteStatus']> = {
  complete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  eligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LadderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LadderResponse'] = ResolversParentTypes['LadderResponse']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quoteStatus?: Resolver<Maybe<ResolversTypes['LadderQuoteStatus']>, ParentType, ContextType>;
  quotes?: Resolver<Array<Maybe<ResolversTypes['LadderQuote']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccount'] = ResolversParentTypes['LaterAccount']> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['LaterAccountCodes'], ParentType, ContextType>;
  contributionLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  performance?: Resolver<Maybe<ResolversTypes['LaterPortfolioPerformance']>, ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  portfolioName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recurringSettings?: Resolver<Maybe<ResolversTypes['RecurringInvestmentSettings']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['LaterAccountStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountAlreadyVerifiedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountAlreadyVerified'] = ResolversParentTypes['LaterAccountAlreadyVerified']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountIneligibleForVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountIneligibleForVerification'] = ResolversParentTypes['LaterAccountIneligibleForVerification']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountInfo'] = ResolversParentTypes['LaterAccountInfo']> = {
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['InvestmentAccountTypes'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LaterAccountStatus'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountInfoOrErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountInfoOrError'] = ResolversParentTypes['LaterAccountInfoOrError']> = {
  __resolveType: TypeResolveFn<'LaterAccountAlreadyVerified' | 'LaterAccountIneligibleForVerification' | 'LaterAccountInfo' | 'LaterAccountNotFound', ParentType, ContextType>;
};

export type LaterAccountNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountNotFound'] = ResolversParentTypes['LaterAccountNotFound']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountRequiresTaxWithholdingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountRequiresTaxWithholdings'] = ResolversParentTypes['LaterAccountRequiresTaxWithholdings']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountRequiresWithdrawalReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountRequiresWithdrawalReason'] = ResolversParentTypes['LaterAccountRequiresWithdrawalReason']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterAccountTaxWithholdingsPercentageExceededResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterAccountTaxWithholdingsPercentageExceeded'] = ResolversParentTypes['LaterAccountTaxWithholdingsPercentageExceeded']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterBeneficiaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterBeneficiary'] = ResolversParentTypes['LaterBeneficiary']> = {
  __resolveType: TypeResolveFn<'LaterIndividualBeneficiary', ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  percentageShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BeneficiaryType']>, ParentType, ContextType>;
};

export type LaterContributionAbilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterContributionAbilityResult'] = ResolversParentTypes['LaterContributionAbilityResult']> = {
  __resolveType: TypeResolveFn<'ContributionAbilityByYear', ParentType, ContextType>;
};

export type LaterContributionLimitMetResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterContributionLimitMet'] = ResolversParentTypes['LaterContributionLimitMet']> = {
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterDebtCollectionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterDebtCollectionItem'] = ResolversParentTypes['LaterDebtCollectionItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterDividendsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterDividendsItem'] = ResolversParentTypes['LaterDividendsItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  etfCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  etfTicker?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterFeeInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterFeeInvestmentItem'] = ResolversParentTypes['LaterFeeInvestmentItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterFullContributionSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterFullContributionSuccess'] = ResolversParentTypes['LaterFullContributionSuccess']> = {
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterHistoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterHistoryItem'] = ResolversParentTypes['LaterHistoryItem']> = {
  __resolveType: TypeResolveFn<'LaterWithdrawal', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reversible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tradeConfirmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['LaterHistoryItemType']>, ParentType, ContextType>;
};

export type LaterHistorySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterHistorySummary'] = ResolversParentTypes['LaterHistorySummary']> = {
  currentYear?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  iraMatchRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyIn?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyOut?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  previousYear?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  previousYearContributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterIndividualBeneficiaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterIndividualBeneficiary'] = ResolversParentTypes['LaterIndividualBeneficiary']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beneficiaryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  birthDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentageShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relationship?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BeneficiaryType']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterIndividualBeneficiaryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterIndividualBeneficiaryResponse'] = ResolversParentTypes['LaterIndividualBeneficiaryResponse']> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentageShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relationship?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterInvestmentItem'] = ResolversParentTypes['LaterInvestmentItem']> = {
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterMatchItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterMatchItem'] = ResolversParentTypes['LaterMatchItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterMatchRemovalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterMatchRemovalItem'] = ResolversParentTypes['LaterMatchRemovalItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterPartialContributionSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterPartialContributionSuccess'] = ResolversParentTypes['LaterPartialContributionSuccess']> = {
  acceptedAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterPortfolioPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterPortfolioPerformance'] = ResolversParentTypes['LaterPortfolioPerformance']> = {
  periodMarketChange?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  periodMarketChangePercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  periodMarketChangePercentWithoutFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  periodMarketChangeWithoutFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterProgramAccountContributionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterProgramAccountContributionResult'] = ResolversParentTypes['LaterProgramAccountContributionResult']> = {
  __resolveType: TypeResolveFn<'LaterContributionLimitMet' | 'LaterFullContributionSuccess' | 'LaterPartialContributionSuccess', ParentType, ContextType>;
};

export type LaterRebalanceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterRebalanceItem'] = ResolversParentTypes['LaterRebalanceItem']> = {
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterRefundedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterRefundedItem'] = ResolversParentTypes['LaterRefundedItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterReinvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterReinvestmentItem'] = ResolversParentTypes['LaterReinvestmentItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterTypedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterTypedException'] = ResolversParentTypes['LaterTypedException']> = {
  __resolveType: TypeResolveFn<'LaterAccountAlreadyVerified' | 'LaterAccountIneligibleForVerification' | 'LaterAccountNotFound', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LaterWaitlistProspectResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterWaitlistProspect'] = ResolversParentTypes['LaterWaitlistProspect']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterWithdrawalResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterWithdrawal'] = ResolversParentTypes['LaterWithdrawal']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  earlyDistributionTaxExceptionReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  federalTaxes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reversible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stateTaxes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tradeConfirmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['LaterHistoryItemType']>, ParentType, ContextType>;
  withdrawalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  withdrawalType?: Resolver<Maybe<ResolversTypes['LaterWithdrawalType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterWithdrawalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterWithdrawalItem'] = ResolversParentTypes['LaterWithdrawalItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  federalWithholdings?: Resolver<Maybe<ResolversTypes['LaterWithholdingValues']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  stateWithholdings?: Resolver<Maybe<ResolversTypes['LaterWithholdingValues']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaterWithholdingValuesResolvers<ContextType = any, ParentType extends ResolversParentTypes['LaterWithholdingValues'] = ResolversParentTypes['LaterWithholdingValues']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayerLinkSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayerLinkSession'] = ResolversParentTypes['LayerLinkSession']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedSubaccounts?: Resolver<Maybe<Array<ResolversTypes['LinkedSubaccount']>>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ssn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnAnswer'] = ResolversParentTypes['LearnAnswer']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCorrect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnArticle'] = ResolversParentTypes['LearnArticle']> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>;
  disclaimer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  featuredVideos?: Resolver<Array<ResolversTypes['LearnMediaReference']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  learnProductKey?: Resolver<Maybe<ResolversTypes['LearnProductKey']>, ParentType, ContextType>;
  mainBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['LearnTag']>, ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnArticlePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnArticlePreview'] = ResolversParentTypes['LearnArticlePreview']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>;
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnArticlePreviewLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnArticlePreviewLocked'] = ResolversParentTypes['LearnArticlePreviewLocked']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  lockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnAuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnAuthor'] = ResolversParentTypes['LearnAuthor']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  photo?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnConnection'] = ResolversParentTypes['LearnConnection']> = {
  __resolveType: TypeResolveFn<'ContentPreviewConnection', ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['LearnEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['LearnPageInfo'], ParentType, ContextType>;
};

export type LearnContentCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnContentCategory'] = ResolversParentTypes['LearnContentCategory']> = {
  __resolveType: TypeResolveFn<'LearnTier' | 'LearnTopic', ParentType, ContextType>;
};

export type LearnContentCommunityStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnContentCommunityStats'] = ResolversParentTypes['LearnContentCommunityStats']> = {
  __resolveType: TypeResolveFn<'LearnContentStats', ParentType, ContextType>;
};

export type LearnContentDurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnContentDuration'] = ResolversParentTypes['LearnContentDuration']> = {
  __resolveType: TypeResolveFn<'Milliseconds', ParentType, ContextType>;
};

export type LearnContentElapsedMillisecondsUpdatedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnContentElapsedMillisecondsUpdatedResult'] = ResolversParentTypes['LearnContentElapsedMillisecondsUpdatedResult']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  elapsedTime?: Resolver<ResolversTypes['Milliseconds'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnContentInteractionStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnContentInteractionState'] = ResolversParentTypes['LearnContentInteractionState']> = {
  __resolveType: TypeResolveFn<'LearnInteractionState', ParentType, ContextType>;
};

export type LearnContentPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnContentPreview'] = ResolversParentTypes['LearnContentPreview']> = {
  __resolveType: TypeResolveFn<'CoursePreview' | 'CoursePreviewLocked' | 'LearnArticlePreview' | 'LearnArticlePreviewLocked' | 'LearnMediaPreview' | 'LearnMediaPreviewLocked' | 'LearnPollPreview' | 'LearnPollPreviewLocked' | 'LessonPreview' | 'LessonPreviewLocked' | 'QuizPreview' | 'QuizPreviewLocked', ParentType, ContextType>;
};

export type LearnContentStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnContentStats'] = ResolversParentTypes['LearnContentStats']> = {
  communityAvg?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  views?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnCourseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnCourse'] = ResolversParentTypes['LearnCourse']> = {
  __resolveType: TypeResolveFn<'Course' | 'CourseLocked', ParentType, ContextType>;
};

export type LearnCoursePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnCoursePreview'] = ResolversParentTypes['LearnCoursePreview']> = {
  __resolveType: TypeResolveFn<'CoursePreview' | 'CoursePreviewLocked', ParentType, ContextType>;
};

export type LearnEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnEdge'] = ResolversParentTypes['LearnEdge']> = {
  __resolveType: TypeResolveFn<'ContentPreviewEdge', ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type LearnHubCitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnHubCitation'] = ResolversParentTypes['LearnHubCitation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnInsightResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnInsight'] = ResolversParentTypes['LearnInsight']> = {
  cuePointMillis?: Resolver<ResolversTypes['Milliseconds'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnInteractionStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnInteractionState'] = ResolversParentTypes['LearnInteractionState']> = {
  elapsedTime?: Resolver<Maybe<ResolversTypes['LearnContentDuration']>, ParentType, ContextType>;
  isFavorites?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHelpful?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnMedia'] = ResolversParentTypes['LearnMedia']> = {
  __resolveType: TypeResolveFn<'LearnMediaArticle', ParentType, ContextType>;
};

export type LearnMediaArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnMediaArticle'] = ResolversParentTypes['LearnMediaArticle']> = {
  audioTheme?: Resolver<Maybe<ResolversTypes['LearnMediaTheme']>, ParentType, ContextType>;
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>;
  featuredImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  insights?: Resolver<Array<ResolversTypes['LearnInsight']>, ParentType, ContextType>;
  media?: Resolver<ResolversTypes['LearnMediaReference'], ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>;
  polls?: Resolver<Array<ResolversTypes['LearnPoll']>, ParentType, ContextType>;
  preEventDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startsAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['LearnTag']>, ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnMediaPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnMediaPreview'] = ResolversParentTypes['LearnMediaPreview']> = {
  audioTheme?: Resolver<Maybe<ResolversTypes['LearnMediaTheme']>, ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['LearnMediaType']>, ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>;
  startsAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnMediaPreviewLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnMediaPreviewLocked'] = ResolversParentTypes['LearnMediaPreviewLocked']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  lockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['LearnMediaType']>, ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnMediaReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnMediaReference'] = ResolversParentTypes['LearnMediaReference']> = {
  aspectRatio?: Resolver<ResolversTypes['LearnAspectRatioType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  theme?: Resolver<Maybe<ResolversTypes['LearnMediaTheme']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transcript?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LearnMediaType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnMediaThemeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnMediaTheme'] = ResolversParentTypes['LearnMediaTheme']> = {
  __resolveType: TypeResolveFn<'LearnThemeLiteral', ParentType, ContextType>;
};

export type LearnMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnMetadata'] = ResolversParentTypes['LearnMetadata']> = {
  contentStats?: Resolver<Maybe<ResolversTypes['LearnContentCommunityStats']>, ParentType, ContextType>;
  interactionState?: Resolver<Maybe<ResolversTypes['LearnContentInteractionState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnNextStepActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnNextStepAction'] = ResolversParentTypes['LearnNextStepAction']> = {
  ctaLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  illustration?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnPageInfo'] = ResolversParentTypes['LearnPageInfo']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnPollResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnPoll'] = ResolversParentTypes['LearnPoll']> = {
  cuePointMillis?: Resolver<Maybe<ResolversTypes['Milliseconds']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  options?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  pollType?: Resolver<ResolversTypes['LearnPollType'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnPollOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnPollOption'] = ResolversParentTypes['LearnPollOption']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  option?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnPollPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnPollPreview'] = ResolversParentTypes['LearnPollPreview']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  options?: Resolver<Maybe<Array<ResolversTypes['LearnPollOption']>>, ParentType, ContextType>;
  pollType?: Resolver<ResolversTypes['LearnPollType'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnPollPreviewLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnPollPreviewLocked'] = ResolversParentTypes['LearnPollPreviewLocked']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  lockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnPollResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnPollResponse'] = ResolversParentTypes['LearnPollResponse']> = {
  isSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  selectedOption?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stats?: Resolver<Maybe<Array<ResolversTypes['LearnPollOption']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnProgress'] = ResolversParentTypes['LearnProgress']> = {
  currentValue?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unitType?: Resolver<ResolversTypes['LearnProgressUnit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnProgressUpdatedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnProgressUpdatedResult'] = ResolversParentTypes['LearnProgressUpdatedResult']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['LearnProgress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnQuestion'] = ResolversParentTypes['LearnQuestion']> = {
  answers?: Resolver<Array<ResolversTypes['LearnAnswer']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  incrementStep?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  insight?: Resolver<Maybe<ResolversTypes['LearnQuestionInsight']>, ParentType, ContextType>;
  questionBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionType?: Resolver<ResolversTypes['LearnQuestionType'], ParentType, ContextType>;
  rangeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rangeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rangeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rangeType?: Resolver<Maybe<ResolversTypes['LearnRangeType']>, ParentType, ContextType>;
  statement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statementHighLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnQuestionInsightResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnQuestionInsight'] = ResolversParentTypes['LearnQuestionInsight']> = {
  featuredImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  insightText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['LearnMediaReference']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['LearnMediaType']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnQuizResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnQuiz'] = ResolversParentTypes['LearnQuiz']> = {
  __resolveType: TypeResolveFn<'Quiz' | 'QuizLocked', ParentType, ContextType>;
};

export type LearnQuizAnswerResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnQuizAnswerResult'] = ResolversParentTypes['LearnQuizAnswerResult']> = {
  isCorrect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  questionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quizId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnQuizPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnQuizPreview'] = ResolversParentTypes['LearnQuizPreview']> = {
  __resolveType: TypeResolveFn<'QuizPreview' | 'QuizPreviewLocked', ParentType, ContextType>;
};

export type LearnSearchTermSavedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnSearchTermSavedResult'] = ResolversParentTypes['LearnSearchTermSavedResult']> = {
  term?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnTag'] = ResolversParentTypes['LearnTag']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnThemeLiteralResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnThemeLiteral'] = ResolversParentTypes['LearnThemeLiteral']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnTier'] = ResolversParentTypes['LearnTier']> = {
  icon?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnTopicResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnTopic'] = ResolversParentTypes['LearnTopic']> = {
  icon?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LearnVisualAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['LearnVisualAsset'] = ResolversParentTypes['LearnVisualAsset']> = {
  __resolveType: TypeResolveFn<'Image', ParentType, ContextType>;
};

export type LegacyAlertDismissalSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyAlertDismissalSuccess'] = ResolversParentTypes['LegacyAlertDismissalSuccess']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyUploadDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyUploadDocument'] = ResolversParentTypes['LegacyUploadDocument']> = {
  documentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyUploadDocumentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyUploadDocumentResult'] = ResolversParentTypes['LegacyUploadDocumentResult']> = {
  __resolveType: TypeResolveFn<'FileDoesNotExistInS3' | 'FileTooLarge' | 'InvalidFile' | 'LegacyUploadDocument' | 'UploadDoesNotExist', ParentType, ContextType>;
};

export type LessonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Lesson'] = ResolversParentTypes['Lesson']> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  insights?: Resolver<Array<ResolversTypes['LearnInsight']>, ParentType, ContextType>;
  media?: Resolver<ResolversTypes['LearnMediaReference'], ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>;
  polls?: Resolver<Array<ResolversTypes['LearnPoll']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonPreview'] = ResolversParentTypes['LessonPreview']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  parentContentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LessonPreviewLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LessonPreviewLocked'] = ResolversParentTypes['LessonPreviewLocked']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  lockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentContentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkManualFundingSourceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkManualFundingSourceResult'] = ResolversParentTypes['LinkManualFundingSourceResult']> = {
  __resolveType: TypeResolveFn<'CurrentBankStatementNotProvided' | 'FundingSourceAccount' | 'FundingSourceAlreadyExists' | 'FundingSourceCredentialsExceedLinkLimit' | 'InvalidAccountNumber' | 'InvalidManualLink' | 'InvalidRoutingNumber' | 'PreviousFundingSourcePending' | 'RdvVerificationRequired', ParentType, ContextType>;
};

export type LinkOidcCredentialsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkOidcCredentialsResult'] = ResolversParentTypes['LinkOidcCredentialsResult']> = {
  __resolveType: TypeResolveFn<'InvalidAppleAccountException' | 'InvalidIdentityTokenException' | 'LinkOidcCredentialsSuccess' | 'OidcCredentialsAlreadyLinkedException' | 'OidcCredentialsTakenException', ParentType, ContextType>;
};

export type LinkOidcCredentialsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkOidcCredentialsSuccess'] = ResolversParentTypes['LinkOidcCredentialsSuccess']> = {
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>;
  oidcProvider?: Resolver<ResolversTypes['OidcProvider'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkSessionResult'] = ResolversParentTypes['LinkSessionResult']> = {
  __resolveType: TypeResolveFn<'RawLinkSession' | 'UnrecoverableLinkedAccountError' | 'WebviewLinkSession', ParentType, ContextType>;
};

export type LinkedAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedAccount'] = ResolversParentTypes['LinkedAccount']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  externalSource?: Resolver<ResolversTypes['LinkedAccountExternalSourceEnum'], ParentType, ContextType>;
  financialInstitution?: Resolver<Maybe<ResolversTypes['FinancialInstitution']>, ParentType, ContextType>;
  financialInstitutionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institutionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedSubaccounts?: Resolver<Array<ResolversTypes['LinkedSubaccount']>, ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LinkedAccountStatusEnum'], ParentType, ContextType>;
  transactionsLastSyncedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkedAccountAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedAccountAlert'] = ResolversParentTypes['LinkedAccountAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkedAccountAlertsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedAccountAlertsResponse'] = ResolversParentTypes['LinkedAccountAlertsResponse']> = {
  __resolveType: TypeResolveFn<'LinkedAccountAlert' | 'RelinkLinkedAccountAlert', ParentType, ContextType>;
};

export type LinkedAccountNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedAccountNotFound'] = ResolversParentTypes['LinkedAccountNotFound']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkedSubaccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedSubaccount'] = ResolversParentTypes['LinkedSubaccount']> = {
  accountNumberLastFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allowedRoles?: Resolver<Array<ResolversTypes['LinkedSubaccountRoleEnum']>, ParentType, ContextType>;
  balanceAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceCurrent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceLimit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  linked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedAccount?: Resolver<ResolversTypes['LinkedAccount'], ParentType, ContextType>;
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  officialName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentEngines?: Resolver<Array<ResolversTypes['LinkedSubaccountPaymentEngineEnum']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['LinkedSubaccountRoleEnum']>, ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FundingSourceStatusEnum']>, ParentType, ContextType>;
  subaccountSubtype?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subaccountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionsLastSyncedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transfersApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  transfersAtRisk?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiquidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Liquidation'] = ResolversParentTypes['Liquidation']> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  billingCycle?: Resolver<ResolversTypes['BillingCycle'], ParentType, ContextType>;
  billingCycleId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  collectedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  feeExecutions?: Resolver<Array<Maybe<ResolversTypes['FeeExecution']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  requestedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiquidationUnavailableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiquidationUnavailableError'] = ResolversParentTypes['LiquidationUnavailableError']> = {
  reason?: Resolver<ResolversTypes['LiquidationUnavailableReason'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LockBankCardPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['LockBankCardPayload'] = ResolversParentTypes['LockBankCardPayload']> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoginAccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginAccess'] = ResolversParentTypes['LoginAccess']> = {
  loginAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  loginRevokedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  loginRevokedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoginRateLimitedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginRateLimitedException'] = ResolversParentTypes['LoginRateLimitedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoutDeviceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutDeviceResult'] = ResolversParentTypes['LogoutDeviceResult']> = {
  __resolveType: TypeResolveFn<'DeviceNotFoundException' | 'LogoutDeviceSuccess' | 'RefreshTokenNotFoundException', ParentType, ContextType>;
};

export type LogoutDeviceSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutDeviceSuccess'] = ResolversParentTypes['LogoutDeviceSuccess']> = {
  Device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoutResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutResult'] = ResolversParentTypes['LogoutResult']> = {
  __resolveType: TypeResolveFn<'AuthTokenNotFoundException' | 'LogoutSuccess' | 'RefreshTokenNotFoundException', ParentType, ContextType>;
};

export type LogoutSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutSuccess'] = ResolversParentTypes['LogoutSuccess']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MakeInvestmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MakeInvestmentPayload'] = ResolversParentTypes['MakeInvestmentPayload']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MalformedRecurringTransferExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MalformedRecurringTransferException'] = ResolversParentTypes['MalformedRecurringTransferException']> = {
  pathExceptions?: Resolver<Array<ResolversTypes['RecurringTransferPathException']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarkAllAsReadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkAllAsReadResult'] = ResolversParentTypes['MarkAllAsReadResult']> = {
  __resolveType: TypeResolveFn<'MarkAllAsReadSuccess' | 'UpdateMessageFailed', ParentType, ContextType>;
};

export type MarkAllAsReadSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkAllAsReadSuccess'] = ResolversParentTypes['MarkAllAsReadSuccess']> = {
  markedAsReadCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarkLearnContentAsHelpfulResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkLearnContentAsHelpfulResult'] = ResolversParentTypes['MarkLearnContentAsHelpfulResult']> = {
  __resolveType: TypeResolveFn<'RecordDoesNotExistError' | 'UpdateLearnContentHelpfulnessResult', ParentType, ContextType>;
};

export type MarkLearnContentAsViewedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkLearnContentAsViewedResult'] = ResolversParentTypes['MarkLearnContentAsViewedResult']> = {
  __resolveType: TypeResolveFn<'RecordDoesNotExistError' | 'ViewedLearnContentResult', ParentType, ContextType>;
};

export type MarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['Market'] = ResolversParentTypes['Market']> = {
  isOpen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketReturn'] = ResolversParentTypes['MarketReturn']> = {
  marketValue?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchProgramResolvers<ContextType = any, ParentType extends ResolversParentTypes['MatchProgram'] = ResolversParentTypes['MatchProgram']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eligibleInvestmentAccountTypes?: Resolver<Array<ResolversTypes['InvestmentAccountType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  matchPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiredContributionVestingDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tier?: Resolver<Maybe<ResolversTypes['Tier']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MaxAccountsCreatedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MaxAccountsCreatedException'] = ResolversParentTypes['MaxAccountsCreatedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  __resolveType: TypeResolveFn<'AlertMessage' | 'NotificationMessage', ParentType, ContextType>;
  body?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>;
  cardColor?: Resolver<Maybe<ResolversTypes['CardColor']>, ParentType, ContextType>;
  deepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  delay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['MessageVisualAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messageCategory?: Resolver<Maybe<ResolversTypes['MessageCategory']>, ParentType, ContextType>;
  messageType?: Resolver<ResolversTypes['MessageType'], ParentType, ContextType>;
  platforms?: Resolver<Array<ResolversTypes['Platform']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>;
  trackingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type MessageConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageConnection'] = ResolversParentTypes['MessageConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MessageEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['MessagePageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEdge'] = ResolversParentTypes['MessageEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagePageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagePageInfo'] = ResolversParentTypes['MessagePageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageTextAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageTextAsset'] = ResolversParentTypes['MessageTextAsset']> = {
  __resolveType: TypeResolveFn<'StringKeyAsset', ParentType, ContextType>;
};

export type MessageVisualAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageVisualAsset'] = ResolversParentTypes['MessageVisualAsset']> = {
  __resolveType: TypeResolveFn<'DesignLibraryIcon' | 'Image', ParentType, ContextType>;
};

export type MfaMissingAuthAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['MfaMissingAuthAlert'] = ResolversParentTypes['MfaMissingAuthAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface MicrosScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Micros'], any> {
  name: 'Micros';
}

export type MicrosMoneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['MicrosMoney'] = ResolversParentTypes['MicrosMoney']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Micros'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MightyOakCardWaiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['MightyOakCardWaiver'] = ResolversParentTypes['MightyOakCardWaiver']> = {
  mightyOakCardWaiverPeriodEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MightyOakCardWaiverExpiredExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MightyOakCardWaiverExpiredException'] = ResolversParentTypes['MightyOakCardWaiverExpiredException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MightyOakCardWaiverNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MightyOakCardWaiverNotFoundException'] = ResolversParentTypes['MightyOakCardWaiverNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MightyOakWaiverResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MightyOakWaiverResult'] = ResolversParentTypes['MightyOakWaiverResult']> = {
  __resolveType: TypeResolveFn<'BillingProfileNotFoundException' | 'MightyOakCardWaiver' | 'MightyOakCardWaiverExpiredException' | 'MightyOakCardWaiverNotFoundException', ParentType, ContextType>;
};

export type MilestoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['Milestone'] = ResolversParentTypes['Milestone']> = {
  accountPoints?: Resolver<ResolversTypes['AccountPoints'], ParentType, ContextType>;
  challengePoints?: Resolver<Maybe<ResolversTypes['ChallengePointsEarned']>, ParentType, ContextType, RequireFields<MilestoneChallengePointsArgs, 'challengeId'>>;
  descriptionKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['Destination']>, ParentType, ContextType>;
  detailsKey?: Resolver<Maybe<ResolversTypes['StringKey']>, ParentType, ContextType>;
  educationTip?: Resolver<ResolversTypes['EducationTip'], ParentType, ContextType>;
  firstCompletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inactiveLogo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  isRepeatable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastCompletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['MilestoneProgress'], ParentType, ContextType>;
  rule?: Resolver<ResolversTypes['MilestoneRuleType'], ParentType, ContextType>;
  simpleNameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MilestoneStatus'], ParentType, ContextType>;
  theme?: Resolver<ResolversTypes['MilestoneTheme'], ParentType, ContextType>;
  timesCompleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneAccountLevelDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneAccountLevelDefinition'] = ResolversParentTypes['MilestoneAccountLevelDefinition']> = {
  activeBackground?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  activeForeground?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inactiveBackground?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneAchievementActionRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneAchievementActionRule'] = ResolversParentTypes['MilestoneAchievementActionRule']> = {
  actions?: Resolver<Array<ResolversTypes['MilestoneAchievementActionType']>, ParentType, ContextType>;
  milestoneID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneChallengeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneChallenge'] = ResolversParentTypes['MilestoneChallenge']> = {
  closingAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endsAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  faqDeepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  groupedMilestones?: Resolver<Array<ResolversTypes['MilestoneGroup']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  milestonesCompleted?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pointsEarned?: Resolver<Maybe<ResolversTypes['DiscreteMilestoneProgress']>, ParentType, ContextType>;
  rulesDeepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneChallengePointsRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneChallengePointsRule'] = ResolversParentTypes['MilestoneChallengePointsRule']> = {
  challengeID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxPointsAllowed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pointsPerCompletion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneDefinition'] = ResolversParentTypes['MilestoneDefinition']> = {
  accountPointsRule?: Resolver<Maybe<ResolversTypes['AccountPointsRule']>, ParentType, ContextType>;
  arg1DateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  arg1Int?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  challengePointsRule?: Resolver<Maybe<ResolversTypes['MilestoneChallengePointsRule']>, ParentType, ContextType, RequireFields<MilestoneDefinitionChallengePointsRuleArgs, 'challengeId'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inactiveLogo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  isRepeatable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  milestoneGroups?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rule?: Resolver<ResolversTypes['MilestoneRule'], ParentType, ContextType>;
  theme?: Resolver<ResolversTypes['MilestoneTheme'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneEligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneEligibility'] = ResolversParentTypes['MilestoneEligibility']> = {
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['MilestoneEligibilityScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneGroup'] = ResolversParentTypes['MilestoneGroup']> = {
  __resolveType: TypeResolveFn<'MilestoneRuleGroup' | 'MilestoneThemeGroup', ParentType, ContextType>;
};

export type MilestoneGroupAchievementActionRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneGroupAchievementActionRule'] = ResolversParentTypes['MilestoneGroupAchievementActionRule']> = {
  actions?: Resolver<Array<ResolversTypes['MilestoneAchievementActionType']>, ParentType, ContextType>;
  milestoneGroupID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneGroupDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneGroupDefinition'] = ResolversParentTypes['MilestoneGroupDefinition']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  milestoneIDs?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneHubResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneHub'] = ResolversParentTypes['MilestoneHub']> = {
  groupedMilestones?: Resolver<Array<ResolversTypes['MilestoneGroup']>, ParentType, ContextType>;
  levelDefinitions?: Resolver<Array<ResolversTypes['MilestoneAccountLevelDefinition']>, ParentType, ContextType>;
  userAccount?: Resolver<ResolversTypes['MilestoneHubAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneHubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneHubAccount'] = ResolversParentTypes['MilestoneHubAccount']> = {
  accountPointsProgress?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>;
  currentLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  milestoneProgress?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneHubDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneHubDefinition'] = ResolversParentTypes['MilestoneHubDefinition']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  milestoneIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneProgress'] = ResolversParentTypes['MilestoneProgress']> = {
  __resolveType: TypeResolveFn<'CurrencyMilestoneProgress' | 'DiscreteMilestoneProgress', ParentType, ContextType>;
};

export type MilestoneRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneRule'] = ResolversParentTypes['MilestoneRule']> = {
  argInput?: Resolver<ResolversTypes['MilestoneRuleArgInput'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  themes?: Resolver<Array<ResolversTypes['MilestoneTheme']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneRuleGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneRuleGroup'] = ResolversParentTypes['MilestoneRuleGroup']> = {
  contents?: Resolver<Array<ResolversTypes['MilestoneRuleGroupContent']>, ParentType, ContextType>;
  descriptionKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  groupCompletion?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  nameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  rule?: Resolver<ResolversTypes['MilestoneRuleType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneRuleGroupContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneRuleGroupContent'] = ResolversParentTypes['MilestoneRuleGroupContent']> = {
  __resolveType: TypeResolveFn<'Milestone', ParentType, ContextType>;
};

export type MilestoneThemeGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneThemeGroup'] = ResolversParentTypes['MilestoneThemeGroup']> = {
  contents?: Resolver<Array<ResolversTypes['MilestoneThemeGroupContent']>, ParentType, ContextType>;
  descriptionKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['Destination']>, ParentType, ContextType>;
  groupCompletion?: Resolver<ResolversTypes['DiscreteMilestoneProgress'], ParentType, ContextType>;
  groupPointsProgress?: Resolver<Maybe<ResolversTypes['DiscreteMilestoneProgress']>, ParentType, ContextType>;
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  nameKey?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  theme?: Resolver<ResolversTypes['MilestoneTheme'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MilestoneThemeGroupContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MilestoneThemeGroupContent'] = ResolversParentTypes['MilestoneThemeGroupContent']> = {
  __resolveType: TypeResolveFn<'Milestone' | 'MilestoneRuleGroup', ParentType, ContextType>;
};

export type MillisecondsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Milliseconds'] = ResolversParentTypes['Milliseconds']> = {
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MiscDocumentRequestedUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['MiscDocumentRequestedUserAlert'] = ResolversParentTypes['MiscDocumentRequestedUserAlert']> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MismatchedDistributionUnitsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MismatchedDistributionUnitsError'] = ResolversParentTypes['MismatchedDistributionUnitsError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingAgreementsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingAgreementsException'] = ResolversParentTypes['MissingAgreementsException']> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingBeneficiarySsnExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingBeneficiarySsnException'] = ResolversParentTypes['MissingBeneficiarySsnException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingFundingSourceExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingFundingSourceException'] = ResolversParentTypes['MissingFundingSourceException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingRequiredAgreementsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingRequiredAgreementsException'] = ResolversParentTypes['MissingRequiredAgreementsException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingSsnBeneficiaryAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingSsnBeneficiaryAlert'] = ResolversParentTypes['MissingSsnBeneficiaryAlert']> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingSsnBeneficiaryAlertItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingSsnBeneficiaryAlertItem'] = ResolversParentTypes['MissingSsnBeneficiaryAlertItem']> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingValidRulesetErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingValidRulesetError'] = ResolversParentTypes['MissingValidRulesetError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModifyMoneyAssignmentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModifyMoneyAssignmentResult'] = ResolversParentTypes['ModifyMoneyAssignmentResult']> = {
  __resolveType: TypeResolveFn<'ModifyMoneyAssignmentSuccess' | 'MoneyAssignmentAlreadyTransferredError' | 'MoneyAssignmentNotFoundError', ParentType, ContextType>;
};

export type ModifyMoneyAssignmentSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModifyMoneyAssignmentSuccess'] = ResolversParentTypes['ModifyMoneyAssignmentSuccess']> = {
  moneyAssignment?: Resolver<ResolversTypes['MoneyManagerMoneyAssignment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonetaryAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonetaryAmount'] = ResolversParentTypes['MonetaryAmount']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonetaryIncentiveResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonetaryIncentive'] = ResolversParentTypes['MonetaryIncentive']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  copyKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  recurring?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyAssignmentAlreadyTransferredErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyAssignmentAlreadyTransferredError'] = ResolversParentTypes['MoneyAssignmentAlreadyTransferredError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyAssignmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyAssignmentConnection'] = ResolversParentTypes['MoneyAssignmentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MoneyAssignmentEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['MoneyManagerPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyAssignmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyAssignmentEdge'] = ResolversParentTypes['MoneyAssignmentEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MoneyManagerMoneyAssignment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyAssignmentNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyAssignmentNotFoundError'] = ResolversParentTypes['MoneyAssignmentNotFoundError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerAllocation'] = ResolversParentTypes['MoneyManagerAllocation']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  associatedTransferId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  beneficiary?: Resolver<Maybe<ResolversTypes['Beneficiary']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  destinationAccount?: Resolver<ResolversTypes['MoneyRulesDestination'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyAssignment?: Resolver<ResolversTypes['MoneyManagerMoneyAssignment'], ParentType, ContextType>;
  rule?: Resolver<ResolversTypes['MoneyRulesRule'], ParentType, ContextType>;
  rules?: Resolver<Array<ResolversTypes['MoneyRulesRule']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MoneyManagerAllocationStatus'], ParentType, ContextType>;
  transferId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerAllocationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerAllocationOption'] = ResolversParentTypes['MoneyManagerAllocationOption']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  normalizedAmounts?: Resolver<Maybe<ResolversTypes['MoneyManagerNormalizedAmounts']>, ParentType, ContextType>;
  otherAccountsRemainder?: Resolver<ResolversTypes['MoneyManagerAllocationRemainder'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  remainder?: Resolver<ResolversTypes['MoneyManagerAllocationRemainder'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerAllocationRemainderResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerAllocationRemainder'] = ResolversParentTypes['MoneyManagerAllocationRemainder']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerAllocationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerAllocationResult'] = ResolversParentTypes['MoneyManagerAllocationResult']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  destinationAccount?: Resolver<ResolversTypes['MoneyRulesDestination'], ParentType, ContextType>;
  rulePriority?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerAutomationTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerAutomationTarget'] = ResolversParentTypes['MoneyManagerAutomationTarget']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  customSelection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  suggestedPeriod?: Resolver<Maybe<ResolversTypes['MoneyManagerPeriod']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MoneyManagerAutomationTargetType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerCascadeObjectiveResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerCascadeObjective'] = ResolversParentTypes['MoneyManagerCascadeObjective']> = {
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  objectiveType?: Resolver<ResolversTypes['MoneyManagerCascadeObjectiveType'], ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['MoneyManagerCascadeTarget']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerCascadeTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerCascadeTarget'] = ResolversParentTypes['MoneyManagerCascadeTarget']> = {
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progressAmount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  progressPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerCategoriesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerCategoriesResult'] = ResolversParentTypes['MoneyManagerCategoriesResult']> = {
  __resolveType: TypeResolveFn<'MoneyManagerCategoriesSuccess', ParentType, ContextType>;
};

export type MoneyManagerCategoriesSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerCategoriesSuccess'] = ResolversParentTypes['MoneyManagerCategoriesSuccess']> = {
  categories?: Resolver<Array<ResolversTypes['MoneyManagerCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerCategory'] = ResolversParentTypes['MoneyManagerCategory']> = {
  allocations?: Resolver<Array<ResolversTypes['MoneyManagerCategoryAllocation']>, ParentType, ContextType>;
  categoryAmount?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  categoryPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  categoryType?: Resolver<ResolversTypes['MoneyManagerCategoryType'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerCategoryAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerCategoryAllocation'] = ResolversParentTypes['MoneyManagerCategoryAllocation']> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  beneficiary?: Resolver<Maybe<ResolversTypes['Beneficiary']>, ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  normalizedAmounts?: Resolver<Maybe<ResolversTypes['MoneyManagerNormalizedAmounts']>, ParentType, ContextType>;
  notEditableReason?: Resolver<Maybe<ResolversTypes['MoneyManagerAllocationNotEditableReason']>, ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  singleRuleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerDeposit'] = ResolversParentTypes['MoneyManagerDeposit']> = {
  __resolveType: TypeResolveFn<'MoneyManagerPaycheck' | 'MoneyManagerRecurringDeposit', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['MoneyManagerDepositCategory'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MoneyManagerDepositAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerDepositAssignment'] = ResolversParentTypes['MoneyManagerDepositAssignment']> = {
  allocations?: Resolver<Array<ResolversTypes['MoneyManagerAllocation']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  cancelReason?: Resolver<Maybe<ResolversTypes['MoneyManagerCancelReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deposit?: Resolver<ResolversTypes['MoneyManagerDeposit'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MoneyManagerMoneyAssignmentStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MoneyManagerMoneyAssignmentType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerDepositSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerDepositSummary'] = ResolversParentTypes['MoneyManagerDepositSummary']> = {
  amount?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  depositType?: Resolver<Maybe<ResolversTypes['MoneyManagerDepositCategory']>, ParentType, ContextType>;
  pendingMoneyAssignment?: Resolver<Maybe<ResolversTypes['MoneyManagerMoneyAssignment']>, ParentType, ContextType>;
  predictedDepositAmount?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['MoneyManagerDepositState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerEligibilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerEligibilityResult'] = ResolversParentTypes['MoneyManagerEligibilityResult']> = {
  ineligibleReasons?: Resolver<Maybe<Array<ResolversTypes['IneligibleReasons']>>, ParentType, ContextType>;
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerError'] = ResolversParentTypes['MoneyManagerError']> = {
  __resolveType: TypeResolveFn<'MoneyManagerInputError' | 'MoneyManagerRulesetNotFoundError', ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MoneyManagerGlobalConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerGlobalConfig'] = ResolversParentTypes['MoneyManagerGlobalConfig']> = {
  recurringDepositsConfig?: Resolver<ResolversTypes['MoneyManagerRecurringDepositsConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerInputErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerInputError'] = ResolversParentTypes['MoneyManagerInputError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerMoneyAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerMoneyAssignment'] = ResolversParentTypes['MoneyManagerMoneyAssignment']> = {
  __resolveType: TypeResolveFn<'MoneyManagerDepositAssignment' | 'MoneyManagerRebalanceAssignment', ParentType, ContextType>;
  allocations?: Resolver<Array<ResolversTypes['MoneyManagerAllocation']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  cancelReason?: Resolver<Maybe<ResolversTypes['MoneyManagerCancelReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MoneyManagerMoneyAssignmentStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MoneyManagerMoneyAssignmentType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MoneyManagerNormalizedAmountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerNormalizedAmounts'] = ResolversParentTypes['MoneyManagerNormalizedAmounts']> = {
  daily?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  monthly?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  weekly?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  yearly?: Resolver<Maybe<ResolversTypes['MoneyRulesCurrencyAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerPageInfo'] = ResolversParentTypes['MoneyManagerPageInfo']> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerPaycheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerPaycheck'] = ResolversParentTypes['MoneyManagerPaycheck']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['MoneyManagerDepositCategory'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerPeriod'] = ResolversParentTypes['MoneyManagerPeriod']> = {
  unit?: Resolver<ResolversTypes['MoneyManagerPeriodUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerRebalanceAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerRebalanceAssignment'] = ResolversParentTypes['MoneyManagerRebalanceAssignment']> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  allocations?: Resolver<Array<ResolversTypes['MoneyManagerAllocation']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  cancelReason?: Resolver<Maybe<ResolversTypes['MoneyManagerCancelReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceAccountType?: Resolver<ResolversTypes['MoneyManagerRebalanceSourceAccountType'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MoneyManagerMoneyAssignmentStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MoneyManagerMoneyAssignmentType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerRebalanceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerRebalanceResult'] = ResolversParentTypes['MoneyManagerRebalanceResult']> = {
  allocations?: Resolver<Array<ResolversTypes['MoneyManagerAllocationResult']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  ruleset?: Resolver<ResolversTypes['MoneyManagerRebalanceRuleset'], ParentType, ContextType>;
  sourceAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceAccountType?: Resolver<ResolversTypes['MoneyManagerRebalanceSourceAccountType'], ParentType, ContextType>;
  sourceAmount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerRebalanceRulesetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerRebalanceRuleset'] = ResolversParentTypes['MoneyManagerRebalanceRuleset']> = {
  archetype?: Resolver<ResolversTypes['MoneyRulesArchetype'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerRebalancesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerRebalancesResponse'] = ResolversParentTypes['MoneyManagerRebalancesResponse']> = {
  rebalances?: Resolver<Array<Maybe<ResolversTypes['MoneyManagerRebalanceResult']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerRecurringDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerRecurringDeposit'] = ResolversParentTypes['MoneyManagerRecurringDeposit']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['MoneyManagerDepositCategory'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerRecurringDepositsConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerRecurringDepositsConfig'] = ResolversParentTypes['MoneyManagerRecurringDepositsConfig']> = {
  allowedFrequencies?: Resolver<Array<ResolversTypes['MoneyManagerRecurringFrequency']>, ParentType, ContextType>;
  maximumAmount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  minimumAmount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerRulesetNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerRulesetNotFoundError'] = ResolversParentTypes['MoneyManagerRulesetNotFoundError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerScheduledDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerScheduledDeposit'] = ResolversParentTypes['MoneyManagerScheduledDeposit']> = {
  __resolveType: TypeResolveFn<'MoneyManagerScheduledPaycheck' | 'MoneyManagerScheduledRecurringDeposit', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  expectedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
};

export type MoneyManagerScheduledPaycheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerScheduledPaycheck'] = ResolversParentTypes['MoneyManagerScheduledPaycheck']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerScheduledRecurringDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerScheduledRecurringDeposit'] = ResolversParentTypes['MoneyManagerScheduledRecurringDeposit']> = {
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  expectedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerSettings'] = ResolversParentTypes['MoneyManagerSettings']> = {
  depositSources?: Resolver<Array<ResolversTypes['MoneyRulesSourceSetting']>, ParentType, ContextType>;
  processRecurringDeposits?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MoneyManagerStatus'], ParentType, ContextType>;
  suppressRebalancesUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerSourceSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerSourceSetting'] = ResolversParentTypes['MoneyManagerSourceSetting']> = {
  depositType?: Resolver<ResolversTypes['MoneyRulesDepositType'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyManagerSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyManagerSummary'] = ResolversParentTypes['MoneyManagerSummary']> = {
  depositSummary?: Resolver<ResolversTypes['MoneyManagerDepositSummary'], ParentType, ContextType>;
  receivedThisPeriodAmount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  scheduledThisPeriodAmount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['MoneyManagerState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesArchetypesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesArchetypesResult'] = ResolversParentTypes['MoneyRulesArchetypesResult']> = {
  __resolveType: TypeResolveFn<'MoneyRulesArchetypesSuccess', ParentType, ContextType>;
};

export type MoneyRulesArchetypesSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesArchetypesSuccess'] = ResolversParentTypes['MoneyRulesArchetypesSuccess']> = {
  rulesets?: Resolver<Array<ResolversTypes['MoneyRulesRuleset']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesCancelMoneyAssignmentSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesCancelMoneyAssignmentSuccess'] = ResolversParentTypes['MoneyRulesCancelMoneyAssignmentSuccess']> = {
  moneyAssignment?: Resolver<ResolversTypes['MoneyManagerMoneyAssignment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesCondition'] = ResolversParentTypes['MoneyRulesCondition']> = {
  fallback?: Resolver<Maybe<ResolversTypes['MoneyRulesDestination']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MoneyRulesConditionType'], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['MoneyRulesConditionUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesCurrencyAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesCurrencyAmount'] = ResolversParentTypes['MoneyRulesCurrencyAmount']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesDestinationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesDestination'] = ResolversParentTypes['MoneyRulesDestination']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['MoneyRulesAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesDistributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesDistribution'] = ResolversParentTypes['MoneyRulesDistribution']> = {
  unit?: Resolver<ResolversTypes['MoneyRulesDistributionUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesMoneySourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesMoneySource'] = ResolversParentTypes['MoneyRulesMoneySource']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['MoneyRulesAccountType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MoneyRulesCurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesMoneySplitResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesMoneySplit'] = ResolversParentTypes['MoneyRulesMoneySplit']> = {
  destination?: Resolver<ResolversTypes['MoneyRulesDestination'], ParentType, ContextType>;
  distribution?: Resolver<ResolversTypes['MoneyRulesDistribution'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesRule'] = ResolversParentTypes['MoneyRulesRule']> = {
  conditions?: Resolver<Array<ResolversTypes['MoneyRulesCondition']>, ParentType, ContextType>;
  destination?: Resolver<ResolversTypes['MoneyRulesDestination'], ParentType, ContextType>;
  distribution?: Resolver<ResolversTypes['MoneyRulesDistribution'], ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ruleType?: Resolver<ResolversTypes['MoneyRulesRuleType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesRulesetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesRuleset'] = ResolversParentTypes['MoneyRulesRuleset']> = {
  archetype?: Resolver<ResolversTypes['MoneyRulesArchetype'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  isCustomized?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  minimumAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rules?: Resolver<Array<ResolversTypes['MoneyRulesRule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesRulesetNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesRulesetNotFoundException'] = ResolversParentTypes['MoneyRulesRulesetNotFoundException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesSettings'] = ResolversParentTypes['MoneyRulesSettings']> = {
  depositSources?: Resolver<Array<ResolversTypes['MoneyRulesSourceSetting']>, ParentType, ContextType>;
  moneyManagerEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  processRecurringDeposits?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesSourceSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesSourceSetting'] = ResolversParentTypes['MoneyRulesSourceSetting']> = {
  depositType?: Resolver<ResolversTypes['MoneyRulesDepositType'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesSuggestedSplitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesSuggestedSplits'] = ResolversParentTypes['MoneyRulesSuggestedSplits']> = {
  moneySource?: Resolver<ResolversTypes['MoneyRulesMoneySource'], ParentType, ContextType>;
  rulesetVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  splits?: Resolver<Array<Maybe<ResolversTypes['MoneyRulesMoneySplit']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyRulesSuggestionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesSuggestionResult'] = ResolversParentTypes['MoneyRulesSuggestionResult']> = {
  __resolveType: TypeResolveFn<'MoneyRulesSuggestedSplits', ParentType, ContextType>;
};

export type MoneyRulesUpdateArchetypeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesUpdateArchetypeResult'] = ResolversParentTypes['MoneyRulesUpdateArchetypeResult']> = {
  __resolveType: TypeResolveFn<'MoneyRulesUpdateRulesetSuccess', ParentType, ContextType>;
};

export type MoneyRulesUpdateCustomerMoneyRulesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesUpdateCustomerMoneyRulesResult'] = ResolversParentTypes['MoneyRulesUpdateCustomerMoneyRulesResult']> = {
  __resolveType: TypeResolveFn<'MoneyRulesUpdateRulesetSuccess', ParentType, ContextType>;
};

export type MoneyRulesUpdateRulesetSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyRulesUpdateRulesetSuccess'] = ResolversParentTypes['MoneyRulesUpdateRulesetSuccess']> = {
  resultingRuleset?: Resolver<ResolversTypes['MoneyRulesRuleset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonthlyTotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthlyTotal'] = ResolversParentTypes['MonthlyTotal']> = {
  isPredicted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FormattedMonetaryAmount'], ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  _placeholder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  acceptDocument?: Resolver<ResolversTypes['AcceptDocumentResponse'], ParentType, ContextType, RequireFields<MutationAcceptDocumentArgs, 'input'>>;
  activateBankCard?: Resolver<Maybe<ResolversTypes['ActivateBankCardPayload']>, ParentType, ContextType, RequireFields<MutationActivateBankCardArgs, 'input'>>;
  addCohortEligibility?: Resolver<ResolversTypes['AddCohortEligibilityResult'], ParentType, ContextType, RequireFields<MutationAddCohortEligibilityArgs, 'input'>>;
  addFavoritePartnerOffers?: Resolver<ResolversTypes['FavoritePartnerOfferGroup'], ParentType, ContextType, RequireFields<MutationAddFavoritePartnerOffersArgs, 'input'>>;
  addSearchTermToLearnSearchHistory?: Resolver<ResolversTypes['AddSearchTermToLearnSearchHistoryResult'], ParentType, ContextType, RequireFields<MutationAddSearchTermToLearnSearchHistoryArgs, 'input'>>;
  addSecurityToPortfolio?: Resolver<ResolversTypes['AddSecurityToPortfolioResult'], ParentType, ContextType, RequireFields<MutationAddSecurityToPortfolioArgs, 'input'>>;
  addSelfDirectedPortfolio?: Resolver<ResolversTypes['AddSelfDirectedPortfolioResult'], ParentType, ContextType, RequireFields<MutationAddSelfDirectedPortfolioArgs, 'input'>>;
  addTrustedContact?: Resolver<ResolversTypes['UpdateTrustedContactResult'], ParentType, ContextType, RequireFields<MutationAddTrustedContactArgs, 'input'>>;
  agreeToAcceptanceDocument?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationAgreeToAcceptanceDocumentArgs, 'id'>>;
  answerChallenge?: Resolver<ResolversTypes['AnswerChallengeResult'], ParentType, ContextType, RequireFields<MutationAnswerChallengeArgs, 'input'>>;
  answerLearnQuizQuestion?: Resolver<ResolversTypes['AnswerLearnQuizQuestionResult'], ParentType, ContextType, RequireFields<MutationAnswerLearnQuizQuestionArgs, 'input'>>;
  applyPromotion?: Resolver<ResolversTypes['ApplyPromotionResult'], ParentType, ContextType, RequireFields<MutationApplyPromotionArgs, 'input'>>;
  applyPromotionalWaiver?: Resolver<Maybe<ResolversTypes['ApplyPromotionalWaiverResult']>, ParentType, ContextType, RequireFields<MutationApplyPromotionalWaiverArgs, 'input'>>;
  applyProvisionalWaiver?: Resolver<Maybe<ResolversTypes['ApplyProvisionalWaiverResult']>, ParentType, ContextType, RequireFields<MutationApplyProvisionalWaiverArgs, 'waiverPeriodEndDate' | 'waiverReason'>>;
  archiveInvalidSmartDepositSettings?: Resolver<ResolversTypes['ArchiveInvalidSmartDepositRecordsResult'], ParentType, ContextType>;
  askFinancialAdvisorQuestion?: Resolver<ResolversTypes['FinancialAdvisorQuestionResponse'], ParentType, ContextType, RequireFields<MutationAskFinancialAdvisorQuestionArgs, 'question' | 'sessionId'>>;
  assignLinkedSubaccount?: Resolver<Maybe<ResolversTypes['LinkedSubaccount']>, ParentType, ContextType, RequireFields<MutationAssignLinkedSubaccountArgs, 'input' | 'linkedSubaccountId'>>;
  authenticate?: Resolver<ResolversTypes['AuthenticateResult'], ParentType, ContextType, RequireFields<MutationAuthenticateArgs, 'input'>>;
  authenticateForFeeNegotiation?: Resolver<ResolversTypes['AuthenticateForFeeNegotiationResult'], ParentType, ContextType, RequireFields<MutationAuthenticateForFeeNegotiationArgs, 'input'>>;
  authenticateForFeeNegotiationChallenge?: Resolver<ResolversTypes['AuthenticateNegotiationStatusResult'], ParentType, ContextType, RequireFields<MutationAuthenticateForFeeNegotiationChallengeArgs, 'input'>>;
  authenticateForFeeNegotiationChallengeMethod?: Resolver<ResolversTypes['AuthenticateNegotiationStatusResult'], ParentType, ContextType, RequireFields<MutationAuthenticateForFeeNegotiationChallengeMethodArgs, 'input'>>;
  batchAddTierSubscriptions?: Resolver<ResolversTypes['BatchAddTierSubscriptionsResult'], ParentType, ContextType, RequireFields<MutationBatchAddTierSubscriptionsArgs, 'input'>>;
  blockDevice?: Resolver<ResolversTypes['BlockDeviceResult'], ParentType, ContextType, RequireFields<MutationBlockDeviceArgs, 'input'>>;
  cancelCheckPayment?: Resolver<Maybe<ResolversTypes['CancelCheckPaymentResult']>, ParentType, ContextType, RequireFields<MutationCancelCheckPaymentArgs, 'id'>>;
  cancelIntent?: Resolver<ResolversTypes['CancelIntentResult'], ParentType, ContextType, RequireFields<MutationCancelIntentArgs, 'nonce'>>;
  cancelInvestment?: Resolver<ResolversTypes['CancelInvestmentResult'], ParentType, ContextType, RequireFields<MutationCancelInvestmentArgs, 'input'>>;
  cancelInvestmentAccountClosureRequest?: Resolver<ResolversTypes['CancelInvestmentAccountClosureRequestResult'], ParentType, ContextType, RequireFields<MutationCancelInvestmentAccountClosureRequestArgs, 'input'>>;
  cancelMoneyAssignment?: Resolver<Maybe<ResolversTypes['CancelMoneyAssignmentResult']>, ParentType, ContextType, RequireFields<MutationCancelMoneyAssignmentArgs, 'input'>>;
  cancelRecurringTransfer?: Resolver<Maybe<ResolversTypes['CancelRecurringTransferResult']>, ParentType, ContextType, RequireFields<MutationCancelRecurringTransferArgs, 'id'>>;
  cancelTransfer?: Resolver<Maybe<ResolversTypes['CancelTransferPayload']>, ParentType, ContextType, RequireFields<MutationCancelTransferArgs, 'accountId' | 'id'>>;
  changeOutsideContributionAmount?: Resolver<ResolversTypes['ChangeOutsideContributionAmountResult'], ParentType, ContextType, RequireFields<MutationChangeOutsideContributionAmountArgs, 'input'>>;
  changePIN?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationChangePinArgs, 'answer' | 'newPIN' | 'oldPIN' | 'questionId'>>;
  changePassword?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'newPassword' | 'oldPassword'>>;
  changePasswordAuth?: Resolver<ResolversTypes['ChangePasswordResult'], ParentType, ContextType, RequireFields<MutationChangePasswordAuthArgs, 'input'>>;
  clearSupportSiteCache?: Resolver<Maybe<ResolversTypes['ClearSupportSiteCache']>, ParentType, ContextType>;
  closeBankAccount?: Resolver<ResolversTypes['CloseBankAccountResult'], ParentType, ContextType, RequireFields<MutationCloseBankAccountArgs, 'input'>>;
  closeInvestmentAccount?: Resolver<ResolversTypes['CloseInvestmentAccountResult'], ParentType, ContextType, RequireFields<MutationCloseInvestmentAccountArgs, 'input'>>;
  closeUserAccount?: Resolver<ResolversTypes['CloseUserAccountResult'], ParentType, ContextType>;
  completeCheckDeposit?: Resolver<Maybe<ResolversTypes['CompleteCheckDepositPayload']>, ParentType, ContextType, RequireFields<MutationCompleteCheckDepositArgs, 'input'>>;
  completeFunnelOnboarding?: Resolver<ResolversTypes['CompleteFunnelOnboardingResult'], ParentType, ContextType>;
  completeRegistration?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  configureSplitDepositDirectDepositIntentSetting?: Resolver<ResolversTypes['ConfigureSplitDepositDirectDepositIntentPayload'], ParentType, ContextType, RequireFields<MutationConfigureSplitDepositDirectDepositIntentSettingArgs, 'input'>>;
  configureSplitDepositDirectDepositSetting?: Resolver<ResolversTypes['ConfigureSplitDepositDirectDepositSettingPayload'], ParentType, ContextType, RequireFields<MutationConfigureSplitDepositDirectDepositSettingArgs, 'input'>>;
  connectACHAccount?: Resolver<ResolversTypes['ConnectACHAccountResult'], ParentType, ContextType, RequireFields<MutationConnectAchAccountArgs, 'input'>>;
  connectLadderCustomer?: Resolver<Maybe<ResolversTypes['LadderLinkResponse']>, ParentType, ContextType, RequireFields<MutationConnectLadderCustomerArgs, 'quoteId'>>;
  consumeUserToken?: Resolver<ResolversTypes['ConsumeUserTokenResult'], ParentType, ContextType, RequireFields<MutationConsumeUserTokenArgs, 'userTokenId'>>;
  createAuthProfile?: Resolver<ResolversTypes['CreateAuthProfileResult'], ParentType, ContextType, Partial<MutationCreateAuthProfileArgs>>;
  createAuthenticatedSupportTicket?: Resolver<Maybe<ResolversTypes['SupportTicket']>, ParentType, ContextType, RequireFields<MutationCreateAuthenticatedSupportTicketArgs, 'input'>>;
  createBankAccount?: Resolver<Maybe<ResolversTypes['CreateBankAccountPayload']>, ParentType, ContextType, RequireFields<MutationCreateBankAccountArgs, 'input'>>;
  createBeneficiary?: Resolver<ResolversTypes['CreateBeneficiaryResult'], ParentType, ContextType, RequireFields<MutationCreateBeneficiaryArgs, 'input'>>;
  createDirectDepositLinkInfo?: Resolver<ResolversTypes['CreateDirectDepositLinkInfoSwitch'], ParentType, ContextType, RequireFields<MutationCreateDirectDepositLinkInfoArgs, 'input'>>;
  createDocumentUpload?: Resolver<ResolversTypes['CreateDocumentUpload'], ParentType, ContextType, RequireFields<MutationCreateDocumentUploadArgs, 'input'>>;
  createIRAWithProfile?: Resolver<Maybe<ResolversTypes['CreateInvestmentAccountResponse']>, ParentType, ContextType, RequireFields<MutationCreateIraWithProfileArgs, 'profileAttributes'>>;
  createIntent?: Resolver<ResolversTypes['CreateIntentResult'], ParentType, ContextType, RequireFields<MutationCreateIntentArgs, 'input'>>;
  createInvestingStrategyRecommendation?: Resolver<ResolversTypes['CreateInvestingStrategyRecommendationResult'], ParentType, ContextType, RequireFields<MutationCreateInvestingStrategyRecommendationArgs, 'input'>>;
  createInvestmentAccount?: Resolver<Maybe<ResolversTypes['CreateInvestmentAccountResponse']>, ParentType, ContextType, Partial<MutationCreateInvestmentAccountArgs>>;
  createJobAlert?: Resolver<Maybe<ResolversTypes['CreateJobAlertResult']>, ParentType, ContextType, RequireFields<MutationCreateJobAlertArgs, 'alertCriteria'>>;
  createLadderQuote?: Resolver<Maybe<ResolversTypes['LadderResponse']>, ParentType, ContextType, RequireFields<MutationCreateLadderQuoteArgs, 'address' | 'age' | 'city' | 'email' | 'firstName' | 'lastName' | 'phone' | 'state' | 'zip'>>;
  createLaterContribution?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationCreateLaterContributionArgs, 'accountId' | 'amount'>>;
  createOffer?: Resolver<ResolversTypes['CreateOfferResult'], ParentType, ContextType, RequireFields<MutationCreateOfferArgs, 'input'>>;
  createOutsideContribution?: Resolver<ResolversTypes['CreateOutsideContributionResult'], ParentType, ContextType, RequireFields<MutationCreateOutsideContributionArgs, 'input'>>;
  createOutsideContributionCheckoutCart?: Resolver<ResolversTypes['CreateOutsideContributionCheckoutCartResult'], ParentType, ContextType, RequireFields<MutationCreateOutsideContributionCheckoutCartArgs, 'input'>>;
  createPlaidLinkedAccount?: Resolver<Maybe<ResolversTypes['LinkedAccount']>, ParentType, ContextType, RequireFields<MutationCreatePlaidLinkedAccountArgs, 'input' | 'publicToken'>>;
  createProspectUser?: Resolver<ResolversTypes['CreateProspectUserResult'], ParentType, ContextType, RequireFields<MutationCreateProspectUserArgs, 'input'>>;
  createReferralCampaign?: Resolver<ResolversTypes['CreateReferralCampaignResult'], ParentType, ContextType, RequireFields<MutationCreateReferralCampaignArgs, 'input'>>;
  createReferralCampaignReward?: Resolver<ResolversTypes['CreateReferralCampaignRewardResult'], ParentType, ContextType, RequireFields<MutationCreateReferralCampaignRewardArgs, 'input'>>;
  createReferralPayout?: Resolver<ResolversTypes['CreateReferralPayoutResult'], ParentType, ContextType, RequireFields<MutationCreateReferralPayoutArgs, 'input'>>;
  createReferralRelationship?: Resolver<ResolversTypes['CreateReferralRelationshipResult'], ParentType, ContextType, RequireFields<MutationCreateReferralRelationshipArgs, 'referralCode'>>;
  createRefund?: Resolver<Maybe<ResolversTypes['CreateRefundResult']>, ParentType, ContextType, RequireFields<MutationCreateRefundArgs, 'invoiceId'>>;
  createSavingsAccount?: Resolver<ResolversTypes['CreateSavingsAccountResult'], ParentType, ContextType, RequireFields<MutationCreateSavingsAccountArgs, 'input'>>;
  createSubscriptionMigration?: Resolver<ResolversTypes['CreateSubscriptionMigrationResult'], ParentType, ContextType, RequireFields<MutationCreateSubscriptionMigrationArgs, 'input'>>;
  createSupportTicket?: Resolver<Maybe<ResolversTypes['SupportTicket']>, ParentType, ContextType, RequireFields<MutationCreateSupportTicketArgs, 'input'>>;
  createSupportTicketOrException?: Resolver<Maybe<ResolversTypes['SupportTicketResponse']>, ParentType, ContextType, RequireFields<MutationCreateSupportTicketOrExceptionArgs, 'input'>>;
  createSupportTicketWithCustomFields?: Resolver<Maybe<ResolversTypes['SupportTicketWithCustomFieldsResponse']>, ParentType, ContextType, RequireFields<MutationCreateSupportTicketWithCustomFieldsArgs, 'input'>>;
  createSuspendedUserSupportTicket?: Resolver<Maybe<ResolversTypes['SupportTicketWithCustomFieldsResponse']>, ParentType, ContextType, RequireFields<MutationCreateSuspendedUserSupportTicketArgs, 'input'>>;
  createUploadUrl?: Resolver<ResolversTypes['CreateUploadUrlResult'], ParentType, ContextType, RequireFields<MutationCreateUploadUrlArgs, 'input'>>;
  createUser?: Resolver<Maybe<ResolversTypes['Session']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  createUserProfile?: Resolver<ResolversTypes['CreateUserProfileResult'], ParentType, ContextType, RequireFields<MutationCreateUserProfileArgs, 'input'>>;
  createVendorInvoice?: Resolver<Maybe<ResolversTypes['CreateVendorInvoiceResult']>, ParentType, ContextType, RequireFields<MutationCreateVendorInvoiceArgs, 'input'>>;
  createVendorLineItem?: Resolver<Maybe<ResolversTypes['CreateVendorLineItemResult']>, ParentType, ContextType, RequireFields<MutationCreateVendorLineItemArgs, 'input'>>;
  deactivateAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<MutationDeactivateAccountArgs, 'accountId'>>;
  deactivateBeneficiary?: Resolver<ResolversTypes['DeactivateBeneficiaryResult'], ParentType, ContextType, RequireFields<MutationDeactivateBeneficiaryArgs, 'id'>>;
  deactivateTierSubscription?: Resolver<ResolversTypes['DeactivateTierSubscriptionResult'], ParentType, ContextType, RequireFields<MutationDeactivateTierSubscriptionArgs, 'input'>>;
  deleteExpiredBankCardOrder?: Resolver<Maybe<ResolversTypes['DeleteExpiredBankCardOrderResult']>, ParentType, ContextType>;
  deleteTrustedContact?: Resolver<ResolversTypes['DeleteTrustedContactResult'], ParentType, ContextType, RequireFields<MutationDeleteTrustedContactArgs, 'id'>>;
  deregisterAuthenticator?: Resolver<ResolversTypes['DeregisterAuthenticatorResult'], ParentType, ContextType, RequireFields<MutationDeregisterAuthenticatorArgs, 'input'>>;
  destroySession?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType>;
  dismissMessage?: Resolver<ResolversTypes['UpdateMessageResult'], ParentType, ContextType, RequireFields<MutationDismissMessageArgs, 'input'>>;
  dismissMessages?: Resolver<ResolversTypes['DismissMessagesResult'], ParentType, ContextType, RequireFields<MutationDismissMessagesArgs, 'input'>>;
  editTrustedContact?: Resolver<ResolversTypes['UpdateTrustedContactResult'], ParentType, ContextType, RequireFields<MutationEditTrustedContactArgs, 'id' | 'input'>>;
  enableQuarterlyRecaps?: Resolver<ResolversTypes['EnableQuarterlyRecapsResult'], ParentType, ContextType, RequireFields<MutationEnableQuarterlyRecapsArgs, 'input'>>;
  endChatSession?: Resolver<ResolversTypes['endChatSessionResponse'], ParentType, ContextType, RequireFields<MutationEndChatSessionArgs, 'sessionId'>>;
  exchangeAcornsEarlyToken?: Resolver<ResolversTypes['ExchangeAcornsEarlyTokenResult'], ParentType, ContextType, RequireFields<MutationExchangeAcornsEarlyTokenArgs, 'token'>>;
  executeMoneyManagerRebalances?: Resolver<ResolversTypes['ExecuteMoneyManagerRebalancesResult'], ParentType, ContextType, RequireFields<MutationExecuteMoneyManagerRebalancesArgs, 'input'>>;
  expirePromotionalWaiver?: Resolver<Maybe<ResolversTypes['ExpirePromotionalWaiverResult']>, ParentType, ContextType, RequireFields<MutationExpirePromotionalWaiverArgs, 'input'>>;
  failVendorInvoice?: Resolver<Maybe<ResolversTypes['FailVendorInvoiceResult']>, ParentType, ContextType, RequireFields<MutationFailVendorInvoiceArgs, 'invoiceId'>>;
  feedEvent?: Resolver<Maybe<ResolversTypes['ActionFeedEventResponse']>, ParentType, ContextType, RequireFields<MutationFeedEventArgs, 'feedEvent'>>;
  generateDocumentUploadSession?: Resolver<ResolversTypes['GenerateDocumentUploadSessionResult'], ParentType, ContextType, RequireFields<MutationGenerateDocumentUploadSessionArgs, 'input'>>;
  generateLayerLinkSession?: Resolver<ResolversTypes['GenerateLayerLinkSessionResult'], ParentType, ContextType, RequireFields<MutationGenerateLayerLinkSessionArgs, 'input'>>;
  generateLinkSession?: Resolver<ResolversTypes['LinkSessionResult'], ParentType, ContextType, RequireFields<MutationGenerateLinkSessionArgs, 'input'>>;
  generateReferralCode?: Resolver<ResolversTypes['GenerateReferralCodeResult'], ParentType, ContextType>;
  hideMessage?: Resolver<ResolversTypes['UpdateMessageResult'], ParentType, ContextType, RequireFields<MutationHideMessageArgs, 'input'>>;
  hideMessageByExternalId?: Resolver<ResolversTypes['UpdateMessageResult'], ParentType, ContextType, RequireFields<MutationHideMessageByExternalIdArgs, 'input'>>;
  initiateBankAccountCreation?: Resolver<ResolversTypes['InitiateBankAccountResponse'], ParentType, ContextType, RequireFields<MutationInitiateBankAccountCreationArgs, 'input'>>;
  initiateBankingKYC?: Resolver<ResolversTypes['InitiateBankingKYCPayload'], ParentType, ContextType, RequireFields<MutationInitiateBankingKycArgs, 'input'>>;
  initiateChallenge?: Resolver<ResolversTypes['InitiateChallengeResult'], ParentType, ContextType, RequireFields<MutationInitiateChallengeArgs, 'input'>>;
  initiateEmailChallenge?: Resolver<ResolversTypes['InitiateEmailChallengeResult'], ParentType, ContextType, RequireFields<MutationInitiateEmailChallengeArgs, 'input'>>;
  initiateLaterProgramAccountContribution?: Resolver<Maybe<ResolversTypes['LaterProgramAccountContributionResult']>, ParentType, ContextType, RequireFields<MutationInitiateLaterProgramAccountContributionArgs, 'input'>>;
  initiateMoneyAssignment?: Resolver<Maybe<ResolversTypes['InitiateMoneyAssignmentResult']>, ParentType, ContextType, RequireFields<MutationInitiateMoneyAssignmentArgs, 'input'>>;
  initiatePartnerDataShare?: Resolver<ResolversTypes['PartnerDataShareResponse'], ParentType, ContextType, RequireFields<MutationInitiatePartnerDataShareArgs, 'input'>>;
  initiatePushChallenge?: Resolver<ResolversTypes['InitiatePushChallengeResult'], ParentType, ContextType>;
  initiateSMSChallenge?: Resolver<ResolversTypes['InitiateSMSChallengeResult'], ParentType, ContextType, RequireFields<MutationInitiateSmsChallengeArgs, 'input'>>;
  initiateTransfer?: Resolver<Maybe<ResolversTypes['InitiateTransferPayload']>, ParentType, ContextType, RequireFields<MutationInitiateTransferArgs, 'input'>>;
  initiateVerification?: Resolver<ResolversTypes['InitiateVerificationResult'], ParentType, ContextType>;
  laterCreateIndividualBeneficiary?: Resolver<Maybe<ResolversTypes['LaterIndividualBeneficiaryResponse']>, ParentType, ContextType, RequireFields<MutationLaterCreateIndividualBeneficiaryArgs, 'accountId' | 'birthDate' | 'firstName' | 'lastName'>>;
  laterTotalLiquidation?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationLaterTotalLiquidationArgs, 'investmentAccountId'>>;
  laterWithdrawal?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationLaterWithdrawalArgs, 'amount' | 'federalTaxes' | 'investmentAccountId' | 'stateTaxes' | 'taxYear'>>;
  legacyUploadDocument?: Resolver<ResolversTypes['LegacyUploadDocumentResult'], ParentType, ContextType, RequireFields<MutationLegacyUploadDocumentArgs, 'input'>>;
  linkACHAccount?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationLinkAchAccountArgs, 'account' | 'routing'>>;
  linkManualFundingSource?: Resolver<ResolversTypes['LinkManualFundingSourceResult'], ParentType, ContextType, RequireFields<MutationLinkManualFundingSourceArgs, 'input'>>;
  linkOidcCredentials?: Resolver<ResolversTypes['LinkOidcCredentialsResult'], ParentType, ContextType, RequireFields<MutationLinkOidcCredentialsArgs, 'input'>>;
  lockBankCard?: Resolver<Maybe<ResolversTypes['LockBankCardPayload']>, ParentType, ContextType, RequireFields<MutationLockBankCardArgs, 'input'>>;
  logout?: Resolver<ResolversTypes['LogoutResult'], ParentType, ContextType>;
  logoutDevice?: Resolver<ResolversTypes['LogoutDeviceResult'], ParentType, ContextType, RequireFields<MutationLogoutDeviceArgs, 'input'>>;
  makeInvestment?: Resolver<ResolversTypes['MakeInvestmentPayload'], ParentType, ContextType, RequireFields<MutationMakeInvestmentArgs, 'input'>>;
  managePayoutRelationship?: Resolver<ResolversTypes['PayoutRelationshipResult'], ParentType, ContextType, RequireFields<MutationManagePayoutRelationshipArgs, 'input'>>;
  markAllAsRead?: Resolver<ResolversTypes['MarkAllAsReadResult'], ParentType, ContextType>;
  markLearnContentAsHelpful?: Resolver<ResolversTypes['MarkLearnContentAsHelpfulResult'], ParentType, ContextType, RequireFields<MutationMarkLearnContentAsHelpfulArgs, 'input'>>;
  markLearnContentAsViewed?: Resolver<ResolversTypes['MarkLearnContentAsViewedResult'], ParentType, ContextType, RequireFields<MutationMarkLearnContentAsViewedArgs, 'input'>>;
  modifyMoneyAssignment?: Resolver<ResolversTypes['ModifyMoneyAssignmentResult'], ParentType, ContextType, RequireFields<MutationModifyMoneyAssignmentArgs, 'input'>>;
  openCoreInvestmentAccount?: Resolver<ResolversTypes['OpenCoreInvestmentAccountResult'], ParentType, ContextType, RequireFields<MutationOpenCoreInvestmentAccountArgs, 'input'>>;
  openEarlyAccount?: Resolver<ResolversTypes['OpenEarlyAccountResult'], ParentType, ContextType, RequireFields<MutationOpenEarlyAccountArgs, 'input'>>;
  orderBankCard?: Resolver<Maybe<ResolversTypes['OrderBankCardResult']>, ParentType, ContextType, RequireFields<MutationOrderBankCardArgs, 'input'>>;
  postBankFeeNegotiation?: Resolver<ResolversTypes['BenefitsMessage'], ParentType, ContextType, RequireFields<MutationPostBankFeeNegotiationArgs, 'linkedAccountId'>>;
  postUserReportedBankFeeRefund?: Resolver<ResolversTypes['BenefitsMessage'], ParentType, ContextType, RequireFields<MutationPostUserReportedBankFeeRefundArgs, 'submissionId' | 'totalRefunds'>>;
  rateChatMessage?: Resolver<ResolversTypes['rateChatMessageResponse'], ParentType, ContextType, RequireFields<MutationRateChatMessageArgs, 'messageId'>>;
  rateFinancialAdvisorResponse?: Resolver<ResolversTypes['InteractionRatingResponse'], ParentType, ContextType, RequireFields<MutationRateFinancialAdvisorResponseArgs, 'interactionId' | 'rating'>>;
  readMessage?: Resolver<ResolversTypes['UpdateMessageResult'], ParentType, ContextType, RequireFields<MutationReadMessageArgs, 'input'>>;
  recordInvestmentAccountRecapView?: Resolver<ResolversTypes['RecordInvestmentAccountRecapViewResult'], ParentType, ContextType, RequireFields<MutationRecordInvestmentAccountRecapViewArgs, 'input'>>;
  recordReferralEvent?: Resolver<ResolversTypes['RecordReferralEventResult'], ParentType, ContextType, RequireFields<MutationRecordReferralEventArgs, 'input'>>;
  recordVendorExternalTransaction?: Resolver<Maybe<ResolversTypes['RecordVendorExternalTransactionResult']>, ParentType, ContextType, RequireFields<MutationRecordVendorExternalTransactionArgs, 'input' | 'invoiceId'>>;
  redeemGiftcard?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationRedeemGiftcardArgs, 'pin'>>;
  refreshAuthToken?: Resolver<ResolversTypes['RefreshAuthTokenResult'], ParentType, ContextType, RequireFields<MutationRefreshAuthTokenArgs, 'input'>>;
  refreshCookie?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType>;
  regenerateInvestmentAccountRecapPublicToken?: Resolver<ResolversTypes['RegenerateInvestmentAccountRecapPublicTokenResult'], ParentType, ContextType, RequireFields<MutationRegenerateInvestmentAccountRecapPublicTokenArgs, 'input'>>;
  registerCredentials?: Resolver<ResolversTypes['RegisterCredentialsResult'], ParentType, ContextType, RequireFields<MutationRegisterCredentialsArgs, 'input'>>;
  registerDeviceTokenAndPushAuthenticator?: Resolver<ResolversTypes['RegisterDeviceTokenAndPushAuthenticatorResult'], ParentType, ContextType, RequireFields<MutationRegisterDeviceTokenAndPushAuthenticatorArgs, 'input'>>;
  registerEmailAuthenticator?: Resolver<ResolversTypes['RegisterEmailAuthenticatorResult'], ParentType, ContextType, RequireFields<MutationRegisterEmailAuthenticatorArgs, 'challengeAnswerInput' | 'input'>>;
  registerLayerLinkSession?: Resolver<ResolversTypes['RegisterLayerLinkSessionResult'], ParentType, ContextType, RequireFields<MutationRegisterLayerLinkSessionArgs, 'input'>>;
  registerLinkSession?: Resolver<Maybe<ResolversTypes['RegisterLinkSessionResult']>, ParentType, ContextType, RequireFields<MutationRegisterLinkSessionArgs, 'input'>>;
  registerOidcCredentials?: Resolver<ResolversTypes['RegisterOidcCredentialsResult'], ParentType, ContextType, RequireFields<MutationRegisterOidcCredentialsArgs, 'input'>>;
  registerPhoneAuthenticator?: Resolver<ResolversTypes['RegisterPhoneAuthenticatorResult'], ParentType, ContextType, RequireFields<MutationRegisterPhoneAuthenticatorArgs, 'challengeAnswerInput' | 'input'>>;
  registerProspect?: Resolver<ResolversTypes['RegisterProspectResult'], ParentType, ContextType, RequireFields<MutationRegisterProspectArgs, 'input'>>;
  reinitiateChallenge?: Resolver<ResolversTypes['ReinitiateSMSChallengeResult'], ParentType, ContextType, RequireFields<MutationReinitiateChallengeArgs, 'input'>>;
  reissueBankCard?: Resolver<Maybe<ResolversTypes['ReissueBankCardResult']>, ParentType, ContextType, RequireFields<MutationReissueBankCardArgs, 'input'>>;
  removeCohortEligibility?: Resolver<ResolversTypes['RemoveCohortEligibilityResult'], ParentType, ContextType, RequireFields<MutationRemoveCohortEligibilityArgs, 'input'>>;
  removeFavoritePartnerOffers?: Resolver<ResolversTypes['FavoritePartnerOfferGroup'], ParentType, ContextType, RequireFields<MutationRemoveFavoritePartnerOffersArgs, 'input'>>;
  removeJobAlert?: Resolver<Maybe<ResolversTypes['RemoveJobAlertResult']>, ParentType, ContextType, RequireFields<MutationRemoveJobAlertArgs, 'id'>>;
  removeSecurityFromPortfolio?: Resolver<ResolversTypes['RemoveSecurityFromPortfolioResult'], ParentType, ContextType, RequireFields<MutationRemoveSecurityFromPortfolioArgs, 'input'>>;
  removeSelfDirectedPortfolio?: Resolver<ResolversTypes['RemoveSelfDirectedPortfolioResult'], ParentType, ContextType, RequireFields<MutationRemoveSelfDirectedPortfolioArgs, 'input'>>;
  reopenUserAccount?: Resolver<ResolversTypes['ReopenUserAccountResult'], ParentType, ContextType>;
  reportBankCardLostStolen?: Resolver<Maybe<ResolversTypes['ReportBankCardLostStolenPayload']>, ParentType, ContextType, RequireFields<MutationReportBankCardLostStolenArgs, 'input'>>;
  requestAccountClosure?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationRequestAccountClosureArgs, 'input'>>;
  requestEarlyAccountClosure?: Resolver<Array<ResolversTypes['RequestEarlyAccountClosureResult']>, ParentType, ContextType, RequireFields<MutationRequestEarlyAccountClosureArgs, 'input'>>;
  requestInvestmentAccountReopen?: Resolver<ResolversTypes['RequestInvestmentAccountReopenResult'], ParentType, ContextType, RequireFields<MutationRequestInvestmentAccountReopenArgs, 'input'>>;
  requestLayerSession?: Resolver<ResolversTypes['RequestLayerSessionResult'], ParentType, ContextType, RequireFields<MutationRequestLayerSessionArgs, 'input'>>;
  requestSubscriptionMigrationWaiver?: Resolver<ResolversTypes['RequestSubscriptionMigrationWaiverResult'], ParentType, ContextType, RequireFields<MutationRequestSubscriptionMigrationWaiverArgs, 'input'>>;
  resendChatMessage?: Resolver<ResolversTypes['ResendChatMessageResponse'], ParentType, ContextType, RequireFields<MutationResendChatMessageArgs, 'messageId' | 'sessionId'>>;
  resetPIN?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationResetPinArgs, 'email'>>;
  resetPassword?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'email'>>;
  resetPasswordByToken?: Resolver<ResolversTypes['ResetPasswordByTokenResult'], ParentType, ContextType, RequireFields<MutationResetPasswordByTokenArgs, 'input'>>;
  resetPasswordWithToken?: Resolver<ResolversTypes['ResetPasswordWithTokenResult'], ParentType, ContextType, RequireFields<MutationResetPasswordWithTokenArgs, 'input'>>;
  respondToLearnPoll?: Resolver<ResolversTypes['RespondToLearnPollResult'], ParentType, ContextType, RequireFields<MutationRespondToLearnPollArgs, 'input'>>;
  restoreLoginAccess?: Resolver<ResolversTypes['RestoreLoginAccessResult'], ParentType, ContextType, RequireFields<MutationRestoreLoginAccessArgs, 'input'>>;
  retriggerRdvs?: Resolver<ResolversTypes['RetriggerRdvsResult'], ParentType, ContextType>;
  revokeLoginAccess?: Resolver<ResolversTypes['RevokeLoginAccessResult'], ParentType, ContextType, RequireFields<MutationRevokeLoginAccessArgs, 'input'>>;
  revokePasswordResetToken?: Resolver<ResolversTypes['RevokePasswordResetTokenResult'], ParentType, ContextType, RequireFields<MutationRevokePasswordResetTokenArgs, 'input'>>;
  roundUpProfile?: Resolver<Maybe<ResolversTypes['RoundUpProfile']>, ParentType, ContextType, RequireFields<MutationRoundUpProfileArgs, 'input'>>;
  saveUploadUrl?: Resolver<ResolversTypes['LegacyUploadDocumentResult'], ParentType, ContextType, RequireFields<MutationSaveUploadUrlArgs, 'input'>>;
  saveUploadUrls?: Resolver<ResolversTypes['SaveUploadUrlsResult'], ParentType, ContextType, RequireFields<MutationSaveUploadUrlsArgs, 'input'>>;
  scheduleRecurringTransfer?: Resolver<Maybe<ResolversTypes['ScheduleRecurringTransferResult']>, ParentType, ContextType, RequireFields<MutationScheduleRecurringTransferArgs, 'input'>>;
  sendBrazeEvent?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationSendBrazeEventArgs, 'input'>>;
  sendChatMessage?: Resolver<ResolversTypes['SendChatMessageResponse'], ParentType, ContextType, RequireFields<MutationSendChatMessageArgs, 'message' | 'sessionId'>>;
  sendCheckPayment?: Resolver<Maybe<ResolversTypes['SendCheckPaymentResult']>, ParentType, ContextType, RequireFields<MutationSendCheckPaymentArgs, 'input'>>;
  sendReferralEvent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendReferralEventArgs, 'input'>>;
  sessionRefresh?: Resolver<Maybe<ResolversTypes['Session']>, ParentType, ContextType, RequireFields<MutationSessionRefreshArgs, 'pin'>>;
  setAuthenticationPIN?: Resolver<ResolversTypes['SetAuthenticationPINResult'], ParentType, ContextType, RequireFields<MutationSetAuthenticationPinArgs, 'input'>>;
  setBeneficiarySsn?: Resolver<ResolversTypes['SetBeneficiarySsnResult'], ParentType, ContextType, RequireFields<MutationSetBeneficiarySsnArgs, 'id' | 'ssn'>>;
  setDefaultAuthenticator?: Resolver<ResolversTypes['SetDefaultAuthenticatorResult'], ParentType, ContextType, RequireFields<MutationSetDefaultAuthenticatorArgs, 'input'>>;
  setFavoritePartnerOffers?: Resolver<ResolversTypes['FavoritePartnerOfferGroup'], ParentType, ContextType, RequireFields<MutationSetFavoritePartnerOffersArgs, 'input'>>;
  setInvestmentAccountRecapPublicAccess?: Resolver<ResolversTypes['SetInvestmentAccountRecapPublicAccessResult'], ParentType, ContextType, RequireFields<MutationSetInvestmentAccountRecapPublicAccessArgs, 'input'>>;
  setLinkingError?: Resolver<Maybe<ResolversTypes['LinkedAccount']>, ParentType, ContextType, RequireFields<MutationSetLinkingErrorArgs, 'linkedAccountId' | 'linkingErrorCode'>>;
  setManualRoundUps?: Resolver<Array<ResolversTypes['RoundUp']>, ParentType, ContextType, RequireFields<MutationSetManualRoundUpsArgs, 'roundUpIds'>>;
  setNegotiationStatus?: Resolver<ResolversTypes['SetNegotiationStatusResult'], ParentType, ContextType, RequireFields<MutationSetNegotiationStatusArgs, 'input'>>;
  setPortfolio?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSetPortfolioArgs, 'input'>>;
  setPreferredWithdrawalAccount?: Resolver<ResolversTypes['SetPreferredWithdrawalAccountResult'], ParentType, ContextType, RequireFields<MutationSetPreferredWithdrawalAccountArgs, 'input'>>;
  setReferralCampaignFlags?: Resolver<ResolversTypes['SetReferralCampaignFlagsResult'], ParentType, ContextType, RequireFields<MutationSetReferralCampaignFlagsArgs, 'input'>>;
  setUserPartnerStatus?: Resolver<ResolversTypes['UserPartnerStatusResponse'], ParentType, ContextType, RequireFields<MutationSetUserPartnerStatusArgs, 'input'>>;
  splitDeposit?: Resolver<ResolversTypes['SplitDepositMutation'], ParentType, ContextType, RequireFields<MutationSplitDepositArgs, 'id'>>;
  splitDepositSettings?: Resolver<ResolversTypes['SplitDepositSettingsMutation'], ParentType, ContextType, RequireFields<MutationSplitDepositSettingsArgs, 'id'>>;
  startAcornsPdfSwitch?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationStartAcornsPdfSwitchArgs, 'input'>>;
  startChatSession?: Resolver<ResolversTypes['startChatSessionResponse'], ParentType, ContextType, Partial<MutationStartChatSessionArgs>>;
  startCheckDeposit?: Resolver<Maybe<ResolversTypes['StartCheckDepositPayload']>, ParentType, ContextType, RequireFields<MutationStartCheckDepositArgs, 'input'>>;
  startOnlineSwitch?: Resolver<ResolversTypes['StartOnlineSwitchPayload'], ParentType, ContextType, RequireFields<MutationStartOnlineSwitchArgs, 'input'>>;
  startSubmittableSwitch?: Resolver<Maybe<ResolversTypes['StartSubmittableSwitchPayload']>, ParentType, ContextType, RequireFields<MutationStartSubmittableSwitchArgs, 'input'>>;
  stopRecurringInvestment?: Resolver<ResolversTypes['RecurringInvestmentPayload'], ParentType, ContextType, Partial<MutationStopRecurringInvestmentArgs>>;
  stub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationStubArgs, 'id'>>;
  submitBankFeeNegotiation?: Resolver<ResolversTypes['SubmitBankFeeNegotiationResult'], ParentType, ContextType, RequireFields<MutationSubmitBankFeeNegotiationArgs, 'input'>>;
  submitEarnMissingCreditRequest?: Resolver<ResolversTypes['SubmitEarnMissingCreditRequestResult'], ParentType, ContextType, RequireFields<MutationSubmitEarnMissingCreditRequestArgs, 'input'>>;
  submitRDVs?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSubmitRdVsArgs, 'deposits'>>;
  submitSpendTransactionsDispute?: Resolver<ResolversTypes['SpendTransactionsDisputeResult'], ParentType, ContextType, RequireFields<MutationSubmitSpendTransactionsDisputeArgs, 'input'>>;
  submitUserReportedBankFeeRefund?: Resolver<ResolversTypes['SubmitUserReportedBankFeeRefundResult'], ParentType, ContextType, RequireFields<MutationSubmitUserReportedBankFeeRefundArgs, 'input'>>;
  subscribeToTier?: Resolver<ResolversTypes['SubscribeToTierResult'], ParentType, ContextType, RequireFields<MutationSubscribeToTierArgs, 'input'>>;
  subscribeUserToTier?: Resolver<ResolversTypes['SubscribeUserToTierResult'], ParentType, ContextType, RequireFields<MutationSubscribeUserToTierArgs, 'input'>>;
  subscribeUserToTierByOpenAccounts?: Resolver<ResolversTypes['TierSubscription'], ParentType, ContextType>;
  subscribeUserToTierByProductKey?: Resolver<ResolversTypes['TierSubscription'], ParentType, ContextType, Partial<MutationSubscribeUserToTierByProductKeyArgs>>;
  succeedVendorInvoice?: Resolver<Maybe<ResolversTypes['SucceedVendorInvoiceResult']>, ParentType, ContextType, RequireFields<MutationSucceedVendorInvoiceArgs, 'invoiceId'>>;
  suppressMoneyManagerRebalances?: Resolver<ResolversTypes['SuppressMoneyManagerRebalancesResult'], ParentType, ContextType, RequireFields<MutationSuppressMoneyManagerRebalancesArgs, 'input'>>;
  suspendDeposits?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationSuspendDepositsArgs, 'suspended'>>;
  suspendUserDeposits?: Resolver<ResolversTypes['Void'], ParentType, ContextType>;
  syncBankFeeTransactions?: Resolver<ResolversTypes['SyncBankFeeTransactionsResult'], ParentType, ContextType, RequireFields<MutationSyncBankFeeTransactionsArgs, 'input'>>;
  syncFundingSourceToVendor?: Resolver<Maybe<ResolversTypes['SyncFundingSourceToVendorResult']>, ParentType, ContextType>;
  taxWithholdingAmounts?: Resolver<Maybe<ResolversTypes['TaxWithholdingAmounts']>, ParentType, ContextType, RequireFields<MutationTaxWithholdingAmountsArgs, 'investmentId' | 'totalSharesAmount'>>;
  unauthenticatedCreateUploadUrl?: Resolver<ResolversTypes['CreateUploadUrlResult'], ParentType, ContextType, RequireFields<MutationUnauthenticatedCreateUploadUrlArgs, 'input'>>;
  unauthenticatedSaveUploadUrl?: Resolver<ResolversTypes['UnauthenticatedSaveUploadUrlResult'], ParentType, ContextType, RequireFields<MutationUnauthenticatedSaveUploadUrlArgs, 'input'>>;
  unblockDevice?: Resolver<ResolversTypes['UnblockDeviceResult'], ParentType, ContextType, RequireFields<MutationUnblockDeviceArgs, 'input'>>;
  unlinkLinkedAccount?: Resolver<Maybe<ResolversTypes['LinkedAccount']>, ParentType, ContextType, RequireFields<MutationUnlinkLinkedAccountArgs, 'linkedAccountId'>>;
  unlockBankCard?: Resolver<Maybe<ResolversTypes['UnlockBankCardPayload']>, ParentType, ContextType>;
  unmarkLearnContentAsHelpful?: Resolver<ResolversTypes['UnmarkLearnContentAsHelpfulResult'], ParentType, ContextType, RequireFields<MutationUnmarkLearnContentAsHelpfulArgs, 'input'>>;
  unsubscribeUserFromTier?: Resolver<ResolversTypes['UnsubscribeUserFromTierResult'], ParentType, ContextType, Partial<MutationUnsubscribeUserFromTierArgs>>;
  unsuspendUserDeposits?: Resolver<ResolversTypes['Void'], ParentType, ContextType>;
  updateAccountPortfolio?: Resolver<ResolversTypes['UpdateAccountPortfolioResponse'], ParentType, ContextType, RequireFields<MutationUpdateAccountPortfolioArgs, 'input'>>;
  updateAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<MutationUpdateAddressArgs, 'addressType' | 'input'>>;
  updateAttribution?: Resolver<ResolversTypes['UpdateAttributionResult'], ParentType, ContextType, RequireFields<MutationUpdateAttributionArgs, 'input'>>;
  updateAuthEmail?: Resolver<ResolversTypes['UpdateAuthEmailResult'], ParentType, ContextType, RequireFields<MutationUpdateAuthEmailArgs, 'input'>>;
  updateAuthPhoneNumber?: Resolver<ResolversTypes['UpdateAuthPhoneNumberResult'], ParentType, ContextType, RequireFields<MutationUpdateAuthPhoneNumberArgs, 'input'>>;
  updateBankAccountGoal?: Resolver<ResolversTypes['UpdateBankAccountGoalResult'], ParentType, ContextType, RequireFields<MutationUpdateBankAccountGoalArgs, 'input'>>;
  updateBankCardPin?: Resolver<Maybe<ResolversTypes['UpdateBankCardPinPayload']>, ParentType, ContextType, RequireFields<MutationUpdateBankCardPinArgs, 'input'>>;
  updateBanners?: Resolver<Maybe<Array<Maybe<ResolversTypes['BannersResponse']>>>, ParentType, ContextType, RequireFields<MutationUpdateBannersArgs, 'input'>>;
  updateBeneficiaryInfo?: Resolver<ResolversTypes['UpdateBeneficiaryInfoResult'], ParentType, ContextType, RequireFields<MutationUpdateBeneficiaryInfoArgs, 'id' | 'input'>>;
  updateBenefitStatus?: Resolver<ResolversTypes['UpdateBenefitStatusResponse'], ParentType, ContextType, RequireFields<MutationUpdateBenefitStatusArgs, 'input'>>;
  updateContactInfo?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateContactInfoArgs, 'input'>>;
  updateCredentials?: Resolver<ResolversTypes['UpdateCredentialsResult'], ParentType, ContextType, RequireFields<MutationUpdateCredentialsArgs, 'input'>>;
  updateCustomerMoneyRules?: Resolver<Maybe<ResolversTypes['MoneyRulesUpdateCustomerMoneyRulesResult']>, ParentType, ContextType, RequireFields<MutationUpdateCustomerMoneyRulesArgs, 'input'>>;
  updateElapsedTimeForLearnQuiz?: Resolver<ResolversTypes['UpdateElapsedTimeForLearnQuizResult'], ParentType, ContextType, RequireFields<MutationUpdateElapsedTimeForLearnQuizArgs, 'input'>>;
  updateEmail?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'email'>>;
  updateEmployment?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateEmploymentArgs, 'input'>>;
  updateHelpcenterBanner?: Resolver<Maybe<ResolversTypes['helpcenterBannerResponse']>, ParentType, ContextType, RequireFields<MutationUpdateHelpcenterBannerArgs, 'input'>>;
  updateInvestorQuestions?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateInvestorQuestionsArgs, 'input'>>;
  updateLadderQuote?: Resolver<Maybe<ResolversTypes['LadderResponse']>, ParentType, ContextType, RequireFields<MutationUpdateLadderQuoteArgs, 'coverage' | 'quoteId'>>;
  updateLearnContentProgress?: Resolver<ResolversTypes['UpdateLearnProgressResult'], ParentType, ContextType, RequireFields<MutationUpdateLearnContentProgressArgs, 'input'>>;
  updateLinkedAccount?: Resolver<Maybe<ResolversTypes['LinkedAccount']>, ParentType, ContextType, RequireFields<MutationUpdateLinkedAccountArgs, 'input' | 'linkedAccountId'>>;
  updateMoneyManagerAllocations?: Resolver<ResolversTypes['UpdateMoneyManagerAllocationsResult'], ParentType, ContextType, RequireFields<MutationUpdateMoneyManagerAllocationsArgs, 'input'>>;
  updateMoneyManagerAutomationTarget?: Resolver<ResolversTypes['UpdateMoneyManagerAutomationTargetResult'], ParentType, ContextType, RequireFields<MutationUpdateMoneyManagerAutomationTargetArgs, 'input'>>;
  updateMoneyManagerSettings?: Resolver<ResolversTypes['UpdateMoneyManagerSettingsResult'], ParentType, ContextType, RequireFields<MutationUpdateMoneyManagerSettingsArgs, 'input'>>;
  updateMoneyRulesSourceSettings?: Resolver<Maybe<ResolversTypes['UpdateMoneyRulesSourceSettingsResult']>, ParentType, ContextType, RequireFields<MutationUpdateMoneyRulesSourceSettingsArgs, 'input'>>;
  updateNegotiationStatus?: Resolver<ResolversTypes['BenefitsMessage'], ParentType, ContextType, RequireFields<MutationUpdateNegotiationStatusArgs, 'negotiationStatusInput'>>;
  updateNotification?: Resolver<Maybe<ResolversTypes['Void']>, ParentType, ContextType, RequireFields<MutationUpdateNotificationArgs, 'active' | 'channel'>>;
  updateOptOutOfTargeting?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType, RequireFields<MutationUpdateOptOutOfTargetingArgs, 'input'>>;
  updatePersonalInfo?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdatePersonalInfoArgs, 'input'>>;
  updatePortfolioSecurities?: Resolver<ResolversTypes['UpdatePortfolioSecuritiesResult'], ParentType, ContextType, RequireFields<MutationUpdatePortfolioSecuritiesArgs, 'input'>>;
  updateProfile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType, RequireFields<MutationUpdateProfileArgs, 'input'>>;
  updatePromotedCampaigns?: Resolver<Maybe<ResolversTypes['UpdatePromotedCampaignsResult']>, ParentType, ContextType, Partial<MutationUpdatePromotedCampaignsArgs>>;
  updateRecurringInvestment?: Resolver<ResolversTypes['RecurringInvestmentPayload'], ParentType, ContextType, RequireFields<MutationUpdateRecurringInvestmentArgs, 'input'>>;
  updateReferralCampaign?: Resolver<ResolversTypes['UpdateReferralCampaignResult'], ParentType, ContextType, RequireFields<MutationUpdateReferralCampaignArgs, 'input'>>;
  updateReferralPayout?: Resolver<ResolversTypes['UpdateReferralPayoutResult'], ParentType, ContextType, RequireFields<MutationUpdateReferralPayoutArgs, 'input'>>;
  updateReferralRelationship?: Resolver<ResolversTypes['UpdateReferralRelationshipResult'], ParentType, ContextType, RequireFields<MutationUpdateReferralRelationshipArgs, 'input'>>;
  updateReferralRewardStatus?: Resolver<ResolversTypes['UpdateReferralRewardResponse'], ParentType, ContextType, RequireFields<MutationUpdateReferralRewardStatusArgs, 'rewardId' | 'rewardStatus'>>;
  updateReferralUserProfile?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationUpdateReferralUserProfileArgs, 'email' | 'updateInfo'>>;
  updateRegistration?: Resolver<ResolversTypes['Result'], ParentType, ContextType, RequireFields<MutationUpdateRegistrationArgs, 'input'>>;
  updateRoundUpAccount?: Resolver<Maybe<ResolversTypes['RoundUpAccount']>, ParentType, ContextType, RequireFields<MutationUpdateRoundUpAccountArgs, 'enabled' | 'linkedSubaccountId'>>;
  updateSignature?: Resolver<Maybe<ResolversTypes['Signature']>, ParentType, ContextType, RequireFields<MutationUpdateSignatureArgs, 'signatureType' | 'svgFile'>>;
  updateSuitability?: Resolver<Maybe<ResolversTypes['suitability_UpdateSuitabilityResult']>, ParentType, ContextType, RequireFields<MutationUpdateSuitabilityArgs, 'suitabilityInput'>>;
  updateUserProfileAndAutomationTarget?: Resolver<ResolversTypes['UpdateUserProfileAndAutomationTargetResult'], ParentType, ContextType, RequireFields<MutationUpdateUserProfileAndAutomationTargetArgs, 'input'>>;
  updateUserSwitchState?: Resolver<ResolversTypes['UpdateUserSwitchState'], ParentType, ContextType, RequireFields<MutationUpdateUserSwitchStateArgs, 'input'>>;
  updateVerificationProfile?: Resolver<ResolversTypes['UpdateVerificationProfileResult'], ParentType, ContextType, RequireFields<MutationUpdateVerificationProfileArgs, 'input'>>;
  upgradeAuthentication?: Resolver<ResolversTypes['UpgradeAuthenticationResult'], ParentType, ContextType>;
  uploadAudienceList?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUploadAudienceListArgs, 'input'>>;
  uploadCheck?: Resolver<Maybe<ResolversTypes['UploadCheckPayload']>, ParentType, ContextType, RequireFields<MutationUploadCheckArgs, 'input'>>;
  uploadDocuments?: Resolver<Array<ResolversTypes['FileOrException']>, ParentType, ContextType, RequireFields<MutationUploadDocumentsArgs, 'input'>>;
  uploadUnsolicitedDocuments?: Resolver<Array<ResolversTypes['FileOrException']>, ParentType, ContextType, RequireFields<MutationUploadUnsolicitedDocumentsArgs, 'input'>>;
  upsertUserMatch?: Resolver<ResolversTypes['UpsertUserMatchResult'], ParentType, ContextType, RequireFields<MutationUpsertUserMatchArgs, 'input'>>;
  validateCredentials?: Resolver<ResolversTypes['ValidateCredentialsResult'], ParentType, ContextType, RequireFields<MutationValidateCredentialsArgs, 'input'>>;
  validateUserSuspendedUploadToken?: Resolver<ResolversTypes['ValidateUserSuspendedUploadTokenResult'], ParentType, ContextType, RequireFields<MutationValidateUserSuspendedUploadTokenArgs, 'input'>>;
  vendAuthSession?: Resolver<ResolversTypes['VendAuthSessionResult'], ParentType, ContextType, RequireFields<MutationVendAuthSessionArgs, 'input'>>;
  verifyDevice?: Resolver<ResolversTypes['VerifyDeviceResult'], ParentType, ContextType, RequireFields<MutationVerifyDeviceArgs, 'input'>>;
  verifyIdentityByDocuments?: Resolver<ResolversTypes['VerifyIdentityByDocumentsResult'], ParentType, ContextType, RequireFields<MutationVerifyIdentityByDocumentsArgs, 'input'>>;
  verifyLaterAccountOrError?: Resolver<ResolversTypes['LaterAccountInfoOrError'], ParentType, ContextType, RequireFields<MutationVerifyLaterAccountOrErrorArgs, 'investmentAccountId'>>;
  verifyPasswords?: Resolver<ResolversTypes['VerifyPasswordsResult'], ParentType, ContextType, RequireFields<MutationVerifyPasswordsArgs, 'input'>>;
  verifyRdvs?: Resolver<ResolversTypes['VerifyRdvsResult'], ParentType, ContextType, RequireFields<MutationVerifyRdvsArgs, 'input'>>;
};

export type NegativeSecurityPercentErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegativeSecurityPercentError'] = ResolversParentTypes['NegativeSecurityPercentError']> = {
  securityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationServiceConnectionFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationServiceConnectionFailure'] = ResolversParentTypes['NegotiationServiceConnectionFailure']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextBillingDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextBillingDate'] = ResolversParentTypes['NextBillingDate']> = {
  next_billing_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextTransferDateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextTransferDateResult'] = ResolversParentTypes['NextTransferDateResult']> = {
  __resolveType: TypeResolveFn<'MalformedRecurringTransferException' | 'RecurringTransferDate', ParentType, ContextType>;
};

export type NoBeneficiaryFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoBeneficiaryFoundException'] = ResolversParentTypes['NoBeneficiaryFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoFundingSourceUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoFundingSourceUserAlert'] = ResolversParentTypes['NoFundingSourceUserAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoProspectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoProspectRecord'] = ResolversParentTypes['NoProspectRecord']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoRegisteredPushAuthenticatorsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoRegisteredPushAuthenticatorsException'] = ResolversParentTypes['NoRegisteredPushAuthenticatorsException']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NonBasicAccountOpenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NonBasicAccountOpenException'] = ResolversParentTypes['NonBasicAccountOpenException']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NonUniqueSingleRuleIdsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['NonUniqueSingleRuleIdsError'] = ResolversParentTypes['NonUniqueSingleRuleIdsError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationMessage'] = ResolversParentTypes['NotificationMessage']> = {
  body?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>;
  cardColor?: Resolver<Maybe<ResolversTypes['CardColor']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deepLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  delay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['MessageVisualAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDismissed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messageCategory?: Resolver<ResolversTypes['MessageCategory'], ParentType, ContextType>;
  messageType?: Resolver<ResolversTypes['MessageType'], ParentType, ContextType>;
  platforms?: Resolver<Array<ResolversTypes['Platform']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['MessageTextAsset'], ParentType, ContextType>;
  trackingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notifications'] = ResolversParentTypes['Notifications']> = {
  emails?: Resolver<Maybe<Array<Maybe<ResolversTypes['Notification']>>>, ParentType, ContextType>;
  pushes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Notification']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OauthAppResolvers<ContextType = any, ParentType extends ResolversParentTypes['OauthApp'] = ResolversParentTypes['OauthApp']> = {
  accessTokenAudience?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  accessTokenExpiry?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  contactEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contract?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  externalApp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  imageUri?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  oauthAppId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pageType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redirectUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshTokenExpiry?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['OauthAppScope']>, ParentType, ContextType>;
  secret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OauthAppType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OauthAppClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['OauthAppClient'] = ResolversParentTypes['OauthAppClient']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  imageUri?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  oauthAppClientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  oauthAppId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OauthAppClientNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OauthAppClientNotFoundException'] = ResolversParentTypes['OauthAppClientNotFoundException']> = {
  oauthAppClientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OauthAppImageUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OauthAppImageUpload'] = ResolversParentTypes['OauthAppImageUpload']> = {
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OauthAppNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OauthAppNotFoundException'] = ResolversParentTypes['OauthAppNotFoundException']> = {
  oauthAppId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OauthAppScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OauthAppScope'] = ResolversParentTypes['OauthAppScope']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OccupationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Occupation'] = ResolversParentTypes['Occupation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['Offer'] = ResolversParentTypes['Offer']> = {
  availableIn?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  availableTo?: Resolver<ResolversTypes['OfferAvailability'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  expiresAfter?: Resolver<Maybe<ResolversTypes['OfferExpiration']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  offering?: Resolver<ResolversTypes['Offering'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['OfferPrice'], ParentType, ContextType>;
  termsUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OfferType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfferExpirationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferExpiration'] = ResolversParentTypes['OfferExpiration']> = {
  period?: Resolver<ResolversTypes['OfferExpirationPeriod'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfferLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferLocation'] = ResolversParentTypes['OfferLocation']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfferPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferPrice'] = ResolversParentTypes['OfferPrice']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OfferPriceType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfferingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Offering'] = ResolversParentTypes['Offering']> = {
  __resolveType: TypeResolveFn<'Product' | 'Tier', ParentType, ContextType>;
};

export type OidcCredentialsAlreadyLinkedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OidcCredentialsAlreadyLinkedException'] = ResolversParentTypes['OidcCredentialsAlreadyLinkedException']> = {
  subId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OidcCredentialsNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OidcCredentialsNotFoundException'] = ResolversParentTypes['OidcCredentialsNotFoundException']> = {
  oidcProvider?: Resolver<Maybe<ResolversTypes['OidcProvider']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OidcCredentialsTakenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OidcCredentialsTakenException'] = ResolversParentTypes['OidcCredentialsTakenException']> = {
  subId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingProductStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingProductStatus'] = ResolversParentTypes['OnboardingProductStatus']> = {
  claimStatus?: Resolver<ResolversTypes['ClaimStatus'], ParentType, ContextType>;
  claimedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<Array<Maybe<ResolversTypes['ClaimStatusDetails']>>>, ParentType, ContextType>;
  expiresOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingProductTileResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingProductTile'] = ResolversParentTypes['OnboardingProductTile']> = {
  claimDetails?: Resolver<ResolversTypes['OnboardingProductStatus'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['OnboardingProducts'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitProductStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingTileGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingTileGroup'] = ResolversParentTypes['OnboardingTileGroup']> = {
  group?: Resolver<ResolversTypes['OnboardingGroups'], ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnboardingProductTile']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingTipItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingTipItem'] = ResolversParentTypes['OnboardingTipItem']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OnboardingTipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingTipsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingTips'] = ResolversParentTypes['OnboardingTips']> = {
  items?: Resolver<Array<ResolversTypes['OnboardingTipItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnlineSwitchResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnlineSwitch'] = ResolversParentTypes['OnlineSwitch']> = {
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vendorTargetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenAccountsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenAccountsException'] = ResolversParentTypes['OpenAccountsException']> = {
  openAccountTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenCoreInvestmentAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenCoreInvestmentAccountResult'] = ResolversParentTypes['OpenCoreInvestmentAccountResult']> = {
  __resolveType: TypeResolveFn<'CoreAccountAlreadyExistsException' | 'InvalidPortfolioIdException' | 'InvestmentAccount' | 'InvestmentAccountCreationException' | 'UserClosedException' | 'UserNotFoundException', ParentType, ContextType>;
};

export type OpenEarlyAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenEarlyAccountResult'] = ResolversParentTypes['OpenEarlyAccountResult']> = {
  __resolveType: TypeResolveFn<'BeneficiaryAccountExistsException' | 'CoreAccountClosedException' | 'InternalErrorException' | 'InvalidStateException' | 'InvalidSubscriptionTierException' | 'InvalidTerminationAgeException' | 'InvestmentAccount' | 'MaxAccountsCreatedException' | 'MissingBeneficiarySsnException' | 'NoBeneficiaryFoundException' | 'UserClosedException' | 'UserNotFoundException' | 'UserNotVerifiedException', ParentType, ContextType>;
};

export type OrderBankCardResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBankCardResult'] = ResolversParentTypes['OrderBankCardResult']> = {
  __resolveType: TypeResolveFn<'BankCardOrder', ParentType, ContextType>;
};

export type OutsideContributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutsideContribution'] = ResolversParentTypes['OutsideContribution']> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  checkoutCart?: Resolver<ResolversTypes['OutsideContributionCheckoutCart'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethodId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['ContributionState'], ParentType, ContextType>;
  transferRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutsideContributionCheckoutCartResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutsideContributionCheckoutCart'] = ResolversParentTypes['OutsideContributionCheckoutCart']> = {
  code?: Resolver<ResolversTypes['OutsideContributionCode'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  feeAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentIntentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckoutCartStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutsideContributionCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutsideContributionCode'] = ResolversParentTypes['OutsideContributionCode']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  recipientFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  signupBonusUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutsideContributionProspectResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutsideContributionProspect'] = ResolversParentTypes['OutsideContributionProspect']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerDataShareResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerDataShare'] = ResolversParentTypes['PartnerDataShare']> = {
  partner?: Resolver<ResolversTypes['BenefitsPartner'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerDataShareResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerDataShareResponse'] = ResolversParentTypes['PartnerDataShareResponse']> = {
  __resolveType: TypeResolveFn<'PartnerDataShare' | 'ProductNotSupportedException', ParentType, ContextType>;
};

export type PartnerDetailsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerDetailsResponse'] = ResolversParentTypes['PartnerDetailsResponse']> = {
  partnerLogoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  partnerName?: Resolver<ResolversTypes['BenefitsPartner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerDocumentUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerDocumentUrlResponse'] = ResolversParentTypes['PartnerDocumentUrlResponse']> = {
  documentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerOfferGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerOfferGroup'] = ResolversParentTypes['PartnerOfferGroup']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselType?: Resolver<ResolversTypes['CarouselType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  offers?: Resolver<Array<ResolversTypes['PartnerOfferGroupItem']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerOfferGroupItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerOfferGroupItem'] = ResolversParentTypes['PartnerOfferGroupItem']> = {
  __resolveType: TypeResolveFn<'EarnOffer' | 'JobOffer' | 'JobSearchOffer' | 'PromoOffer', ParentType, ContextType>;
};

export type PartnerUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerUrlResponse'] = ResolversParentTypes['PartnerUrlResponse']> = {
  partnerUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AcornsPartnerStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordResetFormResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordResetForm'] = ResolversParentTypes['PasswordResetForm']> = {
  fields?: Resolver<Array<Maybe<ResolversTypes['PasswordResetFormFields']>>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordResetFormFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordResetFormFields'] = ResolversParentTypes['PasswordResetFormFields']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastAnnotatedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastAnnotatedItem'] = ResolversParentTypes['PastAnnotatedItem']> = {
  __resolveType: TypeResolveFn<'EarlyGiftItem', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PastBeneficiaryInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastBeneficiaryInfo'] = ResolversParentTypes['PastBeneficiaryInfo']> = {
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastBeneficiaryTransferInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastBeneficiaryTransferInvestmentItem'] = ResolversParentTypes['PastBeneficiaryTransferInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastCashOwedCollectionInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastCashOwedCollectionInvestmentItem'] = ResolversParentTypes['PastCashOwedCollectionInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastCashReinvestmentInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastCashReinvestmentInvestmentItem'] = ResolversParentTypes['PastCashReinvestmentInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastCoreCombinedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastCoreCombinedItem'] = ResolversParentTypes['PastCoreCombinedItem']> = {
  __resolveType: TypeResolveFn<'CoreInvestmentItem' | 'CoreRoundUpsItem', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCombinedInvestment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type PastCoreItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastCoreItem'] = ResolversParentTypes['PastCoreItem']> = {
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastCoreSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastCoreSummary'] = ResolversParentTypes['PastCoreSummary']> = {
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  foundMoneyRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  investments?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  netReturns?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  referralRewards?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  withdrawals?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastCoreTradedItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastCoreTradedItem'] = ResolversParentTypes['PastCoreTradedItem']> = {
  __resolveType: TypeResolveFn<'CoreAdjustmentItem' | 'CoreDebtCollectionItem' | 'CoreDividendsItem' | 'CoreEmployeeCreditItem' | 'CoreFeeInvestmentItem' | 'CoreFoundMoneyRewardItem' | 'CoreGiftCardCreditRedemptionItem' | 'CoreInvestmentItem' | 'CoreLocalFoundMoneyItem' | 'CorePartnerRewardItem' | 'CoreRebalanceItem' | 'CoreReferralRewardItem' | 'CoreRefundedItem' | 'CoreReinvestmentItem' | 'CoreRoundUpsItem' | 'CoreWithdrawalItem' | 'EarlyDebtCollectionItem' | 'EarlyDividendsItem' | 'EarlyFeeInvestmentItem' | 'EarlyGiftItem' | 'EarlyInvestmentItem' | 'EarlyMatchItem' | 'EarlyMatchRemovalItem' | 'EarlyRefundedItem' | 'EarlyReinvestmentItem' | 'EarlyWithdrawalItem' | 'LaterDebtCollectionItem' | 'LaterDividendsItem' | 'LaterFeeInvestmentItem' | 'LaterInvestmentItem' | 'LaterMatchItem' | 'LaterMatchRemovalItem' | 'LaterRebalanceItem' | 'LaterRefundedItem' | 'LaterReinvestmentItem' | 'LaterWithdrawalItem', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tradeConfirmationUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
};

export type PastDividendInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastDividendInvestmentItem'] = ResolversParentTypes['PastDividendInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastEarlyItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastEarlyItem'] = ResolversParentTypes['PastEarlyItem']> = {
  __resolveType: TypeResolveFn<'EarlyDividendsItem' | 'EarlyFeeInvestmentItem' | 'EarlyGiftItem' | 'EarlyInvestmentItem' | 'EarlyMatchItem' | 'EarlyMatchRemovalItem' | 'EarlyRefundedItem' | 'EarlyReinvestmentItem' | 'EarlyWithdrawalItem', ParentType, ContextType>;
  beneficiaryAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PastEarlySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastEarlySummary'] = ResolversParentTypes['PastEarlySummary']> = {
  contributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  netReturns?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  withdrawals?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastEmployeeContributionInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastEmployeeContributionInvestmentItem'] = ResolversParentTypes['PastEmployeeContributionInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastExternalTransferInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastExternalTransferInvestmentItem'] = ResolversParentTypes['PastExternalTransferInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastExternalTransferReversedInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastExternalTransferReversedInvestmentItem'] = ResolversParentTypes['PastExternalTransferReversedInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastFeeInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastFeeInvestmentItem'] = ResolversParentTypes['PastFeeInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastGiftCardInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastGiftCardInvestmentItem'] = ResolversParentTypes['PastGiftCardInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastIraTransferInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastIRATransferInvestmentItem'] = ResolversParentTypes['PastIRATransferInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastInvestmentItem'] = ResolversParentTypes['PastInvestmentItem']> = {
  __resolveType: TypeResolveFn<'PastBeneficiaryTransferInvestmentItem' | 'PastCashOwedCollectionInvestmentItem' | 'PastCashReinvestmentInvestmentItem' | 'PastDividendInvestmentItem' | 'PastEmployeeContributionInvestmentItem' | 'PastExternalTransferInvestmentItem' | 'PastExternalTransferReversedInvestmentItem' | 'PastFeeInvestmentItem' | 'PastGiftCardInvestmentItem' | 'PastIRATransferInvestmentItem' | 'PastLumpSumInvestment' | 'PastMatchInvestmentItem' | 'PastMatchRemovalInvestmentItem' | 'PastOutsideContributionInvestmentItem' | 'PastRealTimeRoundUpInvestmentItem' | 'PastRebalanceInvestmentItem' | 'PastRecurringInvestmentItem' | 'PastReferralRewardInvestmentItem' | 'PastReferralRewardMatchInvestmentItem' | 'PastRefundInvestmentItem' | 'PastReversalInvestmentItem' | 'PastRewardInvestmentItem' | 'PastRewardMatchInvestmentItem' | 'PastRoundUpItem' | 'PastRoundUpMatchInvestmentItem' | 'PastSecurityLiquidationInvestmentItem' | 'PastSmartDepositInvestmentItem' | 'PastWithdrawalInvestmentItem', ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
};

export type PastItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastItem'] = ResolversParentTypes['PastItem']> = {
  __resolveType: TypeResolveFn<'CoreACHSubscriptionFeeItem' | 'CoreAdjustmentItem' | 'CoreCashForwardItem' | 'CoreCollectionItem' | 'CoreDebtCollectionItem' | 'CoreDividendsItem' | 'CoreEmployeeCreditItem' | 'CoreFeeInvestmentItem' | 'CoreFoundMoneyRewardItem' | 'CoreGiftCardCreditRedemptionItem' | 'CoreHoldingsTransferInItem' | 'CoreInvestmentItem' | 'CoreLocalFoundMoneyItem' | 'CorePartnerRewardItem' | 'CoreRebalanceItem' | 'CoreReferralRewardItem' | 'CoreRefundedItem' | 'CoreReinvestmentItem' | 'CoreRoundUpsItem' | 'CoreWithdrawalItem' | 'EarlyDebtCollectionItem' | 'EarlyDividendsItem' | 'EarlyFeeInvestmentItem' | 'EarlyGiftItem' | 'EarlyInvestmentItem' | 'EarlyMatchItem' | 'EarlyMatchRemovalItem' | 'EarlyRefundedItem' | 'EarlyReinvestmentItem' | 'EarlyWithdrawalItem' | 'LaterDebtCollectionItem' | 'LaterDividendsItem' | 'LaterFeeInvestmentItem' | 'LaterInvestmentItem' | 'LaterMatchItem' | 'LaterMatchRemovalItem' | 'LaterRebalanceItem' | 'LaterRefundedItem' | 'LaterReinvestmentItem' | 'LaterWithdrawalItem' | 'PastBeneficiaryTransferInvestmentItem' | 'PastCashOwedCollectionInvestmentItem' | 'PastCashReinvestmentInvestmentItem' | 'PastCoreItem' | 'PastDividendInvestmentItem' | 'PastEmployeeContributionInvestmentItem' | 'PastExternalTransferInvestmentItem' | 'PastExternalTransferReversedInvestmentItem' | 'PastFeeInvestmentItem' | 'PastGiftCardInvestmentItem' | 'PastIRATransferInvestmentItem' | 'PastLumpSumInvestment' | 'PastMatchInvestmentItem' | 'PastMatchRemovalInvestmentItem' | 'PastOutsideContributionInvestmentItem' | 'PastRealTimeRoundUpInvestmentItem' | 'PastRebalanceInvestmentItem' | 'PastRecurringInvestmentItem' | 'PastReferralRewardInvestmentItem' | 'PastReferralRewardMatchInvestmentItem' | 'PastRefundInvestmentItem' | 'PastReversalInvestmentItem' | 'PastRewardInvestmentItem' | 'PastRewardMatchInvestmentItem' | 'PastRoundUpItem' | 'PastRoundUpMatchInvestmentItem' | 'PastSecurityLiquidationInvestmentItem' | 'PastSmartDepositInvestmentItem' | 'PastSpendItem' | 'PastWithdrawalInvestmentItem' | 'SaveInterestPaidItem' | 'SaveTransferInItem' | 'SaveTransferOutItem' | 'SpendATMReimbursementItem' | 'SpendATMWithdrawalItem' | 'SpendBillPayItem' | 'SpendCheckDepositItem' | 'SpendCheckPaymentItem' | 'SpendDigitalWalletItem' | 'SpendDirectDepositItem' | 'SpendECheckItem' | 'SpendInterestPaidItem' | 'SpendPurchaseItem' | 'SpendRealTimeRoundUpItem' | 'SpendTransferInItem' | 'SpendTransferOutItem', ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type PastItemConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastItemConnection'] = ResolversParentTypes['PastItemConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PastItemEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastItemEdge'] = ResolversParentTypes['PastItemEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PastItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastLaterSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastLaterSummary'] = ResolversParentTypes['PastLaterSummary']> = {
  contributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  currentYearContributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  dividends?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  netReturns?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  priorYearContributions?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  withdrawals?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastLumpSumInvestmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastLumpSumInvestment'] = ResolversParentTypes['PastLumpSumInvestment']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastMatchInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastMatchInvestmentItem'] = ResolversParentTypes['PastMatchInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastMatchRemovalInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastMatchRemovalInvestmentItem'] = ResolversParentTypes['PastMatchRemovalInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastMoneyManagerAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastMoneyManagerAllocation'] = ResolversParentTypes['PastMoneyManagerAllocation']> = {
  allocationAmount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  allocationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  targetAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastMoneyManagerAllocationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastMoneyManagerAllocations'] = ResolversParentTypes['PastMoneyManagerAllocations']> = {
  __resolveType: TypeResolveFn<'PastMoneyManagerRecurrenceItem' | 'PastMoneyManagerScheduledPaycheckItem', ParentType, ContextType>;
  allocations?: Resolver<Array<ResolversTypes['PastMoneyManagerAllocation']>, ParentType, ContextType>;
};

export type PastMoneyManagerRecurrenceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastMoneyManagerRecurrenceItem'] = ResolversParentTypes['PastMoneyManagerRecurrenceItem']> = {
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  allocations?: Resolver<Array<ResolversTypes['PastMoneyManagerAllocation']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  recurrence?: Resolver<ResolversTypes['PastRecurrenceSettingsV2'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastMoneyManagerScheduledPaycheckItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastMoneyManagerScheduledPaycheckItem'] = ResolversParentTypes['PastMoneyManagerScheduledPaycheckItem']> = {
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  allocations?: Resolver<Array<ResolversTypes['PastMoneyManagerAllocation']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedNextDeposit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastOutsideContributionInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastOutsideContributionInvestmentItem'] = ResolversParentTypes['PastOutsideContributionInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRealTimeRoundUpInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRealTimeRoundUpInvestmentItem'] = ResolversParentTypes['PastRealTimeRoundUpInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRebalanceInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRebalanceInvestmentItem'] = ResolversParentTypes['PastRebalanceInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRecurrenceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRecurrenceItem'] = ResolversParentTypes['PastRecurrenceItem']> = {
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiary?: Resolver<Maybe<ResolversTypes['PastBeneficiaryInfo']>, ParentType, ContextType>;
  recurrence?: Resolver<ResolversTypes['PastRecurrenceSettings'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRecurrenceItemV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRecurrenceItemV2'] = ResolversParentTypes['PastRecurrenceItemV2']> = {
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  beneficiary?: Resolver<Maybe<ResolversTypes['Beneficiary']>, ParentType, ContextType>;
  recurrence?: Resolver<ResolversTypes['PastRecurrenceSettingsV2'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRecurrenceSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRecurrenceSettings'] = ResolversParentTypes['PastRecurrenceSettings']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dayOfMonth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  daysOfMonth?: Resolver<Maybe<Array<ResolversTypes['Float']>>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['RecurrenceFrequency'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weekday?: Resolver<Maybe<ResolversTypes['DayOfWeek']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRecurrenceSettingsV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRecurrenceSettingsV2'] = ResolversParentTypes['PastRecurrenceSettingsV2']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dayOfMonth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  daysOfMonth?: Resolver<Maybe<Array<ResolversTypes['Float']>>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['RecurrenceFrequency'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weekday?: Resolver<Maybe<ResolversTypes['DayOfWeek']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRecurringInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRecurringInvestmentItem'] = ResolversParentTypes['PastRecurringInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastReferralRewardInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastReferralRewardInvestmentItem'] = ResolversParentTypes['PastReferralRewardInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastReferralRewardMatchInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastReferralRewardMatchInvestmentItem'] = ResolversParentTypes['PastReferralRewardMatchInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRefundInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRefundInvestmentItem'] = ResolversParentTypes['PastRefundInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastReversalInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastReversalInvestmentItem'] = ResolversParentTypes['PastReversalInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRewardInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRewardInvestmentItem'] = ResolversParentTypes['PastRewardInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRewardMatchInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRewardMatchInvestmentItem'] = ResolversParentTypes['PastRewardMatchInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  partnerLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRoundUpItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRoundUpItem'] = ResolversParentTypes['PastRoundUpItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastRoundUpMatchInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastRoundUpMatchInvestmentItem'] = ResolversParentTypes['PastRoundUpMatchInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastScheduledItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastScheduledItem'] = ResolversParentTypes['PastScheduledItem']> = {
  __resolveType: TypeResolveFn<'PastRecurrenceItem' | 'PastSplitDepositItem', ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
};

export type PastScheduledItemV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PastScheduledItemV2'] = ResolversParentTypes['PastScheduledItemV2']> = {
  __resolveType: TypeResolveFn<'PastMoneyManagerRecurrenceItem' | 'PastMoneyManagerScheduledPaycheckItem' | 'PastRecurrenceItemV2' | 'PastSplitDepositItemV2', ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
};

export type PastSecurityLiquidationInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSecurityLiquidationInvestmentItem'] = ResolversParentTypes['PastSecurityLiquidationInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSmartDepositInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSmartDepositInvestmentItem'] = ResolversParentTypes['PastSmartDepositInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSpendItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSpendItem'] = ResolversParentTypes['PastSpendItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSpendSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSpendSummary'] = ResolversParentTypes['PastSpendSummary']> = {
  availableBalance?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  debits?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  debitsLast30Days?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  deposits?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  depositsLast30Days?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  foundMoneyPlus?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  instantRoundUps?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSplitDepositAllocationSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSplitDepositAllocationSettings'] = ResolversParentTypes['PastSplitDepositAllocationSettings']> = {
  allocationList?: Resolver<Array<ResolversTypes['PastSplitDepositAllocations']>, ParentType, ContextType>;
  expectedNextDeposit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSplitDepositAllocationSettingsV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSplitDepositAllocationSettingsV2'] = ResolversParentTypes['PastSplitDepositAllocationSettingsV2']> = {
  allocationList?: Resolver<Array<ResolversTypes['PastSplitDepositAllocationsV2']>, ParentType, ContextType>;
  expectedNextDeposit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSplitDepositAllocationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSplitDepositAllocations'] = ResolversParentTypes['PastSplitDepositAllocations']> = {
  allocationAmount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  targetAccountType?: Resolver<ResolversTypes['SplitDepositTargetAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSplitDepositAllocationsV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSplitDepositAllocationsV2'] = ResolversParentTypes['PastSplitDepositAllocationsV2']> = {
  allocationAmount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  targetAccountType?: Resolver<ResolversTypes['SplitDepositTargetAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSplitDepositItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSplitDepositItem'] = ResolversParentTypes['PastSplitDepositItem']> = {
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  allocations?: Resolver<ResolversTypes['PastSplitDepositAllocationSettings'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  awaitingConfiguration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSplitDepositItemV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSplitDepositItemV2'] = ResolversParentTypes['PastSplitDepositItemV2']> = {
  accountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  allocations?: Resolver<ResolversTypes['PastSplitDepositAllocationSettingsV2'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  awaitingConfiguration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastSummary'] = ResolversParentTypes['PastSummary']> = {
  __resolveType: TypeResolveFn<'AllAccountHistorySummary' | 'CheckingHistorySummary' | 'EarlyHistorySummary' | 'EmergencyFundHistorySummary' | 'InvestHistorySummary' | 'LaterHistorySummary', ParentType, ContextType>;
  moneyIn?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  moneyOut?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
};

export type PastTargetedTransferItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastTargetedTransferItem'] = ResolversParentTypes['PastTargetedTransferItem']> = {
  __resolveType: TypeResolveFn<'PastBeneficiaryTransferInvestmentItem' | 'PastCashOwedCollectionInvestmentItem' | 'PastCashReinvestmentInvestmentItem' | 'PastDividendInvestmentItem' | 'PastEmployeeContributionInvestmentItem' | 'PastExternalTransferInvestmentItem' | 'PastExternalTransferReversedInvestmentItem' | 'PastFeeInvestmentItem' | 'PastGiftCardInvestmentItem' | 'PastIRATransferInvestmentItem' | 'PastLumpSumInvestment' | 'PastMatchInvestmentItem' | 'PastMatchRemovalInvestmentItem' | 'PastOutsideContributionInvestmentItem' | 'PastRealTimeRoundUpInvestmentItem' | 'PastRecurringInvestmentItem' | 'PastReferralRewardInvestmentItem' | 'PastReferralRewardMatchInvestmentItem' | 'PastRefundInvestmentItem' | 'PastReversalInvestmentItem' | 'PastRewardInvestmentItem' | 'PastRewardMatchInvestmentItem' | 'PastRoundUpItem' | 'PastRoundUpMatchInvestmentItem' | 'PastSecurityLiquidationInvestmentItem' | 'PastSmartDepositInvestmentItem' | 'PastSpendItem' | 'PastWithdrawalInvestmentItem' | 'SaveInterestPaidItem' | 'SaveTransferInItem' | 'SaveTransferOutItem' | 'SpendATMReimbursementItem' | 'SpendATMWithdrawalItem' | 'SpendBillPayItem' | 'SpendCheckDepositItem' | 'SpendCheckPaymentItem' | 'SpendDigitalWalletItem' | 'SpendDirectDepositItem' | 'SpendECheckItem' | 'SpendInterestPaidItem' | 'SpendPurchaseItem' | 'SpendRealTimeRoundUpItem' | 'SpendTransferInItem' | 'SpendTransferOutItem', ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PastUserTransferItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastUserTransferItem'] = ResolversParentTypes['PastUserTransferItem']> = {
  __resolveType: TypeResolveFn<'CoreInvestmentItem' | 'CoreRoundUpsItem' | 'CoreWithdrawalItem' | 'EarlyInvestmentItem' | 'EarlyWithdrawalItem' | 'LaterInvestmentItem' | 'LaterWithdrawalItem' | 'SaveTransferInItem' | 'SaveTransferOutItem' | 'SpendTransferInItem' | 'SpendTransferOutItem', ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type PastWithdrawalInvestmentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastWithdrawalInvestmentItem'] = ResolversParentTypes['PastWithdrawalInvestmentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutRelationshipResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutRelationshipResult'] = ResolversParentTypes['PayoutRelationshipResult']> = {
  action?: Resolver<Maybe<ResolversTypes['ManagePayoutRelationshipAction']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ManagePayoutRelationshipResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PdfDownloadUrlPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PdfDownloadUrlPayload'] = ResolversParentTypes['PdfDownloadUrlPayload']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Performance'] = ResolversParentTypes['Performance']> = {
  accountValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountValue']>>>, ParentType, ContextType>;
  marketChange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketChangePercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketChangePercentWithoutFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketChangeWithoutFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previousCloseAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalInvested?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalInvestedWithPending?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['Phone'] = ResolversParentTypes['Phone']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneAuthenticatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneAuthenticator'] = ResolversParentTypes['PhoneAuthenticator']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastAuthenticatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PhoneNumberScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PhoneNumber'], any> {
  name: 'PhoneNumber';
}

export type PhoneNumberOptedOutExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberOptedOutException'] = ResolversParentTypes['PhoneNumberOptedOutException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneRedirectResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneRedirect'] = ResolversParentTypes['PhoneRedirect']> = {
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlaidLayerLinkSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaidLayerLinkSession'] = ResolversParentTypes['PlaidLayerLinkSession']> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PoliciesRecordDoesNotExistExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PoliciesRecordDoesNotExistException'] = ResolversParentTypes['PoliciesRecordDoesNotExistException']> = {
  policyInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Policy'] = ResolversParentTypes['Policy']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyNotAddedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyNotAddedException'] = ResolversParentTypes['PolicyNotAddedException']> = {
  policyInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['Portfolio'] = ResolversParentTypes['Portfolio']> = {
  accountAllocation?: Resolver<ResolversTypes['PortfolioAllocation'], ParentType, ContextType>;
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  customizationLevel?: Resolver<Maybe<ResolversTypes['PortfolioCustomizationLevel']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  etfs?: Resolver<Maybe<Array<ResolversTypes['ETF']>>, ParentType, ContextType>;
  holdings?: Resolver<Maybe<Array<ResolversTypes['PortfolioHolding']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  minimumManagedAllocationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  portfolioSecurities?: Resolver<Maybe<Array<ResolversTypes['PortfolioSecurity']>>, ParentType, ContextType>;
  portfolioSecurityAllocations?: Resolver<Maybe<Array<ResolversTypes['PortfolioSecurityAllocation']>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['PortfolioProjection']>, ParentType, ContextType>;
  riskLevel?: Resolver<ResolversTypes['PortfolioRiskLevel'], ParentType, ContextType>;
  theme?: Resolver<ResolversTypes['PortfolioTheme'], ParentType, ContextType>;
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioAllocation'] = ResolversParentTypes['PortfolioAllocation']> = {
  allocationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioAlreadyRemovedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioAlreadyRemovedError'] = ResolversParentTypes['PortfolioAlreadyRemovedError']> = {
  portfolioRemovedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioHoldingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioHolding'] = ResolversParentTypes['PortfolioHolding']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioNotFoundException'] = ResolversParentTypes['PortfolioNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioNotSupportedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioNotSupportedException'] = ResolversParentTypes['PortfolioNotSupportedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioProjection'] = ResolversParentTypes['PortfolioProjection']> = {
  averageGrowthRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  highestGrowthRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lowestGrowthRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioRemovalInProgressErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioRemovalInProgressError'] = ResolversParentTypes['PortfolioRemovalInProgressError']> = {
  clientMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioSecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioSecurity'] = ResolversParentTypes['PortfolioSecurity']> = {
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  marketValue?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAllocationPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  todaysReturn?: Resolver<ResolversTypes['MarketReturn'], ParentType, ContextType>;
  totalReturn?: Resolver<ResolversTypes['MarketReturn'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioSecurityAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioSecurityAllocation'] = ResolversParentTypes['PortfolioSecurityAllocation']> = {
  allocationPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentCategories?: Resolver<ResolversTypes['InvestmentCategory'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  removableFromBasePortfolio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  security?: Resolver<Maybe<ResolversTypes['Security']>, ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioSecurityLimitReachedResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioSecurityLimitReached'] = ResolversParentTypes['PortfolioSecurityLimitReached']> = {
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioUpdateFailedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioUpdateFailedException'] = ResolversParentTypes['PortfolioUpdateFailedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PositiveFloatScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PositiveFloat'], any> {
  name: 'PositiveFloat';
}

export type PreferredAccountNotEligibleErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreferredAccountNotEligibleError'] = ResolversParentTypes['PreferredAccountNotEligibleError']> = {
  fundingSourceUuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreferredAccountNotSupportedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreferredAccountNotSupportedError'] = ResolversParentTypes['PreferredAccountNotSupportedError']> = {
  userUuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PresentableProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['PresentableProduct'] = ResolversParentTypes['PresentableProduct']> = {
  descriptionKeys?: Resolver<Array<ResolversTypes['StringKey']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreviousFundingSourcePendingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviousFundingSourcePending'] = ResolversParentTypes['PreviousFundingSourcePending']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  descriptionKeys?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['ProductKey'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductNotSupportedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductNotSupportedException'] = ResolversParentTypes['ProductNotSupportedException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = {
  annualIncome?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combinedAnnualIncome?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  debt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  employees?: Resolver<Maybe<ResolversTypes['Employees']>, ParentType, ContextType>;
  employmentStatus?: Resolver<Maybe<ResolversTypes['EmploymentStatus']>, ParentType, ContextType>;
  filingType?: Resolver<Maybe<ResolversTypes['FilingType']>, ParentType, ContextType>;
  financialEducation?: Resolver<Maybe<ResolversTypes['FinancialEducation']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundsAvailability?: Resolver<Maybe<ResolversTypes['FundsAvailability']>, ParentType, ContextType>;
  highInterestDebt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  investmentGoal?: Resolver<Maybe<ResolversTypes['InvestmentGoal']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maritalStatus?: Resolver<Maybe<ResolversTypes['MaritalStatus']>, ParentType, ContextType>;
  monthlyExpenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  netWorth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  optedOutOfTargeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  retirementPlanAccess?: Resolver<Maybe<ResolversTypes['RetirementPlanAccess']>, ParentType, ContextType>;
  selfEmployedIncome?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signatures?: Resolver<Array<Maybe<ResolversTypes['Signature']>>, ParentType, ContextType>;
  ssnLastFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transfersPaused?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCode'] = ResolversParentTypes['PromoCode']> = {
  businessLine?: Resolver<ResolversTypes['PromoCodeBusinessLine'], ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  condensedTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internalMemo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  publishStart?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  qualificationAction?: Resolver<ResolversTypes['PromoCodeQualificationAction'], ParentType, ContextType>;
  qualificationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rewards?: Resolver<Array<ResolversTypes['PromoCodeReward']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PromoCodeStatus'], ParentType, ContextType>;
  termsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodeCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodeCustomer'] = ResolversParentTypes['PromoCodeCustomer']> = {
  promoCode?: Resolver<ResolversTypes['PromoCode'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodeEdge'] = ResolversParentTypes['PromoCodeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PromoCode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodeFieldLengthErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodeFieldLengthError'] = ResolversParentTypes['PromoCodeFieldLengthError']> = {
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodePaginatedInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodePaginatedInfo'] = ResolversParentTypes['PromoCodePaginatedInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodeRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodeReward'] = ResolversParentTypes['PromoCodeReward']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PromoCodeRewardType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodeRewardEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodeRewardEdge'] = ResolversParentTypes['PromoCodeRewardEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PromoCodeReward'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodeRewardsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodeRewardsConnection'] = ResolversParentTypes['PromoCodeRewardsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PromoCodeRewardEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PromoCodePaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoCodesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoCodesConnection'] = ResolversParentTypes['PromoCodesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PromoCodeEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PromoCodePaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromoOfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromoOffer'] = ResolversParentTypes['PromoOffer']> = {
  backgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  desktopBackgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  partnerUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotedBenefitResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotedBenefit'] = ResolversParentTypes['PromotedBenefit']> = {
  product?: Resolver<ResolversTypes['BenefitsTrackerProducts'], ParentType, ContextType>;
  promotedThrough?: Resolver<Array<ResolversTypes['BenefitPromotedThrough']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotedCampaignsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotedCampaigns'] = ResolversParentTypes['PromotedCampaigns']> = {
  campaignIds?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Promotion'] = ResolversParentTypes['Promotion']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['PromotionDuration']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  incentives?: Resolver<Maybe<Array<ResolversTypes['Incentive']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  offering?: Resolver<ResolversTypes['Offering'], ParentType, ContextType>;
  presentInContexts?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  termsUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionConsumedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionConsumedError'] = ResolversParentTypes['PromotionConsumedError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionDurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionDuration'] = ResolversParentTypes['PromotionDuration']> = {
  period?: Resolver<ResolversTypes['PromotionDurationPeriod'], ParentType, ContextType>;
  periodCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionExpiredErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionExpiredError'] = ResolversParentTypes['PromotionExpiredError']> = {
  expiredAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionNotFoundError'] = ResolversParentTypes['PromotionNotFoundError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionalWaiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionalWaiver'] = ResolversParentTypes['PromotionalWaiver']> = {
  promotion?: Resolver<Maybe<ResolversTypes['WaiverPromotion']>, ParentType, ContextType>;
  promotionalWaiverPeriodEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionalWaiver_V2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionalWaiver_V2'] = ResolversParentTypes['PromotionalWaiver_V2']> = {
  promotion?: Resolver<ResolversTypes['WaiverPromotion_V2'], ParentType, ContextType>;
  promotionalWaiverPeriodEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProspectResolvers<ContextType = any, ParentType extends ResolversParentTypes['Prospect'] = ResolversParentTypes['Prospect']> = {
  __resolveType: TypeResolveFn<'GrowProspect' | 'LaterWaitlistProspect' | 'OutsideContributionProspect', ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type ProvisionalWaiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProvisionalWaiver'] = ResolversParentTypes['ProvisionalWaiver']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  waiverPeriodEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  waiverReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProvisionalWaiver_V2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ProvisionalWaiver_V2'] = ResolversParentTypes['ProvisionalWaiver_V2']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  waiverPeriodEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  waiverReason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PushAuthChallengeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PushAuthChallenge'] = ResolversParentTypes['PushAuthChallenge']> = {
  alternateAuthenticators?: Resolver<Array<ResolversTypes['AuthenticatorInfo']>, ParentType, ContextType>;
  challengeTrigger?: Resolver<ResolversTypes['ChallengeTriggers'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pushState?: Resolver<ResolversTypes['ChallengePushState'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PushAuthenticatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PushAuthenticator'] = ResolversParentTypes['PushAuthenticator']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  deviceType?: Resolver<ResolversTypes['DeviceType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastAuthenticatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PushAuthenticatorAlreadyExistsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PushAuthenticatorAlreadyExistsException'] = ResolversParentTypes['PushAuthenticatorAlreadyExistsException']> = {
  authenticatorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QualificationSubTypeMismatchErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['QualificationSubTypeMismatchError'] = ResolversParentTypes['QualificationSubTypeMismatchError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  MightyOakCardWaiver?: Resolver<ResolversTypes['MightyOakWaiverResult'], ParentType, ContextType>;
  acceptanceDocument?: Resolver<Maybe<ResolversTypes['AcceptanceDocument']>, ParentType, ContextType, RequireFields<QueryAcceptanceDocumentArgs, 'type'>>;
  acceptanceDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['AcceptanceDocument']>>>, ParentType, ContextType, Partial<QueryAcceptanceDocumentsArgs>>;
  accountPointsRuleByMilestoneId?: Resolver<Maybe<ResolversTypes['AccountPointsRule']>, ParentType, ContextType, RequireFields<QueryAccountPointsRuleByMilestoneIdArgs, 'milestoneID'>>;
  accountPointsRules?: Resolver<Maybe<Array<ResolversTypes['AccountPointsRule']>>, ParentType, ContextType>;
  accountStrength?: Resolver<Maybe<ResolversTypes['AccountStrengthResult']>, ParentType, ContextType, Partial<QueryAccountStrengthArgs>>;
  accounts?: Resolver<Array<Maybe<ResolversTypes['Account']>>, ParentType, ContextType, Partial<QueryAccountsArgs>>;
  actionFeed?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionCard']>>>, ParentType, ContextType, Partial<QueryActionFeedArgs>>;
  actionScreen?: Resolver<Array<ResolversTypes['ActionScreenComponent']>, ParentType, ContextType, Partial<QueryActionScreenArgs>>;
  activeEarnOffers?: Resolver<ResolversTypes['EarnOfferQueryPage'], ParentType, ContextType, Partial<QueryActiveEarnOffersArgs>>;
  activeReferralCampaigns?: Resolver<Maybe<ResolversTypes['ActiveReferralCampaignOutput']>, ParentType, ContextType>;
  activity?: Resolver<Maybe<Array<Maybe<ResolversTypes['Activity']>>>, ParentType, ContextType, Partial<QueryActivityArgs>>;
  activitySummary?: Resolver<Maybe<ResolversTypes['ActivitySummaryResponse']>, ParentType, ContextType, Partial<QueryActivitySummaryArgs>>;
  addressDeliverability?: Resolver<Maybe<ResolversTypes['AddressDeliverabilityResult']>, ParentType, ContextType, RequireFields<QueryAddressDeliverabilityArgs, 'input'>>;
  addresses?: Resolver<Array<Maybe<ResolversTypes['Address']>>, ParentType, ContextType, Partial<QueryAddressesArgs>>;
  advocate?: Resolver<Maybe<ResolversTypes['Advocate']>, ParentType, ContextType>;
  advocateFriendsStatuses?: Resolver<Maybe<ResolversTypes['AdvocateFriendsStatuses']>, ParentType, ContextType>;
  alertHubBeneficiaryAlerts?: Resolver<Maybe<Array<ResolversTypes['AlertHubBeneficiaryAlert']>>, ParentType, ContextType>;
  allAcceptanceDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['AcceptanceDocument']>>>, ParentType, ContextType, Partial<QueryAllAcceptanceDocumentsArgs>>;
  allAccounts?: Resolver<Array<ResolversTypes['CustomerAccount']>, ParentType, ContextType, Partial<QueryAllAccountsArgs>>;
  allBankAccounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['BankAccount']>>>, ParentType, ContextType, RequireFields<QueryAllBankAccountsArgs, 'input'>>;
  allBankCards?: Resolver<Maybe<Array<Maybe<ResolversTypes['BankCard']>>>, ParentType, ContextType, Partial<QueryAllBankCardsArgs>>;
  allBankDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['BankDocument']>>>, ParentType, ContextType, RequireFields<QueryAllBankDocumentsArgs, 'input'>>;
  allBankStatements?: Resolver<Maybe<Array<Maybe<ResolversTypes['BankStatement']>>>, ParentType, ContextType>;
  allBankTransactions?: Resolver<Maybe<ResolversTypes['BankTransactionConnection']>, ParentType, ContextType, Partial<QueryAllBankTransactionsArgs>>;
  allCardTrackingStatuses?: Resolver<Maybe<Array<ResolversTypes['CardDeliveryStatus']>>, ParentType, ContextType, Partial<QueryAllCardTrackingStatusesArgs>>;
  allChatHistoryMessages?: Resolver<ResolversTypes['AllChatHistoryMessages'], ParentType, ContextType, RequireFields<QueryAllChatHistoryMessagesArgs, 'pagination'>>;
  allCheckPayments?: Resolver<Maybe<ResolversTypes['AllCheckPaymentsResult']>, ParentType, ContextType, RequireFields<QueryAllCheckPaymentsArgs, 'pageInput'>>;
  allCloseAccountReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CloseAccountReason']>>>, ParentType, ContextType>;
  allContactCategories?: Resolver<Maybe<Array<ResolversTypes['ContactCategory']>>, ParentType, ContextType>;
  allInvestmentAccounts?: Resolver<Maybe<Array<ResolversTypes['InvestmentAccount']>>, ParentType, ContextType>;
  allMessages?: Resolver<Maybe<Array<ResolversTypes['Message']>>, ParentType, ContextType, Partial<QueryAllMessagesArgs>>;
  allPastCoreItemChildren?: Resolver<Maybe<Array<ResolversTypes['PastItem']>>, ParentType, ContextType, RequireFields<QueryAllPastCoreItemChildrenArgs, 'pastItemId'>>;
  allPastCoreItems?: Resolver<Maybe<ResolversTypes['PastItemConnection']>, ParentType, ContextType, Partial<QueryAllPastCoreItemsArgs>>;
  allPastEarlyItems?: Resolver<Maybe<ResolversTypes['PastItemConnection']>, ParentType, ContextType, RequireFields<QueryAllPastEarlyItemsArgs, 'beneficiaryAccountId'>>;
  allPastItems?: Resolver<Maybe<ResolversTypes['PastItemConnection']>, ParentType, ContextType, Partial<QueryAllPastItemsArgs>>;
  allPastLaterItems?: Resolver<Maybe<ResolversTypes['PastItemConnection']>, ParentType, ContextType, Partial<QueryAllPastLaterItemsArgs>>;
  allPastPendingItems?: Resolver<Maybe<Array<ResolversTypes['PastItem']>>, ParentType, ContextType, Partial<QueryAllPastPendingItemsArgs>>;
  allPastScheduledItems?: Resolver<Maybe<Array<ResolversTypes['PastScheduledItem']>>, ParentType, ContextType, Partial<QueryAllPastScheduledItemsArgs>>;
  allPastScheduledItemsV2?: Resolver<Maybe<Array<ResolversTypes['PastScheduledItemV2']>>, ParentType, ContextType, Partial<QueryAllPastScheduledItemsV2Args>>;
  allPastSpendItems?: Resolver<Maybe<ResolversTypes['PastItemConnection']>, ParentType, ContextType, Partial<QueryAllPastSpendItemsArgs>>;
  allReturnedCheckDeposits?: Resolver<Maybe<Array<ResolversTypes['ReturnedCheckDeposit']>>, ParentType, ContextType>;
  allSuitabilityQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SuitabilityQuestion']>>>, ParentType, ContextType>;
  allSupportArticles?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportArticle']>>>, ParentType, ContextType, Partial<QueryAllSupportArticlesArgs>>;
  allSupportCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportCategory']>>>, ParentType, ContextType>;
  allSupportSections?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportSection']>>>, ParentType, ContextType, Partial<QueryAllSupportSectionsArgs>>;
  allSupportTicketForms?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportTicketForm']>>>, ParentType, ContextType>;
  allTransferableFrom?: Resolver<Maybe<Array<ResolversTypes['TransferableFrom']>>, ParentType, ContextType>;
  allTransferableTo?: Resolver<Maybe<Array<ResolversTypes['TransferableTo']>>, ParentType, ContextType, RequireFields<QueryAllTransferableToArgs, 'input'>>;
  allTrustedContactsByUserId?: Resolver<Array<Maybe<ResolversTypes['TrustedContact']>>, ParentType, ContextType>;
  authAlerts?: Resolver<Maybe<Array<ResolversTypes['AuthAlert']>>, ParentType, ContextType>;
  authProfile?: Resolver<Maybe<ResolversTypes['AuthProfile']>, ParentType, ContextType>;
  authenticateForFeeNegotiationStatusByLinkedAccountId?: Resolver<Maybe<ResolversTypes['AuthenticateForFeeNegotiationStatus']>, ParentType, ContextType, RequireFields<QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs, 'linkedAccountId'>>;
  backendJobBatchAutomatedOrders?: Resolver<Maybe<Array<ResolversTypes['BackendJobBatch']>>, ParentType, ContextType, RequireFields<QueryBackendJobBatchAutomatedOrdersArgs, 'filter'>>;
  backendJobBatchMoneyMovement?: Resolver<Maybe<Array<ResolversTypes['BackendJobBatch']>>, ParentType, ContextType, RequireFields<QueryBackendJobBatchMoneyMovementArgs, 'filter'>>;
  backendJobBatchOrders?: Resolver<Maybe<Array<ResolversTypes['BackendJobBatch']>>, ParentType, ContextType, RequireFields<QueryBackendJobBatchOrdersArgs, 'filter'>>;
  backendJobBatchProfitStars?: Resolver<Maybe<Array<ResolversTypes['BackendJobBatch']>>, ParentType, ContextType, RequireFields<QueryBackendJobBatchProfitStarsArgs, 'filter'>>;
  backendJobBatchSummary?: Resolver<Maybe<ResolversTypes['BackendJobBatchSummary']>, ParentType, ContextType, RequireFields<QueryBackendJobBatchSummaryArgs, 'filter'>>;
  bankAccountClosureReasons?: Resolver<Array<ResolversTypes['BankAccountClosureReason']>, ParentType, ContextType>;
  bankAccountDisclosures?: Resolver<Maybe<Array<Maybe<ResolversTypes['BankAccountDisclosure']>>>, ParentType, ContextType, RequireFields<QueryBankAccountDisclosuresArgs, 'input'>>;
  bankAccountState?: Resolver<Maybe<ResolversTypes['BankAccountStateResult']>, ParentType, ContextType, Partial<QueryBankAccountStateArgs>>;
  bankCardOrder?: Resolver<Maybe<ResolversTypes['BankCardOrder']>, ParentType, ContextType>;
  bankCardPanDisplay?: Resolver<ResolversTypes['BankCardPanDisplayResult'], ParentType, ContextType>;
  bankCardProvisioningDetails?: Resolver<ResolversTypes['BankCardProvisioningDetailsResult'], ParentType, ContextType, RequireFields<QueryBankCardProvisioningDetailsArgs, 'input'>>;
  bankCardReissue?: Resolver<Maybe<ResolversTypes['BankCardReissue']>, ParentType, ContextType>;
  bankFeeNegotiationsByUserId?: Resolver<ResolversTypes['FeeNegotiationSummary'], ParentType, ContextType>;
  bankFeeSummaryByUserId?: Resolver<Maybe<ResolversTypes['BankFeeSummary']>, ParentType, ContextType>;
  bankFeesByUserId?: Resolver<Maybe<Array<ResolversTypes['BankFee']>>, ParentType, ContextType, RequireFields<QueryBankFeesByUserIdArgs, 'filter' | 'first' | 'offset' | 'statusFilter'>>;
  bankInterestRates?: Resolver<ResolversTypes['BankInterestRatesResult'], ParentType, ContextType, Partial<QueryBankInterestRatesArgs>>;
  bankMetadata?: Resolver<Maybe<ResolversTypes['BankMetadata']>, ParentType, ContextType>;
  bankTransaction?: Resolver<Maybe<ResolversTypes['BankTransaction']>, ParentType, ContextType, RequireFields<QueryBankTransactionArgs, 'id'>>;
  bankingEmploymentStatuses?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  bankingFeatureEligibility?: Resolver<Maybe<ResolversTypes['BankingFeatureEligibility']>, ParentType, ContextType, RequireFields<QueryBankingFeatureEligibilityArgs, 'feature'>>;
  bankingKycDetails?: Resolver<Maybe<ResolversTypes['BankingKyc']>, ParentType, ContextType>;
  banners?: Resolver<Maybe<Array<Maybe<ResolversTypes['BannersResponse']>>>, ParentType, ContextType>;
  beneficiaries?: Resolver<Maybe<Array<ResolversTypes['Beneficiary']>>, ParentType, ContextType>;
  beneficiary?: Resolver<Maybe<ResolversTypes['Beneficiary']>, ParentType, ContextType, RequireFields<QueryBeneficiaryArgs, 'id'>>;
  beneficiaryAlerts?: Resolver<Maybe<Array<ResolversTypes['Alert']>>, ParentType, ContextType>;
  benefitPartnerByUserId?: Resolver<ResolversTypes['BenefitPartnerResponse'], ParentType, ContextType, RequireFields<QueryBenefitPartnerByUserIdArgs, 'input'>>;
  billingCycle?: Resolver<Maybe<ResolversTypes['BillingCycle']>, ParentType, ContextType, Partial<QueryBillingCycleArgs>>;
  billingCycles?: Resolver<Maybe<Array<ResolversTypes['BillingCycle']>>, ParentType, ContextType, Partial<QueryBillingCyclesArgs>>;
  billingProfile?: Resolver<Maybe<ResolversTypes['BillingProfile']>, ParentType, ContextType>;
  calculateMoneySplits?: Resolver<Maybe<ResolversTypes['MoneyRulesSuggestionResult']>, ParentType, ContextType, RequireFields<QueryCalculateMoneySplitsArgs, 'moneySource'>>;
  campaignHistory?: Resolver<Maybe<ResolversTypes['CampaignHistoryConnection']>, ParentType, ContextType, RequireFields<QueryCampaignHistoryArgs, 'filter' | 'page'>>;
  challenges?: Resolver<Maybe<Array<ResolversTypes['AuthChallenge']>>, ParentType, ContextType, Partial<QueryChallengesArgs>>;
  chatHistoryMessagesBySessionId?: Resolver<ResolversTypes['AllChatHistoryMessages'], ParentType, ContextType, RequireFields<QueryChatHistoryMessagesBySessionIdArgs, 'pagination' | 'sessionId'>>;
  closureReasonsByInvestmentAccountType?: Resolver<Array<ResolversTypes['InvestmentAccountClosureReason']>, ParentType, ContextType, Partial<QueryClosureReasonsByInvestmentAccountTypeArgs>>;
  cohortEligibility?: Resolver<Array<ResolversTypes['CohortEligibility']>, ParentType, ContextType, RequireFields<QueryCohortEligibilityArgs, 'scopes'>>;
  cohortEligibility_v2?: Resolver<Maybe<Array<ResolversTypes['CohortEligibility_v2']>>, ParentType, ContextType, Partial<QueryCohortEligibility_V2Args>>;
  combinedPerformanceByUserId?: Resolver<ResolversTypes['CombinedPerformance'], ParentType, ContextType, Partial<QueryCombinedPerformanceByUserIdArgs>>;
  completedQuizByQuizId?: Resolver<Maybe<ResolversTypes['CompletedQuiz']>, ParentType, ContextType, RequireFields<QueryCompletedQuizByQuizIdArgs, 'quizId'>>;
  connectionsByUserId?: Resolver<ResolversTypes['ConnectionSummary'], ParentType, ContextType>;
  contactFormAlert?: Resolver<Maybe<ResolversTypes['ContactFormAlert']>, ParentType, ContextType>;
  course?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QueryCourseArgs, 'id'>>;
  course_v2?: Resolver<Maybe<ResolversTypes['LearnCourse']>, ParentType, ContextType, RequireFields<QueryCourse_V2Args, 'id'>>;
  coursesByTierId?: Resolver<Maybe<Array<ResolversTypes['CoursePreview']>>, ParentType, ContextType, RequireFields<QueryCoursesByTierIdArgs, 'tierId'>>;
  coursesByTopicId?: Resolver<Maybe<Array<ResolversTypes['CoursePreview']>>, ParentType, ContextType, RequireFields<QueryCoursesByTopicIdArgs, 'topicId'>>;
  coursesByTopicId_v2?: Resolver<Maybe<Array<ResolversTypes['LearnCoursePreview']>>, ParentType, ContextType, RequireFields<QueryCoursesByTopicId_V2Args, 'topicId'>>;
  coursesPersonalizedByUserId?: Resolver<Maybe<Array<ResolversTypes['CoursePreview']>>, ParentType, ContextType>;
  cryptoEtf?: Resolver<Maybe<ResolversTypes['ETF']>, ParentType, ContextType>;
  customerAccountClosureRequest?: Resolver<Maybe<ResolversTypes['CustomerAccountClosure']>, ParentType, ContextType>;
  customerEarnOnboardingProgram?: Resolver<Maybe<ResolversTypes['CustomerEarnOnboardingProgram']>, ParentType, ContextType, Partial<QueryCustomerEarnOnboardingProgramArgs>>;
  customerMoneyRules?: Resolver<Maybe<ResolversTypes['CustomerMoneyRulesResult']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  devicesByUserId?: Resolver<Maybe<Array<ResolversTypes['Device']>>, ParentType, ContextType, RequireFields<QueryDevicesByUserIdArgs, 'onlyActive'>>;
  directDepositInfo?: Resolver<ResolversTypes['DirectDepositInfoPayload'], ParentType, ContextType>;
  directDepositState?: Resolver<ResolversTypes['DirectDepositStatePayload'], ParentType, ContextType>;
  diversificationInfoByInvestmentAccountId?: Resolver<Maybe<ResolversTypes['DiversificationInfo']>, ParentType, ContextType, RequireFields<QueryDiversificationInfoByInvestmentAccountIdArgs, 'input'>>;
  documentRequest?: Resolver<Maybe<ResolversTypes['DocumentRequest']>, ParentType, ContextType, RequireFields<QueryDocumentRequestArgs, 'input'>>;
  documentRequests?: Resolver<Maybe<ResolversTypes['DocumentRequestsConnection']>, ParentType, ContextType, RequireFields<QueryDocumentRequestsArgs, 'input'>>;
  earlyAccountClosureReasons?: Resolver<Array<ResolversTypes['InvestmentAccountClosureReason']>, ParentType, ContextType>;
  earlyAccountStateRegulation?: Resolver<ResolversTypes['EarlyAccountStateRegulationResult'], ParentType, ContextType, Partial<QueryEarlyAccountStateRegulationArgs>>;
  earlyAccountTransferInfo?: Resolver<Maybe<ResolversTypes['EarlyAccountTransferInfo']>, ParentType, ContextType, RequireFields<QueryEarlyAccountTransferInfoArgs, 'investmentAccountId'>>;
  earnCTADataByUserId?: Resolver<Maybe<Array<ResolversTypes['EarnCTARecord']>>, ParentType, ContextType>;
  earnOfferByCampaignOfferId?: Resolver<Maybe<ResolversTypes['EarnOffer']>, ParentType, ContextType, RequireFields<QueryEarnOfferByCampaignOfferIdArgs, 'campaignOfferId' | 'origin' | 'sessionId'>>;
  earnRewardsByInvestmentIds?: Resolver<Maybe<Array<ResolversTypes['EarnReward']>>, ParentType, ContextType, RequireFields<QueryEarnRewardsByInvestmentIdsArgs, 'investmentIds'>>;
  eligibility?: Resolver<Maybe<ResolversTypes['Eligibility']>, ParentType, ContextType, RequireFields<QueryEligibilityArgs, 'eligibilityScope'>>;
  emailAddressValidation?: Resolver<ResolversTypes['EmailAddressValidation'], ParentType, ContextType, RequireFields<QueryEmailAddressValidationArgs, 'email'>>;
  estimatedCheckPaymentDates?: Resolver<Maybe<ResolversTypes['EstimatedCheckPaymentDates']>, ParentType, ContextType>;
  estimatedMatchRemoval?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType, RequireFields<QueryEstimatedMatchRemovalArgs, 'investmentAccountId' | 'withdrawalAmount'>>;
  estimatedTransferDates?: Resolver<Maybe<ResolversTypes['EstimatedTransferDatesPayload']>, ParentType, ContextType, RequireFields<QueryEstimatedTransferDatesArgs, 'input'>>;
  etf?: Resolver<Maybe<ResolversTypes['ETF']>, ParentType, ContextType, RequireFields<QueryEtfArgs, 'symbol'>>;
  evaluateCheckDeposit?: Resolver<Maybe<ResolversTypes['EvaluateCheckDepositPayload']>, ParentType, ContextType, RequireFields<QueryEvaluateCheckDepositArgs, 'input'>>;
  extoleCampaignHistory?: Resolver<Maybe<ResolversTypes['ExtoleCampaignHistoryConnection']>, ParentType, ContextType, RequireFields<QueryExtoleCampaignHistoryArgs, 'page'>>;
  extoleReferralHistory?: Resolver<Maybe<ResolversTypes['ExtoleReferralHistory']>, ParentType, ContextType>;
  favoriteEarnOffers?: Resolver<ResolversTypes['FavoritePartnerOfferGroup'], ParentType, ContextType>;
  featuredLearnContentPersonalizedByUserId?: Resolver<Maybe<Array<ResolversTypes['FeaturedLearnContentPreview']>>, ParentType, ContextType>;
  featuredMilestones?: Resolver<ResolversTypes['FeaturedMilestones'], ParentType, ContextType>;
  featuredMilestones_v2?: Resolver<Maybe<ResolversTypes['FeaturedMilestonesV2']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Fee']>, ParentType, ContextType, RequireFields<QueryFeeArgs, 'id'>>;
  fees?: Resolver<Maybe<Array<ResolversTypes['Fee']>>, ParentType, ContextType, Partial<QueryFeesArgs>>;
  financialAdvisorQuestions?: Resolver<ResolversTypes['FinancialAdvisorQuestionsResponse'], ParentType, ContextType>;
  financialGoalsRecommendation?: Resolver<ResolversTypes['FinancialGoalsResult'], ParentType, ContextType, RequireFields<QueryFinancialGoalsRecommendationArgs, 'input'>>;
  financialInstitution?: Resolver<Maybe<ResolversTypes['FinancialInstitution']>, ParentType, ContextType, RequireFields<QueryFinancialInstitutionArgs, 'externalId' | 'linkable'>>;
  financialInstitutions?: Resolver<ResolversTypes['FinancialInstitutionTypePagination'], ParentType, ContextType, RequireFields<QueryFinancialInstitutionsArgs, 'includeBlacklisted' | 'includeDirectBank' | 'pageInput' | 'supportsAuth' | 'supportsFunding'>>;
  finishSetup?: Resolver<Maybe<ResolversTypes['FinishSetup']>, ParentType, ContextType, RequireFields<QueryFinishSetupArgs, 'accountId' | 'feedContext'>>;
  footerContent?: Resolver<Maybe<ResolversTypes['FooterContent']>, ParentType, ContextType>;
  foundMoneyRewards?: Resolver<Maybe<Array<Maybe<ResolversTypes['FoundMoneyReward']>>>, ParentType, ContextType>;
  foundMoneyRewardsV2?: Resolver<Maybe<Array<ResolversTypes['EarnReward']>>, ParentType, ContextType>;
  foundMoneySummary?: Resolver<Maybe<ResolversTypes['FoundMoneySummary']>, ParentType, ContextType>;
  friend?: Resolver<Maybe<ResolversTypes['Friend']>, ParentType, ContextType, Partial<QueryFriendArgs>>;
  friendV2?: Resolver<Maybe<ResolversTypes['FriendV2Output']>, ParentType, ContextType>;
  fundSpendInActivation?: Resolver<Maybe<ResolversTypes['FundSpendInActivationPayload']>, ParentType, ContextType>;
  fundingSourceAccounts?: Resolver<Maybe<Array<ResolversTypes['FundingSourceAccount']>>, ParentType, ContextType>;
  fundingSourceInfo?: Resolver<Maybe<ResolversTypes['FundingSourceInfo']>, ParentType, ContextType>;
  generateUpdatedPdf?: Resolver<Maybe<ResolversTypes['GenerateUpdatedPdfPayload']>, ParentType, ContextType, RequireFields<QueryGenerateUpdatedPdfArgs, 'input'>>;
  getBillingHistory?: Resolver<Maybe<Array<ResolversTypes['BillingInvoice']>>, ParentType, ContextType, Partial<QueryGetBillingHistoryArgs>>;
  getPartnerDetails?: Resolver<ResolversTypes['PartnerDetailsResponse'], ParentType, ContextType, RequireFields<QueryGetPartnerDetailsArgs, 'input'>>;
  getPartnerDocumentByUserId?: Resolver<ResolversTypes['PartnerDocumentUrlResponse'], ParentType, ContextType, RequireFields<QueryGetPartnerDocumentByUserIdArgs, 'input'>>;
  getPartnerUrl?: Resolver<ResolversTypes['PartnerUrlResponse'], ParentType, ContextType, RequireFields<QueryGetPartnerUrlArgs, 'input'>>;
  getUsersBankFromAccountType?: Resolver<Maybe<ResolversTypes['GetUsersBankFromAccountTypePayload']>, ParentType, ContextType, RequireFields<QueryGetUsersBankFromAccountTypeArgs, 'type'>>;
  getVendorInvoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<QueryGetVendorInvoiceArgs, 'invoiceId'>>;
  helpFormContent?: Resolver<Maybe<ResolversTypes['HelpFormContent']>, ParentType, ContextType, RequireFields<QueryHelpFormContentArgs, 'form'>>;
  helpcenterBanner?: Resolver<Maybe<ResolversTypes['helpcenterBannerResponse']>, ParentType, ContextType>;
  instantSearchSupportArticles?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchSupportArticleResult']>>>, ParentType, ContextType, RequireFields<QueryInstantSearchSupportArticlesArgs, 'isPrivate' | 'query'>>;
  intent?: Resolver<Maybe<ResolversTypes['Intent']>, ParentType, ContextType, RequireFields<QueryIntentArgs, 'nonce'>>;
  intents?: Resolver<Array<ResolversTypes['Intent']>, ParentType, ContextType, RequireFields<QueryIntentsArgs, 'filter'>>;
  investment?: Resolver<Maybe<ResolversTypes['Investment']>, ParentType, ContextType, RequireFields<QueryInvestmentArgs, 'id'>>;
  investmentAccount?: Resolver<Maybe<ResolversTypes['InvestmentAccount']>, ParentType, ContextType, RequireFields<QueryInvestmentAccountArgs, 'id'>>;
  investmentAccountByBeneficiaryId?: Resolver<Maybe<ResolversTypes['InvestmentAccount']>, ParentType, ContextType, RequireFields<QueryInvestmentAccountByBeneficiaryIdArgs, 'beneficiaryId'>>;
  investmentAccountRecap?: Resolver<Maybe<ResolversTypes['InvestmentAccountRecap']>, ParentType, ContextType, RequireFields<QueryInvestmentAccountRecapArgs, 'id'>>;
  investmentAccountRecapByPublicToken?: Resolver<Maybe<ResolversTypes['InvestmentAccountRecap']>, ParentType, ContextType, RequireFields<QueryInvestmentAccountRecapByPublicTokenArgs, 'publicToken'>>;
  investmentAccountsByUserId?: Resolver<Array<ResolversTypes['InvestmentAccount']>, ParentType, ContextType, Partial<QueryInvestmentAccountsByUserIdArgs>>;
  investmentsByInvestmentAccountId?: Resolver<Maybe<ResolversTypes['InvestmentPagination']>, ParentType, ContextType, RequireFields<QueryInvestmentsByInvestmentAccountIdArgs, 'investmentAccountId' | 'pageInput'>>;
  invitationForUser?: Resolver<Maybe<ResolversTypes['Referral']>, ParentType, ContextType>;
  jobAlerts?: Resolver<Maybe<Array<ResolversTypes['JobAlert']>>, ParentType, ContextType>;
  jobEducationContent?: Resolver<Maybe<ResolversTypes['jobs_Education']>, ParentType, ContextType>;
  jobSearch?: Resolver<Maybe<Array<ResolversTypes['jobs_Offer']>>, ParentType, ContextType, RequireFields<QueryJobSearchArgs, 'searchCriteria'>>;
  jobSearchPage?: Resolver<Maybe<ResolversTypes['JobSearchPage']>, ParentType, ContextType>;
  jobSearchV2?: Resolver<Maybe<ResolversTypes['jobs_OfferConnection']>, ParentType, ContextType, RequireFields<QueryJobSearchV2Args, 'pagination' | 'searchCriteria'>>;
  laterAccounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['LaterAccount']>>>, ParentType, ContextType>;
  laterBeneficiaries?: Resolver<Maybe<Array<Maybe<ResolversTypes['LaterIndividualBeneficiary']>>>, ParentType, ContextType, RequireFields<QueryLaterBeneficiariesArgs, 'investmentAccountId'>>;
  laterContributionAbility?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContributionAbility']>>>, ParentType, ContextType, Partial<QueryLaterContributionAbilityArgs>>;
  laterContributionHistory?: Resolver<Maybe<Array<ResolversTypes['ContributionHistoryItem']>>, ParentType, ContextType, RequireFields<QueryLaterContributionHistoryArgs, 'investmentAccountId'>>;
  laterHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['LaterHistoryItem']>>>, ParentType, ContextType, RequireFields<QueryLaterHistoryArgs, 'accountId'>>;
  laterUserContributionAbility?: Resolver<Maybe<ResolversTypes['LaterContributionAbilityResult']>, ParentType, ContextType>;
  learnArticle?: Resolver<Maybe<ResolversTypes['LearnArticle']>, ParentType, ContextType, RequireFields<QueryLearnArticleArgs, 'id'>>;
  learnContentBySearchTerm?: Resolver<Maybe<ResolversTypes['ContentPreviewConnection']>, ParentType, ContextType, RequireFields<QueryLearnContentBySearchTermArgs, 'pagination' | 'term'>>;
  learnContentByTierId?: Resolver<Maybe<ResolversTypes['ContentPreviewConnection']>, ParentType, ContextType, RequireFields<QueryLearnContentByTierIdArgs, 'filter' | 'pagination'>>;
  learnContentByTopicId?: Resolver<Maybe<ResolversTypes['ContentPreviewConnection']>, ParentType, ContextType, RequireFields<QueryLearnContentByTopicIdArgs, 'filter' | 'pagination'>>;
  learnContentCategories?: Resolver<Maybe<Array<ResolversTypes['LearnContentCategory']>>, ParentType, ContextType>;
  learnContentPreviewsByContentIds?: Resolver<Maybe<Array<ResolversTypes['LearnContentPreview']>>, ParentType, ContextType, RequireFields<QueryLearnContentPreviewsByContentIdsArgs, 'contentIds'>>;
  learnContentRecommendationsBySearchTerm?: Resolver<Maybe<Array<ResolversTypes['LearnContentPreview']>>, ParentType, ContextType, RequireFields<QueryLearnContentRecommendationsBySearchTermArgs, 'term'>>;
  learnContentSearchHistoryByUserId?: Resolver<Maybe<ResolversTypes['SearchHistory']>, ParentType, ContextType>;
  learnMedia?: Resolver<Maybe<ResolversTypes['LearnMedia']>, ParentType, ContextType, RequireFields<QueryLearnMediaArgs, 'id'>>;
  learnNextStepActionsByCourseId?: Resolver<Maybe<Array<ResolversTypes['LearnNextStepAction']>>, ParentType, ContextType, RequireFields<QueryLearnNextStepActionsByCourseIdArgs, 'courseId'>>;
  learnNextStepActionsByMediaId?: Resolver<Maybe<Array<ResolversTypes['LearnNextStepAction']>>, ParentType, ContextType, RequireFields<QueryLearnNextStepActionsByMediaIdArgs, 'mediaId'>>;
  learnQuestionInsightsByQuizId?: Resolver<Maybe<Array<ResolversTypes['LearnQuestionInsight']>>, ParentType, ContextType, RequireFields<QueryLearnQuestionInsightsByQuizIdArgs, 'quizId'>>;
  learnWidgetContent?: Resolver<Maybe<Array<ResolversTypes['LearnContentPreview']>>, ParentType, ContextType, RequireFields<QueryLearnWidgetContentArgs, 'context'>>;
  linkedAccount?: Resolver<Maybe<ResolversTypes['LinkedAccount']>, ParentType, ContextType, RequireFields<QueryLinkedAccountArgs, 'linkedAccountId'>>;
  linkedAccountAlerts?: Resolver<Maybe<Array<ResolversTypes['LinkedAccountAlertsResponse']>>, ParentType, ContextType>;
  linkedAccountWebhooks?: Resolver<ResolversTypes['Webhooks'], ParentType, ContextType>;
  linkedAccounts?: Resolver<Array<ResolversTypes['LinkedAccount']>, ParentType, ContextType, RequireFields<QueryLinkedAccountsArgs, 'externalSources'>>;
  linkedSubaccount?: Resolver<Maybe<ResolversTypes['LinkedSubaccount']>, ParentType, ContextType, RequireFields<QueryLinkedSubaccountArgs, 'linkedSubaccountId'>>;
  linkedSubaccounts?: Resolver<Array<ResolversTypes['LinkedSubaccount']>, ParentType, ContextType, Partial<QueryLinkedSubaccountsArgs>>;
  liquidation?: Resolver<Maybe<ResolversTypes['Liquidation']>, ParentType, ContextType, RequireFields<QueryLiquidationArgs, 'id'>>;
  liquidations?: Resolver<Maybe<Array<ResolversTypes['Liquidation']>>, ParentType, ContextType, Partial<QueryLiquidationsArgs>>;
  listActiveWaivers?: Resolver<Array<ResolversTypes['WaiverCoupon']>, ParentType, ContextType>;
  listBenefitsByUserId?: Resolver<Maybe<Array<ResolversTypes['BenefitTileGroup']>>, ParentType, ContextType, RequireFields<QueryListBenefitsByUserIdArgs, 'group' | 'product'>>;
  listUserWaiverCoupons?: Resolver<Maybe<Array<ResolversTypes['RedeemedWaiverCoupon']>>, ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['Market']>, ParentType, ContextType>;
  matchProgram?: Resolver<Maybe<ResolversTypes['MatchProgram']>, ParentType, ContextType, RequireFields<QueryMatchProgramArgs, 'id'>>;
  message?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<QueryMessageArgs, 'id'>>;
  messageByExternalId?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<QueryMessageByExternalIdArgs, 'externalId'>>;
  messages?: Resolver<Maybe<ResolversTypes['MessageConnection']>, ParentType, ContextType, Partial<QueryMessagesArgs>>;
  milestone?: Resolver<Maybe<ResolversTypes['Milestone']>, ParentType, ContextType, RequireFields<QueryMilestoneArgs, 'id'>>;
  milestoneAccountLevelDefinitions?: Resolver<Maybe<Array<ResolversTypes['MilestoneAccountLevelDefinition']>>, ParentType, ContextType>;
  milestoneAchievementActionRule?: Resolver<Maybe<ResolversTypes['MilestoneAchievementActionRule']>, ParentType, ContextType, RequireFields<QueryMilestoneAchievementActionRuleArgs, 'milestoneID'>>;
  milestoneAchievementActionRules?: Resolver<Array<ResolversTypes['MilestoneAchievementActionRule']>, ParentType, ContextType>;
  milestoneAchievementActionTypes?: Resolver<Array<ResolversTypes['MilestoneAchievementActionType']>, ParentType, ContextType>;
  milestoneChallenge?: Resolver<Maybe<ResolversTypes['MilestoneChallenge']>, ParentType, ContextType, RequireFields<QueryMilestoneChallengeArgs, 'id'>>;
  milestoneChallengePointsRuleByMilestoneIdByChallengeId?: Resolver<Maybe<ResolversTypes['MilestoneChallengePointsRule']>, ParentType, ContextType, RequireFields<QueryMilestoneChallengePointsRuleByMilestoneIdByChallengeIdArgs, 'challengeID' | 'milestoneID'>>;
  milestoneChallengePointsRulesByMilestoneId?: Resolver<Maybe<Array<ResolversTypes['MilestoneChallengePointsRule']>>, ParentType, ContextType, RequireFields<QueryMilestoneChallengePointsRulesByMilestoneIdArgs, 'milestoneID'>>;
  milestoneDefinition?: Resolver<Maybe<ResolversTypes['MilestoneDefinition']>, ParentType, ContextType, RequireFields<QueryMilestoneDefinitionArgs, 'id'>>;
  milestoneDefinitions?: Resolver<Maybe<Array<ResolversTypes['MilestoneDefinition']>>, ParentType, ContextType>;
  milestoneEligibilityByScopes?: Resolver<Maybe<Array<ResolversTypes['MilestoneEligibility']>>, ParentType, ContextType, RequireFields<QueryMilestoneEligibilityByScopesArgs, 'scopes'>>;
  milestoneGroupAchievementActionRule?: Resolver<Maybe<ResolversTypes['MilestoneGroupAchievementActionRule']>, ParentType, ContextType, RequireFields<QueryMilestoneGroupAchievementActionRuleArgs, 'milestoneGroupID'>>;
  milestoneGroupAchievementActionRules?: Resolver<Maybe<Array<ResolversTypes['MilestoneGroupAchievementActionRule']>>, ParentType, ContextType>;
  milestoneGroupDefinition?: Resolver<Maybe<ResolversTypes['MilestoneGroupDefinition']>, ParentType, ContextType, RequireFields<QueryMilestoneGroupDefinitionArgs, 'groupID'>>;
  milestoneGroupDefinitions?: Resolver<Maybe<Array<ResolversTypes['MilestoneGroupDefinition']>>, ParentType, ContextType>;
  milestoneHub?: Resolver<Maybe<ResolversTypes['MilestoneHub']>, ParentType, ContextType>;
  milestoneHubDefinition?: Resolver<Maybe<ResolversTypes['MilestoneHubDefinition']>, ParentType, ContextType, RequireFields<QueryMilestoneHubDefinitionArgs, 'id'>>;
  milestoneHubDefinitions?: Resolver<Array<ResolversTypes['MilestoneHubDefinition']>, ParentType, ContextType>;
  milestoneHubEligible?: Resolver<Maybe<ResolversTypes['Eligibility']>, ParentType, ContextType, RequireFields<QueryMilestoneHubEligibleArgs, 'registrationCompletedAt'>>;
  milestoneRules?: Resolver<Maybe<Array<ResolversTypes['MilestoneRule']>>, ParentType, ContextType>;
  milestonesByTheme?: Resolver<Maybe<ResolversTypes['MilestoneThemeGroup']>, ParentType, ContextType, RequireFields<QueryMilestonesByThemeArgs, 'theme'>>;
  moneyAssignment?: Resolver<Maybe<ResolversTypes['MoneyManagerMoneyAssignment']>, ParentType, ContextType, RequireFields<QueryMoneyAssignmentArgs, 'id'>>;
  moneyManagerAllocationOptions?: Resolver<Array<ResolversTypes['MoneyManagerAllocationOption']>, ParentType, ContextType, RequireFields<QueryMoneyManagerAllocationOptionsArgs, 'input'>>;
  moneyManagerAllocationsByTransferIds?: Resolver<Maybe<Array<ResolversTypes['MoneyManagerAllocation']>>, ParentType, ContextType, RequireFields<QueryMoneyManagerAllocationsByTransferIdsArgs, 'transferIds'>>;
  moneyManagerAutomationTargetDefaults?: Resolver<Array<ResolversTypes['MoneyManagerAutomationTarget']>, ParentType, ContextType>;
  moneyManagerAutomationTargets?: Resolver<Array<ResolversTypes['MoneyManagerAutomationTarget']>, ParentType, ContextType>;
  moneyManagerCascadeObjectives?: Resolver<Array<ResolversTypes['MoneyManagerCascadeObjective']>, ParentType, ContextType>;
  moneyManagerCategories?: Resolver<Maybe<ResolversTypes['MoneyManagerCategoriesResult']>, ParentType, ContextType, Partial<QueryMoneyManagerCategoriesArgs>>;
  moneyManagerDepositHistory?: Resolver<ResolversTypes['MoneyAssignmentConnection'], ParentType, ContextType, Partial<QueryMoneyManagerDepositHistoryArgs>>;
  moneyManagerEligibility?: Resolver<ResolversTypes['MoneyManagerEligibilityResult'], ParentType, ContextType>;
  moneyManagerGlobalConfig?: Resolver<ResolversTypes['MoneyManagerGlobalConfig'], ParentType, ContextType>;
  moneyManagerMoneyAssignmentsByReferenceIds?: Resolver<Array<ResolversTypes['MoneyManagerMoneyAssignment']>, ParentType, ContextType, RequireFields<QueryMoneyManagerMoneyAssignmentsByReferenceIdsArgs, 'referenceIds'>>;
  moneyManagerPaychecks?: Resolver<Array<ResolversTypes['MoneyManagerPaycheck']>, ParentType, ContextType, Partial<QueryMoneyManagerPaychecksArgs>>;
  moneyManagerRebalances?: Resolver<ResolversTypes['MoneyManagerRebalancesResponse'], ParentType, ContextType>;
  moneyManagerScheduledDeposits?: Resolver<Array<ResolversTypes['MoneyManagerScheduledDeposit']>, ParentType, ContextType>;
  moneyManagerScheduledPaycheckPerEmployer?: Resolver<Array<Maybe<ResolversTypes['MoneyManagerScheduledPaycheck']>>, ParentType, ContextType>;
  moneyManagerSettings?: Resolver<ResolversTypes['MoneyManagerSettings'], ParentType, ContextType>;
  moneyManagerSummary?: Resolver<Maybe<ResolversTypes['MoneyManagerSummary']>, ParentType, ContextType>;
  moneyRulesArchetypes?: Resolver<Maybe<ResolversTypes['MoneyRulesArchetypesResult']>, ParentType, ContextType, Partial<QueryMoneyRulesArchetypesArgs>>;
  moneyRulesSettings?: Resolver<Maybe<ResolversTypes['MoneyRulesSettings']>, ParentType, ContextType>;
  nextBillingDate?: Resolver<Maybe<ResolversTypes['NextBillingDate']>, ParentType, ContextType>;
  nextTransferDate?: Resolver<Maybe<ResolversTypes['NextTransferDateResult']>, ParentType, ContextType, RequireFields<QueryNextTransferDateArgs, 'recurrenceRule'>>;
  notifications?: Resolver<Maybe<ResolversTypes['Notifications']>, ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Occupation']>>>, ParentType, ContextType>;
  offer?: Resolver<Maybe<ResolversTypes['Offer']>, ParentType, ContextType, RequireFields<QueryOfferArgs, 'id'>>;
  onboardingBenefits?: Resolver<Maybe<Array<ResolversTypes['OnboardingTileGroup']>>, ParentType, ContextType, RequireFields<QueryOnboardingBenefitsArgs, 'input'>>;
  onboardingRequirements?: Resolver<Maybe<Array<ResolversTypes['OnboardingRequirement']>>, ParentType, ContextType, RequireFields<QueryOnboardingRequirementsArgs, 'onboardingType'>>;
  onboardingTips?: Resolver<Maybe<ResolversTypes['OnboardingTips']>, ParentType, ContextType, RequireFields<QueryOnboardingTipsArgs, 'feedContext'>>;
  outsideContributionCode?: Resolver<Maybe<ResolversTypes['OutsideContributionCode']>, ParentType, ContextType, RequireFields<QueryOutsideContributionCodeArgs, 'id'>>;
  outsideContributionCodeByCode?: Resolver<Maybe<ResolversTypes['OutsideContributionCode']>, ParentType, ContextType, RequireFields<QueryOutsideContributionCodeByCodeArgs, 'code'>>;
  outsideContributionCodeByInvestmentAccountId?: Resolver<Maybe<ResolversTypes['OutsideContributionCode']>, ParentType, ContextType, RequireFields<QueryOutsideContributionCodeByInvestmentAccountIdArgs, 'investmentAccountId'>>;
  parameterizedPdf?: Resolver<Maybe<ResolversTypes['GenerateUpdatedPdfPayload']>, ParentType, ContextType, RequireFields<QueryParameterizedPdfArgs, 'input'>>;
  partnerOfferGroup?: Resolver<Maybe<ResolversTypes['PartnerOfferGroup']>, ParentType, ContextType, RequireFields<QueryPartnerOfferGroupArgs, 'id'>>;
  partnerOfferGroupCategories?: Resolver<Maybe<Array<ResolversTypes['PartnerOfferGroup']>>, ParentType, ContextType, RequireFields<QueryPartnerOfferGroupCategoriesArgs, 'ids'>>;
  partnerOfferGroupsByType?: Resolver<Maybe<Array<ResolversTypes['PartnerOfferGroup']>>, ParentType, ContextType, RequireFields<QueryPartnerOfferGroupsByTypeArgs, 'partnerOfferGroupsTypeInput'>>;
  passwordResetFormFieldsByToken?: Resolver<Maybe<ResolversTypes['PasswordResetForm']>, ParentType, ContextType, RequireFields<QueryPasswordResetFormFieldsByTokenArgs, 'resetToken'>>;
  pastCoreSummary?: Resolver<Maybe<ResolversTypes['PastCoreSummary']>, ParentType, ContextType>;
  pastEarlySummary?: Resolver<Maybe<ResolversTypes['PastEarlySummary']>, ParentType, ContextType, RequireFields<QueryPastEarlySummaryArgs, 'beneficiaryAccountId'>>;
  pastLaterSummary?: Resolver<Maybe<ResolversTypes['PastLaterSummary']>, ParentType, ContextType, Partial<QueryPastLaterSummaryArgs>>;
  pastSpendSummary?: Resolver<Maybe<ResolversTypes['PastSpendSummary']>, ParentType, ContextType>;
  pastSpendTransactionItem?: Resolver<Maybe<ResolversTypes['PastItem']>, ParentType, ContextType, RequireFields<QueryPastSpendTransactionItemArgs, 'accountType' | 'transactionId'>>;
  pastSummary?: Resolver<Maybe<ResolversTypes['PastSummary']>, ParentType, ContextType, Partial<QueryPastSummaryArgs>>;
  payoutRelationships?: Resolver<Array<Maybe<ResolversTypes['ReferralPayoutRelationship']>>, ParentType, ContextType, Partial<QueryPayoutRelationshipsArgs>>;
  pdfDownloadUrl?: Resolver<Maybe<ResolversTypes['PdfDownloadUrlPayload']>, ParentType, ContextType, RequireFields<QueryPdfDownloadUrlArgs, 'input'>>;
  pendingMoneyAssignments?: Resolver<Array<ResolversTypes['MoneyManagerMoneyAssignment']>, ParentType, ContextType>;
  performance?: Resolver<Maybe<ResolversTypes['Performance']>, ParentType, ContextType, RequireFields<QueryPerformanceArgs, 'days' | 'start'>>;
  personalizedEarnOffers?: Resolver<Maybe<Array<ResolversTypes['EarnOffer']>>, ParentType, ContextType>;
  personalizedFoundMoney?: Resolver<Maybe<Array<ResolversTypes['FoundMoneyCampaignV2']>>, ParentType, ContextType>;
  portfolios?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType, Partial<QueryPortfoliosArgs>>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<QueryProductArgs, 'id'>>;
  productByKey?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<QueryProductByKeyArgs, 'productKey'>>;
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  promoCodeApplied?: Resolver<Maybe<ResolversTypes['PromoCode']>, ParentType, ContextType>;
  promoMilestoneChallengeId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  promotedBenefitsByUserId?: Resolver<Array<ResolversTypes['PromotedBenefit']>, ParentType, ContextType, RequireFields<QueryPromotedBenefitsByUserIdArgs, 'product'>>;
  promotedCampaigns?: Resolver<Maybe<ResolversTypes['PromotedCampaigns']>, ParentType, ContextType>;
  promotedEarnOffers?: Resolver<Maybe<Array<ResolversTypes['EarnOffer']>>, ParentType, ContextType>;
  promotion?: Resolver<Maybe<ResolversTypes['Promotion']>, ParentType, ContextType, RequireFields<QueryPromotionArgs, 'id'>>;
  promotionsByUserId?: Resolver<Maybe<Array<ResolversTypes['Promotion']>>, ParentType, ContextType, RequireFields<QueryPromotionsByUserIdArgs, 'limit'>>;
  quiz?: Resolver<Maybe<ResolversTypes['Quiz']>, ParentType, ContextType, RequireFields<QueryQuizArgs, 'id'>>;
  recommendedPortfolio?: Resolver<Maybe<ResolversTypes['suitability_Portfolio']>, ParentType, ContextType>;
  recommendedSearchTerms?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryRecommendedSearchTermsArgs>>;
  recurringInvestmentSettings?: Resolver<Maybe<ResolversTypes['RecurringInvestmentSettings']>, ParentType, ContextType, Partial<QueryRecurringInvestmentSettingsArgs>>;
  recurringTransfers?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecurringTransfer']>>>, ParentType, ContextType, Partial<QueryRecurringTransfersArgs>>;
  referralCampaignRewards?: Resolver<Maybe<ResolversTypes['ReferralRewardsConnection']>, ParentType, ContextType, RequireFields<QueryReferralCampaignRewardsArgs, 'filter'>>;
  referralCampaigns?: Resolver<Maybe<ResolversTypes['ReferralCampaignConnection']>, ParentType, ContextType, RequireFields<QueryReferralCampaignsArgs, 'filter'>>;
  referralForUser?: Resolver<Maybe<ResolversTypes['Referral']>, ParentType, ContextType>;
  referralHistory?: Resolver<Maybe<ResolversTypes['ReferralHistory']>, ParentType, ContextType>;
  referralPayouts?: Resolver<Maybe<ResolversTypes['ReferralPayoutConnection']>, ParentType, ContextType, RequireFields<QueryReferralPayoutsArgs, 'filter' | 'page'>>;
  referralRelationships?: Resolver<Maybe<ResolversTypes['ReferralRelationshipConnection']>, ParentType, ContextType, RequireFields<QueryReferralRelationshipsArgs, 'filter' | 'page'>>;
  registeredAuthenticators?: Resolver<Maybe<Array<ResolversTypes['Authenticator']>>, ParentType, ContextType>;
  registration?: Resolver<ResolversTypes['Result'], ParentType, ContextType>;
  registrationFunnel?: Resolver<Maybe<ResolversTypes['RegistrationFunnel']>, ParentType, ContextType, RequireFields<QueryRegistrationFunnelArgs, 'filter'>>;
  relatedCourseByArticleId?: Resolver<Maybe<ResolversTypes['Course']>, ParentType, ContextType, RequireFields<QueryRelatedCourseByArticleIdArgs, 'articleId'>>;
  relatedCourseByArticleId_v2?: Resolver<Maybe<ResolversTypes['LearnCourse']>, ParentType, ContextType, RequireFields<QueryRelatedCourseByArticleId_V2Args, 'articleId'>>;
  relatedCoursePreviewsByCourseId?: Resolver<Maybe<Array<ResolversTypes['CoursePreview']>>, ParentType, ContextType, RequireFields<QueryRelatedCoursePreviewsByCourseIdArgs, 'courseId'>>;
  relatedCoursePreviewsByCourseId_v2?: Resolver<Maybe<Array<ResolversTypes['LearnCoursePreview']>>, ParentType, ContextType, RequireFields<QueryRelatedCoursePreviewsByCourseId_V2Args, 'courseId'>>;
  relatedLearnContentByArticleId?: Resolver<Maybe<Array<ResolversTypes['LearnContentPreview']>>, ParentType, ContextType, RequireFields<QueryRelatedLearnContentByArticleIdArgs, 'articleId'>>;
  relatedLearnContentByMediaId?: Resolver<Maybe<Array<ResolversTypes['LearnContentPreview']>>, ParentType, ContextType, RequireFields<QueryRelatedLearnContentByMediaIdArgs, 'mediaId'>>;
  relatedQuizByCourseId?: Resolver<Maybe<ResolversTypes['Quiz']>, ParentType, ContextType, RequireFields<QueryRelatedQuizByCourseIdArgs, 'courseId'>>;
  relatedQuizByCourseId_v2?: Resolver<Maybe<ResolversTypes['LearnQuiz']>, ParentType, ContextType, RequireFields<QueryRelatedQuizByCourseId_V2Args, 'courseId'>>;
  relatedQuizzesByCourseId?: Resolver<Maybe<Array<ResolversTypes['QuizPreview']>>, ParentType, ContextType, RequireFields<QueryRelatedQuizzesByCourseIdArgs, 'courseId'>>;
  relatedQuizzesByCourseId_v2?: Resolver<Maybe<Array<ResolversTypes['LearnQuizPreview']>>, ParentType, ContextType, RequireFields<QueryRelatedQuizzesByCourseId_V2Args, 'courseId'>>;
  remoteStrings?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  roundUpAccount?: Resolver<Maybe<ResolversTypes['RoundUpAccount']>, ParentType, ContextType, RequireFields<QueryRoundUpAccountArgs, 'linkedSubaccountId'>>;
  roundUpAccounts?: Resolver<Array<ResolversTypes['RoundUpAccount']>, ParentType, ContextType>;
  roundUpProfile?: Resolver<Maybe<ResolversTypes['RoundUpProfile']>, ParentType, ContextType>;
  roundUps?: Resolver<ResolversTypes['RoundUpTypePagination'], ParentType, ContextType, RequireFields<QueryRoundUpsArgs, 'pageInput' | 'state'>>;
  sampleMailInDocument?: Resolver<Maybe<ResolversTypes['SampleMailInDocument']>, ParentType, ContextType, RequireFields<QuerySampleMailInDocumentArgs, 'typeFilter'>>;
  savingsAccountEligibilityByUserId?: Resolver<Maybe<ResolversTypes['SavingsAccountEligibility']>, ParentType, ContextType, RequireFields<QuerySavingsAccountEligibilityByUserIdArgs, 'type'>>;
  searchActiveEarnOffers?: Resolver<ResolversTypes['EarnOfferQueryPage'], ParentType, ContextType, RequireFields<QuerySearchActiveEarnOffersArgs, 'searchTerm'>>;
  searchEmployers?: Resolver<Maybe<ResolversTypes['SearchEmployersPayload']>, ParentType, ContextType, RequireFields<QuerySearchEmployersArgs, 'input'>>;
  searchSecurities?: Resolver<Maybe<ResolversTypes['SearchSecuritiesResponse']>, ParentType, ContextType, RequireFields<QuerySearchSecuritiesArgs, 'input'>>;
  searchSupportArticles?: Resolver<Maybe<ResolversTypes['SearchSupportResult']>, ParentType, ContextType, RequireFields<QuerySearchSupportArticlesArgs, 'isPrivate' | 'query'>>;
  securitiesBySector?: Resolver<Maybe<ResolversTypes['SecuritiesBySectorResponse']>, ParentType, ContextType, RequireFields<QuerySecuritiesBySectorArgs, 'input'>>;
  securitiesBySymbols?: Resolver<Maybe<ResolversTypes['SecuritiesBySymbolsResponse']>, ParentType, ContextType, RequireFields<QuerySecuritiesBySymbolsArgs, 'input'>>;
  securityBySymbol?: Resolver<Maybe<ResolversTypes['Security']>, ParentType, ContextType, RequireFields<QuerySecurityBySymbolArgs, 'input'>>;
  securityPerformanceBySymbol?: Resolver<Maybe<ResolversTypes['SecurityPerformance']>, ParentType, ContextType, RequireFields<QuerySecurityPerformanceBySymbolArgs, 'input'>>;
  securityPerformancesBySymbol?: Resolver<Maybe<Array<ResolversTypes['SecurityPerformance']>>, ParentType, ContextType, RequireFields<QuerySecurityPerformancesBySymbolArgs, 'input'>>;
  settings?: Resolver<Maybe<ResolversTypes['Settings']>, ParentType, ContextType>;
  signatures?: Resolver<Array<Maybe<ResolversTypes['Signature']>>, ParentType, ContextType, Partial<QuerySignaturesArgs>>;
  smartDepositMetadata?: Resolver<Maybe<ResolversTypes['SmartDepositMetadataResult']>, ParentType, ContextType, RequireFields<QuerySmartDepositMetadataArgs, 'smartDepositMetadataInput'>>;
  sourceAccounts?: Resolver<Array<ResolversTypes['CustomerAccount']>, ParentType, ContextType, Partial<QuerySourceAccountsArgs>>;
  spendAccount?: Resolver<Maybe<ResolversTypes['SpendAccount']>, ParentType, ContextType>;
  spendAlerts?: Resolver<Maybe<Array<Maybe<ResolversTypes['SpendAlert']>>>, ParentType, ContextType>;
  spendAtms?: Resolver<Maybe<ResolversTypes['SpendAtmsResult']>, ParentType, ContextType, RequireFields<QuerySpendAtmsArgs, 'input'>>;
  splitDepositSettings?: Resolver<Maybe<ResolversTypes['SplitDepositSettings']>, ParentType, ContextType, RequireFields<QuerySplitDepositSettingsArgs, 'id'>>;
  splitDepositSettingsByUserId?: Resolver<Maybe<Array<ResolversTypes['SplitDepositSettings']>>, ParentType, ContextType, Partial<QuerySplitDepositSettingsByUserIdArgs>>;
  statements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Statement']>>>, ParentType, ContextType, RequireFields<QueryStatementsArgs, 'type'>>;
  subscriptionMigration?: Resolver<Maybe<ResolversTypes['SubscriptionMigration']>, ParentType, ContextType, RequireFields<QuerySubscriptionMigrationArgs, 'id'>>;
  subscriptionMigrationWaiver?: Resolver<Maybe<ResolversTypes['SubscriptionMigrationWaiver']>, ParentType, ContextType, RequireFields<QuerySubscriptionMigrationWaiverArgs, 'id'>>;
  subscriptionMigrationWaiversByUserId?: Resolver<Maybe<Array<ResolversTypes['SubscriptionMigrationWaiver']>>, ParentType, ContextType>;
  suggestedMoneyRules?: Resolver<Maybe<ResolversTypes['SuggestedMoneyRulesResult']>, ParentType, ContextType>;
  suitabilityResponses?: Resolver<Maybe<Array<ResolversTypes['suitability_SuitabilityResponse']>>, ParentType, ContextType>;
  suitabilityServiceEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  supportArticle?: Resolver<Maybe<ResolversTypes['SupportArticle']>, ParentType, ContextType, RequireFields<QuerySupportArticleArgs, 'id'>>;
  supportArticlesBySectionId?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportArticle']>>>, ParentType, ContextType, RequireFields<QuerySupportArticlesBySectionIdArgs, 'sectionId'>>;
  supportCategory?: Resolver<Maybe<ResolversTypes['SupportCategory']>, ParentType, ContextType, RequireFields<QuerySupportCategoryArgs, 'categoryId'>>;
  supportChatEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  supportMostCommonFaq?: Resolver<Maybe<Array<ResolversTypes['ContactFaq']>>, ParentType, ContextType>;
  supportSchedule?: Resolver<Maybe<ResolversTypes['ScheduleResult']>, ParentType, ContextType, RequireFields<QuerySupportScheduleArgs, 'input'>>;
  supportSection?: Resolver<Maybe<ResolversTypes['SupportSection']>, ParentType, ContextType, RequireFields<QuerySupportSectionArgs, 'sectionId'>>;
  supportSectionsByCategoryId?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportSection']>>>, ParentType, ContextType, RequireFields<QuerySupportSectionsByCategoryIdArgs, 'categoryId'>>;
  supportTicketForm?: Resolver<Maybe<ResolversTypes['SupportTicketForm']>, ParentType, ContextType, RequireFields<QuerySupportTicketFormArgs, 'id'>>;
  supportTicketFormField?: Resolver<Maybe<ResolversTypes['SupportTicketFormField']>, ParentType, ContextType, RequireFields<QuerySupportTicketFormFieldArgs, 'id'>>;
  supportsPlaidVerification?: Resolver<ResolversTypes['SupportsPlaidVerificationResult'], ParentType, ContextType, RequireFields<QuerySupportsPlaidVerificationArgs, 'routingNumber'>>;
  targetAccounts?: Resolver<Array<ResolversTypes['CustomerAccount']>, ParentType, ContextType, Partial<QueryTargetAccountsArgs>>;
  taxStatementsByTaxYear?: Resolver<ResolversTypes['StatementPagination'], ParentType, ContextType, RequireFields<QueryTaxStatementsByTaxYearArgs, 'pageInput' | 'taxYear'>>;
  tier?: Resolver<Maybe<ResolversTypes['Tier']>, ParentType, ContextType, RequireFields<QueryTierArgs, 'id'>>;
  tierGroup?: Resolver<Maybe<ResolversTypes['TierGroup']>, ParentType, ContextType, Partial<QueryTierGroupArgs>>;
  tierGroupForUser?: Resolver<Maybe<ResolversTypes['TierGroup']>, ParentType, ContextType>;
  tierOptionByOpenAccounts?: Resolver<Maybe<ResolversTypes['TierOption']>, ParentType, ContextType>;
  tierOptionByProductKey?: Resolver<Maybe<ResolversTypes['TierOption']>, ParentType, ContextType, RequireFields<QueryTierOptionByProductKeyArgs, 'productKey'>>;
  tierOptionByTierPriceId?: Resolver<Maybe<ResolversTypes['TierOptionByTierPriceIdResult']>, ParentType, ContextType, RequireFields<QueryTierOptionByTierPriceIdArgs, 'tierPriceId'>>;
  tierSubscription?: Resolver<Maybe<ResolversTypes['TierSubscription']>, ParentType, ContextType, RequireFields<QueryTierSubscriptionArgs, 'id'>>;
  tierSubscriptionByUserId?: Resolver<Maybe<ResolversTypes['TierSubscription']>, ParentType, ContextType>;
  tierSubscriptionForUser?: Resolver<Maybe<ResolversTypes['TierSubscriptionForUser']>, ParentType, ContextType>;
  tierSubscriptionHistoryByUserId?: Resolver<Maybe<ResolversTypes['TierSubscriptionConnection']>, ParentType, ContextType, RequireFields<QueryTierSubscriptionHistoryByUserIdArgs, 'limit' | 'reverse'>>;
  tiers?: Resolver<Maybe<Array<ResolversTypes['Tier']>>, ParentType, ContextType>;
  toggle?: Resolver<Maybe<ResolversTypes['Toggle']>, ParentType, ContextType, RequireFields<QueryToggleArgs, 'projectId' | 'toggleId'>>;
  topEmployers?: Resolver<ResolversTypes['TopEmployerPayload'], ParentType, ContextType>;
  trendingLearnContentByTierId?: Resolver<Maybe<Array<ResolversTypes['TrendingLearnContentPreview']>>, ParentType, ContextType, RequireFields<QueryTrendingLearnContentByTierIdArgs, 'tierId'>>;
  trendingLearnContentByTopicId?: Resolver<Maybe<Array<ResolversTypes['TrendingLearnContentPreview']>>, ParentType, ContextType, RequireFields<QueryTrendingLearnContentByTopicIdArgs, 'topicId'>>;
  trendingLearnContentPersonalizedByUserId?: Resolver<Maybe<Array<ResolversTypes['TrendingLearnContentPreview']>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userAlerts?: Resolver<Maybe<Array<ResolversTypes['UserAlertsResponse']>>, ParentType, ContextType>;
  userBenefitsStatus?: Resolver<ResolversTypes['BenefitsStatusResponse'], ParentType, ContextType, RequireFields<QueryUserBenefitsStatusArgs, 'benefitProductKey' | 'tierKey'>>;
  userCredentials?: Resolver<Array<Maybe<ResolversTypes['UserCredentials']>>, ParentType, ContextType, Partial<QueryUserCredentialsArgs>>;
  userMatches?: Resolver<Array<Maybe<ResolversTypes['UserMatch']>>, ParentType, ContextType>;
  userStatus?: Resolver<Maybe<ResolversTypes['UserStatus']>, ParentType, ContextType>;
  userTokensByUserId?: Resolver<Array<Maybe<ResolversTypes['UserToken']>>, ParentType, ContextType>;
  userWinbackScore?: Resolver<Maybe<ResolversTypes['userWinbackScoreRes']>, ParentType, ContextType>;
  validatePasswordResetToken?: Resolver<ResolversTypes['ValidatePasswordResetTokenResult'], ParentType, ContextType, RequireFields<QueryValidatePasswordResetTokenArgs, 'resetToken'>>;
  verificationProfile?: Resolver<Maybe<ResolversTypes['VerificationProfile']>, ParentType, ContextType>;
  verifyCheckPaymentRecipientAddress?: Resolver<Maybe<ResolversTypes['VerifyCheckPaymentRecipientAddressResult']>, ParentType, ContextType, RequireFields<QueryVerifyCheckPaymentRecipientAddressArgs, 'input'>>;
  verifyPromoCode?: Resolver<Maybe<ResolversTypes['VerifyPromoCodeResponse']>, ParentType, ContextType, RequireFields<QueryVerifyPromoCodeArgs, 'name'>>;
  withholdingDefaults?: Resolver<Maybe<ResolversTypes['WithholdingDefaults']>, ParentType, ContextType, RequireFields<QueryWithholdingDefaultsArgs, 'investmentAccountId' | 'withdrawalAmount'>>;
  withholdingEstimates?: Resolver<Maybe<ResolversTypes['WithholdingEstimates']>, ParentType, ContextType, RequireFields<QueryWithholdingEstimatesArgs, 'federalWithholdingPercentage' | 'investmentAccountId' | 'stateWithholdingPercentage' | 'withdrawalAmount'>>;
  yearLaterReport?: Resolver<ResolversTypes['YearLaterReport'], ParentType, ContextType, RequireFields<QueryYearLaterReportArgs, 'year'>>;
};

export type QuizResolvers<ContextType = any, ParentType extends ResolversParentTypes['Quiz'] = ResolversParentTypes['Quiz']> = {
  authors?: Resolver<Array<ResolversTypes['LearnAuthor']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['LearnMetadata'], ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['LearnQuestion']>, ParentType, ContextType>;
  theme?: Resolver<ResolversTypes['QuizTheme'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['LearnTier'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topics?: Resolver<Array<ResolversTypes['LearnTopic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuizLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuizLocked'] = ResolversParentTypes['QuizLocked']> = {
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<Maybe<ResolversTypes['LearnVisualAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  numQuestions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuizPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuizPreview'] = ResolversParentTypes['QuizPreview']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['LearnProgress']>, ParentType, ContextType>;
  quizTheme?: Resolver<ResolversTypes['QuizTheme'], ParentType, ContextType>;
  tierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuizPreviewLockedResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuizPreviewLocked'] = ResolversParentTypes['QuizPreviewLocked']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['LearnContentType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['LearnContentDuration'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['LearnVisualAsset'], ParentType, ContextType>;
  lockedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryTopicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productRequired?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quizTheme?: Resolver<ResolversTypes['QuizTheme'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuizThemeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuizTheme'] = ResolversParentTypes['QuizTheme']> = {
  __resolveType: TypeResolveFn<'LearnThemeLiteral', ParentType, ContextType>;
};

export type RateLimitDoesNotExistExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RateLimitDoesNotExistException'] = ResolversParentTypes['RateLimitDoesNotExistException']> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RateLimitStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['RateLimitStatus'] = ResolversParentTypes['RateLimitStatus']> = {
  challengeBlockDurationRemaining?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isBlocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  loginBlockDurationRemaining?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RawLinkSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RawLinkSession'] = ResolversParentTypes['RawLinkSession']> = {
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RdvRequiredUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['RdvRequiredUserAlert'] = ResolversParentTypes['RdvRequiredUserAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RdvVerificationRequiredResolvers<ContextType = any, ParentType extends ResolversParentTypes['RdvVerificationRequired'] = ResolversParentTypes['RdvVerificationRequired']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RdvsNotTriggeredResolvers<ContextType = any, ParentType extends ResolversParentTypes['RdvsNotTriggered'] = ResolversParentTypes['RdvsNotTriggered']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebalanceAlreadyExecutedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebalanceAlreadyExecutedError'] = ResolversParentTypes['RebalanceAlreadyExecutedError']> = {
  customerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebalanceSourceInsufficientBalanceErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebalanceSourceInsufficientBalanceError'] = ResolversParentTypes['RebalanceSourceInsufficientBalanceError']> = {
  customerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecaptchaExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecaptchaException'] = ResolversParentTypes['RecaptchaException']> = {
  errorCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecommendedInvestingStrategyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecommendedInvestingStrategy'] = ResolversParentTypes['RecommendedInvestingStrategy']> = {
  accountSubtype?: Resolver<ResolversTypes['SuitabilityAccountSubtype'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['SuitabilityAccountType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  portfolioId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordDoesNotExistErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordDoesNotExistError'] = ResolversParentTypes['RecordDoesNotExistError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordInvestmentAccountRecapViewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordInvestmentAccountRecapViewResult'] = ResolversParentTypes['RecordInvestmentAccountRecapViewResult']> = {
  __resolveType: TypeResolveFn<'InvestmentAccountRecap' | 'InvestmentAccountRecapNotFoundException', ParentType, ContextType>;
};

export type RecordReferralEventResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordReferralEventResult'] = ResolversParentTypes['RecordReferralEventResult']> = {
  __resolveType: TypeResolveFn<'QualificationSubTypeMismatchError' | 'ReferralEventV2' | 'ReferralRelationshipMissingError' | 'RelationshipAlreadyQualifiedError', ParentType, ContextType>;
};

export type RecordVendorExternalTransactionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordVendorExternalTransactionResult'] = ResolversParentTypes['RecordVendorExternalTransactionResult']> = {
  __resolveType: TypeResolveFn<'BillingVendorError' | 'Transaction', ParentType, ContextType>;
};

export type RecurrenceRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurrenceRule'] = ResolversParentTypes['RecurrenceRule']> = {
  byMonthDay?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  byWeekDay?: Resolver<Maybe<Array<ResolversTypes['DayOfWeek']>>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['RecurrenceFrequency'], ParentType, ContextType>;
  interval?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringInvestmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringInvestmentPayload'] = ResolversParentTypes['RecurringInvestmentPayload']> = {
  recurringInvestmentSettings?: Resolver<ResolversTypes['RecurringInvestmentSettings'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringInvestmentSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringInvestmentSettings'] = ResolversParentTypes['RecurringInvestmentSettings']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  day?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['InvestmentFrequency']>, ParentType, ContextType>;
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nextInvestmentAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sourceAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransfer'] = ResolversParentTypes['RecurringTransfer']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nextTransferDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  recurrenceRule?: Resolver<ResolversTypes['RecurrenceRule'], ParentType, ContextType>;
  transferEvent?: Resolver<ResolversTypes['RecurringTransferEvent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransferAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransferAccount'] = ResolversParentTypes['RecurringTransferAccount']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RecurringTransferAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransferDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransferDate'] = ResolversParentTypes['RecurringTransferDate']> = {
  nextTransferDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransferEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransferEvent'] = ResolversParentTypes['RecurringTransferEvent']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['RecurringTransferDirection'], ParentType, ContextType>;
  fundingSource?: Resolver<ResolversTypes['RecurringTransferFundingSource'], ParentType, ContextType>;
  targetAccount?: Resolver<ResolversTypes['RecurringTransferAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransferFundingSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransferFundingSource'] = ResolversParentTypes['RecurringTransferFundingSource']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RecurringTransferFundingSourceType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransferPathExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransferPathException'] = ResolversParentTypes['RecurringTransferPathException']> = {
  exception?: Resolver<ResolversTypes['RecurringTransferPathExceptionCase'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RedeemedWaiverCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['RedeemedWaiverCoupon'] = ResolversParentTypes['RedeemedWaiverCoupon']> = {
  couponId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  waiverPeriodEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  waiverType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralResolvers<ContextType = any, ParentType extends ResolversParentTypes['Referral'] = ResolversParentTypes['Referral']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referreeRewardAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  referrerRewardAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralCampaignResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralCampaign'] = ResolversParentTypes['ReferralCampaign']> = {
  advocateEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  advocateRewards?: Resolver<Maybe<Array<ResolversTypes['ReferralReward']>>, ParentType, ContextType>;
  advocateUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['ReferralEvent']>>, ParentType, ContextType>;
  friendEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  friendRewards?: Resolver<Maybe<Array<ResolversTypes['ReferralReward']>>, ParentType, ContextType>;
  friendUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralCampaignConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralCampaignConnection'] = ResolversParentTypes['ReferralCampaignConnection']> = {
  autoAddCampaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<ResolversTypes['ReferralCampaignEdge']>>, ParentType, ContextType>;
  fallbackCampaignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ReferralPaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralCampaignEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralCampaignEdge'] = ResolversParentTypes['ReferralCampaignEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ReferralCampaignV2'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralCampaignRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralCampaignReward'] = ResolversParentTypes['ReferralCampaignReward']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hurdle?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  repeated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  targets?: Resolver<Array<ResolversTypes['ReferralCampaignRewardTarget']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ReferralCampaignRewardType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralCampaignV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralCampaignV2'] = ResolversParentTypes['ReferralCampaignV2']> = {
  actionFeedDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeInHouseCampaign?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  autoAdd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  background?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  condensedTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eligibilityEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fallback?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  internalMemo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publishEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  publishStart?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  publishedStatus?: Resolver<Maybe<ResolversTypes['PublishedCampaignStatus']>, ParentType, ContextType>;
  qa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  qualificationAction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  qualificationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rewards?: Resolver<Array<ResolversTypes['ReferralCampaignReward']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CampaignStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ReferralCodeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ReferralCode'], any> {
  name: 'ReferralCode';
}

export type ReferralEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralEvent'] = ResolversParentTypes['ReferralEvent']> = {
  dateCompleted?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  referralEventId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralEventType?: Resolver<ResolversTypes['ReferralEventType'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReferralEventStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralEventV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralEventV2'] = ResolversParentTypes['ReferralEventV2']> = {
  advocateId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eventRecordedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['ReferralEventTypeV2'], ParentType, ContextType>;
  friendId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  relationshipId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralHistory'] = ResolversParentTypes['ReferralHistory']> = {
  friendHistory?: Resolver<Maybe<ResolversTypes['FriendHistoryConnection']>, ParentType, ContextType, RequireFields<ReferralHistoryFriendHistoryArgs, 'filter'>>;
  friendSummary?: Resolver<Maybe<Array<ResolversTypes['FriendSummary']>>, ParentType, ContextType>;
  numCompletedReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numPendingReferrals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalReferralRewardsEarned?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralPaginatedInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralPaginatedInfo'] = ResolversParentTypes['ReferralPaginatedInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralPayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralPayout'] = ResolversParentTypes['ReferralPayout']> = {
  advocateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  advocateOfferId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['ReferralCampaignV2']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  friendId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  friendOfferId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reward?: Resolver<Maybe<ResolversTypes['ReferralCampaignReward']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ReferralPayoutStatus']>, ParentType, ContextType>;
  statusChangeAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  statusChangeBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralPayoutConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralPayoutConnection'] = ResolversParentTypes['ReferralPayoutConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ReferralPayoutEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ReferralPaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralPayoutEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralPayoutEdge'] = ResolversParentTypes['ReferralPayoutEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ReferralPayout'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralPayoutExistsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralPayoutExistsError'] = ResolversParentTypes['ReferralPayoutExistsError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralPayoutRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralPayoutRelationship'] = ResolversParentTypes['ReferralPayoutRelationship']> = {
  advocateId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  friendId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  payoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutRelationshipId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  relationshipId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralRelationship'] = ResolversParentTypes['ReferralRelationship']> = {
  advocateId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  friendId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReferralRelationshipStatus'], ParentType, ContextType>;
  statusChangeAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRelationshipConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralRelationshipConnection'] = ResolversParentTypes['ReferralRelationshipConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ReferralRelationshipEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ReferralPaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRelationshipEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralRelationshipEdge'] = ResolversParentTypes['ReferralRelationshipEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ReferralRelationship'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRelationshipMissingErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralRelationshipMissingError'] = ResolversParentTypes['ReferralRelationshipMissingError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralReward'] = ResolversParentTypes['ReferralReward']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rewardFulfilledAtDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rewardStatus?: Resolver<Maybe<ResolversTypes['ReferralRewardStatus']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valueType?: Resolver<Maybe<ResolversTypes['ReferralValueType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRewardEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralRewardEdge'] = ResolversParentTypes['ReferralRewardEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ReferralCampaignReward'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRewardSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralRewardSummary'] = ResolversParentTypes['ReferralRewardSummary']> = {
  advocateUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReferralRewardStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralRewardsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralRewardsConnection'] = ResolversParentTypes['ReferralRewardsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ReferralRewardEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ReferralPaginatedInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefreshAuthTokenRateLimitedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshAuthTokenRateLimitedException'] = ResolversParentTypes['RefreshAuthTokenRateLimitedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefreshAuthTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshAuthTokenResult'] = ResolversParentTypes['RefreshAuthTokenResult']> = {
  __resolveType: TypeResolveFn<'AuthSession' | 'InvalidPinException' | 'RefreshAuthTokenRateLimitedException' | 'TokenExpiredException' | 'UserSuspendedException', ParentType, ContextType>;
};

export type RefreshTokenNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefreshTokenNotFoundException'] = ResolversParentTypes['RefreshTokenNotFoundException']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundBankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundBankAccount'] = ResolversParentTypes['RefundBankAccount']> = {
  accountNickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegenerateInvestmentAccountRecapPublicTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegenerateInvestmentAccountRecapPublicTokenResult'] = ResolversParentTypes['RegenerateInvestmentAccountRecapPublicTokenResult']> = {
  __resolveType: TypeResolveFn<'InvestmentAccountRecap' | 'InvestmentAccountRecapNotFoundException', ParentType, ContextType>;
};

export type RegisterAccountTypeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterAccountTypeResult'] = ResolversParentTypes['RegisterAccountTypeResult']> = {
  __resolveType: TypeResolveFn<'RegisterAccountTypeResultTemporaryImpl', ParentType, ContextType>;
};

export type RegisterAccountTypeResultTemporaryImplResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterAccountTypeResultTemporaryImpl'] = ResolversParentTypes['RegisterAccountTypeResultTemporaryImpl']> = {
  someField?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegisterCredentialsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterCredentialsResult'] = ResolversParentTypes['RegisterCredentialsResult']> = {
  __resolveType: TypeResolveFn<'AuthSession' | 'EmailTakenException' | 'InvalidPasswordException' | 'MissingRequiredAgreementsException', ParentType, ContextType>;
};

export type RegisterDeviceTokenAndPushAuthenticatorResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterDeviceTokenAndPushAuthenticatorResult'] = ResolversParentTypes['RegisterDeviceTokenAndPushAuthenticatorResult']> = {
  __resolveType: TypeResolveFn<'InvalidDeviceParametersException' | 'PushAuthenticator' | 'PushAuthenticatorAlreadyExistsException', ParentType, ContextType>;
};

export type RegisterEmailAuthenticatorResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterEmailAuthenticatorResult'] = ResolversParentTypes['RegisterEmailAuthenticatorResult']> = {
  __resolveType: TypeResolveFn<'AuthChallengeAnswerAttemptsExhaustedException' | 'AuthChallengeAnswerIncorrectException' | 'AuthChallengeExpiredException' | 'AuthenticatorTypeAlreadyRegisteredException' | 'EmailAuthenticator' | 'ExistingEmailVerifiedException', ParentType, ContextType>;
};

export type RegisterLayerLinkSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterLayerLinkSessionResult'] = ResolversParentTypes['RegisterLayerLinkSessionResult']> = {
  __resolveType: TypeResolveFn<'LayerLinkSession' | 'UnrecoverableError', ParentType, ContextType>;
};

export type RegisterLinkSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterLinkSessionResult'] = ResolversParentTypes['RegisterLinkSessionResult']> = {
  __resolveType: TypeResolveFn<'AsyncLinkSessionResult' | 'LinkedAccount', ParentType, ContextType>;
};

export type RegisterOidcCredentialsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterOidcCredentialsResult'] = ResolversParentTypes['RegisterOidcCredentialsResult']> = {
  __resolveType: TypeResolveFn<'AuthSession' | 'EmailTakenException' | 'InvalidAppleAccountException' | 'InvalidCredentialsException' | 'InvalidGoogleAccountException' | 'UserSuspendedException' | 'ValidateCredentialsSuccess', ParentType, ContextType>;
};

export type RegisterPhoneAuthenticatorResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterPhoneAuthenticatorResult'] = ResolversParentTypes['RegisterPhoneAuthenticatorResult']> = {
  __resolveType: TypeResolveFn<'AuthChallengeAnswerAttemptsExhaustedException' | 'AuthChallengeAnswerIncorrectException' | 'AuthChallengeExpiredException' | 'AuthenticatorTypeAlreadyRegisteredException' | 'InvalidPhoneNumberException' | 'PhoneAuthenticator', ParentType, ContextType>;
};

export type RegisterPhoneAuthenticatorWithoutChallengeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterPhoneAuthenticatorWithoutChallengeResult'] = ResolversParentTypes['RegisterPhoneAuthenticatorWithoutChallengeResult']> = {
  __resolveType: TypeResolveFn<'InvalidPhoneNumberException' | 'PhoneAuthenticator', ParentType, ContextType>;
};

export type RegisterProspectResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterProspectResult'] = ResolversParentTypes['RegisterProspectResult']> = {
  __resolveType: TypeResolveFn<'InvalidConversionIdentifierException' | 'InvalidSourceAttributesException' | 'RegistrationFunnel', ParentType, ContextType>;
};

export type RegistrationDrawerContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationDrawerContent'] = ResolversParentTypes['RegistrationDrawerContent']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistrationFunnelResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationFunnel'] = ResolversParentTypes['RegistrationFunnel']> = {
  flow?: Resolver<Array<ResolversTypes['RegistrationPage']>, ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['FunnelMetadata'], ParentType, ContextType>;
  sourceAttributes?: Resolver<ResolversTypes['SourceAttributes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistrationPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationPage'] = ResolversParentTypes['RegistrationPage']> = {
  actions?: Resolver<Array<ResolversTypes['RegistrationPageAction']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['RegistrationPageContent']>, ParentType, ContextType>;
  isBackEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['PageName'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistrationPageActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationPageAction'] = ResolversParentTypes['RegistrationPageAction']> = {
  nextPage?: Resolver<ResolversTypes['PageName'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ActionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistrationPageContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationPageContent'] = ResolversParentTypes['RegistrationPageContent']> = {
  __resolveType: TypeResolveFn<'RegistrationProminenceBannerContent', ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RegistrationProminenceBannerContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistrationProminenceBannerContent'] = ResolversParentTypes['RegistrationProminenceBannerContent']> = {
  campaignId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawer?: Resolver<Maybe<ResolversTypes['RegistrationDrawerContent']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReinitiateSmsChallengeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReinitiateSMSChallengeResult'] = ResolversParentTypes['ReinitiateSMSChallengeResult']> = {
  __resolveType: TypeResolveFn<'AuthChallengeExpiredException' | 'ChallengeRateExceededException' | 'EmailAuthChallenge' | 'PhoneNumberOptedOutException' | 'SMSAuthChallenge', ParentType, ContextType>;
};

export type ReissueBankCardEligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReissueBankCardEligibility'] = ResolversParentTypes['ReissueBankCardEligibility']> = {
  __resolveType: TypeResolveFn<'ReissueBankCardEligible' | 'ReissueBankCardIneligible', ParentType, ContextType>;
};

export type ReissueBankCardEligibleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReissueBankCardEligible'] = ResolversParentTypes['ReissueBankCardEligible']> = {
  originalCardCreatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReissueBankCardExistsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReissueBankCardExistsError'] = ResolversParentTypes['ReissueBankCardExistsError']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReissueBankCardIneligibleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReissueBankCardIneligible'] = ResolversParentTypes['ReissueBankCardIneligible']> = {
  issues?: Resolver<Array<Maybe<ResolversTypes['ReissueBankCardIneligibleIssue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReissueBankCardResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReissueBankCardResult'] = ResolversParentTypes['ReissueBankCardResult']> = {
  __resolveType: TypeResolveFn<'BankCardRequest' | 'ReissueBankCardExistsError', ParentType, ContextType>;
};

export type RelationshipAlreadyQualifiedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelationshipAlreadyQualifiedError'] = ResolversParentTypes['RelationshipAlreadyQualifiedError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelinkLinkedAccountAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelinkLinkedAccountAlert'] = ResolversParentTypes['RelinkLinkedAccountAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveAccountTypeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveAccountTypeResult'] = ResolversParentTypes['RemoveAccountTypeResult']> = {
  __resolveType: TypeResolveFn<'RemoveAccountTypeResultTemporaryImpl', ParentType, ContextType>;
};

export type RemoveAccountTypeResultTemporaryImplResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveAccountTypeResultTemporaryImpl'] = ResolversParentTypes['RemoveAccountTypeResultTemporaryImpl']> = {
  someField?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveCohortEligibilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCohortEligibilityResult'] = ResolversParentTypes['RemoveCohortEligibilityResult']> = {
  __resolveType: TypeResolveFn<'UserCohorts', ParentType, ContextType>;
};

export type RemoveJobAlertResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveJobAlertResult'] = ResolversParentTypes['RemoveJobAlertResult']> = {
  __resolveType: TypeResolveFn<'RemovedJobAlert', ParentType, ContextType>;
};

export type RemovePolicyResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemovePolicyResult'] = ResolversParentTypes['RemovePolicyResult']> = {
  __resolveType: TypeResolveFn<'PoliciesRecordDoesNotExistException' | 'ValidPolicies', ParentType, ContextType>;
};

export type RemoveSecurityFromPortfolioResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveSecurityFromPortfolioResult'] = ResolversParentTypes['RemoveSecurityFromPortfolioResult']> = {
  __resolveType: TypeResolveFn<'InvestmentAccountNotFoundException' | 'InvestmentAccountNotSupportedException' | 'Portfolio' | 'PortfolioNotFoundException' | 'PortfolioNotSupportedException' | 'SecurityNotSupportedException', ParentType, ContextType>;
};

export type RemoveSelfDirectedPortfolioResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveSelfDirectedPortfolioResult'] = ResolversParentTypes['RemoveSelfDirectedPortfolioResult']> = {
  __resolveType: TypeResolveFn<'AccountNotFoundException' | 'InvestmentAccount' | 'InvestmentAccountAlreadyClosed' | 'InvestmentAccountClosureInProgress' | 'PortfolioAlreadyRemovedError' | 'PortfolioNotFoundException' | 'PortfolioRemovalInProgressError', ParentType, ContextType>;
};

export type RemovedJobAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemovedJobAlert'] = ResolversParentTypes['RemovedJobAlert']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReopenUserAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReopenUserAccountResult'] = ResolversParentTypes['ReopenUserAccountResult']> = {
  __resolveType: TypeResolveFn<'UserNotFoundException' | 'UserReopenLockedException' | 'UserReopenSuspendedException' | 'User_v2', ParentType, ContextType>;
};

export type ReplayMoneyAssignmentErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReplayMoneyAssignmentError'] = ResolversParentTypes['ReplayMoneyAssignmentError']> = {
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplayMoneyAssignmentSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReplayMoneyAssignmentSuccess'] = ResolversParentTypes['ReplayMoneyAssignmentSuccess']> = {
  moneyAssignmentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplayMoneyManagerMoneyAssignmentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReplayMoneyManagerMoneyAssignmentResult'] = ResolversParentTypes['ReplayMoneyManagerMoneyAssignmentResult']> = {
  __resolveType: TypeResolveFn<'ReplayMoneyAssignmentError' | 'ReplayMoneyAssignmentSuccess', ParentType, ContextType>;
};

export type ReportBankCardLostStolenPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportBankCardLostStolenPayload'] = ResolversParentTypes['ReportBankCardLostStolenPayload']> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestEarlyAccountClosureResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestEarlyAccountClosureResult'] = ResolversParentTypes['RequestEarlyAccountClosureResult']> = {
  __resolveType: TypeResolveFn<'AccountAlreadyClosedException' | 'ClosureRequestExistsException' | 'FundingSourceRequiresRdvException' | 'InternalErrorException' | 'InvalidAccountTypeException' | 'InvestmentAccount' | 'InvestmentAccountNeedsTransferException' | 'MissingFundingSourceException', ParentType, ContextType>;
};

export type RequestInvestmentAccountReopenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestInvestmentAccountReopenResult'] = ResolversParentTypes['RequestInvestmentAccountReopenResult']> = {
  __resolveType: TypeResolveFn<'ExistingRequestPendingReview' | 'ExistingRequestPendingUserAction' | 'InvalidSubscriptionTierException' | 'InvestmentAccountNotClosedException' | 'InvestmentAccountNotFoundException' | 'InvestmentAccountReopenRequest', ParentType, ContextType>;
};

export type RequestLayerSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestLayerSessionResult'] = ResolversParentTypes['RequestLayerSessionResult']> = {
  __resolveType: TypeResolveFn<'RequestedLayerLinkSession' | 'UnrecoverableError', ParentType, ContextType>;
};

export type RequestSubscriptionMigrationWaiverResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestSubscriptionMigrationWaiverResult'] = ResolversParentTypes['RequestSubscriptionMigrationWaiverResult']> = {
  __resolveType: TypeResolveFn<'InvalidTierForMigrationError' | 'SubscriptionMigrationInvalidError' | 'SubscriptionMigrationWaiver', ParentType, ContextType>;
};

export type RequestedLayerLinkSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestedLayerLinkSession'] = ResolversParentTypes['RequestedLayerLinkSession']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ssnStorageResult?: Resolver<ResolversTypes['SSNStorageResult'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResendChatMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendChatMessageResponse'] = ResolversParentTypes['ResendChatMessageResponse']> = {
  __resolveType: TypeResolveFn<'ChatHistoryMessage' | 'ChatHistoryMessageNotFound', ParentType, ContextType>;
};

export type ResetPasswordByTokenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordByTokenException'] = ResolversParentTypes['ResetPasswordByTokenException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPasswordByTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordByTokenResult'] = ResolversParentTypes['ResetPasswordByTokenResult']> = {
  __resolveType: TypeResolveFn<'IncorrectSecurityAnswerException' | 'IncorrectSsnException' | 'InvalidPasswordException' | 'ResetPasswordByTokenException' | 'ResetPasswordByTokenSuccess' | 'UserCredentialsNotFoundException', ParentType, ContextType>;
};

export type ResetPasswordByTokenSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordByTokenSuccess'] = ResolversParentTypes['ResetPasswordByTokenSuccess']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPasswordWithTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordWithTokenResult'] = ResolversParentTypes['ResetPasswordWithTokenResult']> = {
  __resolveType: TypeResolveFn<'InvalidPasswordResetException' | 'InvalidPasswordResetTokenException' | 'ResetPasswordWithTokenSuccess' | 'UserCredentialsNotFoundException', ParentType, ContextType>;
};

export type ResetPasswordWithTokenSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordWithTokenSuccess'] = ResolversParentTypes['ResetPasswordWithTokenSuccess']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetRateLimitResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetRateLimitResult'] = ResolversParentTypes['ResetRateLimitResult']> = {
  __resolveType: TypeResolveFn<'RateLimitDoesNotExistException' | 'ResetRateLimitSuccess', ParentType, ContextType>;
};

export type ResetRateLimitSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetRateLimitSuccess'] = ResolversParentTypes['ResetRateLimitSuccess']> = {
  challengeRateLimitReset?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  loginRateLimitReset?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResourceNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResourceNotFoundError'] = ResolversParentTypes['ResourceNotFoundError']> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RespondToLearnPollResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RespondToLearnPollResult'] = ResolversParentTypes['RespondToLearnPollResult']> = {
  __resolveType: TypeResolveFn<'InvalidOptionException' | 'LearnPollResponse' | 'RecordDoesNotExistError', ParentType, ContextType>;
};

export type RestoreLoginAccessResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RestoreLoginAccessResult'] = ResolversParentTypes['RestoreLoginAccessResult']> = {
  __resolveType: TypeResolveFn<'AuthProfile' | 'AuthProfileNotFoundException', ParentType, ContextType>;
};

export type ResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['Result'] = ResolversParentTypes['Result']> = {
  funnel?: Resolver<ResolversTypes['Funnel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RetriggerRdvsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetriggerRdvsResult'] = ResolversParentTypes['RetriggerRdvsResult']> = {
  __resolveType: TypeResolveFn<'FundingSourceAccount' | 'RdvsNotTriggered', ParentType, ContextType>;
};

export type ReturnedCheckDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReturnedCheckDeposit'] = ResolversParentTypes['ReturnedCheckDeposit']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  backCheckImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  frontCheckImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rejectedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RevokeLoginAccessResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokeLoginAccessResult'] = ResolversParentTypes['RevokeLoginAccessResult']> = {
  __resolveType: TypeResolveFn<'AuthProfile' | 'UserCredentialsNotFoundException', ParentType, ContextType>;
};

export type RevokePasswordResetTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokePasswordResetTokenResult'] = ResolversParentTypes['RevokePasswordResetTokenResult']> = {
  __resolveType: TypeResolveFn<'InvalidPasswordResetTokenException' | 'RevokePasswordResetTokenSuccess', ParentType, ContextType>;
};

export type RevokePasswordResetTokenSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokePasswordResetTokenSuccess'] = ResolversParentTypes['RevokePasswordResetTokenSuccess']> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoundUpResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundUp'] = ResolversParentTypes['RoundUp']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  instant?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  investmentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  investmentNonce?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  linkedSubaccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  manual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  multiplier?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roundUpAccount?: Resolver<ResolversTypes['RoundUpAccount'], ParentType, ContextType>;
  roundUpProfile?: Resolver<ResolversTypes['RoundUpProfile'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['RoundUpState'], ParentType, ContextType>;
  targetAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  transactionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  transactionDisplayDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoundUpAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundUpAccount'] = ResolversParentTypes['RoundUpAccount']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedSubaccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  roundUpProfile?: Resolver<ResolversTypes['RoundUpProfile'], ParentType, ContextType>;
  roundUps?: Resolver<Array<ResolversTypes['RoundUp']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoundUpProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundUpProfile'] = ResolversParentTypes['RoundUpProfile']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  multiplier?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  realTimeRoundUpEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roundUpAccounts?: Resolver<Array<ResolversTypes['RoundUpAccount']>, ParentType, ContextType>;
  roundUpCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<RoundUpProfileRoundUpCountArgs, 'state'>>;
  roundUpTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<RoundUpProfileRoundUpTotalArgs, 'state'>>;
  roundUps?: Resolver<Array<ResolversTypes['RoundUp']>, ParentType, ContextType>;
  roundUpsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showRoundUpsProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  targetAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  wholeDollarAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoundUpTypeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundUpTypeEdge'] = ResolversParentTypes['RoundUpTypeEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RoundUp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoundUpTypePaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoundUpTypePagination'] = ResolversParentTypes['RoundUpTypePagination']> = {
  edges?: Resolver<Array<ResolversTypes['RoundUpTypeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface RoutingNumberScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['RoutingNumber'], any> {
  name: 'RoutingNumber';
}

export type SmsAuthChallengeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SMSAuthChallenge'] = ResolversParentTypes['SMSAuthChallenge']> = {
  alternateAuthenticators?: Resolver<Array<ResolversTypes['AuthenticatorInfo']>, ParentType, ContextType>;
  challengeTrigger?: Resolver<ResolversTypes['ChallengeTriggers'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maskedPhoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SsnDocumentRequestedUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['SSNDocumentRequestedUserAlert'] = ResolversParentTypes['SSNDocumentRequestedUserAlert']> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SamePasswordsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SamePasswordsException'] = ResolversParentTypes['SamePasswordsException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleMailInDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SampleMailInDocument'] = ResolversParentTypes['SampleMailInDocument']> = {
  letterUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  mailType?: Resolver<ResolversTypes['MailInDocumentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveInterestPaidItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveInterestPaidItem'] = ResolversParentTypes['SaveInterestPaidItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthEarned?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveTransferInItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveTransferInItem'] = ResolversParentTypes['SaveTransferInItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveTransferOutItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveTransferOutItem'] = ResolversParentTypes['SaveTransferOutItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveUploadUrlsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveUploadUrlsResult'] = ResolversParentTypes['SaveUploadUrlsResult']> = {
  __resolveType: TypeResolveFn<'DocumentUploads' | 'UploadSaveError', ParentType, ContextType>;
};

export type SavingsAccountEligibilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavingsAccountEligibility'] = ResolversParentTypes['SavingsAccountEligibility']> = {
  isEligibleForOpen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notEligibleReasons?: Resolver<Array<ResolversTypes['SavingsAccountEligibilityRequirement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleRecurringTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduleRecurringTransferResult'] = ResolversParentTypes['ScheduleRecurringTransferResult']> = {
  __resolveType: TypeResolveFn<'MalformedRecurringTransferException' | 'RecurringTransfer', ParentType, ContextType>;
};

export type ScheduleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduleResult'] = ResolversParentTypes['ScheduleResult']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Scope'] = ResolversParentTypes['Scope']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchEmployersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchEmployersPayload'] = ResolversParentTypes['SearchEmployersPayload']> = {
  results?: Resolver<Maybe<Array<ResolversTypes['Employer']>>, ParentType, ContextType>;
  trackingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchHistory'] = ResolversParentTypes['SearchHistory']> = {
  popularSearches?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  recentSearches?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchSecuritiesPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchSecuritiesPageInfo'] = ResolversParentTypes['SearchSecuritiesPageInfo']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nextPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prevPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalMatches?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchSecuritiesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchSecuritiesResponse'] = ResolversParentTypes['SearchSecuritiesResponse']> = {
  pageInfo?: Resolver<Maybe<ResolversTypes['SearchSecuritiesPageInfo']>, ParentType, ContextType>;
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchSupportArticleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchSupportArticleResult'] = ResolversParentTypes['SearchSupportArticleResult']> = {
  author?: Resolver<ResolversTypes['SupportAuthor'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  draft?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  editedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outdated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promoted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  resultType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  section?: Resolver<ResolversTypes['SupportSection'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  snippet?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchSupportResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchSupportResult'] = ResolversParentTypes['SearchSupportResult']> = {
  relevantSearchArticles?: Resolver<Array<Maybe<ResolversTypes['SearchSupportArticleResult']>>, ParentType, ContextType>;
  relevantSearchCategories?: Resolver<Array<Maybe<ResolversTypes['SupportCategory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecretSquirrelExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecretSquirrelException'] = ResolversParentTypes['SecretSquirrelException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecuritiesBySectorPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecuritiesBySectorPageInfo'] = ResolversParentTypes['SecuritiesBySectorPageInfo']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nextPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prevPageCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalMatches?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecuritiesBySectorResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecuritiesBySectorResponse'] = ResolversParentTypes['SecuritiesBySectorResponse']> = {
  pageInfo?: Resolver<Maybe<ResolversTypes['SecuritiesBySectorPageInfo']>, ParentType, ContextType>;
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecuritiesBySymbolsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecuritiesBySymbolsResponse'] = ResolversParentTypes['SecuritiesBySymbolsResponse']> = {
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Security'] = ResolversParentTypes['Security']> = {
  __resolveType: TypeResolveFn<'Fund' | 'Stock', ParentType, ContextType>;
  currentPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  earliestPriceDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  headlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastClosePrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  lastUpdatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  longName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  marketCap?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  openPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>;
  securityHeadlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>;
  securityProfile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SecurityType'], ParentType, ContextType>;
  volume?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  week52High?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  week52Low?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
};

export type SecurityDiversificationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityDiversificationInfo'] = ResolversParentTypes['SecurityDiversificationInfo']> = {
  diversificationFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityGainResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityGain'] = ResolversParentTypes['SecurityGain']> = {
  marketValue?: Resolver<Maybe<ResolversTypes['BigCurrencyAmount']>, ParentType, ContextType>;
  percent?: Resolver<Maybe<ResolversTypes['BigDecimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityHeadlineResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityHeadline'] = ResolversParentTypes['SecurityHeadline']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  headline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storyUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityNotSupportedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityNotSupportedException'] = ResolversParentTypes['SecurityNotSupportedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPerformance'] = ResolversParentTypes['SecurityPerformance']> = {
  gain?: Resolver<ResolversTypes['SecurityGain'], ParentType, ContextType>;
  prices?: Resolver<Maybe<Array<ResolversTypes['SecurityPrice']>>, ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPrice'] = ResolversParentTypes['SecurityPrice']> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  marketValue?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  unadjustedMarketValue?: Resolver<Maybe<ResolversTypes['BigCurrencyAmount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityProfile'] = ResolversParentTypes['SecurityProfile']> = {
  defaultLogoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  tradingSectors?: Resolver<Array<ResolversTypes['TradingSector']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelfDirectedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelfDirectedPortfolio'] = ResolversParentTypes['SelfDirectedPortfolio']> = {
  accountAllocation?: Resolver<ResolversTypes['PortfolioAllocation'], ParentType, ContextType>;
  cashOwed?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  currentAllocationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  currentBalanceWithPending?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  customizationLevel?: Resolver<Maybe<ResolversTypes['PortfolioCustomizationLevel']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  portfolioSecurities?: Resolver<Maybe<Array<ResolversTypes['PortfolioSecurity']>>, ParentType, ContextType>;
  portfolioSecurityAllocations?: Resolver<Maybe<Array<ResolversTypes['PortfolioSecurityAllocation']>>, ParentType, ContextType>;
  requirements?: Resolver<ResolversTypes['AccountRequirements'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SelfDirectedPortfolioStatus'], ParentType, ContextType>;
  yearToDateReturn?: Resolver<Maybe<ResolversTypes['MarketReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendChatMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendChatMessageResponse'] = ResolversParentTypes['SendChatMessageResponse']> = {
  __resolveType: TypeResolveFn<'ChatHistoryMessage' | 'ChatMessageSizeOutOfBounds' | 'ChatSessionNotFound' | 'ChatUnavailableError', ParentType, ContextType>;
};

export type SendCheckPaymentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendCheckPaymentResult'] = ResolversParentTypes['SendCheckPaymentResult']> = {
  __resolveType: TypeResolveFn<'AuthorizationError' | 'CheckPayment' | 'DuplicateActionError' | 'InvalidAddressError', ParentType, ContextType>;
};

export type SessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Session'] = ResolversParentTypes['Session']> = {
  redirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  token?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetAuthenticationPinResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetAuthenticationPINResult'] = ResolversParentTypes['SetAuthenticationPINResult']> = {
  __resolveType: TypeResolveFn<'InvalidPinException' | 'SetAuthenticationPINSuccess' | 'UserCredentialsNotFoundException', ParentType, ContextType>;
};

export type SetAuthenticationPinSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetAuthenticationPINSuccess'] = ResolversParentTypes['SetAuthenticationPINSuccess']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetBeneficiarySsnResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetBeneficiarySsnResult'] = ResolversParentTypes['SetBeneficiarySsnResult']> = {
  __resolveType: TypeResolveFn<'Beneficiary' | 'BeneficiaryNotFoundException' | 'InternalErrorException' | 'InvalidSsnException' | 'SecretSquirrelException' | 'SsnAlreadyInUseException' | 'SsnMatchesCustodianException' | 'SsnUpdateForbiddenException', ParentType, ContextType>;
};

export type SetDefaultAuthenticatorResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetDefaultAuthenticatorResult'] = ResolversParentTypes['SetDefaultAuthenticatorResult']> = {
  __resolveType: TypeResolveFn<'AuthenticatorAlreadyDefaultException' | 'AuthenticatorNotFoundException' | 'EmailAuthenticator' | 'PhoneAuthenticator', ParentType, ContextType>;
};

export type SetInvestmentAccountRecapPublicAccessResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetInvestmentAccountRecapPublicAccessResult'] = ResolversParentTypes['SetInvestmentAccountRecapPublicAccessResult']> = {
  __resolveType: TypeResolveFn<'InvestmentAccountRecap' | 'InvestmentAccountRecapNotFoundException', ParentType, ContextType>;
};

export type SetNegotiationStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetNegotiationStatusResult'] = ResolversParentTypes['SetNegotiationStatusResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetPreferredWithdrawalAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetPreferredWithdrawalAccountResult'] = ResolversParentTypes['SetPreferredWithdrawalAccountResult']> = {
  __resolveType: TypeResolveFn<'FundingSourceAccount' | 'PreferredAccountNotEligibleError' | 'PreferredAccountNotSupportedError', ParentType, ContextType>;
};

export type SetReferralCampaignFlagsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetReferralCampaignFlagsResult'] = ResolversParentTypes['SetReferralCampaignFlagsResult']> = {
  autoAdd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fallback?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  qa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetUpTipResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetUpTip'] = ResolversParentTypes['SetUpTip']> = {
  backgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaDetails?: Resolver<ResolversTypes['ActionFeedCta'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductSetupTipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Settings'] = ResolversParentTypes['Settings']> = {
  allowDebitCard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  automaticRoundup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  depositsSuspended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dollarRoundupAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  notifications?: Resolver<ResolversTypes['Notifications'], ParentType, ContextType>;
  roundupMultiplier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['Signature'] = ResolversParentTypes['Signature']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  signatureType?: Resolver<ResolversTypes['SignatureType'], ParentType, ContextType>;
  svgFile?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SiteWideBannerContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SiteWideBannerContent'] = ResolversParentTypes['SiteWideBannerContent']> = {
  bannerText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SmartDepositMetadataResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SmartDepositMetadataResult'] = ResolversParentTypes['SmartDepositMetadataResult']> = {
  recommendedAllocations?: Resolver<Array<ResolversTypes['SplitDepositAllocation']>, ParentType, ContextType>;
  targetAccounts?: Resolver<Array<ResolversTypes['SplitDepositTargetAccount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceAttributes'] = ResolversParentTypes['SourceAttributes']> = {
  affiliateCampaignID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buttonSourceToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clickID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeformIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promoCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAtmReimbursementItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendATMReimbursementItem'] = ResolversParentTypes['SpendATMReimbursementItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAtmWithdrawalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendATMWithdrawalItem'] = ResolversParentTypes['SpendATMWithdrawalItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendAccount'] = ResolversParentTypes['SpendAccount']> = {
  accountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bankCardOrder?: Resolver<Maybe<ResolversTypes['BankCardOrder']>, ParentType, ContextType>;
  bankType?: Resolver<Maybe<ResolversTypes['BankType']>, ParentType, ContextType>;
  isDirectDepositIncentiveEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForPremiumCardUpgrade?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isReopenable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lockReason?: Resolver<Maybe<ResolversTypes['BankAccountLockReason']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SpendAccountStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendAlert'] = ResolversParentTypes['SpendAlert']> = {
  __resolveType: TypeResolveFn<'SystemCardLockedSpendAlert' | 'UserCardLockedSpendAlert', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type SpendAtmResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendAtm'] = ResolversParentTypes['SpendAtm']> = {
  address?: Resolver<ResolversTypes['SpendAtmAddress'], ParentType, ContextType>;
  atmName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAtmAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendAtmAddress'] = ResolversParentTypes['SpendAtmAddress']> = {
  addressLine?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stateCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAtmVendorUnavailableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendAtmVendorUnavailableError'] = ResolversParentTypes['SpendAtmVendorUnavailableError']> = {
  requestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAtmsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendAtmsPayload'] = ResolversParentTypes['SpendAtmsPayload']> = {
  atms?: Resolver<Maybe<Array<Maybe<ResolversTypes['SpendAtm']>>>, ParentType, ContextType>;
  executedSearchRadius?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendAtmsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendAtmsResult'] = ResolversParentTypes['SpendAtmsResult']> = {
  __resolveType: TypeResolveFn<'SpendAtmVendorUnavailableError' | 'SpendAtmsPayload', ParentType, ContextType>;
};

export type SpendBillPayItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendBillPayItem'] = ResolversParentTypes['SpendBillPayItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendCheckDepositItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendCheckDepositItem'] = ResolversParentTypes['SpendCheckDepositItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendCheckPaymentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendCheckPaymentItem'] = ResolversParentTypes['SpendCheckPaymentItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendDigitalWalletItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendDigitalWalletItem'] = ResolversParentTypes['SpendDigitalWalletItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendDirectDepositItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendDirectDepositItem'] = ResolversParentTypes['SpendDirectDepositItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendDisputesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendDisputesResponse'] = ResolversParentTypes['SpendDisputesResponse']> = {
  creationDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disputeDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['SpendTransactionsDisputeQuestions']>, ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['SpendTransactionsResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendECheckItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendECheckItem'] = ResolversParentTypes['SpendECheckItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendInterestPaidItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendInterestPaidItem'] = ResolversParentTypes['SpendInterestPaidItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthEarned?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendItem'] = ResolversParentTypes['SpendItem']> = {
  __resolveType: TypeResolveFn<'PastSpendItem' | 'SaveInterestPaidItem' | 'SaveTransferInItem' | 'SaveTransferOutItem' | 'SpendATMReimbursementItem' | 'SpendATMWithdrawalItem' | 'SpendBillPayItem' | 'SpendCheckDepositItem' | 'SpendCheckPaymentItem' | 'SpendDigitalWalletItem' | 'SpendDirectDepositItem' | 'SpendECheckItem' | 'SpendInterestPaidItem' | 'SpendPurchaseItem' | 'SpendRealTimeRoundUpItem' | 'SpendTransferInItem' | 'SpendTransferOutItem', ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
};

export type SpendPurchaseItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendPurchaseItem'] = ResolversParentTypes['SpendPurchaseItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendRealTimeRoundUpItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendRealTimeRoundUpItem'] = ResolversParentTypes['SpendRealTimeRoundUpItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialAmount?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  multiplier?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendTransactionsDisputeCustomersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendTransactionsDisputeCustomersResponse'] = ResolversParentTypes['SpendTransactionsDisputeCustomersResponse']> = {
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputes?: Resolver<Array<ResolversTypes['SpendDisputesResponse']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendTransactionsDisputeQuestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendTransactionsDisputeQuestions'] = ResolversParentTypes['SpendTransactionsDisputeQuestions']> = {
  answer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendTransactionsDisputeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendTransactionsDisputeResponse'] = ResolversParentTypes['SpendTransactionsDisputeResponse']> = {
  bankType?: Resolver<ResolversTypes['BankType'], ParentType, ContextType>;
  customers?: Resolver<ResolversTypes['SpendTransactionsDisputeCustomersResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendTransactionsDisputeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendTransactionsDisputeResult'] = ResolversParentTypes['SpendTransactionsDisputeResult']> = {
  __resolveType: TypeResolveFn<'SpendTransactionsDisputeResponse', ParentType, ContextType>;
};

export type SpendTransactionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendTransactionsResponse'] = ResolversParentTypes['SpendTransactionsResponse']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  coreTransactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disputedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postingDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendTransferInItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendTransferInItem'] = ResolversParentTypes['SpendTransferInItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpendTransferOutItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpendTransferOutItem'] = ResolversParentTypes['SpendTransferOutItem']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  availableAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drawerInclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  moneyManagerTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productAccountType?: Resolver<ResolversTypes['ProductAccountType'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  reversible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PastItemStatus'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAccountTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDeposit'] = ResolversParentTypes['SplitDeposit']> = {
  allocations?: Resolver<Array<ResolversTypes['SplitDepositAllocation']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distributedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expectedNextDepositAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expectedNextDepositAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCanceled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUsingRecommendedAllocations?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settingsId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  splitDistribution?: Resolver<ResolversTypes['DistributionAmounts'], ParentType, ContextType>;
  transactionAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  willDistributeAutomaticallyAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositAllocation'] = ResolversParentTypes['SplitDepositAllocation']> = {
  __resolveType: TypeResolveFn<'SplitDepositDirectDepositAllocation' | 'SplitDepositRecurrenceAllocation', ParentType, ContextType>;
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  targetAccountType?: Resolver<ResolversTypes['SplitDepositTargetAccountType'], ParentType, ContextType>;
};

export type SplitDepositDailyRecurrenceRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositDailyRecurrenceRule'] = ResolversParentTypes['SplitDepositDailyRecurrenceRule']> = {
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositDirectDepositAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositDirectDepositAllocation'] = ResolversParentTypes['SplitDepositDirectDepositAllocation']> = {
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  normalizedAmount?: Resolver<Maybe<ResolversTypes['FormattedMonetaryAmount']>, ParentType, ContextType>;
  normalizedDailyAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  targetAccountType?: Resolver<ResolversTypes['SplitDepositTargetAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositDirectDepositIntentSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositDirectDepositIntentSetting'] = ResolversParentTypes['SplitDepositDirectDepositIntentSetting']> = {
  allocations?: Resolver<Array<ResolversTypes['SplitDepositDirectDepositAllocation']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deposits?: Resolver<Maybe<Array<ResolversTypes['SplitDeposit']>>, ParentType, ContextType, Partial<SplitDepositDirectDepositIntentSettingDepositsArgs>>;
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  estimatedPaycheckAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUsingRecommendedAllocations?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositDirectDepositSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositDirectDepositSetting'] = ResolversParentTypes['SplitDepositDirectDepositSetting']> = {
  allocations?: Resolver<Array<ResolversTypes['SplitDepositDirectDepositAllocation']>, ParentType, ContextType>;
  awaitingConfiguration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deposits?: Resolver<Maybe<Array<ResolversTypes['SplitDeposit']>>, ParentType, ContextType, Partial<SplitDepositDirectDepositSettingDepositsArgs>>;
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUsingRecommendedAllocations?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthlyTotals?: Resolver<Array<ResolversTypes['MonthlyTotal']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  normalizedAmount?: Resolver<Maybe<ResolversTypes['FormattedMonetaryAmount']>, ParentType, ContextType>;
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAmounts?: Resolver<Maybe<ResolversTypes['TotalAmounts']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositMonthlyRecurrenceRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositMonthlyRecurrenceRule'] = ResolversParentTypes['SplitDepositMonthlyRecurrenceRule']> = {
  byMonthDay?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositMutation'] = ResolversParentTypes['SplitDepositMutation']> = {
  cancel?: Resolver<ResolversTypes['SplitDeposit'], ParentType, ContextType>;
  execute?: Resolver<ResolversTypes['SplitDeposit'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositRecurrenceAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositRecurrenceAllocation'] = ResolversParentTypes['SplitDepositRecurrenceAllocation']> = {
  allocationPercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyRecurrenceAmount?: Resolver<Maybe<ResolversTypes['FormattedMonetaryAmount']>, ParentType, ContextType>;
  legacyRecurrenceRule?: Resolver<Maybe<ResolversTypes['SplitDepositRecurrenceRule']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  targetAccountType?: Resolver<ResolversTypes['SplitDepositTargetAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositRecurrenceRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositRecurrenceRule'] = ResolversParentTypes['SplitDepositRecurrenceRule']> = {
  __resolveType: TypeResolveFn<'SplitDepositDailyRecurrenceRule' | 'SplitDepositMonthlyRecurrenceRule' | 'SplitDepositWeeklyRecurrenceRule', ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>;
};

export type SplitDepositRecurrenceSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositRecurrenceSetting'] = ResolversParentTypes['SplitDepositRecurrenceSetting']> = {
  allocations?: Resolver<Array<ResolversTypes['SplitDepositRecurrenceAllocation']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deposits?: Resolver<Maybe<Array<ResolversTypes['SplitDeposit']>>, ParentType, ContextType, Partial<SplitDepositRecurrenceSettingDepositsArgs>>;
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthlyTotals?: Resolver<Array<ResolversTypes['MonthlyTotal']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  normalizedAmount?: Resolver<Maybe<ResolversTypes['FormattedMonetaryAmount']>, ParentType, ContextType>;
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositSettings'] = ResolversParentTypes['SplitDepositSettings']> = {
  __resolveType: TypeResolveFn<'SplitDepositDirectDepositIntentSetting' | 'SplitDepositDirectDepositSetting' | 'SplitDepositRecurrenceSetting', ParentType, ContextType>;
  allocations?: Resolver<Array<ResolversTypes['SplitDepositAllocation']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deposits?: Resolver<Maybe<Array<ResolversTypes['SplitDeposit']>>, ParentType, ContextType, Partial<SplitDepositSettingsDepositsArgs>>;
  distributionType?: Resolver<ResolversTypes['DistributionType'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboarded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  savingsRatePercent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type SplitDepositSettingsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositSettingsMutation'] = ResolversParentTypes['SplitDepositSettingsMutation']> = {
  configure?: Resolver<ResolversTypes['SplitDepositSettings'], ParentType, ContextType, RequireFields<SplitDepositSettingsMutationConfigureArgs, 'input'>>;
  employer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositTargetAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositTargetAccount'] = ResolversParentTypes['SplitDepositTargetAccount']> = {
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  targetAccountType?: Resolver<ResolversTypes['SplitDepositTargetAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitDepositWeeklyRecurrenceRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitDepositWeeklyRecurrenceRule'] = ResolversParentTypes['SplitDepositWeeklyRecurrenceRule']> = {
  byWeekDay?: Resolver<Array<ResolversTypes['DayOfWeek']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['SplitDepositRecurrenceFrequency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SsnAlreadyInUseExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SsnAlreadyInUseException'] = ResolversParentTypes['SsnAlreadyInUseException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SsnMatchesCustodianExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SsnMatchesCustodianException'] = ResolversParentTypes['SsnMatchesCustodianException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SsnUpdateForbiddenExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SsnUpdateForbiddenException'] = ResolversParentTypes['SsnUpdateForbiddenException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StartCheckDepositPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartCheckDepositPayload'] = ResolversParentTypes['StartCheckDepositPayload']> = {
  sessionToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StartOnlineSwitchPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartOnlineSwitchPayload'] = ResolversParentTypes['StartOnlineSwitchPayload']> = {
  userSwitch?: Resolver<ResolversTypes['UserSwitch'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StartSubmittableSwitchPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartSubmittableSwitchPayload'] = ResolversParentTypes['StartSubmittableSwitchPayload']> = {
  userSwitch?: Resolver<ResolversTypes['UserSwitch'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Statement'] = ResolversParentTypes['Statement']> = {
  archivableId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  archivableType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  formType?: Resolver<Maybe<ResolversTypes['FormType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccountType?: Resolver<Maybe<ResolversTypes['InvestmentAccountType']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['StatementLink']>, ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  portfolioType?: Resolver<ResolversTypes['StatementPortfolioType'], ParentType, ContextType>;
  s3Filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  statementLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statementType?: Resolver<ResolversTypes['StatementType'], ParentType, ContextType>;
  taxFormType?: Resolver<Maybe<ResolversTypes['TaxFormType']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  uploaded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatementEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatementEdge'] = ResolversParentTypes['StatementEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Statement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatementLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatementLink'] = ResolversParentTypes['StatementLink']> = {
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatementPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatementPagination'] = ResolversParentTypes['StatementPagination']> = {
  edges?: Resolver<Array<ResolversTypes['StatementEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockResolvers<ContextType = any, ParentType extends ResolversParentTypes['Stock'] = ResolversParentTypes['Stock']> = {
  currentPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  earliestPriceDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  headlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastClosePrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  lastUpdatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  longName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  marketCap?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  openPrice?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>;
  securityHeadlines?: Resolver<Array<ResolversTypes['SecurityHeadline']>, ParentType, ContextType>;
  securityProfile?: Resolver<ResolversTypes['SecurityProfile'], ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['TickerSymbol'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SecurityType'], ParentType, ContextType>;
  volume?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  week52High?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  week52Low?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoredRdvDepositsInvalidResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoredRdvDepositsInvalid'] = ResolversParentTypes['StoredRdvDepositsInvalid']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoredRdvDepositsMissingResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoredRdvDepositsMissing'] = ResolversParentTypes['StoredRdvDepositsMissing']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface StringKeyScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['StringKey'], any> {
  name: 'StringKey';
}

export type StringKeyAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['StringKeyAsset'] = ResolversParentTypes['StringKeyAsset']> = {
  args?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['StringKey'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubcategoryMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubcategoryMessage'] = ResolversParentTypes['SubcategoryMessage']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Submission'] = ResolversParentTypes['Submission']> = {
  bank?: Resolver<ResolversTypes['BankName'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  feeSynopsis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SubmissionStatus'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmissionErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmissionError'] = ResolversParentTypes['SubmissionError']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmitBankFeeNegotiationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitBankFeeNegotiationResponse'] = ResolversParentTypes['SubmitBankFeeNegotiationResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmitBankFeeNegotiationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitBankFeeNegotiationResult'] = ResolversParentTypes['SubmitBankFeeNegotiationResult']> = {
  __resolveType: TypeResolveFn<'LinkedAccountNotFound' | 'SubmitBankFeeNegotiationResponse', ParentType, ContextType>;
};

export type SubmitEarnMissingCreditRequestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitEarnMissingCreditRequestResult'] = ResolversParentTypes['SubmitEarnMissingCreditRequestResult']> = {
  __resolveType: TypeResolveFn<'EarnMissingCreditRequest' | 'EarnMissingCreditRequestPurchaseDateError', ParentType, ContextType>;
};

export type SubmitUserReportedBankFeeRefundResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitUserReportedBankFeeRefundResult'] = ResolversParentTypes['SubmitUserReportedBankFeeRefundResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmittableSwitchResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmittableSwitch'] = ResolversParentTypes['SubmittableSwitch']> = {
  requiresEmployerMailingAddress?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  requiresNonSsnEmployeeId?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  requiresSsnLastFour?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>;
  vendorTargetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscribeToTierResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscribeToTierResult'] = ResolversParentTypes['SubscribeToTierResult']> = {
  __resolveType: TypeResolveFn<'InvalidTier' | 'InvalidTierPrice' | 'TierSubscription', ParentType, ContextType>;
};

export type SubscribeUserToTierResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscribeUserToTierResult'] = ResolversParentTypes['SubscribeUserToTierResult']> = {
  __resolveType: TypeResolveFn<'InvalidTierPriceId' | 'TierDowngradeActionRequired' | 'TierSubscription', ParentType, ContextType>;
};

export type SubscriberIneligibleErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriberIneligibleError'] = ResolversParentTypes['SubscriberIneligibleError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  onChatMessage?: SubscriptionResolver<ResolversTypes['ChatHistoryMessage'], "onChatMessage", ParentType, ContextType, RequireFields<SubscriptionOnChatMessageArgs, 'sessionId'>>;
  onChatMessageStream?: SubscriptionResolver<ResolversTypes['ChatMessageStreamResponse'], "onChatMessageStream", ParentType, ContextType, RequireFields<SubscriptionOnChatMessageStreamArgs, 'sessionId'>>;
  onMessageCreated?: SubscriptionResolver<ResolversTypes['Message'], "onMessageCreated", ParentType, ContextType, Partial<SubscriptionOnMessageCreatedArgs>>;
};

export type SubscriptionMigrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionMigration'] = ResolversParentTypes['SubscriptionMigration']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  effectiveAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fromTier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toTier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionMigrationInvalidErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionMigrationInvalidError'] = ResolversParentTypes['SubscriptionMigrationInvalidError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionMigrationWaiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionMigrationWaiver'] = ResolversParentTypes['SubscriptionMigrationWaiver']> = {
  accepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  migration?: Resolver<ResolversTypes['SubscriptionMigration'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['SubscriptionMigrationWaiverReason'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SucceedVendorInvoiceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SucceedVendorInvoiceResult'] = ResolversParentTypes['SucceedVendorInvoiceResult']> = {
  __resolveType: TypeResolveFn<'BillingVendorError' | 'Invoice', ParentType, ContextType>;
};

export type SuggestedMoneyRulesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedMoneyRulesResult'] = ResolversParentTypes['SuggestedMoneyRulesResult']> = {
  __resolveType: TypeResolveFn<'SuggestedMoneyRulesSuccess', ParentType, ContextType>;
};

export type SuggestedMoneyRulesSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedMoneyRulesSuccess'] = ResolversParentTypes['SuggestedMoneyRulesSuccess']> = {
  adjustedForIncome?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  resultingCategories?: Resolver<Array<ResolversTypes['MoneyManagerCategory']>, ParentType, ContextType>;
  resultingRuleset?: Resolver<ResolversTypes['MoneyRulesRuleset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuitabilityAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuitabilityAnswer'] = ResolversParentTypes['SuitabilityAnswer']> = {
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuitabilityQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuitabilityQuestion'] = ResolversParentTypes['SuitabilityQuestion']> = {
  answers?: Resolver<Array<Maybe<ResolversTypes['SuitabilityAnswer']>>, ParentType, ContextType>;
  defaultAnswer?: Resolver<ResolversTypes['SuitabilityAnswer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pickerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SummaryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SummaryItem'] = ResolversParentTypes['SummaryItem']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportArticle'] = ResolversParentTypes['SupportArticle']> = {
  author?: Resolver<ResolversTypes['SupportAuthor'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  draft?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  editedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  labels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  private?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  promoted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  section?: Resolver<ResolversTypes['SupportSection'], ParentType, ContextType>;
  sectionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportAuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportAuthor'] = ResolversParentTypes['SupportAuthor']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  photo?: Resolver<ResolversTypes['SupportAuthorPhoto'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportAuthorPhotoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportAuthorPhoto'] = ResolversParentTypes['SupportAuthorPhoto']> = {
  contentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportCategory'] = ResolversParentTypes['SupportCategory']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportCitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportCitation'] = ResolversParentTypes['SupportCitation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportSection'] = ResolversParentTypes['SupportSection']> = {
  articles?: Resolver<Array<Maybe<ResolversTypes['SupportArticle']>>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['SupportCategory'], ParentType, ContextType>;
  categoryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicket'] = ResolversParentTypes['SupportTicket']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reportingTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketFormResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketForm'] = ResolversParentTypes['SupportTicketForm']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ticketFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportTicketFormField']>>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketFormFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketFormField'] = ResolversParentTypes['SupportTicketFormField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  customFieldOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomFieldOption']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  systemFieldOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomFieldOption']>>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketResponse'] = ResolversParentTypes['SupportTicketResponse']> = {
  __resolveType: TypeResolveFn<'RecaptchaException' | 'SupportTicket', ParentType, ContextType>;
};

export type SupportTicketWithCustomFieldsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketWithCustomFieldsResponse'] = ResolversParentTypes['SupportTicketWithCustomFieldsResponse']> = {
  __resolveType: TypeResolveFn<'SubmissionError' | 'SupportTicket', ParentType, ContextType>;
};

export type SupportUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportUser'] = ResolversParentTypes['SupportUser']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportsPlaidVerificationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportsPlaidVerificationResult'] = ResolversParentTypes['SupportsPlaidVerificationResult']> = {
  supportsPlaidVerificationType?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuppressMoneyManagerRebalancesErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuppressMoneyManagerRebalancesError'] = ResolversParentTypes['SuppressMoneyManagerRebalancesError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuppressMoneyManagerRebalancesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuppressMoneyManagerRebalancesResult'] = ResolversParentTypes['SuppressMoneyManagerRebalancesResult']> = {
  __resolveType: TypeResolveFn<'SuppressMoneyManagerRebalancesError' | 'SuppressMoneyManagerRebalancesSuccess', ParentType, ContextType>;
};

export type SuppressMoneyManagerRebalancesSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuppressMoneyManagerRebalancesSuccess'] = ResolversParentTypes['SuppressMoneyManagerRebalancesSuccess']> = {
  rebalancesSuppressedFrom?: Resolver<ResolversTypes['MoneyManagerRebalanceSuppressionSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwitchInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchInterface'] = ResolversParentTypes['SwitchInterface']> = {
  __resolveType: TypeResolveFn<'AcornsPdfSwitch' | 'OnlineSwitch' | 'SubmittableSwitch', ParentType, ContextType>;
  source?: Resolver<ResolversTypes['SwitchSource'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>;
};

export type SwitchPayloadInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchPayloadInterface'] = ResolversParentTypes['SwitchPayloadInterface']> = {
  __resolveType: TypeResolveFn<'StartOnlineSwitchPayload' | 'StartSubmittableSwitchPayload', ParentType, ContextType>;
  userSwitch?: Resolver<ResolversTypes['UserSwitch'], ParentType, ContextType>;
};

export type SyncBankFeeTransactionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncBankFeeTransactionsResult'] = ResolversParentTypes['SyncBankFeeTransactionsResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncFundingSourceToVendorResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncFundingSourceToVendorResult'] = ResolversParentTypes['SyncFundingSourceToVendorResult']> = {
  __resolveType: TypeResolveFn<'BillingVendorError' | 'DuplicateBillingInfoError' | 'VendorBillingInfo', ParentType, ContextType>;
};

export type SyncSupportAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncSupportAccountResponse'] = ResolversParentTypes['SyncSupportAccountResponse']> = {
  eventId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemCardLockedSpendAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemCardLockedSpendAlert'] = ResolversParentTypes['SystemCardLockedSpendAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxFilingPartnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxFilingPartner'] = ResolversParentTypes['TaxFilingPartner']> = {
  accountUsed?: Resolver<Maybe<ResolversTypes['RefundBankAccount']>, ParentType, ContextType>;
  disqualificationReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  federalReturn?: Resolver<Maybe<ResolversTypes['TaxReturn']>, ParentType, ContextType>;
  isStateFiled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUserDisqualified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  netRefundAmount?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  refundToAcorns?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stateReturns?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxReturn']>>>, ParentType, ContextType>;
  taxAppStatus?: Resolver<ResolversTypes['TaxApplicationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxReturn'] = ResolversParentTypes['TaxReturn']> = {
  lastSubmissionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  refundAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  rejectedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returnStatus?: Resolver<ResolversTypes['TaxReturnStatus'], ParentType, ContextType>;
  taxLocationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxWithholdingAmountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxWithholdingAmounts'] = ResolversParentTypes['TaxWithholdingAmounts']> = {
  federalWithholdingAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  stateWithholdingAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TfaOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TfaOptions'] = ResolversParentTypes['TfaOptions']> = {
  email?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  notification?: Resolver<Maybe<Array<ResolversTypes['TfaNotification']>>, ParentType, ContextType>;
  phone?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  question?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TickerSymbolScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TickerSymbol'], any> {
  name: 'TickerSymbol';
}

export type TierResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tier'] = ResolversParentTypes['Tier']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  assetPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundles?: Resolver<Maybe<Array<ResolversTypes['Bundle']>>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludedProducts?: Resolver<Array<ResolversTypes['TierProduct']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includedProducts?: Resolver<Array<ResolversTypes['TierProduct']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['TierKey'], ParentType, ContextType>;
  matchProgram?: Resolver<Maybe<ResolversTypes['MatchProgram']>, ParentType, ContextType, RequireFields<TierMatchProgramArgs, 'investmentAccountType'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  tierGroupId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tierPrice?: Resolver<ResolversTypes['TierPrice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierDowngradeActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierDowngradeAction'] = ResolversParentTypes['TierDowngradeAction']> = {
  key?: Resolver<ResolversTypes['TierDowngradeActionKey'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierDowngradeActionRequiredResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierDowngradeActionRequired'] = ResolversParentTypes['TierDowngradeActionRequired']> = {
  actions?: Resolver<Array<ResolversTypes['TierDowngradeAction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierGroup'] = ResolversParentTypes['TierGroup']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  preferredTierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tierOptions?: Resolver<Array<ResolversTypes['TierOption']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  winbackTierOption?: Resolver<Maybe<ResolversTypes['TierOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierOption'] = ResolversParentTypes['TierOption']> = {
  preferredTierPrice?: Resolver<ResolversTypes['TierPrice'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>;
  tierPrices?: Resolver<Array<ResolversTypes['TierPrice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierOptionByTierPriceIdResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierOptionByTierPriceIdResult'] = ResolversParentTypes['TierOptionByTierPriceIdResult']> = {
  __resolveType: TypeResolveFn<'InvalidTierPriceId' | 'TierOption', ParentType, ContextType>;
};

export type TierPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierPrice'] = ResolversParentTypes['TierPrice']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  amountV2?: Resolver<ResolversTypes['MicrosMoney'], ParentType, ContextType>;
  billingFrequency?: Resolver<ResolversTypes['BillingFrequency'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierProduct'] = ResolversParentTypes['TierProduct']> = {
  key?: Resolver<ResolversTypes['ProductKey'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscription'] = ResolversParentTypes['TierSubscription']> = {
  activePromotion?: Resolver<Maybe<ResolversTypes['Promotion']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['TierSubscriptionCreatedBy']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  migration?: Resolver<Maybe<ResolversTypes['SubscriptionMigration']>, ParentType, ContextType>;
  migrationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  offer?: Resolver<Maybe<ResolversTypes['Offer']>, ParentType, ContextType>;
  offerExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  previous?: Resolver<Maybe<ResolversTypes['TierSubscription']>, ParentType, ContextType>;
  promotionAppliedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  promotionExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TierSubscriptionStatus'], ParentType, ContextType>;
  tier?: Resolver<ResolversTypes['Tier'], ParentType, ContextType>;
  tierPrice?: Resolver<ResolversTypes['TierPrice'], ParentType, ContextType>;
  transition?: Resolver<Maybe<ResolversTypes['TierSubscriptionTransition']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  vendorIntegrated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierSubscriptionAlreadyDeactivatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscriptionAlreadyDeactivated'] = ResolversParentTypes['TierSubscriptionAlreadyDeactivated']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierSubscriptionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscriptionConnection'] = ResolversParentTypes['TierSubscriptionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TierSubscription']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['TierSubscriptionPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierSubscriptionForUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscriptionForUser'] = ResolversParentTypes['TierSubscriptionForUser']> = {
  __resolveType: TypeResolveFn<'TierSubscription' | 'TierSubscriptionNotFound' | 'TierSubscriptionUnsubscribed', ParentType, ContextType>;
};

export type TierSubscriptionNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscriptionNotFound'] = ResolversParentTypes['TierSubscriptionNotFound']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierSubscriptionPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscriptionPageInfo'] = ResolversParentTypes['TierSubscriptionPageInfo']> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNext?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierSubscriptionTransitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscriptionTransition'] = ResolversParentTypes['TierSubscriptionTransition']> = {
  desiredTier?: Resolver<Maybe<ResolversTypes['Tier']>, ParentType, ContextType>;
  desiredTierPrice?: Resolver<Maybe<ResolversTypes['TierPrice']>, ParentType, ContextType>;
  initiatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  subscriptionDeactivationReason?: Resolver<Maybe<ResolversTypes['TierSubscriptionDeactivationReason']>, ParentType, ContextType>;
  transitionAction?: Resolver<ResolversTypes['SubscriptionTransitionAction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierSubscriptionUnsubscribedResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierSubscriptionUnsubscribed'] = ResolversParentTypes['TierSubscriptionUnsubscribed']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Time'], any> {
  name: 'Time';
}

export type TimestampsInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimestampsInterface'] = ResolversParentTypes['TimestampsInterface']> = {
  __resolveType: TypeResolveFn<'Account' | 'Address' | 'Beneficiary' | 'BillingCycle' | 'Credit' | 'ExecutionAudit' | 'Fee' | 'FeeExecution' | 'FinancialInstitution' | 'FundingSourceAccount' | 'InvestmentAccount' | 'InvestmentAccountReopenRequest' | 'InvestmentAccountReopenRequestAction' | 'InvestmentAccountReopenRequestNote' | 'LinkedAccount' | 'LinkedSubaccount' | 'Liquidation' | 'MatchProgram' | 'OutsideContribution' | 'OutsideContributionCheckoutCart' | 'OutsideContributionCode' | 'Phone' | 'Profile' | 'RecurringInvestmentSettings' | 'RoundUp' | 'RoundUpAccount' | 'RoundUpProfile' | 'Signature' | 'UserInvestmentAccountReopenCheck', ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type ToggleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Toggle'] = ResolversParentTypes['Toggle']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invalid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenExpiredExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokenExpiredException'] = ResolversParentTypes['TokenExpiredException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopEmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopEmployer'] = ResolversParentTypes['TopEmployer']> = {
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employerSwitchType?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onlineSwitchUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopEmployerPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopEmployerPayload'] = ResolversParentTypes['TopEmployerPayload']> = {
  topEmployersList?: Resolver<Array<ResolversTypes['TopEmployer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopHoldingResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopHolding'] = ResolversParentTypes['TopHolding']> = {
  marketValue?: Resolver<ResolversTypes['BigCurrencyAmount'], ParentType, ContextType>;
  numberOfShares?: Resolver<Maybe<ResolversTypes['BigDecimal']>, ParentType, ContextType>;
  securityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sharePercentage?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  symbol?: Resolver<Maybe<ResolversTypes['TickerSymbol']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalAmountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalAmounts'] = ResolversParentTypes['TotalAmounts']> = {
  totalContributedAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  totalDepositedAmount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  backupPaymentMethodUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  collectedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  collectionMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refunded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  voidedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transfer'] = ResolversParentTypes['Transfer']> = {
  amount?: Resolver<ResolversTypes['CurrencyAmount'], ParentType, ContextType>;
  canceledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['TransferState'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferableAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferableAccount'] = ResolversParentTypes['TransferableAccount']> = {
  accountNumberMasked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  externalSource?: Resolver<Maybe<ResolversTypes['ExternalSource']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TransferableAccountTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferableFromResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferableFrom'] = ResolversParentTypes['TransferableFrom']> = {
  from?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferableToResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferableTo'] = ResolversParentTypes['TransferableTo']> = {
  max?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CurrencyAmount']>, ParentType, ContextType>;
  to?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrendingLearnContentPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendingLearnContentPreview'] = ResolversParentTypes['TrendingLearnContentPreview']> = {
  __resolveType: TypeResolveFn<'LearnArticlePreview' | 'LearnArticlePreviewLocked' | 'LearnMediaPreview' | 'LearnMediaPreviewLocked', ParentType, ContextType>;
};

export type TrustedContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustedContact'] = ResolversParentTypes['TrustedContact']> = {
  email?: Resolver<ResolversTypes['Email'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentAccounts?: Resolver<Array<Maybe<ResolversTypes['InvestmentAccount']>>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrustedContactAlreadyExistsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustedContactAlreadyExistsException'] = ResolversParentTypes['TrustedContactAlreadyExistsException']> = {
  attributes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrustedContactInvalidEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustedContactInvalidEmail'] = ResolversParentTypes['TrustedContactInvalidEmail']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrustedContactInvalidPhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustedContactInvalidPhoneNumber'] = ResolversParentTypes['TrustedContactInvalidPhoneNumber']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrustedContactNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustedContactNotFoundException'] = ResolversParentTypes['TrustedContactNotFoundException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export interface UsStateNameScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['USStateName'], any> {
  name: 'USStateName';
}

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UnableToCancelCheckErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnableToCancelCheckError'] = ResolversParentTypes['UnableToCancelCheckError']> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnauthenticatedSaveUploadUrlResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnauthenticatedSaveUploadUrlResult'] = ResolversParentTypes['UnauthenticatedSaveUploadUrlResult']> = {
  __resolveType: TypeResolveFn<'DocumentUploads' | 'UploadSaveError', ParentType, ContextType>;
};

export type UnauthorizedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnauthorizedException'] = ResolversParentTypes['UnauthorizedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnauthorizedModifyLockedContentErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnauthorizedModifyLockedContentError'] = ResolversParentTypes['UnauthorizedModifyLockedContentError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnblockDeviceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnblockDeviceResult'] = ResolversParentTypes['UnblockDeviceResult']> = {
  __resolveType: TypeResolveFn<'Device' | 'DeviceNotFoundException', ParentType, ContextType>;
};

export type UnlinkOidcCredentialsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnlinkOidcCredentialsResult'] = ResolversParentTypes['UnlinkOidcCredentialsResult']> = {
  __resolveType: TypeResolveFn<'OidcCredentialsNotFoundException' | 'UnlinkOidcCredentialsSuccess', ParentType, ContextType>;
};

export type UnlinkOidcCredentialsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnlinkOidcCredentialsSuccess'] = ResolversParentTypes['UnlinkOidcCredentialsSuccess']> = {
  email?: Resolver<Maybe<ResolversTypes['EmailAddress']>, ParentType, ContextType>;
  oidcProvider?: Resolver<Maybe<ResolversTypes['OidcProvider']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnlockBankCardPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnlockBankCardPayload'] = ResolversParentTypes['UnlockBankCardPayload']> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnmarkLearnContentAsHelpfulResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnmarkLearnContentAsHelpfulResult'] = ResolversParentTypes['UnmarkLearnContentAsHelpfulResult']> = {
  __resolveType: TypeResolveFn<'RecordDoesNotExistError' | 'UpdateLearnContentHelpfulnessResult', ParentType, ContextType>;
};

export type UnmetRequirementsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnmetRequirementsException'] = ResolversParentTypes['UnmetRequirementsException']> = {
  requirements?: Resolver<Array<ResolversTypes['OnboardingRequirement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnrecoverableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnrecoverableError'] = ResolversParentTypes['UnrecoverableError']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnrecoverableLinkedAccountErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnrecoverableLinkedAccountError'] = ResolversParentTypes['UnrecoverableLinkedAccountError']> = {
  linkedAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnsubscribeUserFromTierResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnsubscribeUserFromTierResult'] = ResolversParentTypes['UnsubscribeUserFromTierResult']> = {
  __resolveType: TypeResolveFn<'TierDowngradeActionRequired' | 'TierSubscriptionUnsubscribed', ParentType, ContextType>;
};

export type UnverifiedBeneficiarySsnAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnverifiedBeneficiarySsnAlert'] = ResolversParentTypes['UnverifiedBeneficiarySsnAlert']> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>;
  beneficiaryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnverifiedBeneficiarySsnAlertItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnverifiedBeneficiarySsnAlertItem'] = ResolversParentTypes['UnverifiedBeneficiarySsnAlertItem']> = {
  beneficiary?: Resolver<ResolversTypes['Beneficiary'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAccountPortfolioResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAccountPortfolioResponse'] = ResolversParentTypes['UpdateAccountPortfolioResponse']> = {
  __resolveType: TypeResolveFn<'InvalidActionOnAccount' | 'InvestmentAccount' | 'InvestmentAccountNotFoundException' | 'PortfolioNotFoundException' | 'PortfolioUpdateFailedException', ParentType, ContextType>;
};

export type UpdateAttributionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAttributionResult'] = ResolversParentTypes['UpdateAttributionResult']> = {
  __resolveType: TypeResolveFn<'InvalidConversionIdentifierException' | 'InvalidSourceAttributesException' | 'NoProspectRecord' | 'RegistrationFunnel', ParentType, ContextType>;
};

export type UpdateAuthEmailResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAuthEmailResult'] = ResolversParentTypes['UpdateAuthEmailResult']> = {
  __resolveType: TypeResolveFn<'AuthProfile' | 'ExistingEmailVerifiedException', ParentType, ContextType>;
};

export type UpdateAuthPhoneNumberResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAuthPhoneNumberResult'] = ResolversParentTypes['UpdateAuthPhoneNumberResult']> = {
  __resolveType: TypeResolveFn<'AuthProfile' | 'InvalidPhoneNumberException', ParentType, ContextType>;
};

export type UpdateBankAccountGoalPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBankAccountGoalPayload'] = ResolversParentTypes['UpdateBankAccountGoalPayload']> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBankAccountGoalResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBankAccountGoalResult'] = ResolversParentTypes['UpdateBankAccountGoalResult']> = {
  __resolveType: TypeResolveFn<'UpdateBankAccountGoalPayload', ParentType, ContextType>;
};

export type UpdateBankCardPinPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBankCardPinPayload'] = ResolversParentTypes['UpdateBankCardPinPayload']> = {
  bankCard?: Resolver<Maybe<ResolversTypes['BankCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBeneficiaryInfoResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBeneficiaryInfoResult'] = ResolversParentTypes['UpdateBeneficiaryInfoResult']> = {
  __resolveType: TypeResolveFn<'Beneficiary' | 'BeneficiaryNotFoundException' | 'InternalErrorException' | 'InvalidAddressException' | 'InvalidEmailException' | 'InvalidPhoneException', ParentType, ContextType>;
};

export type UpdateBenefitStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBenefitStatusResponse'] = ResolversParentTypes['UpdateBenefitStatusResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCredentialsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCredentialsResult'] = ResolversParentTypes['UpdateCredentialsResult']> = {
  __resolveType: TypeResolveFn<'BlockedEmailDomainException' | 'Credentials' | 'EmailTakenException' | 'UserCredentialsNotFoundException', ParentType, ContextType>;
};

export type UpdateDelegateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDelegateResult'] = ResolversParentTypes['UpdateDelegateResult']> = {
  __resolveType: TypeResolveFn<'DelegateDefinition', ParentType, ContextType>;
};

export type UpdateElapsedTimeForLearnQuizResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateElapsedTimeForLearnQuizResult'] = ResolversParentTypes['UpdateElapsedTimeForLearnQuizResult']> = {
  __resolveType: TypeResolveFn<'LearnContentElapsedMillisecondsUpdatedResult' | 'RecordDoesNotExistError', ParentType, ContextType>;
};

export type UpdateLearnContentHelpfulnessResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateLearnContentHelpfulnessResult'] = ResolversParentTypes['UpdateLearnContentHelpfulnessResult']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isHelpful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateLearnProgressResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateLearnProgressResult'] = ResolversParentTypes['UpdateLearnProgressResult']> = {
  __resolveType: TypeResolveFn<'LearnProgressUpdatedResult' | 'RecordDoesNotExistError', ParentType, ContextType>;
};

export type UpdateMessageFailedResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMessageFailed'] = ResolversParentTypes['UpdateMessageFailed']> = {
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMessageIgnoredResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMessageIgnored'] = ResolversParentTypes['UpdateMessageIgnored']> = {
  requestId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMessageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMessageResult'] = ResolversParentTypes['UpdateMessageResult']> = {
  __resolveType: TypeResolveFn<'AlertMessage' | 'LegacyAlertDismissalSuccess' | 'NotificationMessage' | 'UpdateMessageIgnored', ParentType, ContextType>;
};

export type UpdateMessagesFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMessagesFailure'] = ResolversParentTypes['UpdateMessagesFailure']> = {
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMoneyManagerAllocationsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyManagerAllocationsResult'] = ResolversParentTypes['UpdateMoneyManagerAllocationsResult']> = {
  __resolveType: TypeResolveFn<'AcornsValidationError' | 'AllocationAmountsSumExceedingMaxError' | 'InvalidSingleRuleIdError' | 'MismatchedDistributionUnitsError' | 'MissingValidRulesetError' | 'NonUniqueSingleRuleIdsError' | 'UpdateMoneyManagerAllocationsSuccess', ParentType, ContextType>;
};

export type UpdateMoneyManagerAllocationsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyManagerAllocationsSuccess'] = ResolversParentTypes['UpdateMoneyManagerAllocationsSuccess']> = {
  categories?: Resolver<Array<ResolversTypes['MoneyManagerCategory']>, ParentType, ContextType>;
  rules?: Resolver<Array<ResolversTypes['MoneyRulesRule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMoneyManagerAutomationTargetResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyManagerAutomationTargetResult'] = ResolversParentTypes['UpdateMoneyManagerAutomationTargetResult']> = {
  __resolveType: TypeResolveFn<'MoneyManagerInputError' | 'UpdateMoneyManagerAutomationTargetSuccess', ParentType, ContextType>;
};

export type UpdateMoneyManagerAutomationTargetSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyManagerAutomationTargetSuccess'] = ResolversParentTypes['UpdateMoneyManagerAutomationTargetSuccess']> = {
  automationTargets?: Resolver<Array<Maybe<ResolversTypes['MoneyManagerAutomationTarget']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMoneyManagerSettingsFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyManagerSettingsFailure'] = ResolversParentTypes['UpdateMoneyManagerSettingsFailure']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMoneyManagerSettingsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyManagerSettingsResult'] = ResolversParentTypes['UpdateMoneyManagerSettingsResult']> = {
  __resolveType: TypeResolveFn<'UpdateMoneyManagerSettingsFailure' | 'UpdateMoneyManagerSettingsSuccess', ParentType, ContextType>;
};

export type UpdateMoneyManagerSettingsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyManagerSettingsSuccess'] = ResolversParentTypes['UpdateMoneyManagerSettingsSuccess']> = {
  settings?: Resolver<Maybe<ResolversTypes['MoneyManagerSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMoneyRulesSourceSettingsFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyRulesSourceSettingsFailure'] = ResolversParentTypes['UpdateMoneyRulesSourceSettingsFailure']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMoneyRulesSourceSettingsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyRulesSourceSettingsResult'] = ResolversParentTypes['UpdateMoneyRulesSourceSettingsResult']> = {
  __resolveType: TypeResolveFn<'UpdateMoneyRulesSourceSettingsFailure' | 'UpdateMoneyRulesSourceSettingsSuccess', ParentType, ContextType>;
};

export type UpdateMoneyRulesSourceSettingsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMoneyRulesSourceSettingsSuccess'] = ResolversParentTypes['UpdateMoneyRulesSourceSettingsSuccess']> = {
  settings?: Resolver<Maybe<ResolversTypes['MoneyRulesSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateOauthAppResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOauthAppResult'] = ResolversParentTypes['UpdateOauthAppResult']> = {
  __resolveType: TypeResolveFn<'OauthApp' | 'OauthAppNotFoundException', ParentType, ContextType>;
};

export type UpdatePortfolioSecuritiesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePortfolioSecuritiesResult'] = ResolversParentTypes['UpdatePortfolioSecuritiesResult']> = {
  __resolveType: TypeResolveFn<'CustomerAgreementRequiredException' | 'InvalidAllocationPercentError' | 'InvalidSecurityError' | 'InvalidSecurityForAllocationError' | 'InvestmentAccount' | 'LiquidationUnavailableError' | 'NegativeSecurityPercentError' | 'PortfolioSecurityLimitReached', ParentType, ContextType>;
};

export type UpdatePromoCodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePromoCodeResult'] = ResolversParentTypes['UpdatePromoCodeResult']> = {
  __resolveType: TypeResolveFn<'DuplicatePromoCodeError' | 'PromoCode' | 'PromoCodeFieldLengthError', ParentType, ContextType>;
};

export type UpdatePromotedCampaignsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePromotedCampaignsResult'] = ResolversParentTypes['UpdatePromotedCampaignsResult']> = {
  __resolveType: TypeResolveFn<'PromotedCampaigns', ParentType, ContextType>;
};

export type UpdateReferralCampaignResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateReferralCampaignResult'] = ResolversParentTypes['UpdateReferralCampaignResult']> = {
  __resolveType: TypeResolveFn<'ReferralCampaignV2', ParentType, ContextType>;
};

export type UpdateReferralPayoutResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateReferralPayoutResult'] = ResolversParentTypes['UpdateReferralPayoutResult']> = {
  __resolveType: TypeResolveFn<'ReferralPayout', ParentType, ContextType>;
};

export type UpdateReferralRelationshipResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateReferralRelationshipResult'] = ResolversParentTypes['UpdateReferralRelationshipResult']> = {
  __resolveType: TypeResolveFn<'ReferralRelationship', ParentType, ContextType>;
};

export type UpdateReferralRewardErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateReferralRewardError'] = ResolversParentTypes['UpdateReferralRewardError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateReferralRewardResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateReferralRewardResponse'] = ResolversParentTypes['UpdateReferralRewardResponse']> = {
  __resolveType: TypeResolveFn<'ReferralRewardSummary' | 'UpdateReferralRewardError', ParentType, ContextType>;
};

export type UpdateScopeExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateScopeException'] = ResolversParentTypes['UpdateScopeException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateScopeResult'] = ResolversParentTypes['UpdateScopeResult']> = {
  __resolveType: TypeResolveFn<'Scope' | 'UpdateScopeException', ParentType, ContextType>;
};

export type UpdateTrustedContactResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTrustedContactResult'] = ResolversParentTypes['UpdateTrustedContactResult']> = {
  __resolveType: TypeResolveFn<'InternalErrorException' | 'TrustedContact' | 'TrustedContactAlreadyExistsException' | 'TrustedContactInvalidEmail' | 'TrustedContactInvalidPhoneNumber' | 'TrustedContactNotFoundException', ParentType, ContextType>;
};

export type UpdateUserProfileAndAutomationTargetResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserProfileAndAutomationTargetResult'] = ResolversParentTypes['UpdateUserProfileAndAutomationTargetResult']> = {
  __resolveType: TypeResolveFn<'UpdateUserProfileAndAutomationTargetSuccess', ParentType, ContextType>;
};

export type UpdateUserProfileAndAutomationTargetSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserProfileAndAutomationTargetSuccess'] = ResolversParentTypes['UpdateUserProfileAndAutomationTargetSuccess']> = {
  annualIncome?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  automationTargets?: Resolver<Array<ResolversTypes['MoneyManagerAutomationTarget']>, ParentType, ContextType>;
  cascadeObjectives?: Resolver<Array<ResolversTypes['MoneyManagerCascadeObjective']>, ParentType, ContextType>;
  updatedTargetTypes?: Resolver<Array<ResolversTypes['MoneyManagerAutomationTargetType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserSwitchStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserSwitchState'] = ResolversParentTypes['UpdateUserSwitchState']> = {
  __resolveType: TypeResolveFn<'UpdateUserSwitchStateFailure' | 'UpdateUserSwitchStatePayload', ParentType, ContextType>;
};

export type UpdateUserSwitchStateFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserSwitchStateFailure'] = ResolversParentTypes['UpdateUserSwitchStateFailure']> = {
  failureMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserSwitchStatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserSwitchStatePayload'] = ResolversParentTypes['UpdateUserSwitchStatePayload']> = {
  switchState?: Resolver<ResolversTypes['SwitchState'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateVerificationProfileResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateVerificationProfileResult'] = ResolversParentTypes['UpdateVerificationProfileResult']> = {
  __resolveType: TypeResolveFn<'VerificationProfile', ParentType, ContextType>;
};

export type UpgradeAuthenticationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpgradeAuthenticationResult'] = ResolversParentTypes['UpgradeAuthenticationResult']> = {
  __resolveType: TypeResolveFn<'AuthSession' | 'AuthenticationAlreadyUpgradedException' | 'UserCredentialsNotFoundException', ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UploadCheckPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadCheckPayload'] = ResolversParentTypes['UploadCheckPayload']> = {
  sessionToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadDoesNotExistResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadDoesNotExist'] = ResolversParentTypes['UploadDoesNotExist']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadDoesNotExistErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadDoesNotExistError'] = ResolversParentTypes['UploadDoesNotExistError']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUuid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFailedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFailedError'] = ResolversParentTypes['UploadFailedError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadOauthAppImageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadOauthAppImageResult'] = ResolversParentTypes['UploadOauthAppImageResult']> = {
  __resolveType: TypeResolveFn<'InvalidContentTypeException' | 'OauthAppImageUpload', ParentType, ContextType>;
};

export type UploadSaveErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSaveError'] = ResolversParentTypes['UploadSaveError']> = {
  uploadExceptions?: Resolver<Array<ResolversTypes['UploadSaveExceptions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadSaveExceptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSaveExceptions'] = ResolversParentTypes['UploadSaveExceptions']> = {
  __resolveType: TypeResolveFn<'FileDoesNotExistError' | 'UploadDoesNotExistError', ParentType, ContextType>;
};

export type UploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadUrl'] = ResolversParentTypes['UploadUrl']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  policy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadUuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  xAmzAlgorithm?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  xAmzCredential?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  xAmzDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  xAmzSecurityToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  xAmzSignature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpsertUserMatchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertUserMatchResult'] = ResolversParentTypes['UpsertUserMatchResult']> = {
  __resolveType: TypeResolveFn<'InternalErrorException' | 'UserMatch', ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alerts?: Resolver<Maybe<Array<ResolversTypes['UserAlert']>>, ParentType, ContextType>;
  allocationProfileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employedAffiliatedWithBrokerDealer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  employer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundingSource?: Resolver<Maybe<ResolversTypes['FundingSource']>, ParentType, ContextType>;
  fundingSourceChangeRequiresApproval?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  investmentAccounts?: Resolver<Maybe<Array<ResolversTypes['InvestmentAccount']>>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pinCreated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  registrationComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  registrationCompletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  shareholderOrDirector?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['USStateName']>, ParentType, ContextType>;
  subjectToBackupWithholding?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uploads?: Resolver<Array<ResolversTypes['UserUpload']>, ParentType, ContextType>;
  usCitizen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAlert'] = ResolversParentTypes['UserAlert']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAlertsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAlertsItem'] = ResolversParentTypes['UserAlertsItem']> = {
  __resolveType: TypeResolveFn<'AddressDocumentRequestedUserAlert' | 'BankDocumentRequestedUserAlert' | 'IdentityDocumentRequestedUserAlert' | 'InsufficientFundsUserAlert' | 'InvestmentsPausedUserAlert' | 'LinkedAccountAlert' | 'MiscDocumentRequestedUserAlert' | 'MissingSsnBeneficiaryAlertItem' | 'NoFundingSourceUserAlert' | 'RdvRequiredUserAlert' | 'RelinkLinkedAccountAlert' | 'SSNDocumentRequestedUserAlert' | 'UnverifiedBeneficiarySsnAlertItem' | 'UserAlert' | 'W9DocumentRequestedUserAlert', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type UserAlertsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAlertsResponse'] = ResolversParentTypes['UserAlertsResponse']> = {
  __resolveType: TypeResolveFn<'AddressDocumentRequestedUserAlert' | 'BankDocumentRequestedUserAlert' | 'IdentityDocumentRequestedUserAlert' | 'InsufficientFundsUserAlert' | 'InvestmentsPausedUserAlert' | 'MiscDocumentRequestedUserAlert' | 'NoFundingSourceUserAlert' | 'RdvRequiredUserAlert' | 'SSNDocumentRequestedUserAlert' | 'UserAlert' | 'W9DocumentRequestedUserAlert', ParentType, ContextType>;
};

export type UserCardLockedSpendAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCardLockedSpendAlert'] = ResolversParentTypes['UserCardLockedSpendAlert']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserClosedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserClosedException'] = ResolversParentTypes['UserClosedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCohortsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCohorts'] = ResolversParentTypes['UserCohorts']> = {
  cohorts?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCredentials'] = ResolversParentTypes['UserCredentials']> = {
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CredentialsType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCredentialsNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCredentialsNotFoundException'] = ResolversParentTypes['UserCredentialsNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserExistsExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserExistsException'] = ResolversParentTypes['UserExistsException']> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInvestmentAccountReopenCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInvestmentAccountReopenCheck'] = ResolversParentTypes['UserInvestmentAccountReopenCheck']> = {
  accountReopenRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  investmentAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reopenCheckType?: Resolver<ResolversTypes['InvestmentAccountReopenCheck'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userUuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLockedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLockedException'] = ResolversParentTypes['UserLockedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMatch'] = ResolversParentTypes['UserMatch']> = {
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  externalMetadata?: Resolver<Maybe<ResolversTypes['ExternalMetadata']>, ParentType, ContextType>;
  externalSource?: Resolver<ResolversTypes['ExternalUserSource'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  matchedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  matchedCriteria?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  matchedStatus?: Resolver<ResolversTypes['UserMatchStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotFound'] = ResolversParentTypes['UserNotFound']> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotFoundExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotFoundException'] = ResolversParentTypes['UserNotFoundException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotUsResidentExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotUSResidentException'] = ResolversParentTypes['UserNotUSResidentException']> = {
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotVerifiedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotVerifiedException'] = ResolversParentTypes['UserNotVerifiedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPartnerStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPartnerStatusResponse'] = ResolversParentTypes['UserPartnerStatusResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserReopenLockedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserReopenLockedException'] = ResolversParentTypes['UserReopenLockedException']> = {
  lockedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserReopenSuspendedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserReopenSuspendedException'] = ResolversParentTypes['UserReopenSuspendedException']> = {
  suspendedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  suspendedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserStatus'] = ResolversParentTypes['UserStatus']> = {
  age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  closed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  closedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  registrationComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  registrationCompleteAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  verifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSuspendedExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSuspendedException'] = ResolversParentTypes['UserSuspendedException']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suspendedToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suspensionReasonValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSuspendedUploadTokenLengthErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSuspendedUploadTokenLengthError'] = ResolversParentTypes['UserSuspendedUploadTokenLengthError']> = {
  length?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSuspendedUploadTokenValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSuspendedUploadTokenValidation'] = ResolversParentTypes['UserSuspendedUploadTokenValidation']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSwitchResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSwitch'] = ResolversParentTypes['UserSwitch']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SwitchStatus'], ParentType, ContextType>;
  switchType?: Resolver<ResolversTypes['SwitchType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  vendorSwitchId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserToken'] = ResolversParentTypes['UserToken']> = {
  consumedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  oauthAppClientId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  oauthAppId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userScopes?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  userTokenId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserUpload'] = ResolversParentTypes['UserUpload']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  documentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_V2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['User_v2'] = ResolversParentTypes['User_v2']> = {
  closedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidPoliciesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidPolicies'] = ResolversParentTypes['ValidPolicies']> = {
  policies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Policy']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateCredentialsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateCredentialsResult'] = ResolversParentTypes['ValidateCredentialsResult']> = {
  __resolveType: TypeResolveFn<'AuthSession' | 'DeviceBlockedException' | 'InvalidCredentialsException' | 'LoginRateLimitedException' | 'OidcCredentialsNotFoundException' | 'UserSuspendedException' | 'ValidateCredentialsSuccess', ParentType, ContextType>;
};

export type ValidateCredentialsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateCredentialsSuccess'] = ResolversParentTypes['ValidateCredentialsSuccess']> = {
  authenticators?: Resolver<Maybe<Array<ResolversTypes['Authenticator']>>, ParentType, ContextType>;
  mfaToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidatePasswordResetTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidatePasswordResetTokenResult'] = ResolversParentTypes['ValidatePasswordResetTokenResult']> = {
  __resolveType: TypeResolveFn<'InvalidPasswordResetTokenException' | 'ValidatePasswordResetTokenSuccess', ParentType, ContextType>;
};

export type ValidatePasswordResetTokenSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidatePasswordResetTokenSuccess'] = ResolversParentTypes['ValidatePasswordResetTokenSuccess']> = {
  displaySsnField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateUserSuspendedUploadTokenResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateUserSuspendedUploadTokenResult'] = ResolversParentTypes['ValidateUserSuspendedUploadTokenResult']> = {
  __resolveType: TypeResolveFn<'UserSuspendedUploadTokenLengthError' | 'UserSuspendedUploadTokenValidation', ParentType, ContextType>;
};

export type ValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidationError'] = ResolversParentTypes['ValidationError']> = {
  errorCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intentId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendAuthSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendAuthSessionResult'] = ResolversParentTypes['VendAuthSessionResult']> = {
  __resolveType: TypeResolveFn<'AuthChallengeAnswerAttemptsExhaustedException' | 'AuthChallengeAnswerIncorrectException' | 'AuthChallengeExpiredException' | 'AuthSession' | 'ChallengeRateExceededException' | 'DeviceBlockedException' | 'UserSuspendedException', ParentType, ContextType>;
};

export type VendorBillingInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorBillingInfo'] = ResolversParentTypes['VendorBillingInfo']> = {
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorCustomerAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorCustomerAccount'] = ResolversParentTypes['VendorCustomerAccount']> = {
  billTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dunningCampaignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorIntegrationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorIntegrationError'] = ResolversParentTypes['VendorIntegrationError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorRefundInvoiceErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorRefundInvoiceError'] = ResolversParentTypes['VendorRefundInvoiceError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationDetails'] = ResolversParentTypes['VerificationDetails']> = {
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  response?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationProfile'] = ResolversParentTypes['VerificationProfile']> = {
  deviceSessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentVerification?: Resolver<Maybe<ResolversTypes['DocumentVerification']>, ParentType, ContextType>;
  eCBSV?: Resolver<ResolversTypes['Ecbsv'], ParentType, ContextType>;
  eCBSVConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyCheckPaymentRecipientAddressResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyCheckPaymentRecipientAddressResult'] = ResolversParentTypes['VerifyCheckPaymentRecipientAddressResult']> = {
  __resolveType: TypeResolveFn<'AuthorizationError' | 'CheckPaymentRecipientAddressType' | 'InvalidAddressError', ParentType, ContextType>;
};

export type VerifyDeviceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyDeviceResult'] = ResolversParentTypes['VerifyDeviceResult']> = {
  __resolveType: TypeResolveFn<'DeviceNotFoundException' | 'EmailAuthChallenge' | 'SMSAuthChallenge', ParentType, ContextType>;
};

export type VerifyIdentityByDocumentsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyIdentityByDocumentsResult'] = ResolversParentTypes['VerifyIdentityByDocumentsResult']> = {
  __resolveType: TypeResolveFn<'DocumentVerification', ParentType, ContextType>;
};

export type VerifyPasswordsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyPasswordsResult'] = ResolversParentTypes['VerifyPasswordsResult']> = {
  __resolveType: TypeResolveFn<'IncorrectOldPasswordException' | 'InvalidPasswordException' | 'SamePasswordsException' | 'UnauthorizedException' | 'VerifyPasswordsSuccess', ParentType, ContextType>;
};

export type VerifyPasswordsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyPasswordsSuccess'] = ResolversParentTypes['VerifyPasswordsSuccess']> = {
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyPromoCodeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyPromoCodeResponse'] = ResolversParentTypes['VerifyPromoCodeResponse']> = {
  __resolveType: TypeResolveFn<'InvalidPromoCodeError' | 'PromoCode', ParentType, ContextType>;
};

export type VerifyRdvsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyRdvsResult'] = ResolversParentTypes['VerifyRdvsResult']> = {
  __resolveType: TypeResolveFn<'AccountFrozen' | 'FundingSourceAccount' | 'IncorrectRdvAmounts' | 'StoredRdvDepositsInvalid' | 'StoredRdvDepositsMissing', ParentType, ContextType>;
};

export type VersionMismatchExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['VersionMismatchException'] = ResolversParentTypes['VersionMismatchException']> = {
  latestVersion?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewedLearnContentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewedLearnContentResult'] = ResolversParentTypes['ViewedLearnContentResult']> = {
  contentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface VoidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Void'], any> {
  name: 'Void';
}

export type W9DocumentRequestedUserAlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['W9DocumentRequestedUserAlert'] = ResolversParentTypes['W9DocumentRequestedUserAlert']> = {
  requestedDocumentType?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['Waiver'] = ResolversParentTypes['Waiver']> = {
  __resolveType: TypeResolveFn<'MightyOakCardWaiver' | 'PromotionalWaiver' | 'ProvisionalWaiver', ParentType, ContextType>;
};

export type WaiverCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['WaiverCoupon'] = ResolversParentTypes['WaiverCoupon']> = {
  couponId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discountAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  monthsToWaive?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  waiverType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaiverCreationExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['WaiverCreationException'] = ResolversParentTypes['WaiverCreationException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaiverDeletionExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['WaiverDeletionException'] = ResolversParentTypes['WaiverDeletionException']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhooksResolvers<ContextType = any, ParentType extends ResolversParentTypes['Webhooks'] = ResolversParentTypes['Webhooks']> = {
  plaid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebviewLinkSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebviewLinkSession'] = ResolversParentTypes['WebviewLinkSession']> = {
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Withdrawal'] = ResolversParentTypes['Withdrawal']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  presentableWithdrawalStatus?: Resolver<ResolversTypes['PresentableWithdrawalStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithholdingDefaultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithholdingDefaults'] = ResolversParentTypes['WithholdingDefaults']> = {
  federalWithholdingPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  showFederalWithholdingField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showStateWithholdingField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  stateWithholdingPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithholdingEstimatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithholdingEstimates'] = ResolversParentTypes['WithholdingEstimates']> = {
  estimatedCustomerAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  estimatedFederalWithholdingAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  estimatedStateWithholdingAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  estimatedTaxableEarnings?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  estimatedTotalWithholdingAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YearLaterReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['YearLaterReport'] = ResolversParentTypes['YearLaterReport']> = {
  accountBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  accountCreationDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountPerformance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstDepositAmountForYear?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  firstDepositDateForYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recurringContributionAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  recurringContributionFrequency?: Resolver<Maybe<ResolversTypes['InvestmentFrequency']>, ParentType, ContextType>;
  totalDeposits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDepositsForYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDividends?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalNetReturns?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalWithdrawals?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  userAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EndChatSessionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['endChatSessionResponse'] = ResolversParentTypes['endChatSessionResponse']> = {
  __resolveType: TypeResolveFn<'ChatSession' | 'ChatSessionNotFound', ParentType, ContextType>;
};

export type HelpcenterBannerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['helpcenterBannerResponse'] = ResolversParentTypes['helpcenterBannerResponse']> = {
  __resolveType: TypeResolveFn<'HelpcenterBannerContent' | 'HelpcenterBannerErrors', ParentType, ContextType>;
};

export type Jobs_ArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['jobs_Article'] = ResolversParentTypes['jobs_Article']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cta?: Resolver<Maybe<ResolversTypes['Cta']>, ParentType, ContextType>;
  eyebrow?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Jobs_EducationResolvers<ContextType = any, ParentType extends ResolversParentTypes['jobs_Education'] = ResolversParentTypes['jobs_Education']> = {
  articles?: Resolver<Array<ResolversTypes['jobs_Article']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Jobs_OfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['jobs_Offer'] = ResolversParentTypes['jobs_Offer']> = {
  companyLogo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['JobLocation'], ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['jobs_OfferSalary']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Jobs_OfferConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['jobs_OfferConnection'] = ResolversParentTypes['jobs_OfferConnection']> = {
  edges?: Resolver<Array<ResolversTypes['jobs_OfferEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Jobs_OfferEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['jobs_OfferEdge'] = ResolversParentTypes['jobs_OfferEdge']> = {
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['jobs_Offer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Jobs_OfferSalaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['jobs_OfferSalary'] = ResolversParentTypes['jobs_OfferSalary']> = {
  interval?: Resolver<ResolversTypes['SalaryInterval'], ParentType, ContextType>;
  maxValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RateChatMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['rateChatMessageResponse'] = ResolversParentTypes['rateChatMessageResponse']> = {
  __resolveType: TypeResolveFn<'ChatHistoryMessage' | 'ChatHistoryMessageCustomFeedbackOutOfBounds' | 'ChatHistoryMessageNotFound' | 'ChatHistoryMessageNotRatable' | 'ChatHistoryMessageRatingFailed' | 'ChatHistoryMessageRatingOutOfBounds', ParentType, ContextType>;
};

export type StartChatSessionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['startChatSessionResponse'] = ResolversParentTypes['startChatSessionResponse']> = {
  __resolveType: TypeResolveFn<'ChatSession' | 'ChatUnavailableError', ParentType, ContextType>;
};

export type Suitability_PortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['suitability_Portfolio'] = ResolversParentTypes['suitability_Portfolio']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Suitability_SuitabilityAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['suitability_SuitabilityAnswer'] = ResolversParentTypes['suitability_SuitabilityAnswer']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Suitability_SuitabilityQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['suitability_SuitabilityQuestion'] = ResolversParentTypes['suitability_SuitabilityQuestion']> = {
  defaultAnswer?: Resolver<Maybe<ResolversTypes['suitability_SuitabilityAnswer']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  possibleAnswers?: Resolver<Array<ResolversTypes['suitability_SuitabilityAnswer']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Suitability_SuitabilityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['suitability_SuitabilityResponse'] = ResolversParentTypes['suitability_SuitabilityResponse']> = {
  answer?: Resolver<Maybe<ResolversTypes['suitability_SuitabilityAnswer']>, ParentType, ContextType>;
  question?: Resolver<ResolversTypes['suitability_SuitabilityQuestion'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Suitability_UpdateSuitabilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['suitability_UpdateSuitabilityResult'] = ResolversParentTypes['suitability_UpdateSuitabilityResult']> = {
  recommendedPortfolio?: Resolver<Maybe<ResolversTypes['suitability_Portfolio']>, ParentType, ContextType>;
  suitabilityResponses?: Resolver<Array<ResolversTypes['suitability_SuitabilityResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserWinbackErrorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userWinbackErrors'] = ResolversParentTypes['userWinbackErrors']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserWinbackScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['userWinbackScore'] = ResolversParentTypes['userWinbackScore']> = {
  churnProbability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  predictedRevenue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserWinbackScoreResResolvers<ContextType = any, ParentType extends ResolversParentTypes['userWinbackScoreRes'] = ResolversParentTypes['userWinbackScoreRes']> = {
  __resolveType: TypeResolveFn<'userWinbackErrors' | 'userWinbackScore', ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AbstractSwitch?: AbstractSwitchResolvers<ContextType>;
  AcceptDocumentResponse?: AcceptDocumentResponseResolvers<ContextType>;
  AcceptanceDocument?: AcceptanceDocumentResolvers<ContextType>;
  AcceptedDocument?: AcceptedDocumentResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  AccountAchievement?: AccountAchievementResolvers<ContextType>;
  AccountAlreadyClosedException?: AccountAlreadyClosedExceptionResolvers<ContextType>;
  AccountClosedException?: AccountClosedExceptionResolvers<ContextType>;
  AccountFrozen?: AccountFrozenResolvers<ContextType>;
  AccountNotFoundException?: AccountNotFoundExceptionResolvers<ContextType>;
  AccountNumber?: GraphQLScalarType;
  AccountPoints?: AccountPointsResolvers<ContextType>;
  AccountPointsRule?: AccountPointsRuleResolvers<ContextType>;
  AccountRequirement?: AccountRequirementResolvers<ContextType>;
  AccountRequirements?: AccountRequirementsResolvers<ContextType>;
  AccountSetupMilestones?: AccountSetupMilestonesResolvers<ContextType>;
  AccountStrengthResult?: AccountStrengthResultResolvers<ContextType>;
  AccountValue?: AccountValueResolvers<ContextType>;
  AcornsEarlyUserDetails?: AcornsEarlyUserDetailsResolvers<ContextType>;
  AcornsPdfSwitch?: AcornsPdfSwitchResolvers<ContextType>;
  AcornsValidationError?: AcornsValidationErrorResolvers<ContextType>;
  ActionCard?: ActionCardResolvers<ContextType>;
  ActionCardButton?: ActionCardButtonResolvers<ContextType>;
  ActionFeedCta?: ActionFeedCtaResolvers<ContextType>;
  ActionFeedEventResponse?: ActionFeedEventResponseResolvers<ContextType>;
  ActionScreenComponent?: ActionScreenComponentResolvers<ContextType>;
  ActionWidget?: ActionWidgetResolvers<ContextType>;
  ActivateBankCardPayload?: ActivateBankCardPayloadResolvers<ContextType>;
  ActivateOauthAppClientResult?: ActivateOauthAppClientResultResolvers<ContextType>;
  ActivateOauthAppResult?: ActivateOauthAppResultResolvers<ContextType>;
  ActiveReferralCampaignOutput?: ActiveReferralCampaignOutputResolvers<ContextType>;
  Activity?: ActivityResolvers<ContextType>;
  ActivitySummaryResponse?: ActivitySummaryResponseResolvers<ContextType>;
  AddCohortEligibilityResult?: AddCohortEligibilityResultResolvers<ContextType>;
  AddPolicyResult?: AddPolicyResultResolvers<ContextType>;
  AddPolicySuccess?: AddPolicySuccessResolvers<ContextType>;
  AddSearchTermToLearnSearchHistoryResult?: AddSearchTermToLearnSearchHistoryResultResolvers<ContextType>;
  AddSecurityToPortfolioResult?: AddSecurityToPortfolioResultResolvers<ContextType>;
  AddSelfDirectedPortfolioResult?: AddSelfDirectedPortfolioResultResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  AddressDeliverabilityAdditionalInfo?: AddressDeliverabilityAdditionalInfoResolvers<ContextType>;
  AddressDeliverabilityCorrectedAddress?: AddressDeliverabilityCorrectedAddressResolvers<ContextType>;
  AddressDeliverabilityResult?: AddressDeliverabilityResultResolvers<ContextType>;
  AddressDeliverabilityUnavailableError?: AddressDeliverabilityUnavailableErrorResolvers<ContextType>;
  AddressDeliverabilityVerificationError?: AddressDeliverabilityVerificationErrorResolvers<ContextType>;
  AddressDeliverabilityVerified?: AddressDeliverabilityVerifiedResolvers<ContextType>;
  AddressDocumentRequestedUserAlert?: AddressDocumentRequestedUserAlertResolvers<ContextType>;
  AddressVerification?: AddressVerificationResolvers<ContextType>;
  Advocate?: AdvocateResolvers<ContextType>;
  AdvocateFriendsStatuses?: AdvocateFriendsStatusesResolvers<ContextType>;
  AdvocateV2?: AdvocateV2Resolvers<ContextType>;
  Alert?: AlertResolvers<ContextType>;
  AlertHubBeneficiaryAlert?: AlertHubBeneficiaryAlertResolvers<ContextType>;
  AlertMessage?: AlertMessageResolvers<ContextType>;
  AllAccountHistorySummary?: AllAccountHistorySummaryResolvers<ContextType>;
  AllChatHistoryMessages?: AllChatHistoryMessagesResolvers<ContextType>;
  AllCheckPaymentsResult?: AllCheckPaymentsResultResolvers<ContextType>;
  AllocationAmountsSumExceedingMaxError?: AllocationAmountsSumExceedingMaxErrorResolvers<ContextType>;
  Amount?: GraphQLScalarType;
  AnswerChallengeResult?: AnswerChallengeResultResolvers<ContextType>;
  AnswerChallengeSuccess?: AnswerChallengeSuccessResolvers<ContextType>;
  AnswerLearnQuizQuestionResult?: AnswerLearnQuizQuestionResultResolvers<ContextType>;
  ApplyPromoCodeResult?: ApplyPromoCodeResultResolvers<ContextType>;
  ApplyPromotionResult?: ApplyPromotionResultResolvers<ContextType>;
  ApplyPromotionalWaiverResult?: ApplyPromotionalWaiverResultResolvers<ContextType>;
  ApplyProvisionalWaiverResult?: ApplyProvisionalWaiverResultResolvers<ContextType>;
  ArchiveInvalidSmartDepositRecordsResult?: ArchiveInvalidSmartDepositRecordsResultResolvers<ContextType>;
  AsyncLinkSessionResult?: AsyncLinkSessionResultResolvers<ContextType>;
  AuthAlert?: AuthAlertResolvers<ContextType>;
  AuthChallenge?: AuthChallengeResolvers<ContextType>;
  AuthChallengeAnswerAttemptsExhaustedException?: AuthChallengeAnswerAttemptsExhaustedExceptionResolvers<ContextType>;
  AuthChallengeAnswerIncorrectException?: AuthChallengeAnswerIncorrectExceptionResolvers<ContextType>;
  AuthChallengeExpiredException?: AuthChallengeExpiredExceptionResolvers<ContextType>;
  AuthProfile?: AuthProfileResolvers<ContextType>;
  AuthProfileAlreadyExistsException?: AuthProfileAlreadyExistsExceptionResolvers<ContextType>;
  AuthProfileNotFoundException?: AuthProfileNotFoundExceptionResolvers<ContextType>;
  AuthSession?: AuthSessionResolvers<ContextType>;
  AuthTokenNotFoundException?: AuthTokenNotFoundExceptionResolvers<ContextType>;
  AuthenticateForFeeNegotiationResult?: AuthenticateForFeeNegotiationResultResolvers<ContextType>;
  AuthenticateForFeeNegotiationStatus?: AuthenticateForFeeNegotiationStatusResolvers<ContextType>;
  AuthenticateNegotiationStatusResult?: AuthenticateNegotiationStatusResultResolvers<ContextType>;
  AuthenticateResult?: AuthenticateResultResolvers<ContextType>;
  AuthenticationAlreadyUpgradedException?: AuthenticationAlreadyUpgradedExceptionResolvers<ContextType>;
  Authenticator?: AuthenticatorResolvers<ContextType>;
  AuthenticatorAlreadyDefaultException?: AuthenticatorAlreadyDefaultExceptionResolvers<ContextType>;
  AuthenticatorInfo?: AuthenticatorInfoResolvers<ContextType>;
  AuthenticatorNotFoundException?: AuthenticatorNotFoundExceptionResolvers<ContextType>;
  AuthenticatorTypeAlreadyRegisteredException?: AuthenticatorTypeAlreadyRegisteredExceptionResolvers<ContextType>;
  AuthenticatorUnavailableException?: AuthenticatorUnavailableExceptionResolvers<ContextType>;
  AuthorizationError?: AuthorizationErrorResolvers<ContextType>;
  AutomationError?: AutomationErrorResolvers<ContextType>;
  BackendJobBatch?: BackendJobBatchResolvers<ContextType>;
  BackendJobBatchSummary?: BackendJobBatchSummaryResolvers<ContextType>;
  BadRequestError?: BadRequestErrorResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  BankAccountDisclosure?: BankAccountDisclosureResolvers<ContextType>;
  BankAccountGoal?: BankAccountGoalResolvers<ContextType>;
  BankAccountGoals?: BankAccountGoalsResolvers<ContextType>;
  BankAccountNotFoundError?: BankAccountNotFoundErrorResolvers<ContextType>;
  BankAccountRequirement?: BankAccountRequirementResolvers<ContextType>;
  BankAccountRequirements?: BankAccountRequirementsResolvers<ContextType>;
  BankAccountState?: BankAccountStateResolvers<ContextType>;
  BankAccountStateResult?: BankAccountStateResultResolvers<ContextType>;
  BankCard?: BankCardResolvers<ContextType>;
  BankCardOrder?: BankCardOrderResolvers<ContextType>;
  BankCardOrderAddressVerification?: BankCardOrderAddressVerificationResolvers<ContextType>;
  BankCardOrderFundingSourceVerification?: BankCardOrderFundingSourceVerificationResolvers<ContextType>;
  BankCardOrderIdentityVerification?: BankCardOrderIdentityVerificationResolvers<ContextType>;
  BankCardOrderPrefundVerification?: BankCardOrderPrefundVerificationResolvers<ContextType>;
  BankCardPanDisplayPayload?: BankCardPanDisplayPayloadResolvers<ContextType>;
  BankCardPanDisplayResult?: BankCardPanDisplayResultResolvers<ContextType>;
  BankCardPin?: GraphQLScalarType;
  BankCardProvisioningDetailsPayload?: BankCardProvisioningDetailsPayloadResolvers<ContextType>;
  BankCardProvisioningDetailsResult?: BankCardProvisioningDetailsResultResolvers<ContextType>;
  BankCardReissue?: BankCardReissueResolvers<ContextType>;
  BankCardRequest?: BankCardRequestResolvers<ContextType>;
  BankCardRequestMailingAddress?: BankCardRequestMailingAddressResolvers<ContextType>;
  BankConnection?: BankConnectionResolvers<ContextType>;
  BankDocument?: BankDocumentResolvers<ContextType>;
  BankDocumentRequestedUserAlert?: BankDocumentRequestedUserAlertResolvers<ContextType>;
  BankFee?: BankFeeResolvers<ContextType>;
  BankFeeConnection?: BankFeeConnectionResolvers<ContextType>;
  BankFeeSummary?: BankFeeSummaryResolvers<ContextType>;
  BankInterestRate?: BankInterestRateResolvers<ContextType>;
  BankInterestRates?: BankInterestRatesResolvers<ContextType>;
  BankInterestRatesResult?: BankInterestRatesResultResolvers<ContextType>;
  BankMetadata?: BankMetadataResolvers<ContextType>;
  BankMetadataTotals?: BankMetadataTotalsResolvers<ContextType>;
  BankServiceFailure?: BankServiceFailureResolvers<ContextType>;
  BankStatement?: BankStatementResolvers<ContextType>;
  BankTransaction?: BankTransactionResolvers<ContextType>;
  BankTransactionConnection?: BankTransactionConnectionResolvers<ContextType>;
  BankTransactionEdge?: BankTransactionEdgeResolvers<ContextType>;
  BankTransactionNachaInfo?: BankTransactionNachaInfoResolvers<ContextType>;
  BankingFeatureEligibility?: BankingFeatureEligibilityResolvers<ContextType>;
  BankingKyc?: BankingKycResolvers<ContextType>;
  BankingKycAddressVerification?: BankingKycAddressVerificationResolvers<ContextType>;
  BankingKycIdentityVerification?: BankingKycIdentityVerificationResolvers<ContextType>;
  BannersErrors?: BannersErrorsResolvers<ContextType>;
  BannersResponse?: BannersResponseResolvers<ContextType>;
  BasePortfolio?: BasePortfolioResolvers<ContextType>;
  BatchAddTierSubscriptions?: BatchAddTierSubscriptionsResolvers<ContextType>;
  BatchAddTierSubscriptionsResult?: BatchAddTierSubscriptionsResultResolvers<ContextType>;
  Beneficiary?: BeneficiaryResolvers<ContextType>;
  BeneficiaryAccountExistsException?: BeneficiaryAccountExistsExceptionResolvers<ContextType>;
  BeneficiaryExceedsAgeLimitException?: BeneficiaryExceedsAgeLimitExceptionResolvers<ContextType>;
  BeneficiaryNotFoundException?: BeneficiaryNotFoundExceptionResolvers<ContextType>;
  BenefitPartnerResponse?: BenefitPartnerResponseResolvers<ContextType>;
  BenefitProductTile?: BenefitProductTileResolvers<ContextType>;
  BenefitStatus?: BenefitStatusResolvers<ContextType>;
  BenefitTileGroup?: BenefitTileGroupResolvers<ContextType>;
  BenefitsMessage?: BenefitsMessageResolvers<ContextType>;
  BenefitsStatusResponse?: BenefitsStatusResponseResolvers<ContextType>;
  BigCurrencyAmount?: BigCurrencyAmountResolvers<ContextType>;
  BigDecimal?: GraphQLScalarType;
  BillingCycle?: BillingCycleResolvers<ContextType>;
  BillingInvoice?: BillingInvoiceResolvers<ContextType>;
  BillingProfile?: BillingProfileResolvers<ContextType>;
  BillingProfileNotFoundException?: BillingProfileNotFoundExceptionResolvers<ContextType>;
  BillingVendorError?: BillingVendorErrorResolvers<ContextType>;
  BlockDeviceResult?: BlockDeviceResultResolvers<ContextType>;
  BlockedEmailDomainException?: BlockedEmailDomainExceptionResolvers<ContextType>;
  Bundle?: BundleResolvers<ContextType>;
  CampaignHistoryConnection?: CampaignHistoryConnectionResolvers<ContextType>;
  CampaignHistoryEdge?: CampaignHistoryEdgeResolvers<ContextType>;
  CampaignV2?: CampaignV2Resolvers<ContextType>;
  CancelCheckPaymentResult?: CancelCheckPaymentResultResolvers<ContextType>;
  CancelIntentResult?: CancelIntentResultResolvers<ContextType>;
  CancelInvestmentAccountClosureRequestResult?: CancelInvestmentAccountClosureRequestResultResolvers<ContextType>;
  CancelInvestmentPayload?: CancelInvestmentPayloadResolvers<ContextType>;
  CancelInvestmentResult?: CancelInvestmentResultResolvers<ContextType>;
  CancelMoneyAssignmentResult?: CancelMoneyAssignmentResultResolvers<ContextType>;
  CancelRecurringTransferResult?: CancelRecurringTransferResultResolvers<ContextType>;
  CancelTransferPayload?: CancelTransferPayloadResolvers<ContextType>;
  CardDeliveryStatus?: CardDeliveryStatusResolvers<ContextType>;
  CardNumberMasked?: GraphQLScalarType;
  ChallengePointsEarned?: ChallengePointsEarnedResolvers<ContextType>;
  ChallengeRateExceededException?: ChallengeRateExceededExceptionResolvers<ContextType>;
  ChangeOutsideContributionAmountResult?: ChangeOutsideContributionAmountResultResolvers<ContextType>;
  ChangePasswordResult?: ChangePasswordResultResolvers<ContextType>;
  ChangePasswordSuccess?: ChangePasswordSuccessResolvers<ContextType>;
  ChatActionData?: ChatActionDataResolvers<ContextType>;
  ChatChoice?: ChatChoiceResolvers<ContextType>;
  ChatChoiceActionData?: ChatChoiceActionDataResolvers<ContextType>;
  ChatChoiceActionMetadata?: ChatChoiceActionMetadataResolvers<ContextType>;
  ChatChoiceWidget?: ChatChoiceWidgetResolvers<ContextType>;
  ChatDeeplink?: ChatDeeplinkResolvers<ContextType>;
  ChatHistoryCitation?: ChatHistoryCitationResolvers<ContextType>;
  ChatHistoryCitationV2?: ChatHistoryCitationV2Resolvers<ContextType>;
  ChatHistoryMessage?: ChatHistoryMessageResolvers<ContextType>;
  ChatHistoryMessageBody?: ChatHistoryMessageBodyResolvers<ContextType>;
  ChatHistoryMessageCustomFeedbackOutOfBounds?: ChatHistoryMessageCustomFeedbackOutOfBoundsResolvers<ContextType>;
  ChatHistoryMessageEdge?: ChatHistoryMessageEdgeResolvers<ContextType>;
  ChatHistoryMessageError?: ChatHistoryMessageErrorResolvers<ContextType>;
  ChatHistoryMessageFooter?: ChatHistoryMessageFooterResolvers<ContextType>;
  ChatHistoryMessageHeader?: ChatHistoryMessageHeaderResolvers<ContextType>;
  ChatHistoryMessageNotFound?: ChatHistoryMessageNotFoundResolvers<ContextType>;
  ChatHistoryMessageNotRatable?: ChatHistoryMessageNotRatableResolvers<ContextType>;
  ChatHistoryMessageRatingFailed?: ChatHistoryMessageRatingFailedResolvers<ContextType>;
  ChatHistoryMessageRatingOutOfBounds?: ChatHistoryMessageRatingOutOfBoundsResolvers<ContextType>;
  ChatMessageMetadata?: ChatMessageMetadataResolvers<ContextType>;
  ChatMessageSizeOutOfBounds?: ChatMessageSizeOutOfBoundsResolvers<ContextType>;
  ChatMessageStreamResponse?: ChatMessageStreamResponseResolvers<ContextType>;
  ChatRedirect?: ChatRedirectResolvers<ContextType>;
  ChatSession?: ChatSessionResolvers<ContextType>;
  ChatSessionNotFound?: ChatSessionNotFoundResolvers<ContextType>;
  ChatUnavailableError?: ChatUnavailableErrorResolvers<ContextType>;
  ChatWidget?: ChatWidgetResolvers<ContextType>;
  CheckPayment?: CheckPaymentResolvers<ContextType>;
  CheckPaymentAddress?: CheckPaymentAddressResolvers<ContextType>;
  CheckPaymentConnection?: CheckPaymentConnectionResolvers<ContextType>;
  CheckPaymentEdge?: CheckPaymentEdgeResolvers<ContextType>;
  CheckPaymentRecipient?: CheckPaymentRecipientResolvers<ContextType>;
  CheckPaymentRecipientAddressType?: CheckPaymentRecipientAddressTypeResolvers<ContextType>;
  CheckingHistorySummary?: CheckingHistorySummaryResolvers<ContextType>;
  CitationWidget?: CitationWidgetResolvers<ContextType>;
  ClaimStatusDetails?: ClaimStatusDetailsResolvers<ContextType>;
  ClearSupportSiteCache?: ClearSupportSiteCacheResolvers<ContextType>;
  CloseAccountReason?: CloseAccountReasonResolvers<ContextType>;
  CloseBankAccountResult?: CloseBankAccountResultResolvers<ContextType>;
  CloseInvestmentAccountResult?: CloseInvestmentAccountResultResolvers<ContextType>;
  CloseUserAccountResult?: CloseUserAccountResultResolvers<ContextType>;
  ClosureRequestDoesNotExistException?: ClosureRequestDoesNotExistExceptionResolvers<ContextType>;
  ClosureRequestExistsException?: ClosureRequestExistsExceptionResolvers<ContextType>;
  CohortEligibility?: CohortEligibilityResolvers<ContextType>;
  CohortEligibility_v2?: CohortEligibility_V2Resolvers<ContextType>;
  CombinedPerformance?: CombinedPerformanceResolvers<ContextType>;
  CompleteCheckDepositPayload?: CompleteCheckDepositPayloadResolvers<ContextType>;
  CompleteFunnelOnboardingResult?: CompleteFunnelOnboardingResultResolvers<ContextType>;
  CompletedQuiz?: CompletedQuizResolvers<ContextType>;
  ConfigureSplitDepositDirectDepositIntentPayload?: ConfigureSplitDepositDirectDepositIntentPayloadResolvers<ContextType>;
  ConfigureSplitDepositDirectDepositSettingPayload?: ConfigureSplitDepositDirectDepositSettingPayloadResolvers<ContextType>;
  ConnectACHAccountResult?: ConnectAchAccountResultResolvers<ContextType>;
  ConnectACHAccountSucceeded?: ConnectAchAccountSucceededResolvers<ContextType>;
  ConnectionSummary?: ConnectionSummaryResolvers<ContextType>;
  ConsumeUserTokenResult?: ConsumeUserTokenResultResolvers<ContextType>;
  ContactCategory?: ContactCategoryResolvers<ContextType>;
  ContactFaq?: ContactFaqResolvers<ContextType>;
  ContactFormAlert?: ContactFormAlertResolvers<ContextType>;
  ContactSubcategory?: ContactSubcategoryResolvers<ContextType>;
  ContentPreviewConnection?: ContentPreviewConnectionResolvers<ContextType>;
  ContentPreviewEdge?: ContentPreviewEdgeResolvers<ContextType>;
  ContributionAbility?: ContributionAbilityResolvers<ContextType>;
  ContributionAbilityByYear?: ContributionAbilityByYearResolvers<ContextType>;
  ContributionActionRequiredError?: ContributionActionRequiredErrorResolvers<ContextType>;
  ContributionAmountAboveThresholdError?: ContributionAmountAboveThresholdErrorResolvers<ContextType>;
  ContributionAmountBelowThresholdError?: ContributionAmountBelowThresholdErrorResolvers<ContextType>;
  ContributionCardDeclinedError?: ContributionCardDeclinedErrorResolvers<ContextType>;
  ContributionHistoryItem?: ContributionHistoryItemResolvers<ContextType>;
  ContributionInvalidOwnerEmailError?: ContributionInvalidOwnerEmailErrorResolvers<ContextType>;
  CoreACHSubscriptionFeeItem?: CoreAchSubscriptionFeeItemResolvers<ContextType>;
  CoreAccountAlreadyExistsException?: CoreAccountAlreadyExistsExceptionResolvers<ContextType>;
  CoreAccountClosedException?: CoreAccountClosedExceptionResolvers<ContextType>;
  CoreAdjustmentItem?: CoreAdjustmentItemResolvers<ContextType>;
  CoreCashForwardItem?: CoreCashForwardItemResolvers<ContextType>;
  CoreCollectionItem?: CoreCollectionItemResolvers<ContextType>;
  CoreDebtCollectionItem?: CoreDebtCollectionItemResolvers<ContextType>;
  CoreDividendsItem?: CoreDividendsItemResolvers<ContextType>;
  CoreEmployeeCreditItem?: CoreEmployeeCreditItemResolvers<ContextType>;
  CoreFeeInvestmentItem?: CoreFeeInvestmentItemResolvers<ContextType>;
  CoreFoundMoneyRewardItem?: CoreFoundMoneyRewardItemResolvers<ContextType>;
  CoreGiftCardCreditRedemptionItem?: CoreGiftCardCreditRedemptionItemResolvers<ContextType>;
  CoreHoldingsTransferInItem?: CoreHoldingsTransferInItemResolvers<ContextType>;
  CoreInvestmentItem?: CoreInvestmentItemResolvers<ContextType>;
  CoreLocalFoundMoneyItem?: CoreLocalFoundMoneyItemResolvers<ContextType>;
  CorePartnerRewardItem?: CorePartnerRewardItemResolvers<ContextType>;
  CoreRebalanceItem?: CoreRebalanceItemResolvers<ContextType>;
  CoreReferralRewardItem?: CoreReferralRewardItemResolvers<ContextType>;
  CoreRefundedItem?: CoreRefundedItemResolvers<ContextType>;
  CoreReinvestmentItem?: CoreReinvestmentItemResolvers<ContextType>;
  CoreRoundUpsItem?: CoreRoundUpsItemResolvers<ContextType>;
  CoreWithdrawalItem?: CoreWithdrawalItemResolvers<ContextType>;
  Course?: CourseResolvers<ContextType>;
  CourseLocked?: CourseLockedResolvers<ContextType>;
  CoursePreview?: CoursePreviewResolvers<ContextType>;
  CoursePreviewLocked?: CoursePreviewLockedResolvers<ContextType>;
  CourseTheme?: CourseThemeResolvers<ContextType>;
  CreateAuthProfileResult?: CreateAuthProfileResultResolvers<ContextType>;
  CreateBankAccountPayload?: CreateBankAccountPayloadResolvers<ContextType>;
  CreateBeneficiaryResult?: CreateBeneficiaryResultResolvers<ContextType>;
  CreateDelegateResult?: CreateDelegateResultResolvers<ContextType>;
  CreateDirectDepositLinkInfoFailure?: CreateDirectDepositLinkInfoFailureResolvers<ContextType>;
  CreateDirectDepositLinkInfoPayload?: CreateDirectDepositLinkInfoPayloadResolvers<ContextType>;
  CreateDirectDepositLinkInfoSwitch?: CreateDirectDepositLinkInfoSwitchResolvers<ContextType>;
  CreateDocumentUpload?: CreateDocumentUploadResolvers<ContextType>;
  CreateImplicitTokenForUserResult?: CreateImplicitTokenForUserResultResolvers<ContextType>;
  CreateIntentResult?: CreateIntentResultResolvers<ContextType>;
  CreateInvestingStrategyRecommendationResult?: CreateInvestingStrategyRecommendationResultResolvers<ContextType>;
  CreateInvestmentAccountResponse?: CreateInvestmentAccountResponseResolvers<ContextType>;
  CreateJobAlertResult?: CreateJobAlertResultResolvers<ContextType>;
  CreateOauthAppResult?: CreateOauthAppResultResolvers<ContextType>;
  CreateOfferResult?: CreateOfferResultResolvers<ContextType>;
  CreateOutsideContributionCheckoutCartResult?: CreateOutsideContributionCheckoutCartResultResolvers<ContextType>;
  CreateOutsideContributionResult?: CreateOutsideContributionResultResolvers<ContextType>;
  CreatePinwheelLinkToken?: CreatePinwheelLinkTokenResolvers<ContextType>;
  CreatePromoCodeResult?: CreatePromoCodeResultResolvers<ContextType>;
  CreatePromoCodeRewardResult?: CreatePromoCodeRewardResultResolvers<ContextType>;
  CreateProspectUserResult?: CreateProspectUserResultResolvers<ContextType>;
  CreateReferralCampaignResult?: CreateReferralCampaignResultResolvers<ContextType>;
  CreateReferralCampaignRewardResult?: CreateReferralCampaignRewardResultResolvers<ContextType>;
  CreateReferralPayoutResult?: CreateReferralPayoutResultResolvers<ContextType>;
  CreateReferralRelationshipResult?: CreateReferralRelationshipResultResolvers<ContextType>;
  CreateRefundError?: CreateRefundErrorResolvers<ContextType>;
  CreateRefundResult?: CreateRefundResultResolvers<ContextType>;
  CreateSavingsAccountPayload?: CreateSavingsAccountPayloadResolvers<ContextType>;
  CreateSavingsAccountResult?: CreateSavingsAccountResultResolvers<ContextType>;
  CreateSavingsAccountVerificationError?: CreateSavingsAccountVerificationErrorResolvers<ContextType>;
  CreateScopeException?: CreateScopeExceptionResolvers<ContextType>;
  CreateScopeResult?: CreateScopeResultResolvers<ContextType>;
  CreateSubscriptionMigrationResult?: CreateSubscriptionMigrationResultResolvers<ContextType>;
  CreateUploadUrlResult?: CreateUploadUrlResultResolvers<ContextType>;
  CreateUserProfileResult?: CreateUserProfileResultResolvers<ContextType>;
  CreateVendorInvoiceResult?: CreateVendorInvoiceResultResolvers<ContextType>;
  CreateVendorLineItemResult?: CreateVendorLineItemResultResolvers<ContextType>;
  Credentials?: CredentialsResolvers<ContextType>;
  Credit?: CreditResolvers<ContextType>;
  Cta?: CtaResolvers<ContextType>;
  CurrencyAmount?: CurrencyAmountResolvers<ContextType>;
  CurrencyMilestoneProgress?: CurrencyMilestoneProgressResolvers<ContextType>;
  CurrentBankStatementNotProvided?: CurrentBankStatementNotProvidedResolvers<ContextType>;
  CustomFieldOption?: CustomFieldOptionResolvers<ContextType>;
  CustomerAccount?: CustomerAccountResolvers<ContextType>;
  CustomerAccountClosure?: CustomerAccountClosureResolvers<ContextType>;
  CustomerAgreementRequiredException?: CustomerAgreementRequiredExceptionResolvers<ContextType>;
  CustomerEarnOnboardingMilestone?: CustomerEarnOnboardingMilestoneResolvers<ContextType>;
  CustomerEarnOnboardingProgram?: CustomerEarnOnboardingProgramResolvers<ContextType>;
  CustomerEarnOnboardingProgramControl?: CustomerEarnOnboardingProgramControlResolvers<ContextType>;
  CustomerEarnOnboardingProgramFeature?: CustomerEarnOnboardingProgramFeatureResolvers<ContextType>;
  CustomerMoneyRulesResult?: CustomerMoneyRulesResultResolvers<ContextType>;
  CustomerMoneyRulesResultSuccess?: CustomerMoneyRulesResultSuccessResolvers<ContextType>;
  CustomerSupportChatWidget?: CustomerSupportChatWidgetResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DeactivateBeneficiaryResult?: DeactivateBeneficiaryResultResolvers<ContextType>;
  DeactivateOauthAppClientResult?: DeactivateOauthAppClientResultResolvers<ContextType>;
  DeactivateOauthAppResult?: DeactivateOauthAppResultResolvers<ContextType>;
  DeactivateTierSubscriptionResult?: DeactivateTierSubscriptionResultResolvers<ContextType>;
  DeeplinkWidget?: DeeplinkWidgetResolvers<ContextType>;
  DelegateDefinition?: DelegateDefinitionResolvers<ContextType>;
  DeleteDelegateResult?: DeleteDelegateResultResolvers<ContextType>;
  DeleteDelegateResultTemporaryImpl?: DeleteDelegateResultTemporaryImplResolvers<ContextType>;
  DeleteExpiredBankCardOrderCardTierNotFoundError?: DeleteExpiredBankCardOrderCardTierNotFoundErrorResolvers<ContextType>;
  DeleteExpiredBankCardOrderNotExpiredError?: DeleteExpiredBankCardOrderNotExpiredErrorResolvers<ContextType>;
  DeleteExpiredBankCardOrderNotFoundError?: DeleteExpiredBankCardOrderNotFoundErrorResolvers<ContextType>;
  DeleteExpiredBankCardOrderResult?: DeleteExpiredBankCardOrderResultResolvers<ContextType>;
  DeleteOauthAppResult?: DeleteOauthAppResultResolvers<ContextType>;
  DeleteOauthAppSuccess?: DeleteOauthAppSuccessResolvers<ContextType>;
  DeleteScopeSuccess?: DeleteScopeSuccessResolvers<ContextType>;
  DeleteTrustedContactResult?: DeleteTrustedContactResultResolvers<ContextType>;
  DepositRiskFactor?: DepositRiskFactorResolvers<ContextType>;
  DeregisterAuthenticatorResult?: DeregisterAuthenticatorResultResolvers<ContextType>;
  DesignLibraryIcon?: DesignLibraryIconResolvers<ContextType>;
  Destination?: DestinationResolvers<ContextType>;
  Device?: DeviceResolvers<ContextType>;
  DeviceBlockedException?: DeviceBlockedExceptionResolvers<ContextType>;
  DeviceNotFoundException?: DeviceNotFoundExceptionResolvers<ContextType>;
  DigitalWalletDevice?: DigitalWalletDeviceResolvers<ContextType>;
  DigitalWalletToken?: DigitalWalletTokenResolvers<ContextType>;
  DirectDepositInfo?: DirectDepositInfoResolvers<ContextType>;
  DirectDepositInfoPayload?: DirectDepositInfoPayloadResolvers<ContextType>;
  DirectDepositState?: DirectDepositStateResolvers<ContextType>;
  DirectDepositStatePayload?: DirectDepositStatePayloadResolvers<ContextType>;
  DiscreteMilestoneProgress?: DiscreteMilestoneProgressResolvers<ContextType>;
  DismissMessagesResult?: DismissMessagesResultResolvers<ContextType>;
  DismissMessagesSuccess?: DismissMessagesSuccessResolvers<ContextType>;
  DistributionAmounts?: DistributionAmountsResolvers<ContextType>;
  DiversificationBucket?: DiversificationBucketResolvers<ContextType>;
  DiversificationInfo?: DiversificationInfoResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  DocumentNotFound?: DocumentNotFoundResolvers<ContextType>;
  DocumentRequest?: DocumentRequestResolvers<ContextType>;
  DocumentRequestEdge?: DocumentRequestEdgeResolvers<ContextType>;
  DocumentRequestsConnection?: DocumentRequestsConnectionResolvers<ContextType>;
  DocumentRequestsPageInfo?: DocumentRequestsPageInfoResolvers<ContextType>;
  DocumentUploadSession?: DocumentUploadSessionResolvers<ContextType>;
  DocumentUploads?: DocumentUploadsResolvers<ContextType>;
  DocumentVerification?: DocumentVerificationResolvers<ContextType>;
  DuplicateActionError?: DuplicateActionErrorResolvers<ContextType>;
  DuplicateBillingInfoError?: DuplicateBillingInfoErrorResolvers<ContextType>;
  DuplicatePromoCodeError?: DuplicatePromoCodeErrorResolvers<ContextType>;
  DuplicatePromoCodeRewardError?: DuplicatePromoCodeRewardErrorResolvers<ContextType>;
  ETF?: EtfResolvers<ContextType>;
  ETFGain?: EtfGainResolvers<ContextType>;
  ETFPerformance?: EtfPerformanceResolvers<ContextType>;
  ETFPrice?: EtfPriceResolvers<ContextType>;
  EarlyAccountStateRegulation?: EarlyAccountStateRegulationResolvers<ContextType>;
  EarlyAccountStateRegulationResult?: EarlyAccountStateRegulationResultResolvers<ContextType>;
  EarlyAccountTransferInfo?: EarlyAccountTransferInfoResolvers<ContextType>;
  EarlyDebtCollectionItem?: EarlyDebtCollectionItemResolvers<ContextType>;
  EarlyDividendsItem?: EarlyDividendsItemResolvers<ContextType>;
  EarlyFeeInvestmentItem?: EarlyFeeInvestmentItemResolvers<ContextType>;
  EarlyGiftItem?: EarlyGiftItemResolvers<ContextType>;
  EarlyHistorySummary?: EarlyHistorySummaryResolvers<ContextType>;
  EarlyInvestmentItem?: EarlyInvestmentItemResolvers<ContextType>;
  EarlyMatchItem?: EarlyMatchItemResolvers<ContextType>;
  EarlyMatchRemovalItem?: EarlyMatchRemovalItemResolvers<ContextType>;
  EarlyRefundedItem?: EarlyRefundedItemResolvers<ContextType>;
  EarlyReinvestmentItem?: EarlyReinvestmentItemResolvers<ContextType>;
  EarlyWithdrawalItem?: EarlyWithdrawalItemResolvers<ContextType>;
  EarnCTARecord?: EarnCtaRecordResolvers<ContextType>;
  EarnMissingCreditRequest?: EarnMissingCreditRequestResolvers<ContextType>;
  EarnMissingCreditRequestPurchaseDateError?: EarnMissingCreditRequestPurchaseDateErrorResolvers<ContextType>;
  EarnOffer?: EarnOfferResolvers<ContextType>;
  EarnOfferCtaDetails?: EarnOfferCtaDetailsResolvers<ContextType>;
  EarnOfferQueryPage?: EarnOfferQueryPageResolvers<ContextType>;
  EarnOnboardingMilestoneCta?: EarnOnboardingMilestoneCtaResolvers<ContextType>;
  EarnPageInfo?: EarnPageInfoResolvers<ContextType>;
  EarnReward?: EarnRewardResolvers<ContextType>;
  Ecbsv?: EcbsvResolvers<ContextType>;
  EducationTip?: EducationTipResolvers<ContextType>;
  Eligibility?: EligibilityResolvers<ContextType>;
  Email?: GraphQLScalarType;
  EmailAddress?: GraphQLScalarType;
  EmailAddressValidation?: EmailAddressValidationResolvers<ContextType>;
  EmailAuthChallenge?: EmailAuthChallengeResolvers<ContextType>;
  EmailAuthenticator?: EmailAuthenticatorResolvers<ContextType>;
  EmailRedirect?: EmailRedirectResolvers<ContextType>;
  EmailTakenException?: EmailTakenExceptionResolvers<ContextType>;
  EmergencyFundHistorySummary?: EmergencyFundHistorySummaryResolvers<ContextType>;
  Employer?: EmployerResolvers<ContextType>;
  EnableQuarterlyRecapsResult?: EnableQuarterlyRecapsResultResolvers<ContextType>;
  EstimatedCheckPaymentDates?: EstimatedCheckPaymentDatesResolvers<ContextType>;
  EstimatedTransferDatesPayload?: EstimatedTransferDatesPayloadResolvers<ContextType>;
  EvaluateCheckDepositPayload?: EvaluateCheckDepositPayloadResolvers<ContextType>;
  ExchangeAcornsEarlyTokenResult?: ExchangeAcornsEarlyTokenResultResolvers<ContextType>;
  ExecuteMoneyInError?: ExecuteMoneyInErrorResolvers<ContextType>;
  ExecuteMoneyInResult?: ExecuteMoneyInResultResolvers<ContextType>;
  ExecuteMoneyInSuccess?: ExecuteMoneyInSuccessResolvers<ContextType>;
  ExecuteMoneyManagerRebalancesResult?: ExecuteMoneyManagerRebalancesResultResolvers<ContextType>;
  ExecuteMoneyManagerRebalancesSuccess?: ExecuteMoneyManagerRebalancesSuccessResolvers<ContextType>;
  ExecutionAudit?: ExecutionAuditResolvers<ContextType>;
  ExistingEmailVerifiedException?: ExistingEmailVerifiedExceptionResolvers<ContextType>;
  ExistingRequestPendingReview?: ExistingRequestPendingReviewResolvers<ContextType>;
  ExistingRequestPendingUserAction?: ExistingRequestPendingUserActionResolvers<ContextType>;
  ExperienceContent?: ExperienceContentResolvers<ContextType>;
  ExpirePromotionalWaiverResult?: ExpirePromotionalWaiverResultResolvers<ContextType>;
  ExternalMetadata?: ExternalMetadataResolvers<ContextType>;
  ExtoleCampaignHistoryConnection?: ExtoleCampaignHistoryConnectionResolvers<ContextType>;
  ExtoleCampaignHistoryEdge?: ExtoleCampaignHistoryEdgeResolvers<ContextType>;
  ExtoleReferralCampaign?: ExtoleReferralCampaignResolvers<ContextType>;
  ExtoleReferralHistory?: ExtoleReferralHistoryResolvers<ContextType>;
  FailVendorInvoiceResult?: FailVendorInvoiceResultResolvers<ContextType>;
  FavoritePartnerOfferGroup?: FavoritePartnerOfferGroupResolvers<ContextType>;
  FeaturedLearnContentPreview?: FeaturedLearnContentPreviewResolvers<ContextType>;
  FeaturedMilestones?: FeaturedMilestonesResolvers<ContextType>;
  FeaturedMilestonesV2?: FeaturedMilestonesV2Resolvers<ContextType>;
  Fee?: FeeResolvers<ContextType>;
  FeeExecution?: FeeExecutionResolvers<ContextType>;
  FeeNegotiation?: FeeNegotiationResolvers<ContextType>;
  FeeNegotiationSummary?: FeeNegotiationSummaryResolvers<ContextType>;
  FeeStatusSummary?: FeeStatusSummaryResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  FileDoesNotExistError?: FileDoesNotExistErrorResolvers<ContextType>;
  FileDoesNotExistInS3?: FileDoesNotExistInS3Resolvers<ContextType>;
  FileOrException?: FileOrExceptionResolvers<ContextType>;
  FileSizeError?: FileSizeErrorResolvers<ContextType>;
  FileTooLarge?: FileTooLargeResolvers<ContextType>;
  FinancialAdvisorQuestionResponse?: FinancialAdvisorQuestionResponseResolvers<ContextType>;
  FinancialAdvisorQuestionsResponse?: FinancialAdvisorQuestionsResponseResolvers<ContextType>;
  FinancialGoalsResult?: FinancialGoalsResultResolvers<ContextType>;
  FinancialInstitution?: FinancialInstitutionResolvers<ContextType>;
  FinancialInstitutionTypeEdge?: FinancialInstitutionTypeEdgeResolvers<ContextType>;
  FinancialInstitutionTypePagination?: FinancialInstitutionTypePaginationResolvers<ContextType>;
  FinishSetup?: FinishSetupResolvers<ContextType>;
  FooterContent?: FooterContentResolvers<ContextType>;
  FormattedMonetaryAmount?: FormattedMonetaryAmountResolvers<ContextType>;
  FoundMoneyCampaignOfferV2?: FoundMoneyCampaignOfferV2Resolvers<ContextType>;
  FoundMoneyCampaignV2?: FoundMoneyCampaignV2Resolvers<ContextType>;
  FoundMoneyReward?: FoundMoneyRewardResolvers<ContextType>;
  FoundMoneySummary?: FoundMoneySummaryResolvers<ContextType>;
  Friend?: FriendResolvers<ContextType>;
  FriendExperienceContent?: FriendExperienceContentResolvers<ContextType>;
  FriendHistory?: FriendHistoryResolvers<ContextType>;
  FriendHistoryConnection?: FriendHistoryConnectionResolvers<ContextType>;
  FriendHistoryEdge?: FriendHistoryEdgeResolvers<ContextType>;
  FriendSummary?: FriendSummaryResolvers<ContextType>;
  FriendV2Output?: FriendV2OutputResolvers<ContextType>;
  Fund?: FundResolvers<ContextType>;
  FundSpendInActivationPayload?: FundSpendInActivationPayloadResolvers<ContextType>;
  FundingSource?: FundingSourceResolvers<ContextType>;
  FundingSourceAccount?: FundingSourceAccountResolvers<ContextType>;
  FundingSourceAlreadyExists?: FundingSourceAlreadyExistsResolvers<ContextType>;
  FundingSourceCredentialsExceedLinkLimit?: FundingSourceCredentialsExceedLinkLimitResolvers<ContextType>;
  FundingSourceInfo?: FundingSourceInfoResolvers<ContextType>;
  FundingSourceRequiresRdvException?: FundingSourceRequiresRdvExceptionResolvers<ContextType>;
  FunnelMetadata?: FunnelMetadataResolvers<ContextType>;
  GenerateDocumentUploadSessionResult?: GenerateDocumentUploadSessionResultResolvers<ContextType>;
  GenerateLayerLinkSessionResult?: GenerateLayerLinkSessionResultResolvers<ContextType>;
  GenerateReferralCodeResult?: GenerateReferralCodeResultResolvers<ContextType>;
  GenerateUpdatedPdfPayload?: GenerateUpdatedPdfPayloadResolvers<ContextType>;
  GetUsersBankFromAccountTypePayload?: GetUsersBankFromAccountTypePayloadResolvers<ContextType>;
  GrowProspect?: GrowProspectResolvers<ContextType>;
  HelpFormContent?: HelpFormContentResolvers<ContextType>;
  HelpcenterBannerContent?: HelpcenterBannerContentResolvers<ContextType>;
  HelpcenterBannerErrors?: HelpcenterBannerErrorsResolvers<ContextType>;
  Holding?: HoldingResolvers<ContextType>;
  HoldingsTransfer?: HoldingsTransferResolvers<ContextType>;
  IRADistribution?: IraDistributionResolvers<ContextType>;
  IdentityDocumentRequestedUserAlert?: IdentityDocumentRequestedUserAlertResolvers<ContextType>;
  IdentityVerification?: IdentityVerificationResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  ImplicitToken?: ImplicitTokenResolvers<ContextType>;
  Incentive?: IncentiveResolvers<ContextType>;
  IncorrectOldPasswordException?: IncorrectOldPasswordExceptionResolvers<ContextType>;
  IncorrectRdvAmounts?: IncorrectRdvAmountsResolvers<ContextType>;
  IncorrectSecurityAnswerException?: IncorrectSecurityAnswerExceptionResolvers<ContextType>;
  IncorrectSsnException?: IncorrectSsnExceptionResolvers<ContextType>;
  InitiateBankAccountResponse?: InitiateBankAccountResponseResolvers<ContextType>;
  InitiateBankingKYCPayload?: InitiateBankingKycPayloadResolvers<ContextType>;
  InitiateChallengeResult?: InitiateChallengeResultResolvers<ContextType>;
  InitiateEmailChallengeResult?: InitiateEmailChallengeResultResolvers<ContextType>;
  InitiateMoneyAssignmentResult?: InitiateMoneyAssignmentResultResolvers<ContextType>;
  InitiateMoneyAssignmentSuccess?: InitiateMoneyAssignmentSuccessResolvers<ContextType>;
  InitiatePushChallengeResult?: InitiatePushChallengeResultResolvers<ContextType>;
  InitiatePushChallengeSuccess?: InitiatePushChallengeSuccessResolvers<ContextType>;
  InitiateSMSChallengeResult?: InitiateSmsChallengeResultResolvers<ContextType>;
  InitiateTransferPayload?: InitiateTransferPayloadResolvers<ContextType>;
  InitiateVerificationResult?: InitiateVerificationResultResolvers<ContextType>;
  InstitutionNotSupportedError?: InstitutionNotSupportedErrorResolvers<ContextType>;
  InsufficientFundsUserAlert?: InsufficientFundsUserAlertResolvers<ContextType>;
  Intent?: IntentResolvers<ContextType>;
  InteractionRatingResponse?: InteractionRatingResponseResolvers<ContextType>;
  InternalErrorException?: InternalErrorExceptionResolvers<ContextType>;
  InvalidAccountNumber?: InvalidAccountNumberResolvers<ContextType>;
  InvalidAccountTypeException?: InvalidAccountTypeExceptionResolvers<ContextType>;
  InvalidAcornsEarlyTokenException?: InvalidAcornsEarlyTokenExceptionResolvers<ContextType>;
  InvalidActionOnAccount?: InvalidActionOnAccountResolvers<ContextType>;
  InvalidAddressError?: InvalidAddressErrorResolvers<ContextType>;
  InvalidAddressException?: InvalidAddressExceptionResolvers<ContextType>;
  InvalidAllocationPercentError?: InvalidAllocationPercentErrorResolvers<ContextType>;
  InvalidAppleAccountException?: InvalidAppleAccountExceptionResolvers<ContextType>;
  InvalidContentTypeException?: InvalidContentTypeExceptionResolvers<ContextType>;
  InvalidConversionIdentifierException?: InvalidConversionIdentifierExceptionResolvers<ContextType>;
  InvalidCredentialsException?: InvalidCredentialsExceptionResolvers<ContextType>;
  InvalidDateException?: InvalidDateExceptionResolvers<ContextType>;
  InvalidDateOfBirthException?: InvalidDateOfBirthExceptionResolvers<ContextType>;
  InvalidDeviceParametersException?: InvalidDeviceParametersExceptionResolvers<ContextType>;
  InvalidEmailException?: InvalidEmailExceptionResolvers<ContextType>;
  InvalidFile?: InvalidFileResolvers<ContextType>;
  InvalidFirstNameException?: InvalidFirstNameExceptionResolvers<ContextType>;
  InvalidGoogleAccountException?: InvalidGoogleAccountExceptionResolvers<ContextType>;
  InvalidIdentityTokenException?: InvalidIdentityTokenExceptionResolvers<ContextType>;
  InvalidInvestmentAccountException?: InvalidInvestmentAccountExceptionResolvers<ContextType>;
  InvalidLastNameException?: InvalidLastNameExceptionResolvers<ContextType>;
  InvalidManualLink?: InvalidManualLinkResolvers<ContextType>;
  InvalidMfaTokenException?: InvalidMfaTokenExceptionResolvers<ContextType>;
  InvalidOauthAppClientIdException?: InvalidOauthAppClientIdExceptionResolvers<ContextType>;
  InvalidOptionException?: InvalidOptionExceptionResolvers<ContextType>;
  InvalidPasswordException?: InvalidPasswordExceptionResolvers<ContextType>;
  InvalidPasswordResetException?: InvalidPasswordResetExceptionResolvers<ContextType>;
  InvalidPasswordResetTokenException?: InvalidPasswordResetTokenExceptionResolvers<ContextType>;
  InvalidPhoneException?: InvalidPhoneExceptionResolvers<ContextType>;
  InvalidPhoneNumberException?: InvalidPhoneNumberExceptionResolvers<ContextType>;
  InvalidPinException?: InvalidPinExceptionResolvers<ContextType>;
  InvalidPortfolioIdException?: InvalidPortfolioIdExceptionResolvers<ContextType>;
  InvalidPromoCodeError?: InvalidPromoCodeErrorResolvers<ContextType>;
  InvalidReferralRelationship?: InvalidReferralRelationshipResolvers<ContextType>;
  InvalidRoutingNumber?: InvalidRoutingNumberResolvers<ContextType>;
  InvalidSecurityError?: InvalidSecurityErrorResolvers<ContextType>;
  InvalidSecurityForAllocationError?: InvalidSecurityForAllocationErrorResolvers<ContextType>;
  InvalidSingleRuleIdError?: InvalidSingleRuleIdErrorResolvers<ContextType>;
  InvalidSourceAttributesException?: InvalidSourceAttributesExceptionResolvers<ContextType>;
  InvalidSsnException?: InvalidSsnExceptionResolvers<ContextType>;
  InvalidStateException?: InvalidStateExceptionResolvers<ContextType>;
  InvalidSubscriptionTierException?: InvalidSubscriptionTierExceptionResolvers<ContextType>;
  InvalidTerminationAgeException?: InvalidTerminationAgeExceptionResolvers<ContextType>;
  InvalidTier?: InvalidTierResolvers<ContextType>;
  InvalidTierForMigrationError?: InvalidTierForMigrationErrorResolvers<ContextType>;
  InvalidTierPrice?: InvalidTierPriceResolvers<ContextType>;
  InvalidTierPriceCombination?: InvalidTierPriceCombinationResolvers<ContextType>;
  InvalidTierPriceId?: InvalidTierPriceIdResolvers<ContextType>;
  InvalidUserIdException?: InvalidUserIdExceptionResolvers<ContextType>;
  InvalidUserTokenException?: InvalidUserTokenExceptionResolvers<ContextType>;
  InvestHistorySummary?: InvestHistorySummaryResolvers<ContextType>;
  Investment?: InvestmentResolvers<ContextType>;
  InvestmentAccount?: InvestmentAccountResolvers<ContextType>;
  InvestmentAccountAlreadyClosed?: InvestmentAccountAlreadyClosedResolvers<ContextType>;
  InvestmentAccountClosureInProgress?: InvestmentAccountClosureInProgressResolvers<ContextType>;
  InvestmentAccountClosureRequest?: InvestmentAccountClosureRequestResolvers<ContextType>;
  InvestmentAccountCreationException?: InvestmentAccountCreationExceptionResolvers<ContextType>;
  InvestmentAccountNeedsTransferException?: InvestmentAccountNeedsTransferExceptionResolvers<ContextType>;
  InvestmentAccountNotClosedException?: InvestmentAccountNotClosedExceptionResolvers<ContextType>;
  InvestmentAccountNotFoundException?: InvestmentAccountNotFoundExceptionResolvers<ContextType>;
  InvestmentAccountNotSupportedException?: InvestmentAccountNotSupportedExceptionResolvers<ContextType>;
  InvestmentAccountOutsideContribution?: InvestmentAccountOutsideContributionResolvers<ContextType>;
  InvestmentAccountRecap?: InvestmentAccountRecapResolvers<ContextType>;
  InvestmentAccountRecapNotFoundException?: InvestmentAccountRecapNotFoundExceptionResolvers<ContextType>;
  InvestmentAccountReopenRequest?: InvestmentAccountReopenRequestResolvers<ContextType>;
  InvestmentAccountReopenRequestAction?: InvestmentAccountReopenRequestActionResolvers<ContextType>;
  InvestmentAccountReopenRequestNote?: InvestmentAccountReopenRequestNoteResolvers<ContextType>;
  InvestmentAccountSummary?: InvestmentAccountSummaryResolvers<ContextType>;
  InvestmentAccountTransferability?: InvestmentAccountTransferabilityResolvers<ContextType>;
  InvestmentAggregation?: InvestmentAggregationResolvers<ContextType>;
  InvestmentAllocation?: InvestmentAllocationResolvers<ContextType>;
  InvestmentCategory?: InvestmentCategoryResolvers<ContextType>;
  InvestmentEdge?: InvestmentEdgeResolvers<ContextType>;
  InvestmentNotFoundException?: InvestmentNotFoundExceptionResolvers<ContextType>;
  InvestmentPagination?: InvestmentPaginationResolvers<ContextType>;
  InvestmentUncancellableException?: InvestmentUncancellableExceptionResolvers<ContextType>;
  InvestmentsPausedUserAlert?: InvestmentsPausedUserAlertResolvers<ContextType>;
  Invitation?: InvitationResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  InvoiceCollection?: InvoiceCollectionResolvers<ContextType>;
  InvoiceItem?: InvoiceItemResolvers<ContextType>;
  InvoiceLineItem?: InvoiceLineItemResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JobAlert?: JobAlertResolvers<ContextType>;
  JobLocation?: JobLocationResolvers<ContextType>;
  JobOffer?: JobOfferResolvers<ContextType>;
  JobOfferSalary?: JobOfferSalaryResolvers<ContextType>;
  JobSearchCriteria?: JobSearchCriteriaResolvers<ContextType>;
  JobSearchFilter?: JobSearchFilterResolvers<ContextType>;
  JobSearchOffer?: JobSearchOfferResolvers<ContextType>;
  JobSearchPage?: JobSearchPageResolvers<ContextType>;
  LadderLinkResponse?: LadderLinkResponseResolvers<ContextType>;
  LadderQuote?: LadderQuoteResolvers<ContextType>;
  LadderQuoteStatus?: LadderQuoteStatusResolvers<ContextType>;
  LadderResponse?: LadderResponseResolvers<ContextType>;
  LaterAccount?: LaterAccountResolvers<ContextType>;
  LaterAccountAlreadyVerified?: LaterAccountAlreadyVerifiedResolvers<ContextType>;
  LaterAccountIneligibleForVerification?: LaterAccountIneligibleForVerificationResolvers<ContextType>;
  LaterAccountInfo?: LaterAccountInfoResolvers<ContextType>;
  LaterAccountInfoOrError?: LaterAccountInfoOrErrorResolvers<ContextType>;
  LaterAccountNotFound?: LaterAccountNotFoundResolvers<ContextType>;
  LaterAccountRequiresTaxWithholdings?: LaterAccountRequiresTaxWithholdingsResolvers<ContextType>;
  LaterAccountRequiresWithdrawalReason?: LaterAccountRequiresWithdrawalReasonResolvers<ContextType>;
  LaterAccountTaxWithholdingsPercentageExceeded?: LaterAccountTaxWithholdingsPercentageExceededResolvers<ContextType>;
  LaterBeneficiary?: LaterBeneficiaryResolvers<ContextType>;
  LaterContributionAbilityResult?: LaterContributionAbilityResultResolvers<ContextType>;
  LaterContributionLimitMet?: LaterContributionLimitMetResolvers<ContextType>;
  LaterDebtCollectionItem?: LaterDebtCollectionItemResolvers<ContextType>;
  LaterDividendsItem?: LaterDividendsItemResolvers<ContextType>;
  LaterFeeInvestmentItem?: LaterFeeInvestmentItemResolvers<ContextType>;
  LaterFullContributionSuccess?: LaterFullContributionSuccessResolvers<ContextType>;
  LaterHistoryItem?: LaterHistoryItemResolvers<ContextType>;
  LaterHistorySummary?: LaterHistorySummaryResolvers<ContextType>;
  LaterIndividualBeneficiary?: LaterIndividualBeneficiaryResolvers<ContextType>;
  LaterIndividualBeneficiaryResponse?: LaterIndividualBeneficiaryResponseResolvers<ContextType>;
  LaterInvestmentItem?: LaterInvestmentItemResolvers<ContextType>;
  LaterMatchItem?: LaterMatchItemResolvers<ContextType>;
  LaterMatchRemovalItem?: LaterMatchRemovalItemResolvers<ContextType>;
  LaterPartialContributionSuccess?: LaterPartialContributionSuccessResolvers<ContextType>;
  LaterPortfolioPerformance?: LaterPortfolioPerformanceResolvers<ContextType>;
  LaterProgramAccountContributionResult?: LaterProgramAccountContributionResultResolvers<ContextType>;
  LaterRebalanceItem?: LaterRebalanceItemResolvers<ContextType>;
  LaterRefundedItem?: LaterRefundedItemResolvers<ContextType>;
  LaterReinvestmentItem?: LaterReinvestmentItemResolvers<ContextType>;
  LaterTypedException?: LaterTypedExceptionResolvers<ContextType>;
  LaterWaitlistProspect?: LaterWaitlistProspectResolvers<ContextType>;
  LaterWithdrawal?: LaterWithdrawalResolvers<ContextType>;
  LaterWithdrawalItem?: LaterWithdrawalItemResolvers<ContextType>;
  LaterWithholdingValues?: LaterWithholdingValuesResolvers<ContextType>;
  LayerLinkSession?: LayerLinkSessionResolvers<ContextType>;
  LearnAnswer?: LearnAnswerResolvers<ContextType>;
  LearnArticle?: LearnArticleResolvers<ContextType>;
  LearnArticlePreview?: LearnArticlePreviewResolvers<ContextType>;
  LearnArticlePreviewLocked?: LearnArticlePreviewLockedResolvers<ContextType>;
  LearnAuthor?: LearnAuthorResolvers<ContextType>;
  LearnConnection?: LearnConnectionResolvers<ContextType>;
  LearnContentCategory?: LearnContentCategoryResolvers<ContextType>;
  LearnContentCommunityStats?: LearnContentCommunityStatsResolvers<ContextType>;
  LearnContentDuration?: LearnContentDurationResolvers<ContextType>;
  LearnContentElapsedMillisecondsUpdatedResult?: LearnContentElapsedMillisecondsUpdatedResultResolvers<ContextType>;
  LearnContentInteractionState?: LearnContentInteractionStateResolvers<ContextType>;
  LearnContentPreview?: LearnContentPreviewResolvers<ContextType>;
  LearnContentStats?: LearnContentStatsResolvers<ContextType>;
  LearnCourse?: LearnCourseResolvers<ContextType>;
  LearnCoursePreview?: LearnCoursePreviewResolvers<ContextType>;
  LearnEdge?: LearnEdgeResolvers<ContextType>;
  LearnHubCitation?: LearnHubCitationResolvers<ContextType>;
  LearnInsight?: LearnInsightResolvers<ContextType>;
  LearnInteractionState?: LearnInteractionStateResolvers<ContextType>;
  LearnMedia?: LearnMediaResolvers<ContextType>;
  LearnMediaArticle?: LearnMediaArticleResolvers<ContextType>;
  LearnMediaPreview?: LearnMediaPreviewResolvers<ContextType>;
  LearnMediaPreviewLocked?: LearnMediaPreviewLockedResolvers<ContextType>;
  LearnMediaReference?: LearnMediaReferenceResolvers<ContextType>;
  LearnMediaTheme?: LearnMediaThemeResolvers<ContextType>;
  LearnMetadata?: LearnMetadataResolvers<ContextType>;
  LearnNextStepAction?: LearnNextStepActionResolvers<ContextType>;
  LearnPageInfo?: LearnPageInfoResolvers<ContextType>;
  LearnPoll?: LearnPollResolvers<ContextType>;
  LearnPollOption?: LearnPollOptionResolvers<ContextType>;
  LearnPollPreview?: LearnPollPreviewResolvers<ContextType>;
  LearnPollPreviewLocked?: LearnPollPreviewLockedResolvers<ContextType>;
  LearnPollResponse?: LearnPollResponseResolvers<ContextType>;
  LearnProgress?: LearnProgressResolvers<ContextType>;
  LearnProgressUpdatedResult?: LearnProgressUpdatedResultResolvers<ContextType>;
  LearnQuestion?: LearnQuestionResolvers<ContextType>;
  LearnQuestionInsight?: LearnQuestionInsightResolvers<ContextType>;
  LearnQuiz?: LearnQuizResolvers<ContextType>;
  LearnQuizAnswerResult?: LearnQuizAnswerResultResolvers<ContextType>;
  LearnQuizPreview?: LearnQuizPreviewResolvers<ContextType>;
  LearnSearchTermSavedResult?: LearnSearchTermSavedResultResolvers<ContextType>;
  LearnTag?: LearnTagResolvers<ContextType>;
  LearnThemeLiteral?: LearnThemeLiteralResolvers<ContextType>;
  LearnTier?: LearnTierResolvers<ContextType>;
  LearnTopic?: LearnTopicResolvers<ContextType>;
  LearnVisualAsset?: LearnVisualAssetResolvers<ContextType>;
  LegacyAlertDismissalSuccess?: LegacyAlertDismissalSuccessResolvers<ContextType>;
  LegacyUploadDocument?: LegacyUploadDocumentResolvers<ContextType>;
  LegacyUploadDocumentResult?: LegacyUploadDocumentResultResolvers<ContextType>;
  Lesson?: LessonResolvers<ContextType>;
  LessonPreview?: LessonPreviewResolvers<ContextType>;
  LessonPreviewLocked?: LessonPreviewLockedResolvers<ContextType>;
  LinkManualFundingSourceResult?: LinkManualFundingSourceResultResolvers<ContextType>;
  LinkOidcCredentialsResult?: LinkOidcCredentialsResultResolvers<ContextType>;
  LinkOidcCredentialsSuccess?: LinkOidcCredentialsSuccessResolvers<ContextType>;
  LinkSessionResult?: LinkSessionResultResolvers<ContextType>;
  LinkedAccount?: LinkedAccountResolvers<ContextType>;
  LinkedAccountAlert?: LinkedAccountAlertResolvers<ContextType>;
  LinkedAccountAlertsResponse?: LinkedAccountAlertsResponseResolvers<ContextType>;
  LinkedAccountNotFound?: LinkedAccountNotFoundResolvers<ContextType>;
  LinkedSubaccount?: LinkedSubaccountResolvers<ContextType>;
  Liquidation?: LiquidationResolvers<ContextType>;
  LiquidationUnavailableError?: LiquidationUnavailableErrorResolvers<ContextType>;
  LockBankCardPayload?: LockBankCardPayloadResolvers<ContextType>;
  LoginAccess?: LoginAccessResolvers<ContextType>;
  LoginRateLimitedException?: LoginRateLimitedExceptionResolvers<ContextType>;
  LogoutDeviceResult?: LogoutDeviceResultResolvers<ContextType>;
  LogoutDeviceSuccess?: LogoutDeviceSuccessResolvers<ContextType>;
  LogoutResult?: LogoutResultResolvers<ContextType>;
  LogoutSuccess?: LogoutSuccessResolvers<ContextType>;
  MakeInvestmentPayload?: MakeInvestmentPayloadResolvers<ContextType>;
  MalformedRecurringTransferException?: MalformedRecurringTransferExceptionResolvers<ContextType>;
  MarkAllAsReadResult?: MarkAllAsReadResultResolvers<ContextType>;
  MarkAllAsReadSuccess?: MarkAllAsReadSuccessResolvers<ContextType>;
  MarkLearnContentAsHelpfulResult?: MarkLearnContentAsHelpfulResultResolvers<ContextType>;
  MarkLearnContentAsViewedResult?: MarkLearnContentAsViewedResultResolvers<ContextType>;
  Market?: MarketResolvers<ContextType>;
  MarketReturn?: MarketReturnResolvers<ContextType>;
  MatchProgram?: MatchProgramResolvers<ContextType>;
  MaxAccountsCreatedException?: MaxAccountsCreatedExceptionResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageConnection?: MessageConnectionResolvers<ContextType>;
  MessageEdge?: MessageEdgeResolvers<ContextType>;
  MessagePageInfo?: MessagePageInfoResolvers<ContextType>;
  MessageTextAsset?: MessageTextAssetResolvers<ContextType>;
  MessageVisualAsset?: MessageVisualAssetResolvers<ContextType>;
  MfaMissingAuthAlert?: MfaMissingAuthAlertResolvers<ContextType>;
  Micros?: GraphQLScalarType;
  MicrosMoney?: MicrosMoneyResolvers<ContextType>;
  MightyOakCardWaiver?: MightyOakCardWaiverResolvers<ContextType>;
  MightyOakCardWaiverExpiredException?: MightyOakCardWaiverExpiredExceptionResolvers<ContextType>;
  MightyOakCardWaiverNotFoundException?: MightyOakCardWaiverNotFoundExceptionResolvers<ContextType>;
  MightyOakWaiverResult?: MightyOakWaiverResultResolvers<ContextType>;
  Milestone?: MilestoneResolvers<ContextType>;
  MilestoneAccountLevelDefinition?: MilestoneAccountLevelDefinitionResolvers<ContextType>;
  MilestoneAchievementActionRule?: MilestoneAchievementActionRuleResolvers<ContextType>;
  MilestoneChallenge?: MilestoneChallengeResolvers<ContextType>;
  MilestoneChallengePointsRule?: MilestoneChallengePointsRuleResolvers<ContextType>;
  MilestoneDefinition?: MilestoneDefinitionResolvers<ContextType>;
  MilestoneEligibility?: MilestoneEligibilityResolvers<ContextType>;
  MilestoneGroup?: MilestoneGroupResolvers<ContextType>;
  MilestoneGroupAchievementActionRule?: MilestoneGroupAchievementActionRuleResolvers<ContextType>;
  MilestoneGroupDefinition?: MilestoneGroupDefinitionResolvers<ContextType>;
  MilestoneHub?: MilestoneHubResolvers<ContextType>;
  MilestoneHubAccount?: MilestoneHubAccountResolvers<ContextType>;
  MilestoneHubDefinition?: MilestoneHubDefinitionResolvers<ContextType>;
  MilestoneProgress?: MilestoneProgressResolvers<ContextType>;
  MilestoneRule?: MilestoneRuleResolvers<ContextType>;
  MilestoneRuleGroup?: MilestoneRuleGroupResolvers<ContextType>;
  MilestoneRuleGroupContent?: MilestoneRuleGroupContentResolvers<ContextType>;
  MilestoneThemeGroup?: MilestoneThemeGroupResolvers<ContextType>;
  MilestoneThemeGroupContent?: MilestoneThemeGroupContentResolvers<ContextType>;
  Milliseconds?: MillisecondsResolvers<ContextType>;
  MiscDocumentRequestedUserAlert?: MiscDocumentRequestedUserAlertResolvers<ContextType>;
  MismatchedDistributionUnitsError?: MismatchedDistributionUnitsErrorResolvers<ContextType>;
  MissingAgreementsException?: MissingAgreementsExceptionResolvers<ContextType>;
  MissingBeneficiarySsnException?: MissingBeneficiarySsnExceptionResolvers<ContextType>;
  MissingFundingSourceException?: MissingFundingSourceExceptionResolvers<ContextType>;
  MissingRequiredAgreementsException?: MissingRequiredAgreementsExceptionResolvers<ContextType>;
  MissingSsnBeneficiaryAlert?: MissingSsnBeneficiaryAlertResolvers<ContextType>;
  MissingSsnBeneficiaryAlertItem?: MissingSsnBeneficiaryAlertItemResolvers<ContextType>;
  MissingValidRulesetError?: MissingValidRulesetErrorResolvers<ContextType>;
  ModifyMoneyAssignmentResult?: ModifyMoneyAssignmentResultResolvers<ContextType>;
  ModifyMoneyAssignmentSuccess?: ModifyMoneyAssignmentSuccessResolvers<ContextType>;
  MonetaryAmount?: MonetaryAmountResolvers<ContextType>;
  MonetaryIncentive?: MonetaryIncentiveResolvers<ContextType>;
  MoneyAssignmentAlreadyTransferredError?: MoneyAssignmentAlreadyTransferredErrorResolvers<ContextType>;
  MoneyAssignmentConnection?: MoneyAssignmentConnectionResolvers<ContextType>;
  MoneyAssignmentEdge?: MoneyAssignmentEdgeResolvers<ContextType>;
  MoneyAssignmentNotFoundError?: MoneyAssignmentNotFoundErrorResolvers<ContextType>;
  MoneyManagerAllocation?: MoneyManagerAllocationResolvers<ContextType>;
  MoneyManagerAllocationOption?: MoneyManagerAllocationOptionResolvers<ContextType>;
  MoneyManagerAllocationRemainder?: MoneyManagerAllocationRemainderResolvers<ContextType>;
  MoneyManagerAllocationResult?: MoneyManagerAllocationResultResolvers<ContextType>;
  MoneyManagerAutomationTarget?: MoneyManagerAutomationTargetResolvers<ContextType>;
  MoneyManagerCascadeObjective?: MoneyManagerCascadeObjectiveResolvers<ContextType>;
  MoneyManagerCascadeTarget?: MoneyManagerCascadeTargetResolvers<ContextType>;
  MoneyManagerCategoriesResult?: MoneyManagerCategoriesResultResolvers<ContextType>;
  MoneyManagerCategoriesSuccess?: MoneyManagerCategoriesSuccessResolvers<ContextType>;
  MoneyManagerCategory?: MoneyManagerCategoryResolvers<ContextType>;
  MoneyManagerCategoryAllocation?: MoneyManagerCategoryAllocationResolvers<ContextType>;
  MoneyManagerDeposit?: MoneyManagerDepositResolvers<ContextType>;
  MoneyManagerDepositAssignment?: MoneyManagerDepositAssignmentResolvers<ContextType>;
  MoneyManagerDepositSummary?: MoneyManagerDepositSummaryResolvers<ContextType>;
  MoneyManagerEligibilityResult?: MoneyManagerEligibilityResultResolvers<ContextType>;
  MoneyManagerError?: MoneyManagerErrorResolvers<ContextType>;
  MoneyManagerGlobalConfig?: MoneyManagerGlobalConfigResolvers<ContextType>;
  MoneyManagerInputError?: MoneyManagerInputErrorResolvers<ContextType>;
  MoneyManagerMoneyAssignment?: MoneyManagerMoneyAssignmentResolvers<ContextType>;
  MoneyManagerNormalizedAmounts?: MoneyManagerNormalizedAmountsResolvers<ContextType>;
  MoneyManagerPageInfo?: MoneyManagerPageInfoResolvers<ContextType>;
  MoneyManagerPaycheck?: MoneyManagerPaycheckResolvers<ContextType>;
  MoneyManagerPeriod?: MoneyManagerPeriodResolvers<ContextType>;
  MoneyManagerRebalanceAssignment?: MoneyManagerRebalanceAssignmentResolvers<ContextType>;
  MoneyManagerRebalanceResult?: MoneyManagerRebalanceResultResolvers<ContextType>;
  MoneyManagerRebalanceRuleset?: MoneyManagerRebalanceRulesetResolvers<ContextType>;
  MoneyManagerRebalancesResponse?: MoneyManagerRebalancesResponseResolvers<ContextType>;
  MoneyManagerRecurringDeposit?: MoneyManagerRecurringDepositResolvers<ContextType>;
  MoneyManagerRecurringDepositsConfig?: MoneyManagerRecurringDepositsConfigResolvers<ContextType>;
  MoneyManagerRulesetNotFoundError?: MoneyManagerRulesetNotFoundErrorResolvers<ContextType>;
  MoneyManagerScheduledDeposit?: MoneyManagerScheduledDepositResolvers<ContextType>;
  MoneyManagerScheduledPaycheck?: MoneyManagerScheduledPaycheckResolvers<ContextType>;
  MoneyManagerScheduledRecurringDeposit?: MoneyManagerScheduledRecurringDepositResolvers<ContextType>;
  MoneyManagerSettings?: MoneyManagerSettingsResolvers<ContextType>;
  MoneyManagerSourceSetting?: MoneyManagerSourceSettingResolvers<ContextType>;
  MoneyManagerSummary?: MoneyManagerSummaryResolvers<ContextType>;
  MoneyRulesArchetypesResult?: MoneyRulesArchetypesResultResolvers<ContextType>;
  MoneyRulesArchetypesSuccess?: MoneyRulesArchetypesSuccessResolvers<ContextType>;
  MoneyRulesCancelMoneyAssignmentSuccess?: MoneyRulesCancelMoneyAssignmentSuccessResolvers<ContextType>;
  MoneyRulesCondition?: MoneyRulesConditionResolvers<ContextType>;
  MoneyRulesCurrencyAmount?: MoneyRulesCurrencyAmountResolvers<ContextType>;
  MoneyRulesDestination?: MoneyRulesDestinationResolvers<ContextType>;
  MoneyRulesDistribution?: MoneyRulesDistributionResolvers<ContextType>;
  MoneyRulesMoneySource?: MoneyRulesMoneySourceResolvers<ContextType>;
  MoneyRulesMoneySplit?: MoneyRulesMoneySplitResolvers<ContextType>;
  MoneyRulesRule?: MoneyRulesRuleResolvers<ContextType>;
  MoneyRulesRuleset?: MoneyRulesRulesetResolvers<ContextType>;
  MoneyRulesRulesetNotFoundException?: MoneyRulesRulesetNotFoundExceptionResolvers<ContextType>;
  MoneyRulesSettings?: MoneyRulesSettingsResolvers<ContextType>;
  MoneyRulesSourceSetting?: MoneyRulesSourceSettingResolvers<ContextType>;
  MoneyRulesSuggestedSplits?: MoneyRulesSuggestedSplitsResolvers<ContextType>;
  MoneyRulesSuggestionResult?: MoneyRulesSuggestionResultResolvers<ContextType>;
  MoneyRulesUpdateArchetypeResult?: MoneyRulesUpdateArchetypeResultResolvers<ContextType>;
  MoneyRulesUpdateCustomerMoneyRulesResult?: MoneyRulesUpdateCustomerMoneyRulesResultResolvers<ContextType>;
  MoneyRulesUpdateRulesetSuccess?: MoneyRulesUpdateRulesetSuccessResolvers<ContextType>;
  MonthlyTotal?: MonthlyTotalResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NegativeSecurityPercentError?: NegativeSecurityPercentErrorResolvers<ContextType>;
  NegotiationServiceConnectionFailure?: NegotiationServiceConnectionFailureResolvers<ContextType>;
  NextBillingDate?: NextBillingDateResolvers<ContextType>;
  NextTransferDateResult?: NextTransferDateResultResolvers<ContextType>;
  NoBeneficiaryFoundException?: NoBeneficiaryFoundExceptionResolvers<ContextType>;
  NoFundingSourceUserAlert?: NoFundingSourceUserAlertResolvers<ContextType>;
  NoProspectRecord?: NoProspectRecordResolvers<ContextType>;
  NoRegisteredPushAuthenticatorsException?: NoRegisteredPushAuthenticatorsExceptionResolvers<ContextType>;
  NonBasicAccountOpenException?: NonBasicAccountOpenExceptionResolvers<ContextType>;
  NonUniqueSingleRuleIdsError?: NonUniqueSingleRuleIdsErrorResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationMessage?: NotificationMessageResolvers<ContextType>;
  Notifications?: NotificationsResolvers<ContextType>;
  OauthApp?: OauthAppResolvers<ContextType>;
  OauthAppClient?: OauthAppClientResolvers<ContextType>;
  OauthAppClientNotFoundException?: OauthAppClientNotFoundExceptionResolvers<ContextType>;
  OauthAppImageUpload?: OauthAppImageUploadResolvers<ContextType>;
  OauthAppNotFoundException?: OauthAppNotFoundExceptionResolvers<ContextType>;
  OauthAppScope?: OauthAppScopeResolvers<ContextType>;
  Occupation?: OccupationResolvers<ContextType>;
  Offer?: OfferResolvers<ContextType>;
  OfferExpiration?: OfferExpirationResolvers<ContextType>;
  OfferLocation?: OfferLocationResolvers<ContextType>;
  OfferPrice?: OfferPriceResolvers<ContextType>;
  Offering?: OfferingResolvers<ContextType>;
  OidcCredentialsAlreadyLinkedException?: OidcCredentialsAlreadyLinkedExceptionResolvers<ContextType>;
  OidcCredentialsNotFoundException?: OidcCredentialsNotFoundExceptionResolvers<ContextType>;
  OidcCredentialsTakenException?: OidcCredentialsTakenExceptionResolvers<ContextType>;
  OnboardingProductStatus?: OnboardingProductStatusResolvers<ContextType>;
  OnboardingProductTile?: OnboardingProductTileResolvers<ContextType>;
  OnboardingTileGroup?: OnboardingTileGroupResolvers<ContextType>;
  OnboardingTipItem?: OnboardingTipItemResolvers<ContextType>;
  OnboardingTips?: OnboardingTipsResolvers<ContextType>;
  OnlineSwitch?: OnlineSwitchResolvers<ContextType>;
  OpenAccountsException?: OpenAccountsExceptionResolvers<ContextType>;
  OpenCoreInvestmentAccountResult?: OpenCoreInvestmentAccountResultResolvers<ContextType>;
  OpenEarlyAccountResult?: OpenEarlyAccountResultResolvers<ContextType>;
  OrderBankCardResult?: OrderBankCardResultResolvers<ContextType>;
  OutsideContribution?: OutsideContributionResolvers<ContextType>;
  OutsideContributionCheckoutCart?: OutsideContributionCheckoutCartResolvers<ContextType>;
  OutsideContributionCode?: OutsideContributionCodeResolvers<ContextType>;
  OutsideContributionProspect?: OutsideContributionProspectResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PartnerDataShare?: PartnerDataShareResolvers<ContextType>;
  PartnerDataShareResponse?: PartnerDataShareResponseResolvers<ContextType>;
  PartnerDetailsResponse?: PartnerDetailsResponseResolvers<ContextType>;
  PartnerDocumentUrlResponse?: PartnerDocumentUrlResponseResolvers<ContextType>;
  PartnerOfferGroup?: PartnerOfferGroupResolvers<ContextType>;
  PartnerOfferGroupItem?: PartnerOfferGroupItemResolvers<ContextType>;
  PartnerUrlResponse?: PartnerUrlResponseResolvers<ContextType>;
  PasswordResetForm?: PasswordResetFormResolvers<ContextType>;
  PasswordResetFormFields?: PasswordResetFormFieldsResolvers<ContextType>;
  PastAnnotatedItem?: PastAnnotatedItemResolvers<ContextType>;
  PastBeneficiaryInfo?: PastBeneficiaryInfoResolvers<ContextType>;
  PastBeneficiaryTransferInvestmentItem?: PastBeneficiaryTransferInvestmentItemResolvers<ContextType>;
  PastCashOwedCollectionInvestmentItem?: PastCashOwedCollectionInvestmentItemResolvers<ContextType>;
  PastCashReinvestmentInvestmentItem?: PastCashReinvestmentInvestmentItemResolvers<ContextType>;
  PastCoreCombinedItem?: PastCoreCombinedItemResolvers<ContextType>;
  PastCoreItem?: PastCoreItemResolvers<ContextType>;
  PastCoreSummary?: PastCoreSummaryResolvers<ContextType>;
  PastCoreTradedItem?: PastCoreTradedItemResolvers<ContextType>;
  PastDividendInvestmentItem?: PastDividendInvestmentItemResolvers<ContextType>;
  PastEarlyItem?: PastEarlyItemResolvers<ContextType>;
  PastEarlySummary?: PastEarlySummaryResolvers<ContextType>;
  PastEmployeeContributionInvestmentItem?: PastEmployeeContributionInvestmentItemResolvers<ContextType>;
  PastExternalTransferInvestmentItem?: PastExternalTransferInvestmentItemResolvers<ContextType>;
  PastExternalTransferReversedInvestmentItem?: PastExternalTransferReversedInvestmentItemResolvers<ContextType>;
  PastFeeInvestmentItem?: PastFeeInvestmentItemResolvers<ContextType>;
  PastGiftCardInvestmentItem?: PastGiftCardInvestmentItemResolvers<ContextType>;
  PastIRATransferInvestmentItem?: PastIraTransferInvestmentItemResolvers<ContextType>;
  PastInvestmentItem?: PastInvestmentItemResolvers<ContextType>;
  PastItem?: PastItemResolvers<ContextType>;
  PastItemConnection?: PastItemConnectionResolvers<ContextType>;
  PastItemEdge?: PastItemEdgeResolvers<ContextType>;
  PastLaterSummary?: PastLaterSummaryResolvers<ContextType>;
  PastLumpSumInvestment?: PastLumpSumInvestmentResolvers<ContextType>;
  PastMatchInvestmentItem?: PastMatchInvestmentItemResolvers<ContextType>;
  PastMatchRemovalInvestmentItem?: PastMatchRemovalInvestmentItemResolvers<ContextType>;
  PastMoneyManagerAllocation?: PastMoneyManagerAllocationResolvers<ContextType>;
  PastMoneyManagerAllocations?: PastMoneyManagerAllocationsResolvers<ContextType>;
  PastMoneyManagerRecurrenceItem?: PastMoneyManagerRecurrenceItemResolvers<ContextType>;
  PastMoneyManagerScheduledPaycheckItem?: PastMoneyManagerScheduledPaycheckItemResolvers<ContextType>;
  PastOutsideContributionInvestmentItem?: PastOutsideContributionInvestmentItemResolvers<ContextType>;
  PastRealTimeRoundUpInvestmentItem?: PastRealTimeRoundUpInvestmentItemResolvers<ContextType>;
  PastRebalanceInvestmentItem?: PastRebalanceInvestmentItemResolvers<ContextType>;
  PastRecurrenceItem?: PastRecurrenceItemResolvers<ContextType>;
  PastRecurrenceItemV2?: PastRecurrenceItemV2Resolvers<ContextType>;
  PastRecurrenceSettings?: PastRecurrenceSettingsResolvers<ContextType>;
  PastRecurrenceSettingsV2?: PastRecurrenceSettingsV2Resolvers<ContextType>;
  PastRecurringInvestmentItem?: PastRecurringInvestmentItemResolvers<ContextType>;
  PastReferralRewardInvestmentItem?: PastReferralRewardInvestmentItemResolvers<ContextType>;
  PastReferralRewardMatchInvestmentItem?: PastReferralRewardMatchInvestmentItemResolvers<ContextType>;
  PastRefundInvestmentItem?: PastRefundInvestmentItemResolvers<ContextType>;
  PastReversalInvestmentItem?: PastReversalInvestmentItemResolvers<ContextType>;
  PastRewardInvestmentItem?: PastRewardInvestmentItemResolvers<ContextType>;
  PastRewardMatchInvestmentItem?: PastRewardMatchInvestmentItemResolvers<ContextType>;
  PastRoundUpItem?: PastRoundUpItemResolvers<ContextType>;
  PastRoundUpMatchInvestmentItem?: PastRoundUpMatchInvestmentItemResolvers<ContextType>;
  PastScheduledItem?: PastScheduledItemResolvers<ContextType>;
  PastScheduledItemV2?: PastScheduledItemV2Resolvers<ContextType>;
  PastSecurityLiquidationInvestmentItem?: PastSecurityLiquidationInvestmentItemResolvers<ContextType>;
  PastSmartDepositInvestmentItem?: PastSmartDepositInvestmentItemResolvers<ContextType>;
  PastSpendItem?: PastSpendItemResolvers<ContextType>;
  PastSpendSummary?: PastSpendSummaryResolvers<ContextType>;
  PastSplitDepositAllocationSettings?: PastSplitDepositAllocationSettingsResolvers<ContextType>;
  PastSplitDepositAllocationSettingsV2?: PastSplitDepositAllocationSettingsV2Resolvers<ContextType>;
  PastSplitDepositAllocations?: PastSplitDepositAllocationsResolvers<ContextType>;
  PastSplitDepositAllocationsV2?: PastSplitDepositAllocationsV2Resolvers<ContextType>;
  PastSplitDepositItem?: PastSplitDepositItemResolvers<ContextType>;
  PastSplitDepositItemV2?: PastSplitDepositItemV2Resolvers<ContextType>;
  PastSummary?: PastSummaryResolvers<ContextType>;
  PastTargetedTransferItem?: PastTargetedTransferItemResolvers<ContextType>;
  PastUserTransferItem?: PastUserTransferItemResolvers<ContextType>;
  PastWithdrawalInvestmentItem?: PastWithdrawalInvestmentItemResolvers<ContextType>;
  PayoutRelationshipResult?: PayoutRelationshipResultResolvers<ContextType>;
  PdfDownloadUrlPayload?: PdfDownloadUrlPayloadResolvers<ContextType>;
  Performance?: PerformanceResolvers<ContextType>;
  Phone?: PhoneResolvers<ContextType>;
  PhoneAuthenticator?: PhoneAuthenticatorResolvers<ContextType>;
  PhoneNumber?: GraphQLScalarType;
  PhoneNumberOptedOutException?: PhoneNumberOptedOutExceptionResolvers<ContextType>;
  PhoneRedirect?: PhoneRedirectResolvers<ContextType>;
  PlaidLayerLinkSession?: PlaidLayerLinkSessionResolvers<ContextType>;
  PoliciesRecordDoesNotExistException?: PoliciesRecordDoesNotExistExceptionResolvers<ContextType>;
  Policy?: PolicyResolvers<ContextType>;
  PolicyNotAddedException?: PolicyNotAddedExceptionResolvers<ContextType>;
  Portfolio?: PortfolioResolvers<ContextType>;
  PortfolioAllocation?: PortfolioAllocationResolvers<ContextType>;
  PortfolioAlreadyRemovedError?: PortfolioAlreadyRemovedErrorResolvers<ContextType>;
  PortfolioHolding?: PortfolioHoldingResolvers<ContextType>;
  PortfolioNotFoundException?: PortfolioNotFoundExceptionResolvers<ContextType>;
  PortfolioNotSupportedException?: PortfolioNotSupportedExceptionResolvers<ContextType>;
  PortfolioProjection?: PortfolioProjectionResolvers<ContextType>;
  PortfolioRemovalInProgressError?: PortfolioRemovalInProgressErrorResolvers<ContextType>;
  PortfolioSecurity?: PortfolioSecurityResolvers<ContextType>;
  PortfolioSecurityAllocation?: PortfolioSecurityAllocationResolvers<ContextType>;
  PortfolioSecurityLimitReached?: PortfolioSecurityLimitReachedResolvers<ContextType>;
  PortfolioUpdateFailedException?: PortfolioUpdateFailedExceptionResolvers<ContextType>;
  PositiveFloat?: GraphQLScalarType;
  PreferredAccountNotEligibleError?: PreferredAccountNotEligibleErrorResolvers<ContextType>;
  PreferredAccountNotSupportedError?: PreferredAccountNotSupportedErrorResolvers<ContextType>;
  PresentableProduct?: PresentableProductResolvers<ContextType>;
  PreviousFundingSourcePending?: PreviousFundingSourcePendingResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  ProductNotSupportedException?: ProductNotSupportedExceptionResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  PromoCode?: PromoCodeResolvers<ContextType>;
  PromoCodeCustomer?: PromoCodeCustomerResolvers<ContextType>;
  PromoCodeEdge?: PromoCodeEdgeResolvers<ContextType>;
  PromoCodeFieldLengthError?: PromoCodeFieldLengthErrorResolvers<ContextType>;
  PromoCodePaginatedInfo?: PromoCodePaginatedInfoResolvers<ContextType>;
  PromoCodeReward?: PromoCodeRewardResolvers<ContextType>;
  PromoCodeRewardEdge?: PromoCodeRewardEdgeResolvers<ContextType>;
  PromoCodeRewardsConnection?: PromoCodeRewardsConnectionResolvers<ContextType>;
  PromoCodesConnection?: PromoCodesConnectionResolvers<ContextType>;
  PromoOffer?: PromoOfferResolvers<ContextType>;
  PromotedBenefit?: PromotedBenefitResolvers<ContextType>;
  PromotedCampaigns?: PromotedCampaignsResolvers<ContextType>;
  Promotion?: PromotionResolvers<ContextType>;
  PromotionConsumedError?: PromotionConsumedErrorResolvers<ContextType>;
  PromotionDuration?: PromotionDurationResolvers<ContextType>;
  PromotionExpiredError?: PromotionExpiredErrorResolvers<ContextType>;
  PromotionNotFoundError?: PromotionNotFoundErrorResolvers<ContextType>;
  PromotionalWaiver?: PromotionalWaiverResolvers<ContextType>;
  PromotionalWaiver_V2?: PromotionalWaiver_V2Resolvers<ContextType>;
  Prospect?: ProspectResolvers<ContextType>;
  ProvisionalWaiver?: ProvisionalWaiverResolvers<ContextType>;
  ProvisionalWaiver_V2?: ProvisionalWaiver_V2Resolvers<ContextType>;
  PushAuthChallenge?: PushAuthChallengeResolvers<ContextType>;
  PushAuthenticator?: PushAuthenticatorResolvers<ContextType>;
  PushAuthenticatorAlreadyExistsException?: PushAuthenticatorAlreadyExistsExceptionResolvers<ContextType>;
  QualificationSubTypeMismatchError?: QualificationSubTypeMismatchErrorResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Quiz?: QuizResolvers<ContextType>;
  QuizLocked?: QuizLockedResolvers<ContextType>;
  QuizPreview?: QuizPreviewResolvers<ContextType>;
  QuizPreviewLocked?: QuizPreviewLockedResolvers<ContextType>;
  QuizTheme?: QuizThemeResolvers<ContextType>;
  RateLimitDoesNotExistException?: RateLimitDoesNotExistExceptionResolvers<ContextType>;
  RateLimitStatus?: RateLimitStatusResolvers<ContextType>;
  RawLinkSession?: RawLinkSessionResolvers<ContextType>;
  RdvRequiredUserAlert?: RdvRequiredUserAlertResolvers<ContextType>;
  RdvVerificationRequired?: RdvVerificationRequiredResolvers<ContextType>;
  RdvsNotTriggered?: RdvsNotTriggeredResolvers<ContextType>;
  RebalanceAlreadyExecutedError?: RebalanceAlreadyExecutedErrorResolvers<ContextType>;
  RebalanceSourceInsufficientBalanceError?: RebalanceSourceInsufficientBalanceErrorResolvers<ContextType>;
  RecaptchaException?: RecaptchaExceptionResolvers<ContextType>;
  RecommendedInvestingStrategy?: RecommendedInvestingStrategyResolvers<ContextType>;
  RecordDoesNotExistError?: RecordDoesNotExistErrorResolvers<ContextType>;
  RecordInvestmentAccountRecapViewResult?: RecordInvestmentAccountRecapViewResultResolvers<ContextType>;
  RecordReferralEventResult?: RecordReferralEventResultResolvers<ContextType>;
  RecordVendorExternalTransactionResult?: RecordVendorExternalTransactionResultResolvers<ContextType>;
  RecurrenceRule?: RecurrenceRuleResolvers<ContextType>;
  RecurringInvestmentPayload?: RecurringInvestmentPayloadResolvers<ContextType>;
  RecurringInvestmentSettings?: RecurringInvestmentSettingsResolvers<ContextType>;
  RecurringTransfer?: RecurringTransferResolvers<ContextType>;
  RecurringTransferAccount?: RecurringTransferAccountResolvers<ContextType>;
  RecurringTransferDate?: RecurringTransferDateResolvers<ContextType>;
  RecurringTransferEvent?: RecurringTransferEventResolvers<ContextType>;
  RecurringTransferFundingSource?: RecurringTransferFundingSourceResolvers<ContextType>;
  RecurringTransferPathException?: RecurringTransferPathExceptionResolvers<ContextType>;
  RedeemedWaiverCoupon?: RedeemedWaiverCouponResolvers<ContextType>;
  Referral?: ReferralResolvers<ContextType>;
  ReferralCampaign?: ReferralCampaignResolvers<ContextType>;
  ReferralCampaignConnection?: ReferralCampaignConnectionResolvers<ContextType>;
  ReferralCampaignEdge?: ReferralCampaignEdgeResolvers<ContextType>;
  ReferralCampaignReward?: ReferralCampaignRewardResolvers<ContextType>;
  ReferralCampaignV2?: ReferralCampaignV2Resolvers<ContextType>;
  ReferralCode?: GraphQLScalarType;
  ReferralEvent?: ReferralEventResolvers<ContextType>;
  ReferralEventV2?: ReferralEventV2Resolvers<ContextType>;
  ReferralHistory?: ReferralHistoryResolvers<ContextType>;
  ReferralPaginatedInfo?: ReferralPaginatedInfoResolvers<ContextType>;
  ReferralPayout?: ReferralPayoutResolvers<ContextType>;
  ReferralPayoutConnection?: ReferralPayoutConnectionResolvers<ContextType>;
  ReferralPayoutEdge?: ReferralPayoutEdgeResolvers<ContextType>;
  ReferralPayoutExistsError?: ReferralPayoutExistsErrorResolvers<ContextType>;
  ReferralPayoutRelationship?: ReferralPayoutRelationshipResolvers<ContextType>;
  ReferralRelationship?: ReferralRelationshipResolvers<ContextType>;
  ReferralRelationshipConnection?: ReferralRelationshipConnectionResolvers<ContextType>;
  ReferralRelationshipEdge?: ReferralRelationshipEdgeResolvers<ContextType>;
  ReferralRelationshipMissingError?: ReferralRelationshipMissingErrorResolvers<ContextType>;
  ReferralReward?: ReferralRewardResolvers<ContextType>;
  ReferralRewardEdge?: ReferralRewardEdgeResolvers<ContextType>;
  ReferralRewardSummary?: ReferralRewardSummaryResolvers<ContextType>;
  ReferralRewardsConnection?: ReferralRewardsConnectionResolvers<ContextType>;
  RefreshAuthTokenRateLimitedException?: RefreshAuthTokenRateLimitedExceptionResolvers<ContextType>;
  RefreshAuthTokenResult?: RefreshAuthTokenResultResolvers<ContextType>;
  RefreshTokenNotFoundException?: RefreshTokenNotFoundExceptionResolvers<ContextType>;
  RefundBankAccount?: RefundBankAccountResolvers<ContextType>;
  RegenerateInvestmentAccountRecapPublicTokenResult?: RegenerateInvestmentAccountRecapPublicTokenResultResolvers<ContextType>;
  RegisterAccountTypeResult?: RegisterAccountTypeResultResolvers<ContextType>;
  RegisterAccountTypeResultTemporaryImpl?: RegisterAccountTypeResultTemporaryImplResolvers<ContextType>;
  RegisterCredentialsResult?: RegisterCredentialsResultResolvers<ContextType>;
  RegisterDeviceTokenAndPushAuthenticatorResult?: RegisterDeviceTokenAndPushAuthenticatorResultResolvers<ContextType>;
  RegisterEmailAuthenticatorResult?: RegisterEmailAuthenticatorResultResolvers<ContextType>;
  RegisterLayerLinkSessionResult?: RegisterLayerLinkSessionResultResolvers<ContextType>;
  RegisterLinkSessionResult?: RegisterLinkSessionResultResolvers<ContextType>;
  RegisterOidcCredentialsResult?: RegisterOidcCredentialsResultResolvers<ContextType>;
  RegisterPhoneAuthenticatorResult?: RegisterPhoneAuthenticatorResultResolvers<ContextType>;
  RegisterPhoneAuthenticatorWithoutChallengeResult?: RegisterPhoneAuthenticatorWithoutChallengeResultResolvers<ContextType>;
  RegisterProspectResult?: RegisterProspectResultResolvers<ContextType>;
  RegistrationDrawerContent?: RegistrationDrawerContentResolvers<ContextType>;
  RegistrationFunnel?: RegistrationFunnelResolvers<ContextType>;
  RegistrationPage?: RegistrationPageResolvers<ContextType>;
  RegistrationPageAction?: RegistrationPageActionResolvers<ContextType>;
  RegistrationPageContent?: RegistrationPageContentResolvers<ContextType>;
  RegistrationProminenceBannerContent?: RegistrationProminenceBannerContentResolvers<ContextType>;
  ReinitiateSMSChallengeResult?: ReinitiateSmsChallengeResultResolvers<ContextType>;
  ReissueBankCardEligibility?: ReissueBankCardEligibilityResolvers<ContextType>;
  ReissueBankCardEligible?: ReissueBankCardEligibleResolvers<ContextType>;
  ReissueBankCardExistsError?: ReissueBankCardExistsErrorResolvers<ContextType>;
  ReissueBankCardIneligible?: ReissueBankCardIneligibleResolvers<ContextType>;
  ReissueBankCardResult?: ReissueBankCardResultResolvers<ContextType>;
  RelationshipAlreadyQualifiedError?: RelationshipAlreadyQualifiedErrorResolvers<ContextType>;
  RelinkLinkedAccountAlert?: RelinkLinkedAccountAlertResolvers<ContextType>;
  RemoveAccountTypeResult?: RemoveAccountTypeResultResolvers<ContextType>;
  RemoveAccountTypeResultTemporaryImpl?: RemoveAccountTypeResultTemporaryImplResolvers<ContextType>;
  RemoveCohortEligibilityResult?: RemoveCohortEligibilityResultResolvers<ContextType>;
  RemoveJobAlertResult?: RemoveJobAlertResultResolvers<ContextType>;
  RemovePolicyResult?: RemovePolicyResultResolvers<ContextType>;
  RemoveSecurityFromPortfolioResult?: RemoveSecurityFromPortfolioResultResolvers<ContextType>;
  RemoveSelfDirectedPortfolioResult?: RemoveSelfDirectedPortfolioResultResolvers<ContextType>;
  RemovedJobAlert?: RemovedJobAlertResolvers<ContextType>;
  ReopenUserAccountResult?: ReopenUserAccountResultResolvers<ContextType>;
  ReplayMoneyAssignmentError?: ReplayMoneyAssignmentErrorResolvers<ContextType>;
  ReplayMoneyAssignmentSuccess?: ReplayMoneyAssignmentSuccessResolvers<ContextType>;
  ReplayMoneyManagerMoneyAssignmentResult?: ReplayMoneyManagerMoneyAssignmentResultResolvers<ContextType>;
  ReportBankCardLostStolenPayload?: ReportBankCardLostStolenPayloadResolvers<ContextType>;
  RequestEarlyAccountClosureResult?: RequestEarlyAccountClosureResultResolvers<ContextType>;
  RequestInvestmentAccountReopenResult?: RequestInvestmentAccountReopenResultResolvers<ContextType>;
  RequestLayerSessionResult?: RequestLayerSessionResultResolvers<ContextType>;
  RequestSubscriptionMigrationWaiverResult?: RequestSubscriptionMigrationWaiverResultResolvers<ContextType>;
  RequestedLayerLinkSession?: RequestedLayerLinkSessionResolvers<ContextType>;
  ResendChatMessageResponse?: ResendChatMessageResponseResolvers<ContextType>;
  ResetPasswordByTokenException?: ResetPasswordByTokenExceptionResolvers<ContextType>;
  ResetPasswordByTokenResult?: ResetPasswordByTokenResultResolvers<ContextType>;
  ResetPasswordByTokenSuccess?: ResetPasswordByTokenSuccessResolvers<ContextType>;
  ResetPasswordWithTokenResult?: ResetPasswordWithTokenResultResolvers<ContextType>;
  ResetPasswordWithTokenSuccess?: ResetPasswordWithTokenSuccessResolvers<ContextType>;
  ResetRateLimitResult?: ResetRateLimitResultResolvers<ContextType>;
  ResetRateLimitSuccess?: ResetRateLimitSuccessResolvers<ContextType>;
  ResourceNotFoundError?: ResourceNotFoundErrorResolvers<ContextType>;
  RespondToLearnPollResult?: RespondToLearnPollResultResolvers<ContextType>;
  RestoreLoginAccessResult?: RestoreLoginAccessResultResolvers<ContextType>;
  Result?: ResultResolvers<ContextType>;
  RetriggerRdvsResult?: RetriggerRdvsResultResolvers<ContextType>;
  ReturnedCheckDeposit?: ReturnedCheckDepositResolvers<ContextType>;
  RevokeLoginAccessResult?: RevokeLoginAccessResultResolvers<ContextType>;
  RevokePasswordResetTokenResult?: RevokePasswordResetTokenResultResolvers<ContextType>;
  RevokePasswordResetTokenSuccess?: RevokePasswordResetTokenSuccessResolvers<ContextType>;
  RoundUp?: RoundUpResolvers<ContextType>;
  RoundUpAccount?: RoundUpAccountResolvers<ContextType>;
  RoundUpProfile?: RoundUpProfileResolvers<ContextType>;
  RoundUpTypeEdge?: RoundUpTypeEdgeResolvers<ContextType>;
  RoundUpTypePagination?: RoundUpTypePaginationResolvers<ContextType>;
  RoutingNumber?: GraphQLScalarType;
  SMSAuthChallenge?: SmsAuthChallengeResolvers<ContextType>;
  SSNDocumentRequestedUserAlert?: SsnDocumentRequestedUserAlertResolvers<ContextType>;
  SamePasswordsException?: SamePasswordsExceptionResolvers<ContextType>;
  SampleMailInDocument?: SampleMailInDocumentResolvers<ContextType>;
  SaveInterestPaidItem?: SaveInterestPaidItemResolvers<ContextType>;
  SaveTransferInItem?: SaveTransferInItemResolvers<ContextType>;
  SaveTransferOutItem?: SaveTransferOutItemResolvers<ContextType>;
  SaveUploadUrlsResult?: SaveUploadUrlsResultResolvers<ContextType>;
  SavingsAccountEligibility?: SavingsAccountEligibilityResolvers<ContextType>;
  ScheduleRecurringTransferResult?: ScheduleRecurringTransferResultResolvers<ContextType>;
  ScheduleResult?: ScheduleResultResolvers<ContextType>;
  Scope?: ScopeResolvers<ContextType>;
  SearchEmployersPayload?: SearchEmployersPayloadResolvers<ContextType>;
  SearchHistory?: SearchHistoryResolvers<ContextType>;
  SearchSecuritiesPageInfo?: SearchSecuritiesPageInfoResolvers<ContextType>;
  SearchSecuritiesResponse?: SearchSecuritiesResponseResolvers<ContextType>;
  SearchSupportArticleResult?: SearchSupportArticleResultResolvers<ContextType>;
  SearchSupportResult?: SearchSupportResultResolvers<ContextType>;
  SecretSquirrelException?: SecretSquirrelExceptionResolvers<ContextType>;
  SecuritiesBySectorPageInfo?: SecuritiesBySectorPageInfoResolvers<ContextType>;
  SecuritiesBySectorResponse?: SecuritiesBySectorResponseResolvers<ContextType>;
  SecuritiesBySymbolsResponse?: SecuritiesBySymbolsResponseResolvers<ContextType>;
  Security?: SecurityResolvers<ContextType>;
  SecurityDiversificationInfo?: SecurityDiversificationInfoResolvers<ContextType>;
  SecurityGain?: SecurityGainResolvers<ContextType>;
  SecurityHeadline?: SecurityHeadlineResolvers<ContextType>;
  SecurityNotSupportedException?: SecurityNotSupportedExceptionResolvers<ContextType>;
  SecurityPerformance?: SecurityPerformanceResolvers<ContextType>;
  SecurityPrice?: SecurityPriceResolvers<ContextType>;
  SecurityProfile?: SecurityProfileResolvers<ContextType>;
  SelfDirectedPortfolio?: SelfDirectedPortfolioResolvers<ContextType>;
  SendChatMessageResponse?: SendChatMessageResponseResolvers<ContextType>;
  SendCheckPaymentResult?: SendCheckPaymentResultResolvers<ContextType>;
  Session?: SessionResolvers<ContextType>;
  SetAuthenticationPINResult?: SetAuthenticationPinResultResolvers<ContextType>;
  SetAuthenticationPINSuccess?: SetAuthenticationPinSuccessResolvers<ContextType>;
  SetBeneficiarySsnResult?: SetBeneficiarySsnResultResolvers<ContextType>;
  SetDefaultAuthenticatorResult?: SetDefaultAuthenticatorResultResolvers<ContextType>;
  SetInvestmentAccountRecapPublicAccessResult?: SetInvestmentAccountRecapPublicAccessResultResolvers<ContextType>;
  SetNegotiationStatusResult?: SetNegotiationStatusResultResolvers<ContextType>;
  SetPreferredWithdrawalAccountResult?: SetPreferredWithdrawalAccountResultResolvers<ContextType>;
  SetReferralCampaignFlagsResult?: SetReferralCampaignFlagsResultResolvers<ContextType>;
  SetUpTip?: SetUpTipResolvers<ContextType>;
  Settings?: SettingsResolvers<ContextType>;
  Signature?: SignatureResolvers<ContextType>;
  SiteWideBannerContent?: SiteWideBannerContentResolvers<ContextType>;
  SmartDepositMetadataResult?: SmartDepositMetadataResultResolvers<ContextType>;
  SourceAttributes?: SourceAttributesResolvers<ContextType>;
  SpendATMReimbursementItem?: SpendAtmReimbursementItemResolvers<ContextType>;
  SpendATMWithdrawalItem?: SpendAtmWithdrawalItemResolvers<ContextType>;
  SpendAccount?: SpendAccountResolvers<ContextType>;
  SpendAlert?: SpendAlertResolvers<ContextType>;
  SpendAtm?: SpendAtmResolvers<ContextType>;
  SpendAtmAddress?: SpendAtmAddressResolvers<ContextType>;
  SpendAtmVendorUnavailableError?: SpendAtmVendorUnavailableErrorResolvers<ContextType>;
  SpendAtmsPayload?: SpendAtmsPayloadResolvers<ContextType>;
  SpendAtmsResult?: SpendAtmsResultResolvers<ContextType>;
  SpendBillPayItem?: SpendBillPayItemResolvers<ContextType>;
  SpendCheckDepositItem?: SpendCheckDepositItemResolvers<ContextType>;
  SpendCheckPaymentItem?: SpendCheckPaymentItemResolvers<ContextType>;
  SpendDigitalWalletItem?: SpendDigitalWalletItemResolvers<ContextType>;
  SpendDirectDepositItem?: SpendDirectDepositItemResolvers<ContextType>;
  SpendDisputesResponse?: SpendDisputesResponseResolvers<ContextType>;
  SpendECheckItem?: SpendECheckItemResolvers<ContextType>;
  SpendInterestPaidItem?: SpendInterestPaidItemResolvers<ContextType>;
  SpendItem?: SpendItemResolvers<ContextType>;
  SpendPurchaseItem?: SpendPurchaseItemResolvers<ContextType>;
  SpendRealTimeRoundUpItem?: SpendRealTimeRoundUpItemResolvers<ContextType>;
  SpendTransactionsDisputeCustomersResponse?: SpendTransactionsDisputeCustomersResponseResolvers<ContextType>;
  SpendTransactionsDisputeQuestions?: SpendTransactionsDisputeQuestionsResolvers<ContextType>;
  SpendTransactionsDisputeResponse?: SpendTransactionsDisputeResponseResolvers<ContextType>;
  SpendTransactionsDisputeResult?: SpendTransactionsDisputeResultResolvers<ContextType>;
  SpendTransactionsResponse?: SpendTransactionsResponseResolvers<ContextType>;
  SpendTransferInItem?: SpendTransferInItemResolvers<ContextType>;
  SpendTransferOutItem?: SpendTransferOutItemResolvers<ContextType>;
  SplitDeposit?: SplitDepositResolvers<ContextType>;
  SplitDepositAllocation?: SplitDepositAllocationResolvers<ContextType>;
  SplitDepositDailyRecurrenceRule?: SplitDepositDailyRecurrenceRuleResolvers<ContextType>;
  SplitDepositDirectDepositAllocation?: SplitDepositDirectDepositAllocationResolvers<ContextType>;
  SplitDepositDirectDepositIntentSetting?: SplitDepositDirectDepositIntentSettingResolvers<ContextType>;
  SplitDepositDirectDepositSetting?: SplitDepositDirectDepositSettingResolvers<ContextType>;
  SplitDepositMonthlyRecurrenceRule?: SplitDepositMonthlyRecurrenceRuleResolvers<ContextType>;
  SplitDepositMutation?: SplitDepositMutationResolvers<ContextType>;
  SplitDepositRecurrenceAllocation?: SplitDepositRecurrenceAllocationResolvers<ContextType>;
  SplitDepositRecurrenceRule?: SplitDepositRecurrenceRuleResolvers<ContextType>;
  SplitDepositRecurrenceSetting?: SplitDepositRecurrenceSettingResolvers<ContextType>;
  SplitDepositSettings?: SplitDepositSettingsResolvers<ContextType>;
  SplitDepositSettingsMutation?: SplitDepositSettingsMutationResolvers<ContextType>;
  SplitDepositTargetAccount?: SplitDepositTargetAccountResolvers<ContextType>;
  SplitDepositWeeklyRecurrenceRule?: SplitDepositWeeklyRecurrenceRuleResolvers<ContextType>;
  SsnAlreadyInUseException?: SsnAlreadyInUseExceptionResolvers<ContextType>;
  SsnMatchesCustodianException?: SsnMatchesCustodianExceptionResolvers<ContextType>;
  SsnUpdateForbiddenException?: SsnUpdateForbiddenExceptionResolvers<ContextType>;
  StartCheckDepositPayload?: StartCheckDepositPayloadResolvers<ContextType>;
  StartOnlineSwitchPayload?: StartOnlineSwitchPayloadResolvers<ContextType>;
  StartSubmittableSwitchPayload?: StartSubmittableSwitchPayloadResolvers<ContextType>;
  Statement?: StatementResolvers<ContextType>;
  StatementEdge?: StatementEdgeResolvers<ContextType>;
  StatementLink?: StatementLinkResolvers<ContextType>;
  StatementPagination?: StatementPaginationResolvers<ContextType>;
  Stock?: StockResolvers<ContextType>;
  StoredRdvDepositsInvalid?: StoredRdvDepositsInvalidResolvers<ContextType>;
  StoredRdvDepositsMissing?: StoredRdvDepositsMissingResolvers<ContextType>;
  StringKey?: GraphQLScalarType;
  StringKeyAsset?: StringKeyAssetResolvers<ContextType>;
  SubcategoryMessage?: SubcategoryMessageResolvers<ContextType>;
  Submission?: SubmissionResolvers<ContextType>;
  SubmissionError?: SubmissionErrorResolvers<ContextType>;
  SubmitBankFeeNegotiationResponse?: SubmitBankFeeNegotiationResponseResolvers<ContextType>;
  SubmitBankFeeNegotiationResult?: SubmitBankFeeNegotiationResultResolvers<ContextType>;
  SubmitEarnMissingCreditRequestResult?: SubmitEarnMissingCreditRequestResultResolvers<ContextType>;
  SubmitUserReportedBankFeeRefundResult?: SubmitUserReportedBankFeeRefundResultResolvers<ContextType>;
  SubmittableSwitch?: SubmittableSwitchResolvers<ContextType>;
  SubscribeToTierResult?: SubscribeToTierResultResolvers<ContextType>;
  SubscribeUserToTierResult?: SubscribeUserToTierResultResolvers<ContextType>;
  SubscriberIneligibleError?: SubscriberIneligibleErrorResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionMigration?: SubscriptionMigrationResolvers<ContextType>;
  SubscriptionMigrationInvalidError?: SubscriptionMigrationInvalidErrorResolvers<ContextType>;
  SubscriptionMigrationWaiver?: SubscriptionMigrationWaiverResolvers<ContextType>;
  SucceedVendorInvoiceResult?: SucceedVendorInvoiceResultResolvers<ContextType>;
  SuggestedMoneyRulesResult?: SuggestedMoneyRulesResultResolvers<ContextType>;
  SuggestedMoneyRulesSuccess?: SuggestedMoneyRulesSuccessResolvers<ContextType>;
  SuitabilityAnswer?: SuitabilityAnswerResolvers<ContextType>;
  SuitabilityQuestion?: SuitabilityQuestionResolvers<ContextType>;
  SummaryItem?: SummaryItemResolvers<ContextType>;
  SupportArticle?: SupportArticleResolvers<ContextType>;
  SupportAuthor?: SupportAuthorResolvers<ContextType>;
  SupportAuthorPhoto?: SupportAuthorPhotoResolvers<ContextType>;
  SupportCategory?: SupportCategoryResolvers<ContextType>;
  SupportCitation?: SupportCitationResolvers<ContextType>;
  SupportSection?: SupportSectionResolvers<ContextType>;
  SupportTicket?: SupportTicketResolvers<ContextType>;
  SupportTicketForm?: SupportTicketFormResolvers<ContextType>;
  SupportTicketFormField?: SupportTicketFormFieldResolvers<ContextType>;
  SupportTicketResponse?: SupportTicketResponseResolvers<ContextType>;
  SupportTicketWithCustomFieldsResponse?: SupportTicketWithCustomFieldsResponseResolvers<ContextType>;
  SupportUser?: SupportUserResolvers<ContextType>;
  SupportsPlaidVerificationResult?: SupportsPlaidVerificationResultResolvers<ContextType>;
  SuppressMoneyManagerRebalancesError?: SuppressMoneyManagerRebalancesErrorResolvers<ContextType>;
  SuppressMoneyManagerRebalancesResult?: SuppressMoneyManagerRebalancesResultResolvers<ContextType>;
  SuppressMoneyManagerRebalancesSuccess?: SuppressMoneyManagerRebalancesSuccessResolvers<ContextType>;
  SwitchInterface?: SwitchInterfaceResolvers<ContextType>;
  SwitchPayloadInterface?: SwitchPayloadInterfaceResolvers<ContextType>;
  SyncBankFeeTransactionsResult?: SyncBankFeeTransactionsResultResolvers<ContextType>;
  SyncFundingSourceToVendorResult?: SyncFundingSourceToVendorResultResolvers<ContextType>;
  SyncSupportAccountResponse?: SyncSupportAccountResponseResolvers<ContextType>;
  SystemCardLockedSpendAlert?: SystemCardLockedSpendAlertResolvers<ContextType>;
  TaxFilingPartner?: TaxFilingPartnerResolvers<ContextType>;
  TaxReturn?: TaxReturnResolvers<ContextType>;
  TaxWithholdingAmounts?: TaxWithholdingAmountsResolvers<ContextType>;
  TfaOptions?: TfaOptionsResolvers<ContextType>;
  TickerSymbol?: GraphQLScalarType;
  Tier?: TierResolvers<ContextType>;
  TierDowngradeAction?: TierDowngradeActionResolvers<ContextType>;
  TierDowngradeActionRequired?: TierDowngradeActionRequiredResolvers<ContextType>;
  TierGroup?: TierGroupResolvers<ContextType>;
  TierOption?: TierOptionResolvers<ContextType>;
  TierOptionByTierPriceIdResult?: TierOptionByTierPriceIdResultResolvers<ContextType>;
  TierPrice?: TierPriceResolvers<ContextType>;
  TierProduct?: TierProductResolvers<ContextType>;
  TierSubscription?: TierSubscriptionResolvers<ContextType>;
  TierSubscriptionAlreadyDeactivated?: TierSubscriptionAlreadyDeactivatedResolvers<ContextType>;
  TierSubscriptionConnection?: TierSubscriptionConnectionResolvers<ContextType>;
  TierSubscriptionForUser?: TierSubscriptionForUserResolvers<ContextType>;
  TierSubscriptionNotFound?: TierSubscriptionNotFoundResolvers<ContextType>;
  TierSubscriptionPageInfo?: TierSubscriptionPageInfoResolvers<ContextType>;
  TierSubscriptionTransition?: TierSubscriptionTransitionResolvers<ContextType>;
  TierSubscriptionUnsubscribed?: TierSubscriptionUnsubscribedResolvers<ContextType>;
  Time?: GraphQLScalarType;
  TimestampsInterface?: TimestampsInterfaceResolvers<ContextType>;
  Toggle?: ToggleResolvers<ContextType>;
  TokenExpiredException?: TokenExpiredExceptionResolvers<ContextType>;
  TopEmployer?: TopEmployerResolvers<ContextType>;
  TopEmployerPayload?: TopEmployerPayloadResolvers<ContextType>;
  TopHolding?: TopHoldingResolvers<ContextType>;
  TotalAmounts?: TotalAmountsResolvers<ContextType>;
  Transaction?: TransactionResolvers<ContextType>;
  Transfer?: TransferResolvers<ContextType>;
  TransferableAccount?: TransferableAccountResolvers<ContextType>;
  TransferableFrom?: TransferableFromResolvers<ContextType>;
  TransferableTo?: TransferableToResolvers<ContextType>;
  TrendingLearnContentPreview?: TrendingLearnContentPreviewResolvers<ContextType>;
  TrustedContact?: TrustedContactResolvers<ContextType>;
  TrustedContactAlreadyExistsException?: TrustedContactAlreadyExistsExceptionResolvers<ContextType>;
  TrustedContactInvalidEmail?: TrustedContactInvalidEmailResolvers<ContextType>;
  TrustedContactInvalidPhoneNumber?: TrustedContactInvalidPhoneNumberResolvers<ContextType>;
  TrustedContactNotFoundException?: TrustedContactNotFoundExceptionResolvers<ContextType>;
  URL?: GraphQLScalarType;
  USStateName?: GraphQLScalarType;
  UUID?: GraphQLScalarType;
  UnableToCancelCheckError?: UnableToCancelCheckErrorResolvers<ContextType>;
  UnauthenticatedSaveUploadUrlResult?: UnauthenticatedSaveUploadUrlResultResolvers<ContextType>;
  UnauthorizedException?: UnauthorizedExceptionResolvers<ContextType>;
  UnauthorizedModifyLockedContentError?: UnauthorizedModifyLockedContentErrorResolvers<ContextType>;
  UnblockDeviceResult?: UnblockDeviceResultResolvers<ContextType>;
  UnlinkOidcCredentialsResult?: UnlinkOidcCredentialsResultResolvers<ContextType>;
  UnlinkOidcCredentialsSuccess?: UnlinkOidcCredentialsSuccessResolvers<ContextType>;
  UnlockBankCardPayload?: UnlockBankCardPayloadResolvers<ContextType>;
  UnmarkLearnContentAsHelpfulResult?: UnmarkLearnContentAsHelpfulResultResolvers<ContextType>;
  UnmetRequirementsException?: UnmetRequirementsExceptionResolvers<ContextType>;
  UnrecoverableError?: UnrecoverableErrorResolvers<ContextType>;
  UnrecoverableLinkedAccountError?: UnrecoverableLinkedAccountErrorResolvers<ContextType>;
  UnsubscribeUserFromTierResult?: UnsubscribeUserFromTierResultResolvers<ContextType>;
  UnverifiedBeneficiarySsnAlert?: UnverifiedBeneficiarySsnAlertResolvers<ContextType>;
  UnverifiedBeneficiarySsnAlertItem?: UnverifiedBeneficiarySsnAlertItemResolvers<ContextType>;
  UpdateAccountPortfolioResponse?: UpdateAccountPortfolioResponseResolvers<ContextType>;
  UpdateAttributionResult?: UpdateAttributionResultResolvers<ContextType>;
  UpdateAuthEmailResult?: UpdateAuthEmailResultResolvers<ContextType>;
  UpdateAuthPhoneNumberResult?: UpdateAuthPhoneNumberResultResolvers<ContextType>;
  UpdateBankAccountGoalPayload?: UpdateBankAccountGoalPayloadResolvers<ContextType>;
  UpdateBankAccountGoalResult?: UpdateBankAccountGoalResultResolvers<ContextType>;
  UpdateBankCardPinPayload?: UpdateBankCardPinPayloadResolvers<ContextType>;
  UpdateBeneficiaryInfoResult?: UpdateBeneficiaryInfoResultResolvers<ContextType>;
  UpdateBenefitStatusResponse?: UpdateBenefitStatusResponseResolvers<ContextType>;
  UpdateCredentialsResult?: UpdateCredentialsResultResolvers<ContextType>;
  UpdateDelegateResult?: UpdateDelegateResultResolvers<ContextType>;
  UpdateElapsedTimeForLearnQuizResult?: UpdateElapsedTimeForLearnQuizResultResolvers<ContextType>;
  UpdateLearnContentHelpfulnessResult?: UpdateLearnContentHelpfulnessResultResolvers<ContextType>;
  UpdateLearnProgressResult?: UpdateLearnProgressResultResolvers<ContextType>;
  UpdateMessageFailed?: UpdateMessageFailedResolvers<ContextType>;
  UpdateMessageIgnored?: UpdateMessageIgnoredResolvers<ContextType>;
  UpdateMessageResult?: UpdateMessageResultResolvers<ContextType>;
  UpdateMessagesFailure?: UpdateMessagesFailureResolvers<ContextType>;
  UpdateMoneyManagerAllocationsResult?: UpdateMoneyManagerAllocationsResultResolvers<ContextType>;
  UpdateMoneyManagerAllocationsSuccess?: UpdateMoneyManagerAllocationsSuccessResolvers<ContextType>;
  UpdateMoneyManagerAutomationTargetResult?: UpdateMoneyManagerAutomationTargetResultResolvers<ContextType>;
  UpdateMoneyManagerAutomationTargetSuccess?: UpdateMoneyManagerAutomationTargetSuccessResolvers<ContextType>;
  UpdateMoneyManagerSettingsFailure?: UpdateMoneyManagerSettingsFailureResolvers<ContextType>;
  UpdateMoneyManagerSettingsResult?: UpdateMoneyManagerSettingsResultResolvers<ContextType>;
  UpdateMoneyManagerSettingsSuccess?: UpdateMoneyManagerSettingsSuccessResolvers<ContextType>;
  UpdateMoneyRulesSourceSettingsFailure?: UpdateMoneyRulesSourceSettingsFailureResolvers<ContextType>;
  UpdateMoneyRulesSourceSettingsResult?: UpdateMoneyRulesSourceSettingsResultResolvers<ContextType>;
  UpdateMoneyRulesSourceSettingsSuccess?: UpdateMoneyRulesSourceSettingsSuccessResolvers<ContextType>;
  UpdateOauthAppResult?: UpdateOauthAppResultResolvers<ContextType>;
  UpdatePortfolioSecuritiesResult?: UpdatePortfolioSecuritiesResultResolvers<ContextType>;
  UpdatePromoCodeResult?: UpdatePromoCodeResultResolvers<ContextType>;
  UpdatePromotedCampaignsResult?: UpdatePromotedCampaignsResultResolvers<ContextType>;
  UpdateReferralCampaignResult?: UpdateReferralCampaignResultResolvers<ContextType>;
  UpdateReferralPayoutResult?: UpdateReferralPayoutResultResolvers<ContextType>;
  UpdateReferralRelationshipResult?: UpdateReferralRelationshipResultResolvers<ContextType>;
  UpdateReferralRewardError?: UpdateReferralRewardErrorResolvers<ContextType>;
  UpdateReferralRewardResponse?: UpdateReferralRewardResponseResolvers<ContextType>;
  UpdateScopeException?: UpdateScopeExceptionResolvers<ContextType>;
  UpdateScopeResult?: UpdateScopeResultResolvers<ContextType>;
  UpdateTrustedContactResult?: UpdateTrustedContactResultResolvers<ContextType>;
  UpdateUserProfileAndAutomationTargetResult?: UpdateUserProfileAndAutomationTargetResultResolvers<ContextType>;
  UpdateUserProfileAndAutomationTargetSuccess?: UpdateUserProfileAndAutomationTargetSuccessResolvers<ContextType>;
  UpdateUserSwitchState?: UpdateUserSwitchStateResolvers<ContextType>;
  UpdateUserSwitchStateFailure?: UpdateUserSwitchStateFailureResolvers<ContextType>;
  UpdateUserSwitchStatePayload?: UpdateUserSwitchStatePayloadResolvers<ContextType>;
  UpdateVerificationProfileResult?: UpdateVerificationProfileResultResolvers<ContextType>;
  UpgradeAuthenticationResult?: UpgradeAuthenticationResultResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UploadCheckPayload?: UploadCheckPayloadResolvers<ContextType>;
  UploadDoesNotExist?: UploadDoesNotExistResolvers<ContextType>;
  UploadDoesNotExistError?: UploadDoesNotExistErrorResolvers<ContextType>;
  UploadFailedError?: UploadFailedErrorResolvers<ContextType>;
  UploadOauthAppImageResult?: UploadOauthAppImageResultResolvers<ContextType>;
  UploadSaveError?: UploadSaveErrorResolvers<ContextType>;
  UploadSaveExceptions?: UploadSaveExceptionsResolvers<ContextType>;
  UploadUrl?: UploadUrlResolvers<ContextType>;
  UpsertUserMatchResult?: UpsertUserMatchResultResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAlert?: UserAlertResolvers<ContextType>;
  UserAlertsItem?: UserAlertsItemResolvers<ContextType>;
  UserAlertsResponse?: UserAlertsResponseResolvers<ContextType>;
  UserCardLockedSpendAlert?: UserCardLockedSpendAlertResolvers<ContextType>;
  UserClosedException?: UserClosedExceptionResolvers<ContextType>;
  UserCohorts?: UserCohortsResolvers<ContextType>;
  UserCredentials?: UserCredentialsResolvers<ContextType>;
  UserCredentialsNotFoundException?: UserCredentialsNotFoundExceptionResolvers<ContextType>;
  UserExistsException?: UserExistsExceptionResolvers<ContextType>;
  UserInvestmentAccountReopenCheck?: UserInvestmentAccountReopenCheckResolvers<ContextType>;
  UserLockedException?: UserLockedExceptionResolvers<ContextType>;
  UserMatch?: UserMatchResolvers<ContextType>;
  UserNotFound?: UserNotFoundResolvers<ContextType>;
  UserNotFoundException?: UserNotFoundExceptionResolvers<ContextType>;
  UserNotUSResidentException?: UserNotUsResidentExceptionResolvers<ContextType>;
  UserNotVerifiedException?: UserNotVerifiedExceptionResolvers<ContextType>;
  UserPartnerStatusResponse?: UserPartnerStatusResponseResolvers<ContextType>;
  UserReopenLockedException?: UserReopenLockedExceptionResolvers<ContextType>;
  UserReopenSuspendedException?: UserReopenSuspendedExceptionResolvers<ContextType>;
  UserStatus?: UserStatusResolvers<ContextType>;
  UserSuspendedException?: UserSuspendedExceptionResolvers<ContextType>;
  UserSuspendedUploadTokenLengthError?: UserSuspendedUploadTokenLengthErrorResolvers<ContextType>;
  UserSuspendedUploadTokenValidation?: UserSuspendedUploadTokenValidationResolvers<ContextType>;
  UserSwitch?: UserSwitchResolvers<ContextType>;
  UserToken?: UserTokenResolvers<ContextType>;
  UserUpload?: UserUploadResolvers<ContextType>;
  User_v2?: User_V2Resolvers<ContextType>;
  ValidPolicies?: ValidPoliciesResolvers<ContextType>;
  ValidateCredentialsResult?: ValidateCredentialsResultResolvers<ContextType>;
  ValidateCredentialsSuccess?: ValidateCredentialsSuccessResolvers<ContextType>;
  ValidatePasswordResetTokenResult?: ValidatePasswordResetTokenResultResolvers<ContextType>;
  ValidatePasswordResetTokenSuccess?: ValidatePasswordResetTokenSuccessResolvers<ContextType>;
  ValidateUserSuspendedUploadTokenResult?: ValidateUserSuspendedUploadTokenResultResolvers<ContextType>;
  ValidationError?: ValidationErrorResolvers<ContextType>;
  VendAuthSessionResult?: VendAuthSessionResultResolvers<ContextType>;
  VendorBillingInfo?: VendorBillingInfoResolvers<ContextType>;
  VendorCustomerAccount?: VendorCustomerAccountResolvers<ContextType>;
  VendorIntegrationError?: VendorIntegrationErrorResolvers<ContextType>;
  VendorRefundInvoiceError?: VendorRefundInvoiceErrorResolvers<ContextType>;
  VerificationDetails?: VerificationDetailsResolvers<ContextType>;
  VerificationProfile?: VerificationProfileResolvers<ContextType>;
  VerifyCheckPaymentRecipientAddressResult?: VerifyCheckPaymentRecipientAddressResultResolvers<ContextType>;
  VerifyDeviceResult?: VerifyDeviceResultResolvers<ContextType>;
  VerifyIdentityByDocumentsResult?: VerifyIdentityByDocumentsResultResolvers<ContextType>;
  VerifyPasswordsResult?: VerifyPasswordsResultResolvers<ContextType>;
  VerifyPasswordsSuccess?: VerifyPasswordsSuccessResolvers<ContextType>;
  VerifyPromoCodeResponse?: VerifyPromoCodeResponseResolvers<ContextType>;
  VerifyRdvsResult?: VerifyRdvsResultResolvers<ContextType>;
  VersionMismatchException?: VersionMismatchExceptionResolvers<ContextType>;
  ViewedLearnContentResult?: ViewedLearnContentResultResolvers<ContextType>;
  Void?: GraphQLScalarType;
  W9DocumentRequestedUserAlert?: W9DocumentRequestedUserAlertResolvers<ContextType>;
  Waiver?: WaiverResolvers<ContextType>;
  WaiverCoupon?: WaiverCouponResolvers<ContextType>;
  WaiverCreationException?: WaiverCreationExceptionResolvers<ContextType>;
  WaiverDeletionException?: WaiverDeletionExceptionResolvers<ContextType>;
  Webhooks?: WebhooksResolvers<ContextType>;
  WebviewLinkSession?: WebviewLinkSessionResolvers<ContextType>;
  Withdrawal?: WithdrawalResolvers<ContextType>;
  WithholdingDefaults?: WithholdingDefaultsResolvers<ContextType>;
  WithholdingEstimates?: WithholdingEstimatesResolvers<ContextType>;
  YearLaterReport?: YearLaterReportResolvers<ContextType>;
  endChatSessionResponse?: EndChatSessionResponseResolvers<ContextType>;
  helpcenterBannerResponse?: HelpcenterBannerResponseResolvers<ContextType>;
  jobs_Article?: Jobs_ArticleResolvers<ContextType>;
  jobs_Education?: Jobs_EducationResolvers<ContextType>;
  jobs_Offer?: Jobs_OfferResolvers<ContextType>;
  jobs_OfferConnection?: Jobs_OfferConnectionResolvers<ContextType>;
  jobs_OfferEdge?: Jobs_OfferEdgeResolvers<ContextType>;
  jobs_OfferSalary?: Jobs_OfferSalaryResolvers<ContextType>;
  rateChatMessageResponse?: RateChatMessageResponseResolvers<ContextType>;
  startChatSessionResponse?: StartChatSessionResponseResolvers<ContextType>;
  suitability_Portfolio?: Suitability_PortfolioResolvers<ContextType>;
  suitability_SuitabilityAnswer?: Suitability_SuitabilityAnswerResolvers<ContextType>;
  suitability_SuitabilityQuestion?: Suitability_SuitabilityQuestionResolvers<ContextType>;
  suitability_SuitabilityResponse?: Suitability_SuitabilityResponseResolvers<ContextType>;
  suitability_UpdateSuitabilityResult?: Suitability_UpdateSuitabilityResultResolvers<ContextType>;
  userWinbackErrors?: UserWinbackErrorsResolvers<ContextType>;
  userWinbackScore?: UserWinbackScoreResolvers<ContextType>;
  userWinbackScoreRes?: UserWinbackScoreResResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  authz?: AuthzDirectiveResolver<any, any, ContextType>;
  draft?: DraftDirectiveResolver<any, any, ContextType>;
  implicit?: ImplicitDirectiveResolver<any, any, ContextType>;
  inct1661BandAid?: Inct1661BandAidDirectiveResolver<any, any, ContextType>;
  rateLimit?: RateLimitDirectiveResolver<any, any, ContextType>;
  skipAuth?: SkipAuthDirectiveResolver<any, any, ContextType>;
  supergraph?: SupergraphDirectiveResolver<any, any, ContextType>;
};
